import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  JWT: any;
};

export type AiGeneratedTopicPrompt = {
  __typename?: 'AIGeneratedTopicPrompt';
  engagementPlan?: Maybe<Scalars['String']>;
  priorityContent?: Maybe<Scalars['String']>;
  relevantContent?: Maybe<Scalars['String']>;
};

export type AcceptPushNotificationInput = {
  deviceModel: Scalars['String'];
  deviceUniqueId: Scalars['String'];
  verifyToken: Scalars['String'];
};

/** Activity Entity */
export enum ActivityEntity {
  Asset = 'Asset',
  AssetAnnotation = 'AssetAnnotation',
  BrandAnalytics = 'BrandAnalytics',
  BrandCommunityHub = 'BrandCommunityHub',
  BrandCompetitorAnalytics = 'BrandCompetitorAnalytics',
  Collection = 'Collection',
  Comment = 'Comment',
  Competitor = 'Competitor',
  ContentIdea = 'ContentIdea',
  Deliverable = 'Deliverable',
  Post = 'Post',
  Project = 'Project',
  ProjectMember = 'ProjectMember',
  Request = 'Request',
  RequestResponse = 'RequestResponse',
  Resource = 'Resource',
  SocialListeningEngagement = 'SocialListeningEngagement',
  Subtask = 'Subtask',
  SubtaskMember = 'SubtaskMember',
  SuggestedPosts = 'SuggestedPosts',
  Task = 'Task',
  TaskMember = 'TaskMember',
  TrendingPosts = 'TrendingPosts',
  Workstream = 'Workstream'
}

export type ActivityModel = {
  __typename?: 'ActivityModel';
  brand?: Maybe<BrandModel>;
  collection?: Maybe<CollectionModel>;
  competitor?: Maybe<CompetitorModel>;
  createdAt: Scalars['DateTime'];
  entity: ActivityEntity;
  id: Scalars['ID'];
  type: ActivityType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

/** Type of Activity */
export enum ActivityType {
  Archived = 'Archived',
  Created = 'Created',
  CreatedMany = 'CreatedMany',
  Deleted = 'Deleted',
  DeletedMany = 'DeletedMany',
  Updated = 'Updated',
  UpdatedMany = 'UpdatedMany',
  Viewed = 'Viewed'
}

export type AddCreatorToCreatorProfileInput = {
  creatorId: Scalars['String'];
  creatorProfileId: Scalars['String'];
};

export type AddLabelsToSocialPostCommentInput = {
  organizationSocialPostCommentLabelIds: Array<Scalars['String']>;
  socialPostCommentIds: Array<Scalars['String']>;
};

export type AddOrganizationCreatorProfileLabelToCreatorProfileInput = {
  creatorProfileId: Scalars['String'];
  labelId: Scalars['String'];
};

export type AddPostToCollectionInput = {
  collectionId: Scalars['String'];
  postId: Scalars['String'];
};

export type AddPostsToContentCalendarInput = {
  data: AddPostsToContentCalendarInputData;
};

export type AddPostsToContentCalendarInputData = {
  postIds: Array<Scalars['String']>;
};

export type AddToContentCalendarForSocialListeningPostInput = {
  socialMediaUrl: Scalars['String'];
  socialPostEngagementSuggestionId: Scalars['String'];
  socialPostId: Scalars['String'];
};

export type AddTrendToContentCalendarInput = {
  trendId: Scalars['String'];
  urlMetadataId: Scalars['String'];
};

export type AggregatedBrandDurationUsageFilters = {
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
};

export type AggregatedBrandDurationUsageResult = {
  __typename?: 'AggregatedBrandDurationUsageResult';
  brand: BrandModel;
  brandId: Scalars['String'];
  durationUsed: Scalars['Float'];
  topics: Array<AggregatedTopicDurationUsageResult>;
  totalParsedPostsCount: Scalars['Int'];
  totalPositivelyParsedPostsCount: Scalars['Int'];
  totalTopicsCount: Scalars['Int'];
};

export type AggregatedTopicDurationUsageFilters = {
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
};

export type AggregatedTopicDurationUsageResult = {
  __typename?: 'AggregatedTopicDurationUsageResult';
  durationUsed: Scalars['Float'];
  topic: TopicModel;
  topicId: Scalars['String'];
  totalParsedPostsCount: Scalars['Int'];
  totalPositivelyParsedPostsCount: Scalars['Int'];
};

export type AllSentimentTrendsInput = {
  sentiment: Sentiment;
  sources?: InputMaybe<Array<BrandCompetitorMentionSource>>;
  timeRange: MetricsTimeRange;
  topicIds: Array<Scalars['String']>;
};

export type ApproveOrganizationUserAccessRequestInput = {
  accessRequestId: Scalars['String'];
};

export type ApproveOrganizationUserAccessRequestWithRoleInput = {
  accessRequestId: Scalars['String'];
  role?: InputMaybe<InternalOrganizationRole>;
};

export type ApproveOrganizationUserAccessRequestsInput = {
  accessRequestIds: Array<Scalars['String']>;
};

export type ApprovePermissionRequestInput = {
  input: ApprovePermissionRequestInputData;
  permissionRequestId: Scalars['String'];
};

export type ApprovePermissionRequestInputData = {
  permissionLevel?: InputMaybe<PermissionLevel>;
};

export type ArchiveTaskInput = {
  taskId: Scalars['String'];
};

export type AttachmentInput = {
  metaData: AttachmentMetaDataInput;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type AttachmentMetaData = {
  __typename?: 'AttachmentMetaData';
  imageInfo?: Maybe<ImageInfo>;
  mimeType?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
  videoInfo?: Maybe<VideoInfo>;
};

export type AttachmentMetaDataInput = {
  imageInfo?: InputMaybe<ImageInfoInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  uuid: Scalars['String'];
  videoInfo?: InputMaybe<VideoInfoInput>;
};

export type AttachmentModel = {
  __typename?: 'AttachmentModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  metaData: AttachmentMetaData;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type AudioTranscript = {
  __typename?: 'AudioTranscript';
  end: Scalars['Int'];
  sentence?: Maybe<Scalars['String']>;
  speaker?: Maybe<Scalars['String']>;
  start: Scalars['Int'];
};

export type AudioTrendGroupFilters = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  query?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortByInputData>;
  sortByTotalPostCount?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type AudioTrendGroupModel = {
  __typename?: 'AudioTrendGroupModel';
  audioArtist?: Maybe<Scalars['String']>;
  audioId: Scalars['String'];
  audioTitle?: Maybe<Scalars['String']>;
  audioVideoCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  parsedTimestamp: Scalars['DateTime'];
  posts: Array<AudioTrendGroupPostModel>;
  updatedAt: Scalars['DateTime'];
};

export type AudioTrendGroupPostModel = {
  __typename?: 'AudioTrendGroupPostModel';
  engagementRate: Scalars['Float'];
  platformId: Scalars['String'];
  viralRate: Scalars['Float'];
};

export type AuthModel = {
  __typename?: 'AuthModel';
  /** JWT access token */
  accessToken: Scalars['JWT'];
  isSignUp?: Maybe<Scalars['Boolean']>;
  /** JWT refresh token */
  refreshToken: Scalars['JWT'];
  user: MeModel;
};

export type AuthUrlModel = {
  __typename?: 'AuthUrlModel';
  loginUrl: Scalars['String'];
  signupUrl: Scalars['String'];
};

export type BillingCoupon = {
  __typename?: 'BillingCoupon';
  amountOff?: Maybe<Scalars['Int']>;
  duration: Scalars['String'];
  id: Scalars['String'];
  percentOff?: Maybe<Scalars['Int']>;
};

export type BillingCustomer = {
  __typename?: 'BillingCustomer';
  defaultPaymentMethod: BillingPaymentMethod;
  id: Scalars['String'];
};

export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  amountDue: Scalars['Int'];
  created: Scalars['Int'];
  description: Scalars['String'];
  hostedInvoiceUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interval: Scalars['String'];
  quantity: Scalars['Int'];
  status: Scalars['String'];
};

export type BillingPaymentMethod = {
  __typename?: 'BillingPaymentMethod';
  card: BillingPaymentMethodCard;
  id: Scalars['String'];
};

export type BillingPaymentMethodCard = {
  __typename?: 'BillingPaymentMethodCard';
  brand: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  last4: Scalars['String'];
};

export type BillingPlanModel = {
  __typename?: 'BillingPlanModel';
  aiFeaturesEnabled?: Maybe<Scalars['Boolean']>;
  collectionUsageLimit?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  customTrendsEnabled?: Maybe<Scalars['Boolean']>;
  fileDeliveryLimitInMb?: Maybe<Scalars['Int']>;
  fileStorageLimitInMb?: Maybe<Scalars['Int']>;
  guestLimit?: Maybe<Scalars['Int']>;
  guestPermission: PermissionLevel;
  id: Scalars['ID'];
  mobileAppEnabled?: Maybe<Scalars['Boolean']>;
  name: BillingPlanName;
  numberOfTrialDays?: Maybe<Scalars['Int']>;
  organizationMemberLimit?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['String']>;
  socialListeningEnabled?: Maybe<Scalars['Boolean']>;
  trendsEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export enum BillingPlanName {
  Basic = 'basic',
  Enterprise = 'enterprise',
  Free = 'free',
  Standard = 'standard'
}

export type BillingPlanPrice = {
  __typename?: 'BillingPlanPrice';
  name: BillingPlanName;
  prices: Array<BillingPrice>;
  productId?: Maybe<Scalars['String']>;
};

export type BillingPrice = {
  __typename?: 'BillingPrice';
  amount?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
  id: Scalars['String'];
  recurringInterval?: Maybe<Scalars['String']>;
  unitAmountDecimal?: Maybe<Scalars['String']>;
};

export type BillingSetupIntent = {
  __typename?: 'BillingSetupIntent';
  clientSecret: Scalars['String'];
  id: Scalars['String'];
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  cancelAt?: Maybe<Scalars['Int']>;
  clientSecret?: Maybe<Scalars['String']>;
  coupon?: Maybe<BillingSubscriptionCoupon>;
  currentPeriodEnd?: Maybe<Scalars['Int']>;
  defaultPaymentMethod?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  latestInvoiceId?: Maybe<Scalars['String']>;
  products?: Maybe<Array<BillingSubscriptionProduct>>;
  status?: Maybe<BillingSubscriptionStatus>;
  trialEnd?: Maybe<Scalars['Int']>;
  upcomingInvoice?: Maybe<BillingSubscriptionUpcomingInvoice>;
};

export type BillingSubscriptionCoupon = {
  __typename?: 'BillingSubscriptionCoupon';
  amountOff: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BillingSubscriptionProduct = {
  __typename?: 'BillingSubscriptionProduct';
  amount: Scalars['Int'];
  id: Scalars['String'];
  interval: Scalars['String'];
  itemId: Scalars['String'];
  priceId: Scalars['String'];
  quantity: Scalars['Int'];
};

export enum BillingSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type BillingSubscriptionUpcomingInvoice = {
  __typename?: 'BillingSubscriptionUpcomingInvoice';
  amountDue: Scalars['Int'];
  periodEnd: Scalars['Int'];
  periodStart: Scalars['Int'];
};

export type BlockCreatorFromCreatorProfileInput = {
  brandId: Scalars['String'];
  creatorProfileId: Scalars['String'];
};

export type BlockCreatorInput = {
  brandId: Scalars['String'];
  creatorHandle?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  creatorPlatform?: InputMaybe<Platform>;
};

export type BookmarkModel = {
  __typename?: 'BookmarkModel';
  brand?: Maybe<BrandModel>;
  brandId?: Maybe<Scalars['String']>;
  collection?: Maybe<CollectionModel>;
  collectionId?: Maybe<Scalars['String']>;
  competitor?: Maybe<CompetitorModel>;
  competitorId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  topic?: Maybe<TopicModel>;
  topicId?: Maybe<Scalars['String']>;
  type: BookmarkType;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
  userId: Scalars['String'];
};

export enum BookmarkType {
  BrandAnalytics = 'BrandAnalytics',
  BrandCommunityHub = 'BrandCommunityHub',
  BrandCompetitorAnalytics = 'BrandCompetitorAnalytics',
  BrandOwnedAnalytics = 'BrandOwnedAnalytics',
  BrandUgcAnalytics = 'BrandUgcAnalytics',
  Collection = 'Collection',
  Competitor = 'Competitor',
  Outbound = 'Outbound',
  SocialListeningEngagement = 'SocialListeningEngagement',
  Topic = 'Topic'
}

export type BrandAnalysisModel = {
  __typename?: 'BrandAnalysisModel';
  brand: BrandModel;
  brandClaims: Array<BrandClaimModel>;
  brandId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isConfident: Scalars['Boolean'];
  sentimentScore?: Maybe<Scalars['Float']>;
  sentimentTone?: Maybe<Sentiment>;
  socialPost: SocialPostModel;
  socialPostId: Scalars['String'];
  socialPosts: SocialPostModel;
  updatedAt: Scalars['DateTime'];
};

export type BrandBookmarkState = {
  __typename?: 'BrandBookmarkState';
  brandAnalytics: Scalars['Boolean'];
  communityHub: Scalars['Boolean'];
  competitorAnalytics: Scalars['Boolean'];
  outbound: Scalars['Boolean'];
  ownedBrandAnalytics: Scalars['Boolean'];
  socialListeningEngagement: Scalars['Boolean'];
  ugcAnalytics: Scalars['Boolean'];
};

export type BrandClaimModel = {
  __typename?: 'BrandClaimModel';
  attribute?: Maybe<Scalars['String']>;
  brand: BrandModel;
  brandAnalysis: BrandAnalysisModel;
  brandId: Scalars['String'];
  claim: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  sentimentScore: Scalars['Float'];
  socialPost?: Maybe<SocialPostModel>;
  socialPostId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum BrandCompetitorMentionSource {
  Organic = 'Organic',
  Paid = 'Paid'
}

export type BrandCompetitorsData = {
  __typename?: 'BrandCompetitorsData';
  brand: BrandModel;
  mentionCount: Scalars['Int'];
  percentageShare: Scalars['Float'];
};

export type BrandCompetitorsDataResponse = {
  __typename?: 'BrandCompetitorsDataResponse';
  currentDurationRank?: Maybe<Scalars['Int']>;
  data: Array<BrandCompetitorsData>;
  previousDurationRank?: Maybe<Scalars['Int']>;
  totalVideos?: Maybe<Scalars['Int']>;
};

export type BrandCompetitorsInput = {
  sources?: InputMaybe<Array<BrandCompetitorMentionSource>>;
  timeRange: MetricsTimeRange;
  topicIds: Array<Scalars['String']>;
};

export type BrandCompetitorsSentimentData = {
  __typename?: 'BrandCompetitorsSentimentData';
  brand: BrandModel;
  negativeCount: Scalars['Int'];
  negativePercentage: Scalars['Float'];
  neutralCount: Scalars['Int'];
  neutralPercentage: Scalars['Float'];
  positiveCount: Scalars['Int'];
  positivePercentage: Scalars['Float'];
};

export type BrandCompetitorsSentimentDataResponse = {
  __typename?: 'BrandCompetitorsSentimentDataResponse';
  currentDurationRank?: Maybe<Scalars['Int']>;
  data: Array<BrandCompetitorsSentimentData>;
  previousDurationRank?: Maybe<Scalars['Int']>;
};

export enum BrandContentType {
  Owned = 'Owned',
  Topic = 'Topic',
  Ugc = 'UGC'
}

export type BrandDurationUsageDurationBreakdown = {
  __typename?: 'BrandDurationUsageDurationBreakdown';
  competitors: Array<BrandDurationUsageDurationBreakdownCompetitor>;
  topics: Array<BrandDurationUsageDurationBreakdownTopic>;
};

export type BrandDurationUsageDurationBreakdownCompetitor = {
  __typename?: 'BrandDurationUsageDurationBreakdownCompetitor';
  competitorId: Scalars['String'];
  duration: Scalars['Float'];
};

export type BrandDurationUsageDurationBreakdownTopic = {
  __typename?: 'BrandDurationUsageDurationBreakdownTopic';
  duration: Scalars['Float'];
  topicId: Scalars['String'];
};

export type BrandDurationUsageModel = {
  __typename?: 'BrandDurationUsageModel';
  createdAt: Scalars['DateTime'];
  durationBreakdown: BrandDurationUsageDurationBreakdown;
  durationUsed: Scalars['Float'];
  id: Scalars['ID'];
  parsingDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type BrandHoursParsedInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  topicId?: InputMaybe<Scalars['String']>;
};

export type BrandInboundFiltersInput = {
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandInboundFiltersInputForCapturedProduct = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  excludeEmptyLineModelCombinations?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy: CapturedProductSectionSortBy;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
  viewType: CapturedProductSectionViewType;
};

export type BrandInboundFiltersInputForCommentInsights = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  commentEnrichmentTypes?: InputMaybe<Array<CommentEnrichmentType>>;
  commentTargetTypes?: InputMaybe<Array<CommentTargetType>>;
  commentText?: InputMaybe<Scalars['String']>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  organizationSocialPostCommentLabelIds?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandInboundFiltersInputForGraphData = {
  aggregationType: BrandInboundFiltersInputForGraphDataAggregationType;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum BrandInboundFiltersInputForGraphDataAggregationType {
  TotalEngagement = 'TotalEngagement',
  TotalImpressions = 'TotalImpressions',
  TotalPostCount = 'TotalPostCount'
}

export type BrandInboundFiltersInputForHashtagsUsed = {
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  sortBy?: InputMaybe<BrandInboundFiltersInputForHashtagsUsedSortBy>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandInboundFiltersInputForHashtagsUsedSortBy = {
  field: BrandInboundFiltersInputForHashtagsUsedSortField;
  order?: InputMaybe<SortOrder>;
};

export enum BrandInboundFiltersInputForHashtagsUsedSortField {
  AverageEngagementRate = 'AverageEngagementRate',
  NumberOfTimesUsed = 'NumberOfTimesUsed'
}

export type BrandInboundFiltersInputForRelatedBrands = {
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  sortBy?: InputMaybe<RelatedBrandsSortBy>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandInboundFiltersInputForSentimentMetrics = {
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  commentCreatorIds?: InputMaybe<Array<Scalars['String']>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  medium: SentimentMedium;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiment: Sentiment;
  sentimentSubjectIds?: InputMaybe<Array<Scalars['String']>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandInboundFiltersInputForTopCreatorsSortBy = {
  field: BrandInboundFiltersInputForTopCreatorsSortField;
  order?: InputMaybe<SortOrder>;
};

export enum BrandInboundFiltersInputForTopCreatorsSortField {
  FollowerCount = 'FollowerCount',
  NumberOfBrandMentions = 'NumberOfBrandMentions'
}

export type BrandInboundGraphData = {
  __typename?: 'BrandInboundGraphData';
  chartDataPoints: Array<ChartDataPoint>;
  multiChartDataPoints?: Maybe<Array<MultiChartDataPoint>>;
  totalCount: Scalars['Int'];
};

export type BrandInboundSentimentMetrics = {
  __typename?: 'BrandInboundSentimentMetrics';
  claimMetrics: Array<ClaimMetric>;
  sentimentMetrics: SentimentMetric;
};

export type BrandInboundSocialPostCommentInsightsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  commentEnrichmentTypes?: InputMaybe<Array<CommentEnrichmentType>>;
  commentTargetTypes?: InputMaybe<Array<CommentTargetType>>;
  commentText?: InputMaybe<Scalars['String']>;
  dateRange: Array<Scalars['DateTime']>;
  organizationSocialPostCommentLabelIds?: InputMaybe<Array<Scalars['String']>>;
  platforms: Array<Platform>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandInviteMemberModel = {
  __typename?: 'BrandInviteMemberModel';
  brand: BrandModel;
  brandId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<UserProfileModel>;
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  permissionLevel: PermissionLevel;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
  userId: Scalars['String'];
};

export type BrandMentionedMetrics = {
  __typename?: 'BrandMentionedMetrics';
  allTimeHigh: ChartDataPoint;
  averageCountPerDay: Scalars['Float'];
  chartDataPoints: Array<ChartDataPoint>;
};

export type BrandMentionedMetricsInput = {
  timeRange: MetricsTimeRange;
  topicIds: Array<Scalars['String']>;
};

export type BrandMetricsFilters = {
  dateRange?: InputMaybe<Array<Scalars['DateTime']>>;
  platforms?: InputMaybe<Array<Platform>>;
  responderIds?: InputMaybe<Array<Scalars['String']>>;
  sources?: InputMaybe<Array<SocialPostCommentSource>>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandMetricsResponse = {
  __typename?: 'BrandMetricsResponse';
  chartDataPoints: Array<ChartDataPoint>;
  total: Scalars['Int'];
};

export type BrandModel = {
  __typename?: 'BrandModel';
  allBrandTrends?: Maybe<Array<BrandTrendsBySentimentData>>;
  blockedCreators: Array<CreatorModel>;
  bookmarkState: BrandBookmarkState;
  brandCompetitors: BrandCompetitorsDataResponse;
  brandCompetitorsSentiment: BrandCompetitorsSentimentDataResponse;
  brandDurationUsage: Array<BrandDurationUsageModel>;
  brandKnownNames: Array<Scalars['String']>;
  brandMentionedStats: WeeklySnapshotSummaryResponse;
  brandMentionsMetrics?: Maybe<BrandMentionedMetrics>;
  brandResponseMetrics?: Maybe<BrandMetricsResponse>;
  brandSentimentTrendsBySentiment: BrandSentimentTrendBySentimentResponse;
  brandSummary?: Maybe<BrandSummary>;
  brandTrendsBySentiment: BrandTrendsBySentimentResponse;
  commentLikesMetrics?: Maybe<BrandMetricsResponse>;
  commentRepliesMetrics?: Maybe<BrandMetricsResponse>;
  competitorAnalysisEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  creator?: Maybe<CreatorModel>;
  creatorId?: Maybe<Scalars['String']>;
  creators: Array<CreatorModel>;
  description: Scalars['String'];
  generalPermission: GeneralPermission;
  id: Scalars['ID'];
  /** Members that has been explicitly invited to the brand */
  inviteMembers: Array<BrandInviteMemberModel>;
  minimumProcessingRules?: Maybe<Array<Rule>>;
  myPermissions: Array<BrandPermission>;
  name: Scalars['String'];
  organization: OrganizationModel;
  organizationId?: Maybe<Scalars['String']>;
  outboundCommentsStats: WeeklySnapshotSummaryResponse;
  parsingSettings?: Maybe<ParsingSettings>;
  permissionLevel: PermissionLevel;
  productNames: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
  resetOnNextCycle: Scalars['Boolean'];
  sentimentMetrics?: Maybe<SentimentMetricsModel>;
  status: BrandStatus;
  topics: Array<TopicModel>;
  totalHoursParsedCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type BrandModelAllBrandTrendsArgs = {
  data: AllSentimentTrendsInput;
};


export type BrandModelBrandCompetitorsArgs = {
  data: BrandCompetitorsInput;
};


export type BrandModelBrandCompetitorsSentimentArgs = {
  data: BrandCompetitorsInput;
};


export type BrandModelBrandMentionsMetricsArgs = {
  data: BrandMentionedMetricsInput;
};


export type BrandModelBrandSentimentTrendsBySentimentArgs = {
  data: SentimentMetricsInput;
};


export type BrandModelBrandSummaryArgs = {
  data: BrandInboundFiltersInput;
};


export type BrandModelBrandTrendsBySentimentArgs = {
  data: SentimentMetricsInput;
};


export type BrandModelSentimentMetricsArgs = {
  data: SentimentMetricsInput;
};


export type BrandModelTotalHoursParsedCountArgs = {
  data?: InputMaybe<BrandHoursParsedInput>;
};

export type BrandOutboundEngagementPerformanceByUserFilters = {
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
  platforms?: InputMaybe<Array<Platform>>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandOutboundEngagementPerformanceByUserResponse = {
  __typename?: 'BrandOutboundEngagementPerformanceByUserResponse';
  averageEngagement: Scalars['Int'];
  bestPerformingSocialPosts: Array<SocialPostModel>;
  id: Scalars['String'];
  maxLikes: Scalars['Int'];
  numberOfPostsCommentedOn: Scalars['Int'];
  user: UserProfileModel;
};

export type BrandOutboundLeaderboardFilters = {
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
  platforms?: InputMaybe<Array<Platform>>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandOutboundLeaderboardItem = {
  __typename?: 'BrandOutboundLeaderboardItem';
  averageEngagement: Scalars['Int'];
  bestPerformingSocialPosts: Array<SocialPostModel>;
  id: Scalars['String'];
  maxLikes: Scalars['Int'];
  numberOfPostsCommentedOn: Scalars['Int'];
  user: UserProfileModel;
};

export enum BrandPermission {
  Delete = 'Delete',
  Read = 'Read',
  Update = 'Update',
  Write = 'Write'
}

export type BrandRadarEventsConfigModel = {
  __typename?: 'BrandRadarEventsConfigModel';
  brandId: Scalars['String'];
  commentsThreshold: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  engagementRateThreshold: Scalars['Int'];
  engagementThreshold: Scalars['Int'];
  id: Scalars['ID'];
  mentionsThreshold: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BrandSentimentTextModel = {
  __typename?: 'BrandSentimentTextModel';
  brandId: Scalars['String'];
  category: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  keyword: Scalars['String'];
  products: Array<Scalars['String']>;
  sentiment: Sentiment;
  sentimentIntensity: Scalars['Int'];
  socialPost: SocialPostModel;
  socialPostId: Scalars['String'];
  subCategory: Scalars['String'];
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BrandSentimentTrendBySentimentDataResponse = {
  __typename?: 'BrandSentimentTrendBySentimentDataResponse';
  data: BrandSentimentTrendModel;
  score: Scalars['Int'];
  texts: Array<BrandSentimentTextModel>;
};

export type BrandSentimentTrendBySentimentResponse = {
  __typename?: 'BrandSentimentTrendBySentimentResponse';
  negative: Array<BrandSentimentTrendBySentimentDataResponse>;
  neutral: Array<BrandSentimentTrendBySentimentDataResponse>;
  positive: Array<BrandSentimentTrendBySentimentDataResponse>;
};

export type BrandSentimentTrendModel = {
  __typename?: 'BrandSentimentTrendModel';
  brandId: Scalars['String'];
  brandSentimentTexts: PaginatedBrandSentimentTextModel;
  name: Scalars['String'];
  sentiment: Sentiment;
  type: BrandSentimentTrendType;
};


export type BrandSentimentTrendModelBrandSentimentTextsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  timeRange?: InputMaybe<MetricsTimeRange>;
  topicIds: Array<Scalars['String']>;
};

export enum BrandSentimentTrendType {
  Category = 'category',
  SubCategory = 'subCategory'
}

export type BrandSocialPostEngagementModel = {
  __typename?: 'BrandSocialPostEngagementModel';
  brand: BrandModel;
  brandId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  respondedByUser?: Maybe<UserProfileModel>;
  respondedByUserId?: Maybe<Scalars['String']>;
  socialPost: SocialPostModel;
  socialPostId: Scalars['String'];
  status: BrandSocialPostEngagementStatus;
  updatedAt: Scalars['DateTime'];
};

export enum BrandSocialPostEngagementStatus {
  ForResearch = 'ForResearch',
  NotStarted = 'NotStarted',
  Pass = 'Pass',
  Responded = 'Responded'
}

export enum BrandStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Paused = 'PAUSED'
}

export type BrandSummary = {
  __typename?: 'BrandSummary';
  averageLikes: Scalars['Float'];
  averageViewCount: Scalars['Float'];
  followers: Scalars['Int'];
  postsPerWeek: Scalars['Float'];
  totalEngagements: Scalars['String'];
  totalPosts: Scalars['Int'];
  totalViewCount: Scalars['String'];
};

export type BrandTrendIdentifierModel = {
  __typename?: 'BrandTrendIdentifierModel';
  brandId: Scalars['String'];
  name: Scalars['String'];
  sentiment: Sentiment;
};

export type BrandTrendsBySentimentData = {
  __typename?: 'BrandTrendsBySentimentData';
  data: BrandTrendIdentifierModel;
  score: Scalars['Int'];
};

export type BrandTrendsBySentimentResponse = {
  __typename?: 'BrandTrendsBySentimentResponse';
  negative: Array<BrandTrendsBySentimentData>;
  neutral: Array<BrandTrendsBySentimentData>;
  positive: Array<BrandTrendsBySentimentData>;
};

export type CancelSetupIntentInput = {
  setupIntentId: Scalars['String'];
};

export type CapturedProductAllLabelsProductLineModel = {
  __typename?: 'CapturedProductAllLabelsProductLineModel';
  productLine?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
};

export type CapturedProductAttributeModel = {
  __typename?: 'CapturedProductAttributeModel';
  capturedProductCategoryId: Scalars['String'];
  capturedProductId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type CapturedProductAttributeUsage = {
  __typename?: 'CapturedProductAttributeUsage';
  attribute: Scalars['String'];
  attributeId: Scalars['String'];
  count: Scalars['Int'];
};

export type CapturedProductCategoryModel = {
  __typename?: 'CapturedProductCategoryModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CapturedProductDataForInbound = {
  __typename?: 'CapturedProductDataForInbound';
  attributeUsage: Array<CapturedProductAttributeUsage>;
  brand?: Maybe<BrandModel>;
  brandId?: Maybe<Scalars['String']>;
  brandMentionCount: Scalars['Int'];
  category?: Maybe<CapturedProductCategoryModel>;
  categoryId?: Maybe<Scalars['String']>;
  graphData: Array<CapturedProductDataForInboundGraphData>;
  /** This will be a made up id since we show the data grouped by line & model OR grouped by brand */
  id: Scalars['String'];
  line?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  /** This is the percent change of the social post count on the first day and last day of the date range */
  percentChange: Scalars['Float'];
  previewPosts: Array<SocialPostModel>;
  sentimentReasons: Array<Scalars['String']>;
  socialPostCount: Scalars['Int'];
  /** This is the total engagement (comment count + like count) of the social posts. Keeping it in float since int can overflow due to large numbers. The client will convert to int for rendering. */
  totalEngagement: Scalars['Float'];
  /** This is the total view count of the social posts. Keeping it in float since int can overflow due to large numbers. The client will convert to int for rendering. */
  totalViewCount: Scalars['Float'];
};


export type CapturedProductDataForInboundPreviewPostsArgs = {
  count: Scalars['Int'];
};

export type CapturedProductDataForInboundGraphData = {
  __typename?: 'CapturedProductDataForInboundGraphData';
  x: Scalars['String'];
  y: Scalars['Int'];
};

export type CapturedProductDataForInboundStats = {
  __typename?: 'CapturedProductDataForInboundStats';
  attributeUsage: Array<CapturedProductAttributeUsage>;
  graphData: Array<CapturedProductDataForInboundGraphData>;
  percentChange: Scalars['Float'];
  /** This is the total engagement of the social posts. Keeping it in float since int can overflow due to large numbers. The client will convert to int for rendering. */
  totalEngagement: Scalars['Float'];
  totalPostsCount: Scalars['Int'];
  /** This is the total view count of the social posts. Keeping it in float since int can overflow due to large numbers. The client will convert to int for rendering. */
  totalViewCount: Scalars['Float'];
};

export type CapturedProductModel = {
  __typename?: 'CapturedProductModel';
  attributes: Array<CapturedProductAttributeModel>;
  brand: BrandModel;
  brandId: Scalars['String'];
  category: CapturedProductCategoryModel;
  categoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  line: Scalars['String'];
  model: Scalars['String'];
  socialPost: SocialPostModel;
  socialPostCount: Scalars['Int'];
  socialPostId: Scalars['String'];
  totalViewCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CapturedProductSectionSortBy = {
  field: CapturedProductSectionSortField;
  order?: InputMaybe<SortOrder>;
};

export enum CapturedProductSectionSortField {
  NumberOfPosts = 'NumberOfPosts',
  PercentChange = 'PercentChange',
  TotalEngagement = 'TotalEngagement',
  ViewCount = 'ViewCount'
}

export enum CapturedProductSectionViewType {
  ProductBrand = 'ProductBrand',
  ProductCategory = 'ProductCategory',
  ProductLineModel = 'ProductLineModel'
}

export type CarouselMedia = {
  __typename?: 'CarouselMedia';
  id: Scalars['String'];
  type: CarouselMediaTypeEnum;
  url: Scalars['String'];
};

export enum CarouselMediaTypeEnum {
  Image = 'image',
  Video = 'video'
}

export type ChartDataPoint = {
  __typename?: 'ChartDataPoint';
  X: Scalars['DateTime'];
  Y: Scalars['Float'];
};

export type ClaimMetric = {
  __typename?: 'ClaimMetric';
  attribute: Scalars['String'];
  numberOfMentions: Scalars['Int'];
};

/** Source of the action to create a collection. We need it to count how many collections are created from each source. */
export enum CollectionCreationSource {
  Mobile = 'Mobile',
  Sms = 'SMS',
  Web = 'Web'
}

/** Collection Filter Type */
export enum CollectionFilterType {
  ContentCalendar = 'ContentCalendar'
}

export type CollectionFilters = {
  dateFilterInput?: InputMaybe<SimpleDateRangeFilterInput>;
  filterType?: InputMaybe<CollectionFilterType>;
  includeContentIdeaCollections?: InputMaybe<Scalars['Boolean']>;
  parentCollectionId?: InputMaybe<Scalars['String']>;
  parentCollectionIds?: InputMaybe<Array<Scalars['String']>>;
  postIds?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  searchAllCollections?: InputMaybe<Scalars['Boolean']>;
  userFilterInput?: InputMaybe<UserFilterInput>;
};

export type CollectionInviteMemberModel = {
  __typename?: 'CollectionInviteMemberModel';
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<UserProfileModel>;
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastSeen?: Maybe<Scalars['DateTime']>;
  permissionLevel: PermissionLevel;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
};

export enum CollectionInviteType {
  CollectionInvite = 'CollectionInvite',
  ContentIdeaAssigned = 'ContentIdeaAssigned',
  ContentIdeaInvite = 'ContentIdeaInvite'
}

export type CollectionManyPostsPermissionUpdateResult = {
  __typename?: 'CollectionManyPostsPermissionUpdateResult';
  collection: CollectionModel;
  modifiedInviteMembers: Array<CollectionInviteMemberModel>;
  postsAbleToUpdate: Array<PostModel>;
  postsNotAbleToUpdate: Array<PostModel>;
};

export type CollectionModel = {
  __typename?: 'CollectionModel';
  breadcrumbsFromRoot: Array<CollectionModel>;
  childCollections: Array<CollectionModel>;
  contentIdeaId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creator: UserProfileModel;
  creatorId: Scalars['String'];
  generalPermission: GeneralPermission;
  hasPreviewPost: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Members that has been explicitly invited to the collection */
  inviteMembers: Array<CollectionInviteMemberModel>;
  isBookmarked: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
  isPinnedToParent: Scalars['Boolean'];
  isPinnedToRoot: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  myPermissions: Array<CollectionPermission>;
  name: Scalars['String'];
  newPostCount: Scalars['Int'];
  newSuggestedPostCount: Scalars['Int'];
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  parentCollection?: Maybe<CollectionModel>;
  parentCollectionId?: Maybe<Scalars['String']>;
  permissionLevel: PermissionLevel;
  permissionRequests?: Maybe<Array<PermissionRequestModel>>;
  pinnedEntities: Array<PinnedEntityModel>;
  posts: Array<PostModel>;
  previewPost?: Maybe<PostModel>;
  roomId?: Maybe<Scalars['String']>;
  totalChildCollections: Scalars['Int'];
  totalPosts: Scalars['Int'];
  totalSuggestedPosts: Scalars['Int'];
  unreadCommentCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  /** Viewers retrieving from Activity table */
  viewers: Array<CollectionViewerModel>;
};


export type CollectionModelPostsArgs = {
  includePostsFromChildCollections?: InputMaybe<Scalars['Boolean']>;
  postCount?: InputMaybe<Scalars['Int']>;
  previewableFirst?: InputMaybe<Scalars['Boolean']>;
};

export enum CollectionPermission {
  Comment = 'Comment',
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Update = 'Update'
}

export type CollectionSearchHit = {
  __typename?: 'CollectionSearchHit';
  item: CollectionModel;
  score: Scalars['Float'];
  searchHighlights: Array<SearchHighlight>;
  type: SearchHitType;
};

export type CollectionSearchResult = {
  __typename?: 'CollectionSearchResult';
  hits: Array<CollectionSearchHit>;
  totalCount: Scalars['Int'];
};

export type CollectionViewerModel = {
  __typename?: 'CollectionViewerModel';
  lastSeen?: Maybe<Scalars['DateTime']>;
  user: UserProfileModel;
};

export enum CommentEnrichmentType {
  None = 'None',
  Question = 'Question',
  Request = 'Request',
  Sentiment = 'Sentiment'
}

export type CommentFilter = {
  collectionId?: InputMaybe<Scalars['String']>;
  filterOnlyParentThreads?: InputMaybe<Scalars['Boolean']>;
  nestedCollectionsOnly?: InputMaybe<Scalars['Boolean']>;
  postCommentsOnly?: InputMaybe<Scalars['Boolean']>;
  postId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  showMyThreads?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<SortByInputData>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type CommentInputData = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  comment: Scalars['String'];
  parentThreadId?: InputMaybe<Scalars['String']>;
};

export enum CommentInsightsCategoryType {
  BrandQuestionInsights = 'BrandQuestionInsights',
  CompetitorCommentInsights = 'CompetitorCommentInsights'
}

export type CommentModel = {
  __typename?: 'CommentModel';
  attachments: Array<AttachmentModel>;
  childComments: Array<CommentModel>;
  collection?: Maybe<CollectionModel>;
  collectionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileModel;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  parentComment?: Maybe<CommentModel>;
  parentThreadId?: Maybe<Scalars['String']>;
  post?: Maybe<PostModel>;
  postAnnotation?: Maybe<PostAnnotationModel>;
  postId?: Maybe<Scalars['String']>;
  task?: Maybe<TaskModel>;
  taskId?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userReactions: Array<UserReactionModel>;
};

export enum CommentTargetType {
  Brand = 'Brand',
  Creator = 'Creator',
  Product = 'Product',
  Unknown = 'Unknown',
  VideoContent = 'VideoContent',
  VideoTopic = 'VideoTopic'
}

export type CompetitorCreatorMetricsModel = {
  __typename?: 'CompetitorCreatorMetricsModel';
  averageEngagementRate: Scalars['Float'];
  averageLikes: Scalars['Float'];
  averageVideoViews: Scalars['Float'];
  competitor: CompetitorModel;
  competitorId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  followerCount: Scalars['Int'];
  id: Scalars['ID'];
  platforms: Array<Platform>;
  socialPosts?: Maybe<PaginatedSocialPost>;
  trackingBrand: BrandModel;
  trackingBrandCreatorIds: Array<Scalars['String']>;
  trackingBrandCreators: Array<CreatorModel>;
  trackingBrandId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CompetitorCreatorMetricsModelSocialPostsArgs = {
  data: GetSocialPostsCreatedForCompetitorsResolveFieldInput;
};

export enum CompetitorCreatorSocialPostContentFilter {
  Owned = 'Owned',
  Ugc = 'UGC'
}

export type CompetitorFlatAnalyticFiltersInput = {
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
};

export type CompetitorFlatCreatorAnalyticFiltersInput = {
  /** The brand id is the current brand id which is making the request */
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
};

export type CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  /** The brand id is the current brand id which is making the request */
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy: CapturedProductSectionSortBy;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  viewType: CapturedProductSectionViewType;
};

export type CompetitorFlatCreatorBrandMentionsMetrics = {
  __typename?: 'CompetitorFlatCreatorBrandMentionsMetrics';
  allTimeHigh?: Maybe<ChartDataPoint>;
  chartDataPoints: Array<ChartDataPoint>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum CompetitorFlatCreatorGraphDataAggregationType {
  TotalEngagement = 'TotalEngagement',
  TotalImpressions = 'TotalImpressions',
  TotalPostCount = 'TotalPostCount'
}

export type CompetitorFlatCreatorSentimentInteractions = {
  __typename?: 'CompetitorFlatCreatorSentimentInteractions';
  socialPostComments?: Maybe<Array<SocialPostCommentModel>>;
  socialPosts?: Maybe<Array<SocialPostModel>>;
};

export type CompetitorFlatCreatorSentimentMetrics = {
  __typename?: 'CompetitorFlatCreatorSentimentMetrics';
  claimMetrics: Array<ClaimMetric>;
  sentimentMetrics: SentimentMetric;
};

export type CompetitorFlatCreatorSummaryModel = {
  __typename?: 'CompetitorFlatCreatorSummaryModel';
  averageEngagementRate: Scalars['Float'];
  averageLikes: Scalars['Float'];
  averageVideoViews: Scalars['Float'];
  followers: Scalars['Int'];
  postsPerWeek: Scalars['Float'];
  sentiment: DetailedSentiment;
  totalEngagements: Scalars['Float'];
  totalPosts: Scalars['Int'];
  totalViewCount: Scalars['Float'];
};

export type CompetitorModel = {
  __typename?: 'CompetitorModel';
  allowAppCreatorToUpdateSearchTermList: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  forBrand: BrandModel;
  id: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  name: Scalars['String'];
  numberOfBrandMentionsByCreator: Scalars['Int'];
  parsingSettings?: Maybe<ParsingSettings>;
  regions: Array<Scalars['String']>;
  searchTerms: Array<SearchTermModel>;
  trackingBrand: BrandModel;
  updatedAt: Scalars['DateTime'];
};


export type CompetitorModelNumberOfBrandMentionsByCreatorArgs = {
  data: GetNumberOfBrandMentionsByCreatorInput;
};

export type CompetitorShareOfVoiceAggregatedDataItem = {
  __typename?: 'CompetitorShareOfVoiceAggregatedDataItem';
  aggregatedData: CompetitorShareOfVoiceData;
  base: CompetitorShareOfVoiceBaseModel;
  id: Scalars['String'];
};

export type CompetitorShareOfVoiceAggregatedDataSortByInputData = {
  field: CompetitorShareOfVoiceAggregatedDataSortField;
  order?: InputMaybe<SortOrder>;
};

export enum CompetitorShareOfVoiceAggregatedDataSortField {
  EngagementRate = 'EngagementRate',
  MentionCount = 'MentionCount',
  ShareOfVoice = 'ShareOfVoice',
  TotalEngagement = 'TotalEngagement',
  ViewCount = 'ViewCount'
}

export type CompetitorShareOfVoiceBaseModel = {
  __typename?: 'CompetitorShareOfVoiceBaseModel';
  brand: BrandModel;
  competitor?: Maybe<CompetitorModel>;
  id: Scalars['String'];
  previewPosts: Array<SocialPostModel>;
};


export type CompetitorShareOfVoiceBaseModelPreviewPostsArgs = {
  filters: CompetitorShareOfVoicePreviewPostsFiltersInput;
};

export type CompetitorShareOfVoiceData = {
  __typename?: 'CompetitorShareOfVoiceData';
  engagementRate: Scalars['Float'];
  mentionCount: Scalars['Int'];
  shareOfVoice: Scalars['Float'];
  totalEngagement: Scalars['Int'];
  viewCount: Scalars['Int'];
};

export type CompetitorShareOfVoiceDataPoint = {
  __typename?: 'CompetitorShareOfVoiceDataPoint';
  data: CompetitorShareOfVoiceData;
  date: Scalars['DateTime'];
};

export type CompetitorShareOfVoiceFiltersInput = {
  brandId: Scalars['String'];
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  platforms?: InputMaybe<Array<Platform>>;
  q?: InputMaybe<Scalars['String']>;
};

export type CompetitorShareOfVoicePreviewPostsFiltersInput = {
  dateRange: SimpleDateRangeFilterInput;
  platforms?: InputMaybe<Array<Platform>>;
};

export type CompetitorShareOfVoiceTimeSeriesDataItem = {
  __typename?: 'CompetitorShareOfVoiceTimeSeriesDataItem';
  base: CompetitorShareOfVoiceBaseModel;
  dataPoints: Array<CompetitorShareOfVoiceDataPoint>;
  id: Scalars['String'];
};

export type ConsumeShareLinkInput = {
  entityId: Scalars['String'];
  entityType: ShareEntityType;
  validationToken: Scalars['String'];
};

export type ContentCalendarViewModel = {
  __typename?: 'ContentCalendarViewModel';
  createdAt: Scalars['DateTime'];
  creator: UserProfileModel;
  filters: Scalars['String'];
  id: Scalars['ID'];
  myPermissions: Array<ContentCalendarViewPermission>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  users: Array<UserProfileModel>;
};

export enum ContentCalendarViewPermission {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Update = 'Update'
}

export type ContentIdeaFieldFilters = {
  isPrimaryField?: InputMaybe<Scalars['Boolean']>;
  primaryFields?: InputMaybe<Array<ContentIdeaPrimaryField>>;
  query?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FieldType>;
};

export type ContentIdeaFieldModel = {
  __typename?: 'ContentIdeaFieldModel';
  allowNewOptions: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPrimaryField: Scalars['Boolean'];
  name: Scalars['String'];
  options: Array<ContentIdeaFieldOptionModel>;
  sortOrder: Scalars['Float'];
  type: FieldType;
  updatedAt: Scalars['DateTime'];
};

export type ContentIdeaFieldOptionModel = {
  __typename?: 'ContentIdeaFieldOptionModel';
  bgcolor?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type ContentIdeaFieldValueContentFilter = {
  fileFilterInput?: InputMaybe<FileFilterInput>;
  linkFilterInput?: InputMaybe<LinkFilterInput>;
};

export type ContentIdeaFieldValueDateFilter = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ContentIdeaFieldValueFilter = {
  name: Scalars['String'];
  value: ContentIdeaFieldValueFilterValue;
};

export type ContentIdeaFieldValueFilterValue = {
  date?: InputMaybe<ContentIdeaFieldValueDateFilter>;
  multiSelect?: InputMaybe<Array<Scalars['String']>>;
};

export type ContentIdeaFieldValueModel = {
  __typename?: 'ContentIdeaFieldValueModel';
  contentIdea: ContentIdeaModel;
  contentIdeaField: ContentIdeaFieldModel;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  value?: Maybe<FieldValue>;
};

export type ContentIdeaFilters = {
  collectionIds?: InputMaybe<Array<Scalars['String']>>;
  content?: InputMaybe<ContentIdeaFieldValueContentFilter>;
  fields?: InputMaybe<Array<ContentIdeaFieldValueFilter>>;
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
  socialAuthorIds?: InputMaybe<Array<Scalars['String']>>;
  stage?: InputMaybe<Stage>;
};

export type ContentIdeaMetaStats = {
  __typename?: 'ContentIdeaMetaStats';
  braindumpTotalCount: Scalars['Int'];
  iceboxTotalCount: Scalars['Int'];
  productionTotalCount: Scalars['Int'];
  publishTotalCount: Scalars['Int'];
};

export type ContentIdeaModel = {
  __typename?: 'ContentIdeaModel';
  audio: ContentIdeaFieldValueModel;
  caption: ContentIdeaFieldValueModel;
  collection: CollectionModel;
  contentIdeaPublishMetadata: Array<ContentIdeaPublishMetadataModel>;
  createdAt: Scalars['DateTime'];
  creator: UserProfileModel;
  draftAssets?: Maybe<ContentIdeaFieldValueModel>;
  dueDate: ContentIdeaFieldValueModel;
  fields: Array<ContentIdeaFieldValueModel>;
  finalAssets?: Maybe<ContentIdeaFieldValueModel>;
  id: Scalars['ID'];
  moodboard?: Maybe<ContentIdeaFieldValueModel>;
  myPermissions: Array<ContentIdeaPermission>;
  name: Scalars['String'];
  noteContent?: Maybe<Scalars['String']>;
  owners: ContentIdeaFieldValueModel;
  pillars: ContentIdeaFieldValueModel;
  platforms: ContentIdeaFieldValueModel;
  previewPost?: Maybe<PermittedPostModel>;
  roomId?: Maybe<Scalars['String']>;
  rootCollection?: Maybe<PermittedCollectionModel>;
  snoozeDate?: Maybe<Scalars['DateTime']>;
  stage: Stage;
  status: ContentIdeaFieldValueModel;
  updatedAt: Scalars['DateTime'];
  /** Viewers retrieving from Activity table */
  viewers: Array<ContentIdeaViewerModel>;
};

export enum ContentIdeaPermission {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Update = 'Update'
}

export enum ContentIdeaPrimaryField {
  DraftAssets = 'DraftAssets',
  DueDate = 'DueDate',
  FinalAssets = 'FinalAssets',
  FinalAudio = 'FinalAudio',
  FinalCaption = 'FinalCaption',
  Moodboard = 'Moodboard',
  Owners = 'Owners',
  Pillars = 'Pillars',
  Platforms = 'Platforms',
  Status = 'Status'
}

export type ContentIdeaPublishMetadataModel = {
  __typename?: 'ContentIdeaPublishMetadataModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  platform: Platform;
  publishUrl?: Maybe<Scalars['String']>;
  socialAuthor?: Maybe<SocialAuthorModel>;
  updatedAt: Scalars['DateTime'];
};

export type ContentIdeaViewerModel = {
  __typename?: 'ContentIdeaViewerModel';
  lastSeen?: Maybe<Scalars['DateTime']>;
  user: UserProfileModel;
};

export type CountryModel = {
  __typename?: 'CountryModel';
  code: Scalars['String'];
};

export type CreateBillingSubscriptionInput = {
  couponId: Scalars['String'];
  numberOfMembers: Scalars['Int'];
  paymentMethodId: Scalars['String'];
  priceId: Scalars['String'];
};

export type CreateBrandBookmarkInput = {
  brandId: Scalars['String'];
  type: BookmarkType;
};

export type CreateBrandInput = {
  name: Scalars['String'];
};

export type CreateBrandMentionTopicInput = {
  brandId: Scalars['String'];
  communicationStrategy?: InputMaybe<Scalars['String']>;
  generatedPrompt?: InputMaybe<Scalars['String']>;
  prioritizationInfo?: InputMaybe<Scalars['String']>;
  topicDescription?: InputMaybe<Scalars['String']>;
};

export type CreateBrandSocialPostEngagementInput = {
  brandId: Scalars['String'];
  socialPostId: Scalars['String'];
  status?: InputMaybe<BrandSocialPostEngagementStatus>;
};

export type CreateCollectionBookmarkInput = {
  collectionId: Scalars['String'];
};

export type CreateCollectionInput = {
  contentIdeaId?: InputMaybe<Scalars['String']>;
  movePostsFromParent?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentCollectionId?: InputMaybe<Scalars['String']>;
  postIds?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<CollectionCreationSource>;
};

export type CreateCommentInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  data: CommentInputData;
  postAnnotationId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type CreateCompetitorBookmarkInput = {
  competitorId: Scalars['String'];
};

export type CreateCompetitorCreatorDataInput = {
  handle: Scalars['String'];
  platform: Platform;
};

export type CreateCompetitorDataInput = {
  allowAppCreatorToUpdateSearchTermList: Scalars['Boolean'];
  creators: Array<CreateCompetitorCreatorDataInput>;
  description: Scalars['String'];
  isPaused: Scalars['Boolean'];
  name: Scalars['String'];
  regions: Array<Scalars['String']>;
  searchTerms: Array<CreateCompetitorSearchTermDataInput>;
};

export type CreateCompetitorInput = {
  data: Array<CreateCompetitorDataInput>;
  organizationBrandId: Scalars['String'];
};

export type CreateCompetitorSearchTermDataInput = {
  term: Scalars['String'];
};

export type CreateContentCalendarViewInput = {
  data: CreateContentCalendarViewInputData;
};

export type CreateContentCalendarViewInputData = {
  filters: Scalars['String'];
  name: Scalars['String'];
};

export type CreateContentIdeaFieldInput = {
  contentIdeaId: Scalars['String'];
  data: CreateContentIdeaFieldInputData;
};

export type CreateContentIdeaFieldInputData = {
  fieldType: FieldType;
  icon?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateContentIdeaFieldOptionData = {
  bgcolor?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export type CreateContentIdeaFieldOptionInput = {
  contentIdeaFieldId: Scalars['String'];
  data: CreateContentIdeaFieldOptionData;
};

export type CreateContentIdeaInput = {
  contentIdeaId: Scalars['String'];
  data: CreateContentIdeaInputData;
};

export type CreateContentIdeaInputData = {
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rootCollectionId?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Stage>;
};

export type CreateCreatorInput = {
  data: CreateCreatorInputData;
};

export type CreateCreatorInputData = {
  brandId?: InputMaybe<Scalars['String']>;
  handle: Scalars['String'];
  platform: Platform;
};

export type CreateCreatorProfileIfNotExistsInput = {
  brandId: Scalars['String'];
  creatorHandle: Scalars['String'];
  creatorPlatform: Platform;
  creatorPlatformId: Scalars['String'];
};

export type CreateCreatorTrackingTopicInput = {
  brandId: Scalars['String'];
  name: Scalars['String'];
};

export type CreateEditorialPostsInput = {
  apiKey: Scalars['String'];
  data: Array<NewEditorialPostInput>;
  trendingDate: Scalars['DateTime'];
};

export type CreateEditorialTaskInput = {
  editorialPostId: Scalars['String'];
  newTask: NewTaskInput;
  projectId?: InputMaybe<Scalars['String']>;
};

export type CreateEngagementTopicInput = {
  brandId: Scalars['String'];
  name: Scalars['String'];
};

export type CreateFilePostInput = {
  attachment: AttachmentInput;
  collectionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<PostCreationSource>;
  taskId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateLinkPostInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  socialPostEngagementSuggestionId?: InputMaybe<Scalars['String']>;
  socialPostId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<PostCreationSource>;
  taskId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trendId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateNotePostInput = {
  body?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<PostCreationSource>;
  taskId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateOrganizationCreatorProfileLabelInput = {
  bgColor?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  creatorProfileId: Scalars['String'];
  label: Scalars['String'];
};

export type CreateOrganizationSocialPostCommentLabelInput = {
  labelText: Scalars['String'];
  organizationId: Scalars['String'];
};

export type CreateOrganizationUserAccessRequestInput = {
  input: CreateOrganizationUserAccessRequestInputData;
};

export type CreateOrganizationUserAccessRequestInputData = {
  message?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationUserAccessRequestsByNonAdminInput = {
  input: CreateOrganizationUserAccessRequestsByNonAdminInputData;
};

export type CreateOrganizationUserAccessRequestsByNonAdminInputData = {
  message?: InputMaybe<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type CreatePermissionRequestInput = {
  input: CreatePermissionRequestInputData;
};

export type CreatePermissionRequestInputData = {
  brandId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
};

export type CreatePermissionRequestsInput = {
  input: Array<CreatePermissionRequestsInputData>;
};

export type CreatePermissionRequestsInputData = {
  brandId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CreatePostAnnotationInput = {
  annotation: PostAnnotationInputData;
  postId: Scalars['String'];
};

export type CreatePostBaseInput = {
  attachment?: InputMaybe<AttachmentInput>;
  collectionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  deliverableId?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<PostCreationSource>;
  taskId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type: PostType;
  url?: InputMaybe<Scalars['String']>;
};

export type CreatePostFavoriteInput = {
  isFavoriteTrend?: InputMaybe<Scalars['Boolean']>;
  postId: Scalars['String'];
};

export type CreatePostFavoriteInputV2 = {
  postId: Scalars['String'];
};

export type CreatePostForEditorialPostInput = {
  trendingPostId: Scalars['String'];
};

export type CreatePostForSocialListeningPostInput = {
  socialMediaUrl: Scalars['String'];
  socialPostEngagementSuggestionId: Scalars['String'];
  socialPostId: Scalars['String'];
};

export type CreatePostForTrendInput = {
  trendId: Scalars['String'];
  urlMetadataId?: InputMaybe<Scalars['String']>;
};

export type CreatePostsFavoriteInput = {
  postIds: Array<Scalars['String']>;
};

export type CreatePostsInput = {
  posts: Array<CreatePostBaseInput>;
};

export type CreateRadarEventActivityCommunicationChannelInput = {
  bgColor?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateRadarEventActivityInput = {
  assetIds: Array<Scalars['String']>;
  createdForCreatorProfileIds: Array<Scalars['String']>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  direction: RadarEventActivityDirection;
  radarEventActivityCommunicationChannelIds: Array<Scalars['String']>;
  radarEventIds: Array<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateSavedConfigInput = {
  brandId?: InputMaybe<Scalars['String']>;
  config: Scalars['String'];
  name: Scalars['String'];
  type?: InputMaybe<SavedConfigType>;
};

export type CreateSearchTermInput = {
  allowToUpdateSearchTerm: Scalars['Boolean'];
  terms: Array<Scalars['String']>;
  topicId: Scalars['String'];
};

export type CreateSetupIntentInput = {
  paymentMethodTypes: Array<Scalars['String']>;
};

export type CreateSignalCategoryOptionInput = {
  data: CreateSignalCategoryOptionInputData;
};

export type CreateSignalCategoryOptionInputData = {
  label: Scalars['String'];
  signalDefinitionId: Scalars['String'];
};

export type CreateSignalDefinitionInput = {
  data: CreateSignalDefinitionInputData;
  signalDefinitionId?: InputMaybe<Scalars['String']>;
};

export type CreateSignalDefinitionInputData = {
  topicId: Scalars['String'];
};

export type CreateSocialAuthorInput = {
  data: CreateSocialAuthorInputData;
};

export type CreateSocialAuthorInputData = {
  platform: Platform;
  url: Scalars['String'];
};

export type CreateSocialPostForOutboundCommentsInput = {
  brandId: Scalars['String'];
  data: CreateSocialPostForOutboundCommentsInputData;
};

export type CreateSocialPostForOutboundCommentsInputData = {
  platform: Platform;
  url: Scalars['String'];
};

export type CreateSocialPostNotificationConfigInput = {
  data: CreateSocialPostNotificationConfigInputData;
};

export type CreateSocialPostNotificationConfigInputData = {
  brandId: Scalars['String'];
  creatorFollowingEnabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  followersScale?: InputMaybe<Array<FollowersScale>>;
  /** Minimum score to trigger notification. Range: 0-1. Default is 0.5. */
  minimumScore?: InputMaybe<Scalars['Float']>;
  minimumScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  sentiments?: InputMaybe<Array<DetailedSentiment>>;
  sentimentsEnabled?: InputMaybe<Scalars['Boolean']>;
  topicId?: InputMaybe<Scalars['String']>;
};

export type CreateSocialPostReportInput = {
  brandId: Scalars['String'];
  reason: Scalars['String'];
  socialPostId: Scalars['String'];
};

export type CreateTaskInput = {
  newTask: NewTaskInput;
  projectId?: InputMaybe<Scalars['String']>;
};

export type CreateTopicBookmarkInput = {
  topicId: Scalars['String'];
};

export type CreateTrendFavoriteInput = {
  postId: Scalars['String'];
};

export type CreateTrendInput = {
  apiKey: Scalars['String'];
  postId: Scalars['String'];
};

export type CreatorModel = {
  __typename?: 'CreatorModel';
  audience_demographics?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creatorTrackedTopics: Array<TopicModel>;
  engagementRate: Scalars['Float'];
  followerCount: Scalars['Int'];
  followingCount: Scalars['Int'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  isTrackingInsightsForCreatorProfile?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Float'];
  nickName: Scalars['String'];
  numberOfBrandMentions?: Maybe<Scalars['Int']>;
  otherInsights?: Maybe<Scalars['String']>;
  platform: Platform;
  platformId: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  videoCount: Scalars['Int'];
};


export type CreatorModelCreatorTrackedTopicsArgs = {
  brandId: Scalars['String'];
};


export type CreatorModelIsTrackingInsightsForCreatorProfileArgs = {
  brandId: Scalars['String'];
};

export type CreatorProfileBrandMentionStats = {
  __typename?: 'CreatorProfileBrandMentionStats';
  brandMentionCount: Scalars['Float'];
  engagementRate: Scalars['Float'];
  sentiment: Sentiment;
  sentimentScore: Scalars['Float'];
  totalComments: Scalars['Int'];
  totalLikes: Scalars['Float'];
  totalViews: Scalars['Float'];
};

export type CreatorProfileBrandMentionedStatsInput = {
  /** The ID of the brand whose mentions are being analyzed in relation to the creator profile. */
  brandId: Scalars['String'];
  /** The ID of the creator profile being analyzed. */
  creatorProfileId: Scalars['String'];
  /** The brand ID of the currently logged-in user or selected brand context. */
  currentBrandId: Scalars['String'];
  dateRange: SimpleDateRangeFilterInput;
  mentionSources?: InputMaybe<Array<SocialPostMentionSource>>;
  platforms?: InputMaybe<Array<Platform>>;
};

/** Filter type to show tracking or non-tracking creators in the UI */
export enum CreatorProfileFilterType {
  IsNotTrackingInsights = 'IsNotTrackingInsights',
  IsTrackingInsights = 'IsTrackingInsights'
}

export type CreatorProfileMentionedBrandsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  /** The ID of the brand whose mentions are being analyzed in relation to the creator profile. */
  brandId?: InputMaybe<Scalars['String']>;
  /** The ID of the creator profile being analyzed. */
  creatorProfileId: Scalars['String'];
  /** The brand ID of the currently logged-in user or selected brand context. */
  currentBrandId: Scalars['String'];
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  mentionSources?: InputMaybe<Array<SocialPostMentionSource>>;
  platforms?: InputMaybe<Array<Platform>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CreatorProfileModel = {
  __typename?: 'CreatorProfileModel';
  averageSentimentScore: Scalars['Float'];
  birthdate?: Maybe<Scalars['DateTime']>;
  brand: BrandModel;
  brandId: Scalars['String'];
  brandMentionCount: Scalars['Float'];
  capturedProducts: Array<CapturedProductModel>;
  createdAt: Scalars['DateTime'];
  creatorTrackedTopics: Array<TopicModel>;
  creators: Array<CreatorModel>;
  defaultCreatorId: Scalars['String'];
  emails?: Maybe<Array<Scalars['String']>>;
  engagementRate: Scalars['Float'];
  followersCount: Scalars['Float'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  isBlockedFromCommunityHub: Scalars['Boolean'];
  isBrandBlocked: Scalars['Boolean'];
  isTrackingInsights: Scalars['Boolean'];
  labels: Array<OrganizationCreatorProfileLabelModel>;
  latestRadarEventActivity?: Maybe<RadarEventActivityModel>;
  location?: Maybe<Scalars['String']>;
  locationReferenceSocialPost?: Maybe<SocialPostModel>;
  locationReferenceSocialPostId?: Maybe<Scalars['String']>;
  radarEvents: Array<RadarEventModel>;
  reasonForLocation?: Maybe<Scalars['String']>;
  relationshipStrength: CreatorProfileRelationshipStrength;
  relationshipStrengthScore: Scalars['Float'];
  totalComments: Scalars['Float'];
  totalEngagement: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};


export type CreatorProfileModelCreatorTrackedTopicsArgs = {
  brandId: Scalars['String'];
};

export type CreatorProfilePaginatedBrandMentionsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  /** The ID of the specific brand whose mentions by this creator are being retrieved. */
  brandId: Scalars['String'];
  /** The ID of the creator profile being analyzed. */
  creatorProfileId: Scalars['String'];
  /** The brand ID of the currently logged-in user or selected brand context. */
  currentBrandId: Scalars['String'];
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  mentionSources?: InputMaybe<Array<SocialPostMentionSource>>;
  platforms?: InputMaybe<Array<Platform>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<CreatorProfilePaginatedBrandMentionsInputSortBy>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CreatorProfilePaginatedBrandMentionsInputSortBy = {
  field: CreatorProfilePaginatedBrandMentionsInputSortField;
  order?: InputMaybe<SortOrder>;
};

export enum CreatorProfilePaginatedBrandMentionsInputSortField {
  DiggCount = 'DiggCount',
  EngagementRate = 'EngagementRate',
  PlayCount = 'PlayCount',
  Recency = 'Recency'
}

export type CreatorProfilePaginatedSuperfanEngagementInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  creatorProfileId: Scalars['String'];
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<CreatorProfilePaginatedSuperfanEngagementInputSortBy>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CreatorProfilePaginatedSuperfanEngagementInputSortBy = {
  field: CreatorProfilePaginatedSuperfanEngagementInputSortField;
  order?: InputMaybe<SortOrder>;
};

export enum CreatorProfilePaginatedSuperfanEngagementInputSortField {
  ChildCommentCount = 'ChildCommentCount',
  DiggCount = 'DiggCount',
  EngagementRate = 'EngagementRate',
  Recency = 'Recency'
}

/** The strength of the relationship between the creator and the brand */
export enum CreatorProfileRelationshipStrength {
  Neutral = 'Neutral',
  Strong = 'Strong',
  VeryStrong = 'VeryStrong',
  VeryWeak = 'VeryWeak',
  Weak = 'Weak'
}

export type CreatorProfileSuperfanEngagementStats = {
  __typename?: 'CreatorProfileSuperfanEngagementStats';
  maxLikes: Scalars['Int'];
  sentiment: Sentiment;
  sentimentScore: Scalars['Float'];
  totalComments: Scalars['Int'];
  totalEngagement: Scalars['Int'];
};

export type CreatorProfileSuperfanEngagementStatsInput = {
  brandId: Scalars['String'];
  creatorProfileId: Scalars['String'];
  dateRange: SimpleDateRangeFilterInput;
  platforms?: InputMaybe<Array<Platform>>;
};

export type CreatorProfilesByCreatorIdInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  creatorId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CreatorProfilesByIdsInput = {
  creatorProfileIds: Array<Scalars['String']>;
};

export type CreatorTopicTrackingInput = {
  brandId: Scalars['String'];
  creatorIds: Array<Scalars['String']>;
};

export type CreatorTopicTrackingModel = {
  __typename?: 'CreatorTopicTrackingModel';
  isTracking: Scalars['Boolean'];
  topic: TopicModel;
};

export type CreatorTrackingTopicModel = {
  __typename?: 'CreatorTrackingTopicModel';
  createdAt: Scalars['DateTime'];
  creator: CreatorModel;
  creatorId: Scalars['String'];
  id: Scalars['ID'];
  topic: TopicModel;
  topicId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CustomTrendPersonaModel = {
  __typename?: 'CustomTrendPersonaModel';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  emoji?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Date Filter Type */
export enum DateFilterType {
  LastSevenDays = 'LastSevenDays',
  LastThirtyDays = 'LastThirtyDays',
  LastYear = 'LastYear',
  ThisYear = 'ThisYear',
  Today = 'Today'
}

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type DeclinePendingUserRequestInput = {
  organizationIdToJoin: Scalars['String'];
  userId: Scalars['String'];
};

export type DeleteAttachmentInput = {
  attachmentId: Scalars['String'];
};

export type DeleteBrandBookmarkInput = {
  brandId: Scalars['String'];
  type: BookmarkType;
};

export type DeleteCollectionBookmarkInput = {
  collectionId: Scalars['String'];
};

export type DeleteCollectionsInput = {
  collectionIds: Array<Scalars['String']>;
};

export type DeleteCommentInput = {
  commentId: Scalars['String'];
};

export type DeleteCompetitorBookmarkInput = {
  competitorId: Scalars['String'];
};

export type DeleteContentCalendarViewInput = {
  contentCalendarViewId: Scalars['String'];
};

export type DeleteContentIdeaFieldInput = {
  contentIdeaFieldId: Scalars['String'];
};

export type DeleteContentIdeaFieldOptionInput = {
  contentIdeaFieldOptionId: Scalars['String'];
};

export type DeleteContentIdeaInput = {
  contentIdeaId: Scalars['String'];
};

export type DeleteManuallyParsedSocialPostTrackerInput = {
  manuallyParsedSocialPostTrackerId: Scalars['String'];
};

export type DeleteNotificationsInput = {
  notificationIds: Array<Scalars['String']>;
};

export type DeletePostAnnotationInput = {
  postAnnotationId: Scalars['String'];
};

export type DeletePostFavoriteInput = {
  isFavoriteTrend?: InputMaybe<Scalars['Boolean']>;
  postId: Scalars['String'];
};

export type DeletePostFavoriteInputV2 = {
  postId: Scalars['String'];
};

export type DeletePostsFavoriteInput = {
  postIds: Array<Scalars['String']>;
};

export type DeletePostsInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  postIds: Array<Scalars['String']>;
};

export type DeleteSavedConfigInput = {
  id: Scalars['String'];
};

export type DeleteSignalCategoryOptionInput = {
  signalCategoryOptionId: Scalars['String'];
};

export type DeleteSignalDefinitionInput = {
  signalDefinitionId: Scalars['String'];
};

export type DeleteSocialAuthorInput = {
  socialAuthorId: Scalars['String'];
};

export type DeleteSuggestedPostInput = {
  collectionId: Scalars['String'];
  postId: Scalars['String'];
};

export type DeleteTaskInput = {
  taskId: Scalars['String'];
};

export type DeleteTopicBookmarkInput = {
  topicId: Scalars['String'];
};

export type DeleteTrendFavoriteInput = {
  postId: Scalars['String'];
};

export type DeletedResult = {
  __typename?: 'DeletedResult';
  id: Scalars['String'];
};

export enum DetailedSentiment {
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive',
  SlighlyPositive = 'SlighlyPositive',
  SlightlyNegative = 'SlightlyNegative'
}

export type DisableUsersInput = {
  userIds: Array<Scalars['String']>;
};

export type DuplicateContentCalendarViewInput = {
  contentCalendarViewId: Scalars['String'];
};

export type DuplicateContentIdeaFieldInput = {
  contentIdeaFieldId: Scalars['String'];
  contentIdeaId?: InputMaybe<Scalars['String']>;
};

export type DuplicatePostInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  postId: Scalars['String'];
  source?: InputMaybe<PostCreationSource>;
};

export type DuplicateTaskInput = {
  data: DuplicateTaskInputData;
  taskId: Scalars['String'];
};

export type DuplicateTaskInputData = {
  name: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
};

export type EditorialPostModel = {
  __typename?: 'EditorialPostModel';
  body?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  lastViewed?: Maybe<Scalars['DateTime']>;
  posts: Array<PostModel>;
  title?: Maybe<Scalars['String']>;
  trendingDate: Scalars['DateTime'];
  type: PostType;
  updatedAt: Scalars['DateTime'];
  urlMetadata: Array<UrlMetadataModel>;
};

export type EmailInput = {
  email: Scalars['String'];
  permission: PermissionLevel;
};

export type EnableUsersInput = {
  userIds: Array<Scalars['String']>;
};

export type ExcludeBrandInput = {
  data: ExcludeBrandInputData;
  id: Scalars['String'];
};

export type ExcludeBrandInputData = {
  brandIdToExclude: Scalars['String'];
  topicId?: InputMaybe<Scalars['String']>;
};

/** Possible social post types for filtering, not to be confused with actual db type of social post */
export enum ExtendedSocialPostTypeForFilter {
  Carousel = 'Carousel',
  Photo = 'Photo',
  Story = 'Story',
  Video = 'Video'
}

/** External organization role of a user, used by OrganizationExternalMember */
export enum ExternalOrganizationRole {
  Collaborator = 'Collaborator',
  Stakeholder = 'Stakeholder'
}

export type FeatureFlagModel = {
  __typename?: 'FeatureFlagModel';
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: PlotFeature;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum FieldType {
  Checkbox = 'Checkbox',
  Collection = 'Collection',
  Date = 'Date',
  MultiSelect = 'MultiSelect',
  Select = 'Select',
  Tasks = 'Tasks',
  Text = 'Text',
  Users = 'Users'
}

export type FieldValue = {
  __typename?: 'FieldValue';
  checkbox?: Maybe<Scalars['Boolean']>;
  collection?: Maybe<CollectionModel>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  multiSelect?: Maybe<Array<ContentIdeaFieldOptionModel>>;
  select?: Maybe<ContentIdeaFieldOptionModel>;
  tasks?: Maybe<Array<TaskModel>>;
  text?: Maybe<Scalars['String']>;
  users?: Maybe<Array<UserProfileModel>>;
};

export type FileFilterInput = {
  selectAll?: Scalars['Boolean'];
  types?: InputMaybe<Array<FileFilterType>>;
};

/** File Filter Type */
export enum FileFilterType {
  Document = 'Document',
  Images = 'Images',
  Video = 'Video'
}

export type FilterSearchInput = {
  query: Scalars['String'];
};

export type FiltersSearch = {
  __typename?: 'FiltersSearch';
  collections?: Maybe<Array<CollectionModel>>;
  createdBy?: Maybe<Array<UserProfileModel>>;
  dateModified?: Maybe<Array<DateFilterType>>;
  reaction?: Maybe<Array<ReactionFilterType>>;
  sharedBy?: Maybe<Array<UserProfileModel>>;
  type?: Maybe<Array<Scalars['String']>>;
};

export enum FollowersScale {
  Macro = 'Macro',
  Mega = 'Mega',
  Micro = 'Micro',
  Nano = 'Nano'
}

/** Possible followers types */
export enum FollowersType {
  Macro = 'Macro',
  Mega = 'Mega',
  Micro = 'Micro',
  Nano = 'Nano'
}

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export enum GeneralPermission {
  InviteOnly = 'InviteOnly',
  OrganizationMembers = 'OrganizationMembers'
}

export type GeneralPermissionInput = {
  generalPermission?: InputMaybe<GeneralPermission>;
  permissionLevel?: InputMaybe<PermissionLevel>;
};

export type GenerateShareLinkInput = {
  entityId: Scalars['String'];
  entityType: ShareEntityType;
};

export type GetBrandByIdsInput = {
  brandIds: Array<Scalars['String']>;
};

export type GetCapturedProductAttributeByIdsInput = {
  attributeIds: Array<Scalars['String']>;
};

export type GetCapturedProductCategoryByIdsInput = {
  categoryIds: Array<Scalars['String']>;
};

export type GetCollectionByIdsInput = {
  collectionIds: Array<Scalars['String']>;
};

export type GetCollectionPostsForPermissionUpdateInput = {
  collectionId: Scalars['String'];
};

export type GetCompetitorCommentInsightsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  commentEnrichmentTypes?: InputMaybe<Array<CommentEnrichmentType>>;
  commentTargetTypes?: InputMaybe<Array<CommentTargetType>>;
  commentText?: InputMaybe<Scalars['String']>;
  organizationSocialPostCommentLabelIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetCompetitorCommentInsightsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  filters: GetCompetitorCommentInsightsFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetCompetitorFlatCreatorGraphDataInput = {
  aggregationType: CompetitorFlatCreatorGraphDataAggregationType;
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
};

export type GetCompetitorSentimentInteractionsFilterInput = {
  atrributes: Array<Scalars['String']>;
  dateRange: Array<Scalars['DateTime']>;
  medium: SentimentMedium;
  platform?: InputMaybe<Array<Platform>>;
  sentiment: Sentiment;
};

export type GetCompetitorSentimentInteractionsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competitorId: Scalars['String'];
  filters: GetCompetitorSentimentInteractionsFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetCompetitorSentimentMetricsFilterInput = {
  medium: SentimentMedium;
  sentiment: Sentiment;
};

export type GetCompetitorSentimentMetricsInput = {
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  filters: GetCompetitorSentimentMetricsFilterInput;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
};

export type GetCreatorHashtagFilters = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

export type GetCreatorInput = {
  creatorId: Scalars['String'];
};

export type GetCreatorProfilesCapturedProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: GetCreatorProfilesCapturedProductsFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetCreatorProfilesCapturedProductsFilters = {
  brandId: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
};

export type GetCreatorsThatMentionedCompetitorInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetHashtagUsedByCompetitorInput = {
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  filters: GetCreatorHashtagFilters;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  hashtag?: InputMaybe<Scalars['String']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sortBy?: InputMaybe<SortByInputData>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take: Scalars['Int'];
};

export type GetNumberOfBrandMentionsByCreatorInput = {
  competitorId: Scalars['String'];
  creatorId: Scalars['String'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type GetPaginatedSocialPostEngagementSuggestionsFilterInput = {
  followers?: InputMaybe<Array<FollowersType>>;
  query?: InputMaybe<Scalars['String']>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetPaginatedSocialPostFilterInput = {
  dateRange?: InputMaybe<Array<Scalars['DateTime']>>;
  followers?: InputMaybe<Array<FollowersType>>;
  includeTaggedPosts?: InputMaybe<Scalars['Boolean']>;
  isOrganic?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  minimumPlayCount?: InputMaybe<Scalars['Int']>;
  onlyShowBrandMentions?: InputMaybe<Scalars['Boolean']>;
  platforms?: InputMaybe<Array<Platform>>;
  query?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Array<Scalars['String']>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  signalOptionIds?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<BrandSocialPostEngagementStatus>>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
  topicRelevancy?: InputMaybe<Scalars['Float']>;
  types?: InputMaybe<Array<ExtendedSocialPostTypeForFilter>>;
};

export type GetPostByIdsInput = {
  postIds: Array<Scalars['String']>;
};

export type GetPostCollectionInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterType?: InputMaybe<CollectionFilterType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  parentCollectionId?: InputMaybe<Scalars['String']>;
  postIds: Array<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetSameLevelCollectionsInput = {
  collectionId: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
};

export type GetSearchTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: SearchTermFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetSocialPostsByHashtagsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competitorId: Scalars['String'];
  creatorId: Scalars['String'];
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  hashtag: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy: SortByInputForSocialPostsByHashtags;
  startDate: Scalars['DateTime'];
  take?: InputMaybe<Scalars['Int']>;
};

export type GetSocialPostsCreatedForCompetitorsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<PaginatedCompetitorFlatAnalyticFiltersInputSortBy>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetSocialPostsCreatedForCompetitorsResolveFieldInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customViewId?: InputMaybe<Scalars['String']>;
  filters: TaskFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  secondaryFilters?: InputMaybe<TaskFilters>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetTopCreatorPostsThatMentionedBrandInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
  filters: BrandInboundFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputForTopCreatorPostsThatMentionedBrand>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetTopHashtagsPostsForBrandInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: BrandInboundFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  hashtags: Array<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputForSocialPostsByHashtags>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetTopHashtagsPostsForCompetitorInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: CompetitorFlatAnalyticFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  hashtags: Array<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputForSocialPostsByHashtags>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GhostSearchQuery = {
  __typename?: 'GhostSearchQuery';
  query: Scalars['String'];
};

export type HashTagModel = {
  __typename?: 'HashTagModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type HashtagUsedForBrandModel = {
  __typename?: 'HashtagUsedForBrandModel';
  averageEngagementRate?: Maybe<Scalars['Float']>;
  isHidden: Scalars['Boolean'];
  name: Scalars['String'];
  numberOfTimesUsed?: Maybe<Scalars['Int']>;
};

export type HashtagUsedForCompetitorModel = {
  __typename?: 'HashtagUsedForCompetitorModel';
  averageEngagementRate?: Maybe<Scalars['Float']>;
  isHidden: Scalars['Boolean'];
  name: Scalars['String'];
  numberOfTimesUsed?: Maybe<Scalars['Int']>;
};

export type Headline = {
  __typename?: 'Headline';
  column: Scalars['String'];
  headline: Scalars['String'];
};

export type HideHashtagUsedForBrandInput = {
  brandId: Scalars['String'];
  hashtagName: Scalars['String'];
  platform?: InputMaybe<Platform>;
};

export type HideHashtagUsedForCreatorInput = {
  competitorId: Scalars['String'];
  hashtagName: Scalars['String'];
  platform?: InputMaybe<Platform>;
};

export type IdInput = {
  id: Scalars['String'];
};

export type ImageInfo = {
  __typename?: 'ImageInfo';
  height: Scalars['Int'];
  orientation?: Maybe<Scalars['Int']>;
  width: Scalars['Int'];
};

export type ImageInfoInput = {
  height: Scalars['Int'];
  orientation?: InputMaybe<Scalars['Int']>;
  width: Scalars['Int'];
};

export enum InboxNotificationFilterType {
  Billing = 'Billing',
  Comments = 'Comments',
  ContentIdea = 'ContentIdea',
  Invites = 'Invites',
  Mentions = 'Mentions',
  OrganizationUserAccessRequest = 'OrganizationUserAccessRequest',
  PermissionRequest = 'PermissionRequest',
  Reactions = 'Reactions',
  SocialListening = 'SocialListening',
  Tasks = 'Tasks'
}

export type InboxNotificationFilters = {
  filterTypes?: InputMaybe<Array<InboxNotificationFilterType>>;
  statuses?: InputMaybe<Array<NotificationStatus>>;
};

export type InboxNotificationMeta = {
  __typename?: 'InboxNotificationMeta';
  billingTotalCount: Scalars['Int'];
  commentsTotalCount: Scalars['Int'];
  contentIdeasTotalCount: Scalars['Int'];
  invitesTotalCount: Scalars['Int'];
  mentionsTotalCount: Scalars['Int'];
  organizationUserAccessRequestsTotalCount: Scalars['Int'];
  permissionRequestsTotalCount: Scalars['Int'];
  reactionsTotalCount: Scalars['Int'];
  socialListeningTotalCount: Scalars['Int'];
  tasksTotalCount: Scalars['Int'];
};

/** Internal organization role of a user */
export enum InternalOrganizationRole {
  Admin = 'Admin',
  InternalStakeholder = 'InternalStakeholder',
  SocialListeningUser = 'SocialListeningUser',
  User = 'User'
}

export type InviteCollectionMemberByEmailInput = {
  collectionId: Scalars['String'];
  email: Scalars['String'];
  permission: PermissionLevel;
};

export type InviteCollectionMemberByIdInput = {
  collectionId: Scalars['String'];
  permission: PermissionLevel;
  userId: Scalars['String'];
};

export type InviteCollectionMembersInput = {
  emailInvites: Array<InviteCollectionMemberByEmailInput>;
  inviteType?: InputMaybe<CollectionInviteType>;
  memberInvites: Array<InviteCollectionMemberByIdInput>;
  message?: InputMaybe<Scalars['String']>;
  shouldCreateComment?: InputMaybe<Scalars['Boolean']>;
};

export type InviteMembersInput = {
  emailInvites: Array<EmailInput>;
  inviteType?: InputMaybe<CollectionInviteType>;
  message?: InputMaybe<Scalars['String']>;
  shouldCreateComment?: InputMaybe<Scalars['Boolean']>;
};

export type InvitePostMemberByEmailInput = {
  email: Scalars['String'];
  permission: PermissionLevel;
  postId: Scalars['String'];
};

export type InvitePostMemberByIdInput = {
  permission: PermissionLevel;
  postId: Scalars['String'];
  userId: Scalars['String'];
};

export type InvitePostMembersInput = {
  emailInvites: Array<InvitePostMemberByEmailInput>;
  memberInvites: Array<InvitePostMemberByIdInput>;
  message?: InputMaybe<Scalars['String']>;
  shouldCreateComment?: InputMaybe<Scalars['Boolean']>;
};

export type InviteUsersToCurrentOrgByRoleData = {
  email: Scalars['String'];
  role: InternalOrganizationRole;
};

export type InviteUsersToCurrentOrgByRoleInput = {
  data: Array<InviteUsersToCurrentOrgByRoleData>;
};

export type InviteUsersToCurrentOrgInput = {
  emails: Array<Scalars['String']>;
  role: InternalOrganizationRole;
};

export type InviteUsersWithoutOrgInput = {
  emails: Array<Scalars['String']>;
};

export type IsCollectionsPermissionLessThanParentCollectionPermissionInput = {
  collectionIds: Array<Scalars['String']>;
  parentCollectionId: Scalars['String'];
};

export type IsPostsPermissionLessThanParentCollectionPermissionInput = {
  collectionId: Scalars['String'];
  postIds: Array<Scalars['String']>;
};

export type IsTrackingCreatorProfileInsightsByCreatorIdInput = {
  brandId: Scalars['String'];
  creatorId: Scalars['String'];
};

export type IsTrackingCreatorProfileInsightsInput = {
  brandId: Scalars['String'];
  creatorProfileId: Scalars['String'];
};

export type JoinCollectionThroughLinkInput = {
  collectionId: Scalars['String'];
};

export type JoinContentCalendarViewInput = {
  contentCalendarViewId: Scalars['String'];
};

export type LanguageModel = {
  __typename?: 'LanguageModel';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type LinkFilterInput = {
  selectAll?: Scalars['Boolean'];
  types?: InputMaybe<Array<LinkFilterType>>;
};

/** Link Filter Type */
export enum LinkFilterType {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Linkedin = 'Linkedin',
  Other = 'Other',
  Pinterest = 'Pinterest',
  Threads = 'Threads',
  TikTok = 'TikTok',
  X = 'X',
  YouTube = 'YouTube'
}

export type ListSavedConfigsInput = {
  brandId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SavedConfigType>;
};

export enum ListeningTopicType {
  BrandMention = 'BrandMention',
  CompetitorAnalysis = 'CompetitorAnalysis',
  CreatorTracking = 'CreatorTracking',
  Engagement = 'Engagement',
  SignalMining = 'SignalMining',
  SocialAnalytics = 'SocialAnalytics',
  TopicEngagement = 'TopicEngagement'
}

export enum LoginSource {
  Mobile = 'Mobile',
  Web = 'Web'
}

export type ManuallyParsedSocialPostTrackerFilters = {
  brandIds: Array<Scalars['String']>;
  hasFoundBrandCreatorComment?: InputMaybe<Scalars['Boolean']>;
  parsedByUserIds?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Platform>>;
};

export type ManuallyParsedSocialPostTrackerModel = {
  __typename?: 'ManuallyParsedSocialPostTrackerModel';
  brand: BrandModel;
  brandId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  parsedByUser: UserProfileModel;
  parsedByUserId: Scalars['String'];
  socialPost: SocialPostModel;
  socialPostId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MarkRadarEventAsReadInput = {
  radarEventIds: Array<Scalars['String']>;
};

export type MeModel = {
  __typename?: 'MeModel';
  avatarUrl?: Maybe<Scalars['String']>;
  cohorts: Array<UserCohorts>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  emailVerificationToken?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Scalars['String']>>;
  firstName: Scalars['String'];
  hasBeenApprovedByAdmin: Scalars['Boolean'];
  hasVerifiedEmail: Scalars['Boolean'];
  id: Scalars['ID'];
  invitedByOrganization?: Maybe<OrganizationProfileModel>;
  invitedByUser?: Maybe<UserProfileModel>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  joinedOrganizations: Array<OrganizationProfileModel>;
  lastName: Scalars['String'];
  logoutUrl?: Maybe<Scalars['String']>;
  notificationSettings: Array<NotificationSettingModel>;
  onboardingAnswers?: Maybe<OnboardingAnswersData>;
  onboardingState?: Maybe<OnboardingStateData>;
  organization: OrganizationModel;
  organizationId: Scalars['String'];
  personalSettings?: Maybe<PersonalSettings>;
  phoneNumber?: Maybe<Scalars['String']>;
  plan: Scalars['String'];
  postCreatedCount: Scalars['Int'];
  registrationMethod: Array<RegistrationMethod>;
  role: InternalOrganizationRole;
  socialListeningBrands: Array<BrandModel>;
  taskCreatedCount: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uploadToken: UploadSecureToken;
};

export type MediaSize = {
  __typename?: 'MediaSize';
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type MergeCreatorProfilesInput = {
  creatorIdsToAdd: Array<Scalars['String']>;
  creatorProfileIdsToMerge: Array<Scalars['String']>;
  currentCreatorProfileId: Scalars['String'];
};

export type Metadata = {
  __typename?: 'Metadata';
  audio?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  canonical?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fileSizeInBytes?: Maybe<Scalars['Int']>;
  hashtags?: Maybe<Array<Scalars['String']>>;
  medias?: Maybe<Array<SocialMediaResource>>;
  medium?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Array<ThumbnailMetadata>>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum MetricsTimeRange {
  AllTime = 'AllTime',
  OneMonth = 'OneMonth',
  OneWeek = 'OneWeek',
  OneYear = 'OneYear',
  SixMonths = 'SixMonths',
  ThreeMonths = 'ThreeMonths'
}

export type MoveCollectionsToCollectionInput = {
  collectionIds: Array<Scalars['String']>;
  toCollectionId: Scalars['String'];
};

export type MovePostsToCollectionInput = {
  fromCollectionId?: InputMaybe<Scalars['String']>;
  postIds: Array<Scalars['String']>;
  toCollectionId: Scalars['String'];
};

export type MultiChartDataPoint = {
  __typename?: 'MultiChartDataPoint';
  chartDataPoints: Array<ChartDataPoint>;
  id: Scalars['String'];
  label: Scalars['String'];
  parsingSince: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptPushNotification: Result;
  addBrandExclusion: Result;
  addCreatorToCreatorProfile: Result;
  addOrganizationCreatorProfileLabelToCreatorProfile: Result;
  addOrganizationSocialPostCommentLabelsToSocialPostComment: Array<SocialPostCommentModel>;
  addPostToCollection: Result;
  addPostsToContentCalendar: Result;
  addToContentCalendarForSocialListeningPost: PostModel;
  addTrendToContentCalendar: PostModel;
  approveOrganizationAccessRequest: OrganizationUserAccessRequestModel;
  approveOrganizationAccessRequestForEnterpriseOrg: OrganizationUserAccessRequestModel;
  approveOrganizationAccessRequests: Array<OrganizationUserAccessRequestModel>;
  approvePermissionRequest: PermissionRequestModel;
  archiveTask: TaskModel;
  blockCreator: Result;
  blockCreatorFromCreatorProfile: Result;
  cancelSetupIntent: BillingSetupIntent;
  consumeShareLink: Result;
  createBrand: BrandModel;
  createBrandBookmark: BookmarkModel;
  createBrandMentionTopic: TopicModel;
  createBrandSocialPostEngagement: BrandSocialPostEngagementModel;
  createCollection: CollectionModel;
  createCollectionBookmark: BookmarkModel;
  createComment: CommentModel;
  createCompetitorBookmark: BookmarkModel;
  createCompetitors: Array<CompetitorModel>;
  createContentCalendarView: ContentCalendarViewModel;
  createContentIdea: ContentIdeaModel;
  createContentIdeaField: ContentIdeaFieldModel;
  createContentIdeaFieldOption: ContentIdeaFieldOptionModel;
  createCreator: CreatorModel;
  createCreatorProfileIfNotExists: Result;
  createCreatorTrackingTopic: TopicModel;
  createEditorialPosts: Result;
  createEditorialTask: PostModel;
  createEngagementTopic: TopicModel;
  createFilePost: PostModel;
  createFreeTrialSubscription: BillingSubscription;
  createLinkPost: PostModel;
  createNotePost: PostModel;
  createOrganizationAccessRequest: OrganizationUserAccessRequestModel;
  createOrganizationAccessRequestsByNonAdmin: Array<OrganizationUserAccessRequestModel>;
  createOrganizationCreatorProfileLabel: OrganizationCreatorProfileLabelModel;
  createOrganizationSocialPostCommentLabels: OrganizationSocialPostCommentLabelModel;
  createPermissionRequest: PermissionRequestModel;
  createPermissionRequests: Array<PermissionRequestModel>;
  createPostAnnotation: PostAnnotationModel;
  createPostFavorite: PostFavoriteModel;
  createPostFavoriteV2: PostFavoriteModel;
  createPostForSocialListeningPost: PostModel;
  createPostForTrend: PostModel;
  createPostForTrendingPost: PostModel;
  createPosts: Array<PostModel>;
  createPostsFavorite: Array<PostFavoriteModel>;
  createRadarEventActivity: RadarEventActivityModel;
  createRadarEventActivityCommunicationChannel: RadarEventActivityCommunicationChannelModel;
  createSavedConfig: Result;
  createSearchClicked: SearchClickedResultModel;
  createSearchTerms: Array<SearchTermModel>;
  createSetupIntent: BillingSetupIntent;
  createSignalCategoryOption: SignalCategoryOptionModel;
  createSignalDefinition: SignalDefinitionModel;
  createSocialAuthor: SocialAuthorModel;
  createSocialPostForOutboundComments: SocialPostModel;
  createSocialPostNotificationConfig: SocialPostNotificationConfigModel;
  createSocialPostReport: SocialPostReportModel;
  createSubscription: BillingSubscription;
  createTask: TaskModel;
  createTopicBookmark: BookmarkModel;
  /** Create a trend from a post. Primarily use in case cron job fails */
  createTrend: TrendModel;
  createTrendFavorite: PostFavoriteModel;
  declinePendingUserRequest: Result;
  deleteAccount: Result;
  deleteAssetComment: Result;
  deleteAttachment: Result;
  deleteBookmark: Result;
  deleteBrandBookmark: Result;
  deleteCollection: Result;
  deleteCollectionBookmark: Result;
  deleteCollections: Result;
  deleteComment: Result;
  deleteCompetitorBookmark: Result;
  deleteContentCalendarView: Result;
  deleteContentIdea: Result;
  deleteContentIdeaField: Result;
  deleteContentIdeaFieldOption: Result;
  deleteManuallyParsedSocialPostTracker: Result;
  deleteNotifications: Result;
  deletePost: Result;
  deletePostAnnotation: Result;
  deletePostFavorite: Result;
  deletePostFavoriteV2: Result;
  deletePosts: Result;
  deletePostsFavorite: Result;
  deleteSavedConfig: Result;
  deleteSignalCategoryOption: Result;
  deleteSignalDefinition: Result;
  deleteSocialAuthor: Result;
  deleteSocialPostNotificationConfig: Result;
  deleteSuggestedPost: Result;
  deleteTask: Result;
  deleteTopic: Result;
  deleteTopicBookmark: Result;
  deleteTrendFavorite: Result;
  disableUsers: Result;
  downgradeToFreePlan: OrganizationBillingModel;
  duplicateContentCalendarView: ContentCalendarViewModel;
  duplicateContentIdeaField: ContentIdeaFieldModel;
  duplicatePost: PostModel;
  duplicateTask: TaskModel;
  enableOnlyTheseUsers: Result;
  enableUsers: Result;
  fetchNewCreatorIntoDb: Result;
  forgotPassword: Result;
  generateShareLink: ShareLinkModel;
  getCollectionPostsForPermissionUpdate: CollectionManyPostsPermissionUpdateResult;
  getCoupon: BillingCoupon;
  getInvoices: Array<BillingInvoice>;
  getSubscription: BillingSubscription;
  hideHashtagUsedForBrand: Result;
  hideHashtagUsedForCreator: HashtagUsedForCompetitorModel;
  inviteCollectionMembers: Result;
  invitePostMembers: Result;
  inviteUsersToCurrentOrg: Array<UserProfileModel>;
  inviteUsersToCurrentOrgByRoles: Array<UserProfileModel>;
  inviteUsersWithoutOrg: Array<UserProfileModel>;
  joinCollectionThroughLink: Result;
  joinContentCalendarView: ContentCalendarViewModel;
  markRadarEventAsRead: Result;
  mergeCreatorProfiles: Result;
  moveCollectionsToCollection: Result;
  movePostsToCollection: Result;
  notifyAdminForBilling: Result;
  organizePosts: Result;
  /** This mutation is used to pause post parsing for a brand until the next cycle starts, or to pause post parsing indefinitely */
  pauseBrand: BrandModel;
  pauseTopic: TopicModel;
  pinCollectionToParent: PinnedEntityModel;
  pinCollectionToRoot: PinnedEntityModel;
  pinCollectionsToRoot: Array<PinnedEntityModel>;
  pinManyCollectionsToParent: Array<PinnedEntityModel>;
  pinManyPostsToCollection: Array<PinnedEntityModel>;
  pinPostToCollection: PinnedEntityModel;
  processPostsAfterCreation: Array<PostModel>;
  react: Result;
  reactToPost: Result;
  readAllComments: Result;
  readAllNotifications: Result;
  readNotification: NotificationModel;
  readNotifications: Result;
  refreshToken: TokenModel;
  rejectOrganizationAccessRequest: OrganizationUserAccessRequestModel;
  rejectPermissionRequest: PermissionRequestModel;
  removeCollectionsParent: Result;
  removeCompetitors: Array<CompetitorModel>;
  removeContentIdeaFromSnooze: ContentIdeaModel;
  removeCreator: Result;
  removeCreatorBlockingByHandle: Result;
  removeCreatorFromCreatorProfile: Result;
  removeGuestUser: Result;
  removeOrganizationCreatorProfileLabelFromCreatorProfile: Result;
  removeOrganizationSocialPostCommentLabelsFromSocialPostComment: Array<SocialPostCommentModel>;
  removePermissionRequestInvitedUser: PermissionRequestModel;
  removePostFromCollection: Result;
  removePostsFromCollections: Result;
  removeSuggestedPostFromCollection: Result;
  requestAdminToUpgrade: Result;
  resolvePostAnnotation: PostAnnotationModel;
  restrictAccessForUser: Result;
  resumeBrand: BrandModel;
  resumeSubscription: BillingSubscription;
  resumeTopic: TopicModel;
  resyncFromSocials: Result;
  resyncFromSocialsForOrganization: Result;
  revokeShareLink: Result;
  savePostsToCollections: Result;
  sendOTP: Result;
  setHasSeenFreeTrialEnded: OrganizationBillingModel;
  shouldUpdatePostPermissionToCollectionPermission: ShouldUpdatePostPermissionToCollectionPermissionResult;
  submitCompetitorParsing: Result;
  submitCreatorTrackingTopicParsing: Result;
  submitInitialTopicParsing: Result;
  trackCreatorForCreatorTrackingTopic: CreatorModel;
  trackCreatorForCreatorTrackingTopics: CreatorModel;
  trackEvent: Result;
  unblockCreatorFromCreatorProfile: Result;
  unhideHashtagUsedForBrand: Result;
  unhideHashtagUsedForCreator: HashtagUsedForCompetitorModel;
  unpinCollectionFromParent: Result;
  unpinCollectionFromRoot: Result;
  unpinCollectionsFromRoot: Result;
  unpinManyCollectionsFromParent: Result;
  unpinManyPostsFromCollection: Result;
  unpinPostFromCollection: Result;
  unreadNotification: NotificationModel;
  unrestrictAccessForUser: Result;
  untrackCreatorForCreatorTrackingTopic: CreatorModel;
  untrackCreatorForCreatorTrackingTopics: CreatorModel;
  updateBrand: BrandModel;
  updateBrandMentionTopic: TopicModel;
  updateBrandPermissions: Result;
  updateBrandRadarEventsConfig: Result;
  updateBrandSocialPostEngagement: BrandSocialPostEngagementModel;
  updateBrandSocialPostEngagementResponder: Result;
  updateCollection: CollectionModel;
  updateCollectionPermissionToParentCollectionPermission: Result;
  updateCollectionPermissions: Result;
  updateCollectionPermissionsV2: Result;
  updateCollectionPreview?: Maybe<PostModel>;
  updateComment: CommentModel;
  updateCompetitors: CompetitorModel;
  updateContentCalendarView: ContentCalendarViewModel;
  updateContentIdea: ContentIdeaModel;
  updateContentIdeaField: ContentIdeaFieldModel;
  updateContentIdeaFieldOption: ContentIdeaFieldOptionModel;
  updateContentIdeaFieldValue: ContentIdeaFieldValueModel;
  updateContentIdeaPublishMetadata: ContentIdeaPublishMetadataModel;
  updateCreatorProfile: Result;
  updateCreatorTrackingTopic: TopicModel;
  updateCreatorTrackingTopicStatus: Result;
  updateCustomerDefaultPaymentMethod: BillingCustomer;
  updateEngagementTopic: TopicModel;
  updateNestedCollectionPostPermissions: Result;
  updateNotificationSetting: NotificationSettingModel;
  updateOrganization: OrganizationModel;
  updateOrganizationSettings: OrganizationModel;
  updateOrganizationUserRole: UserProfileModel;
  updatePendingOrganizationAccessRequest: OrganizationUserAccessRequestModel;
  updatePost: PostModel;
  updatePostPermissionToCollectionPermission: Result;
  updatePostPermissionsV2: Result;
  updateRadarEventActivity: RadarEventActivityModel;
  updateSavedConfig: Result;
  updateSentimentSubject: Result;
  updateSignalCategoryOption: SignalCategoryOptionModel;
  updateSignalDefinition: SignalDefinitionModel;
  updateSocialListeningHourUsageThresholdAlert: NotificationModel;
  updateSocialPostNotificationConfig: SocialPostNotificationConfigModel;
  updateSubscription: BillingSubscription;
  updateTask: TaskModel;
  updateTopic: TopicModel;
  updateTrackingInsightsForCreatorProfileByCreatorId: CreatorModel;
  updateUserOnboarding: MeModel;
  updateUserOnboardingState: MeModel;
  updateUserPersonalSettings: MeModel;
  updateUserProfile: MeModel;
  upgradeDuringFreeTrial: BillingSubscription;
  upsertSentimentSubjects: Array<SentimentSubjectModel>;
  validateWorkosSignup: AuthModel;
  verifyOTP: Result;
  viewEntities: Result;
  viewEntity: Result;
};


export type MutationAcceptPushNotificationArgs = {
  data: AcceptPushNotificationInput;
};


export type MutationAddBrandExclusionArgs = {
  data: ExcludeBrandInput;
};


export type MutationAddCreatorToCreatorProfileArgs = {
  input: AddCreatorToCreatorProfileInput;
};


export type MutationAddOrganizationCreatorProfileLabelToCreatorProfileArgs = {
  input: AddOrganizationCreatorProfileLabelToCreatorProfileInput;
};


export type MutationAddOrganizationSocialPostCommentLabelsToSocialPostCommentArgs = {
  data: AddLabelsToSocialPostCommentInput;
};


export type MutationAddPostToCollectionArgs = {
  data: AddPostToCollectionInput;
};


export type MutationAddPostsToContentCalendarArgs = {
  data: AddPostsToContentCalendarInput;
};


export type MutationAddToContentCalendarForSocialListeningPostArgs = {
  data: AddToContentCalendarForSocialListeningPostInput;
};


export type MutationAddTrendToContentCalendarArgs = {
  data: AddTrendToContentCalendarInput;
};


export type MutationApproveOrganizationAccessRequestArgs = {
  data: ApproveOrganizationUserAccessRequestInput;
};


export type MutationApproveOrganizationAccessRequestForEnterpriseOrgArgs = {
  data: ApproveOrganizationUserAccessRequestWithRoleInput;
};


export type MutationApproveOrganizationAccessRequestsArgs = {
  data: ApproveOrganizationUserAccessRequestsInput;
};


export type MutationApprovePermissionRequestArgs = {
  data: ApprovePermissionRequestInput;
};


export type MutationArchiveTaskArgs = {
  data: ArchiveTaskInput;
};


export type MutationBlockCreatorArgs = {
  data: BlockCreatorInput;
};


export type MutationBlockCreatorFromCreatorProfileArgs = {
  input: BlockCreatorFromCreatorProfileInput;
};


export type MutationCancelSetupIntentArgs = {
  data: CancelSetupIntentInput;
};


export type MutationConsumeShareLinkArgs = {
  data: ConsumeShareLinkInput;
};


export type MutationCreateBrandArgs = {
  data: CreateBrandInput;
};


export type MutationCreateBrandBookmarkArgs = {
  input: CreateBrandBookmarkInput;
};


export type MutationCreateBrandMentionTopicArgs = {
  data: CreateBrandMentionTopicInput;
};


export type MutationCreateBrandSocialPostEngagementArgs = {
  data: CreateBrandSocialPostEngagementInput;
};


export type MutationCreateCollectionArgs = {
  data: CreateCollectionInput;
};


export type MutationCreateCollectionBookmarkArgs = {
  input: CreateCollectionBookmarkInput;
};


export type MutationCreateCommentArgs = {
  data: CreateCommentInput;
};


export type MutationCreateCompetitorBookmarkArgs = {
  input: CreateCompetitorBookmarkInput;
};


export type MutationCreateCompetitorsArgs = {
  data: CreateCompetitorInput;
};


export type MutationCreateContentCalendarViewArgs = {
  data: CreateContentCalendarViewInput;
};


export type MutationCreateContentIdeaArgs = {
  data: CreateContentIdeaInput;
};


export type MutationCreateContentIdeaFieldArgs = {
  data: CreateContentIdeaFieldInput;
};


export type MutationCreateContentIdeaFieldOptionArgs = {
  data: CreateContentIdeaFieldOptionInput;
};


export type MutationCreateCreatorArgs = {
  data: CreateCreatorInput;
};


export type MutationCreateCreatorProfileIfNotExistsArgs = {
  input: CreateCreatorProfileIfNotExistsInput;
};


export type MutationCreateCreatorTrackingTopicArgs = {
  data: CreateCreatorTrackingTopicInput;
};


export type MutationCreateEditorialPostsArgs = {
  data: CreateEditorialPostsInput;
};


export type MutationCreateEditorialTaskArgs = {
  data: CreateEditorialTaskInput;
};


export type MutationCreateEngagementTopicArgs = {
  data: CreateEngagementTopicInput;
};


export type MutationCreateFilePostArgs = {
  data: CreateFilePostInput;
};


export type MutationCreateFreeTrialSubscriptionArgs = {
  planName: Scalars['String'];
};


export type MutationCreateLinkPostArgs = {
  data: CreateLinkPostInput;
};


export type MutationCreateNotePostArgs = {
  data: CreateNotePostInput;
};


export type MutationCreateOrganizationAccessRequestArgs = {
  data: CreateOrganizationUserAccessRequestInput;
};


export type MutationCreateOrganizationAccessRequestsByNonAdminArgs = {
  data: CreateOrganizationUserAccessRequestsByNonAdminInput;
};


export type MutationCreateOrganizationCreatorProfileLabelArgs = {
  input: CreateOrganizationCreatorProfileLabelInput;
};


export type MutationCreateOrganizationSocialPostCommentLabelsArgs = {
  data: CreateOrganizationSocialPostCommentLabelInput;
};


export type MutationCreatePermissionRequestArgs = {
  data: CreatePermissionRequestInput;
};


export type MutationCreatePermissionRequestsArgs = {
  data: CreatePermissionRequestsInput;
};


export type MutationCreatePostAnnotationArgs = {
  data: CreatePostAnnotationInput;
};


export type MutationCreatePostFavoriteArgs = {
  data: CreatePostFavoriteInput;
};


export type MutationCreatePostFavoriteV2Args = {
  data: CreatePostFavoriteInputV2;
};


export type MutationCreatePostForSocialListeningPostArgs = {
  data: CreatePostForSocialListeningPostInput;
};


export type MutationCreatePostForTrendArgs = {
  data: CreatePostForTrendInput;
};


export type MutationCreatePostForTrendingPostArgs = {
  data: CreatePostForEditorialPostInput;
};


export type MutationCreatePostsArgs = {
  data: CreatePostsInput;
};


export type MutationCreatePostsFavoriteArgs = {
  data: CreatePostsFavoriteInput;
};


export type MutationCreateRadarEventActivityArgs = {
  input: CreateRadarEventActivityInput;
};


export type MutationCreateRadarEventActivityCommunicationChannelArgs = {
  input: CreateRadarEventActivityCommunicationChannelInput;
};


export type MutationCreateSavedConfigArgs = {
  input: CreateSavedConfigInput;
};


export type MutationCreateSearchClickedArgs = {
  data: SearchHitClickInput;
};


export type MutationCreateSearchTermsArgs = {
  data: CreateSearchTermInput;
};


export type MutationCreateSetupIntentArgs = {
  data: CreateSetupIntentInput;
};


export type MutationCreateSignalCategoryOptionArgs = {
  data: CreateSignalCategoryOptionInput;
};


export type MutationCreateSignalDefinitionArgs = {
  data: CreateSignalDefinitionInput;
};


export type MutationCreateSocialAuthorArgs = {
  data: CreateSocialAuthorInput;
};


export type MutationCreateSocialPostForOutboundCommentsArgs = {
  data: CreateSocialPostForOutboundCommentsInput;
};


export type MutationCreateSocialPostNotificationConfigArgs = {
  data: CreateSocialPostNotificationConfigInput;
};


export type MutationCreateSocialPostReportArgs = {
  data: CreateSocialPostReportInput;
};


export type MutationCreateSubscriptionArgs = {
  data: CreateBillingSubscriptionInput;
};


export type MutationCreateTaskArgs = {
  data: CreateTaskInput;
};


export type MutationCreateTopicBookmarkArgs = {
  input: CreateTopicBookmarkInput;
};


export type MutationCreateTrendArgs = {
  input: CreateTrendInput;
};


export type MutationCreateTrendFavoriteArgs = {
  data: CreateTrendFavoriteInput;
};


export type MutationDeclinePendingUserRequestArgs = {
  data: DeclinePendingUserRequestInput;
};


export type MutationDeleteAssetCommentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAttachmentArgs = {
  data: DeleteAttachmentInput;
};


export type MutationDeleteBookmarkArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBrandBookmarkArgs = {
  input: DeleteBrandBookmarkInput;
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCollectionBookmarkArgs = {
  input: DeleteCollectionBookmarkInput;
};


export type MutationDeleteCollectionsArgs = {
  data: DeleteCollectionsInput;
};


export type MutationDeleteCommentArgs = {
  data: DeleteCommentInput;
};


export type MutationDeleteCompetitorBookmarkArgs = {
  input: DeleteCompetitorBookmarkInput;
};


export type MutationDeleteContentCalendarViewArgs = {
  data: DeleteContentCalendarViewInput;
};


export type MutationDeleteContentIdeaArgs = {
  data: DeleteContentIdeaInput;
};


export type MutationDeleteContentIdeaFieldArgs = {
  data: DeleteContentIdeaFieldInput;
};


export type MutationDeleteContentIdeaFieldOptionArgs = {
  data: DeleteContentIdeaFieldOptionInput;
};


export type MutationDeleteManuallyParsedSocialPostTrackerArgs = {
  data: DeleteManuallyParsedSocialPostTrackerInput;
};


export type MutationDeleteNotificationsArgs = {
  data: DeleteNotificationsInput;
};


export type MutationDeletePostArgs = {
  id: Scalars['String'];
};


export type MutationDeletePostAnnotationArgs = {
  data: DeletePostAnnotationInput;
};


export type MutationDeletePostFavoriteArgs = {
  data: DeletePostFavoriteInput;
};


export type MutationDeletePostFavoriteV2Args = {
  data: DeletePostFavoriteInputV2;
};


export type MutationDeletePostsArgs = {
  data: DeletePostsInput;
};


export type MutationDeletePostsFavoriteArgs = {
  data: DeletePostsFavoriteInput;
};


export type MutationDeleteSavedConfigArgs = {
  input: DeleteSavedConfigInput;
};


export type MutationDeleteSignalCategoryOptionArgs = {
  data: DeleteSignalCategoryOptionInput;
};


export type MutationDeleteSignalDefinitionArgs = {
  data: DeleteSignalDefinitionInput;
};


export type MutationDeleteSocialAuthorArgs = {
  data: DeleteSocialAuthorInput;
};


export type MutationDeleteSocialPostNotificationConfigArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSuggestedPostArgs = {
  data: DeleteSuggestedPostInput;
};


export type MutationDeleteTaskArgs = {
  data: DeleteTaskInput;
};


export type MutationDeleteTopicArgs = {
  topicId: Scalars['String'];
};


export type MutationDeleteTopicBookmarkArgs = {
  input: DeleteTopicBookmarkInput;
};


export type MutationDeleteTrendFavoriteArgs = {
  data: DeleteTrendFavoriteInput;
};


export type MutationDisableUsersArgs = {
  data: DisableUsersInput;
};


export type MutationDuplicateContentCalendarViewArgs = {
  data: DuplicateContentCalendarViewInput;
};


export type MutationDuplicateContentIdeaFieldArgs = {
  data: DuplicateContentIdeaFieldInput;
};


export type MutationDuplicatePostArgs = {
  data: DuplicatePostInput;
};


export type MutationDuplicateTaskArgs = {
  data: DuplicateTaskInput;
};


export type MutationEnableOnlyTheseUsersArgs = {
  data: EnableUsersInput;
};


export type MutationEnableUsersArgs = {
  data: EnableUsersInput;
};


export type MutationFetchNewCreatorIntoDbArgs = {
  handle: Scalars['String'];
  platform: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  data: ForgotPasswordInput;
};


export type MutationGenerateShareLinkArgs = {
  data: GenerateShareLinkInput;
};


export type MutationGetCollectionPostsForPermissionUpdateArgs = {
  data: GetCollectionPostsForPermissionUpdateInput;
};


export type MutationGetCouponArgs = {
  promotionCode: Scalars['String'];
};


export type MutationGetSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationHideHashtagUsedForBrandArgs = {
  data: HideHashtagUsedForBrandInput;
};


export type MutationHideHashtagUsedForCreatorArgs = {
  data: HideHashtagUsedForCreatorInput;
};


export type MutationInviteCollectionMembersArgs = {
  data: InviteCollectionMembersInput;
};


export type MutationInvitePostMembersArgs = {
  data: InvitePostMembersInput;
};


export type MutationInviteUsersToCurrentOrgArgs = {
  data: InviteUsersToCurrentOrgInput;
};


export type MutationInviteUsersToCurrentOrgByRolesArgs = {
  data: InviteUsersToCurrentOrgByRoleInput;
};


export type MutationInviteUsersWithoutOrgArgs = {
  data: InviteUsersWithoutOrgInput;
};


export type MutationJoinCollectionThroughLinkArgs = {
  data: JoinCollectionThroughLinkInput;
};


export type MutationJoinContentCalendarViewArgs = {
  data: JoinContentCalendarViewInput;
};


export type MutationMarkRadarEventAsReadArgs = {
  input: MarkRadarEventAsReadInput;
};


export type MutationMergeCreatorProfilesArgs = {
  input: MergeCreatorProfilesInput;
};


export type MutationMoveCollectionsToCollectionArgs = {
  data: MoveCollectionsToCollectionInput;
};


export type MutationMovePostsToCollectionArgs = {
  data: MovePostsToCollectionInput;
};


export type MutationOrganizePostsArgs = {
  data: OrganizePostsInput;
};


export type MutationPauseBrandArgs = {
  data: PauseBrandInput;
};


export type MutationPauseTopicArgs = {
  data: PauseTopicInput;
};


export type MutationPinCollectionToParentArgs = {
  data: PinCollectionInput;
};


export type MutationPinCollectionToRootArgs = {
  data: PinCollectionInput;
};


export type MutationPinCollectionsToRootArgs = {
  data: PinCollectionsInput;
};


export type MutationPinManyCollectionsToParentArgs = {
  data: PinManyCollectionsToParentInput;
};


export type MutationPinManyPostsToCollectionArgs = {
  data: PinManyPostsToCollectionInput;
};


export type MutationPinPostToCollectionArgs = {
  data: PinPostToCollectionInput;
};


export type MutationProcessPostsAfterCreationArgs = {
  data: ProcessPostsAfterCreationInput;
};


export type MutationReactArgs = {
  data: ReactInput;
};


export type MutationReactToPostArgs = {
  data: ReactToPostInput;
};


export type MutationReadAllCommentsArgs = {
  data: ReadAllCommentsInput;
};


export type MutationReadNotificationArgs = {
  id: Scalars['String'];
};


export type MutationReadNotificationsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationRefreshTokenArgs = {
  token: Scalars['JWT'];
};


export type MutationRejectOrganizationAccessRequestArgs = {
  data: RejectOrganizationUserAccessRequestInput;
};


export type MutationRejectPermissionRequestArgs = {
  data: RejectPermissionRequestInput;
};


export type MutationRemoveCollectionsParentArgs = {
  data: RemoveCollectionsParentInput;
};


export type MutationRemoveCompetitorsArgs = {
  data: RemoveCompetitorsInput;
};


export type MutationRemoveContentIdeaFromSnoozeArgs = {
  contentIdeaId: Scalars['String'];
};


export type MutationRemoveCreatorArgs = {
  data: RemoveCreatorInput;
};


export type MutationRemoveCreatorBlockingByHandleArgs = {
  data: RemoveCreatorBlockingByHandleInput;
};


export type MutationRemoveCreatorFromCreatorProfileArgs = {
  input: RemoveCreatorFromCreatorProfileInput;
};


export type MutationRemoveGuestUserArgs = {
  data: Scalars['String'];
};


export type MutationRemoveOrganizationCreatorProfileLabelFromCreatorProfileArgs = {
  input: RemoveOrganizationCreatorProfileLabelFromCreatorProfileInput;
};


export type MutationRemoveOrganizationSocialPostCommentLabelsFromSocialPostCommentArgs = {
  data: RemoveLabelsFromSocialPostCommentInput;
};


export type MutationRemovePermissionRequestInvitedUserArgs = {
  data: RemovePermissionRequestInvitedMemberInput;
};


export type MutationRemovePostFromCollectionArgs = {
  data: RemovePostFromCollectionInput;
};


export type MutationRemovePostsFromCollectionsArgs = {
  data: RemovePostsFromCollectionsInput;
};


export type MutationRemoveSuggestedPostFromCollectionArgs = {
  data: RemoveSuggestedPostFromCollectionsInput;
};


export type MutationRequestAdminToUpgradeArgs = {
  data: RequestAdminToUpgradeInput;
};


export type MutationResolvePostAnnotationArgs = {
  data: ResolvePostAnnotationInput;
};


export type MutationResumeBrandArgs = {
  data: ResumeBrandInput;
};


export type MutationResumeSubscriptionArgs = {
  data: ResumeBillingSubscriptionInput;
};


export type MutationResumeTopicArgs = {
  data: ResumeTopicInput;
};


export type MutationResyncFromSocialsForOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type MutationRevokeShareLinkArgs = {
  data: RevokeShareLinkInput;
};


export type MutationSavePostsToCollectionsArgs = {
  data: SavePostsToCollectionsInput;
};


export type MutationSendOtpArgs = {
  data: SendOtpInput;
};


export type MutationShouldUpdatePostPermissionToCollectionPermissionArgs = {
  data: ShouldUpdatePostPermissionToCollectionPermissionInput;
};


export type MutationSubmitCompetitorParsingArgs = {
  competitorId: Scalars['String'];
  daysCount: Scalars['Int'];
};


export type MutationSubmitCreatorTrackingTopicParsingArgs = {
  daysCount: Scalars['Int'];
  topicId: Scalars['String'];
};


export type MutationSubmitInitialTopicParsingArgs = {
  daysCount: Scalars['Int'];
  includeInstagram?: InputMaybe<Scalars['Boolean']>;
  includeTiktok?: InputMaybe<Scalars['Boolean']>;
  topicId: Scalars['String'];
};


export type MutationTrackCreatorForCreatorTrackingTopicArgs = {
  data: TrackCreatorInput;
};


export type MutationTrackCreatorForCreatorTrackingTopicsArgs = {
  data: TrackCreatorsInput;
};


export type MutationTrackEventArgs = {
  data: TrackEventInput;
};


export type MutationUnblockCreatorFromCreatorProfileArgs = {
  input: UnblockCreatorFromCreatorProfileInput;
};


export type MutationUnhideHashtagUsedForBrandArgs = {
  data: HideHashtagUsedForBrandInput;
};


export type MutationUnhideHashtagUsedForCreatorArgs = {
  data: UnhideHashtagUsedForCreatorInput;
};


export type MutationUnpinCollectionFromParentArgs = {
  data: UnpinCollectionInput;
};


export type MutationUnpinCollectionFromRootArgs = {
  data: UnpinCollectionInput;
};


export type MutationUnpinCollectionsFromRootArgs = {
  data: UnpinCollectionsInput;
};


export type MutationUnpinManyCollectionsFromParentArgs = {
  data: UnpinManyCollectionsFromParentInput;
};


export type MutationUnpinManyPostsFromCollectionArgs = {
  data: UnpinManyPostsFromCollectionInput;
};


export type MutationUnpinPostFromCollectionArgs = {
  data: UnpinPostFromCollectionInput;
};


export type MutationUnreadNotificationArgs = {
  id: Scalars['String'];
};


export type MutationUntrackCreatorForCreatorTrackingTopicArgs = {
  data: TrackCreatorInput;
};


export type MutationUntrackCreatorForCreatorTrackingTopicsArgs = {
  data: UntrackCreatorForTopicsInput;
};


export type MutationUpdateBrandArgs = {
  data: UpdateBrandInput;
};


export type MutationUpdateBrandMentionTopicArgs = {
  data: UpdateBrandMentionTopicInput;
};


export type MutationUpdateBrandPermissionsArgs = {
  data: UpdateBrandPermissionsInput;
};


export type MutationUpdateBrandRadarEventsConfigArgs = {
  brandId: Scalars['String'];
  input: UpdateBrandRadarEventsConfigInput;
};


export type MutationUpdateBrandSocialPostEngagementArgs = {
  data: UpdateBrandSocialPostEngagementInput;
};


export type MutationUpdateBrandSocialPostEngagementResponderArgs = {
  data: UpdateBrandSocialPostEngagementResponderInput;
};


export type MutationUpdateCollectionArgs = {
  data: UpdateCollectionInput;
};


export type MutationUpdateCollectionPermissionToParentCollectionPermissionArgs = {
  data: UpdateCollectionPermissionToParentCollectionPermissionInput;
};


export type MutationUpdateCollectionPermissionsArgs = {
  data: UpdateCollectionPermissionsInput;
};


export type MutationUpdateCollectionPermissionsV2Args = {
  data: UpdateCollectionPermissionsInputV2;
};


export type MutationUpdateCollectionPreviewArgs = {
  data: UpdateCollectionPreviewInput;
};


export type MutationUpdateCommentArgs = {
  data: UpdateCommentInput;
};


export type MutationUpdateCompetitorsArgs = {
  data: UpdateCompetitorInput;
};


export type MutationUpdateContentCalendarViewArgs = {
  data: UpdateContentCalendarViewInput;
};


export type MutationUpdateContentIdeaArgs = {
  data: UpdateContentIdeaInput;
};


export type MutationUpdateContentIdeaFieldArgs = {
  data: UpdateContentIdeaFieldInput;
};


export type MutationUpdateContentIdeaFieldOptionArgs = {
  data: UpdateContentIdeaFieldOptionInput;
};


export type MutationUpdateContentIdeaFieldValueArgs = {
  data: UpdateContentIdeaFieldValueInput;
};


export type MutationUpdateContentIdeaPublishMetadataArgs = {
  data: UpdateContentIdeaPublishMetadataInput;
};


export type MutationUpdateCreatorProfileArgs = {
  input: UpdateCreatorProfileInput;
};


export type MutationUpdateCreatorTrackingTopicArgs = {
  data: UpdateCreatorTrackingTopicInput;
};


export type MutationUpdateCreatorTrackingTopicStatusArgs = {
  input: UpdateCreatorTrackingTopicStatusInput;
};


export type MutationUpdateCustomerDefaultPaymentMethodArgs = {
  data: UpdateBillingCustomerDefaultPaymentMethodInput;
};


export type MutationUpdateEngagementTopicArgs = {
  data: UpdateEngagementTopicInput;
};


export type MutationUpdateNestedCollectionPostPermissionsArgs = {
  data: UpdateNestedCollectionPostPermissionsInput;
};


export type MutationUpdateNotificationSettingArgs = {
  data: UpdateNotificationSettingInput;
};


export type MutationUpdateOrganizationArgs = {
  data: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationSettingsArgs = {
  data: UpdateOrganizationSettingsInput;
};


export type MutationUpdateOrganizationUserRoleArgs = {
  data: UpdateOrganizationUserRoleInput;
};


export type MutationUpdatePendingOrganizationAccessRequestArgs = {
  data: UpdateOrganizationUserAccessRequestInput;
};


export type MutationUpdatePostArgs = {
  data: UpdatePostInput;
};


export type MutationUpdatePostPermissionToCollectionPermissionArgs = {
  data: UpdatePostPermissionToCollectionPermissionInput;
};


export type MutationUpdatePostPermissionsV2Args = {
  data: UpdatePostPermissionsInputV2;
};


export type MutationUpdateRadarEventActivityArgs = {
  input: UpdateRadarEventActivityInput;
};


export type MutationUpdateSavedConfigArgs = {
  input: UpdateSavedConfigInput;
};


export type MutationUpdateSentimentSubjectArgs = {
  data: UpdateSentimentSubjectInput;
};


export type MutationUpdateSignalCategoryOptionArgs = {
  data: UpdateSignalCategoryOptionInput;
};


export type MutationUpdateSignalDefinitionArgs = {
  data: UpdateSignalDefinitionInput;
};


export type MutationUpdateSocialListeningHourUsageThresholdAlertArgs = {
  data: UpdateSocialListeningHourUsageThresholdAlertInput;
};


export type MutationUpdateSocialPostNotificationConfigArgs = {
  data: UpdateSocialPostNotificationConfigInput;
};


export type MutationUpdateSubscriptionArgs = {
  data: UpdateBillingSubscriptionInput;
};


export type MutationUpdateTaskArgs = {
  data: UpdateTaskInput;
};


export type MutationUpdateTopicArgs = {
  data: UpdateTopicInput;
};


export type MutationUpdateTrackingInsightsForCreatorProfileByCreatorIdArgs = {
  input: UpdateTrackingInsightsForCreatorProfileByCreatorIdInput;
};


export type MutationUpdateUserOnboardingArgs = {
  data: UpdateUserOnboardingInput;
};


export type MutationUpdateUserOnboardingStateArgs = {
  data: UpdateUserOnboardingStateInput;
};


export type MutationUpdateUserPersonalSettingsArgs = {
  data: UpdateUserPersonalSettingsInput;
};


export type MutationUpdateUserProfileArgs = {
  data: UpdateUserProfileInput;
};


export type MutationUpgradeDuringFreeTrialArgs = {
  data: UpgradeDuringTrialInput;
};


export type MutationUpsertSentimentSubjectsArgs = {
  data: UpsertSentimentSubjectInput;
};


export type MutationValidateWorkosSignupArgs = {
  data: Scalars['String'];
  source?: InputMaybe<LoginSource>;
};


export type MutationVerifyOtpArgs = {
  data: VerifyOtpInput;
};


export type MutationViewEntitiesArgs = {
  data: ViewEntitiesInput;
};


export type MutationViewEntityArgs = {
  data: ViewEntityInput;
};

export type NestedEntities = {
  collectionId: Scalars['String'];
  excludedChildCollectionIds: Array<Scalars['String']>;
  excludedPostIds: Array<Scalars['String']>;
  mode: NestedEntitiesMode;
  nestedEntities: Array<NestedEntities>;
  parentCollectionId?: InputMaybe<Scalars['String']>;
};

export enum NestedEntitiesMode {
  Exclude = 'EXCLUDE',
  Select = 'SELECT'
}

export type NewEditorialPostInput = {
  body?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type: PostType;
  url?: InputMaybe<Scalars['String']>;
};

export type NewTaskInput = {
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
  memberIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  parentTaskId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<TaskPriority>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<TaskStatus>;
  subtasks?: InputMaybe<Array<SubtaskInput>>;
};

export type NoteFilterInput = {
  selectAll?: Scalars['Boolean'];
};

export type NotificationModel = {
  __typename?: 'NotificationModel';
  brandInviteMember?: Maybe<BrandInviteMemberModel>;
  collection?: Maybe<CollectionModel>;
  collectionInviteMember?: Maybe<CollectionInviteMemberModel>;
  comment?: Maybe<CommentModel>;
  contentIdea?: Maybe<ContentIdeaModel>;
  createdAt: Scalars['DateTime'];
  createdByUser: UserProfileModel;
  createdByUserId: Scalars['String'];
  createdForUserId: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  organizationUserAccessRequest?: Maybe<OrganizationUserAccessRequestModel>;
  permissionRequest?: Maybe<PermissionRequestModel>;
  post?: Maybe<PostModel>;
  postInviteMember?: Maybe<PostInviteMemberModel>;
  posts?: Maybe<Array<PostModel>>;
  resource?: Maybe<ResourceModel>;
  socialPostsNotificationData?: Maybe<SocialPostsNotificationDataModel>;
  status: NotificationStatus;
  task?: Maybe<TaskModel>;
  type: NotificationType;
  updatedAt: Scalars['DateTime'];
  userReaction?: Maybe<UserReactionModel>;
};

export type NotificationModelEdge = {
  __typename?: 'NotificationModelEdge';
  cursor: Scalars['String'];
  node: NotificationModel;
};

export type NotificationSettingModel = {
  __typename?: 'NotificationSettingModel';
  createdAt: Scalars['DateTime'];
  email: Scalars['Boolean'];
  id: Scalars['ID'];
  inbox: Scalars['Boolean'];
  mobilePush: Scalars['Boolean'];
  type: NotificationType;
  updatedAt: Scalars['DateTime'];
};

/** Status of the notification */
export enum NotificationStatus {
  Read = 'Read',
  Unread = 'Unread'
}

/** Type of the notification */
export enum NotificationType {
  AssetCommentAdded = 'AssetCommentAdded',
  AssetCreated = 'AssetCreated',
  AssetDeleted = 'AssetDeleted',
  AssignedToContentIdea = 'AssignedToContentIdea',
  BillingActionNeededFromMembers = 'BillingActionNeededFromMembers',
  BrandMemberInvite = 'BrandMemberInvite',
  BulkSocialPostsCreated = 'BulkSocialPostsCreated',
  CollectionComment = 'CollectionComment',
  CollectionCommentReaction = 'CollectionCommentReaction',
  CollectionMemberInvite = 'CollectionMemberInvite',
  CollectionMention = 'CollectionMention',
  DeliverableCreated = 'DeliverableCreated',
  DeliverableDeleted = 'DeliverableDeleted',
  DeliverableDescriptionUpdated = 'DeliverableDescriptionUpdated',
  DeliverableNameUpdated = 'DeliverableNameUpdated',
  DeliverableVersionCreated = 'DeliverableVersionCreated',
  InvitedToContentIdea = 'InvitedToContentIdea',
  MultiplePostInvite = 'MultiplePostInvite',
  MultiplePostMention = 'MultiplePostMention',
  OrganizationExternalMemberCreated = 'OrganizationExternalMemberCreated',
  OrganizationUserAccessRequestCreated = 'OrganizationUserAccessRequestCreated',
  PermissionRequestCreated = 'PermissionRequestCreated',
  PostComment = 'PostComment',
  PostCommentCreated = 'PostCommentCreated',
  PostCommentReaction = 'PostCommentReaction',
  PostCommentUserTagged = 'PostCommentUserTagged',
  PostFavoriteCreated = 'PostFavoriteCreated',
  PostMemberInvite = 'PostMemberInvite',
  PostMention = 'PostMention',
  PostNoteUserTagged = 'PostNoteUserTagged',
  PostReaction = 'PostReaction',
  PostTaskAssigned = 'PostTaskAssigned',
  ProjectDeleted = 'ProjectDeleted',
  ProjectMemberAdded = 'ProjectMemberAdded',
  ProjectMemberRemoved = 'ProjectMemberRemoved',
  ReminderForContentIdea = 'ReminderForContentIdea',
  RequestAdminToUpgrade = 'RequestAdminToUpgrade',
  RequestApproved = 'RequestApproved',
  RequestChangeRequested = 'RequestChangeRequested',
  RequestCommentCreated = 'RequestCommentCreated',
  RequestCreated = 'RequestCreated',
  RequestDeclined = 'RequestDeclined',
  RequestMemberTagged = 'RequestMemberTagged',
  RequestResolved = 'RequestResolved',
  ResourceCreated = 'ResourceCreated',
  ResourceDeleted = 'ResourceDeleted',
  SocialListeningBrandReachedUsageLimit = 'SocialListeningBrandReachedUsageLimit',
  SocialPostHourUsage = 'SocialPostHourUsage',
  SubtaskDeleted = 'SubtaskDeleted',
  SubtaskMemberAssigned = 'SubtaskMemberAssigned',
  TaskComment = 'TaskComment',
  TaskCommentReaction = 'TaskCommentReaction',
  TaskDateAdded = 'TaskDateAdded',
  TaskDateUpdated = 'TaskDateUpdated',
  TaskDeleted = 'TaskDeleted',
  TaskMemberAdded = 'TaskMemberAdded',
  TaskMention = 'TaskMention',
  TaskNameUpdated = 'TaskNameUpdated',
  TaskStatusUpdated = 'TaskStatusUpdated',
  UserCreated = 'UserCreated'
}

export type NumberRangeInput = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

/** The preference for sending OTP */
export enum OtpPreference {
  Sms = 'SMS',
  WhatsApp = 'WhatsApp'
}

export type OnboardingAnswersData = {
  __typename?: 'OnboardingAnswersData';
  painPoint?: Maybe<Scalars['String']>;
  referralSource?: Maybe<Scalars['String']>;
};

export type OnboardingAnswersInput = {
  painPoint?: InputMaybe<Scalars['String']>;
  referralSource?: InputMaybe<Scalars['String']>;
};

export type OnboardingStateData = {
  __typename?: 'OnboardingStateData';
  hasBeenApprovedByAdmin?: Maybe<Scalars['Boolean']>;
  hasSeenContentCalendarIntroduction?: Maybe<Scalars['Boolean']>;
  hasSeenContentCalendarOnboarding?: Maybe<Scalars['Boolean']>;
  hasSeenSLCommunityIntroduction?: Maybe<Scalars['Boolean']>;
  haveClickedJuiceBoxBtn?: Maybe<Scalars['Boolean']>;
  haveOnboardedAiOrganize?: Maybe<Scalars['Boolean']>;
  haveSeenJuiceBoxIntro?: Maybe<Scalars['Boolean']>;
  haveSeenTrialWrapped?: Maybe<Scalars['Boolean']>;
};

export type OnboardingStateInput = {
  hasSeenContentCalendarIntroduction?: InputMaybe<Scalars['Boolean']>;
  hasSeenContentCalendarOnboarding?: InputMaybe<Scalars['Boolean']>;
  hasSeenSLCommunityIntroduction?: InputMaybe<Scalars['Boolean']>;
  haveClickedJuiceBoxBtn?: InputMaybe<Scalars['Boolean']>;
  haveFilledQuestionaire?: InputMaybe<Scalars['Boolean']>;
  haveOnboardedAiOrganize?: InputMaybe<Scalars['Boolean']>;
  haveOnboardedMobile?: InputMaybe<Scalars['Boolean']>;
  haveSeenJuiceBoxIntro?: InputMaybe<Scalars['Boolean']>;
  haveSeenTrialWrapped?: InputMaybe<Scalars['Boolean']>;
};

/** The type of onboarding flow from which the user is linking their phone number */
export enum OnboardingType {
  Cjb = 'CJB',
  ContentCalendar = 'ContentCalendar'
}

export type OrganizationBillingModel = {
  __typename?: 'OrganizationBillingModel';
  aiFeaturesEnabled?: Maybe<Scalars['Boolean']>;
  billingCustomerId?: Maybe<Scalars['String']>;
  brandHoursParseLimit?: Maybe<Scalars['Int']>;
  collectionUsageCount: Scalars['Int'];
  collectionUsageLimit?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  customTrendsEnabled?: Maybe<Scalars['Boolean']>;
  fileDeliveryLimitInMb?: Maybe<Scalars['Int']>;
  fileStorageLimitInMb?: Maybe<Scalars['Int']>;
  fileStorageUsedInMb: Scalars['Int'];
  guestLimit?: Maybe<Scalars['Int']>;
  guestPermission: PermissionLevel;
  guestUsage: Scalars['Int'];
  hasReachedBrandUsageLimit: Scalars['Boolean'];
  hasSeenFreeTrialEnded?: Maybe<Scalars['Boolean']>;
  hasSeenNewPricing: Scalars['Boolean'];
  hasUsedFreeTrial?: Maybe<Scalars['Boolean']>;
  highestFreeTrialUsed?: Maybe<BillingPlanName>;
  id: Scalars['ID'];
  lastUpdatedByUserId: Scalars['String'];
  mobileAppEnabled?: Maybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  organizationMemberLimit?: Maybe<Scalars['Int']>;
  organizationMemberUsage: Scalars['Int'];
  plan: BillingPlanName;
  requestedAdminToUpgradePlans?: Maybe<Array<BillingPlanName>>;
  socialListeningEnabled?: Maybe<Scalars['Boolean']>;
  socialListeningHourUsageThresholdAlert: SocialListeningHourUsageThresholdAlert;
  subscription?: Maybe<BillingSubscription>;
  subscriptionId?: Maybe<Scalars['String']>;
  trendsEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationCreatorProfileLabelModel = {
  __typename?: 'OrganizationCreatorProfileLabelModel';
  bgColor?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdByUser: UserProfileModel;
  createdByUserId: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  organization: OrganizationModel;
  organizationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type OrganizationModel = {
  __typename?: 'OrganizationModel';
  billing: OrganizationBillingModel;
  createdAt: Scalars['DateTime'];
  domain: Scalars['String'];
  externalUsers: Array<UserProfileModel>;
  id: Scalars['ID'];
  myPermissions: Array<OrganizationPermission>;
  name: Scalars['String'];
  settings: OrganizationSettings;
  socialAuthors: Array<SocialAuthorModel>;
  socialListeningBrands: Array<BrandModel>;
  type?: Maybe<OrganizationType>;
  updatedAt: Scalars['DateTime'];
  users: Array<UserProfileModel>;
};

export enum OrganizationPermission {
  Invite = 'Invite',
  MemberManagement = 'MemberManagement',
  Read = 'Read',
  Update = 'Update'
}

export type OrganizationProfileModel = {
  __typename?: 'OrganizationProfileModel';
  billing: OrganizationBillingModel;
  createdAt: Scalars['DateTime'];
  externalRole?: Maybe<ExternalOrganizationRole>;
  id: Scalars['ID'];
  internalRole?: Maybe<InternalOrganizationRole>;
  name: Scalars['String'];
  socialAuthors?: Maybe<Array<SocialAuthorModel>>;
  updatedAt: Scalars['DateTime'];
  users: Array<UserProfileModel>;
};

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  restrictedAccessForUser: Scalars['Boolean'];
};

export type OrganizationSocialPostCommentLabelModel = {
  __typename?: 'OrganizationSocialPostCommentLabelModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  organization: OrganizationModel;
  organizationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type OrganizationSocialPostCommentLabelsFilterInput = {
  labelText?: InputMaybe<Scalars['String']>;
};

export type OrganizationSocialPostCommentLabelsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: OrganizationSocialPostCommentLabelsFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export enum OrganizationType {
  EnterpriseLead = 'EnterpriseLead',
  RegularLead = 'RegularLead'
}

export type OrganizationUserAccessRequestModel = {
  __typename?: 'OrganizationUserAccessRequestModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invitedBy?: Maybe<UserProfileModel>;
  message?: Maybe<Scalars['String']>;
  organization: OrganizationModel;
  status: OrganizationUserAccessRequestStatus;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<UserProfileModel>;
  user: UserProfileModel;
};

export enum OrganizationUserAccessRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Reject = 'Reject'
}

export type OrganizePostsInput = {
  approvedPosts: Array<OrganizePostsInputPostItem>;
  rejectedPosts: Array<OrganizePostsInputPostItem>;
};

export type OrganizePostsInputPostItem = {
  collectionIds: Array<Scalars['String']>;
  postId: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedAudioTrendGroupSearchResult = {
  __typename?: 'PaginatedAudioTrendGroupSearchResult';
  data: Array<AudioTrendGroupModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedBrandClaimsModel = {
  __typename?: 'PaginatedBrandClaimsModel';
  data: Array<BrandClaimModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedBrandInboundFiltersInputForCapturedProductSocialPosts = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy: PaginatedBrandInboundFiltersInputForCapturedProductSortBy;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PaginatedBrandInboundFiltersInputForCapturedProductSortBy = {
  field: PaginatedBrandInboundFiltersInputForCapturedProductSortField;
  order?: InputMaybe<SortOrder>;
};

export enum PaginatedBrandInboundFiltersInputForCapturedProductSortField {
  DiggCount = 'DiggCount',
  TotalEngagement = 'TotalEngagement',
  TotalImpressions = 'TotalImpressions'
}

export type PaginatedBrandInboundFiltersInputForRelatedBrands = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<RelatedBrandsSortBy>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PaginatedBrandInboundFiltersInputForSentimentClaimInteractions = {
  after?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  medium: SentimentMedium;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiment: Sentiment;
  sentimentSubjectIds?: InputMaybe<Array<Scalars['String']>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PaginatedBrandInboundFiltersInputForSocialPosts = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<PaginatedBrandInboundFiltersInputForSocialPostsSortBy>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PaginatedBrandInboundFiltersInputForSocialPostsSortBy = {
  field: PaginatedBrandInboundFiltersInputSortField;
  order?: InputMaybe<SortOrder>;
};

export type PaginatedBrandInboundFiltersInputForTopCreators = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  contentType: BrandContentType;
  countries?: InputMaybe<Array<Scalars['String']>>;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  sentiments?: InputMaybe<Array<Sentiment>>;
  signalCategoryOptionIds?: InputMaybe<Array<Scalars['String']>>;
  signalDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<BrandInboundFiltersInputForTopCreatorsSortBy>;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum PaginatedBrandInboundFiltersInputSortField {
  TotalEngagement = 'TotalEngagement',
  TotalImpressions = 'TotalImpressions'
}

export type PaginatedBrandModel = {
  __typename?: 'PaginatedBrandModel';
  data: Array<BrandModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedBrandOutboundLeaderboardResponse = {
  __typename?: 'PaginatedBrandOutboundLeaderboardResponse';
  data: Array<BrandOutboundLeaderboardItem>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedBrandSentimentTextModel = {
  __typename?: 'PaginatedBrandSentimentTextModel';
  data: Array<BrandSentimentTextModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCapturedProductAllLabelsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PaginatedCapturedProductAllLabelsProductLineModel = {
  __typename?: 'PaginatedCapturedProductAllLabelsProductLineModel';
  data: Array<CapturedProductAllLabelsProductLineModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCapturedProductAttributeModel = {
  __typename?: 'PaginatedCapturedProductAttributeModel';
  data: Array<CapturedProductAttributeModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCapturedProductCategoryModel = {
  __typename?: 'PaginatedCapturedProductCategoryModel';
  data: Array<CapturedProductCategoryModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCapturedProductDataForInbound = {
  __typename?: 'PaginatedCapturedProductDataForInbound';
  data: Array<CapturedProductDataForInbound>;
  meta: PaginatedCapturedProductDataForInboundPaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCapturedProductDataForInboundPaginationMeta = {
  __typename?: 'PaginatedCapturedProductDataForInboundPaginationMeta';
  totalCount: Scalars['Int'];
  totalPostsCount: Scalars['Int'];
};

export type PaginatedCapturedProductModel = {
  __typename?: 'PaginatedCapturedProductModel';
  data: Array<CapturedProductModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCollectionResult = {
  __typename?: 'PaginatedCollectionResult';
  data: Array<CollectionModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCollectionSearchResult = {
  __typename?: 'PaginatedCollectionSearchResult';
  data: Array<CollectionSearchHit>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCompetitorCreatorMetricsResult = {
  __typename?: 'PaginatedCompetitorCreatorMetricsResult';
  data: Array<CompetitorCreatorMetricsModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCompetitorFlatAnalyticFiltersInputForCapturedProductSocialPosts = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  /** The brand id is the current brand id which is making the request */
  brandId: Scalars['String'];
  capturedProductAttributeIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductBrandIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  capturedProductLineModelInputs?: InputMaybe<Array<ProductLineModelInput>>;
  competitorId: Scalars['String'];
  contentFilter: CompetitorCreatorSocialPostContentFilter;
  creatorIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<SocialPostGenderDemographic>>;
  generation?: InputMaybe<Array<SocialPostGenerationDemographic>>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  postTypes?: InputMaybe<Array<SocialPostType>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy: PaginatedBrandInboundFiltersInputForCapturedProductSortBy;
  sources?: InputMaybe<Array<SocialPostMentionSource>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedCompetitorFlatAnalyticFiltersInputSortBy = {
  field: PaginatedCompetitorFlatAnalyticFiltersInputSortField;
  order?: InputMaybe<SortOrder>;
};

export enum PaginatedCompetitorFlatAnalyticFiltersInputSortField {
  TotalEngagement = 'TotalEngagement',
  TotalImpressions = 'TotalImpressions'
}

export type PaginatedCompetitorFlatCreatorSentimentInteractions = {
  __typename?: 'PaginatedCompetitorFlatCreatorSentimentInteractions';
  data: CompetitorFlatCreatorSentimentInteractions;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCompetitorShareOfVoiceAggregatedData = {
  __typename?: 'PaginatedCompetitorShareOfVoiceAggregatedData';
  data: Array<CompetitorShareOfVoiceAggregatedDataItem>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCompetitorShareOfVoiceTimeSeriesData = {
  __typename?: 'PaginatedCompetitorShareOfVoiceTimeSeriesData';
  data: Array<CompetitorShareOfVoiceTimeSeriesDataItem>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedContentIdeaSearchResult = {
  __typename?: 'PaginatedContentIdeaSearchResult';
  data: Array<ContentIdeaModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCreator = {
  __typename?: 'PaginatedCreator';
  data: Array<CreatorModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedCreatorProfileInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  brandMentionsCount?: InputMaybe<NumberRangeInput>;
  capturedProductIds?: InputMaybe<Array<Scalars['String']>>;
  commentsCount?: InputMaybe<NumberRangeInput>;
  creatorProfileIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange: SimpleDateRangeFilterInput;
  filterType?: InputMaybe<CreatorProfileFilterType>;
  first?: InputMaybe<Scalars['Int']>;
  followersCount?: InputMaybe<NumberRangeInput>;
  labelIds?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Platform>>;
  query?: InputMaybe<Scalars['String']>;
  relationshipStrength?: InputMaybe<Array<CreatorProfileRelationshipStrength>>;
  sentiment?: InputMaybe<Array<Sentiment>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<PaginatedCreatorProfileInputSortBy>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedCreatorProfileInputSortBy = {
  field: PaginatedCreatorProfileInputSortField;
  order?: InputMaybe<SortOrder>;
};

export enum PaginatedCreatorProfileInputSortField {
  BrandEngagementCount = 'BrandEngagementCount',
  BrandEngagementRate = 'BrandEngagementRate',
  BrandMentionsCount = 'BrandMentionsCount',
  CreatedAt = 'CreatedAt',
  FollowersCount = 'FollowersCount',
  RelationshipStrength = 'RelationshipStrength'
}

export type PaginatedCreatorProfileModel = {
  __typename?: 'PaginatedCreatorProfileModel';
  data: Array<CreatorProfileModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedEditorialPostSearchResult = {
  __typename?: 'PaginatedEditorialPostSearchResult';
  data: Array<EditorialPostModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedInboxNotifications = {
  __typename?: 'PaginatedInboxNotifications';
  meta: InboxNotificationMeta;
  notifications: Array<NotificationModel>;
  pageInfo: PageInfo;
};

export type PaginatedManuallyParsedSocialPostTrackerPaginationMeta = {
  __typename?: 'PaginatedManuallyParsedSocialPostTrackerPaginationMeta';
  newPostCount?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type PaginatedManuallyParsedSocialPostTrackerSearchResult = {
  __typename?: 'PaginatedManuallyParsedSocialPostTrackerSearchResult';
  data: Array<ManuallyParsedSocialPostTrackerModel>;
  meta: PaginatedManuallyParsedSocialPostTrackerPaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedOrganizationCreatorProfileLabelInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedOrganizationCreatorProfileLabelModel = {
  __typename?: 'PaginatedOrganizationCreatorProfileLabelModel';
  data: Array<OrganizationCreatorProfileLabelModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedOrganizationSocialPostCommentLabel = {
  __typename?: 'PaginatedOrganizationSocialPostCommentLabel';
  data: Array<OrganizationSocialPostCommentLabelModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedPostCollections = {
  __typename?: 'PaginatedPostCollections';
  data: Array<CollectionSearchHit>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedPostSearchPaginationMeta = {
  __typename?: 'PaginatedPostSearchPaginationMeta';
  newPostCount?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type PaginatedPostSearchResult = {
  __typename?: 'PaginatedPostSearchResult';
  data: Array<PostModel>;
  meta: PaginatedPostSearchPaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedPostSmartSearchResult = {
  __typename?: 'PaginatedPostSmartSearchResult';
  data: Array<PostSearchHit>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedRadarEventActivityCommunicationChannelInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedRadarEventActivityCommunicationChannelModel = {
  __typename?: 'PaginatedRadarEventActivityCommunicationChannelModel';
  data: Array<RadarEventActivityCommunicationChannelModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedRadarEventActivityInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  createdForCreatorProfileIds?: InputMaybe<Array<Scalars['String']>>;
  deduplicateByNameAndCreator?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedRadarEventActivityModel = {
  __typename?: 'PaginatedRadarEventActivityModel';
  data: Array<RadarEventActivityModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedRadarEventInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  creatorProfileIds?: InputMaybe<Array<Scalars['String']>>;
  creatorProfileLabelIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
  eventTypes?: InputMaybe<Array<RadarEventType>>;
  first?: InputMaybe<Scalars['Int']>;
  followersCount?: InputMaybe<NumberRangeInput>;
  last?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  readStatuses?: InputMaybe<Array<RadarEventReadStatus>>;
  relationshipStrength?: InputMaybe<Array<CreatorProfileRelationshipStrength>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  viewType?: InputMaybe<RadarEventViewType>;
};

export type PaginatedRadarEventModel = {
  __typename?: 'PaginatedRadarEventModel';
  data: Array<RadarEventModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedResourceSearchResultMeta = {
  __typename?: 'PaginatedResourceSearchResultMeta';
  totalCount: Scalars['Int'];
};

export type PaginatedSearchClickedResult = {
  __typename?: 'PaginatedSearchClickedResult';
  data: Array<SearchClickedResultModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedSearchTerm = {
  __typename?: 'PaginatedSearchTerm';
  data: Array<SearchTermModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedSentimentClaimInteractions = {
  __typename?: 'PaginatedSentimentClaimInteractions';
  data: SentimentClaimInteractions;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedSocialPost = {
  __typename?: 'PaginatedSocialPost';
  data: Array<SocialPostModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedSocialPostComment = {
  __typename?: 'PaginatedSocialPostComment';
  data: Array<SocialPostCommentModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedSocialPostCommentCategoriesForBrand = {
  __typename?: 'PaginatedSocialPostCommentCategoriesForBrand';
  data: Array<Scalars['String']>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedSocialPostEngagementSuggestion = {
  __typename?: 'PaginatedSocialPostEngagementSuggestion';
  data: Array<SocialPostEngagementSuggestionModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedSocialPostForHashTag = {
  __typename?: 'PaginatedSocialPostForHashTag';
  data: Array<SocialPostModel>;
  meta: PaginatedSocialPostMetaForHashTag;
  pageInfo: PageInfo;
};

export type PaginatedSocialPostMetaForHashTag = {
  __typename?: 'PaginatedSocialPostMetaForHashTag';
  averageEngagementRate: Scalars['Float'];
  numberOfTimesUsed: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PaginatedSocialPostsForBrandInboundPosts = {
  __typename?: 'PaginatedSocialPostsForBrandInboundPosts';
  data: Array<SocialPostModel>;
  meta: PaginatedSocialPostsMetaForBrandInboundPosts;
  pageInfo: PageInfo;
};

export type PaginatedSocialPostsMetaForBrandInboundPosts = {
  __typename?: 'PaginatedSocialPostsMetaForBrandInboundPosts';
  totalCount: Scalars['Int'];
  totalEngagement: Scalars['Int'];
  totalViewCount: Scalars['Int'];
};

export type PaginatedSuggestedPriorityTaskResult = {
  __typename?: 'PaginatedSuggestedPriorityTaskResult';
  data: Array<TaskModel>;
  pageInfo: PageInfo;
};

export type PaginatedTaskGroupResult = {
  __typename?: 'PaginatedTaskGroupResult';
  data: Array<TaskGroupModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginatedTaskSearchResult = {
  __typename?: 'PaginatedTaskSearchResult';
  data: Array<TaskModel>;
  meta: PaginatedTaskSearchResultMeta;
  pageInfo: PageInfo;
};

export type PaginatedTaskSearchResultMeta = {
  __typename?: 'PaginatedTaskSearchResultMeta';
  completedCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PaginatedTrendSearchResult = {
  __typename?: 'PaginatedTrendSearchResult';
  data: Array<TrendModel>;
  meta: PaginationMeta;
  pageInfo: PageInfo;
};

export type PaginationMeta = {
  __typename?: 'PaginationMeta';
  totalCount: Scalars['Int'];
};

export type ParsingSettings = {
  __typename?: 'ParsingSettings';
  Instagram: ParsingSettingsPlatform;
  Tiktok: ParsingSettingsPlatform;
  Youtube: ParsingSettingsPlatform;
};

export type ParsingSettingsInputData = {
  Instagram: ParsingSettingsInputDataPlatform;
  Tiktok: ParsingSettingsInputDataPlatform;
  Youtube: ParsingSettingsInputDataPlatform;
};

export type ParsingSettingsInputDataPlatform = {
  enabled: Scalars['Boolean'];
  types?: InputMaybe<ParsingSettingsInputDataType>;
};

export type ParsingSettingsInputDataType = {
  Carousel?: InputMaybe<Scalars['Boolean']>;
  Photo?: InputMaybe<Scalars['Boolean']>;
  Video?: InputMaybe<Scalars['Boolean']>;
};

export type ParsingSettingsPlatform = {
  __typename?: 'ParsingSettingsPlatform';
  enabled: Scalars['Boolean'];
  types?: Maybe<ParsingSettingsType>;
};

export type ParsingSettingsType = {
  __typename?: 'ParsingSettingsType';
  Carousel?: Maybe<Scalars['Boolean']>;
  Photo?: Maybe<Scalars['Boolean']>;
  Video?: Maybe<Scalars['Boolean']>;
};

export type PauseBrandInput = {
  brandId: Scalars['String'];
  resetOnNextCycle?: InputMaybe<Scalars['Boolean']>;
};

export type PauseTopicInput = {
  resetOnNextCycle?: InputMaybe<Scalars['Boolean']>;
  topicId: Scalars['String'];
};

export type PermissionInput = {
  generalPermission?: InputMaybe<GeneralPermissionInput>;
  inviteMembers: InviteMembersInput;
  removeMemberIds: Array<Scalars['String']>;
};

export enum PermissionLevel {
  Comment = 'Comment',
  Full = 'Full',
  View = 'View'
}

export type PermissionRequestModel = {
  __typename?: 'PermissionRequestModel';
  brand?: Maybe<BrandModel>;
  brandId?: Maybe<Scalars['String']>;
  collection?: Maybe<CollectionModel>;
  collectionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  post?: Maybe<PostModel>;
  postId?: Maybe<Scalars['String']>;
  status: PermissionRequestStatus;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
  userId: Scalars['String'];
};

export enum PermissionRequestStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  Pending = 'Pending'
}

export type PermittedCollectionFilters = {
  userId?: InputMaybe<Scalars['String']>;
};

export type PermittedCollectionModel = {
  __typename?: 'PermittedCollectionModel';
  collection?: Maybe<CollectionModel>;
  id: Scalars['String'];
  permissionLevel?: Maybe<PermissionLevel>;
};

export type PermittedPostFilters = {
  collectionId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type PermittedPostModel = {
  __typename?: 'PermittedPostModel';
  id: Scalars['String'];
  permissionLevel?: Maybe<PermissionLevel>;
  post?: Maybe<PostModel>;
};

export type PersonalSettings = {
  __typename?: 'PersonalSettings';
  collectionGeneralPermissionDefault?: Maybe<GeneralPermission>;
  collectionGeneralPermissionDefaultPermissionLevel?: Maybe<PermissionLevel>;
  postGeneralPermissionDefault?: Maybe<GeneralPermission>;
  postGeneralPermissionDefaultPermissionLevel?: Maybe<PermissionLevel>;
};

export type PinCollectionInput = {
  collectionId: Scalars['String'];
};

export type PinCollectionsInput = {
  collectionIds: Array<Scalars['String']>;
};

export type PinManyCollectionsToParentInput = {
  collectionIds: Array<Scalars['String']>;
};

export type PinManyPostsToCollectionInput = {
  collectionId: Scalars['String'];
  postIds: Array<Scalars['String']>;
};

export type PinPostToCollectionInput = {
  collectionId: Scalars['String'];
  postId: Scalars['String'];
};

export type PinnedEntityFilters = {
  parentCollectionId?: InputMaybe<Scalars['String']>;
};

export type PinnedEntityModel = {
  __typename?: 'PinnedEntityModel';
  collection?: Maybe<CollectionModel>;
  collectionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creator: UserProfileModel;
  creatorId: Scalars['String'];
  id: Scalars['ID'];
  parentCollection?: Maybe<CollectionModel>;
  parentCollectionId?: Maybe<Scalars['String']>;
  post?: Maybe<PostModel>;
  postId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum Platform {
  Instagram = 'Instagram',
  Reel = 'Reel',
  Tiktok = 'Tiktok',
  Youtube = 'Youtube'
}

/** Plot Features */
export enum PlotFeature {
  AiSuggestions = 'AISuggestions',
  AudioTrendGroup = 'AudioTrendGroup',
  AutoSyncSocialPosts = 'AutoSyncSocialPosts',
  CompetitorAnalysis = 'CompetitorAnalysis',
  CompetitorShareOfVoice = 'CompetitorShareOfVoice',
  ContentCalendar = 'ContentCalendar',
  ContentCalendarMobile = 'ContentCalendarMobile',
  CreateProjectWithGpt = 'CreateProjectWithGPT',
  CreateProjectWithGptForAnonymousUser = 'CreateProjectWithGPTForAnonymousUser',
  CreativeJuiceBox = 'CreativeJuiceBox',
  CreatorTracking = 'CreatorTracking',
  CustomTrend = 'CustomTrend',
  DisableTopicCreation = 'DisableTopicCreation',
  ExpandedTiktokParsing = 'ExpandedTiktokParsing',
  HideCreatorEngagementRate = 'HideCreatorEngagementRate',
  InstagramPostParsing = 'InstagramPostParsing',
  ManualOutboundUpload = 'ManualOutboundUpload',
  ManualSyncSocialPosts = 'ManualSyncSocialPosts',
  ProjectInbound = 'ProjectInbound',
  SlContextualSearch = 'SLContextualSearch',
  ScraperResponseCaching = 'ScraperResponseCaching',
  ShowOldSlCompetitorAnalysis = 'ShowOldSLCompetitorAnalysis',
  SignalMining = 'SignalMining',
  SocialListeningCrm = 'SocialListeningCRM',
  SocialListeningNotifications = 'SocialListeningNotifications',
  StaticContentParse = 'StaticContentParse',
  TrackOrgBrandCompetitor = 'TrackOrgBrandCompetitor',
  UserTaggedStoriesParsing = 'UserTaggedStoriesParsing',
  YamlOutputPreprocess = 'YAMLOutputPreprocess',
  YoutubeParsing = 'YoutubeParsing'
}

export type PostAnnotationFilters = {
  noteCommentAnchorIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PostAnnotationInputData = {
  comment: CommentInputData;
  noteCommentAnchorId?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type PostAnnotationModel = {
  __typename?: 'PostAnnotationModel';
  comments: Array<CommentModel>;
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileModel;
  id: Scalars['ID'];
  isResolved?: Maybe<Scalars['Boolean']>;
  noteCommentAnchorId?: Maybe<Scalars['String']>;
  noteCommentExtract?: Maybe<Scalars['String']>;
  pageNumber?: Maybe<Scalars['Int']>;
  post: PostModel;
  postId: Scalars['String'];
  time?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

/** Source of the action to create a post. We need it to count how many posts are created from each source. */
export enum PostCreationSource {
  Mobile = 'Mobile',
  Sms = 'SMS',
  Web = 'Web'
}

export type PostFavoriteModel = {
  __typename?: 'PostFavoriteModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  post: PostModel;
  postId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

/** Post Filter Type */
export enum PostFilterType {
  ContentCalendar = 'ContentCalendar',
  MyFavoritePosts = 'MyFavoritePosts',
  MyPosts = 'MyPosts',
  MySavedTrends = 'MySavedTrends',
  OrganizationPosts = 'OrganizationPosts',
  SocialListeningPosts = 'SocialListeningPosts'
}

export type PostFilters = {
  collectionId?: InputMaybe<Scalars['String']>;
  filterType: PostFilterType;
};

export type PostFiltersForSmartSearch = {
  collectionId?: InputMaybe<Scalars['String']>;
  collectionIds?: InputMaybe<Array<Scalars['String']>>;
  dateFilterInput?: InputMaybe<SimpleDateRangeFilterInput>;
  fileFilterInput?: InputMaybe<FileFilterInput>;
  filterType: PostFilterType;
  linkFilterInput?: InputMaybe<LinkFilterInput>;
  noteFilterInput?: InputMaybe<NoteFilterInput>;
  query?: InputMaybe<Scalars['String']>;
  reactionFilterInput?: InputMaybe<ReactionFilterInput>;
  userFilterInput?: InputMaybe<UserFilterInput>;
};

export type PostInviteMemberModel = {
  __typename?: 'PostInviteMemberModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastSeen?: Maybe<Scalars['DateTime']>;
  permissionLevel: PermissionLevel;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
};

export type PostMemberModel = {
  __typename?: 'PostMemberModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastSeen?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
};

export type PostModel = {
  __typename?: 'PostModel';
  annotations: Array<PostAnnotationModel>;
  attachment?: Maybe<AttachmentModel>;
  body?: Maybe<Scalars['String']>;
  collections: Array<CollectionModel>;
  color: Scalars['String'];
  comments: Array<CommentModel>;
  createdAt: Scalars['DateTime'];
  creator: UserProfileModel;
  description: Scalars['String'];
  favorites: Array<PostFavoriteModel>;
  generalPermission: GeneralPermission;
  id: Scalars['ID'];
  /** Members that has been explicitly invited to the post */
  inviteMembers: Array<PostInviteMemberModel>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isFavorite: Scalars['Boolean'];
  isFavoriteTrend: Scalars['Boolean'];
  isNew?: Maybe<Scalars['Boolean']>;
  isPrivate: Scalars['Boolean'];
  /** Members that has made any edits to the post */
  members: Array<PostMemberModel>;
  myPermissions: Array<PostPermission>;
  noteAttachments: Array<AttachmentModel>;
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  permissionLevel: PermissionLevel;
  permissionRequests?: Maybe<Array<PermissionRequestModel>>;
  pinnedToCollections: Array<PinnedEntityModel>;
  postAcceptedSuggestedCollectionAssignments: Array<PostSuggestedCollectionAssignmentsModel>;
  postSuggestedCollectionAssignments: Array<PostSuggestedCollectionAssignmentsModel>;
  roomId?: Maybe<Scalars['String']>;
  socialPost?: Maybe<SocialPostModel>;
  socialPostEngagementSuggestion?: Maybe<SocialPostEngagementSuggestionModel>;
  socialPostEngagementSuggestionId?: Maybe<Scalars['String']>;
  socialPostId?: Maybe<Scalars['String']>;
  tasks: Array<TaskModel>;
  title?: Maybe<Scalars['String']>;
  trend?: Maybe<TrendModel>;
  type: PostType;
  unreadCommentCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  urlMetadata: Array<UrlMetadataModel>;
  userReactions?: Maybe<Array<UserReactionModel>>;
  /** Viewers retrieving from Activity table */
  viewers: Array<PostViewerModel>;
};

export enum PostPermission {
  Comment = 'Comment',
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Update = 'Update'
}

export type PostSearchHit = {
  __typename?: 'PostSearchHit';
  item: PostModel;
  score: Scalars['Float'];
  searchHighlights: Array<SearchHighlight>;
  type: SearchHitType;
};

export type PostSearchResult = {
  __typename?: 'PostSearchResult';
  hits: Array<PostSearchHit>;
  totalCount: Scalars['Int'];
};

export type PostSuggestedAuthModel = {
  __typename?: 'PostSuggestedAuthModel';
  generalPermission: GeneralPermission;
  permissionLevel: PermissionLevel;
  suggestedInviteMembers: Array<SuggestedInviteMember>;
};

export type PostSuggestedCollectionAssignmentsModel = {
  __typename?: 'PostSuggestedCollectionAssignmentsModel';
  collection: CollectionModel;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  post: PostModel;
  score: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export enum PostType {
  Attachment = 'Attachment',
  Link = 'Link',
  Note = 'Note'
}

export type PostViewerModel = {
  __typename?: 'PostViewerModel';
  lastSeen?: Maybe<Scalars['DateTime']>;
  user: UserProfileModel;
};

export type ProcessPostsAfterCreationInput = {
  addPostsToFavorites?: InputMaybe<Scalars['Boolean']>;
  brandIdsToAddPostsForOutboundCommentTracking?: InputMaybe<Array<Scalars['String']>>;
  collectionIds?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
  postIds: Array<Scalars['String']>;
  postPermissions?: InputMaybe<UpdatePostPermissionsInputDataV2>;
  savePostsToContentCalendar?: InputMaybe<Scalars['Boolean']>;
};

export type ProductLineModelInput = {
  line?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  aggregatedBrandDurationUsage: Array<AggregatedBrandDurationUsageResult>;
  aggregatedTopicDurationUsage: Array<AggregatedTopicDurationUsageResult>;
  aiGeneratedBrandDescription: Scalars['String'];
  aiGeneratedTopicPrompt: AiGeneratedTopicPrompt;
  appLevelFeatureFlags: Array<FeatureFlagModel>;
  attachment: AttachmentModel;
  attributeForCapturedProductAllLabelsByIds: Array<CapturedProductAttributeModel>;
  attributesForCapturedProductAllLabels: PaginatedCapturedProductAttributeModel;
  audioTrendGroup: AudioTrendGroupModel;
  audioTrendGroups: PaginatedAudioTrendGroupSearchResult;
  billingPlan: BillingPlanModel;
  bookmarks: Array<BookmarkModel>;
  brand: BrandModel;
  brandByIds: Array<BrandModel>;
  brandInboundGraphData: BrandInboundGraphData;
  brandInboundSentimentMetrics: BrandInboundSentimentMetrics;
  brandInboundSocialPostCommentInsights: PaginatedSocialPostComment;
  brandInboundTopCreators: PaginatedCreator;
  brandOutboundEngagementPerformanceByUser: BrandOutboundEngagementPerformanceByUserResponse;
  brandOutboundLeaderboard: PaginatedBrandOutboundLeaderboardResponse;
  brandOutboundLikeMetrics: BrandMetricsResponse;
  brandOutboundReplyMetrics: BrandMetricsResponse;
  brandOutboundResponseMetrics: BrandMetricsResponse;
  brandSocialPostEngagement: BrandSocialPostEngagementModel;
  brands: Array<BrandModel>;
  brandsForCapturedProductAllLabels: PaginatedBrandModel;
  capturedProductDataForCompetitorsStats: CapturedProductDataForInboundStats;
  capturedProductDataForInboundStats: CapturedProductDataForInboundStats;
  capturedProductsPaginatedForCompetitors: PaginatedCapturedProductDataForInbound;
  capturedProductsPaginatedForInbound: PaginatedCapturedProductDataForInbound;
  capturedProductsSocialPostsPaginatedForCompetitors: PaginatedSocialPost;
  capturedProductsSocialPostsPaginatedForInbound: PaginatedSocialPost;
  categoriesForCapturedProductAllLabels: PaginatedCapturedProductCategoryModel;
  categoryForCapturedProductAllLabelsByIds: Array<CapturedProductCategoryModel>;
  collection: CollectionModel;
  collectionByIds: Array<CollectionModel>;
  /**
   * Find similar exsting collection names to a given query. This should be used during
   *       the create a collection flow to find potential similar collection names
   *       Returns a list of collections with similar names
   */
  collectionsSimilarSearch: CollectionSearchResult;
  /**
   * Perform a search for collections using a search query, filters and sort option.
   *       Returns a paginated search result list
   */
  collectionsSmartSearch: PaginatedCollectionSearchResult;
  comments: Array<CommentModel>;
  competitor: CompetitorModel;
  competitorFlatCreatorAnalyticSummary: CompetitorFlatCreatorSummaryModel;
  competitorShareOfVoiceAggregatedData: PaginatedCompetitorShareOfVoiceAggregatedData;
  competitorShareOfVoiceBaseModel: CompetitorShareOfVoiceBaseModel;
  competitorShareOfVoiceTimeSeriesData: PaginatedCompetitorShareOfVoiceTimeSeriesData;
  contentCalendarView: ContentCalendarViewModel;
  contentCalendarViews: Array<ContentCalendarViewModel>;
  contentIdea: ContentIdeaModel;
  contentIdeaCollections: PaginatedCollectionResult;
  contentIdeaField: ContentIdeaFieldModel;
  contentIdeaFieldOption: ContentIdeaFieldOptionModel;
  contentIdeaFields: Array<ContentIdeaFieldModel>;
  contentIdeaMetaStats: ContentIdeaMetaStats;
  contentIdeaPublishMetadata: ContentIdeaPublishMetadataModel;
  contentIdeas: PaginatedContentIdeaSearchResult;
  countriesWithSocialPosts: Array<CountryModel>;
  creatorProfile: CreatorProfileModel;
  creatorProfileBrandMentionStats: CreatorProfileBrandMentionStats;
  creatorProfileBrandMentions: PaginatedSocialPost;
  creatorProfileByIds: Array<CreatorProfileModel>;
  creatorProfileMentionedBrands: PaginatedBrandModel;
  creatorProfilesByCreatorId: PaginatedCreatorProfileModel;
  editorialPost: EditorialPostModel;
  editorialPosts: PaginatedEditorialPostSearchResult;
  existingSocialPostReportReasons: Array<Scalars['String']>;
  featureFlags: Array<FeatureFlagModel>;
  filtersSearch: FiltersSearch;
  frequentlyViewedEntities: Array<ActivityModel>;
  getAIKeywordsForBrand: Array<Scalars['String']>;
  getAIKeywordsForBrandDescription: Array<Scalars['String']>;
  getAIKeywordsForTopic: Array<Scalars['String']>;
  getAvailablePrices: Array<BillingPlanPrice>;
  getBrandInboundCommentInsights: PaginatedSocialPostComment;
  getBrandInboundCreatorDemographics: Array<SocialPostCreatorDemographicModel>;
  getBrandInboundSocialPosts: PaginatedSocialPostsForBrandInboundPosts;
  getBrandRadarEventsConfig: BrandRadarEventsConfigModel;
  getBrandSentimentInteractions: PaginatedSentimentClaimInteractions;
  getBrandSentimentTextsBySubCategoryTrend: PaginatedBrandSentimentTextModel;
  getCompetitorCommentInsights: PaginatedSocialPostComment;
  getCompetitorFlatCreatorDemographics: Array<SocialPostCreatorDemographicModel>;
  getCompetitorFlatCreatorGraphData?: Maybe<CompetitorFlatCreatorBrandMentionsMetrics>;
  getCompetitorSentimentInteractions: PaginatedCompetitorFlatCreatorSentimentInteractions;
  getCompetitorSentimentMetrics?: Maybe<CompetitorFlatCreatorSentimentMetrics>;
  getCreator: CreatorModel;
  getCreatorProfileLocations: Array<Scalars['String']>;
  getCreatorProfileSuperfanEngagement: PaginatedSocialPostComment;
  getCreatorProfileSuperfanEngagementStats: CreatorProfileSuperfanEngagementStats;
  getCreatorProfilesCapturedProducts: PaginatedCapturedProductModel;
  getCreatorsThatMentionedCompetitor: PaginatedCreator;
  getDefaultPaymentMethod?: Maybe<BillingPaymentMethod>;
  getFollowing: Array<SocialMediaUserModel>;
  getHashtagUsedByCompetitor: Array<HashtagUsedForCompetitorModel>;
  getNotificationConfig: SocialPostNotificationConfigModel;
  getNotificationConfigs: Array<SocialPostNotificationConfigModel>;
  getPaginatedRadarEvents: PaginatedRadarEventModel;
  getPaginatedRelatedBrandsSocialPosts: PaginatedSocialPost;
  getPaginatedSocialPostEngagementSuggestions: PaginatedSocialPostEngagementSuggestion;
  getPaginatedSocialPosts: PaginatedSocialPost;
  getPostSuggestedAuth: PostSuggestedAuthModel;
  getPricesForPlan: Array<BillingPrice>;
  getRecentSearchQueries: PaginatedSearchClickedResult;
  getRelatedBrands: RelatedBrandsData;
  getSavedConfigsByType: Array<SavedConfigModel>;
  getSearchTerms: PaginatedSearchTerm;
  getSearchesClicked: PaginatedSearchClickedResult;
  getSocialCreator: CreatorModel;
  getSocialPostsByCreator: PaginatedSocialPost;
  getSocialPostsByCreatorsForCompetitor: PaginatedSocialPost;
  getSocialPostsByHashtags: PaginatedSocialPostForHashTag;
  getSocialPostsByHashtagsForBrand: PaginatedSocialPostForHashTag;
  getSocialPostsByHashtagsForCompetitor: PaginatedSocialPostForHashTag;
  getSocialPostsByTrend: PaginatedSocialPost;
  getSocialPostsCountriesData: Array<SocialPostCountryStatsModel>;
  getSocialPostsCreatedForCompetitors: PaginatedSocialPost;
  getSocialPostsLanguagesData: Array<SocialPostLanguageStatsModel>;
  getSubCategorySentimentTrend: Array<BrandSentimentTrendModel>;
  getSuggestedCreators: Array<CreatorModel>;
  getTopicsTrackingList: Array<CreatorTopicTrackingModel>;
  getTrackedCreatorsForTopic: Array<CreatorModel>;
  ghostSearchQuery: GhostSearchQuery;
  hashtagsForBrand: Array<HashtagUsedForBrandModel>;
  inboxNotifications: PaginatedInboxNotifications;
  /** Determine where the collections permission is less than the parent collection permission */
  isCollectionsPermissionLessThanParentCollectionPermission: Scalars['Boolean'];
  /** Determine where the posts permission is less than the parent collection permission */
  isPostsPermissionLessThanParentCollectionPermission: Scalars['Boolean'];
  isTrackingCreatorProfileInsights: Scalars['Boolean'];
  isTrackingCreatorProfileInsightsByCreatorId: Scalars['Boolean'];
  languages: Array<LanguageModel>;
  manuallyParsedSocialPostTrackers: PaginatedManuallyParsedSocialPostTrackerSearchResult;
  me: MeModel;
  mobileAppMinimumVersion: Scalars['String'];
  myOrganizationAccessRequests: Array<OrganizationUserAccessRequestModel>;
  myPendingOrganizationAccessRequestsForAdmin: Array<OrganizationUserAccessRequestModel>;
  myPermissionRequests: Array<PermissionRequestModel>;
  nonWorkDomains: Array<Scalars['String']>;
  oldestSocialPostForBrandInboundFiltersInput?: Maybe<SocialPostModel>;
  organizationAccessRequest: OrganizationUserAccessRequestModel;
  organizationBilling: OrganizationBillingModel;
  organizationCompetitors: Array<CompetitorModel>;
  organizationSocialPostCommentLabels: PaginatedOrganizationSocialPostCommentLabel;
  paginatedCreatorProfiles: PaginatedCreatorProfileModel;
  paginatedOrganizationCreatorProfileLabels: PaginatedOrganizationCreatorProfileLabelModel;
  paginatedRadarEventActivities: PaginatedRadarEventActivityModel;
  paginatedRadarEventActivityCommunicationChannels: PaginatedRadarEventActivityCommunicationChannelModel;
  pendingPermissionRequestsForBrand: Array<PermissionRequestModel>;
  permissionRequest: PermissionRequestModel;
  permittedCollections: Array<PermittedCollectionModel>;
  permittedPosts: Array<PermittedPostModel>;
  personas: Array<CustomTrendPersonaModel>;
  pinnedEntitiesToParent: Array<PinnedEntityModel>;
  pinnedEntitiesToRoot: Array<PinnedEntityModel>;
  post?: Maybe<PostModel>;
  postAnnotation: PostAnnotationModel;
  postAnnotations: Array<PostAnnotationModel>;
  postByIds: Array<PostModel>;
  /**
   * Get all collections related to the post
   *       First return suggested collections (max 3),
   *       then the collections the post belong to,
   *       then all other collections user has access to.
   *       Only the last list is paginated
   */
  postCollections: PaginatedPostCollections;
  posts: PaginatedPostSearchResult;
  postsSmartSearch: PaginatedPostSmartSearchResult;
  productLinesModelsForCapturedProductAllLabels: PaginatedCapturedProductAllLabelsProductLineModel;
  radarEvent: RadarEventModel;
  radarEventActivityCommunicationChannelByIds: Array<RadarEventActivityCommunicationChannelModel>;
  recentCollections: Array<CollectionModel>;
  sameLevelCollections: PaginatedCollectionResult;
  searchCompetitorFlatCreators: PaginatedCompetitorCreatorMetricsResult;
  searchCreators: Array<SocialMediaUserModel>;
  searchDbCreators: Array<CreatorModel>;
  searchEntities: SearchResults;
  sentimentClaimInteractions: PaginatedSentimentClaimInteractions;
  sentimentSubjectClaimMetricsForTopicInbound: BrandInboundSentimentMetrics;
  sentimentSubjectsByTopic: Array<SentimentSubjectModel>;
  shareLink: ShareLinkModel;
  signalDefinitionsByBrandId: Array<SignalDefinitionModel>;
  socialPost: SocialPostModel;
  socialPostCommentCategoriesForBrand: PaginatedSocialPostCommentCategoriesForBrand;
  socialPostComments: PaginatedSocialPostComment;
  socialPosts: Array<SocialPostModel>;
  suggestedPosts: Array<PostModel>;
  suggestedPostsForUser: Array<PostModel>;
  suggestedPriorityTasks: PaginatedSuggestedPriorityTaskResult;
  task: TaskModel;
  taskGroups: PaginatedTaskGroupResult;
  tasks: PaginatedTaskSearchResult;
  tasksByIds: Array<TaskModel>;
  topCreatorPostsThatMentionedBrand: PaginatedSocialPost;
  topic: TopicModel;
  topicSignalDefinitions: Array<SignalDefinitionModel>;
  trend: TrendModel;
  trends: PaginatedTrendSearchResult;
  /**
   * Perform a global search across a users entities using a search query.
   *       Takes a search query, searchable entity types and the type of search to perform.
   *       Returns a search results for each of the selected entity types
   */
  universalSearch: UniversalSearchResults;
  unreadCollectionComments: Scalars['Int'];
  unreadNotifications: Scalars['Int'];
  unreadNotificationsV2: Scalars['Int'];
  unreadPostComments: Scalars['Int'];
  unreadTaskComments: Scalars['Int'];
  userProfile: UserProfileModel;
  workosAuthUrl: AuthUrlModel;
};


export type QueryAggregatedBrandDurationUsageArgs = {
  filters: AggregatedBrandDurationUsageFilters;
};


export type QueryAggregatedTopicDurationUsageArgs = {
  brandId: Scalars['String'];
  filters: AggregatedTopicDurationUsageFilters;
};


export type QueryAiGeneratedBrandDescriptionArgs = {
  brandName: Scalars['String'];
};


export type QueryAiGeneratedTopicPromptArgs = {
  topicId: Scalars['String'];
};


export type QueryAttachmentArgs = {
  id: Scalars['String'];
};


export type QueryAttributeForCapturedProductAllLabelsByIdsArgs = {
  input: GetCapturedProductAttributeByIdsInput;
};


export type QueryAttributesForCapturedProductAllLabelsArgs = {
  input: PaginatedCapturedProductAllLabelsInput;
};


export type QueryAudioTrendGroupArgs = {
  id: Scalars['String'];
};


export type QueryAudioTrendGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: AudioTrendGroupFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBillingPlanArgs = {
  plan: Scalars['String'];
};


export type QueryBrandArgs = {
  id: Scalars['String'];
};


export type QueryBrandByIdsArgs = {
  input: GetBrandByIdsInput;
};


export type QueryBrandInboundGraphDataArgs = {
  data: BrandInboundFiltersInputForGraphData;
};


export type QueryBrandInboundSentimentMetricsArgs = {
  data: BrandInboundFiltersInputForSentimentMetrics;
};


export type QueryBrandInboundSocialPostCommentInsightsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  filters: BrandInboundSocialPostCommentInsightsFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandInboundTopCreatorsArgs = {
  data: PaginatedBrandInboundFiltersInputForTopCreators;
};


export type QueryBrandOutboundEngagementPerformanceByUserArgs = {
  brandIds: Array<Scalars['String']>;
  filters?: InputMaybe<BrandOutboundEngagementPerformanceByUserFilters>;
  userId: Scalars['String'];
};


export type QueryBrandOutboundLeaderboardArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandIds: Array<Scalars['String']>;
  filters?: InputMaybe<BrandOutboundLeaderboardFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandOutboundLikeMetricsArgs = {
  brandId: Scalars['String'];
  filters: BrandMetricsFilters;
};


export type QueryBrandOutboundReplyMetricsArgs = {
  brandId: Scalars['String'];
  filters: BrandMetricsFilters;
};


export type QueryBrandOutboundResponseMetricsArgs = {
  brandId: Scalars['String'];
  filters: BrandMetricsFilters;
};


export type QueryBrandSocialPostEngagementArgs = {
  id: Scalars['String'];
};


export type QueryBrandsForCapturedProductAllLabelsArgs = {
  input: PaginatedCapturedProductAllLabelsInput;
};


export type QueryCapturedProductDataForCompetitorsStatsArgs = {
  data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct;
};


export type QueryCapturedProductDataForInboundStatsArgs = {
  data: BrandInboundFiltersInputForCapturedProduct;
};


export type QueryCapturedProductsPaginatedForCompetitorsArgs = {
  data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct;
};


export type QueryCapturedProductsPaginatedForInboundArgs = {
  data: BrandInboundFiltersInputForCapturedProduct;
};


export type QueryCapturedProductsSocialPostsPaginatedForCompetitorsArgs = {
  data: PaginatedCompetitorFlatAnalyticFiltersInputForCapturedProductSocialPosts;
};


export type QueryCapturedProductsSocialPostsPaginatedForInboundArgs = {
  data: PaginatedBrandInboundFiltersInputForCapturedProductSocialPosts;
};


export type QueryCategoriesForCapturedProductAllLabelsArgs = {
  input: PaginatedCapturedProductAllLabelsInput;
};


export type QueryCategoryForCapturedProductAllLabelsByIdsArgs = {
  input: GetCapturedProductCategoryByIdsInput;
};


export type QueryCollectionArgs = {
  id: Scalars['String'];
};


export type QueryCollectionByIdsArgs = {
  input: GetCollectionByIdsInput;
};


export type QueryCollectionsSimilarSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: CollectionFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<SortType>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCollectionsSmartSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: CollectionFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<SortType>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCommentsArgs = {
  filters: CommentFilter;
};


export type QueryCompetitorArgs = {
  id: Scalars['String'];
};


export type QueryCompetitorFlatCreatorAnalyticSummaryArgs = {
  data: CompetitorFlatCreatorAnalyticFiltersInput;
};


export type QueryCompetitorShareOfVoiceAggregatedDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: CompetitorShareOfVoiceFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<CompetitorShareOfVoiceAggregatedDataSortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompetitorShareOfVoiceTimeSeriesDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: CompetitorShareOfVoiceFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryContentCalendarViewArgs = {
  id: Scalars['String'];
};


export type QueryContentIdeaArgs = {
  id: Scalars['String'];
};


export type QueryContentIdeaCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryContentIdeaFieldArgs = {
  id: Scalars['String'];
};


export type QueryContentIdeaFieldsArgs = {
  filters?: InputMaybe<ContentIdeaFieldFilters>;
};


export type QueryContentIdeaMetaStatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ContentIdeaFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryContentIdeasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ContentIdeaFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCountriesWithSocialPostsArgs = {
  data: BrandInboundFiltersInput;
};


export type QueryCreatorProfileArgs = {
  id: Scalars['String'];
};


export type QueryCreatorProfileBrandMentionStatsArgs = {
  input: CreatorProfileBrandMentionedStatsInput;
};


export type QueryCreatorProfileBrandMentionsArgs = {
  input: CreatorProfilePaginatedBrandMentionsInput;
};


export type QueryCreatorProfileByIdsArgs = {
  input: CreatorProfilesByIdsInput;
};


export type QueryCreatorProfileMentionedBrandsArgs = {
  input: CreatorProfileMentionedBrandsInput;
};


export type QueryCreatorProfilesByCreatorIdArgs = {
  input: CreatorProfilesByCreatorIdInput;
};


export type QueryEditorialPostArgs = {
  id: Scalars['String'];
};


export type QueryEditorialPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryExistingSocialPostReportReasonsArgs = {
  brandId: Scalars['String'];
};


export type QueryFiltersSearchArgs = {
  data: FilterSearchInput;
};


export type QueryGetAiKeywordsForBrandArgs = {
  brandId: Scalars['String'];
};


export type QueryGetAiKeywordsForBrandDescriptionArgs = {
  description: Scalars['String'];
};


export type QueryGetAiKeywordsForTopicArgs = {
  topicId: Scalars['String'];
};


export type QueryGetBrandInboundCommentInsightsArgs = {
  data: BrandInboundFiltersInputForCommentInsights;
};


export type QueryGetBrandInboundCreatorDemographicsArgs = {
  data: BrandInboundFiltersInput;
};


export type QueryGetBrandInboundSocialPostsArgs = {
  data: PaginatedBrandInboundFiltersInputForSocialPosts;
};


export type QueryGetBrandRadarEventsConfigArgs = {
  brandId: Scalars['String'];
};


export type QueryGetBrandSentimentInteractionsArgs = {
  data: PaginatedBrandInboundFiltersInputForSentimentClaimInteractions;
};


export type QueryGetBrandSentimentTextsBySubCategoryTrendArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  categoryName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sentiment: Sentiment;
  skip?: InputMaybe<Scalars['Int']>;
  subCategoryName: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  timeRange?: InputMaybe<MetricsTimeRange>;
  topicIds: Array<Scalars['String']>;
};


export type QueryGetCompetitorCommentInsightsArgs = {
  data: GetCompetitorCommentInsightsInput;
};


export type QueryGetCompetitorFlatCreatorDemographicsArgs = {
  data: CompetitorFlatAnalyticFiltersInput;
};


export type QueryGetCompetitorFlatCreatorGraphDataArgs = {
  data: GetCompetitorFlatCreatorGraphDataInput;
};


export type QueryGetCompetitorSentimentInteractionsArgs = {
  data: GetCompetitorSentimentInteractionsInput;
};


export type QueryGetCompetitorSentimentMetricsArgs = {
  data: GetCompetitorSentimentMetricsInput;
};


export type QueryGetCreatorArgs = {
  data: GetCreatorInput;
};


export type QueryGetCreatorProfileLocationsArgs = {
  brandId: Scalars['String'];
};


export type QueryGetCreatorProfileSuperfanEngagementArgs = {
  input: CreatorProfilePaginatedSuperfanEngagementInput;
};


export type QueryGetCreatorProfileSuperfanEngagementStatsArgs = {
  input: CreatorProfileSuperfanEngagementStatsInput;
};


export type QueryGetCreatorProfilesCapturedProductsArgs = {
  input: GetCreatorProfilesCapturedProductsArgs;
};


export type QueryGetCreatorsThatMentionedCompetitorArgs = {
  data: GetCreatorsThatMentionedCompetitorInput;
};


export type QueryGetFollowingArgs = {
  filters: SocialCreatorFilters;
};


export type QueryGetHashtagUsedByCompetitorArgs = {
  data: GetHashtagUsedByCompetitorInput;
};


export type QueryGetNotificationConfigArgs = {
  id: Scalars['String'];
};


export type QueryGetPaginatedRadarEventsArgs = {
  input: PaginatedRadarEventInput;
};


export type QueryGetPaginatedRelatedBrandsSocialPostsArgs = {
  data: PaginatedBrandInboundFiltersInputForRelatedBrands;
};


export type QueryGetPaginatedSocialPostEngagementSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GetPaginatedSocialPostEngagementSuggestionsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SocialListeningSuggestionsSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPaginatedSocialPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  contextualSearch?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GetPaginatedSocialPostFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchType?: InputMaybe<SocialPostSearchType>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SocialListeningPostsSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPostSuggestedAuthArgs = {
  collectionIds: Array<Scalars['String']>;
};


export type QueryGetPricesForPlanArgs = {
  planName: Scalars['String'];
};


export type QueryGetRecentSearchQueriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetRelatedBrandsArgs = {
  data: BrandInboundFiltersInputForRelatedBrands;
};


export type QueryGetSavedConfigsByTypeArgs = {
  input: ListSavedConfigsInput;
};


export type QueryGetSearchTermsArgs = {
  data: GetSearchTermsArgs;
};


export type QueryGetSearchesClickedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchableEntityTypes: Array<SearchableEntityType>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSocialCreatorArgs = {
  filters: SocialCreatorFilters;
};


export type QueryGetSocialPostsByCreatorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSocialPostsByCreatorsForCompetitorArgs = {
  data: SocialPostsByCreatorsForCompetitorInput;
};


export type QueryGetSocialPostsByHashtagsArgs = {
  data: GetSocialPostsByHashtagsInput;
};


export type QueryGetSocialPostsByHashtagsForBrandArgs = {
  data: GetTopHashtagsPostsForBrandInput;
};


export type QueryGetSocialPostsByHashtagsForCompetitorArgs = {
  data: GetTopHashtagsPostsForCompetitorInput;
};


export type QueryGetSocialPostsByTrendArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  categoryName: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sentiment: Sentiment;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  timeRange?: InputMaybe<MetricsTimeRange>;
  topicIds: Array<Scalars['String']>;
};


export type QueryGetSocialPostsCountriesDataArgs = {
  data: BrandInboundFiltersInput;
};


export type QueryGetSocialPostsCreatedForCompetitorsArgs = {
  data: GetSocialPostsCreatedForCompetitorsInput;
};


export type QueryGetSocialPostsLanguagesDataArgs = {
  data: BrandInboundFiltersInput;
};


export type QueryGetSubCategorySentimentTrendArgs = {
  brandId: Scalars['String'];
  categoryName: Scalars['String'];
  sentiment: Sentiment;
  timeRange?: InputMaybe<MetricsTimeRange>;
  topicIds: Array<Scalars['String']>;
};


export type QueryGetSuggestedCreatorsArgs = {
  brandId: Scalars['String'];
  filters: SocialCreatorFilters;
};


export type QueryGetTopicsTrackingListArgs = {
  data: CreatorTopicTrackingInput;
};


export type QueryGetTrackedCreatorsForTopicArgs = {
  data: TopicTrackedCreatorsInput;
};


export type QueryHashtagsForBrandArgs = {
  data: BrandInboundFiltersInputForHashtagsUsed;
};


export type QueryInboxNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: InboxNotificationFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryIsCollectionsPermissionLessThanParentCollectionPermissionArgs = {
  data: IsCollectionsPermissionLessThanParentCollectionPermissionInput;
};


export type QueryIsPostsPermissionLessThanParentCollectionPermissionArgs = {
  data: IsPostsPermissionLessThanParentCollectionPermissionInput;
};


export type QueryIsTrackingCreatorProfileInsightsArgs = {
  input: IsTrackingCreatorProfileInsightsInput;
};


export type QueryIsTrackingCreatorProfileInsightsByCreatorIdArgs = {
  input: IsTrackingCreatorProfileInsightsByCreatorIdInput;
};


export type QueryManuallyParsedSocialPostTrackersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: ManuallyParsedSocialPostTrackerFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOldestSocialPostForBrandInboundFiltersInputArgs = {
  data: BrandInboundFiltersInput;
};


export type QueryOrganizationAccessRequestArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationCompetitorsArgs = {
  brandId: Scalars['String'];
};


export type QueryOrganizationSocialPostCommentLabelsArgs = {
  data: OrganizationSocialPostCommentLabelsInput;
};


export type QueryPaginatedCreatorProfilesArgs = {
  input: PaginatedCreatorProfileInput;
};


export type QueryPaginatedOrganizationCreatorProfileLabelsArgs = {
  input: PaginatedOrganizationCreatorProfileLabelInput;
};


export type QueryPaginatedRadarEventActivitiesArgs = {
  input: PaginatedRadarEventActivityInput;
};


export type QueryPaginatedRadarEventActivityCommunicationChannelsArgs = {
  input: PaginatedRadarEventActivityCommunicationChannelInput;
};


export type QueryPendingPermissionRequestsForBrandArgs = {
  brandId: Scalars['String'];
};


export type QueryPermissionRequestArgs = {
  id: Scalars['String'];
};


export type QueryPermittedCollectionsArgs = {
  filters: PermittedCollectionFilters;
};


export type QueryPermittedPostsArgs = {
  filters: PermittedPostFilters;
};


export type QueryPinnedEntitiesToParentArgs = {
  filters: PinnedEntityFilters;
};


export type QueryPostArgs = {
  id: Scalars['String'];
};


export type QueryPostAnnotationArgs = {
  id: Scalars['String'];
};


export type QueryPostAnnotationsArgs = {
  filters?: InputMaybe<PostAnnotationFilters>;
};


export type QueryPostByIdsArgs = {
  input: GetPostByIdsInput;
};


export type QueryPostCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GetPostCollectionInput;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: PostFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPostsSmartSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: PostFiltersForSmartSearch;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  sortType?: InputMaybe<SortType>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryProductLinesModelsForCapturedProductAllLabelsArgs = {
  input: PaginatedCapturedProductAllLabelsInput;
};


export type QueryRadarEventArgs = {
  id: Scalars['String'];
};


export type QueryRadarEventActivityCommunicationChannelByIdsArgs = {
  input: RadarEventActivityCommunicationChannelByIdsInput;
};


export type QuerySameLevelCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GetSameLevelCollectionsInput;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchCompetitorFlatCreatorsArgs = {
  data: SearchCompetitorFlatCreatorsInput;
};


export type QuerySearchCreatorsArgs = {
  filters: SocialCreatorFilters;
  query: Scalars['String'];
};


export type QuerySearchDbCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Platform>;
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchEntitiesArgs = {
  data: SearchInput;
};


export type QuerySentimentClaimInteractionsArgs = {
  data: PaginatedBrandInboundFiltersInputForSentimentClaimInteractions;
};


export type QuerySentimentSubjectClaimMetricsForTopicInboundArgs = {
  data: BrandInboundFiltersInputForSentimentMetrics;
};


export type QuerySentimentSubjectsByTopicArgs = {
  topicId: Scalars['String'];
};


export type QueryShareLinkArgs = {
  id: Scalars['String'];
};


export type QuerySignalDefinitionsByBrandIdArgs = {
  brandId: Scalars['String'];
};


export type QuerySocialPostArgs = {
  id: Scalars['String'];
};


export type QuerySocialPostCommentCategoriesForBrandArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: SocialPostCommentCategoriesForBrandFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySocialPostCommentsArgs = {
  data: SocialPostCommentsInput;
};


export type QuerySocialPostsArgs = {
  socialPostIds: Array<Scalars['String']>;
};


export type QuerySuggestedPostsArgs = {
  filters: SuggestedPostsFilters;
};


export type QuerySuggestedPriorityTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTaskArgs = {
  id: Scalars['String'];
};


export type QueryTaskGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupBy: TaskGroupBy;
  groupValues?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  taskSearchArgs: GetTasksArgs;
};


export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customViewId?: InputMaybe<Scalars['String']>;
  filters: TaskFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  secondaryFilters?: InputMaybe<TaskFilters>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTasksByIdsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryTopCreatorPostsThatMentionedBrandArgs = {
  data: GetTopCreatorPostsThatMentionedBrandInput;
};


export type QueryTopicArgs = {
  id: Scalars['String'];
};


export type QueryTopicSignalDefinitionsArgs = {
  topicId: Scalars['String'];
};


export type QueryTrendArgs = {
  id: Scalars['String'];
};


export type QueryTrendsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: TrendFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUniversalSearchArgs = {
  data: UniversalSearchInput;
};


export type QueryUnreadCollectionCommentsArgs = {
  collectionId: Scalars['String'];
};


export type QueryUnreadPostCommentsArgs = {
  postId: Scalars['String'];
};


export type QueryUnreadTaskCommentsArgs = {
  taskId: Scalars['String'];
};


export type QueryUserProfileArgs = {
  id: Scalars['String'];
};

export type RadarEventActivityCommunicationChannelByIdsInput = {
  communicationChannelIds: Array<Scalars['String']>;
};

export type RadarEventActivityCommunicationChannelModel = {
  __typename?: 'RadarEventActivityCommunicationChannelModel';
  bgColor?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: OrganizationModel;
  organizationId: Scalars['String'];
  radarEventActivities: Array<RadarEventActivityModel>;
  updatedAt: Scalars['DateTime'];
};

/** The direction of the radar event activity */
export enum RadarEventActivityDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound'
}

export type RadarEventActivityModel = {
  __typename?: 'RadarEventActivityModel';
  assets: Array<PostModel>;
  channels: Array<RadarEventActivityCommunicationChannelModel>;
  createdAt: Scalars['DateTime'];
  createdByUser: UserProfileModel;
  createdByUserId: Scalars['String'];
  createdForCreatorProfiles: Array<CreatorProfileModel>;
  dateTime?: Maybe<Scalars['DateTime']>;
  direction: RadarEventActivityDirection;
  id: Scalars['ID'];
  radarEvents: Array<RadarEventModel>;
  summary: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type RadarEventModel = {
  __typename?: 'RadarEventModel';
  brand: BrandModel;
  brandId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  creator?: Maybe<CreatorModel>;
  creatorId?: Maybe<Scalars['String']>;
  creatorProfile: CreatorProfileModel;
  creatorProfileId: Scalars['String'];
  eventType: RadarEventType;
  eventTypeCounter: Scalars['Int'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  platformCreateTime: Scalars['DateTime'];
  radarEventActivities: Array<RadarEventActivityModel>;
  readStatus: RadarEventReadStatus;
  socialPost?: Maybe<SocialPostModel>;
  socialPostComment?: Maybe<SocialPostCommentModel>;
  updatedAt: Scalars['DateTime'];
};

export type RadarEventReadRecordModel = {
  __typename?: 'RadarEventReadRecordModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  radarEvent: RadarEventModel;
  radarEventId: Scalars['String'];
  readStatus: RadarEventReadStatus;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
  userId: Scalars['String'];
};

/** The read status of the radar event */
export enum RadarEventReadStatus {
  Read = 'Read',
  Unread = 'Unread'
}

/** The type of radar event */
export enum RadarEventType {
  Anniversary = 'Anniversary',
  Birthday = 'Birthday',
  Comment = 'Comment',
  Engagement = 'Engagement',
  Internal = 'Internal',
  Moment = 'Moment',
  Ugc = 'UGC',
  UgcEngagementRate = 'UGCEngagementRate'
}

export enum RadarEventViewType {
  AllEvents = 'AllEvents',
  KeyEvents = 'KeyEvents'
}

export type ReactInput = {
  commentId?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  requestResponseId?: InputMaybe<Scalars['String']>;
};

export type ReactToPostInput = {
  emoji: Scalars['String'];
  postId: Scalars['String'];
};

export type ReactionFilterInput = {
  emojis: Array<Scalars['String']>;
};

/** Reaction Filter Type */
export enum ReactionFilterType {
  Archive = 'Archive',
  Confused = 'Confused',
  Dislike = 'Dislike',
  Like = 'Like'
}

export type ReadAllCommentsInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};

/** Sign Up Provider */
export enum RegistrationMethod {
  Google = 'Google',
  Plot = 'Plot'
}

export type RejectOrganizationUserAccessRequestInput = {
  accessRequestId: Scalars['String'];
};

export type RejectPermissionRequestInput = {
  permissionRequestId: Scalars['String'];
};

export type RelatedBrand = {
  __typename?: 'RelatedBrand';
  brand: BrandModel;
  totalEngagement: Scalars['Float'];
  totalImpressions: Scalars['Float'];
  totalPosts: Scalars['Int'];
};

export type RelatedBrandMeta = {
  __typename?: 'RelatedBrandMeta';
  totalCount: Scalars['Int'];
};

export type RelatedBrandsData = {
  __typename?: 'RelatedBrandsData';
  data: Array<RelatedBrand>;
  meta: RelatedBrandMeta;
};

export type RelatedBrandsSortBy = {
  field: RelatedBrandsSortField;
  order?: InputMaybe<SortOrder>;
};

export enum RelatedBrandsSortField {
  TotalEngagement = 'TotalEngagement',
  TotalImpressions = 'TotalImpressions',
  TotalPosts = 'TotalPosts'
}

export type RemoveCollectionMembersInput = {
  collectionIds: Array<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type RemoveCollectionsParentInput = {
  collectionIds: Array<Scalars['String']>;
};

export type RemoveCompetitorsInput = {
  competitorIds: Array<Scalars['String']>;
};

export type RemoveCreatorBlockingByHandleInput = {
  brandId: Scalars['String'];
  handle: Scalars['String'];
};

export type RemoveCreatorFromCreatorProfileInput = {
  creatorId: Scalars['String'];
  creatorProfileId: Scalars['String'];
};

export type RemoveCreatorInput = {
  brandId: Scalars['String'];
  creatorId: Scalars['String'];
};

export type RemoveLabelsFromSocialPostCommentInput = {
  organizationSocialPostCommentLabelIds: Array<Scalars['String']>;
  socialPostCommentIds: Array<Scalars['String']>;
};

export type RemoveOrganizationCreatorProfileLabelFromCreatorProfileInput = {
  creatorProfileId: Scalars['String'];
  labelId: Scalars['String'];
};

export type RemovePermissionRequestInvitedMemberInput = {
  permissionRequestId: Scalars['String'];
};

export type RemovePostFromCollectionInput = {
  collectionId: Scalars['String'];
  postId: Scalars['String'];
};

export type RemovePostMembersInput = {
  postIds: Array<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type RemovePostsFromCollectionsInput = {
  collectionIds: Array<Scalars['String']>;
  postIds: Array<Scalars['String']>;
};

export type RemoveSuggestedPostFromCollectionsInput = {
  collectionId: Scalars['String'];
  postId: Scalars['String'];
};

export type RequestAdminToUpgradeInput = {
  plan: BillingPlanName;
};

export type ResolvePostAnnotationInput = {
  isResolved: Scalars['Boolean'];
  postAnnotationId: Scalars['String'];
};

export type ResourceModel = {
  __typename?: 'ResourceModel';
  attachment?: Maybe<AttachmentModel>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  post?: Maybe<PostModel>;
  projectId?: Maybe<Scalars['String']>;
  task?: Maybe<TaskModel>;
  type: ResourceType;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  urlMetadata?: Maybe<UrlMetadataModel>;
};

/** Type of a reference resources */
export enum ResourceType {
  Attachment = 'Attachment',
  Link = 'Link',
  Post = 'Post'
}

export type Result = {
  __typename?: 'Result';
  deleted?: Maybe<Array<DeletedResult>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ResumeBillingSubscriptionInput = {
  couponId: Scalars['String'];
  numberOfMembers: Scalars['Int'];
  paymentMethodId: Scalars['String'];
  priceId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type ResumeBrandInput = {
  brandId: Scalars['String'];
};

export type ResumeTopicInput = {
  topicId: Scalars['String'];
};

export type RevokeShareLinkInput = {
  shareLinkId: Scalars['String'];
};

export type Rule = {
  __typename?: 'Rule';
  condition?: Maybe<RuleCondition>;
  excludedKeywords?: Maybe<Array<Scalars['String']>>;
  field?: Maybe<Scalars['String']>;
  operator?: Maybe<RuleOperator>;
  platform?: Maybe<Platform>;
  rules?: Maybe<Array<Rule>>;
  value?: Maybe<Scalars['Int']>;
};

export enum RuleCondition {
  And = 'AND',
  Or = 'OR'
}

export type RuleInputData = {
  condition?: InputMaybe<RuleCondition>;
  excludedKeywords?: InputMaybe<Array<Scalars['String']>>;
  field?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<RuleOperator>;
  platform?: InputMaybe<Platform>;
  rules?: InputMaybe<Array<RuleInputData>>;
  value?: InputMaybe<Scalars['Int']>;
};

export enum RuleOperator {
  Equal = 'Equal',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  NotEqual = 'NotEqual'
}

export type SavePostsToCollectionsInput = {
  collectionIds: Array<Scalars['String']>;
  postIds: Array<Scalars['String']>;
};

export type SavedConfigModel = {
  __typename?: 'SavedConfigModel';
  brandId?: Maybe<Scalars['String']>;
  config: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: SavedConfigType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export enum SavedConfigType {
  CreatorProfileFiltersConfig = 'CreatorProfileFiltersConfig'
}

export type SearchClickedResultModel = {
  __typename?: 'SearchClickedResultModel';
  collection?: Maybe<CollectionModel>;
  post?: Maybe<PostModel>;
  query?: Maybe<Scalars['String']>;
  task?: Maybe<TaskModel>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserProfileModel>;
};

export type SearchCompetitorFlatCreatorsFilters = {
  competitorId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
  platforms: Array<Platform>;
};

export type SearchCompetitorFlatCreatorsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  filters: SearchCompetitorFlatCreatorsFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};

export type SearchHighlight = {
  __typename?: 'SearchHighlight';
  column: Scalars['String'];
  headline: Scalars['String'];
};

export type SearchHitClickInput = {
  collection?: InputMaybe<IdInput>;
  deliverable?: InputMaybe<IdInput>;
  post?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
  query?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<IdInput>;
  task?: InputMaybe<IdInput>;
  user?: InputMaybe<IdInput>;
};

/** Search result types */
export enum SearchHitType {
  Regular = 'Regular',
  Smart = 'Smart'
}

export type SearchInput = {
  entityTypes: Array<SearchableEntityType>;
  limit?: Scalars['Int'];
  text: Scalars['String'];
};

export type SearchResults = {
  __typename?: 'SearchResults';
  postSearchHits: Array<PostModel>;
  taskSearchHits: Array<TaskSearchHit>;
  userSearchHits: Array<UserProfileModel>;
};

export type SearchTermFilters = {
  query?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SearchTermModel = {
  __typename?: 'SearchTermModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isHashTag: Scalars['Boolean'];
  term: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Search types */
export enum SearchType {
  FullText = 'FullText',
  Hybrid = 'Hybrid',
  SmartFullText = 'SmartFullText'
}

/** Searchable entity types. */
export enum SearchableEntityType {
  Attachments = 'Attachments',
  Collections = 'Collections',
  Links = 'Links',
  Notes = 'Notes',
  Posts = 'Posts',
  Tasks = 'Tasks',
  Users = 'Users'
}

export type SendOtpInput = {
  phoneNumber: Scalars['String'];
  preference: OtpPreference;
  termsAccepted?: InputMaybe<Scalars['Boolean']>;
};

/** Possible sentiment types */
export enum Sentiment {
  Mixed = 'MIXED',
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  None = 'NONE',
  Positive = 'POSITIVE'
}

export type SentimentClaimInteractions = {
  __typename?: 'SentimentClaimInteractions';
  socialPostComments?: Maybe<Array<SocialPostCommentModel>>;
  socialPosts?: Maybe<Array<SocialPostModel>>;
};

export enum SentimentMedium {
  InComments = 'IN_COMMENTS',
  InPosts = 'IN_POSTS'
}

export type SentimentMetric = {
  __typename?: 'SentimentMetric';
  averageCountPerDay: Scalars['Float'];
  chartDataPoints: Array<ChartDataPoint>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SentimentMetricsInput = {
  timeRange: MetricsTimeRange;
  topicIds: Array<Scalars['String']>;
};

export type SentimentMetricsModel = {
  __typename?: 'SentimentMetricsModel';
  negative: SentimentMetric;
  neutral: SentimentMetric;
  positive: SentimentMetric;
};

export type SentimentSubjectModel = {
  __typename?: 'SentimentSubjectModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  status: SentimentSubjectStatus;
  subject: Scalars['String'];
  topic: TopicModel;
  topicId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum SentimentSubjectStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum ShareEntityType {
  Collection = 'Collection',
  ContentIdea = 'ContentIdea',
  Post = 'Post'
}

export type ShareLinkModel = {
  __typename?: 'ShareLinkModel';
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityType: ShareEntityType;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  validationToken: Scalars['String'];
};

export type ShouldUpdatePostPermissionToCollectionPermissionInput = {
  collectionId: Scalars['String'];
  postId?: InputMaybe<Scalars['String']>;
  postIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ShouldUpdatePostPermissionToCollectionPermissionResult = {
  __typename?: 'ShouldUpdatePostPermissionToCollectionPermissionResult';
  should: Scalars['Boolean'];
};

export type SignalCategoryOptionModel = {
  __typename?: 'SignalCategoryOptionModel';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  signalDefinition: SignalDefinitionModel;
  signalDefinitionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type SignalCategoryOptionNewModel = {
  __typename?: 'SignalCategoryOptionNewModel';
  id: Scalars['String'];
  value: Scalars['String'];
};

export type SignalDefinitionModel = {
  __typename?: 'SignalDefinitionModel';
  childSignals: Array<SignalDefinitionModel>;
  createdAt: Scalars['DateTime'];
  depth: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  options: Array<SignalCategoryOptionModel>;
  parentSignal?: Maybe<SignalDefinitionModel>;
  parentSignalId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SignalDefinitionNewModel = {
  __typename?: 'SignalDefinitionNewModel';
  id: Scalars['String'];
  label: Scalars['String'];
  name: Scalars['String'];
};

export type SignalValueModel = {
  __typename?: 'SignalValueModel';
  childSignalValues: Array<SignalValueModel>;
  confidenceScore?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  depth: Scalars['Int'];
  id: Scalars['ID'];
  parentSignalValue?: Maybe<SignalValueModel>;
  parentSignalValueId?: Maybe<Scalars['String']>;
  signalCategoryOption?: Maybe<SignalCategoryOptionModel>;
  signalCategoryOptionId?: Maybe<Scalars['String']>;
  signalDefinition: SignalDefinitionModel;
  signalDefinitionId: Scalars['String'];
  socialpost: SocialPostModel;
  socialpostId: Scalars['String'];
  topic: TopicModel;
  topicId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type SimpleDateRangeFilterInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type SocialAuthorModel = {
  __typename?: 'SocialAuthorModel';
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: Platform;
  platformHandle?: Maybe<Scalars['String']>;
  profileUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SocialCreatorFilters = {
  handle?: InputMaybe<Scalars['String']>;
  platform: Platform;
  platformId?: InputMaybe<Scalars['String']>;
};

export type SocialListeningHourUsageThresholdAlert = {
  __typename?: 'SocialListeningHourUsageThresholdAlert';
  dialogAlertThresholdPercentage: Scalars['Int'];
  emailAlertThresholdPercentage: Scalars['Int'];
};

/** Possible sort by types for social listening posts */
export enum SocialListeningPostsSortBy {
  ConfidenceScore = 'ConfidenceScore',
  CreatedAt = 'CreatedAt',
  EngagementScore = 'EngagementScore',
  FollowerCount = 'FollowerCount',
  TotalBookmarks = 'TotalBookmarks',
  TotalEngagementScore = 'TotalEngagementScore',
  TotalShares = 'TotalShares',
  ViewCount = 'ViewCount'
}

/** Possible sort by types for social listening suggestions */
export enum SocialListeningSuggestionsSortBy {
  ConfidenceScore = 'ConfidenceScore',
  CreatedAt = 'CreatedAt'
}

export type SocialMediaResource = {
  __typename?: 'SocialMediaResource';
  type: Scalars['String'];
  url: Scalars['String'];
};

export type SocialMediaUserModel = {
  __typename?: 'SocialMediaUserModel';
  createdAt: Scalars['DateTime'];
  followerCount: Scalars['Int'];
  followingCount: Scalars['Int'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  nickName: Scalars['String'];
  platform: Platform;
  platformId: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum SocialPostAgeGroupDemographic {
  Age0_4 = 'Age0_4',
  Age5_12 = 'Age5_12',
  Age13_17 = 'Age13_17',
  Age18_24 = 'Age18_24',
  Age25_34 = 'Age25_34',
  Age35_44 = 'Age35_44',
  Age45_54 = 'Age45_54',
  Age55_64 = 'Age55_64',
  Age65_74 = 'Age65_74',
  Age75Plus = 'Age75Plus',
  NotSpecified = 'NotSpecified'
}

export type SocialPostCommentCategoriesForBrandFilters = {
  brandId: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  platforms: Array<Platform>;
  query?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  type: CommentInsightsCategoryType;
};

export type SocialPostCommentClaimModel = {
  __typename?: 'SocialPostCommentClaimModel';
  brand?: Maybe<BrandModel>;
  brandId?: Maybe<Scalars['String']>;
  claim: Scalars['String'];
  claimAttribute: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  sentimentScore: Scalars['Float'];
  socialPostComment: SocialPostCommentModel;
  updatedAt: Scalars['DateTime'];
};

export type SocialPostCommentModel = {
  __typename?: 'SocialPostCommentModel';
  categoryName: Array<Scalars['String']>;
  childCommentCount: Scalars['Int'];
  commentCreator: CreatorModel;
  commentCreatorId: Scalars['String'];
  commentEngagement: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  diggCount: Scalars['Int'];
  enrichedComment?: Maybe<Scalars['String']>;
  enrichmentType?: Maybe<CommentEnrichmentType>;
  id: Scalars['ID'];
  organizationSocialPostCommentLabels: Array<OrganizationSocialPostCommentLabelModel>;
  parentSocialPostComment?: Maybe<SocialPostCommentModel>;
  parentSocialPostCommentId?: Maybe<Scalars['String']>;
  platform: Platform;
  platformCreateTime: Scalars['DateTime'];
  socialPost: SocialPostModel;
  socialPostCommentClaims: Array<SocialPostCommentClaimModel>;
  socialPostId: Scalars['String'];
  targetType?: Maybe<CommentTargetType>;
  text: Scalars['String'];
  topic?: Maybe<TopicModel>;
  updatedAt: Scalars['DateTime'];
};

export enum SocialPostCommentSource {
  Auto = 'Auto',
  Manual = 'Manual'
}

export type SocialPostCommentsFilters = {
  brandIds: Array<Scalars['String']>;
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
  platforms?: InputMaybe<Array<Platform>>;
  responderIds?: InputMaybe<Array<Scalars['String']>>;
  sources?: InputMaybe<Array<SocialPostCommentSource>>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SocialPostCommentsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: SocialPostCommentsFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
};

export type SocialPostContextualInformation = {
  __typename?: 'SocialPostContextualInformation';
  detailedSummary?: Maybe<Scalars['String']>;
  oneLineSummary?: Maybe<Scalars['String']>;
};

export type SocialPostCountryStatsForDateModel = {
  __typename?: 'SocialPostCountryStatsForDateModel';
  totalEngagement: Scalars['Float'];
  totalImpressions: Scalars['Float'];
  totalPosts: Scalars['Float'];
};

export type SocialPostCountryStatsModel = {
  __typename?: 'SocialPostCountryStatsModel';
  country: Scalars['String'];
  statsForFirstDate: SocialPostCountryStatsForDateModel;
  statsForLastDate: SocialPostCountryStatsForDateModel;
  totalEngagement: Scalars['Float'];
  totalImpressions: Scalars['Float'];
  totalPosts: Scalars['Int'];
};

export type SocialPostCreatorDemographicModel = {
  __typename?: 'SocialPostCreatorDemographicModel';
  ageGroup: SocialPostAgeGroupDemographic;
  createdAt: Scalars['DateTime'];
  gender: SocialPostGenderDemographic;
  generation: SocialPostGenerationDemographic;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type SocialPostEngagementSuggestionModel = {
  __typename?: 'SocialPostEngagementSuggestionModel';
  createdAt: Scalars['DateTime'];
  highlights: Array<VideoHighlight>;
  id: Scalars['ID'];
  oneLineSummary: Scalars['String'];
  reason: Scalars['String'];
  score: Scalars['Float'];
  sentiment: Sentiment;
  socialPost?: Maybe<SocialPostModel>;
  socialpostId: Scalars['String'];
  suggestedComment: Scalars['String'];
  topic?: Maybe<TopicModel>;
  topicId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  videoSummary: Scalars['String'];
};

export enum SocialPostGenderDemographic {
  Female = 'Female',
  Male = 'Male',
  NotSpecified = 'NotSpecified'
}

export enum SocialPostGenerationDemographic {
  Boomers = 'Boomers',
  GenAlpha = 'GenAlpha',
  GenX = 'GenX',
  GenZ = 'GenZ',
  Millennials = 'Millennials',
  NotSpecified = 'NotSpecified'
}

export type SocialPostLanguageStatsModel = {
  __typename?: 'SocialPostLanguageStatsModel';
  language: Scalars['String'];
  statsForFirstDate: SocialPostCountryStatsForDateModel;
  statsForLastDate: SocialPostCountryStatsForDateModel;
  totalEngagement: Scalars['Float'];
  totalImpressions: Scalars['Float'];
  totalPosts: Scalars['Int'];
};

export enum SocialPostMentionSource {
  Organic = 'Organic',
  Paid = 'Paid'
}

export type SocialPostModel = {
  __typename?: 'SocialPostModel';
  audioTranscription: Array<AudioTranscript>;
  bookmarkCount: Scalars['Int'];
  brandAnalysis: Array<BrandAnalysisModel>;
  brandClaims: Array<BrandClaimModel>;
  brandSocialPostEngagement?: Maybe<BrandSocialPostEngagementModel>;
  carouselFolderUrl?: Maybe<Scalars['String']>;
  carouselMedias: Array<CarouselMedia>;
  commentCount: Scalars['Int'];
  communityComments: Array<SocialPostCommentModel>;
  contextualInformation?: Maybe<SocialPostContextualInformation>;
  createdAt: Scalars['DateTime'];
  creator?: Maybe<CreatorModel>;
  creatorId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  diggCount: Scalars['Int'];
  duration: Scalars['Int'];
  engagementRate: Scalars['Float'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  hashtags: Array<HashTagModel>;
  id: Scalars['ID'];
  isAd: Scalars['Boolean'];
  isSavedToContentCalendar: Scalars['Boolean'];
  matchedMusic?: Maybe<Scalars['String']>;
  platform: Platform;
  platformCreateTime: Scalars['DateTime'];
  platformId: Scalars['String'];
  playCount: Scalars['Int'];
  region?: Maybe<Scalars['String']>;
  savedPost?: Maybe<PostModel>;
  savedPostId?: Maybe<Scalars['String']>;
  sentimentTexts: Array<BrandSentimentTextModel>;
  shareCount: Scalars['Int'];
  socialPostCreatorDemographics?: Maybe<Array<SocialPostCreatorDemographicModel>>;
  socialPostEngagementSuggestions?: Maybe<Array<SocialPostEngagementSuggestionModel>>;
  socialPostEngagementSuggestionsWithTopic: Array<SocialPostEngagementSuggestionModel>;
  socialPostSentimentSubjectClaims?: Maybe<Array<SocialPostSentimentSubjectClaimModel>>;
  socialPostSignalValues?: Maybe<SocialPostValueModel>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  totalContentCalendarSaves: Scalars['Int'];
  totalEngagement: Scalars['Int'];
  totalPostSaves: Scalars['Int'];
  type: SocialPostType;
  updatedAt: Scalars['DateTime'];
  videoThumbnailFolderUrl?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  viralRate: Scalars['Float'];
};


export type SocialPostModelBrandSocialPostEngagementArgs = {
  brandId: Scalars['String'];
};


export type SocialPostModelSocialPostEngagementSuggestionsArgs = {
  brandId?: InputMaybe<Scalars['String']>;
};


export type SocialPostModelSocialPostEngagementSuggestionsWithTopicArgs = {
  brandId?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SocialPostNotificationConfigModel = {
  __typename?: 'SocialPostNotificationConfigModel';
  brand: BrandModel;
  brandId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  creatorFollowing: Array<FollowersScale>;
  creatorFollowingEnabled: Scalars['Boolean'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  minimumScore: Scalars['Float'];
  minimumScoreEnabled: Scalars['Boolean'];
  sentiments: Array<DetailedSentiment>;
  sentimentsEnabled: Scalars['Boolean'];
  topic?: Maybe<TopicModel>;
  topicId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
  userId: Scalars['String'];
};

export type SocialPostReportModel = {
  __typename?: 'SocialPostReportModel';
  createdAt: Scalars['DateTime'];
  forBrand: BrandModel;
  id: Scalars['ID'];
  reason: Scalars['String'];
  reportedByUser: UserProfileModel;
  socialPost: SocialPostModel;
  updatedAt: Scalars['DateTime'];
};

/** Search type for social posts. If contextual it uses embed data, if filtered it uses the database posts */
export enum SocialPostSearchType {
  Contextual = 'contextual',
  Filtered = 'filtered'
}

export type SocialPostSentimentSubjectClaimModel = {
  __typename?: 'SocialPostSentimentSubjectClaimModel';
  attribute: Scalars['String'];
  claim: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isConfident: Scalars['Boolean'];
  isExplicit: Scalars['Boolean'];
  reason: Scalars['String'];
  sentimentScore: Scalars['Float'];
  sentimentSubjectId: Scalars['String'];
  socialPostId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum SocialPostType {
  Carousel = 'Carousel',
  Photo = 'Photo',
  Video = 'Video'
}

export type SocialPostValueModel = {
  __typename?: 'SocialPostValueModel';
  id: Scalars['String'];
  signalCategoryOption: SignalCategoryOptionNewModel;
  signalDefinition: SignalDefinitionNewModel;
};

export type SocialPostsByCreatorsForCompetitorInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competitorId: Scalars['String'];
  creatorId: Scalars['String'];
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy: SortByInputForSocialPostsByCreatorsForCompetitor;
  startDate: Scalars['DateTime'];
  take?: InputMaybe<Scalars['Int']>;
};

export type SocialPostsNotificationDataModel = {
  __typename?: 'SocialPostsNotificationDataModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  notificationConfig: SocialPostNotificationConfigModel;
  notificationConfigId: Scalars['String'];
  socialPostIds: Array<Scalars['String']>;
  socialPosts: Array<SocialPostModel>;
  updatedAt: Scalars['DateTime'];
};

export type SortByInputData = {
  field?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<SortOrder>;
};

/** Sort By Input For Social Posts By Creators For Competitor */
export enum SortByInputForSocialPostsByCreatorsForCompetitor {
  EngagementRate = 'EngagementRate',
  LikeCount = 'LikeCount',
  PlayCount = 'PlayCount'
}

/** Sort By Input For Social Posts By Hashtags */
export enum SortByInputForSocialPostsByHashtags {
  EngagementRate = 'EngagementRate',
  LikeCount = 'LikeCount',
  PlayCount = 'PlayCount'
}

/** Sort By Input For Top Creator Posts That Mentioned Brand */
export enum SortByInputForTopCreatorPostsThatMentionedBrand {
  EngagementRate = 'EngagementRate',
  LikeCount = 'LikeCount',
  PlayCount = 'PlayCount'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortType {
  DateCreated = 'DateCreated',
  RecentActivity = 'RecentActivity',
  Relevance = 'Relevance'
}

export enum Stage {
  BrainDump = 'BrainDump',
  IceBox = 'IceBox',
  Production = 'Production',
  Publish = 'Publish'
}

export type SubtaskInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  memberIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  priority?: InputMaybe<TaskPriority>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<TaskStatus>;
};

export type SuggestedInviteMember = {
  __typename?: 'SuggestedInviteMember';
  permissionLevel: PermissionLevel;
  user: UserProfileModel;
};

export type SuggestedPostsFilters = {
  collectionId: Scalars['String'];
};

export type TaskFilters = {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdByIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  includeSubtasks?: InputMaybe<Scalars['Boolean']>;
  memberIds?: InputMaybe<Array<Scalars['String']>>;
  parentTaskId?: InputMaybe<Scalars['String']>;
  postIds?: InputMaybe<Array<Scalars['String']>>;
  priorities?: InputMaybe<Array<Scalars['String']>>;
  projectGroupIds?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortByInputData>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  statuses?: InputMaybe<Array<TaskStatus>>;
  subscriberIds?: InputMaybe<Array<Scalars['String']>>;
  workstreamIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Possible grouping types of a task group */
export enum TaskGroupBy {
  Creator = 'Creator',
  DueDate = 'DueDate',
  Owner = 'Owner',
  Post = 'Post',
  Priority = 'Priority',
  Status = 'Status'
}

export type TaskGroupModel = {
  __typename?: 'TaskGroupModel';
  id: Scalars['String'];
  tasks: PaginatedTaskSearchResult;
};

export type TaskModel = {
  __typename?: 'TaskModel';
  completedDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileModel;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  excerpt: Scalars['String'];
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  isPreview: Scalars['Boolean'];
  myPermissions: Array<TaskPermission>;
  name: Scalars['String'];
  parentTask?: Maybe<TaskModel>;
  parentTaskId?: Maybe<Scalars['String']>;
  posts?: Maybe<Array<PostModel>>;
  previewPosts?: Maybe<Array<PostModel>>;
  priority?: Maybe<TaskPriority>;
  sortOrder?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startedDate?: Maybe<Scalars['DateTime']>;
  status: TaskStatus;
  subscribers: Array<UserProfileModel>;
  subtasks: Array<TaskModel>;
  taskMembers: Array<UserProfileModel>;
  updatedAt: Scalars['DateTime'];
};


export type TaskModelSubtasksArgs = {
  args?: InputMaybe<GetTasksArgs>;
};

export enum TaskPermission {
  Delete = 'Delete',
  Read = 'Read',
  Update = 'Update'
}

/** The priority of a task */
export enum TaskPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type TaskSearchHit = {
  __typename?: 'TaskSearchHit';
  headline: Array<Headline>;
  taskModel: TaskModel;
};

export type TaskSearchHitV2 = {
  __typename?: 'TaskSearchHitV2';
  item: TaskModel;
  score: Scalars['Float'];
  searchHighlights: Array<SearchHighlight>;
  type: SearchHitType;
};

export type TaskSearchResult = {
  __typename?: 'TaskSearchResult';
  hits: Array<TaskSearchHitV2>;
  totalCount: Scalars['Int'];
};

/** The status of a task */
export enum TaskStatus {
  Archived = 'Archived',
  Done = 'Done',
  InProgress = 'InProgress',
  InReview = 'InReview',
  ToDo = 'ToDo'
}

export type TextDetection = {
  __typename?: 'TextDetection';
  confidence?: Maybe<Scalars['Int']>;
  detectedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ThumbnailMetadata = {
  __typename?: 'ThumbnailMetadata';
  href?: Maybe<Scalars['String']>;
  mediaSize?: Maybe<MediaSize>;
  status?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type TiktokMetaData = {
  __typename?: 'TiktokMetaData';
  commentCount: Scalars['Int'];
  creatorHandle: Scalars['String'];
  creatorName: Scalars['String'];
  creatorUrl: Scalars['String'];
  diggCount: Scalars['Int'];
  playCount: Scalars['Int'];
  videoUrl: Scalars['String'];
};

export type TokenModel = {
  __typename?: 'TokenModel';
  /** JWT access token */
  accessToken: Scalars['JWT'];
  /** JWT refresh token */
  refreshToken: Scalars['JWT'];
};

export type TopicHoursParsedInput = {
  brandId: Scalars['String'];
  dateRange?: InputMaybe<SimpleDateRangeFilterInput>;
};

export type TopicModel = {
  __typename?: 'TopicModel';
  active: Scalars['Boolean'];
  allowToUpdateSearchTerm: Scalars['Boolean'];
  brand: BrandModel;
  brandId?: Maybe<Scalars['String']>;
  communicationStrategy?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creatorTrackingTopics: Array<CreatorTrackingTopicModel>;
  generatedPrompt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
  minimumProcessingRules?: Maybe<Array<Rule>>;
  name: Scalars['String'];
  parsingSettings?: Maybe<ParsingSettings>;
  prioritizationInfo?: Maybe<Scalars['String']>;
  resetOnNextCycle: Scalars['Boolean'];
  searchTerms: Array<SearchTermModel>;
  sentimentSubjects: Array<SentimentSubjectModel>;
  status: TopicStatus;
  topicContentStrategy?: Maybe<Scalars['String']>;
  topicDescription?: Maybe<Scalars['String']>;
  topicSignalDefinitions: Array<TopicSignalDefinitionModel>;
  totalHoursParsedCount: Scalars['Int'];
  type: ListeningTopicType;
  updatedAt: Scalars['DateTime'];
};


export type TopicModelTotalHoursParsedCountArgs = {
  data?: InputMaybe<TopicHoursParsedInput>;
};

export type TopicSignalDefinitionModel = {
  __typename?: 'TopicSignalDefinitionModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  signalDefinition: SignalDefinitionModel;
  signalDefinitionId: Scalars['String'];
  topic: TopicModel;
  topicId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum TopicStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Paused = 'PAUSED'
}

export type TopicTrackedCreatorsInput = {
  platforms: Array<Platform>;
  topicId: Scalars['String'];
};

export type TopicTrackingStatusInput = {
  topicId: Scalars['String'];
  trackingStatus: Scalars['Boolean'];
};

export type TrackCreatorInput = {
  data: TrackCreatorInputData;
  topicId: Scalars['String'];
};

export type TrackCreatorInputData = {
  handle: Scalars['String'];
  platform: Platform;
  platformId: Scalars['String'];
};

export type TrackCreatorsInput = {
  data: TrackCreatorInputData;
  topicIds: Array<Scalars['String']>;
};

export type TrackEventInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  eventName: Scalars['String'];
};

export type TrendAudioModel = {
  __typename?: 'TrendAudioModel';
  author?: Maybe<SocialAuthorModel>;
  authorId?: Maybe<Scalars['String']>;
  authorUsername?: Maybe<Scalars['String']>;
  changePercentage?: Maybe<Scalars['Float']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  platform: Platform;
  title?: Maybe<Scalars['String']>;
  totalVideoCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  urlMetadata: UrlMetadataModel;
};

export type TrendAudioSavedCount = {
  __typename?: 'TrendAudioSavedCount';
  savedContentCalendarTotal: Scalars['Int'];
  totalSavedCount: Scalars['Int'];
};

/** Trend Category */
export enum TrendCategory {
  Music = 'Music',
  Other = 'Other',
  PopCulture = 'PopCulture',
  VideoStructure = 'VideoStructure',
  Voiceover = 'Voiceover'
}

export type TrendExampleModel = {
  __typename?: 'TrendExampleModel';
  id: Scalars['String'];
  savedContentCalendarTotal: Scalars['Int'];
  totalSavedCount: Scalars['Int'];
  urlMetadata: UrlMetadataModel;
};

export type TrendFilters = {
  categories?: InputMaybe<Array<TrendCategory>>;
  customPersonaIds?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortByInputData>;
};

export type TrendModel = {
  __typename?: 'TrendModel';
  category: TrendCategory;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  lastViewed?: Maybe<Scalars['DateTime']>;
  linkedPosts: Array<PostModel>;
  previewPost?: Maybe<PostModel>;
  previewThumbnail?: Maybe<Scalars['String']>;
  previewUrlMetadata?: Maybe<UrlMetadataModel>;
  status?: Maybe<TrendStatus>;
  title: Scalars['String'];
  trendAudio?: Maybe<TrendAudioModel>;
  trendAudioId?: Maybe<Scalars['String']>;
  trendAudioSavedCount?: Maybe<TrendAudioSavedCount>;
  trendExamples: Array<TrendExampleModel>;
  trendingDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/** Trend Status */
export enum TrendStatus {
  Falling = 'Falling',
  Hot = 'Hot',
  Rising = 'Rising'
}

export type UrlMetadataModel = {
  __typename?: 'URLMetadataModel';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  metadata?: Maybe<Metadata>;
  tiktokMetaData?: Maybe<TiktokMetaData>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type UnblockCreatorFromCreatorProfileInput = {
  brandId: Scalars['String'];
  creatorProfileId: Scalars['String'];
};

export type UnhideHashtagUsedForCreatorInput = {
  competitorId: Scalars['String'];
  hashtagName: Scalars['String'];
  platform?: InputMaybe<Platform>;
};

export type UniversalSearchInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entityTypes: Array<SearchableEntityType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: Scalars['Int'];
  searchType: SearchType;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
};

export type UniversalSearchResults = {
  __typename?: 'UniversalSearchResults';
  attachmentSearchResult: PostSearchResult;
  collectionSearchResult: CollectionSearchResult;
  linkSearchResult: PostSearchResult;
  noteSearchResult: PostSearchResult;
  pageInfo: PageInfo;
  taskSearchResult: TaskSearchResult;
};

export type UnpinCollectionInput = {
  collectionId: Scalars['String'];
};

export type UnpinCollectionsInput = {
  collectionIds: Array<Scalars['String']>;
};

export type UnpinManyCollectionsFromParentInput = {
  collectionIds: Array<Scalars['String']>;
};

export type UnpinManyPostsFromCollectionInput = {
  collectionId: Scalars['String'];
  postIds: Array<Scalars['String']>;
};

export type UnpinPostFromCollectionInput = {
  collectionId: Scalars['String'];
  postId: Scalars['String'];
};

export type UntrackCreatorForTopicsInput = {
  data: UntrackCreatorForTopicsInputData;
  topicIds: Array<Scalars['String']>;
};

export type UntrackCreatorForTopicsInputData = {
  handle: Scalars['String'];
  platform: Platform;
  platformId: Scalars['String'];
};

export type UpdateBillingCustomerDefaultPaymentMethodInput = {
  paymentMethodId: Scalars['String'];
};

export type UpdateBillingSubscriptionInput = {
  couponId?: InputMaybe<Scalars['String']>;
  numberOfMembers?: InputMaybe<Scalars['Int']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  trialEnd?: InputMaybe<Scalars['Int']>;
  trialEndNow?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateBrandGeneralPermissionInput = {
  generalPermission: GeneralPermission;
  permissionLevel?: InputMaybe<PermissionLevel>;
};

export type UpdateBrandGeneralPermissionMember = {
  email: Scalars['String'];
  permission: PermissionLevel;
};

export type UpdateBrandInput = {
  data: UpdateBrandInputData;
  id: Scalars['String'];
};

export type UpdateBrandInputData = {
  brandKnownNames?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  minimumProcessingRules?: InputMaybe<Array<RuleInputData>>;
  name?: InputMaybe<Scalars['String']>;
  parsingSettings?: InputMaybe<ParsingSettingsInputData>;
  regions?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateBrandMentionTopicInput = {
  data: UpdateBrandMentionTopicInputData;
  id: Scalars['String'];
};

export type UpdateBrandMentionTopicInputData = {
  communicationStrategy?: InputMaybe<Scalars['String']>;
  generatedPrompt?: InputMaybe<Scalars['String']>;
  minimumProcessingRules?: InputMaybe<Array<RuleInputData>>;
  name?: InputMaybe<Scalars['String']>;
  parsingSettings?: InputMaybe<ParsingSettingsInputData>;
  prioritizationInfo?: InputMaybe<Scalars['String']>;
  topicContentStrategy?: InputMaybe<Scalars['String']>;
  topicDescription?: InputMaybe<Scalars['String']>;
};

export type UpdateBrandPermissionsInput = {
  brandId: Scalars['String'];
  generalPermission?: InputMaybe<UpdateBrandGeneralPermissionInput>;
  members: Array<UpdateBrandGeneralPermissionMember>;
};

export type UpdateBrandRadarEventsConfigInput = {
  brandId: Scalars['String'];
  data: UpdateBrandRadarEventsConfigInputData;
};

export type UpdateBrandRadarEventsConfigInputData = {
  engagementRateThreshold: Scalars['Int'];
  engagementThreshold: Scalars['Int'];
  mentionsThreshold: Scalars['Int'];
};

export type UpdateBrandSocialPostEngagementInput = {
  brandId: Scalars['String'];
  socialPostId: Scalars['String'];
  status?: InputMaybe<BrandSocialPostEngagementStatus>;
};

export type UpdateBrandSocialPostEngagementResponderInput = {
  brandId?: InputMaybe<Scalars['String']>;
  brandSocialPostEngagementId?: InputMaybe<Scalars['String']>;
  responderId?: InputMaybe<Scalars['String']>;
  socialPostId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BrandSocialPostEngagementStatus>;
};

export type UpdateCollectionInput = {
  collectionId: Scalars['String'];
  data: UpdateCollectionInputData;
};

export type UpdateCollectionInputData = {
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCollectionPermissionToParentCollectionPermissionInput = {
  collectionIds: Array<Scalars['String']>;
  parentCollectionId: Scalars['String'];
};

export type UpdateCollectionPermissionsInput = {
  generalPermission?: InputMaybe<UpdateCollectionsGeneralPermissionInput>;
  inviteMembers?: InputMaybe<InviteCollectionMembersInput>;
  removeMembers?: InputMaybe<RemoveCollectionMembersInput>;
};

export type UpdateCollectionPermissionsInputDataV2 = {
  generalPermission?: InputMaybe<UpdateCollectionsGeneralPermissionInput>;
  inviteMembers?: InputMaybe<InviteCollectionMembersInput>;
  removeMembers?: InputMaybe<RemoveCollectionMembersInput>;
};

export type UpdateCollectionPermissionsInputV2 = {
  input: UpdateCollectionPermissionsInputDataV2;
};

export type UpdateCollectionPreviewInput = {
  collectionId: Scalars['String'];
  postId?: InputMaybe<Scalars['String']>;
};

export type UpdateCollectionsGeneralPermissionInput = {
  collectionIds: Array<Scalars['String']>;
  generalPermission: GeneralPermission;
  permissionLevel?: InputMaybe<PermissionLevel>;
};

export type UpdateCommentInput = {
  commentId: Scalars['String'];
  data: UpdateCommentInputData;
};

export type UpdateCommentInputData = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  comment: Scalars['String'];
};

export type UpdateCompetitorCreatorDataInput = {
  handle: Scalars['String'];
  platform: Platform;
};

export type UpdateCompetitorDataInput = {
  allowAppCreatorToUpdateSearchTermList?: InputMaybe<Scalars['Boolean']>;
  creators?: InputMaybe<Array<UpdateCompetitorCreatorDataInput>>;
  description?: InputMaybe<Scalars['String']>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parsingSettings?: InputMaybe<ParsingSettingsInputData>;
  regions?: InputMaybe<Array<Scalars['String']>>;
  searchTerms?: InputMaybe<Array<UpdateCompetitorSearchTermDataInput>>;
};

export type UpdateCompetitorInput = {
  competitorId: Scalars['String'];
  data: UpdateCompetitorDataInput;
};

export type UpdateCompetitorSearchTermDataInput = {
  term: Scalars['String'];
};

export type UpdateContentCalendarViewInput = {
  contentCalendarViewId: Scalars['String'];
  data: UpdateContentCalendarViewInputData;
};

export type UpdateContentCalendarViewInputData = {
  filters?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateContentIdeaFieldInput = {
  contentIdeaFieldId: Scalars['String'];
  contentIdeaId?: InputMaybe<Scalars['String']>;
  data: UpdateContentIdeaFieldInputData;
};

export type UpdateContentIdeaFieldInputData = {
  icon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
};

export type UpdateContentIdeaFieldOptionData = {
  value: Scalars['String'];
};

export type UpdateContentIdeaFieldOptionInput = {
  contentIdeaFieldOptionId: Scalars['String'];
  data: UpdateContentIdeaFieldOptionData;
};

export type UpdateContentIdeaFieldValue = {
  checkbox?: InputMaybe<Scalars['Boolean']>;
  collectionId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  multiSelect?: InputMaybe<Array<Scalars['String']>>;
  select?: InputMaybe<Scalars['String']>;
  taskIds?: InputMaybe<Array<Scalars['String']>>;
  text?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateContentIdeaFieldValueData = {
  timeZone?: InputMaybe<Scalars['String']>;
  value: UpdateContentIdeaFieldValue;
};

export type UpdateContentIdeaFieldValueInput = {
  contentIdeaFieldValueId: Scalars['String'];
  data: UpdateContentIdeaFieldValueData;
};

export type UpdateContentIdeaInput = {
  contentIdeaId: Scalars['String'];
  data: UpdateContentIdeaInputData;
};

export type UpdateContentIdeaInputData = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  noteContent?: InputMaybe<Scalars['String']>;
  rootCollectionId?: InputMaybe<Scalars['String']>;
  snoozeDate?: InputMaybe<Scalars['DateTime']>;
  stage?: InputMaybe<Stage>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type UpdateContentIdeaPublishMetadataInput = {
  contentIdeaPublishMetadataId: Scalars['String'];
  data: UpdateContentIdeaPublishMetadataInputData;
};

export type UpdateContentIdeaPublishMetadataInputData = {
  audio?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  publishUrl?: InputMaybe<Scalars['String']>;
  socialAuthorId?: InputMaybe<Scalars['String']>;
};

export type UpdateCreatorProfileInput = {
  data: UpdateCreatorProfileInputData;
  id: Scalars['String'];
};

export type UpdateCreatorProfileInputData = {
  address?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['DateTime']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  isTrackingInsights?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCreatorTrackingTopicInput = {
  data: UpdateCreatorTrackingTopicInputData;
  id: Scalars['String'];
};

export type UpdateCreatorTrackingTopicInputData = {
  communicationStrategy?: InputMaybe<Scalars['String']>;
  generatedPrompt?: InputMaybe<Scalars['String']>;
  minimumProcessingRules?: InputMaybe<Array<RuleInputData>>;
  name?: InputMaybe<Scalars['String']>;
  parsingSettings?: InputMaybe<ParsingSettingsInputData>;
  prioritizationInfo?: InputMaybe<Scalars['String']>;
  topicContentStrategy?: InputMaybe<Scalars['String']>;
  topicDescription?: InputMaybe<Scalars['String']>;
};

export type UpdateCreatorTrackingTopicStatusInput = {
  creatorProfileId: Scalars['String'];
  topicTrackingStatuses: Array<TopicTrackingStatusInput>;
};

export type UpdateEngagementTopicInput = {
  brandId: Scalars['String'];
  data: UpdateEngagementTopicInputData;
  id: Scalars['String'];
};

export type UpdateEngagementTopicInputData = {
  communicationStrategy?: InputMaybe<Scalars['String']>;
  generatedPrompt?: InputMaybe<Scalars['String']>;
  minimumProcessingRules?: InputMaybe<Array<RuleInputData>>;
  name?: InputMaybe<Scalars['String']>;
  parsingSettings?: InputMaybe<ParsingSettingsInputData>;
  prioritizationInfo?: InputMaybe<Scalars['String']>;
  topicContentStrategy?: InputMaybe<Scalars['String']>;
  topicDescription?: InputMaybe<Scalars['String']>;
};

export type UpdateNestedCollectionPostPermissionsInput = {
  collectionId: Scalars['String'];
  nestedEntities: Array<NestedEntities>;
  permissions: PermissionInput;
};

export type UpdateNotificationSettingInput = {
  data: UpdateNotificationSettingInputData;
  notificationSettingId: Scalars['String'];
};

export type UpdateNotificationSettingInputData = {
  email?: InputMaybe<Scalars['Boolean']>;
  inbox?: InputMaybe<Scalars['Boolean']>;
  mobilePush?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationInput = {
  data: UpdateOrganizationInputData;
  organizationId: Scalars['String'];
};

export type UpdateOrganizationInputData = {
  fileStorageUsedInMb?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationSettingsInput = {
  data: UpdateOrganizationSettingsInputData;
  organizationId: Scalars['String'];
};

export type UpdateOrganizationSettingsInputData = {
  restrictedAccessForUser?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationUserAccessRequestInput = {
  input: UpdateOrganizationUserAccessRequestInputData;
  requestId: Scalars['String'];
};

export type UpdateOrganizationUserAccessRequestInputData = {
  internalUserRole: InternalOrganizationRole;
};

export type UpdateOrganizationUserRoleInput = {
  externalRole?: InputMaybe<ExternalOrganizationRole>;
  role?: InputMaybe<InternalOrganizationRole>;
  slBrandIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
};

export type UpdatePostInput = {
  data: UpdatePostInputData;
  postId: Scalars['String'];
};

export type UpdatePostInputData = {
  body?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<PostCreationSource>;
  taskId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePostPermissionToCollectionPermissionInput = {
  collectionId: Scalars['String'];
  postIds: Array<Scalars['String']>;
};

export type UpdatePostPermissionsInputDataV2 = {
  generalPermission?: InputMaybe<UpdatePostsGeneralPermissionInput>;
  inviteMembers?: InputMaybe<InvitePostMembersInput>;
  removeMembers?: InputMaybe<RemovePostMembersInput>;
  sendNotification?: Scalars['Boolean'];
};

export type UpdatePostPermissionsInputV2 = {
  input: UpdatePostPermissionsInputDataV2;
};

export type UpdatePostsGeneralPermissionInput = {
  generalPermission: GeneralPermission;
  permissionLevel?: InputMaybe<PermissionLevel>;
  postIds: Array<Scalars['String']>;
};

export type UpdateRadarEventActivityData = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  createdForCreatorProfileIds?: InputMaybe<Array<Scalars['String']>>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  direction?: InputMaybe<RadarEventActivityDirection>;
  radarEventActivityCommunicationChannelIds?: InputMaybe<Array<Scalars['String']>>;
  radarEventIds?: InputMaybe<Array<Scalars['String']>>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateRadarEventActivityInput = {
  data: UpdateRadarEventActivityData;
  id: Scalars['String'];
};

export type UpdateSavedConfigInput = {
  config?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSentimentSubjectData = {
  status?: InputMaybe<SentimentSubjectStatus>;
  subject?: InputMaybe<Scalars['String']>;
};

export type UpdateSentimentSubjectInput = {
  data: UpdateSentimentSubjectData;
  sentimentSubjectId: Scalars['String'];
};

export type UpdateSignalCategoryOptionInput = {
  data: UpdateSignalCategoryOptionInputData;
  signalCategoryOptionId: Scalars['String'];
};

export type UpdateSignalCategoryOptionInputData = {
  label: Scalars['String'];
};

export type UpdateSignalDefinitionInput = {
  data: UpdateSignalDefinitionInputData;
  signalDefinitionId: Scalars['String'];
};

export type UpdateSignalDefinitionInputData = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSocialListeningHourUsageThresholdAlertInput = {
  data: UpdateSocialListeningHourUsageThresholdAlertInputData;
};

export type UpdateSocialListeningHourUsageThresholdAlertInputData = {
  dialogAlertThresholdPercentage?: InputMaybe<Scalars['Int']>;
  emailAlertThresholdPercentage?: InputMaybe<Scalars['Int']>;
};

export type UpdateSocialPostNotificationConfigInput = {
  data: UpdateSocialPostNotificationConfigInputData;
  id: Scalars['String'];
};

export type UpdateSocialPostNotificationConfigInputData = {
  creatorFollowingEnabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  followersScale?: InputMaybe<Array<FollowersScale>>;
  /** Minimum score to trigger notification. Range: 0-1. Default is 0.5. */
  minimumScore?: InputMaybe<Scalars['Float']>;
  minimumScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  sentiments?: InputMaybe<Array<DetailedSentiment>>;
  sentimentsEnabled?: InputMaybe<Scalars['Boolean']>;
  topicId?: InputMaybe<Scalars['String']>;
};

export type UpdateTaskInput = {
  data: UpdateTaskInputData;
  taskId: Scalars['String'];
};

export type UpdateTaskInputData = {
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  memberIds?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  parentTaskId?: InputMaybe<Scalars['String']>;
  postIds?: InputMaybe<Array<Scalars['String']>>;
  priority?: InputMaybe<TaskPriority>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<TaskStatus>;
};

export type UpdateTopicInput = {
  data: UpdateTopicInputData;
  topicId: Scalars['String'];
};

export type UpdateTopicInputData = {
  communicationStrategy?: InputMaybe<Scalars['String']>;
  generatedPrompt?: InputMaybe<Scalars['String']>;
  minimumProcessingRules?: InputMaybe<Array<RuleInputData>>;
  name?: InputMaybe<Scalars['String']>;
  parsingSettings?: InputMaybe<ParsingSettingsInputData>;
  prioritizationInfo?: InputMaybe<Scalars['String']>;
  topicContentStrategy?: InputMaybe<Scalars['String']>;
  topicDescription?: InputMaybe<Scalars['String']>;
};

export type UpdateTrackingInsightsForCreatorProfileByCreatorIdInput = {
  brandId: Scalars['String'];
  creatorHandle: Scalars['String'];
  creatorPlatform: Platform;
  creatorPlatformId: Scalars['String'];
  isTrackingInsights: Scalars['Boolean'];
};

export type UpdateUserOnboardingInput = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  onboardingAnswers?: InputMaybe<OnboardingAnswersInput>;
  organizationName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateUserOnboardingStateInput = {
  onboardingState: OnboardingStateInput;
};

export type UpdateUserPersonalSettingsInput = {
  collectionGeneralPermissionDefault?: InputMaybe<GeneralPermission>;
  collectionGeneralPermissionDefaultPermissionLevel?: InputMaybe<PermissionLevel>;
  postGeneralPermissionDefault?: InputMaybe<GeneralPermission>;
  postGeneralPermissionDefaultPermissionLevel?: InputMaybe<PermissionLevel>;
};

export type UpdateUserProfileInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type UpgradeDuringTrialInput = {
  couponId: Scalars['String'];
  numberOfMembers: Scalars['Int'];
  paymentMethodId: Scalars['String'];
  priceId: Scalars['String'];
};

export type UploadSecureToken = {
  __typename?: 'UploadSecureToken';
  secureExpire: Scalars['String'];
  secureSignature: Scalars['String'];
};

export type UpsertSentimentSubjectInput = {
  subjects: Array<Scalars['String']>;
  topicId: Scalars['String'];
};

/** User Cohorts */
export enum UserCohorts {
  UserJoinedAfterCjb = 'UserJoinedAfterCJB'
}

export type UserFilterInput = {
  data: Array<UserFilterInputData>;
};

export type UserFilterInputData = {
  type?: InputMaybe<UserFilterType>;
  userId: Scalars['String'];
};

/** User Filter Type */
export enum UserFilterType {
  CreatedBy = 'CreatedBy',
  SharedBy = 'SharedBy'
}

export type UserProfileModel = {
  __typename?: 'UserProfileModel';
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  externalRole?: Maybe<ExternalOrganizationRole>;
  fields?: Maybe<Array<Scalars['String']>>;
  firstName: Scalars['String'];
  hasBeenApprovedByAdmin?: Maybe<Scalars['Boolean']>;
  hasSignedUp?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDisabled?: Maybe<Scalars['Boolean']>;
  isInvitedBy?: Maybe<UserProfileModel>;
  isInvitedByUserId?: Maybe<Scalars['String']>;
  isPending?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organization: OrganizationProfileModel;
  permittedCollectionCount: Scalars['Int'];
  permittedPostCount: Scalars['Int'];
  role?: Maybe<InternalOrganizationRole>;
  shouldBeCountedTowardPaywall?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UserReactionModel = {
  __typename?: 'UserReactionModel';
  commentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emoji: Scalars['String'];
  id: Scalars['ID'];
  requestResponseId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserProfileModel;
  userId: Scalars['String'];
};

export type VerifyOtpInput = {
  code: Scalars['String'];
  onboardingType?: InputMaybe<OnboardingType>;
  phoneNumber: Scalars['String'];
  preference: OtpPreference;
};

export type VideoHighlight = {
  __typename?: 'VideoHighlight';
  end: Scalars['Float'];
  highlightSummary?: Maybe<Scalars['String']>;
  start: Scalars['Float'];
};

export type VideoInfo = {
  __typename?: 'VideoInfo';
  duration: Scalars['Int'];
  format: Scalars['String'];
  video: VideoMetaData;
};

export type VideoInfoInput = {
  duration: Scalars['Int'];
  format: Scalars['String'];
  video: VideoMetaDataInput;
};

export type VideoMetaData = {
  __typename?: 'VideoMetaData';
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type VideoMetaDataInput = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type ViewEntitiesInput = {
  entityIds: Array<Scalars['String']>;
  entityType: ViewEntityType;
};

export type ViewEntityInput = {
  entityId: Scalars['String'];
  entityType: ViewEntityType;
};

/** View entity type */
export enum ViewEntityType {
  BrandAnalytics = 'BrandAnalytics',
  BrandCommunityHub = 'BrandCommunityHub',
  BrandCompetitorAnalytics = 'BrandCompetitorAnalytics',
  Collection = 'Collection',
  Competitor = 'Competitor',
  ContentIdea = 'ContentIdea',
  Post = 'Post',
  SocialListeningEngagement = 'SocialListeningEngagement',
  SuggestedPostSection = 'SuggestedPostSection',
  Task = 'Task',
  TrendingPostSection = 'TrendingPostSection'
}

export type WeeklySnapshotSummaryResponse = {
  __typename?: 'WeeklySnapshotSummaryResponse';
  count: Scalars['Int'];
  percentageChange: Scalars['Float'];
  previousCount: Scalars['Int'];
};

export type UserProfileFragmentAnnotationFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null };

export type PostAnnotationFragmentAnnotationFragment = { __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> };

export type UserFragmentAvatarGroupFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null };

export type UrlMetadataFragmentIframelyFragment = { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null };

export type UserReactionFragmentReactionListFragment = { __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type UserFragmentSubscribersFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null };

export type SearchResultFragmentRichTextFragment = { __typename?: 'SearchResults', taskSearchHits: Array<{ __typename?: 'TaskSearchHit', taskModel: { __typename?: 'TaskModel', id: string, name: string, description: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }, headline: Array<{ __typename?: 'Headline', column: string, headline: string }> }>, userSearchHits: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, postSearchHits: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> }> };

export type BrandFragmentForFrequentlyVisitedPagesFragment = { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> };

export type ActivityFragmentForFrequentlyVisitedPagesFragment = { __typename?: 'ActivityModel', id: string, entity: ActivityEntity, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null };

export type GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery = { __typename?: 'Query', frequentlyViewedEntities: Array<{ __typename?: 'ActivityModel', id: string, entity: ActivityEntity, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null }> };

export type GetNotificationUnreadCountForNotificationsSidebarLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationUnreadCountForNotificationsSidebarLinkQuery = { __typename?: 'Query', unreadNotificationsV2: number };

export type UpdateOrganizationForOrganizationLayoutNameSectionMutationVariables = Exact<{
  data: UpdateOrganizationInput;
}>;


export type UpdateOrganizationForOrganizationLayoutNameSectionMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'OrganizationModel', id: string, name: string } };

export type GetNotificationUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationUnreadCountQuery = { __typename?: 'Query', unreadNotificationsV2: number };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename?: 'Query', featureFlags: Array<{ __typename?: 'FeatureFlagModel', id: string, name: PlotFeature, enabled: boolean, organizationId?: string | null, updatedAt: any, createdAt: any }> };

export type AppLevelFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppLevelFeatureFlagsQuery = { __typename?: 'Query', appLevelFeatureFlags: Array<{ __typename?: 'FeatureFlagModel', id: string, name: PlotFeature, enabled: boolean, organizationId?: string | null, updatedAt: any, createdAt: any }> };

export type FeatureFlagFragmentFeatureFlagsContextFragment = { __typename?: 'FeatureFlagModel', id: string, name: PlotFeature, enabled: boolean, organizationId?: string | null, updatedAt: any, createdAt: any };

export type CreateCollectionForCollectionCommandMutationVariables = Exact<{
  data: CreateCollectionInput;
}>;


export type CreateCollectionForCollectionCommandMutation = { __typename?: 'Mutation', createCollection: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } };

export type GetCollectionForCreateCollectionDialogHandlerQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForCreateCollectionDialogHandlerQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string } };

export type CollectionFragmentCollectionCommandFragment = { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> };

export type PostFragmentCollectionCommandFragment = { __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type CreateContentIdeaForCreateContentIdeaHandlerMutationVariables = Exact<{
  data: CreateContentIdeaInput;
}>;


export type CreateContentIdeaForCreateContentIdeaHandlerMutation = { __typename?: 'Mutation', createContentIdea: { __typename?: 'ContentIdeaModel', id: string } };

export type ProcessPostsAfterCreationForPostAfterCreationHandlerMutationVariables = Exact<{
  data: ProcessPostsAfterCreationInput;
}>;


export type ProcessPostsAfterCreationForPostAfterCreationHandlerMutation = { __typename?: 'Mutation', processPostsAfterCreation: Array<{ __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> }> };

export type DeletePostForPostAfterCreationHandlerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePostForPostAfterCreationHandlerMutation = { __typename?: 'Mutation', deletePost: { __typename?: 'Result', message: string, success: boolean } };

export type GetCollectionForPostUploadFilesHandlerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionForPostUploadFilesHandlerQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, organizationId: string } };

export type CreateLinkPostForPostCommandMutationVariables = Exact<{
  data: CreateLinkPostInput;
}>;


export type CreateLinkPostForPostCommandMutation = { __typename?: 'Mutation', createLinkPost: { __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } };

export type CreateFilePostForPostCommandMutationVariables = Exact<{
  data: CreateFilePostInput;
}>;


export type CreateFilePostForPostCommandMutation = { __typename?: 'Mutation', createFilePost: { __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } };

export type CreateNotePostForPostCommandMutationVariables = Exact<{
  data: CreateNotePostInput;
}>;


export type CreateNotePostForPostCommandMutation = { __typename?: 'Mutation', createNotePost: { __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } };

export type PostFragmentPostCommandFragment = { __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type UniversalSearchFragmentSearchHandlerFragment = { __typename?: 'UniversalSearchResults', noteSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, title?: string | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> } }> }, linkSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> } }> }, attachmentSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> }, taskSearchResult: { __typename?: 'TaskSearchResult', totalCount: number, hits: Array<{ __typename?: 'TaskSearchHitV2', score: number, type: SearchHitType, item: { __typename?: 'TaskModel', id: string, name: string, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null } }> }, collectionSearchResult: { __typename?: 'CollectionSearchResult', totalCount: number, hits: Array<{ __typename?: 'CollectionSearchHit', score: number, type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } }> } };

export type GlobalSearchResultsQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type GlobalSearchResultsQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', noteSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, title?: string | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> } }> }, linkSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> } }> }, attachmentSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> }, taskSearchResult: { __typename?: 'TaskSearchResult', totalCount: number, hits: Array<{ __typename?: 'TaskSearchHitV2', score: number, type: SearchHitType, item: { __typename?: 'TaskModel', id: string, name: string, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null } }> }, collectionSearchResult: { __typename?: 'CollectionSearchResult', totalCount: number, hits: Array<{ __typename?: 'CollectionSearchHit', score: number, type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } }> } } };

export type GetAllRecentSearchesClickedQueryQueryVariables = Exact<{
  searchableEntityTypes: Array<SearchableEntityType> | SearchableEntityType;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllRecentSearchesClickedQueryQuery = { __typename?: 'Query', getSearchesClicked: { __typename?: 'PaginatedSearchClickedResult', data: Array<{ __typename?: 'SearchClickedResultModel', updatedAt: any, task?: { __typename?: 'TaskModel', id: string, name: string, description: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } | null, user?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null, post?: { __typename?: 'PostModel', title?: string | null, id: string, body?: string | null, type: PostType, urlMetadata: Array<{ __typename?: 'URLMetadataModel', createdAt: any, id: string, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', createdAt: any, id: string, name: string, updatedAt: any, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null, size?: number | null, imageInfo?: { __typename?: 'ImageInfo', height: number, orientation?: number | null, width: number } | null, videoInfo?: { __typename?: 'VideoInfo', duration: number, format: string, video: { __typename?: 'VideoMetaData', height: number, width: number } } | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null }> } };

export type UserProfileFragmentAssigneeListFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null };

export type TaskFragmentCreateSubtaskFragment = { __typename?: 'TaskModel', id: string, name: string, startDate?: any | null, endDate?: any | null, status: TaskStatus, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type TaskFragmentCreateNewTaskFragment = { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, endDate?: any | null, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null }> };

export type CreateTaskForCreateTaskModalMutationVariables = Exact<{
  data: CreateTaskInput;
}>;


export type CreateTaskForCreateTaskModalMutation = { __typename?: 'Mutation', createTask: { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, endDate?: any | null, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null }> } };

export type TaskFragmentCreateTaskModalFragment = { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, endDate?: any | null, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null }> };

export type GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery = { __typename?: 'Query', myPendingOrganizationAccessRequestsForAdmin: Array<{ __typename?: 'OrganizationUserAccessRequestModel', id: string, user: { __typename?: 'UserProfileModel', id: string, email: string } }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, createdAt: any, email: string, firstName: string, lastName: string, phoneNumber?: string | null, avatarUrl?: string | null, fields?: Array<string> | null, role: InternalOrganizationRole, title: string, cohorts: Array<UserCohorts>, hasBeenApprovedByAdmin: boolean, registrationMethod: Array<RegistrationMethod>, hasVerifiedEmail: boolean, emailVerificationToken?: string | null, taskCreatedCount: number, postCreatedCount: number, plan: string, logoutUrl?: string | null, onboardingState?: { __typename?: 'OnboardingStateData', haveSeenJuiceBoxIntro?: boolean | null, haveClickedJuiceBoxBtn?: boolean | null, haveOnboardedAiOrganize?: boolean | null, haveSeenTrialWrapped?: boolean | null, hasSeenContentCalendarIntroduction?: boolean | null, hasSeenContentCalendarOnboarding?: boolean | null, hasSeenSLCommunityIntroduction?: boolean | null } | null, socialListeningBrands: Array<{ __typename?: 'BrandModel', id: string, name: string, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, competitorAnalysisEnabled: boolean, organizationId?: string | null, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null }>, inviteMembers: Array<{ __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> }>, onboardingAnswers?: { __typename?: 'OnboardingAnswersData', referralSource?: string | null } | null, organization: { __typename?: 'OrganizationModel', id: string, name: string, domain: string, myPermissions: Array<OrganizationPermission>, type?: OrganizationType | null, socialListeningBrands: Array<{ __typename?: 'BrandModel', id: string, name: string }>, settings: { __typename?: 'OrganizationSettings', restrictedAccessForUser: boolean }, users: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, title: string, fields?: Array<string> | null, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, createdAt: any, isDisabled?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } }>, externalUsers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, title: string, fields?: Array<string> | null, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, createdAt: any, isDisabled?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } }>, billing: { __typename?: 'OrganizationBillingModel', id: string, organizationId: string, billingCustomerId?: string | null, aiFeaturesEnabled?: boolean | null, socialListeningEnabled?: boolean | null, requestedAdminToUpgradePlans?: Array<BillingPlanName> | null, customTrendsEnabled?: boolean | null, brandHoursParseLimit?: number | null, hasReachedBrandUsageLimit: boolean, hasUsedFreeTrial?: boolean | null, collectionUsageCount: number, collectionUsageLimit?: number | null, fileDeliveryLimitInMb?: number | null, plan: BillingPlanName, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel, organizationMemberUsage: number, organizationMemberLimit?: number | null, trendsEnabled?: boolean | null, hasSeenNewPricing: boolean, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number, socialListeningHourUsageThresholdAlert: { __typename?: 'SocialListeningHourUsageThresholdAlert', emailAlertThresholdPercentage: number, dialogAlertThresholdPercentage: number }, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null, currentPeriodEnd?: number | null, upcomingInvoice?: { __typename?: 'BillingSubscriptionUpcomingInvoice', periodEnd: number, amountDue: number } | null } | null }, socialAuthors: Array<{ __typename?: 'SocialAuthorModel', id: string, name: string, profileUrl?: string | null, avatarUrl?: string | null, platform: Platform, platformHandle?: string | null }> }, joinedOrganizations: Array<{ __typename?: 'OrganizationProfileModel', id: string, name: string, internalRole?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, billing: { __typename?: 'OrganizationBillingModel', id: string, organizationId: string, billingCustomerId?: string | null, aiFeaturesEnabled?: boolean | null, socialListeningEnabled?: boolean | null, requestedAdminToUpgradePlans?: Array<BillingPlanName> | null, customTrendsEnabled?: boolean | null, brandHoursParseLimit?: number | null, hasReachedBrandUsageLimit: boolean, hasUsedFreeTrial?: boolean | null, collectionUsageCount: number, collectionUsageLimit?: number | null, fileDeliveryLimitInMb?: number | null, plan: BillingPlanName, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel, organizationMemberUsage: number, organizationMemberLimit?: number | null, trendsEnabled?: boolean | null, hasSeenNewPricing: boolean, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number, socialListeningHourUsageThresholdAlert: { __typename?: 'SocialListeningHourUsageThresholdAlert', emailAlertThresholdPercentage: number, dialogAlertThresholdPercentage: number }, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null, currentPeriodEnd?: number | null, upcomingInvoice?: { __typename?: 'BillingSubscriptionUpcomingInvoice', periodEnd: number, amountDue: number } | null } | null } }>, uploadToken: { __typename?: 'UploadSecureToken', secureExpire: string, secureSignature: string }, invitedByOrganization?: { __typename?: 'OrganizationProfileModel', id: string, name: string } | null, invitedByUser?: { __typename?: 'UserProfileModel', id: string, email: string } | null, personalSettings?: { __typename?: 'PersonalSettings', postGeneralPermissionDefault?: GeneralPermission | null, postGeneralPermissionDefaultPermissionLevel?: PermissionLevel | null, collectionGeneralPermissionDefault?: GeneralPermission | null, collectionGeneralPermissionDefaultPermissionLevel?: PermissionLevel | null } | null } };

export type RefreshTokenAppMutationVariables = Exact<{
  token: Scalars['JWT'];
}>;


export type RefreshTokenAppMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'TokenModel', accessToken: any, refreshToken: any } };

export type UserProfileFragmentUserContextFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, title: string, fields?: Array<string> | null, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, createdAt: any, isDisabled?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } };

export type OrganizationBillingFragmentUserContextFragment = { __typename?: 'OrganizationBillingModel', id: string, organizationId: string, billingCustomerId?: string | null, aiFeaturesEnabled?: boolean | null, socialListeningEnabled?: boolean | null, requestedAdminToUpgradePlans?: Array<BillingPlanName> | null, customTrendsEnabled?: boolean | null, brandHoursParseLimit?: number | null, hasReachedBrandUsageLimit: boolean, hasUsedFreeTrial?: boolean | null, collectionUsageCount: number, collectionUsageLimit?: number | null, fileDeliveryLimitInMb?: number | null, plan: BillingPlanName, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel, organizationMemberUsage: number, organizationMemberLimit?: number | null, trendsEnabled?: boolean | null, hasSeenNewPricing: boolean, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number, socialListeningHourUsageThresholdAlert: { __typename?: 'SocialListeningHourUsageThresholdAlert', emailAlertThresholdPercentage: number, dialogAlertThresholdPercentage: number }, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null, currentPeriodEnd?: number | null, upcomingInvoice?: { __typename?: 'BillingSubscriptionUpcomingInvoice', periodEnd: number, amountDue: number } | null } | null };

export type SocialAuthorFragmentUserContextFragment = { __typename?: 'SocialAuthorModel', id: string, name: string, profileUrl?: string | null, avatarUrl?: string | null, platform: Platform, platformHandle?: string | null };

export type OrganizationFragmentUserContextFragment = { __typename?: 'OrganizationModel', id: string, name: string, domain: string, myPermissions: Array<OrganizationPermission>, type?: OrganizationType | null, users: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, title: string, fields?: Array<string> | null, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, createdAt: any, isDisabled?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } }>, externalUsers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, title: string, fields?: Array<string> | null, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, createdAt: any, isDisabled?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } }>, billing: { __typename?: 'OrganizationBillingModel', id: string, organizationId: string, billingCustomerId?: string | null, aiFeaturesEnabled?: boolean | null, socialListeningEnabled?: boolean | null, requestedAdminToUpgradePlans?: Array<BillingPlanName> | null, customTrendsEnabled?: boolean | null, brandHoursParseLimit?: number | null, hasReachedBrandUsageLimit: boolean, hasUsedFreeTrial?: boolean | null, collectionUsageCount: number, collectionUsageLimit?: number | null, fileDeliveryLimitInMb?: number | null, plan: BillingPlanName, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel, organizationMemberUsage: number, organizationMemberLimit?: number | null, trendsEnabled?: boolean | null, hasSeenNewPricing: boolean, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number, socialListeningHourUsageThresholdAlert: { __typename?: 'SocialListeningHourUsageThresholdAlert', emailAlertThresholdPercentage: number, dialogAlertThresholdPercentage: number }, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null, currentPeriodEnd?: number | null, upcomingInvoice?: { __typename?: 'BillingSubscriptionUpcomingInvoice', periodEnd: number, amountDue: number } | null } | null }, socialAuthors: Array<{ __typename?: 'SocialAuthorModel', id: string, name: string, profileUrl?: string | null, avatarUrl?: string | null, platform: Platform, platformHandle?: string | null }> };

export type MeFragmentUserQueriesFragment = { __typename?: 'MeModel', id: string, createdAt: any, email: string, firstName: string, lastName: string, phoneNumber?: string | null, avatarUrl?: string | null, fields?: Array<string> | null, role: InternalOrganizationRole, title: string, cohorts: Array<UserCohorts>, hasBeenApprovedByAdmin: boolean, registrationMethod: Array<RegistrationMethod>, hasVerifiedEmail: boolean, emailVerificationToken?: string | null, taskCreatedCount: number, postCreatedCount: number, plan: string, logoutUrl?: string | null, onboardingState?: { __typename?: 'OnboardingStateData', haveSeenJuiceBoxIntro?: boolean | null, haveClickedJuiceBoxBtn?: boolean | null, haveOnboardedAiOrganize?: boolean | null, haveSeenTrialWrapped?: boolean | null, hasSeenContentCalendarIntroduction?: boolean | null, hasSeenContentCalendarOnboarding?: boolean | null, hasSeenSLCommunityIntroduction?: boolean | null } | null, socialListeningBrands: Array<{ __typename?: 'BrandModel', id: string, name: string, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, competitorAnalysisEnabled: boolean, organizationId?: string | null, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null }>, inviteMembers: Array<{ __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> }>, onboardingAnswers?: { __typename?: 'OnboardingAnswersData', referralSource?: string | null } | null, organization: { __typename?: 'OrganizationModel', id: string, name: string, domain: string, myPermissions: Array<OrganizationPermission>, type?: OrganizationType | null, socialListeningBrands: Array<{ __typename?: 'BrandModel', id: string, name: string }>, settings: { __typename?: 'OrganizationSettings', restrictedAccessForUser: boolean }, users: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, title: string, fields?: Array<string> | null, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, createdAt: any, isDisabled?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } }>, externalUsers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, title: string, fields?: Array<string> | null, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, createdAt: any, isDisabled?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } }>, billing: { __typename?: 'OrganizationBillingModel', id: string, organizationId: string, billingCustomerId?: string | null, aiFeaturesEnabled?: boolean | null, socialListeningEnabled?: boolean | null, requestedAdminToUpgradePlans?: Array<BillingPlanName> | null, customTrendsEnabled?: boolean | null, brandHoursParseLimit?: number | null, hasReachedBrandUsageLimit: boolean, hasUsedFreeTrial?: boolean | null, collectionUsageCount: number, collectionUsageLimit?: number | null, fileDeliveryLimitInMb?: number | null, plan: BillingPlanName, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel, organizationMemberUsage: number, organizationMemberLimit?: number | null, trendsEnabled?: boolean | null, hasSeenNewPricing: boolean, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number, socialListeningHourUsageThresholdAlert: { __typename?: 'SocialListeningHourUsageThresholdAlert', emailAlertThresholdPercentage: number, dialogAlertThresholdPercentage: number }, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null, currentPeriodEnd?: number | null, upcomingInvoice?: { __typename?: 'BillingSubscriptionUpcomingInvoice', periodEnd: number, amountDue: number } | null } | null }, socialAuthors: Array<{ __typename?: 'SocialAuthorModel', id: string, name: string, profileUrl?: string | null, avatarUrl?: string | null, platform: Platform, platformHandle?: string | null }> }, joinedOrganizations: Array<{ __typename?: 'OrganizationProfileModel', id: string, name: string, internalRole?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, billing: { __typename?: 'OrganizationBillingModel', id: string, organizationId: string, billingCustomerId?: string | null, aiFeaturesEnabled?: boolean | null, socialListeningEnabled?: boolean | null, requestedAdminToUpgradePlans?: Array<BillingPlanName> | null, customTrendsEnabled?: boolean | null, brandHoursParseLimit?: number | null, hasReachedBrandUsageLimit: boolean, hasUsedFreeTrial?: boolean | null, collectionUsageCount: number, collectionUsageLimit?: number | null, fileDeliveryLimitInMb?: number | null, plan: BillingPlanName, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel, organizationMemberUsage: number, organizationMemberLimit?: number | null, trendsEnabled?: boolean | null, hasSeenNewPricing: boolean, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number, socialListeningHourUsageThresholdAlert: { __typename?: 'SocialListeningHourUsageThresholdAlert', emailAlertThresholdPercentage: number, dialogAlertThresholdPercentage: number }, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null, currentPeriodEnd?: number | null, upcomingInvoice?: { __typename?: 'BillingSubscriptionUpcomingInvoice', periodEnd: number, amountDue: number } | null } | null } }>, uploadToken: { __typename?: 'UploadSecureToken', secureExpire: string, secureSignature: string }, invitedByOrganization?: { __typename?: 'OrganizationProfileModel', id: string, name: string } | null, invitedByUser?: { __typename?: 'UserProfileModel', id: string, email: string } | null, personalSettings?: { __typename?: 'PersonalSettings', postGeneralPermissionDefault?: GeneralPermission | null, postGeneralPermissionDefaultPermissionLevel?: PermissionLevel | null, collectionGeneralPermissionDefault?: GeneralPermission | null, collectionGeneralPermissionDefaultPermissionLevel?: PermissionLevel | null } | null };

export type AuthFragmentUserContextFragment = { __typename?: 'AuthModel', accessToken: any, refreshToken: any, isSignUp?: boolean | null, user: { __typename?: 'MeModel', id: string, role: InternalOrganizationRole } };

export type UserFragmentAccessRequestAdminListFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null };

export type OrganizationUserAccessRequestFragmentAccessRequestHandlersFragment = { __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', id: string, hasBeenApprovedByAdmin?: boolean | null } };

export type CreateOrganizationAccessRequestMutationVariables = Exact<{
  data: CreateOrganizationUserAccessRequestInput;
}>;


export type CreateOrganizationAccessRequestMutation = { __typename?: 'Mutation', createOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, createdAt: any, updatedAt: any } };

export type GetMyOrganizationAccessRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationAccessRequestsQuery = { __typename?: 'Query', myOrganizationAccessRequests: Array<{ __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, createdAt: any, updatedAt: any }> };

export type ApproveOrganizationAccessRequestMutationVariables = Exact<{
  data: ApproveOrganizationUserAccessRequestInput;
}>;


export type ApproveOrganizationAccessRequestMutation = { __typename?: 'Mutation', approveOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', id: string, hasBeenApprovedByAdmin?: boolean | null } } };

export type ApproveOrganizationAccessRequestForEnterpriseOrgMutationVariables = Exact<{
  data: ApproveOrganizationUserAccessRequestWithRoleInput;
}>;


export type ApproveOrganizationAccessRequestForEnterpriseOrgMutation = { __typename?: 'Mutation', approveOrganizationAccessRequestForEnterpriseOrg: { __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', id: string, hasBeenApprovedByAdmin?: boolean | null } } };

export type ApproveOrganizationAccessRequestsMutationVariables = Exact<{
  data: ApproveOrganizationUserAccessRequestsInput;
}>;


export type ApproveOrganizationAccessRequestsMutation = { __typename?: 'Mutation', approveOrganizationAccessRequests: Array<{ __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', id: string, hasBeenApprovedByAdmin?: boolean | null } }> };

export type RejectOrganizationAccessRequestMutationVariables = Exact<{
  data: RejectOrganizationUserAccessRequestInput;
}>;


export type RejectOrganizationAccessRequestMutation = { __typename?: 'Mutation', rejectOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', id: string, hasBeenApprovedByAdmin?: boolean | null } } };

export type OrganizationFragmentAccessRequestCreateViewFragment = { __typename?: 'OrganizationModel', id: string, name: string, users: Array<{ __typename?: 'UserProfileModel', role?: InternalOrganizationRole | null, hasBeenApprovedByAdmin?: boolean | null, id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type PostFragmentAiOrganizeSelectedCollectionListFragment = { __typename?: 'PostModel', id: string };

export type CollectionFragmentAiOrganizeCollectionListFragment = { __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null, childCollections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null, name: string, generalPermission: GeneralPermission, organizationName: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null }> };

export type GetCollectionByIdsForAiOrganizeCollectionListQueryVariables = Exact<{
  input: GetCollectionByIdsInput;
}>;


export type GetCollectionByIdsForAiOrganizeCollectionListQuery = { __typename?: 'Query', collectionByIds: Array<{ __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null, childCollections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null, name: string, generalPermission: GeneralPermission, organizationName: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null }> }> };

export type PostFragmentAiOrganizeNoteCardViewFragment = { __typename?: 'PostModel', id: string, body?: string | null, myPermissions: Array<PostPermission>, title?: string | null, color: string };

export type PostFragmentAiOrganizePostCardViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type PostFragmentAiOrganizeSwiperViewFragment = { __typename?: 'PostModel', id: string, type: PostType, permissionLevel: PermissionLevel, generalPermission: GeneralPermission, title?: string | null, body?: string | null, myPermissions: Array<PostPermission>, color: string, updatedAt: any, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationVariables = Exact<{
  data: UpdateUserOnboardingStateInput;
}>;


export type UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation = { __typename?: 'Mutation', updateUserOnboardingState: { __typename?: 'MeModel', id: string, onboardingState?: { __typename?: 'OnboardingStateData', haveOnboardedAiOrganize?: boolean | null } | null } };

export type AttachmentFragmentAttachmentNameFragment = { __typename?: 'AttachmentModel', id: string, name: string };

export type AttachmentFragmentAttachmentPreviewFragment = { __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } };

export type OrganizationBillingFragmentAiOrganizePaywallFragment = { __typename?: 'OrganizationBillingModel', id: string, hasUsedFreeTrial?: boolean | null, aiFeaturesEnabled?: boolean | null };

export type PostFragmentBillingAiOrganizePaywallFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type GetSuggestedPostsForBillingAiOrganizePaywallQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuggestedPostsForBillingAiOrganizePaywallQuery = { __typename?: 'Query', suggestedPostsForUser: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type OrganizationBillingFragmentCollectionPaywallFragment = { __typename?: 'OrganizationBillingModel', id: string, hasUsedFreeTrial?: boolean | null, collectionUsageCount: number, collectionUsageLimit?: number | null };

export type OrganizationBillingFragmentFileDeliveryFragment = { __typename?: 'OrganizationBillingModel', id: string, fileDeliveryLimitInMb?: number | null, hasUsedFreeTrial?: boolean | null };

export type OrganizationBillingFragmentFileStorageLimitProgressFragment = { __typename?: 'OrganizationBillingModel', id: string, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number };

export type SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationVariables = Exact<{ [key: string]: never; }>;


export type SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation = { __typename?: 'Mutation', setHasSeenFreeTrialEnded: { __typename?: 'OrganizationBillingModel', id: string } };

export type OrganizationBillingFragmentFreeTrialFragment = { __typename?: 'OrganizationBillingModel', id: string, plan: BillingPlanName, hasUsedFreeTrial?: boolean | null, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null } | null };

export type OrganizationBillingFragmentGuestPaywallFragment = { __typename?: 'OrganizationBillingModel', id: string, hasUsedFreeTrial?: boolean | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel };

export type GetBrandsParsedHoursForBillingHourUsageProgressQueryVariables = Exact<{
  totalHoursParsedData?: InputMaybe<BrandHoursParsedInput>;
}>;


export type GetBrandsParsedHoursForBillingHourUsageProgressQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, organization: { __typename?: 'OrganizationModel', id: string, billing: { __typename?: 'OrganizationBillingModel', id: string, brandHoursParseLimit?: number | null }, socialListeningBrands: Array<{ __typename?: 'BrandModel', id: string, name: string, totalHoursParsedCount: number }> } } };

export type DowngradeToFreePlanForNewPricingMutationVariables = Exact<{ [key: string]: never; }>;


export type DowngradeToFreePlanForNewPricingMutation = { __typename?: 'Mutation', downgradeToFreePlan: { __typename?: 'OrganizationBillingModel', id: string } };

export type OrganizationBillingFragmentNewPricingFragment = { __typename?: 'OrganizationBillingModel', id: string, plan: BillingPlanName, hasSeenNewPricing: boolean };

export type OrganizationBillingFragmentOrganizationMemberPaywallFragment = { __typename?: 'OrganizationBillingModel', id: string, hasUsedFreeTrial?: boolean | null, organizationMemberUsage: number, organizationMemberLimit?: number | null };

export type GetBillingAvailablePricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingAvailablePricesQuery = { __typename?: 'Query', getAvailablePrices: Array<{ __typename?: 'BillingPlanPrice', name: BillingPlanName, productId?: string | null, prices: Array<{ __typename?: 'BillingPrice', id: string, currency: string, recurringInterval?: string | null, amount?: number | null, unitAmountDecimal?: string | null }> }> };

export type OrganizationBillingFragmentTrendsPaywallFragment = { __typename?: 'OrganizationBillingModel', id: string, hasUsedFreeTrial?: boolean | null, trendsEnabled?: boolean | null };

export type CreateFreeTrialSubscriptionMutationVariables = Exact<{
  planName: Scalars['String'];
}>;


export type CreateFreeTrialSubscriptionMutation = { __typename?: 'Mutation', createFreeTrialSubscription: { __typename?: 'BillingSubscription', id: string } };

export type NotifyAdminForBillingMutationVariables = Exact<{ [key: string]: never; }>;


export type NotifyAdminForBillingMutation = { __typename?: 'Mutation', notifyAdminForBilling: { __typename?: 'Result', success: boolean, message: string } };

export type RequestAdminToUpgradeMutationVariables = Exact<{
  data: RequestAdminToUpgradeInput;
}>;


export type RequestAdminToUpgradeMutation = { __typename?: 'Mutation', requestAdminToUpgrade: { __typename?: 'Result', success: boolean, message: string } };

export type GetBillingPlanQueryVariables = Exact<{
  plan: Scalars['String'];
}>;


export type GetBillingPlanQuery = { __typename?: 'Query', billingPlan: { __typename?: 'BillingPlanModel', name: BillingPlanName, numberOfTrialDays?: number | null, organizationMemberLimit?: number | null } };

export type OrganizationBillingFragmentBannerViewFragment = { __typename?: 'OrganizationBillingModel', plan: BillingPlanName, id: string, hasUsedFreeTrial?: boolean | null, organizationMemberUsage: number, organizationMemberLimit?: number | null, highestFreeTrialUsed?: BillingPlanName | null, hasSeenFreeTrialEnded?: boolean | null, subscription?: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, trialEnd?: number | null } | null };

export type OrganizationBillingFragmentLimitProgressFragment = { __typename?: 'OrganizationBillingModel', id: string, plan: BillingPlanName, hasUsedFreeTrial?: boolean | null, fileStorageLimitInMb?: number | null, fileStorageUsedInMb: number, collectionUsageCount: number, collectionUsageLimit?: number | null, organizationMemberUsage: number, organizationMemberLimit?: number | null, guestUsage: number, guestLimit?: number | null, guestPermission: PermissionLevel, subscription?: { __typename?: 'BillingSubscription', status?: BillingSubscriptionStatus | null, trialEnd?: number | null, currentPeriodEnd?: number | null } | null };

export type BrandFragmentForBookmarkSidebarItemFragment = { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> };

export type BookmarkFragmentForBookmarkSidebarItemFragment = { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null };

export type DeleteBookmarkForBookmarkHandlersMutationVariables = Exact<{
  deleteBookmarkId: Scalars['String'];
}>;


export type DeleteBookmarkForBookmarkHandlersMutation = { __typename?: 'Mutation', deleteBookmark: { __typename?: 'Result', message: string, success: boolean } };

export type BookmarkFragmentForBookmarkHandlersFragment = { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null };

export type GetBookmarksForBookmarkHandlersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookmarksForBookmarkHandlersQuery = { __typename?: 'Query', bookmarks: Array<{ __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null }> };

export type BrandFragmentBrandConnectedCreatorsFragment = { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> };

export type BrandFragmentBrandMoreContextMenuFragment = { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> };

export type BrandFragmentBrandPauseContextMenuFragment = { __typename?: 'BrandModel', id: string, status: BrandStatus, resetOnNextCycle: boolean };

export type PauseBrandForBrandPauseContextMenuMutationVariables = Exact<{
  data: PauseBrandInput;
}>;


export type PauseBrandForBrandPauseContextMenuMutation = { __typename?: 'Mutation', pauseBrand: { __typename?: 'BrandModel', id: string, status: BrandStatus, resetOnNextCycle: boolean } };

export type ResumeBrandForBrandPauseContextMenuMutationVariables = Exact<{
  data: ResumeBrandInput;
}>;


export type ResumeBrandForBrandPauseContextMenuMutation = { __typename?: 'Mutation', resumeBrand: { __typename?: 'BrandModel', id: string, status: BrandStatus, resetOnNextCycle: boolean } };

export type GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryVariables = Exact<{
  filters: AggregatedBrandDurationUsageFilters;
}>;


export type GetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery = { __typename?: 'Query', aggregatedBrandDurationUsage: Array<{ __typename?: 'AggregatedBrandDurationUsageResult', durationUsed: number, totalParsedPostsCount: number, totalPositivelyParsedPostsCount: number, brand: { __typename?: 'BrandModel', id: string, name: string, status: BrandStatus, resetOnNextCycle: boolean, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> }, topics: Array<{ __typename?: 'AggregatedTopicDurationUsageResult', durationUsed: number, totalParsedPostsCount: number, totalPositivelyParsedPostsCount: number, topic: { __typename?: 'TopicModel', id: string, name: string, status: TopicStatus, resetOnNextCycle: boolean, type: ListeningTopicType, isBookmarked: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } }> }> };

export type AggregatedBrandDurationUsageFragmentBrandTableRowFragment = { __typename?: 'AggregatedBrandDurationUsageResult', durationUsed: number, totalParsedPostsCount: number, totalPositivelyParsedPostsCount: number, brand: { __typename?: 'BrandModel', id: string, name: string, status: BrandStatus, resetOnNextCycle: boolean, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> }, topics: Array<{ __typename?: 'AggregatedTopicDurationUsageResult', durationUsed: number, totalParsedPostsCount: number, totalPositivelyParsedPostsCount: number, topic: { __typename?: 'TopicModel', id: string, name: string, status: TopicStatus, resetOnNextCycle: boolean, type: ListeningTopicType, isBookmarked: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } }> };

export type BrandFragmentBrandContentFilterSettingsViewFragment = { __typename?: 'BrandModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null };

export type GetBrandForBrandContentFilterSettingsViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBrandForBrandContentFilterSettingsViewQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null } };

export type UpdateBrandForBrandContentFilterSettingsViewMutationVariables = Exact<{
  data: UpdateBrandInput;
}>;


export type UpdateBrandForBrandContentFilterSettingsViewMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'BrandModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null } };

export type BrandFragmentBrandContentFilterSettingsDialogViewFragment = { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> };

export type BrandFragmentBrandParsingSettingsViewFragment = { __typename?: 'BrandModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null };

export type GetBrandForBrandParsingSettingsViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBrandForBrandParsingSettingsViewQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type UpdateBrandForBrandParsingSettingsViewMutationVariables = Exact<{
  data: UpdateBrandInput;
}>;


export type UpdateBrandForBrandParsingSettingsViewMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'BrandModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type CompetitorFragmentForBrandCompetitorActionContextMenuFragment = { __typename?: 'CompetitorModel', id: string, isBookmarked: boolean };

export type DeleteCompetitorForBrandCompetitorActionContextMenuMutationVariables = Exact<{
  data: RemoveCompetitorsInput;
}>;


export type DeleteCompetitorForBrandCompetitorActionContextMenuMutation = { __typename?: 'Mutation', removeCompetitors: Array<{ __typename?: 'CompetitorModel', id: string }> };

export type GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryVariables = Exact<{
  data: GetCompetitorFlatCreatorGraphDataInput;
}>;


export type GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery = { __typename?: 'Query', getCompetitorFlatCreatorGraphData?: { __typename?: 'CompetitorFlatCreatorBrandMentionsMetrics', totalCount?: number | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', Y: number, X: any }> } | null };

export type CompetitorFragmentBrandCompetitorInfoFragment = { __typename?: 'CompetitorModel', id: string, trackingBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null, handle: string, platform: Platform }> } };

export type GetBrandInboundSocialPostCommentInsightsQueryVariables = Exact<{
  data: BrandInboundFiltersInputForCommentInsights;
  brandId: Scalars['String'];
}>;


export type GetBrandInboundSocialPostCommentInsightsQuery = { __typename?: 'Query', getBrandInboundCommentInsights: { __typename?: 'PaginatedSocialPostComment', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'SocialPostCommentModel', id: string, text: string, enrichedComment?: string | null, commentEngagement: number, categoryName: Array<string>, socialPost: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, engagementRate: number, videoUrl?: string | null, platformCreateTime: any, platformId: string, platform: Platform, expiresAt?: any | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, type: ListeningTopicType, name: string, brandId?: string | null } | null }> | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }, parentSocialPostComment?: { __typename?: 'SocialPostCommentModel', id: string, text: string } | null, organizationSocialPostCommentLabels: Array<{ __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string }> }> } };

export type GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryVariables = Exact<{
  data: GetCompetitorCommentInsightsInput;
  brandId: Scalars['String'];
}>;


export type GetCompetitorCommentInsightsForCompetitorCommentInsightsQuery = { __typename?: 'Query', getCompetitorCommentInsights: { __typename?: 'PaginatedSocialPostComment', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'SocialPostCommentModel', id: string, text: string, enrichedComment?: string | null, commentEngagement: number, categoryName: Array<string>, socialPost: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, engagementRate: number, videoUrl?: string | null, platformCreateTime: any, platformId: string, platform: Platform, expiresAt?: any | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, type: ListeningTopicType, name: string, brandId?: string | null } | null }> | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }, parentSocialPostComment?: { __typename?: 'SocialPostCommentModel', id: string, text: string } | null, organizationSocialPostCommentLabels: Array<{ __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string }> }> } };

export type GetBrandsForCommentInsightsFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandsForCommentInsightsFiltersQuery = { __typename?: 'Query', brands: Array<{ __typename?: 'BrandModel', id: string, topics: Array<{ __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType }> }> };

export type OrganizationSocialPostCommentLabelFragmentCommentInsightsFiltersFragment = { __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string };

export type GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryVariables = Exact<{
  data: OrganizationSocialPostCommentLabelsInput;
}>;


export type GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery = { __typename?: 'Query', organizationSocialPostCommentLabels: { __typename?: 'PaginatedOrganizationSocialPostCommentLabel', data: Array<{ __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string }> } };

export type GetCategoriesForCommentInsightsFiltersQueryVariables = Exact<{
  filters: SocialPostCommentCategoriesForBrandFilters;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCategoriesForCommentInsightsFiltersQuery = { __typename?: 'Query', socialPostCommentCategoriesForBrand: { __typename?: 'PaginatedSocialPostCommentCategoriesForBrand', data: Array<string>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SocialPostCommentFragmentCommentInsightsTableFragment = { __typename?: 'SocialPostCommentModel', id: string, text: string, enrichedComment?: string | null, commentEngagement: number, categoryName: Array<string>, socialPost: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, engagementRate: number, videoUrl?: string | null, platformCreateTime: any, platformId: string, platform: Platform, expiresAt?: any | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, type: ListeningTopicType, name: string, brandId?: string | null } | null }> | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }, parentSocialPostComment?: { __typename?: 'SocialPostCommentModel', id: string, text: string } | null, organizationSocialPostCommentLabels: Array<{ __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string }> };

export type AddLabelsToSocialPostCommentForCommentInsightsTableMutationVariables = Exact<{
  data: AddLabelsToSocialPostCommentInput;
}>;


export type AddLabelsToSocialPostCommentForCommentInsightsTableMutation = { __typename?: 'Mutation', addOrganizationSocialPostCommentLabelsToSocialPostComment: Array<{ __typename?: 'SocialPostCommentModel', id: string }> };

export type RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationVariables = Exact<{
  data: RemoveLabelsFromSocialPostCommentInput;
}>;


export type RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation = { __typename?: 'Mutation', removeOrganizationSocialPostCommentLabelsFromSocialPostComment: Array<{ __typename?: 'SocialPostCommentModel', id: string }> };

export type SocialPostFragmentLinkTableCellFragment = { __typename?: 'SocialPostModel', id: string, platformId: string, platform: Platform, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null };

export type TopicFragmentTopicInfoTableCellFragment = { __typename?: 'TopicModel', id: string, name: string, brandId?: string | null, type: ListeningTopicType };

export type GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryVariables = Exact<{
  data: CompetitorFlatAnalyticFiltersInput;
}>;


export type GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery = { __typename?: 'Query', getCompetitorFlatCreatorDemographics: Array<{ __typename?: 'SocialPostCreatorDemographicModel', id: string, generation: SocialPostGenerationDemographic, gender: SocialPostGenderDemographic }> };

export type GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryVariables = Exact<{
  data: GetCompetitorSentimentInteractionsInput;
  brandId: Scalars['String'];
}>;


export type GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery = { __typename?: 'Query', getCompetitorSentimentInteractions: { __typename?: 'PaginatedCompetitorFlatCreatorSentimentInteractions', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: { __typename?: 'CompetitorFlatCreatorSentimentInteractions', socialPosts?: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, brandClaims: Array<{ __typename?: 'BrandClaimModel', attribute?: string | null, claim: string, id: string }> }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null } | null }> | null, socialPostComments?: Array<{ __typename?: 'SocialPostCommentModel', id: string, text: string, socialPostCommentClaims: Array<{ __typename?: 'SocialPostCommentClaimModel', id: string, claim: string, claimAttribute: string, brandId?: string | null }>, socialPost: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, brandClaims: Array<{ __typename?: 'BrandClaimModel', claim: string, id: string }> }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null } | null } }> | null } } };

export type GetCompetitorSentimentMetricsForCompetitorSentimentQueryVariables = Exact<{
  data: GetCompetitorSentimentMetricsInput;
}>;


export type GetCompetitorSentimentMetricsForCompetitorSentimentQuery = { __typename?: 'Query', getCompetitorSentimentMetrics?: { __typename?: 'CompetitorFlatCreatorSentimentMetrics', claimMetrics: Array<{ __typename?: 'ClaimMetric', attribute: string, numberOfMentions: number }>, sentimentMetrics: { __typename?: 'SentimentMetric', averageCountPerDay: number, totalCount?: number | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> } } | null };

export type ClaimMetricFragmentCompetitorSentimentThemesFragment = { __typename?: 'ClaimMetric', attribute: string, numberOfMentions: number };

export type GetCompetitorFlatCreatorForCompetitorsSummaryQueryVariables = Exact<{
  data: CompetitorFlatCreatorAnalyticFiltersInput;
}>;


export type GetCompetitorFlatCreatorForCompetitorsSummaryQuery = { __typename?: 'Query', competitorFlatCreatorAnalyticSummary: { __typename?: 'CompetitorFlatCreatorSummaryModel', followers: number, totalPosts: number, postsPerWeek: number, totalEngagements: number, totalViewCount: number, averageLikes: number, averageVideoViews: number, averageEngagementRate: number, sentiment: DetailedSentiment } };

export type CreatorFragmentCompetitorTopCreatorsFragment = { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, industry?: string | null, likeCount: number, platformId: string, signature?: string | null, updatedAt: any, videoCount: number };

export type GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryVariables = Exact<{
  data: GetCreatorsThatMentionedCompetitorInput;
}>;


export type GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery = { __typename?: 'Query', getCreatorsThatMentionedCompetitor: { __typename?: 'PaginatedCreator', data: Array<{ __typename?: 'CreatorModel', id: string, numberOfBrandMentions?: number | null, followerCount: number, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followingCount: number, industry?: string | null, likeCount: number, platformId: string, signature?: string | null, updatedAt: any, videoCount: number }> } };

export type BrandFragmentForCompetitorTopCreatorsFragment = { __typename?: 'BrandModel', id: string, name: string };

export type HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtagsFragment = { __typename?: 'HashtagUsedForCompetitorModel', isHidden: boolean, name: string, numberOfTimesUsed?: number | null, averageEngagementRate?: number | null };

export type GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryVariables = Exact<{
  data: GetHashtagUsedByCompetitorInput;
}>;


export type GetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery = { __typename?: 'Query', getHashtagUsedByCompetitor: Array<{ __typename?: 'HashtagUsedForCompetitorModel', isHidden: boolean, name: string, numberOfTimesUsed?: number | null, averageEngagementRate?: number | null }> };

export type HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables = Exact<{
  data: HideHashtagUsedForCreatorInput;
}>;


export type HideHashtagUsedForCreatorForCompetitorTopHashtagsMutation = { __typename?: 'Mutation', hideHashtagUsedForCreator: { __typename?: 'HashtagUsedForCompetitorModel', isHidden: boolean, name: string, numberOfTimesUsed?: number | null, averageEngagementRate?: number | null } };

export type UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables = Exact<{
  data: UnhideHashtagUsedForCreatorInput;
}>;


export type UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation = { __typename?: 'Mutation', unhideHashtagUsedForCreator: { __typename?: 'HashtagUsedForCompetitorModel', isHidden: boolean, name: string, numberOfTimesUsed?: number | null, averageEngagementRate?: number | null } };

export type BrandFragmentForCompetitorTopHashtagsFragment = { __typename?: 'BrandModel', id: string, name: string };

export type GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryVariables = Exact<{
  data: GetSocialPostsCreatedForCompetitorsInput;
}>;


export type GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery = { __typename?: 'Query', getSocialPostsCreatedForCompetitors: { __typename?: 'PaginatedSocialPost', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }> } };

export type OrganizationSocialPostCommentLabelFragmentEditCompetitorLabelsFragment = { __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string };

export type GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryVariables = Exact<{
  data: OrganizationSocialPostCommentLabelsInput;
}>;


export type GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery = { __typename?: 'Query', organizationSocialPostCommentLabels: { __typename?: 'PaginatedOrganizationSocialPostCommentLabel', data: Array<{ __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string }> } };

export type CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationVariables = Exact<{
  data: CreateOrganizationSocialPostCommentLabelInput;
}>;


export type CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation = { __typename?: 'Mutation', createOrganizationSocialPostCommentLabels: { __typename?: 'OrganizationSocialPostCommentLabelModel', id: string, organizationId: string, label: string } };

export type CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables = Exact<{
  input: CreateBrandBookmarkInput;
}>;


export type CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation = { __typename?: 'Mutation', createBrandBookmark: { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null } };

export type DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables = Exact<{
  input: DeleteBrandBookmarkInput;
}>;


export type DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation = { __typename?: 'Mutation', deleteBrandBookmark: { __typename?: 'Result', message: string, success: boolean, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables = Exact<{
  input: CreateCompetitorBookmarkInput;
}>;


export type CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation = { __typename?: 'Mutation', createCompetitorBookmark: { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null } };

export type DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables = Exact<{
  input: DeleteCompetitorBookmarkInput;
}>;


export type DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation = { __typename?: 'Mutation', deleteCompetitorBookmark: { __typename?: 'Result', message: string, success: boolean, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type GetCompetitorForBrandCompetitorDetailQueryVariables = Exact<{
  competitorId: Scalars['String'];
}>;


export type GetCompetitorForBrandCompetitorDetailQuery = { __typename?: 'Query', competitor: { __typename?: 'CompetitorModel', id: string, isBookmarked: boolean, trackingBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null, handle: string, platform: Platform }> } } };

export type BrandFragmentForBrandCompetitorsViewFragment = { __typename?: 'BrandModel', id: string, myPermissions: Array<BrandPermission>, bookmarkState: { __typename?: 'BrandBookmarkState', competitorAnalytics: boolean } };

export type GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryVariables = Exact<{
  data: SearchCompetitorFlatCreatorsInput;
  socialPostsData: GetSocialPostsCreatedForCompetitorsResolveFieldInput;
}>;


export type GetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery = { __typename?: 'Query', searchCompetitorFlatCreators: { __typename?: 'PaginatedCompetitorCreatorMetricsResult', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, data: Array<{ __typename?: 'CompetitorCreatorMetricsModel', competitorId: string, followerCount: number, platforms: Array<Platform>, averageVideoViews: number, averageLikes: number, averageEngagementRate: number, competitor: { __typename?: 'CompetitorModel', id: string, isBookmarked: boolean }, trackingBrand: { __typename?: 'BrandModel', id: string, name: string }, trackingBrandCreators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null, handle: string, platform: Platform }>, socialPosts?: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> } | null }> } };

export type BrandFragmentBrandCreatorPostsFragment = { __typename?: 'BrandModel', id: string, name: string };

export type CreatorFragmentBrandCreatorPostsFragment = { __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, profilePictureUrl?: string | null, followerCount: number };

export type GetCreatorForBrandCreatorPostsQueryVariables = Exact<{
  data: GetCreatorInput;
}>;


export type GetCreatorForBrandCreatorPostsQuery = { __typename?: 'Query', getCreator: { __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, profilePictureUrl?: string | null, followerCount: number } };

export type GetCompetitorForBrandCreatorPostsQueryVariables = Exact<{
  competitorId: Scalars['String'];
  data: GetNumberOfBrandMentionsByCreatorInput;
}>;


export type GetCompetitorForBrandCreatorPostsQuery = { __typename?: 'Query', competitor: { __typename?: 'CompetitorModel', id: string, numberOfBrandMentionsByCreator: number, forBrand: { __typename?: 'BrandModel', id: string, name: string } } };

export type GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryVariables = Exact<{
  data: SocialPostsByCreatorsForCompetitorInput;
}>;


export type GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery = { __typename?: 'Query', getSocialPostsByCreatorsForCompetitor: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type BrandFragmentBrandHashtagPostsFragment = { __typename?: 'BrandModel', id: string, name: string };

export type GetHashtagUsedByCompetitorForBrandHashtagPostsQueryVariables = Exact<{
  data: GetHashtagUsedByCompetitorInput;
}>;


export type GetHashtagUsedByCompetitorForBrandHashtagPostsQuery = { __typename?: 'Query', getHashtagUsedByCompetitor: Array<{ __typename?: 'HashtagUsedForCompetitorModel', name: string, averageEngagementRate?: number | null, numberOfTimesUsed?: number | null }> };

export type GetCompetitorForBrandHashtagPostsQueryVariables = Exact<{
  competitorId: Scalars['String'];
}>;


export type GetCompetitorForBrandHashtagPostsQuery = { __typename?: 'Query', competitor: { __typename?: 'CompetitorModel', id: string, forBrand: { __typename?: 'BrandModel', id: string, name: string } } };

export type GetSocialPostsByHashtagsQueryVariables = Exact<{
  data: GetTopHashtagsPostsForCompetitorInput;
}>;


export type GetSocialPostsByHashtagsQuery = { __typename?: 'Query', getSocialPostsByHashtagsForCompetitor: { __typename?: 'PaginatedSocialPostForHashTag', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, meta: { __typename?: 'PaginatedSocialPostMetaForHashTag', totalCount: number, averageEngagementRate: number, numberOfTimesUsed: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryVariables = Exact<{
  filters: CompetitorShareOfVoiceFiltersInput;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery = { __typename?: 'Query', competitorShareOfVoiceTimeSeriesData: { __typename?: 'PaginatedCompetitorShareOfVoiceTimeSeriesData', data: Array<{ __typename?: 'CompetitorShareOfVoiceTimeSeriesDataItem', id: string, base: { __typename?: 'CompetitorShareOfVoiceBaseModel', id: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> }, competitor?: { __typename?: 'CompetitorModel', id: string, name: string } | null }, dataPoints: Array<{ __typename?: 'CompetitorShareOfVoiceDataPoint', date: any, data: { __typename?: 'CompetitorShareOfVoiceData', shareOfVoice: number, mentionCount: number, viewCount: number, totalEngagement: number, engagementRate: number } }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type BrandFragmentBrandCompetitorsShareOfVoiceSocialPostsDialogFragment = { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> };

export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables = Exact<{
  filters: CompetitorShareOfVoiceFiltersInput;
}>;


export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery = { __typename?: 'Query', competitorShareOfVoiceAggregatedData: { __typename?: 'PaginatedCompetitorShareOfVoiceAggregatedData', data: Array<{ __typename?: 'CompetitorShareOfVoiceAggregatedDataItem', id: string, aggregatedData: { __typename?: 'CompetitorShareOfVoiceData', shareOfVoice: number, mentionCount: number, viewCount: number, totalEngagement: number, engagementRate: number } }> } };

export type GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables = Exact<{
  filters: PaginatedBrandInboundFiltersInputForSocialPosts;
}>;


export type GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery = { __typename?: 'Query', getBrandInboundSocialPosts: { __typename?: 'PaginatedSocialPostsForBrandInboundPosts', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CompetitorShareOfVoiceAggregatedDataItemFragmentBcShareOfVoiceTableFragment = { __typename?: 'CompetitorShareOfVoiceAggregatedDataItem', id: string, base: { __typename?: 'CompetitorShareOfVoiceBaseModel', id: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> }, competitor?: { __typename?: 'CompetitorModel', id: string, name: string } | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null }> }, aggregatedData: { __typename?: 'CompetitorShareOfVoiceData', shareOfVoice: number, mentionCount: number, viewCount: number, totalEngagement: number, engagementRate: number } };

export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryVariables = Exact<{
  filters: CompetitorShareOfVoiceFiltersInput;
  sortBy?: InputMaybe<CompetitorShareOfVoiceAggregatedDataSortByInputData>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  previewPostsFilters: CompetitorShareOfVoicePreviewPostsFiltersInput;
}>;


export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery = { __typename?: 'Query', competitorShareOfVoiceAggregatedData: { __typename?: 'PaginatedCompetitorShareOfVoiceAggregatedData', data: Array<{ __typename?: 'CompetitorShareOfVoiceAggregatedDataItem', id: string, base: { __typename?: 'CompetitorShareOfVoiceBaseModel', id: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> }, competitor?: { __typename?: 'CompetitorModel', id: string, name: string } | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null }> }, aggregatedData: { __typename?: 'CompetitorShareOfVoiceData', shareOfVoice: number, mentionCount: number, viewCount: number, totalEngagement: number, engagementRate: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationVariables = Exact<{
  data: UpdateSocialListeningHourUsageThresholdAlertInput;
}>;


export type UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation = { __typename?: 'Mutation', updateSocialListeningHourUsageThresholdAlert: { __typename?: 'NotificationModel', id: string } };

export type AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryVariables = Exact<{
  filters: AggregatedBrandDurationUsageFilters;
}>;


export type AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery = { __typename?: 'Query', aggregatedBrandDurationUsage: Array<{ __typename?: 'AggregatedBrandDurationUsageResult', durationUsed: number, totalTopicsCount: number, topics: Array<{ __typename?: 'AggregatedTopicDurationUsageResult', durationUsed: number, topic: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType, isBookmarked: boolean, status: TopicStatus, resetOnNextCycle: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } }>, brand: { __typename?: 'BrandModel', id: string, name: string, status: BrandStatus, resetOnNextCycle: boolean, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } }> };

export type CollectionFragmentCollectionBreadcrumbsFragment = { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> };

export type CollectionFragmentCollectionContextMenuFragment = { __typename?: 'CollectionModel', id: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, previewPost?: { __typename?: 'PostModel', id: string } | null };

export type DeleteCollectionForCollectionContextMenuMutationVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type DeleteCollectionForCollectionContextMenuMutation = { __typename?: 'Mutation', deleteCollection: { __typename?: 'Result', message: string, success: boolean } };

export type UpdateCollectionPreviewForCollectionContextMenuMutationVariables = Exact<{
  data: UpdateCollectionPreviewInput;
}>;


export type UpdateCollectionPreviewForCollectionContextMenuMutation = { __typename?: 'Mutation', updateCollectionPreview?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type PostFragmentCollectionMultiPostPreviewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CollectionFragmentCollectionMultiPostPreviewFragment = { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type CollectionFragmentCollectionNameFragment = { __typename?: 'CollectionModel', id: string, name: string };

export type UpdateCollectionForCollectionNameMutationVariables = Exact<{
  data: UpdateCollectionInput;
}>;


export type UpdateCollectionForCollectionNameMutation = { __typename?: 'Mutation', updateCollection: { __typename?: 'CollectionModel', id: string, name: string } };

export type CollectionFragmentCollectionPinFragment = { __typename?: 'CollectionModel', id: string, isPinnedToRoot: boolean, isPinnedToParent: boolean };

export type CollectionFragmentCollectionSummaryFragment = { __typename?: 'CollectionModel', id: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean };

export type PostFragmentCollectionThumbnailFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CollectionFragmentCollectionThumbnailFragment = { __typename?: 'CollectionModel', id: string, hasPreviewPost: boolean, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryVariables = Exact<{
  input: GetSameLevelCollectionsInput;
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery = { __typename?: 'Query', sameLevelCollections: { __typename?: 'PaginatedCollectionResult', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, data: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } };

export type CollectionFragmentCollectionTopHeaderBreadcrumbsFragment = { __typename?: 'CollectionModel', id: string, name: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> };

export type GetCollectionViewersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionViewersQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, viewers: Array<{ __typename?: 'CollectionViewerModel', lastSeen?: any | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> } };

export type CollectionFragmentCollectionViewersFragment = { __typename?: 'CollectionModel', id: string, viewers: Array<{ __typename?: 'CollectionViewerModel', lastSeen?: any | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> };

export type PostFragmentCollectionCreateFormFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CollectionFragmentSimilarCollectionListFragment = { __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, childCollections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null, name: string, generalPermission: GeneralPermission, organizationName: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null }> };

export type GetCollectionsSimilarSearchForSimilarCollectionListQueryVariables = Exact<{
  filters: CollectionFilters;
}>;


export type GetCollectionsSimilarSearchForSimilarCollectionListQuery = { __typename?: 'Query', collectionsSimilarSearch: { __typename?: 'CollectionSearchResult', hits: Array<{ __typename?: 'CollectionSearchHit', type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, childCollections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null, name: string, generalPermission: GeneralPermission, organizationName: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null }> } }> } };

export type PostFragmentCollectionSendToCollectionFormFragment = { __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type SavePostsToCollectionsForCollectionSendToCollectionFormMutationVariables = Exact<{
  data: SavePostsToCollectionsInput;
}>;


export type SavePostsToCollectionsForCollectionSendToCollectionFormMutation = { __typename?: 'Mutation', savePostsToCollections: { __typename?: 'Result', success: boolean, message: string } };

export type RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationVariables = Exact<{
  data: RemovePostsFromCollectionsInput;
}>;


export type RemovePostsFromCollectionsForCollectionSendToCollectionFormMutation = { __typename?: 'Mutation', removePostsFromCollections: { __typename?: 'Result', success: boolean, message: string } };

export type CollectionFragmentUseAutocompleteInfiniteCollectionsFragment = { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryVariables = Exact<{
  input: GetPostCollectionInput;
}>;


export type GetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery = { __typename?: 'Query', postCollections: { __typename?: 'PaginatedPostCollections', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, startCursor?: string | null, hasPreviousPage: boolean }, data: Array<{ __typename?: 'CollectionSearchHit', type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } }> } };

export type DeleteBookmarkForCollectionBookmarkHandlersMutationVariables = Exact<{
  input: DeleteCollectionBookmarkInput;
}>;


export type DeleteBookmarkForCollectionBookmarkHandlersMutation = { __typename?: 'Mutation', deleteCollectionBookmark: { __typename?: 'Result', message: string, success: boolean, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type CreateBookmarkForCollectionBookmarkHandlersMutationVariables = Exact<{
  input: CreateCollectionBookmarkInput;
}>;


export type CreateBookmarkForCollectionBookmarkHandlersMutation = { __typename?: 'Mutation', createCollectionBookmark: { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null } };

export type CollectionFragmentCollectionSavedToContentCalendarFragment = { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null }> };

export type CollectionFragmentMoveToAnotherCollectionCollectionsListFragment = { __typename?: 'CollectionModel', id: string, name: string, hasPreviewPost: boolean, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type GetMoveToAnotherCollectionCollectionsListQueryVariables = Exact<{
  filters: CollectionFilters;
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetMoveToAnotherCollectionCollectionsListQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'CollectionSearchHit', type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, name: string, hasPreviewPost: boolean, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } }> } };

export type MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationVariables = Exact<{
  data: MoveCollectionsToCollectionInput;
}>;


export type MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation = { __typename?: 'Mutation', moveCollectionsToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationVariables = Exact<{
  data: RemoveCollectionsParentInput;
}>;


export type RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation = { __typename?: 'Mutation', removeCollectionsParent: { __typename?: 'Result', success: boolean, message: string } };

export type CollectionFragmentCollectionCardViewFragment = { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> };

export type GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery = { __typename?: 'Query', contentIdeaCollections: { __typename?: 'PaginatedCollectionResult', meta: { __typename?: 'PaginationMeta', totalCount: number } } };

export type GetPostsForCustomCollectionsUsePreviewablePostQueryVariables = Exact<{
  filters: PostFilters;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetPostsForCustomCollectionsUsePreviewablePostQuery = { __typename?: 'Query', posts: { __typename?: 'PaginatedPostSearchResult', data: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, meta: { __typename?: 'PaginatedPostSearchPaginationMeta', totalCount: number, newPostCount?: number | null } } };

export type PostFragmentCollectionCardCompactViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CollectionFragmentCollectionCardCompactViewFragment = { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type CollectionFragmentCollectionCollaborationsViewFragment = { __typename?: 'CollectionModel', id: string, roomId?: string | null, parentCollectionId?: string | null };

export type PostFragmentCollectionCreateFromSmartSearchResultDialogViewFragment = { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type PostFragmentCollectionListItemViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CollectionFragmentCollectionListItemViewFragment = { __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null }> };

export type GetPostCollectionsForCollectionAutocompleteMenuQueryVariables = Exact<{
  input: GetPostCollectionInput;
}>;


export type GetPostCollectionsForCollectionAutocompleteMenuQuery = { __typename?: 'Query', postCollections: { __typename?: 'PaginatedPostCollections', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, startCursor?: string | null, hasPreviousPage: boolean }, data: Array<{ __typename?: 'CollectionSearchHit', type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } }> } };

export type CollectionFragmentCollectionAutocompleteMenuFragment = { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type CollectionFragmentCollectionMenuItemViewFragment = { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetCollectionForCollectionMenuItemViewQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForCollectionMenuItemViewQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } };

export type GetCollectionForCollectionSearchAutocompleteSectionQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForCollectionSearchAutocompleteSectionQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string } };

export type CollectionFragmentMoveToAnotherCollectionFragment = { __typename?: 'CollectionModel', id: string, hasPreviewPost: boolean, generalPermission: GeneralPermission, organizationName: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, isBookmarked: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type GetCollectionForMoveToAnotherCollectionQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForMoveToAnotherCollectionQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, hasPreviewPost: boolean, generalPermission: GeneralPermission, organizationName: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, isBookmarked: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } };

export type CollectionFragmentCollectionPeekingCardViewFragment = { __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, childCollections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null, name: string, generalPermission: GeneralPermission, organizationName: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null }> };

export type GetPostsForCollectionPeekingCardViewQueryVariables = Exact<{
  filters: PostFilters;
  take: Scalars['Int'];
}>;


export type GetPostsForCollectionPeekingCardViewQuery = { __typename?: 'Query', posts: { __typename?: 'PaginatedPostSearchResult', data: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } };

export type CollectionInviteMemberFragmentCollectionPermissionMemberFragment = { __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type CollectionPermissionToastQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CollectionPermissionToastQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } };

export type CollectionFragmentCollectionPermissionCollectionTreeFragment = { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, generalPermission: GeneralPermission, organizationName: string, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryVariables = Exact<{
  filters: CollectionFilters;
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type CollectionsSmartSearchForCollectionPermissionCollectionTreeQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'CollectionSearchHit', type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } }> } };

export type PostFragmentCollectionPermissionCollectionTreeFragment = { __typename?: 'PostModel', id: string, description: string, generalPermission: GeneralPermission, organizationName: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, color: string, updatedAt: any, isFavorite: boolean, attachment?: { __typename?: 'AttachmentModel', name: string, id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, collections: Array<{ __typename?: 'CollectionModel', id: string }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<SortType>;
}>;


export type GetPostsSmartSearchForCollectionPermissionCollectionTreeQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, description: string, generalPermission: GeneralPermission, organizationName: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, color: string, updatedAt: any, isFavorite: boolean, attachment?: { __typename?: 'AttachmentModel', name: string, id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, collections: Array<{ __typename?: 'CollectionModel', id: string }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type UpdateCollectionPermissionsMutationVariables = Exact<{
  data: UpdateCollectionPermissionsInputV2;
}>;


export type UpdateCollectionPermissionsMutation = { __typename?: 'Mutation', updateCollectionPermissionsV2: { __typename?: 'Result', message: string, success: boolean } };

export type IsCollectionsPermissionLessThanParentCollectionPermissionQueryVariables = Exact<{
  data: IsCollectionsPermissionLessThanParentCollectionPermissionInput;
}>;


export type IsCollectionsPermissionLessThanParentCollectionPermissionQuery = { __typename?: 'Query', isCollectionsPermissionLessThanParentCollectionPermission: boolean };

export type UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationVariables = Exact<{
  data: UpdateNestedCollectionPostPermissionsInput;
}>;


export type UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation = { __typename?: 'Mutation', updateNestedCollectionPostPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type CollectionFragmentCollectionPermissionDialogBodyFragment = { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, organizationId: string, organizationName: string, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, childCollections: Array<{ __typename?: 'CollectionModel', id: string }>, posts: Array<{ __typename?: 'PostModel', id: string }> };

export type GetCollectionPermissionForDialogViewQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionPermissionForDialogViewQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', name: string, id: string, myPermissions: Array<CollectionPermission>, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, organizationId: string, organizationName: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, childCollections: Array<{ __typename?: 'CollectionModel', id: string }> } };

export type CollectionFragmentManyPostsPermissionDialogFragment = { __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, organizationId: string, organizationName: string };

export type CollectionFragmentCollectionPermissionUpdatesDialogFragment = { __typename?: 'CollectionModel', id: string, name: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type CollectionFragmentCollectionPermissionSummaryFragment = { __typename?: 'CollectionModel', id: string, generalPermission: GeneralPermission, organizationName: string, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type CollectionFragmentCollectionPostDndCollectionCardFragment = { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> };

export type MovePostsToCollectionForCollectionPostDndCollectionCardMutationVariables = Exact<{
  data: MovePostsToCollectionInput;
}>;


export type MovePostsToCollectionForCollectionPostDndCollectionCardMutation = { __typename?: 'Mutation', movePostsToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type PostFragmentCollectionPostDndHoveringActionPopupFragment = { __typename?: 'PostModel', id: string, myPermissions: Array<PostPermission>, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type DeletePostsForCollectionPostDndHoveringActionPopupMutationVariables = Exact<{
  data: DeletePostsInput;
}>;


export type DeletePostsForCollectionPostDndHoveringActionPopupMutation = { __typename?: 'Mutation', deletePosts: { __typename?: 'Result', success: boolean, message: string } };

export type PostFragmentCollectionPostDndPostCardFragment = { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type AttachmentFragmentCommentAttachmentListFragment = { __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } };

export type CommentFragmentCommentAttachmentListFragment = { __typename?: 'CommentModel', id: string, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type DeleteAttachmentForCommentAttachmentListMutationVariables = Exact<{
  data: DeleteAttachmentInput;
}>;


export type DeleteAttachmentForCommentAttachmentListMutation = { __typename?: 'Mutation', deleteAttachment: { __typename?: 'Result', success: boolean, message: string } };

export type CommentFragmentCommentInputFragment = { __typename?: 'CommentModel', id: string, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type CreateCommentForCollectionMutationVariables = Exact<{
  data: CreateCommentInput;
}>;


export type CreateCommentForCollectionMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> } };

export type ReadAllCommentsForCollectionMutationVariables = Exact<{
  data: ReadAllCommentsInput;
}>;


export type ReadAllCommentsForCollectionMutation = { __typename?: 'Mutation', readAllComments: { __typename?: 'Result', message: string, success: boolean } };

export type InviteCollectionMembersMutationVariables = Exact<{
  data: InviteCollectionMembersInput;
}>;


export type InviteCollectionMembersMutation = { __typename?: 'Mutation', inviteCollectionMembers: { __typename?: 'Result', success: boolean, message: string } };

export type InvitePostMembersMutationVariables = Exact<{
  data: InvitePostMembersInput;
}>;


export type InvitePostMembersMutation = { __typename?: 'Mutation', invitePostMembers: { __typename?: 'Result', success: boolean, message: string } };

export type GetPostForInviteMemberHandlersQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostForInviteMemberHandlersQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationId: string, creator: { __typename?: 'UserProfileModel', id: string }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> } | null };

export type GetCollectionForInviteMemberHandlersQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForInviteMemberHandlersQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, generalPermission: GeneralPermission, organizationId: string, creator: { __typename?: 'UserProfileModel', id: string }, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> } };

export type CreatePermissionRequestsMutationVariables = Exact<{
  data: CreatePermissionRequestsInput;
}>;


export type CreatePermissionRequestsMutation = { __typename?: 'Mutation', createPermissionRequests: Array<{ __typename?: 'PermissionRequestModel', id: string }> };

export type CreateCommentForPostMutationVariables = Exact<{
  data: CreateCommentInput;
}>;


export type CreateCommentForPostMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> } };

export type ReactToCommentForPostMutationVariables = Exact<{
  data: ReactInput;
}>;


export type ReactToCommentForPostMutation = { __typename?: 'Mutation', react: { __typename?: 'Result', message: string, success: boolean } };

export type UpdateCommentForPostMutationVariables = Exact<{
  data: UpdateCommentInput;
}>;


export type UpdateCommentForPostMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> } };

export type DeleteCommentForPostMutationVariables = Exact<{
  data: DeleteCommentInput;
}>;


export type DeleteCommentForPostMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'Result', message: string, success: boolean } };

export type ReadAllCommentsForPostMutationVariables = Exact<{
  data: ReadAllCommentsInput;
}>;


export type ReadAllCommentsForPostMutation = { __typename?: 'Mutation', readAllComments: { __typename?: 'Result', message: string, success: boolean } };

export type CreateCommentForTaskMutationVariables = Exact<{
  data: CreateCommentInput;
}>;


export type CreateCommentForTaskMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> } };

export type ReactToCommentForTaskMutationVariables = Exact<{
  data: ReactInput;
}>;


export type ReactToCommentForTaskMutation = { __typename?: 'Mutation', react: { __typename?: 'Result', message: string, success: boolean } };

export type UpdateCommentForTaskMutationVariables = Exact<{
  data: UpdateCommentInput;
}>;


export type UpdateCommentForTaskMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> } };

export type DeleteCommentForTaskMutationVariables = Exact<{
  data: DeleteCommentInput;
}>;


export type DeleteCommentForTaskMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'Result', message: string, success: boolean } };

export type ReadAllCommentsForTaskMutationVariables = Exact<{
  data: ReadAllCommentsInput;
}>;


export type ReadAllCommentsForTaskMutation = { __typename?: 'Mutation', readAllComments: { __typename?: 'Result', message: string, success: boolean } };

export type GetCollectionForCollectionCommentViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionForCollectionCommentViewQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, parentCollectionId?: string | null, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } };

export type CollectionFragmentCollectionCommentViewFragment = { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, parentCollectionId?: string | null, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> };

export type CommentFragmentCollectionCommentViewFragment = { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type CommentFragmentCollectionCommentListViewFragment = { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type GetCommentsForCollectionCommentListViewQueryVariables = Exact<{
  filters: CommentFilter;
}>;


export type GetCommentsForCollectionCommentListViewQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> };

export type CommentFragmentCommentContainerViewFragment = { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type DeletePostAnnotationForCommentContainerViewMutationVariables = Exact<{
  data: DeletePostAnnotationInput;
}>;


export type DeletePostAnnotationForCommentContainerViewMutation = { __typename?: 'Mutation', deletePostAnnotation: { __typename?: 'Result', message: string, success: boolean } };

export type CommentFragmentCommentContentViewFragment = { __typename?: 'CommentModel', id: string, text: string, createdAt: any, parentThreadId?: string | null, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type CommentFragmentPostCommentViewFragment = { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type PostFragmentPostCommentViewFragment = { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type GetPostForPostCommentViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForPostCommentViewQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type CommentFragmentPostCommentListViewFragment = { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type GetCommentsForPostCommentListViewQueryVariables = Exact<{
  filters: CommentFilter;
}>;


export type GetCommentsForPostCommentListViewQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> };

export type CommentFragmentTaskCommentListViewFragment = { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> };

export type GetCommentsForTaskCommentListViewQueryVariables = Exact<{
  filters: CommentFilter;
}>;


export type GetCommentsForTaskCommentListViewQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> };

export type CompetitorFragmentCompetitorParsingSettingsViewFragment = { __typename?: 'CompetitorModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null };

export type GetCompetitorForCompetitorParsingSettingsViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompetitorForCompetitorParsingSettingsViewQuery = { __typename?: 'Query', competitor: { __typename?: 'CompetitorModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type UpdateCompetitorForCompetitorParsingSettingsViewMutationVariables = Exact<{
  data: UpdateCompetitorInput;
}>;


export type UpdateCompetitorForCompetitorParsingSettingsViewMutation = { __typename?: 'Mutation', updateCompetitors: { __typename?: 'CompetitorModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type CollectionFragmentContentCalendarCollectionMenuItemFragment = { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationVariables = Exact<{
  data: JoinContentCalendarViewInput;
}>;


export type JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation = { __typename?: 'Mutation', joinContentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string } };

export type ContentIdeaFieldOptionFragmentContentCalendarFilterFragment = { __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null };

export type ContentIdeaFieldFragmentContentCalendarFilterFragment = { __typename?: 'ContentIdeaFieldModel', id: string, name: string, icon?: string | null, type: FieldType, options: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> };

export type GetContentIdeaFieldsForContentCalendarFilterQueryVariables = Exact<{
  filters?: InputMaybe<ContentIdeaFieldFilters>;
}>;


export type GetContentIdeaFieldsForContentCalendarFilterQuery = { __typename?: 'Query', contentIdeaFields: Array<{ __typename?: 'ContentIdeaFieldModel', id: string, name: string, icon?: string | null, type: FieldType, options: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> }> };

export type GetContentIdeaFieldsForContentCalendarSortQueryVariables = Exact<{
  filters?: InputMaybe<ContentIdeaFieldFilters>;
}>;


export type GetContentIdeaFieldsForContentCalendarSortQuery = { __typename?: 'Query', contentIdeaFields: Array<{ __typename?: 'ContentIdeaFieldModel', id: string, name: string }> };

export type CollectionFragmentContentCalendarFilterByCollectionsFragment = { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryVariables = Exact<{
  filters: CollectionFilters;
  take?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<SortType>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', data: Array<{ __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetMeForContentCalendarFilterByOwnersInnerContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeForContentCalendarFilterByOwnersInnerContentQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, organization: { __typename?: 'OrganizationModel', id: string, name: string, users: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, externalUsers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string, name: string } }> }, joinedOrganizations: Array<{ __typename?: 'OrganizationProfileModel', id: string, name: string, users: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }> } };

export type GetMeForContentCalendarFilterByPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeForContentCalendarFilterByPlatformsQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, organization: { __typename?: 'OrganizationModel', id: string, socialAuthors: Array<{ __typename?: 'SocialAuthorModel', id: string, platform: Platform, platformHandle?: string | null }> }, joinedOrganizations: Array<{ __typename?: 'OrganizationProfileModel', id: string, socialAuthors?: Array<{ __typename?: 'SocialAuthorModel', id: string, platform: Platform, platformHandle?: string | null }> | null }> } };

export type UpdateContentCalendarViewForApplyChangesButtonMutationVariables = Exact<{
  data: UpdateContentCalendarViewInput;
}>;


export type UpdateContentCalendarViewForApplyChangesButtonMutation = { __typename?: 'Mutation', updateContentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string, filters: string } };

export type CreateContentCalendarViewForApplyChangesPromptDialogMutationVariables = Exact<{
  data: CreateContentCalendarViewInput;
}>;


export type CreateContentCalendarViewForApplyChangesPromptDialogMutation = { __typename?: 'Mutation', createContentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string } };

export type UpdateContentCalendarViewForApplyChangesPromptDialogMutationVariables = Exact<{
  data: UpdateContentCalendarViewInput;
}>;


export type UpdateContentCalendarViewForApplyChangesPromptDialogMutation = { __typename?: 'Mutation', updateContentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string, filters: string } };

export type CreateContentCalendarViewForCreateViewFormMutationVariables = Exact<{
  data: CreateContentCalendarViewInput;
}>;


export type CreateContentCalendarViewForCreateViewFormMutation = { __typename?: 'Mutation', createContentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string, name: string, myPermissions: Array<ContentCalendarViewPermission>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string } } };

export type GetContentCalendarViewsForManageViewsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentCalendarViewsForManageViewsSectionQuery = { __typename?: 'Query', contentCalendarViews: Array<{ __typename?: 'ContentCalendarViewModel', id: string, name: string, myPermissions: Array<ContentCalendarViewPermission>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string } }> };

export type UpdateUserOnboardingStateForContentCalendarIntroModalMutationVariables = Exact<{
  data: UpdateUserOnboardingStateInput;
}>;


export type UpdateUserOnboardingStateForContentCalendarIntroModalMutation = { __typename?: 'Mutation', updateUserOnboardingState: { __typename?: 'MeModel', id: string, onboardingState?: { __typename?: 'OnboardingStateData', hasSeenContentCalendarIntroduction?: boolean | null } | null } };

export type ContentCalendarViewFragmentContentCalendarViewContextMenuFragment = { __typename?: 'ContentCalendarViewModel', id: string, myPermissions: Array<ContentCalendarViewPermission> };

export type DeleteContentCalendarViewForContentCalendarViewContextMenuMutationVariables = Exact<{
  data: DeleteContentCalendarViewInput;
}>;


export type DeleteContentCalendarViewForContentCalendarViewContextMenuMutation = { __typename?: 'Mutation', deleteContentCalendarView: { __typename?: 'Result', success: boolean, message: string } };

export type DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationVariables = Exact<{
  data: DuplicateContentCalendarViewInput;
}>;


export type DuplicateContentCalendarViewForContentCalendarViewContextMenuMutation = { __typename?: 'Mutation', duplicateContentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string } };

export type GetContentCalendarViewForUseContentCalendarViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentCalendarViewForUseContentCalendarViewQuery = { __typename?: 'Query', contentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string, name: string, filters: string, myPermissions: Array<ContentCalendarViewPermission> } };

export type ContentCalendarViewFragmentContentCalendarViewListItemViewFragment = { __typename?: 'ContentCalendarViewModel', id: string, name: string, myPermissions: Array<ContentCalendarViewPermission>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string } };

export type UpdateContentCalendarViewForContentCalendarViewListItemViewMutationVariables = Exact<{
  data: UpdateContentCalendarViewInput;
}>;


export type UpdateContentCalendarViewForContentCalendarViewListItemViewMutation = { __typename?: 'Mutation', updateContentCalendarView: { __typename?: 'ContentCalendarViewModel', id: string, name: string } };

export type ContentIdeaFragmentContentIdeaAudioFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null } };

export type ContentIdeaFragmentContentIdeaCaptionFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null } };

export type ContentIdeaFragmentContentIdeaCollectionFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null };

export type UpdateContentIdeaForContentIdeaCollectionMutationVariables = Exact<{
  data: UpdateContentIdeaInput;
}>;


export type UpdateContentIdeaForContentIdeaCollectionMutation = { __typename?: 'Mutation', updateContentIdea: { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null } };

export type ContentIdeaFragmentContentIdeaContextMenuFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, name: string };

export type DeleteContentIdeaForContentIdeaContextMenuMutationVariables = Exact<{
  data: DeleteContentIdeaInput;
}>;


export type DeleteContentIdeaForContentIdeaContextMenuMutation = { __typename?: 'Mutation', deleteContentIdea: { __typename?: 'Result', success: boolean, message: string } };

export type ContentIdeaFragmentContentIdeaDueDateFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } };

export type PostFragmentCollectionFieldFragment = { __typename?: 'PostModel', id: string, myPermissions: Array<PostPermission>, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CollectionFragmentCollectionFieldFragment = { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, myPermissions: Array<PostPermission>, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, childCollections: Array<{ __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }> };

export type GetCollectionForCollectionFieldQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForCollectionFieldQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, myPermissions: Array<PostPermission>, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, childCollections: Array<{ __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }> } };

export type SavePostsToCollectionsForCollectionFieldMutationVariables = Exact<{
  data: SavePostsToCollectionsInput;
}>;


export type SavePostsToCollectionsForCollectionFieldMutation = { __typename?: 'Mutation', savePostsToCollections: { __typename?: 'Result', success: boolean, message: string } };

export type RemovePostFromCollectionForCollectionFieldMutationVariables = Exact<{
  data: RemovePostFromCollectionInput;
}>;


export type RemovePostFromCollectionForCollectionFieldMutation = { __typename?: 'Mutation', removePostFromCollection: { __typename?: 'Result', success: boolean, message: string } };

export type DeletePostForCollectionFieldMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePostForCollectionFieldMutation = { __typename?: 'Mutation', deletePost: { __typename?: 'Result', message: string, success: boolean } };

export type MovePostsToCollectionForCollectionFieldMutationVariables = Exact<{
  data: MovePostsToCollectionInput;
}>;


export type MovePostsToCollectionForCollectionFieldMutation = { __typename?: 'Mutation', movePostsToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type ContentIdeaFieldValueFragmentContentIdeaFieldFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null, date?: any | null, checkbox?: boolean | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null };

export type UpdateContentIdeaFieldValueForContentIdeaFieldMutationVariables = Exact<{
  data: UpdateContentIdeaFieldValueInput;
}>;


export type UpdateContentIdeaFieldValueForContentIdeaFieldMutation = { __typename?: 'Mutation', updateContentIdeaFieldValue: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null, date?: any | null, checkbox?: boolean | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } };

export type ContentIdeaFieldOptionFragmentMultiSelectFieldFragment = { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null };

export type ContentIdeaFieldModelFragmentMultiSelectFieldFragment = { __typename?: 'ContentIdeaFieldModel', id: string, name: string, allowNewOptions: boolean, options: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> };

export type GetContentIdeaFieldForMultiSelectFieldQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentIdeaFieldForMultiSelectFieldQuery = { __typename?: 'Query', contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, name: string, allowNewOptions: boolean, options: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> } };

export type ContentIdeaFieldOptionFragmentSelectFieldFragment = { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null };

export type ContentIdeaFieldModelFragmentSelectFieldFragment = { __typename?: 'ContentIdeaFieldModel', id: string, name: string, allowNewOptions: boolean, options: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> };

export type GetContentIdeaFieldForSelectFieldQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentIdeaFieldForSelectFieldQuery = { __typename?: 'Query', contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, name: string, allowNewOptions: boolean, options: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> } };

export type TaskFragmentTasksFieldFragment = { __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type GetTaskByIdsForTasksFieldQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetTaskByIdsForTasksFieldQuery = { __typename?: 'Query', tasksByIds: Array<{ __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, subtasks: Array<{ __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }> };

export type TaskFragmentUseTasksFieldShortcutsFragment = { __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type UpdateTaskForUseTasksFieldShortcutsMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForUseTasksFieldShortcutsMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, subtasks: Array<{ __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } };

export type ContentIdeaFieldValueFragmentContentIdeaFieldTextFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null };

export type ContentIdeaFieldValueFragmentContentIdeaFieldSelectFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null };

export type ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelectFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null };

export type ContentIdeaFieldValueFragmentContentIdeaFieldDateFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null };

export type ContentIdeaFieldValueFragmentContentIdeaFieldCheckboxFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, checkbox?: boolean | null } | null };

export type ContentIdeaFieldValueFragmentContentIdeaFieldTasksFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null } | null };

export type ContentIdeaFieldValueFragmentContentIdeaFieldUsersFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null } | null };

export type ContentIdeaFieldValueFragmentContentIdeaFieldCollectionFragment = { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null };

export type ContentIdeaFieldFragmentContentIdeaFieldNameFragment = { __typename?: 'ContentIdeaFieldModel', id: string, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean };

export type UpdateContentIdeaFieldForContentIdeaFieldNameMutationVariables = Exact<{
  data: UpdateContentIdeaFieldInput;
}>;


export type UpdateContentIdeaFieldForContentIdeaFieldNameMutation = { __typename?: 'Mutation', updateContentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean } };

export type DuplicateContentIdeaFieldForContentIdeaFieldNameMutationVariables = Exact<{
  data: DuplicateContentIdeaFieldInput;
}>;


export type DuplicateContentIdeaFieldForContentIdeaFieldNameMutation = { __typename?: 'Mutation', duplicateContentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean } };

export type DeleteContentIdeaFieldForContentIdeaFieldNameMutationVariables = Exact<{
  data: DeleteContentIdeaFieldInput;
}>;


export type DeleteContentIdeaFieldForContentIdeaFieldNameMutation = { __typename?: 'Mutation', deleteContentIdeaField: { __typename?: 'Result', success: boolean, message: string } };

export type GetContentIdeaFieldsForContentIdeaFieldNameQueryVariables = Exact<{
  filters?: InputMaybe<ContentIdeaFieldFilters>;
}>;


export type GetContentIdeaFieldsForContentIdeaFieldNameQuery = { __typename?: 'Query', contentIdeaFields: Array<{ __typename?: 'ContentIdeaFieldModel', id: string, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean }> };

export type ContentIdeaFragmentContentIdeaIceboxFragment = { __typename?: 'ContentIdeaModel', id: string, stage: Stage, myPermissions: Array<ContentIdeaPermission> };

export type UpdateContentIdeaForContentIdeaIceboxMutationVariables = Exact<{
  data: UpdateContentIdeaInput;
}>;


export type UpdateContentIdeaForContentIdeaIceboxMutation = { __typename?: 'Mutation', updateContentIdea: { __typename?: 'ContentIdeaModel', id: string, stage: Stage, myPermissions: Array<ContentIdeaPermission> } };

export type ContentIdeaFragmentContentIdeaInviteAssigneeUserModalFragment = { __typename?: 'ContentIdeaModel', id: string, name: string };

export type ContentIdeaFragmentContentIdeaNameFragment = { __typename?: 'ContentIdeaModel', id: string, name: string, myPermissions: Array<ContentIdeaPermission> };

export type UpdateContentIdeaForContentIdeaNameMutationVariables = Exact<{
  data: UpdateContentIdeaInput;
}>;


export type UpdateContentIdeaForContentIdeaNameMutation = { __typename?: 'Mutation', updateContentIdea: { __typename?: 'ContentIdeaModel', id: string, name: string, myPermissions: Array<ContentIdeaPermission> } };

export type ContentIdeaFragmentContentIdeaNoteFragment = { __typename?: 'ContentIdeaModel', id: string, noteContent?: string | null, roomId?: string | null, myPermissions: Array<ContentIdeaPermission> };

export type UpdateContentIdeaForContentIdeaNoteMutationVariables = Exact<{
  data: UpdateContentIdeaInput;
}>;


export type UpdateContentIdeaForContentIdeaNoteMutation = { __typename?: 'Mutation', updateContentIdea: { __typename?: 'ContentIdeaModel', id: string, noteContent?: string | null } };

export type ContentIdeaFragmentContentIdeaOwnersFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, name: string, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } } };

export type InviteMembersForContentIdeaOwnersMutationVariables = Exact<{
  data: InviteCollectionMembersInput;
}>;


export type InviteMembersForContentIdeaOwnersMutation = { __typename?: 'Mutation', inviteCollectionMembers: { __typename?: 'Result', success: boolean, message: string } };

export type UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationVariables = Exact<{
  data: UpdateNestedCollectionPostPermissionsInput;
}>;


export type UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation = { __typename?: 'Mutation', updateNestedCollectionPostPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type UpdateContentIdeaFieldValueForContentIdeaOwnersMutationVariables = Exact<{
  data: UpdateContentIdeaFieldValueInput;
}>;


export type UpdateContentIdeaFieldValueForContentIdeaOwnersMutation = { __typename?: 'Mutation', updateContentIdeaFieldValue: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null } | null } };

export type ContentIdeaFragmentContentIdeaPillarsFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null } };

export type ContentIdeaPublishMetadataFragmentContentIdeaPlatformsFragment = { __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null };

export type ContentIdeaFragmentContentIdeaPlatformsFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }> };

export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationVariables = Exact<{
  data: UpdateContentIdeaPublishMetadataInput;
}>;


export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation = { __typename?: 'Mutation', updateContentIdeaPublishMetadata: { __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null } };

export type ContentIdeaPublishMetadataFragmentContentIdeaPlatformsMenuItemFragment = { __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null };

export type ContentIdeaFragmentContentIdeaPlatformsMenuItemFragment = { __typename?: 'ContentIdeaModel', id: string, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }> };

export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationVariables = Exact<{
  data: UpdateContentIdeaPublishMetadataInput;
}>;


export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation = { __typename?: 'Mutation', updateContentIdeaPublishMetadata: { __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null } };

export type ContentIdeaFragmentContentIdeaPreviewFragment = { __typename?: 'ContentIdeaModel', id: string, noteContent?: string | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string } | null } | null }, collection: { __typename?: 'CollectionModel', id: string }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null };

export type SavePostsToCollectionsForContentIdeaPreviewMutationVariables = Exact<{
  data: SavePostsToCollectionsInput;
}>;


export type SavePostsToCollectionsForContentIdeaPreviewMutation = { __typename?: 'Mutation', savePostsToCollections: { __typename?: 'Result', success: boolean, message: string } };

export type UpdateCollectionPreviewForContentIdeaPreviewMutationVariables = Exact<{
  data: UpdateCollectionPreviewInput;
}>;


export type UpdateCollectionPreviewForContentIdeaPreviewMutation = { __typename?: 'Mutation', updateCollectionPreview?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type ContentIdeaPublishMetadataFragmentContentIdeaPublishMetadataPublishUrlCustomFieldFragment = { __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null };

export type UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationVariables = Exact<{
  data: UpdateContentIdeaPublishMetadataInput;
}>;


export type UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation = { __typename?: 'Mutation', updateContentIdeaPublishMetadata: { __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null } };

export type ContentIdeaFragmentContentIdeaReminderModalFragment = { __typename?: 'ContentIdeaModel', id: string, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } };

export type UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationVariables = Exact<{
  data: UpdateContentIdeaFieldValueInput;
}>;


export type UpdateContentIdeaFieldValueForContentIdeaReminderModalMutation = { __typename?: 'Mutation', updateContentIdeaFieldValue: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } };

export type ContentIdeaFragmentContentIdeaSnoozeDateFragment = { __typename?: 'ContentIdeaModel', id: string, snoozeDate?: any | null, stage: Stage, myPermissions: Array<ContentIdeaPermission> };

export type UpdateContentIdeaForContentIdeaSnoozeDateMutationVariables = Exact<{
  data: UpdateContentIdeaInput;
}>;


export type UpdateContentIdeaForContentIdeaSnoozeDateMutation = { __typename?: 'Mutation', updateContentIdea: { __typename?: 'ContentIdeaModel', id: string, snoozeDate?: any | null, stage: Stage, myPermissions: Array<ContentIdeaPermission> } };

export type RemoveSnoozeForContentIdeaSnoozeDateMutationVariables = Exact<{
  contentIdeaId: Scalars['String'];
}>;


export type RemoveSnoozeForContentIdeaSnoozeDateMutation = { __typename?: 'Mutation', removeContentIdeaFromSnooze: { __typename?: 'ContentIdeaModel', id: string, snoozeDate?: any | null, stage: Stage, myPermissions: Array<ContentIdeaPermission> } };

export type ContentIdeaFragmentContentIdeaStatusFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null }, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } };

export type GetContentIdeaForContentIdeaStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentIdeaForContentIdeaStatusQuery = { __typename?: 'Query', contentIdea: { __typename?: 'ContentIdeaModel', id: string, stage: Stage } };

export type GetContentIdeaViewersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentIdeaViewersQuery = { __typename?: 'Query', contentIdea: { __typename?: 'ContentIdeaModel', id: string, viewers: Array<{ __typename?: 'ContentIdeaViewerModel', lastSeen?: any | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> } };

export type ContentIdeaFragmentContentIdeaViewersFragment = { __typename?: 'ContentIdeaModel', id: string, viewers: Array<{ __typename?: 'ContentIdeaViewerModel', lastSeen?: any | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> };

export type ContentIdeaFieldOptionFragmentContentIdeaFieldOptionHandlersFragment = { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string };

export type CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables = Exact<{
  data: CreateContentIdeaFieldOptionInput;
}>;


export type CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation = { __typename?: 'Mutation', createContentIdeaFieldOption: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } };

export type DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables = Exact<{
  data: DeleteContentIdeaFieldOptionInput;
}>;


export type DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation = { __typename?: 'Mutation', deleteContentIdeaFieldOption: { __typename?: 'Result', message: string, success: boolean } };

export type UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables = Exact<{
  data: UpdateContentIdeaFieldOptionInput;
}>;


export type UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation = { __typename?: 'Mutation', updateContentIdeaFieldOption: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } };

export type ContentIdeaFragmentContentIdeaCalendarEventPublishedViewFragment = { __typename?: 'ContentIdeaModel', id: string, name: string, noteContent?: string | null, myPermissions: Array<ContentIdeaPermission>, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null } | null } | null }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> | null } | null }, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> | null } | null }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, collection: { __typename?: 'CollectionModel', id: string }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null };

export type ContentIdeaFragmentContentIdeaCalendarEventViewFragment = { __typename?: 'ContentIdeaModel', id: string, name: string, noteContent?: string | null, myPermissions: Array<ContentIdeaPermission>, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null } | null } | null }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> | null } | null }, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null }, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, collection: { __typename?: 'CollectionModel', id: string }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }> };

export type ContentIdeaFieldFragmentContentIdeaDetailViewFragment = { __typename?: 'ContentIdeaFieldModel', id: string, sortOrder: number, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean };

export type ContentIdeaFragmentContentIdeaDetailViewFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, noteContent?: string | null, name: string, roomId?: string | null, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, fields: Array<{ __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, sortOrder: number, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null, date?: any | null, checkbox?: boolean | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null }>, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } };

export type CreateContentIdeaFieldForContentIdeaDetailViewMutationVariables = Exact<{
  data: CreateContentIdeaFieldInput;
}>;


export type CreateContentIdeaFieldForContentIdeaDetailViewMutation = { __typename?: 'Mutation', createContentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean } };

export type GetCollectionForContentIdeaDetailViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionForContentIdeaDetailViewQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, myPermissions: Array<PostPermission>, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, childCollections: Array<{ __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }> } };

export type UpdateContentIdeaFieldForContentIdeaDetailViewMutationVariables = Exact<{
  data: UpdateContentIdeaFieldInput;
}>;


export type UpdateContentIdeaFieldForContentIdeaDetailViewMutation = { __typename?: 'Mutation', updateContentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, sortOrder: number, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean } };

export type ContentIdeaFragmentContentIdeaListItemViewFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, noteContent?: string | null, name: string, snoozeDate?: any | null, stage: Stage, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null } };

export type ContentIdeaFragmentContentIdeaTableViewFragment = { __typename?: 'ContentIdeaModel', id: string, stage: Stage, myPermissions: Array<ContentIdeaPermission>, noteContent?: string | null, name: string, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', bgcolor?: string | null, id: string, value: string, label: string }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', bgcolor?: string | null, id: string, value: string, label: string }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null } };

export type GetContentIdeasForContentIdeaTableViewQueryVariables = Exact<{
  filters: ContentIdeaFilters;
  sortBy?: InputMaybe<SortByInputData>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetContentIdeasForContentIdeaTableViewQuery = { __typename?: 'Query', contentIdeas: { __typename?: 'PaginatedContentIdeaSearchResult', data: Array<{ __typename?: 'ContentIdeaModel', id: string, stage: Stage, myPermissions: Array<ContentIdeaPermission>, noteContent?: string | null, name: string, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', bgcolor?: string | null, id: string, value: string, label: string }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', bgcolor?: string | null, id: string, value: string, label: string }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateContentIdeaForContentIdeaTableViewMutationVariables = Exact<{
  data: CreateContentIdeaInput;
}>;


export type CreateContentIdeaForContentIdeaTableViewMutation = { __typename?: 'Mutation', createContentIdea: { __typename?: 'ContentIdeaModel', id: string, stage: Stage, myPermissions: Array<ContentIdeaPermission>, noteContent?: string | null, name: string, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', bgcolor?: string | null, id: string, value: string, label: string }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', bgcolor?: string | null, id: string, value: string, label: string }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null } } };

export type CreatorFragmentCreatorAvatarFragment = { __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null };

export type CreatorFragmentCreatorHandleChipFragment = { __typename?: 'CreatorModel', id: string, handle: string, platform: Platform };

export type CreatorFragmentCreatorAvatarWithNameViewFragment = { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null };

export type GetCollectionByIdsForDndCollectionDragPreviewQueryVariables = Exact<{
  input: GetCollectionByIdsInput;
}>;


export type GetCollectionByIdsForDndCollectionDragPreviewQuery = { __typename?: 'Query', collectionByIds: Array<{ __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }> };

export type GetPostByIdsForDndPostDragPreviewQueryVariables = Exact<{
  input: GetPostByIdsInput;
}>;


export type GetPostByIdsForDndPostDragPreviewQuery = { __typename?: 'Query', postByIds: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type ConsumeShareLinkForUseInvitationThroughLinkMutationVariables = Exact<{
  data: ConsumeShareLinkInput;
}>;


export type ConsumeShareLinkForUseInvitationThroughLinkMutation = { __typename?: 'Mutation', consumeShareLink: { __typename?: 'Result', success: boolean, message: string } };

export type GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, createdByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } };

export type UpdateUserOnboardingStateForJuiceboxIntroPopupMutationVariables = Exact<{
  data: UpdateUserOnboardingStateInput;
}>;


export type UpdateUserOnboardingStateForJuiceboxIntroPopupMutation = { __typename?: 'Mutation', updateUserOnboardingState: { __typename?: 'MeModel', id: string, onboardingState?: { __typename?: 'OnboardingStateData', haveSeenJuiceBoxIntro?: boolean | null, haveClickedJuiceBoxBtn?: boolean | null } | null } };

export type PostFragmentJuicePostLayoutFragment = { __typename?: 'PostModel', id: string, permissionLevel: PermissionLevel, generalPermission: GeneralPermission, title?: string | null, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, description: string, createdAt: any, color: string, updatedAt: any, socialPostId?: string | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null };

export type GetCollectionForJuiceboxPostLayoutQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForJuiceboxPostLayoutQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } } };

export type PostFragmentJuiceboxAttachmentSearchItemFragment = { __typename?: 'PostModel', id: string, type: PostType, attachment?: { __typename?: 'AttachmentModel', id: string, name: string, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> };

export type CollectionFragmentJuiceboxCollectionSearchItemFragment = { __typename?: 'CollectionModel', id: string, name: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> };

export type PostFragmentJuiceboxLinkSearchItemFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type PostFragmentJuiceboxNoteSearchItemFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type GetAttachmentsForJuiceboxAttachmentSearchResultQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type GetAttachmentsForJuiceboxAttachmentSearchResultQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', attachmentSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, type: PostType, attachment?: { __typename?: 'AttachmentModel', id: string, name: string, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null } } };

export type GetCollectionsForJuiceboxCollectionSearchResultQueryVariables = Exact<{
  data: UniversalSearchInput;
  postCount?: InputMaybe<Scalars['Int']>;
  previewableFirst?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCollectionsForJuiceboxCollectionSearchResultQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', collectionSearchResult: { __typename?: 'CollectionSearchResult', totalCount: number, hits: Array<{ __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetLinksForJuiceboxLinkSearchResultQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type GetLinksForJuiceboxLinkSearchResultQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', linkSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetNotesForJuiceboxLinkSearchResultQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type GetNotesForJuiceboxLinkSearchResultQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', noteSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetRecentSearchQueriesForJuiceboxRecentSearchResultQuery = { __typename?: 'Query', getRecentSearchQueries: { __typename?: 'PaginatedSearchClickedResult', data: Array<{ __typename?: 'SearchClickedResultModel', query?: string | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryVariables = Exact<{
  searchableEntityTypes: Array<SearchableEntityType> | SearchableEntityType;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  postCount?: InputMaybe<Scalars['Int']>;
  previewableFirst?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRecentlyOpenedQueriesForJuiceboxSearchResultQuery = { __typename?: 'Query', getSearchesClicked: { __typename?: 'PaginatedSearchClickedResult', data: Array<{ __typename?: 'SearchClickedResultModel', collection?: { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, attachment?: { __typename?: 'AttachmentModel', id: string, name: string, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CollectionFragmentJuiceboxSelectContextFragment = { __typename?: 'CollectionModel', id: string, isPinnedToParent: boolean, isPinnedToRoot: boolean };

export type PostFragmentJuiceboxSelectContextFragment = { __typename?: 'PostModel', id: string, isFavorite: boolean, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', type?: string | null, site?: string | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> };

export type GetPostByIdsForJuiceboxSelectContextQueryVariables = Exact<{
  input: GetPostByIdsInput;
}>;


export type GetPostByIdsForJuiceboxSelectContextQuery = { __typename?: 'Query', postByIds: Array<{ __typename?: 'PostModel', id: string, isFavorite: boolean, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', type?: string | null, site?: string | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> }> };

export type GetCollectionByIdsForJuiceboxSelectContextQueryVariables = Exact<{
  input: GetCollectionByIdsInput;
}>;


export type GetCollectionByIdsForJuiceboxSelectContextQuery = { __typename?: 'Query', collectionByIds: Array<{ __typename?: 'CollectionModel', id: string, isPinnedToParent: boolean, isPinnedToRoot: boolean }> };

export type CollectionFragmentJuiceboxCollectionSelectButtonFilterFragment = { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryVariables = Exact<{
  filters: CollectionFilters;
  take?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<SortType>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', data: Array<{ __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DeletePostsForCollectionPostContextMenuMutationVariables = Exact<{
  data: DeletePostsInput;
}>;


export type DeletePostsForCollectionPostContextMenuMutation = { __typename?: 'Mutation', deletePosts: { __typename?: 'Result', message: string, success: boolean } };

export type DeleteCollectionsForCollectionPostContextMenuMutationVariables = Exact<{
  data: DeleteCollectionsInput;
}>;


export type DeleteCollectionsForCollectionPostContextMenuMutation = { __typename?: 'Mutation', deleteCollections: { __typename?: 'Result', message: string, success: boolean } };

export type AddPostsToCollectionForCollectionPostContextMenuMutationVariables = Exact<{
  data: SavePostsToCollectionsInput;
}>;


export type AddPostsToCollectionForCollectionPostContextMenuMutation = { __typename?: 'Mutation', savePostsToCollections: { __typename?: 'Result', message: string, success: boolean } };

export type CreatePostsFavoriteForCollectionPostContextMenuMutationVariables = Exact<{
  data: CreatePostsFavoriteInput;
}>;


export type CreatePostsFavoriteForCollectionPostContextMenuMutation = { __typename?: 'Mutation', createPostsFavorite: Array<{ __typename?: 'PostFavoriteModel', id: string }> };

export type DeletePostsFavoriteForCollectionPostContextMenuMutationVariables = Exact<{
  data: DeletePostsFavoriteInput;
}>;


export type DeletePostsFavoriteForCollectionPostContextMenuMutation = { __typename?: 'Mutation', deletePostsFavorite: { __typename?: 'Result', success: boolean, message: string } };

export type MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables = Exact<{
  data: MoveCollectionsToCollectionInput;
}>;


export type MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation = { __typename?: 'Mutation', moveCollectionsToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables = Exact<{
  data: MovePostsToCollectionInput;
}>;


export type MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation = { __typename?: 'Mutation', movePostsToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables = Exact<{
  data: IsCollectionsPermissionLessThanParentCollectionPermissionInput;
}>;


export type IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery = { __typename?: 'Query', isCollectionsPermissionLessThanParentCollectionPermission: boolean };

export type IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables = Exact<{
  data: IsPostsPermissionLessThanParentCollectionPermissionInput;
}>;


export type IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery = { __typename?: 'Query', isPostsPermissionLessThanParentCollectionPermission: boolean };

export type CollectionFragmentSelectModeFragment = { __typename?: 'CollectionModel', id: string };

export type PostFragmentSelectModeFragment = { __typename?: 'PostModel', id: string };

export type GetFiltersSearchForJuiceboxFilterSuggestionViewQueryVariables = Exact<{
  data: FilterSearchInput;
}>;


export type GetFiltersSearchForJuiceboxFilterSuggestionViewQuery = { __typename?: 'Query', filtersSearch: { __typename?: 'FiltersSearch', type?: Array<string> | null, reaction?: Array<ReactionFilterType> | null, dateModified?: Array<DateFilterType> | null, collections?: Array<{ __typename?: 'CollectionModel', id: string, name: string }> | null, createdBy?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null, sharedBy?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } };

export type GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryVariables = Exact<{
  searchableEntityTypes: Array<SearchableEntityType> | SearchableEntityType;
  take?: InputMaybe<Scalars['Int']>;
  postCount?: InputMaybe<Scalars['Int']>;
  previewableFirst?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery = { __typename?: 'Query', getSearchesClicked: { __typename?: 'PaginatedSearchClickedResult', data: Array<{ __typename?: 'SearchClickedResultModel', collection?: { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, attachment?: { __typename?: 'AttachmentModel', id: string, name: string, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> } | null }> } };

export type GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery = { __typename?: 'Query', getRecentSearchQueries: { __typename?: 'PaginatedSearchClickedResult', data: Array<{ __typename?: 'SearchClickedResultModel', query?: string | null }> } };

export type GetUniversalSearchForJuiceboxFilterSuggestionViewQueryVariables = Exact<{
  data: UniversalSearchInput;
  postCount?: InputMaybe<Scalars['Int']>;
  previewableFirst?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUniversalSearchForJuiceboxFilterSuggestionViewQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', noteSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> }, linkSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> }, collectionSearchResult: { __typename?: 'CollectionSearchResult', totalCount: number, hits: Array<{ __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } }> }, attachmentSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, type: PostType, attachment?: { __typename?: 'AttachmentModel', id: string, name: string, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> } }> }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreateSearchHitForJuiceboxFilterSuggestionViewMutationVariables = Exact<{
  data: SearchHitClickInput;
}>;


export type CreateSearchHitForJuiceboxFilterSuggestionViewMutation = { __typename?: 'Mutation', createSearchClicked: { __typename?: 'SearchClickedResultModel', query?: string | null } };

export type CollectionFragmentJuiceboxTableCollectionTableRowFragment = { __typename?: 'CollectionModel', id: string, isDisabled: boolean, totalPosts: number, totalChildCollections: number, name: string, generalPermission: GeneralPermission, organizationName: string, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragment = { __typename?: 'CollectionModel', id: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, name: string, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type CollectionFragmentJuiceboxTableCollectionTableRowCellActivityFragment = { __typename?: 'CollectionModel', id: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean };

export type CollectionFragmentJuiceboxTableCollectionTableRowCellNameFragment = { __typename?: 'CollectionModel', id: string, isDisabled: boolean, name: string };

export type CollectionFragmentJuiceboxTableCollectionTableRowCellPermissionFragment = { __typename?: 'CollectionModel', id: string, generalPermission: GeneralPermission, organizationName: string, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type CollectionFragmentJuiceboxTableCollectionTableRowCellPreviewFragment = { __typename?: 'CollectionModel', id: string, isDisabled: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type CollectionFragmentJuiceboxTableCollectionTableRowCellSelectIconFragment = { __typename?: 'CollectionModel', id: string, isDisabled: boolean };

export type PostFragmentJuiceboxTablePostTableRowFragment = { __typename?: 'PostModel', id: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, generalPermission: GeneralPermission, organizationName: string, unreadCommentCount: number, color: string, updatedAt: any, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type PostFragmentJuiceboxTablePostTableRowWithContextMenuFragment = { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, generalPermission: GeneralPermission, organizationName: string, unreadCommentCount: number, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type PostFragmentJuiceboxTablePostTableRowCellActivityFragment = { __typename?: 'PostModel', id: string, unreadCommentCount: number };

export type PostFragmentJuiceboxTablePostTableRowCellNameFragment = { __typename?: 'PostModel', id: string, title?: string | null, myPermissions: Array<PostPermission>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type PostFragmentJuiceboxTablePostTableRowCellPermissionFragment = { __typename?: 'PostModel', id: string, generalPermission: GeneralPermission, organizationName: string, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type PostFragmentJuiceboxTablePostTableRowCellPreviewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type PostFragmentJuiceboxTablePostTableRowCellSelectIconFragment = { __typename?: 'PostModel', id: string };

export type CollectionFragmentUseCustomCollectionNestedTableDataFragment = { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, creatorId: string, parentCollectionId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type PostFragmentUseCustomCollectionNestedTableDataFragment = { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, generalPermission: GeneralPermission, organizationName: string, unreadCommentCount: number, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<SortType>;
}>;


export type GetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, generalPermission: GeneralPermission, organizationName: string, unreadCommentCount: number, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
}>;


export type GetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery = { __typename?: 'Query', contentIdeaCollections: { __typename?: 'PaginatedCollectionResult', data: Array<{ __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, creatorId: string, parentCollectionId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CollectionFragmentUseNormalCollectionNestedTableDataFragment = { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, creatorId: string, parentCollectionId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables = Exact<{
  filters: CollectionFilters;
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type CollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'CollectionSearchHit', type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, creatorId: string, parentCollectionId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } }> } };

export type PostFragmentUseNormalCollectionNestedTableDataFragment = { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, generalPermission: GeneralPermission, organizationName: string, unreadCommentCount: number, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<SortType>;
}>;


export type GetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, generalPermission: GeneralPermission, organizationName: string, unreadCommentCount: number, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetCollectionForCjbWindowCollectionListSectionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionForCjbWindowCollectionListSectionQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } };

export type DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationVariables = Exact<{
  data: DeleteManuallyParsedSocialPostTrackerInput;
}>;


export type DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation = { __typename?: 'Mutation', deleteManuallyParsedSocialPostTracker: { __typename?: 'Result', success: boolean, message: string } };

export type ManuallyParsedSocialPostTrackerFragmentMpsptOutboundCommentCardFragment = { __typename?: 'ManuallyParsedSocialPostTrackerModel', id: string, createdAt: any, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }, parsedByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryVariables = Exact<{
  filters: ManuallyParsedSocialPostTrackerFilters;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery = { __typename?: 'Query', manuallyParsedSocialPostTrackers: { __typename?: 'PaginatedManuallyParsedSocialPostTrackerSearchResult', data: Array<{ __typename?: 'ManuallyParsedSocialPostTrackerModel', id: string, createdAt: any, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }, parsedByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, meta: { __typename?: 'PaginatedManuallyParsedSocialPostTrackerPaginationMeta', totalCount: number } } };

export type UpdateUserPersonalSettingsMutationVariables = Exact<{
  data: UpdateUserPersonalSettingsInput;
}>;


export type UpdateUserPersonalSettingsMutation = { __typename?: 'Mutation', updateUserPersonalSettings: { __typename?: 'MeModel', id: string, personalSettings?: { __typename?: 'PersonalSettings', postGeneralPermissionDefault?: GeneralPermission | null, postGeneralPermissionDefaultPermissionLevel?: PermissionLevel | null, collectionGeneralPermissionDefault?: GeneralPermission | null, collectionGeneralPermissionDefaultPermissionLevel?: PermissionLevel | null } | null } };

export type UpdateNoteColorMutationVariables = Exact<{
  data: UpdatePostInput;
}>;


export type UpdateNoteColorMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostModel', id: string, color: string } };

export type PostFragmentNoteColorFragment = { __typename?: 'PostModel', id: string, color: string };

export type GetPostAnnotationsForUseValidateCommentsQueryVariables = Exact<{
  filters?: InputMaybe<PostAnnotationFilters>;
}>;


export type GetPostAnnotationsForUseValidateCommentsQuery = { __typename?: 'Query', postAnnotations: Array<{ __typename?: 'PostAnnotationModel', id: string, noteCommentAnchorId?: string | null }> };

export type UpdateNoteTitleMutationVariables = Exact<{
  data: UpdatePostInput;
}>;


export type UpdateNoteTitleMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostModel', id: string, title?: string | null } };

export type PostFragmentNoteTitleFragment = { __typename?: 'PostModel', id: string, title?: string | null, color: string };

export type UpdateNoteBodyMutationVariables = Exact<{
  data: UpdatePostInput;
}>;


export type UpdateNoteBodyMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostModel', id: string, body?: string | null } };

export type PostFragmentCollaborativeNoteViewFragment = { __typename?: 'PostModel', id: string, roomId?: string | null, body?: string | null, myPermissions: Array<PostPermission>, title?: string | null, color: string };

export type PostFragmentNoteDetailContentViewFragment = { __typename?: 'PostModel', id: string, roomId?: string | null, body?: string | null, myPermissions: Array<PostPermission>, title?: string | null, color: string, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }> };

export type UpdateNoteForNoteDetailContentViewMutationVariables = Exact<{
  data: UpdatePostInput;
}>;


export type UpdateNoteForNoteDetailContentViewMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostModel', id: string, title?: string | null, body?: string | null, type: PostType, description: string, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationName: string, permissionLevel: PermissionLevel, roomId?: string | null, color: string, updatedAt: any, socialPostId?: string | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null } };

export type PostFragmentNoteViewFragment = { __typename?: 'PostModel', id: string, body?: string | null, myPermissions: Array<PostPermission>, title?: string | null, color: string };

export type NotificationFragmentCommentBodyFragment = { __typename?: 'NotificationModel', id: string, comment?: { __typename?: 'CommentModel', id: string, text: string, parentComment?: { __typename?: 'CommentModel', id: string, text: string } | null } | null };

export type NotificationFragmentAssignedToContentIdeaBodyFragment = { __typename?: 'NotificationModel', id: string, createdAt: any, contentIdea?: { __typename?: 'ContentIdeaModel', id: string, name: string } | null };

export type NotificationFragmentInvitedToContentIdeaBodyFragment = { __typename?: 'NotificationModel', id: string, createdAt: any, contentIdea?: { __typename?: 'ContentIdeaModel', id: string, name: string } | null };

export type NotificationFragmentReminderForContentIdeaBodyFragment = { __typename?: 'NotificationModel', id: string, createdAt: any, contentIdea?: { __typename?: 'ContentIdeaModel', id: string, name: string } | null };

export type NotificationFragmentCreatorAvatarFragment = { __typename?: 'NotificationModel', id: string, createdByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type NotificationFragmentCreatorNameFragment = { __typename?: 'NotificationModel', id: string, createdByUser: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string } };

export type NotificationFragmentHeaderFragment = { __typename?: 'NotificationModel', id: string, type: NotificationType, collection?: { __typename?: 'CollectionModel', id: string, name: string } | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null } | null, task?: { __typename?: 'TaskModel', id: string, name: string } | null, permissionRequest?: { __typename?: 'PermissionRequestModel', id: string, postId?: string | null, collectionId?: string | null, post?: { __typename?: 'PostModel', id: string, type: PostType } | null, brand?: { __typename?: 'BrandModel', id: string, name: string } | null } | null };

export type NotificationFragmentCollectionHeaderFragment = { __typename?: 'NotificationModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, name: string } | null };

export type NotificationFragmentPostHeaderFragment = { __typename?: 'NotificationModel', id: string, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null } | null };

export type NotificationFragmentTaskHeaderFragment = { __typename?: 'NotificationModel', id: string, task?: { __typename?: 'TaskModel', id: string, name: string } | null };

export type NotificationFragmentPermissionRequestHeaderFragment = { __typename?: 'NotificationModel', id: string, permissionRequest?: { __typename?: 'PermissionRequestModel', id: string, postId?: string | null, collectionId?: string | null, post?: { __typename?: 'PostModel', id: string, type: PostType } | null, brand?: { __typename?: 'BrandModel', id: string, name: string } | null } | null };

export type NotificationFragmentInviteBodyFragment = { __typename?: 'NotificationModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, name: string } | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null } | null, collectionInviteMember?: { __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel } | null, postInviteMember?: { __typename?: 'PostInviteMemberModel', id: string, permissionLevel: PermissionLevel } | null, brandInviteMember?: { __typename: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }> }, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } } | null };

export type NotificationFragmentNotificationMultiplePostInviteBodyFragment = { __typename?: 'NotificationModel', id: string, createdAt: any, type: NotificationType, posts?: Array<{ __typename?: 'PostModel', id: string }> | null, createdByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type NotificationFragmentNotificationMultiplePostMentionBodyFragment = { __typename?: 'NotificationModel', id: string, createdAt: any, type: NotificationType, data?: any | null, posts?: Array<{ __typename?: 'PostModel', id: string }> | null, createdByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type UnreadNotificationForNotificationMoreMenuMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UnreadNotificationForNotificationMoreMenuMutation = { __typename?: 'Mutation', unreadNotification: { __typename?: 'NotificationModel', id: string, status: NotificationStatus } };

export type ReadNotificationForNotificationMoreMenuMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReadNotificationForNotificationMoreMenuMutation = { __typename?: 'Mutation', readNotification: { __typename?: 'NotificationModel', id: string, status: NotificationStatus } };

export type NotificationFragmentMoreMenuFragment = { __typename?: 'NotificationModel', id: string, status: NotificationStatus, type: NotificationType, collection?: { __typename?: 'CollectionModel', id: string } | null, post?: { __typename?: 'PostModel', id: string, type: PostType } | null, task?: { __typename?: 'TaskModel', id: string } | null, organizationUserAccessRequest?: { __typename?: 'OrganizationUserAccessRequestModel', id: string } | null, contentIdea?: { __typename?: 'ContentIdeaModel', id: string } | null, permissionRequest?: { __typename?: 'PermissionRequestModel', id: string, collection?: { __typename?: 'CollectionModel', id: string } | null, post?: { __typename?: 'PostModel', id: string, type: PostType } | null } | null, socialPostsNotificationData?: { __typename?: 'SocialPostsNotificationDataModel', id: string, socialPosts: Array<{ __typename?: 'SocialPostModel', id: string }> } | null };

export type NotificationFragmentPermissionRequestBodyFragment = { __typename?: 'NotificationModel', id: string, createdAt: any, permissionRequest?: { __typename?: 'PermissionRequestModel', id: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, brand?: { __typename?: 'BrandModel', id: string, name: string } | null } | null };

export type NotificationFragmentPreviewAssetsFragment = { __typename?: 'NotificationModel', id: string, permissionRequest?: { __typename?: 'PermissionRequestModel', post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null } | null, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, posts?: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> | null };

export type NotificationFragmentNotificationSlBrandReachedUsageLimitBodyFragment = { __typename?: 'NotificationModel', id: string, type: NotificationType, data?: any | null, createdAt: any };

export type NotificationFragmentTaskBodyFragment = { __typename?: 'NotificationModel', id: string, task?: { __typename?: 'TaskModel', id: string, name: string } | null };

export type NotificationFragmentUserReactionFragment = { __typename?: 'NotificationModel', id: string, userReaction?: { __typename?: 'UserReactionModel', id: string, emoji: string, commentId?: string | null } | null };

export type NotificationFragmentAggregatedCardViewFragment = { __typename?: 'NotificationModel', id: string, type: NotificationType, status: NotificationStatus, createdAt: any, data?: any | null, organizationUserAccessRequest?: { __typename?: 'OrganizationUserAccessRequestModel', id: string } | null, contentIdea?: { __typename?: 'ContentIdeaModel', id: string } | null, socialPostsNotificationData?: { __typename?: 'SocialPostsNotificationDataModel', id: string, socialPosts: Array<{ __typename?: 'SocialPostModel', id: string }> } | null, createdByUser: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, posts?: Array<{ __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }> | null, permissionRequest?: { __typename?: 'PermissionRequestModel', id: string, postId?: string | null, collectionId?: string | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, brand?: { __typename?: 'BrandModel', id: string, name: string } | null } | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, userReaction?: { __typename?: 'UserReactionModel', id: string, emoji: string, commentId?: string | null } | null, task?: { __typename?: 'TaskModel', id: string, name: string } | null };

export type NotificationFragmentCardViewFragment = { __typename?: 'NotificationModel', id: string, type: NotificationType, status: NotificationStatus, createdAt: any, data?: any | null, socialPostsNotificationData?: { __typename?: 'SocialPostsNotificationDataModel', id: string, socialPosts: Array<{ __typename?: 'SocialPostModel', id: string }> } | null, createdByUser: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comment?: { __typename?: 'CommentModel', id: string, text: string, parentComment?: { __typename?: 'CommentModel', id: string, text: string } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collectionInviteMember?: { __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel } | null, postInviteMember?: { __typename?: 'PostInviteMemberModel', id: string, permissionLevel: PermissionLevel } | null, brandInviteMember?: { __typename: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }> }, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } } | null, task?: { __typename?: 'TaskModel', id: string, name: string } | null, permissionRequest?: { __typename?: 'PermissionRequestModel', id: string, postId?: string | null, collectionId?: string | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, brand?: { __typename?: 'BrandModel', id: string, name: string } | null } | null, posts?: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, description: string, color: string, updatedAt: any, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }> | null, userReaction?: { __typename?: 'UserReactionModel', id: string, emoji: string, commentId?: string | null } | null, organizationUserAccessRequest?: { __typename?: 'OrganizationUserAccessRequestModel', id: string } | null, contentIdea?: { __typename?: 'ContentIdeaModel', id: string, name: string } | null };

export type PostFragmentOnboardingPostNoteCardFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CreateNotePostForOnboardingNoteMutationVariables = Exact<{
  data: CreateNotePostInput;
}>;


export type CreateNotePostForOnboardingNoteMutation = { __typename?: 'Mutation', createNotePost: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } };

export type UpdatePostForOnboardingNoteMutationVariables = Exact<{
  data: UpdatePostInput;
}>;


export type UpdatePostForOnboardingNoteMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } };

export type PostFragmentPostQueryForOnboardingPostCardFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type GetPostByIdForOnboardingPostCardQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostByIdForOnboardingPostCardQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, description: string, myPermissions: Array<PostPermission>, color: string, updatedAt: any, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } | null };

export type GetPostsForOnboardingPostCardQueryVariables = Exact<{
  filters: PostFilters;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetPostsForOnboardingPostCardQuery = { __typename?: 'Query', posts: { __typename?: 'PaginatedPostSearchResult', data: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type OrganizationProfileFragmentOrganizationAvatarWithNameFragment = { __typename?: 'OrganizationProfileModel', id: string, name: string, users: Array<{ __typename?: 'UserProfileModel', id: string }> };

export type GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryVariables = Exact<{
  filters: PermittedCollectionFilters;
}>;


export type GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery = { __typename?: 'Query', permittedCollections: Array<{ __typename?: 'PermittedCollectionModel', id: string, permissionLevel?: PermissionLevel | null, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null }> };

export type PermittedCollectionFragmentOrganizationMembersPermittedCollectionListItemFragment = { __typename?: 'PermittedCollectionModel', id: string, permissionLevel?: PermissionLevel | null, collection?: { __typename?: 'CollectionModel', id: string, name: string } | null };

export type GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryVariables = Exact<{
  filters: PermittedPostFilters;
}>;


export type GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery = { __typename?: 'Query', permittedPosts: Array<{ __typename?: 'PermittedPostModel', id: string, permissionLevel?: PermissionLevel | null, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null }> };

export type UserFragmentUseOrgMemberManagementFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null };

export type InviteUsersToCurrentOrgForUseOrgMemberManagementMutationVariables = Exact<{
  data: InviteUsersToCurrentOrgInput;
}>;


export type InviteUsersToCurrentOrgForUseOrgMemberManagementMutation = { __typename?: 'Mutation', inviteUsersToCurrentOrg: Array<{ __typename?: 'UserProfileModel', id: string }> };

export type InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationVariables = Exact<{
  data: InviteUsersToCurrentOrgByRoleInput;
}>;


export type InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation = { __typename?: 'Mutation', inviteUsersToCurrentOrgByRoles: Array<{ __typename?: 'UserProfileModel', id: string }> };

export type UserFragmentAddUsersToOrgViewManageUsersListFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null };

export type UserFragmentAddUsersToOrgViewMemberUserRoleSelectionFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null };

export type UserFragmentAddUsersToOrgViewFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null };

export type UserProfileFragmentGuestMembersTableFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, title: string, createdAt: any, role?: InternalOrganizationRole | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null };

export type UpdateBrandPermissionsForInternalMembersMutationVariables = Exact<{
  data: UpdateBrandPermissionsInput;
}>;


export type UpdateBrandPermissionsForInternalMembersMutation = { __typename?: 'Mutation', updateBrandPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type UserProfileFragmentInternalMembersFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, title: string, createdAt: any, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } };

export type UpdateBrandPermissionsForMembersViewMutationVariables = Exact<{
  data: UpdateBrandPermissionsInput;
}>;


export type UpdateBrandPermissionsForMembersViewMutation = { __typename?: 'Mutation', updateBrandPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type OrganizationUserAccessRequestFragmentUserApprovalRequestsTableFragment = { __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', role?: InternalOrganizationRole | null, hasSignedUp?: boolean | null, id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }, invitedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null };

export type UpdateBrandPermissionsForUserApprovalRequestsTableMutationVariables = Exact<{
  data: UpdateBrandPermissionsInput;
}>;


export type UpdateBrandPermissionsForUserApprovalRequestsTableMutation = { __typename?: 'Mutation', updateBrandPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationVariables = Exact<{
  data: UpdateOrganizationUserAccessRequestInput;
}>;


export type UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation = { __typename?: 'Mutation', updatePendingOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string } };

export type RestrictAccessForUserForMembersViewMutationVariables = Exact<{ [key: string]: never; }>;


export type RestrictAccessForUserForMembersViewMutation = { __typename?: 'Mutation', restrictAccessForUser: { __typename?: 'Result', message: string, success: boolean } };

export type UnrestrictAccessForUserForMembersViewMutationVariables = Exact<{ [key: string]: never; }>;


export type UnrestrictAccessForUserForMembersViewMutation = { __typename?: 'Mutation', unrestrictAccessForUser: { __typename?: 'Result', message: string, success: boolean } };

export type GetMyPendingOrganizationAccessRequestsForAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPendingOrganizationAccessRequestsForAdminQuery = { __typename?: 'Query', myPendingOrganizationAccessRequestsForAdmin: Array<{ __typename?: 'OrganizationUserAccessRequestModel', id: string, message?: string | null, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', role?: InternalOrganizationRole | null, hasSignedUp?: boolean | null, id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }, invitedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null }> };

export type PermissionRequestFragmentPermissionApproveRequestFragment = { __typename?: 'PermissionRequestModel', id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type UserProfileFragmentManageUsersInputFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null };

export type GenerateShareLinkForUseCopyLinkMutationVariables = Exact<{
  data: GenerateShareLinkInput;
}>;


export type GenerateShareLinkForUseCopyLinkMutation = { __typename?: 'Mutation', generateShareLink: { __typename?: 'ShareLinkModel', id: string, entityId: string, entityType: ShareEntityType, validationToken: string } };

export type PermissionRequestFragmentUsePermissionRequestHandlerFragment = { __typename?: 'PermissionRequestModel', postId?: string | null, collectionId?: string | null, brandId?: string | null, id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type CreatePermissionRequestForPermissionRequestHandlersMutationVariables = Exact<{
  data: CreatePermissionRequestInput;
}>;


export type CreatePermissionRequestForPermissionRequestHandlersMutation = { __typename?: 'Mutation', createPermissionRequest: { __typename?: 'PermissionRequestModel', postId?: string | null, collectionId?: string | null, brandId?: string | null, id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } } };

export type ApprovePermissionRequestForPermissionRequestHandlersMutationVariables = Exact<{
  data: ApprovePermissionRequestInput;
}>;


export type ApprovePermissionRequestForPermissionRequestHandlersMutation = { __typename?: 'Mutation', approvePermissionRequest: { __typename?: 'PermissionRequestModel', postId?: string | null, collectionId?: string | null, brandId?: string | null, id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } } };

export type RejectPermissionRequestForPermissionRequestHandlersMutationVariables = Exact<{
  data: RejectPermissionRequestInput;
}>;


export type RejectPermissionRequestForPermissionRequestHandlersMutation = { __typename?: 'Mutation', rejectPermissionRequest: { __typename?: 'PermissionRequestModel', postId?: string | null, collectionId?: string | null, brandId?: string | null, id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } } };

export type MyPermissionRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPermissionRequestsQuery = { __typename?: 'Query', myPermissionRequests: Array<{ __typename?: 'PermissionRequestModel', id: string, postId?: string | null, collectionId?: string | null, brandId?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string } }> };

export type GetOrganizationUsersForUsePermissionUsersSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationUsersForUsePermissionUsersSearchQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, organization: { __typename?: 'OrganizationModel', id: string, domain: string, externalUsers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }>, users: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }> } } };

export type PinManyCollectionsToParentMutationVariables = Exact<{
  data: PinManyCollectionsToParentInput;
}>;


export type PinManyCollectionsToParentMutation = { __typename?: 'Mutation', pinManyCollectionsToParent: Array<{ __typename?: 'PinnedEntityModel', id: string }> };

export type UnpinManyCollectionsFromParentMutationVariables = Exact<{
  data: UnpinManyCollectionsFromParentInput;
}>;


export type UnpinManyCollectionsFromParentMutation = { __typename?: 'Mutation', unpinManyCollectionsFromParent: { __typename?: 'Result', success: boolean, message: string, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type UnpinManyCollectionsFromRootMutationVariables = Exact<{
  data: UnpinCollectionsInput;
}>;


export type UnpinManyCollectionsFromRootMutation = { __typename?: 'Mutation', unpinCollectionsFromRoot: { __typename?: 'Result', success: boolean, message: string, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type PinCollectionToRootMutationVariables = Exact<{
  data: PinCollectionInput;
}>;


export type PinCollectionToRootMutation = { __typename?: 'Mutation', pinCollectionToRoot: { __typename?: 'PinnedEntityModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } | null } };

export type PinCollectionsToRootMutationVariables = Exact<{
  data: PinCollectionsInput;
}>;


export type PinCollectionsToRootMutation = { __typename?: 'Mutation', pinCollectionsToRoot: Array<{ __typename?: 'PinnedEntityModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } | null }> };

export type UnpinCollectionFromRootMutationVariables = Exact<{
  data: UnpinCollectionInput;
}>;


export type UnpinCollectionFromRootMutation = { __typename?: 'Mutation', unpinCollectionFromRoot: { __typename?: 'Result', success: boolean, message: string, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type PinManyPostsToCollectionMutationVariables = Exact<{
  data: PinManyPostsToCollectionInput;
}>;


export type PinManyPostsToCollectionMutation = { __typename?: 'Mutation', pinManyPostsToCollection: Array<{ __typename?: 'PinnedEntityModel', id: string }> };

export type UnpinManyPostsFromCollectionMutationVariables = Exact<{
  data: UnpinManyPostsFromCollectionInput;
}>;


export type UnpinManyPostsFromCollectionMutation = { __typename?: 'Mutation', unpinManyPostsFromCollection: { __typename?: 'Result', success: boolean, message: string, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type PostInviteMemberFragmentPostPermissionMemberFragment = { __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type SuggestedInviteMemberFragmentPostPermissionSuggestedMemberFragment = { __typename?: 'SuggestedInviteMember', permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type PostFragmentPostPermissionSummaryFragment = { __typename?: 'PostModel', id: string, generalPermission: GeneralPermission, organizationName: string, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type GetPostForUsePostPermissionsDialogViewQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostForUsePostPermissionsDialogViewQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, permissionLevel: PermissionLevel, generalPermission: GeneralPermission, title?: string | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } } | null };

export type UpdatePostPermissionsMutationVariables = Exact<{
  data: UpdatePostPermissionsInputV2;
}>;


export type UpdatePostPermissionsMutation = { __typename?: 'Mutation', updatePostPermissionsV2: { __typename?: 'Result', message: string, success: boolean } };

export type IsPostsPermissionLessThanParentCollectionPermissionQueryVariables = Exact<{
  data: IsPostsPermissionLessThanParentCollectionPermissionInput;
}>;


export type IsPostsPermissionLessThanParentCollectionPermissionQuery = { __typename?: 'Query', isPostsPermissionLessThanParentCollectionPermission: boolean };

export type GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string } };

export type PostFragmentPostPermissionDialogBodyFragment = { __typename?: 'PostModel', id: string, type: PostType, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, organizationId: string, organizationName: string, myPermissions: Array<PostPermission>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type PostFragmentPostPermissionDialogViewFragment = { __typename?: 'PostModel', id: string, permissionLevel: PermissionLevel, generalPermission: GeneralPermission, title?: string | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type GetPostPermissionForDialogViewQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostPermissionForDialogViewQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, type: PostType, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, organizationId: string, organizationName: string, myPermissions: Array<PostPermission>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string, note?: string | null, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } | null };

export type PostFragmentPostPermissionMasonryCardViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type PostSuggestedAuthFragmentPostPermissionSuggestedAuthDialogBodyFragment = { __typename?: 'PostSuggestedAuthModel', generalPermission: GeneralPermission, permissionLevel: PermissionLevel, suggestedInviteMembers: Array<{ __typename?: 'SuggestedInviteMember', permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryVariables = Exact<{
  collectionIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetPostSuggestedAuthForPostPermissionSuggestedDialogQuery = { __typename?: 'Query', getPostSuggestedAuth: { __typename?: 'PostSuggestedAuthModel', generalPermission: GeneralPermission, permissionLevel: PermissionLevel, suggestedInviteMembers: Array<{ __typename?: 'SuggestedInviteMember', permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } };

export type UpdatePostPermissionToCollectionPermissionMutationVariables = Exact<{
  data: UpdatePostPermissionToCollectionPermissionInput;
}>;


export type UpdatePostPermissionToCollectionPermissionMutation = { __typename?: 'Mutation', updatePostPermissionToCollectionPermission: { __typename?: 'Result', success: boolean, message: string } };

export type UpdateCollectionPermissionToParentCollectionPermissionMutationVariables = Exact<{
  data: UpdateCollectionPermissionToParentCollectionPermissionInput;
}>;


export type UpdateCollectionPermissionToParentCollectionPermissionMutation = { __typename?: 'Mutation', updateCollectionPermissionToParentCollectionPermission: { __typename?: 'Result', success: boolean, message: string } };

export type CollectionFragmentUpdatePostPermissionAlertViewFragment = { __typename?: 'CollectionModel', id: string, name: string };

export type PostFragmentAttachmentFragment = { __typename?: 'PostModel', attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type PostFragmentPostBookmarkButtonFragment = { __typename?: 'PostModel', id: string, isFavorite: boolean, isFavoriteTrend: boolean, trend?: { __typename?: 'TrendModel', id: string, title: string } | null };

export type GetPostForPostBookmarkPopoverQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForPostBookmarkPopoverQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, collections: Array<{ __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission>, name: string, generalPermission: GeneralPermission, organizationName: string, hasPreviewPost: boolean, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type CreatePostFavoriteForPostBookmarkButtonMutationVariables = Exact<{
  data: CreatePostFavoriteInputV2;
}>;


export type CreatePostFavoriteForPostBookmarkButtonMutation = { __typename?: 'Mutation', createPostFavoriteV2: { __typename?: 'PostFavoriteModel', id: string } };

export type DeletePostFavoriteForPostBookmarkButtonMutationVariables = Exact<{
  data: DeletePostFavoriteInputV2;
}>;


export type DeletePostFavoriteForPostBookmarkButtonMutation = { __typename?: 'Mutation', deletePostFavoriteV2: { __typename?: 'Result', success: boolean, message: string } };

export type AddPostToCollectionForPostBookmarkPopoverMutationVariables = Exact<{
  data: AddPostToCollectionInput;
}>;


export type AddPostToCollectionForPostBookmarkPopoverMutation = { __typename?: 'Mutation', addPostToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type RemovePostFromCollectionForPostBookmarkPopoverMutationVariables = Exact<{
  data: RemovePostFromCollectionInput;
}>;


export type RemovePostFromCollectionForPostBookmarkPopoverMutation = { __typename?: 'Mutation', removePostFromCollection: { __typename?: 'Result', success: boolean, message: string } };

export type PostFragmentPostCollectionListFragment = { __typename?: 'PostModel', id: string, myPermissions: Array<PostPermission>, isFavorite: boolean, isFavoriteTrend: boolean, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }> };

export type DeleteTrendFavoriteForPostCollectionListMutationVariables = Exact<{
  data: DeleteTrendFavoriteInput;
}>;


export type DeleteTrendFavoriteForPostCollectionListMutation = { __typename?: 'Mutation', deleteTrendFavorite: { __typename?: 'Result', success: boolean, message: string } };

export type GetPostForPostCollectionListQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForPostCollectionListQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, collections: Array<{ __typename?: 'CollectionModel', id: string, name: string, myPermissions: Array<CollectionPermission>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, contentIdeaId?: string | null, name: string }> }> } | null };

export type AddPostToCollectionForPostCollectionListMutationVariables = Exact<{
  data: AddPostToCollectionInput;
}>;


export type AddPostToCollectionForPostCollectionListMutation = { __typename?: 'Mutation', addPostToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type RemovePostFromCollectionForPostCollectionListMutationVariables = Exact<{
  data: RemovePostFromCollectionInput;
}>;


export type RemovePostFromCollectionForPostCollectionListMutation = { __typename?: 'Mutation', removePostFromCollection: { __typename?: 'Result', success: boolean, message: string } };

export type PostFragmentPostContextMenuFragment = { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type RemovePostFromCollectionForPostContextMenuMutationVariables = Exact<{
  data: RemovePostFromCollectionInput;
}>;


export type RemovePostFromCollectionForPostContextMenuMutation = { __typename?: 'Mutation', removePostFromCollection: { __typename?: 'Result', message: string, success: boolean } };

export type DeletePostForPostContextMenuMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePostForPostContextMenuMutation = { __typename?: 'Mutation', deletePost: { __typename?: 'Result', message: string, success: boolean } };

export type DuplicatePostForPostContextMenuMutationVariables = Exact<{
  data: DuplicatePostInput;
}>;


export type DuplicatePostForPostContextMenuMutation = { __typename?: 'Mutation', duplicatePost: { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } };

export type PostFragmentPostCreatorFragment = { __typename?: 'PostModel', id: string, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type PostFragmentPostDescriptionFragment = { __typename?: 'PostModel', id: string, description: string, myPermissions: Array<PostPermission> };

export type UpdatePostForPostDescriptionMutationVariables = Exact<{
  data: UpdatePostInput;
}>;


export type UpdatePostForPostDescriptionMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostModel', id: string, description: string, myPermissions: Array<PostPermission> } };

export type PostFragmentPostIconFragment = { __typename?: 'PostModel', id: string, type: PostType, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> };

export type PostFragmentPostNewBadgeFragment = { __typename?: 'PostModel', id: string, isNew?: boolean | null };

export type PostFragmentPostPinFragment = { __typename?: 'PostModel', id: string, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> };

export type UrlMetadataFragmentPostPreviewFragment = { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null };

export type PostFragmentPostPreviewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type UserReactionFragmentPostReactionButtonFragment = { __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } };

export type PostFragmentPostReactionButtonFragment = { __typename?: 'PostModel', id: string, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null };

export type ReactToPostForPostReactionButtonMutationVariables = Exact<{
  data: ReactToPostInput;
}>;


export type ReactToPostForPostReactionButtonMutation = { __typename?: 'Mutation', reactToPost: { __typename?: 'Result', success: boolean, message: string } };

export type UserReactionFragmentPostReactionListFragment = { __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } };

export type PostFragmentPostReactionListFragment = { __typename?: 'PostModel', id: string, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null };

export type ReactToPostForPostReactionListMutationVariables = Exact<{
  data: ReactToPostInput;
}>;


export type ReactToPostForPostReactionListMutation = { __typename?: 'Mutation', reactToPost: { __typename?: 'Result', success: boolean, message: string } };

export type PostFragmentPostSaveToContentCalendarButtonFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type AddPostsToContentCalendarForPostContentCalendarButtonMutationVariables = Exact<{
  data: AddPostsToContentCalendarInput;
}>;


export type AddPostsToContentCalendarForPostContentCalendarButtonMutation = { __typename?: 'Mutation', addPostsToContentCalendar: { __typename?: 'Result', message: string, success: boolean } };

export type PostFragmentPostSocialPostButtonFragment = { __typename?: 'PostModel', id: string, socialPostId?: string | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null };

export type PostFragmentPostTitleFragment = { __typename?: 'PostModel', id: string, title?: string | null, myPermissions: Array<PostPermission>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> };

export type UpdatePostTitleMutationVariables = Exact<{
  data: UpdatePostInput;
}>;


export type UpdatePostTitleMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostModel', id: string, title?: string | null } };

export type PostFragmentPostUnreadCommentBadgeFragment = { __typename?: 'PostModel', id: string, unreadCommentCount: number };

export type PostFragmentUrlMetadataFragment = { __typename?: 'PostModel', urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> };

export type GetPostViewersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostViewersQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, viewers: Array<{ __typename?: 'PostViewerModel', lastSeen?: any | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> } | null };

export type PostFragmentPostViewersFragment = { __typename?: 'PostModel', id: string, viewers: Array<{ __typename?: 'PostViewerModel', lastSeen?: any | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> };

export type MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationVariables = Exact<{
  data: MovePostsToCollectionInput;
}>;


export type MovePostsToCollectionForUseMoveToAnotherCollectionModalMutation = { __typename?: 'Mutation', movePostsToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type PostFragmentUseNavigatePostSearchParamsFragment = { __typename?: 'PostModel', id: string, type: PostType };

export type GetPostsSmartSearchForPostNavigationSearchParamsQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<SortType>;
  sortBy?: InputMaybe<SortByInputData>;
}>;


export type GetPostsSmartSearchForPostNavigationSearchParamsQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, type: PostType } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ViewEntitiesForPostMutationVariables = Exact<{
  data: ViewEntitiesInput;
}>;


export type ViewEntitiesForPostMutation = { __typename?: 'Mutation', viewEntities: { __typename?: 'Result', message: string, success: boolean } };

export type PostFragmentPostCardViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, myPermissions: Array<PostPermission>, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string } };

export type PostFragmentPostDetailContentCollaborationFragment = { __typename?: 'PostModel', id: string, roomId?: string | null, myPermissions: Array<PostPermission> };

export type PostFragmentPostDetailContentViewFragment = { __typename?: 'PostModel', id: string, createdAt: any, roomId?: string | null, myPermissions: Array<PostPermission>, type: PostType, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CreatePostAnnotationForPostDetailContentViewMutationVariables = Exact<{
  data: CreatePostAnnotationInput;
}>;


export type CreatePostAnnotationForPostDetailContentViewMutation = { __typename?: 'Mutation', createPostAnnotation: { __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> } };

export type DeletePostAnnotationForPostDetailContentViewMutationVariables = Exact<{
  data: DeletePostAnnotationInput;
}>;


export type DeletePostAnnotationForPostDetailContentViewMutation = { __typename?: 'Mutation', deletePostAnnotation: { __typename?: 'Result', message: string, success: boolean } };

export type CreateCommentForPostDetailContentViewMutationVariables = Exact<{
  data: CreateCommentInput;
}>;


export type CreateCommentForPostDetailContentViewMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> } };

export type ReactToCommentForPostDetailContentViewMutationVariables = Exact<{
  data: ReactInput;
}>;


export type ReactToCommentForPostDetailContentViewMutation = { __typename?: 'Mutation', react: { __typename?: 'Result', message: string, success: boolean } };

export type UpdateCommentForPostDetailContentViewMutationVariables = Exact<{
  data: UpdateCommentInput;
}>;


export type UpdateCommentForPostDetailContentViewMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> } };

export type DeleteCommentForPostDetailContentViewMutationVariables = Exact<{
  data: DeleteCommentInput;
}>;


export type DeleteCommentForPostDetailContentViewMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'Result', message: string, success: boolean } };

export type PostFragmentPostDetailSidebarViewFragment = { __typename?: 'PostModel', id: string, createdAt: any, isFavoriteTrend: boolean, title?: string | null, type: PostType, description: string, myPermissions: Array<PostPermission>, isFavorite: boolean, socialPostId?: string | null, color: string, updatedAt: any, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string }>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null };

export type PostFragmentPostDetailSidebarViewCommentsTabContentFragment = { __typename?: 'PostModel', id: string, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string }> };

export type PostFragmentPostDetailSidebarViewInfoTabContentFragment = { __typename?: 'PostModel', id: string, createdAt: any, isFavoriteTrend: boolean, description: string, myPermissions: Array<PostPermission>, isFavorite: boolean, socialPostId?: string | null, title?: string | null, type: PostType, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type PostFragmentTasksTabContentFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type PostFragmentPostInfoViewFragment = { __typename?: 'PostModel', id: string, createdAt: any, isFavoriteTrend: boolean, description: string, myPermissions: Array<PostPermission>, isFavorite: boolean, socialPostId?: string | null, title?: string | null, type: PostType, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type UrlMetadataFragmentPostMasonryCardViewFragment = { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null };

export type PostFragmentPostMasonryCardViewFragment = { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type PostFragmentPostMoveToAnotherCollectionFragment = { __typename?: 'PostModel', description: string, id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type CollectionFragmentUseMoveToAnotherCollectionModalFragment = { __typename?: 'CollectionModel', id: string, name: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> };

export type GetCollectionForPostMoveToAnotherCollectionQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForPostMoveToAnotherCollectionQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } };

export type GetPostForPostMoveToAnotherCollectionQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostForPostMoveToAnotherCollectionQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type PostFragmentPostNotePreviewViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }> };

export type PostFragmentPostNotePreviewCompactViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, color: string };

export type PostFragmentPostPreviewWindowViewFragment = { __typename?: 'PostModel', id: string, color: string, type: PostType, createdAt: any, roomId?: string | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, body?: string | null, isFavorite: boolean, title?: string | null, description: string, updatedAt: any, socialPostId?: string | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null };

export type PostFragmentPostSectionHeaderViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type GetCollectionsSmartSearchForPostSmartSearchResultViewQueryVariables = Exact<{
  filters: CollectionFilters;
  take?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<SortType>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCollectionsSmartSearchForPostSmartSearchResultViewQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', data: Array<{ __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetPostsSmartSearchForPostSmartSearchResultViewQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<SortType>;
}>;


export type GetPostsSmartSearchForPostSmartSearchResultViewQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type PostFragmentPostSuggestionCardViewFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type RadarEventFragmentRadarEventTimelineItemInternalActivityFragment = { __typename?: 'RadarEventModel', id: string, brandId: string, createdAt: any, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, profilePictureUrl?: string | null }> }, creator?: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, profilePictureUrl?: string | null } | null, radarEventActivities: Array<{ __typename?: 'RadarEventActivityModel', id: string, title: string, summary: string, direction: RadarEventActivityDirection, createdAt: any, dateTime?: any | null, createdByUser: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null }, assets: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, channels: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string, name: string, color?: string | null, bgColor?: string | null }>, createdForCreatorProfiles: Array<{ __typename?: 'CreatorProfileModel', id: string }>, radarEvents: Array<{ __typename?: 'RadarEventModel', id: string }> }> };

export type RadarEventFragmentRadarEventTimelineItemSocialPostFragment = { __typename?: 'RadarEventModel', id: string, brandId: string, socialPost?: { __typename?: 'SocialPostModel', id: string, description: string, diggCount: number, commentCount: number, playCount: number, engagementRate: number, platformCreateTime: any, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, platformId: string, expiresAt?: any | null, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, sentimentTone?: Sentiment | null }>, creator?: { __typename?: 'CreatorModel', id: string, handle: string, nickName: string, platform: Platform, profilePictureUrl?: string | null } | null } | null };

export type RadarEventFragmentRadarEventTimelineItemSocialPostCommentFragment = { __typename?: 'RadarEventModel', id: string, brandId: string, socialPost?: { __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null } | null, socialPostComment?: { __typename?: 'SocialPostCommentModel', id: string, text: string, diggCount: number, childCommentCount: number, socialPostCommentClaims: Array<{ __typename?: 'SocialPostCommentClaimModel', sentimentScore: number, brandId?: string | null }> } | null };

export type RadarEventFragmentRadarEventCommunityUpdateItemViewFragment = { __typename?: 'RadarEventModel', id: string, brandId: string, createdAt: any, message?: string | null, eventType: RadarEventType, eventTypeCounter: number, readStatus: RadarEventReadStatus, radarEventActivities: Array<{ __typename?: 'RadarEventActivityModel', id: string, title: string }>, creatorProfile: { __typename?: 'CreatorProfileModel', id: string, fullName: string, relationshipStrength: CreatorProfileRelationshipStrength, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, platform: Platform, profilePictureUrl?: string | null }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string }> }, socialPost?: { __typename?: 'SocialPostModel', id: string, platformId: string, platform: Platform, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } | null, socialPostComment?: { __typename?: 'SocialPostCommentModel', id: string } | null };

export type GetRadarEventForRadarEventCommunityUpdateItemViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRadarEventForRadarEventCommunityUpdateItemViewQuery = { __typename?: 'Query', radarEvent: { __typename?: 'RadarEventModel', id: string, radarEventActivities: Array<{ __typename?: 'RadarEventActivityModel', id: string, title: string }> } };

export type RadarEventFragmentRadarEventTimelineItemViewFragment = { __typename?: 'RadarEventModel', id: string, brandId: string, eventType: RadarEventType, platformCreateTime: any, message?: string | null, createdAt: any, radarEventActivities: Array<{ __typename?: 'RadarEventActivityModel', id: string, title: string, summary: string, direction: RadarEventActivityDirection, createdAt: any, dateTime?: any | null, createdByUser: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null }, assets: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, channels: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string, name: string, color?: string | null, bgColor?: string | null }>, createdForCreatorProfiles: Array<{ __typename?: 'CreatorProfileModel', id: string }>, radarEvents: Array<{ __typename?: 'RadarEventModel', id: string }> }>, creator?: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, profilePictureUrl?: string | null } | null, socialPostComment?: { __typename?: 'SocialPostCommentModel', id: string, text: string, diggCount: number, childCommentCount: number, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string }, socialPostCommentClaims: Array<{ __typename?: 'SocialPostCommentClaimModel', sentimentScore: number, brandId?: string | null }> } | null, socialPost?: { __typename?: 'SocialPostModel', id: string, description: string, diggCount: number, commentCount: number, playCount: number, engagementRate: number, platformCreateTime: any, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null } | null, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, sentimentTone?: Sentiment | null }> } | null, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, profilePictureUrl?: string | null }> } };

export type NoteSearchHitFragmentSearchTypeFragment = { __typename?: 'PostSearchHit', type: SearchHitType };

export type LinkSearchHitFragmentSearchTypeFragment = { __typename?: 'PostSearchHit', type: SearchHitType };

export type AttachmentSearchHitFragmentSearchTypeFragment = { __typename?: 'PostSearchHit', type: SearchHitType };

export type TaskSearchHitFragmentSearchTypeFragment = { __typename?: 'TaskSearchHitV2', type: SearchHitType };

export type CollectionSearchHitFragmentSearchTypeFragment = { __typename?: 'CollectionSearchHit', type: SearchHitType };

export type NoteSearchHitFragmentItemSuffixFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> } };

export type LinkSearchHitFragmentItemSuffixFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string } };

export type AttachmentSearchHitFragmentItemSuffixFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string } };

export type TaskSearchHitFragmentItemSuffixFragment = { __typename?: 'TaskSearchHitV2', item: { __typename?: 'TaskModel', id: string } };

export type CollectionSearchHitFragmentItemSuffixFragment = { __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }> } };

export type NoteSearchHitFragmentItemThumbnailFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string } };

export type LinkSearchHitFragmentItemThumbnailFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> } };

export type AttachmentSearchHitFragmentItemThumbnailFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } };

export type TaskSearchHitFragmentItemThumbnailFragment = { __typename?: 'TaskSearchHitV2', item: { __typename?: 'TaskModel', id: string } };

export type CollectionSearchHitFragmentItemThumbnailFragment = { __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string } };

export type NoteSearchHitFragmentItemNameFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, title?: string | null } };

export type LinkSearchHitFragmentItemNameFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> } };

export type AttachmentSearchHitFragmentItemNameFragment = { __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } };

export type TaskSearchHitFragmentItemNameFragment = { __typename?: 'TaskSearchHitV2', item: { __typename?: 'TaskModel', id: string, name: string, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null } };

export type CollectionSearchHitFragmentItemNameFragment = { __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } };

export type UrlMetadataFragmentSearchHandlerFragment = { __typename?: 'URLMetadataModel', createdAt: any, id: string, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null };

export type PostAttachmentFragmentSearchHandlerFragment = { __typename?: 'AttachmentModel', createdAt: any, id: string, name: string, updatedAt: any, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null, size?: number | null, imageInfo?: { __typename?: 'ImageInfo', height: number, orientation?: number | null, width: number } | null, videoInfo?: { __typename?: 'VideoInfo', duration: number, format: string, video: { __typename?: 'VideoMetaData', height: number, width: number } } | null } };

export type PostFragmentSearchHandlerFragment = { __typename?: 'PostModel', title?: string | null, id: string, body?: string | null, type: PostType, urlMetadata: Array<{ __typename?: 'URLMetadataModel', createdAt: any, id: string, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', createdAt: any, id: string, name: string, updatedAt: any, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null, size?: number | null, imageInfo?: { __typename?: 'ImageInfo', height: number, orientation?: number | null, width: number } | null, videoInfo?: { __typename?: 'VideoInfo', duration: number, format: string, video: { __typename?: 'VideoMetaData', height: number, width: number } } | null } } | null };

export type CollectionFragmentSearchRecentFragment = { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> };

export type SearchClickedResultFragmentSearchRecentFragment = { __typename?: 'SearchClickedResultModel', updatedAt: any, task?: { __typename?: 'TaskModel', id: string, name: string, description: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } | null, user?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null, post?: { __typename?: 'PostModel', title?: string | null, id: string, body?: string | null, type: PostType, urlMetadata: Array<{ __typename?: 'URLMetadataModel', createdAt: any, id: string, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', createdAt: any, id: string, name: string, updatedAt: any, url: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null, size?: number | null, imageInfo?: { __typename?: 'ImageInfo', height: number, orientation?: number | null, width: number } | null, videoInfo?: { __typename?: 'VideoInfo', duration: number, format: string, video: { __typename?: 'VideoMetaData', height: number, width: number } } | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null };

export type GetSearchResultForRichTextQueryVariables = Exact<{
  data: SearchInput;
}>;


export type GetSearchResultForRichTextQuery = { __typename?: 'Query', searchEntities: { __typename?: 'SearchResults', taskSearchHits: Array<{ __typename?: 'TaskSearchHit', taskModel: { __typename?: 'TaskModel', id: string, name: string, description: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }, headline: Array<{ __typename?: 'Headline', column: string, headline: string }> }>, userSearchHits: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, postSearchHits: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> }> } };

export type CreatePostSearchClickForSearchHandlerMutationVariables = Exact<{
  data: SearchHitClickInput;
}>;


export type CreatePostSearchClickForSearchHandlerMutation = { __typename?: 'Mutation', createSearchClicked: { __typename?: 'SearchClickedResultModel', post?: { __typename: 'PostModel', id: string } | null } };

export type CreateTaskSearchClickMutationVariables = Exact<{
  data: SearchHitClickInput;
}>;


export type CreateTaskSearchClickMutation = { __typename?: 'Mutation', createSearchClicked: { __typename?: 'SearchClickedResultModel', task?: { __typename?: 'TaskModel', id: string } | null } };

export type CreateCollectionSearchClickMutationVariables = Exact<{
  data: SearchHitClickInput;
}>;


export type CreateCollectionSearchClickMutation = { __typename?: 'Mutation', createSearchClicked: { __typename?: 'SearchClickedResultModel', collection?: { __typename?: 'CollectionModel', id: string } | null } };

export type NoteSearchHitFragmentListItemViewFragment = { __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, title?: string | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> } };

export type LinkSearchHitFragmentListItemViewFragment = { __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> } };

export type AttachmentSearchHitFragmentListItemViewFragment = { __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } };

export type TaskSearchHitFragmentListItemViewFragment = { __typename?: 'TaskSearchHitV2', score: number, type: SearchHitType, item: { __typename?: 'TaskModel', id: string, name: string, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null } };

export type CollectionSearchHitFragmentListItemViewFragment = { __typename?: 'CollectionSearchHit', score: number, type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } };

export type PostSearchModalFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> };

export type PaginatedAttachmentsForAttachmentSearchResultsQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type PaginatedAttachmentsForAttachmentSearchResultsQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', attachmentSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PaginatedCollectionsForCollectionSearchResultsQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type PaginatedCollectionsForCollectionSearchResultsQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', collectionSearchResult: { __typename?: 'CollectionSearchResult', totalCount: number, hits: Array<{ __typename?: 'CollectionSearchHit', score: number, type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PaginatedLinksForLinkSearchResultsQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type PaginatedLinksForLinkSearchResultsQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', linkSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PaginatedNotesForNoteSearchResultsQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type PaginatedNotesForNoteSearchResultsQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', noteSearchResult: { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, title?: string | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PaginatedTasksForTaskSearchResultsQueryVariables = Exact<{
  data: UniversalSearchInput;
}>;


export type PaginatedTasksForTaskSearchResultsQuery = { __typename?: 'Query', universalSearch: { __typename?: 'UniversalSearchResults', taskSearchResult: { __typename?: 'TaskSearchResult', totalCount: number, hits: Array<{ __typename?: 'TaskSearchHitV2', score: number, type: SearchHitType, item: { __typename?: 'TaskModel', id: string, name: string, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null } }> }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type TaskFragmentSearchModalFragment = { __typename?: 'TaskModel', id: string, name: string, description: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type TaskSearchHitFragmentSearchModalFragment = { __typename?: 'TaskSearchHit', taskModel: { __typename?: 'TaskModel', id: string, name: string, description: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }, headline: Array<{ __typename?: 'Headline', column: string, headline: string }> };

export type NoteSearchResultFragmentSectionViewFragment = { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, title?: string | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> } }> };

export type LinkSearchResultFragmentSectionViewFragment = { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, description?: string | null, site?: string | null, medium?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null }> | null } | null }> } }> };

export type AttachmentSearchResultFragmentSectionViewFragment = { __typename?: 'PostSearchResult', totalCount: number, hits: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, attachment?: { __typename?: 'AttachmentModel', url: string, id: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } }> };

export type TaskSearchResultFragmentSectionViewFragment = { __typename?: 'TaskSearchResult', totalCount: number, hits: Array<{ __typename?: 'TaskSearchHitV2', score: number, type: SearchHitType, item: { __typename?: 'TaskModel', id: string, name: string, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null } }> };

export type CollectionSearchResultFragmentSectionViewFragment = { __typename?: 'CollectionSearchResult', totalCount: number, hits: Array<{ __typename?: 'CollectionSearchHit', score: number, type: SearchHitType, item: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } }> };

export type SocialAuthorFragmentSocialAuthorAvatarFragment = { __typename?: 'SocialAuthorModel', id: string, platform: Platform, platformHandle?: string | null, avatarUrl?: string | null };

export type CapturedProductGraphDataFragmentForSlaRankingGraphDataFragment = { __typename?: 'CapturedProductDataForInboundGraphData', x: string, y: number };

export type BrandFragmentBrandContentTypeFragment = { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> };

export type SocialPostFragmentInfinitePostsGridFragment = { __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null };

export type GetAttributesForSlaAnalyticsFilterByAttributesQueryVariables = Exact<{
  input: PaginatedCapturedProductAllLabelsInput;
}>;


export type GetAttributesForSlaAnalyticsFilterByAttributesQuery = { __typename?: 'Query', attributesForCapturedProductAllLabels: { __typename?: 'PaginatedCapturedProductAttributeModel', data: Array<{ __typename?: 'CapturedProductAttributeModel', id: string, value: string }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetBrandsForSlaAnalyticsFilterByBrandsQueryVariables = Exact<{
  input: PaginatedCapturedProductAllLabelsInput;
}>;


export type GetBrandsForSlaAnalyticsFilterByBrandsQuery = { __typename?: 'Query', brandsForCapturedProductAllLabels: { __typename?: 'PaginatedBrandModel', data: Array<{ __typename?: 'BrandModel', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetCategoriesForSlaAnalyticsFilterByCategoryQueryVariables = Exact<{
  input: PaginatedCapturedProductAllLabelsInput;
}>;


export type GetCategoriesForSlaAnalyticsFilterByCategoryQuery = { __typename?: 'Query', categoriesForCapturedProductAllLabels: { __typename?: 'PaginatedCapturedProductCategoryModel', data: Array<{ __typename?: 'CapturedProductCategoryModel', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetLanguagesForSlaAnalyticsFilterByLanguageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesForSlaAnalyticsFilterByLanguageQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'LanguageModel', name: string }> };

export type GetBrandForSlaAnalyticsFilterByPlatformQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForSlaAnalyticsFilterByPlatformQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, platform: Platform }> } };

export type GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryVariables = Exact<{
  input: PaginatedCapturedProductAllLabelsInput;
}>;


export type GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery = { __typename?: 'Query', productLinesModelsForCapturedProductAllLabels: { __typename?: 'PaginatedCapturedProductAllLabelsProductLineModel', data: Array<{ __typename?: 'CapturedProductAllLabelsProductLineModel', productModel?: string | null, productLine?: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type SignalDefinitionFragmentSlaAnalyticsFilterBySignalsFragment = { __typename?: 'SignalDefinitionModel', id: string, title: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string, value: string }> };

export type GetTopicForSlaAnalyticsFiltersQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetTopicForSlaAnalyticsFiltersQuery = { __typename?: 'Query', topic: { __typename?: 'TopicModel', id: string, topicSignalDefinitions: Array<{ __typename?: 'TopicSignalDefinitionModel', id: string, signalDefinition: { __typename?: 'SignalDefinitionModel', id: string, title: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string, value: string }> } }> } };

export type GetOldestSocialPostForSlaAnalyticsFiltersQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetOldestSocialPostForSlaAnalyticsFiltersQuery = { __typename?: 'Query', oldestSocialPostForBrandInboundFiltersInput?: { __typename?: 'SocialPostModel', id: string, platformCreateTime: any } | null };

export type GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryVariables = Exact<{
  input: GetCapturedProductAttributeByIdsInput;
}>;


export type GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery = { __typename?: 'Query', attributeForCapturedProductAllLabelsByIds: Array<{ __typename?: 'CapturedProductAttributeModel', id: string, value: string }> };

export type GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryVariables = Exact<{
  input: GetCapturedProductCategoryByIdsInput;
}>;


export type GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery = { __typename?: 'Query', categoryForCapturedProductAllLabelsByIds: Array<{ __typename?: 'CapturedProductCategoryModel', id: string, name: string }> };

export type GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryVariables = Exact<{
  input: GetBrandByIdsInput;
}>;


export type GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery = { __typename?: 'Query', brandByIds: Array<{ __typename?: 'BrandModel', id: string, name: string }> };

export type BrandFragmentSlaBrandContentTypeSelectorFragment = { __typename?: 'BrandModel', id: string, name: string, bookmarkState: { __typename?: 'BrandBookmarkState', ownedBrandAnalytics: boolean, ugcAnalytics: boolean }, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> };

export type SocialPostCreatorDemographicFragmentSlaCreatorDemographicsFragment = { __typename?: 'SocialPostCreatorDemographicModel', id: string, generation: SocialPostGenerationDemographic, gender: SocialPostGenderDemographic };

export type SocialPostFragmentSlaInfinitePostsGridFragment = { __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null };

export type SocialPostFragmentSlaRankingProductSocialPostsFragment = { __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null };

export type GetCapturedProductsForSlaRankingTableQueryVariables = Exact<{
  data: BrandInboundFiltersInputForCapturedProduct;
  count: Scalars['Int'];
}>;


export type GetCapturedProductsForSlaRankingTableQuery = { __typename?: 'Query', capturedProductsPaginatedForInbound: { __typename?: 'PaginatedCapturedProductDataForInbound', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, percentChange: number, socialPostCount: number, totalViewCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, count: number, attributeId: string }>, graphData: Array<{ __typename?: 'CapturedProductDataForInboundGraphData', x: string, y: number }>, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> }>, meta: { __typename?: 'PaginatedCapturedProductDataForInboundPaginationMeta', totalPostsCount: number } } };

export type CapturedProductAttributeUsageFragmentForSlaRankingTableAttributesFragment = { __typename?: 'CapturedProductAttributeUsage', attribute: string, attributeId: string, count: number };

export type CapturedProductFragmentForSlaRankingTableCompetitorFragment = { __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, percentChange: number, socialPostCount: number, totalViewCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, count: number, attributeId: string }>, graphData: Array<{ __typename?: 'CapturedProductDataForInboundGraphData', x: string, y: number }>, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> };

export type GetCapturedProductsForSlaRankingTableCompetitorQueryVariables = Exact<{
  data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct;
  count: Scalars['Int'];
}>;


export type GetCapturedProductsForSlaRankingTableCompetitorQuery = { __typename?: 'Query', capturedProductsPaginatedForCompetitors: { __typename?: 'PaginatedCapturedProductDataForInbound', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, percentChange: number, socialPostCount: number, totalViewCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, count: number, attributeId: string }>, graphData: Array<{ __typename?: 'CapturedProductDataForInboundGraphData', x: string, y: number }>, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> }>, meta: { __typename?: 'PaginatedCapturedProductDataForInboundPaginationMeta', totalPostsCount: number } } };

export type CapturedProductFragmentForSlaRankingTableFragment = { __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, percentChange: number, socialPostCount: number, totalViewCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, count: number, attributeId: string }>, graphData: Array<{ __typename?: 'CapturedProductDataForInboundGraphData', x: string, y: number }>, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> };

export type CapturedProductFragmentForViewProductPopoverFragment = { __typename?: 'CapturedProductDataForInbound', id: string, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null };

export type ClaimMetricFragmentSlaSentimentClaimsFragment = { __typename?: 'ClaimMetric', attribute: string, numberOfMentions: number };

export type CreatorFragmentSlaTopCreatorsFragment = { __typename?: 'CreatorModel', id: string, numberOfBrandMentions?: number | null, followerCount: number, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followingCount: number, industry?: string | null, likeCount: number, platformId: string, signature?: string | null, updatedAt: any, videoCount: number };

export type TopicFragmentTopicSelectorFragment = { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType, isBookmarked: boolean, status: TopicStatus, resetOnNextCycle: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } };

export type GetBrandForTopicSelectorQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForTopicSelectorQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, topics: Array<{ __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType, isBookmarked: boolean, status: TopicStatus, resetOnNextCycle: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } }> } };

export type CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables = Exact<{
  input: CreateBrandBookmarkInput;
}>;


export type CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation = { __typename?: 'Mutation', createBrandBookmark: { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null } };

export type DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables = Exact<{
  input: DeleteBrandBookmarkInput;
}>;


export type DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation = { __typename?: 'Mutation', deleteBrandBookmark: { __typename?: 'Result', message: string, success: boolean, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery = { __typename?: 'Query', getSocialPostsCountriesData: Array<{ __typename?: 'SocialPostCountryStatsModel', country: string, totalEngagement: number, totalImpressions: number, totalPosts: number, statsForFirstDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number }, statsForLastDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number } }> };

export type GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForSocialPosts;
}>;


export type GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery = { __typename?: 'Query', getBrandInboundSocialPosts: { __typename?: 'PaginatedSocialPostsForBrandInboundPosts', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, meta: { __typename?: 'PaginatedSocialPostsMetaForBrandInboundPosts', totalCount: number } } };

export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery = { __typename?: 'Query', getSocialPostsCountriesData: Array<{ __typename?: 'SocialPostCountryStatsModel', country: string, totalEngagement: number, totalImpressions: number, totalPosts: number, statsForFirstDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number }, statsForLastDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number } }> };

export type GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery = { __typename?: 'Query', countriesWithSocialPosts: Array<{ __typename?: 'CountryModel', code: string }> };

export type GetBrandForSlaBrandAnalyticsInboundViewQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForSlaBrandAnalyticsInboundViewQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, name: string, topics: Array<{ __typename?: 'TopicModel', id: string, type: ListeningTopicType }>, bookmarkState: { __typename?: 'BrandBookmarkState', ownedBrandAnalytics: boolean, ugcAnalytics: boolean }, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> } };

export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery = { __typename?: 'Query', getSocialPostsLanguagesData: Array<{ __typename?: 'SocialPostLanguageStatsModel', language: string, totalEngagement: number, totalImpressions: number, totalPosts: number, statsForFirstDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number }, statsForLastDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number } }> };

export type GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForSocialPosts;
}>;


export type GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery = { __typename?: 'Query', getBrandInboundSocialPosts: { __typename?: 'PaginatedSocialPostsForBrandInboundPosts', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, meta: { __typename?: 'PaginatedSocialPostsMetaForBrandInboundPosts', totalCount: number } } };

export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery = { __typename?: 'Query', getSocialPostsLanguagesData: Array<{ __typename?: 'SocialPostLanguageStatsModel', language: string, totalEngagement: number, totalImpressions: number, totalPosts: number, statsForFirstDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number }, statsForLastDate: { __typename?: 'SocialPostCountryStatsForDateModel', totalEngagement: number, totalImpressions: number, totalPosts: number } }> };

export type GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery = { __typename?: 'Query', countriesWithSocialPosts: Array<{ __typename?: 'CountryModel', code: string }> };

export type GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryVariables = Exact<{
  data: BrandInboundFiltersInput;
}>;


export type GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery = { __typename?: 'Query', getBrandInboundCreatorDemographics: Array<{ __typename?: 'SocialPostCreatorDemographicModel', id: string, generation: SocialPostGenerationDemographic, gender: SocialPostGenderDemographic }> };

export type GetTopicForSlaBrandInboundGraphViewQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetTopicForSlaBrandInboundGraphViewQuery = { __typename?: 'Query', topic: { __typename?: 'TopicModel', id: string, topicSignalDefinitions: Array<{ __typename?: 'TopicSignalDefinitionModel', id: string, signalDefinition: { __typename?: 'SignalDefinitionModel', id: string, title: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string, value: string }> } }> } };

export type GetChartDataPointsForSlaBrandInboundGraphViewQueryVariables = Exact<{
  data: BrandInboundFiltersInputForGraphData;
}>;


export type GetChartDataPointsForSlaBrandInboundGraphViewQuery = { __typename?: 'Query', brandInboundGraphData: { __typename?: 'BrandInboundGraphData', totalCount: number, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', Y: number, X: any }>, multiChartDataPoints?: Array<{ __typename?: 'MultiChartDataPoint', id: string, label: string, parsingSince: any, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', Y: number, X: any }> }> | null } };

export type SignalDefinitionFragmentSlaBrandInboundGraphPostsViewFragment = { __typename?: 'SignalDefinitionModel', id: string, title: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string, value: string }> };

export type GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForSocialPosts;
}>;


export type GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery = { __typename?: 'Query', getBrandInboundSocialPosts: { __typename?: 'PaginatedSocialPostsForBrandInboundPosts', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, meta: { __typename?: 'PaginatedSocialPostsMetaForBrandInboundPosts', totalCount: number, totalEngagement: number, totalViewCount: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables = Exact<{
  data: PaginatedCompetitorFlatAnalyticFiltersInputForCapturedProductSocialPosts;
}>;


export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery = { __typename?: 'Query', capturedProductsSocialPostsPaginatedForCompetitors: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables = Exact<{
  data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct;
}>;


export type GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery = { __typename?: 'Query', capturedProductDataForCompetitorsStats: { __typename?: 'CapturedProductDataForInboundStats', percentChange: number, totalEngagement: number, totalPostsCount: number, totalViewCount: number, graphData: Array<{ __typename?: 'CapturedProductDataForInboundGraphData', x: string, y: number }>, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', count: number, attribute: string }> } };

export type GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables = Exact<{
  data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct;
  count: Scalars['Int'];
}>;


export type GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery = { __typename?: 'Query', capturedProductsPaginatedForCompetitors: { __typename?: 'PaginatedCapturedProductDataForInbound', data: Array<{ __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, socialPostCount: number, totalViewCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> }> } };

export type CapturedProductFragmentForSlaBrandInboundRankingProductCompetitorDialogViewFragment = { __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, socialPostCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, count: number, attributeId: string }> };

export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForCapturedProductSocialPosts;
}>;


export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery = { __typename?: 'Query', capturedProductsSocialPostsPaginatedForInbound: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryVariables = Exact<{
  data: BrandInboundFiltersInputForCapturedProduct;
}>;


export type GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery = { __typename?: 'Query', capturedProductDataForInboundStats: { __typename?: 'CapturedProductDataForInboundStats', percentChange: number, totalEngagement: number, totalPostsCount: number, totalViewCount: number, graphData: Array<{ __typename?: 'CapturedProductDataForInboundGraphData', x: string, y: number }>, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', count: number, attribute: string }> } };

export type GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryVariables = Exact<{
  data: BrandInboundFiltersInputForCapturedProduct;
  count: Scalars['Int'];
}>;


export type GetTopProductsForSlaBrandInboundRankingProductDialogViewQuery = { __typename?: 'Query', capturedProductsPaginatedForInbound: { __typename?: 'PaginatedCapturedProductDataForInbound', data: Array<{ __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, socialPostCount: number, totalViewCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> }> } };

export type CapturedProductFragmentForSlaBrandInboundRankingProductDialogViewFragment = { __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, socialPostCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, count: number, attributeId: string }> };

export type CapturedProductFragmentForTopProductsSectionFragment = { __typename?: 'CapturedProductDataForInbound', id: string, line?: string | null, model?: string | null, socialPostCount: number, totalViewCount: number, brand?: { __typename?: 'BrandModel', id: string, name: string } | null, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> };

export type GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForSentimentClaimInteractions;
  brandId: Scalars['String'];
}>;


export type GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery = { __typename?: 'Query', getBrandSentimentInteractions: { __typename?: 'PaginatedSentimentClaimInteractions', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: { __typename?: 'SentimentClaimInteractions', socialPosts?: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, brandClaims: Array<{ __typename?: 'BrandClaimModel', attribute?: string | null, claim: string, id: string }> }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null } | null }> | null, socialPostComments?: Array<{ __typename?: 'SocialPostCommentModel', id: string, text: string, socialPostCommentClaims: Array<{ __typename?: 'SocialPostCommentClaimModel', id: string, claim: string, claimAttribute: string, brandId?: string | null }>, socialPost: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, brandClaims: Array<{ __typename?: 'BrandClaimModel', claim: string, id: string }> }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null } | null } }> | null } } };

export type GetBrandInboundSentimentMetricsQueryVariables = Exact<{
  data: BrandInboundFiltersInputForSentimentMetrics;
}>;


export type GetBrandInboundSentimentMetricsQuery = { __typename?: 'Query', brandInboundSentimentMetrics: { __typename?: 'BrandInboundSentimentMetrics', sentimentMetrics: { __typename?: 'SentimentMetric', averageCountPerDay: number, totalCount?: number | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', Y: number, X: any }> }, claimMetrics: Array<{ __typename?: 'ClaimMetric', numberOfMentions: number, attribute: string }> } };

export type GetBrandForSlaBrandInboundSummaryViewQueryVariables = Exact<{
  brandId: Scalars['String'];
  data: BrandInboundFiltersInput;
}>;


export type GetBrandForSlaBrandInboundSummaryViewQuery = { __typename?: 'Query', brand: { __typename: 'BrandModel', id: string, name: string, brandSummary?: { __typename: 'BrandSummary', averageLikes: number, averageViewCount: number, followers: number, postsPerWeek: number, totalEngagements: string, totalPosts: number, totalViewCount: string } | null } };

export type GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForTopCreators;
}>;


export type GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery = { __typename?: 'Query', brandInboundTopCreators: { __typename?: 'PaginatedCreator', data: Array<{ __typename: 'CreatorModel', id: string, numberOfBrandMentions?: number | null, followerCount: number, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followingCount: number, industry?: string | null, likeCount: number, platformId: string, signature?: string | null, updatedAt: any, videoCount: number }> } };

export type GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryVariables = Exact<{
  data: BrandInboundFiltersInputForHashtagsUsed;
}>;


export type GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery = { __typename?: 'Query', hashtagsForBrand: Array<{ __typename?: 'HashtagUsedForBrandModel', name: string, isHidden: boolean, averageEngagementRate?: number | null, numberOfTimesUsed?: number | null }> };

export type HashtagUsedForBrandFragmentSlaBrandInboundTopHashtagsViewFragment = { __typename?: 'HashtagUsedForBrandModel', isHidden: boolean, name: string, numberOfTimesUsed?: number | null, averageEngagementRate?: number | null };

export type BrandFragmentSlaBrandInboundTopHashtagsViewFragment = { __typename?: 'BrandModel', id: string, name: string };

export type HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables = Exact<{
  data: HideHashtagUsedForBrandInput;
}>;


export type HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation = { __typename?: 'Mutation', hideHashtagUsedForBrand: { __typename?: 'Result', success: boolean } };

export type UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables = Exact<{
  data: HideHashtagUsedForBrandInput;
}>;


export type UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation = { __typename?: 'Mutation', unhideHashtagUsedForBrand: { __typename?: 'Result', success: boolean } };

export type GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForSocialPosts;
}>;


export type GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery = { __typename?: 'Query', getBrandInboundSocialPosts: { __typename?: 'PaginatedSocialPostsForBrandInboundPosts', meta: { __typename?: 'PaginatedSocialPostsMetaForBrandInboundPosts', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }> } };

export type BrandFragmentSlaBrandTopCreatorPostsViewFragment = { __typename?: 'BrandModel', id: string, name: string };

export type CreatorFragmentSlaBrandTopCreatorPostsViewFragment = { __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, profilePictureUrl?: string | null, followerCount: number };

export type GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryVariables = Exact<{
  data: GetCreatorInput;
}>;


export type GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery = { __typename?: 'Query', getCreator: { __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, profilePictureUrl?: string | null, followerCount: number } };

export type GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryVariables = Exact<{
  data: GetTopCreatorPostsThatMentionedBrandInput;
}>;


export type GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery = { __typename?: 'Query', topCreatorPostsThatMentionedBrand: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type BrandFragmentSlaBrandTopHashtagPostsViewFragment = { __typename?: 'BrandModel', id: string, name: string };

export type GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryVariables = Exact<{
  data: GetTopHashtagsPostsForBrandInput;
}>;


export type GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery = { __typename?: 'Query', getSocialPostsByHashtagsForBrand: { __typename?: 'PaginatedSocialPostForHashTag', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, meta: { __typename?: 'PaginatedSocialPostMetaForHashTag', totalCount: number, averageEngagementRate: number, numberOfTimesUsed: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type RelatedBrandForSlaRelatedBrandsViewFragment = { __typename?: 'RelatedBrand', totalEngagement: number, totalImpressions: number, totalPosts: number, brand: { __typename?: 'BrandModel', id: string, name: string } };

export type AddBrandExclusionForSlaRelatedBrandsViewMutationVariables = Exact<{
  data: ExcludeBrandInput;
}>;


export type AddBrandExclusionForSlaRelatedBrandsViewMutation = { __typename?: 'Mutation', addBrandExclusion: { __typename?: 'Result', message: string, success: boolean } };

export type GetRelatedBrandsForSlaRelatedBrandsViewQueryVariables = Exact<{
  data: BrandInboundFiltersInputForRelatedBrands;
}>;


export type GetRelatedBrandsForSlaRelatedBrandsViewQuery = { __typename?: 'Query', getRelatedBrands: { __typename?: 'RelatedBrandsData', meta: { __typename?: 'RelatedBrandMeta', totalCount: number }, data: Array<{ __typename?: 'RelatedBrand', totalEngagement: number, totalImpressions: number, totalPosts: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> } };

export type BrandFragmentSlaRelatedBrandsTopPostsViewFragment = { __typename?: 'BrandModel', id: string, name: string };

export type GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForRelatedBrands;
}>;


export type GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery = { __typename?: 'Query', getPaginatedRelatedBrandsSocialPosts: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, meta: { __typename?: 'PaginationMeta', totalCount: number } } };

export type GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForSentimentClaimInteractions;
  brandId: Scalars['String'];
}>;


export type GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery = { __typename?: 'Query', sentimentClaimInteractions: { __typename?: 'PaginatedSentimentClaimInteractions', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, data: { __typename?: 'SentimentClaimInteractions', socialPosts?: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, socialPostSentimentSubjectClaims?: Array<{ __typename?: 'SocialPostSentimentSubjectClaimModel', id: string, claim: string, attribute: string, isConfident: boolean }> | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null } | null }> | null, socialPostComments?: Array<{ __typename?: 'SocialPostCommentModel', id: string, text: string, socialPostCommentClaims: Array<{ __typename?: 'SocialPostCommentClaimModel', id: string, claim: string, claimAttribute: string, brandId?: string | null }>, socialPost: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, brandClaims: Array<{ __typename?: 'BrandClaimModel', claim: string, id: string }> }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null } | null } }> | null } } };

export type GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryVariables = Exact<{
  data: BrandInboundFiltersInputForSentimentMetrics;
}>;


export type GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery = { __typename?: 'Query', sentimentSubjectClaimMetricsForTopicInbound: { __typename?: 'BrandInboundSentimentMetrics', sentimentMetrics: { __typename?: 'SentimentMetric', totalCount?: number | null, averageCountPerDay: number, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> }, claimMetrics: Array<{ __typename?: 'ClaimMetric', numberOfMentions: number, attribute: string }> } };

export type SentimentSubjectFragmentSlaTopicInboundSentimentsViewFragment = { __typename?: 'SentimentSubjectModel', id: string, status: SentimentSubjectStatus, subject: string };

export type SentimentSubjectFragmentSlaTopicInboundSentimentsContainerViewFragment = { __typename?: 'SentimentSubjectModel', id: string, status: SentimentSubjectStatus, subject: string };

export type GetTopicForSlaTopicInboundSentimentsViewQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetTopicForSlaTopicInboundSentimentsViewQuery = { __typename?: 'Query', topic: { __typename?: 'TopicModel', id: string, sentimentSubjects: Array<{ __typename?: 'SentimentSubjectModel', id: string, status: SentimentSubjectStatus, subject: string }> } };

export type OrganizationCreatorProfileLabelFragmentSlLabelSelectorFragment = { __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null };

export type GetCreatorProfileLabelsForSlLabelSelectorQueryVariables = Exact<{
  input: PaginatedOrganizationCreatorProfileLabelInput;
}>;


export type GetCreatorProfileLabelsForSlLabelSelectorQuery = { __typename?: 'Query', paginatedOrganizationCreatorProfileLabels: { __typename?: 'PaginatedOrganizationCreatorProfileLabelModel', data: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreateCreatorProfileLabelForSlLabelSelectorMutationVariables = Exact<{
  input: CreateOrganizationCreatorProfileLabelInput;
}>;


export type CreateCreatorProfileLabelForSlLabelSelectorMutation = { __typename?: 'Mutation', createOrganizationCreatorProfileLabel: { __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null } };

export type AddLabelToCreatorProfileForSlLabelSelectorMutationVariables = Exact<{
  input: AddOrganizationCreatorProfileLabelToCreatorProfileInput;
}>;


export type AddLabelToCreatorProfileForSlLabelSelectorMutation = { __typename?: 'Mutation', addOrganizationCreatorProfileLabelToCreatorProfile: { __typename?: 'Result', message: string, success: boolean } };

export type RemoveLabelFromCreatorProfileForSlLabelSelectorMutationVariables = Exact<{
  input: RemoveOrganizationCreatorProfileLabelFromCreatorProfileInput;
}>;


export type RemoveLabelFromCreatorProfileForSlLabelSelectorMutation = { __typename?: 'Mutation', removeOrganizationCreatorProfileLabelFromCreatorProfile: { __typename?: 'Result', message: string, success: boolean } };

export type CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables = Exact<{
  input: CreateBrandBookmarkInput;
}>;


export type CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation = { __typename?: 'Mutation', createBrandBookmark: { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null } };

export type DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables = Exact<{
  input: DeleteBrandBookmarkInput;
}>;


export type DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation = { __typename?: 'Mutation', deleteBrandBookmark: { __typename?: 'Result', message: string, success: boolean, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type GetPaginatedRadarEventsForSlCommunityInfoViewQueryVariables = Exact<{
  input: PaginatedRadarEventInput;
}>;


export type GetPaginatedRadarEventsForSlCommunityInfoViewQuery = { __typename?: 'Query', getPaginatedRadarEvents: { __typename?: 'PaginatedRadarEventModel', data: Array<{ __typename?: 'RadarEventModel', id: string, eventType: RadarEventType, eventTypeCounter: number, message?: string | null, creatorProfile: { __typename?: 'CreatorProfileModel', id: string, fullName: string }, socialPost?: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null } | null }>, meta: { __typename?: 'PaginationMeta', totalCount: number } } };

export type UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationVariables = Exact<{
  data: UpdateUserOnboardingStateInput;
}>;


export type UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation = { __typename?: 'Mutation', updateUserOnboardingState: { __typename?: 'MeModel', id: string, onboardingState?: { __typename?: 'OnboardingStateData', hasSeenSLCommunityIntroduction?: boolean | null } | null } };

export type GetTopicsTrackingListForSlPeekCreatorDialogViewQueryVariables = Exact<{
  data: CreatorTopicTrackingInput;
}>;


export type GetTopicsTrackingListForSlPeekCreatorDialogViewQuery = { __typename?: 'Query', getTopicsTrackingList: Array<{ __typename?: 'CreatorTopicTrackingModel', isTracking: boolean, topic: { __typename?: 'TopicModel', active: boolean, id: string, name: string } }> };

export type CreatorProfileFragmentSlPeekCreatorDialogViewFragment = { __typename?: 'CreatorProfileModel', id: string, isTrackingInsights: boolean, creators: Array<{ __typename?: 'CreatorModel', id: string }> };

export type UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationVariables = Exact<{
  input: UpdateCreatorTrackingTopicStatusInput;
}>;


export type UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation = { __typename?: 'Mutation', updateCreatorTrackingTopicStatus: { __typename?: 'Result', message: string, success: boolean } };

export type UpdateCreatorProfileForSlPeekCreatorDialogViewMutationVariables = Exact<{
  input: UpdateCreatorProfileInput;
}>;


export type UpdateCreatorProfileForSlPeekCreatorDialogViewMutation = { __typename?: 'Mutation', updateCreatorProfile: { __typename?: 'Result', message: string, success: boolean } };

export type GetCreatorProfileForSlCommunityTableRowQueryVariables = Exact<{
  id: Scalars['String'];
  brandId: Scalars['String'];
}>;


export type GetCreatorProfileForSlCommunityTableRowQuery = { __typename?: 'Query', creatorProfile: { __typename?: 'CreatorProfileModel', id: string, isTrackingInsights: boolean, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }>, latestRadarEventActivity?: { __typename?: 'RadarEventActivityModel', id: string, direction: RadarEventActivityDirection, title: string, dateTime?: any | null, createdByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } } | null } };

export type BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables = Exact<{
  input: BlockCreatorFromCreatorProfileInput;
}>;


export type BlockCreatorFromCreatorProfileForSlCommunityTableRowMutation = { __typename?: 'Mutation', blockCreatorFromCreatorProfile: { __typename?: 'Result', success: boolean } };

export type UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables = Exact<{
  input: UnblockCreatorFromCreatorProfileInput;
}>;


export type UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation = { __typename?: 'Mutation', unblockCreatorFromCreatorProfile: { __typename?: 'Result', success: boolean } };

export type BlockCreatorForSlCommunityTableRowMutationVariables = Exact<{
  data: BlockCreatorInput;
}>;


export type BlockCreatorForSlCommunityTableRowMutation = { __typename?: 'Mutation', blockCreator: { __typename?: 'Result', success: boolean } };

export type CreatorProfileFragmentSlCommunityTableFragment = { __typename?: 'CreatorProfileModel', id: string, createdAt: any, brandId: string, fullName: string, followersCount: number, brandMentionCount: number, engagementRate: number, totalEngagement: number, totalComments: number, relationshipStrength: CreatorProfileRelationshipStrength, relationshipStrengthScore: number, averageSentimentScore: number, isBlockedFromCommunityHub: boolean, isTrackingInsights: boolean, capturedProducts: Array<{ __typename?: 'CapturedProductModel', id: string, line: string, model: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null, platform: Platform, industry?: string | null, platformId: string }>, latestRadarEventActivity?: { __typename?: 'RadarEventActivityModel', id: string, direction: RadarEventActivityDirection, title: string, dateTime?: any | null, createdByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } } | null, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> };

export type GetCreatorProfilesForSlCommunityTableQueryVariables = Exact<{
  input: PaginatedCreatorProfileInput;
  brandId: Scalars['String'];
}>;


export type GetCreatorProfilesForSlCommunityTableQuery = { __typename?: 'Query', paginatedCreatorProfiles: { __typename?: 'PaginatedCreatorProfileModel', data: Array<{ __typename?: 'CreatorProfileModel', id: string, createdAt: any, brandId: string, fullName: string, followersCount: number, brandMentionCount: number, engagementRate: number, totalEngagement: number, totalComments: number, relationshipStrength: CreatorProfileRelationshipStrength, relationshipStrengthScore: number, averageSentimentScore: number, isBlockedFromCommunityHub: boolean, isTrackingInsights: boolean, capturedProducts: Array<{ __typename?: 'CapturedProductModel', id: string, line: string, model: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null, platform: Platform, industry?: string | null, platformId: string }>, latestRadarEventActivity?: { __typename?: 'RadarEventActivityModel', id: string, direction: RadarEventActivityDirection, title: string, dateTime?: any | null, createdByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } } | null, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, meta: { __typename?: 'PaginationMeta', totalCount: number } } };

export type GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryVariables = Exact<{
  input: CreatorProfileBrandMentionedStatsInput;
}>;


export type GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery = { __typename?: 'Query', creatorProfileBrandMentionStats: { __typename?: 'CreatorProfileBrandMentionStats', brandMentionCount: number, engagementRate: number, sentiment: Sentiment, totalLikes: number, totalViews: number, sentimentScore: number } };

export type GetSocialPostsForSlCreatorProfileBrandMentionViewQueryVariables = Exact<{
  input: CreatorProfilePaginatedBrandMentionsInput;
}>;


export type GetSocialPostsForSlCreatorProfileBrandMentionViewQuery = { __typename?: 'Query', creatorProfileBrandMentions: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreatorProfileFragmentSlCreatorProfileBrandMentionDialogViewFragment = { __typename?: 'CreatorProfileModel', id: string, brandId: string, fullName: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> };

export type CreatorProfileFragmentSlCreatorProfileDetailsViewFragment = { __typename?: 'CreatorProfileModel', id: string, fullName: string, emails?: Array<string> | null, brandId: string, relationshipStrength: CreatorProfileRelationshipStrength, location?: string | null, reasonForLocation?: string | null, birthdate?: any | null, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, audience_demographics?: string | null, industry?: string | null, otherInsights?: string | null, profilePictureUrl?: string | null, videoCount: number, followerCount: number, engagementRate: number, platformId: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, locationReferenceSocialPost?: { __typename?: 'SocialPostModel', id: string } | null };

export type GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryVariables = Exact<{
  input: CreatorProfilesByCreatorIdInput;
}>;


export type GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery = { __typename?: 'Query', creatorProfilesByCreatorId: { __typename?: 'PaginatedCreatorProfileModel', data: Array<{ __typename?: 'CreatorProfileModel', id: string, fullName: string, emails?: Array<string> | null, brandId: string, relationshipStrength: CreatorProfileRelationshipStrength, location?: string | null, reasonForLocation?: string | null, birthdate?: any | null, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, audience_demographics?: string | null, industry?: string | null, otherInsights?: string | null, profilePictureUrl?: string | null, videoCount: number, followerCount: number, engagementRate: number, platformId: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, locationReferenceSocialPost?: { __typename?: 'SocialPostModel', id: string } | null }> } };

export type UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationVariables = Exact<{
  input: UpdateCreatorProfileInput;
}>;


export type UpdateCreatorProfileForSlCreatorProfileDetailsViewMutation = { __typename?: 'Mutation', updateCreatorProfile: { __typename?: 'Result', success: boolean } };

export type RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationVariables = Exact<{
  input: RemoveCreatorFromCreatorProfileInput;
}>;


export type RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation = { __typename?: 'Mutation', removeCreatorFromCreatorProfile: { __typename?: 'Result', success: boolean } };

export type CreateCreatorForSlCreatorProfileDetailsViewMutationVariables = Exact<{
  data: CreateCreatorInput;
}>;


export type CreateCreatorForSlCreatorProfileDetailsViewMutation = { __typename?: 'Mutation', createCreator: { __typename?: 'CreatorModel', id: string, platform: Platform, handle: string } };

export type AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationVariables = Exact<{
  input: AddCreatorToCreatorProfileInput;
}>;


export type AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation = { __typename?: 'Mutation', addCreatorToCreatorProfile: { __typename?: 'Result', success: boolean } };

export type MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationVariables = Exact<{
  input: MergeCreatorProfilesInput;
}>;


export type MergeCreatorProfilesForSlCreatorProfileDetailsViewMutation = { __typename?: 'Mutation', mergeCreatorProfiles: { __typename?: 'Result', success: boolean } };

export type CreatorFragmentSocialListeningCreatorProfileDetailsViewFragment = { __typename?: 'CreatorModel', id: string, handle: string, platform: Platform, profilePictureUrl?: string | null, nickName: string, followerCount: number };

export type GetSearchDbCreatorsForSocialHandleInputQueryVariables = Exact<{
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Platform>;
}>;


export type GetSearchDbCreatorsForSocialHandleInputQuery = { __typename?: 'Query', searchDbCreators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, platform: Platform, profilePictureUrl?: string | null, nickName: string, followerCount: number }> };

export type CreatorFragmentSlCreatorProfileHandlerViewFragment = { __typename?: 'CreatorModel', id: string, platform: Platform, nickName: string, profilePictureUrl?: string | null, videoCount: number, followerCount: number, engagementRate: number, handle: string, platformId: string };

export type CreatorProfileFragmentSlCreatorProfileInsightsViewFragment = { __typename?: 'CreatorProfileModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, audience_demographics?: string | null, otherInsights?: string | null, industry?: string | null }> };

export type GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryVariables = Exact<{
  input: CreatorProfileMentionedBrandsInput;
}>;


export type GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery = { __typename?: 'Query', creatorProfileMentionedBrands: { __typename?: 'PaginatedBrandModel', data: Array<{ __typename?: 'BrandModel', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryVariables = Exact<{
  input: CreatorProfileBrandMentionedStatsInput;
}>;


export type GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery = { __typename?: 'Query', creatorProfileBrandMentionStats: { __typename?: 'CreatorProfileBrandMentionStats', brandMentionCount: number, engagementRate: number, sentiment: Sentiment, totalLikes: number, totalViews: number, totalComments: number } };

export type GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryVariables = Exact<{
  input: CreatorProfilePaginatedBrandMentionsInput;
}>;


export type GetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery = { __typename?: 'Query', creatorProfileBrandMentions: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null, platformId: string, platform: Platform, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null }> } };

export type SocialListeningCreatorProfileMergeViewFragmentCreatorFragment = { __typename?: 'CreatorModel', id: string, platform: Platform, handle: string };

export type SocialListeningCreatorProfileMergeViewFragmentCreatorProfileFragment = { __typename?: 'CreatorProfileModel', id: string, fullName: string, emails?: Array<string> | null, brandId: string, relationshipStrength: CreatorProfileRelationshipStrength, location?: string | null, reasonForLocation?: string | null, birthdate?: any | null, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, audience_demographics?: string | null, industry?: string | null, otherInsights?: string | null, profilePictureUrl?: string | null, videoCount: number, followerCount: number, engagementRate: number, platformId: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, locationReferenceSocialPost?: { __typename?: 'SocialPostModel', id: string } | null };

export type GetBrandMentionStatsForSlCreatorProfileMergeViewQueryVariables = Exact<{
  input: CreatorProfileBrandMentionedStatsInput;
}>;


export type GetBrandMentionStatsForSlCreatorProfileMergeViewQuery = { __typename?: 'Query', creatorProfileBrandMentionStats: { __typename?: 'CreatorProfileBrandMentionStats', brandMentionCount: number, totalComments: number, sentimentScore: number } };

export type GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryVariables = Exact<{
  input: CreatorProfileSuperfanEngagementStatsInput;
}>;


export type GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery = { __typename?: 'Query', getCreatorProfileSuperfanEngagementStats: { __typename?: 'CreatorProfileSuperfanEngagementStats', sentimentScore: number } };

export type GetRadarEventsForSlCreatorMomentsViewQueryVariables = Exact<{
  input: PaginatedRadarEventInput;
}>;


export type GetRadarEventsForSlCreatorMomentsViewQuery = { __typename?: 'Query', getPaginatedRadarEvents: { __typename?: 'PaginatedRadarEventModel', data: Array<{ __typename?: 'RadarEventModel', id: string, eventType: RadarEventType, eventTypeCounter: number, message?: string | null, creatorProfileId: string, platformCreateTime: any, socialPost?: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type CapturedProductFragmentForSocialListeningCreatorProfileProductsViewFragment = { __typename?: 'CapturedProductDataForInbound', id: string, socialPostCount: number, sentimentReasons: Array<string>, line?: string | null, model?: string | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null }>, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, attributeId: string, count: number }>, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, brand?: { __typename?: 'BrandModel', id: string, name: string } | null };

export type CreatorProfileFragmentSocialListeningCreatorProfileProductsViewFragment = { __typename?: 'CreatorProfileModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null, nickName: string }> };

export type GetProductsForSlCreatorProfileProductsViewQueryVariables = Exact<{
  data: BrandInboundFiltersInputForCapturedProduct;
  count: Scalars['Int'];
}>;


export type GetProductsForSlCreatorProfileProductsViewQuery = { __typename?: 'Query', capturedProductsPaginatedForInbound: { __typename?: 'PaginatedCapturedProductDataForInbound', data: Array<{ __typename?: 'CapturedProductDataForInbound', id: string, socialPostCount: number, sentimentReasons: Array<string>, line?: string | null, model?: string | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null }>, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, attributeId: string, count: number }>, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, brand?: { __typename?: 'BrandModel', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryVariables = Exact<{
  data: PaginatedBrandInboundFiltersInputForCapturedProductSocialPosts;
}>;


export type GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery = { __typename?: 'Query', capturedProductsSocialPostsPaginatedForInbound: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CreatorProfileFragmentSocialListeningCreatorProfileProductsDialogViewFragment = { __typename?: 'CreatorProfileModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null, nickName: string }> };

export type CapturedProductFragmentForSocialListeningCreatorProfileProductsDialogViewFragment = { __typename?: 'CapturedProductDataForInbound', id: string, socialPostCount: number, sentimentReasons: Array<string>, line?: string | null, model?: string | null, previewPosts: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null }>, attributeUsage: Array<{ __typename?: 'CapturedProductAttributeUsage', attribute: string, attributeId: string, count: number }>, category?: { __typename?: 'CapturedProductCategoryModel', id: string, name: string } | null, brand?: { __typename?: 'BrandModel', id: string, name: string } | null };

export type CreatorProfileFragmentSlCreatorProfileSentimentDialogViewFragment = { __typename?: 'CreatorProfileModel', id: string, brandId: string, fullName: string, creators: Array<{ __typename?: 'CreatorModel', id: string }> };

export type CreatorProfileFragmentSlCreatorProfileStatsViewFragment = { __typename?: 'CreatorProfileModel', id: string, brandId: string, fullName: string, creators: Array<{ __typename?: 'CreatorModel', id: string }> };

export type GetStatsForSlCreatorProfileSuperfanEngagementViewQueryVariables = Exact<{
  input: CreatorProfileSuperfanEngagementStatsInput;
}>;


export type GetStatsForSlCreatorProfileSuperfanEngagementViewQuery = { __typename?: 'Query', getCreatorProfileSuperfanEngagementStats: { __typename?: 'CreatorProfileSuperfanEngagementStats', maxLikes: number, sentiment: Sentiment, totalComments: number, totalEngagement: number, sentimentScore: number } };

export type GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryVariables = Exact<{
  brandId: Scalars['String'];
  input: CreatorProfilePaginatedSuperfanEngagementInput;
}>;


export type GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery = { __typename?: 'Query', getCreatorProfileSuperfanEngagement: { __typename?: 'PaginatedSocialPostComment', data: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, text: string, diggCount: number, platformCreateTime: any, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreatorProfileFragmentSlCreatorProfileFanEngagementDialogViewFragment = { __typename?: 'CreatorProfileModel', id: string, brandId: string, fullName: string, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> };

export type BrandInviteMemberModelFragmentApproveBrandInviteMemberFragment = { __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type BrandInviteMemberFragmentSocialListeningPermissionMemberFragment = { __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type UserProfileFragmentSocialListeningPermissionMemberFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } };

export type UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationVariables = Exact<{
  data: UpdateBrandPermissionsInput;
}>;


export type UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation = { __typename?: 'Mutation', updateBrandPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationVariables = Exact<{
  data: InviteUsersToCurrentOrgByRoleInput;
}>;


export type InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation = { __typename?: 'Mutation', inviteUsersToCurrentOrgByRoles: Array<{ __typename?: 'UserProfileModel', id: string }> };

export type UserProfileFragmentSocialListeningUserPermissionsDialogBodyViewFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } };

export type BrandInviteMemberModelFragmentSocialListeningUserPermissionsDialogBodyViewFragment = { __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationVariables = Exact<{
  data: CreatePermissionRequestInput;
}>;


export type CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation = { __typename?: 'Mutation', createPermissionRequest: { __typename?: 'PermissionRequestModel', id: string } };

export type GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery = { __typename?: 'Query', pendingPermissionRequestsForBrand: Array<{ __typename?: 'PermissionRequestModel', id: string, status: PermissionRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForSocialListeningUserPermissionsDialogBodyViewQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, name: string, organizationId?: string | null, myPermissions: Array<BrandPermission>, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }>, organization: { __typename?: 'OrganizationModel', id: string, name: string }, inviteMembers: Array<{ __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, role?: InternalOrganizationRole | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, hasBeenApprovedByAdmin?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } };

export type UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationVariables = Exact<{
  data: UpdateBrandPermissionsInput;
}>;


export type UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation = { __typename?: 'Mutation', updateBrandPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type GetPostByIdsForSlAssetsSelectorQueryVariables = Exact<{
  input: GetPostByIdsInput;
}>;


export type GetPostByIdsForSlAssetsSelectorQuery = { __typename?: 'Query', postByIds: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type CreatorProfileFragmentSlRadarCreatorAutocompleteFragment = { __typename?: 'CreatorProfileModel', id: string, fullName: string, emails?: Array<string> | null, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> };

export type GetCreatorProfilesForSlRadarCreatorAutocompleteQueryVariables = Exact<{
  input: PaginatedCreatorProfileInput;
}>;


export type GetCreatorProfilesForSlRadarCreatorAutocompleteQuery = { __typename?: 'Query', paginatedCreatorProfiles: { __typename?: 'PaginatedCreatorProfileModel', data: Array<{ __typename?: 'CreatorProfileModel', id: string, fullName: string, emails?: Array<string> | null, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryVariables = Exact<{
  input: CreatorProfilesByIdsInput;
}>;


export type GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery = { __typename?: 'Query', creatorProfileByIds: Array<{ __typename?: 'CreatorProfileModel', id: string, fullName: string, emails?: Array<string> | null, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> }> };

export type RadarEventActivityCommunicationChannelFragmentSlRadarActivityCommunicationChannelHandlersFragment = { __typename?: 'RadarEventActivityCommunicationChannelModel', id: string, color?: string | null, bgColor?: string | null, name: string };

export type GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryVariables = Exact<{
  input: RadarEventActivityCommunicationChannelByIdsInput;
}>;


export type GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery = { __typename?: 'Query', radarEventActivityCommunicationChannelByIds: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string, color?: string | null, bgColor?: string | null, name: string }> };

export type GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryVariables = Exact<{
  input: PaginatedRadarEventActivityCommunicationChannelInput;
}>;


export type GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery = { __typename?: 'Query', paginatedRadarEventActivityCommunicationChannels: { __typename?: 'PaginatedRadarEventActivityCommunicationChannelModel', data: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string, color?: string | null, bgColor?: string | null, name: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationVariables = Exact<{
  input: CreateRadarEventActivityCommunicationChannelInput;
}>;


export type CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation = { __typename?: 'Mutation', createRadarEventActivityCommunicationChannel: { __typename?: 'RadarEventActivityCommunicationChannelModel', id: string, color?: string | null, bgColor?: string | null, name: string } };

export type RadarEventActivityFragmentSlRadarActivityHandlersFragment = { __typename?: 'RadarEventActivityModel', id: string, title: string, direction: RadarEventActivityDirection, summary: string, dateTime?: any | null, createdForCreatorProfiles: Array<{ __typename?: 'CreatorProfileModel', id: string }>, channels: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string }>, assets: Array<{ __typename?: 'PostModel', id: string }>, radarEvents: Array<{ __typename?: 'RadarEventModel', id: string }> };

export type GetRadarEventActivitiesForSlRadarActivityHandlersQueryVariables = Exact<{
  input: PaginatedRadarEventActivityInput;
}>;


export type GetRadarEventActivitiesForSlRadarActivityHandlersQuery = { __typename?: 'Query', paginatedRadarEventActivities: { __typename?: 'PaginatedRadarEventActivityModel', data: Array<{ __typename?: 'RadarEventActivityModel', id: string, title: string, direction: RadarEventActivityDirection, summary: string, dateTime?: any | null, createdForCreatorProfiles: Array<{ __typename?: 'CreatorProfileModel', id: string }>, channels: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string }>, assets: Array<{ __typename?: 'PostModel', id: string }>, radarEvents: Array<{ __typename?: 'RadarEventModel', id: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreateRadarEventActivityForSlRadarActivityHandlersMutationVariables = Exact<{
  input: CreateRadarEventActivityInput;
}>;


export type CreateRadarEventActivityForSlRadarActivityHandlersMutation = { __typename?: 'Mutation', createRadarEventActivity: { __typename?: 'RadarEventActivityModel', id: string, title: string, direction: RadarEventActivityDirection, summary: string, dateTime?: any | null, createdForCreatorProfiles: Array<{ __typename?: 'CreatorProfileModel', id: string }>, channels: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string }>, assets: Array<{ __typename?: 'PostModel', id: string }>, radarEvents: Array<{ __typename?: 'RadarEventModel', id: string }> } };

export type UpdateRadarEventActivityForSlRadarActivityHandlersMutationVariables = Exact<{
  input: UpdateRadarEventActivityInput;
}>;


export type UpdateRadarEventActivityForSlRadarActivityHandlersMutation = { __typename?: 'Mutation', updateRadarEventActivity: { __typename?: 'RadarEventActivityModel', id: string, title: string, direction: RadarEventActivityDirection, summary: string, dateTime?: any | null, createdForCreatorProfiles: Array<{ __typename?: 'CreatorProfileModel', id: string }>, channels: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string }>, assets: Array<{ __typename?: 'PostModel', id: string }>, radarEvents: Array<{ __typename?: 'RadarEventModel', id: string }> } };

export type GetPaginatedRadarEventsForSlRadarEventsViewQueryVariables = Exact<{
  input: PaginatedRadarEventInput;
}>;


export type GetPaginatedRadarEventsForSlRadarEventsViewQuery = { __typename?: 'Query', getPaginatedRadarEvents: { __typename?: 'PaginatedRadarEventModel', data: Array<{ __typename?: 'RadarEventModel', id: string, brandId: string, createdAt: any, message?: string | null, eventType: RadarEventType, eventTypeCounter: number, readStatus: RadarEventReadStatus, radarEventActivities: Array<{ __typename?: 'RadarEventActivityModel', id: string, title: string }>, creatorProfile: { __typename?: 'CreatorProfileModel', id: string, fullName: string, relationshipStrength: CreatorProfileRelationshipStrength, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, platform: Platform, profilePictureUrl?: string | null }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string }> }, socialPost?: { __typename?: 'SocialPostModel', id: string, platformId: string, platform: Platform, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } | null, socialPostComment?: { __typename?: 'SocialPostCommentModel', id: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, meta: { __typename?: 'PaginationMeta', totalCount: number } } };

export type MarkRadarEventAsReadForSlRadarEventsViewMutationVariables = Exact<{
  input: MarkRadarEventAsReadInput;
}>;


export type MarkRadarEventAsReadForSlRadarEventsViewMutation = { __typename?: 'Mutation', markRadarEventAsRead: { __typename?: 'Result', message: string, success: boolean } };

export type CreatorFragmentSocialListeningSettingsSocialHandleInputFragment = { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null };

export type GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryVariables = Exact<{
  filters: SocialCreatorFilters;
}>;


export type GetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery = { __typename?: 'Query', getSocialCreator: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null } };

export type BlockCreatorForBlockCreatorFormMutationVariables = Exact<{
  data: BlockCreatorInput;
}>;


export type BlockCreatorForBlockCreatorFormMutation = { __typename?: 'Mutation', blockCreator: { __typename?: 'Result', success: boolean } };

export type RemoveBlockFromCreatorForBlockedAccountsDialogMutationVariables = Exact<{
  data: RemoveCreatorBlockingByHandleInput;
}>;


export type RemoveBlockFromCreatorForBlockedAccountsDialogMutation = { __typename?: 'Mutation', removeCreatorBlockingByHandle: { __typename?: 'Result', success: boolean } };

export type GetCreatorByHandleForBlockAccountFormQueryVariables = Exact<{
  filters: SocialCreatorFilters;
}>;


export type GetCreatorByHandleForBlockAccountFormQuery = { __typename?: 'Query', getSocialCreator: { __typename?: 'CreatorModel', handle: string } };

export type TopicFragmentNotificationsSectionFragment = { __typename?: 'TopicModel', id: string, name: string };

export type SocialPostNotificationConfigFragmentNotificationsSectionFragment = { __typename?: 'SocialPostNotificationConfigModel', id: string, creatorFollowing: Array<FollowersScale>, brandId: string, sentiments: Array<DetailedSentiment>, minimumScore: number, enabled?: boolean | null, creatorFollowingEnabled: boolean, sentimentsEnabled: boolean, minimumScoreEnabled: boolean, topic?: { __typename?: 'TopicModel', id: string, name: string } | null };

export type GetNotificationConfigsForNotificationsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationConfigsForNotificationsSectionQuery = { __typename?: 'Query', getNotificationConfigs: Array<{ __typename?: 'SocialPostNotificationConfigModel', id: string, creatorFollowing: Array<FollowersScale>, brandId: string, sentiments: Array<DetailedSentiment>, minimumScore: number, enabled?: boolean | null, creatorFollowingEnabled: boolean, sentimentsEnabled: boolean, minimumScoreEnabled: boolean, topic?: { __typename?: 'TopicModel', id: string, name: string } | null }> };

export type CreateSocialPostNotificationConfigForNotificationsSectionMutationVariables = Exact<{
  data: CreateSocialPostNotificationConfigInput;
}>;


export type CreateSocialPostNotificationConfigForNotificationsSectionMutation = { __typename?: 'Mutation', createSocialPostNotificationConfig: { __typename?: 'SocialPostNotificationConfigModel', id: string, creatorFollowing: Array<FollowersScale>, brandId: string, sentiments: Array<DetailedSentiment>, minimumScore: number, enabled?: boolean | null, creatorFollowingEnabled: boolean, sentimentsEnabled: boolean, minimumScoreEnabled: boolean, topic?: { __typename?: 'TopicModel', id: string, name: string } | null } };

export type UpdateSocialPostNotificationConfigForNotificationsSectionMutationVariables = Exact<{
  data: UpdateSocialPostNotificationConfigInput;
}>;


export type UpdateSocialPostNotificationConfigForNotificationsSectionMutation = { __typename?: 'Mutation', updateSocialPostNotificationConfig: { __typename?: 'SocialPostNotificationConfigModel', id: string, creatorFollowing: Array<FollowersScale>, brandId: string, sentiments: Array<DetailedSentiment>, minimumScore: number, enabled?: boolean | null, creatorFollowingEnabled: boolean, sentimentsEnabled: boolean, minimumScoreEnabled: boolean, topic?: { __typename?: 'TopicModel', id: string, name: string } | null } };

export type DeleteSocialPostNotificationConfigForNotificationsSectionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSocialPostNotificationConfigForNotificationsSectionMutation = { __typename?: 'Mutation', deleteSocialPostNotificationConfig: { __typename?: 'Result', success: boolean, message: string } };

export type GetBrandForNotificationSectionQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForNotificationSectionQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, topics: Array<{ __typename?: 'TopicModel', id: string, name: string }> } };

export type GetBrandRadarEventsConfigForCommunityHubQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandRadarEventsConfigForCommunityHubQuery = { __typename?: 'Query', getBrandRadarEventsConfig: { __typename?: 'BrandRadarEventsConfigModel', id: string, engagementRateThreshold: number, engagementThreshold: number, mentionsThreshold: number, brandId: string } };

export type UpdateBrandRadarEventsConfigForCommunityHubMutationVariables = Exact<{
  brandId: Scalars['String'];
  input: UpdateBrandRadarEventsConfigInput;
}>;


export type UpdateBrandRadarEventsConfigForCommunityHubMutation = { __typename?: 'Mutation', updateBrandRadarEventsConfig: { __typename?: 'Result', success: boolean, message: string } };

export type CompetitorFragmentCompetitorEditFragment = { __typename?: 'CompetitorModel', id: string, isPaused: boolean, description: string, name: string, regions: Array<string>, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, isHashTag: boolean, term: string }>, trackingBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }> } };

export type UpdateCompetitorsForCompetitorEditMutationVariables = Exact<{
  data: UpdateCompetitorInput;
}>;


export type UpdateCompetitorsForCompetitorEditMutation = { __typename?: 'Mutation', updateCompetitors: { __typename?: 'CompetitorModel', id: string, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string }>, trackingBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }> } } };

export type RemoveCompetitorsForCompetitorEditMutationVariables = Exact<{
  data: RemoveCompetitorsInput;
}>;


export type RemoveCompetitorsForCompetitorEditMutation = { __typename?: 'Mutation', removeCompetitors: Array<{ __typename?: 'CompetitorModel', id: string }> };

export type GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery = { __typename?: 'Query', organizationCompetitors: Array<{ __typename?: 'CompetitorModel', id: string, isPaused: boolean, description: string, name: string, regions: Array<string>, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, isHashTag: boolean, term: string }>, trackingBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }> } }> };

export type CreateCreatorForSocialMediaListeningSettingsGeneralMutationVariables = Exact<{
  data: CreateCreatorInput;
}>;


export type CreateCreatorForSocialMediaListeningSettingsGeneralMutation = { __typename?: 'Mutation', createCreator: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null } };

export type RemoveCreatorForSocialMediaListeningSettingsGeneralMutationVariables = Exact<{
  data: RemoveCreatorInput;
}>;


export type RemoveCreatorForSocialMediaListeningSettingsGeneralMutation = { __typename?: 'Mutation', removeCreator: { __typename?: 'Result', message: string, success: boolean } };

export type GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery = { __typename?: 'Query', sentimentSubjectsByTopic: Array<{ __typename?: 'SentimentSubjectModel', id: string, subject: string, topicId: string, status: SentimentSubjectStatus }> };

export type UpsertSentimentSubjectsForSettingsSentimentSubjectMutationVariables = Exact<{
  data: UpsertSentimentSubjectInput;
}>;


export type UpsertSentimentSubjectsForSettingsSentimentSubjectMutation = { __typename?: 'Mutation', upsertSentimentSubjects: Array<{ __typename?: 'SentimentSubjectModel', id: string, subject: string, topicId: string, status: SentimentSubjectStatus }> };

export type UpdateSentimentSubjectForSettingsSentimentSubjectMutationVariables = Exact<{
  data: UpdateSentimentSubjectInput;
}>;


export type UpdateSentimentSubjectForSettingsSentimentSubjectMutation = { __typename?: 'Mutation', updateSentimentSubject: { __typename?: 'Result', success: boolean } };

export type GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery = { __typename?: 'Query', topicSignalDefinitions: Array<{ __typename?: 'SignalDefinitionModel', id: string, title: string, description: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string }> }> };

export type CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationVariables = Exact<{
  data: CreateSignalDefinitionInput;
}>;


export type CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation = { __typename?: 'Mutation', createSignalDefinition: { __typename?: 'SignalDefinitionModel', id: string, title: string, description: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string }> } };

export type GetBrandForSocialListeningUsersViewQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForSocialListeningUsersViewQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, inviteMembers: Array<{ __typename?: 'BrandInviteMemberModel', id: string, userId: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, lastName: string, firstName: string, email: string } | null } }> } };

export type UpdateBrandPermissionsForSocialListeningUsersViewMutationVariables = Exact<{
  data: UpdateBrandPermissionsInput;
}>;


export type UpdateBrandPermissionsForSocialListeningUsersViewMutation = { __typename?: 'Mutation', updateBrandPermissions: { __typename?: 'Result', success: boolean, message: string } };

export type GetCreatorTrackingTopicsForBlockingCreatorDialogQueryVariables = Exact<{
  data: CreatorTopicTrackingInput;
}>;


export type GetCreatorTrackingTopicsForBlockingCreatorDialogQuery = { __typename?: 'Query', getTopicsTrackingList: Array<{ __typename?: 'CreatorTopicTrackingModel', isTracking: boolean, topic: { __typename?: 'TopicModel', id: string } }> };

export type BlockCreatorForBlockCreatorDialogMutationVariables = Exact<{
  data: BlockCreatorInput;
}>;


export type BlockCreatorForBlockCreatorDialogMutation = { __typename?: 'Mutation', blockCreator: { __typename?: 'Result', success: boolean } };

export type GetBrandsParsedHoursQueryVariables = Exact<{
  totalHoursParsedData?: InputMaybe<BrandHoursParsedInput>;
}>;


export type GetBrandsParsedHoursQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, organization: { __typename?: 'OrganizationModel', id: string, billing: { __typename?: 'OrganizationBillingModel', id: string, brandHoursParseLimit?: number | null }, socialListeningBrands: Array<{ __typename?: 'BrandModel', id: string, name: string, totalHoursParsedCount: number, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> }> } } };

export type GetTopicsTrackingListForCreatorPeekingQueryVariables = Exact<{
  data: CreatorTopicTrackingInput;
}>;


export type GetTopicsTrackingListForCreatorPeekingQuery = { __typename?: 'Query', getTopicsTrackingList: Array<{ __typename?: 'CreatorTopicTrackingModel', isTracking: boolean, topic: { __typename?: 'TopicModel', active: boolean, id: string, name: string } }> };

export type GetCreatorInsightsByCreatorIdForCreatorPeekingQueryVariables = Exact<{
  input: IsTrackingCreatorProfileInsightsByCreatorIdInput;
}>;


export type GetCreatorInsightsByCreatorIdForCreatorPeekingQuery = { __typename?: 'Query', isTrackingCreatorProfileInsightsByCreatorId: boolean };

export type CreatorFragmentCreatorPeekingFragment = { __typename?: 'CreatorModel', id: string, platformId: string, handle: string, platform: Platform };

export type CreatorProfileFragmentSocialMediaListeningCreatorProfileFragment = { __typename?: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number };

export type GetTopicsTrackingListForCreatorTrackingListQueryVariables = Exact<{
  data: CreatorTopicTrackingInput;
}>;


export type GetTopicsTrackingListForCreatorTrackingListQuery = { __typename?: 'Query', getTopicsTrackingList: Array<{ __typename?: 'CreatorTopicTrackingModel', isTracking: boolean, topic: { __typename?: 'TopicModel', id: string, name: string } }> };

export type TopicFragmentSocialMediaListeningFilterByTopicsButtonFragment = { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType };

export type GetLanguagesForFilterByLanguageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesForFilterByLanguageQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'LanguageModel', name: string }> };

export type SignalDefinitionFragmentFilterBySignalsFragment = { __typename?: 'SignalDefinitionModel', id: string, title: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string, value: string }> };

export type GetSignalDefinitionsByBrandIdForFilterBySignalsQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetSignalDefinitionsByBrandIdForFilterBySignalsQuery = { __typename?: 'Query', signalDefinitionsByBrandId: Array<{ __typename?: 'SignalDefinitionModel', id: string, title: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string, value: string }> }> };

export type GetSearchTermsForSocialMediaListeningKeywordsQueryVariables = Exact<{
  data: GetSearchTermsArgs;
}>;


export type GetSearchTermsForSocialMediaListeningKeywordsQuery = { __typename?: 'Query', getSearchTerms: { __typename?: 'PaginatedSearchTerm', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, data: Array<{ __typename?: 'SearchTermModel', id: string, term: string }> } };

export type SocialPostFragmentPostBrandSentimentsFragment = { __typename?: 'SocialPostModel', id: string, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', sentimentScore?: number | null, isConfident: boolean, sentimentTone?: Sentiment | null, brand: { __typename?: 'BrandModel', id: string, name: string }, brandClaims: Array<{ __typename?: 'BrandClaimModel', attribute?: string | null, claim: string, brandId: string, sentimentScore: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }> };

export type SocialPostFragmentSocialMediaListeningPostContextMenuFragment = { __typename?: 'SocialPostModel', id: string, totalContentCalendarSaves: number, isSavedToContentCalendar: boolean, totalPostSaves: number, savedPostId?: string | null, platformId: string, platform: Platform, expiresAt?: any | null, savedPost?: { __typename?: 'PostModel', id: string, isFavorite: boolean, isFavoriteTrend: boolean } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null };

export type GetSocialPostForSocialPostContextMenuQueryVariables = Exact<{
  socialPostId: Scalars['String'];
}>;


export type GetSocialPostForSocialPostContextMenuQuery = { __typename?: 'Query', socialPost: { __typename?: 'SocialPostModel', id: string, totalContentCalendarSaves: number, isSavedToContentCalendar: boolean, totalPostSaves: number, savedPostId?: string | null, platformId: string, platform: Platform, expiresAt?: any | null, savedPost?: { __typename?: 'PostModel', id: string, isFavorite: boolean, isFavoriteTrend: boolean } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } };

export type SocialPostFragmentSocialListeningContentCalendarSaveButtonFragment = { __typename?: 'SocialPostModel', id: string, totalContentCalendarSaves: number, isSavedToContentCalendar: boolean, savedPostId?: string | null, totalPostSaves: number, platformId: string, platform: Platform, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null };

export type SocialPostFragmentSocialListeningPostSaveButtonFragment = { __typename?: 'SocialPostModel', id: string, totalContentCalendarSaves: number, isSavedToContentCalendar: boolean, totalPostSaves: number, platformId: string, platform: Platform, expiresAt?: any | null, savedPost?: { __typename?: 'PostModel', id: string, isFavorite: boolean, isFavoriteTrend: boolean } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null };

export type GetBrandsDataForWeeklySnapShotSummaryQueryVariables = Exact<{
  brandId: Scalars['String'];
  data?: InputMaybe<BrandHoursParsedInput>;
}>;


export type GetBrandsDataForWeeklySnapShotSummaryQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, totalHoursParsedCount: number, brandMentionedStats: { __typename?: 'WeeklySnapshotSummaryResponse', count: number, percentageChange: number, previousCount: number }, outboundCommentsStats: { __typename?: 'WeeklySnapshotSummaryResponse', count: number, previousCount: number, percentageChange: number } } };

export type BrandFragmentUseSocialListeningOnboardingBrandFragment = { __typename?: 'BrandModel', id: string, name: string, description: string, regions: Array<string>, brandKnownNames: Array<string>, topics: Array<{ __typename?: 'TopicModel', id: string, brandId?: string | null, name: string, type: ListeningTopicType, active: boolean, generatedPrompt?: string | null, topicDescription?: string | null, prioritizationInfo?: string | null, communicationStrategy?: string | null, allowToUpdateSearchTerm: boolean, status: TopicStatus, resetOnNextCycle: boolean, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> }>, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform }>, blockedCreators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform }> };

export type GetBrandForUseSocialListeningOnboardingQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForUseSocialListeningOnboardingQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, name: string, description: string, regions: Array<string>, brandKnownNames: Array<string>, topics: Array<{ __typename?: 'TopicModel', id: string, brandId?: string | null, name: string, type: ListeningTopicType, active: boolean, generatedPrompt?: string | null, topicDescription?: string | null, prioritizationInfo?: string | null, communicationStrategy?: string | null, allowToUpdateSearchTerm: boolean, status: TopicStatus, resetOnNextCycle: boolean, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> }>, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform }>, blockedCreators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform }> } };

export type CreateBrandForUseSocialListeningOnboardingMutationVariables = Exact<{
  data: CreateBrandInput;
}>;


export type CreateBrandForUseSocialListeningOnboardingMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'BrandModel', id: string } };

export type UpdateBrandForUseSocialListeningOnboardingMutationVariables = Exact<{
  data: UpdateBrandInput;
}>;


export type UpdateBrandForUseSocialListeningOnboardingMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'BrandModel', id: string } };

export type GetAiGeneratedBrandDescriptionQueryVariables = Exact<{
  brandName: Scalars['String'];
}>;


export type GetAiGeneratedBrandDescriptionQuery = { __typename?: 'Query', aiGeneratedBrandDescription: string };

export type SearchTermFragmentForUseBrandSearchTermsForSocialListeningOnboardingFragment = { __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean };

export type CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationVariables = Exact<{
  data: CreateSearchTermInput;
}>;


export type CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation = { __typename?: 'Mutation', createSearchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> };

export type CreatorFragmentForUseCreatorDataForSocialListeningOnboardingFragment = { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform };

export type GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryVariables = Exact<{
  filters: SocialCreatorFilters;
}>;


export type GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery = { __typename?: 'Query', getSocialCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform } };

export type CreateCreatorForUseSocialListeningOnboardingBrandMutationVariables = Exact<{
  data: CreateCreatorInput;
}>;


export type CreateCreatorForUseSocialListeningOnboardingBrandMutation = { __typename?: 'Mutation', createCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform } };

export type RemoveCreatorForUseSocialListeningOnboardingBrandMutationVariables = Exact<{
  data: RemoveCreatorInput;
}>;


export type RemoveCreatorForUseSocialListeningOnboardingBrandMutation = { __typename?: 'Mutation', removeCreator: { __typename?: 'Result', success: boolean, message: string } };

export type TopicFragmentForUseTopicDataForSocialListeningOnboardingFragment = { __typename?: 'TopicModel', id: string, brandId?: string | null, name: string, type: ListeningTopicType, active: boolean, generatedPrompt?: string | null, topicDescription?: string | null, prioritizationInfo?: string | null, communicationStrategy?: string | null, allowToUpdateSearchTerm: boolean, status: TopicStatus, resetOnNextCycle: boolean, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> };

export type GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery = { __typename?: 'Query', aiGeneratedTopicPrompt: { __typename?: 'AIGeneratedTopicPrompt', engagementPlan?: string | null, priorityContent?: string | null, relevantContent?: string | null } };

export type CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: CreateBrandMentionTopicInput;
}>;


export type CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', createBrandMentionTopic: { __typename?: 'TopicModel', id: string, brandId?: string | null, name: string, type: ListeningTopicType, active: boolean, generatedPrompt?: string | null, topicDescription?: string | null, prioritizationInfo?: string | null, communicationStrategy?: string | null, allowToUpdateSearchTerm: boolean, status: TopicStatus, resetOnNextCycle: boolean, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> } };

export type UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: UpdateBrandMentionTopicInput;
}>;


export type UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', updateBrandMentionTopic: { __typename?: 'TopicModel', id: string, brandId?: string | null, name: string, type: ListeningTopicType, active: boolean, generatedPrompt?: string | null, topicDescription?: string | null, prioritizationInfo?: string | null, communicationStrategy?: string | null, allowToUpdateSearchTerm: boolean, status: TopicStatus, resetOnNextCycle: boolean, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> } };

export type CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: CreateEngagementTopicInput;
}>;


export type CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', createEngagementTopic: { __typename?: 'TopicModel', id: string, brandId?: string | null, name: string, type: ListeningTopicType, active: boolean, generatedPrompt?: string | null, topicDescription?: string | null, prioritizationInfo?: string | null, communicationStrategy?: string | null, allowToUpdateSearchTerm: boolean, status: TopicStatus, resetOnNextCycle: boolean, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> } };

export type UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: UpdateEngagementTopicInput;
}>;


export type UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', updateEngagementTopic: { __typename?: 'TopicModel', id: string, brandId?: string | null, name: string, type: ListeningTopicType, active: boolean, generatedPrompt?: string | null, topicDescription?: string | null, prioritizationInfo?: string | null, communicationStrategy?: string | null, allowToUpdateSearchTerm: boolean, status: TopicStatus, resetOnNextCycle: boolean, searchTerms: Array<{ __typename?: 'SearchTermModel', id: string, term: string, isHashTag: boolean }> } };

export type CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: CreateCreatorTrackingTopicInput;
}>;


export type CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', createCreatorTrackingTopic: { __typename?: 'TopicModel', id: string } };

export type UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: UpdateCreatorTrackingTopicInput;
}>;


export type UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', updateCreatorTrackingTopic: { __typename?: 'TopicModel', id: string } };

export type DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type DeleteTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', deleteTopic: { __typename?: 'Result', message: string, success: boolean } };

export type PauseTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: PauseTopicInput;
}>;


export type PauseTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', pauseTopic: { __typename?: 'TopicModel', id: string, status: TopicStatus, resetOnNextCycle: boolean } };

export type ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationVariables = Exact<{
  data: ResumeTopicInput;
}>;


export type ResumeTopicForUseTopicDataForSocialListeningOnboardingMutation = { __typename?: 'Mutation', resumeTopic: { __typename?: 'TopicModel', id: string, status: TopicStatus, resetOnNextCycle: boolean } };

export type GetBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandsQuery = { __typename?: 'Query', brands: Array<{ __typename?: 'BrandModel', id: string, name: string, myPermissions: Array<BrandPermission>, bookmarkState: { __typename?: 'BrandBookmarkState', brandAnalytics: boolean, ownedBrandAnalytics: boolean, ugcAnalytics: boolean, communityHub: boolean, outbound: boolean, competitorAnalytics: boolean }, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> }> };

export type BrandFragmentUseBrandDetailsFragment = { __typename?: 'BrandModel', id: string, name: string, myPermissions: Array<BrandPermission>, bookmarkState: { __typename?: 'BrandBookmarkState', brandAnalytics: boolean, ownedBrandAnalytics: boolean, ugcAnalytics: boolean, communityHub: boolean, outbound: boolean, competitorAnalytics: boolean }, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> };

export type SocialPostFragmentUseCreatePostHandlerForSocialListeningFragment = { __typename?: 'SocialPostModel', id: string, platformId: string, platform: Platform, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null };

export type CreatePostForSocialListeningPostMutationVariables = Exact<{
  data: CreatePostForSocialListeningPostInput;
}>;


export type CreatePostForSocialListeningPostMutation = { __typename?: 'Mutation', createPostForSocialListeningPost: { __typename?: 'PostModel', id: string } };

export type AddToContentCalendarForSocialListeningPostMutationVariables = Exact<{
  data: AddToContentCalendarForSocialListeningPostInput;
}>;


export type AddToContentCalendarForSocialListeningPostMutation = { __typename?: 'Mutation', addToContentCalendarForSocialListeningPost: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } };

export type TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables = Exact<{
  data: TrackCreatorInput;
  trackingInsightsBrandId: Scalars['String'];
  creatorTrackedTopicBrandId: Scalars['String'];
}>;


export type TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation = { __typename?: 'Mutation', trackCreatorForCreatorTrackingTopic: { __typename?: 'CreatorModel', id: string, isTrackingInsightsForCreatorProfile?: boolean | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> } };

export type UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables = Exact<{
  data: TrackCreatorInput;
  trackingInsightsBrandId: Scalars['String'];
  creatorTrackedTopicBrandId: Scalars['String'];
}>;


export type UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation = { __typename?: 'Mutation', untrackCreatorForCreatorTrackingTopic: { __typename?: 'CreatorModel', id: string, isTrackingInsightsForCreatorProfile?: boolean | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> } };

export type UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationVariables = Exact<{
  data: UntrackCreatorForTopicsInput;
  trackingInsightsBrandId: Scalars['String'];
  creatorTrackedTopicBrandId: Scalars['String'];
}>;


export type UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation = { __typename?: 'Mutation', untrackCreatorForCreatorTrackingTopics: { __typename?: 'CreatorModel', id: string, isTrackingInsightsForCreatorProfile?: boolean | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> } };

export type CreatorFragmentUseCreatorsTopicTrackingForSocialListeningFragment = { __typename?: 'CreatorModel', id: string, isTrackingInsightsForCreatorProfile?: boolean | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> };

export type GetTrackedCreatorsForTopicQueryVariables = Exact<{
  data: TopicTrackedCreatorsInput;
  trackingInsightsBrandId: Scalars['String'];
  creatorTrackedTopicBrandId: Scalars['String'];
}>;


export type GetTrackedCreatorsForTopicQuery = { __typename?: 'Query', getTrackedCreatorsForTopic: Array<{ __typename?: 'CreatorModel', id: string, isTrackingInsightsForCreatorProfile?: boolean | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> }> };

export type GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryVariables = Exact<{
  filters: SocialCreatorFilters;
}>;


export type GetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery = { __typename?: 'Query', getFollowing: Array<{ __typename?: 'SocialMediaUserModel', id: string, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, updatedAt: any, handle: string, followingCount: number, followerCount: number, createdAt: any }> };

export type SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryVariables = Exact<{
  query: Scalars['String'];
  filters: SocialCreatorFilters;
}>;


export type SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery = { __typename?: 'Query', searchCreators: Array<{ __typename?: 'SocialMediaUserModel', id: string, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, updatedAt: any, handle: string, followingCount: number, followerCount: number, createdAt: any }> };

export type UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationVariables = Exact<{
  input: UpdateTrackingInsightsForCreatorProfileByCreatorIdInput;
  trackingInsightsBrandId: Scalars['String'];
  creatorTrackedTopicBrandId: Scalars['String'];
}>;


export type UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation = { __typename?: 'Mutation', updateTrackingInsightsForCreatorProfileByCreatorId: { __typename?: 'CreatorModel', id: string, isTrackingInsightsForCreatorProfile?: boolean | null, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }> } };

export type SocialPostFragmentUseInstagramStoryPostStateFragment = { __typename?: 'SocialPostModel', id: string, expiresAt?: any | null };

export type SocialPostFragmentUseRenderSocialListeningPostVideoFragment = { __typename?: 'SocialPostModel', videoUrl?: string | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string, highlights: Array<{ __typename?: 'VideoHighlight', end: number, start: number, highlightSummary?: string | null }> }> | null };

export type GetBrandForUseSlBrandPermissionsQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForUseSlBrandPermissionsQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, myPermissions: Array<BrandPermission> } };

export type CreateBookmarkForSocialListeningBookmarkHandlersMutationVariables = Exact<{
  input: CreateBrandBookmarkInput;
}>;


export type CreateBookmarkForSocialListeningBookmarkHandlersMutation = { __typename?: 'Mutation', createBrandBookmark: { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null } };

export type DeleteBookmarkForSocialListeningBookmarkHandlersMutationVariables = Exact<{
  input: DeleteBrandBookmarkInput;
}>;


export type DeleteBookmarkForSocialListeningBookmarkHandlersMutation = { __typename?: 'Mutation', deleteBrandBookmark: { __typename?: 'Result', message: string, success: boolean, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type BrandFragmentForUseBrandSelectorFragment = { __typename?: 'BrandModel', id: string, name: string, generalPermission: GeneralPermission, permissionLevel: PermissionLevel, competitorAnalysisEnabled: boolean, organizationId?: string | null, creators: Array<{ __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null }>, inviteMembers: Array<{ __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }> };

export type CreatorFragmentUseSocialListeningCreatorLinkGeneratorFragment = { __typename?: 'CreatorModel', id: string, handle: string, platform: Platform, platformId: string };

export type SocialPostFragmentUseSocialListeningPostLinkGeneratorFragment = { __typename?: 'SocialPostModel', id: string, platformId: string, platform: Platform, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null };

export type GetSocialPostsQueryVariables = Exact<{
  filters?: InputMaybe<GetPaginatedSocialPostFilterInput>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SocialListeningPostsSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  take?: InputMaybe<Scalars['Int']>;
  topicIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  brandId: Scalars['String'];
  searchType?: InputMaybe<SocialPostSearchType>;
  contextualSearch?: InputMaybe<Scalars['String']>;
}>;


export type GetSocialPostsQuery = { __typename?: 'Query', getPaginatedSocialPosts: { __typename?: 'PaginatedSocialPost', data: Array<{ __typename: 'SocialPostModel', id: string, commentCount: number, createdAt: any, creatorId?: string | null, description: string, diggCount: number, duration: number, engagementRate: number, isAd: boolean, matchedMusic?: string | null, platform: Platform, platformCreateTime: any, platformId: string, playCount: number, region?: string | null, shareCount: number, type: SocialPostType, updatedAt: any, viralRate: number, thumbnailUrl?: string | null, videoUrl?: string | null, videoThumbnailFolderUrl?: string | null, carouselFolderUrl?: string | null, totalEngagement: number, expiresAt?: any | null, bookmarkCount: number, creator?: { __typename?: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, createdAt: any, oneLineSummary: string, reason: string, score: number, sentiment: Sentiment, socialpostId: string, suggestedComment: string, topicId: string, updatedAt: any, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }> | null, socialPostEngagementSuggestionsWithTopic: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, sentiment: Sentiment, score: number, oneLineSummary: string, reason: string, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }>, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, meta: { __typename?: 'PaginationMeta', totalCount: number } } };

export type AddBrandExclusionMutationVariables = Exact<{
  data: ExcludeBrandInput;
}>;


export type AddBrandExclusionMutation = { __typename?: 'Mutation', addBrandExclusion: { __typename?: 'Result', message: string, success: boolean } };

export type BrandCompetitorsDataResponseFragmentSocialListeningAnalyticsCompetitorsRankingFragment = { __typename?: 'BrandCompetitorsDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, totalVideos?: number | null, data: Array<{ __typename?: 'BrandCompetitorsData', percentageShare: number, mentionCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> };

export type BrandCompetitorsSentimentDataResponseFragmentSocialListeningAnalyticsCompetitorsSentimentFragment = { __typename?: 'BrandCompetitorsSentimentDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, data: Array<{ __typename?: 'BrandCompetitorsSentimentData', negativePercentage: number, neutralPercentage: number, positivePercentage: number, positiveCount: number, neutralCount: number, negativeCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> };

export type GetBrandForSentimentTrendsByBrandDialogQueryVariables = Exact<{
  brandId: Scalars['String'];
  data: AllSentimentTrendsInput;
}>;


export type GetBrandForSentimentTrendsByBrandDialogQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, allBrandTrends?: Array<{ __typename?: 'BrandTrendsBySentimentData', score: number, data: { __typename?: 'BrandTrendIdentifierModel', name: string, sentiment: Sentiment, brandId: string } }> | null } };

export type BrandFragmentSentimentTrendsByBrandDialogFragment = { __typename?: 'BrandModel', id: string, name: string, topics: Array<{ __typename: 'TopicModel', id: string, name: string, type: ListeningTopicType, topicContentStrategy?: string | null }>, brandCompetitors: { __typename?: 'BrandCompetitorsDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, totalVideos?: number | null, data: Array<{ __typename?: 'BrandCompetitorsData', percentageShare: number, mentionCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }, brandCompetitorsSentiment: { __typename?: 'BrandCompetitorsSentimentDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, data: Array<{ __typename?: 'BrandCompetitorsSentimentData', negativePercentage: number, neutralPercentage: number, positivePercentage: number, positiveCount: number, neutralCount: number, negativeCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> } };

export type BrandFragmentSocialMediaListeningAnalyticsCompetitorsViewFragment = { __typename?: 'BrandModel', id: string, name: string, topics: Array<{ __typename: 'TopicModel', id: string, name: string, type: ListeningTopicType, topicContentStrategy?: string | null }>, brandCompetitors: { __typename?: 'BrandCompetitorsDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, totalVideos?: number | null, data: Array<{ __typename?: 'BrandCompetitorsData', percentageShare: number, mentionCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }, brandCompetitorsSentiment: { __typename?: 'BrandCompetitorsSentimentDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, data: Array<{ __typename?: 'BrandCompetitorsSentimentData', negativePercentage: number, neutralPercentage: number, positivePercentage: number, positiveCount: number, neutralCount: number, negativeCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> } };

export type GetBrandDataForSocialListeningAnalyticsCompetitorsQueryVariables = Exact<{
  id: Scalars['String'];
  competitorsDataInput: BrandCompetitorsInput;
}>;


export type GetBrandDataForSocialListeningAnalyticsCompetitorsQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, name: string, topics: Array<{ __typename: 'TopicModel', id: string, name: string, type: ListeningTopicType, topicContentStrategy?: string | null }>, brandCompetitors: { __typename?: 'BrandCompetitorsDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, totalVideos?: number | null, data: Array<{ __typename?: 'BrandCompetitorsData', percentageShare: number, mentionCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }, brandCompetitorsSentiment: { __typename?: 'BrandCompetitorsSentimentDataResponse', currentDurationRank?: number | null, previousDurationRank?: number | null, data: Array<{ __typename?: 'BrandCompetitorsSentimentData', negativePercentage: number, neutralPercentage: number, positivePercentage: number, positiveCount: number, neutralCount: number, negativeCount: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> } } };

export type GetAllBrandClaimsTrendsForAllCategoriesDialogQueryVariables = Exact<{
  data: AllSentimentTrendsInput;
}>;


export type GetAllBrandClaimsTrendsForAllCategoriesDialogQuery = { __typename?: 'Query', brands: Array<{ __typename?: 'BrandModel', id: string, allBrandTrends?: Array<{ __typename?: 'BrandTrendsBySentimentData', score: number, data: { __typename: 'BrandTrendIdentifierModel', sentiment: Sentiment, name: string, brandId: string } }> | null }> };

export type BrandSentimentTrendBySentimentDataFragmentSentimentTrendTableDataFragment = { __typename?: 'BrandTrendsBySentimentData', score: number, data: { __typename?: 'BrandTrendIdentifierModel', name: string, brandId: string, sentiment: Sentiment } };

export type GetSocialPostsByTrendQueryVariables = Exact<{
  categoryName: Scalars['String'];
  sentiment: Sentiment;
  topicIds: Array<Scalars['String']> | Scalars['String'];
  brandId: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
  timeRange?: InputMaybe<MetricsTimeRange>;
}>;


export type GetSocialPostsByTrendQuery = { __typename?: 'Query', getSocialPostsByTrend: { __typename?: 'PaginatedSocialPost', meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, data: Array<{ __typename: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, platformId: string, createdAt: any, videoUrl?: string | null, platform: Platform, diggCount: number, shareCount: number, playCount: number, platformCreateTime: any, commentCount: number, engagementRate: number, type: SocialPostType, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, sentimentScore?: number | null, sentimentTone?: Sentiment | null, isConfident: boolean, brandClaims: Array<{ __typename?: 'BrandClaimModel', id: string, claim: string, attribute?: string | null, sentimentScore: number, brandId: string, brand: { __typename?: 'BrandModel', id: string, name: string } }>, brand: { __typename?: 'BrandModel', id: string, name: string } }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string, videoSummary: string, highlights: Array<{ __typename?: 'VideoHighlight', end: number, start: number, highlightSummary?: string | null }> }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null, detailedSummary?: string | null } | null, audioTranscription: Array<{ __typename?: 'AudioTranscript', start: number, speaker?: string | null, sentence?: string | null, end: number }>, sentimentTexts: Array<{ __typename?: 'BrandSentimentTextModel', id: string, category: string, keyword: string, sentiment: Sentiment, subCategory: string }>, communityComments: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, parentSocialPostCommentId?: string | null, diggCount: number, platformCreateTime: any, text: string, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null } }>, creator?: { __typename: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null }> } };

export type BrandSentimentTrendBySentimentDataFragmentThemeDialogFragment = { __typename?: 'BrandTrendsBySentimentData', score: number, data: { __typename?: 'BrandTrendIdentifierModel', name: string, brandId: string, sentiment: Sentiment } };

export type SentimentMetricsFragmentSentimentThemeCardFragment = { __typename?: 'SentimentMetric', averageCountPerDay: number, totalCount?: number | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> };

export type TopicFragmentSocialMediaListeningTopicsFilterFragment = { __typename: 'TopicModel', id: string, name: string, type: ListeningTopicType, topicContentStrategy?: string | null };

export type BrandMentionedMetricsFragmentSocialListeningAnalyticsInboundFragment = { __typename?: 'BrandMentionedMetrics', averageCountPerDay: number, allTimeHigh: { __typename?: 'ChartDataPoint', X: any, Y: number }, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> };

export type GetBrandDataForSocialListeningAnalyticsQueryVariables = Exact<{
  brandId: Scalars['String'];
  brandMentionedMetricsData: BrandMentionedMetricsInput;
  sentimentMetricsData: SentimentMetricsInput;
  brandTrendsBySentiment: SentimentMetricsInput;
}>;


export type GetBrandDataForSocialListeningAnalyticsQuery = { __typename?: 'Query', brand: { __typename: 'BrandModel', id: string, name: string, topics: Array<{ __typename: 'TopicModel', id: string, name: string, type: ListeningTopicType, topicContentStrategy?: string | null }>, brandMentionsMetrics?: { __typename?: 'BrandMentionedMetrics', averageCountPerDay: number, allTimeHigh: { __typename?: 'ChartDataPoint', X: any, Y: number }, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> } | null, sentimentMetrics?: { __typename?: 'SentimentMetricsModel', neutral: { __typename?: 'SentimentMetric', averageCountPerDay: number, totalCount?: number | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> }, negative: { __typename?: 'SentimentMetric', averageCountPerDay: number, totalCount?: number | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> }, positive: { __typename?: 'SentimentMetric', averageCountPerDay: number, totalCount?: number | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> } } | null, brandTrendsBySentiment: { __typename?: 'BrandTrendsBySentimentResponse', positive: Array<{ __typename?: 'BrandTrendsBySentimentData', score: number, data: { __typename?: 'BrandTrendIdentifierModel', name: string, brandId: string, sentiment: Sentiment } }>, negative: Array<{ __typename?: 'BrandTrendsBySentimentData', score: number, data: { __typename?: 'BrandTrendIdentifierModel', name: string, brandId: string, sentiment: Sentiment } }>, neutral: Array<{ __typename?: 'BrandTrendsBySentimentData', score: number, data: { __typename?: 'BrandTrendIdentifierModel', name: string, brandId: string, sentiment: Sentiment } }> }, bookmarkState: { __typename?: 'BrandBookmarkState', ownedBrandAnalytics: boolean, ugcAnalytics: boolean }, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> } };

export type GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery = { __typename?: 'Query', brands: Array<{ __typename?: 'BrandModel', id: string, name: string, topics: Array<{ __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType }>, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> }> };

export type GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables = Exact<{
  brandId: Scalars['String'];
  filters: BrandMetricsFilters;
}>;


export type GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery = { __typename?: 'Query', brandOutboundResponseMetrics: { __typename?: 'BrandMetricsResponse', total: number, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> } };

export type GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables = Exact<{
  brandId: Scalars['String'];
  filters: BrandMetricsFilters;
}>;


export type GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery = { __typename?: 'Query', brandOutboundLikeMetrics: { __typename?: 'BrandMetricsResponse', total: number, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> } };

export type GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables = Exact<{
  brandId: Scalars['String'];
  filters: BrandMetricsFilters;
}>;


export type GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery = { __typename?: 'Query', brandOutboundReplyMetrics: { __typename?: 'BrandMetricsResponse', total: number, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> } };

export type GetSocialPostCommentsForLeaderboardDetailViewQueryVariables = Exact<{
  brandId: Scalars['String'];
  data: SocialPostCommentsInput;
}>;


export type GetSocialPostCommentsForLeaderboardDetailViewQuery = { __typename?: 'Query', socialPostComments: { __typename?: 'PaginatedSocialPostComment', data: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, text: string, diggCount: number, platformCreateTime: any, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type BrandOutboundLeaderboardItemFragmentLeaderboardSectionFragment = { __typename?: 'BrandOutboundLeaderboardItem', id: string, averageEngagement: number, numberOfPostsCommentedOn: number, maxLikes: number, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, bestPerformingSocialPosts: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null }> };

export type GetBrandOutboundLeaderboardForLeaderboardSectionQueryVariables = Exact<{
  brandIds: Array<Scalars['String']> | Scalars['String'];
  filters: BrandOutboundLeaderboardFilters;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetBrandOutboundLeaderboardForLeaderboardSectionQuery = { __typename?: 'Query', brandOutboundLeaderboard: { __typename?: 'PaginatedBrandOutboundLeaderboardResponse', data: Array<{ __typename?: 'BrandOutboundLeaderboardItem', id: string, averageEngagement: number, numberOfPostsCommentedOn: number, maxLikes: number, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, bestPerformingSocialPosts: Array<{ __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, videoUrl?: string | null }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type BrandMetricsResponseFragmentMetricsChartFragment = { __typename?: 'BrandMetricsResponse', total: number, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', X: any, Y: number }> };

export type GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryVariables = Exact<{
  brandId: Scalars['String'];
  data: SocialPostCommentsInput;
}>;


export type GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery = { __typename?: 'Query', socialPostComments: { __typename?: 'PaginatedSocialPostComment', data: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, text: string, diggCount: number, platformCreateTime: any, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } }>, meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type SocialPostCommentFragmentSocialPostCommentsListViewTableRowFragment = { __typename?: 'SocialPostCommentModel', id: string, platformCreateTime: any, text: string, diggCount: number, childCommentCount: number, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } };

export type TopicFragmentCreatorPeekingContentFragment = { __typename?: 'TopicModel', id: string, name: string };

export type GetBrandTopicsForCreatorsListingQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandTopicsForCreatorsListingQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, topics: Array<{ __typename?: 'TopicModel', active: boolean, id: string, name: string, creatorTrackingTopics: Array<{ __typename?: 'CreatorTrackingTopicModel', id: string, creatorId: string }> }> } };

export type SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationVariables = Exact<{
  topicId: Scalars['String'];
  daysCount: Scalars['Int'];
  includeTiktok?: InputMaybe<Scalars['Boolean']>;
  includeInstagram?: InputMaybe<Scalars['Boolean']>;
}>;


export type SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation = { __typename?: 'Mutation', submitInitialTopicParsing: { __typename?: 'Result', message: string, success: boolean } };

export type CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationVariables = Exact<{
  data: CreateCompetitorInput;
}>;


export type CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation = { __typename?: 'Mutation', createCompetitors: Array<{ __typename?: 'CompetitorModel', id: string }> };

export type SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationVariables = Exact<{
  daysCount: Scalars['Int'];
  topicId: Scalars['String'];
}>;


export type SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation = { __typename?: 'Mutation', submitCreatorTrackingTopicParsing: { __typename?: 'Result', message: string, success: boolean } };

export type SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationVariables = Exact<{
  topicId: Scalars['String'];
  daysCount: Scalars['Int'];
  includeTiktok?: InputMaybe<Scalars['Boolean']>;
  includeInstagram?: InputMaybe<Scalars['Boolean']>;
}>;


export type SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation = { __typename?: 'Mutation', submitInitialTopicParsing: { __typename?: 'Result', message: string, success: boolean } };

export type GetBrandForSmlOnboardingBrandParsingSettingsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBrandForSmlOnboardingBrandParsingSettingsQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, topics: Array<{ __typename?: 'TopicModel', id: string, type: ListeningTopicType }>, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type UpdateTopicForSmlOnboardingBrandParsingSettingsMutationVariables = Exact<{
  data: UpdateTopicInput;
}>;


export type UpdateTopicForSmlOnboardingBrandParsingSettingsMutation = { __typename?: 'Mutation', updateTopic: { __typename?: 'TopicModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationVariables = Exact<{
  handle: Scalars['String'];
  platform: Scalars['String'];
}>;


export type TriggerFetchNewCreatorIntoDbForCompetitorDetailMutation = { __typename?: 'Mutation', fetchNewCreatorIntoDb: { __typename?: 'Result', success: boolean } };

export type GetAiGeneratedBrandDescriptionForCompetitorDetailQueryVariables = Exact<{
  brandName: Scalars['String'];
}>;


export type GetAiGeneratedBrandDescriptionForCompetitorDetailQuery = { __typename?: 'Query', aiGeneratedBrandDescription: string };

export type GetAiGeneratedKeywordsForCompetitorDetailQueryVariables = Exact<{
  description: Scalars['String'];
}>;


export type GetAiGeneratedKeywordsForCompetitorDetailQuery = { __typename?: 'Query', getAIKeywordsForBrandDescription: Array<string> };

export type GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryVariables = Exact<{
  brandId: Scalars['String'];
  filters: SocialCreatorFilters;
}>;


export type GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery = { __typename?: 'Query', getSuggestedCreators: Array<{ __typename?: 'CreatorModel', id: string, audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number }> };

export type GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery = { __typename?: 'Query', sentimentSubjectsByTopic: Array<{ __typename?: 'SentimentSubjectModel', id: string, subject: string, topicId: string }> };

export type UpsertSentimentSubjectsMutationVariables = Exact<{
  data: UpsertSentimentSubjectInput;
}>;


export type UpsertSentimentSubjectsMutation = { __typename?: 'Mutation', upsertSentimentSubjects: Array<{ __typename?: 'SentimentSubjectModel', id: string }> };

export type GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery = { __typename?: 'Query', topicSignalDefinitions: Array<{ __typename?: 'SignalDefinitionModel', id: string, title: string, description: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string }> }> };

export type CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationVariables = Exact<{
  data: CreateSignalDefinitionInput;
}>;


export type CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation = { __typename?: 'Mutation', createSignalDefinition: { __typename?: 'SignalDefinitionModel', id: string, title: string, description: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string }> } };

export type CreatorFragmentSocialMediaListeningOnboardingSocialHandleFormFragment = { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null, handle: string, platform: Platform };

export type GetTopicForSmlOnboardingTopicParsingSettingsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTopicForSmlOnboardingTopicParsingSettingsQuery = { __typename?: 'Query', topic: { __typename?: 'TopicModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type CreatePermissionRequestForSocialListeningPermissionRequestMutationVariables = Exact<{
  data: CreatePermissionRequestInput;
}>;


export type CreatePermissionRequestForSocialListeningPermissionRequestMutation = { __typename?: 'Mutation', createPermissionRequest: { __typename?: 'PermissionRequestModel', id: string } };

export type SocialPostFragmentWhatYouCanSayFragment = { __typename?: 'SocialPostModel', id: string, platformId: string, platform: Platform, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null, socialPostEngagementSuggestions?: Array<{ __typename: 'SocialPostEngagementSuggestionModel', id: string, sentiment: Sentiment, suggestedComment: string }> | null };

export type GetSocialPostForSocialMediaListeningPostDetailQueryVariables = Exact<{
  socialPostId: Scalars['String'];
  topicIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  brandId: Scalars['String'];
}>;


export type GetSocialPostForSocialMediaListeningPostDetailQuery = { __typename?: 'Query', socialPost: { __typename: 'SocialPostModel', id: string, expiresAt?: any | null, totalContentCalendarSaves: number, isSavedToContentCalendar: boolean, type: SocialPostType, totalPostSaves: number, platformId: string, createdAt: any, videoUrl?: string | null, thumbnailUrl?: string | null, platform: Platform, description: string, diggCount: number, shareCount: number, playCount: number, platformCreateTime: any, commentCount: number, engagementRate: number, savedPost?: { __typename?: 'PostModel', id: string, isFavorite: boolean, isFavoriteTrend: boolean } | null, carouselMedias: Array<{ __typename?: 'CarouselMedia', id: string, type: CarouselMediaTypeEnum, url: string }>, sentimentTexts: Array<{ __typename?: 'BrandSentimentTextModel', id: string, sentiment: Sentiment, keyword: string, category: string, subCategory: string, brandId: string }>, socialPostEngagementSuggestionsWithTopic: Array<{ __typename: 'SocialPostEngagementSuggestionModel', id: string, sentiment: Sentiment, score: number, suggestedComment: string, oneLineSummary: string, reason: string, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }>, socialPostEngagementSuggestions?: Array<{ __typename: 'SocialPostEngagementSuggestionModel', id: string, sentiment: Sentiment, score: number, suggestedComment: string, oneLineSummary: string, reason: string, videoSummary: string, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null, highlights: Array<{ __typename?: 'VideoHighlight', end: number, start: number, highlightSummary?: string | null }> }> | null, audioTranscription: Array<{ __typename?: 'AudioTranscript', start: number, speaker?: string | null, sentence?: string | null, end: number }>, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null, detailedSummary?: string | null } | null, communityComments: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, parentSocialPostCommentId?: string | null, diggCount: number, platformCreateTime: any, text: string, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null } }>, creator?: { __typename: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', sentimentScore?: number | null, isConfident: boolean, sentimentTone?: Sentiment | null, brand: { __typename?: 'BrandModel', id: string, name: string }, brandClaims: Array<{ __typename?: 'BrandClaimModel', attribute?: string | null, claim: string, brandId: string, sentimentScore: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }> } };

export type SocialPostFragmentPostVideoDialogFragment = { __typename: 'SocialPostModel', id: string, platformId: string, createdAt: any, videoUrl?: string | null, thumbnailUrl?: string | null, platform: Platform, description: string, diggCount: number, shareCount: number, playCount: number, platformCreateTime: any, commentCount: number, engagementRate: number, type: SocialPostType, audioTranscription: Array<{ __typename?: 'AudioTranscript', start: number, speaker?: string | null, sentence?: string | null, end: number }>, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null, detailedSummary?: string | null } | null, sentimentTexts: Array<{ __typename?: 'BrandSentimentTextModel', id: string, category: string, keyword: string, sentiment: Sentiment, subCategory: string }>, communityComments: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, parentSocialPostCommentId?: string | null, diggCount: number, platformCreateTime: any, text: string, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null } }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string, videoSummary: string, highlights: Array<{ __typename?: 'VideoHighlight', end: number, start: number, highlightSummary?: string | null }> }> | null, creator?: { __typename: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', sentimentScore?: number | null, isConfident: boolean, sentimentTone?: Sentiment | null, brand: { __typename?: 'BrandModel', id: string, name: string }, brandClaims: Array<{ __typename?: 'BrandClaimModel', attribute?: string | null, claim: string, brandId: string, sentimentScore: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }> };

export type SocialPostFragmentPostVideoDialogContentTabsFragment = { __typename: 'SocialPostModel', id: string, platformId: string, createdAt: any, videoUrl?: string | null, thumbnailUrl?: string | null, platform: Platform, description: string, diggCount: number, shareCount: number, playCount: number, platformCreateTime: any, commentCount: number, engagementRate: number, type: SocialPostType, audioTranscription: Array<{ __typename?: 'AudioTranscript', start: number, speaker?: string | null, sentence?: string | null, end: number }>, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null, detailedSummary?: string | null } | null, sentimentTexts: Array<{ __typename?: 'BrandSentimentTextModel', id: string, category: string, keyword: string, sentiment: Sentiment, subCategory: string }>, communityComments: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, parentSocialPostCommentId?: string | null, diggCount: number, platformCreateTime: any, text: string, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null } }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string, videoSummary: string, highlights: Array<{ __typename?: 'VideoHighlight', end: number, start: number, highlightSummary?: string | null }> }> | null, creator?: { __typename: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', sentimentScore?: number | null, isConfident: boolean, sentimentTone?: Sentiment | null, brand: { __typename?: 'BrandModel', id: string, name: string }, brandClaims: Array<{ __typename?: 'BrandClaimModel', attribute?: string | null, claim: string, brandId: string, sentimentScore: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }> };

export type SocialPostCommentFragmentSocialPostCommunityCommentsFragment = { __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, parentSocialPostCommentId?: string | null, diggCount: number, platformCreateTime: any, text: string, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null } };

export type SocialPostFragmentPostVideoDialogVideoHighlightsFragment = { __typename: 'SocialPostModel', id: string, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string, highlights: Array<{ __typename?: 'VideoHighlight', end: number, start: number, highlightSummary?: string | null }> }> | null };

export type SocialPostFragmentPostVideoDialogVideoTranscriptFragment = { __typename?: 'SocialPostModel', id: string, audioTranscription: Array<{ __typename?: 'AudioTranscript', start: number, end: number, speaker?: string | null, sentence?: string | null }> };

export type SocialPostFragmentSocialMediaListeningPostSummaryFragment = { __typename: 'SocialPostModel', id: string, platformId: string, createdAt: any, videoUrl?: string | null, thumbnailUrl?: string | null, platform: Platform, description: string, diggCount: number, shareCount: number, playCount: number, platformCreateTime: any, commentCount: number, engagementRate: number, type: SocialPostType, audioTranscription: Array<{ __typename?: 'AudioTranscript', start: number, speaker?: string | null, sentence?: string | null, end: number }>, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null, detailedSummary?: string | null } | null, sentimentTexts: Array<{ __typename?: 'BrandSentimentTextModel', id: string, category: string, keyword: string, sentiment: Sentiment, subCategory: string }>, communityComments: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, parentSocialPostCommentId?: string | null, diggCount: number, platformCreateTime: any, text: string, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, profilePictureUrl?: string | null } }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string, videoSummary: string, highlights: Array<{ __typename?: 'VideoHighlight', end: number, start: number, highlightSummary?: string | null }> }> | null, creator?: { __typename: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', sentimentScore?: number | null, isConfident: boolean, sentimentTone?: Sentiment | null, brand: { __typename?: 'BrandModel', id: string, name: string }, brandClaims: Array<{ __typename?: 'BrandClaimModel', attribute?: string | null, claim: string, brandId: string, sentimentScore: number, brand: { __typename?: 'BrandModel', id: string, name: string } }> }> };

export type SocialPostFragmentSocialMediaListeningPostCardFragment = { __typename?: 'SocialPostModel', commentCount: number, createdAt: any, expiresAt?: any | null, totalEngagement: number, description: string, diggCount: number, duration: number, engagementRate: number, bookmarkCount: number, id: string, isAd: boolean, platform: Platform, platformId: string, platformCreateTime: any, playCount: number, shareCount: number, type: SocialPostType, updatedAt: any, viralRate: number, thumbnailUrl?: string | null, videoUrl?: string | null, videoThumbnailFolderUrl?: string | null, carouselFolderUrl?: string | null, creator?: { __typename?: 'CreatorModel', createdAt: any, engagementRate: number, followerCount: number, handle: string, id: string, industry?: string | null, nickName: string, platform: Platform, profilePictureUrl?: string | null, updatedAt: any } | null, socialPostEngagementSuggestionsWithTopic: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, sentiment: Sentiment, score: number, oneLineSummary: string, reason: string, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, createdAt: any, oneLineSummary: string, reason: string, score: number, sentiment: Sentiment, socialpostId: string, topicId: string, updatedAt: any, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }> | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null };

export type SocialPostFragmentSocialMediaListeningPostsGridViewFragment = { __typename?: 'SocialPostModel', commentCount: number, createdAt: any, expiresAt?: any | null, totalEngagement: number, description: string, diggCount: number, duration: number, engagementRate: number, bookmarkCount: number, id: string, isAd: boolean, platform: Platform, platformId: string, platformCreateTime: any, playCount: number, shareCount: number, type: SocialPostType, updatedAt: any, viralRate: number, thumbnailUrl?: string | null, videoUrl?: string | null, videoThumbnailFolderUrl?: string | null, carouselFolderUrl?: string | null, creator?: { __typename?: 'CreatorModel', createdAt: any, engagementRate: number, followerCount: number, handle: string, id: string, industry?: string | null, nickName: string, platform: Platform, profilePictureUrl?: string | null, updatedAt: any } | null, socialPostEngagementSuggestionsWithTopic: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, sentiment: Sentiment, score: number, oneLineSummary: string, reason: string, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, createdAt: any, oneLineSummary: string, reason: string, score: number, sentiment: Sentiment, socialpostId: string, topicId: string, updatedAt: any, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }> | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null };

export type SocialPostEngagementSuggestionFragmentSocialMediaListeningListItemFragment = { __typename?: 'SocialPostEngagementSuggestionModel', id: string, createdAt: any, oneLineSummary: string, reason: string, score: number, sentiment: Sentiment, socialpostId: string, suggestedComment: string, topicId: string, updatedAt: any, socialPost?: { __typename?: 'SocialPostModel', commentCount: number, createdAt: any, creatorId?: string | null, description: string, diggCount: number, duration: number, engagementRate: number, bookmarkCount: number, id: string, isAd: boolean, matchedMusic?: string | null, platform: Platform, platformCreateTime: any, platformId: string, playCount: number, region?: string | null, shareCount: number, type: SocialPostType, updatedAt: any, viralRate: number, thumbnailUrl?: string | null, videoUrl?: string | null, videoThumbnailFolderUrl?: string | null, carouselFolderUrl?: string | null, creator?: { __typename?: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null } | null };

export type SocialPostFragmentSocialMediaListeningListItemFragment = { __typename?: 'SocialPostModel', commentCount: number, createdAt: any, creatorId?: string | null, description: string, diggCount: number, duration: number, engagementRate: number, id: string, isAd: boolean, matchedMusic?: string | null, platform: Platform, platformCreateTime: any, platformId: string, playCount: number, region?: string | null, shareCount: number, type: SocialPostType, updatedAt: any, viralRate: number, thumbnailUrl?: string | null, videoUrl?: string | null, videoThumbnailFolderUrl?: string | null, carouselFolderUrl?: string | null, totalEngagement: number, creator?: { __typename?: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, createdAt: any, oneLineSummary: string, reason: string, score: number, sentiment: Sentiment, socialpostId: string, suggestedComment: string, topicId: string, updatedAt: any, topic?: { __typename?: 'TopicModel', id: string, name: string } | null }> | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null };

export type SocialPostFragmentSocialMediaListeningPostsListViewFragment = { __typename?: 'SocialPostModel', commentCount: number, createdAt: any, creatorId?: string | null, description: string, diggCount: number, duration: number, engagementRate: number, id: string, isAd: boolean, matchedMusic?: string | null, platform: Platform, platformCreateTime: any, platformId: string, playCount: number, region?: string | null, shareCount: number, type: SocialPostType, updatedAt: any, viralRate: number, thumbnailUrl?: string | null, videoUrl?: string | null, videoThumbnailFolderUrl?: string | null, carouselFolderUrl?: string | null, totalEngagement: number, creator?: { __typename?: 'CreatorModel', audience_demographics?: string | null, createdAt: any, engagementRate: number, followerCount: number, followingCount: number, handle: string, id: string, industry?: string | null, likeCount: number, nickName: string, platform: Platform, platformId: string, profilePictureUrl?: string | null, signature?: string | null, updatedAt: any, videoCount: number } | null, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, createdAt: any, oneLineSummary: string, reason: string, score: number, sentiment: Sentiment, socialpostId: string, suggestedComment: string, topicId: string, updatedAt: any, topic?: { __typename?: 'TopicModel', id: string, name: string } | null }> | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null };

export type GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery = { __typename?: 'Query', existingSocialPostReportReasons: Array<string> };

export type CreateSocialPostReportForSocialListeningReportPostViewMutationVariables = Exact<{
  data: CreateSocialPostReportInput;
}>;


export type CreateSocialPostReportForSocialListeningReportPostViewMutation = { __typename?: 'Mutation', createSocialPostReport: { __typename?: 'SocialPostReportModel', id: string } };

export type UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationVariables = Exact<{
  data: UpdateBrandSocialPostEngagementInput;
}>;


export type UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation = { __typename?: 'Mutation', updateBrandSocialPostEngagement: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } };

export type SocialPostFragmentBrandSocialPostEngagementStatusFragment = { __typename?: 'SocialPostModel', id: string, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null };

export type SocialPostFragmentSocialPostPlatformFragment = { __typename?: 'SocialPostModel', id: string, platform: Platform };

export type SocialPostFragmentSocialPostClaimsCardFragment = { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null, description: string, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, oneLineSummary: string }> | null, contextualInformation?: { __typename?: 'SocialPostContextualInformation', oneLineSummary?: string | null } | null };

export type SocialPostFragmentSocialPostThumbnailFragment = { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null };

export type UpdateBrandSocialPostEngagementMutationVariables = Exact<{
  data: UpdateBrandSocialPostEngagementInput;
}>;


export type UpdateBrandSocialPostEngagementMutation = { __typename?: 'Mutation', updateBrandSocialPostEngagement: { __typename?: 'BrandSocialPostEngagementModel', id: string } };

export type SocialPostFragmentSocialPostCardViewFragment = { __typename?: 'SocialPostModel', id: string, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, playCount: number, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string, profilePictureUrl?: string | null } | null };

export type SocialPostCommentFragmentSocialPostCommentResponderButtonFragment = { __typename?: 'SocialPostCommentModel', id: string, socialPost: { __typename?: 'SocialPostModel', id: string, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string } | null } | null } };

export type SocialPostCommentFragmentSocialPostCommentResponderPillFragment = { __typename?: 'SocialPostCommentModel', id: string, socialPost: { __typename?: 'SocialPostModel', id: string, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } | null } };

export type SocialPostCommentFragmentSocialPostCommentCreatedTimeFragment = { __typename?: 'SocialPostCommentModel', id: string, platformCreateTime: any };

export type SocialPostCommentFragmentSocialPostCommentLikesFragment = { __typename?: 'SocialPostCommentModel', id: string, diggCount: number };

export type SocialPostCommentFragmentSocialPostCommentRepliesFragment = { __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number };

export type SocialPostCommentFragmentSocialPostCommentTextFragment = { __typename?: 'SocialPostCommentModel', id: string, text: string };

export type UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationVariables = Exact<{
  data: UpdateBrandSocialPostEngagementResponderInput;
}>;


export type UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation = { __typename?: 'Mutation', updateBrandSocialPostEngagementResponder: { __typename?: 'Result', success: boolean, message: string } };

export type SocialPostCommentFragmentUseResponderChangeFragment = { __typename?: 'SocialPostCommentModel', id: string, socialPost: { __typename?: 'SocialPostModel', id: string, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string } | null } | null } };

export type SocialPostCommentFragmentSocialPostCommentCardViewFragment = { __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, text: string, diggCount: number, platformCreateTime: any, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } };

export type TaskFragmentTaskAssigneeFragment = { __typename?: 'TaskModel', id: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type UpdateTaskForTaskAssigneeMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskAssigneeMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } };

export type TaskFragmentTaskContextMenuFragment = { __typename?: 'TaskModel', id: string, myPermissions: Array<TaskPermission> };

export type DeleteTaskForTaskContextMenuMutationVariables = Exact<{
  data: DeleteTaskInput;
}>;


export type DeleteTaskForTaskContextMenuMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'Result', message: string, success: boolean } };

export type TaskFragmentTaskDescriptionFragment = { __typename?: 'TaskModel', id: string, description: string, myPermissions: Array<TaskPermission> };

export type UpdateTaskForTaskDescriptionMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskDescriptionMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, description: string } };

export type TaskFragmentTaskDueDateFragment = { __typename?: 'TaskModel', id: string, endDate?: any | null };

export type UpdateTaskForTaskDueDateMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskDueDateMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, endDate?: any | null } };

export type TaskFragmentTaskDueDateRangeFragment = { __typename?: 'TaskModel', id: string, startDate?: any | null, endDate?: any | null };

export type UpdateTaskForTaskDueDateRangeMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskDueDateRangeMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, startDate?: any | null, endDate?: any | null } };

export type TaskFragmentTaskNameFragment = { __typename?: 'TaskModel', id: string, name: string, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null };

export type UpdateTaskNameMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskNameMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, name: string } };

export type TaskFragmentTaskPriorityComponentFragment = { __typename?: 'TaskModel', id: string, priority?: TaskPriority | null };

export type UpdateTaskForTaskPriorityComponentMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskPriorityComponentMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, priority?: TaskPriority | null } };

export type TaskFragmentTaskStatusFragment = { __typename?: 'TaskModel', id: string, status: TaskStatus };

export type UpdateTaskForTaskStatusMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskStatusMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, status: TaskStatus } };

export type GetTaskPermissionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskPermissionsQuery = { __typename?: 'Query', task: { __typename?: 'TaskModel', id: string, myPermissions: Array<TaskPermission> } };

export type TaskFragmentTaskCalendarEventViewFragment = { __typename?: 'TaskModel', id: string, name: string, startDate?: any | null, endDate?: any | null, status: TaskStatus, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null };

export type TaskFragmentTaskDetailViewNestedTaskNavigationContextFragment = { __typename?: 'TaskModel', id: string, name: string };

export type CreateSubtaskForTaskDetailViewMutationVariables = Exact<{
  data: CreateTaskInput;
}>;


export type CreateSubtaskForTaskDetailViewMutation = { __typename?: 'Mutation', createTask: { __typename?: 'TaskModel', parentTaskId?: string | null, sortOrder?: number | null, myPermissions: Array<TaskPermission>, id: string, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } };

export type UpdateSubtaskForTaskDetailViewMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateSubtaskForTaskDetailViewMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, startDate?: any | null, endDate?: any | null, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string }> } };

export type DeleteSubtaskForTaskDetailViewMutationVariables = Exact<{
  data: DeleteTaskInput;
}>;


export type DeleteSubtaskForTaskDetailViewMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'Result', success: boolean, message: string } };

export type UpdateTaskForTaskDetailViewMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskDetailViewMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, name: string, description: string, status: TaskStatus, startDate?: any | null, endDate?: any | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string }> } };

export type DeleteTaskForTaskDetailViewMutationVariables = Exact<{
  data: DeleteTaskInput;
}>;


export type DeleteTaskForTaskDetailViewMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'Result', success: boolean, message: string } };

export type PostFragmentTaskHeadingSectionFragment = { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type GetPostForTaskDetailViewHeadingSectionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForTaskDetailViewHeadingSectionQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type TaskFragmentTaskDetailViewLocationNavigatorFragment = { __typename?: 'TaskModel', id: string, name: string };

export type UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, posts?: Array<{ __typename?: 'PostModel', id: string, description: string, title?: string | null, myPermissions: Array<PostPermission>, type: PostType, unreadCommentCount: number, isNew?: boolean | null, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> }> | null } };

export type GetTaskForTaskDetailViewMediaSectionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskForTaskDetailViewMediaSectionQuery = { __typename?: 'Query', task: { __typename?: 'TaskModel', id: string, posts?: Array<{ __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }> | null } };

export type TaskFragmentTaskSubtaskSectionFragment = { __typename?: 'TaskModel', myPermissions: Array<TaskPermission>, id: string, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type TaskFragmentTaskDetailViewFragment = { __typename?: 'TaskModel', id: string, name: string, description: string, startDate?: any | null, endDate?: any | null, status: TaskStatus, priority?: TaskPriority | null, parentTaskId?: string | null, isPreview: boolean, myPermissions: Array<TaskPermission>, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, subtasks: Array<{ __typename?: 'TaskModel', myPermissions: Array<TaskPermission>, id: string, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null };

export type GetTaskForTaskDetailViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskForTaskDetailViewQuery = { __typename?: 'Query', task: { __typename?: 'TaskModel', id: string, name: string, description: string, startDate?: any | null, endDate?: any | null, status: TaskStatus, priority?: TaskPriority | null, parentTaskId?: string | null, isPreview: boolean, myPermissions: Array<TaskPermission>, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, subtasks: Array<{ __typename?: 'TaskModel', myPermissions: Array<TaskPermission>, id: string, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null } };

export type GetTaskWithTaskMembersForTaskDetailViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskWithTaskMembersForTaskDetailViewQuery = { __typename?: 'Query', task: { __typename?: 'TaskModel', id: string, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } };

export type TaskFragmentTaskListItemViewFragment = { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type UpdateTaskForTaskListItemViewMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForTaskListItemViewMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } };

export type TaskFragmentTaskPeekingCardViewFragment = { __typename?: 'TaskModel', id: string, name: string, startDate?: any | null, endDate?: any | null, status: TaskStatus, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, posts?: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> | null };

export type GetTaskForTaskPeekingCardViewQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type GetTaskForTaskPeekingCardViewQuery = { __typename?: 'Query', task: { __typename?: 'TaskModel', id: string, name: string, startDate?: any | null, endDate?: any | null, status: TaskStatus, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, posts?: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> | null } };

export type TaskFragmentUseTaskListWithKeyboardShortcutsFragment = { __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type GetTasksForUseTaskListWithKeyboardShortcutsQueryVariables = Exact<{
  filters: TaskFilters;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetTasksForUseTaskListWithKeyboardShortcutsQuery = { __typename?: 'Query', tasks: { __typename?: 'PaginatedTaskSearchResult', data: Array<{ __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, subtasks: Array<{ __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type UpdateTaskForUseTaskListWithKeyboardShortcutsMutationVariables = Exact<{
  data: UpdateTaskInput;
}>;


export type UpdateTaskForUseTaskListWithKeyboardShortcutsMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, subtasks: Array<{ __typename?: 'TaskModel', id: string, parentTaskId?: string | null, sortOrder?: number | null, name: string, status: TaskStatus, priority?: TaskPriority | null, endDate?: any | null, myPermissions: Array<TaskPermission>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } };

export type GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryVariables = Exact<{
  groupBy: TaskGroupBy;
  after?: InputMaybe<Scalars['String']>;
  taskSearchArgs: GetTasksArgs;
}>;


export type GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery = { __typename?: 'Query', taskGroups: { __typename?: 'PaginatedTaskGroupResult', data: Array<{ __typename?: 'TaskGroupModel', id: string, tasks: { __typename?: 'PaginatedTaskSearchResult', meta: { __typename?: 'PaginatedTaskSearchResultMeta', totalCount: number } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', title?: string | null, site?: string | null, medium?: string | null, type?: string | null, author?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery = { __typename?: 'Query', userProfile: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } };

export type GetPostAnnotationsForCommentThreadsPopoverQueryVariables = Exact<{
  filters?: InputMaybe<PostAnnotationFilters>;
}>;


export type GetPostAnnotationsForCommentThreadsPopoverQuery = { __typename?: 'Query', postAnnotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }> };

export type GetPostForEmbedNodeViewPostRendererQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForEmbedNodeViewPostRendererQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', type: PostType, id: string, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type TaskFragmentTaskItemExtensionFragment = { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, startDate?: any | null, endDate?: any | null, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> };

export type GetTaskForTaskItemExtensionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskForTaskItemExtensionQuery = { __typename?: 'Query', task: { __typename?: 'TaskModel', id: string, name: string, status: TaskStatus, startDate?: any | null, endDate?: any | null, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> } };

export type TopicFragmentTopicLabelFragment = { __typename?: 'TopicModel', id: string, type: ListeningTopicType };

export type TopicFragmentTopicMoreContextMenuFragment = { __typename?: 'TopicModel', id: string, type: ListeningTopicType, isBookmarked: boolean, name: string, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } };

export type DeleteTopicForTopicMoreContextMenuMutationVariables = Exact<{
  topicId: Scalars['String'];
}>;


export type DeleteTopicForTopicMoreContextMenuMutation = { __typename?: 'Mutation', deleteTopic: { __typename?: 'Result', success: boolean, message: string } };

export type CreateTopicBookmarkForTopicMoreContextMenuMutationVariables = Exact<{
  input: CreateTopicBookmarkInput;
}>;


export type CreateTopicBookmarkForTopicMoreContextMenuMutation = { __typename?: 'Mutation', createTopicBookmark: { __typename?: 'BookmarkModel', id: string, type: BookmarkType, collection?: { __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null } | null, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, competitor?: { __typename?: 'CompetitorModel', id: string, name: string, forBrand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null, topic?: { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } | null } };

export type DeleteTopicBookmarkForTopicMoreContextMenuMutationVariables = Exact<{
  input: DeleteTopicBookmarkInput;
}>;


export type DeleteTopicBookmarkForTopicMoreContextMenuMutation = { __typename?: 'Mutation', deleteTopicBookmark: { __typename?: 'Result', message: string, success: boolean, deleted?: Array<{ __typename?: 'DeletedResult', id: string }> | null } };

export type TopicFragmentTopicPauseContextMenuFragment = { __typename?: 'TopicModel', id: string, status: TopicStatus, resetOnNextCycle: boolean };

export type PauseTopicForTopicPauseContextMenuMutationVariables = Exact<{
  data: PauseTopicInput;
}>;


export type PauseTopicForTopicPauseContextMenuMutation = { __typename?: 'Mutation', pauseTopic: { __typename?: 'TopicModel', id: string, status: TopicStatus, resetOnNextCycle: boolean } };

export type ResumeTopicForTopicPauseContextMenuMutationVariables = Exact<{
  data: ResumeTopicInput;
}>;


export type ResumeTopicForTopicPauseContextMenuMutation = { __typename?: 'Mutation', resumeTopic: { __typename?: 'TopicModel', id: string, status: TopicStatus, resetOnNextCycle: boolean } };

export type SignalDefinitionFragmentTopicSignalFragment = { __typename?: 'SignalDefinitionModel', id: string, title: string, description: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string }> };

export type UpdateSignalDefinitionForTopicSignalMutationVariables = Exact<{
  data: UpdateSignalDefinitionInput;
}>;


export type UpdateSignalDefinitionForTopicSignalMutation = { __typename?: 'Mutation', updateSignalDefinition: { __typename?: 'SignalDefinitionModel', id: string, title: string, description: string, options: Array<{ __typename?: 'SignalCategoryOptionModel', id: string, label: string }> } };

export type DeleteSignalDefinitionForTopicSignalMutationVariables = Exact<{
  data: DeleteSignalDefinitionInput;
}>;


export type DeleteSignalDefinitionForTopicSignalMutation = { __typename?: 'Mutation', deleteSignalDefinition: { __typename?: 'Result', message: string, success: boolean } };

export type CreateSignalCategoryOptionForTopicSignalMutationVariables = Exact<{
  data: CreateSignalCategoryOptionInput;
}>;


export type CreateSignalCategoryOptionForTopicSignalMutation = { __typename?: 'Mutation', createSignalCategoryOption: { __typename?: 'SignalCategoryOptionModel', id: string, label: string } };

export type UpdateSignalCategoryOptionForTopicSignalMutationVariables = Exact<{
  data: UpdateSignalCategoryOptionInput;
}>;


export type UpdateSignalCategoryOptionForTopicSignalMutation = { __typename?: 'Mutation', updateSignalCategoryOption: { __typename?: 'SignalCategoryOptionModel', id: string, label: string } };

export type DeleteSignalCategoryOptionForTopicSignalMutationVariables = Exact<{
  data: DeleteSignalCategoryOptionInput;
}>;


export type DeleteSignalCategoryOptionForTopicSignalMutation = { __typename?: 'Mutation', deleteSignalCategoryOption: { __typename?: 'Result', message: string, success: boolean } };

export type TopicFragmentTopicBreakdownPopoverViewFragment = { __typename?: 'TopicModel', id: string, name: string, status: TopicStatus, resetOnNextCycle: boolean, type: ListeningTopicType, isBookmarked: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } };

export type GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryVariables = Exact<{
  filters: AggregatedTopicDurationUsageFilters;
  brandId: Scalars['String'];
}>;


export type GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery = { __typename?: 'Query', aggregatedTopicDurationUsage: Array<{ __typename?: 'AggregatedTopicDurationUsageResult', topicId: string, durationUsed: number, topic: { __typename?: 'TopicModel', id: string, name: string, status: TopicStatus, resetOnNextCycle: boolean, type: ListeningTopicType, isBookmarked: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } }> };

export type TopicFragmentTopicBreakdownTableViewFragment = { __typename?: 'TopicModel', id: string, name: string, status: TopicStatus, resetOnNextCycle: boolean, type: ListeningTopicType };

export type GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryVariables = Exact<{
  filters: AggregatedTopicDurationUsageFilters;
  brandId: Scalars['String'];
}>;


export type GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery = { __typename?: 'Query', aggregatedTopicDurationUsage: Array<{ __typename?: 'AggregatedTopicDurationUsageResult', topicId: string, durationUsed: number, totalParsedPostsCount: number, totalPositivelyParsedPostsCount: number, topic: { __typename?: 'TopicModel', id: string, name: string, status: TopicStatus, resetOnNextCycle: boolean, type: ListeningTopicType, isBookmarked: boolean, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } } }> };

export type TopicFragmentTopicContentFilterSettingsViewFragment = { __typename?: 'TopicModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null, brand: { __typename?: 'BrandModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null } };

export type GetTopicForTopicContentFilterSettingsViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTopicForTopicContentFilterSettingsViewQuery = { __typename?: 'Query', topic: { __typename?: 'TopicModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null, brand: { __typename?: 'BrandModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null } } };

export type UpdateTopicForTopicContentFilterSettingsViewMutationVariables = Exact<{
  data: UpdateTopicInput;
}>;


export type UpdateTopicForTopicContentFilterSettingsViewMutation = { __typename?: 'Mutation', updateTopic: { __typename?: 'TopicModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null, brand: { __typename?: 'BrandModel', id: string, minimumProcessingRules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null, rules?: Array<{ __typename?: 'Rule', field?: string | null, operator?: RuleOperator | null, value?: number | null, platform?: Platform | null, condition?: RuleCondition | null, excludedKeywords?: Array<string> | null }> | null }> | null } } };

export type TopicFragmentTopicContentFilterSettingsDialogViewFragment = { __typename?: 'TopicModel', id: string, name: string, brand: { __typename?: 'BrandModel', id: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } };

export type TopicFragmentTopicParsingSettingsViewFragment = { __typename?: 'TopicModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null };

export type GetTopicForTopicParsingSettingsViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTopicForTopicParsingSettingsViewQuery = { __typename?: 'Query', topic: { __typename?: 'TopicModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type UpdateTopicForTopicParsingSettingsViewMutationVariables = Exact<{
  data: UpdateTopicInput;
}>;


export type UpdateTopicForTopicParsingSettingsViewMutation = { __typename?: 'Mutation', updateTopic: { __typename?: 'TopicModel', id: string, parsingSettings?: { __typename?: 'ParsingSettings', Instagram: { __typename?: 'ParsingSettingsPlatform', enabled: boolean, types?: { __typename?: 'ParsingSettingsType', Photo?: boolean | null, Video?: boolean | null, Carousel?: boolean | null } | null }, Tiktok: { __typename?: 'ParsingSettingsPlatform', enabled: boolean }, Youtube: { __typename?: 'ParsingSettingsPlatform', enabled: boolean } } | null } };

export type AudioTrendGroupFragmentUseTrendAudioGroupNavigatorHandlerFragment = { __typename?: 'AudioTrendGroupModel', id: string };

export type AudioTrendGroupForPaginationQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filters: AudioTrendGroupFilters;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type AudioTrendGroupForPaginationQuery = { __typename?: 'Query', audioTrendGroups: { __typename?: 'PaginatedAudioTrendGroupSearchResult', data: Array<{ __typename?: 'AudioTrendGroupModel', id: string }> } };

export type AudioTrendGroupFragmentTrendAudioGroupCardViewFragment = { __typename?: 'AudioTrendGroupModel', id: string, audioId: string, audioTitle?: string | null, audioVideoCount: number, audioArtist?: string | null, posts: Array<{ __typename?: 'AudioTrendGroupPostModel', platformId: string }> };

export type LinkedPostFragmentTrendLinkPostsFragment = { __typename?: 'PostModel', id: string, type: PostType, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', createdAt: any, id: string, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, status?: string | null, token?: number | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, collections: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null, parentCollection?: { __typename?: 'CollectionModel', contentIdeaId?: string | null, id: string, name: string } | null }> };

export type TrendAudioFragmentTrendingAudioPreviewFragment = { __typename?: 'TrendAudioModel', id: string, coverUrl?: string | null, duration?: number | null, totalVideoCount?: number | null, platform: Platform, title?: string | null, authorUsername?: string | null, urlMetadata: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }, author?: { __typename?: 'SocialAuthorModel', id: string, name: string, avatarUrl?: string | null } | null };

export type TrendFragmentTrendingPreviewFragment = { __typename?: 'TrendModel', id: string, category: TrendCategory, previewThumbnail?: string | null, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, previewUrlMetadata?: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null } | null };

export type TrendAudioFragmentTrendingSocialMediaPreviewFragment = { __typename?: 'TrendAudioModel', id: string, coverUrl?: string | null, platform: Platform, title?: string | null, urlMetadata: { __typename?: 'URLMetadataModel', id: string, url: string } };

export type TrendFragmentTrendInfoFragment = { __typename: 'TrendModel', id: string, createdAt: any, description: string, title: string, category: TrendCategory, status?: TrendStatus | null, trendAudio?: { __typename?: 'TrendAudioModel', totalVideoCount?: number | null, changePercentage?: number | null } | null };

export type CreatePostForTrendMutationVariables = Exact<{
  data: CreatePostForTrendInput;
}>;


export type CreatePostForTrendMutation = { __typename?: 'Mutation', createPostForTrend: { __typename?: 'PostModel', id: string, isFavoriteTrend: boolean, type: PostType, createdAt: any, isFavorite: boolean, myPermissions: Array<PostPermission>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, createdAt: any, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, status?: string | null, token?: number | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null }>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, collections: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null, parentCollection?: { __typename?: 'CollectionModel', contentIdeaId?: string | null, id: string, name: string } | null }> } };

export type SaveTrendForTrendingPageMutationVariables = Exact<{
  data: CreateTrendFavoriteInput;
}>;


export type SaveTrendForTrendingPageMutation = { __typename?: 'Mutation', createTrendFavorite: { __typename?: 'PostFavoriteModel', id: string, post: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } } };

export type UnsaveTrendForTrendingPageMutationVariables = Exact<{
  data: DeleteTrendFavoriteInput;
}>;


export type UnsaveTrendForTrendingPageMutation = { __typename?: 'Mutation', deleteTrendFavorite: { __typename?: 'Result', success: boolean, message: string } };

export type TrendFragmentUseTrendNavigatorHandlerFragment = { __typename?: 'TrendModel', id: string, category: TrendCategory };

export type TrendsForPaginationQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  filters: TrendFilters;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TrendsForPaginationQuery = { __typename?: 'Query', trends: { __typename?: 'PaginatedTrendSearchResult', data: Array<{ __typename?: 'TrendModel', id: string, category: TrendCategory }> } };

export type TrendFragmentTrendingCardViewFragment = { __typename?: 'TrendModel', id: string, description: string, title: string, category: TrendCategory, status?: TrendStatus | null, trendingDate: any, lastViewed?: any | null, createdAt: any, previewThumbnail?: string | null, trendAudio?: { __typename?: 'TrendAudioModel', id: string, changePercentage?: number | null, totalVideoCount?: number | null } | null, linkedPosts: Array<{ __typename?: 'PostModel', id: string, isFavoriteTrend: boolean, creator: { __typename?: 'UserProfileModel', id: string }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string }> }>, previewUrlMetadata?: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null } | null, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type TrendFragmentTrendingDetailViewFragment = { __typename: 'TrendModel', id: string, createdAt: any, description: string, title: string, category: TrendCategory, status?: TrendStatus | null, trendAudioSavedCount?: { __typename?: 'TrendAudioSavedCount', totalSavedCount: number, savedContentCalendarTotal: number } | null, trendAudio?: { __typename?: 'TrendAudioModel', totalVideoCount?: number | null, changePercentage?: number | null, id: string, coverUrl?: string | null, duration?: number | null, platform: Platform, title?: string | null, authorUsername?: string | null, urlMetadata: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }, author?: { __typename?: 'SocialAuthorModel', id: string, name: string, avatarUrl?: string | null } | null } | null, trendExamples: Array<{ __typename?: 'TrendExampleModel', id: string, totalSavedCount: number, savedContentCalendarTotal: number, urlMetadata: { __typename?: 'URLMetadataModel', id: string, createdAt: any, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, audio?: string | null, title?: string | null, type?: string | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, status?: string | null, token?: number | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null } }>, linkedPosts: Array<{ __typename?: 'PostModel', id: string, type: PostType, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', createdAt: any, id: string, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, status?: string | null, token?: number | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, collections: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null, parentCollection?: { __typename?: 'CollectionModel', contentIdeaId?: string | null, id: string, name: string } | null }> }> };

export type TrendQueryForTrendingDetailViewQueryVariables = Exact<{
  trendId: Scalars['String'];
}>;


export type TrendQueryForTrendingDetailViewQuery = { __typename?: 'Query', trend: { __typename: 'TrendModel', id: string, createdAt: any, description: string, title: string, category: TrendCategory, status?: TrendStatus | null, trendAudioSavedCount?: { __typename?: 'TrendAudioSavedCount', totalSavedCount: number, savedContentCalendarTotal: number } | null, trendAudio?: { __typename?: 'TrendAudioModel', totalVideoCount?: number | null, changePercentage?: number | null, id: string, coverUrl?: string | null, duration?: number | null, platform: Platform, title?: string | null, authorUsername?: string | null, urlMetadata: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }, author?: { __typename?: 'SocialAuthorModel', id: string, name: string, avatarUrl?: string | null } | null } | null, trendExamples: Array<{ __typename?: 'TrendExampleModel', id: string, totalSavedCount: number, savedContentCalendarTotal: number, urlMetadata: { __typename?: 'URLMetadataModel', id: string, createdAt: any, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, audio?: string | null, title?: string | null, type?: string | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, status?: string | null, token?: number | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null } }>, linkedPosts: Array<{ __typename?: 'PostModel', id: string, type: PostType, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', createdAt: any, id: string, updatedAt: any, url: string, metadata?: { __typename?: 'Metadata', audio?: string | null, author?: string | null, description?: string | null, hashtags?: Array<string> | null, medium?: string | null, site?: string | null, title?: string | null, type?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', href?: string | null, status?: string | null, token?: number | null, type?: string | null, mediaSize?: { __typename?: 'MediaSize', height: number, width: number } | null }> | null } | null }>, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, collections: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null, parentCollection?: { __typename?: 'CollectionModel', contentIdeaId?: string | null, id: string, name: string } | null }> }> } };

export type AddTrendToContentCalendarForTrendContentCalendarButtonMutationVariables = Exact<{
  data: AddTrendToContentCalendarInput;
}>;


export type AddTrendToContentCalendarForTrendContentCalendarButtonMutation = { __typename?: 'Mutation', addTrendToContentCalendar: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } };

export type UserProfileFragmentUserProfileChipViewFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, avatarUrl?: string | null, email: string };

export type UserProfileFragmentUserProfilePermissionItemViewFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } };

export type GetCollectionForCollectionPermissionsQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForCollectionPermissionsQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, myPermissions: Array<CollectionPermission> } };

export type GetPostForPostPermissionsQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostForPostPermissionsQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, myPermissions: Array<PostPermission> } | null };

export type GetTaskForTaskPermissionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskForTaskPermissionsQuery = { __typename?: 'Query', task: { __typename?: 'TaskModel', id: string, myPermissions: Array<TaskPermission> } };

export type TrackEventForAnalyticsMutationVariables = Exact<{
  data: TrackEventInput;
}>;


export type TrackEventForAnalyticsMutation = { __typename?: 'Mutation', trackEvent: { __typename?: 'Result', success: boolean } };

export type GetNonWorkDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonWorkDomainsQuery = { __typename?: 'Query', nonWorkDomains: Array<string> };

export type ViewEntityMutationVariables = Exact<{
  data: ViewEntityInput;
}>;


export type ViewEntityMutation = { __typename?: 'Mutation', viewEntity: { __typename?: 'Result', message: string, success: boolean } };

export type PostFragmentAiOrganizePageFragment = { __typename?: 'PostModel', id: string, type: PostType, permissionLevel: PermissionLevel, generalPermission: GeneralPermission, title?: string | null, body?: string | null, myPermissions: Array<PostPermission>, color: string, updatedAt: any, postSuggestedCollectionAssignments: Array<{ __typename?: 'PostSuggestedCollectionAssignmentsModel', id: string, score: number, collection: { __typename?: 'CollectionModel', id: string } }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null };

export type GetSuggestedPostsForAiOrganizePageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuggestedPostsForAiOrganizePageQuery = { __typename?: 'Query', suggestedPostsForUser: Array<{ __typename?: 'PostModel', id: string, type: PostType, permissionLevel: PermissionLevel, generalPermission: GeneralPermission, title?: string | null, body?: string | null, myPermissions: Array<PostPermission>, color: string, updatedAt: any, postSuggestedCollectionAssignments: Array<{ __typename?: 'PostSuggestedCollectionAssignmentsModel', id: string, score: number, collection: { __typename?: 'CollectionModel', id: string } }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type OrganizePostsForAiOrganizePageMutationVariables = Exact<{
  data: OrganizePostsInput;
}>;


export type OrganizePostsForAiOrganizePageMutation = { __typename?: 'Mutation', organizePosts: { __typename?: 'Result', success: boolean, message: string } };

export type GetAttachmentForAttachmentDetailPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAttachmentForAttachmentDetailPageQuery = { __typename?: 'Query', attachment: { __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } };

export type ForgotPasswordMutationVariables = Exact<{
  data: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'Result', message: string, success: boolean } };

export type ValidateWorkosSignupMutationVariables = Exact<{
  data: Scalars['String'];
  source?: InputMaybe<LoginSource>;
}>;


export type ValidateWorkosSignupMutation = { __typename?: 'Mutation', validateWorkosSignup: { __typename?: 'AuthModel', accessToken: any, refreshToken: any, isSignUp?: boolean | null, user: { __typename?: 'MeModel', id: string, role: InternalOrganizationRole } } };

export type GenerateAuthUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateAuthUrlQuery = { __typename?: 'Query', workosAuthUrl: { __typename?: 'AuthUrlModel', loginUrl: string, signupUrl: string } };

export type GetBillingPricesForPlanQueryVariables = Exact<{
  planName: Scalars['String'];
}>;


export type GetBillingPricesForPlanQuery = { __typename?: 'Query', getPricesForPlan: Array<{ __typename?: 'BillingPrice', id: string, currency: string, recurringInterval?: string | null, amount?: number | null, unitAmountDecimal?: string | null }> };

export type GetBillingCouponMutationVariables = Exact<{
  promotionCode: Scalars['String'];
}>;


export type GetBillingCouponMutation = { __typename?: 'Mutation', getCoupon: { __typename?: 'BillingCoupon', id: string, amountOff?: number | null, percentOff?: number | null, duration: string } };

export type BillingPaymentMethodFragmentPaymentDetailsFragment = { __typename?: 'BillingPaymentMethod', id: string, card: { __typename?: 'BillingPaymentMethodCard', brand: string, expMonth: number, expYear: number, last4: string } };

export type GetDefaultPaymentMethodForCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultPaymentMethodForCheckoutQuery = { __typename?: 'Query', getDefaultPaymentMethod?: { __typename?: 'BillingPaymentMethod', id: string, card: { __typename?: 'BillingPaymentMethodCard', brand: string, expMonth: number, expYear: number, last4: string } } | null };

export type CreateBillingSubscriptionForCheckoutMutationVariables = Exact<{
  data: CreateBillingSubscriptionInput;
}>;


export type CreateBillingSubscriptionForCheckoutMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'BillingSubscription', id: string, clientSecret?: string | null, status?: BillingSubscriptionStatus | null } };

export type UpdateBillingSubscriptionForCheckoutMutationVariables = Exact<{
  data: UpdateBillingSubscriptionInput;
}>;


export type UpdateBillingSubscriptionForCheckoutMutation = { __typename?: 'Mutation', updateSubscription: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null, clientSecret?: string | null } };

export type CreateSetupIntentForCheckoutMutationVariables = Exact<{
  data: CreateSetupIntentInput;
}>;


export type CreateSetupIntentForCheckoutMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'BillingSetupIntent', id: string, clientSecret: string } };

export type ResumeSubscriptionForCheckoutMutationVariables = Exact<{
  data: ResumeBillingSubscriptionInput;
}>;


export type ResumeSubscriptionForCheckoutMutation = { __typename?: 'Mutation', resumeSubscription: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null } };

export type UpgradeDuringFreeTrialForCheckoutMutationVariables = Exact<{
  data: UpgradeDuringTrialInput;
}>;


export type UpgradeDuringFreeTrialForCheckoutMutation = { __typename?: 'Mutation', upgradeDuringFreeTrial: { __typename?: 'BillingSubscription', id: string, status?: BillingSubscriptionStatus | null } };

export type CollectionFragmentCollectionPageFragment = { __typename?: 'CollectionModel', id: string, name: string, parentCollectionId?: string | null, creatorId: string, unreadCommentCount: number, myPermissions: Array<CollectionPermission>, organizationId: string, isDisabled: boolean, contentIdeaId?: string | null, totalSuggestedPosts: number, newSuggestedPostCount: number, roomId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null, childCollections: Array<{ __typename?: 'CollectionModel', id: string, name: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, totalPosts: number, totalChildCollections: number, isDisabled: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetCollectionForCollectionPageQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForCollectionPageQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string, parentCollectionId?: string | null, creatorId: string, unreadCommentCount: number, myPermissions: Array<CollectionPermission>, organizationId: string, isDisabled: boolean, contentIdeaId?: string | null, totalSuggestedPosts: number, newSuggestedPostCount: number, roomId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null, childCollections: Array<{ __typename?: 'CollectionModel', id: string, name: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, totalPosts: number, totalChildCollections: number, isDisabled: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } };

export type GetUnreadCollectionCommentsForCollectionPageQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetUnreadCollectionCommentsForCollectionPageQuery = { __typename?: 'Query', unreadCollectionComments: number };

export type GetContentIdeaCollectionsForCustomCollectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByInputData>;
}>;


export type GetContentIdeaCollectionsForCustomCollectionQuery = { __typename?: 'Query', contentIdeaCollections: { __typename?: 'PaginatedCollectionResult', data: Array<{ __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPostsSmartSearchForCollectionPageCustomCollectionQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<SortType>;
}>;


export type GetPostsSmartSearchForCollectionPageCustomCollectionQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetPostsSmartSearchForCollectionPageNormalCollectionQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<SortType>;
}>;


export type GetPostsSmartSearchForCollectionPageNormalCollectionQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', item: { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetSuggestedPostsForCollectionPageQueryVariables = Exact<{
  filters: SuggestedPostsFilters;
}>;


export type GetSuggestedPostsForCollectionPageQuery = { __typename?: 'Query', suggestedPosts: Array<{ __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }> };

export type AddPostToCollectionForCollectionPageMutationVariables = Exact<{
  data: AddPostToCollectionInput;
}>;


export type AddPostToCollectionForCollectionPageMutation = { __typename?: 'Mutation', addPostToCollection: { __typename?: 'Result', success: boolean, message: string } };

export type DeletePostForCollectionPageMutationVariables = Exact<{
  data: DeleteSuggestedPostInput;
}>;


export type DeletePostForCollectionPageMutation = { __typename?: 'Mutation', deleteSuggestedPost: { __typename?: 'Result', message: string, success: boolean } };

export type CollectionFragmentCollectionPageSuggestedPostSectionFragment = { __typename?: 'CollectionModel', id: string, organizationId: string, totalSuggestedPosts: number, newSuggestedPostCount: number };

export type PostFragmentCollectionPageSuggestedPostSectionFragment = { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type GetContentIdeaMetaStatsForContentCalendarQueryVariables = Exact<{
  filters?: InputMaybe<ContentIdeaFilters>;
}>;


export type GetContentIdeaMetaStatsForContentCalendarQuery = { __typename?: 'Query', contentIdeaMetaStats: { __typename?: 'ContentIdeaMetaStats', braindumpTotalCount: number, productionTotalCount: number, publishTotalCount: number, iceboxTotalCount: number } };

export type UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationVariables = Exact<{
  data: UpdateUserOnboardingStateInput;
}>;


export type UpdateUserOnboardingStateForContentCalendarOnboardingViewMutation = { __typename?: 'Mutation', updateUserOnboardingState: { __typename?: 'MeModel', id: string, onboardingState?: { __typename?: 'OnboardingStateData', hasSeenContentCalendarOnboarding?: boolean | null } | null } };

export type GetContentIdeaForContentCalendarPageSplitViewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentIdeaForContentCalendarPageSplitViewQuery = { __typename?: 'Query', contentIdea: { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, noteContent?: string | null, name: string, roomId?: string | null, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, fields: Array<{ __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, sortOrder: number, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null, date?: any | null, checkbox?: boolean | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null }>, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } } };

export type GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery = { __typename?: 'Query', contentIdeaFields: Array<{ __typename?: 'ContentIdeaFieldModel', id: string, name: string, type: FieldType }> };

export type GetContentIdeasForContentCalendarPageCalendarSectionQueryVariables = Exact<{
  filters: ContentIdeaFilters;
  sortBy?: InputMaybe<SortByInputData>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetContentIdeasForContentCalendarPageCalendarSectionQuery = { __typename?: 'Query', contentIdeas: { __typename?: 'PaginatedContentIdeaSearchResult', data: Array<{ __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, name: string, noteContent?: string | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null } | null } | null }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> | null } | null }, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, label: string, value: string, bgcolor?: string | null }> | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null }, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, collection: { __typename?: 'CollectionModel', id: string }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }> }> } };

export type UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationVariables = Exact<{
  data: UpdateContentIdeaFieldValueInput;
}>;


export type UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation = { __typename?: 'Mutation', updateContentIdeaFieldValue: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } };

export type ResyncFromSocialsMutationVariables = Exact<{ [key: string]: never; }>;


export type ResyncFromSocialsMutation = { __typename?: 'Mutation', resyncFromSocials: { __typename?: 'Result', success: boolean, message: string } };

export type ContentIdeaFragmentContentCalendarPageListSectionFragment = { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, name: string, noteContent?: string | null, snoozeDate?: any | null, stage: Stage, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null } };

export type GetContentIdeasForContentCalendarPageListSectionQueryVariables = Exact<{
  filters: ContentIdeaFilters;
  sortBy?: InputMaybe<SortByInputData>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetContentIdeasForContentCalendarPageListSectionQuery = { __typename?: 'Query', contentIdeas: { __typename?: 'PaginatedContentIdeaSearchResult', data: Array<{ __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, name: string, noteContent?: string | null, snoozeDate?: any | null, stage: Stage, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateContentIdeaForContentCalendarPageListSectionMutationVariables = Exact<{
  data: CreateContentIdeaInput;
}>;


export type CreateContentIdeaForContentCalendarPageListSectionMutation = { __typename?: 'Mutation', createContentIdea: { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, name: string, noteContent?: string | null, snoozeDate?: any | null, stage: Stage, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, pillars: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null } } };

export type UpdateContentIdeaForContentCalendarPageListSectionMutationVariables = Exact<{
  data: UpdateContentIdeaInput;
}>;


export type UpdateContentIdeaForContentCalendarPageListSectionMutation = { __typename?: 'Mutation', updateContentIdea: { __typename?: 'ContentIdeaModel', id: string } };

export type ContentIdeaFragmentContentIdeaPageFragment = { __typename?: 'ContentIdeaModel', id: string, stage: Stage, myPermissions: Array<ContentIdeaPermission>, name: string, noteContent?: string | null, roomId?: string | null, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, fields: Array<{ __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, sortOrder: number, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null, date?: any | null, checkbox?: boolean | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null }>, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } };

export type GetContentIdeaForContentIdeaPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentIdeaForContentIdeaPageQuery = { __typename?: 'Query', contentIdea: { __typename?: 'ContentIdeaModel', id: string, stage: Stage, myPermissions: Array<ContentIdeaPermission>, name: string, noteContent?: string | null, roomId?: string | null, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, fields: Array<{ __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, sortOrder: number, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null, date?: any | null, checkbox?: boolean | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null }>, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } } };

export type UserProfileFragmentInboxBrandInviteMemberApprovalFragment = { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null };

export type BrandInviteMemberFragmentInboxBrandInviteMemberApprovalFragment = { __typename?: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null }, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }> } };

export type GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryVariables = Exact<{
  organizationAccessRequestId: Scalars['String'];
}>;


export type GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery = { __typename?: 'Query', organizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, status: OrganizationUserAccessRequestStatus, user: { __typename?: 'UserProfileModel', id: string, email: string }, updatedBy?: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null } };

export type ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables = Exact<{
  data: ApproveOrganizationUserAccessRequestInput;
}>;


export type ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation = { __typename?: 'Mutation', approveOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, status: OrganizationUserAccessRequestStatus } };

export type RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables = Exact<{
  data: RejectOrganizationUserAccessRequestInput;
}>;


export type RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation = { __typename?: 'Mutation', rejectOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, status: OrganizationUserAccessRequestStatus } };

export type GetCollectionForInboxQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionForInboxQuery = { __typename?: 'Query', collection: { __typename?: 'CollectionModel', id: string, name: string, parentCollectionId?: string | null, creatorId: string, unreadCommentCount: number, myPermissions: Array<CollectionPermission>, organizationId: string, isDisabled: boolean, contentIdeaId?: string | null, totalSuggestedPosts: number, newSuggestedPostCount: number, roomId?: string | null, hasPreviewPost: boolean, isBookmarked: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null, childCollections: Array<{ __typename?: 'CollectionModel', id: string, name: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, totalPosts: number, totalChildCollections: number, isDisabled: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } };

export type GetContentIdeaForInboxContentIdeaQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContentIdeaForInboxContentIdeaQuery = { __typename?: 'Query', contentIdea: { __typename?: 'ContentIdeaModel', id: string, myPermissions: Array<ContentIdeaPermission>, noteContent?: string | null, name: string, roomId?: string | null, collection: { __typename?: 'CollectionModel', id: string, creatorId: string, generalPermission: GeneralPermission, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, user: { __typename?: 'UserProfileModel', id: string } }> }, fields: Array<{ __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string, sortOrder: number, name: string, icon?: string | null, type: FieldType, isPrimaryField: boolean }, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null, date?: any | null, checkbox?: boolean | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null, tasks?: Array<{ __typename?: 'TaskModel', id: string }> | null, users?: Array<{ __typename?: 'UserProfileModel', id: string }> | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null }>, contentIdeaPublishMetadata: Array<{ __typename?: 'ContentIdeaPublishMetadataModel', id: string, platform: Platform, publishUrl?: string | null, socialAuthor?: { __typename?: 'SocialAuthorModel', id: string, platformHandle?: string | null } | null }>, draftAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, finalAssets?: { __typename?: 'ContentIdeaFieldValueModel', id: string } | null, caption: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, text?: string | null } | null }, audio: { __typename?: 'ContentIdeaFieldValueModel', id: string }, status: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, select?: { __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null } | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, moodboard?: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, collection?: { __typename?: 'CollectionModel', id: string } | null } | null } | null, previewPost?: { __typename?: 'PermittedPostModel', id: string, post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null } | null, rootCollection?: { __typename?: 'PermittedCollectionModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string }> } | null } | null, platforms: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, multiSelect?: Array<{ __typename?: 'ContentIdeaFieldOptionModel', id: string, value: string, label: string, bgcolor?: string | null }> | null } | null }, owners: { __typename?: 'ContentIdeaFieldValueModel', id: string, value?: { __typename?: 'FieldValue', id?: string | null, users?: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }> | null } | null, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string } }, dueDate: { __typename?: 'ContentIdeaFieldValueModel', id: string, contentIdeaField: { __typename?: 'ContentIdeaFieldModel', id: string }, value?: { __typename?: 'FieldValue', id?: string | null, date?: any | null } | null } } };

export type NotificationFragmentInboxMultiplePostInviteFragment = { __typename?: 'NotificationModel', id: string, createdByUser: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, posts?: Array<{ __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }> | null };

export type NotificationFragmentInboxMultiplePostMentionFragment = { __typename?: 'NotificationModel', id: string, posts?: Array<{ __typename?: 'PostModel', id: string }> | null };

export type GetPostForInboxMultiplePostMentionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForInboxMultiplePostMentionQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, body?: string | null, type: PostType, description: string, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationName: string, permissionLevel: PermissionLevel, roomId?: string | null, color: string, updatedAt: any, socialPostId?: string | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null } | null };

export type OrganizationUserAccessRequestFragmentInboxContentFragment = { __typename?: 'OrganizationUserAccessRequestModel', id: string, status: OrganizationUserAccessRequestStatus, message?: string | null, organization: { __typename?: 'OrganizationModel', id: string, name: string }, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, updatedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null, invitedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null };

export type GetOrganizationAccessRequestForInboxQueryVariables = Exact<{
  organizationAccessRequestId: Scalars['String'];
}>;


export type GetOrganizationAccessRequestForInboxQuery = { __typename?: 'Query', organizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, status: OrganizationUserAccessRequestStatus, message?: string | null, organization: { __typename?: 'OrganizationModel', id: string, name: string }, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, updatedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null, invitedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } };

export type ApproveOrganizationAccessRequestForInboxNotificationMutationVariables = Exact<{
  data: ApproveOrganizationUserAccessRequestInput;
}>;


export type ApproveOrganizationAccessRequestForInboxNotificationMutation = { __typename?: 'Mutation', approveOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, status: OrganizationUserAccessRequestStatus, updatedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } };

export type RejectOrganizationAccessRequestForInboxNotificationMutationVariables = Exact<{
  data: RejectOrganizationUserAccessRequestInput;
}>;


export type RejectOrganizationAccessRequestForInboxNotificationMutation = { __typename?: 'Mutation', rejectOrganizationAccessRequest: { __typename?: 'OrganizationUserAccessRequestModel', id: string, status: OrganizationUserAccessRequestStatus, updatedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } };

export type GetPostForInboxQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForInboxQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, body?: string | null, type: PostType, description: string, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationName: string, permissionLevel: PermissionLevel, roomId?: string | null, color: string, updatedAt: any, socialPostId?: string | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null } | null };

export type GetPostNoteForInboxQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostNoteForInboxQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, body?: string | null, type: PostType, description: string, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationName: string, permissionLevel: PermissionLevel, roomId?: string | null, color: string, updatedAt: any, socialPostId?: string | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null } | null };

export type NotificationFragmentInboxSlBrandReachedUsageLimitContentFragment = { __typename?: 'NotificationModel', id: string, data?: any | null };

export type GetSocialPostsForInboxSocialListeningContentQueryVariables = Exact<{
  socialPostIds: Array<Scalars['String']> | Scalars['String'];
  topicIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  brandId: Scalars['String'];
}>;


export type GetSocialPostsForInboxSocialListeningContentQuery = { __typename?: 'Query', socialPosts: Array<{ __typename?: 'SocialPostModel', id: string, commentCount: number, createdAt: any, expiresAt?: any | null, totalEngagement: number, description: string, diggCount: number, duration: number, engagementRate: number, bookmarkCount: number, isAd: boolean, platform: Platform, platformId: string, platformCreateTime: any, playCount: number, shareCount: number, type: SocialPostType, updatedAt: any, viralRate: number, thumbnailUrl?: string | null, videoUrl?: string | null, videoThumbnailFolderUrl?: string | null, carouselFolderUrl?: string | null, creator?: { __typename?: 'CreatorModel', createdAt: any, engagementRate: number, followerCount: number, handle: string, id: string, industry?: string | null, nickName: string, platform: Platform, profilePictureUrl?: string | null, updatedAt: any } | null, socialPostEngagementSuggestionsWithTopic: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, sentiment: Sentiment, score: number, oneLineSummary: string, reason: string, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }>, socialPostEngagementSuggestions?: Array<{ __typename?: 'SocialPostEngagementSuggestionModel', id: string, createdAt: any, oneLineSummary: string, reason: string, score: number, sentiment: Sentiment, socialpostId: string, topicId: string, updatedAt: any, topic?: { __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType } | null }> | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, status: BrandSocialPostEngagementStatus } | null }> };

export type GetPermissionRequestForInboxQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPermissionRequestForInboxQuery = { __typename?: 'Query', permissionRequest: { __typename?: 'PermissionRequestModel', id: string, collectionId?: string | null, brandId?: string | null, note?: string | null, status: PermissionRequestStatus, brand?: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, profilePictureUrl?: string | null }> } | null, post?: { __typename?: 'PostModel', type: PostType, id: string, organizationId: string, createdAt: any, roomId?: string | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, body?: string | null, isFavorite: boolean, title?: string | null, description: string, color: string, updatedAt: any, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string } }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, organizationId: string, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string } }> } | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } } };

export type ApprovePermissionRequestForInboxPermissionRequestContentMutationVariables = Exact<{
  data: ApprovePermissionRequestInput;
}>;


export type ApprovePermissionRequestForInboxPermissionRequestContentMutation = { __typename?: 'Mutation', approvePermissionRequest: { __typename?: 'PermissionRequestModel', id: string } };

export type RejectPermissionRequestForInboxPermissionRequestContentMutationVariables = Exact<{
  data: RejectPermissionRequestInput;
}>;


export type RejectPermissionRequestForInboxPermissionRequestContentMutation = { __typename?: 'Mutation', rejectPermissionRequest: { __typename?: 'PermissionRequestModel', id: string } };

export type ApprovePermissionRequestForInboxNotificationMutationVariables = Exact<{
  data: ApprovePermissionRequestInput;
}>;


export type ApprovePermissionRequestForInboxNotificationMutation = { __typename?: 'Mutation', approvePermissionRequest: { __typename?: 'PermissionRequestModel', id: string, status: PermissionRequestStatus } };

export type RejectPermissionRequestForInboxNotificationMutationVariables = Exact<{
  data: RejectPermissionRequestInput;
}>;


export type RejectPermissionRequestForInboxNotificationMutation = { __typename?: 'Mutation', rejectPermissionRequest: { __typename?: 'PermissionRequestModel', id: string, status: PermissionRequestStatus } };

export type RemovePermissionRequestInvitedUserForInboxNotificationMutationVariables = Exact<{
  data: RemovePermissionRequestInvitedMemberInput;
}>;


export type RemovePermissionRequestInvitedUserForInboxNotificationMutation = { __typename?: 'Mutation', removePermissionRequestInvitedUser: { __typename?: 'PermissionRequestModel', id: string, status: PermissionRequestStatus } };

export type PermissionRequestFragmentInboxPermissionRequestSideViewFragment = { __typename?: 'PermissionRequestModel', id: string, note?: string | null, status: PermissionRequestStatus, post?: { __typename?: 'PostModel', id: string, organizationId: string, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string } }> } | null, collection?: { __typename?: 'CollectionModel', id: string, organizationId: string, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string } }> } | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } };

export type GetNotificationsForInboxQueryVariables = Exact<{
  filters: InboxNotificationFilters;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetNotificationsForInboxQuery = { __typename?: 'Query', inboxNotifications: { __typename?: 'PaginatedInboxNotifications', notifications: Array<{ __typename?: 'NotificationModel', id: string, type: NotificationType, status: NotificationStatus, createdAt: any, data?: any | null, socialPostsNotificationData?: { __typename?: 'SocialPostsNotificationDataModel', id: string, socialPosts: Array<{ __typename?: 'SocialPostModel', id: string }> } | null, createdByUser: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comment?: { __typename?: 'CommentModel', id: string, text: string, parentComment?: { __typename?: 'CommentModel', id: string, text: string } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, name: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collectionInviteMember?: { __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel } | null, postInviteMember?: { __typename?: 'PostInviteMemberModel', id: string, permissionLevel: PermissionLevel } | null, brandInviteMember?: { __typename: 'BrandInviteMemberModel', id: string, permissionLevel: PermissionLevel, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null }> }, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } } | null, task?: { __typename?: 'TaskModel', id: string, name: string } | null, permissionRequest?: { __typename?: 'PermissionRequestModel', id: string, postId?: string | null, collectionId?: string | null, post?: { __typename?: 'PostModel', id: string, type: PostType, title?: string | null, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, collection?: { __typename?: 'CollectionModel', id: string, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, brand?: { __typename?: 'BrandModel', id: string, name: string } | null } | null, posts?: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, description: string, color: string, updatedAt: any, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }> | null, userReaction?: { __typename?: 'UserReactionModel', id: string, emoji: string, commentId?: string | null } | null, organizationUserAccessRequest?: { __typename?: 'OrganizationUserAccessRequestModel', id: string } | null, contentIdea?: { __typename?: 'ContentIdeaModel', id: string, name: string } | null }>, meta: { __typename?: 'InboxNotificationMeta', mentionsTotalCount: number, commentsTotalCount: number, reactionsTotalCount: number, tasksTotalCount: number, invitesTotalCount: number, permissionRequestsTotalCount: number, organizationUserAccessRequestsTotalCount: number, contentIdeasTotalCount: number, socialListeningTotalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', readNotification: { __typename?: 'NotificationModel', id: string, status: NotificationStatus } };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', readNotifications: { __typename?: 'Result', success: boolean } };

export type DeleteNotificationsForInboxPageMutationVariables = Exact<{
  data: DeleteNotificationsInput;
}>;


export type DeleteNotificationsForInboxPageMutation = { __typename?: 'Mutation', deleteNotifications: { __typename?: 'Result', success: boolean } };

export type GetSuggestedPostsForAiOrganizeSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuggestedPostsForAiOrganizeSectionQuery = { __typename?: 'Query', suggestedPostsForUser: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> };

export type UpdateUserOnboardingStateForJuiceboxSectionMutationVariables = Exact<{
  data: UpdateUserOnboardingStateInput;
}>;


export type UpdateUserOnboardingStateForJuiceboxSectionMutation = { __typename?: 'Mutation', updateUserOnboardingState: { __typename?: 'MeModel', id: string, onboardingState?: { __typename?: 'OnboardingStateData', haveSeenJuiceBoxIntro?: boolean | null, haveClickedJuiceBoxBtn?: boolean | null } | null } };

export type UrlMetadataFragmentJuiceModalFragment = { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null };

export type PostFragmentJuiceModalFragment = { __typename?: 'PostModel', id: string, title?: string | null, body?: string | null, type: PostType, description: string, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationName: string, permissionLevel: PermissionLevel, roomId?: string | null, color: string, updatedAt: any, socialPostId?: string | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null };

export type GetPostForJuiceModalQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForJuiceModalQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, body?: string | null, type: PostType, description: string, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationName: string, permissionLevel: PermissionLevel, roomId?: string | null, color: string, updatedAt: any, socialPostId?: string | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null } | null };

export type GetPostCommentsUnreadCountQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostCommentsUnreadCountQuery = { __typename?: 'Query', unreadPostComments: number };

export type GetPostForPostPreviewPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForPostPreviewPageQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, color: string, type: PostType, createdAt: any, description: string, title?: string | null, myPermissions: Array<PostPermission>, roomId?: string | null, isFavoriteTrend: boolean, body?: string | null, unreadCommentCount: number, isNew?: boolean | null, generalPermission: GeneralPermission, organizationName: string, isFavorite: boolean, updatedAt: any, socialPostId?: string | null, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null } | null };

export type GetGhostSearchQueryForJuiceboxPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGhostSearchQueryForJuiceboxPageQuery = { __typename?: 'Query', ghostSearchQuery: { __typename?: 'GhostSearchQuery', query: string } };

export type GetPostsForJuiceboxQueryVariables = Exact<{
  filters: PostFilters;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetPostsForJuiceboxQuery = { __typename?: 'Query', posts: { __typename?: 'PaginatedPostSearchResult', data: Array<{ __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetSmartSearchPostsForJuiceboxQueryVariables = Exact<{
  filters: PostFiltersForSmartSearch;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetSmartSearchPostsForJuiceboxQuery = { __typename?: 'Query', postsSmartSearch: { __typename?: 'PaginatedPostSmartSearchResult', data: Array<{ __typename?: 'PostSearchHit', score: number, type: SearchHitType, item: { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryVariables = Exact<{
  filters: CollectionFilters;
  take?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<SortType>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', data: Array<{ __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryVariables = Exact<{
  filters: PinnedEntityFilters;
}>;


export type GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery = { __typename?: 'Query', pinnedEntitiesToParent: Array<{ __typename?: 'PinnedEntityModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> } | null, post?: { __typename?: 'PostModel', id: string, description: string, title?: string | null, type: PostType, unreadCommentCount: number, isNew?: boolean | null, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, generalPermission: GeneralPermission, organizationName: string, color: string, updatedAt: any, isFavorite: boolean, collections: Array<{ __typename?: 'CollectionModel', id: string }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string, email: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }> } | null }> };

export type GetRecentCollectionsForGridViewRecentCollectionsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentCollectionsForGridViewRecentCollectionsSectionQuery = { __typename?: 'Query', recentCollections: Array<{ __typename?: 'CollectionModel', id: string, name: string, totalPosts: number, totalChildCollections: number, isDisabled: boolean, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, generalPermission: GeneralPermission, organizationName: string, isPinnedToRoot: boolean, isPinnedToParent: boolean, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, breadcrumbsFromRoot: Array<{ __typename?: 'CollectionModel', id: string, name: string, contentIdeaId?: string | null }> }> };

export type GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryVariables = Exact<{
  filters: CollectionFilters;
  take?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<SortType>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCollectionsSmartSearchForListViewAllCollectionsSectionQuery = { __typename?: 'Query', collectionsSmartSearch: { __typename?: 'PaginatedCollectionSearchResult', data: Array<{ __typename?: 'CollectionSearchHit', item: { __typename?: 'CollectionModel', id: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, name: string, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryVariables = Exact<{
  filters: PinnedEntityFilters;
}>;


export type GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery = { __typename?: 'Query', pinnedEntitiesToParent: Array<{ __typename?: 'PinnedEntityModel', id: string, collection?: { __typename?: 'CollectionModel', id: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, name: string, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> } | null, post?: { __typename?: 'PostModel', id: string, type: PostType, myPermissions: Array<PostPermission>, isFavoriteTrend: boolean, isFavorite: boolean, title?: string | null, description: string, generalPermission: GeneralPermission, organizationName: string, unreadCommentCount: number, color: string, updatedAt: any, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, creator: { __typename?: 'UserProfileModel', id: string, firstName: string }, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> } | null }> };

export type GetRecentCollectionsForListViewRecentCollectionsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentCollectionsForListViewRecentCollectionsSectionQuery = { __typename?: 'Query', recentCollections: Array<{ __typename?: 'CollectionModel', id: string, creatorId: string, parentCollectionId?: string | null, myPermissions: Array<CollectionPermission>, hasPreviewPost: boolean, isBookmarked: boolean, isDisabled: boolean, isPinnedToRoot: boolean, isPinnedToParent: boolean, totalPosts: number, totalChildCollections: number, name: string, generalPermission: GeneralPermission, organizationName: string, previewPost?: { __typename?: 'PostModel', id: string } | null, inviteMembers: Array<{ __typename?: 'CollectionInviteMemberModel', id: string, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, posts: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }> }> };

export type GetNotePostForJuiceboxNoteModalQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetNotePostForJuiceboxNoteModalQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, body?: string | null, type: PostType, description: string, createdAt: any, isFavorite: boolean, isFavoriteTrend: boolean, myPermissions: Array<PostPermission>, generalPermission: GeneralPermission, organizationName: string, permissionLevel: PermissionLevel, roomId?: string | null, color: string, updatedAt: any, socialPostId?: string | null, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, userReactions?: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, user: { __typename?: 'UserProfileModel', id: string, firstName: string } }> | null, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string, lastSeen?: any | null, permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null, organization: { __typename?: 'OrganizationProfileModel', id: string } } }>, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null } | null };

export type PostSuggestedAuthFragmentJuiceboxNoteModalFragment = { __typename?: 'PostSuggestedAuthModel', generalPermission: GeneralPermission, permissionLevel: PermissionLevel, suggestedInviteMembers: Array<{ __typename?: 'SuggestedInviteMember', permissionLevel: PermissionLevel, user: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, organization: { __typename?: 'OrganizationProfileModel', id: string } } }> };

export type PostFragmentJuiceboxNoteModalFragment = { __typename?: 'PostModel', id: string, description: string, isFavorite: boolean, roomId?: string | null, body?: string | null, myPermissions: Array<PostPermission>, permissionLevel: PermissionLevel, generalPermission: GeneralPermission, title?: string | null, type: PostType, isFavoriteTrend: boolean, color: string, createdAt: any, updatedAt: any, socialPostId?: string | null, collections: Array<{ __typename?: 'CollectionModel', id: string, parentCollectionId?: string | null }>, annotations: Array<{ __typename?: 'PostAnnotationModel', id: string, pageNumber?: number | null, time?: number | null, x?: number | null, y?: number | null, noteCommentAnchorId?: string | null, createdAt: any, updatedAt: any, isResolved?: boolean | null, postId: string, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, comments: Array<{ __typename?: 'CommentModel', id: string, isRead: boolean, parentThreadId?: string | null, postId?: string | null, taskId?: string | null, collectionId?: string | null, text: string, createdAt: any, childComments: Array<{ __typename?: 'CommentModel', id: string, postId?: string | null, taskId?: string | null, isRead: boolean, parentThreadId?: string | null, text: string, createdAt: any, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }>, createdBy: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, userReactions: Array<{ __typename?: 'UserReactionModel', id: string, emoji: string, userId: string, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } }>, postAnnotation?: { __typename?: 'PostAnnotationModel', id: string, postId: string, x?: number | null, y?: number | null, time?: number | null, pageNumber?: number | null, noteCommentAnchorId?: string | null, noteCommentExtract?: string | null } | null, attachments: Array<{ __typename?: 'AttachmentModel', id: string, url: string, name: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } }> }> }>, inviteMembers: Array<{ __typename?: 'PostInviteMemberModel', id: string }>, permissionRequests?: Array<{ __typename?: 'PermissionRequestModel', id: string }> | null, creator: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }, trend?: { __typename?: 'TrendModel', id: string, title: string } | null, pinnedToCollections: Array<{ __typename?: 'PinnedEntityModel', id: string, parentCollectionId?: string | null }>, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null, socialPostEngagementSuggestion?: { __typename?: 'SocialPostEngagementSuggestionModel', id: string, topic?: { __typename?: 'TopicModel', id: string, brandId?: string | null } | null } | null };

export type GetTrendingAudioGroupsQueryVariables = Exact<{
  filters: AudioTrendGroupFilters;
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendingAudioGroupsQuery = { __typename?: 'Query', audioTrendGroups: { __typename?: 'PaginatedAudioTrendGroupSearchResult', data: Array<{ __typename?: 'AudioTrendGroupModel', id: string, createdAt: any, updatedAt: any, audioId: string, audioTitle?: string | null, audioVideoCount: number, audioArtist?: string | null, posts: Array<{ __typename?: 'AudioTrendGroupPostModel', platformId: string }> }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryVariables = Exact<{
  audioTrendGroupId: Scalars['String'];
}>;


export type GetAudioTrendGroupForTrendingAudioGroupDetailPageQuery = { __typename?: 'Query', audioTrendGroup: { __typename?: 'AudioTrendGroupModel', id: string, audioArtist?: string | null, audioId: string, audioTitle?: string | null, audioVideoCount: number, createdAt: any, posts: Array<{ __typename?: 'AudioTrendGroupPostModel', engagementRate: number, platformId: string, viralRate: number }> } };

export type GetTrendingPostsQueryVariables = Exact<{
  filters: TrendFilters;
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendingPostsQuery = { __typename?: 'Query', trends: { __typename?: 'PaginatedTrendSearchResult', data: Array<{ __typename?: 'TrendModel', id: string, description: string, title: string, category: TrendCategory, status?: TrendStatus | null, trendingDate: any, lastViewed?: any | null, createdAt: any, previewThumbnail?: string | null, trendAudio?: { __typename?: 'TrendAudioModel', id: string, changePercentage?: number | null, totalVideoCount?: number | null } | null, linkedPosts: Array<{ __typename?: 'PostModel', id: string, isFavoriteTrend: boolean, creator: { __typename?: 'UserProfileModel', id: string }, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string }> }>, previewUrlMetadata?: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null } | null, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetCustomTrendPersonasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomTrendPersonasQuery = { __typename?: 'Query', personas: Array<{ __typename?: 'CustomTrendPersonaModel', id: string, name: string, description: string, emoji?: string | null }> };

export type GetPostsForTrendingJuiceboxSavedTrendButtonQueryVariables = Exact<{
  filters: PostFilters;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetPostsForTrendingJuiceboxSavedTrendButtonQuery = { __typename?: 'Query', posts: { __typename?: 'PaginatedPostSearchResult', data: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, meta: { __typename?: 'PaginatedPostSearchPaginationMeta', totalCount: number } } };

export type GetTrendsForTrendingJuiceboxSearchBarQueryVariables = Exact<{
  filters: TrendFilters;
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendsForTrendingJuiceboxSearchBarQuery = { __typename?: 'Query', trends: { __typename?: 'PaginatedTrendSearchResult', data: Array<{ __typename?: 'TrendModel', id: string, title: string, category: TrendCategory, previewThumbnail?: string | null, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, previewUrlMetadata?: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, meta: { __typename?: 'PaginationMeta', totalCount: number } } };

export type TrendFragmentTrendingJuiceboxSearchBarItemFragment = { __typename?: 'TrendModel', id: string, title: string, category: TrendCategory, previewThumbnail?: string | null, previewPost?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null, previewUrlMetadata?: { __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null } | null };

export type EditorialPostFragmentTrendingJuiceBoxFragment = { __typename?: 'EditorialPostModel', id: string, body?: string | null, color?: string | null, description: string, title?: string | null, type: PostType, trendingDate: any, lastViewed?: any | null, createdAt: any, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, posts: Array<{ __typename?: 'PostModel', id: string, type: PostType, createdAt: any, creator: { __typename?: 'UserProfileModel', email: string, id: string, lastName: string, firstName: string, avatarUrl?: string | null }, collections: Array<{ __typename?: 'CollectionModel', id: string, name: string, parentCollection?: { __typename?: 'CollectionModel', id: string, name: string } | null }> }> };

export type UpdateUserOnboardingMutationVariables = Exact<{
  data: UpdateUserOnboardingInput;
}>;


export type UpdateUserOnboardingMutation = { __typename?: 'Mutation', updateUserOnboarding: { __typename?: 'MeModel', id: string, title: string, organization: { __typename?: 'OrganizationModel', id: string, name: string }, onboardingAnswers?: { __typename?: 'OnboardingAnswersData', referralSource?: string | null } | null, invitedByUser?: { __typename?: 'UserProfileModel', id: string } | null } };

export type UpdateUserProfileForProfileTabMutationVariables = Exact<{
  data: UpdateUserProfileInput;
}>;


export type UpdateUserProfileForProfileTabMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'MeModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } };

export type GetBillingInvoicesMutationVariables = Exact<{ [key: string]: never; }>;


export type GetBillingInvoicesMutation = { __typename?: 'Mutation', getInvoices: Array<{ __typename?: 'BillingInvoice', id: string, created: number, amountDue: number, status: string, hostedInvoiceUrl?: string | null, description: string, quantity: number, interval: string }> };

export type BillingPaymentMethodFragmentCardDetailFragment = { __typename?: 'BillingPaymentMethod', id: string, card: { __typename?: 'BillingPaymentMethodCard', brand: string, expMonth: number, expYear: number, last4: string } };

export type GetDefaultPaymentMethodForCardDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultPaymentMethodForCardDetailsQuery = { __typename?: 'Query', getDefaultPaymentMethod?: { __typename?: 'BillingPaymentMethod', id: string, card: { __typename?: 'BillingPaymentMethodCard', brand: string, expMonth: number, expYear: number, last4: string } } | null };

export type UpdateCustomerDefaultPaymentMethodMutationVariables = Exact<{
  data: UpdateBillingCustomerDefaultPaymentMethodInput;
}>;


export type UpdateCustomerDefaultPaymentMethodMutation = { __typename?: 'Mutation', updateCustomerDefaultPaymentMethod: { __typename?: 'BillingCustomer', id: string, defaultPaymentMethod: { __typename?: 'BillingPaymentMethod', id: string, card: { __typename?: 'BillingPaymentMethodCard', brand: string, expMonth: number, expYear: number, last4: string } } } };

export type CreateBillingSetupIntentMethodMutationVariables = Exact<{
  data: CreateSetupIntentInput;
}>;


export type CreateBillingSetupIntentMethodMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'BillingSetupIntent', id: string, clientSecret: string } };

export type CancelBillingSetupIntentMethodMutationVariables = Exact<{
  data: CancelSetupIntentInput;
}>;


export type CancelBillingSetupIntentMethodMutation = { __typename?: 'Mutation', cancelSetupIntent: { __typename?: 'BillingSetupIntent', id: string } };

export type UserFragmentUserRequestFragment = { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, role?: InternalOrganizationRole | null, externalRole?: ExternalOrganizationRole | null, isDisabled?: boolean | null, isInvitedBy?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null };

export type UpdateOrganizationUserRoleMutationVariables = Exact<{
  data: UpdateOrganizationUserRoleInput;
}>;


export type UpdateOrganizationUserRoleMutation = { __typename?: 'Mutation', updateOrganizationUserRole: { __typename?: 'UserProfileModel', id: string } };

export type DeclinePendingUserRequestMutationVariables = Exact<{
  data: DeclinePendingUserRequestInput;
}>;


export type DeclinePendingUserRequestMutation = { __typename?: 'Mutation', declinePendingUserRequest: { __typename?: 'Result', message: string, success: boolean } };

export type DisableUsersMutationVariables = Exact<{
  data: DisableUsersInput;
}>;


export type DisableUsersMutation = { __typename?: 'Mutation', disableUsers: { __typename?: 'Result', success: boolean, message: string } };

export type EnableOnlyTheseUsersMutationVariables = Exact<{
  data: EnableUsersInput;
}>;


export type EnableOnlyTheseUsersMutation = { __typename?: 'Mutation', enableOnlyTheseUsers: { __typename?: 'Result', success: boolean, message: string } };

export type EnableUsersMutationVariables = Exact<{
  data: EnableUsersInput;
}>;


export type EnableUsersMutation = { __typename?: 'Mutation', enableUsers: { __typename?: 'Result', success: boolean, message: string } };

export type RemoveGuestUserMutationVariables = Exact<{
  data: Scalars['String'];
}>;


export type RemoveGuestUserMutation = { __typename?: 'Mutation', removeGuestUser: { __typename?: 'Result', success: boolean, message: string } };

export type UpdateNotificationSettingMutationVariables = Exact<{
  data: UpdateNotificationSettingInput;
}>;


export type UpdateNotificationSettingMutation = { __typename?: 'Mutation', updateNotificationSetting: { __typename?: 'NotificationSettingModel', id: string, type: NotificationType, email: boolean, mobilePush: boolean, inbox: boolean } };

export type NotificationSettingFragmentUseNotificationSettingsFragment = { __typename?: 'NotificationSettingModel', id: string, type: NotificationType, email: boolean, mobilePush: boolean, inbox: boolean };

export type GetMeForUseNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeForUseNotificationSettingsQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, notificationSettings: Array<{ __typename?: 'NotificationSettingModel', id: string, type: NotificationType, email: boolean, mobilePush: boolean, inbox: boolean }> } };

export type OrganizationFragmentSocialsPageFragment = { __typename?: 'OrganizationModel', id: string, socialAuthors: Array<{ __typename?: 'SocialAuthorModel', id: string, platform: Platform, profileUrl?: string | null }> };

export type GetMeForSocialsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeForSocialsPageQuery = { __typename?: 'Query', me: { __typename?: 'MeModel', id: string, organization: { __typename?: 'OrganizationModel', id: string, socialAuthors: Array<{ __typename?: 'SocialAuthorModel', id: string, platform: Platform, profileUrl?: string | null }> } } };

export type SocialAuthorFragmentSocialAuthorListSectionFragment = { __typename?: 'SocialAuthorModel', id: string, platform: Platform, profileUrl?: string | null };

export type CreateSocialAuthorForSocialAuthorListSectionMutationVariables = Exact<{
  data: CreateSocialAuthorInput;
}>;


export type CreateSocialAuthorForSocialAuthorListSectionMutation = { __typename?: 'Mutation', createSocialAuthor: { __typename?: 'SocialAuthorModel', id: string, platform: Platform, profileUrl?: string | null } };

export type DeleteSocialAuthorForSocialAuthorListSectionMutationVariables = Exact<{
  data: DeleteSocialAuthorInput;
}>;


export type DeleteSocialAuthorForSocialAuthorListSectionMutation = { __typename?: 'Mutation', deleteSocialAuthor: { __typename?: 'Result', success: boolean, message: string } };

export type SendOtpMutationVariables = Exact<{
  data: SendOtpInput;
}>;


export type SendOtpMutation = { __typename?: 'Mutation', sendOTP: { __typename?: 'Result', message: string, success: boolean } };

export type VerifyOtpMutationVariables = Exact<{
  data: VerifyOtpInput;
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOTP: { __typename?: 'Result', message: string, success: boolean } };

export type SocialPostFragmentAddACommentButtonFragment = { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null };

export type CreateSocialPostForOutboundCommentsForAddACommentButtonMutationVariables = Exact<{
  data: CreateSocialPostForOutboundCommentsInput;
}>;


export type CreateSocialPostForOutboundCommentsForAddACommentButtonMutation = { __typename?: 'Mutation', createSocialPostForOutboundComments: { __typename?: 'SocialPostModel', id: string, thumbnailUrl?: string | null } };

export type GetSocialPostCommentsQueryVariables = Exact<{
  brandId: Scalars['String'];
  data: SocialPostCommentsInput;
}>;


export type GetSocialPostCommentsQuery = { __typename?: 'Query', socialPostComments: { __typename?: 'PaginatedSocialPostComment', data: Array<{ __typename?: 'SocialPostCommentModel', id: string, childCommentCount: number, text: string, diggCount: number, platformCreateTime: any, socialPost: { __typename?: 'SocialPostModel', id: string, videoUrl?: string | null, thumbnailUrl?: string | null, platformCreateTime: any, platform: Platform, platformId: string, expiresAt?: any | null, brandSocialPostEngagement?: { __typename?: 'BrandSocialPostEngagementModel', id: string, respondedByUser?: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } | null } | null, creator?: { __typename?: 'CreatorModel', id: string, handle: string } | null } }>, meta: { __typename?: 'PaginationMeta', totalCount: number }, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryVariables = Exact<{
  brandIds: Array<Scalars['String']> | Scalars['String'];
  userId: Scalars['String'];
  filters: BrandOutboundEngagementPerformanceByUserFilters;
}>;


export type GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery = { __typename?: 'Query', brandOutboundEngagementPerformanceByUser: { __typename?: 'BrandOutboundEngagementPerformanceByUserResponse', id: string, averageEngagement: number, numberOfPostsCommentedOn: number, maxLikes: number, user: { __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null } } };

export type GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryVariables = Exact<{
  input: PaginatedOrganizationCreatorProfileLabelInput;
}>;


export type GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery = { __typename?: 'Query', paginatedOrganizationCreatorProfileLabels: { __typename?: 'PaginatedOrganizationCreatorProfileLabelModel', data: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetLocationsForSlCommunityPageFiltersQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetLocationsForSlCommunityPageFiltersQuery = { __typename?: 'Query', getCreatorProfileLocations: Array<string> };

export type GetCapturedProductsForSlCommunityPageFiltersQueryVariables = Exact<{
  input: GetCreatorProfilesCapturedProductsArgs;
}>;


export type GetCapturedProductsForSlCommunityPageFiltersQuery = { __typename?: 'Query', getCreatorProfilesCapturedProducts: { __typename?: 'PaginatedCapturedProductModel', data: Array<{ __typename?: 'CapturedProductModel', id: string, line: string, model: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SavedConfigFragmentSavedViewsMenuFragment = { __typename?: 'SavedConfigModel', id: string, name: string, type: SavedConfigType, config: string, brandId?: string | null };

export type GetSavedConfigsByTypeForSavedMenuViewsQueryVariables = Exact<{
  input: ListSavedConfigsInput;
}>;


export type GetSavedConfigsByTypeForSavedMenuViewsQuery = { __typename?: 'Query', getSavedConfigsByType: Array<{ __typename?: 'SavedConfigModel', id: string, name: string, type: SavedConfigType, config: string, brandId?: string | null }> };

export type CreateSavedConfigForSavedMenuViewsMutationVariables = Exact<{
  input: CreateSavedConfigInput;
}>;


export type CreateSavedConfigForSavedMenuViewsMutation = { __typename?: 'Mutation', createSavedConfig: { __typename?: 'Result', success: boolean, message: string } };

export type UpdateSavedConfigForSavedMenuViewsMutationVariables = Exact<{
  input: UpdateSavedConfigInput;
}>;


export type UpdateSavedConfigForSavedMenuViewsMutation = { __typename?: 'Mutation', updateSavedConfig: { __typename?: 'Result', success: boolean, message: string } };

export type DeleteSavedConfigForSavedMenuViewsMutationVariables = Exact<{
  input: DeleteSavedConfigInput;
}>;


export type DeleteSavedConfigForSavedMenuViewsMutation = { __typename?: 'Mutation', deleteSavedConfig: { __typename?: 'Result', success: boolean, message: string } };

export type CompetitorFragmentForSlCompetitorDetailPageFragment = { __typename?: 'CompetitorModel', id: string, isBookmarked: boolean };

export type GetCreatorProfileForSlCreatorProfilePageQueryVariables = Exact<{
  id: Scalars['String'];
  brandId: Scalars['String'];
}>;


export type GetCreatorProfileForSlCreatorProfilePageQuery = { __typename?: 'Query', creatorProfile: { __typename?: 'CreatorProfileModel', id: string, fullName: string, isBlockedFromCommunityHub: boolean, isBrandBlocked: boolean, defaultCreatorId: string, brandId: string, isTrackingInsights: boolean, emails?: Array<string> | null, relationshipStrength: CreatorProfileRelationshipStrength, location?: string | null, reasonForLocation?: string | null, birthdate?: any | null, brand: { __typename?: 'BrandModel', id: string, name: string }, creators: Array<{ __typename?: 'CreatorModel', id: string, audience_demographics?: string | null, otherInsights?: string | null, industry?: string | null, platform: Platform, handle: string, nickName: string, profilePictureUrl?: string | null, platformId: string, videoCount: number, followerCount: number, engagementRate: number }>, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, locationReferenceSocialPost?: { __typename?: 'SocialPostModel', id: string } | null } };

export type BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables = Exact<{
  input: BlockCreatorFromCreatorProfileInput;
}>;


export type BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation = { __typename?: 'Mutation', blockCreatorFromCreatorProfile: { __typename?: 'Result', success: boolean } };

export type UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables = Exact<{
  input: UnblockCreatorFromCreatorProfileInput;
}>;


export type UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation = { __typename?: 'Mutation', unblockCreatorFromCreatorProfile: { __typename?: 'Result', success: boolean } };

export type BlockCreatorForSlCreatorProfilePageMutationVariables = Exact<{
  data: BlockCreatorInput;
}>;


export type BlockCreatorForSlCreatorProfilePageMutation = { __typename?: 'Mutation', blockCreator: { __typename?: 'Result', success: boolean } };

export type RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationVariables = Exact<{
  data: RemoveCreatorBlockingByHandleInput;
}>;


export type RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation = { __typename?: 'Mutation', removeCreatorBlockingByHandle: { __typename?: 'Result', success: boolean } };

export type CreatorProfileFragmentAboutTabContentFragment = { __typename?: 'CreatorProfileModel', id: string, brandId: string, isTrackingInsights: boolean, fullName: string, emails?: Array<string> | null, relationshipStrength: CreatorProfileRelationshipStrength, location?: string | null, reasonForLocation?: string | null, birthdate?: any | null, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }>, creators: Array<{ __typename?: 'CreatorModel', id: string, audience_demographics?: string | null, otherInsights?: string | null, industry?: string | null, platform: Platform, handle: string, nickName: string, profilePictureUrl?: string | null, videoCount: number, followerCount: number, engagementRate: number, platformId: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, locationReferenceSocialPost?: { __typename?: 'SocialPostModel', id: string } | null };

export type CreatorProfileFragmentActivityTabContentFragment = { __typename?: 'CreatorProfileModel', id: string, brandId: string, isTrackingInsights: boolean, fullName: string, emails?: Array<string> | null, relationshipStrength: CreatorProfileRelationshipStrength, location?: string | null, reasonForLocation?: string | null, birthdate?: any | null, creatorTrackedTopics: Array<{ __typename?: 'TopicModel', id: string }>, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, nickName: string, audience_demographics?: string | null, industry?: string | null, otherInsights?: string | null, profilePictureUrl?: string | null, videoCount: number, followerCount: number, engagementRate: number, platformId: string }>, labels: Array<{ __typename?: 'OrganizationCreatorProfileLabelModel', id: string, label: string, color?: string | null, bgColor?: string | null }>, locationReferenceSocialPost?: { __typename?: 'SocialPostModel', id: string } | null };

export type GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryVariables = Exact<{
  input: CreatorProfileBrandMentionedStatsInput;
}>;


export type GetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery = { __typename?: 'Query', creatorProfileBrandMentionStats: { __typename?: 'CreatorProfileBrandMentionStats', brandMentionCount: number, engagementRate: number, sentiment: Sentiment, totalLikes: number, totalViews: number, sentimentScore: number } };

export type GetStatsForSlCreatorProfileActivityTabContentQueryVariables = Exact<{
  input: CreatorProfileSuperfanEngagementStatsInput;
}>;


export type GetStatsForSlCreatorProfileActivityTabContentQuery = { __typename?: 'Query', getCreatorProfileSuperfanEngagementStats: { __typename?: 'CreatorProfileSuperfanEngagementStats', maxLikes: number, sentiment: Sentiment, totalComments: number, totalEngagement: number, sentimentScore: number } };

export type GetPaginatedRadarEventsForActivityTabContentQueryVariables = Exact<{
  input: PaginatedRadarEventInput;
}>;


export type GetPaginatedRadarEventsForActivityTabContentQuery = { __typename?: 'Query', getPaginatedRadarEvents: { __typename?: 'PaginatedRadarEventModel', data: Array<{ __typename?: 'RadarEventModel', id: string, brandId: string, eventType: RadarEventType, platformCreateTime: any, message?: string | null, createdAt: any, radarEventActivities: Array<{ __typename?: 'RadarEventActivityModel', id: string, title: string, summary: string, direction: RadarEventActivityDirection, createdAt: any, dateTime?: any | null, createdByUser: { __typename?: 'UserProfileModel', id: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null }, assets: Array<{ __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null }>, channels: Array<{ __typename?: 'RadarEventActivityCommunicationChannelModel', id: string, name: string, color?: string | null, bgColor?: string | null }>, createdForCreatorProfiles: Array<{ __typename?: 'CreatorProfileModel', id: string }>, radarEvents: Array<{ __typename?: 'RadarEventModel', id: string }> }>, creator?: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, profilePictureUrl?: string | null } | null, socialPostComment?: { __typename?: 'SocialPostCommentModel', id: string, text: string, diggCount: number, childCommentCount: number, commentCreator: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string }, socialPostCommentClaims: Array<{ __typename?: 'SocialPostCommentClaimModel', sentimentScore: number, brandId?: string | null }> } | null, socialPost?: { __typename?: 'SocialPostModel', id: string, description: string, diggCount: number, commentCount: number, playCount: number, engagementRate: number, platformCreateTime: any, platform: Platform, thumbnailUrl?: string | null, videoUrl?: string | null, type: SocialPostType, platformId: string, expiresAt?: any | null, creator?: { __typename?: 'CreatorModel', id: string, nickName: string, handle: string, platform: Platform, profilePictureUrl?: string | null } | null, brandAnalysis: Array<{ __typename?: 'BrandAnalysisModel', id: string, brandId: string, sentimentScore?: number | null, sentimentTone?: Sentiment | null }> } | null, brand: { __typename?: 'BrandModel', id: string, name: string, creators: Array<{ __typename?: 'CreatorModel', id: string, nickName: string, handle: string, profilePictureUrl?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type GetBrandForSocialMediaListeningQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBrandForSocialMediaListeningQuery = { __typename?: 'Query', brand: { __typename?: 'BrandModel', id: string, name: string, regions: Array<string>, topics: Array<{ __typename?: 'TopicModel', id: string, name: string, type: ListeningTopicType, topicContentStrategy?: string | null }>, bookmarkState: { __typename?: 'BrandBookmarkState', socialListeningEngagement: boolean }, creators: Array<{ __typename?: 'CreatorModel', id: string, platform: Platform, handle: string, profilePictureUrl?: string | null }> } };

export type GetPostForTaskDetailPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostForTaskDetailPageQuery = { __typename?: 'Query', post?: { __typename?: 'PostModel', id: string, title?: string | null, type: PostType, color: string, updatedAt: any, urlMetadata: Array<{ __typename?: 'URLMetadataModel', id: string, url: string, metadata?: { __typename?: 'Metadata', site?: string | null, medium?: string | null, type?: string | null, author?: string | null, title?: string | null, thumbnail?: Array<{ __typename?: 'ThumbnailMetadata', type?: string | null, href?: string | null, mediaSize?: { __typename?: 'MediaSize', width: number, height: number } | null }> | null, medias?: Array<{ __typename?: 'SocialMediaResource', type: string, url: string }> | null } | null }>, attachment?: { __typename?: 'AttachmentModel', id: string, metaData: { __typename?: 'AttachmentMetaData', mimeType?: string | null } } | null } | null };

export type GetTaskCommentsUnreadCountQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type GetTaskCommentsUnreadCountQuery = { __typename?: 'Query', unreadTaskComments: number };

export type GetTasksForTaskCalendarSectionQueryVariables = Exact<{
  filters: TaskFilters;
  take?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetTasksForTaskCalendarSectionQuery = { __typename?: 'Query', tasks: { __typename?: 'PaginatedTaskSearchResult', data: Array<{ __typename?: 'TaskModel', id: string, name: string, startDate?: any | null, endDate?: any | null, status: TaskStatus, priority?: TaskPriority | null, taskMembers: Array<{ __typename?: 'UserProfileModel', id: string, email: string, firstName: string, lastName: string, avatarUrl?: string | null, isDisabled?: boolean | null, hasSignedUp?: boolean | null, shouldBeCountedTowardPaywall?: boolean | null }>, parentTask?: { __typename?: 'TaskModel', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, meta: { __typename?: 'PaginatedTaskSearchResultMeta', totalCount: number, completedCount: number } } };

export type GetTasksForTaskListSectionQueryVariables = Exact<{
  filters: TaskFilters;
}>;


export type GetTasksForTaskListSectionQuery = { __typename?: 'Query', tasks: { __typename?: 'PaginatedTaskSearchResult', meta: { __typename?: 'PaginatedTaskSearchResultMeta', totalCount: number } } };

export const UserFragmentAvatarGroupFragmentDoc = gql`
    fragment UserFragmentAvatarGroup on UserProfileModel {
  id
  email
  firstName
  lastName
  avatarUrl
  isDisabled
  hasSignedUp
  shouldBeCountedTowardPaywall
}
    `;
export const UserReactionFragmentReactionListFragmentDoc = gql`
    fragment UserReactionFragmentReactionList on UserReactionModel {
  id
  emoji
  userId
  user {
    id
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const UserFragmentSubscribersFragmentDoc = gql`
    fragment UserFragmentSubscribers on UserProfileModel {
  ...UserFragmentAvatarGroup
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const TaskFragmentSearchModalFragmentDoc = gql`
    fragment TaskFragmentSearchModal on TaskModel {
  id
  name
  description
  taskMembers {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const TaskSearchHitFragmentSearchModalFragmentDoc = gql`
    fragment TaskSearchHitFragmentSearchModal on TaskSearchHit {
  taskModel {
    ...TaskFragmentSearchModal
  }
  headline {
    column
    headline
  }
}
    ${TaskFragmentSearchModalFragmentDoc}`;
export const PostSearchModalFragmentDoc = gql`
    fragment PostSearchModal on PostModel {
  id
  title
  type
  urlMetadata {
    id
    url
    metadata {
      thumbnail {
        href
      }
    }
  }
}
    `;
export const SearchResultFragmentRichTextFragmentDoc = gql`
    fragment SearchResultFragmentRichText on SearchResults {
  taskSearchHits {
    ...TaskSearchHitFragmentSearchModal
  }
  userSearchHits {
    ...UserFragmentAvatarGroup
  }
  postSearchHits {
    ...PostSearchModal
  }
}
    ${TaskSearchHitFragmentSearchModalFragmentDoc}
${UserFragmentAvatarGroupFragmentDoc}
${PostSearchModalFragmentDoc}`;
export const BrandFragmentForFrequentlyVisitedPagesFragmentDoc = gql`
    fragment BrandFragmentForFrequentlyVisitedPages on BrandModel {
  id
  name
  creators {
    id
    profilePictureUrl
  }
}
    `;
export const ActivityFragmentForFrequentlyVisitedPagesFragmentDoc = gql`
    fragment ActivityFragmentForFrequentlyVisitedPages on ActivityModel {
  id
  entity
  brand {
    ...BrandFragmentForFrequentlyVisitedPages
  }
  competitor {
    id
    name
    forBrand {
      ...BrandFragmentForFrequentlyVisitedPages
    }
  }
  collection {
    id
    name
    parentCollection {
      id
      name
    }
  }
}
    ${BrandFragmentForFrequentlyVisitedPagesFragmentDoc}`;
export const FeatureFlagFragmentFeatureFlagsContextFragmentDoc = gql`
    fragment FeatureFlagFragmentFeatureFlagsContext on FeatureFlagModel {
  id
  name
  enabled
  organizationId
  updatedAt
  createdAt
}
    `;
export const CollectionFragmentCollectionNameFragmentDoc = gql`
    fragment CollectionFragmentCollectionName on CollectionModel {
  id
  name
}
    `;
export const CollectionFragmentCollectionSummaryFragmentDoc = gql`
    fragment CollectionFragmentCollectionSummary on CollectionModel {
  id
  totalPosts
  totalChildCollections
  isDisabled
}
    `;
export const UrlMetadataFragmentIframelyFragmentDoc = gql`
    fragment URLMetadataFragmentIframely on URLMetadataModel {
  id
  url
  metadata {
    site
    medium
    type
    author
    title
    thumbnail {
      type
      href
      mediaSize {
        width
        height
      }
    }
    medias {
      type
      url
    }
  }
}
    `;
export const UrlMetadataFragmentPostPreviewFragmentDoc = gql`
    fragment URLMetadataFragmentPostPreview on URLMetadataModel {
  ...URLMetadataFragmentIframely
}
    ${UrlMetadataFragmentIframelyFragmentDoc}`;
export const PostFragmentPostNotePreviewViewFragmentDoc = gql`
    fragment PostFragmentPostNotePreviewView on PostModel {
  id
  title
  color
  updatedAt
  urlMetadata {
    ...URLMetadataFragmentIframely
  }
}
    ${UrlMetadataFragmentIframelyFragmentDoc}`;
export const PostFragmentPostNotePreviewCompactViewFragmentDoc = gql`
    fragment PostFragmentPostNotePreviewCompactView on PostModel {
  id
  title
  color
}
    `;
export const PostFragmentPostPreviewFragmentDoc = gql`
    fragment PostFragmentPostPreview on PostModel {
  id
  title
  type
  urlMetadata {
    ...URLMetadataFragmentPostPreview
  }
  attachment {
    id
    metaData {
      mimeType
    }
  }
  ...PostFragmentPostNotePreviewView
  ...PostFragmentPostNotePreviewCompactView
}
    ${UrlMetadataFragmentPostPreviewFragmentDoc}
${PostFragmentPostNotePreviewViewFragmentDoc}
${PostFragmentPostNotePreviewCompactViewFragmentDoc}`;
export const PostFragmentCollectionMultiPostPreviewFragmentDoc = gql`
    fragment PostFragmentCollectionMultiPostPreview on PostModel {
  id
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const CollectionFragmentCollectionMultiPostPreviewFragmentDoc = gql`
    fragment CollectionFragmentCollectionMultiPostPreview on CollectionModel {
  id
  posts(postCount: 3) {
    id
    ...PostFragmentCollectionMultiPostPreview
  }
}
    ${PostFragmentCollectionMultiPostPreviewFragmentDoc}`;
export const CollectionFragmentCollectionPinFragmentDoc = gql`
    fragment CollectionFragmentCollectionPin on CollectionModel {
  id
  isPinnedToRoot
  isPinnedToParent
}
    `;
export const CollectionFragmentCollectionContextMenuFragmentDoc = gql`
    fragment CollectionFragmentCollectionContextMenu on CollectionModel {
  id
  creatorId
  parentCollectionId
  myPermissions
  hasPreviewPost
  isBookmarked
  ...CollectionFragmentCollectionPin
  previewPost {
    id
  }
}
    ${CollectionFragmentCollectionPinFragmentDoc}`;
export const UserProfileFragmentUserProfilePermissionItemViewFragmentDoc = gql`
    fragment UserProfileFragmentUserProfilePermissionItemView on UserProfileModel {
  id
  ...UserFragmentAvatarGroup
  organization {
    id
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const CollectionInviteMemberFragmentCollectionPermissionMemberFragmentDoc = gql`
    fragment CollectionInviteMemberFragmentCollectionPermissionMember on CollectionInviteMemberModel {
  id
  permissionLevel
  user {
    ...UserProfileFragmentUserProfilePermissionItemView
  }
}
    ${UserProfileFragmentUserProfilePermissionItemViewFragmentDoc}`;
export const CollectionFragmentCollectionPermissionSummaryFragmentDoc = gql`
    fragment CollectionFragmentCollectionPermissionSummary on CollectionModel {
  id
  generalPermission
  organizationName
  inviteMembers {
    ...CollectionInviteMemberFragmentCollectionPermissionMember
  }
}
    ${CollectionInviteMemberFragmentCollectionPermissionMemberFragmentDoc}`;
export const CollectionFragmentCollectionThumbnailFragmentDoc = gql`
    fragment CollectionFragmentCollectionThumbnail on CollectionModel {
  id
  hasPreviewPost
  previewPost {
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const CollectionFragmentCollectionBreadcrumbsFragmentDoc = gql`
    fragment CollectionFragmentCollectionBreadcrumbs on CollectionModel {
  id
  breadcrumbsFromRoot {
    id
    name
  }
}
    `;
export const CollectionFragmentCollectionSavedToContentCalendarFragmentDoc = gql`
    fragment CollectionFragmentCollectionSavedToContentCalendar on CollectionModel {
  id
  breadcrumbsFromRoot {
    id
    contentIdeaId
  }
}
    `;
export const CollectionFragmentCollectionCardViewFragmentDoc = gql`
    fragment CollectionFragmentCollectionCardView on CollectionModel {
  id
  ...CollectionFragmentCollectionName
  ...CollectionFragmentCollectionSummary
  ...CollectionFragmentCollectionMultiPostPreview
  ...CollectionFragmentCollectionContextMenu
  ...CollectionFragmentCollectionPermissionSummary
  ...CollectionFragmentCollectionThumbnail
  ...CollectionFragmentCollectionPin
  ...CollectionFragmentCollectionBreadcrumbs
  ...CollectionFragmentCollectionSavedToContentCalendar
}
    ${CollectionFragmentCollectionNameFragmentDoc}
${CollectionFragmentCollectionSummaryFragmentDoc}
${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}
${CollectionFragmentCollectionContextMenuFragmentDoc}
${CollectionFragmentCollectionPermissionSummaryFragmentDoc}
${CollectionFragmentCollectionThumbnailFragmentDoc}
${CollectionFragmentCollectionPinFragmentDoc}
${CollectionFragmentCollectionBreadcrumbsFragmentDoc}
${CollectionFragmentCollectionSavedToContentCalendarFragmentDoc}`;
export const CollectionFragmentCollectionCommandFragmentDoc = gql`
    fragment CollectionFragmentCollectionCommand on CollectionModel {
  id
  ...CollectionFragmentCollectionCardView
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;
export const PostFragmentPostUnreadCommentBadgeFragmentDoc = gql`
    fragment PostFragmentPostUnreadCommentBadge on PostModel {
  id
  unreadCommentCount
}
    `;
export const PostFragmentPostNewBadgeFragmentDoc = gql`
    fragment PostFragmentPostNewBadge on PostModel {
  id
  isNew
}
    `;
export const PostFragmentCollectionThumbnailFragmentDoc = gql`
    fragment PostFragmentCollectionThumbnail on PostModel {
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentPostBookmarkButtonFragmentDoc = gql`
    fragment PostFragmentPostBookmarkButton on PostModel {
  id
  isFavorite
  isFavoriteTrend
  trend {
    id
    title
  }
}
    `;
export const PostFragmentPostPinFragmentDoc = gql`
    fragment PostFragmentPostPin on PostModel {
  id
  pinnedToCollections {
    id
    parentCollectionId
  }
}
    `;
export const PostFragmentPostMoveToAnotherCollectionFragmentDoc = gql`
    fragment PostFragmentPostMoveToAnotherCollection on PostModel {
  description
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentPostSaveToContentCalendarButtonFragmentDoc = gql`
    fragment PostFragmentPostSaveToContentCalendarButton on PostModel {
  id
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentPostContextMenuFragmentDoc = gql`
    fragment PostFragmentPostContextMenu on PostModel {
  id
  type
  myPermissions
  isFavoriteTrend
  trend {
    id
    title
  }
  ...PostFragmentCollectionThumbnail
  ...PostFragmentPostBookmarkButton
  ...PostFragmentPostPin
  ...PostFragmentPostPreview
  ...PostFragmentPostMoveToAnotherCollection
  ...PostFragmentPostSaveToContentCalendarButton
}
    ${PostFragmentCollectionThumbnailFragmentDoc}
${PostFragmentPostBookmarkButtonFragmentDoc}
${PostFragmentPostPinFragmentDoc}
${PostFragmentPostPreviewFragmentDoc}
${PostFragmentPostMoveToAnotherCollectionFragmentDoc}
${PostFragmentPostSaveToContentCalendarButtonFragmentDoc}`;
export const UserReactionFragmentPostReactionListFragmentDoc = gql`
    fragment UserReactionFragmentPostReactionList on UserReactionModel {
  id
  emoji
  user {
    id
    firstName
  }
}
    `;
export const PostFragmentPostReactionListFragmentDoc = gql`
    fragment PostFragmentPostReactionList on PostModel {
  id
  userReactions {
    id
    ...UserReactionFragmentPostReactionList
  }
}
    ${UserReactionFragmentPostReactionListFragmentDoc}`;
export const PostFragmentPostCreatorFragmentDoc = gql`
    fragment PostFragmentPostCreator on PostModel {
  id
  creator {
    id
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const PostInviteMemberFragmentPostPermissionMemberFragmentDoc = gql`
    fragment PostInviteMemberFragmentPostPermissionMember on PostInviteMemberModel {
  id
  lastSeen
  permissionLevel
  user {
    ...UserProfileFragmentUserProfilePermissionItemView
  }
}
    ${UserProfileFragmentUserProfilePermissionItemViewFragmentDoc}`;
export const PostFragmentPostPermissionSummaryFragmentDoc = gql`
    fragment PostFragmentPostPermissionSummary on PostModel {
  id
  generalPermission
  organizationName
  inviteMembers {
    ...PostInviteMemberFragmentPostPermissionMember
  }
}
    ${PostInviteMemberFragmentPostPermissionMemberFragmentDoc}`;
export const PostFragmentPostTitleFragmentDoc = gql`
    fragment PostFragmentPostTitle on PostModel {
  id
  title
  myPermissions
  creator {
    id
    firstName
  }
  urlMetadata {
    id
    url
  }
}
    `;
export const PostFragmentCollectionPostDndPostCardFragmentDoc = gql`
    fragment PostFragmentCollectionPostDndPostCard on PostModel {
  id
  collections {
    id
  }
  description
  ...PostFragmentPostPreview
  ...PostFragmentPostUnreadCommentBadge
  ...PostFragmentPostNewBadge
  ...PostFragmentPostContextMenu
  ...PostFragmentPostReactionList
  ...PostFragmentPostCreator
  ...PostFragmentCollectionThumbnail
  ...PostFragmentPostPermissionSummary
  ...PostFragmentPostTitle
}
    ${PostFragmentPostPreviewFragmentDoc}
${PostFragmentPostUnreadCommentBadgeFragmentDoc}
${PostFragmentPostNewBadgeFragmentDoc}
${PostFragmentPostContextMenuFragmentDoc}
${PostFragmentPostReactionListFragmentDoc}
${PostFragmentPostCreatorFragmentDoc}
${PostFragmentCollectionThumbnailFragmentDoc}
${PostFragmentPostPermissionSummaryFragmentDoc}
${PostFragmentPostTitleFragmentDoc}`;
export const PostFragmentJuiceboxTablePostTableRowCellNameFragmentDoc = gql`
    fragment PostFragmentJuiceboxTablePostTableRowCellName on PostModel {
  id
  ...PostFragmentPostTitle
  ...PostFragmentPostPin
}
    ${PostFragmentPostTitleFragmentDoc}
${PostFragmentPostPinFragmentDoc}`;
export const PostFragmentJuiceboxTablePostTableRowCellPreviewFragmentDoc = gql`
    fragment PostFragmentJuiceboxTablePostTableRowCellPreview on PostModel {
  id
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentJuiceboxTablePostTableRowCellPermissionFragmentDoc = gql`
    fragment PostFragmentJuiceboxTablePostTableRowCellPermission on PostModel {
  id
  ...PostFragmentPostPermissionSummary
}
    ${PostFragmentPostPermissionSummaryFragmentDoc}`;
export const PostFragmentJuiceboxTablePostTableRowCellActivityFragmentDoc = gql`
    fragment PostFragmentJuiceboxTablePostTableRowCellActivity on PostModel {
  id
  ...PostFragmentPostUnreadCommentBadge
}
    ${PostFragmentPostUnreadCommentBadgeFragmentDoc}`;
export const PostFragmentJuiceboxTablePostTableRowCellSelectIconFragmentDoc = gql`
    fragment PostFragmentJuiceboxTablePostTableRowCellSelectIcon on PostModel {
  id
}
    `;
export const PostFragmentJuiceboxTablePostTableRowFragmentDoc = gql`
    fragment PostFragmentJuiceboxTablePostTableRow on PostModel {
  id
  ...PostFragmentJuiceboxTablePostTableRowCellName
  ...PostFragmentJuiceboxTablePostTableRowCellPreview
  ...PostFragmentJuiceboxTablePostTableRowCellPermission
  ...PostFragmentJuiceboxTablePostTableRowCellActivity
  ...PostFragmentJuiceboxTablePostTableRowCellSelectIcon
}
    ${PostFragmentJuiceboxTablePostTableRowCellNameFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowCellPreviewFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowCellPermissionFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowCellActivityFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowCellSelectIconFragmentDoc}`;
export const PostFragmentJuiceboxTablePostTableRowWithContextMenuFragmentDoc = gql`
    fragment PostFragmentJuiceboxTablePostTableRowWithContextMenu on PostModel {
  id
  ...PostFragmentJuiceboxTablePostTableRow
  ...PostFragmentPostContextMenu
}
    ${PostFragmentJuiceboxTablePostTableRowFragmentDoc}
${PostFragmentPostContextMenuFragmentDoc}`;
export const PostFragmentPostCommandFragmentDoc = gql`
    fragment PostFragmentPostCommand on PostModel {
  id
  ...PostFragmentCollectionPostDndPostCard
  ...PostFragmentJuiceboxTablePostTableRowWithContextMenu
  ...PostFragmentPostTitle
}
    ${PostFragmentCollectionPostDndPostCardFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowWithContextMenuFragmentDoc}
${PostFragmentPostTitleFragmentDoc}`;
export const PostFragmentCollectionCommandFragmentDoc = gql`
    fragment PostFragmentCollectionCommand on PostModel {
  id
  ...PostFragmentPostCommand
}
    ${PostFragmentPostCommandFragmentDoc}`;
export const NoteSearchHitFragmentSearchTypeFragmentDoc = gql`
    fragment NoteSearchHitFragmentSearchType on PostSearchHit {
  type
}
    `;
export const NoteSearchHitFragmentItemNameFragmentDoc = gql`
    fragment NoteSearchHitFragmentItemName on PostSearchHit {
  item {
    id
    title
  }
}
    `;
export const NoteSearchHitFragmentItemThumbnailFragmentDoc = gql`
    fragment NoteSearchHitFragmentItemThumbnail on PostSearchHit {
  item {
    id
  }
}
    `;
export const NoteSearchHitFragmentItemSuffixFragmentDoc = gql`
    fragment NoteSearchHitFragmentItemSuffix on PostSearchHit {
  item {
    id
    urlMetadata {
      id
      url
    }
  }
}
    `;
export const NoteSearchHitFragmentListItemViewFragmentDoc = gql`
    fragment NoteSearchHitFragmentListItemView on PostSearchHit {
  score
  ...NoteSearchHitFragmentSearchType
  ...NoteSearchHitFragmentItemName
  ...NoteSearchHitFragmentItemThumbnail
  ...NoteSearchHitFragmentItemSuffix
}
    ${NoteSearchHitFragmentSearchTypeFragmentDoc}
${NoteSearchHitFragmentItemNameFragmentDoc}
${NoteSearchHitFragmentItemThumbnailFragmentDoc}
${NoteSearchHitFragmentItemSuffixFragmentDoc}`;
export const NoteSearchResultFragmentSectionViewFragmentDoc = gql`
    fragment NoteSearchResultFragmentSectionView on PostSearchResult {
  totalCount
  hits {
    ...NoteSearchHitFragmentListItemView
  }
}
    ${NoteSearchHitFragmentListItemViewFragmentDoc}`;
export const LinkSearchHitFragmentSearchTypeFragmentDoc = gql`
    fragment LinkSearchHitFragmentSearchType on PostSearchHit {
  type
}
    `;
export const PostFragmentUrlMetadataFragmentDoc = gql`
    fragment PostFragmentUrlMetadata on PostModel {
  urlMetadata {
    id
    url
    metadata {
      title
      description
      site
      medium
      type
      thumbnail {
        href
      }
    }
  }
}
    `;
export const LinkSearchHitFragmentItemNameFragmentDoc = gql`
    fragment LinkSearchHitFragmentItemName on PostSearchHit {
  item {
    id
    ...PostFragmentUrlMetadata
  }
}
    ${PostFragmentUrlMetadataFragmentDoc}`;
export const LinkSearchHitFragmentItemThumbnailFragmentDoc = gql`
    fragment LinkSearchHitFragmentItemThumbnail on PostSearchHit {
  item {
    id
    ...PostFragmentUrlMetadata
  }
}
    ${PostFragmentUrlMetadataFragmentDoc}`;
export const LinkSearchHitFragmentItemSuffixFragmentDoc = gql`
    fragment LinkSearchHitFragmentItemSuffix on PostSearchHit {
  item {
    id
  }
}
    `;
export const LinkSearchHitFragmentListItemViewFragmentDoc = gql`
    fragment LinkSearchHitFragmentListItemView on PostSearchHit {
  score
  ...LinkSearchHitFragmentSearchType
  ...LinkSearchHitFragmentItemName
  ...LinkSearchHitFragmentItemThumbnail
  ...LinkSearchHitFragmentItemSuffix
}
    ${LinkSearchHitFragmentSearchTypeFragmentDoc}
${LinkSearchHitFragmentItemNameFragmentDoc}
${LinkSearchHitFragmentItemThumbnailFragmentDoc}
${LinkSearchHitFragmentItemSuffixFragmentDoc}`;
export const LinkSearchResultFragmentSectionViewFragmentDoc = gql`
    fragment LinkSearchResultFragmentSectionView on PostSearchResult {
  totalCount
  hits {
    ...LinkSearchHitFragmentListItemView
  }
}
    ${LinkSearchHitFragmentListItemViewFragmentDoc}`;
export const AttachmentSearchHitFragmentSearchTypeFragmentDoc = gql`
    fragment AttachmentSearchHitFragmentSearchType on PostSearchHit {
  type
}
    `;
export const AttachmentFragmentAttachmentNameFragmentDoc = gql`
    fragment AttachmentFragmentAttachmentName on AttachmentModel {
  id
  name
}
    `;
export const PostFragmentAttachmentFragmentDoc = gql`
    fragment PostFragmentAttachment on PostModel {
  attachment {
    ...AttachmentFragmentAttachmentName
    url
    metaData {
      mimeType
    }
  }
}
    ${AttachmentFragmentAttachmentNameFragmentDoc}`;
export const AttachmentSearchHitFragmentItemNameFragmentDoc = gql`
    fragment AttachmentSearchHitFragmentItemName on PostSearchHit {
  item {
    id
    ...PostFragmentAttachment
  }
}
    ${PostFragmentAttachmentFragmentDoc}`;
export const AttachmentSearchHitFragmentItemThumbnailFragmentDoc = gql`
    fragment AttachmentSearchHitFragmentItemThumbnail on PostSearchHit {
  item {
    id
    ...PostFragmentAttachment
  }
}
    ${PostFragmentAttachmentFragmentDoc}`;
export const AttachmentSearchHitFragmentItemSuffixFragmentDoc = gql`
    fragment AttachmentSearchHitFragmentItemSuffix on PostSearchHit {
  item {
    id
  }
}
    `;
export const AttachmentSearchHitFragmentListItemViewFragmentDoc = gql`
    fragment AttachmentSearchHitFragmentListItemView on PostSearchHit {
  score
  ...AttachmentSearchHitFragmentSearchType
  ...AttachmentSearchHitFragmentItemName
  ...AttachmentSearchHitFragmentItemThumbnail
  ...AttachmentSearchHitFragmentItemSuffix
}
    ${AttachmentSearchHitFragmentSearchTypeFragmentDoc}
${AttachmentSearchHitFragmentItemNameFragmentDoc}
${AttachmentSearchHitFragmentItemThumbnailFragmentDoc}
${AttachmentSearchHitFragmentItemSuffixFragmentDoc}`;
export const AttachmentSearchResultFragmentSectionViewFragmentDoc = gql`
    fragment AttachmentSearchResultFragmentSectionView on PostSearchResult {
  totalCount
  hits {
    ...AttachmentSearchHitFragmentListItemView
  }
}
    ${AttachmentSearchHitFragmentListItemViewFragmentDoc}`;
export const TaskSearchHitFragmentSearchTypeFragmentDoc = gql`
    fragment TaskSearchHitFragmentSearchType on TaskSearchHitV2 {
  type
}
    `;
export const TaskFragmentTaskNameFragmentDoc = gql`
    fragment TaskFragmentTaskName on TaskModel {
  id
  name
  parentTask {
    id
    name
  }
}
    `;
export const TaskSearchHitFragmentItemNameFragmentDoc = gql`
    fragment TaskSearchHitFragmentItemName on TaskSearchHitV2 {
  item {
    id
    ...TaskFragmentTaskName
  }
}
    ${TaskFragmentTaskNameFragmentDoc}`;
export const TaskSearchHitFragmentItemThumbnailFragmentDoc = gql`
    fragment TaskSearchHitFragmentItemThumbnail on TaskSearchHitV2 {
  item {
    id
  }
}
    `;
export const TaskSearchHitFragmentItemSuffixFragmentDoc = gql`
    fragment TaskSearchHitFragmentItemSuffix on TaskSearchHitV2 {
  item {
    id
  }
}
    `;
export const TaskSearchHitFragmentListItemViewFragmentDoc = gql`
    fragment TaskSearchHitFragmentListItemView on TaskSearchHitV2 {
  score
  ...TaskSearchHitFragmentSearchType
  ...TaskSearchHitFragmentItemName
  ...TaskSearchHitFragmentItemThumbnail
  ...TaskSearchHitFragmentItemSuffix
}
    ${TaskSearchHitFragmentSearchTypeFragmentDoc}
${TaskSearchHitFragmentItemNameFragmentDoc}
${TaskSearchHitFragmentItemThumbnailFragmentDoc}
${TaskSearchHitFragmentItemSuffixFragmentDoc}`;
export const TaskSearchResultFragmentSectionViewFragmentDoc = gql`
    fragment TaskSearchResultFragmentSectionView on TaskSearchResult {
  totalCount
  hits {
    ...TaskSearchHitFragmentListItemView
  }
}
    ${TaskSearchHitFragmentListItemViewFragmentDoc}`;
export const CollectionSearchHitFragmentSearchTypeFragmentDoc = gql`
    fragment CollectionSearchHitFragmentSearchType on CollectionSearchHit {
  type
}
    `;
export const CollectionSearchHitFragmentItemNameFragmentDoc = gql`
    fragment CollectionSearchHitFragmentItemName on CollectionSearchHit {
  item {
    id
    ...CollectionFragmentCollectionBreadcrumbs
  }
}
    ${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;
export const CollectionSearchHitFragmentItemThumbnailFragmentDoc = gql`
    fragment CollectionSearchHitFragmentItemThumbnail on CollectionSearchHit {
  item {
    id
  }
}
    `;
export const CollectionSearchHitFragmentItemSuffixFragmentDoc = gql`
    fragment CollectionSearchHitFragmentItemSuffix on CollectionSearchHit {
  item {
    id
    posts {
      id
      urlMetadata {
        id
        url
      }
    }
  }
}
    `;
export const CollectionSearchHitFragmentListItemViewFragmentDoc = gql`
    fragment CollectionSearchHitFragmentListItemView on CollectionSearchHit {
  score
  ...CollectionSearchHitFragmentSearchType
  ...CollectionSearchHitFragmentItemName
  ...CollectionSearchHitFragmentItemThumbnail
  ...CollectionSearchHitFragmentItemSuffix
}
    ${CollectionSearchHitFragmentSearchTypeFragmentDoc}
${CollectionSearchHitFragmentItemNameFragmentDoc}
${CollectionSearchHitFragmentItemThumbnailFragmentDoc}
${CollectionSearchHitFragmentItemSuffixFragmentDoc}`;
export const CollectionSearchResultFragmentSectionViewFragmentDoc = gql`
    fragment CollectionSearchResultFragmentSectionView on CollectionSearchResult {
  totalCount
  hits {
    ...CollectionSearchHitFragmentListItemView
  }
}
    ${CollectionSearchHitFragmentListItemViewFragmentDoc}`;
export const UniversalSearchFragmentSearchHandlerFragmentDoc = gql`
    fragment UniversalSearchFragmentSearchHandler on UniversalSearchResults {
  noteSearchResult {
    ...NoteSearchResultFragmentSectionView
  }
  linkSearchResult {
    ...LinkSearchResultFragmentSectionView
  }
  attachmentSearchResult {
    ...AttachmentSearchResultFragmentSectionView
  }
  taskSearchResult {
    ...TaskSearchResultFragmentSectionView
  }
  collectionSearchResult {
    ...CollectionSearchResultFragmentSectionView
  }
}
    ${NoteSearchResultFragmentSectionViewFragmentDoc}
${LinkSearchResultFragmentSectionViewFragmentDoc}
${AttachmentSearchResultFragmentSectionViewFragmentDoc}
${TaskSearchResultFragmentSectionViewFragmentDoc}
${CollectionSearchResultFragmentSectionViewFragmentDoc}`;
export const UserProfileFragmentAssigneeListFragmentDoc = gql`
    fragment UserProfileFragmentAssigneeList on UserProfileModel {
  ...UserFragmentAvatarGroup
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const TaskFragmentCreateSubtaskFragmentDoc = gql`
    fragment TaskFragmentCreateSubtask on TaskModel {
  id
  name
  startDate
  endDate
  status
  priority
  taskMembers {
    ...UserProfileFragmentAssigneeList
  }
}
    ${UserProfileFragmentAssigneeListFragmentDoc}`;
export const TaskFragmentCreateNewTaskFragmentDoc = gql`
    fragment TaskFragmentCreateNewTask on TaskModel {
  id
  name
  status
  endDate
  priority
  taskMembers {
    id
    email
    firstName
    lastName
    avatarUrl
  }
}
    `;
export const TaskFragmentCreateTaskModalFragmentDoc = gql`
    fragment TaskFragmentCreateTaskModal on TaskModel {
  id
  ...TaskFragmentCreateNewTask
}
    ${TaskFragmentCreateNewTaskFragmentDoc}`;
export const BrandFragmentForUseBrandSelectorFragmentDoc = gql`
    fragment BrandFragmentForUseBrandSelector on BrandModel {
  id
  name
  generalPermission
  permissionLevel
  competitorAnalysisEnabled
  organizationId
  creators {
    id
    handle
    profilePictureUrl
  }
  inviteMembers {
    id
    permissionLevel
    user {
      id
      email
      ...UserFragmentAvatarGroup
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const UserProfileFragmentUserContextFragmentDoc = gql`
    fragment UserProfileFragmentUserContext on UserProfileModel {
  id
  email
  firstName
  lastName
  avatarUrl
  title
  fields
  role
  externalRole
  createdAt
  role
  externalRole
  isDisabled
  hasBeenApprovedByAdmin
  isInvitedBy {
    id
    firstName
    lastName
    email
    avatarUrl
  }
  organization {
    id
    name
  }
  ...UserFragmentAvatarGroup
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const OrganizationBillingFragmentCollectionPaywallFragmentDoc = gql`
    fragment OrganizationBillingFragmentCollectionPaywall on OrganizationBillingModel {
  id
  hasUsedFreeTrial
  collectionUsageCount
  collectionUsageLimit
}
    `;
export const OrganizationBillingFragmentFileDeliveryFragmentDoc = gql`
    fragment OrganizationBillingFragmentFileDelivery on OrganizationBillingModel {
  id
  fileDeliveryLimitInMb
  hasUsedFreeTrial
}
    `;
export const OrganizationBillingFragmentFileStorageLimitProgressFragmentDoc = gql`
    fragment OrganizationBillingFragmentFileStorageLimitProgress on OrganizationBillingModel {
  id
  fileStorageLimitInMb
  fileStorageUsedInMb
}
    `;
export const OrganizationBillingFragmentOrganizationMemberPaywallFragmentDoc = gql`
    fragment OrganizationBillingFragmentOrganizationMemberPaywall on OrganizationBillingModel {
  id
  hasUsedFreeTrial
  organizationMemberUsage
  organizationMemberLimit
}
    `;
export const OrganizationBillingFragmentGuestPaywallFragmentDoc = gql`
    fragment OrganizationBillingFragmentGuestPaywall on OrganizationBillingModel {
  id
  hasUsedFreeTrial
  guestUsage
  guestLimit
  guestPermission
}
    `;
export const OrganizationBillingFragmentLimitProgressFragmentDoc = gql`
    fragment OrganizationBillingFragmentLimitProgress on OrganizationBillingModel {
  id
  plan
  hasUsedFreeTrial
  subscription {
    status
    trialEnd
    currentPeriodEnd
  }
  ...OrganizationBillingFragmentFileStorageLimitProgress
  ...OrganizationBillingFragmentCollectionPaywall
  ...OrganizationBillingFragmentOrganizationMemberPaywall
  ...OrganizationBillingFragmentGuestPaywall
}
    ${OrganizationBillingFragmentFileStorageLimitProgressFragmentDoc}
${OrganizationBillingFragmentCollectionPaywallFragmentDoc}
${OrganizationBillingFragmentOrganizationMemberPaywallFragmentDoc}
${OrganizationBillingFragmentGuestPaywallFragmentDoc}`;
export const OrganizationBillingFragmentFreeTrialFragmentDoc = gql`
    fragment OrganizationBillingFragmentFreeTrial on OrganizationBillingModel {
  id
  plan
  hasUsedFreeTrial
  highestFreeTrialUsed
  hasSeenFreeTrialEnded
  subscription {
    id
    status
    trialEnd
  }
}
    `;
export const OrganizationBillingFragmentBannerViewFragmentDoc = gql`
    fragment OrganizationBillingFragmentBannerView on OrganizationBillingModel {
  plan
  subscription {
    id
    status
  }
  ...OrganizationBillingFragmentOrganizationMemberPaywall
  ...OrganizationBillingFragmentFreeTrial
}
    ${OrganizationBillingFragmentOrganizationMemberPaywallFragmentDoc}
${OrganizationBillingFragmentFreeTrialFragmentDoc}`;
export const OrganizationBillingFragmentTrendsPaywallFragmentDoc = gql`
    fragment OrganizationBillingFragmentTrendsPaywall on OrganizationBillingModel {
  id
  hasUsedFreeTrial
  trendsEnabled
}
    `;
export const OrganizationBillingFragmentNewPricingFragmentDoc = gql`
    fragment OrganizationBillingFragmentNewPricing on OrganizationBillingModel {
  id
  plan
  hasSeenNewPricing
}
    `;
export const OrganizationBillingFragmentUserContextFragmentDoc = gql`
    fragment OrganizationBillingFragmentUserContext on OrganizationBillingModel {
  id
  organizationId
  billingCustomerId
  aiFeaturesEnabled
  socialListeningEnabled
  requestedAdminToUpgradePlans
  customTrendsEnabled
  brandHoursParseLimit
  hasReachedBrandUsageLimit
  socialListeningHourUsageThresholdAlert {
    emailAlertThresholdPercentage
    dialogAlertThresholdPercentage
  }
  subscription {
    id
    upcomingInvoice {
      periodEnd
      amountDue
    }
  }
  ...OrganizationBillingFragmentCollectionPaywall
  ...OrganizationBillingFragmentFileDelivery
  ...OrganizationBillingFragmentLimitProgress
  ...OrganizationBillingFragmentFreeTrial
  ...OrganizationBillingFragmentGuestPaywall
  ...OrganizationBillingFragmentOrganizationMemberPaywall
  ...OrganizationBillingFragmentBannerView
  ...OrganizationBillingFragmentTrendsPaywall
  ...OrganizationBillingFragmentNewPricing
}
    ${OrganizationBillingFragmentCollectionPaywallFragmentDoc}
${OrganizationBillingFragmentFileDeliveryFragmentDoc}
${OrganizationBillingFragmentLimitProgressFragmentDoc}
${OrganizationBillingFragmentFreeTrialFragmentDoc}
${OrganizationBillingFragmentGuestPaywallFragmentDoc}
${OrganizationBillingFragmentOrganizationMemberPaywallFragmentDoc}
${OrganizationBillingFragmentBannerViewFragmentDoc}
${OrganizationBillingFragmentTrendsPaywallFragmentDoc}
${OrganizationBillingFragmentNewPricingFragmentDoc}`;
export const SocialAuthorFragmentUserContextFragmentDoc = gql`
    fragment SocialAuthorFragmentUserContext on SocialAuthorModel {
  id
  name
  profileUrl
  avatarUrl
  platform
  platformHandle
}
    `;
export const OrganizationFragmentUserContextFragmentDoc = gql`
    fragment OrganizationFragmentUserContext on OrganizationModel {
  id
  name
  domain
  myPermissions
  type
  users {
    ...UserProfileFragmentUserContext
  }
  externalUsers {
    ...UserProfileFragmentUserContext
  }
  myPermissions
  billing {
    ...OrganizationBillingFragmentUserContext
  }
  socialAuthors {
    id
    ...SocialAuthorFragmentUserContext
  }
}
    ${UserProfileFragmentUserContextFragmentDoc}
${OrganizationBillingFragmentUserContextFragmentDoc}
${SocialAuthorFragmentUserContextFragmentDoc}`;
export const MeFragmentUserQueriesFragmentDoc = gql`
    fragment MeFragmentUserQueries on MeModel {
  id
  createdAt
  email
  firstName
  lastName
  phoneNumber
  avatarUrl
  fields
  role
  title
  cohorts
  hasBeenApprovedByAdmin
  onboardingState {
    haveSeenJuiceBoxIntro
    haveClickedJuiceBoxBtn
    haveOnboardedAiOrganize
    haveSeenTrialWrapped
    hasSeenContentCalendarIntroduction
    hasSeenContentCalendarOnboarding
    hasSeenSLCommunityIntroduction
  }
  socialListeningBrands {
    ...BrandFragmentForUseBrandSelector
  }
  onboardingAnswers {
    referralSource
  }
  organization {
    socialListeningBrands {
      id
      name
    }
    settings {
      restrictedAccessForUser
    }
    ...OrganizationFragmentUserContext
  }
  joinedOrganizations {
    id
    name
    internalRole
    externalRole
    billing {
      ...OrganizationBillingFragmentUserContext
    }
  }
  uploadToken {
    secureExpire
    secureSignature
  }
  registrationMethod
  hasVerifiedEmail
  emailVerificationToken
  taskCreatedCount
  postCreatedCount
  plan
  invitedByOrganization {
    id
    name
  }
  invitedByUser {
    id
    email
  }
  personalSettings {
    postGeneralPermissionDefault
    postGeneralPermissionDefaultPermissionLevel
    collectionGeneralPermissionDefault
    collectionGeneralPermissionDefaultPermissionLevel
  }
  logoutUrl
}
    ${BrandFragmentForUseBrandSelectorFragmentDoc}
${OrganizationFragmentUserContextFragmentDoc}
${OrganizationBillingFragmentUserContextFragmentDoc}`;
export const AuthFragmentUserContextFragmentDoc = gql`
    fragment AuthFragmentUserContext on AuthModel {
  accessToken
  refreshToken
  user {
    id
    role
  }
  isSignUp
}
    `;
export const OrganizationUserAccessRequestFragmentAccessRequestHandlersFragmentDoc = gql`
    fragment OrganizationUserAccessRequestFragmentAccessRequestHandlers on OrganizationUserAccessRequestModel {
  id
  message
  status
  user {
    id
    hasBeenApprovedByAdmin
  }
}
    `;
export const UserFragmentAccessRequestAdminListFragmentDoc = gql`
    fragment UserFragmentAccessRequestAdminList on UserProfileModel {
  ...UserFragmentAvatarGroup
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const OrganizationFragmentAccessRequestCreateViewFragmentDoc = gql`
    fragment OrganizationFragmentAccessRequestCreateView on OrganizationModel {
  id
  name
  users {
    role
    hasBeenApprovedByAdmin
    ...UserFragmentAccessRequestAdminList
  }
}
    ${UserFragmentAccessRequestAdminListFragmentDoc}`;
export const PostFragmentCollectionCardCompactViewFragmentDoc = gql`
    fragment PostFragmentCollectionCardCompactView on PostModel {
  id
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const CollectionFragmentCollectionCardCompactViewFragmentDoc = gql`
    fragment CollectionFragmentCollectionCardCompactView on CollectionModel {
  id
  name
  posts(postCount: 1) {
    id
    ...PostFragmentCollectionCardCompactView
  }
}
    ${PostFragmentCollectionCardCompactViewFragmentDoc}`;
export const CollectionFragmentCollectionListItemViewFragmentDoc = gql`
    fragment CollectionFragmentCollectionListItemView on CollectionModel {
  id
  name
  ...CollectionFragmentCollectionPermissionSummary
  ...CollectionFragmentCollectionThumbnail
  ...CollectionFragmentCollectionSavedToContentCalendar
}
    ${CollectionFragmentCollectionPermissionSummaryFragmentDoc}
${CollectionFragmentCollectionThumbnailFragmentDoc}
${CollectionFragmentCollectionSavedToContentCalendarFragmentDoc}`;
export const CollectionFragmentCollectionPeekingCardViewFragmentDoc = gql`
    fragment CollectionFragmentCollectionPeekingCardView on CollectionModel {
  id
  name
  childCollections {
    id
    parentCollectionId
    ...CollectionFragmentCollectionCardCompactView
    ...CollectionFragmentCollectionPermissionSummary
  }
  ...CollectionFragmentCollectionListItemView
  ...CollectionFragmentCollectionPermissionSummary
}
    ${CollectionFragmentCollectionCardCompactViewFragmentDoc}
${CollectionFragmentCollectionPermissionSummaryFragmentDoc}
${CollectionFragmentCollectionListItemViewFragmentDoc}`;
export const CollectionFragmentAiOrganizeCollectionListFragmentDoc = gql`
    fragment CollectionFragmentAiOrganizeCollectionList on CollectionModel {
  id
  name
  parentCollection {
    id
    name
  }
  ...CollectionFragmentCollectionPeekingCardView
}
    ${CollectionFragmentCollectionPeekingCardViewFragmentDoc}`;
export const OrganizationBillingFragmentAiOrganizePaywallFragmentDoc = gql`
    fragment OrganizationBillingFragmentAiOrganizePaywall on OrganizationBillingModel {
  id
  hasUsedFreeTrial
  aiFeaturesEnabled
}
    `;
export const PostFragmentBillingAiOrganizePaywallFragmentDoc = gql`
    fragment PostFragmentBillingAiOrganizePaywall on PostModel {
  id
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const BrandFragmentForBookmarkSidebarItemFragmentDoc = gql`
    fragment BrandFragmentForBookmarkSidebarItem on BrandModel {
  id
  name
  creators {
    id
    profilePictureUrl
  }
}
    `;
export const BookmarkFragmentForBookmarkSidebarItemFragmentDoc = gql`
    fragment BookmarkFragmentForBookmarkSidebarItem on BookmarkModel {
  id
  type
  collection {
    id
    name
    parentCollection {
      id
      name
    }
  }
  brand {
    ...BrandFragmentForBookmarkSidebarItem
  }
  competitor {
    id
    name
    forBrand {
      ...BrandFragmentForBookmarkSidebarItem
    }
  }
  topic {
    id
    name
    brand {
      ...BrandFragmentForBookmarkSidebarItem
    }
  }
}
    ${BrandFragmentForBookmarkSidebarItemFragmentDoc}`;
export const BookmarkFragmentForBookmarkHandlersFragmentDoc = gql`
    fragment BookmarkFragmentForBookmarkHandlers on BookmarkModel {
  ...BookmarkFragmentForBookmarkSidebarItem
}
    ${BookmarkFragmentForBookmarkSidebarItemFragmentDoc}`;
export const BrandFragmentBrandPauseContextMenuFragmentDoc = gql`
    fragment BrandFragmentBrandPauseContextMenu on BrandModel {
  id
  status
  resetOnNextCycle
}
    `;
export const BrandFragmentBrandContentFilterSettingsDialogViewFragmentDoc = gql`
    fragment BrandFragmentBrandContentFilterSettingsDialogView on BrandModel {
  id
  name
  creators {
    id
    profilePictureUrl
  }
}
    `;
export const BrandFragmentBrandMoreContextMenuFragmentDoc = gql`
    fragment BrandFragmentBrandMoreContextMenu on BrandModel {
  id
  ...BrandFragmentBrandContentFilterSettingsDialogView
}
    ${BrandFragmentBrandContentFilterSettingsDialogViewFragmentDoc}`;
export const TopicFragmentTopicPauseContextMenuFragmentDoc = gql`
    fragment TopicFragmentTopicPauseContextMenu on TopicModel {
  id
  status
  resetOnNextCycle
}
    `;
export const TopicFragmentTopicContentFilterSettingsDialogViewFragmentDoc = gql`
    fragment TopicFragmentTopicContentFilterSettingsDialogView on TopicModel {
  id
  name
  brand {
    id
    creators {
      id
      profilePictureUrl
    }
  }
}
    `;
export const TopicFragmentTopicMoreContextMenuFragmentDoc = gql`
    fragment TopicFragmentTopicMoreContextMenu on TopicModel {
  id
  type
  isBookmarked
  ...TopicFragmentTopicContentFilterSettingsDialogView
}
    ${TopicFragmentTopicContentFilterSettingsDialogViewFragmentDoc}`;
export const TopicFragmentTopicLabelFragmentDoc = gql`
    fragment TopicFragmentTopicLabel on TopicModel {
  id
  type
}
    `;
export const AggregatedBrandDurationUsageFragmentBrandTableRowFragmentDoc = gql`
    fragment AggregatedBrandDurationUsageFragmentBrandTableRow on AggregatedBrandDurationUsageResult {
  durationUsed
  totalParsedPostsCount
  totalPositivelyParsedPostsCount
  brand {
    id
    name
    ...BrandFragmentBrandPauseContextMenu
    ...BrandFragmentBrandMoreContextMenu
    creators {
      id
      profilePictureUrl
    }
  }
  topics {
    topic {
      id
      name
      ...TopicFragmentTopicPauseContextMenu
      ...TopicFragmentTopicMoreContextMenu
      ...TopicFragmentTopicLabel
    }
    durationUsed
    totalParsedPostsCount
    totalPositivelyParsedPostsCount
  }
}
    ${BrandFragmentBrandPauseContextMenuFragmentDoc}
${BrandFragmentBrandMoreContextMenuFragmentDoc}
${TopicFragmentTopicPauseContextMenuFragmentDoc}
${TopicFragmentTopicMoreContextMenuFragmentDoc}
${TopicFragmentTopicLabelFragmentDoc}`;
export const BrandFragmentBrandContentFilterSettingsViewFragmentDoc = gql`
    fragment BrandFragmentBrandContentFilterSettingsView on BrandModel {
  id
  minimumProcessingRules {
    field
    operator
    value
    platform
    condition
    excludedKeywords
    rules {
      field
      operator
      value
      platform
      condition
      excludedKeywords
    }
  }
}
    `;
export const BrandFragmentBrandParsingSettingsViewFragmentDoc = gql`
    fragment BrandFragmentBrandParsingSettingsView on BrandModel {
  id
  parsingSettings {
    Instagram {
      enabled
      types {
        Photo
        Video
        Carousel
      }
    }
    Tiktok {
      enabled
    }
    Youtube {
      enabled
    }
  }
}
    `;
export const CreatorFragmentCreatorHandleChipFragmentDoc = gql`
    fragment CreatorFragmentCreatorHandleChip on CreatorModel {
  id
  handle
  platform
}
    `;
export const CompetitorFragmentBrandCompetitorInfoFragmentDoc = gql`
    fragment CompetitorFragmentBrandCompetitorInfo on CompetitorModel {
  id
  trackingBrand {
    id
    name
    creators {
      id
      profilePictureUrl
      ...CreatorFragmentCreatorHandleChip
    }
  }
}
    ${CreatorFragmentCreatorHandleChipFragmentDoc}`;
export const OrganizationSocialPostCommentLabelFragmentCommentInsightsFiltersFragmentDoc = gql`
    fragment OrganizationSocialPostCommentLabelFragmentCommentInsightsFilters on OrganizationSocialPostCommentLabelModel {
  id
  organizationId
  label
}
    `;
export const SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc = gql`
    fragment SocialPostFragmentUseSocialListeningPostLinkGenerator on SocialPostModel {
  id
  platformId
  platform
  expiresAt
  creator {
    id
    handle
  }
}
    `;
export const SocialPostFragmentLinkTableCellFragmentDoc = gql`
    fragment SocialPostFragmentLinkTableCell on SocialPostModel {
  ...SocialPostFragmentUseSocialListeningPostLinkGenerator
}
    ${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}`;
export const SocialPostFragmentSocialPostPlatformFragmentDoc = gql`
    fragment SocialPostFragmentSocialPostPlatform on SocialPostModel {
  id
  platform
}
    `;
export const SocialPostFragmentSocialPostThumbnailFragmentDoc = gql`
    fragment SocialPostFragmentSocialPostThumbnail on SocialPostModel {
  id
  videoUrl
  thumbnailUrl
  platformCreateTime
  ...SocialPostFragmentSocialPostPlatform
  ...SocialPostFragmentUseSocialListeningPostLinkGenerator
}
    ${SocialPostFragmentSocialPostPlatformFragmentDoc}
${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}`;
export const SocialPostCommentFragmentCommentInsightsTableFragmentDoc = gql`
    fragment SocialPostCommentFragmentCommentInsightsTable on SocialPostCommentModel {
  id
  text
  enrichedComment
  commentEngagement
  socialPost {
    id
    thumbnailUrl
    engagementRate
    ...SocialPostFragmentLinkTableCell
    socialPostEngagementSuggestions(brandId: $brandId) {
      id
      topic {
        id
        type
        name
        brandId
      }
    }
    ...SocialPostFragmentSocialPostThumbnail
  }
  parentSocialPostComment {
    id
    text
  }
  categoryName
  organizationSocialPostCommentLabels {
    id
    organizationId
    label
  }
}
    ${SocialPostFragmentLinkTableCellFragmentDoc}
${SocialPostFragmentSocialPostThumbnailFragmentDoc}`;
export const TopicFragmentTopicInfoTableCellFragmentDoc = gql`
    fragment TopicFragmentTopicInfoTableCell on TopicModel {
  id
  name
  brandId
  ...TopicFragmentTopicLabel
}
    ${TopicFragmentTopicLabelFragmentDoc}`;
export const ClaimMetricFragmentCompetitorSentimentThemesFragmentDoc = gql`
    fragment ClaimMetricFragmentCompetitorSentimentThemes on ClaimMetric {
  attribute
  numberOfMentions
}
    `;
export const CreatorFragmentCreatorAvatarWithNameViewFragmentDoc = gql`
    fragment CreatorFragmentCreatorAvatarWithNameView on CreatorModel {
  id
  nickName
  handle
  platform
  profilePictureUrl
}
    `;
export const CreatorProfileFragmentSocialMediaListeningCreatorProfileFragmentDoc = gql`
    fragment CreatorProfileFragmentSocialMediaListeningCreatorProfile on CreatorModel {
  audience_demographics
  createdAt
  engagementRate
  followerCount
  followingCount
  handle
  id
  industry
  likeCount
  nickName
  platform
  platformId
  profilePictureUrl
  signature
  updatedAt
  videoCount
}
    `;
export const CreatorFragmentCompetitorTopCreatorsFragmentDoc = gql`
    fragment CreatorFragmentCompetitorTopCreators on CreatorModel {
  ...CreatorFragmentCreatorAvatarWithNameView
  ...CreatorProfileFragmentSocialMediaListeningCreatorProfile
}
    ${CreatorFragmentCreatorAvatarWithNameViewFragmentDoc}
${CreatorProfileFragmentSocialMediaListeningCreatorProfileFragmentDoc}`;
export const BrandFragmentBrandCreatorPostsFragmentDoc = gql`
    fragment BrandFragmentBrandCreatorPosts on BrandModel {
  id
  name
}
    `;
export const BrandFragmentForCompetitorTopCreatorsFragmentDoc = gql`
    fragment BrandFragmentForCompetitorTopCreators on BrandModel {
  ...BrandFragmentBrandCreatorPosts
}
    ${BrandFragmentBrandCreatorPostsFragmentDoc}`;
export const HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtagsFragmentDoc = gql`
    fragment HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtags on HashtagUsedForCompetitorModel {
  isHidden
  name
  numberOfTimesUsed
  averageEngagementRate
}
    `;
export const BrandFragmentForCompetitorTopHashtagsFragmentDoc = gql`
    fragment BrandFragmentForCompetitorTopHashtags on BrandModel {
  ...BrandFragmentBrandCreatorPosts
}
    ${BrandFragmentBrandCreatorPostsFragmentDoc}`;
export const OrganizationSocialPostCommentLabelFragmentEditCompetitorLabelsFragmentDoc = gql`
    fragment OrganizationSocialPostCommentLabelFragmentEditCompetitorLabels on OrganizationSocialPostCommentLabelModel {
  id
  organizationId
  label
}
    `;
export const CreatorFragmentBrandCreatorPostsFragmentDoc = gql`
    fragment CreatorFragmentBrandCreatorPosts on CreatorModel {
  id
  platform
  handle
  nickName
  profilePictureUrl
  followerCount
}
    `;
export const BrandFragmentBrandHashtagPostsFragmentDoc = gql`
    fragment BrandFragmentBrandHashtagPosts on BrandModel {
  id
  name
}
    `;
export const CreatorFragmentCreatorAvatarFragmentDoc = gql`
    fragment CreatorFragmentCreatorAvatar on CreatorModel {
  id
  platform
  handle
  profilePictureUrl
}
    `;
export const BrandFragmentBrandCompetitorsShareOfVoiceSocialPostsDialogFragmentDoc = gql`
    fragment BrandFragmentBrandCompetitorsShareOfVoiceSocialPostsDialog on BrandModel {
  id
  name
  creators {
    id
    ...CreatorFragmentCreatorAvatar
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;
export const CompetitorShareOfVoiceAggregatedDataItemFragmentBcShareOfVoiceTableFragmentDoc = gql`
    fragment CompetitorShareOfVoiceAggregatedDataItemFragmentBCShareOfVoiceTable on CompetitorShareOfVoiceAggregatedDataItem {
  id
  base {
    id
    brand {
      id
      name
      creators {
        id
        ...CreatorFragmentCreatorAvatar
      }
    }
    competitor {
      id
      name
    }
    previewPosts(filters: $previewPostsFilters) {
      id
      thumbnailUrl
      videoUrl
    }
  }
  aggregatedData {
    shareOfVoice
    mentionCount
    viewCount
    totalEngagement
    engagementRate
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;
export const CollectionFragmentCollectionViewersFragmentDoc = gql`
    fragment CollectionFragmentCollectionViewers on CollectionModel {
  id
  viewers {
    lastSeen
    user {
      ...UserFragmentAvatarGroup
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const PostFragmentCollectionCreateFormFragmentDoc = gql`
    fragment PostFragmentCollectionCreateForm on PostModel {
  id
  ...PostFragmentCollectionMultiPostPreview
}
    ${PostFragmentCollectionMultiPostPreviewFragmentDoc}`;
export const CollectionFragmentSimilarCollectionListFragmentDoc = gql`
    fragment CollectionFragmentSimilarCollectionList on CollectionModel {
  id
  ...CollectionFragmentCollectionListItemView
  ...CollectionFragmentCollectionPeekingCardView
}
    ${CollectionFragmentCollectionListItemViewFragmentDoc}
${CollectionFragmentCollectionPeekingCardViewFragmentDoc}`;
export const PostFragmentCollectionSendToCollectionFormFragmentDoc = gql`
    fragment PostFragmentCollectionSendToCollectionForm on PostModel {
  id
  ...PostFragmentPostCommand
}
    ${PostFragmentPostCommandFragmentDoc}`;
export const CollectionFragmentCollectionMenuItemViewFragmentDoc = gql`
    fragment CollectionFragmentCollectionMenuItemView on CollectionModel {
  id
  myPermissions
  ...CollectionFragmentCollectionListItemView
  ...CollectionFragmentCollectionBreadcrumbs
  ...CollectionFragmentCollectionSavedToContentCalendar
}
    ${CollectionFragmentCollectionListItemViewFragmentDoc}
${CollectionFragmentCollectionBreadcrumbsFragmentDoc}
${CollectionFragmentCollectionSavedToContentCalendarFragmentDoc}`;
export const CollectionFragmentUseAutocompleteInfiniteCollectionsFragmentDoc = gql`
    fragment CollectionFragmentUseAutocompleteInfiniteCollections on CollectionModel {
  id
  myPermissions
  ...CollectionFragmentCollectionMenuItemView
  ...CollectionFragmentCollectionBreadcrumbs
}
    ${CollectionFragmentCollectionMenuItemViewFragmentDoc}
${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;
export const CollectionFragmentMoveToAnotherCollectionCollectionsListFragmentDoc = gql`
    fragment CollectionFragmentMoveToAnotherCollectionCollectionsList on CollectionModel {
  id
  name
  ...CollectionFragmentCollectionThumbnail
  ...CollectionFragmentCollectionBreadcrumbs
  ...CollectionFragmentCollectionPermissionSummary
  ...CollectionFragmentCollectionMultiPostPreview
}
    ${CollectionFragmentCollectionThumbnailFragmentDoc}
${CollectionFragmentCollectionBreadcrumbsFragmentDoc}
${CollectionFragmentCollectionPermissionSummaryFragmentDoc}
${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}`;
export const PostFragmentCollectionCreateFromSmartSearchResultDialogViewFragmentDoc = gql`
    fragment PostFragmentCollectionCreateFromSmartSearchResultDialogView on PostModel {
  id
  ...PostFragmentCollectionPostDndPostCard
}
    ${PostFragmentCollectionPostDndPostCardFragmentDoc}`;
export const PostFragmentCollectionListItemViewFragmentDoc = gql`
    fragment PostFragmentCollectionListItemView on PostModel {
  id
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const CollectionFragmentCollectionAutocompleteMenuFragmentDoc = gql`
    fragment CollectionFragmentCollectionAutocompleteMenu on CollectionModel {
  id
  ...CollectionFragmentCollectionMenuItemView
}
    ${CollectionFragmentCollectionMenuItemViewFragmentDoc}`;
export const CollectionFragmentMoveToAnotherCollectionFragmentDoc = gql`
    fragment CollectionFragmentMoveToAnotherCollection on CollectionModel {
  ...CollectionFragmentCollectionCardView
  ...CollectionFragmentCollectionBreadcrumbs
  ...CollectionFragmentCollectionThumbnail
  ...CollectionFragmentCollectionPermissionSummary
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}
${CollectionFragmentCollectionBreadcrumbsFragmentDoc}
${CollectionFragmentCollectionThumbnailFragmentDoc}
${CollectionFragmentCollectionPermissionSummaryFragmentDoc}`;
export const CollectionFragmentCollectionPermissionCollectionTreeFragmentDoc = gql`
    fragment CollectionFragmentCollectionPermissionCollectionTree on CollectionModel {
  id
  name
  myPermissions
  ...CollectionFragmentCollectionPermissionSummary
}
    ${CollectionFragmentCollectionPermissionSummaryFragmentDoc}`;
export const PostFragmentCollectionPermissionCollectionTreeFragmentDoc = gql`
    fragment PostFragmentCollectionPermissionCollectionTree on PostModel {
  id
  attachment {
    name
  }
  ...PostFragmentCollectionPostDndPostCard
  ...PostFragmentPostPermissionSummary
}
    ${PostFragmentCollectionPostDndPostCardFragmentDoc}
${PostFragmentPostPermissionSummaryFragmentDoc}`;
export const PermissionRequestFragmentPermissionApproveRequestFragmentDoc = gql`
    fragment PermissionRequestFragmentPermissionApproveRequest on PermissionRequestModel {
  id
  note
  status
  user {
    organization {
      id
    }
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const CollectionFragmentCollectionPermissionDialogBodyFragmentDoc = gql`
    fragment CollectionFragmentCollectionPermissionDialogBody on CollectionModel {
  id
  name
  myPermissions
  generalPermission
  permissionLevel
  organizationId
  organizationName
  myPermissions
  permissionRequests {
    ...PermissionRequestFragmentPermissionApproveRequest
  }
  creator {
    ...UserProfileFragmentUserProfilePermissionItemView
  }
  inviteMembers {
    ...CollectionInviteMemberFragmentCollectionPermissionMember
  }
  childCollections {
    id
  }
  posts(postCount: 3) {
    id
  }
}
    ${PermissionRequestFragmentPermissionApproveRequestFragmentDoc}
${UserProfileFragmentUserProfilePermissionItemViewFragmentDoc}
${CollectionInviteMemberFragmentCollectionPermissionMemberFragmentDoc}`;
export const CollectionFragmentManyPostsPermissionDialogFragmentDoc = gql`
    fragment CollectionFragmentManyPostsPermissionDialog on CollectionModel {
  id
  name
  generalPermission
  permissionLevel
  organizationId
  organizationName
}
    `;
export const CollectionFragmentCollectionPermissionUpdatesDialogFragmentDoc = gql`
    fragment CollectionFragmentCollectionPermissionUpdatesDialog on CollectionModel {
  id
  name
  generalPermission
  inviteMembers {
    ...CollectionInviteMemberFragmentCollectionPermissionMember
  }
}
    ${CollectionInviteMemberFragmentCollectionPermissionMemberFragmentDoc}`;
export const PostFragmentCollectionPostDndHoveringActionPopupFragmentDoc = gql`
    fragment PostFragmentCollectionPostDndHoveringActionPopup on PostModel {
  id
  myPermissions
  ...PostFragmentCollectionPostDndPostCard
  ...PostFragmentJuiceboxTablePostTableRowWithContextMenu
}
    ${PostFragmentCollectionPostDndPostCardFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowWithContextMenuFragmentDoc}`;
export const CollectionFragmentCollectionCommentViewFragmentDoc = gql`
    fragment CollectionFragmentCollectionCommentView on CollectionModel {
  id
  name
  myPermissions
  parentCollectionId
  ...CollectionFragmentCollectionMultiPostPreview
  ...CollectionFragmentCollectionBreadcrumbs
}
    ${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}
${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;
export const AttachmentFragmentAttachmentPreviewFragmentDoc = gql`
    fragment AttachmentFragmentAttachmentPreview on AttachmentModel {
  id
  url
  name
  metaData {
    mimeType
  }
}
    `;
export const AttachmentFragmentCommentAttachmentListFragmentDoc = gql`
    fragment AttachmentFragmentCommentAttachmentList on AttachmentModel {
  id
  ...AttachmentFragmentAttachmentPreview
}
    ${AttachmentFragmentAttachmentPreviewFragmentDoc}`;
export const CommentFragmentCommentAttachmentListFragmentDoc = gql`
    fragment CommentFragmentCommentAttachmentList on CommentModel {
  id
  attachments {
    id
    ...AttachmentFragmentCommentAttachmentList
  }
}
    ${AttachmentFragmentCommentAttachmentListFragmentDoc}`;
export const CommentFragmentCommentInputFragmentDoc = gql`
    fragment CommentFragmentCommentInput on CommentModel {
  id
  ...CommentFragmentCommentAttachmentList
}
    ${CommentFragmentCommentAttachmentListFragmentDoc}`;
export const CommentFragmentCommentContentViewFragmentDoc = gql`
    fragment CommentFragmentCommentContentView on CommentModel {
  id
  text
  createdAt
  parentThreadId
  createdBy {
    id
    ...UserFragmentAvatarGroup
  }
  userReactions {
    id
    emoji
    userId
    user {
      id
      ...UserFragmentAvatarGroup
    }
  }
  postAnnotation {
    id
    postId
    x
    y
    time
    pageNumber
    noteCommentAnchorId
    noteCommentExtract
  }
  ...CommentFragmentCommentInput
}
    ${UserFragmentAvatarGroupFragmentDoc}
${CommentFragmentCommentInputFragmentDoc}`;
export const CommentFragmentCommentContainerViewFragmentDoc = gql`
    fragment CommentFragmentCommentContainerView on CommentModel {
  id
  isRead
  parentThreadId
  postId
  taskId
  collectionId
  childComments {
    id
    postId
    taskId
    isRead
    parentThreadId
    ...CommentFragmentCommentContentView
  }
  ...CommentFragmentCommentContentView
}
    ${CommentFragmentCommentContentViewFragmentDoc}`;
export const CommentFragmentCollectionCommentViewFragmentDoc = gql`
    fragment CommentFragmentCollectionCommentView on CommentModel {
  id
  ...CommentFragmentCommentContainerView
}
    ${CommentFragmentCommentContainerViewFragmentDoc}`;
export const CommentFragmentCollectionCommentListViewFragmentDoc = gql`
    fragment CommentFragmentCollectionCommentListView on CommentModel {
  id
  ...CommentFragmentCollectionCommentView
}
    ${CommentFragmentCollectionCommentViewFragmentDoc}`;
export const PostFragmentPostIconFragmentDoc = gql`
    fragment PostFragmentPostIcon on PostModel {
  id
  type
  urlMetadata {
    id
    ...URLMetadataFragmentIframely
  }
}
    ${UrlMetadataFragmentIframelyFragmentDoc}`;
export const PostFragmentPostSectionHeaderViewFragmentDoc = gql`
    fragment PostFragmentPostSectionHeaderView on PostModel {
  id
  urlMetadata {
    metadata {
      title
    }
  }
  ...PostFragmentPostPreview
  ...PostFragmentPostIcon
}
    ${PostFragmentPostPreviewFragmentDoc}
${PostFragmentPostIconFragmentDoc}`;
export const PostFragmentPostCommentViewFragmentDoc = gql`
    fragment PostFragmentPostCommentView on PostModel {
  id
  type
  myPermissions
  ...PostFragmentPostSectionHeaderView
}
    ${PostFragmentPostSectionHeaderViewFragmentDoc}`;
export const CommentFragmentPostCommentViewFragmentDoc = gql`
    fragment CommentFragmentPostCommentView on CommentModel {
  id
  ...CommentFragmentCommentContainerView
}
    ${CommentFragmentCommentContainerViewFragmentDoc}`;
export const CommentFragmentPostCommentListViewFragmentDoc = gql`
    fragment CommentFragmentPostCommentListView on CommentModel {
  id
  ...CommentFragmentPostCommentView
}
    ${CommentFragmentPostCommentViewFragmentDoc}`;
export const CommentFragmentTaskCommentListViewFragmentDoc = gql`
    fragment CommentFragmentTaskCommentListView on CommentModel {
  id
  ...CommentFragmentCommentContainerView
}
    ${CommentFragmentCommentContainerViewFragmentDoc}`;
export const CompetitorFragmentCompetitorParsingSettingsViewFragmentDoc = gql`
    fragment CompetitorFragmentCompetitorParsingSettingsView on CompetitorModel {
  id
  parsingSettings {
    Instagram {
      enabled
      types {
        Photo
        Video
        Carousel
      }
    }
    Tiktok {
      enabled
    }
    Youtube {
      enabled
    }
  }
}
    `;
export const CollectionFragmentContentCalendarCollectionMenuItemFragmentDoc = gql`
    fragment CollectionFragmentContentCalendarCollectionMenuItem on CollectionModel {
  id
  ...CollectionFragmentCollectionMenuItemView
}
    ${CollectionFragmentCollectionMenuItemViewFragmentDoc}`;
export const ContentIdeaFieldOptionFragmentContentCalendarFilterFragmentDoc = gql`
    fragment ContentIdeaFieldOptionFragmentContentCalendarFilter on ContentIdeaFieldOptionModel {
  id
  label
  value
  bgcolor
}
    `;
export const ContentIdeaFieldFragmentContentCalendarFilterFragmentDoc = gql`
    fragment ContentIdeaFieldFragmentContentCalendarFilter on ContentIdeaFieldModel {
  id
  name
  icon
  type
  options {
    ...ContentIdeaFieldOptionFragmentContentCalendarFilter
  }
}
    ${ContentIdeaFieldOptionFragmentContentCalendarFilterFragmentDoc}`;
export const CollectionFragmentContentCalendarFilterByCollectionsFragmentDoc = gql`
    fragment CollectionFragmentContentCalendarFilterByCollections on CollectionModel {
  id
  ...CollectionFragmentCollectionMenuItemView
}
    ${CollectionFragmentCollectionMenuItemViewFragmentDoc}`;
export const ContentCalendarViewFragmentContentCalendarViewContextMenuFragmentDoc = gql`
    fragment ContentCalendarViewFragmentContentCalendarViewContextMenu on ContentCalendarViewModel {
  id
  myPermissions
}
    `;
export const ContentCalendarViewFragmentContentCalendarViewListItemViewFragmentDoc = gql`
    fragment ContentCalendarViewFragmentContentCalendarViewListItemView on ContentCalendarViewModel {
  id
  name
  creator {
    id
    firstName
    lastName
  }
  ...ContentCalendarViewFragmentContentCalendarViewContextMenu
}
    ${ContentCalendarViewFragmentContentCalendarViewContextMenuFragmentDoc}`;
export const PostFragmentCollectionFieldFragmentDoc = gql`
    fragment PostFragmentCollectionField on PostModel {
  id
  myPermissions
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const CollectionFragmentCollectionFieldFragmentDoc = gql`
    fragment CollectionFragmentCollectionField on CollectionModel {
  id
  posts(includePostsFromChildCollections: false) {
    ...PostFragmentCollectionField
  }
  childCollections {
    id
    ...CollectionFragmentCollectionCardView
  }
}
    ${PostFragmentCollectionFieldFragmentDoc}
${CollectionFragmentCollectionCardViewFragmentDoc}`;
export const ContentIdeaFieldOptionFragmentMultiSelectFieldFragmentDoc = gql`
    fragment ContentIdeaFieldOptionFragmentMultiSelectField on ContentIdeaFieldOptionModel {
  id
  value
  label
  bgcolor
}
    `;
export const ContentIdeaFieldModelFragmentMultiSelectFieldFragmentDoc = gql`
    fragment ContentIdeaFieldModelFragmentMultiSelectField on ContentIdeaFieldModel {
  id
  name
  allowNewOptions
  options {
    ...ContentIdeaFieldOptionFragmentMultiSelectField
  }
}
    ${ContentIdeaFieldOptionFragmentMultiSelectFieldFragmentDoc}`;
export const ContentIdeaFieldOptionFragmentSelectFieldFragmentDoc = gql`
    fragment ContentIdeaFieldOptionFragmentSelectField on ContentIdeaFieldOptionModel {
  id
  value
  label
  bgcolor
}
    `;
export const ContentIdeaFieldModelFragmentSelectFieldFragmentDoc = gql`
    fragment ContentIdeaFieldModelFragmentSelectField on ContentIdeaFieldModel {
  id
  name
  allowNewOptions
  options {
    ...ContentIdeaFieldOptionFragmentSelectField
  }
}
    ${ContentIdeaFieldOptionFragmentSelectFieldFragmentDoc}`;
export const TaskFragmentTaskStatusFragmentDoc = gql`
    fragment TaskFragmentTaskStatus on TaskModel {
  id
  status
}
    `;
export const TaskFragmentTaskAssigneeFragmentDoc = gql`
    fragment TaskFragmentTaskAssignee on TaskModel {
  id
  taskMembers {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const TaskFragmentTaskPriorityComponentFragmentDoc = gql`
    fragment TaskFragmentTaskPriorityComponent on TaskModel {
  id
  priority
}
    `;
export const TaskFragmentTaskDueDateFragmentDoc = gql`
    fragment TaskFragmentTaskDueDate on TaskModel {
  id
  endDate
}
    `;
export const TaskFragmentTaskContextMenuFragmentDoc = gql`
    fragment TaskFragmentTaskContextMenu on TaskModel {
  id
  myPermissions
}
    `;
export const TaskFragmentTaskListItemViewFragmentDoc = gql`
    fragment TaskFragmentTaskListItemView on TaskModel {
  id
  ...TaskFragmentTaskName
  ...TaskFragmentTaskStatus
  ...TaskFragmentTaskAssignee
  ...TaskFragmentTaskPriorityComponent
  ...TaskFragmentTaskDueDate
  ...TaskFragmentTaskContextMenu
}
    ${TaskFragmentTaskNameFragmentDoc}
${TaskFragmentTaskStatusFragmentDoc}
${TaskFragmentTaskAssigneeFragmentDoc}
${TaskFragmentTaskPriorityComponentFragmentDoc}
${TaskFragmentTaskDueDateFragmentDoc}
${TaskFragmentTaskContextMenuFragmentDoc}`;
export const TaskFragmentUseTasksFieldShortcutsFragmentDoc = gql`
    fragment TaskFragmentUseTasksFieldShortcuts on TaskModel {
  id
  parentTaskId
  sortOrder
  ...TaskFragmentTaskListItemView
}
    ${TaskFragmentTaskListItemViewFragmentDoc}`;
export const TaskFragmentTasksFieldFragmentDoc = gql`
    fragment TaskFragmentTasksField on TaskModel {
  ...TaskFragmentTaskListItemView
  ...TaskFragmentUseTasksFieldShortcuts
}
    ${TaskFragmentTaskListItemViewFragmentDoc}
${TaskFragmentUseTasksFieldShortcutsFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaViewersFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaViewers on ContentIdeaModel {
  id
  viewers {
    lastSeen
    user {
      ...UserFragmentAvatarGroup
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const ContentIdeaFieldOptionFragmentContentIdeaFieldOptionHandlersFragmentDoc = gql`
    fragment ContentIdeaFieldOptionFragmentContentIdeaFieldOptionHandlers on ContentIdeaFieldOptionModel {
  id
  value
}
    `;
export const ContentIdeaFragmentContentIdeaPreviewFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaPreview on ContentIdeaModel {
  id
  noteContent
  caption {
    id
    value {
      id
      text
    }
  }
  status {
    id
    value {
      id
      select {
        id
        value
      }
    }
  }
  collection {
    id
  }
  moodboard {
    id
    value {
      id
      collection {
        id
      }
    }
  }
  previewPost {
    id
    post {
      ...PostFragmentPostPreview
    }
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaContextMenuFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaContextMenu on ContentIdeaModel {
  id
  myPermissions
  name
}
    `;
export const ContentIdeaFragmentContentIdeaCalendarEventPublishedViewFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaCalendarEventPublishedView on ContentIdeaModel {
  id
  name
  dueDate {
    id
    value {
      id
      date
    }
  }
  status {
    id
    value {
      id
      select {
        id
        label
        value
        bgcolor
      }
    }
  }
  platforms {
    id
    value {
      id
      multiSelect {
        id
        label
        value
        bgcolor
      }
    }
  }
  pillars {
    id
    value {
      id
      multiSelect {
        id
        label
        value
        bgcolor
      }
    }
  }
  contentIdeaPublishMetadata {
    id
    platform
    publishUrl
    socialAuthor {
      id
      platformHandle
    }
  }
  ...ContentIdeaFragmentContentIdeaPreview
  ...ContentIdeaFragmentContentIdeaContextMenu
}
    ${ContentIdeaFragmentContentIdeaPreviewFragmentDoc}
${ContentIdeaFragmentContentIdeaContextMenuFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaCalendarEventViewFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaCalendarEventView on ContentIdeaModel {
  id
  name
  dueDate {
    id
    value {
      id
      date
    }
  }
  status {
    id
    value {
      id
      select {
        id
        label
        value
        bgcolor
      }
    }
  }
  platforms {
    id
    value {
      id
      multiSelect {
        id
        label
        value
        bgcolor
      }
    }
  }
  pillars {
    id
    value {
      id
      multiSelect {
        id
        label
        value
        bgcolor
      }
    }
  }
  owners {
    id
    value {
      id
      users {
        id
        ...UserFragmentAvatarGroup
      }
    }
  }
  ...ContentIdeaFragmentContentIdeaPreview
  ...ContentIdeaFragmentContentIdeaCalendarEventPublishedView
  ...ContentIdeaFragmentContentIdeaContextMenu
}
    ${UserFragmentAvatarGroupFragmentDoc}
${ContentIdeaFragmentContentIdeaPreviewFragmentDoc}
${ContentIdeaFragmentContentIdeaCalendarEventPublishedViewFragmentDoc}
${ContentIdeaFragmentContentIdeaContextMenuFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaNameFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaName on ContentIdeaModel {
  id
  name
  myPermissions
}
    `;
export const ContentIdeaFieldValueFragmentContentIdeaFieldSelectFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldSelect on ContentIdeaFieldValueModel {
  id
  value {
    id
    select {
      ...ContentIdeaFieldOptionFragmentSelectField
    }
  }
}
    ${ContentIdeaFieldOptionFragmentSelectFieldFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaReminderModalFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaReminderModal on ContentIdeaModel {
  id
  dueDate {
    id
    value {
      id
      date
    }
  }
}
    `;
export const ContentIdeaFragmentContentIdeaStatusFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaStatus on ContentIdeaModel {
  id
  myPermissions
  status {
    id
    contentIdeaField {
      id
    }
    ...ContentIdeaFieldValueFragmentContentIdeaFieldSelect
  }
  ...ContentIdeaFragmentContentIdeaReminderModal
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldSelectFragmentDoc}
${ContentIdeaFragmentContentIdeaReminderModalFragmentDoc}`;
export const ContentIdeaFieldValueFragmentContentIdeaFieldDateFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldDate on ContentIdeaFieldValueModel {
  id
  value {
    id
    date
  }
}
    `;
export const ContentIdeaFragmentContentIdeaDueDateFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaDueDate on ContentIdeaModel {
  id
  myPermissions
  dueDate {
    id
    contentIdeaField {
      id
    }
    ...ContentIdeaFieldValueFragmentContentIdeaFieldDate
  }
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldDateFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaInviteAssigneeUserModalFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaInviteAssigneeUserModal on ContentIdeaModel {
  id
  name
}
    `;
export const ContentIdeaFragmentContentIdeaOwnersFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaOwners on ContentIdeaModel {
  id
  myPermissions
  collection {
    id
    creatorId
    generalPermission
    inviteMembers {
      id
      user {
        id
      }
    }
  }
  owners {
    id
    value {
      id
      users {
        id
        ...UserFragmentAvatarGroup
      }
    }
    contentIdeaField {
      id
    }
  }
  ...ContentIdeaFragmentContentIdeaInviteAssigneeUserModal
}
    ${UserFragmentAvatarGroupFragmentDoc}
${ContentIdeaFragmentContentIdeaInviteAssigneeUserModalFragmentDoc}`;
export const ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelectFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelect on ContentIdeaFieldValueModel {
  id
  value {
    id
    multiSelect {
      ...ContentIdeaFieldOptionFragmentMultiSelectField
    }
  }
}
    ${ContentIdeaFieldOptionFragmentMultiSelectFieldFragmentDoc}`;
export const ContentIdeaPublishMetadataFragmentContentIdeaPlatformsFragmentDoc = gql`
    fragment ContentIdeaPublishMetadataFragmentContentIdeaPlatforms on ContentIdeaPublishMetadataModel {
  id
  platform
  socialAuthor {
    id
    platformHandle
  }
}
    `;
export const ContentIdeaPublishMetadataFragmentContentIdeaPlatformsMenuItemFragmentDoc = gql`
    fragment ContentIdeaPublishMetadataFragmentContentIdeaPlatformsMenuItem on ContentIdeaPublishMetadataModel {
  id
  platform
  socialAuthor {
    id
    platformHandle
  }
}
    `;
export const ContentIdeaFragmentContentIdeaPlatformsMenuItemFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaPlatformsMenuItem on ContentIdeaModel {
  id
  platforms {
    id
    contentIdeaField {
      id
    }
    ...ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelect
  }
  contentIdeaPublishMetadata {
    id
    ...ContentIdeaPublishMetadataFragmentContentIdeaPlatformsMenuItem
  }
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelectFragmentDoc}
${ContentIdeaPublishMetadataFragmentContentIdeaPlatformsMenuItemFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaPlatformsFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaPlatforms on ContentIdeaModel {
  id
  myPermissions
  platforms {
    id
    contentIdeaField {
      id
    }
    ...ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelect
  }
  contentIdeaPublishMetadata {
    id
    ...ContentIdeaPublishMetadataFragmentContentIdeaPlatforms
  }
  ...ContentIdeaFragmentContentIdeaPlatformsMenuItem
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelectFragmentDoc}
${ContentIdeaPublishMetadataFragmentContentIdeaPlatformsFragmentDoc}
${ContentIdeaFragmentContentIdeaPlatformsMenuItemFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaPillarsFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaPillars on ContentIdeaModel {
  id
  myPermissions
  pillars {
    id
    contentIdeaField {
      id
    }
    ...ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelect
  }
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelectFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaCollectionFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaCollection on ContentIdeaModel {
  id
  myPermissions
  rootCollection {
    id
    collection {
      ...CollectionFragmentCollectionBreadcrumbs
    }
  }
}
    ${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;
export const ContentIdeaFieldValueFragmentContentIdeaFieldTextFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldText on ContentIdeaFieldValueModel {
  id
  value {
    id
    text
  }
}
    `;
export const ContentIdeaFragmentContentIdeaCaptionFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaCaption on ContentIdeaModel {
  id
  myPermissions
  caption {
    id
    contentIdeaField {
      id
    }
    ...ContentIdeaFieldValueFragmentContentIdeaFieldText
  }
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldTextFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaAudioFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaAudio on ContentIdeaModel {
  id
  myPermissions
  audio {
    id
    contentIdeaField {
      id
    }
    ...ContentIdeaFieldValueFragmentContentIdeaFieldText
  }
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldTextFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaTableViewFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaTableView on ContentIdeaModel {
  id
  stage
  myPermissions
  pillars {
    id
    value {
      id
      multiSelect {
        bgcolor
      }
    }
  }
  platforms {
    id
    value {
      id
      multiSelect {
        bgcolor
      }
    }
  }
  moodboard {
    id
    value {
      id
      collection {
        id
      }
    }
  }
  draftAssets {
    id
    value {
      id
      collection {
        id
      }
    }
  }
  finalAssets {
    id
    value {
      id
      collection {
        id
      }
    }
  }
  ...ContentIdeaFragmentContentIdeaPreview
  ...ContentIdeaFragmentContentIdeaName
  ...ContentIdeaFragmentContentIdeaStatus
  ...ContentIdeaFragmentContentIdeaDueDate
  ...ContentIdeaFragmentContentIdeaOwners
  ...ContentIdeaFragmentContentIdeaPlatforms
  ...ContentIdeaFragmentContentIdeaPillars
  ...ContentIdeaFragmentContentIdeaCollection
  ...ContentIdeaFragmentContentIdeaCaption
  ...ContentIdeaFragmentContentIdeaAudio
  ...ContentIdeaFragmentContentIdeaContextMenu
}
    ${ContentIdeaFragmentContentIdeaPreviewFragmentDoc}
${ContentIdeaFragmentContentIdeaNameFragmentDoc}
${ContentIdeaFragmentContentIdeaStatusFragmentDoc}
${ContentIdeaFragmentContentIdeaDueDateFragmentDoc}
${ContentIdeaFragmentContentIdeaOwnersFragmentDoc}
${ContentIdeaFragmentContentIdeaPlatformsFragmentDoc}
${ContentIdeaFragmentContentIdeaPillarsFragmentDoc}
${ContentIdeaFragmentContentIdeaCollectionFragmentDoc}
${ContentIdeaFragmentContentIdeaCaptionFragmentDoc}
${ContentIdeaFragmentContentIdeaAudioFragmentDoc}
${ContentIdeaFragmentContentIdeaContextMenuFragmentDoc}`;
export const PostFragmentJuiceboxAttachmentSearchItemFragmentDoc = gql`
    fragment PostFragmentJuiceboxAttachmentSearchItem on PostModel {
  id
  ...PostFragmentPostIcon
  attachment {
    id
    name
    url
    metaData {
      mimeType
    }
  }
}
    ${PostFragmentPostIconFragmentDoc}`;
export const CollectionFragmentJuiceboxCollectionSearchItemFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxCollectionSearchItem on CollectionModel {
  id
  name
  ...CollectionFragmentCollectionBreadcrumbs
}
    ${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;
export const PostFragmentJuiceboxLinkSearchItemFragmentDoc = gql`
    fragment PostFragmentJuiceboxLinkSearchItem on PostModel {
  id
  urlMetadata {
    id
    url
    metadata {
      title
      site
    }
  }
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentJuiceboxNoteSearchItemFragmentDoc = gql`
    fragment PostFragmentJuiceboxNoteSearchItem on PostModel {
  id
  title
  type
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const CollectionFragmentSelectModeFragmentDoc = gql`
    fragment CollectionFragmentSelectMode on CollectionModel {
  id
}
    `;
export const CollectionFragmentJuiceboxSelectContextFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxSelectContext on CollectionModel {
  id
  isPinnedToParent
  isPinnedToRoot
  ...CollectionFragmentSelectMode
}
    ${CollectionFragmentSelectModeFragmentDoc}`;
export const PostFragmentSelectModeFragmentDoc = gql`
    fragment PostFragmentSelectMode on PostModel {
  id
}
    `;
export const PostFragmentJuiceboxSelectContextFragmentDoc = gql`
    fragment PostFragmentJuiceboxSelectContext on PostModel {
  id
  ...PostFragmentSelectMode
  pinnedToCollections {
    id
    parentCollectionId
  }
  isFavorite
  urlMetadata {
    id
    url
    metadata {
      type
      site
      medias {
        type
        url
      }
    }
  }
}
    ${PostFragmentSelectModeFragmentDoc}`;
export const CollectionFragmentJuiceboxCollectionSelectButtonFilterFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxCollectionSelectButtonFilter on CollectionModel {
  id
  ...CollectionFragmentCollectionMenuItemView
}
    ${CollectionFragmentCollectionMenuItemViewFragmentDoc}`;
export const CollectionFragmentJuiceboxTableCollectionTableRowCellSelectIconFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxTableCollectionTableRowCellSelectIcon on CollectionModel {
  id
  isDisabled
}
    `;
export const CollectionFragmentJuiceboxTableCollectionTableRowCellActivityFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxTableCollectionTableRowCellActivity on CollectionModel {
  id
  ...CollectionFragmentCollectionSummary
}
    ${CollectionFragmentCollectionSummaryFragmentDoc}`;
export const CollectionFragmentJuiceboxTableCollectionTableRowCellNameFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxTableCollectionTableRowCellName on CollectionModel {
  id
  isDisabled
  ...CollectionFragmentCollectionName
}
    ${CollectionFragmentCollectionNameFragmentDoc}`;
export const CollectionFragmentJuiceboxTableCollectionTableRowCellPermissionFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxTableCollectionTableRowCellPermission on CollectionModel {
  id
  ...CollectionFragmentCollectionPermissionSummary
}
    ${CollectionFragmentCollectionPermissionSummaryFragmentDoc}`;
export const CollectionFragmentJuiceboxTableCollectionTableRowCellPreviewFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxTableCollectionTableRowCellPreview on CollectionModel {
  id
  isDisabled
  ...CollectionFragmentCollectionMultiPostPreview
}
    ${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}`;
export const CollectionFragmentJuiceboxTableCollectionTableRowFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxTableCollectionTableRow on CollectionModel {
  id
  ...CollectionFragmentJuiceboxTableCollectionTableRowCellSelectIcon
  ...CollectionFragmentJuiceboxTableCollectionTableRowCellActivity
  ...CollectionFragmentJuiceboxTableCollectionTableRowCellName
  ...CollectionFragmentJuiceboxTableCollectionTableRowCellPermission
  ...CollectionFragmentJuiceboxTableCollectionTableRowCellPreview
}
    ${CollectionFragmentJuiceboxTableCollectionTableRowCellSelectIconFragmentDoc}
${CollectionFragmentJuiceboxTableCollectionTableRowCellActivityFragmentDoc}
${CollectionFragmentJuiceboxTableCollectionTableRowCellNameFragmentDoc}
${CollectionFragmentJuiceboxTableCollectionTableRowCellPermissionFragmentDoc}
${CollectionFragmentJuiceboxTableCollectionTableRowCellPreviewFragmentDoc}`;
export const CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragmentDoc = gql`
    fragment CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenu on CollectionModel {
  id
  ...CollectionFragmentJuiceboxTableCollectionTableRow
  ...CollectionFragmentCollectionContextMenu
}
    ${CollectionFragmentJuiceboxTableCollectionTableRowFragmentDoc}
${CollectionFragmentCollectionContextMenuFragmentDoc}`;
export const CollectionFragmentUseCustomCollectionNestedTableDataFragmentDoc = gql`
    fragment CollectionFragmentUseCustomCollectionNestedTableData on CollectionModel {
  id
  name
  myPermissions
  ...CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenu
}
    ${CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragmentDoc}`;
export const PostFragmentUseCustomCollectionNestedTableDataFragmentDoc = gql`
    fragment PostFragmentUseCustomCollectionNestedTableData on PostModel {
  id
  ...PostFragmentJuiceboxTablePostTableRowWithContextMenu
}
    ${PostFragmentJuiceboxTablePostTableRowWithContextMenuFragmentDoc}`;
export const CollectionFragmentUseNormalCollectionNestedTableDataFragmentDoc = gql`
    fragment CollectionFragmentUseNormalCollectionNestedTableData on CollectionModel {
  id
  name
  myPermissions
  ...CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenu
}
    ${CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragmentDoc}`;
export const PostFragmentUseNormalCollectionNestedTableDataFragmentDoc = gql`
    fragment PostFragmentUseNormalCollectionNestedTableData on PostModel {
  id
  ...PostFragmentJuiceboxTablePostTableRowWithContextMenu
}
    ${PostFragmentJuiceboxTablePostTableRowWithContextMenuFragmentDoc}`;
export const ManuallyParsedSocialPostTrackerFragmentMpsptOutboundCommentCardFragmentDoc = gql`
    fragment ManuallyParsedSocialPostTrackerFragmentMPSPTOutboundCommentCard on ManuallyParsedSocialPostTrackerModel {
  id
  createdAt
  socialPost {
    id
    ...SocialPostFragmentSocialPostThumbnail
  }
  parsedByUser {
    id
    ...UserFragmentAvatarGroup
  }
}
    ${SocialPostFragmentSocialPostThumbnailFragmentDoc}
${UserFragmentAvatarGroupFragmentDoc}`;
export const PostFragmentPostMasonryCardViewFragmentDoc = gql`
    fragment PostFragmentPostMasonryCardView on PostModel {
  id
  description
  ...PostFragmentPostPreview
  ...PostFragmentPostUnreadCommentBadge
  ...PostFragmentPostNewBadge
  ...PostFragmentPostContextMenu
  ...PostFragmentPostReactionList
  ...PostFragmentPostCreator
  ...PostFragmentPostPin
  ...PostFragmentPostPermissionSummary
  ...PostFragmentPostTitle
}
    ${PostFragmentPostPreviewFragmentDoc}
${PostFragmentPostUnreadCommentBadgeFragmentDoc}
${PostFragmentPostNewBadgeFragmentDoc}
${PostFragmentPostContextMenuFragmentDoc}
${PostFragmentPostReactionListFragmentDoc}
${PostFragmentPostCreatorFragmentDoc}
${PostFragmentPostPinFragmentDoc}
${PostFragmentPostPermissionSummaryFragmentDoc}
${PostFragmentPostTitleFragmentDoc}`;
export const NotificationFragmentInboxMultiplePostInviteFragmentDoc = gql`
    fragment NotificationFragmentInboxMultiplePostInvite on NotificationModel {
  id
  createdByUser {
    ...UserFragmentAvatarGroup
  }
  posts {
    ...PostFragmentPostMasonryCardView
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}
${PostFragmentPostMasonryCardViewFragmentDoc}`;
export const NotificationFragmentCreatorNameFragmentDoc = gql`
    fragment NotificationFragmentCreatorName on NotificationModel {
  id
  createdByUser {
    id
    firstName
    lastName
    email
  }
}
    `;
export const NotificationFragmentCollectionHeaderFragmentDoc = gql`
    fragment NotificationFragmentCollectionHeader on NotificationModel {
  id
  collection {
    id
    name
  }
}
    `;
export const NotificationFragmentPostHeaderFragmentDoc = gql`
    fragment NotificationFragmentPostHeader on NotificationModel {
  id
  post {
    id
    type
    title
  }
}
    `;
export const NotificationFragmentTaskHeaderFragmentDoc = gql`
    fragment NotificationFragmentTaskHeader on NotificationModel {
  id
  task {
    id
    name
  }
}
    `;
export const NotificationFragmentPermissionRequestHeaderFragmentDoc = gql`
    fragment NotificationFragmentPermissionRequestHeader on NotificationModel {
  id
  permissionRequest {
    id
    postId
    collectionId
    post {
      id
      type
    }
    brand {
      id
      name
    }
  }
}
    `;
export const NotificationFragmentHeaderFragmentDoc = gql`
    fragment NotificationFragmentHeader on NotificationModel {
  id
  type
  ...NotificationFragmentCollectionHeader
  ...NotificationFragmentPostHeader
  ...NotificationFragmentTaskHeader
  ...NotificationFragmentPermissionRequestHeader
}
    ${NotificationFragmentCollectionHeaderFragmentDoc}
${NotificationFragmentPostHeaderFragmentDoc}
${NotificationFragmentTaskHeaderFragmentDoc}
${NotificationFragmentPermissionRequestHeaderFragmentDoc}`;
export const NotificationFragmentPreviewAssetsFragmentDoc = gql`
    fragment NotificationFragmentPreviewAssets on NotificationModel {
  id
  permissionRequest {
    post {
      ...PostFragmentPostPreview
    }
    collection {
      ...CollectionFragmentCollectionMultiPostPreview
    }
  }
  post {
    ...PostFragmentPostPreview
  }
  collection {
    ...CollectionFragmentCollectionMultiPostPreview
  }
  posts {
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}
${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}`;
export const NotificationFragmentUserReactionFragmentDoc = gql`
    fragment NotificationFragmentUserReaction on NotificationModel {
  id
  userReaction {
    id
    emoji
    commentId
  }
}
    `;
export const NotificationFragmentInboxMultiplePostMentionFragmentDoc = gql`
    fragment NotificationFragmentInboxMultiplePostMention on NotificationModel {
  id
  posts {
    id
  }
}
    `;
export const NotificationFragmentAggregatedCardViewFragmentDoc = gql`
    fragment NotificationFragmentAggregatedCardView on NotificationModel {
  id
  type
  status
  createdAt
  data
  organizationUserAccessRequest {
    id
  }
  contentIdea {
    id
  }
  socialPostsNotificationData {
    id
    socialPosts {
      id
    }
  }
  ...NotificationFragmentInboxMultiplePostInvite
  ...NotificationFragmentCreatorName
  ...NotificationFragmentHeader
  ...NotificationFragmentPreviewAssets
  ...NotificationFragmentUserReaction
  ...NotificationFragmentInboxMultiplePostMention
}
    ${NotificationFragmentInboxMultiplePostInviteFragmentDoc}
${NotificationFragmentCreatorNameFragmentDoc}
${NotificationFragmentHeaderFragmentDoc}
${NotificationFragmentPreviewAssetsFragmentDoc}
${NotificationFragmentUserReactionFragmentDoc}
${NotificationFragmentInboxMultiplePostMentionFragmentDoc}`;
export const NotificationFragmentCreatorAvatarFragmentDoc = gql`
    fragment NotificationFragmentCreatorAvatar on NotificationModel {
  id
  createdByUser {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const NotificationFragmentCommentBodyFragmentDoc = gql`
    fragment NotificationFragmentCommentBody on NotificationModel {
  id
  comment {
    id
    text
    parentComment {
      id
      text
    }
  }
}
    `;
export const CreatorFragmentSocialListeningSettingsSocialHandleInputFragmentDoc = gql`
    fragment CreatorFragmentSocialListeningSettingsSocialHandleInput on CreatorModel {
  id
  ...CreatorFragmentCreatorAvatarWithNameView
}
    ${CreatorFragmentCreatorAvatarWithNameViewFragmentDoc}`;
export const NotificationFragmentInviteBodyFragmentDoc = gql`
    fragment NotificationFragmentInviteBody on NotificationModel {
  id
  collection {
    id
    name
  }
  post {
    id
    type
    title
  }
  collectionInviteMember {
    id
    permissionLevel
  }
  postInviteMember {
    id
    permissionLevel
  }
  brandInviteMember {
    id
    __typename
    permissionLevel
    brand {
      id
      name
      creators {
        id
        ...CreatorFragmentSocialListeningSettingsSocialHandleInput
      }
    }
    user {
      id
      firstName
      lastName
      email
      avatarUrl
    }
  }
}
    ${CreatorFragmentSocialListeningSettingsSocialHandleInputFragmentDoc}`;
export const NotificationFragmentTaskBodyFragmentDoc = gql`
    fragment NotificationFragmentTaskBody on NotificationModel {
  id
  task {
    id
    name
  }
}
    `;
export const NotificationFragmentMoreMenuFragmentDoc = gql`
    fragment NotificationFragmentMoreMenu on NotificationModel {
  id
  status
  type
  collection {
    id
  }
  post {
    id
    type
  }
  task {
    id
  }
  organizationUserAccessRequest {
    id
  }
  contentIdea {
    id
  }
  permissionRequest {
    id
    collection {
      id
    }
    post {
      id
      type
    }
  }
  socialPostsNotificationData {
    id
    socialPosts {
      id
    }
  }
}
    `;
export const NotificationFragmentPermissionRequestBodyFragmentDoc = gql`
    fragment NotificationFragmentPermissionRequestBody on NotificationModel {
  id
  createdAt
  permissionRequest {
    id
    user {
      ...UserFragmentAvatarGroup
    }
    brand {
      id
      name
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const NotificationFragmentAssignedToContentIdeaBodyFragmentDoc = gql`
    fragment NotificationFragmentAssignedToContentIdeaBody on NotificationModel {
  id
  createdAt
  contentIdea {
    id
    name
  }
}
    `;
export const NotificationFragmentInvitedToContentIdeaBodyFragmentDoc = gql`
    fragment NotificationFragmentInvitedToContentIdeaBody on NotificationModel {
  id
  createdAt
  contentIdea {
    id
    name
  }
}
    `;
export const NotificationFragmentReminderForContentIdeaBodyFragmentDoc = gql`
    fragment NotificationFragmentReminderForContentIdeaBody on NotificationModel {
  id
  createdAt
  contentIdea {
    id
    name
  }
}
    `;
export const NotificationFragmentNotificationMultiplePostInviteBodyFragmentDoc = gql`
    fragment NotificationFragmentNotificationMultiplePostInviteBody on NotificationModel {
  id
  createdAt
  type
  posts {
    id
  }
  createdByUser {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const NotificationFragmentNotificationSlBrandReachedUsageLimitBodyFragmentDoc = gql`
    fragment NotificationFragmentNotificationSLBrandReachedUsageLimitBody on NotificationModel {
  id
  type
  data
  createdAt
}
    `;
export const NotificationFragmentNotificationMultiplePostMentionBodyFragmentDoc = gql`
    fragment NotificationFragmentNotificationMultiplePostMentionBody on NotificationModel {
  id
  createdAt
  type
  posts {
    id
  }
  data
  createdByUser {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const NotificationFragmentCardViewFragmentDoc = gql`
    fragment NotificationFragmentCardView on NotificationModel {
  id
  type
  status
  createdAt
  data
  socialPostsNotificationData {
    id
    socialPosts {
      id
    }
  }
  ...NotificationFragmentCreatorAvatar
  ...NotificationFragmentCreatorName
  ...NotificationFragmentHeader
  ...NotificationFragmentCommentBody
  ...NotificationFragmentInviteBody
  ...NotificationFragmentTaskBody
  ...NotificationFragmentPreviewAssets
  ...NotificationFragmentUserReaction
  ...NotificationFragmentMoreMenu
  ...NotificationFragmentPermissionRequestBody
  ...NotificationFragmentAssignedToContentIdeaBody
  ...NotificationFragmentInvitedToContentIdeaBody
  ...NotificationFragmentReminderForContentIdeaBody
  ...NotificationFragmentNotificationMultiplePostInviteBody
  ...NotificationFragmentInboxMultiplePostInvite
  ...NotificationFragmentNotificationSLBrandReachedUsageLimitBody
  ...NotificationFragmentNotificationMultiplePostMentionBody
  ...NotificationFragmentInboxMultiplePostMention
}
    ${NotificationFragmentCreatorAvatarFragmentDoc}
${NotificationFragmentCreatorNameFragmentDoc}
${NotificationFragmentHeaderFragmentDoc}
${NotificationFragmentCommentBodyFragmentDoc}
${NotificationFragmentInviteBodyFragmentDoc}
${NotificationFragmentTaskBodyFragmentDoc}
${NotificationFragmentPreviewAssetsFragmentDoc}
${NotificationFragmentUserReactionFragmentDoc}
${NotificationFragmentMoreMenuFragmentDoc}
${NotificationFragmentPermissionRequestBodyFragmentDoc}
${NotificationFragmentAssignedToContentIdeaBodyFragmentDoc}
${NotificationFragmentInvitedToContentIdeaBodyFragmentDoc}
${NotificationFragmentReminderForContentIdeaBodyFragmentDoc}
${NotificationFragmentNotificationMultiplePostInviteBodyFragmentDoc}
${NotificationFragmentInboxMultiplePostInviteFragmentDoc}
${NotificationFragmentNotificationSlBrandReachedUsageLimitBodyFragmentDoc}
${NotificationFragmentNotificationMultiplePostMentionBodyFragmentDoc}
${NotificationFragmentInboxMultiplePostMentionFragmentDoc}`;
export const PostFragmentPostQueryForOnboardingPostCardFragmentDoc = gql`
    fragment PostFragmentPostQueryForOnboardingPostCard on PostModel {
  id
  collections {
    id
  }
  creator {
    ...UserFragmentAvatarGroup
  }
  ...PostFragmentPostPreview
}
    ${UserFragmentAvatarGroupFragmentDoc}
${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentOnboardingPostNoteCardFragmentDoc = gql`
    fragment PostFragmentOnboardingPostNoteCard on PostModel {
  ...PostFragmentPostQueryForOnboardingPostCard
}
    ${PostFragmentPostQueryForOnboardingPostCardFragmentDoc}`;
export const OrganizationProfileFragmentOrganizationAvatarWithNameFragmentDoc = gql`
    fragment OrganizationProfileFragmentOrganizationAvatarWithName on OrganizationProfileModel {
  id
  name
  users {
    id
  }
}
    `;
export const PermittedCollectionFragmentOrganizationMembersPermittedCollectionListItemFragmentDoc = gql`
    fragment PermittedCollectionFragmentOrganizationMembersPermittedCollectionListItem on PermittedCollectionModel {
  id
  permissionLevel
  collection {
    id
    name
  }
}
    `;
export const UserFragmentUseOrgMemberManagementFragmentDoc = gql`
    fragment UserFragmentUseOrgMemberManagement on UserProfileModel {
  id
  firstName
  lastName
  email
  avatarUrl
}
    `;
export const UserFragmentAddUsersToOrgViewManageUsersListFragmentDoc = gql`
    fragment UserFragmentAddUsersToOrgViewManageUsersList on UserProfileModel {
  id
  firstName
  lastName
  email
  avatarUrl
}
    `;
export const UserFragmentAddUsersToOrgViewMemberUserRoleSelectionFragmentDoc = gql`
    fragment UserFragmentAddUsersToOrgViewMemberUserRoleSelection on UserProfileModel {
  id
  firstName
  lastName
  email
  avatarUrl
}
    `;
export const UserFragmentAddUsersToOrgViewFragmentDoc = gql`
    fragment UserFragmentAddUsersToOrgView on UserProfileModel {
  id
  firstName
  lastName
  email
  avatarUrl
}
    `;
export const UserProfileFragmentGuestMembersTableFragmentDoc = gql`
    fragment UserProfileFragmentGuestMembersTable on UserProfileModel {
  id
  firstName
  lastName
  email
  avatarUrl
  title
  createdAt
  role
  isInvitedBy {
    id
    firstName
    lastName
    email
    avatarUrl
  }
}
    `;
export const UserProfileFragmentInternalMembersFragmentDoc = gql`
    fragment UserProfileFragmentInternalMembers on UserProfileModel {
  id
  firstName
  lastName
  email
  avatarUrl
  title
  createdAt
  role
  isDisabled
  hasSignedUp
  hasBeenApprovedByAdmin
  organization {
    id
  }
}
    `;
export const OrganizationUserAccessRequestFragmentUserApprovalRequestsTableFragmentDoc = gql`
    fragment OrganizationUserAccessRequestFragmentUserApprovalRequestsTable on OrganizationUserAccessRequestModel {
  id
  message
  status
  user {
    role
    hasSignedUp
    organization {
      id
    }
    ...UserFragmentAvatarGroup
  }
  invitedBy {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const UserProfileFragmentManageUsersInputFragmentDoc = gql`
    fragment UserProfileFragmentManageUsersInput on UserProfileModel {
  id
  ...UserFragmentAvatarGroup
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const PermissionRequestFragmentUsePermissionRequestHandlerFragmentDoc = gql`
    fragment PermissionRequestFragmentUsePermissionRequestHandler on PermissionRequestModel {
  postId
  collectionId
  brandId
  user {
    organization {
      id
    }
  }
  ...PermissionRequestFragmentPermissionApproveRequest
}
    ${PermissionRequestFragmentPermissionApproveRequestFragmentDoc}`;
export const PostFragmentPostPermissionDialogBodyFragmentDoc = gql`
    fragment PostFragmentPostPermissionDialogBody on PostModel {
  id
  type
  generalPermission
  permissionLevel
  organizationId
  organizationName
  myPermissions
  permissionRequests {
    ...PermissionRequestFragmentPermissionApproveRequest
  }
  creator {
    ...UserProfileFragmentUserProfilePermissionItemView
  }
  inviteMembers {
    ...PostInviteMemberFragmentPostPermissionMember
  }
}
    ${PermissionRequestFragmentPermissionApproveRequestFragmentDoc}
${UserProfileFragmentUserProfilePermissionItemViewFragmentDoc}
${PostInviteMemberFragmentPostPermissionMemberFragmentDoc}`;
export const PostFragmentPostPermissionMasonryCardViewFragmentDoc = gql`
    fragment PostFragmentPostPermissionMasonryCardView on PostModel {
  id
  ...PostFragmentPostPreview
  ...PostFragmentPostPermissionSummary
}
    ${PostFragmentPostPreviewFragmentDoc}
${PostFragmentPostPermissionSummaryFragmentDoc}`;
export const SuggestedInviteMemberFragmentPostPermissionSuggestedMemberFragmentDoc = gql`
    fragment SuggestedInviteMemberFragmentPostPermissionSuggestedMember on SuggestedInviteMember {
  permissionLevel
  user {
    ...UserProfileFragmentUserProfilePermissionItemView
  }
}
    ${UserProfileFragmentUserProfilePermissionItemViewFragmentDoc}`;
export const PostSuggestedAuthFragmentPostPermissionSuggestedAuthDialogBodyFragmentDoc = gql`
    fragment PostSuggestedAuthFragmentPostPermissionSuggestedAuthDialogBody on PostSuggestedAuthModel {
  generalPermission
  permissionLevel
  suggestedInviteMembers {
    ...SuggestedInviteMemberFragmentPostPermissionSuggestedMember
  }
}
    ${SuggestedInviteMemberFragmentPostPermissionSuggestedMemberFragmentDoc}`;
export const CollectionFragmentUpdatePostPermissionAlertViewFragmentDoc = gql`
    fragment CollectionFragmentUpdatePostPermissionAlertView on CollectionModel {
  id
  ...CollectionFragmentCollectionName
}
    ${CollectionFragmentCollectionNameFragmentDoc}`;
export const UserReactionFragmentPostReactionButtonFragmentDoc = gql`
    fragment UserReactionFragmentPostReactionButton on UserReactionModel {
  id
  emoji
  user {
    id
    firstName
  }
}
    `;
export const PostFragmentPostReactionButtonFragmentDoc = gql`
    fragment PostFragmentPostReactionButton on PostModel {
  id
  userReactions {
    id
    ...UserReactionFragmentPostReactionButton
  }
}
    ${UserReactionFragmentPostReactionButtonFragmentDoc}`;
export const PostFragmentPostViewersFragmentDoc = gql`
    fragment PostFragmentPostViewers on PostModel {
  id
  viewers {
    lastSeen
    user {
      ...UserFragmentAvatarGroup
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const PostFragmentUseNavigatePostSearchParamsFragmentDoc = gql`
    fragment PostFragmentUseNavigatePostSearchParams on PostModel {
  id
  type
}
    `;
export const PostFragmentPostCardViewFragmentDoc = gql`
    fragment PostFragmentPostCardView on PostModel {
  id
  ...PostFragmentPostPreview
  ...PostFragmentPostTitle
  ...PostFragmentPostIcon
}
    ${PostFragmentPostPreviewFragmentDoc}
${PostFragmentPostTitleFragmentDoc}
${PostFragmentPostIconFragmentDoc}`;
export const UrlMetadataFragmentPostMasonryCardViewFragmentDoc = gql`
    fragment URLMetadataFragmentPostMasonryCardView on URLMetadataModel {
  ...URLMetadataFragmentIframely
}
    ${UrlMetadataFragmentIframelyFragmentDoc}`;
export const CollectionFragmentUseMoveToAnotherCollectionModalFragmentDoc = gql`
    fragment CollectionFragmentUseMoveToAnotherCollectionModal on CollectionModel {
  id
  name
  ...CollectionFragmentCollectionBreadcrumbs
}
    ${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;
export const UserProfileFragmentAnnotationFragmentDoc = gql`
    fragment UserProfileFragmentAnnotation on UserProfileModel {
  id
  ...UserFragmentAvatarGroup
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const PostAnnotationFragmentAnnotationFragmentDoc = gql`
    fragment PostAnnotationFragmentAnnotation on PostAnnotationModel {
  id
  pageNumber
  time
  x
  y
  noteCommentAnchorId
  createdAt
  updatedAt
  isResolved
  postId
  createdBy {
    id
    ...UserProfileFragmentAnnotation
  }
  comments {
    ...CommentFragmentCommentContainerView
  }
}
    ${UserProfileFragmentAnnotationFragmentDoc}
${CommentFragmentCommentContainerViewFragmentDoc}`;
export const PostFragmentPostDetailContentCollaborationFragmentDoc = gql`
    fragment PostFragmentPostDetailContentCollaboration on PostModel {
  id
  roomId
  myPermissions
}
    `;
export const PostFragmentPostDetailContentViewFragmentDoc = gql`
    fragment PostFragmentPostDetailContentView on PostModel {
  id
  createdAt
  urlMetadata {
    id
    ...URLMetadataFragmentIframely
  }
  annotations {
    id
    ...PostAnnotationFragmentAnnotation
  }
  ...PostFragmentPostDetailContentCollaboration
  ...PostFragmentPostContextMenu
}
    ${UrlMetadataFragmentIframelyFragmentDoc}
${PostAnnotationFragmentAnnotationFragmentDoc}
${PostFragmentPostDetailContentCollaborationFragmentDoc}
${PostFragmentPostContextMenuFragmentDoc}`;
export const PostFragmentNoteTitleFragmentDoc = gql`
    fragment PostFragmentNoteTitle on PostModel {
  id
  title
  color
}
    `;
export const PostFragmentNoteColorFragmentDoc = gql`
    fragment PostFragmentNoteColor on PostModel {
  id
  color
}
    `;
export const PostFragmentCollaborativeNoteViewFragmentDoc = gql`
    fragment PostFragmentCollaborativeNoteView on PostModel {
  id
  roomId
  ...PostFragmentNoteTitle
  ...PostFragmentNoteColor
  body
  myPermissions
}
    ${PostFragmentNoteTitleFragmentDoc}
${PostFragmentNoteColorFragmentDoc}`;
export const PostFragmentNoteDetailContentViewFragmentDoc = gql`
    fragment PostFragmentNoteDetailContentView on PostModel {
  id
  annotations {
    id
    ...PostAnnotationFragmentAnnotation
  }
  ...PostFragmentCollaborativeNoteView
}
    ${PostAnnotationFragmentAnnotationFragmentDoc}
${PostFragmentCollaborativeNoteViewFragmentDoc}`;
export const PostFragmentPostDetailSidebarViewCommentsTabContentFragmentDoc = gql`
    fragment PostFragmentPostDetailSidebarViewCommentsTabContent on PostModel {
  id
  annotations {
    id
  }
}
    `;
export const PostFragmentTaskHeadingSectionFragmentDoc = gql`
    fragment PostFragmentTaskHeadingSection on PostModel {
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentTasksTabContentFragmentDoc = gql`
    fragment PostFragmentTasksTabContent on PostModel {
  ...PostFragmentTaskHeadingSection
}
    ${PostFragmentTaskHeadingSectionFragmentDoc}`;
export const PostFragmentPostDescriptionFragmentDoc = gql`
    fragment PostFragmentPostDescription on PostModel {
  id
  description
  myPermissions
}
    `;
export const PostFragmentPostCollectionListFragmentDoc = gql`
    fragment PostFragmentPostCollectionList on PostModel {
  id
  myPermissions
  isFavorite
  isFavoriteTrend
  trend {
    id
    title
  }
  collections {
    id
    parentCollectionId
  }
}
    `;
export const PostFragmentPostSocialPostButtonFragmentDoc = gql`
    fragment PostFragmentPostSocialPostButton on PostModel {
  id
  socialPostId
  socialPostEngagementSuggestion {
    id
    topic {
      id
      brandId
    }
  }
}
    `;
export const PostFragmentPostInfoViewFragmentDoc = gql`
    fragment PostFragmentPostInfoView on PostModel {
  id
  createdAt
  isFavoriteTrend
  trend {
    id
    title
  }
  creator {
    id
    ...UserFragmentAvatarGroup
  }
  ...PostFragmentPostDescription
  ...PostFragmentPostCollectionList
  ...PostFragmentPostSaveToContentCalendarButton
  ...PostFragmentPostSocialPostButton
}
    ${UserFragmentAvatarGroupFragmentDoc}
${PostFragmentPostDescriptionFragmentDoc}
${PostFragmentPostCollectionListFragmentDoc}
${PostFragmentPostSaveToContentCalendarButtonFragmentDoc}
${PostFragmentPostSocialPostButtonFragmentDoc}`;
export const PostFragmentPostDetailSidebarViewInfoTabContentFragmentDoc = gql`
    fragment PostFragmentPostDetailSidebarViewInfoTabContent on PostModel {
  id
  ...PostFragmentPostInfoView
}
    ${PostFragmentPostInfoViewFragmentDoc}`;
export const PostFragmentPostDetailSidebarViewFragmentDoc = gql`
    fragment PostFragmentPostDetailSidebarView on PostModel {
  id
  ...PostFragmentPostDetailSidebarViewCommentsTabContent
  ...PostFragmentTasksTabContent
  ...PostFragmentPostDetailSidebarViewInfoTabContent
}
    ${PostFragmentPostDetailSidebarViewCommentsTabContentFragmentDoc}
${PostFragmentTasksTabContentFragmentDoc}
${PostFragmentPostDetailSidebarViewInfoTabContentFragmentDoc}`;
export const PostFragmentPostPreviewWindowViewFragmentDoc = gql`
    fragment PostFragmentPostPreviewWindowView on PostModel {
  id
  color
  type
  ...PostFragmentPostDetailContentView
  ...PostFragmentNoteDetailContentView
  ...PostFragmentPostDetailSidebarView
}
    ${PostFragmentPostDetailContentViewFragmentDoc}
${PostFragmentNoteDetailContentViewFragmentDoc}
${PostFragmentPostDetailSidebarViewFragmentDoc}`;
export const RadarEventFragmentRadarEventCommunityUpdateItemViewFragmentDoc = gql`
    fragment RadarEventFragmentRadarEventCommunityUpdateItemView on RadarEventModel {
  id
  brandId
  createdAt
  message
  eventType
  eventTypeCounter
  readStatus
  radarEventActivities {
    id
    title
  }
  creatorProfile {
    id
    fullName
    relationshipStrength
    creators {
      id
      handle
      ...CreatorFragmentCreatorAvatar
    }
    labels {
      id
      label
    }
  }
  socialPost {
    id
    ...SocialPostFragmentUseSocialListeningPostLinkGenerator
  }
  socialPostComment {
    id
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}
${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}`;
export const RadarEventFragmentRadarEventTimelineItemInternalActivityFragmentDoc = gql`
    fragment RadarEventFragmentRadarEventTimelineItemInternalActivity on RadarEventModel {
  id
  brandId
  brand {
    id
    name
    creators {
      id
      nickName
      handle
      profilePictureUrl
    }
  }
  createdAt
  creator {
    id
    nickName
    handle
    profilePictureUrl
  }
  radarEventActivities {
    id
    title
    summary
    direction
    createdAt
    dateTime
    createdByUser {
      id
      firstName
      lastName
      email
      avatarUrl
    }
    assets {
      id
      ...PostFragmentPostPreview
    }
    channels {
      id
      name
      color
      bgColor
    }
    createdForCreatorProfiles {
      id
    }
    radarEvents {
      id
    }
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const SocialPostFragmentUseInstagramStoryPostStateFragmentDoc = gql`
    fragment SocialPostFragmentUseInstagramStoryPostState on SocialPostModel {
  id
  expiresAt
}
    `;
export const SocialPostFragmentSocialPostCardViewFragmentDoc = gql`
    fragment SocialPostFragmentSocialPostCardView on SocialPostModel {
  id
  platform
  thumbnailUrl
  videoUrl
  type
  playCount
  creator {
    id
    handle
    profilePictureUrl
  }
  ...SocialPostFragmentUseSocialListeningPostLinkGenerator
  ...SocialPostFragmentUseInstagramStoryPostState
}
    ${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}
${SocialPostFragmentUseInstagramStoryPostStateFragmentDoc}`;
export const RadarEventFragmentRadarEventTimelineItemSocialPostCommentFragmentDoc = gql`
    fragment RadarEventFragmentRadarEventTimelineItemSocialPostComment on RadarEventModel {
  id
  brandId
  socialPost {
    id
    ...SocialPostFragmentSocialPostCardView
  }
  socialPostComment {
    id
    text
    diggCount
    childCommentCount
    socialPostCommentClaims {
      sentimentScore
      brandId
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;
export const RadarEventFragmentRadarEventTimelineItemSocialPostFragmentDoc = gql`
    fragment RadarEventFragmentRadarEventTimelineItemSocialPost on RadarEventModel {
  id
  brandId
  socialPost {
    id
    description
    diggCount
    commentCount
    playCount
    engagementRate
    platformCreateTime
    brandAnalysis {
      id
      brandId
      sentimentScore
      sentimentTone
    }
    creator {
      id
      handle
      nickName
      platform
      profilePictureUrl
    }
    ...SocialPostFragmentSocialPostCardView
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;
export const RadarEventFragmentRadarEventTimelineItemViewFragmentDoc = gql`
    fragment RadarEventFragmentRadarEventTimelineItemView on RadarEventModel {
  id
  brandId
  eventType
  platformCreateTime
  message
  radarEventActivities {
    id
    createdByUser {
      id
      firstName
      lastName
      email
    }
  }
  creator {
    id
    nickName
    handle
  }
  socialPostComment {
    id
    commentCreator {
      id
      nickName
      handle
    }
  }
  socialPost {
    id
    creator {
      id
      nickName
      handle
    }
  }
  ...RadarEventFragmentRadarEventTimelineItemInternalActivity
  ...RadarEventFragmentRadarEventTimelineItemSocialPostComment
  ...RadarEventFragmentRadarEventTimelineItemSocialPost
}
    ${RadarEventFragmentRadarEventTimelineItemInternalActivityFragmentDoc}
${RadarEventFragmentRadarEventTimelineItemSocialPostCommentFragmentDoc}
${RadarEventFragmentRadarEventTimelineItemSocialPostFragmentDoc}`;
export const UrlMetadataFragmentSearchHandlerFragmentDoc = gql`
    fragment URLMetadataFragmentSearchHandler on URLMetadataModel {
  createdAt
  id
  metadata {
    audio
    author
    description
    hashtags
    medium
    site
    thumbnail {
      href
      mediaSize {
        height
        width
      }
      type
    }
    title
    type
  }
  updatedAt
  url
}
    `;
export const PostAttachmentFragmentSearchHandlerFragmentDoc = gql`
    fragment PostAttachmentFragmentSearchHandler on AttachmentModel {
  createdAt
  id
  metaData {
    imageInfo {
      height
      orientation
      width
    }
    mimeType
    size
    videoInfo {
      duration
      format
      video {
        height
        width
      }
    }
  }
  name
  updatedAt
  url
}
    `;
export const PostFragmentSearchHandlerFragmentDoc = gql`
    fragment PostFragmentSearchHandler on PostModel {
  urlMetadata {
    ...URLMetadataFragmentSearchHandler
  }
  title
  id
  body
  attachment {
    ...PostAttachmentFragmentSearchHandler
  }
  type
}
    ${UrlMetadataFragmentSearchHandlerFragmentDoc}
${PostAttachmentFragmentSearchHandlerFragmentDoc}`;
export const CollectionFragmentSearchRecentFragmentDoc = gql`
    fragment CollectionFragmentSearchRecent on CollectionModel {
  id
  ...CollectionFragmentCollectionBreadcrumbs
  posts {
    id
    urlMetadata {
      id
      url
    }
  }
}
    ${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;
export const SearchClickedResultFragmentSearchRecentFragmentDoc = gql`
    fragment SearchClickedResultFragmentSearchRecent on SearchClickedResultModel {
  updatedAt
  task {
    ...TaskFragmentSearchModal
  }
  user {
    ...UserFragmentAvatarGroup
  }
  post {
    ...PostFragmentSearchHandler
  }
  collection {
    ...CollectionFragmentSearchRecent
  }
}
    ${TaskFragmentSearchModalFragmentDoc}
${UserFragmentAvatarGroupFragmentDoc}
${PostFragmentSearchHandlerFragmentDoc}
${CollectionFragmentSearchRecentFragmentDoc}`;
export const SocialAuthorFragmentSocialAuthorAvatarFragmentDoc = gql`
    fragment SocialAuthorFragmentSocialAuthorAvatar on SocialAuthorModel {
  id
  platform
  platformHandle
  avatarUrl
}
    `;
export const BrandFragmentBrandContentTypeFragmentDoc = gql`
    fragment BrandFragmentBrandContentType on BrandModel {
  id
  name
  creators {
    id
    ...CreatorFragmentCreatorAvatar
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;
export const SocialPostFragmentInfinitePostsGridFragmentDoc = gql`
    fragment SocialPostFragmentInfinitePostsGrid on SocialPostModel {
  ...SocialPostFragmentSocialPostCardView
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;
export const BrandFragmentSlaBrandContentTypeSelectorFragmentDoc = gql`
    fragment BrandFragmentSLABrandContentTypeSelector on BrandModel {
  id
  name
  bookmarkState {
    ownedBrandAnalytics
    ugcAnalytics
  }
  creators {
    id
    ...CreatorFragmentCreatorAvatar
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;
export const SocialPostCreatorDemographicFragmentSlaCreatorDemographicsFragmentDoc = gql`
    fragment SocialPostCreatorDemographicFragmentSLACreatorDemographics on SocialPostCreatorDemographicModel {
  id
  generation
  gender
}
    `;
export const SocialPostFragmentSlaInfinitePostsGridFragmentDoc = gql`
    fragment SocialPostFragmentSLAInfinitePostsGrid on SocialPostModel {
  ...SocialPostFragmentSocialPostCardView
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;
export const SocialPostFragmentSlaRankingProductSocialPostsFragmentDoc = gql`
    fragment SocialPostFragmentSLARankingProductSocialPosts on SocialPostModel {
  ...SocialPostFragmentSocialPostCardView
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;
export const CapturedProductAttributeUsageFragmentForSlaRankingTableAttributesFragmentDoc = gql`
    fragment CapturedProductAttributeUsageFragmentForSLARankingTableAttributes on CapturedProductAttributeUsage {
  attribute
  attributeId
  count
}
    `;
export const CapturedProductGraphDataFragmentForSlaRankingGraphDataFragmentDoc = gql`
    fragment CapturedProductGraphDataFragmentForSLARankingGraphData on CapturedProductDataForInboundGraphData {
  x
  y
}
    `;
export const CapturedProductFragmentForSlaBrandInboundRankingProductDialogViewFragmentDoc = gql`
    fragment CapturedProductFragmentForSLABrandInboundRankingProductDialogView on CapturedProductDataForInbound {
  id
  line
  model
  socialPostCount
  brand {
    id
    name
  }
  category {
    id
    name
  }
  attributeUsage {
    attribute
    count
    attributeId
  }
}
    `;
export const CapturedProductFragmentForViewProductPopoverFragmentDoc = gql`
    fragment CapturedProductFragmentForViewProductPopover on CapturedProductDataForInbound {
  id
  brand {
    id
    name
  }
  category {
    id
    name
  }
}
    `;
export const CapturedProductFragmentForSlaRankingTableCompetitorFragmentDoc = gql`
    fragment CapturedProductFragmentForSLARankingTableCompetitor on CapturedProductDataForInbound {
  id
  line
  model
  percentChange
  socialPostCount
  totalViewCount
  brand {
    id
    name
  }
  category {
    id
    name
  }
  attributeUsage {
    ...CapturedProductAttributeUsageFragmentForSLARankingTableAttributes
  }
  graphData {
    ...CapturedProductGraphDataFragmentForSLARankingGraphData
  }
  previewPosts(count: $count) {
    ...SocialPostFragmentSocialPostThumbnail
  }
  ...CapturedProductFragmentForSLABrandInboundRankingProductDialogView
  ...CapturedProductFragmentForViewProductPopover
}
    ${CapturedProductAttributeUsageFragmentForSlaRankingTableAttributesFragmentDoc}
${CapturedProductGraphDataFragmentForSlaRankingGraphDataFragmentDoc}
${SocialPostFragmentSocialPostThumbnailFragmentDoc}
${CapturedProductFragmentForSlaBrandInboundRankingProductDialogViewFragmentDoc}
${CapturedProductFragmentForViewProductPopoverFragmentDoc}`;
export const CapturedProductFragmentForSlaRankingTableFragmentDoc = gql`
    fragment CapturedProductFragmentForSLARankingTable on CapturedProductDataForInbound {
  id
  line
  model
  percentChange
  socialPostCount
  totalViewCount
  brand {
    id
    name
  }
  category {
    id
    name
  }
  attributeUsage {
    ...CapturedProductAttributeUsageFragmentForSLARankingTableAttributes
  }
  graphData {
    ...CapturedProductGraphDataFragmentForSLARankingGraphData
  }
  previewPosts(count: $count) {
    ...SocialPostFragmentSocialPostThumbnail
  }
  ...CapturedProductFragmentForSLABrandInboundRankingProductDialogView
  ...CapturedProductFragmentForViewProductPopover
}
    ${CapturedProductAttributeUsageFragmentForSlaRankingTableAttributesFragmentDoc}
${CapturedProductGraphDataFragmentForSlaRankingGraphDataFragmentDoc}
${SocialPostFragmentSocialPostThumbnailFragmentDoc}
${CapturedProductFragmentForSlaBrandInboundRankingProductDialogViewFragmentDoc}
${CapturedProductFragmentForViewProductPopoverFragmentDoc}`;
export const ClaimMetricFragmentSlaSentimentClaimsFragmentDoc = gql`
    fragment ClaimMetricFragmentSLASentimentClaims on ClaimMetric {
  attribute
  numberOfMentions
}
    `;
export const CreatorFragmentSlaTopCreatorsFragmentDoc = gql`
    fragment CreatorFragmentSLATopCreators on CreatorModel {
  id
  numberOfBrandMentions
  followerCount
  ...CreatorFragmentCreatorAvatarWithNameView
  ...CreatorProfileFragmentSocialMediaListeningCreatorProfile
}
    ${CreatorFragmentCreatorAvatarWithNameViewFragmentDoc}
${CreatorProfileFragmentSocialMediaListeningCreatorProfileFragmentDoc}`;
export const TopicFragmentTopicSelectorFragmentDoc = gql`
    fragment TopicFragmentTopicSelector on TopicModel {
  id
  name
  ...TopicFragmentTopicLabel
  ...TopicFragmentTopicMoreContextMenu
  ...TopicFragmentTopicPauseContextMenu
}
    ${TopicFragmentTopicLabelFragmentDoc}
${TopicFragmentTopicMoreContextMenuFragmentDoc}
${TopicFragmentTopicPauseContextMenuFragmentDoc}`;
export const SignalDefinitionFragmentSlaAnalyticsFilterBySignalsFragmentDoc = gql`
    fragment SignalDefinitionFragmentSLAAnalyticsFilterBySignals on SignalDefinitionModel {
  id
  title
  options {
    id
    label
    value
  }
}
    `;
export const SignalDefinitionFragmentSlaBrandInboundGraphPostsViewFragmentDoc = gql`
    fragment SignalDefinitionFragmentSLABrandInboundGraphPostsView on SignalDefinitionModel {
  ...SignalDefinitionFragmentSLAAnalyticsFilterBySignals
}
    ${SignalDefinitionFragmentSlaAnalyticsFilterBySignalsFragmentDoc}`;
export const CapturedProductFragmentForSlaBrandInboundRankingProductCompetitorDialogViewFragmentDoc = gql`
    fragment CapturedProductFragmentForSLABrandInboundRankingProductCompetitorDialogView on CapturedProductDataForInbound {
  id
  line
  model
  socialPostCount
  brand {
    id
    name
  }
  category {
    id
    name
  }
  attributeUsage {
    attribute
    count
    attributeId
  }
}
    `;
export const CapturedProductFragmentForTopProductsSectionFragmentDoc = gql`
    fragment CapturedProductFragmentForTopProductsSection on CapturedProductDataForInbound {
  id
  line
  model
  socialPostCount
  totalViewCount
  brand {
    id
    name
  }
  category {
    id
    name
  }
  previewPosts(count: $count) {
    ...SocialPostFragmentSocialPostThumbnail
  }
}
    ${SocialPostFragmentSocialPostThumbnailFragmentDoc}`;
export const HashtagUsedForBrandFragmentSlaBrandInboundTopHashtagsViewFragmentDoc = gql`
    fragment HashtagUsedForBrandFragmentSLABrandInboundTopHashtagsView on HashtagUsedForBrandModel {
  isHidden
  name
  numberOfTimesUsed
  averageEngagementRate
}
    `;
export const BrandFragmentSlaBrandInboundTopHashtagsViewFragmentDoc = gql`
    fragment BrandFragmentSlaBrandInboundTopHashtagsView on BrandModel {
  id
  name
}
    `;
export const BrandFragmentSlaBrandTopCreatorPostsViewFragmentDoc = gql`
    fragment BrandFragmentSLABrandTopCreatorPostsView on BrandModel {
  id
  name
}
    `;
export const CreatorFragmentSlaBrandTopCreatorPostsViewFragmentDoc = gql`
    fragment CreatorFragmentSLABrandTopCreatorPostsView on CreatorModel {
  id
  platform
  handle
  nickName
  profilePictureUrl
  followerCount
}
    `;
export const BrandFragmentSlaBrandTopHashtagPostsViewFragmentDoc = gql`
    fragment BrandFragmentSlaBrandTopHashtagPostsView on BrandModel {
  id
  name
}
    `;
export const RelatedBrandForSlaRelatedBrandsViewFragmentDoc = gql`
    fragment RelatedBrandForSLARelatedBrandsView on RelatedBrand {
  totalEngagement
  totalImpressions
  totalPosts
  brand {
    id
    name
  }
}
    `;
export const BrandFragmentSlaRelatedBrandsTopPostsViewFragmentDoc = gql`
    fragment BrandFragmentSLARelatedBrandsTopPostsView on BrandModel {
  id
  name
}
    `;
export const SentimentSubjectFragmentSlaTopicInboundSentimentsViewFragmentDoc = gql`
    fragment SentimentSubjectFragmentSLATopicInboundSentimentsView on SentimentSubjectModel {
  id
  status
  subject
}
    `;
export const SentimentSubjectFragmentSlaTopicInboundSentimentsContainerViewFragmentDoc = gql`
    fragment SentimentSubjectFragmentSLATopicInboundSentimentsContainerView on SentimentSubjectModel {
  id
  status
  subject
}
    `;
export const OrganizationCreatorProfileLabelFragmentSlLabelSelectorFragmentDoc = gql`
    fragment OrganizationCreatorProfileLabelFragmentSLLabelSelector on OrganizationCreatorProfileLabelModel {
  id
  label
  color
  bgColor
}
    `;
export const CreatorFragmentUseSocialListeningCreatorLinkGeneratorFragmentDoc = gql`
    fragment CreatorFragmentUseSocialListeningCreatorLinkGenerator on CreatorModel {
  id
  handle
  platform
  platformId
}
    `;
export const CreatorProfileFragmentSlPeekCreatorDialogViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSLPeekCreatorDialogView on CreatorProfileModel {
  id
  isTrackingInsights
  creators {
    id
  }
}
    `;
export const CreatorProfileFragmentSlCommunityTableFragmentDoc = gql`
    fragment CreatorProfileFragmentSLCommunityTable on CreatorProfileModel {
  id
  createdAt
  brandId
  fullName
  followersCount
  brandMentionCount
  engagementRate
  totalEngagement
  totalComments
  relationshipStrength
  relationshipStrengthScore
  averageSentimentScore
  isBlockedFromCommunityHub
  isTrackingInsights
  capturedProducts {
    id
    line
    model
  }
  labels {
    id
    ...OrganizationCreatorProfileLabelFragmentSLLabelSelector
  }
  creators {
    id
    handle
    profilePictureUrl
    platform
    industry
    ...CreatorFragmentUseSocialListeningCreatorLinkGenerator
  }
  latestRadarEventActivity {
    id
    direction
    title
    dateTime
    createdByUser {
      id
      ...UserFragmentAvatarGroup
    }
  }
  creatorTrackedTopics(brandId: $brandId) {
    id
  }
  ...CreatorProfileFragmentSLPeekCreatorDialogView
}
    ${OrganizationCreatorProfileLabelFragmentSlLabelSelectorFragmentDoc}
${CreatorFragmentUseSocialListeningCreatorLinkGeneratorFragmentDoc}
${UserFragmentAvatarGroupFragmentDoc}
${CreatorProfileFragmentSlPeekCreatorDialogViewFragmentDoc}`;
export const CreatorProfileFragmentSlCreatorProfileBrandMentionDialogViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSLCreatorProfileBrandMentionDialogView on CreatorProfileModel {
  id
  brandId
  fullName
  creators {
    id
    ...CreatorFragmentCreatorAvatar
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;
export const CreatorFragmentSocialListeningCreatorProfileDetailsViewFragmentDoc = gql`
    fragment CreatorFragmentSocialListeningCreatorProfileDetailsView on CreatorModel {
  id
  handle
  platform
  profilePictureUrl
  nickName
  followerCount
}
    `;
export const SocialListeningCreatorProfileMergeViewFragmentCreatorFragmentDoc = gql`
    fragment SocialListeningCreatorProfileMergeViewFragmentCreator on CreatorModel {
  id
  platform
  handle
}
    `;
export const CreatorFragmentSlCreatorProfileHandlerViewFragmentDoc = gql`
    fragment CreatorFragmentSLCreatorProfileHandlerView on CreatorModel {
  id
  platform
  nickName
  profilePictureUrl
  videoCount
  followerCount
  engagementRate
  ...CreatorFragmentCreatorAvatar
  ...CreatorFragmentUseSocialListeningCreatorLinkGenerator
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}
${CreatorFragmentUseSocialListeningCreatorLinkGeneratorFragmentDoc}`;
export const CreatorProfileFragmentSlCreatorProfileDetailsViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSLCreatorProfileDetailsView on CreatorProfileModel {
  id
  fullName
  emails
  brandId
  creators {
    id
    platform
    handle
    nickName
    audience_demographics
    industry
    otherInsights
    ...CreatorFragmentSLCreatorProfileHandlerView
    ...CreatorFragmentUseSocialListeningCreatorLinkGenerator
  }
  labels {
    id
    label
    color
    bgColor
  }
  relationshipStrength
  location
  reasonForLocation
  locationReferenceSocialPost {
    id
  }
  birthdate
}
    ${CreatorFragmentSlCreatorProfileHandlerViewFragmentDoc}
${CreatorFragmentUseSocialListeningCreatorLinkGeneratorFragmentDoc}`;
export const SocialListeningCreatorProfileMergeViewFragmentCreatorProfileFragmentDoc = gql`
    fragment SocialListeningCreatorProfileMergeViewFragmentCreatorProfile on CreatorProfileModel {
  id
  ...CreatorProfileFragmentSLCreatorProfileDetailsView
}
    ${CreatorProfileFragmentSlCreatorProfileDetailsViewFragmentDoc}`;
export const CreatorProfileFragmentSocialListeningCreatorProfileProductsDialogViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSocialListeningCreatorProfileProductsDialogView on CreatorProfileModel {
  id
  creators {
    id
    handle
    profilePictureUrl
    nickName
  }
}
    `;
export const CreatorProfileFragmentSocialListeningCreatorProfileProductsViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSocialListeningCreatorProfileProductsView on CreatorProfileModel {
  id
  ...CreatorProfileFragmentSocialListeningCreatorProfileProductsDialogView
}
    ${CreatorProfileFragmentSocialListeningCreatorProfileProductsDialogViewFragmentDoc}`;
export const CapturedProductFragmentForSocialListeningCreatorProfileProductsViewFragmentDoc = gql`
    fragment CapturedProductFragmentForSocialListeningCreatorProfileProductsView on CapturedProductDataForInbound {
  id
  socialPostCount
  previewPosts(count: $count) {
    id
    thumbnailUrl
    videoUrl
  }
  sentimentReasons
  attributeUsage {
    attribute
    attributeId
    count
  }
  category {
    id
    name
  }
  line
  model
  brand {
    id
    name
  }
}
    `;
export const CapturedProductFragmentForSocialListeningCreatorProfileProductsDialogViewFragmentDoc = gql`
    fragment CapturedProductFragmentForSocialListeningCreatorProfileProductsDialogView on CapturedProductDataForInbound {
  id
  ...CapturedProductFragmentForSocialListeningCreatorProfileProductsView
}
    ${CapturedProductFragmentForSocialListeningCreatorProfileProductsViewFragmentDoc}`;
export const CreatorProfileFragmentSlCreatorProfileFanEngagementDialogViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSLCreatorProfileFanEngagementDialogView on CreatorProfileModel {
  id
  brandId
  fullName
  creators {
    id
    ...CreatorFragmentCreatorAvatar
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;
export const UserProfileFragmentSocialListeningPermissionMemberFragmentDoc = gql`
    fragment UserProfileFragmentSocialListeningPermissionMember on UserProfileModel {
  id
  firstName
  lastName
  email
  role
  isDisabled
  hasSignedUp
  hasBeenApprovedByAdmin
  organization {
    id
  }
}
    `;
export const BrandInviteMemberFragmentSocialListeningPermissionMemberFragmentDoc = gql`
    fragment BrandInviteMemberFragmentSocialListeningPermissionMember on BrandInviteMemberModel {
  id
  permissionLevel
  user {
    id
    ...UserProfileFragmentSocialListeningPermissionMember
  }
}
    ${UserProfileFragmentSocialListeningPermissionMemberFragmentDoc}`;
export const BrandInviteMemberModelFragmentApproveBrandInviteMemberFragmentDoc = gql`
    fragment BrandInviteMemberModelFragmentApproveBrandInviteMember on BrandInviteMemberModel {
  ...BrandInviteMemberFragmentSocialListeningPermissionMember
}
    ${BrandInviteMemberFragmentSocialListeningPermissionMemberFragmentDoc}`;
export const UserProfileFragmentSocialListeningUserPermissionsDialogBodyViewFragmentDoc = gql`
    fragment UserProfileFragmentSocialListeningUserPermissionsDialogBodyView on UserProfileModel {
  ...UserProfileFragmentSocialListeningPermissionMember
}
    ${UserProfileFragmentSocialListeningPermissionMemberFragmentDoc}`;
export const BrandInviteMemberModelFragmentSocialListeningUserPermissionsDialogBodyViewFragmentDoc = gql`
    fragment BrandInviteMemberModelFragmentSocialListeningUserPermissionsDialogBodyView on BrandInviteMemberModel {
  ...BrandInviteMemberFragmentSocialListeningPermissionMember
}
    ${BrandInviteMemberFragmentSocialListeningPermissionMemberFragmentDoc}`;
export const CreatorProfileFragmentSlRadarCreatorAutocompleteFragmentDoc = gql`
    fragment CreatorProfileFragmentSLRadarCreatorAutocomplete on CreatorProfileModel {
  id
  fullName
  emails
  creators {
    id
    profilePictureUrl
  }
}
    `;
export const RadarEventActivityCommunicationChannelFragmentSlRadarActivityCommunicationChannelHandlersFragmentDoc = gql`
    fragment RadarEventActivityCommunicationChannelFragmentSLRadarActivityCommunicationChannelHandlers on RadarEventActivityCommunicationChannelModel {
  id
  color
  bgColor
  name
}
    `;
export const RadarEventActivityFragmentSlRadarActivityHandlersFragmentDoc = gql`
    fragment RadarEventActivityFragmentSLRadarActivityHandlers on RadarEventActivityModel {
  id
  title
  direction
  summary
  dateTime
  createdForCreatorProfiles {
    id
  }
  channels {
    id
  }
  assets {
    id
  }
  radarEvents {
    id
  }
}
    `;
export const TopicFragmentNotificationsSectionFragmentDoc = gql`
    fragment TopicFragmentNotificationsSection on TopicModel {
  id
  name
}
    `;
export const SocialPostNotificationConfigFragmentNotificationsSectionFragmentDoc = gql`
    fragment SocialPostNotificationConfigFragmentNotificationsSection on SocialPostNotificationConfigModel {
  id
  creatorFollowing
  brandId
  sentiments
  minimumScore
  enabled
  creatorFollowingEnabled
  sentimentsEnabled
  minimumScoreEnabled
  topic {
    id
    ...TopicFragmentNotificationsSection
  }
}
    ${TopicFragmentNotificationsSectionFragmentDoc}`;
export const CompetitorFragmentCompetitorEditFragmentDoc = gql`
    fragment CompetitorFragmentCompetitorEdit on CompetitorModel {
  id
  isPaused
  description
  name
  regions
  searchTerms {
    id
    isHashTag
    term
  }
  trackingBrand {
    id
    name
    creators {
      id
      ...CreatorFragmentSocialListeningSettingsSocialHandleInput
    }
  }
}
    ${CreatorFragmentSocialListeningSettingsSocialHandleInputFragmentDoc}`;
export const CreatorFragmentCreatorPeekingFragmentDoc = gql`
    fragment CreatorFragmentCreatorPeeking on CreatorModel {
  id
  platformId
  handle
  platform
}
    `;
export const TopicFragmentSocialMediaListeningFilterByTopicsButtonFragmentDoc = gql`
    fragment TopicFragmentSocialMediaListeningFilterByTopicsButton on TopicModel {
  id
  name
  ...TopicFragmentTopicLabel
}
    ${TopicFragmentTopicLabelFragmentDoc}`;
export const SignalDefinitionFragmentFilterBySignalsFragmentDoc = gql`
    fragment SignalDefinitionFragmentFilterBySignals on SignalDefinitionModel {
  id
  title
  options {
    id
    label
    value
  }
}
    `;
export const SocialPostFragmentSocialListeningPostSaveButtonFragmentDoc = gql`
    fragment SocialPostFragmentSocialListeningPostSaveButton on SocialPostModel {
  id
  totalContentCalendarSaves
  isSavedToContentCalendar
  savedPost {
    id
    isFavorite
    isFavoriteTrend
  }
  totalPostSaves
  ...SocialPostFragmentUseSocialListeningPostLinkGenerator
}
    ${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}`;
export const SocialPostFragmentSocialListeningContentCalendarSaveButtonFragmentDoc = gql`
    fragment SocialPostFragmentSocialListeningContentCalendarSaveButton on SocialPostModel {
  id
  totalContentCalendarSaves
  isSavedToContentCalendar
  savedPostId
  totalPostSaves
  ...SocialPostFragmentUseSocialListeningPostLinkGenerator
}
    ${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}`;
export const SocialPostFragmentSocialMediaListeningPostContextMenuFragmentDoc = gql`
    fragment SocialPostFragmentSocialMediaListeningPostContextMenu on SocialPostModel {
  ...SocialPostFragmentSocialListeningPostSaveButton
  ...SocialPostFragmentSocialListeningContentCalendarSaveButton
}
    ${SocialPostFragmentSocialListeningPostSaveButtonFragmentDoc}
${SocialPostFragmentSocialListeningContentCalendarSaveButtonFragmentDoc}`;
export const SearchTermFragmentForUseBrandSearchTermsForSocialListeningOnboardingFragmentDoc = gql`
    fragment SearchTermFragmentForUseBrandSearchTermsForSocialListeningOnboarding on SearchTermModel {
  id
  term
  isHashTag
}
    `;
export const TopicFragmentForUseTopicDataForSocialListeningOnboardingFragmentDoc = gql`
    fragment TopicFragmentForUseTopicDataForSocialListeningOnboarding on TopicModel {
  id
  brandId
  name
  type
  active
  generatedPrompt
  topicDescription
  prioritizationInfo
  communicationStrategy
  allowToUpdateSearchTerm
  searchTerms {
    ...SearchTermFragmentForUseBrandSearchTermsForSocialListeningOnboarding
  }
  status
  resetOnNextCycle
}
    ${SearchTermFragmentForUseBrandSearchTermsForSocialListeningOnboardingFragmentDoc}`;
export const CreatorFragmentForUseCreatorDataForSocialListeningOnboardingFragmentDoc = gql`
    fragment CreatorFragmentForUseCreatorDataForSocialListeningOnboarding on CreatorModel {
  id
  nickName
  profilePictureUrl
  handle
  platform
}
    `;
export const BrandFragmentUseSocialListeningOnboardingBrandFragmentDoc = gql`
    fragment BrandFragmentUseSocialListeningOnboardingBrand on BrandModel {
  id
  name
  description
  regions
  brandKnownNames
  topics {
    ...TopicFragmentForUseTopicDataForSocialListeningOnboarding
  }
  creators {
    ...CreatorFragmentForUseCreatorDataForSocialListeningOnboarding
  }
  blockedCreators {
    ...CreatorFragmentForUseCreatorDataForSocialListeningOnboarding
  }
}
    ${TopicFragmentForUseTopicDataForSocialListeningOnboardingFragmentDoc}
${CreatorFragmentForUseCreatorDataForSocialListeningOnboardingFragmentDoc}`;
export const BrandFragmentBrandConnectedCreatorsFragmentDoc = gql`
    fragment BrandFragmentBrandConnectedCreators on BrandModel {
  id
  creators {
    id
    ...CreatorFragmentCreatorAvatar
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;
export const BrandFragmentForBrandCompetitorsViewFragmentDoc = gql`
    fragment BrandFragmentForBrandCompetitorsView on BrandModel {
  id
  myPermissions
  bookmarkState {
    competitorAnalytics
  }
}
    `;
export const BrandFragmentUseBrandDetailsFragmentDoc = gql`
    fragment BrandFragmentUseBrandDetails on BrandModel {
  id
  name
  bookmarkState {
    brandAnalytics
    ownedBrandAnalytics
    ugcAnalytics
    communityHub
    outbound
  }
  ...BrandFragmentBrandConnectedCreators
  ...BrandFragmentForBrandCompetitorsView
}
    ${BrandFragmentBrandConnectedCreatorsFragmentDoc}
${BrandFragmentForBrandCompetitorsViewFragmentDoc}`;
export const SocialPostFragmentUseCreatePostHandlerForSocialListeningFragmentDoc = gql`
    fragment SocialPostFragmentUseCreatePostHandlerForSocialListening on SocialPostModel {
  id
  ...SocialPostFragmentUseSocialListeningPostLinkGenerator
}
    ${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}`;
export const CreatorFragmentUseCreatorsTopicTrackingForSocialListeningFragmentDoc = gql`
    fragment CreatorFragmentUseCreatorsTopicTrackingForSocialListening on CreatorModel {
  id
  creatorTrackedTopics(brandId: $creatorTrackedTopicBrandId) {
    id
  }
  isTrackingInsightsForCreatorProfile(brandId: $trackingInsightsBrandId)
  ...CreatorProfileFragmentSocialMediaListeningCreatorProfile
}
    ${CreatorProfileFragmentSocialMediaListeningCreatorProfileFragmentDoc}`;
export const SocialPostFragmentUseRenderSocialListeningPostVideoFragmentDoc = gql`
    fragment SocialPostFragmentUseRenderSocialListeningPostVideo on SocialPostModel {
  videoUrl
  socialPostEngagementSuggestions(brandId: $brandId) {
    id
    oneLineSummary
    highlights {
      end
      start
      highlightSummary
    }
  }
}
    `;
export const BrandCompetitorsDataResponseFragmentSocialListeningAnalyticsCompetitorsRankingFragmentDoc = gql`
    fragment BrandCompetitorsDataResponseFragmentSocialListeningAnalyticsCompetitorsRanking on BrandCompetitorsDataResponse {
  data {
    percentageShare
    mentionCount
    brand {
      id
      name
    }
  }
  currentDurationRank
  previousDurationRank
  totalVideos
}
    `;
export const BrandCompetitorsSentimentDataResponseFragmentSocialListeningAnalyticsCompetitorsSentimentFragmentDoc = gql`
    fragment BrandCompetitorsSentimentDataResponseFragmentSocialListeningAnalyticsCompetitorsSentiment on BrandCompetitorsSentimentDataResponse {
  currentDurationRank
  previousDurationRank
  data {
    negativePercentage
    neutralPercentage
    positivePercentage
    positiveCount
    neutralCount
    negativeCount
    brand {
      id
      name
    }
  }
}
    `;
export const BrandFragmentSocialMediaListeningAnalyticsCompetitorsViewFragmentDoc = gql`
    fragment BrandFragmentSocialMediaListeningAnalyticsCompetitorsView on BrandModel {
  id
  name
  topics {
    __typename
    id
    name
    type
    topicContentStrategy
  }
  brandCompetitors(data: $competitorsDataInput) {
    ...BrandCompetitorsDataResponseFragmentSocialListeningAnalyticsCompetitorsRanking
  }
  brandCompetitorsSentiment(data: $competitorsDataInput) {
    ...BrandCompetitorsSentimentDataResponseFragmentSocialListeningAnalyticsCompetitorsSentiment
  }
}
    ${BrandCompetitorsDataResponseFragmentSocialListeningAnalyticsCompetitorsRankingFragmentDoc}
${BrandCompetitorsSentimentDataResponseFragmentSocialListeningAnalyticsCompetitorsSentimentFragmentDoc}`;
export const BrandFragmentSentimentTrendsByBrandDialogFragmentDoc = gql`
    fragment BrandFragmentSentimentTrendsByBrandDialog on BrandModel {
  ...BrandFragmentSocialMediaListeningAnalyticsCompetitorsView
}
    ${BrandFragmentSocialMediaListeningAnalyticsCompetitorsViewFragmentDoc}`;
export const BrandSentimentTrendBySentimentDataFragmentThemeDialogFragmentDoc = gql`
    fragment BrandSentimentTrendBySentimentDataFragmentThemeDialog on BrandTrendsBySentimentData {
  score
  data {
    name
    brandId
    sentiment
  }
}
    `;
export const BrandSentimentTrendBySentimentDataFragmentSentimentTrendTableDataFragmentDoc = gql`
    fragment BrandSentimentTrendBySentimentDataFragmentSentimentTrendTableData on BrandTrendsBySentimentData {
  ...BrandSentimentTrendBySentimentDataFragmentThemeDialog
}
    ${BrandSentimentTrendBySentimentDataFragmentThemeDialogFragmentDoc}`;
export const SentimentMetricsFragmentSentimentThemeCardFragmentDoc = gql`
    fragment SentimentMetricsFragmentSentimentThemeCard on SentimentMetric {
  averageCountPerDay
  totalCount
  chartDataPoints {
    X
    Y
  }
}
    `;
export const TopicFragmentSocialMediaListeningTopicsFilterFragmentDoc = gql`
    fragment TopicFragmentSocialMediaListeningTopicsFilter on TopicModel {
  id
  __typename
  name
  type
  topicContentStrategy
}
    `;
export const BrandMentionedMetricsFragmentSocialListeningAnalyticsInboundFragmentDoc = gql`
    fragment BrandMentionedMetricsFragmentSocialListeningAnalyticsInbound on BrandMentionedMetrics {
  averageCountPerDay
  allTimeHigh {
    X
    Y
  }
  chartDataPoints {
    X
    Y
  }
}
    `;
export const BrandOutboundLeaderboardItemFragmentLeaderboardSectionFragmentDoc = gql`
    fragment BrandOutboundLeaderboardItemFragmentLeaderboardSection on BrandOutboundLeaderboardItem {
  id
  user {
    id
    ...UserFragmentAvatarGroup
  }
  averageEngagement
  numberOfPostsCommentedOn
  maxLikes
  bestPerformingSocialPosts {
    id
    thumbnailUrl
    videoUrl
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const BrandMetricsResponseFragmentMetricsChartFragmentDoc = gql`
    fragment BrandMetricsResponseFragmentMetricsChart on BrandMetricsResponse {
  total
  chartDataPoints {
    X
    Y
  }
}
    `;
export const SocialPostCommentFragmentSocialPostCommentCreatedTimeFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentCreatedTime on SocialPostCommentModel {
  id
  platformCreateTime
}
    `;
export const SocialPostCommentFragmentSocialPostCommentTextFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentText on SocialPostCommentModel {
  id
  text
}
    `;
export const SocialPostCommentFragmentUseResponderChangeFragmentDoc = gql`
    fragment SocialPostCommentFragmentUseResponderChange on SocialPostCommentModel {
  id
  socialPost {
    id
    brandSocialPostEngagement(brandId: $brandId) {
      id
      respondedByUser {
        id
      }
    }
  }
}
    `;
export const SocialPostCommentFragmentSocialPostCommentResponderPillFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentResponderPill on SocialPostCommentModel {
  id
  socialPost {
    brandSocialPostEngagement(brandId: $brandId) {
      id
      respondedByUser {
        ...UserFragmentAvatarGroup
      }
    }
  }
  ...SocialPostCommentFragmentUseResponderChange
}
    ${UserFragmentAvatarGroupFragmentDoc}
${SocialPostCommentFragmentUseResponderChangeFragmentDoc}`;
export const SocialPostCommentFragmentSocialPostCommentLikesFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentLikes on SocialPostCommentModel {
  id
  diggCount
}
    `;
export const SocialPostCommentFragmentSocialPostCommentRepliesFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentReplies on SocialPostCommentModel {
  id
  childCommentCount
}
    `;
export const SocialPostCommentFragmentSocialPostCommentResponderButtonFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentResponderButton on SocialPostCommentModel {
  id
  ...SocialPostCommentFragmentUseResponderChange
}
    ${SocialPostCommentFragmentUseResponderChangeFragmentDoc}`;
export const SocialPostCommentFragmentSocialPostCommentsListViewTableRowFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentsListViewTableRow on SocialPostCommentModel {
  id
  socialPost {
    ...SocialPostFragmentSocialPostThumbnail
  }
  ...SocialPostCommentFragmentSocialPostCommentCreatedTime
  ...SocialPostCommentFragmentSocialPostCommentText
  ...SocialPostCommentFragmentSocialPostCommentResponderPill
  ...SocialPostCommentFragmentSocialPostCommentLikes
  ...SocialPostCommentFragmentSocialPostCommentReplies
  ...SocialPostCommentFragmentSocialPostCommentResponderButton
}
    ${SocialPostFragmentSocialPostThumbnailFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentCreatedTimeFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentTextFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentResponderPillFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentLikesFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentRepliesFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentResponderButtonFragmentDoc}`;
export const TopicFragmentCreatorPeekingContentFragmentDoc = gql`
    fragment TopicFragmentCreatorPeekingContent on TopicModel {
  id
  name
}
    `;
export const CreatorFragmentSocialMediaListeningOnboardingSocialHandleFormFragmentDoc = gql`
    fragment CreatorFragmentSocialMediaListeningOnboardingSocialHandleForm on CreatorModel {
  ...CreatorFragmentForUseCreatorDataForSocialListeningOnboarding
}
    ${CreatorFragmentForUseCreatorDataForSocialListeningOnboardingFragmentDoc}`;
export const SocialPostFragmentWhatYouCanSayFragmentDoc = gql`
    fragment SocialPostFragmentWhatYouCanSay on SocialPostModel {
  id
  platformId
  platform
  creator {
    id
    handle
    profilePictureUrl
  }
  socialPostEngagementSuggestions(brandId: $brandId) {
    id
    __typename
    sentiment
    suggestedComment
  }
}
    `;
export const SocialPostCommentFragmentSocialPostCommunityCommentsFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommunityComments on SocialPostCommentModel {
  id
  childCommentCount
  parentSocialPostCommentId
  diggCount
  commentCreator {
    id
    nickName
    profilePictureUrl
  }
  platformCreateTime
  text
}
    `;
export const SocialPostFragmentPostBrandSentimentsFragmentDoc = gql`
    fragment SocialPostFragmentPostBrandSentiments on SocialPostModel {
  id
  brandAnalysis {
    brand {
      id
      name
    }
    brandClaims {
      attribute
      claim
      brandId
      sentimentScore
      brand {
        id
        name
      }
    }
    sentimentScore
    isConfident
    sentimentTone
  }
}
    `;
export const SocialPostFragmentSocialMediaListeningPostSummaryFragmentDoc = gql`
    fragment SocialPostFragmentSocialMediaListeningPostSummary on SocialPostModel {
  id
  __typename
  platformId
  createdAt
  videoUrl
  thumbnailUrl
  platform
  platformId
  description
  diggCount
  shareCount
  playCount
  platformCreateTime
  commentCount
  engagementRate
  type
  audioTranscription {
    start
    speaker
    sentence
    end
  }
  contextualInformation {
    oneLineSummary
    detailedSummary
  }
  sentimentTexts {
    id
    category
    keyword
    sentiment
    subCategory
  }
  communityComments {
    ...SocialPostCommentFragmentSocialPostCommunityComments
  }
  socialPostEngagementSuggestions(brandId: $brandId) {
    id
    oneLineSummary
    videoSummary
    highlights {
      end
      start
      highlightSummary
    }
  }
  creator {
    __typename
    audience_demographics
    createdAt
    engagementRate
    followerCount
    followingCount
    handle
    id
    industry
    likeCount
    nickName
    platform
    platformId
    profilePictureUrl
    signature
    updatedAt
    videoCount
  }
  ...SocialPostFragmentPostBrandSentiments
}
    ${SocialPostCommentFragmentSocialPostCommunityCommentsFragmentDoc}
${SocialPostFragmentPostBrandSentimentsFragmentDoc}`;
export const SocialPostFragmentPostVideoDialogFragmentDoc = gql`
    fragment SocialPostFragmentPostVideoDialog on SocialPostModel {
  ...SocialPostFragmentSocialMediaListeningPostSummary
}
    ${SocialPostFragmentSocialMediaListeningPostSummaryFragmentDoc}`;
export const SocialPostFragmentPostVideoDialogContentTabsFragmentDoc = gql`
    fragment SocialPostFragmentPostVideoDialogContentTabs on SocialPostModel {
  ...SocialPostFragmentSocialMediaListeningPostSummary
}
    ${SocialPostFragmentSocialMediaListeningPostSummaryFragmentDoc}`;
export const SocialPostFragmentPostVideoDialogVideoHighlightsFragmentDoc = gql`
    fragment SocialPostFragmentPostVideoDialogVideoHighlights on SocialPostModel {
  id
  __typename
  socialPostEngagementSuggestions(brandId: $brandId) {
    id
    oneLineSummary
    highlights {
      end
      start
      highlightSummary
    }
  }
}
    `;
export const SocialPostFragmentPostVideoDialogVideoTranscriptFragmentDoc = gql`
    fragment SocialPostFragmentPostVideoDialogVideoTranscript on SocialPostModel {
  id
  audioTranscription {
    start
    end
    speaker
    sentence
  }
}
    `;
export const SocialPostFragmentBrandSocialPostEngagementStatusFragmentDoc = gql`
    fragment SocialPostFragmentBrandSocialPostEngagementStatus on SocialPostModel {
  id
  brandSocialPostEngagement(brandId: $brandId) {
    id
    status
  }
}
    `;
export const SocialPostFragmentSocialMediaListeningPostCardFragmentDoc = gql`
    fragment SocialPostFragmentSocialMediaListeningPostCard on SocialPostModel {
  commentCount
  createdAt
  expiresAt
  totalEngagement
  creator {
    createdAt
    engagementRate
    followerCount
    handle
    id
    industry
    nickName
    platform
    profilePictureUrl
    updatedAt
  }
  description
  diggCount
  duration
  engagementRate
  bookmarkCount
  id
  isAd
  platform
  platformId
  platformCreateTime
  playCount
  shareCount
  type
  updatedAt
  viralRate
  thumbnailUrl
  videoUrl
  videoThumbnailFolderUrl
  carouselFolderUrl
  ...SocialPostFragmentBrandSocialPostEngagementStatus
  socialPostEngagementSuggestionsWithTopic(topicIds: $topicIds, brandId: $brandId) {
    id
    sentiment
    score
    oneLineSummary
    reason
    topic {
      id
      name
      ...TopicFragmentTopicLabel
    }
  }
  socialPostEngagementSuggestions(brandId: $brandId) {
    id
    createdAt
    oneLineSummary
    reason
    score
    sentiment
    socialpostId
    topicId
    topic {
      id
      name
      ...TopicFragmentTopicLabel
    }
    updatedAt
  }
  ...SocialPostFragmentUseInstagramStoryPostState
}
    ${SocialPostFragmentBrandSocialPostEngagementStatusFragmentDoc}
${TopicFragmentTopicLabelFragmentDoc}
${SocialPostFragmentUseInstagramStoryPostStateFragmentDoc}`;
export const SocialPostFragmentSocialMediaListeningPostsGridViewFragmentDoc = gql`
    fragment SocialPostFragmentSocialMediaListeningPostsGridView on SocialPostModel {
  ...SocialPostFragmentSocialMediaListeningPostCard
}
    ${SocialPostFragmentSocialMediaListeningPostCardFragmentDoc}`;
export const SocialPostEngagementSuggestionFragmentSocialMediaListeningListItemFragmentDoc = gql`
    fragment SocialPostEngagementSuggestionFragmentSocialMediaListeningListItem on SocialPostEngagementSuggestionModel {
  id
  createdAt
  oneLineSummary
  reason
  score
  sentiment
  socialPost {
    commentCount
    createdAt
    creator {
      audience_demographics
      createdAt
      engagementRate
      followerCount
      followingCount
      handle
      id
      industry
      likeCount
      nickName
      platform
      platformId
      profilePictureUrl
      signature
      updatedAt
      videoCount
    }
    creatorId
    description
    diggCount
    duration
    engagementRate
    bookmarkCount
    id
    isAd
    matchedMusic
    platform
    platformCreateTime
    platformId
    playCount
    region
    shareCount
    type
    updatedAt
    viralRate
    thumbnailUrl
    videoUrl
    videoThumbnailFolderUrl
    carouselFolderUrl
  }
  socialpostId
  suggestedComment
  topicId
  updatedAt
}
    `;
export const SocialPostFragmentSocialMediaListeningListItemFragmentDoc = gql`
    fragment SocialPostFragmentSocialMediaListeningListItem on SocialPostModel {
  commentCount
  createdAt
  creatorId
  description
  diggCount
  duration
  engagementRate
  id
  isAd
  matchedMusic
  platform
  platformCreateTime
  platformId
  playCount
  region
  shareCount
  type
  updatedAt
  viralRate
  thumbnailUrl
  videoUrl
  videoThumbnailFolderUrl
  carouselFolderUrl
  totalEngagement
  ...SocialPostFragmentBrandSocialPostEngagementStatus
  creator {
    audience_demographics
    createdAt
    engagementRate
    followerCount
    followingCount
    handle
    id
    industry
    likeCount
    nickName
    platform
    platformId
    profilePictureUrl
    signature
    updatedAt
    videoCount
  }
  socialPostEngagementSuggestions(brandId: $brandId) {
    id
    createdAt
    oneLineSummary
    reason
    score
    sentiment
    socialpostId
    suggestedComment
    topicId
    updatedAt
    topic {
      id
      name
    }
  }
}
    ${SocialPostFragmentBrandSocialPostEngagementStatusFragmentDoc}`;
export const SocialPostFragmentSocialMediaListeningPostsListViewFragmentDoc = gql`
    fragment SocialPostFragmentSocialMediaListeningPostsListView on SocialPostModel {
  ...SocialPostFragmentSocialMediaListeningListItem
}
    ${SocialPostFragmentSocialMediaListeningListItemFragmentDoc}`;
export const SocialPostFragmentSocialPostClaimsCardFragmentDoc = gql`
    fragment SocialPostFragmentSocialPostClaimsCard on SocialPostModel {
  socialPostEngagementSuggestions(brandId: $brandId) {
    id
    oneLineSummary
  }
  id
  thumbnailUrl
  description
  contextualInformation {
    oneLineSummary
  }
}
    `;
export const SocialPostCommentFragmentSocialPostCommentCardViewFragmentDoc = gql`
    fragment SocialPostCommentFragmentSocialPostCommentCardView on SocialPostCommentModel {
  id
  socialPost {
    ...SocialPostFragmentSocialPostThumbnail
  }
  ...SocialPostCommentFragmentSocialPostCommentReplies
  ...SocialPostCommentFragmentSocialPostCommentText
  ...SocialPostCommentFragmentSocialPostCommentLikes
  ...SocialPostCommentFragmentSocialPostCommentCreatedTime
  ...SocialPostCommentFragmentSocialPostCommentResponderPill
}
    ${SocialPostFragmentSocialPostThumbnailFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentRepliesFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentTextFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentLikesFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentCreatedTimeFragmentDoc}
${SocialPostCommentFragmentSocialPostCommentResponderPillFragmentDoc}`;
export const TaskFragmentTaskDescriptionFragmentDoc = gql`
    fragment TaskFragmentTaskDescription on TaskModel {
  id
  description
  myPermissions
}
    `;
export const TaskFragmentTaskCalendarEventViewFragmentDoc = gql`
    fragment TaskFragmentTaskCalendarEventView on TaskModel {
  id
  name
  startDate
  endDate
  status
  priority
  taskMembers {
    ...UserFragmentAvatarGroup
  }
  parentTask {
    id
    name
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const TaskFragmentTaskDetailViewNestedTaskNavigationContextFragmentDoc = gql`
    fragment TaskFragmentTaskDetailViewNestedTaskNavigationContext on TaskModel {
  id
  name
}
    `;
export const TaskFragmentTaskDetailViewLocationNavigatorFragmentDoc = gql`
    fragment TaskFragmentTaskDetailViewLocationNavigator on TaskModel {
  id
  name
}
    `;
export const TaskFragmentTaskSubtaskSectionFragmentDoc = gql`
    fragment TaskFragmentTaskSubtaskSection on TaskModel {
  ...TaskFragmentTaskListItemView
  myPermissions
}
    ${TaskFragmentTaskListItemViewFragmentDoc}`;
export const TaskFragmentTaskDetailViewFragmentDoc = gql`
    fragment TaskFragmentTaskDetailView on TaskModel {
  id
  name
  description
  startDate
  endDate
  status
  priority
  ...TaskFragmentTaskSubtaskSection
  taskMembers {
    ...UserProfileFragmentAssigneeList
  }
  subtasks {
    ...TaskFragmentTaskSubtaskSection
  }
  parentTaskId
  isPreview
}
    ${TaskFragmentTaskSubtaskSectionFragmentDoc}
${UserProfileFragmentAssigneeListFragmentDoc}`;
export const TaskFragmentTaskPeekingCardViewFragmentDoc = gql`
    fragment TaskFragmentTaskPeekingCardView on TaskModel {
  id
  name
  startDate
  endDate
  status
  priority
  taskMembers {
    ...UserFragmentAvatarGroup
  }
  parentTask {
    id
    name
  }
  posts {
    ...PostFragmentPostPreview
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}
${PostFragmentPostPreviewFragmentDoc}`;
export const TaskFragmentUseTaskListWithKeyboardShortcutsFragmentDoc = gql`
    fragment TaskFragmentUseTaskListWithKeyboardShortcuts on TaskModel {
  id
  parentTaskId
  sortOrder
  ...TaskFragmentTaskListItemView
}
    ${TaskFragmentTaskListItemViewFragmentDoc}`;
export const TaskFragmentTaskDueDateRangeFragmentDoc = gql`
    fragment TaskFragmentTaskDueDateRange on TaskModel {
  id
  startDate
  endDate
}
    `;
export const TaskFragmentTaskItemExtensionFragmentDoc = gql`
    fragment TaskFragmentTaskItemExtension on TaskModel {
  id
  name
  ...TaskFragmentTaskStatus
  ...TaskFragmentTaskAssignee
  ...TaskFragmentTaskDueDateRange
  ...TaskFragmentTaskPriorityComponent
}
    ${TaskFragmentTaskStatusFragmentDoc}
${TaskFragmentTaskAssigneeFragmentDoc}
${TaskFragmentTaskDueDateRangeFragmentDoc}
${TaskFragmentTaskPriorityComponentFragmentDoc}`;
export const SignalDefinitionFragmentTopicSignalFragmentDoc = gql`
    fragment SignalDefinitionFragmentTopicSignal on SignalDefinitionModel {
  id
  title
  description
  options {
    id
    label
  }
}
    `;
export const TopicFragmentTopicBreakdownPopoverViewFragmentDoc = gql`
    fragment TopicFragmentTopicBreakdownPopoverView on TopicModel {
  id
  name
  status
  resetOnNextCycle
  type
  ...TopicFragmentTopicMoreContextMenu
}
    ${TopicFragmentTopicMoreContextMenuFragmentDoc}`;
export const TopicFragmentTopicBreakdownTableViewFragmentDoc = gql`
    fragment TopicFragmentTopicBreakdownTableView on TopicModel {
  id
  name
  status
  resetOnNextCycle
  type
}
    `;
export const TopicFragmentTopicContentFilterSettingsViewFragmentDoc = gql`
    fragment TopicFragmentTopicContentFilterSettingsView on TopicModel {
  id
  minimumProcessingRules {
    field
    operator
    value
    platform
    condition
    excludedKeywords
    rules {
      field
      operator
      value
      platform
      condition
      excludedKeywords
    }
  }
  brand {
    id
    minimumProcessingRules {
      field
      operator
      value
      platform
      condition
      excludedKeywords
      rules {
        field
        operator
        value
        platform
        condition
        excludedKeywords
      }
    }
  }
}
    `;
export const TopicFragmentTopicParsingSettingsViewFragmentDoc = gql`
    fragment TopicFragmentTopicParsingSettingsView on TopicModel {
  id
  parsingSettings {
    Instagram {
      enabled
      types {
        Photo
        Video
        Carousel
      }
    }
    Tiktok {
      enabled
    }
    Youtube {
      enabled
    }
  }
}
    `;
export const AudioTrendGroupFragmentUseTrendAudioGroupNavigatorHandlerFragmentDoc = gql`
    fragment AudioTrendGroupFragmentUseTrendAudioGroupNavigatorHandler on AudioTrendGroupModel {
  id
}
    `;
export const AudioTrendGroupFragmentTrendAudioGroupCardViewFragmentDoc = gql`
    fragment AudioTrendGroupFragmentTrendAudioGroupCardView on AudioTrendGroupModel {
  id
  audioId
  audioTitle
  audioVideoCount
  audioArtist
  posts {
    platformId
  }
}
    `;
export const TrendAudioFragmentTrendingSocialMediaPreviewFragmentDoc = gql`
    fragment TrendAudioFragmentTrendingSocialMediaPreview on TrendAudioModel {
  id
  coverUrl
  platform
  title
  urlMetadata {
    id
    url
  }
}
    `;
export const TrendFragmentUseTrendNavigatorHandlerFragmentDoc = gql`
    fragment TrendFragmentUseTrendNavigatorHandler on TrendModel {
  id
  category
}
    `;
export const TrendFragmentTrendingPreviewFragmentDoc = gql`
    fragment TrendFragmentTrendingPreview on TrendModel {
  id
  category
  previewPost {
    id
    ...PostFragmentPostPreview
  }
  previewThumbnail
  previewUrlMetadata {
    id
    ...URLMetadataFragmentIframely
  }
}
    ${PostFragmentPostPreviewFragmentDoc}
${UrlMetadataFragmentIframelyFragmentDoc}`;
export const TrendFragmentTrendingCardViewFragmentDoc = gql`
    fragment TrendFragmentTrendingCardView on TrendModel {
  id
  description
  title
  category
  status
  trendingDate
  lastViewed
  createdAt
  trendAudio {
    id
    changePercentage
    totalVideoCount
  }
  linkedPosts {
    id
    isFavoriteTrend
    creator {
      id
    }
    urlMetadata {
      id
    }
  }
  previewUrlMetadata {
    id
    ...URLMetadataFragmentIframely
  }
  ...TrendFragmentTrendingPreview
}
    ${UrlMetadataFragmentIframelyFragmentDoc}
${TrendFragmentTrendingPreviewFragmentDoc}`;
export const TrendFragmentTrendInfoFragmentDoc = gql`
    fragment TrendFragmentTrendInfo on TrendModel {
  id
  __typename
  createdAt
  description
  title
  category
  status
  trendAudio {
    totalVideoCount
    changePercentage
  }
}
    `;
export const TrendAudioFragmentTrendingAudioPreviewFragmentDoc = gql`
    fragment TrendAudioFragmentTrendingAudioPreview on TrendAudioModel {
  id
  coverUrl
  duration
  totalVideoCount
  platform
  title
  authorUsername
  urlMetadata {
    ...URLMetadataFragmentIframely
  }
  author {
    id
    name
    avatarUrl
  }
}
    ${UrlMetadataFragmentIframelyFragmentDoc}`;
export const LinkedPostFragmentTrendLinkPostsFragmentDoc = gql`
    fragment LinkedPostFragmentTrendLinkPosts on PostModel {
  id
  type
  createdAt
  isFavorite
  isFavoriteTrend
  myPermissions
  trend {
    id
    title
  }
  urlMetadata {
    createdAt
    id
    metadata {
      audio
      author
      description
      hashtags
      medium
      site
      thumbnail {
        href
        mediaSize {
          height
          width
        }
        status
        token
        type
      }
      title
      type
    }
    updatedAt
    url
  }
  creator {
    ...UserFragmentAvatarGroup
  }
  collections {
    id
    name
    contentIdeaId
    parentCollection {
      contentIdeaId
      id
      name
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const TrendFragmentTrendingDetailViewFragmentDoc = gql`
    fragment TrendFragmentTrendingDetailView on TrendModel {
  ...TrendFragmentTrendInfo
  trendAudioSavedCount {
    totalSavedCount
    savedContentCalendarTotal
  }
  trendAudio {
    ...TrendAudioFragmentTrendingAudioPreview
  }
  trendExamples {
    id
    totalSavedCount
    savedContentCalendarTotal
    urlMetadata {
      id
      createdAt
      metadata {
        author
        description
        hashtags
        medium
        site
        audio
        medias {
          type
          url
        }
        thumbnail {
          href
          mediaSize {
            height
            width
          }
          status
          token
          type
        }
        title
        type
      }
      updatedAt
      url
    }
  }
  linkedPosts {
    ...LinkedPostFragmentTrendLinkPosts
  }
}
    ${TrendFragmentTrendInfoFragmentDoc}
${TrendAudioFragmentTrendingAudioPreviewFragmentDoc}
${LinkedPostFragmentTrendLinkPostsFragmentDoc}`;
export const UserProfileFragmentUserProfileChipViewFragmentDoc = gql`
    fragment UserProfileFragmentUserProfileChipView on UserProfileModel {
  id
  firstName
  lastName
  avatarUrl
  email
}
    `;
export const PostFragmentAiOrganizePostCardViewFragmentDoc = gql`
    fragment PostFragmentAiOrganizePostCardView on PostModel {
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentNoteViewFragmentDoc = gql`
    fragment PostFragmentNoteView on PostModel {
  id
  ...PostFragmentNoteTitle
  ...PostFragmentNoteColor
  body
  myPermissions
}
    ${PostFragmentNoteTitleFragmentDoc}
${PostFragmentNoteColorFragmentDoc}`;
export const PostFragmentAiOrganizeNoteCardViewFragmentDoc = gql`
    fragment PostFragmentAiOrganizeNoteCardView on PostModel {
  ...PostFragmentNoteView
}
    ${PostFragmentNoteViewFragmentDoc}`;
export const PostFragmentPostPermissionDialogViewFragmentDoc = gql`
    fragment PostFragmentPostPermissionDialogView on PostModel {
  id
  permissionLevel
  generalPermission
  title
  inviteMembers {
    id
  }
  permissionRequests {
    id
  }
  creator {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const PostFragmentAiOrganizeSwiperViewFragmentDoc = gql`
    fragment PostFragmentAiOrganizeSwiperView on PostModel {
  id
  type
  ...PostFragmentAiOrganizePostCardView
  ...PostFragmentAiOrganizeNoteCardView
  ...PostFragmentPostPermissionDialogView
}
    ${PostFragmentAiOrganizePostCardViewFragmentDoc}
${PostFragmentAiOrganizeNoteCardViewFragmentDoc}
${PostFragmentPostPermissionDialogViewFragmentDoc}`;
export const PostFragmentAiOrganizeSelectedCollectionListFragmentDoc = gql`
    fragment PostFragmentAiOrganizeSelectedCollectionList on PostModel {
  id
}
    `;
export const PostFragmentAiOrganizePageFragmentDoc = gql`
    fragment PostFragmentAiOrganizePage on PostModel {
  id
  type
  ...PostFragmentAiOrganizeSwiperView
  ...PostFragmentAiOrganizeSelectedCollectionList
  postSuggestedCollectionAssignments {
    id
    score
    collection {
      id
    }
  }
}
    ${PostFragmentAiOrganizeSwiperViewFragmentDoc}
${PostFragmentAiOrganizeSelectedCollectionListFragmentDoc}`;
export const BillingPaymentMethodFragmentPaymentDetailsFragmentDoc = gql`
    fragment BillingPaymentMethodFragmentPaymentDetails on BillingPaymentMethod {
  id
  card {
    brand
    expMonth
    expYear
    last4
  }
}
    `;
export const CollectionFragmentCollectionPostDndCollectionCardFragmentDoc = gql`
    fragment CollectionFragmentCollectionPostDndCollectionCard on CollectionModel {
  id
  ...CollectionFragmentCollectionCardView
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;
export const CollectionFragmentCollectionPageSuggestedPostSectionFragmentDoc = gql`
    fragment CollectionFragmentCollectionPageSuggestedPostSection on CollectionModel {
  id
  organizationId
  totalSuggestedPosts
  newSuggestedPostCount
}
    `;
export const CollectionFragmentCollectionCollaborationsViewFragmentDoc = gql`
    fragment CollectionFragmentCollectionCollaborationsView on CollectionModel {
  id
  roomId
  parentCollectionId
}
    `;
export const CollectionFragmentCollectionTopHeaderBreadcrumbsFragmentDoc = gql`
    fragment CollectionFragmentCollectionTopHeaderBreadcrumbs on CollectionModel {
  id
  name
  breadcrumbsFromRoot {
    id
    name
  }
}
    `;
export const CollectionFragmentCollectionPageFragmentDoc = gql`
    fragment CollectionFragmentCollectionPage on CollectionModel {
  id
  name
  parentCollectionId
  creatorId
  unreadCommentCount
  myPermissions
  organizationId
  isDisabled
  contentIdeaId
  creator {
    ...UserFragmentAvatarGroup
  }
  parentCollection {
    id
    name
  }
  childCollections {
    id
    name
    ...CollectionFragmentCollectionPostDndCollectionCard
    ...CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenu
  }
  ...CollectionFragmentCollectionBreadcrumbs
  ...CollectionFragmentCollectionPageSuggestedPostSection
  ...CollectionFragmentCollectionCollaborationsView
  ...CollectionFragmentCollectionThumbnail
  ...CollectionFragmentCollectionContextMenu
  ...CollectionFragmentCollectionSavedToContentCalendar
  ...CollectionFragmentCollectionTopHeaderBreadcrumbs
}
    ${UserFragmentAvatarGroupFragmentDoc}
${CollectionFragmentCollectionPostDndCollectionCardFragmentDoc}
${CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragmentDoc}
${CollectionFragmentCollectionBreadcrumbsFragmentDoc}
${CollectionFragmentCollectionPageSuggestedPostSectionFragmentDoc}
${CollectionFragmentCollectionCollaborationsViewFragmentDoc}
${CollectionFragmentCollectionThumbnailFragmentDoc}
${CollectionFragmentCollectionContextMenuFragmentDoc}
${CollectionFragmentCollectionSavedToContentCalendarFragmentDoc}
${CollectionFragmentCollectionTopHeaderBreadcrumbsFragmentDoc}`;
export const PostFragmentPostSuggestionCardViewFragmentDoc = gql`
    fragment PostFragmentPostSuggestionCardView on PostModel {
  ...PostFragmentPostPreview
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export const PostFragmentCollectionPageSuggestedPostSectionFragmentDoc = gql`
    fragment PostFragmentCollectionPageSuggestedPostSection on PostModel {
  id
  ...PostFragmentPostSuggestionCardView
  ...PostFragmentPostMasonryCardView
}
    ${PostFragmentPostSuggestionCardViewFragmentDoc}
${PostFragmentPostMasonryCardViewFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaSnoozeDateFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaSnoozeDate on ContentIdeaModel {
  id
  snoozeDate
  stage
  myPermissions
}
    `;
export const ContentIdeaFragmentContentIdeaIceboxFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaIcebox on ContentIdeaModel {
  id
  stage
  myPermissions
}
    `;
export const ContentIdeaFragmentContentIdeaListItemViewFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaListItemView on ContentIdeaModel {
  id
  myPermissions
  draftAssets {
    id
  }
  finalAssets {
    id
  }
  caption {
    id
  }
  audio {
    id
  }
  ...ContentIdeaFragmentContentIdeaPreview
  ...ContentIdeaFragmentContentIdeaName
  ...ContentIdeaFragmentContentIdeaSnoozeDate
  ...ContentIdeaFragmentContentIdeaStatus
  ...ContentIdeaFragmentContentIdeaDueDate
  ...ContentIdeaFragmentContentIdeaOwners
  ...ContentIdeaFragmentContentIdeaPlatforms
  ...ContentIdeaFragmentContentIdeaPillars
  ...ContentIdeaFragmentContentIdeaIcebox
}
    ${ContentIdeaFragmentContentIdeaPreviewFragmentDoc}
${ContentIdeaFragmentContentIdeaNameFragmentDoc}
${ContentIdeaFragmentContentIdeaSnoozeDateFragmentDoc}
${ContentIdeaFragmentContentIdeaStatusFragmentDoc}
${ContentIdeaFragmentContentIdeaDueDateFragmentDoc}
${ContentIdeaFragmentContentIdeaOwnersFragmentDoc}
${ContentIdeaFragmentContentIdeaPlatformsFragmentDoc}
${ContentIdeaFragmentContentIdeaPillarsFragmentDoc}
${ContentIdeaFragmentContentIdeaIceboxFragmentDoc}`;
export const ContentIdeaFragmentContentCalendarPageListSectionFragmentDoc = gql`
    fragment ContentIdeaFragmentContentCalendarPageListSection on ContentIdeaModel {
  id
  ...ContentIdeaFragmentContentIdeaListItemView
  ...ContentIdeaFragmentContentIdeaContextMenu
}
    ${ContentIdeaFragmentContentIdeaListItemViewFragmentDoc}
${ContentIdeaFragmentContentIdeaContextMenuFragmentDoc}`;
export const ContentIdeaFieldFragmentContentIdeaFieldNameFragmentDoc = gql`
    fragment ContentIdeaFieldFragmentContentIdeaFieldName on ContentIdeaFieldModel {
  id
  name
  icon
  type
  isPrimaryField
}
    `;
export const ContentIdeaFieldFragmentContentIdeaDetailViewFragmentDoc = gql`
    fragment ContentIdeaFieldFragmentContentIdeaDetailView on ContentIdeaFieldModel {
  id
  sortOrder
  ...ContentIdeaFieldFragmentContentIdeaFieldName
}
    ${ContentIdeaFieldFragmentContentIdeaFieldNameFragmentDoc}`;
export const ContentIdeaFieldValueFragmentContentIdeaFieldCheckboxFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldCheckbox on ContentIdeaFieldValueModel {
  id
  value {
    id
    checkbox
  }
}
    `;
export const ContentIdeaFieldValueFragmentContentIdeaFieldTasksFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldTasks on ContentIdeaFieldValueModel {
  id
  value {
    id
    tasks {
      id
    }
  }
}
    `;
export const ContentIdeaFieldValueFragmentContentIdeaFieldUsersFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldUsers on ContentIdeaFieldValueModel {
  id
  value {
    id
    users {
      id
    }
  }
}
    `;
export const ContentIdeaFieldValueFragmentContentIdeaFieldCollectionFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaFieldCollection on ContentIdeaFieldValueModel {
  id
  value {
    id
    collection {
      id
    }
  }
}
    `;
export const ContentIdeaFieldValueFragmentContentIdeaFieldFragmentDoc = gql`
    fragment ContentIdeaFieldValueFragmentContentIdeaField on ContentIdeaFieldValueModel {
  id
  ...ContentIdeaFieldValueFragmentContentIdeaFieldText
  ...ContentIdeaFieldValueFragmentContentIdeaFieldSelect
  ...ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelect
  ...ContentIdeaFieldValueFragmentContentIdeaFieldDate
  ...ContentIdeaFieldValueFragmentContentIdeaFieldCheckbox
  ...ContentIdeaFieldValueFragmentContentIdeaFieldTasks
  ...ContentIdeaFieldValueFragmentContentIdeaFieldUsers
  ...ContentIdeaFieldValueFragmentContentIdeaFieldCollection
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldTextFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldSelectFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldMultiSelectFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldDateFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldCheckboxFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldTasksFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldUsersFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldCollectionFragmentDoc}`;
export const ContentIdeaPublishMetadataFragmentContentIdeaPublishMetadataPublishUrlCustomFieldFragmentDoc = gql`
    fragment ContentIdeaPublishMetadataFragmentContentIdeaPublishMetadataPublishUrlCustomField on ContentIdeaPublishMetadataModel {
  id
  platform
  publishUrl
}
    `;
export const ContentIdeaFragmentContentIdeaNoteFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaNote on ContentIdeaModel {
  id
  noteContent
  roomId
  myPermissions
}
    `;
export const ContentIdeaFragmentContentIdeaDetailViewFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaDetailView on ContentIdeaModel {
  id
  myPermissions
  collection {
    id
  }
  fields {
    id
    contentIdeaField {
      id
      ...ContentIdeaFieldFragmentContentIdeaDetailView
    }
    ...ContentIdeaFieldValueFragmentContentIdeaField
  }
  contentIdeaPublishMetadata {
    id
    platform
    ...ContentIdeaPublishMetadataFragmentContentIdeaPublishMetadataPublishUrlCustomField
  }
  draftAssets {
    id
  }
  finalAssets {
    id
  }
  caption {
    id
  }
  audio {
    id
  }
  ...ContentIdeaFragmentContentIdeaPreview
  ...ContentIdeaFragmentContentIdeaName
  ...ContentIdeaFragmentContentIdeaCollection
  ...ContentIdeaFragmentContentIdeaNote
  ...ContentIdeaFragmentContentIdeaPlatforms
  ...ContentIdeaFragmentContentIdeaStatus
  ...ContentIdeaFragmentContentIdeaOwners
  ...ContentIdeaFragmentContentIdeaDueDate
}
    ${ContentIdeaFieldFragmentContentIdeaDetailViewFragmentDoc}
${ContentIdeaFieldValueFragmentContentIdeaFieldFragmentDoc}
${ContentIdeaPublishMetadataFragmentContentIdeaPublishMetadataPublishUrlCustomFieldFragmentDoc}
${ContentIdeaFragmentContentIdeaPreviewFragmentDoc}
${ContentIdeaFragmentContentIdeaNameFragmentDoc}
${ContentIdeaFragmentContentIdeaCollectionFragmentDoc}
${ContentIdeaFragmentContentIdeaNoteFragmentDoc}
${ContentIdeaFragmentContentIdeaPlatformsFragmentDoc}
${ContentIdeaFragmentContentIdeaStatusFragmentDoc}
${ContentIdeaFragmentContentIdeaOwnersFragmentDoc}
${ContentIdeaFragmentContentIdeaDueDateFragmentDoc}`;
export const ContentIdeaFragmentContentIdeaPageFragmentDoc = gql`
    fragment ContentIdeaFragmentContentIdeaPage on ContentIdeaModel {
  id
  stage
  ...ContentIdeaFragmentContentIdeaDetailView
  ...ContentIdeaFragmentContentIdeaContextMenu
}
    ${ContentIdeaFragmentContentIdeaDetailViewFragmentDoc}
${ContentIdeaFragmentContentIdeaContextMenuFragmentDoc}`;
export const UserProfileFragmentInboxBrandInviteMemberApprovalFragmentDoc = gql`
    fragment UserProfileFragmentInboxBrandInviteMemberApproval on UserProfileModel {
  id
  firstName
  lastName
  email
  avatarUrl
}
    `;
export const BrandInviteMemberFragmentInboxBrandInviteMemberApprovalFragmentDoc = gql`
    fragment BrandInviteMemberFragmentInboxBrandInviteMemberApproval on BrandInviteMemberModel {
  id
  user {
    ...UserProfileFragmentInboxBrandInviteMemberApproval
  }
  brand {
    id
    name
    creators {
      id
      ...CreatorFragmentSocialListeningSettingsSocialHandleInput
    }
  }
  permissionLevel
}
    ${UserProfileFragmentInboxBrandInviteMemberApprovalFragmentDoc}
${CreatorFragmentSocialListeningSettingsSocialHandleInputFragmentDoc}`;
export const OrganizationUserAccessRequestFragmentInboxContentFragmentDoc = gql`
    fragment OrganizationUserAccessRequestFragmentInboxContent on OrganizationUserAccessRequestModel {
  id
  status
  message
  organization {
    id
    name
  }
  user {
    ...UserFragmentAvatarGroup
  }
  updatedBy {
    ...UserFragmentAvatarGroup
  }
  invitedBy {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const NotificationFragmentInboxSlBrandReachedUsageLimitContentFragmentDoc = gql`
    fragment NotificationFragmentInboxSLBrandReachedUsageLimitContent on NotificationModel {
  id
  data
}
    `;
export const PermissionRequestFragmentInboxPermissionRequestSideViewFragmentDoc = gql`
    fragment PermissionRequestFragmentInboxPermissionRequestSideView on PermissionRequestModel {
  id
  note
  status
  post {
    id
    organizationId
    inviteMembers {
      id
      permissionLevel
      user {
        id
      }
    }
  }
  collection {
    id
    organizationId
    inviteMembers {
      id
      permissionLevel
      user {
        id
      }
    }
  }
  user {
    organization {
      id
    }
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const UrlMetadataFragmentJuiceModalFragmentDoc = gql`
    fragment UrlMetadataFragmentJuiceModal on URLMetadataModel {
  id
  ...URLMetadataFragmentIframely
}
    ${UrlMetadataFragmentIframelyFragmentDoc}`;
export const PostFragmentJuicePostLayoutFragmentDoc = gql`
    fragment PostFragmentJuicePostLayout on PostModel {
  id
  ...PostFragmentPostDetailSidebarView
  ...PostFragmentPostPermissionDialogView
  ...PostFragmentPostContextMenu
}
    ${PostFragmentPostDetailSidebarViewFragmentDoc}
${PostFragmentPostPermissionDialogViewFragmentDoc}
${PostFragmentPostContextMenuFragmentDoc}`;
export const PostFragmentJuiceboxNoteModalFragmentDoc = gql`
    fragment PostFragmentJuiceboxNoteModal on PostModel {
  id
  description
  isFavorite
  collections {
    id
  }
  ...PostFragmentNoteDetailContentView
  ...PostFragmentJuicePostLayout
}
    ${PostFragmentNoteDetailContentViewFragmentDoc}
${PostFragmentJuicePostLayoutFragmentDoc}`;
export const PostFragmentJuiceModalFragmentDoc = gql`
    fragment PostFragmentJuiceModal on PostModel {
  id
  title
  body
  type
  description
  createdAt
  isFavorite
  isFavoriteTrend
  trend {
    id
    title
  }
  creator {
    ...UserFragmentAvatarGroup
  }
  annotations {
    ...PostAnnotationFragmentAnnotation
  }
  urlMetadata {
    ...UrlMetadataFragmentJuiceModal
  }
  ...PostFragmentJuiceboxNoteModal
  ...PostFragmentPostReactionList
  ...PostFragmentPostContextMenu
  ...PostFragmentTasksTabContent
  ...PostFragmentJuicePostLayout
  ...PostFragmentPostPermissionSummary
}
    ${UserFragmentAvatarGroupFragmentDoc}
${PostAnnotationFragmentAnnotationFragmentDoc}
${UrlMetadataFragmentJuiceModalFragmentDoc}
${PostFragmentJuiceboxNoteModalFragmentDoc}
${PostFragmentPostReactionListFragmentDoc}
${PostFragmentPostContextMenuFragmentDoc}
${PostFragmentTasksTabContentFragmentDoc}
${PostFragmentJuicePostLayoutFragmentDoc}
${PostFragmentPostPermissionSummaryFragmentDoc}`;
export const PostSuggestedAuthFragmentJuiceboxNoteModalFragmentDoc = gql`
    fragment PostSuggestedAuthFragmentJuiceboxNoteModal on PostSuggestedAuthModel {
  generalPermission
  permissionLevel
  suggestedInviteMembers {
    permissionLevel
    user {
      id
      firstName
      lastName
      email
      organization {
        id
      }
    }
  }
}
    `;
export const TrendFragmentTrendingJuiceboxSearchBarItemFragmentDoc = gql`
    fragment TrendFragmentTrendingJuiceboxSearchBarItem on TrendModel {
  id
  title
  category
  ...TrendFragmentTrendingPreview
}
    ${TrendFragmentTrendingPreviewFragmentDoc}`;
export const EditorialPostFragmentTrendingJuiceBoxFragmentDoc = gql`
    fragment EditorialPostFragmentTrendingJuiceBox on EditorialPostModel {
  id
  body
  color
  description
  title
  type
  trendingDate
  lastViewed
  createdAt
  updatedAt
  urlMetadata {
    ...URLMetadataFragmentIframely
  }
  posts {
    id
    type
    createdAt
    creator {
      email
      id
      lastName
      firstName
      avatarUrl
    }
    collections {
      id
      name
      parentCollection {
        id
        name
      }
    }
  }
}
    ${UrlMetadataFragmentIframelyFragmentDoc}`;
export const BillingPaymentMethodFragmentCardDetailFragmentDoc = gql`
    fragment BillingPaymentMethodFragmentCardDetail on BillingPaymentMethod {
  id
  card {
    brand
    expMonth
    expYear
    last4
  }
}
    `;
export const UserFragmentUserRequestFragmentDoc = gql`
    fragment UserFragmentUserRequest on UserProfileModel {
  id
  email
  firstName
  lastName
  role
  externalRole
  isDisabled
  isInvitedBy {
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export const NotificationSettingFragmentUseNotificationSettingsFragmentDoc = gql`
    fragment NotificationSettingFragmentUseNotificationSettings on NotificationSettingModel {
  id
  type
  email
  mobilePush
  inbox
}
    `;
export const SocialAuthorFragmentSocialAuthorListSectionFragmentDoc = gql`
    fragment SocialAuthorFragmentSocialAuthorListSection on SocialAuthorModel {
  id
  platform
  profileUrl
}
    `;
export const OrganizationFragmentSocialsPageFragmentDoc = gql`
    fragment OrganizationFragmentSocialsPage on OrganizationModel {
  id
  socialAuthors {
    id
    platform
    ...SocialAuthorFragmentSocialAuthorListSection
  }
}
    ${SocialAuthorFragmentSocialAuthorListSectionFragmentDoc}`;
export const SocialPostFragmentAddACommentButtonFragmentDoc = gql`
    fragment SocialPostFragmentAddACommentButton on SocialPostModel {
  id
  thumbnailUrl
}
    `;
export const SavedConfigFragmentSavedViewsMenuFragmentDoc = gql`
    fragment SavedConfigFragmentSavedViewsMenu on SavedConfigModel {
  id
  name
  type
  config
  brandId
}
    `;
export const CompetitorFragmentForBrandCompetitorActionContextMenuFragmentDoc = gql`
    fragment CompetitorFragmentForBrandCompetitorActionContextMenu on CompetitorModel {
  id
  isBookmarked
}
    `;
export const CompetitorFragmentForSlCompetitorDetailPageFragmentDoc = gql`
    fragment CompetitorFragmentForSLCompetitorDetailPage on CompetitorModel {
  ...CompetitorFragmentForBrandCompetitorActionContextMenu
}
    ${CompetitorFragmentForBrandCompetitorActionContextMenuFragmentDoc}`;
export const CreatorProfileFragmentSlCreatorProfileInsightsViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSLCreatorProfileInsightsView on CreatorProfileModel {
  id
  creators {
    id
    audience_demographics
    otherInsights
    industry
  }
}
    `;
export const CreatorProfileFragmentSlCreatorProfileSentimentDialogViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSLCreatorProfileSentimentDialogView on CreatorProfileModel {
  id
  brandId
  fullName
  creators {
    id
  }
}
    `;
export const CreatorProfileFragmentSlCreatorProfileStatsViewFragmentDoc = gql`
    fragment CreatorProfileFragmentSLCreatorProfileStatsView on CreatorProfileModel {
  id
  ...CreatorProfileFragmentSLCreatorProfileSentimentDialogView
}
    ${CreatorProfileFragmentSlCreatorProfileSentimentDialogViewFragmentDoc}`;
export const CreatorProfileFragmentAboutTabContentFragmentDoc = gql`
    fragment CreatorProfileFragmentAboutTabContent on CreatorProfileModel {
  id
  brandId
  isTrackingInsights
  creatorTrackedTopics(brandId: $brandId) {
    id
  }
  ...CreatorProfileFragmentSLCreatorProfileInsightsView
  ...CreatorProfileFragmentSLCreatorProfileStatsView
  ...CreatorProfileFragmentSLCreatorProfileDetailsView
}
    ${CreatorProfileFragmentSlCreatorProfileInsightsViewFragmentDoc}
${CreatorProfileFragmentSlCreatorProfileStatsViewFragmentDoc}
${CreatorProfileFragmentSlCreatorProfileDetailsViewFragmentDoc}`;
export const CreatorProfileFragmentActivityTabContentFragmentDoc = gql`
    fragment CreatorProfileFragmentActivityTabContent on CreatorProfileModel {
  id
  brandId
  isTrackingInsights
  creatorTrackedTopics(brandId: $brandId) {
    id
  }
  ...CreatorProfileFragmentSLCreatorProfileDetailsView
}
    ${CreatorProfileFragmentSlCreatorProfileDetailsViewFragmentDoc}`;
export const GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesDocument = gql`
    query GetFrequentlyViewedEntitiesForFrequentlyVisitedPages {
  frequentlyViewedEntities {
    ...ActivityFragmentForFrequentlyVisitedPages
  }
}
    ${ActivityFragmentForFrequentlyVisitedPagesFragmentDoc}`;

/**
 * __useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery__
 *
 * To run a query within a React component, call `useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery(baseOptions?: Apollo.QueryHookOptions<GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery, GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery, GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryVariables>(GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesDocument, options);
      }
export function useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery, GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery, GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryVariables>(GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesDocument, options);
        }
export type GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryHookResult = ReturnType<typeof useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery>;
export type GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesLazyQueryHookResult = ReturnType<typeof useGetFrequentlyViewedEntitiesForFrequentlyVisitedPagesLazyQuery>;
export type GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryResult = Apollo.QueryResult<GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQuery, GetFrequentlyViewedEntitiesForFrequentlyVisitedPagesQueryVariables>;
export const GetNotificationUnreadCountForNotificationsSidebarLinkDocument = gql`
    query GetNotificationUnreadCountForNotificationsSidebarLink {
  unreadNotificationsV2
}
    `;

/**
 * __useGetNotificationUnreadCountForNotificationsSidebarLinkQuery__
 *
 * To run a query within a React component, call `useGetNotificationUnreadCountForNotificationsSidebarLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationUnreadCountForNotificationsSidebarLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationUnreadCountForNotificationsSidebarLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationUnreadCountForNotificationsSidebarLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationUnreadCountForNotificationsSidebarLinkQuery, GetNotificationUnreadCountForNotificationsSidebarLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationUnreadCountForNotificationsSidebarLinkQuery, GetNotificationUnreadCountForNotificationsSidebarLinkQueryVariables>(GetNotificationUnreadCountForNotificationsSidebarLinkDocument, options);
      }
export function useGetNotificationUnreadCountForNotificationsSidebarLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationUnreadCountForNotificationsSidebarLinkQuery, GetNotificationUnreadCountForNotificationsSidebarLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationUnreadCountForNotificationsSidebarLinkQuery, GetNotificationUnreadCountForNotificationsSidebarLinkQueryVariables>(GetNotificationUnreadCountForNotificationsSidebarLinkDocument, options);
        }
export type GetNotificationUnreadCountForNotificationsSidebarLinkQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountForNotificationsSidebarLinkQuery>;
export type GetNotificationUnreadCountForNotificationsSidebarLinkLazyQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountForNotificationsSidebarLinkLazyQuery>;
export type GetNotificationUnreadCountForNotificationsSidebarLinkQueryResult = Apollo.QueryResult<GetNotificationUnreadCountForNotificationsSidebarLinkQuery, GetNotificationUnreadCountForNotificationsSidebarLinkQueryVariables>;
export const UpdateOrganizationForOrganizationLayoutNameSectionDocument = gql`
    mutation UpdateOrganizationForOrganizationLayoutNameSection($data: UpdateOrganizationInput!) {
  updateOrganization(data: $data) {
    id
    name
  }
}
    `;
export type UpdateOrganizationForOrganizationLayoutNameSectionMutationFn = Apollo.MutationFunction<UpdateOrganizationForOrganizationLayoutNameSectionMutation, UpdateOrganizationForOrganizationLayoutNameSectionMutationVariables>;

/**
 * __useUpdateOrganizationForOrganizationLayoutNameSectionMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationForOrganizationLayoutNameSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationForOrganizationLayoutNameSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationForOrganizationLayoutNameSectionMutation, { data, loading, error }] = useUpdateOrganizationForOrganizationLayoutNameSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationForOrganizationLayoutNameSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationForOrganizationLayoutNameSectionMutation, UpdateOrganizationForOrganizationLayoutNameSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationForOrganizationLayoutNameSectionMutation, UpdateOrganizationForOrganizationLayoutNameSectionMutationVariables>(UpdateOrganizationForOrganizationLayoutNameSectionDocument, options);
      }
export type UpdateOrganizationForOrganizationLayoutNameSectionMutationHookResult = ReturnType<typeof useUpdateOrganizationForOrganizationLayoutNameSectionMutation>;
export type UpdateOrganizationForOrganizationLayoutNameSectionMutationResult = Apollo.MutationResult<UpdateOrganizationForOrganizationLayoutNameSectionMutation>;
export type UpdateOrganizationForOrganizationLayoutNameSectionMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationForOrganizationLayoutNameSectionMutation, UpdateOrganizationForOrganizationLayoutNameSectionMutationVariables>;
export const GetNotificationUnreadCountDocument = gql`
    query GetNotificationUnreadCount {
  unreadNotificationsV2
}
    `;

/**
 * __useGetNotificationUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationUnreadCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
      }
export function useGetNotificationUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
        }
export type GetNotificationUnreadCountQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountQuery>;
export type GetNotificationUnreadCountLazyQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountLazyQuery>;
export type GetNotificationUnreadCountQueryResult = Apollo.QueryResult<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>;
export const FeatureFlagsDocument = gql`
    query FeatureFlags {
  featureFlags {
    id
    name
    enabled
    organizationId
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
      }
export function useFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const AppLevelFeatureFlagsDocument = gql`
    query AppLevelFeatureFlags {
  appLevelFeatureFlags {
    id
    name
    enabled
    organizationId
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useAppLevelFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useAppLevelFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppLevelFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppLevelFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppLevelFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<AppLevelFeatureFlagsQuery, AppLevelFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppLevelFeatureFlagsQuery, AppLevelFeatureFlagsQueryVariables>(AppLevelFeatureFlagsDocument, options);
      }
export function useAppLevelFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppLevelFeatureFlagsQuery, AppLevelFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppLevelFeatureFlagsQuery, AppLevelFeatureFlagsQueryVariables>(AppLevelFeatureFlagsDocument, options);
        }
export type AppLevelFeatureFlagsQueryHookResult = ReturnType<typeof useAppLevelFeatureFlagsQuery>;
export type AppLevelFeatureFlagsLazyQueryHookResult = ReturnType<typeof useAppLevelFeatureFlagsLazyQuery>;
export type AppLevelFeatureFlagsQueryResult = Apollo.QueryResult<AppLevelFeatureFlagsQuery, AppLevelFeatureFlagsQueryVariables>;
export const CreateCollectionForCollectionCommandDocument = gql`
    mutation CreateCollectionForCollectionCommand($data: CreateCollectionInput!) {
  createCollection(data: $data) {
    id
    ...CollectionFragmentCollectionCommand
  }
}
    ${CollectionFragmentCollectionCommandFragmentDoc}`;
export type CreateCollectionForCollectionCommandMutationFn = Apollo.MutationFunction<CreateCollectionForCollectionCommandMutation, CreateCollectionForCollectionCommandMutationVariables>;

/**
 * __useCreateCollectionForCollectionCommandMutation__
 *
 * To run a mutation, you first call `useCreateCollectionForCollectionCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionForCollectionCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionForCollectionCommandMutation, { data, loading, error }] = useCreateCollectionForCollectionCommandMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCollectionForCollectionCommandMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionForCollectionCommandMutation, CreateCollectionForCollectionCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionForCollectionCommandMutation, CreateCollectionForCollectionCommandMutationVariables>(CreateCollectionForCollectionCommandDocument, options);
      }
export type CreateCollectionForCollectionCommandMutationHookResult = ReturnType<typeof useCreateCollectionForCollectionCommandMutation>;
export type CreateCollectionForCollectionCommandMutationResult = Apollo.MutationResult<CreateCollectionForCollectionCommandMutation>;
export type CreateCollectionForCollectionCommandMutationOptions = Apollo.BaseMutationOptions<CreateCollectionForCollectionCommandMutation, CreateCollectionForCollectionCommandMutationVariables>;
export const GetCollectionForCreateCollectionDialogHandlerDocument = gql`
    query GetCollectionForCreateCollectionDialogHandler($collectionId: String!) {
  collection(id: $collectionId) {
    id
    ...CollectionFragmentCollectionName
  }
}
    ${CollectionFragmentCollectionNameFragmentDoc}`;

/**
 * __useGetCollectionForCreateCollectionDialogHandlerQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCreateCollectionDialogHandlerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCreateCollectionDialogHandlerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCreateCollectionDialogHandlerQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForCreateCollectionDialogHandlerQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCreateCollectionDialogHandlerQuery, GetCollectionForCreateCollectionDialogHandlerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCreateCollectionDialogHandlerQuery, GetCollectionForCreateCollectionDialogHandlerQueryVariables>(GetCollectionForCreateCollectionDialogHandlerDocument, options);
      }
export function useGetCollectionForCreateCollectionDialogHandlerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCreateCollectionDialogHandlerQuery, GetCollectionForCreateCollectionDialogHandlerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCreateCollectionDialogHandlerQuery, GetCollectionForCreateCollectionDialogHandlerQueryVariables>(GetCollectionForCreateCollectionDialogHandlerDocument, options);
        }
export type GetCollectionForCreateCollectionDialogHandlerQueryHookResult = ReturnType<typeof useGetCollectionForCreateCollectionDialogHandlerQuery>;
export type GetCollectionForCreateCollectionDialogHandlerLazyQueryHookResult = ReturnType<typeof useGetCollectionForCreateCollectionDialogHandlerLazyQuery>;
export type GetCollectionForCreateCollectionDialogHandlerQueryResult = Apollo.QueryResult<GetCollectionForCreateCollectionDialogHandlerQuery, GetCollectionForCreateCollectionDialogHandlerQueryVariables>;
export const CreateContentIdeaForCreateContentIdeaHandlerDocument = gql`
    mutation CreateContentIdeaForCreateContentIdeaHandler($data: CreateContentIdeaInput!) {
  createContentIdea(data: $data) {
    id
  }
}
    `;
export type CreateContentIdeaForCreateContentIdeaHandlerMutationFn = Apollo.MutationFunction<CreateContentIdeaForCreateContentIdeaHandlerMutation, CreateContentIdeaForCreateContentIdeaHandlerMutationVariables>;

/**
 * __useCreateContentIdeaForCreateContentIdeaHandlerMutation__
 *
 * To run a mutation, you first call `useCreateContentIdeaForCreateContentIdeaHandlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentIdeaForCreateContentIdeaHandlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentIdeaForCreateContentIdeaHandlerMutation, { data, loading, error }] = useCreateContentIdeaForCreateContentIdeaHandlerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentIdeaForCreateContentIdeaHandlerMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentIdeaForCreateContentIdeaHandlerMutation, CreateContentIdeaForCreateContentIdeaHandlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentIdeaForCreateContentIdeaHandlerMutation, CreateContentIdeaForCreateContentIdeaHandlerMutationVariables>(CreateContentIdeaForCreateContentIdeaHandlerDocument, options);
      }
export type CreateContentIdeaForCreateContentIdeaHandlerMutationHookResult = ReturnType<typeof useCreateContentIdeaForCreateContentIdeaHandlerMutation>;
export type CreateContentIdeaForCreateContentIdeaHandlerMutationResult = Apollo.MutationResult<CreateContentIdeaForCreateContentIdeaHandlerMutation>;
export type CreateContentIdeaForCreateContentIdeaHandlerMutationOptions = Apollo.BaseMutationOptions<CreateContentIdeaForCreateContentIdeaHandlerMutation, CreateContentIdeaForCreateContentIdeaHandlerMutationVariables>;
export const ProcessPostsAfterCreationForPostAfterCreationHandlerDocument = gql`
    mutation ProcessPostsAfterCreationForPostAfterCreationHandler($data: ProcessPostsAfterCreationInput!) {
  processPostsAfterCreation(data: $data) {
    id
    ...PostFragmentPostCommand
  }
}
    ${PostFragmentPostCommandFragmentDoc}`;
export type ProcessPostsAfterCreationForPostAfterCreationHandlerMutationFn = Apollo.MutationFunction<ProcessPostsAfterCreationForPostAfterCreationHandlerMutation, ProcessPostsAfterCreationForPostAfterCreationHandlerMutationVariables>;

/**
 * __useProcessPostsAfterCreationForPostAfterCreationHandlerMutation__
 *
 * To run a mutation, you first call `useProcessPostsAfterCreationForPostAfterCreationHandlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPostsAfterCreationForPostAfterCreationHandlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPostsAfterCreationForPostAfterCreationHandlerMutation, { data, loading, error }] = useProcessPostsAfterCreationForPostAfterCreationHandlerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProcessPostsAfterCreationForPostAfterCreationHandlerMutation(baseOptions?: Apollo.MutationHookOptions<ProcessPostsAfterCreationForPostAfterCreationHandlerMutation, ProcessPostsAfterCreationForPostAfterCreationHandlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessPostsAfterCreationForPostAfterCreationHandlerMutation, ProcessPostsAfterCreationForPostAfterCreationHandlerMutationVariables>(ProcessPostsAfterCreationForPostAfterCreationHandlerDocument, options);
      }
export type ProcessPostsAfterCreationForPostAfterCreationHandlerMutationHookResult = ReturnType<typeof useProcessPostsAfterCreationForPostAfterCreationHandlerMutation>;
export type ProcessPostsAfterCreationForPostAfterCreationHandlerMutationResult = Apollo.MutationResult<ProcessPostsAfterCreationForPostAfterCreationHandlerMutation>;
export type ProcessPostsAfterCreationForPostAfterCreationHandlerMutationOptions = Apollo.BaseMutationOptions<ProcessPostsAfterCreationForPostAfterCreationHandlerMutation, ProcessPostsAfterCreationForPostAfterCreationHandlerMutationVariables>;
export const DeletePostForPostAfterCreationHandlerDocument = gql`
    mutation DeletePostForPostAfterCreationHandler($id: String!) {
  deletePost(id: $id) {
    message
    success
  }
}
    `;
export type DeletePostForPostAfterCreationHandlerMutationFn = Apollo.MutationFunction<DeletePostForPostAfterCreationHandlerMutation, DeletePostForPostAfterCreationHandlerMutationVariables>;

/**
 * __useDeletePostForPostAfterCreationHandlerMutation__
 *
 * To run a mutation, you first call `useDeletePostForPostAfterCreationHandlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostForPostAfterCreationHandlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostForPostAfterCreationHandlerMutation, { data, loading, error }] = useDeletePostForPostAfterCreationHandlerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostForPostAfterCreationHandlerMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostForPostAfterCreationHandlerMutation, DeletePostForPostAfterCreationHandlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostForPostAfterCreationHandlerMutation, DeletePostForPostAfterCreationHandlerMutationVariables>(DeletePostForPostAfterCreationHandlerDocument, options);
      }
export type DeletePostForPostAfterCreationHandlerMutationHookResult = ReturnType<typeof useDeletePostForPostAfterCreationHandlerMutation>;
export type DeletePostForPostAfterCreationHandlerMutationResult = Apollo.MutationResult<DeletePostForPostAfterCreationHandlerMutation>;
export type DeletePostForPostAfterCreationHandlerMutationOptions = Apollo.BaseMutationOptions<DeletePostForPostAfterCreationHandlerMutation, DeletePostForPostAfterCreationHandlerMutationVariables>;
export const GetCollectionForPostUploadFilesHandlerDocument = gql`
    query GetCollectionForPostUploadFilesHandler($id: String!) {
  collection(id: $id) {
    id
    organizationId
  }
}
    `;

/**
 * __useGetCollectionForPostUploadFilesHandlerQuery__
 *
 * To run a query within a React component, call `useGetCollectionForPostUploadFilesHandlerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForPostUploadFilesHandlerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForPostUploadFilesHandlerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionForPostUploadFilesHandlerQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForPostUploadFilesHandlerQuery, GetCollectionForPostUploadFilesHandlerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForPostUploadFilesHandlerQuery, GetCollectionForPostUploadFilesHandlerQueryVariables>(GetCollectionForPostUploadFilesHandlerDocument, options);
      }
export function useGetCollectionForPostUploadFilesHandlerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForPostUploadFilesHandlerQuery, GetCollectionForPostUploadFilesHandlerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForPostUploadFilesHandlerQuery, GetCollectionForPostUploadFilesHandlerQueryVariables>(GetCollectionForPostUploadFilesHandlerDocument, options);
        }
export type GetCollectionForPostUploadFilesHandlerQueryHookResult = ReturnType<typeof useGetCollectionForPostUploadFilesHandlerQuery>;
export type GetCollectionForPostUploadFilesHandlerLazyQueryHookResult = ReturnType<typeof useGetCollectionForPostUploadFilesHandlerLazyQuery>;
export type GetCollectionForPostUploadFilesHandlerQueryResult = Apollo.QueryResult<GetCollectionForPostUploadFilesHandlerQuery, GetCollectionForPostUploadFilesHandlerQueryVariables>;
export const CreateLinkPostForPostCommandDocument = gql`
    mutation CreateLinkPostForPostCommand($data: CreateLinkPostInput!) {
  createLinkPost(data: $data) {
    ...PostFragmentPostCommand
  }
}
    ${PostFragmentPostCommandFragmentDoc}`;
export type CreateLinkPostForPostCommandMutationFn = Apollo.MutationFunction<CreateLinkPostForPostCommandMutation, CreateLinkPostForPostCommandMutationVariables>;

/**
 * __useCreateLinkPostForPostCommandMutation__
 *
 * To run a mutation, you first call `useCreateLinkPostForPostCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkPostForPostCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkPostForPostCommandMutation, { data, loading, error }] = useCreateLinkPostForPostCommandMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLinkPostForPostCommandMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkPostForPostCommandMutation, CreateLinkPostForPostCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkPostForPostCommandMutation, CreateLinkPostForPostCommandMutationVariables>(CreateLinkPostForPostCommandDocument, options);
      }
export type CreateLinkPostForPostCommandMutationHookResult = ReturnType<typeof useCreateLinkPostForPostCommandMutation>;
export type CreateLinkPostForPostCommandMutationResult = Apollo.MutationResult<CreateLinkPostForPostCommandMutation>;
export type CreateLinkPostForPostCommandMutationOptions = Apollo.BaseMutationOptions<CreateLinkPostForPostCommandMutation, CreateLinkPostForPostCommandMutationVariables>;
export const CreateFilePostForPostCommandDocument = gql`
    mutation CreateFilePostForPostCommand($data: CreateFilePostInput!) {
  createFilePost(data: $data) {
    ...PostFragmentPostCommand
  }
}
    ${PostFragmentPostCommandFragmentDoc}`;
export type CreateFilePostForPostCommandMutationFn = Apollo.MutationFunction<CreateFilePostForPostCommandMutation, CreateFilePostForPostCommandMutationVariables>;

/**
 * __useCreateFilePostForPostCommandMutation__
 *
 * To run a mutation, you first call `useCreateFilePostForPostCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilePostForPostCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilePostForPostCommandMutation, { data, loading, error }] = useCreateFilePostForPostCommandMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFilePostForPostCommandMutation(baseOptions?: Apollo.MutationHookOptions<CreateFilePostForPostCommandMutation, CreateFilePostForPostCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFilePostForPostCommandMutation, CreateFilePostForPostCommandMutationVariables>(CreateFilePostForPostCommandDocument, options);
      }
export type CreateFilePostForPostCommandMutationHookResult = ReturnType<typeof useCreateFilePostForPostCommandMutation>;
export type CreateFilePostForPostCommandMutationResult = Apollo.MutationResult<CreateFilePostForPostCommandMutation>;
export type CreateFilePostForPostCommandMutationOptions = Apollo.BaseMutationOptions<CreateFilePostForPostCommandMutation, CreateFilePostForPostCommandMutationVariables>;
export const CreateNotePostForPostCommandDocument = gql`
    mutation CreateNotePostForPostCommand($data: CreateNotePostInput!) {
  createNotePost(data: $data) {
    ...PostFragmentPostCommand
  }
}
    ${PostFragmentPostCommandFragmentDoc}`;
export type CreateNotePostForPostCommandMutationFn = Apollo.MutationFunction<CreateNotePostForPostCommandMutation, CreateNotePostForPostCommandMutationVariables>;

/**
 * __useCreateNotePostForPostCommandMutation__
 *
 * To run a mutation, you first call `useCreateNotePostForPostCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotePostForPostCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotePostForPostCommandMutation, { data, loading, error }] = useCreateNotePostForPostCommandMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNotePostForPostCommandMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotePostForPostCommandMutation, CreateNotePostForPostCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotePostForPostCommandMutation, CreateNotePostForPostCommandMutationVariables>(CreateNotePostForPostCommandDocument, options);
      }
export type CreateNotePostForPostCommandMutationHookResult = ReturnType<typeof useCreateNotePostForPostCommandMutation>;
export type CreateNotePostForPostCommandMutationResult = Apollo.MutationResult<CreateNotePostForPostCommandMutation>;
export type CreateNotePostForPostCommandMutationOptions = Apollo.BaseMutationOptions<CreateNotePostForPostCommandMutation, CreateNotePostForPostCommandMutationVariables>;
export const GlobalSearchResultsDocument = gql`
    query GlobalSearchResults($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    ...UniversalSearchFragmentSearchHandler
  }
}
    ${UniversalSearchFragmentSearchHandlerFragmentDoc}`;

/**
 * __useGlobalSearchResultsQuery__
 *
 * To run a query within a React component, call `useGlobalSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchResultsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGlobalSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<GlobalSearchResultsQuery, GlobalSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalSearchResultsQuery, GlobalSearchResultsQueryVariables>(GlobalSearchResultsDocument, options);
      }
export function useGlobalSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalSearchResultsQuery, GlobalSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalSearchResultsQuery, GlobalSearchResultsQueryVariables>(GlobalSearchResultsDocument, options);
        }
export type GlobalSearchResultsQueryHookResult = ReturnType<typeof useGlobalSearchResultsQuery>;
export type GlobalSearchResultsLazyQueryHookResult = ReturnType<typeof useGlobalSearchResultsLazyQuery>;
export type GlobalSearchResultsQueryResult = Apollo.QueryResult<GlobalSearchResultsQuery, GlobalSearchResultsQueryVariables>;
export const GetAllRecentSearchesClickedQueryDocument = gql`
    query GetAllRecentSearchesClickedQuery($searchableEntityTypes: [SearchableEntityType!]!, $take: Int) {
  getSearchesClicked(searchableEntityTypes: $searchableEntityTypes, take: $take) {
    data {
      ...SearchClickedResultFragmentSearchRecent
    }
  }
}
    ${SearchClickedResultFragmentSearchRecentFragmentDoc}`;

/**
 * __useGetAllRecentSearchesClickedQueryQuery__
 *
 * To run a query within a React component, call `useGetAllRecentSearchesClickedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRecentSearchesClickedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRecentSearchesClickedQueryQuery({
 *   variables: {
 *      searchableEntityTypes: // value for 'searchableEntityTypes'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllRecentSearchesClickedQueryQuery(baseOptions: Apollo.QueryHookOptions<GetAllRecentSearchesClickedQueryQuery, GetAllRecentSearchesClickedQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRecentSearchesClickedQueryQuery, GetAllRecentSearchesClickedQueryQueryVariables>(GetAllRecentSearchesClickedQueryDocument, options);
      }
export function useGetAllRecentSearchesClickedQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRecentSearchesClickedQueryQuery, GetAllRecentSearchesClickedQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRecentSearchesClickedQueryQuery, GetAllRecentSearchesClickedQueryQueryVariables>(GetAllRecentSearchesClickedQueryDocument, options);
        }
export type GetAllRecentSearchesClickedQueryQueryHookResult = ReturnType<typeof useGetAllRecentSearchesClickedQueryQuery>;
export type GetAllRecentSearchesClickedQueryLazyQueryHookResult = ReturnType<typeof useGetAllRecentSearchesClickedQueryLazyQuery>;
export type GetAllRecentSearchesClickedQueryQueryResult = Apollo.QueryResult<GetAllRecentSearchesClickedQueryQuery, GetAllRecentSearchesClickedQueryQueryVariables>;
export const CreateTaskForCreateTaskModalDocument = gql`
    mutation CreateTaskForCreateTaskModal($data: CreateTaskInput!) {
  createTask(data: $data) {
    ...TaskFragmentCreateTaskModal
  }
}
    ${TaskFragmentCreateTaskModalFragmentDoc}`;
export type CreateTaskForCreateTaskModalMutationFn = Apollo.MutationFunction<CreateTaskForCreateTaskModalMutation, CreateTaskForCreateTaskModalMutationVariables>;

/**
 * __useCreateTaskForCreateTaskModalMutation__
 *
 * To run a mutation, you first call `useCreateTaskForCreateTaskModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskForCreateTaskModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskForCreateTaskModalMutation, { data, loading, error }] = useCreateTaskForCreateTaskModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTaskForCreateTaskModalMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskForCreateTaskModalMutation, CreateTaskForCreateTaskModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskForCreateTaskModalMutation, CreateTaskForCreateTaskModalMutationVariables>(CreateTaskForCreateTaskModalDocument, options);
      }
export type CreateTaskForCreateTaskModalMutationHookResult = ReturnType<typeof useCreateTaskForCreateTaskModalMutation>;
export type CreateTaskForCreateTaskModalMutationResult = Apollo.MutationResult<CreateTaskForCreateTaskModalMutation>;
export type CreateTaskForCreateTaskModalMutationOptions = Apollo.BaseMutationOptions<CreateTaskForCreateTaskModalMutation, CreateTaskForCreateTaskModalMutationVariables>;
export const GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsDocument = gql`
    query GetMyPendingOrganizationAccessRequestsForAdminForPendingActions {
  myPendingOrganizationAccessRequestsForAdmin {
    id
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery__
 *
 * To run a query within a React component, call `useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery, GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery, GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryVariables>(GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsDocument, options);
      }
export function useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery, GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery, GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryVariables>(GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsDocument, options);
        }
export type GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryHookResult = ReturnType<typeof useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery>;
export type GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsLazyQueryHookResult = ReturnType<typeof useGetMyPendingOrganizationAccessRequestsForAdminForPendingActionsLazyQuery>;
export type GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryResult = Apollo.QueryResult<GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQuery, GetMyPendingOrganizationAccessRequestsForAdminForPendingActionsQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    ...MeFragmentUserQueries
  }
}
    ${MeFragmentUserQueriesFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const RefreshTokenAppDocument = gql`
    mutation RefreshTokenApp($token: JWT!) {
  refreshToken(token: $token) {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenAppMutationFn = Apollo.MutationFunction<RefreshTokenAppMutation, RefreshTokenAppMutationVariables>;

/**
 * __useRefreshTokenAppMutation__
 *
 * To run a mutation, you first call `useRefreshTokenAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenAppMutation, { data, loading, error }] = useRefreshTokenAppMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRefreshTokenAppMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenAppMutation, RefreshTokenAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenAppMutation, RefreshTokenAppMutationVariables>(RefreshTokenAppDocument, options);
      }
export type RefreshTokenAppMutationHookResult = ReturnType<typeof useRefreshTokenAppMutation>;
export type RefreshTokenAppMutationResult = Apollo.MutationResult<RefreshTokenAppMutation>;
export type RefreshTokenAppMutationOptions = Apollo.BaseMutationOptions<RefreshTokenAppMutation, RefreshTokenAppMutationVariables>;
export const CreateOrganizationAccessRequestDocument = gql`
    mutation CreateOrganizationAccessRequest($data: CreateOrganizationUserAccessRequestInput!) {
  createOrganizationAccessRequest(data: $data) {
    id
    message
    status
    createdAt
    updatedAt
  }
}
    `;
export type CreateOrganizationAccessRequestMutationFn = Apollo.MutationFunction<CreateOrganizationAccessRequestMutation, CreateOrganizationAccessRequestMutationVariables>;

/**
 * __useCreateOrganizationAccessRequestMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAccessRequestMutation, { data, loading, error }] = useCreateOrganizationAccessRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationAccessRequestMutation, CreateOrganizationAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationAccessRequestMutation, CreateOrganizationAccessRequestMutationVariables>(CreateOrganizationAccessRequestDocument, options);
      }
export type CreateOrganizationAccessRequestMutationHookResult = ReturnType<typeof useCreateOrganizationAccessRequestMutation>;
export type CreateOrganizationAccessRequestMutationResult = Apollo.MutationResult<CreateOrganizationAccessRequestMutation>;
export type CreateOrganizationAccessRequestMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationAccessRequestMutation, CreateOrganizationAccessRequestMutationVariables>;
export const GetMyOrganizationAccessRequestsDocument = gql`
    query GetMyOrganizationAccessRequests {
  myOrganizationAccessRequests {
    id
    message
    status
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetMyOrganizationAccessRequestsQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationAccessRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrganizationAccessRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrganizationAccessRequestsQuery, GetMyOrganizationAccessRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrganizationAccessRequestsQuery, GetMyOrganizationAccessRequestsQueryVariables>(GetMyOrganizationAccessRequestsDocument, options);
      }
export function useGetMyOrganizationAccessRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrganizationAccessRequestsQuery, GetMyOrganizationAccessRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrganizationAccessRequestsQuery, GetMyOrganizationAccessRequestsQueryVariables>(GetMyOrganizationAccessRequestsDocument, options);
        }
export type GetMyOrganizationAccessRequestsQueryHookResult = ReturnType<typeof useGetMyOrganizationAccessRequestsQuery>;
export type GetMyOrganizationAccessRequestsLazyQueryHookResult = ReturnType<typeof useGetMyOrganizationAccessRequestsLazyQuery>;
export type GetMyOrganizationAccessRequestsQueryResult = Apollo.QueryResult<GetMyOrganizationAccessRequestsQuery, GetMyOrganizationAccessRequestsQueryVariables>;
export const ApproveOrganizationAccessRequestDocument = gql`
    mutation ApproveOrganizationAccessRequest($data: ApproveOrganizationUserAccessRequestInput!) {
  approveOrganizationAccessRequest(data: $data) {
    ...OrganizationUserAccessRequestFragmentAccessRequestHandlers
  }
}
    ${OrganizationUserAccessRequestFragmentAccessRequestHandlersFragmentDoc}`;
export type ApproveOrganizationAccessRequestMutationFn = Apollo.MutationFunction<ApproveOrganizationAccessRequestMutation, ApproveOrganizationAccessRequestMutationVariables>;

/**
 * __useApproveOrganizationAccessRequestMutation__
 *
 * To run a mutation, you first call `useApproveOrganizationAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrganizationAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrganizationAccessRequestMutation, { data, loading, error }] = useApproveOrganizationAccessRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApproveOrganizationAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrganizationAccessRequestMutation, ApproveOrganizationAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrganizationAccessRequestMutation, ApproveOrganizationAccessRequestMutationVariables>(ApproveOrganizationAccessRequestDocument, options);
      }
export type ApproveOrganizationAccessRequestMutationHookResult = ReturnType<typeof useApproveOrganizationAccessRequestMutation>;
export type ApproveOrganizationAccessRequestMutationResult = Apollo.MutationResult<ApproveOrganizationAccessRequestMutation>;
export type ApproveOrganizationAccessRequestMutationOptions = Apollo.BaseMutationOptions<ApproveOrganizationAccessRequestMutation, ApproveOrganizationAccessRequestMutationVariables>;
export const ApproveOrganizationAccessRequestForEnterpriseOrgDocument = gql`
    mutation ApproveOrganizationAccessRequestForEnterpriseOrg($data: ApproveOrganizationUserAccessRequestWithRoleInput!) {
  approveOrganizationAccessRequestForEnterpriseOrg(data: $data) {
    ...OrganizationUserAccessRequestFragmentAccessRequestHandlers
  }
}
    ${OrganizationUserAccessRequestFragmentAccessRequestHandlersFragmentDoc}`;
export type ApproveOrganizationAccessRequestForEnterpriseOrgMutationFn = Apollo.MutationFunction<ApproveOrganizationAccessRequestForEnterpriseOrgMutation, ApproveOrganizationAccessRequestForEnterpriseOrgMutationVariables>;

/**
 * __useApproveOrganizationAccessRequestForEnterpriseOrgMutation__
 *
 * To run a mutation, you first call `useApproveOrganizationAccessRequestForEnterpriseOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrganizationAccessRequestForEnterpriseOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrganizationAccessRequestForEnterpriseOrgMutation, { data, loading, error }] = useApproveOrganizationAccessRequestForEnterpriseOrgMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApproveOrganizationAccessRequestForEnterpriseOrgMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrganizationAccessRequestForEnterpriseOrgMutation, ApproveOrganizationAccessRequestForEnterpriseOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrganizationAccessRequestForEnterpriseOrgMutation, ApproveOrganizationAccessRequestForEnterpriseOrgMutationVariables>(ApproveOrganizationAccessRequestForEnterpriseOrgDocument, options);
      }
export type ApproveOrganizationAccessRequestForEnterpriseOrgMutationHookResult = ReturnType<typeof useApproveOrganizationAccessRequestForEnterpriseOrgMutation>;
export type ApproveOrganizationAccessRequestForEnterpriseOrgMutationResult = Apollo.MutationResult<ApproveOrganizationAccessRequestForEnterpriseOrgMutation>;
export type ApproveOrganizationAccessRequestForEnterpriseOrgMutationOptions = Apollo.BaseMutationOptions<ApproveOrganizationAccessRequestForEnterpriseOrgMutation, ApproveOrganizationAccessRequestForEnterpriseOrgMutationVariables>;
export const ApproveOrganizationAccessRequestsDocument = gql`
    mutation ApproveOrganizationAccessRequests($data: ApproveOrganizationUserAccessRequestsInput!) {
  approveOrganizationAccessRequests(data: $data) {
    ...OrganizationUserAccessRequestFragmentAccessRequestHandlers
  }
}
    ${OrganizationUserAccessRequestFragmentAccessRequestHandlersFragmentDoc}`;
export type ApproveOrganizationAccessRequestsMutationFn = Apollo.MutationFunction<ApproveOrganizationAccessRequestsMutation, ApproveOrganizationAccessRequestsMutationVariables>;

/**
 * __useApproveOrganizationAccessRequestsMutation__
 *
 * To run a mutation, you first call `useApproveOrganizationAccessRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrganizationAccessRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrganizationAccessRequestsMutation, { data, loading, error }] = useApproveOrganizationAccessRequestsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApproveOrganizationAccessRequestsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrganizationAccessRequestsMutation, ApproveOrganizationAccessRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrganizationAccessRequestsMutation, ApproveOrganizationAccessRequestsMutationVariables>(ApproveOrganizationAccessRequestsDocument, options);
      }
export type ApproveOrganizationAccessRequestsMutationHookResult = ReturnType<typeof useApproveOrganizationAccessRequestsMutation>;
export type ApproveOrganizationAccessRequestsMutationResult = Apollo.MutationResult<ApproveOrganizationAccessRequestsMutation>;
export type ApproveOrganizationAccessRequestsMutationOptions = Apollo.BaseMutationOptions<ApproveOrganizationAccessRequestsMutation, ApproveOrganizationAccessRequestsMutationVariables>;
export const RejectOrganizationAccessRequestDocument = gql`
    mutation RejectOrganizationAccessRequest($data: RejectOrganizationUserAccessRequestInput!) {
  rejectOrganizationAccessRequest(data: $data) {
    ...OrganizationUserAccessRequestFragmentAccessRequestHandlers
  }
}
    ${OrganizationUserAccessRequestFragmentAccessRequestHandlersFragmentDoc}`;
export type RejectOrganizationAccessRequestMutationFn = Apollo.MutationFunction<RejectOrganizationAccessRequestMutation, RejectOrganizationAccessRequestMutationVariables>;

/**
 * __useRejectOrganizationAccessRequestMutation__
 *
 * To run a mutation, you first call `useRejectOrganizationAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectOrganizationAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectOrganizationAccessRequestMutation, { data, loading, error }] = useRejectOrganizationAccessRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRejectOrganizationAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectOrganizationAccessRequestMutation, RejectOrganizationAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectOrganizationAccessRequestMutation, RejectOrganizationAccessRequestMutationVariables>(RejectOrganizationAccessRequestDocument, options);
      }
export type RejectOrganizationAccessRequestMutationHookResult = ReturnType<typeof useRejectOrganizationAccessRequestMutation>;
export type RejectOrganizationAccessRequestMutationResult = Apollo.MutationResult<RejectOrganizationAccessRequestMutation>;
export type RejectOrganizationAccessRequestMutationOptions = Apollo.BaseMutationOptions<RejectOrganizationAccessRequestMutation, RejectOrganizationAccessRequestMutationVariables>;
export const GetCollectionByIdsForAiOrganizeCollectionListDocument = gql`
    query GetCollectionByIdsForAiOrganizeCollectionList($input: GetCollectionByIdsInput!) {
  collectionByIds(input: $input) {
    ...CollectionFragmentAiOrganizeCollectionList
  }
}
    ${CollectionFragmentAiOrganizeCollectionListFragmentDoc}`;

/**
 * __useGetCollectionByIdsForAiOrganizeCollectionListQuery__
 *
 * To run a query within a React component, call `useGetCollectionByIdsForAiOrganizeCollectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionByIdsForAiOrganizeCollectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionByIdsForAiOrganizeCollectionListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCollectionByIdsForAiOrganizeCollectionListQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionByIdsForAiOrganizeCollectionListQuery, GetCollectionByIdsForAiOrganizeCollectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionByIdsForAiOrganizeCollectionListQuery, GetCollectionByIdsForAiOrganizeCollectionListQueryVariables>(GetCollectionByIdsForAiOrganizeCollectionListDocument, options);
      }
export function useGetCollectionByIdsForAiOrganizeCollectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionByIdsForAiOrganizeCollectionListQuery, GetCollectionByIdsForAiOrganizeCollectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionByIdsForAiOrganizeCollectionListQuery, GetCollectionByIdsForAiOrganizeCollectionListQueryVariables>(GetCollectionByIdsForAiOrganizeCollectionListDocument, options);
        }
export type GetCollectionByIdsForAiOrganizeCollectionListQueryHookResult = ReturnType<typeof useGetCollectionByIdsForAiOrganizeCollectionListQuery>;
export type GetCollectionByIdsForAiOrganizeCollectionListLazyQueryHookResult = ReturnType<typeof useGetCollectionByIdsForAiOrganizeCollectionListLazyQuery>;
export type GetCollectionByIdsForAiOrganizeCollectionListQueryResult = Apollo.QueryResult<GetCollectionByIdsForAiOrganizeCollectionListQuery, GetCollectionByIdsForAiOrganizeCollectionListQueryVariables>;
export const UpdateUserOnboardingStateForAiOrganizeWalkthroughViewDocument = gql`
    mutation UpdateUserOnboardingStateForAiOrganizeWalkthroughView($data: UpdateUserOnboardingStateInput!) {
  updateUserOnboardingState(data: $data) {
    id
    onboardingState {
      haveOnboardedAiOrganize
    }
  }
}
    `;
export type UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationFn = Apollo.MutationFunction<UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation, UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationVariables>;

/**
 * __useUpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingStateForAiOrganizeWalkthroughViewMutation, { data, loading, error }] = useUpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation, UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation, UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationVariables>(UpdateUserOnboardingStateForAiOrganizeWalkthroughViewDocument, options);
      }
export type UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationHookResult = ReturnType<typeof useUpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation>;
export type UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationResult = Apollo.MutationResult<UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation>;
export type UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutation, UpdateUserOnboardingStateForAiOrganizeWalkthroughViewMutationVariables>;
export const GetSuggestedPostsForBillingAiOrganizePaywallDocument = gql`
    query GetSuggestedPostsForBillingAiOrganizePaywall {
  suggestedPostsForUser {
    ...PostFragmentBillingAiOrganizePaywall
  }
}
    ${PostFragmentBillingAiOrganizePaywallFragmentDoc}`;

/**
 * __useGetSuggestedPostsForBillingAiOrganizePaywallQuery__
 *
 * To run a query within a React component, call `useGetSuggestedPostsForBillingAiOrganizePaywallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedPostsForBillingAiOrganizePaywallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedPostsForBillingAiOrganizePaywallQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuggestedPostsForBillingAiOrganizePaywallQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestedPostsForBillingAiOrganizePaywallQuery, GetSuggestedPostsForBillingAiOrganizePaywallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedPostsForBillingAiOrganizePaywallQuery, GetSuggestedPostsForBillingAiOrganizePaywallQueryVariables>(GetSuggestedPostsForBillingAiOrganizePaywallDocument, options);
      }
export function useGetSuggestedPostsForBillingAiOrganizePaywallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedPostsForBillingAiOrganizePaywallQuery, GetSuggestedPostsForBillingAiOrganizePaywallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedPostsForBillingAiOrganizePaywallQuery, GetSuggestedPostsForBillingAiOrganizePaywallQueryVariables>(GetSuggestedPostsForBillingAiOrganizePaywallDocument, options);
        }
export type GetSuggestedPostsForBillingAiOrganizePaywallQueryHookResult = ReturnType<typeof useGetSuggestedPostsForBillingAiOrganizePaywallQuery>;
export type GetSuggestedPostsForBillingAiOrganizePaywallLazyQueryHookResult = ReturnType<typeof useGetSuggestedPostsForBillingAiOrganizePaywallLazyQuery>;
export type GetSuggestedPostsForBillingAiOrganizePaywallQueryResult = Apollo.QueryResult<GetSuggestedPostsForBillingAiOrganizePaywallQuery, GetSuggestedPostsForBillingAiOrganizePaywallQueryVariables>;
export const SetHasSeenFreeTrialEndedForBillingFreeTrialEndedDocument = gql`
    mutation SetHasSeenFreeTrialEndedForBillingFreeTrialEnded {
  setHasSeenFreeTrialEnded {
    id
  }
}
    `;
export type SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationFn = Apollo.MutationFunction<SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation, SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationVariables>;

/**
 * __useSetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation__
 *
 * To run a mutation, you first call `useSetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation, { data, loading, error }] = useSetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation(baseOptions?: Apollo.MutationHookOptions<SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation, SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation, SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationVariables>(SetHasSeenFreeTrialEndedForBillingFreeTrialEndedDocument, options);
      }
export type SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationHookResult = ReturnType<typeof useSetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation>;
export type SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationResult = Apollo.MutationResult<SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation>;
export type SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationOptions = Apollo.BaseMutationOptions<SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutation, SetHasSeenFreeTrialEndedForBillingFreeTrialEndedMutationVariables>;
export const GetBrandsParsedHoursForBillingHourUsageProgressDocument = gql`
    query GetBrandsParsedHoursForBillingHourUsageProgress($totalHoursParsedData: BrandHoursParsedInput) {
  me {
    id
    organization {
      id
      billing {
        id
        brandHoursParseLimit
      }
      socialListeningBrands {
        id
        name
        totalHoursParsedCount(data: $totalHoursParsedData)
      }
    }
  }
}
    `;

/**
 * __useGetBrandsParsedHoursForBillingHourUsageProgressQuery__
 *
 * To run a query within a React component, call `useGetBrandsParsedHoursForBillingHourUsageProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsParsedHoursForBillingHourUsageProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsParsedHoursForBillingHourUsageProgressQuery({
 *   variables: {
 *      totalHoursParsedData: // value for 'totalHoursParsedData'
 *   },
 * });
 */
export function useGetBrandsParsedHoursForBillingHourUsageProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetBrandsParsedHoursForBillingHourUsageProgressQuery, GetBrandsParsedHoursForBillingHourUsageProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsParsedHoursForBillingHourUsageProgressQuery, GetBrandsParsedHoursForBillingHourUsageProgressQueryVariables>(GetBrandsParsedHoursForBillingHourUsageProgressDocument, options);
      }
export function useGetBrandsParsedHoursForBillingHourUsageProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsParsedHoursForBillingHourUsageProgressQuery, GetBrandsParsedHoursForBillingHourUsageProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsParsedHoursForBillingHourUsageProgressQuery, GetBrandsParsedHoursForBillingHourUsageProgressQueryVariables>(GetBrandsParsedHoursForBillingHourUsageProgressDocument, options);
        }
export type GetBrandsParsedHoursForBillingHourUsageProgressQueryHookResult = ReturnType<typeof useGetBrandsParsedHoursForBillingHourUsageProgressQuery>;
export type GetBrandsParsedHoursForBillingHourUsageProgressLazyQueryHookResult = ReturnType<typeof useGetBrandsParsedHoursForBillingHourUsageProgressLazyQuery>;
export type GetBrandsParsedHoursForBillingHourUsageProgressQueryResult = Apollo.QueryResult<GetBrandsParsedHoursForBillingHourUsageProgressQuery, GetBrandsParsedHoursForBillingHourUsageProgressQueryVariables>;
export const DowngradeToFreePlanForNewPricingDocument = gql`
    mutation DowngradeToFreePlanForNewPricing {
  downgradeToFreePlan {
    id
  }
}
    `;
export type DowngradeToFreePlanForNewPricingMutationFn = Apollo.MutationFunction<DowngradeToFreePlanForNewPricingMutation, DowngradeToFreePlanForNewPricingMutationVariables>;

/**
 * __useDowngradeToFreePlanForNewPricingMutation__
 *
 * To run a mutation, you first call `useDowngradeToFreePlanForNewPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDowngradeToFreePlanForNewPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downgradeToFreePlanForNewPricingMutation, { data, loading, error }] = useDowngradeToFreePlanForNewPricingMutation({
 *   variables: {
 *   },
 * });
 */
export function useDowngradeToFreePlanForNewPricingMutation(baseOptions?: Apollo.MutationHookOptions<DowngradeToFreePlanForNewPricingMutation, DowngradeToFreePlanForNewPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DowngradeToFreePlanForNewPricingMutation, DowngradeToFreePlanForNewPricingMutationVariables>(DowngradeToFreePlanForNewPricingDocument, options);
      }
export type DowngradeToFreePlanForNewPricingMutationHookResult = ReturnType<typeof useDowngradeToFreePlanForNewPricingMutation>;
export type DowngradeToFreePlanForNewPricingMutationResult = Apollo.MutationResult<DowngradeToFreePlanForNewPricingMutation>;
export type DowngradeToFreePlanForNewPricingMutationOptions = Apollo.BaseMutationOptions<DowngradeToFreePlanForNewPricingMutation, DowngradeToFreePlanForNewPricingMutationVariables>;
export const GetBillingAvailablePricesDocument = gql`
    query GetBillingAvailablePrices {
  getAvailablePrices {
    name
    productId
    prices {
      id
      currency
      recurringInterval
      amount
      unitAmountDecimal
    }
  }
}
    `;

/**
 * __useGetBillingAvailablePricesQuery__
 *
 * To run a query within a React component, call `useGetBillingAvailablePricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingAvailablePricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingAvailablePricesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingAvailablePricesQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingAvailablePricesQuery, GetBillingAvailablePricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingAvailablePricesQuery, GetBillingAvailablePricesQueryVariables>(GetBillingAvailablePricesDocument, options);
      }
export function useGetBillingAvailablePricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingAvailablePricesQuery, GetBillingAvailablePricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingAvailablePricesQuery, GetBillingAvailablePricesQueryVariables>(GetBillingAvailablePricesDocument, options);
        }
export type GetBillingAvailablePricesQueryHookResult = ReturnType<typeof useGetBillingAvailablePricesQuery>;
export type GetBillingAvailablePricesLazyQueryHookResult = ReturnType<typeof useGetBillingAvailablePricesLazyQuery>;
export type GetBillingAvailablePricesQueryResult = Apollo.QueryResult<GetBillingAvailablePricesQuery, GetBillingAvailablePricesQueryVariables>;
export const CreateFreeTrialSubscriptionDocument = gql`
    mutation createFreeTrialSubscription($planName: String!) {
  createFreeTrialSubscription(planName: $planName) {
    id
  }
}
    `;
export type CreateFreeTrialSubscriptionMutationFn = Apollo.MutationFunction<CreateFreeTrialSubscriptionMutation, CreateFreeTrialSubscriptionMutationVariables>;

/**
 * __useCreateFreeTrialSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateFreeTrialSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFreeTrialSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFreeTrialSubscriptionMutation, { data, loading, error }] = useCreateFreeTrialSubscriptionMutation({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useCreateFreeTrialSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFreeTrialSubscriptionMutation, CreateFreeTrialSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFreeTrialSubscriptionMutation, CreateFreeTrialSubscriptionMutationVariables>(CreateFreeTrialSubscriptionDocument, options);
      }
export type CreateFreeTrialSubscriptionMutationHookResult = ReturnType<typeof useCreateFreeTrialSubscriptionMutation>;
export type CreateFreeTrialSubscriptionMutationResult = Apollo.MutationResult<CreateFreeTrialSubscriptionMutation>;
export type CreateFreeTrialSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateFreeTrialSubscriptionMutation, CreateFreeTrialSubscriptionMutationVariables>;
export const NotifyAdminForBillingDocument = gql`
    mutation NotifyAdminForBilling {
  notifyAdminForBilling {
    success
    message
  }
}
    `;
export type NotifyAdminForBillingMutationFn = Apollo.MutationFunction<NotifyAdminForBillingMutation, NotifyAdminForBillingMutationVariables>;

/**
 * __useNotifyAdminForBillingMutation__
 *
 * To run a mutation, you first call `useNotifyAdminForBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyAdminForBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyAdminForBillingMutation, { data, loading, error }] = useNotifyAdminForBillingMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotifyAdminForBillingMutation(baseOptions?: Apollo.MutationHookOptions<NotifyAdminForBillingMutation, NotifyAdminForBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyAdminForBillingMutation, NotifyAdminForBillingMutationVariables>(NotifyAdminForBillingDocument, options);
      }
export type NotifyAdminForBillingMutationHookResult = ReturnType<typeof useNotifyAdminForBillingMutation>;
export type NotifyAdminForBillingMutationResult = Apollo.MutationResult<NotifyAdminForBillingMutation>;
export type NotifyAdminForBillingMutationOptions = Apollo.BaseMutationOptions<NotifyAdminForBillingMutation, NotifyAdminForBillingMutationVariables>;
export const RequestAdminToUpgradeDocument = gql`
    mutation RequestAdminToUpgrade($data: RequestAdminToUpgradeInput!) {
  requestAdminToUpgrade(data: $data) {
    success
    message
  }
}
    `;
export type RequestAdminToUpgradeMutationFn = Apollo.MutationFunction<RequestAdminToUpgradeMutation, RequestAdminToUpgradeMutationVariables>;

/**
 * __useRequestAdminToUpgradeMutation__
 *
 * To run a mutation, you first call `useRequestAdminToUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAdminToUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAdminToUpgradeMutation, { data, loading, error }] = useRequestAdminToUpgradeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestAdminToUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<RequestAdminToUpgradeMutation, RequestAdminToUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAdminToUpgradeMutation, RequestAdminToUpgradeMutationVariables>(RequestAdminToUpgradeDocument, options);
      }
export type RequestAdminToUpgradeMutationHookResult = ReturnType<typeof useRequestAdminToUpgradeMutation>;
export type RequestAdminToUpgradeMutationResult = Apollo.MutationResult<RequestAdminToUpgradeMutation>;
export type RequestAdminToUpgradeMutationOptions = Apollo.BaseMutationOptions<RequestAdminToUpgradeMutation, RequestAdminToUpgradeMutationVariables>;
export const GetBillingPlanDocument = gql`
    query GetBillingPlan($plan: String!) {
  billingPlan(plan: $plan) {
    name
    numberOfTrialDays
    organizationMemberLimit
  }
}
    `;

/**
 * __useGetBillingPlanQuery__
 *
 * To run a query within a React component, call `useGetBillingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingPlanQuery({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useGetBillingPlanQuery(baseOptions: Apollo.QueryHookOptions<GetBillingPlanQuery, GetBillingPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingPlanQuery, GetBillingPlanQueryVariables>(GetBillingPlanDocument, options);
      }
export function useGetBillingPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingPlanQuery, GetBillingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingPlanQuery, GetBillingPlanQueryVariables>(GetBillingPlanDocument, options);
        }
export type GetBillingPlanQueryHookResult = ReturnType<typeof useGetBillingPlanQuery>;
export type GetBillingPlanLazyQueryHookResult = ReturnType<typeof useGetBillingPlanLazyQuery>;
export type GetBillingPlanQueryResult = Apollo.QueryResult<GetBillingPlanQuery, GetBillingPlanQueryVariables>;
export const DeleteBookmarkForBookmarkHandlersDocument = gql`
    mutation DeleteBookmarkForBookmarkHandlers($deleteBookmarkId: String!) {
  deleteBookmark(id: $deleteBookmarkId) {
    message
    success
  }
}
    `;
export type DeleteBookmarkForBookmarkHandlersMutationFn = Apollo.MutationFunction<DeleteBookmarkForBookmarkHandlersMutation, DeleteBookmarkForBookmarkHandlersMutationVariables>;

/**
 * __useDeleteBookmarkForBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkForBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkForBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkForBookmarkHandlersMutation, { data, loading, error }] = useDeleteBookmarkForBookmarkHandlersMutation({
 *   variables: {
 *      deleteBookmarkId: // value for 'deleteBookmarkId'
 *   },
 * });
 */
export function useDeleteBookmarkForBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkForBookmarkHandlersMutation, DeleteBookmarkForBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkForBookmarkHandlersMutation, DeleteBookmarkForBookmarkHandlersMutationVariables>(DeleteBookmarkForBookmarkHandlersDocument, options);
      }
export type DeleteBookmarkForBookmarkHandlersMutationHookResult = ReturnType<typeof useDeleteBookmarkForBookmarkHandlersMutation>;
export type DeleteBookmarkForBookmarkHandlersMutationResult = Apollo.MutationResult<DeleteBookmarkForBookmarkHandlersMutation>;
export type DeleteBookmarkForBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkForBookmarkHandlersMutation, DeleteBookmarkForBookmarkHandlersMutationVariables>;
export const GetBookmarksForBookmarkHandlersDocument = gql`
    query GetBookmarksForBookmarkHandlers {
  bookmarks {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;

/**
 * __useGetBookmarksForBookmarkHandlersQuery__
 *
 * To run a query within a React component, call `useGetBookmarksForBookmarkHandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarksForBookmarkHandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarksForBookmarkHandlersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookmarksForBookmarkHandlersQuery(baseOptions?: Apollo.QueryHookOptions<GetBookmarksForBookmarkHandlersQuery, GetBookmarksForBookmarkHandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookmarksForBookmarkHandlersQuery, GetBookmarksForBookmarkHandlersQueryVariables>(GetBookmarksForBookmarkHandlersDocument, options);
      }
export function useGetBookmarksForBookmarkHandlersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookmarksForBookmarkHandlersQuery, GetBookmarksForBookmarkHandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookmarksForBookmarkHandlersQuery, GetBookmarksForBookmarkHandlersQueryVariables>(GetBookmarksForBookmarkHandlersDocument, options);
        }
export type GetBookmarksForBookmarkHandlersQueryHookResult = ReturnType<typeof useGetBookmarksForBookmarkHandlersQuery>;
export type GetBookmarksForBookmarkHandlersLazyQueryHookResult = ReturnType<typeof useGetBookmarksForBookmarkHandlersLazyQuery>;
export type GetBookmarksForBookmarkHandlersQueryResult = Apollo.QueryResult<GetBookmarksForBookmarkHandlersQuery, GetBookmarksForBookmarkHandlersQueryVariables>;
export const PauseBrandForBrandPauseContextMenuDocument = gql`
    mutation PauseBrandForBrandPauseContextMenu($data: PauseBrandInput!) {
  pauseBrand(data: $data) {
    id
    ...BrandFragmentBrandPauseContextMenu
  }
}
    ${BrandFragmentBrandPauseContextMenuFragmentDoc}`;
export type PauseBrandForBrandPauseContextMenuMutationFn = Apollo.MutationFunction<PauseBrandForBrandPauseContextMenuMutation, PauseBrandForBrandPauseContextMenuMutationVariables>;

/**
 * __usePauseBrandForBrandPauseContextMenuMutation__
 *
 * To run a mutation, you first call `usePauseBrandForBrandPauseContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseBrandForBrandPauseContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseBrandForBrandPauseContextMenuMutation, { data, loading, error }] = usePauseBrandForBrandPauseContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePauseBrandForBrandPauseContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<PauseBrandForBrandPauseContextMenuMutation, PauseBrandForBrandPauseContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseBrandForBrandPauseContextMenuMutation, PauseBrandForBrandPauseContextMenuMutationVariables>(PauseBrandForBrandPauseContextMenuDocument, options);
      }
export type PauseBrandForBrandPauseContextMenuMutationHookResult = ReturnType<typeof usePauseBrandForBrandPauseContextMenuMutation>;
export type PauseBrandForBrandPauseContextMenuMutationResult = Apollo.MutationResult<PauseBrandForBrandPauseContextMenuMutation>;
export type PauseBrandForBrandPauseContextMenuMutationOptions = Apollo.BaseMutationOptions<PauseBrandForBrandPauseContextMenuMutation, PauseBrandForBrandPauseContextMenuMutationVariables>;
export const ResumeBrandForBrandPauseContextMenuDocument = gql`
    mutation ResumeBrandForBrandPauseContextMenu($data: ResumeBrandInput!) {
  resumeBrand(data: $data) {
    id
    ...BrandFragmentBrandPauseContextMenu
  }
}
    ${BrandFragmentBrandPauseContextMenuFragmentDoc}`;
export type ResumeBrandForBrandPauseContextMenuMutationFn = Apollo.MutationFunction<ResumeBrandForBrandPauseContextMenuMutation, ResumeBrandForBrandPauseContextMenuMutationVariables>;

/**
 * __useResumeBrandForBrandPauseContextMenuMutation__
 *
 * To run a mutation, you first call `useResumeBrandForBrandPauseContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeBrandForBrandPauseContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeBrandForBrandPauseContextMenuMutation, { data, loading, error }] = useResumeBrandForBrandPauseContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResumeBrandForBrandPauseContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<ResumeBrandForBrandPauseContextMenuMutation, ResumeBrandForBrandPauseContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeBrandForBrandPauseContextMenuMutation, ResumeBrandForBrandPauseContextMenuMutationVariables>(ResumeBrandForBrandPauseContextMenuDocument, options);
      }
export type ResumeBrandForBrandPauseContextMenuMutationHookResult = ReturnType<typeof useResumeBrandForBrandPauseContextMenuMutation>;
export type ResumeBrandForBrandPauseContextMenuMutationResult = Apollo.MutationResult<ResumeBrandForBrandPauseContextMenuMutation>;
export type ResumeBrandForBrandPauseContextMenuMutationOptions = Apollo.BaseMutationOptions<ResumeBrandForBrandPauseContextMenuMutation, ResumeBrandForBrandPauseContextMenuMutationVariables>;
export const GetAggregatedBrandDurationUsageForBrandBreakdownDialogDocument = gql`
    query GetAggregatedBrandDurationUsageForBrandBreakdownDialog($filters: AggregatedBrandDurationUsageFilters!) {
  aggregatedBrandDurationUsage(filters: $filters) {
    ...AggregatedBrandDurationUsageFragmentBrandTableRow
  }
}
    ${AggregatedBrandDurationUsageFragmentBrandTableRowFragmentDoc}`;

/**
 * __useGetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery__
 *
 * To run a query within a React component, call `useGetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery, GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery, GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryVariables>(GetAggregatedBrandDurationUsageForBrandBreakdownDialogDocument, options);
      }
export function useGetAggregatedBrandDurationUsageForBrandBreakdownDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery, GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery, GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryVariables>(GetAggregatedBrandDurationUsageForBrandBreakdownDialogDocument, options);
        }
export type GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryHookResult = ReturnType<typeof useGetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery>;
export type GetAggregatedBrandDurationUsageForBrandBreakdownDialogLazyQueryHookResult = ReturnType<typeof useGetAggregatedBrandDurationUsageForBrandBreakdownDialogLazyQuery>;
export type GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryResult = Apollo.QueryResult<GetAggregatedBrandDurationUsageForBrandBreakdownDialogQuery, GetAggregatedBrandDurationUsageForBrandBreakdownDialogQueryVariables>;
export const GetBrandForBrandContentFilterSettingsViewDocument = gql`
    query GetBrandForBrandContentFilterSettingsView($id: String!) {
  brand(id: $id) {
    id
    ...BrandFragmentBrandContentFilterSettingsView
  }
}
    ${BrandFragmentBrandContentFilterSettingsViewFragmentDoc}`;

/**
 * __useGetBrandForBrandContentFilterSettingsViewQuery__
 *
 * To run a query within a React component, call `useGetBrandForBrandContentFilterSettingsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForBrandContentFilterSettingsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForBrandContentFilterSettingsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandForBrandContentFilterSettingsViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForBrandContentFilterSettingsViewQuery, GetBrandForBrandContentFilterSettingsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForBrandContentFilterSettingsViewQuery, GetBrandForBrandContentFilterSettingsViewQueryVariables>(GetBrandForBrandContentFilterSettingsViewDocument, options);
      }
export function useGetBrandForBrandContentFilterSettingsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForBrandContentFilterSettingsViewQuery, GetBrandForBrandContentFilterSettingsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForBrandContentFilterSettingsViewQuery, GetBrandForBrandContentFilterSettingsViewQueryVariables>(GetBrandForBrandContentFilterSettingsViewDocument, options);
        }
export type GetBrandForBrandContentFilterSettingsViewQueryHookResult = ReturnType<typeof useGetBrandForBrandContentFilterSettingsViewQuery>;
export type GetBrandForBrandContentFilterSettingsViewLazyQueryHookResult = ReturnType<typeof useGetBrandForBrandContentFilterSettingsViewLazyQuery>;
export type GetBrandForBrandContentFilterSettingsViewQueryResult = Apollo.QueryResult<GetBrandForBrandContentFilterSettingsViewQuery, GetBrandForBrandContentFilterSettingsViewQueryVariables>;
export const UpdateBrandForBrandContentFilterSettingsViewDocument = gql`
    mutation UpdateBrandForBrandContentFilterSettingsView($data: UpdateBrandInput!) {
  updateBrand(data: $data) {
    id
    ...BrandFragmentBrandContentFilterSettingsView
  }
}
    ${BrandFragmentBrandContentFilterSettingsViewFragmentDoc}`;
export type UpdateBrandForBrandContentFilterSettingsViewMutationFn = Apollo.MutationFunction<UpdateBrandForBrandContentFilterSettingsViewMutation, UpdateBrandForBrandContentFilterSettingsViewMutationVariables>;

/**
 * __useUpdateBrandForBrandContentFilterSettingsViewMutation__
 *
 * To run a mutation, you first call `useUpdateBrandForBrandContentFilterSettingsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandForBrandContentFilterSettingsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandForBrandContentFilterSettingsViewMutation, { data, loading, error }] = useUpdateBrandForBrandContentFilterSettingsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandForBrandContentFilterSettingsViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandForBrandContentFilterSettingsViewMutation, UpdateBrandForBrandContentFilterSettingsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandForBrandContentFilterSettingsViewMutation, UpdateBrandForBrandContentFilterSettingsViewMutationVariables>(UpdateBrandForBrandContentFilterSettingsViewDocument, options);
      }
export type UpdateBrandForBrandContentFilterSettingsViewMutationHookResult = ReturnType<typeof useUpdateBrandForBrandContentFilterSettingsViewMutation>;
export type UpdateBrandForBrandContentFilterSettingsViewMutationResult = Apollo.MutationResult<UpdateBrandForBrandContentFilterSettingsViewMutation>;
export type UpdateBrandForBrandContentFilterSettingsViewMutationOptions = Apollo.BaseMutationOptions<UpdateBrandForBrandContentFilterSettingsViewMutation, UpdateBrandForBrandContentFilterSettingsViewMutationVariables>;
export const GetBrandForBrandParsingSettingsViewDocument = gql`
    query GetBrandForBrandParsingSettingsView($id: String!) {
  brand(id: $id) {
    id
    ...BrandFragmentBrandParsingSettingsView
  }
}
    ${BrandFragmentBrandParsingSettingsViewFragmentDoc}`;

/**
 * __useGetBrandForBrandParsingSettingsViewQuery__
 *
 * To run a query within a React component, call `useGetBrandForBrandParsingSettingsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForBrandParsingSettingsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForBrandParsingSettingsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandForBrandParsingSettingsViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForBrandParsingSettingsViewQuery, GetBrandForBrandParsingSettingsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForBrandParsingSettingsViewQuery, GetBrandForBrandParsingSettingsViewQueryVariables>(GetBrandForBrandParsingSettingsViewDocument, options);
      }
export function useGetBrandForBrandParsingSettingsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForBrandParsingSettingsViewQuery, GetBrandForBrandParsingSettingsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForBrandParsingSettingsViewQuery, GetBrandForBrandParsingSettingsViewQueryVariables>(GetBrandForBrandParsingSettingsViewDocument, options);
        }
export type GetBrandForBrandParsingSettingsViewQueryHookResult = ReturnType<typeof useGetBrandForBrandParsingSettingsViewQuery>;
export type GetBrandForBrandParsingSettingsViewLazyQueryHookResult = ReturnType<typeof useGetBrandForBrandParsingSettingsViewLazyQuery>;
export type GetBrandForBrandParsingSettingsViewQueryResult = Apollo.QueryResult<GetBrandForBrandParsingSettingsViewQuery, GetBrandForBrandParsingSettingsViewQueryVariables>;
export const UpdateBrandForBrandParsingSettingsViewDocument = gql`
    mutation UpdateBrandForBrandParsingSettingsView($data: UpdateBrandInput!) {
  updateBrand(data: $data) {
    id
    ...BrandFragmentBrandParsingSettingsView
  }
}
    ${BrandFragmentBrandParsingSettingsViewFragmentDoc}`;
export type UpdateBrandForBrandParsingSettingsViewMutationFn = Apollo.MutationFunction<UpdateBrandForBrandParsingSettingsViewMutation, UpdateBrandForBrandParsingSettingsViewMutationVariables>;

/**
 * __useUpdateBrandForBrandParsingSettingsViewMutation__
 *
 * To run a mutation, you first call `useUpdateBrandForBrandParsingSettingsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandForBrandParsingSettingsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandForBrandParsingSettingsViewMutation, { data, loading, error }] = useUpdateBrandForBrandParsingSettingsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandForBrandParsingSettingsViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandForBrandParsingSettingsViewMutation, UpdateBrandForBrandParsingSettingsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandForBrandParsingSettingsViewMutation, UpdateBrandForBrandParsingSettingsViewMutationVariables>(UpdateBrandForBrandParsingSettingsViewDocument, options);
      }
export type UpdateBrandForBrandParsingSettingsViewMutationHookResult = ReturnType<typeof useUpdateBrandForBrandParsingSettingsViewMutation>;
export type UpdateBrandForBrandParsingSettingsViewMutationResult = Apollo.MutationResult<UpdateBrandForBrandParsingSettingsViewMutation>;
export type UpdateBrandForBrandParsingSettingsViewMutationOptions = Apollo.BaseMutationOptions<UpdateBrandForBrandParsingSettingsViewMutation, UpdateBrandForBrandParsingSettingsViewMutationVariables>;
export const DeleteCompetitorForBrandCompetitorActionContextMenuDocument = gql`
    mutation DeleteCompetitorForBrandCompetitorActionContextMenu($data: RemoveCompetitorsInput!) {
  removeCompetitors(data: $data) {
    id
  }
}
    `;
export type DeleteCompetitorForBrandCompetitorActionContextMenuMutationFn = Apollo.MutationFunction<DeleteCompetitorForBrandCompetitorActionContextMenuMutation, DeleteCompetitorForBrandCompetitorActionContextMenuMutationVariables>;

/**
 * __useDeleteCompetitorForBrandCompetitorActionContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteCompetitorForBrandCompetitorActionContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompetitorForBrandCompetitorActionContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompetitorForBrandCompetitorActionContextMenuMutation, { data, loading, error }] = useDeleteCompetitorForBrandCompetitorActionContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCompetitorForBrandCompetitorActionContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompetitorForBrandCompetitorActionContextMenuMutation, DeleteCompetitorForBrandCompetitorActionContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompetitorForBrandCompetitorActionContextMenuMutation, DeleteCompetitorForBrandCompetitorActionContextMenuMutationVariables>(DeleteCompetitorForBrandCompetitorActionContextMenuDocument, options);
      }
export type DeleteCompetitorForBrandCompetitorActionContextMenuMutationHookResult = ReturnType<typeof useDeleteCompetitorForBrandCompetitorActionContextMenuMutation>;
export type DeleteCompetitorForBrandCompetitorActionContextMenuMutationResult = Apollo.MutationResult<DeleteCompetitorForBrandCompetitorActionContextMenuMutation>;
export type DeleteCompetitorForBrandCompetitorActionContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteCompetitorForBrandCompetitorActionContextMenuMutation, DeleteCompetitorForBrandCompetitorActionContextMenuMutationVariables>;
export const GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphDocument = gql`
    query GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraph($data: GetCompetitorFlatCreatorGraphDataInput!) {
  getCompetitorFlatCreatorGraphData(data: $data) {
    chartDataPoints {
      Y
      X
    }
    totalCount
  }
}
    `;

/**
 * __useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery__
 *
 * To run a query within a React component, call `useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery, GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery, GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryVariables>(GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphDocument, options);
      }
export function useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery, GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery, GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryVariables>(GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphDocument, options);
        }
export type GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery>;
export type GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphLazyQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphLazyQuery>;
export type GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryResult = Apollo.QueryResult<GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQuery, GetCompetitorFlatCreatorGraphDataForBrandCompetitorGraphQueryVariables>;
export const GetBrandInboundSocialPostCommentInsightsDocument = gql`
    query GetBrandInboundSocialPostCommentInsights($data: BrandInboundFiltersInputForCommentInsights!, $brandId: String!) {
  getBrandInboundCommentInsights(data: $data) {
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      ...SocialPostCommentFragmentCommentInsightsTable
    }
  }
}
    ${SocialPostCommentFragmentCommentInsightsTableFragmentDoc}`;

/**
 * __useGetBrandInboundSocialPostCommentInsightsQuery__
 *
 * To run a query within a React component, call `useGetBrandInboundSocialPostCommentInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInboundSocialPostCommentInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInboundSocialPostCommentInsightsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandInboundSocialPostCommentInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInboundSocialPostCommentInsightsQuery, GetBrandInboundSocialPostCommentInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInboundSocialPostCommentInsightsQuery, GetBrandInboundSocialPostCommentInsightsQueryVariables>(GetBrandInboundSocialPostCommentInsightsDocument, options);
      }
export function useGetBrandInboundSocialPostCommentInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInboundSocialPostCommentInsightsQuery, GetBrandInboundSocialPostCommentInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInboundSocialPostCommentInsightsQuery, GetBrandInboundSocialPostCommentInsightsQueryVariables>(GetBrandInboundSocialPostCommentInsightsDocument, options);
        }
export type GetBrandInboundSocialPostCommentInsightsQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostCommentInsightsQuery>;
export type GetBrandInboundSocialPostCommentInsightsLazyQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostCommentInsightsLazyQuery>;
export type GetBrandInboundSocialPostCommentInsightsQueryResult = Apollo.QueryResult<GetBrandInboundSocialPostCommentInsightsQuery, GetBrandInboundSocialPostCommentInsightsQueryVariables>;
export const GetCompetitorCommentInsightsForCompetitorCommentInsightsDocument = gql`
    query GetCompetitorCommentInsightsForCompetitorCommentInsights($data: GetCompetitorCommentInsightsInput!, $brandId: String!) {
  getCompetitorCommentInsights(data: $data) {
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      ...SocialPostCommentFragmentCommentInsightsTable
    }
  }
}
    ${SocialPostCommentFragmentCommentInsightsTableFragmentDoc}`;

/**
 * __useGetCompetitorCommentInsightsForCompetitorCommentInsightsQuery__
 *
 * To run a query within a React component, call `useGetCompetitorCommentInsightsForCompetitorCommentInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorCommentInsightsForCompetitorCommentInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorCommentInsightsForCompetitorCommentInsightsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetCompetitorCommentInsightsForCompetitorCommentInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorCommentInsightsForCompetitorCommentInsightsQuery, GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorCommentInsightsForCompetitorCommentInsightsQuery, GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryVariables>(GetCompetitorCommentInsightsForCompetitorCommentInsightsDocument, options);
      }
export function useGetCompetitorCommentInsightsForCompetitorCommentInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorCommentInsightsForCompetitorCommentInsightsQuery, GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorCommentInsightsForCompetitorCommentInsightsQuery, GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryVariables>(GetCompetitorCommentInsightsForCompetitorCommentInsightsDocument, options);
        }
export type GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryHookResult = ReturnType<typeof useGetCompetitorCommentInsightsForCompetitorCommentInsightsQuery>;
export type GetCompetitorCommentInsightsForCompetitorCommentInsightsLazyQueryHookResult = ReturnType<typeof useGetCompetitorCommentInsightsForCompetitorCommentInsightsLazyQuery>;
export type GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryResult = Apollo.QueryResult<GetCompetitorCommentInsightsForCompetitorCommentInsightsQuery, GetCompetitorCommentInsightsForCompetitorCommentInsightsQueryVariables>;
export const GetBrandsForCommentInsightsFiltersDocument = gql`
    query GetBrandsForCommentInsightsFilters {
  brands {
    id
    topics {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useGetBrandsForCommentInsightsFiltersQuery__
 *
 * To run a query within a React component, call `useGetBrandsForCommentInsightsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsForCommentInsightsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsForCommentInsightsFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandsForCommentInsightsFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetBrandsForCommentInsightsFiltersQuery, GetBrandsForCommentInsightsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsForCommentInsightsFiltersQuery, GetBrandsForCommentInsightsFiltersQueryVariables>(GetBrandsForCommentInsightsFiltersDocument, options);
      }
export function useGetBrandsForCommentInsightsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsForCommentInsightsFiltersQuery, GetBrandsForCommentInsightsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsForCommentInsightsFiltersQuery, GetBrandsForCommentInsightsFiltersQueryVariables>(GetBrandsForCommentInsightsFiltersDocument, options);
        }
export type GetBrandsForCommentInsightsFiltersQueryHookResult = ReturnType<typeof useGetBrandsForCommentInsightsFiltersQuery>;
export type GetBrandsForCommentInsightsFiltersLazyQueryHookResult = ReturnType<typeof useGetBrandsForCommentInsightsFiltersLazyQuery>;
export type GetBrandsForCommentInsightsFiltersQueryResult = Apollo.QueryResult<GetBrandsForCommentInsightsFiltersQuery, GetBrandsForCommentInsightsFiltersQueryVariables>;
export const GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersDocument = gql`
    query GetOrganizationSocialPostCommentLabelsForCommentInsightsFilters($data: OrganizationSocialPostCommentLabelsInput!) {
  organizationSocialPostCommentLabels(data: $data) {
    data {
      ...OrganizationSocialPostCommentLabelFragmentCommentInsightsFilters
    }
  }
}
    ${OrganizationSocialPostCommentLabelFragmentCommentInsightsFiltersFragmentDoc}`;

/**
 * __useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery, GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery, GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryVariables>(GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersDocument, options);
      }
export function useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery, GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery, GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryVariables>(GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersDocument, options);
        }
export type GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryHookResult = ReturnType<typeof useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery>;
export type GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersLazyQueryHookResult = ReturnType<typeof useGetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersLazyQuery>;
export type GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryResult = Apollo.QueryResult<GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQuery, GetOrganizationSocialPostCommentLabelsForCommentInsightsFiltersQueryVariables>;
export const GetCategoriesForCommentInsightsFiltersDocument = gql`
    query GetCategoriesForCommentInsightsFilters($filters: SocialPostCommentCategoriesForBrandFilters!, $after: String) {
  socialPostCommentCategoriesForBrand(filters: $filters, after: $after) {
    data
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetCategoriesForCommentInsightsFiltersQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForCommentInsightsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForCommentInsightsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForCommentInsightsFiltersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCategoriesForCommentInsightsFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForCommentInsightsFiltersQuery, GetCategoriesForCommentInsightsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForCommentInsightsFiltersQuery, GetCategoriesForCommentInsightsFiltersQueryVariables>(GetCategoriesForCommentInsightsFiltersDocument, options);
      }
export function useGetCategoriesForCommentInsightsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForCommentInsightsFiltersQuery, GetCategoriesForCommentInsightsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForCommentInsightsFiltersQuery, GetCategoriesForCommentInsightsFiltersQueryVariables>(GetCategoriesForCommentInsightsFiltersDocument, options);
        }
export type GetCategoriesForCommentInsightsFiltersQueryHookResult = ReturnType<typeof useGetCategoriesForCommentInsightsFiltersQuery>;
export type GetCategoriesForCommentInsightsFiltersLazyQueryHookResult = ReturnType<typeof useGetCategoriesForCommentInsightsFiltersLazyQuery>;
export type GetCategoriesForCommentInsightsFiltersQueryResult = Apollo.QueryResult<GetCategoriesForCommentInsightsFiltersQuery, GetCategoriesForCommentInsightsFiltersQueryVariables>;
export const AddLabelsToSocialPostCommentForCommentInsightsTableDocument = gql`
    mutation AddLabelsToSocialPostCommentForCommentInsightsTable($data: AddLabelsToSocialPostCommentInput!) {
  addOrganizationSocialPostCommentLabelsToSocialPostComment(data: $data) {
    id
  }
}
    `;
export type AddLabelsToSocialPostCommentForCommentInsightsTableMutationFn = Apollo.MutationFunction<AddLabelsToSocialPostCommentForCommentInsightsTableMutation, AddLabelsToSocialPostCommentForCommentInsightsTableMutationVariables>;

/**
 * __useAddLabelsToSocialPostCommentForCommentInsightsTableMutation__
 *
 * To run a mutation, you first call `useAddLabelsToSocialPostCommentForCommentInsightsTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLabelsToSocialPostCommentForCommentInsightsTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLabelsToSocialPostCommentForCommentInsightsTableMutation, { data, loading, error }] = useAddLabelsToSocialPostCommentForCommentInsightsTableMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddLabelsToSocialPostCommentForCommentInsightsTableMutation(baseOptions?: Apollo.MutationHookOptions<AddLabelsToSocialPostCommentForCommentInsightsTableMutation, AddLabelsToSocialPostCommentForCommentInsightsTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLabelsToSocialPostCommentForCommentInsightsTableMutation, AddLabelsToSocialPostCommentForCommentInsightsTableMutationVariables>(AddLabelsToSocialPostCommentForCommentInsightsTableDocument, options);
      }
export type AddLabelsToSocialPostCommentForCommentInsightsTableMutationHookResult = ReturnType<typeof useAddLabelsToSocialPostCommentForCommentInsightsTableMutation>;
export type AddLabelsToSocialPostCommentForCommentInsightsTableMutationResult = Apollo.MutationResult<AddLabelsToSocialPostCommentForCommentInsightsTableMutation>;
export type AddLabelsToSocialPostCommentForCommentInsightsTableMutationOptions = Apollo.BaseMutationOptions<AddLabelsToSocialPostCommentForCommentInsightsTableMutation, AddLabelsToSocialPostCommentForCommentInsightsTableMutationVariables>;
export const RemoveLabelsFromSocialPostCommentForCommentInsightsTableDocument = gql`
    mutation RemoveLabelsFromSocialPostCommentForCommentInsightsTable($data: RemoveLabelsFromSocialPostCommentInput!) {
  removeOrganizationSocialPostCommentLabelsFromSocialPostComment(data: $data) {
    id
  }
}
    `;
export type RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationFn = Apollo.MutationFunction<RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation, RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationVariables>;

/**
 * __useRemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation__
 *
 * To run a mutation, you first call `useRemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabelsFromSocialPostCommentForCommentInsightsTableMutation, { data, loading, error }] = useRemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation, RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation, RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationVariables>(RemoveLabelsFromSocialPostCommentForCommentInsightsTableDocument, options);
      }
export type RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationHookResult = ReturnType<typeof useRemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation>;
export type RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationResult = Apollo.MutationResult<RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation>;
export type RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationOptions = Apollo.BaseMutationOptions<RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutation, RemoveLabelsFromSocialPostCommentForCommentInsightsTableMutationVariables>;
export const GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsDocument = gql`
    query GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographics($data: CompetitorFlatAnalyticFiltersInput!) {
  getCompetitorFlatCreatorDemographics(data: $data) {
    ...SocialPostCreatorDemographicFragmentSLACreatorDemographics
  }
}
    ${SocialPostCreatorDemographicFragmentSlaCreatorDemographicsFragmentDoc}`;

/**
 * __useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery__
 *
 * To run a query within a React component, call `useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery, GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery, GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryVariables>(GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsDocument, options);
      }
export function useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery, GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery, GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryVariables>(GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsDocument, options);
        }
export type GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery>;
export type GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsLazyQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsLazyQuery>;
export type GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryResult = Apollo.QueryResult<GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQuery, GetCompetitorFlatCreatorDemographicsForCompetitorCreatorDemographicsQueryVariables>;
export const GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalDocument = gql`
    query GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModal($data: GetCompetitorSentimentInteractionsInput!, $brandId: String!) {
  getCompetitorSentimentInteractions(data: $data) {
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      socialPosts {
        id
        ...SocialPostFragmentSocialPostClaimsCard
        brandAnalysis {
          id
          brandId
          sentimentScore
          brandClaims {
            attribute
            claim
            id
          }
        }
      }
      socialPostComments {
        id
        text
        socialPostCommentClaims {
          id
          claim
          claimAttribute
          brandId
        }
        socialPost {
          id
          ...SocialPostFragmentSocialPostClaimsCard
          brandAnalysis {
            id
            brandId
            sentimentScore
            brandClaims {
              claim
              id
            }
          }
        }
      }
    }
  }
}
    ${SocialPostFragmentSocialPostClaimsCardFragmentDoc}`;

/**
 * __useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery__
 *
 * To run a query within a React component, call `useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery({
 *   variables: {
 *      data: // value for 'data'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery, GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery, GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryVariables>(GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalDocument, options);
      }
export function useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery, GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery, GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryVariables>(GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalDocument, options);
        }
export type GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryHookResult = ReturnType<typeof useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery>;
export type GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalLazyQueryHookResult = ReturnType<typeof useGetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalLazyQuery>;
export type GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryResult = Apollo.QueryResult<GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQuery, GetCompetitorSentimentInteractionsForCompetitorSentimentDetailsModalQueryVariables>;
export const GetCompetitorSentimentMetricsForCompetitorSentimentDocument = gql`
    query GetCompetitorSentimentMetricsForCompetitorSentiment($data: GetCompetitorSentimentMetricsInput!) {
  getCompetitorSentimentMetrics(data: $data) {
    claimMetrics {
      attribute
      numberOfMentions
    }
    sentimentMetrics {
      averageCountPerDay
      totalCount
      chartDataPoints {
        X
        Y
      }
    }
  }
}
    `;

/**
 * __useGetCompetitorSentimentMetricsForCompetitorSentimentQuery__
 *
 * To run a query within a React component, call `useGetCompetitorSentimentMetricsForCompetitorSentimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorSentimentMetricsForCompetitorSentimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorSentimentMetricsForCompetitorSentimentQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCompetitorSentimentMetricsForCompetitorSentimentQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorSentimentMetricsForCompetitorSentimentQuery, GetCompetitorSentimentMetricsForCompetitorSentimentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorSentimentMetricsForCompetitorSentimentQuery, GetCompetitorSentimentMetricsForCompetitorSentimentQueryVariables>(GetCompetitorSentimentMetricsForCompetitorSentimentDocument, options);
      }
export function useGetCompetitorSentimentMetricsForCompetitorSentimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorSentimentMetricsForCompetitorSentimentQuery, GetCompetitorSentimentMetricsForCompetitorSentimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorSentimentMetricsForCompetitorSentimentQuery, GetCompetitorSentimentMetricsForCompetitorSentimentQueryVariables>(GetCompetitorSentimentMetricsForCompetitorSentimentDocument, options);
        }
export type GetCompetitorSentimentMetricsForCompetitorSentimentQueryHookResult = ReturnType<typeof useGetCompetitorSentimentMetricsForCompetitorSentimentQuery>;
export type GetCompetitorSentimentMetricsForCompetitorSentimentLazyQueryHookResult = ReturnType<typeof useGetCompetitorSentimentMetricsForCompetitorSentimentLazyQuery>;
export type GetCompetitorSentimentMetricsForCompetitorSentimentQueryResult = Apollo.QueryResult<GetCompetitorSentimentMetricsForCompetitorSentimentQuery, GetCompetitorSentimentMetricsForCompetitorSentimentQueryVariables>;
export const GetCompetitorFlatCreatorForCompetitorsSummaryDocument = gql`
    query GetCompetitorFlatCreatorForCompetitorsSummary($data: CompetitorFlatCreatorAnalyticFiltersInput!) {
  competitorFlatCreatorAnalyticSummary(data: $data) {
    followers
    totalPosts
    postsPerWeek
    totalEngagements
    totalViewCount
    averageLikes
    averageVideoViews
    averageEngagementRate
    sentiment
  }
}
    `;

/**
 * __useGetCompetitorFlatCreatorForCompetitorsSummaryQuery__
 *
 * To run a query within a React component, call `useGetCompetitorFlatCreatorForCompetitorsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorFlatCreatorForCompetitorsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorFlatCreatorForCompetitorsSummaryQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCompetitorFlatCreatorForCompetitorsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorFlatCreatorForCompetitorsSummaryQuery, GetCompetitorFlatCreatorForCompetitorsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorFlatCreatorForCompetitorsSummaryQuery, GetCompetitorFlatCreatorForCompetitorsSummaryQueryVariables>(GetCompetitorFlatCreatorForCompetitorsSummaryDocument, options);
      }
export function useGetCompetitorFlatCreatorForCompetitorsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorFlatCreatorForCompetitorsSummaryQuery, GetCompetitorFlatCreatorForCompetitorsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorFlatCreatorForCompetitorsSummaryQuery, GetCompetitorFlatCreatorForCompetitorsSummaryQueryVariables>(GetCompetitorFlatCreatorForCompetitorsSummaryDocument, options);
        }
export type GetCompetitorFlatCreatorForCompetitorsSummaryQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorForCompetitorsSummaryQuery>;
export type GetCompetitorFlatCreatorForCompetitorsSummaryLazyQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorForCompetitorsSummaryLazyQuery>;
export type GetCompetitorFlatCreatorForCompetitorsSummaryQueryResult = Apollo.QueryResult<GetCompetitorFlatCreatorForCompetitorsSummaryQuery, GetCompetitorFlatCreatorForCompetitorsSummaryQueryVariables>;
export const GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsDocument = gql`
    query GetCreatorsThatMentionedCompetitorForCompetitorTopCreators($data: GetCreatorsThatMentionedCompetitorInput!) {
  getCreatorsThatMentionedCompetitor(data: $data) {
    data {
      id
      numberOfBrandMentions
      followerCount
      ...CreatorFragmentCompetitorTopCreators
    }
  }
}
    ${CreatorFragmentCompetitorTopCreatorsFragmentDoc}`;

/**
 * __useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery__
 *
 * To run a query within a React component, call `useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery, GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery, GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryVariables>(GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsDocument, options);
      }
export function useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery, GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery, GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryVariables>(GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsDocument, options);
        }
export type GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryHookResult = ReturnType<typeof useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery>;
export type GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsLazyQueryHookResult = ReturnType<typeof useGetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsLazyQuery>;
export type GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryResult = Apollo.QueryResult<GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQuery, GetCreatorsThatMentionedCompetitorForCompetitorTopCreatorsQueryVariables>;
export const GetHashtagUsedForCompetitorForCompetitorTopHashtagsDocument = gql`
    query GetHashtagUsedForCompetitorForCompetitorTopHashtags($data: GetHashtagUsedByCompetitorInput!) {
  getHashtagUsedByCompetitor(data: $data) {
    ...HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtags
  }
}
    ${HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtagsFragmentDoc}`;

/**
 * __useGetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery__
 *
 * To run a query within a React component, call `useGetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery(baseOptions: Apollo.QueryHookOptions<GetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery, GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery, GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryVariables>(GetHashtagUsedForCompetitorForCompetitorTopHashtagsDocument, options);
      }
export function useGetHashtagUsedForCompetitorForCompetitorTopHashtagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery, GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery, GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryVariables>(GetHashtagUsedForCompetitorForCompetitorTopHashtagsDocument, options);
        }
export type GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryHookResult = ReturnType<typeof useGetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery>;
export type GetHashtagUsedForCompetitorForCompetitorTopHashtagsLazyQueryHookResult = ReturnType<typeof useGetHashtagUsedForCompetitorForCompetitorTopHashtagsLazyQuery>;
export type GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryResult = Apollo.QueryResult<GetHashtagUsedForCompetitorForCompetitorTopHashtagsQuery, GetHashtagUsedForCompetitorForCompetitorTopHashtagsQueryVariables>;
export const HideHashtagUsedForCreatorForCompetitorTopHashtagsDocument = gql`
    mutation HideHashtagUsedForCreatorForCompetitorTopHashtags($data: HideHashtagUsedForCreatorInput!) {
  hideHashtagUsedForCreator(data: $data) {
    ...HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtags
  }
}
    ${HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtagsFragmentDoc}`;
export type HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationFn = Apollo.MutationFunction<HideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>;

/**
 * __useHideHashtagUsedForCreatorForCompetitorTopHashtagsMutation__
 *
 * To run a mutation, you first call `useHideHashtagUsedForCreatorForCompetitorTopHashtagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideHashtagUsedForCreatorForCompetitorTopHashtagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, { data, loading, error }] = useHideHashtagUsedForCreatorForCompetitorTopHashtagsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHideHashtagUsedForCreatorForCompetitorTopHashtagsMutation(baseOptions?: Apollo.MutationHookOptions<HideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>(HideHashtagUsedForCreatorForCompetitorTopHashtagsDocument, options);
      }
export type HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationHookResult = ReturnType<typeof useHideHashtagUsedForCreatorForCompetitorTopHashtagsMutation>;
export type HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationResult = Apollo.MutationResult<HideHashtagUsedForCreatorForCompetitorTopHashtagsMutation>;
export type HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationOptions = Apollo.BaseMutationOptions<HideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, HideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>;
export const UnhideHashtagUsedForCreatorForCompetitorTopHashtagsDocument = gql`
    mutation UnhideHashtagUsedForCreatorForCompetitorTopHashtags($data: UnhideHashtagUsedForCreatorInput!) {
  unhideHashtagUsedForCreator(data: $data) {
    ...HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtags
  }
}
    ${HashtagUsedForCompetitorFragmentCompetitorDetailTopHashtagsFragmentDoc}`;
export type UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationFn = Apollo.MutationFunction<UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>;

/**
 * __useUnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation__
 *
 * To run a mutation, you first call `useUnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, { data, loading, error }] = useUnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation(baseOptions?: Apollo.MutationHookOptions<UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>(UnhideHashtagUsedForCreatorForCompetitorTopHashtagsDocument, options);
      }
export type UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationHookResult = ReturnType<typeof useUnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation>;
export type UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationResult = Apollo.MutationResult<UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation>;
export type UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationOptions = Apollo.BaseMutationOptions<UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutation, UnhideHashtagUsedForCreatorForCompetitorTopHashtagsMutationVariables>;
export const GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsDocument = gql`
    query GetSocialPostsCreatedForCompetitorsForCompetitorTopPosts($data: GetSocialPostsCreatedForCompetitorsInput!) {
  getSocialPostsCreatedForCompetitors(data: $data) {
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      ...SocialPostFragmentSLAInfinitePostsGrid
    }
  }
}
    ${SocialPostFragmentSlaInfinitePostsGridFragmentDoc}`;

/**
 * __useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery, GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery, GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryVariables>(GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsDocument, options);
      }
export function useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery, GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery, GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryVariables>(GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsDocument, options);
        }
export type GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryHookResult = ReturnType<typeof useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery>;
export type GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsLazyQueryHookResult = ReturnType<typeof useGetSocialPostsCreatedForCompetitorsForCompetitorTopPostsLazyQuery>;
export type GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryResult = Apollo.QueryResult<GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQuery, GetSocialPostsCreatedForCompetitorsForCompetitorTopPostsQueryVariables>;
export const GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsDocument = gql`
    query GetOrganizationSocialPostCommentLabelsForEditCompetitorLabels($data: OrganizationSocialPostCommentLabelsInput!) {
  organizationSocialPostCommentLabels(data: $data) {
    data {
      ...OrganizationSocialPostCommentLabelFragmentEditCompetitorLabels
    }
  }
}
    ${OrganizationSocialPostCommentLabelFragmentEditCompetitorLabelsFragmentDoc}`;

/**
 * __useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery, GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery, GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryVariables>(GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsDocument, options);
      }
export function useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery, GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery, GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryVariables>(GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsDocument, options);
        }
export type GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryHookResult = ReturnType<typeof useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery>;
export type GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsLazyQueryHookResult = ReturnType<typeof useGetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsLazyQuery>;
export type GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryResult = Apollo.QueryResult<GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQuery, GetOrganizationSocialPostCommentLabelsForEditCompetitorLabelsQueryVariables>;
export const CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsDocument = gql`
    mutation CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabels($data: CreateOrganizationSocialPostCommentLabelInput!) {
  createOrganizationSocialPostCommentLabels(data: $data) {
    ...OrganizationSocialPostCommentLabelFragmentCommentInsightsFilters
  }
}
    ${OrganizationSocialPostCommentLabelFragmentCommentInsightsFiltersFragmentDoc}`;
export type CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationFn = Apollo.MutationFunction<CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation, CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationVariables>;

/**
 * __useCreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation, { data, loading, error }] = useCreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation, CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation, CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationVariables>(CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsDocument, options);
      }
export type CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationHookResult = ReturnType<typeof useCreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation>;
export type CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationResult = Apollo.MutationResult<CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation>;
export type CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutation, CreateOrganizationSocialPostCommentLabelsForEditCompetitorLabelsMutationVariables>;
export const CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersDocument = gql`
    mutation CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlers($input: CreateBrandBookmarkInput!) {
  createBrandBookmark(input: $input) {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;
export type CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationFn = Apollo.MutationFunction<CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;

/**
 * __useCreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useCreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, { data, loading, error }] = useCreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>(CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersDocument, options);
      }
export type CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationHookResult = ReturnType<typeof useCreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationResult = Apollo.MutationResult<CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;
export const DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersDocument = gql`
    mutation DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlers($input: DeleteBrandBookmarkInput!) {
  deleteBrandBookmark(input: $input) {
    message
    success
    deleted {
      id
    }
  }
}
    `;
export type DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationFn = Apollo.MutationFunction<DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;

/**
 * __useDeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, { data, loading, error }] = useDeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>(DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersDocument, options);
      }
export type DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationHookResult = ReturnType<typeof useDeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationResult = Apollo.MutationResult<DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteAnalyticBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;
export const CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersDocument = gql`
    mutation CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlers($input: CreateCompetitorBookmarkInput!) {
  createCompetitorBookmark(input: $input) {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;
export type CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationFn = Apollo.MutationFunction<CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;

/**
 * __useCreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useCreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, { data, loading, error }] = useCreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>(CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersDocument, options);
      }
export type CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationHookResult = ReturnType<typeof useCreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationResult = Apollo.MutationResult<CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, CreateCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;
export const DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersDocument = gql`
    mutation DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlers($input: DeleteCompetitorBookmarkInput!) {
  deleteCompetitorBookmark(input: $input) {
    message
    success
    deleted {
      id
    }
  }
}
    `;
export type DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationFn = Apollo.MutationFunction<DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;

/**
 * __useDeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, { data, loading, error }] = useDeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>(DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersDocument, options);
      }
export type DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationHookResult = ReturnType<typeof useDeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationResult = Apollo.MutationResult<DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation>;
export type DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutation, DeleteCompetitorBookmarkForBrandCompetitorBookmarkHandlersMutationVariables>;
export const GetCompetitorForBrandCompetitorDetailDocument = gql`
    query GetCompetitorForBrandCompetitorDetail($competitorId: String!) {
  competitor(id: $competitorId) {
    ...CompetitorFragmentBrandCompetitorInfo
    ...CompetitorFragmentForSLCompetitorDetailPage
    trackingBrand {
      ...BrandFragmentForCompetitorTopHashtags
      ...BrandFragmentForCompetitorTopCreators
    }
  }
}
    ${CompetitorFragmentBrandCompetitorInfoFragmentDoc}
${CompetitorFragmentForSlCompetitorDetailPageFragmentDoc}
${BrandFragmentForCompetitorTopHashtagsFragmentDoc}
${BrandFragmentForCompetitorTopCreatorsFragmentDoc}`;

/**
 * __useGetCompetitorForBrandCompetitorDetailQuery__
 *
 * To run a query within a React component, call `useGetCompetitorForBrandCompetitorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorForBrandCompetitorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorForBrandCompetitorDetailQuery({
 *   variables: {
 *      competitorId: // value for 'competitorId'
 *   },
 * });
 */
export function useGetCompetitorForBrandCompetitorDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorForBrandCompetitorDetailQuery, GetCompetitorForBrandCompetitorDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorForBrandCompetitorDetailQuery, GetCompetitorForBrandCompetitorDetailQueryVariables>(GetCompetitorForBrandCompetitorDetailDocument, options);
      }
export function useGetCompetitorForBrandCompetitorDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorForBrandCompetitorDetailQuery, GetCompetitorForBrandCompetitorDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorForBrandCompetitorDetailQuery, GetCompetitorForBrandCompetitorDetailQueryVariables>(GetCompetitorForBrandCompetitorDetailDocument, options);
        }
export type GetCompetitorForBrandCompetitorDetailQueryHookResult = ReturnType<typeof useGetCompetitorForBrandCompetitorDetailQuery>;
export type GetCompetitorForBrandCompetitorDetailLazyQueryHookResult = ReturnType<typeof useGetCompetitorForBrandCompetitorDetailLazyQuery>;
export type GetCompetitorForBrandCompetitorDetailQueryResult = Apollo.QueryResult<GetCompetitorForBrandCompetitorDetailQuery, GetCompetitorForBrandCompetitorDetailQueryVariables>;
export const GetCompetitorFlatCreatorsListForBrandCompetitorsViewDocument = gql`
    query GetCompetitorFlatCreatorsListForBrandCompetitorsView($data: SearchCompetitorFlatCreatorsInput!, $socialPostsData: GetSocialPostsCreatedForCompetitorsResolveFieldInput!) {
  searchCompetitorFlatCreators(data: $data) {
    pageInfo {
      hasNextPage
    }
    data {
      competitorId
      followerCount
      platforms
      averageVideoViews
      averageLikes
      averageEngagementRate
      competitor {
        ...CompetitorFragmentForBrandCompetitorActionContextMenu
      }
      trackingBrand {
        id
        name
      }
      trackingBrandCreators {
        id
        profilePictureUrl
        ...CreatorFragmentCreatorHandleChip
      }
      socialPosts(data: $socialPostsData) {
        data {
          ...SocialPostFragmentSocialPostThumbnail
        }
      }
    }
  }
}
    ${CompetitorFragmentForBrandCompetitorActionContextMenuFragmentDoc}
${CreatorFragmentCreatorHandleChipFragmentDoc}
${SocialPostFragmentSocialPostThumbnailFragmentDoc}`;

/**
 * __useGetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery__
 *
 * To run a query within a React component, call `useGetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *      socialPostsData: // value for 'socialPostsData'
 *   },
 * });
 */
export function useGetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery, GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery, GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryVariables>(GetCompetitorFlatCreatorsListForBrandCompetitorsViewDocument, options);
      }
export function useGetCompetitorFlatCreatorsListForBrandCompetitorsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery, GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery, GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryVariables>(GetCompetitorFlatCreatorsListForBrandCompetitorsViewDocument, options);
        }
export type GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery>;
export type GetCompetitorFlatCreatorsListForBrandCompetitorsViewLazyQueryHookResult = ReturnType<typeof useGetCompetitorFlatCreatorsListForBrandCompetitorsViewLazyQuery>;
export type GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryResult = Apollo.QueryResult<GetCompetitorFlatCreatorsListForBrandCompetitorsViewQuery, GetCompetitorFlatCreatorsListForBrandCompetitorsViewQueryVariables>;
export const GetCreatorForBrandCreatorPostsDocument = gql`
    query GetCreatorForBrandCreatorPosts($data: GetCreatorInput!) {
  getCreator(data: $data) {
    ...CreatorFragmentBrandCreatorPosts
  }
}
    ${CreatorFragmentBrandCreatorPostsFragmentDoc}`;

/**
 * __useGetCreatorForBrandCreatorPostsQuery__
 *
 * To run a query within a React component, call `useGetCreatorForBrandCreatorPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorForBrandCreatorPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorForBrandCreatorPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCreatorForBrandCreatorPostsQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorForBrandCreatorPostsQuery, GetCreatorForBrandCreatorPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorForBrandCreatorPostsQuery, GetCreatorForBrandCreatorPostsQueryVariables>(GetCreatorForBrandCreatorPostsDocument, options);
      }
export function useGetCreatorForBrandCreatorPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorForBrandCreatorPostsQuery, GetCreatorForBrandCreatorPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorForBrandCreatorPostsQuery, GetCreatorForBrandCreatorPostsQueryVariables>(GetCreatorForBrandCreatorPostsDocument, options);
        }
export type GetCreatorForBrandCreatorPostsQueryHookResult = ReturnType<typeof useGetCreatorForBrandCreatorPostsQuery>;
export type GetCreatorForBrandCreatorPostsLazyQueryHookResult = ReturnType<typeof useGetCreatorForBrandCreatorPostsLazyQuery>;
export type GetCreatorForBrandCreatorPostsQueryResult = Apollo.QueryResult<GetCreatorForBrandCreatorPostsQuery, GetCreatorForBrandCreatorPostsQueryVariables>;
export const GetCompetitorForBrandCreatorPostsDocument = gql`
    query GetCompetitorForBrandCreatorPosts($competitorId: String!, $data: GetNumberOfBrandMentionsByCreatorInput!) {
  competitor(id: $competitorId) {
    id
    numberOfBrandMentionsByCreator(data: $data)
    forBrand {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCompetitorForBrandCreatorPostsQuery__
 *
 * To run a query within a React component, call `useGetCompetitorForBrandCreatorPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorForBrandCreatorPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorForBrandCreatorPostsQuery({
 *   variables: {
 *      competitorId: // value for 'competitorId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCompetitorForBrandCreatorPostsQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorForBrandCreatorPostsQuery, GetCompetitorForBrandCreatorPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorForBrandCreatorPostsQuery, GetCompetitorForBrandCreatorPostsQueryVariables>(GetCompetitorForBrandCreatorPostsDocument, options);
      }
export function useGetCompetitorForBrandCreatorPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorForBrandCreatorPostsQuery, GetCompetitorForBrandCreatorPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorForBrandCreatorPostsQuery, GetCompetitorForBrandCreatorPostsQueryVariables>(GetCompetitorForBrandCreatorPostsDocument, options);
        }
export type GetCompetitorForBrandCreatorPostsQueryHookResult = ReturnType<typeof useGetCompetitorForBrandCreatorPostsQuery>;
export type GetCompetitorForBrandCreatorPostsLazyQueryHookResult = ReturnType<typeof useGetCompetitorForBrandCreatorPostsLazyQuery>;
export type GetCompetitorForBrandCreatorPostsQueryResult = Apollo.QueryResult<GetCompetitorForBrandCreatorPostsQuery, GetCompetitorForBrandCreatorPostsQueryVariables>;
export const GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsDocument = gql`
    query GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPosts($data: SocialPostsByCreatorsForCompetitorInput!) {
  getSocialPostsByCreatorsForCompetitor(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    meta {
      totalCount
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery, GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery, GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryVariables>(GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsDocument, options);
      }
export function useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery, GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery, GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryVariables>(GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsDocument, options);
        }
export type GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryHookResult = ReturnType<typeof useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery>;
export type GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsLazyQueryHookResult = ReturnType<typeof useGetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsLazyQuery>;
export type GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryResult = Apollo.QueryResult<GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQuery, GetSocialPostsByCreatorsForCompetitorForBrandCompetitorPostsQueryVariables>;
export const GetHashtagUsedByCompetitorForBrandHashtagPostsDocument = gql`
    query GetHashtagUsedByCompetitorForBrandHashtagPosts($data: GetHashtagUsedByCompetitorInput!) {
  getHashtagUsedByCompetitor(data: $data) {
    name
    averageEngagementRate
    numberOfTimesUsed
  }
}
    `;

/**
 * __useGetHashtagUsedByCompetitorForBrandHashtagPostsQuery__
 *
 * To run a query within a React component, call `useGetHashtagUsedByCompetitorForBrandHashtagPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagUsedByCompetitorForBrandHashtagPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagUsedByCompetitorForBrandHashtagPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetHashtagUsedByCompetitorForBrandHashtagPostsQuery(baseOptions: Apollo.QueryHookOptions<GetHashtagUsedByCompetitorForBrandHashtagPostsQuery, GetHashtagUsedByCompetitorForBrandHashtagPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHashtagUsedByCompetitorForBrandHashtagPostsQuery, GetHashtagUsedByCompetitorForBrandHashtagPostsQueryVariables>(GetHashtagUsedByCompetitorForBrandHashtagPostsDocument, options);
      }
export function useGetHashtagUsedByCompetitorForBrandHashtagPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHashtagUsedByCompetitorForBrandHashtagPostsQuery, GetHashtagUsedByCompetitorForBrandHashtagPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHashtagUsedByCompetitorForBrandHashtagPostsQuery, GetHashtagUsedByCompetitorForBrandHashtagPostsQueryVariables>(GetHashtagUsedByCompetitorForBrandHashtagPostsDocument, options);
        }
export type GetHashtagUsedByCompetitorForBrandHashtagPostsQueryHookResult = ReturnType<typeof useGetHashtagUsedByCompetitorForBrandHashtagPostsQuery>;
export type GetHashtagUsedByCompetitorForBrandHashtagPostsLazyQueryHookResult = ReturnType<typeof useGetHashtagUsedByCompetitorForBrandHashtagPostsLazyQuery>;
export type GetHashtagUsedByCompetitorForBrandHashtagPostsQueryResult = Apollo.QueryResult<GetHashtagUsedByCompetitorForBrandHashtagPostsQuery, GetHashtagUsedByCompetitorForBrandHashtagPostsQueryVariables>;
export const GetCompetitorForBrandHashtagPostsDocument = gql`
    query GetCompetitorForBrandHashtagPosts($competitorId: String!) {
  competitor(id: $competitorId) {
    id
    forBrand {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCompetitorForBrandHashtagPostsQuery__
 *
 * To run a query within a React component, call `useGetCompetitorForBrandHashtagPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorForBrandHashtagPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorForBrandHashtagPostsQuery({
 *   variables: {
 *      competitorId: // value for 'competitorId'
 *   },
 * });
 */
export function useGetCompetitorForBrandHashtagPostsQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorForBrandHashtagPostsQuery, GetCompetitorForBrandHashtagPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorForBrandHashtagPostsQuery, GetCompetitorForBrandHashtagPostsQueryVariables>(GetCompetitorForBrandHashtagPostsDocument, options);
      }
export function useGetCompetitorForBrandHashtagPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorForBrandHashtagPostsQuery, GetCompetitorForBrandHashtagPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorForBrandHashtagPostsQuery, GetCompetitorForBrandHashtagPostsQueryVariables>(GetCompetitorForBrandHashtagPostsDocument, options);
        }
export type GetCompetitorForBrandHashtagPostsQueryHookResult = ReturnType<typeof useGetCompetitorForBrandHashtagPostsQuery>;
export type GetCompetitorForBrandHashtagPostsLazyQueryHookResult = ReturnType<typeof useGetCompetitorForBrandHashtagPostsLazyQuery>;
export type GetCompetitorForBrandHashtagPostsQueryResult = Apollo.QueryResult<GetCompetitorForBrandHashtagPostsQuery, GetCompetitorForBrandHashtagPostsQueryVariables>;
export const GetSocialPostsByHashtagsDocument = gql`
    query GetSocialPostsByHashtags($data: GetTopHashtagsPostsForCompetitorInput!) {
  getSocialPostsByHashtagsForCompetitor(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    meta {
      totalCount
      averageEngagementRate
      numberOfTimesUsed
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetSocialPostsByHashtagsQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsByHashtagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsByHashtagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsByHashtagsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsByHashtagsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsByHashtagsQuery, GetSocialPostsByHashtagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsByHashtagsQuery, GetSocialPostsByHashtagsQueryVariables>(GetSocialPostsByHashtagsDocument, options);
      }
export function useGetSocialPostsByHashtagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsByHashtagsQuery, GetSocialPostsByHashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsByHashtagsQuery, GetSocialPostsByHashtagsQueryVariables>(GetSocialPostsByHashtagsDocument, options);
        }
export type GetSocialPostsByHashtagsQueryHookResult = ReturnType<typeof useGetSocialPostsByHashtagsQuery>;
export type GetSocialPostsByHashtagsLazyQueryHookResult = ReturnType<typeof useGetSocialPostsByHashtagsLazyQuery>;
export type GetSocialPostsByHashtagsQueryResult = Apollo.QueryResult<GetSocialPostsByHashtagsQuery, GetSocialPostsByHashtagsQueryVariables>;
export const GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartDocument = gql`
    query GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChart($filters: CompetitorShareOfVoiceFiltersInput!, $skip: Int, $take: Int) {
  competitorShareOfVoiceTimeSeriesData(
    filters: $filters
    skip: $skip
    take: $take
  ) {
    data {
      id
      base {
        id
        brand {
          id
          name
          creators {
            id
            ...CreatorFragmentCreatorAvatar
          }
        }
        competitor {
          id
          name
        }
      }
      dataPoints {
        date
        data {
          shareOfVoice
          mentionCount
          viewCount
          totalEngagement
          engagementRate
        }
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}`;

/**
 * __useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery__
 *
 * To run a query within a React component, call `useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery, GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery, GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryVariables>(GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartDocument, options);
      }
export function useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery, GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery, GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryVariables>(GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartDocument, options);
        }
export type GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryHookResult = ReturnType<typeof useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery>;
export type GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartLazyQueryHookResult = ReturnType<typeof useGetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartLazyQuery>;
export type GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryResult = Apollo.QueryResult<GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQuery, GetCompetitorShareOfVoiceTimeSeriesDataForBrandCompetitorsShareOfVoiceLineChartQueryVariables>;
export const GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogDocument = gql`
    query GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialog($filters: CompetitorShareOfVoiceFiltersInput!) {
  competitorShareOfVoiceAggregatedData(filters: $filters) {
    data {
      id
      aggregatedData {
        shareOfVoice
        mentionCount
        viewCount
        totalEngagement
        engagementRate
      }
    }
  }
}
    `;

/**
 * __useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery__
 *
 * To run a query within a React component, call `useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>(GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogDocument, options);
      }
export function useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>(GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogDocument, options);
        }
export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryHookResult = ReturnType<typeof useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery>;
export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogLazyQueryHookResult = ReturnType<typeof useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogLazyQuery>;
export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryResult = Apollo.QueryResult<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>;
export const GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogDocument = gql`
    query GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialog($filters: PaginatedBrandInboundFiltersInputForSocialPosts!) {
  getBrandInboundSocialPosts(data: $filters) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery__
 *
 * To run a query within a React component, call `useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>(GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogDocument, options);
      }
export function useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>(GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogDocument, options);
        }
export type GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery>;
export type GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogLazyQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogLazyQuery>;
export type GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryResult = Apollo.QueryResult<GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQuery, GetBrandInboundSocialPostsForBrandCompetitorsShareOfVoiceSocialPostsDialogQueryVariables>;
export const GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableDocument = gql`
    query GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTable($filters: CompetitorShareOfVoiceFiltersInput!, $sortBy: CompetitorShareOfVoiceAggregatedDataSortByInputData, $skip: Int, $take: Int, $previewPostsFilters: CompetitorShareOfVoicePreviewPostsFiltersInput!) {
  competitorShareOfVoiceAggregatedData(
    filters: $filters
    sortBy: $sortBy
    skip: $skip
    take: $take
  ) {
    data {
      id
      ...CompetitorShareOfVoiceAggregatedDataItemFragmentBCShareOfVoiceTable
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${CompetitorShareOfVoiceAggregatedDataItemFragmentBcShareOfVoiceTableFragmentDoc}`;

/**
 * __useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery__
 *
 * To run a query within a React component, call `useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      previewPostsFilters: // value for 'previewPostsFilters'
 *   },
 * });
 */
export function useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryVariables>(GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableDocument, options);
      }
export function useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryVariables>(GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableDocument, options);
        }
export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryHookResult = ReturnType<typeof useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery>;
export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableLazyQueryHookResult = ReturnType<typeof useGetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableLazyQuery>;
export type GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryResult = Apollo.QueryResult<GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQuery, GetCompetitorShareOfVoiceAggregatedDataForBrandCompetitorsShareOfVoiceTableQueryVariables>;
export const UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewDocument = gql`
    mutation UpdateHourUsageThresholdAlertForBrandDurationUsageDialogView($data: UpdateSocialListeningHourUsageThresholdAlertInput!) {
  updateSocialListeningHourUsageThresholdAlert(data: $data) {
    id
  }
}
    `;
export type UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationFn = Apollo.MutationFunction<UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation, UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationVariables>;

/**
 * __useUpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation__
 *
 * To run a mutation, you first call `useUpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation, { data, loading, error }] = useUpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation, UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation, UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationVariables>(UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewDocument, options);
      }
export type UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationHookResult = ReturnType<typeof useUpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation>;
export type UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationResult = Apollo.MutationResult<UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation>;
export type UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationOptions = Apollo.BaseMutationOptions<UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutation, UpdateHourUsageThresholdAlertForBrandDurationUsageDialogViewMutationVariables>;
export const AggregatedBrandDurationUsageForBrandDurationUsageDialogViewDocument = gql`
    query AggregatedBrandDurationUsageForBrandDurationUsageDialogView($filters: AggregatedBrandDurationUsageFilters!) {
  aggregatedBrandDurationUsage(filters: $filters) {
    durationUsed
    totalTopicsCount
    topics {
      durationUsed
      topic {
        id
        name
        ...TopicFragmentTopicMoreContextMenu
        ...TopicFragmentTopicPauseContextMenu
      }
    }
    brand {
      id
      name
      creators {
        id
        profilePictureUrl
      }
      ...BrandFragmentBrandPauseContextMenu
      ...BrandFragmentBrandMoreContextMenu
    }
  }
}
    ${TopicFragmentTopicMoreContextMenuFragmentDoc}
${TopicFragmentTopicPauseContextMenuFragmentDoc}
${BrandFragmentBrandPauseContextMenuFragmentDoc}
${BrandFragmentBrandMoreContextMenuFragmentDoc}`;

/**
 * __useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery__
 *
 * To run a query within a React component, call `useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery(baseOptions: Apollo.QueryHookOptions<AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery, AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery, AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryVariables>(AggregatedBrandDurationUsageForBrandDurationUsageDialogViewDocument, options);
      }
export function useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery, AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery, AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryVariables>(AggregatedBrandDurationUsageForBrandDurationUsageDialogViewDocument, options);
        }
export type AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryHookResult = ReturnType<typeof useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery>;
export type AggregatedBrandDurationUsageForBrandDurationUsageDialogViewLazyQueryHookResult = ReturnType<typeof useAggregatedBrandDurationUsageForBrandDurationUsageDialogViewLazyQuery>;
export type AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryResult = Apollo.QueryResult<AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQuery, AggregatedBrandDurationUsageForBrandDurationUsageDialogViewQueryVariables>;
export const DeleteCollectionForCollectionContextMenuDocument = gql`
    mutation DeleteCollectionForCollectionContextMenu($collectionId: String!) {
  deleteCollection(id: $collectionId) {
    message
    success
  }
}
    `;
export type DeleteCollectionForCollectionContextMenuMutationFn = Apollo.MutationFunction<DeleteCollectionForCollectionContextMenuMutation, DeleteCollectionForCollectionContextMenuMutationVariables>;

/**
 * __useDeleteCollectionForCollectionContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionForCollectionContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionForCollectionContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionForCollectionContextMenuMutation, { data, loading, error }] = useDeleteCollectionForCollectionContextMenuMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useDeleteCollectionForCollectionContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollectionForCollectionContextMenuMutation, DeleteCollectionForCollectionContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollectionForCollectionContextMenuMutation, DeleteCollectionForCollectionContextMenuMutationVariables>(DeleteCollectionForCollectionContextMenuDocument, options);
      }
export type DeleteCollectionForCollectionContextMenuMutationHookResult = ReturnType<typeof useDeleteCollectionForCollectionContextMenuMutation>;
export type DeleteCollectionForCollectionContextMenuMutationResult = Apollo.MutationResult<DeleteCollectionForCollectionContextMenuMutation>;
export type DeleteCollectionForCollectionContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteCollectionForCollectionContextMenuMutation, DeleteCollectionForCollectionContextMenuMutationVariables>;
export const UpdateCollectionPreviewForCollectionContextMenuDocument = gql`
    mutation UpdateCollectionPreviewForCollectionContextMenu($data: UpdateCollectionPreviewInput!) {
  updateCollectionPreview(data: $data) {
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export type UpdateCollectionPreviewForCollectionContextMenuMutationFn = Apollo.MutationFunction<UpdateCollectionPreviewForCollectionContextMenuMutation, UpdateCollectionPreviewForCollectionContextMenuMutationVariables>;

/**
 * __useUpdateCollectionPreviewForCollectionContextMenuMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionPreviewForCollectionContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionPreviewForCollectionContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionPreviewForCollectionContextMenuMutation, { data, loading, error }] = useUpdateCollectionPreviewForCollectionContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCollectionPreviewForCollectionContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionPreviewForCollectionContextMenuMutation, UpdateCollectionPreviewForCollectionContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionPreviewForCollectionContextMenuMutation, UpdateCollectionPreviewForCollectionContextMenuMutationVariables>(UpdateCollectionPreviewForCollectionContextMenuDocument, options);
      }
export type UpdateCollectionPreviewForCollectionContextMenuMutationHookResult = ReturnType<typeof useUpdateCollectionPreviewForCollectionContextMenuMutation>;
export type UpdateCollectionPreviewForCollectionContextMenuMutationResult = Apollo.MutationResult<UpdateCollectionPreviewForCollectionContextMenuMutation>;
export type UpdateCollectionPreviewForCollectionContextMenuMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionPreviewForCollectionContextMenuMutation, UpdateCollectionPreviewForCollectionContextMenuMutationVariables>;
export const UpdateCollectionForCollectionNameDocument = gql`
    mutation UpdateCollectionForCollectionName($data: UpdateCollectionInput!) {
  updateCollection(data: $data) {
    ...CollectionFragmentCollectionName
  }
}
    ${CollectionFragmentCollectionNameFragmentDoc}`;
export type UpdateCollectionForCollectionNameMutationFn = Apollo.MutationFunction<UpdateCollectionForCollectionNameMutation, UpdateCollectionForCollectionNameMutationVariables>;

/**
 * __useUpdateCollectionForCollectionNameMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionForCollectionNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionForCollectionNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionForCollectionNameMutation, { data, loading, error }] = useUpdateCollectionForCollectionNameMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCollectionForCollectionNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionForCollectionNameMutation, UpdateCollectionForCollectionNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionForCollectionNameMutation, UpdateCollectionForCollectionNameMutationVariables>(UpdateCollectionForCollectionNameDocument, options);
      }
export type UpdateCollectionForCollectionNameMutationHookResult = ReturnType<typeof useUpdateCollectionForCollectionNameMutation>;
export type UpdateCollectionForCollectionNameMutationResult = Apollo.MutationResult<UpdateCollectionForCollectionNameMutation>;
export type UpdateCollectionForCollectionNameMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionForCollectionNameMutation, UpdateCollectionForCollectionNameMutationVariables>;
export const GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsDocument = gql`
    query GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbs($input: GetSameLevelCollectionsInput!, $after: String, $take: Int) {
  sameLevelCollections(input: $input, after: $after, take: $take) {
    pageInfo {
      endCursor
      hasNextPage
    }
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery__
 *
 * To run a query within a React component, call `useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery(baseOptions: Apollo.QueryHookOptions<GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery, GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery, GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryVariables>(GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsDocument, options);
      }
export function useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery, GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery, GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryVariables>(GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsDocument, options);
        }
export type GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryHookResult = ReturnType<typeof useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery>;
export type GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsLazyQueryHookResult = ReturnType<typeof useGetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsLazyQuery>;
export type GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryResult = Apollo.QueryResult<GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQuery, GetSameLevelCollectionsForCollectionTopHeaderBreadcrumbsQueryVariables>;
export const GetCollectionViewersDocument = gql`
    query GetCollectionViewers($id: String!) {
  collection(id: $id) {
    ...CollectionFragmentCollectionViewers
  }
}
    ${CollectionFragmentCollectionViewersFragmentDoc}`;

/**
 * __useGetCollectionViewersQuery__
 *
 * To run a query within a React component, call `useGetCollectionViewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionViewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionViewersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionViewersQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionViewersQuery, GetCollectionViewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionViewersQuery, GetCollectionViewersQueryVariables>(GetCollectionViewersDocument, options);
      }
export function useGetCollectionViewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionViewersQuery, GetCollectionViewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionViewersQuery, GetCollectionViewersQueryVariables>(GetCollectionViewersDocument, options);
        }
export type GetCollectionViewersQueryHookResult = ReturnType<typeof useGetCollectionViewersQuery>;
export type GetCollectionViewersLazyQueryHookResult = ReturnType<typeof useGetCollectionViewersLazyQuery>;
export type GetCollectionViewersQueryResult = Apollo.QueryResult<GetCollectionViewersQuery, GetCollectionViewersQueryVariables>;
export const GetCollectionsSimilarSearchForSimilarCollectionListDocument = gql`
    query GetCollectionsSimilarSearchForSimilarCollectionList($filters: CollectionFilters!) {
  collectionsSimilarSearch(filters: $filters) {
    hits {
      type
      item {
        id
        ...CollectionFragmentSimilarCollectionList
      }
    }
  }
}
    ${CollectionFragmentSimilarCollectionListFragmentDoc}`;

/**
 * __useGetCollectionsSimilarSearchForSimilarCollectionListQuery__
 *
 * To run a query within a React component, call `useGetCollectionsSimilarSearchForSimilarCollectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsSimilarSearchForSimilarCollectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsSimilarSearchForSimilarCollectionListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCollectionsSimilarSearchForSimilarCollectionListQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsSimilarSearchForSimilarCollectionListQuery, GetCollectionsSimilarSearchForSimilarCollectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsSimilarSearchForSimilarCollectionListQuery, GetCollectionsSimilarSearchForSimilarCollectionListQueryVariables>(GetCollectionsSimilarSearchForSimilarCollectionListDocument, options);
      }
export function useGetCollectionsSimilarSearchForSimilarCollectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsSimilarSearchForSimilarCollectionListQuery, GetCollectionsSimilarSearchForSimilarCollectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsSimilarSearchForSimilarCollectionListQuery, GetCollectionsSimilarSearchForSimilarCollectionListQueryVariables>(GetCollectionsSimilarSearchForSimilarCollectionListDocument, options);
        }
export type GetCollectionsSimilarSearchForSimilarCollectionListQueryHookResult = ReturnType<typeof useGetCollectionsSimilarSearchForSimilarCollectionListQuery>;
export type GetCollectionsSimilarSearchForSimilarCollectionListLazyQueryHookResult = ReturnType<typeof useGetCollectionsSimilarSearchForSimilarCollectionListLazyQuery>;
export type GetCollectionsSimilarSearchForSimilarCollectionListQueryResult = Apollo.QueryResult<GetCollectionsSimilarSearchForSimilarCollectionListQuery, GetCollectionsSimilarSearchForSimilarCollectionListQueryVariables>;
export const SavePostsToCollectionsForCollectionSendToCollectionFormDocument = gql`
    mutation SavePostsToCollectionsForCollectionSendToCollectionForm($data: SavePostsToCollectionsInput!) {
  savePostsToCollections(data: $data) {
    success
    message
  }
}
    `;
export type SavePostsToCollectionsForCollectionSendToCollectionFormMutationFn = Apollo.MutationFunction<SavePostsToCollectionsForCollectionSendToCollectionFormMutation, SavePostsToCollectionsForCollectionSendToCollectionFormMutationVariables>;

/**
 * __useSavePostsToCollectionsForCollectionSendToCollectionFormMutation__
 *
 * To run a mutation, you first call `useSavePostsToCollectionsForCollectionSendToCollectionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostsToCollectionsForCollectionSendToCollectionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostsToCollectionsForCollectionSendToCollectionFormMutation, { data, loading, error }] = useSavePostsToCollectionsForCollectionSendToCollectionFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSavePostsToCollectionsForCollectionSendToCollectionFormMutation(baseOptions?: Apollo.MutationHookOptions<SavePostsToCollectionsForCollectionSendToCollectionFormMutation, SavePostsToCollectionsForCollectionSendToCollectionFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePostsToCollectionsForCollectionSendToCollectionFormMutation, SavePostsToCollectionsForCollectionSendToCollectionFormMutationVariables>(SavePostsToCollectionsForCollectionSendToCollectionFormDocument, options);
      }
export type SavePostsToCollectionsForCollectionSendToCollectionFormMutationHookResult = ReturnType<typeof useSavePostsToCollectionsForCollectionSendToCollectionFormMutation>;
export type SavePostsToCollectionsForCollectionSendToCollectionFormMutationResult = Apollo.MutationResult<SavePostsToCollectionsForCollectionSendToCollectionFormMutation>;
export type SavePostsToCollectionsForCollectionSendToCollectionFormMutationOptions = Apollo.BaseMutationOptions<SavePostsToCollectionsForCollectionSendToCollectionFormMutation, SavePostsToCollectionsForCollectionSendToCollectionFormMutationVariables>;
export const RemovePostsFromCollectionsForCollectionSendToCollectionFormDocument = gql`
    mutation RemovePostsFromCollectionsForCollectionSendToCollectionForm($data: RemovePostsFromCollectionsInput!) {
  removePostsFromCollections(data: $data) {
    success
    message
  }
}
    `;
export type RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationFn = Apollo.MutationFunction<RemovePostsFromCollectionsForCollectionSendToCollectionFormMutation, RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationVariables>;

/**
 * __useRemovePostsFromCollectionsForCollectionSendToCollectionFormMutation__
 *
 * To run a mutation, you first call `useRemovePostsFromCollectionsForCollectionSendToCollectionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePostsFromCollectionsForCollectionSendToCollectionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePostsFromCollectionsForCollectionSendToCollectionFormMutation, { data, loading, error }] = useRemovePostsFromCollectionsForCollectionSendToCollectionFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePostsFromCollectionsForCollectionSendToCollectionFormMutation(baseOptions?: Apollo.MutationHookOptions<RemovePostsFromCollectionsForCollectionSendToCollectionFormMutation, RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePostsFromCollectionsForCollectionSendToCollectionFormMutation, RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationVariables>(RemovePostsFromCollectionsForCollectionSendToCollectionFormDocument, options);
      }
export type RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationHookResult = ReturnType<typeof useRemovePostsFromCollectionsForCollectionSendToCollectionFormMutation>;
export type RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationResult = Apollo.MutationResult<RemovePostsFromCollectionsForCollectionSendToCollectionFormMutation>;
export type RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationOptions = Apollo.BaseMutationOptions<RemovePostsFromCollectionsForCollectionSendToCollectionFormMutation, RemovePostsFromCollectionsForCollectionSendToCollectionFormMutationVariables>;
export const GetPostCollectionsForUseAutocompleteInfiniteCollectionsDocument = gql`
    query GetPostCollectionsForUseAutocompleteInfiniteCollections($input: GetPostCollectionInput!) {
  postCollections(input: $input) {
    meta {
      totalCount
    }
    pageInfo {
      endCursor
      hasNextPage
      startCursor
      hasPreviousPage
    }
    data {
      type
      item {
        ...CollectionFragmentUseAutocompleteInfiniteCollections
      }
    }
  }
}
    ${CollectionFragmentUseAutocompleteInfiniteCollectionsFragmentDoc}`;

/**
 * __useGetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery__
 *
 * To run a query within a React component, call `useGetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery, GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery, GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryVariables>(GetPostCollectionsForUseAutocompleteInfiniteCollectionsDocument, options);
      }
export function useGetPostCollectionsForUseAutocompleteInfiniteCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery, GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery, GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryVariables>(GetPostCollectionsForUseAutocompleteInfiniteCollectionsDocument, options);
        }
export type GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryHookResult = ReturnType<typeof useGetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery>;
export type GetPostCollectionsForUseAutocompleteInfiniteCollectionsLazyQueryHookResult = ReturnType<typeof useGetPostCollectionsForUseAutocompleteInfiniteCollectionsLazyQuery>;
export type GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryResult = Apollo.QueryResult<GetPostCollectionsForUseAutocompleteInfiniteCollectionsQuery, GetPostCollectionsForUseAutocompleteInfiniteCollectionsQueryVariables>;
export const DeleteBookmarkForCollectionBookmarkHandlersDocument = gql`
    mutation DeleteBookmarkForCollectionBookmarkHandlers($input: DeleteCollectionBookmarkInput!) {
  deleteCollectionBookmark(input: $input) {
    message
    success
    deleted {
      id
    }
  }
}
    `;
export type DeleteBookmarkForCollectionBookmarkHandlersMutationFn = Apollo.MutationFunction<DeleteBookmarkForCollectionBookmarkHandlersMutation, DeleteBookmarkForCollectionBookmarkHandlersMutationVariables>;

/**
 * __useDeleteBookmarkForCollectionBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkForCollectionBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkForCollectionBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkForCollectionBookmarkHandlersMutation, { data, loading, error }] = useDeleteBookmarkForCollectionBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBookmarkForCollectionBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkForCollectionBookmarkHandlersMutation, DeleteBookmarkForCollectionBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkForCollectionBookmarkHandlersMutation, DeleteBookmarkForCollectionBookmarkHandlersMutationVariables>(DeleteBookmarkForCollectionBookmarkHandlersDocument, options);
      }
export type DeleteBookmarkForCollectionBookmarkHandlersMutationHookResult = ReturnType<typeof useDeleteBookmarkForCollectionBookmarkHandlersMutation>;
export type DeleteBookmarkForCollectionBookmarkHandlersMutationResult = Apollo.MutationResult<DeleteBookmarkForCollectionBookmarkHandlersMutation>;
export type DeleteBookmarkForCollectionBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkForCollectionBookmarkHandlersMutation, DeleteBookmarkForCollectionBookmarkHandlersMutationVariables>;
export const CreateBookmarkForCollectionBookmarkHandlersDocument = gql`
    mutation CreateBookmarkForCollectionBookmarkHandlers($input: CreateCollectionBookmarkInput!) {
  createCollectionBookmark(input: $input) {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;
export type CreateBookmarkForCollectionBookmarkHandlersMutationFn = Apollo.MutationFunction<CreateBookmarkForCollectionBookmarkHandlersMutation, CreateBookmarkForCollectionBookmarkHandlersMutationVariables>;

/**
 * __useCreateBookmarkForCollectionBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkForCollectionBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkForCollectionBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkForCollectionBookmarkHandlersMutation, { data, loading, error }] = useCreateBookmarkForCollectionBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookmarkForCollectionBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkForCollectionBookmarkHandlersMutation, CreateBookmarkForCollectionBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkForCollectionBookmarkHandlersMutation, CreateBookmarkForCollectionBookmarkHandlersMutationVariables>(CreateBookmarkForCollectionBookmarkHandlersDocument, options);
      }
export type CreateBookmarkForCollectionBookmarkHandlersMutationHookResult = ReturnType<typeof useCreateBookmarkForCollectionBookmarkHandlersMutation>;
export type CreateBookmarkForCollectionBookmarkHandlersMutationResult = Apollo.MutationResult<CreateBookmarkForCollectionBookmarkHandlersMutation>;
export type CreateBookmarkForCollectionBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkForCollectionBookmarkHandlersMutation, CreateBookmarkForCollectionBookmarkHandlersMutationVariables>;
export const GetMoveToAnotherCollectionCollectionsListDocument = gql`
    query GetMoveToAnotherCollectionCollectionsList($filters: CollectionFilters!, $after: String, $take: Int) {
  collectionsSmartSearch(filters: $filters, after: $after, take: $take) {
    meta {
      totalCount
    }
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
    data {
      type
      item {
        ...CollectionFragmentMoveToAnotherCollectionCollectionsList
      }
    }
  }
}
    ${CollectionFragmentMoveToAnotherCollectionCollectionsListFragmentDoc}`;

/**
 * __useGetMoveToAnotherCollectionCollectionsListQuery__
 *
 * To run a query within a React component, call `useGetMoveToAnotherCollectionCollectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveToAnotherCollectionCollectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveToAnotherCollectionCollectionsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetMoveToAnotherCollectionCollectionsListQuery(baseOptions: Apollo.QueryHookOptions<GetMoveToAnotherCollectionCollectionsListQuery, GetMoveToAnotherCollectionCollectionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoveToAnotherCollectionCollectionsListQuery, GetMoveToAnotherCollectionCollectionsListQueryVariables>(GetMoveToAnotherCollectionCollectionsListDocument, options);
      }
export function useGetMoveToAnotherCollectionCollectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoveToAnotherCollectionCollectionsListQuery, GetMoveToAnotherCollectionCollectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoveToAnotherCollectionCollectionsListQuery, GetMoveToAnotherCollectionCollectionsListQueryVariables>(GetMoveToAnotherCollectionCollectionsListDocument, options);
        }
export type GetMoveToAnotherCollectionCollectionsListQueryHookResult = ReturnType<typeof useGetMoveToAnotherCollectionCollectionsListQuery>;
export type GetMoveToAnotherCollectionCollectionsListLazyQueryHookResult = ReturnType<typeof useGetMoveToAnotherCollectionCollectionsListLazyQuery>;
export type GetMoveToAnotherCollectionCollectionsListQueryResult = Apollo.QueryResult<GetMoveToAnotherCollectionCollectionsListQuery, GetMoveToAnotherCollectionCollectionsListQueryVariables>;
export const MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalDocument = gql`
    mutation MoveCollectionsToCollectionForUseMoveToAnotherCollectionModal($data: MoveCollectionsToCollectionInput!) {
  moveCollectionsToCollection(data: $data) {
    success
    message
  }
}
    `;
export type MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationFn = Apollo.MutationFunction<MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>;

/**
 * __useMoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation__
 *
 * To run a mutation, you first call `useMoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation, { data, loading, error }] = useMoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation(baseOptions?: Apollo.MutationHookOptions<MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>(MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalDocument, options);
      }
export type MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationHookResult = ReturnType<typeof useMoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation>;
export type MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationResult = Apollo.MutationResult<MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation>;
export type MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationOptions = Apollo.BaseMutationOptions<MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>;
export const RemoveCollectionsParentForUseMoveToAnotherCollectionModalDocument = gql`
    mutation RemoveCollectionsParentForUseMoveToAnotherCollectionModal($data: RemoveCollectionsParentInput!) {
  removeCollectionsParent(data: $data) {
    success
    message
  }
}
    `;
export type RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationFn = Apollo.MutationFunction<RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation, RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationVariables>;

/**
 * __useRemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation__
 *
 * To run a mutation, you first call `useRemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCollectionsParentForUseMoveToAnotherCollectionModalMutation, { data, loading, error }] = useRemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation, RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation, RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationVariables>(RemoveCollectionsParentForUseMoveToAnotherCollectionModalDocument, options);
      }
export type RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationHookResult = ReturnType<typeof useRemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation>;
export type RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationResult = Apollo.MutationResult<RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation>;
export type RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationOptions = Apollo.BaseMutationOptions<RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutation, RemoveCollectionsParentForUseMoveToAnotherCollectionModalMutationVariables>;
export const GetContentIdeaCollectionsForContentCalendarCollectionCardViewDocument = gql`
    query GetContentIdeaCollectionsForContentCalendarCollectionCardView($take: Int) {
  contentIdeaCollections(take: $take) {
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useGetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery, GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery, GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryVariables>(GetContentIdeaCollectionsForContentCalendarCollectionCardViewDocument, options);
      }
export function useGetContentIdeaCollectionsForContentCalendarCollectionCardViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery, GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery, GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryVariables>(GetContentIdeaCollectionsForContentCalendarCollectionCardViewDocument, options);
        }
export type GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryHookResult = ReturnType<typeof useGetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery>;
export type GetContentIdeaCollectionsForContentCalendarCollectionCardViewLazyQueryHookResult = ReturnType<typeof useGetContentIdeaCollectionsForContentCalendarCollectionCardViewLazyQuery>;
export type GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryResult = Apollo.QueryResult<GetContentIdeaCollectionsForContentCalendarCollectionCardViewQuery, GetContentIdeaCollectionsForContentCalendarCollectionCardViewQueryVariables>;
export const GetPostsForCustomCollectionsUsePreviewablePostDocument = gql`
    query GetPostsForCustomCollectionsUsePreviewablePost($filters: PostFilters!, $take: Int, $after: String) {
  posts(filters: $filters, take: $take, after: $after) {
    data {
      id
      ...PostFragmentCollectionMultiPostPreview
    }
    meta {
      totalCount
      newPostCount
    }
  }
}
    ${PostFragmentCollectionMultiPostPreviewFragmentDoc}`;

/**
 * __useGetPostsForCustomCollectionsUsePreviewablePostQuery__
 *
 * To run a query within a React component, call `useGetPostsForCustomCollectionsUsePreviewablePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForCustomCollectionsUsePreviewablePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForCustomCollectionsUsePreviewablePostQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPostsForCustomCollectionsUsePreviewablePostQuery(baseOptions: Apollo.QueryHookOptions<GetPostsForCustomCollectionsUsePreviewablePostQuery, GetPostsForCustomCollectionsUsePreviewablePostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsForCustomCollectionsUsePreviewablePostQuery, GetPostsForCustomCollectionsUsePreviewablePostQueryVariables>(GetPostsForCustomCollectionsUsePreviewablePostDocument, options);
      }
export function useGetPostsForCustomCollectionsUsePreviewablePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsForCustomCollectionsUsePreviewablePostQuery, GetPostsForCustomCollectionsUsePreviewablePostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsForCustomCollectionsUsePreviewablePostQuery, GetPostsForCustomCollectionsUsePreviewablePostQueryVariables>(GetPostsForCustomCollectionsUsePreviewablePostDocument, options);
        }
export type GetPostsForCustomCollectionsUsePreviewablePostQueryHookResult = ReturnType<typeof useGetPostsForCustomCollectionsUsePreviewablePostQuery>;
export type GetPostsForCustomCollectionsUsePreviewablePostLazyQueryHookResult = ReturnType<typeof useGetPostsForCustomCollectionsUsePreviewablePostLazyQuery>;
export type GetPostsForCustomCollectionsUsePreviewablePostQueryResult = Apollo.QueryResult<GetPostsForCustomCollectionsUsePreviewablePostQuery, GetPostsForCustomCollectionsUsePreviewablePostQueryVariables>;
export const GetPostCollectionsForCollectionAutocompleteMenuDocument = gql`
    query GetPostCollectionsForCollectionAutocompleteMenu($input: GetPostCollectionInput!) {
  postCollections(input: $input) {
    meta {
      totalCount
    }
    pageInfo {
      endCursor
      hasNextPage
      startCursor
      hasPreviousPage
    }
    data {
      type
      item {
        ...CollectionFragmentCollectionAutocompleteMenu
      }
    }
  }
}
    ${CollectionFragmentCollectionAutocompleteMenuFragmentDoc}`;

/**
 * __useGetPostCollectionsForCollectionAutocompleteMenuQuery__
 *
 * To run a query within a React component, call `useGetPostCollectionsForCollectionAutocompleteMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCollectionsForCollectionAutocompleteMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCollectionsForCollectionAutocompleteMenuQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostCollectionsForCollectionAutocompleteMenuQuery(baseOptions: Apollo.QueryHookOptions<GetPostCollectionsForCollectionAutocompleteMenuQuery, GetPostCollectionsForCollectionAutocompleteMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCollectionsForCollectionAutocompleteMenuQuery, GetPostCollectionsForCollectionAutocompleteMenuQueryVariables>(GetPostCollectionsForCollectionAutocompleteMenuDocument, options);
      }
export function useGetPostCollectionsForCollectionAutocompleteMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCollectionsForCollectionAutocompleteMenuQuery, GetPostCollectionsForCollectionAutocompleteMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCollectionsForCollectionAutocompleteMenuQuery, GetPostCollectionsForCollectionAutocompleteMenuQueryVariables>(GetPostCollectionsForCollectionAutocompleteMenuDocument, options);
        }
export type GetPostCollectionsForCollectionAutocompleteMenuQueryHookResult = ReturnType<typeof useGetPostCollectionsForCollectionAutocompleteMenuQuery>;
export type GetPostCollectionsForCollectionAutocompleteMenuLazyQueryHookResult = ReturnType<typeof useGetPostCollectionsForCollectionAutocompleteMenuLazyQuery>;
export type GetPostCollectionsForCollectionAutocompleteMenuQueryResult = Apollo.QueryResult<GetPostCollectionsForCollectionAutocompleteMenuQuery, GetPostCollectionsForCollectionAutocompleteMenuQueryVariables>;
export const GetCollectionForCollectionMenuItemViewDocument = gql`
    query GetCollectionForCollectionMenuItemView($collectionId: String!) {
  collection(id: $collectionId) {
    ...CollectionFragmentCollectionMenuItemView
  }
}
    ${CollectionFragmentCollectionMenuItemViewFragmentDoc}`;

/**
 * __useGetCollectionForCollectionMenuItemViewQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCollectionMenuItemViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCollectionMenuItemViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCollectionMenuItemViewQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForCollectionMenuItemViewQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCollectionMenuItemViewQuery, GetCollectionForCollectionMenuItemViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCollectionMenuItemViewQuery, GetCollectionForCollectionMenuItemViewQueryVariables>(GetCollectionForCollectionMenuItemViewDocument, options);
      }
export function useGetCollectionForCollectionMenuItemViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCollectionMenuItemViewQuery, GetCollectionForCollectionMenuItemViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCollectionMenuItemViewQuery, GetCollectionForCollectionMenuItemViewQueryVariables>(GetCollectionForCollectionMenuItemViewDocument, options);
        }
export type GetCollectionForCollectionMenuItemViewQueryHookResult = ReturnType<typeof useGetCollectionForCollectionMenuItemViewQuery>;
export type GetCollectionForCollectionMenuItemViewLazyQueryHookResult = ReturnType<typeof useGetCollectionForCollectionMenuItemViewLazyQuery>;
export type GetCollectionForCollectionMenuItemViewQueryResult = Apollo.QueryResult<GetCollectionForCollectionMenuItemViewQuery, GetCollectionForCollectionMenuItemViewQueryVariables>;
export const GetCollectionForCollectionSearchAutocompleteSectionDocument = gql`
    query GetCollectionForCollectionSearchAutocompleteSection($collectionId: String!) {
  collection(id: $collectionId) {
    id
    ...CollectionFragmentCollectionName
  }
}
    ${CollectionFragmentCollectionNameFragmentDoc}`;

/**
 * __useGetCollectionForCollectionSearchAutocompleteSectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCollectionSearchAutocompleteSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCollectionSearchAutocompleteSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCollectionSearchAutocompleteSectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForCollectionSearchAutocompleteSectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCollectionSearchAutocompleteSectionQuery, GetCollectionForCollectionSearchAutocompleteSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCollectionSearchAutocompleteSectionQuery, GetCollectionForCollectionSearchAutocompleteSectionQueryVariables>(GetCollectionForCollectionSearchAutocompleteSectionDocument, options);
      }
export function useGetCollectionForCollectionSearchAutocompleteSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCollectionSearchAutocompleteSectionQuery, GetCollectionForCollectionSearchAutocompleteSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCollectionSearchAutocompleteSectionQuery, GetCollectionForCollectionSearchAutocompleteSectionQueryVariables>(GetCollectionForCollectionSearchAutocompleteSectionDocument, options);
        }
export type GetCollectionForCollectionSearchAutocompleteSectionQueryHookResult = ReturnType<typeof useGetCollectionForCollectionSearchAutocompleteSectionQuery>;
export type GetCollectionForCollectionSearchAutocompleteSectionLazyQueryHookResult = ReturnType<typeof useGetCollectionForCollectionSearchAutocompleteSectionLazyQuery>;
export type GetCollectionForCollectionSearchAutocompleteSectionQueryResult = Apollo.QueryResult<GetCollectionForCollectionSearchAutocompleteSectionQuery, GetCollectionForCollectionSearchAutocompleteSectionQueryVariables>;
export const GetCollectionForMoveToAnotherCollectionDocument = gql`
    query GetCollectionForMoveToAnotherCollection($collectionId: String!) {
  collection(id: $collectionId) {
    id
    ...CollectionFragmentMoveToAnotherCollection
  }
}
    ${CollectionFragmentMoveToAnotherCollectionFragmentDoc}`;

/**
 * __useGetCollectionForMoveToAnotherCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionForMoveToAnotherCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForMoveToAnotherCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForMoveToAnotherCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForMoveToAnotherCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForMoveToAnotherCollectionQuery, GetCollectionForMoveToAnotherCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForMoveToAnotherCollectionQuery, GetCollectionForMoveToAnotherCollectionQueryVariables>(GetCollectionForMoveToAnotherCollectionDocument, options);
      }
export function useGetCollectionForMoveToAnotherCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForMoveToAnotherCollectionQuery, GetCollectionForMoveToAnotherCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForMoveToAnotherCollectionQuery, GetCollectionForMoveToAnotherCollectionQueryVariables>(GetCollectionForMoveToAnotherCollectionDocument, options);
        }
export type GetCollectionForMoveToAnotherCollectionQueryHookResult = ReturnType<typeof useGetCollectionForMoveToAnotherCollectionQuery>;
export type GetCollectionForMoveToAnotherCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionForMoveToAnotherCollectionLazyQuery>;
export type GetCollectionForMoveToAnotherCollectionQueryResult = Apollo.QueryResult<GetCollectionForMoveToAnotherCollectionQuery, GetCollectionForMoveToAnotherCollectionQueryVariables>;
export const GetPostsForCollectionPeekingCardViewDocument = gql`
    query GetPostsForCollectionPeekingCardView($filters: PostFilters!, $take: Int!) {
  posts(filters: $filters, take: $take) {
    data {
      id
      ...PostFragmentPostPreview
    }
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetPostsForCollectionPeekingCardViewQuery__
 *
 * To run a query within a React component, call `useGetPostsForCollectionPeekingCardViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForCollectionPeekingCardViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForCollectionPeekingCardViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPostsForCollectionPeekingCardViewQuery(baseOptions: Apollo.QueryHookOptions<GetPostsForCollectionPeekingCardViewQuery, GetPostsForCollectionPeekingCardViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsForCollectionPeekingCardViewQuery, GetPostsForCollectionPeekingCardViewQueryVariables>(GetPostsForCollectionPeekingCardViewDocument, options);
      }
export function useGetPostsForCollectionPeekingCardViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsForCollectionPeekingCardViewQuery, GetPostsForCollectionPeekingCardViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsForCollectionPeekingCardViewQuery, GetPostsForCollectionPeekingCardViewQueryVariables>(GetPostsForCollectionPeekingCardViewDocument, options);
        }
export type GetPostsForCollectionPeekingCardViewQueryHookResult = ReturnType<typeof useGetPostsForCollectionPeekingCardViewQuery>;
export type GetPostsForCollectionPeekingCardViewLazyQueryHookResult = ReturnType<typeof useGetPostsForCollectionPeekingCardViewLazyQuery>;
export type GetPostsForCollectionPeekingCardViewQueryResult = Apollo.QueryResult<GetPostsForCollectionPeekingCardViewQuery, GetPostsForCollectionPeekingCardViewQueryVariables>;
export const CollectionPermissionToastDocument = gql`
    query CollectionPermissionToast($id: String!) {
  collection(id: $id) {
    ...CollectionFragmentCollectionMultiPostPreview
  }
}
    ${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}`;

/**
 * __useCollectionPermissionToastQuery__
 *
 * To run a query within a React component, call `useCollectionPermissionToastQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionPermissionToastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionPermissionToastQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionPermissionToastQuery(baseOptions: Apollo.QueryHookOptions<CollectionPermissionToastQuery, CollectionPermissionToastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionPermissionToastQuery, CollectionPermissionToastQueryVariables>(CollectionPermissionToastDocument, options);
      }
export function useCollectionPermissionToastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionPermissionToastQuery, CollectionPermissionToastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionPermissionToastQuery, CollectionPermissionToastQueryVariables>(CollectionPermissionToastDocument, options);
        }
export type CollectionPermissionToastQueryHookResult = ReturnType<typeof useCollectionPermissionToastQuery>;
export type CollectionPermissionToastLazyQueryHookResult = ReturnType<typeof useCollectionPermissionToastLazyQuery>;
export type CollectionPermissionToastQueryResult = Apollo.QueryResult<CollectionPermissionToastQuery, CollectionPermissionToastQueryVariables>;
export const CollectionsSmartSearchForCollectionPermissionCollectionTreeDocument = gql`
    query CollectionsSmartSearchForCollectionPermissionCollectionTree($filters: CollectionFilters!, $after: String, $take: Int) {
  collectionsSmartSearch(filters: $filters, after: $after, take: $take) {
    meta {
      totalCount
    }
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
    data {
      type
      item {
        ...CollectionFragmentCollectionCardView
        ...CollectionFragmentCollectionPermissionCollectionTree
      }
    }
  }
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}
${CollectionFragmentCollectionPermissionCollectionTreeFragmentDoc}`;

/**
 * __useCollectionsSmartSearchForCollectionPermissionCollectionTreeQuery__
 *
 * To run a query within a React component, call `useCollectionsSmartSearchForCollectionPermissionCollectionTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsSmartSearchForCollectionPermissionCollectionTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsSmartSearchForCollectionPermissionCollectionTreeQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCollectionsSmartSearchForCollectionPermissionCollectionTreeQuery(baseOptions: Apollo.QueryHookOptions<CollectionsSmartSearchForCollectionPermissionCollectionTreeQuery, CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsSmartSearchForCollectionPermissionCollectionTreeQuery, CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>(CollectionsSmartSearchForCollectionPermissionCollectionTreeDocument, options);
      }
export function useCollectionsSmartSearchForCollectionPermissionCollectionTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsSmartSearchForCollectionPermissionCollectionTreeQuery, CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsSmartSearchForCollectionPermissionCollectionTreeQuery, CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>(CollectionsSmartSearchForCollectionPermissionCollectionTreeDocument, options);
        }
export type CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryHookResult = ReturnType<typeof useCollectionsSmartSearchForCollectionPermissionCollectionTreeQuery>;
export type CollectionsSmartSearchForCollectionPermissionCollectionTreeLazyQueryHookResult = ReturnType<typeof useCollectionsSmartSearchForCollectionPermissionCollectionTreeLazyQuery>;
export type CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryResult = Apollo.QueryResult<CollectionsSmartSearchForCollectionPermissionCollectionTreeQuery, CollectionsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>;
export const GetPostsSmartSearchForCollectionPermissionCollectionTreeDocument = gql`
    query GetPostsSmartSearchForCollectionPermissionCollectionTree($filters: PostFiltersForSmartSearch!, $take: Int, $after: String, $sortType: SortType) {
  postsSmartSearch(
    filters: $filters
    take: $take
    after: $after
    sortType: $sortType
  ) {
    data {
      item {
        id
        ...PostFragmentCollectionPermissionCollectionTree
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentCollectionPermissionCollectionTreeFragmentDoc}`;

/**
 * __useGetPostsSmartSearchForCollectionPermissionCollectionTreeQuery__
 *
 * To run a query within a React component, call `useGetPostsSmartSearchForCollectionPermissionCollectionTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSmartSearchForCollectionPermissionCollectionTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSmartSearchForCollectionPermissionCollectionTreeQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetPostsSmartSearchForCollectionPermissionCollectionTreeQuery(baseOptions: Apollo.QueryHookOptions<GetPostsSmartSearchForCollectionPermissionCollectionTreeQuery, GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsSmartSearchForCollectionPermissionCollectionTreeQuery, GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>(GetPostsSmartSearchForCollectionPermissionCollectionTreeDocument, options);
      }
export function useGetPostsSmartSearchForCollectionPermissionCollectionTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsSmartSearchForCollectionPermissionCollectionTreeQuery, GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsSmartSearchForCollectionPermissionCollectionTreeQuery, GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>(GetPostsSmartSearchForCollectionPermissionCollectionTreeDocument, options);
        }
export type GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForCollectionPermissionCollectionTreeQuery>;
export type GetPostsSmartSearchForCollectionPermissionCollectionTreeLazyQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForCollectionPermissionCollectionTreeLazyQuery>;
export type GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryResult = Apollo.QueryResult<GetPostsSmartSearchForCollectionPermissionCollectionTreeQuery, GetPostsSmartSearchForCollectionPermissionCollectionTreeQueryVariables>;
export const UpdateCollectionPermissionsDocument = gql`
    mutation UpdateCollectionPermissions($data: UpdateCollectionPermissionsInputV2!) {
  updateCollectionPermissionsV2(data: $data) {
    message
    success
  }
}
    `;
export type UpdateCollectionPermissionsMutationFn = Apollo.MutationFunction<UpdateCollectionPermissionsMutation, UpdateCollectionPermissionsMutationVariables>;

/**
 * __useUpdateCollectionPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionPermissionsMutation, { data, loading, error }] = useUpdateCollectionPermissionsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCollectionPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionPermissionsMutation, UpdateCollectionPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionPermissionsMutation, UpdateCollectionPermissionsMutationVariables>(UpdateCollectionPermissionsDocument, options);
      }
export type UpdateCollectionPermissionsMutationHookResult = ReturnType<typeof useUpdateCollectionPermissionsMutation>;
export type UpdateCollectionPermissionsMutationResult = Apollo.MutationResult<UpdateCollectionPermissionsMutation>;
export type UpdateCollectionPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionPermissionsMutation, UpdateCollectionPermissionsMutationVariables>;
export const IsCollectionsPermissionLessThanParentCollectionPermissionDocument = gql`
    query IsCollectionsPermissionLessThanParentCollectionPermission($data: IsCollectionsPermissionLessThanParentCollectionPermissionInput!) {
  isCollectionsPermissionLessThanParentCollectionPermission(data: $data)
}
    `;

/**
 * __useIsCollectionsPermissionLessThanParentCollectionPermissionQuery__
 *
 * To run a query within a React component, call `useIsCollectionsPermissionLessThanParentCollectionPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCollectionsPermissionLessThanParentCollectionPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCollectionsPermissionLessThanParentCollectionPermissionQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIsCollectionsPermissionLessThanParentCollectionPermissionQuery(baseOptions: Apollo.QueryHookOptions<IsCollectionsPermissionLessThanParentCollectionPermissionQuery, IsCollectionsPermissionLessThanParentCollectionPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCollectionsPermissionLessThanParentCollectionPermissionQuery, IsCollectionsPermissionLessThanParentCollectionPermissionQueryVariables>(IsCollectionsPermissionLessThanParentCollectionPermissionDocument, options);
      }
export function useIsCollectionsPermissionLessThanParentCollectionPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCollectionsPermissionLessThanParentCollectionPermissionQuery, IsCollectionsPermissionLessThanParentCollectionPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCollectionsPermissionLessThanParentCollectionPermissionQuery, IsCollectionsPermissionLessThanParentCollectionPermissionQueryVariables>(IsCollectionsPermissionLessThanParentCollectionPermissionDocument, options);
        }
export type IsCollectionsPermissionLessThanParentCollectionPermissionQueryHookResult = ReturnType<typeof useIsCollectionsPermissionLessThanParentCollectionPermissionQuery>;
export type IsCollectionsPermissionLessThanParentCollectionPermissionLazyQueryHookResult = ReturnType<typeof useIsCollectionsPermissionLessThanParentCollectionPermissionLazyQuery>;
export type IsCollectionsPermissionLessThanParentCollectionPermissionQueryResult = Apollo.QueryResult<IsCollectionsPermissionLessThanParentCollectionPermissionQuery, IsCollectionsPermissionLessThanParentCollectionPermissionQueryVariables>;
export const UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionDocument = gql`
    mutation UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollection($data: UpdateNestedCollectionPostPermissionsInput!) {
  updateNestedCollectionPostPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationFn = Apollo.MutationFunction<UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation, UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationVariables>;

/**
 * __useUpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation, { data, loading, error }] = useUpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation, UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation, UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationVariables>(UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionDocument, options);
      }
export type UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationHookResult = ReturnType<typeof useUpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation>;
export type UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationResult = Apollo.MutationResult<UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation>;
export type UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutation, UpdateNestedCollectionPostPermissionsForUseCollectionPermissionsUpdateCollectionMutationVariables>;
export const GetCollectionPermissionForDialogViewDocument = gql`
    query GetCollectionPermissionForDialogView($collectionId: String!) {
  collection(id: $collectionId) {
    name
    ...CollectionFragmentCollectionMultiPostPreview
    ...CollectionFragmentCollectionPermissionDialogBody
  }
}
    ${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}
${CollectionFragmentCollectionPermissionDialogBodyFragmentDoc}`;

/**
 * __useGetCollectionPermissionForDialogViewQuery__
 *
 * To run a query within a React component, call `useGetCollectionPermissionForDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionPermissionForDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionPermissionForDialogViewQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionPermissionForDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionPermissionForDialogViewQuery, GetCollectionPermissionForDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionPermissionForDialogViewQuery, GetCollectionPermissionForDialogViewQueryVariables>(GetCollectionPermissionForDialogViewDocument, options);
      }
export function useGetCollectionPermissionForDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionPermissionForDialogViewQuery, GetCollectionPermissionForDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionPermissionForDialogViewQuery, GetCollectionPermissionForDialogViewQueryVariables>(GetCollectionPermissionForDialogViewDocument, options);
        }
export type GetCollectionPermissionForDialogViewQueryHookResult = ReturnType<typeof useGetCollectionPermissionForDialogViewQuery>;
export type GetCollectionPermissionForDialogViewLazyQueryHookResult = ReturnType<typeof useGetCollectionPermissionForDialogViewLazyQuery>;
export type GetCollectionPermissionForDialogViewQueryResult = Apollo.QueryResult<GetCollectionPermissionForDialogViewQuery, GetCollectionPermissionForDialogViewQueryVariables>;
export const MovePostsToCollectionForCollectionPostDndCollectionCardDocument = gql`
    mutation MovePostsToCollectionForCollectionPostDndCollectionCard($data: MovePostsToCollectionInput!) {
  movePostsToCollection(data: $data) {
    success
    message
  }
}
    `;
export type MovePostsToCollectionForCollectionPostDndCollectionCardMutationFn = Apollo.MutationFunction<MovePostsToCollectionForCollectionPostDndCollectionCardMutation, MovePostsToCollectionForCollectionPostDndCollectionCardMutationVariables>;

/**
 * __useMovePostsToCollectionForCollectionPostDndCollectionCardMutation__
 *
 * To run a mutation, you first call `useMovePostsToCollectionForCollectionPostDndCollectionCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePostsToCollectionForCollectionPostDndCollectionCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePostsToCollectionForCollectionPostDndCollectionCardMutation, { data, loading, error }] = useMovePostsToCollectionForCollectionPostDndCollectionCardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMovePostsToCollectionForCollectionPostDndCollectionCardMutation(baseOptions?: Apollo.MutationHookOptions<MovePostsToCollectionForCollectionPostDndCollectionCardMutation, MovePostsToCollectionForCollectionPostDndCollectionCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePostsToCollectionForCollectionPostDndCollectionCardMutation, MovePostsToCollectionForCollectionPostDndCollectionCardMutationVariables>(MovePostsToCollectionForCollectionPostDndCollectionCardDocument, options);
      }
export type MovePostsToCollectionForCollectionPostDndCollectionCardMutationHookResult = ReturnType<typeof useMovePostsToCollectionForCollectionPostDndCollectionCardMutation>;
export type MovePostsToCollectionForCollectionPostDndCollectionCardMutationResult = Apollo.MutationResult<MovePostsToCollectionForCollectionPostDndCollectionCardMutation>;
export type MovePostsToCollectionForCollectionPostDndCollectionCardMutationOptions = Apollo.BaseMutationOptions<MovePostsToCollectionForCollectionPostDndCollectionCardMutation, MovePostsToCollectionForCollectionPostDndCollectionCardMutationVariables>;
export const DeletePostsForCollectionPostDndHoveringActionPopupDocument = gql`
    mutation DeletePostsForCollectionPostDndHoveringActionPopup($data: DeletePostsInput!) {
  deletePosts(data: $data) {
    success
    message
  }
}
    `;
export type DeletePostsForCollectionPostDndHoveringActionPopupMutationFn = Apollo.MutationFunction<DeletePostsForCollectionPostDndHoveringActionPopupMutation, DeletePostsForCollectionPostDndHoveringActionPopupMutationVariables>;

/**
 * __useDeletePostsForCollectionPostDndHoveringActionPopupMutation__
 *
 * To run a mutation, you first call `useDeletePostsForCollectionPostDndHoveringActionPopupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostsForCollectionPostDndHoveringActionPopupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostsForCollectionPostDndHoveringActionPopupMutation, { data, loading, error }] = useDeletePostsForCollectionPostDndHoveringActionPopupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePostsForCollectionPostDndHoveringActionPopupMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostsForCollectionPostDndHoveringActionPopupMutation, DeletePostsForCollectionPostDndHoveringActionPopupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostsForCollectionPostDndHoveringActionPopupMutation, DeletePostsForCollectionPostDndHoveringActionPopupMutationVariables>(DeletePostsForCollectionPostDndHoveringActionPopupDocument, options);
      }
export type DeletePostsForCollectionPostDndHoveringActionPopupMutationHookResult = ReturnType<typeof useDeletePostsForCollectionPostDndHoveringActionPopupMutation>;
export type DeletePostsForCollectionPostDndHoveringActionPopupMutationResult = Apollo.MutationResult<DeletePostsForCollectionPostDndHoveringActionPopupMutation>;
export type DeletePostsForCollectionPostDndHoveringActionPopupMutationOptions = Apollo.BaseMutationOptions<DeletePostsForCollectionPostDndHoveringActionPopupMutation, DeletePostsForCollectionPostDndHoveringActionPopupMutationVariables>;
export const DeleteAttachmentForCommentAttachmentListDocument = gql`
    mutation DeleteAttachmentForCommentAttachmentList($data: DeleteAttachmentInput!) {
  deleteAttachment(data: $data) {
    success
    message
  }
}
    `;
export type DeleteAttachmentForCommentAttachmentListMutationFn = Apollo.MutationFunction<DeleteAttachmentForCommentAttachmentListMutation, DeleteAttachmentForCommentAttachmentListMutationVariables>;

/**
 * __useDeleteAttachmentForCommentAttachmentListMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentForCommentAttachmentListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentForCommentAttachmentListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentForCommentAttachmentListMutation, { data, loading, error }] = useDeleteAttachmentForCommentAttachmentListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteAttachmentForCommentAttachmentListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentForCommentAttachmentListMutation, DeleteAttachmentForCommentAttachmentListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentForCommentAttachmentListMutation, DeleteAttachmentForCommentAttachmentListMutationVariables>(DeleteAttachmentForCommentAttachmentListDocument, options);
      }
export type DeleteAttachmentForCommentAttachmentListMutationHookResult = ReturnType<typeof useDeleteAttachmentForCommentAttachmentListMutation>;
export type DeleteAttachmentForCommentAttachmentListMutationResult = Apollo.MutationResult<DeleteAttachmentForCommentAttachmentListMutation>;
export type DeleteAttachmentForCommentAttachmentListMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentForCommentAttachmentListMutation, DeleteAttachmentForCommentAttachmentListMutationVariables>;
export const CreateCommentForCollectionDocument = gql`
    mutation CreateCommentForCollection($data: CreateCommentInput!) {
  createComment(data: $data) {
    id
    ...CommentFragmentCollectionCommentListView
  }
}
    ${CommentFragmentCollectionCommentListViewFragmentDoc}`;
export type CreateCommentForCollectionMutationFn = Apollo.MutationFunction<CreateCommentForCollectionMutation, CreateCommentForCollectionMutationVariables>;

/**
 * __useCreateCommentForCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCommentForCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentForCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentForCollectionMutation, { data, loading, error }] = useCreateCommentForCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCommentForCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentForCollectionMutation, CreateCommentForCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentForCollectionMutation, CreateCommentForCollectionMutationVariables>(CreateCommentForCollectionDocument, options);
      }
export type CreateCommentForCollectionMutationHookResult = ReturnType<typeof useCreateCommentForCollectionMutation>;
export type CreateCommentForCollectionMutationResult = Apollo.MutationResult<CreateCommentForCollectionMutation>;
export type CreateCommentForCollectionMutationOptions = Apollo.BaseMutationOptions<CreateCommentForCollectionMutation, CreateCommentForCollectionMutationVariables>;
export const ReadAllCommentsForCollectionDocument = gql`
    mutation ReadAllCommentsForCollection($data: ReadAllCommentsInput!) {
  readAllComments(data: $data) {
    message
    success
  }
}
    `;
export type ReadAllCommentsForCollectionMutationFn = Apollo.MutationFunction<ReadAllCommentsForCollectionMutation, ReadAllCommentsForCollectionMutationVariables>;

/**
 * __useReadAllCommentsForCollectionMutation__
 *
 * To run a mutation, you first call `useReadAllCommentsForCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllCommentsForCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllCommentsForCollectionMutation, { data, loading, error }] = useReadAllCommentsForCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReadAllCommentsForCollectionMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllCommentsForCollectionMutation, ReadAllCommentsForCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllCommentsForCollectionMutation, ReadAllCommentsForCollectionMutationVariables>(ReadAllCommentsForCollectionDocument, options);
      }
export type ReadAllCommentsForCollectionMutationHookResult = ReturnType<typeof useReadAllCommentsForCollectionMutation>;
export type ReadAllCommentsForCollectionMutationResult = Apollo.MutationResult<ReadAllCommentsForCollectionMutation>;
export type ReadAllCommentsForCollectionMutationOptions = Apollo.BaseMutationOptions<ReadAllCommentsForCollectionMutation, ReadAllCommentsForCollectionMutationVariables>;
export const InviteCollectionMembersDocument = gql`
    mutation InviteCollectionMembers($data: InviteCollectionMembersInput!) {
  inviteCollectionMembers(data: $data) {
    success
    message
  }
}
    `;
export type InviteCollectionMembersMutationFn = Apollo.MutationFunction<InviteCollectionMembersMutation, InviteCollectionMembersMutationVariables>;

/**
 * __useInviteCollectionMembersMutation__
 *
 * To run a mutation, you first call `useInviteCollectionMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCollectionMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCollectionMembersMutation, { data, loading, error }] = useInviteCollectionMembersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteCollectionMembersMutation(baseOptions?: Apollo.MutationHookOptions<InviteCollectionMembersMutation, InviteCollectionMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCollectionMembersMutation, InviteCollectionMembersMutationVariables>(InviteCollectionMembersDocument, options);
      }
export type InviteCollectionMembersMutationHookResult = ReturnType<typeof useInviteCollectionMembersMutation>;
export type InviteCollectionMembersMutationResult = Apollo.MutationResult<InviteCollectionMembersMutation>;
export type InviteCollectionMembersMutationOptions = Apollo.BaseMutationOptions<InviteCollectionMembersMutation, InviteCollectionMembersMutationVariables>;
export const InvitePostMembersDocument = gql`
    mutation InvitePostMembers($data: InvitePostMembersInput!) {
  invitePostMembers(data: $data) {
    success
    message
  }
}
    `;
export type InvitePostMembersMutationFn = Apollo.MutationFunction<InvitePostMembersMutation, InvitePostMembersMutationVariables>;

/**
 * __useInvitePostMembersMutation__
 *
 * To run a mutation, you first call `useInvitePostMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitePostMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitePostMembersMutation, { data, loading, error }] = useInvitePostMembersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvitePostMembersMutation(baseOptions?: Apollo.MutationHookOptions<InvitePostMembersMutation, InvitePostMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitePostMembersMutation, InvitePostMembersMutationVariables>(InvitePostMembersDocument, options);
      }
export type InvitePostMembersMutationHookResult = ReturnType<typeof useInvitePostMembersMutation>;
export type InvitePostMembersMutationResult = Apollo.MutationResult<InvitePostMembersMutation>;
export type InvitePostMembersMutationOptions = Apollo.BaseMutationOptions<InvitePostMembersMutation, InvitePostMembersMutationVariables>;
export const GetPostForInviteMemberHandlersDocument = gql`
    query GetPostForInviteMemberHandlers($postId: String!) {
  post(id: $postId) {
    id
    type
    myPermissions
    generalPermission
    organizationId
    creator {
      id
    }
    inviteMembers {
      id
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useGetPostForInviteMemberHandlersQuery__
 *
 * To run a query within a React component, call `useGetPostForInviteMemberHandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForInviteMemberHandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForInviteMemberHandlersQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostForInviteMemberHandlersQuery(baseOptions: Apollo.QueryHookOptions<GetPostForInviteMemberHandlersQuery, GetPostForInviteMemberHandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForInviteMemberHandlersQuery, GetPostForInviteMemberHandlersQueryVariables>(GetPostForInviteMemberHandlersDocument, options);
      }
export function useGetPostForInviteMemberHandlersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForInviteMemberHandlersQuery, GetPostForInviteMemberHandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForInviteMemberHandlersQuery, GetPostForInviteMemberHandlersQueryVariables>(GetPostForInviteMemberHandlersDocument, options);
        }
export type GetPostForInviteMemberHandlersQueryHookResult = ReturnType<typeof useGetPostForInviteMemberHandlersQuery>;
export type GetPostForInviteMemberHandlersLazyQueryHookResult = ReturnType<typeof useGetPostForInviteMemberHandlersLazyQuery>;
export type GetPostForInviteMemberHandlersQueryResult = Apollo.QueryResult<GetPostForInviteMemberHandlersQuery, GetPostForInviteMemberHandlersQueryVariables>;
export const GetCollectionForInviteMemberHandlersDocument = gql`
    query GetCollectionForInviteMemberHandlers($collectionId: String!) {
  collection(id: $collectionId) {
    id
    myPermissions
    generalPermission
    organizationId
    creator {
      id
    }
    inviteMembers {
      id
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCollectionForInviteMemberHandlersQuery__
 *
 * To run a query within a React component, call `useGetCollectionForInviteMemberHandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForInviteMemberHandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForInviteMemberHandlersQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForInviteMemberHandlersQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForInviteMemberHandlersQuery, GetCollectionForInviteMemberHandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForInviteMemberHandlersQuery, GetCollectionForInviteMemberHandlersQueryVariables>(GetCollectionForInviteMemberHandlersDocument, options);
      }
export function useGetCollectionForInviteMemberHandlersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForInviteMemberHandlersQuery, GetCollectionForInviteMemberHandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForInviteMemberHandlersQuery, GetCollectionForInviteMemberHandlersQueryVariables>(GetCollectionForInviteMemberHandlersDocument, options);
        }
export type GetCollectionForInviteMemberHandlersQueryHookResult = ReturnType<typeof useGetCollectionForInviteMemberHandlersQuery>;
export type GetCollectionForInviteMemberHandlersLazyQueryHookResult = ReturnType<typeof useGetCollectionForInviteMemberHandlersLazyQuery>;
export type GetCollectionForInviteMemberHandlersQueryResult = Apollo.QueryResult<GetCollectionForInviteMemberHandlersQuery, GetCollectionForInviteMemberHandlersQueryVariables>;
export const CreatePermissionRequestsDocument = gql`
    mutation CreatePermissionRequests($data: CreatePermissionRequestsInput!) {
  createPermissionRequests(data: $data) {
    id
  }
}
    `;
export type CreatePermissionRequestsMutationFn = Apollo.MutationFunction<CreatePermissionRequestsMutation, CreatePermissionRequestsMutationVariables>;

/**
 * __useCreatePermissionRequestsMutation__
 *
 * To run a mutation, you first call `useCreatePermissionRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionRequestsMutation, { data, loading, error }] = useCreatePermissionRequestsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePermissionRequestsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionRequestsMutation, CreatePermissionRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionRequestsMutation, CreatePermissionRequestsMutationVariables>(CreatePermissionRequestsDocument, options);
      }
export type CreatePermissionRequestsMutationHookResult = ReturnType<typeof useCreatePermissionRequestsMutation>;
export type CreatePermissionRequestsMutationResult = Apollo.MutationResult<CreatePermissionRequestsMutation>;
export type CreatePermissionRequestsMutationOptions = Apollo.BaseMutationOptions<CreatePermissionRequestsMutation, CreatePermissionRequestsMutationVariables>;
export const CreateCommentForPostDocument = gql`
    mutation CreateCommentForPost($data: CreateCommentInput!) {
  createComment(data: $data) {
    id
    ...CommentFragmentPostCommentListView
  }
}
    ${CommentFragmentPostCommentListViewFragmentDoc}`;
export type CreateCommentForPostMutationFn = Apollo.MutationFunction<CreateCommentForPostMutation, CreateCommentForPostMutationVariables>;

/**
 * __useCreateCommentForPostMutation__
 *
 * To run a mutation, you first call `useCreateCommentForPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentForPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentForPostMutation, { data, loading, error }] = useCreateCommentForPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCommentForPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentForPostMutation, CreateCommentForPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentForPostMutation, CreateCommentForPostMutationVariables>(CreateCommentForPostDocument, options);
      }
export type CreateCommentForPostMutationHookResult = ReturnType<typeof useCreateCommentForPostMutation>;
export type CreateCommentForPostMutationResult = Apollo.MutationResult<CreateCommentForPostMutation>;
export type CreateCommentForPostMutationOptions = Apollo.BaseMutationOptions<CreateCommentForPostMutation, CreateCommentForPostMutationVariables>;
export const ReactToCommentForPostDocument = gql`
    mutation ReactToCommentForPost($data: ReactInput!) {
  react(data: $data) {
    message
    success
  }
}
    `;
export type ReactToCommentForPostMutationFn = Apollo.MutationFunction<ReactToCommentForPostMutation, ReactToCommentForPostMutationVariables>;

/**
 * __useReactToCommentForPostMutation__
 *
 * To run a mutation, you first call `useReactToCommentForPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToCommentForPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToCommentForPostMutation, { data, loading, error }] = useReactToCommentForPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReactToCommentForPostMutation(baseOptions?: Apollo.MutationHookOptions<ReactToCommentForPostMutation, ReactToCommentForPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactToCommentForPostMutation, ReactToCommentForPostMutationVariables>(ReactToCommentForPostDocument, options);
      }
export type ReactToCommentForPostMutationHookResult = ReturnType<typeof useReactToCommentForPostMutation>;
export type ReactToCommentForPostMutationResult = Apollo.MutationResult<ReactToCommentForPostMutation>;
export type ReactToCommentForPostMutationOptions = Apollo.BaseMutationOptions<ReactToCommentForPostMutation, ReactToCommentForPostMutationVariables>;
export const UpdateCommentForPostDocument = gql`
    mutation UpdateCommentForPost($data: UpdateCommentInput!) {
  updateComment(data: $data) {
    id
    ...CommentFragmentPostCommentListView
  }
}
    ${CommentFragmentPostCommentListViewFragmentDoc}`;
export type UpdateCommentForPostMutationFn = Apollo.MutationFunction<UpdateCommentForPostMutation, UpdateCommentForPostMutationVariables>;

/**
 * __useUpdateCommentForPostMutation__
 *
 * To run a mutation, you first call `useUpdateCommentForPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentForPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentForPostMutation, { data, loading, error }] = useUpdateCommentForPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCommentForPostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentForPostMutation, UpdateCommentForPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentForPostMutation, UpdateCommentForPostMutationVariables>(UpdateCommentForPostDocument, options);
      }
export type UpdateCommentForPostMutationHookResult = ReturnType<typeof useUpdateCommentForPostMutation>;
export type UpdateCommentForPostMutationResult = Apollo.MutationResult<UpdateCommentForPostMutation>;
export type UpdateCommentForPostMutationOptions = Apollo.BaseMutationOptions<UpdateCommentForPostMutation, UpdateCommentForPostMutationVariables>;
export const DeleteCommentForPostDocument = gql`
    mutation DeleteCommentForPost($data: DeleteCommentInput!) {
  deleteComment(data: $data) {
    message
    success
  }
}
    `;
export type DeleteCommentForPostMutationFn = Apollo.MutationFunction<DeleteCommentForPostMutation, DeleteCommentForPostMutationVariables>;

/**
 * __useDeleteCommentForPostMutation__
 *
 * To run a mutation, you first call `useDeleteCommentForPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentForPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentForPostMutation, { data, loading, error }] = useDeleteCommentForPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCommentForPostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentForPostMutation, DeleteCommentForPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentForPostMutation, DeleteCommentForPostMutationVariables>(DeleteCommentForPostDocument, options);
      }
export type DeleteCommentForPostMutationHookResult = ReturnType<typeof useDeleteCommentForPostMutation>;
export type DeleteCommentForPostMutationResult = Apollo.MutationResult<DeleteCommentForPostMutation>;
export type DeleteCommentForPostMutationOptions = Apollo.BaseMutationOptions<DeleteCommentForPostMutation, DeleteCommentForPostMutationVariables>;
export const ReadAllCommentsForPostDocument = gql`
    mutation ReadAllCommentsForPost($data: ReadAllCommentsInput!) {
  readAllComments(data: $data) {
    message
    success
  }
}
    `;
export type ReadAllCommentsForPostMutationFn = Apollo.MutationFunction<ReadAllCommentsForPostMutation, ReadAllCommentsForPostMutationVariables>;

/**
 * __useReadAllCommentsForPostMutation__
 *
 * To run a mutation, you first call `useReadAllCommentsForPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllCommentsForPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllCommentsForPostMutation, { data, loading, error }] = useReadAllCommentsForPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReadAllCommentsForPostMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllCommentsForPostMutation, ReadAllCommentsForPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllCommentsForPostMutation, ReadAllCommentsForPostMutationVariables>(ReadAllCommentsForPostDocument, options);
      }
export type ReadAllCommentsForPostMutationHookResult = ReturnType<typeof useReadAllCommentsForPostMutation>;
export type ReadAllCommentsForPostMutationResult = Apollo.MutationResult<ReadAllCommentsForPostMutation>;
export type ReadAllCommentsForPostMutationOptions = Apollo.BaseMutationOptions<ReadAllCommentsForPostMutation, ReadAllCommentsForPostMutationVariables>;
export const CreateCommentForTaskDocument = gql`
    mutation CreateCommentForTask($data: CreateCommentInput!) {
  createComment(data: $data) {
    id
    ...CommentFragmentTaskCommentListView
  }
}
    ${CommentFragmentTaskCommentListViewFragmentDoc}`;
export type CreateCommentForTaskMutationFn = Apollo.MutationFunction<CreateCommentForTaskMutation, CreateCommentForTaskMutationVariables>;

/**
 * __useCreateCommentForTaskMutation__
 *
 * To run a mutation, you first call `useCreateCommentForTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentForTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentForTaskMutation, { data, loading, error }] = useCreateCommentForTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCommentForTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentForTaskMutation, CreateCommentForTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentForTaskMutation, CreateCommentForTaskMutationVariables>(CreateCommentForTaskDocument, options);
      }
export type CreateCommentForTaskMutationHookResult = ReturnType<typeof useCreateCommentForTaskMutation>;
export type CreateCommentForTaskMutationResult = Apollo.MutationResult<CreateCommentForTaskMutation>;
export type CreateCommentForTaskMutationOptions = Apollo.BaseMutationOptions<CreateCommentForTaskMutation, CreateCommentForTaskMutationVariables>;
export const ReactToCommentForTaskDocument = gql`
    mutation ReactToCommentForTask($data: ReactInput!) {
  react(data: $data) {
    message
    success
  }
}
    `;
export type ReactToCommentForTaskMutationFn = Apollo.MutationFunction<ReactToCommentForTaskMutation, ReactToCommentForTaskMutationVariables>;

/**
 * __useReactToCommentForTaskMutation__
 *
 * To run a mutation, you first call `useReactToCommentForTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToCommentForTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToCommentForTaskMutation, { data, loading, error }] = useReactToCommentForTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReactToCommentForTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReactToCommentForTaskMutation, ReactToCommentForTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactToCommentForTaskMutation, ReactToCommentForTaskMutationVariables>(ReactToCommentForTaskDocument, options);
      }
export type ReactToCommentForTaskMutationHookResult = ReturnType<typeof useReactToCommentForTaskMutation>;
export type ReactToCommentForTaskMutationResult = Apollo.MutationResult<ReactToCommentForTaskMutation>;
export type ReactToCommentForTaskMutationOptions = Apollo.BaseMutationOptions<ReactToCommentForTaskMutation, ReactToCommentForTaskMutationVariables>;
export const UpdateCommentForTaskDocument = gql`
    mutation UpdateCommentForTask($data: UpdateCommentInput!) {
  updateComment(data: $data) {
    id
    ...CommentFragmentTaskCommentListView
  }
}
    ${CommentFragmentTaskCommentListViewFragmentDoc}`;
export type UpdateCommentForTaskMutationFn = Apollo.MutationFunction<UpdateCommentForTaskMutation, UpdateCommentForTaskMutationVariables>;

/**
 * __useUpdateCommentForTaskMutation__
 *
 * To run a mutation, you first call `useUpdateCommentForTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentForTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentForTaskMutation, { data, loading, error }] = useUpdateCommentForTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCommentForTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentForTaskMutation, UpdateCommentForTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentForTaskMutation, UpdateCommentForTaskMutationVariables>(UpdateCommentForTaskDocument, options);
      }
export type UpdateCommentForTaskMutationHookResult = ReturnType<typeof useUpdateCommentForTaskMutation>;
export type UpdateCommentForTaskMutationResult = Apollo.MutationResult<UpdateCommentForTaskMutation>;
export type UpdateCommentForTaskMutationOptions = Apollo.BaseMutationOptions<UpdateCommentForTaskMutation, UpdateCommentForTaskMutationVariables>;
export const DeleteCommentForTaskDocument = gql`
    mutation DeleteCommentForTask($data: DeleteCommentInput!) {
  deleteComment(data: $data) {
    message
    success
  }
}
    `;
export type DeleteCommentForTaskMutationFn = Apollo.MutationFunction<DeleteCommentForTaskMutation, DeleteCommentForTaskMutationVariables>;

/**
 * __useDeleteCommentForTaskMutation__
 *
 * To run a mutation, you first call `useDeleteCommentForTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentForTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentForTaskMutation, { data, loading, error }] = useDeleteCommentForTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCommentForTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentForTaskMutation, DeleteCommentForTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentForTaskMutation, DeleteCommentForTaskMutationVariables>(DeleteCommentForTaskDocument, options);
      }
export type DeleteCommentForTaskMutationHookResult = ReturnType<typeof useDeleteCommentForTaskMutation>;
export type DeleteCommentForTaskMutationResult = Apollo.MutationResult<DeleteCommentForTaskMutation>;
export type DeleteCommentForTaskMutationOptions = Apollo.BaseMutationOptions<DeleteCommentForTaskMutation, DeleteCommentForTaskMutationVariables>;
export const ReadAllCommentsForTaskDocument = gql`
    mutation ReadAllCommentsForTask($data: ReadAllCommentsInput!) {
  readAllComments(data: $data) {
    message
    success
  }
}
    `;
export type ReadAllCommentsForTaskMutationFn = Apollo.MutationFunction<ReadAllCommentsForTaskMutation, ReadAllCommentsForTaskMutationVariables>;

/**
 * __useReadAllCommentsForTaskMutation__
 *
 * To run a mutation, you first call `useReadAllCommentsForTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllCommentsForTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllCommentsForTaskMutation, { data, loading, error }] = useReadAllCommentsForTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReadAllCommentsForTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllCommentsForTaskMutation, ReadAllCommentsForTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllCommentsForTaskMutation, ReadAllCommentsForTaskMutationVariables>(ReadAllCommentsForTaskDocument, options);
      }
export type ReadAllCommentsForTaskMutationHookResult = ReturnType<typeof useReadAllCommentsForTaskMutation>;
export type ReadAllCommentsForTaskMutationResult = Apollo.MutationResult<ReadAllCommentsForTaskMutation>;
export type ReadAllCommentsForTaskMutationOptions = Apollo.BaseMutationOptions<ReadAllCommentsForTaskMutation, ReadAllCommentsForTaskMutationVariables>;
export const GetCollectionForCollectionCommentViewDocument = gql`
    query GetCollectionForCollectionCommentView($id: String!) {
  collection(id: $id) {
    id
    ...CollectionFragmentCollectionCommentView
  }
}
    ${CollectionFragmentCollectionCommentViewFragmentDoc}`;

/**
 * __useGetCollectionForCollectionCommentViewQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCollectionCommentViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCollectionCommentViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCollectionCommentViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionForCollectionCommentViewQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCollectionCommentViewQuery, GetCollectionForCollectionCommentViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCollectionCommentViewQuery, GetCollectionForCollectionCommentViewQueryVariables>(GetCollectionForCollectionCommentViewDocument, options);
      }
export function useGetCollectionForCollectionCommentViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCollectionCommentViewQuery, GetCollectionForCollectionCommentViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCollectionCommentViewQuery, GetCollectionForCollectionCommentViewQueryVariables>(GetCollectionForCollectionCommentViewDocument, options);
        }
export type GetCollectionForCollectionCommentViewQueryHookResult = ReturnType<typeof useGetCollectionForCollectionCommentViewQuery>;
export type GetCollectionForCollectionCommentViewLazyQueryHookResult = ReturnType<typeof useGetCollectionForCollectionCommentViewLazyQuery>;
export type GetCollectionForCollectionCommentViewQueryResult = Apollo.QueryResult<GetCollectionForCollectionCommentViewQuery, GetCollectionForCollectionCommentViewQueryVariables>;
export const GetCommentsForCollectionCommentListViewDocument = gql`
    query GetCommentsForCollectionCommentListView($filters: CommentFilter!) {
  comments(filters: $filters) {
    id
    ...CommentFragmentCollectionCommentListView
  }
}
    ${CommentFragmentCollectionCommentListViewFragmentDoc}`;

/**
 * __useGetCommentsForCollectionCommentListViewQuery__
 *
 * To run a query within a React component, call `useGetCommentsForCollectionCommentListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsForCollectionCommentListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsForCollectionCommentListViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCommentsForCollectionCommentListViewQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsForCollectionCommentListViewQuery, GetCommentsForCollectionCommentListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsForCollectionCommentListViewQuery, GetCommentsForCollectionCommentListViewQueryVariables>(GetCommentsForCollectionCommentListViewDocument, options);
      }
export function useGetCommentsForCollectionCommentListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsForCollectionCommentListViewQuery, GetCommentsForCollectionCommentListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsForCollectionCommentListViewQuery, GetCommentsForCollectionCommentListViewQueryVariables>(GetCommentsForCollectionCommentListViewDocument, options);
        }
export type GetCommentsForCollectionCommentListViewQueryHookResult = ReturnType<typeof useGetCommentsForCollectionCommentListViewQuery>;
export type GetCommentsForCollectionCommentListViewLazyQueryHookResult = ReturnType<typeof useGetCommentsForCollectionCommentListViewLazyQuery>;
export type GetCommentsForCollectionCommentListViewQueryResult = Apollo.QueryResult<GetCommentsForCollectionCommentListViewQuery, GetCommentsForCollectionCommentListViewQueryVariables>;
export const DeletePostAnnotationForCommentContainerViewDocument = gql`
    mutation DeletePostAnnotationForCommentContainerView($data: DeletePostAnnotationInput!) {
  deletePostAnnotation(data: $data) {
    message
    success
  }
}
    `;
export type DeletePostAnnotationForCommentContainerViewMutationFn = Apollo.MutationFunction<DeletePostAnnotationForCommentContainerViewMutation, DeletePostAnnotationForCommentContainerViewMutationVariables>;

/**
 * __useDeletePostAnnotationForCommentContainerViewMutation__
 *
 * To run a mutation, you first call `useDeletePostAnnotationForCommentContainerViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostAnnotationForCommentContainerViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostAnnotationForCommentContainerViewMutation, { data, loading, error }] = useDeletePostAnnotationForCommentContainerViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePostAnnotationForCommentContainerViewMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostAnnotationForCommentContainerViewMutation, DeletePostAnnotationForCommentContainerViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostAnnotationForCommentContainerViewMutation, DeletePostAnnotationForCommentContainerViewMutationVariables>(DeletePostAnnotationForCommentContainerViewDocument, options);
      }
export type DeletePostAnnotationForCommentContainerViewMutationHookResult = ReturnType<typeof useDeletePostAnnotationForCommentContainerViewMutation>;
export type DeletePostAnnotationForCommentContainerViewMutationResult = Apollo.MutationResult<DeletePostAnnotationForCommentContainerViewMutation>;
export type DeletePostAnnotationForCommentContainerViewMutationOptions = Apollo.BaseMutationOptions<DeletePostAnnotationForCommentContainerViewMutation, DeletePostAnnotationForCommentContainerViewMutationVariables>;
export const GetPostForPostCommentViewDocument = gql`
    query GetPostForPostCommentView($id: String!) {
  post(id: $id) {
    id
    ...PostFragmentPostCommentView
  }
}
    ${PostFragmentPostCommentViewFragmentDoc}`;

/**
 * __useGetPostForPostCommentViewQuery__
 *
 * To run a query within a React component, call `useGetPostForPostCommentViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForPostCommentViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForPostCommentViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForPostCommentViewQuery(baseOptions: Apollo.QueryHookOptions<GetPostForPostCommentViewQuery, GetPostForPostCommentViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForPostCommentViewQuery, GetPostForPostCommentViewQueryVariables>(GetPostForPostCommentViewDocument, options);
      }
export function useGetPostForPostCommentViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForPostCommentViewQuery, GetPostForPostCommentViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForPostCommentViewQuery, GetPostForPostCommentViewQueryVariables>(GetPostForPostCommentViewDocument, options);
        }
export type GetPostForPostCommentViewQueryHookResult = ReturnType<typeof useGetPostForPostCommentViewQuery>;
export type GetPostForPostCommentViewLazyQueryHookResult = ReturnType<typeof useGetPostForPostCommentViewLazyQuery>;
export type GetPostForPostCommentViewQueryResult = Apollo.QueryResult<GetPostForPostCommentViewQuery, GetPostForPostCommentViewQueryVariables>;
export const GetCommentsForPostCommentListViewDocument = gql`
    query GetCommentsForPostCommentListView($filters: CommentFilter!) {
  comments(filters: $filters) {
    id
    ...CommentFragmentPostCommentListView
  }
}
    ${CommentFragmentPostCommentListViewFragmentDoc}`;

/**
 * __useGetCommentsForPostCommentListViewQuery__
 *
 * To run a query within a React component, call `useGetCommentsForPostCommentListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsForPostCommentListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsForPostCommentListViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCommentsForPostCommentListViewQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsForPostCommentListViewQuery, GetCommentsForPostCommentListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsForPostCommentListViewQuery, GetCommentsForPostCommentListViewQueryVariables>(GetCommentsForPostCommentListViewDocument, options);
      }
export function useGetCommentsForPostCommentListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsForPostCommentListViewQuery, GetCommentsForPostCommentListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsForPostCommentListViewQuery, GetCommentsForPostCommentListViewQueryVariables>(GetCommentsForPostCommentListViewDocument, options);
        }
export type GetCommentsForPostCommentListViewQueryHookResult = ReturnType<typeof useGetCommentsForPostCommentListViewQuery>;
export type GetCommentsForPostCommentListViewLazyQueryHookResult = ReturnType<typeof useGetCommentsForPostCommentListViewLazyQuery>;
export type GetCommentsForPostCommentListViewQueryResult = Apollo.QueryResult<GetCommentsForPostCommentListViewQuery, GetCommentsForPostCommentListViewQueryVariables>;
export const GetCommentsForTaskCommentListViewDocument = gql`
    query GetCommentsForTaskCommentListView($filters: CommentFilter!) {
  comments(filters: $filters) {
    id
    ...CommentFragmentTaskCommentListView
  }
}
    ${CommentFragmentTaskCommentListViewFragmentDoc}`;

/**
 * __useGetCommentsForTaskCommentListViewQuery__
 *
 * To run a query within a React component, call `useGetCommentsForTaskCommentListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsForTaskCommentListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsForTaskCommentListViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCommentsForTaskCommentListViewQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsForTaskCommentListViewQuery, GetCommentsForTaskCommentListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsForTaskCommentListViewQuery, GetCommentsForTaskCommentListViewQueryVariables>(GetCommentsForTaskCommentListViewDocument, options);
      }
export function useGetCommentsForTaskCommentListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsForTaskCommentListViewQuery, GetCommentsForTaskCommentListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsForTaskCommentListViewQuery, GetCommentsForTaskCommentListViewQueryVariables>(GetCommentsForTaskCommentListViewDocument, options);
        }
export type GetCommentsForTaskCommentListViewQueryHookResult = ReturnType<typeof useGetCommentsForTaskCommentListViewQuery>;
export type GetCommentsForTaskCommentListViewLazyQueryHookResult = ReturnType<typeof useGetCommentsForTaskCommentListViewLazyQuery>;
export type GetCommentsForTaskCommentListViewQueryResult = Apollo.QueryResult<GetCommentsForTaskCommentListViewQuery, GetCommentsForTaskCommentListViewQueryVariables>;
export const GetCompetitorForCompetitorParsingSettingsViewDocument = gql`
    query GetCompetitorForCompetitorParsingSettingsView($id: String!) {
  competitor(id: $id) {
    id
    ...CompetitorFragmentCompetitorParsingSettingsView
  }
}
    ${CompetitorFragmentCompetitorParsingSettingsViewFragmentDoc}`;

/**
 * __useGetCompetitorForCompetitorParsingSettingsViewQuery__
 *
 * To run a query within a React component, call `useGetCompetitorForCompetitorParsingSettingsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorForCompetitorParsingSettingsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorForCompetitorParsingSettingsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompetitorForCompetitorParsingSettingsViewQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorForCompetitorParsingSettingsViewQuery, GetCompetitorForCompetitorParsingSettingsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorForCompetitorParsingSettingsViewQuery, GetCompetitorForCompetitorParsingSettingsViewQueryVariables>(GetCompetitorForCompetitorParsingSettingsViewDocument, options);
      }
export function useGetCompetitorForCompetitorParsingSettingsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorForCompetitorParsingSettingsViewQuery, GetCompetitorForCompetitorParsingSettingsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorForCompetitorParsingSettingsViewQuery, GetCompetitorForCompetitorParsingSettingsViewQueryVariables>(GetCompetitorForCompetitorParsingSettingsViewDocument, options);
        }
export type GetCompetitorForCompetitorParsingSettingsViewQueryHookResult = ReturnType<typeof useGetCompetitorForCompetitorParsingSettingsViewQuery>;
export type GetCompetitorForCompetitorParsingSettingsViewLazyQueryHookResult = ReturnType<typeof useGetCompetitorForCompetitorParsingSettingsViewLazyQuery>;
export type GetCompetitorForCompetitorParsingSettingsViewQueryResult = Apollo.QueryResult<GetCompetitorForCompetitorParsingSettingsViewQuery, GetCompetitorForCompetitorParsingSettingsViewQueryVariables>;
export const UpdateCompetitorForCompetitorParsingSettingsViewDocument = gql`
    mutation UpdateCompetitorForCompetitorParsingSettingsView($data: UpdateCompetitorInput!) {
  updateCompetitors(data: $data) {
    id
    ...CompetitorFragmentCompetitorParsingSettingsView
  }
}
    ${CompetitorFragmentCompetitorParsingSettingsViewFragmentDoc}`;
export type UpdateCompetitorForCompetitorParsingSettingsViewMutationFn = Apollo.MutationFunction<UpdateCompetitorForCompetitorParsingSettingsViewMutation, UpdateCompetitorForCompetitorParsingSettingsViewMutationVariables>;

/**
 * __useUpdateCompetitorForCompetitorParsingSettingsViewMutation__
 *
 * To run a mutation, you first call `useUpdateCompetitorForCompetitorParsingSettingsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompetitorForCompetitorParsingSettingsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompetitorForCompetitorParsingSettingsViewMutation, { data, loading, error }] = useUpdateCompetitorForCompetitorParsingSettingsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompetitorForCompetitorParsingSettingsViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompetitorForCompetitorParsingSettingsViewMutation, UpdateCompetitorForCompetitorParsingSettingsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompetitorForCompetitorParsingSettingsViewMutation, UpdateCompetitorForCompetitorParsingSettingsViewMutationVariables>(UpdateCompetitorForCompetitorParsingSettingsViewDocument, options);
      }
export type UpdateCompetitorForCompetitorParsingSettingsViewMutationHookResult = ReturnType<typeof useUpdateCompetitorForCompetitorParsingSettingsViewMutation>;
export type UpdateCompetitorForCompetitorParsingSettingsViewMutationResult = Apollo.MutationResult<UpdateCompetitorForCompetitorParsingSettingsViewMutation>;
export type UpdateCompetitorForCompetitorParsingSettingsViewMutationOptions = Apollo.BaseMutationOptions<UpdateCompetitorForCompetitorParsingSettingsViewMutation, UpdateCompetitorForCompetitorParsingSettingsViewMutationVariables>;
export const JoinContentCalendarViewForContentCalendarSortAndFilterButtonDocument = gql`
    mutation JoinContentCalendarViewForContentCalendarSortAndFilterButton($data: JoinContentCalendarViewInput!) {
  joinContentCalendarView(data: $data) {
    id
  }
}
    `;
export type JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationFn = Apollo.MutationFunction<JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation, JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationVariables>;

/**
 * __useJoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation__
 *
 * To run a mutation, you first call `useJoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinContentCalendarViewForContentCalendarSortAndFilterButtonMutation, { data, loading, error }] = useJoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useJoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation(baseOptions?: Apollo.MutationHookOptions<JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation, JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation, JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationVariables>(JoinContentCalendarViewForContentCalendarSortAndFilterButtonDocument, options);
      }
export type JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationHookResult = ReturnType<typeof useJoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation>;
export type JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationResult = Apollo.MutationResult<JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation>;
export type JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationOptions = Apollo.BaseMutationOptions<JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutation, JoinContentCalendarViewForContentCalendarSortAndFilterButtonMutationVariables>;
export const GetContentIdeaFieldsForContentCalendarFilterDocument = gql`
    query GetContentIdeaFieldsForContentCalendarFilter($filters: ContentIdeaFieldFilters) {
  contentIdeaFields(filters: $filters) {
    ...ContentIdeaFieldFragmentContentCalendarFilter
  }
}
    ${ContentIdeaFieldFragmentContentCalendarFilterFragmentDoc}`;

/**
 * __useGetContentIdeaFieldsForContentCalendarFilterQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaFieldsForContentCalendarFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaFieldsForContentCalendarFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaFieldsForContentCalendarFilterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetContentIdeaFieldsForContentCalendarFilterQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaFieldsForContentCalendarFilterQuery, GetContentIdeaFieldsForContentCalendarFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaFieldsForContentCalendarFilterQuery, GetContentIdeaFieldsForContentCalendarFilterQueryVariables>(GetContentIdeaFieldsForContentCalendarFilterDocument, options);
      }
export function useGetContentIdeaFieldsForContentCalendarFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaFieldsForContentCalendarFilterQuery, GetContentIdeaFieldsForContentCalendarFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaFieldsForContentCalendarFilterQuery, GetContentIdeaFieldsForContentCalendarFilterQueryVariables>(GetContentIdeaFieldsForContentCalendarFilterDocument, options);
        }
export type GetContentIdeaFieldsForContentCalendarFilterQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentCalendarFilterQuery>;
export type GetContentIdeaFieldsForContentCalendarFilterLazyQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentCalendarFilterLazyQuery>;
export type GetContentIdeaFieldsForContentCalendarFilterQueryResult = Apollo.QueryResult<GetContentIdeaFieldsForContentCalendarFilterQuery, GetContentIdeaFieldsForContentCalendarFilterQueryVariables>;
export const GetContentIdeaFieldsForContentCalendarSortDocument = gql`
    query GetContentIdeaFieldsForContentCalendarSort($filters: ContentIdeaFieldFilters) {
  contentIdeaFields(filters: $filters) {
    id
    name
  }
}
    `;

/**
 * __useGetContentIdeaFieldsForContentCalendarSortQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaFieldsForContentCalendarSortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaFieldsForContentCalendarSortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaFieldsForContentCalendarSortQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetContentIdeaFieldsForContentCalendarSortQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaFieldsForContentCalendarSortQuery, GetContentIdeaFieldsForContentCalendarSortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaFieldsForContentCalendarSortQuery, GetContentIdeaFieldsForContentCalendarSortQueryVariables>(GetContentIdeaFieldsForContentCalendarSortDocument, options);
      }
export function useGetContentIdeaFieldsForContentCalendarSortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaFieldsForContentCalendarSortQuery, GetContentIdeaFieldsForContentCalendarSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaFieldsForContentCalendarSortQuery, GetContentIdeaFieldsForContentCalendarSortQueryVariables>(GetContentIdeaFieldsForContentCalendarSortDocument, options);
        }
export type GetContentIdeaFieldsForContentCalendarSortQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentCalendarSortQuery>;
export type GetContentIdeaFieldsForContentCalendarSortLazyQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentCalendarSortLazyQuery>;
export type GetContentIdeaFieldsForContentCalendarSortQueryResult = Apollo.QueryResult<GetContentIdeaFieldsForContentCalendarSortQuery, GetContentIdeaFieldsForContentCalendarSortQueryVariables>;
export const GetCollectionsSmartSearchForContentCalendarFilterByCollectionsDocument = gql`
    query GetCollectionsSmartSearchForContentCalendarFilterByCollections($filters: CollectionFilters!, $take: Int, $sortType: SortType, $after: String) {
  collectionsSmartSearch(
    filters: $filters
    take: $take
    sortType: $sortType
    after: $after
  ) {
    data {
      item {
        ...CollectionFragmentContentCalendarFilterByCollections
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionFragmentContentCalendarFilterByCollectionsFragmentDoc}`;

/**
 * __useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      sortType: // value for 'sortType'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery, GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery, GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryVariables>(GetCollectionsSmartSearchForContentCalendarFilterByCollectionsDocument, options);
      }
export function useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery, GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery, GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryVariables>(GetCollectionsSmartSearchForContentCalendarFilterByCollectionsDocument, options);
        }
export type GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery>;
export type GetCollectionsSmartSearchForContentCalendarFilterByCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForContentCalendarFilterByCollectionsLazyQuery>;
export type GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryResult = Apollo.QueryResult<GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQuery, GetCollectionsSmartSearchForContentCalendarFilterByCollectionsQueryVariables>;
export const GetMeForContentCalendarFilterByOwnersInnerContentDocument = gql`
    query GetMeForContentCalendarFilterByOwnersInnerContent {
  me {
    id
    organization {
      id
      name
      users {
        id
        ...UserFragmentAvatarGroup
      }
      externalUsers {
        id
        ...UserFragmentAvatarGroup
        organization {
          id
          name
        }
      }
    }
    joinedOrganizations {
      id
      name
      users {
        id
        ...UserFragmentAvatarGroup
      }
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;

/**
 * __useGetMeForContentCalendarFilterByOwnersInnerContentQuery__
 *
 * To run a query within a React component, call `useGetMeForContentCalendarFilterByOwnersInnerContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeForContentCalendarFilterByOwnersInnerContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeForContentCalendarFilterByOwnersInnerContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeForContentCalendarFilterByOwnersInnerContentQuery(baseOptions?: Apollo.QueryHookOptions<GetMeForContentCalendarFilterByOwnersInnerContentQuery, GetMeForContentCalendarFilterByOwnersInnerContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeForContentCalendarFilterByOwnersInnerContentQuery, GetMeForContentCalendarFilterByOwnersInnerContentQueryVariables>(GetMeForContentCalendarFilterByOwnersInnerContentDocument, options);
      }
export function useGetMeForContentCalendarFilterByOwnersInnerContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeForContentCalendarFilterByOwnersInnerContentQuery, GetMeForContentCalendarFilterByOwnersInnerContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeForContentCalendarFilterByOwnersInnerContentQuery, GetMeForContentCalendarFilterByOwnersInnerContentQueryVariables>(GetMeForContentCalendarFilterByOwnersInnerContentDocument, options);
        }
export type GetMeForContentCalendarFilterByOwnersInnerContentQueryHookResult = ReturnType<typeof useGetMeForContentCalendarFilterByOwnersInnerContentQuery>;
export type GetMeForContentCalendarFilterByOwnersInnerContentLazyQueryHookResult = ReturnType<typeof useGetMeForContentCalendarFilterByOwnersInnerContentLazyQuery>;
export type GetMeForContentCalendarFilterByOwnersInnerContentQueryResult = Apollo.QueryResult<GetMeForContentCalendarFilterByOwnersInnerContentQuery, GetMeForContentCalendarFilterByOwnersInnerContentQueryVariables>;
export const GetMeForContentCalendarFilterByPlatformsDocument = gql`
    query GetMeForContentCalendarFilterByPlatforms {
  me {
    id
    organization {
      id
      socialAuthors {
        id
        platform
        platformHandle
      }
    }
    joinedOrganizations {
      id
      socialAuthors {
        id
        platform
        platformHandle
      }
    }
  }
}
    `;

/**
 * __useGetMeForContentCalendarFilterByPlatformsQuery__
 *
 * To run a query within a React component, call `useGetMeForContentCalendarFilterByPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeForContentCalendarFilterByPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeForContentCalendarFilterByPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeForContentCalendarFilterByPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<GetMeForContentCalendarFilterByPlatformsQuery, GetMeForContentCalendarFilterByPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeForContentCalendarFilterByPlatformsQuery, GetMeForContentCalendarFilterByPlatformsQueryVariables>(GetMeForContentCalendarFilterByPlatformsDocument, options);
      }
export function useGetMeForContentCalendarFilterByPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeForContentCalendarFilterByPlatformsQuery, GetMeForContentCalendarFilterByPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeForContentCalendarFilterByPlatformsQuery, GetMeForContentCalendarFilterByPlatformsQueryVariables>(GetMeForContentCalendarFilterByPlatformsDocument, options);
        }
export type GetMeForContentCalendarFilterByPlatformsQueryHookResult = ReturnType<typeof useGetMeForContentCalendarFilterByPlatformsQuery>;
export type GetMeForContentCalendarFilterByPlatformsLazyQueryHookResult = ReturnType<typeof useGetMeForContentCalendarFilterByPlatformsLazyQuery>;
export type GetMeForContentCalendarFilterByPlatformsQueryResult = Apollo.QueryResult<GetMeForContentCalendarFilterByPlatformsQuery, GetMeForContentCalendarFilterByPlatformsQueryVariables>;
export const UpdateContentCalendarViewForApplyChangesButtonDocument = gql`
    mutation UpdateContentCalendarViewForApplyChangesButton($data: UpdateContentCalendarViewInput!) {
  updateContentCalendarView(data: $data) {
    id
    filters
  }
}
    `;
export type UpdateContentCalendarViewForApplyChangesButtonMutationFn = Apollo.MutationFunction<UpdateContentCalendarViewForApplyChangesButtonMutation, UpdateContentCalendarViewForApplyChangesButtonMutationVariables>;

/**
 * __useUpdateContentCalendarViewForApplyChangesButtonMutation__
 *
 * To run a mutation, you first call `useUpdateContentCalendarViewForApplyChangesButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentCalendarViewForApplyChangesButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentCalendarViewForApplyChangesButtonMutation, { data, loading, error }] = useUpdateContentCalendarViewForApplyChangesButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentCalendarViewForApplyChangesButtonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentCalendarViewForApplyChangesButtonMutation, UpdateContentCalendarViewForApplyChangesButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentCalendarViewForApplyChangesButtonMutation, UpdateContentCalendarViewForApplyChangesButtonMutationVariables>(UpdateContentCalendarViewForApplyChangesButtonDocument, options);
      }
export type UpdateContentCalendarViewForApplyChangesButtonMutationHookResult = ReturnType<typeof useUpdateContentCalendarViewForApplyChangesButtonMutation>;
export type UpdateContentCalendarViewForApplyChangesButtonMutationResult = Apollo.MutationResult<UpdateContentCalendarViewForApplyChangesButtonMutation>;
export type UpdateContentCalendarViewForApplyChangesButtonMutationOptions = Apollo.BaseMutationOptions<UpdateContentCalendarViewForApplyChangesButtonMutation, UpdateContentCalendarViewForApplyChangesButtonMutationVariables>;
export const CreateContentCalendarViewForApplyChangesPromptDialogDocument = gql`
    mutation CreateContentCalendarViewForApplyChangesPromptDialog($data: CreateContentCalendarViewInput!) {
  createContentCalendarView(data: $data) {
    id
  }
}
    `;
export type CreateContentCalendarViewForApplyChangesPromptDialogMutationFn = Apollo.MutationFunction<CreateContentCalendarViewForApplyChangesPromptDialogMutation, CreateContentCalendarViewForApplyChangesPromptDialogMutationVariables>;

/**
 * __useCreateContentCalendarViewForApplyChangesPromptDialogMutation__
 *
 * To run a mutation, you first call `useCreateContentCalendarViewForApplyChangesPromptDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentCalendarViewForApplyChangesPromptDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentCalendarViewForApplyChangesPromptDialogMutation, { data, loading, error }] = useCreateContentCalendarViewForApplyChangesPromptDialogMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentCalendarViewForApplyChangesPromptDialogMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentCalendarViewForApplyChangesPromptDialogMutation, CreateContentCalendarViewForApplyChangesPromptDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentCalendarViewForApplyChangesPromptDialogMutation, CreateContentCalendarViewForApplyChangesPromptDialogMutationVariables>(CreateContentCalendarViewForApplyChangesPromptDialogDocument, options);
      }
export type CreateContentCalendarViewForApplyChangesPromptDialogMutationHookResult = ReturnType<typeof useCreateContentCalendarViewForApplyChangesPromptDialogMutation>;
export type CreateContentCalendarViewForApplyChangesPromptDialogMutationResult = Apollo.MutationResult<CreateContentCalendarViewForApplyChangesPromptDialogMutation>;
export type CreateContentCalendarViewForApplyChangesPromptDialogMutationOptions = Apollo.BaseMutationOptions<CreateContentCalendarViewForApplyChangesPromptDialogMutation, CreateContentCalendarViewForApplyChangesPromptDialogMutationVariables>;
export const UpdateContentCalendarViewForApplyChangesPromptDialogDocument = gql`
    mutation UpdateContentCalendarViewForApplyChangesPromptDialog($data: UpdateContentCalendarViewInput!) {
  updateContentCalendarView(data: $data) {
    id
    filters
  }
}
    `;
export type UpdateContentCalendarViewForApplyChangesPromptDialogMutationFn = Apollo.MutationFunction<UpdateContentCalendarViewForApplyChangesPromptDialogMutation, UpdateContentCalendarViewForApplyChangesPromptDialogMutationVariables>;

/**
 * __useUpdateContentCalendarViewForApplyChangesPromptDialogMutation__
 *
 * To run a mutation, you first call `useUpdateContentCalendarViewForApplyChangesPromptDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentCalendarViewForApplyChangesPromptDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentCalendarViewForApplyChangesPromptDialogMutation, { data, loading, error }] = useUpdateContentCalendarViewForApplyChangesPromptDialogMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentCalendarViewForApplyChangesPromptDialogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentCalendarViewForApplyChangesPromptDialogMutation, UpdateContentCalendarViewForApplyChangesPromptDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentCalendarViewForApplyChangesPromptDialogMutation, UpdateContentCalendarViewForApplyChangesPromptDialogMutationVariables>(UpdateContentCalendarViewForApplyChangesPromptDialogDocument, options);
      }
export type UpdateContentCalendarViewForApplyChangesPromptDialogMutationHookResult = ReturnType<typeof useUpdateContentCalendarViewForApplyChangesPromptDialogMutation>;
export type UpdateContentCalendarViewForApplyChangesPromptDialogMutationResult = Apollo.MutationResult<UpdateContentCalendarViewForApplyChangesPromptDialogMutation>;
export type UpdateContentCalendarViewForApplyChangesPromptDialogMutationOptions = Apollo.BaseMutationOptions<UpdateContentCalendarViewForApplyChangesPromptDialogMutation, UpdateContentCalendarViewForApplyChangesPromptDialogMutationVariables>;
export const CreateContentCalendarViewForCreateViewFormDocument = gql`
    mutation CreateContentCalendarViewForCreateViewForm($data: CreateContentCalendarViewInput!) {
  createContentCalendarView(data: $data) {
    id
    ...ContentCalendarViewFragmentContentCalendarViewListItemView
  }
}
    ${ContentCalendarViewFragmentContentCalendarViewListItemViewFragmentDoc}`;
export type CreateContentCalendarViewForCreateViewFormMutationFn = Apollo.MutationFunction<CreateContentCalendarViewForCreateViewFormMutation, CreateContentCalendarViewForCreateViewFormMutationVariables>;

/**
 * __useCreateContentCalendarViewForCreateViewFormMutation__
 *
 * To run a mutation, you first call `useCreateContentCalendarViewForCreateViewFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentCalendarViewForCreateViewFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentCalendarViewForCreateViewFormMutation, { data, loading, error }] = useCreateContentCalendarViewForCreateViewFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentCalendarViewForCreateViewFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentCalendarViewForCreateViewFormMutation, CreateContentCalendarViewForCreateViewFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentCalendarViewForCreateViewFormMutation, CreateContentCalendarViewForCreateViewFormMutationVariables>(CreateContentCalendarViewForCreateViewFormDocument, options);
      }
export type CreateContentCalendarViewForCreateViewFormMutationHookResult = ReturnType<typeof useCreateContentCalendarViewForCreateViewFormMutation>;
export type CreateContentCalendarViewForCreateViewFormMutationResult = Apollo.MutationResult<CreateContentCalendarViewForCreateViewFormMutation>;
export type CreateContentCalendarViewForCreateViewFormMutationOptions = Apollo.BaseMutationOptions<CreateContentCalendarViewForCreateViewFormMutation, CreateContentCalendarViewForCreateViewFormMutationVariables>;
export const GetContentCalendarViewsForManageViewsSectionDocument = gql`
    query GetContentCalendarViewsForManageViewsSection {
  contentCalendarViews {
    id
    ...ContentCalendarViewFragmentContentCalendarViewListItemView
  }
}
    ${ContentCalendarViewFragmentContentCalendarViewListItemViewFragmentDoc}`;

/**
 * __useGetContentCalendarViewsForManageViewsSectionQuery__
 *
 * To run a query within a React component, call `useGetContentCalendarViewsForManageViewsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentCalendarViewsForManageViewsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentCalendarViewsForManageViewsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentCalendarViewsForManageViewsSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetContentCalendarViewsForManageViewsSectionQuery, GetContentCalendarViewsForManageViewsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentCalendarViewsForManageViewsSectionQuery, GetContentCalendarViewsForManageViewsSectionQueryVariables>(GetContentCalendarViewsForManageViewsSectionDocument, options);
      }
export function useGetContentCalendarViewsForManageViewsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentCalendarViewsForManageViewsSectionQuery, GetContentCalendarViewsForManageViewsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentCalendarViewsForManageViewsSectionQuery, GetContentCalendarViewsForManageViewsSectionQueryVariables>(GetContentCalendarViewsForManageViewsSectionDocument, options);
        }
export type GetContentCalendarViewsForManageViewsSectionQueryHookResult = ReturnType<typeof useGetContentCalendarViewsForManageViewsSectionQuery>;
export type GetContentCalendarViewsForManageViewsSectionLazyQueryHookResult = ReturnType<typeof useGetContentCalendarViewsForManageViewsSectionLazyQuery>;
export type GetContentCalendarViewsForManageViewsSectionQueryResult = Apollo.QueryResult<GetContentCalendarViewsForManageViewsSectionQuery, GetContentCalendarViewsForManageViewsSectionQueryVariables>;
export const UpdateUserOnboardingStateForContentCalendarIntroModalDocument = gql`
    mutation UpdateUserOnboardingStateForContentCalendarIntroModal($data: UpdateUserOnboardingStateInput!) {
  updateUserOnboardingState(data: $data) {
    id
    onboardingState {
      hasSeenContentCalendarIntroduction
    }
  }
}
    `;
export type UpdateUserOnboardingStateForContentCalendarIntroModalMutationFn = Apollo.MutationFunction<UpdateUserOnboardingStateForContentCalendarIntroModalMutation, UpdateUserOnboardingStateForContentCalendarIntroModalMutationVariables>;

/**
 * __useUpdateUserOnboardingStateForContentCalendarIntroModalMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingStateForContentCalendarIntroModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingStateForContentCalendarIntroModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingStateForContentCalendarIntroModalMutation, { data, loading, error }] = useUpdateUserOnboardingStateForContentCalendarIntroModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOnboardingStateForContentCalendarIntroModalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingStateForContentCalendarIntroModalMutation, UpdateUserOnboardingStateForContentCalendarIntroModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingStateForContentCalendarIntroModalMutation, UpdateUserOnboardingStateForContentCalendarIntroModalMutationVariables>(UpdateUserOnboardingStateForContentCalendarIntroModalDocument, options);
      }
export type UpdateUserOnboardingStateForContentCalendarIntroModalMutationHookResult = ReturnType<typeof useUpdateUserOnboardingStateForContentCalendarIntroModalMutation>;
export type UpdateUserOnboardingStateForContentCalendarIntroModalMutationResult = Apollo.MutationResult<UpdateUserOnboardingStateForContentCalendarIntroModalMutation>;
export type UpdateUserOnboardingStateForContentCalendarIntroModalMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingStateForContentCalendarIntroModalMutation, UpdateUserOnboardingStateForContentCalendarIntroModalMutationVariables>;
export const DeleteContentCalendarViewForContentCalendarViewContextMenuDocument = gql`
    mutation DeleteContentCalendarViewForContentCalendarViewContextMenu($data: DeleteContentCalendarViewInput!) {
  deleteContentCalendarView(data: $data) {
    success
    message
  }
}
    `;
export type DeleteContentCalendarViewForContentCalendarViewContextMenuMutationFn = Apollo.MutationFunction<DeleteContentCalendarViewForContentCalendarViewContextMenuMutation, DeleteContentCalendarViewForContentCalendarViewContextMenuMutationVariables>;

/**
 * __useDeleteContentCalendarViewForContentCalendarViewContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteContentCalendarViewForContentCalendarViewContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentCalendarViewForContentCalendarViewContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentCalendarViewForContentCalendarViewContextMenuMutation, { data, loading, error }] = useDeleteContentCalendarViewForContentCalendarViewContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteContentCalendarViewForContentCalendarViewContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentCalendarViewForContentCalendarViewContextMenuMutation, DeleteContentCalendarViewForContentCalendarViewContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentCalendarViewForContentCalendarViewContextMenuMutation, DeleteContentCalendarViewForContentCalendarViewContextMenuMutationVariables>(DeleteContentCalendarViewForContentCalendarViewContextMenuDocument, options);
      }
export type DeleteContentCalendarViewForContentCalendarViewContextMenuMutationHookResult = ReturnType<typeof useDeleteContentCalendarViewForContentCalendarViewContextMenuMutation>;
export type DeleteContentCalendarViewForContentCalendarViewContextMenuMutationResult = Apollo.MutationResult<DeleteContentCalendarViewForContentCalendarViewContextMenuMutation>;
export type DeleteContentCalendarViewForContentCalendarViewContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteContentCalendarViewForContentCalendarViewContextMenuMutation, DeleteContentCalendarViewForContentCalendarViewContextMenuMutationVariables>;
export const DuplicateContentCalendarViewForContentCalendarViewContextMenuDocument = gql`
    mutation DuplicateContentCalendarViewForContentCalendarViewContextMenu($data: DuplicateContentCalendarViewInput!) {
  duplicateContentCalendarView(data: $data) {
    id
  }
}
    `;
export type DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationFn = Apollo.MutationFunction<DuplicateContentCalendarViewForContentCalendarViewContextMenuMutation, DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationVariables>;

/**
 * __useDuplicateContentCalendarViewForContentCalendarViewContextMenuMutation__
 *
 * To run a mutation, you first call `useDuplicateContentCalendarViewForContentCalendarViewContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateContentCalendarViewForContentCalendarViewContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateContentCalendarViewForContentCalendarViewContextMenuMutation, { data, loading, error }] = useDuplicateContentCalendarViewForContentCalendarViewContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDuplicateContentCalendarViewForContentCalendarViewContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateContentCalendarViewForContentCalendarViewContextMenuMutation, DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateContentCalendarViewForContentCalendarViewContextMenuMutation, DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationVariables>(DuplicateContentCalendarViewForContentCalendarViewContextMenuDocument, options);
      }
export type DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationHookResult = ReturnType<typeof useDuplicateContentCalendarViewForContentCalendarViewContextMenuMutation>;
export type DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationResult = Apollo.MutationResult<DuplicateContentCalendarViewForContentCalendarViewContextMenuMutation>;
export type DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationOptions = Apollo.BaseMutationOptions<DuplicateContentCalendarViewForContentCalendarViewContextMenuMutation, DuplicateContentCalendarViewForContentCalendarViewContextMenuMutationVariables>;
export const GetContentCalendarViewForUseContentCalendarViewDocument = gql`
    query GetContentCalendarViewForUseContentCalendarView($id: String!) {
  contentCalendarView(id: $id) {
    id
    name
    filters
    myPermissions
  }
}
    `;

/**
 * __useGetContentCalendarViewForUseContentCalendarViewQuery__
 *
 * To run a query within a React component, call `useGetContentCalendarViewForUseContentCalendarViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentCalendarViewForUseContentCalendarViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentCalendarViewForUseContentCalendarViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentCalendarViewForUseContentCalendarViewQuery(baseOptions: Apollo.QueryHookOptions<GetContentCalendarViewForUseContentCalendarViewQuery, GetContentCalendarViewForUseContentCalendarViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentCalendarViewForUseContentCalendarViewQuery, GetContentCalendarViewForUseContentCalendarViewQueryVariables>(GetContentCalendarViewForUseContentCalendarViewDocument, options);
      }
export function useGetContentCalendarViewForUseContentCalendarViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentCalendarViewForUseContentCalendarViewQuery, GetContentCalendarViewForUseContentCalendarViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentCalendarViewForUseContentCalendarViewQuery, GetContentCalendarViewForUseContentCalendarViewQueryVariables>(GetContentCalendarViewForUseContentCalendarViewDocument, options);
        }
export type GetContentCalendarViewForUseContentCalendarViewQueryHookResult = ReturnType<typeof useGetContentCalendarViewForUseContentCalendarViewQuery>;
export type GetContentCalendarViewForUseContentCalendarViewLazyQueryHookResult = ReturnType<typeof useGetContentCalendarViewForUseContentCalendarViewLazyQuery>;
export type GetContentCalendarViewForUseContentCalendarViewQueryResult = Apollo.QueryResult<GetContentCalendarViewForUseContentCalendarViewQuery, GetContentCalendarViewForUseContentCalendarViewQueryVariables>;
export const UpdateContentCalendarViewForContentCalendarViewListItemViewDocument = gql`
    mutation UpdateContentCalendarViewForContentCalendarViewListItemView($data: UpdateContentCalendarViewInput!) {
  updateContentCalendarView(data: $data) {
    id
    name
  }
}
    `;
export type UpdateContentCalendarViewForContentCalendarViewListItemViewMutationFn = Apollo.MutationFunction<UpdateContentCalendarViewForContentCalendarViewListItemViewMutation, UpdateContentCalendarViewForContentCalendarViewListItemViewMutationVariables>;

/**
 * __useUpdateContentCalendarViewForContentCalendarViewListItemViewMutation__
 *
 * To run a mutation, you first call `useUpdateContentCalendarViewForContentCalendarViewListItemViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentCalendarViewForContentCalendarViewListItemViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentCalendarViewForContentCalendarViewListItemViewMutation, { data, loading, error }] = useUpdateContentCalendarViewForContentCalendarViewListItemViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentCalendarViewForContentCalendarViewListItemViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentCalendarViewForContentCalendarViewListItemViewMutation, UpdateContentCalendarViewForContentCalendarViewListItemViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentCalendarViewForContentCalendarViewListItemViewMutation, UpdateContentCalendarViewForContentCalendarViewListItemViewMutationVariables>(UpdateContentCalendarViewForContentCalendarViewListItemViewDocument, options);
      }
export type UpdateContentCalendarViewForContentCalendarViewListItemViewMutationHookResult = ReturnType<typeof useUpdateContentCalendarViewForContentCalendarViewListItemViewMutation>;
export type UpdateContentCalendarViewForContentCalendarViewListItemViewMutationResult = Apollo.MutationResult<UpdateContentCalendarViewForContentCalendarViewListItemViewMutation>;
export type UpdateContentCalendarViewForContentCalendarViewListItemViewMutationOptions = Apollo.BaseMutationOptions<UpdateContentCalendarViewForContentCalendarViewListItemViewMutation, UpdateContentCalendarViewForContentCalendarViewListItemViewMutationVariables>;
export const UpdateContentIdeaForContentIdeaCollectionDocument = gql`
    mutation UpdateContentIdeaForContentIdeaCollection($data: UpdateContentIdeaInput!) {
  updateContentIdea(data: $data) {
    id
    ...ContentIdeaFragmentContentIdeaCollection
  }
}
    ${ContentIdeaFragmentContentIdeaCollectionFragmentDoc}`;
export type UpdateContentIdeaForContentIdeaCollectionMutationFn = Apollo.MutationFunction<UpdateContentIdeaForContentIdeaCollectionMutation, UpdateContentIdeaForContentIdeaCollectionMutationVariables>;

/**
 * __useUpdateContentIdeaForContentIdeaCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaForContentIdeaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaForContentIdeaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaForContentIdeaCollectionMutation, { data, loading, error }] = useUpdateContentIdeaForContentIdeaCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaForContentIdeaCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaForContentIdeaCollectionMutation, UpdateContentIdeaForContentIdeaCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaForContentIdeaCollectionMutation, UpdateContentIdeaForContentIdeaCollectionMutationVariables>(UpdateContentIdeaForContentIdeaCollectionDocument, options);
      }
export type UpdateContentIdeaForContentIdeaCollectionMutationHookResult = ReturnType<typeof useUpdateContentIdeaForContentIdeaCollectionMutation>;
export type UpdateContentIdeaForContentIdeaCollectionMutationResult = Apollo.MutationResult<UpdateContentIdeaForContentIdeaCollectionMutation>;
export type UpdateContentIdeaForContentIdeaCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaForContentIdeaCollectionMutation, UpdateContentIdeaForContentIdeaCollectionMutationVariables>;
export const DeleteContentIdeaForContentIdeaContextMenuDocument = gql`
    mutation DeleteContentIdeaForContentIdeaContextMenu($data: DeleteContentIdeaInput!) {
  deleteContentIdea(data: $data) {
    success
    message
  }
}
    `;
export type DeleteContentIdeaForContentIdeaContextMenuMutationFn = Apollo.MutationFunction<DeleteContentIdeaForContentIdeaContextMenuMutation, DeleteContentIdeaForContentIdeaContextMenuMutationVariables>;

/**
 * __useDeleteContentIdeaForContentIdeaContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteContentIdeaForContentIdeaContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentIdeaForContentIdeaContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentIdeaForContentIdeaContextMenuMutation, { data, loading, error }] = useDeleteContentIdeaForContentIdeaContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteContentIdeaForContentIdeaContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentIdeaForContentIdeaContextMenuMutation, DeleteContentIdeaForContentIdeaContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentIdeaForContentIdeaContextMenuMutation, DeleteContentIdeaForContentIdeaContextMenuMutationVariables>(DeleteContentIdeaForContentIdeaContextMenuDocument, options);
      }
export type DeleteContentIdeaForContentIdeaContextMenuMutationHookResult = ReturnType<typeof useDeleteContentIdeaForContentIdeaContextMenuMutation>;
export type DeleteContentIdeaForContentIdeaContextMenuMutationResult = Apollo.MutationResult<DeleteContentIdeaForContentIdeaContextMenuMutation>;
export type DeleteContentIdeaForContentIdeaContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteContentIdeaForContentIdeaContextMenuMutation, DeleteContentIdeaForContentIdeaContextMenuMutationVariables>;
export const GetCollectionForCollectionFieldDocument = gql`
    query GetCollectionForCollectionField($collectionId: String!) {
  collection(id: $collectionId) {
    id
    ...CollectionFragmentCollectionField
  }
}
    ${CollectionFragmentCollectionFieldFragmentDoc}`;

/**
 * __useGetCollectionForCollectionFieldQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCollectionFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCollectionFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCollectionFieldQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForCollectionFieldQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCollectionFieldQuery, GetCollectionForCollectionFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCollectionFieldQuery, GetCollectionForCollectionFieldQueryVariables>(GetCollectionForCollectionFieldDocument, options);
      }
export function useGetCollectionForCollectionFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCollectionFieldQuery, GetCollectionForCollectionFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCollectionFieldQuery, GetCollectionForCollectionFieldQueryVariables>(GetCollectionForCollectionFieldDocument, options);
        }
export type GetCollectionForCollectionFieldQueryHookResult = ReturnType<typeof useGetCollectionForCollectionFieldQuery>;
export type GetCollectionForCollectionFieldLazyQueryHookResult = ReturnType<typeof useGetCollectionForCollectionFieldLazyQuery>;
export type GetCollectionForCollectionFieldQueryResult = Apollo.QueryResult<GetCollectionForCollectionFieldQuery, GetCollectionForCollectionFieldQueryVariables>;
export const SavePostsToCollectionsForCollectionFieldDocument = gql`
    mutation SavePostsToCollectionsForCollectionField($data: SavePostsToCollectionsInput!) {
  savePostsToCollections(data: $data) {
    success
    message
  }
}
    `;
export type SavePostsToCollectionsForCollectionFieldMutationFn = Apollo.MutationFunction<SavePostsToCollectionsForCollectionFieldMutation, SavePostsToCollectionsForCollectionFieldMutationVariables>;

/**
 * __useSavePostsToCollectionsForCollectionFieldMutation__
 *
 * To run a mutation, you first call `useSavePostsToCollectionsForCollectionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostsToCollectionsForCollectionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostsToCollectionsForCollectionFieldMutation, { data, loading, error }] = useSavePostsToCollectionsForCollectionFieldMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSavePostsToCollectionsForCollectionFieldMutation(baseOptions?: Apollo.MutationHookOptions<SavePostsToCollectionsForCollectionFieldMutation, SavePostsToCollectionsForCollectionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePostsToCollectionsForCollectionFieldMutation, SavePostsToCollectionsForCollectionFieldMutationVariables>(SavePostsToCollectionsForCollectionFieldDocument, options);
      }
export type SavePostsToCollectionsForCollectionFieldMutationHookResult = ReturnType<typeof useSavePostsToCollectionsForCollectionFieldMutation>;
export type SavePostsToCollectionsForCollectionFieldMutationResult = Apollo.MutationResult<SavePostsToCollectionsForCollectionFieldMutation>;
export type SavePostsToCollectionsForCollectionFieldMutationOptions = Apollo.BaseMutationOptions<SavePostsToCollectionsForCollectionFieldMutation, SavePostsToCollectionsForCollectionFieldMutationVariables>;
export const RemovePostFromCollectionForCollectionFieldDocument = gql`
    mutation RemovePostFromCollectionForCollectionField($data: RemovePostFromCollectionInput!) {
  removePostFromCollection(data: $data) {
    success
    message
  }
}
    `;
export type RemovePostFromCollectionForCollectionFieldMutationFn = Apollo.MutationFunction<RemovePostFromCollectionForCollectionFieldMutation, RemovePostFromCollectionForCollectionFieldMutationVariables>;

/**
 * __useRemovePostFromCollectionForCollectionFieldMutation__
 *
 * To run a mutation, you first call `useRemovePostFromCollectionForCollectionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePostFromCollectionForCollectionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePostFromCollectionForCollectionFieldMutation, { data, loading, error }] = useRemovePostFromCollectionForCollectionFieldMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePostFromCollectionForCollectionFieldMutation(baseOptions?: Apollo.MutationHookOptions<RemovePostFromCollectionForCollectionFieldMutation, RemovePostFromCollectionForCollectionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePostFromCollectionForCollectionFieldMutation, RemovePostFromCollectionForCollectionFieldMutationVariables>(RemovePostFromCollectionForCollectionFieldDocument, options);
      }
export type RemovePostFromCollectionForCollectionFieldMutationHookResult = ReturnType<typeof useRemovePostFromCollectionForCollectionFieldMutation>;
export type RemovePostFromCollectionForCollectionFieldMutationResult = Apollo.MutationResult<RemovePostFromCollectionForCollectionFieldMutation>;
export type RemovePostFromCollectionForCollectionFieldMutationOptions = Apollo.BaseMutationOptions<RemovePostFromCollectionForCollectionFieldMutation, RemovePostFromCollectionForCollectionFieldMutationVariables>;
export const DeletePostForCollectionFieldDocument = gql`
    mutation DeletePostForCollectionField($id: String!) {
  deletePost(id: $id) {
    message
    success
  }
}
    `;
export type DeletePostForCollectionFieldMutationFn = Apollo.MutationFunction<DeletePostForCollectionFieldMutation, DeletePostForCollectionFieldMutationVariables>;

/**
 * __useDeletePostForCollectionFieldMutation__
 *
 * To run a mutation, you first call `useDeletePostForCollectionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostForCollectionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostForCollectionFieldMutation, { data, loading, error }] = useDeletePostForCollectionFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostForCollectionFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostForCollectionFieldMutation, DeletePostForCollectionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostForCollectionFieldMutation, DeletePostForCollectionFieldMutationVariables>(DeletePostForCollectionFieldDocument, options);
      }
export type DeletePostForCollectionFieldMutationHookResult = ReturnType<typeof useDeletePostForCollectionFieldMutation>;
export type DeletePostForCollectionFieldMutationResult = Apollo.MutationResult<DeletePostForCollectionFieldMutation>;
export type DeletePostForCollectionFieldMutationOptions = Apollo.BaseMutationOptions<DeletePostForCollectionFieldMutation, DeletePostForCollectionFieldMutationVariables>;
export const MovePostsToCollectionForCollectionFieldDocument = gql`
    mutation MovePostsToCollectionForCollectionField($data: MovePostsToCollectionInput!) {
  movePostsToCollection(data: $data) {
    success
    message
  }
}
    `;
export type MovePostsToCollectionForCollectionFieldMutationFn = Apollo.MutationFunction<MovePostsToCollectionForCollectionFieldMutation, MovePostsToCollectionForCollectionFieldMutationVariables>;

/**
 * __useMovePostsToCollectionForCollectionFieldMutation__
 *
 * To run a mutation, you first call `useMovePostsToCollectionForCollectionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePostsToCollectionForCollectionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePostsToCollectionForCollectionFieldMutation, { data, loading, error }] = useMovePostsToCollectionForCollectionFieldMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMovePostsToCollectionForCollectionFieldMutation(baseOptions?: Apollo.MutationHookOptions<MovePostsToCollectionForCollectionFieldMutation, MovePostsToCollectionForCollectionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePostsToCollectionForCollectionFieldMutation, MovePostsToCollectionForCollectionFieldMutationVariables>(MovePostsToCollectionForCollectionFieldDocument, options);
      }
export type MovePostsToCollectionForCollectionFieldMutationHookResult = ReturnType<typeof useMovePostsToCollectionForCollectionFieldMutation>;
export type MovePostsToCollectionForCollectionFieldMutationResult = Apollo.MutationResult<MovePostsToCollectionForCollectionFieldMutation>;
export type MovePostsToCollectionForCollectionFieldMutationOptions = Apollo.BaseMutationOptions<MovePostsToCollectionForCollectionFieldMutation, MovePostsToCollectionForCollectionFieldMutationVariables>;
export const UpdateContentIdeaFieldValueForContentIdeaFieldDocument = gql`
    mutation UpdateContentIdeaFieldValueForContentIdeaField($data: UpdateContentIdeaFieldValueInput!) {
  updateContentIdeaFieldValue(data: $data) {
    id
    ...ContentIdeaFieldValueFragmentContentIdeaField
  }
}
    ${ContentIdeaFieldValueFragmentContentIdeaFieldFragmentDoc}`;
export type UpdateContentIdeaFieldValueForContentIdeaFieldMutationFn = Apollo.MutationFunction<UpdateContentIdeaFieldValueForContentIdeaFieldMutation, UpdateContentIdeaFieldValueForContentIdeaFieldMutationVariables>;

/**
 * __useUpdateContentIdeaFieldValueForContentIdeaFieldMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaFieldValueForContentIdeaFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaFieldValueForContentIdeaFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaFieldValueForContentIdeaFieldMutation, { data, loading, error }] = useUpdateContentIdeaFieldValueForContentIdeaFieldMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaFieldValueForContentIdeaFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaFieldValueForContentIdeaFieldMutation, UpdateContentIdeaFieldValueForContentIdeaFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaFieldValueForContentIdeaFieldMutation, UpdateContentIdeaFieldValueForContentIdeaFieldMutationVariables>(UpdateContentIdeaFieldValueForContentIdeaFieldDocument, options);
      }
export type UpdateContentIdeaFieldValueForContentIdeaFieldMutationHookResult = ReturnType<typeof useUpdateContentIdeaFieldValueForContentIdeaFieldMutation>;
export type UpdateContentIdeaFieldValueForContentIdeaFieldMutationResult = Apollo.MutationResult<UpdateContentIdeaFieldValueForContentIdeaFieldMutation>;
export type UpdateContentIdeaFieldValueForContentIdeaFieldMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaFieldValueForContentIdeaFieldMutation, UpdateContentIdeaFieldValueForContentIdeaFieldMutationVariables>;
export const GetContentIdeaFieldForMultiSelectFieldDocument = gql`
    query GetContentIdeaFieldForMultiSelectField($id: String!) {
  contentIdeaField(id: $id) {
    ...ContentIdeaFieldModelFragmentMultiSelectField
  }
}
    ${ContentIdeaFieldModelFragmentMultiSelectFieldFragmentDoc}`;

/**
 * __useGetContentIdeaFieldForMultiSelectFieldQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaFieldForMultiSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaFieldForMultiSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaFieldForMultiSelectFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentIdeaFieldForMultiSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeaFieldForMultiSelectFieldQuery, GetContentIdeaFieldForMultiSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaFieldForMultiSelectFieldQuery, GetContentIdeaFieldForMultiSelectFieldQueryVariables>(GetContentIdeaFieldForMultiSelectFieldDocument, options);
      }
export function useGetContentIdeaFieldForMultiSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaFieldForMultiSelectFieldQuery, GetContentIdeaFieldForMultiSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaFieldForMultiSelectFieldQuery, GetContentIdeaFieldForMultiSelectFieldQueryVariables>(GetContentIdeaFieldForMultiSelectFieldDocument, options);
        }
export type GetContentIdeaFieldForMultiSelectFieldQueryHookResult = ReturnType<typeof useGetContentIdeaFieldForMultiSelectFieldQuery>;
export type GetContentIdeaFieldForMultiSelectFieldLazyQueryHookResult = ReturnType<typeof useGetContentIdeaFieldForMultiSelectFieldLazyQuery>;
export type GetContentIdeaFieldForMultiSelectFieldQueryResult = Apollo.QueryResult<GetContentIdeaFieldForMultiSelectFieldQuery, GetContentIdeaFieldForMultiSelectFieldQueryVariables>;
export const GetContentIdeaFieldForSelectFieldDocument = gql`
    query GetContentIdeaFieldForSelectField($id: String!) {
  contentIdeaField(id: $id) {
    ...ContentIdeaFieldModelFragmentSelectField
  }
}
    ${ContentIdeaFieldModelFragmentSelectFieldFragmentDoc}`;

/**
 * __useGetContentIdeaFieldForSelectFieldQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaFieldForSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaFieldForSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaFieldForSelectFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentIdeaFieldForSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeaFieldForSelectFieldQuery, GetContentIdeaFieldForSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaFieldForSelectFieldQuery, GetContentIdeaFieldForSelectFieldQueryVariables>(GetContentIdeaFieldForSelectFieldDocument, options);
      }
export function useGetContentIdeaFieldForSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaFieldForSelectFieldQuery, GetContentIdeaFieldForSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaFieldForSelectFieldQuery, GetContentIdeaFieldForSelectFieldQueryVariables>(GetContentIdeaFieldForSelectFieldDocument, options);
        }
export type GetContentIdeaFieldForSelectFieldQueryHookResult = ReturnType<typeof useGetContentIdeaFieldForSelectFieldQuery>;
export type GetContentIdeaFieldForSelectFieldLazyQueryHookResult = ReturnType<typeof useGetContentIdeaFieldForSelectFieldLazyQuery>;
export type GetContentIdeaFieldForSelectFieldQueryResult = Apollo.QueryResult<GetContentIdeaFieldForSelectFieldQuery, GetContentIdeaFieldForSelectFieldQueryVariables>;
export const GetTaskByIdsForTasksFieldDocument = gql`
    query GetTaskByIdsForTasksField($ids: [String!]!) {
  tasksByIds(ids: $ids) {
    ...TaskFragmentTasksField
    subtasks {
      ...TaskFragmentTasksField
    }
  }
}
    ${TaskFragmentTasksFieldFragmentDoc}`;

/**
 * __useGetTaskByIdsForTasksFieldQuery__
 *
 * To run a query within a React component, call `useGetTaskByIdsForTasksFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdsForTasksFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByIdsForTasksFieldQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetTaskByIdsForTasksFieldQuery(baseOptions: Apollo.QueryHookOptions<GetTaskByIdsForTasksFieldQuery, GetTaskByIdsForTasksFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskByIdsForTasksFieldQuery, GetTaskByIdsForTasksFieldQueryVariables>(GetTaskByIdsForTasksFieldDocument, options);
      }
export function useGetTaskByIdsForTasksFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskByIdsForTasksFieldQuery, GetTaskByIdsForTasksFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskByIdsForTasksFieldQuery, GetTaskByIdsForTasksFieldQueryVariables>(GetTaskByIdsForTasksFieldDocument, options);
        }
export type GetTaskByIdsForTasksFieldQueryHookResult = ReturnType<typeof useGetTaskByIdsForTasksFieldQuery>;
export type GetTaskByIdsForTasksFieldLazyQueryHookResult = ReturnType<typeof useGetTaskByIdsForTasksFieldLazyQuery>;
export type GetTaskByIdsForTasksFieldQueryResult = Apollo.QueryResult<GetTaskByIdsForTasksFieldQuery, GetTaskByIdsForTasksFieldQueryVariables>;
export const UpdateTaskForUseTasksFieldShortcutsDocument = gql`
    mutation UpdateTaskForUseTasksFieldShortcuts($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    subtasks {
      id
      ...TaskFragmentUseTasksFieldShortcuts
    }
    ...TaskFragmentUseTasksFieldShortcuts
  }
}
    ${TaskFragmentUseTasksFieldShortcutsFragmentDoc}`;
export type UpdateTaskForUseTasksFieldShortcutsMutationFn = Apollo.MutationFunction<UpdateTaskForUseTasksFieldShortcutsMutation, UpdateTaskForUseTasksFieldShortcutsMutationVariables>;

/**
 * __useUpdateTaskForUseTasksFieldShortcutsMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForUseTasksFieldShortcutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForUseTasksFieldShortcutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForUseTasksFieldShortcutsMutation, { data, loading, error }] = useUpdateTaskForUseTasksFieldShortcutsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForUseTasksFieldShortcutsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForUseTasksFieldShortcutsMutation, UpdateTaskForUseTasksFieldShortcutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForUseTasksFieldShortcutsMutation, UpdateTaskForUseTasksFieldShortcutsMutationVariables>(UpdateTaskForUseTasksFieldShortcutsDocument, options);
      }
export type UpdateTaskForUseTasksFieldShortcutsMutationHookResult = ReturnType<typeof useUpdateTaskForUseTasksFieldShortcutsMutation>;
export type UpdateTaskForUseTasksFieldShortcutsMutationResult = Apollo.MutationResult<UpdateTaskForUseTasksFieldShortcutsMutation>;
export type UpdateTaskForUseTasksFieldShortcutsMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForUseTasksFieldShortcutsMutation, UpdateTaskForUseTasksFieldShortcutsMutationVariables>;
export const UpdateContentIdeaFieldForContentIdeaFieldNameDocument = gql`
    mutation UpdateContentIdeaFieldForContentIdeaFieldName($data: UpdateContentIdeaFieldInput!) {
  updateContentIdeaField(data: $data) {
    id
    ...ContentIdeaFieldFragmentContentIdeaFieldName
  }
}
    ${ContentIdeaFieldFragmentContentIdeaFieldNameFragmentDoc}`;
export type UpdateContentIdeaFieldForContentIdeaFieldNameMutationFn = Apollo.MutationFunction<UpdateContentIdeaFieldForContentIdeaFieldNameMutation, UpdateContentIdeaFieldForContentIdeaFieldNameMutationVariables>;

/**
 * __useUpdateContentIdeaFieldForContentIdeaFieldNameMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaFieldForContentIdeaFieldNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaFieldForContentIdeaFieldNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaFieldForContentIdeaFieldNameMutation, { data, loading, error }] = useUpdateContentIdeaFieldForContentIdeaFieldNameMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaFieldForContentIdeaFieldNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaFieldForContentIdeaFieldNameMutation, UpdateContentIdeaFieldForContentIdeaFieldNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaFieldForContentIdeaFieldNameMutation, UpdateContentIdeaFieldForContentIdeaFieldNameMutationVariables>(UpdateContentIdeaFieldForContentIdeaFieldNameDocument, options);
      }
export type UpdateContentIdeaFieldForContentIdeaFieldNameMutationHookResult = ReturnType<typeof useUpdateContentIdeaFieldForContentIdeaFieldNameMutation>;
export type UpdateContentIdeaFieldForContentIdeaFieldNameMutationResult = Apollo.MutationResult<UpdateContentIdeaFieldForContentIdeaFieldNameMutation>;
export type UpdateContentIdeaFieldForContentIdeaFieldNameMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaFieldForContentIdeaFieldNameMutation, UpdateContentIdeaFieldForContentIdeaFieldNameMutationVariables>;
export const DuplicateContentIdeaFieldForContentIdeaFieldNameDocument = gql`
    mutation DuplicateContentIdeaFieldForContentIdeaFieldName($data: DuplicateContentIdeaFieldInput!) {
  duplicateContentIdeaField(data: $data) {
    id
    ...ContentIdeaFieldFragmentContentIdeaFieldName
  }
}
    ${ContentIdeaFieldFragmentContentIdeaFieldNameFragmentDoc}`;
export type DuplicateContentIdeaFieldForContentIdeaFieldNameMutationFn = Apollo.MutationFunction<DuplicateContentIdeaFieldForContentIdeaFieldNameMutation, DuplicateContentIdeaFieldForContentIdeaFieldNameMutationVariables>;

/**
 * __useDuplicateContentIdeaFieldForContentIdeaFieldNameMutation__
 *
 * To run a mutation, you first call `useDuplicateContentIdeaFieldForContentIdeaFieldNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateContentIdeaFieldForContentIdeaFieldNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateContentIdeaFieldForContentIdeaFieldNameMutation, { data, loading, error }] = useDuplicateContentIdeaFieldForContentIdeaFieldNameMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDuplicateContentIdeaFieldForContentIdeaFieldNameMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateContentIdeaFieldForContentIdeaFieldNameMutation, DuplicateContentIdeaFieldForContentIdeaFieldNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateContentIdeaFieldForContentIdeaFieldNameMutation, DuplicateContentIdeaFieldForContentIdeaFieldNameMutationVariables>(DuplicateContentIdeaFieldForContentIdeaFieldNameDocument, options);
      }
export type DuplicateContentIdeaFieldForContentIdeaFieldNameMutationHookResult = ReturnType<typeof useDuplicateContentIdeaFieldForContentIdeaFieldNameMutation>;
export type DuplicateContentIdeaFieldForContentIdeaFieldNameMutationResult = Apollo.MutationResult<DuplicateContentIdeaFieldForContentIdeaFieldNameMutation>;
export type DuplicateContentIdeaFieldForContentIdeaFieldNameMutationOptions = Apollo.BaseMutationOptions<DuplicateContentIdeaFieldForContentIdeaFieldNameMutation, DuplicateContentIdeaFieldForContentIdeaFieldNameMutationVariables>;
export const DeleteContentIdeaFieldForContentIdeaFieldNameDocument = gql`
    mutation DeleteContentIdeaFieldForContentIdeaFieldName($data: DeleteContentIdeaFieldInput!) {
  deleteContentIdeaField(data: $data) {
    success
    message
  }
}
    `;
export type DeleteContentIdeaFieldForContentIdeaFieldNameMutationFn = Apollo.MutationFunction<DeleteContentIdeaFieldForContentIdeaFieldNameMutation, DeleteContentIdeaFieldForContentIdeaFieldNameMutationVariables>;

/**
 * __useDeleteContentIdeaFieldForContentIdeaFieldNameMutation__
 *
 * To run a mutation, you first call `useDeleteContentIdeaFieldForContentIdeaFieldNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentIdeaFieldForContentIdeaFieldNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentIdeaFieldForContentIdeaFieldNameMutation, { data, loading, error }] = useDeleteContentIdeaFieldForContentIdeaFieldNameMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteContentIdeaFieldForContentIdeaFieldNameMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentIdeaFieldForContentIdeaFieldNameMutation, DeleteContentIdeaFieldForContentIdeaFieldNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentIdeaFieldForContentIdeaFieldNameMutation, DeleteContentIdeaFieldForContentIdeaFieldNameMutationVariables>(DeleteContentIdeaFieldForContentIdeaFieldNameDocument, options);
      }
export type DeleteContentIdeaFieldForContentIdeaFieldNameMutationHookResult = ReturnType<typeof useDeleteContentIdeaFieldForContentIdeaFieldNameMutation>;
export type DeleteContentIdeaFieldForContentIdeaFieldNameMutationResult = Apollo.MutationResult<DeleteContentIdeaFieldForContentIdeaFieldNameMutation>;
export type DeleteContentIdeaFieldForContentIdeaFieldNameMutationOptions = Apollo.BaseMutationOptions<DeleteContentIdeaFieldForContentIdeaFieldNameMutation, DeleteContentIdeaFieldForContentIdeaFieldNameMutationVariables>;
export const GetContentIdeaFieldsForContentIdeaFieldNameDocument = gql`
    query GetContentIdeaFieldsForContentIdeaFieldName($filters: ContentIdeaFieldFilters) {
  contentIdeaFields(filters: $filters) {
    id
    ...ContentIdeaFieldFragmentContentIdeaFieldName
  }
}
    ${ContentIdeaFieldFragmentContentIdeaFieldNameFragmentDoc}`;

/**
 * __useGetContentIdeaFieldsForContentIdeaFieldNameQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaFieldsForContentIdeaFieldNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaFieldsForContentIdeaFieldNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaFieldsForContentIdeaFieldNameQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetContentIdeaFieldsForContentIdeaFieldNameQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaFieldsForContentIdeaFieldNameQuery, GetContentIdeaFieldsForContentIdeaFieldNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaFieldsForContentIdeaFieldNameQuery, GetContentIdeaFieldsForContentIdeaFieldNameQueryVariables>(GetContentIdeaFieldsForContentIdeaFieldNameDocument, options);
      }
export function useGetContentIdeaFieldsForContentIdeaFieldNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaFieldsForContentIdeaFieldNameQuery, GetContentIdeaFieldsForContentIdeaFieldNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaFieldsForContentIdeaFieldNameQuery, GetContentIdeaFieldsForContentIdeaFieldNameQueryVariables>(GetContentIdeaFieldsForContentIdeaFieldNameDocument, options);
        }
export type GetContentIdeaFieldsForContentIdeaFieldNameQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentIdeaFieldNameQuery>;
export type GetContentIdeaFieldsForContentIdeaFieldNameLazyQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentIdeaFieldNameLazyQuery>;
export type GetContentIdeaFieldsForContentIdeaFieldNameQueryResult = Apollo.QueryResult<GetContentIdeaFieldsForContentIdeaFieldNameQuery, GetContentIdeaFieldsForContentIdeaFieldNameQueryVariables>;
export const UpdateContentIdeaForContentIdeaIceboxDocument = gql`
    mutation UpdateContentIdeaForContentIdeaIcebox($data: UpdateContentIdeaInput!) {
  updateContentIdea(data: $data) {
    id
    ...ContentIdeaFragmentContentIdeaIcebox
  }
}
    ${ContentIdeaFragmentContentIdeaIceboxFragmentDoc}`;
export type UpdateContentIdeaForContentIdeaIceboxMutationFn = Apollo.MutationFunction<UpdateContentIdeaForContentIdeaIceboxMutation, UpdateContentIdeaForContentIdeaIceboxMutationVariables>;

/**
 * __useUpdateContentIdeaForContentIdeaIceboxMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaForContentIdeaIceboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaForContentIdeaIceboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaForContentIdeaIceboxMutation, { data, loading, error }] = useUpdateContentIdeaForContentIdeaIceboxMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaForContentIdeaIceboxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaForContentIdeaIceboxMutation, UpdateContentIdeaForContentIdeaIceboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaForContentIdeaIceboxMutation, UpdateContentIdeaForContentIdeaIceboxMutationVariables>(UpdateContentIdeaForContentIdeaIceboxDocument, options);
      }
export type UpdateContentIdeaForContentIdeaIceboxMutationHookResult = ReturnType<typeof useUpdateContentIdeaForContentIdeaIceboxMutation>;
export type UpdateContentIdeaForContentIdeaIceboxMutationResult = Apollo.MutationResult<UpdateContentIdeaForContentIdeaIceboxMutation>;
export type UpdateContentIdeaForContentIdeaIceboxMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaForContentIdeaIceboxMutation, UpdateContentIdeaForContentIdeaIceboxMutationVariables>;
export const UpdateContentIdeaForContentIdeaNameDocument = gql`
    mutation UpdateContentIdeaForContentIdeaName($data: UpdateContentIdeaInput!) {
  updateContentIdea(data: $data) {
    id
    ...ContentIdeaFragmentContentIdeaName
  }
}
    ${ContentIdeaFragmentContentIdeaNameFragmentDoc}`;
export type UpdateContentIdeaForContentIdeaNameMutationFn = Apollo.MutationFunction<UpdateContentIdeaForContentIdeaNameMutation, UpdateContentIdeaForContentIdeaNameMutationVariables>;

/**
 * __useUpdateContentIdeaForContentIdeaNameMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaForContentIdeaNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaForContentIdeaNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaForContentIdeaNameMutation, { data, loading, error }] = useUpdateContentIdeaForContentIdeaNameMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaForContentIdeaNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaForContentIdeaNameMutation, UpdateContentIdeaForContentIdeaNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaForContentIdeaNameMutation, UpdateContentIdeaForContentIdeaNameMutationVariables>(UpdateContentIdeaForContentIdeaNameDocument, options);
      }
export type UpdateContentIdeaForContentIdeaNameMutationHookResult = ReturnType<typeof useUpdateContentIdeaForContentIdeaNameMutation>;
export type UpdateContentIdeaForContentIdeaNameMutationResult = Apollo.MutationResult<UpdateContentIdeaForContentIdeaNameMutation>;
export type UpdateContentIdeaForContentIdeaNameMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaForContentIdeaNameMutation, UpdateContentIdeaForContentIdeaNameMutationVariables>;
export const UpdateContentIdeaForContentIdeaNoteDocument = gql`
    mutation UpdateContentIdeaForContentIdeaNote($data: UpdateContentIdeaInput!) {
  updateContentIdea(data: $data) {
    id
    noteContent
  }
}
    `;
export type UpdateContentIdeaForContentIdeaNoteMutationFn = Apollo.MutationFunction<UpdateContentIdeaForContentIdeaNoteMutation, UpdateContentIdeaForContentIdeaNoteMutationVariables>;

/**
 * __useUpdateContentIdeaForContentIdeaNoteMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaForContentIdeaNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaForContentIdeaNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaForContentIdeaNoteMutation, { data, loading, error }] = useUpdateContentIdeaForContentIdeaNoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaForContentIdeaNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaForContentIdeaNoteMutation, UpdateContentIdeaForContentIdeaNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaForContentIdeaNoteMutation, UpdateContentIdeaForContentIdeaNoteMutationVariables>(UpdateContentIdeaForContentIdeaNoteDocument, options);
      }
export type UpdateContentIdeaForContentIdeaNoteMutationHookResult = ReturnType<typeof useUpdateContentIdeaForContentIdeaNoteMutation>;
export type UpdateContentIdeaForContentIdeaNoteMutationResult = Apollo.MutationResult<UpdateContentIdeaForContentIdeaNoteMutation>;
export type UpdateContentIdeaForContentIdeaNoteMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaForContentIdeaNoteMutation, UpdateContentIdeaForContentIdeaNoteMutationVariables>;
export const InviteMembersForContentIdeaOwnersDocument = gql`
    mutation InviteMembersForContentIdeaOwners($data: InviteCollectionMembersInput!) {
  inviteCollectionMembers(data: $data) {
    success
    message
  }
}
    `;
export type InviteMembersForContentIdeaOwnersMutationFn = Apollo.MutationFunction<InviteMembersForContentIdeaOwnersMutation, InviteMembersForContentIdeaOwnersMutationVariables>;

/**
 * __useInviteMembersForContentIdeaOwnersMutation__
 *
 * To run a mutation, you first call `useInviteMembersForContentIdeaOwnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMembersForContentIdeaOwnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMembersForContentIdeaOwnersMutation, { data, loading, error }] = useInviteMembersForContentIdeaOwnersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteMembersForContentIdeaOwnersMutation(baseOptions?: Apollo.MutationHookOptions<InviteMembersForContentIdeaOwnersMutation, InviteMembersForContentIdeaOwnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMembersForContentIdeaOwnersMutation, InviteMembersForContentIdeaOwnersMutationVariables>(InviteMembersForContentIdeaOwnersDocument, options);
      }
export type InviteMembersForContentIdeaOwnersMutationHookResult = ReturnType<typeof useInviteMembersForContentIdeaOwnersMutation>;
export type InviteMembersForContentIdeaOwnersMutationResult = Apollo.MutationResult<InviteMembersForContentIdeaOwnersMutation>;
export type InviteMembersForContentIdeaOwnersMutationOptions = Apollo.BaseMutationOptions<InviteMembersForContentIdeaOwnersMutation, InviteMembersForContentIdeaOwnersMutationVariables>;
export const UpdateNestedCollectionPostPermissionsForContentIdeaOwnersDocument = gql`
    mutation UpdateNestedCollectionPostPermissionsForContentIdeaOwners($data: UpdateNestedCollectionPostPermissionsInput!) {
  updateNestedCollectionPostPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationFn = Apollo.MutationFunction<UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation, UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationVariables>;

/**
 * __useUpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation__
 *
 * To run a mutation, you first call `useUpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNestedCollectionPostPermissionsForContentIdeaOwnersMutation, { data, loading, error }] = useUpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation, UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation, UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationVariables>(UpdateNestedCollectionPostPermissionsForContentIdeaOwnersDocument, options);
      }
export type UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationHookResult = ReturnType<typeof useUpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation>;
export type UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationResult = Apollo.MutationResult<UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation>;
export type UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationOptions = Apollo.BaseMutationOptions<UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutation, UpdateNestedCollectionPostPermissionsForContentIdeaOwnersMutationVariables>;
export const UpdateContentIdeaFieldValueForContentIdeaOwnersDocument = gql`
    mutation UpdateContentIdeaFieldValueForContentIdeaOwners($data: UpdateContentIdeaFieldValueInput!) {
  updateContentIdeaFieldValue(data: $data) {
    id
    value {
      id
      users {
        id
      }
    }
  }
}
    `;
export type UpdateContentIdeaFieldValueForContentIdeaOwnersMutationFn = Apollo.MutationFunction<UpdateContentIdeaFieldValueForContentIdeaOwnersMutation, UpdateContentIdeaFieldValueForContentIdeaOwnersMutationVariables>;

/**
 * __useUpdateContentIdeaFieldValueForContentIdeaOwnersMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaFieldValueForContentIdeaOwnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaFieldValueForContentIdeaOwnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaFieldValueForContentIdeaOwnersMutation, { data, loading, error }] = useUpdateContentIdeaFieldValueForContentIdeaOwnersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaFieldValueForContentIdeaOwnersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaFieldValueForContentIdeaOwnersMutation, UpdateContentIdeaFieldValueForContentIdeaOwnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaFieldValueForContentIdeaOwnersMutation, UpdateContentIdeaFieldValueForContentIdeaOwnersMutationVariables>(UpdateContentIdeaFieldValueForContentIdeaOwnersDocument, options);
      }
export type UpdateContentIdeaFieldValueForContentIdeaOwnersMutationHookResult = ReturnType<typeof useUpdateContentIdeaFieldValueForContentIdeaOwnersMutation>;
export type UpdateContentIdeaFieldValueForContentIdeaOwnersMutationResult = Apollo.MutationResult<UpdateContentIdeaFieldValueForContentIdeaOwnersMutation>;
export type UpdateContentIdeaFieldValueForContentIdeaOwnersMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaFieldValueForContentIdeaOwnersMutation, UpdateContentIdeaFieldValueForContentIdeaOwnersMutationVariables>;
export const UpdateContentIdeaPublishMetadataForContentIdeaPlatformsDocument = gql`
    mutation UpdateContentIdeaPublishMetadataForContentIdeaPlatforms($data: UpdateContentIdeaPublishMetadataInput!) {
  updateContentIdeaPublishMetadata(data: $data) {
    id
    ...ContentIdeaPublishMetadataFragmentContentIdeaPlatforms
  }
}
    ${ContentIdeaPublishMetadataFragmentContentIdeaPlatformsFragmentDoc}`;
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationFn = Apollo.MutationFunction<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationVariables>;

/**
 * __useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaPublishMetadataForContentIdeaPlatformsMutation, { data, loading, error }] = useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationVariables>(UpdateContentIdeaPublishMetadataForContentIdeaPlatformsDocument, options);
      }
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationHookResult = ReturnType<typeof useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation>;
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationResult = Apollo.MutationResult<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation>;
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMutationVariables>;
export const UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemDocument = gql`
    mutation UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItem($data: UpdateContentIdeaPublishMetadataInput!) {
  updateContentIdeaPublishMetadata(data: $data) {
    id
    ...ContentIdeaPublishMetadataFragmentContentIdeaPlatformsMenuItem
  }
}
    ${ContentIdeaPublishMetadataFragmentContentIdeaPlatformsMenuItemFragmentDoc}`;
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationFn = Apollo.MutationFunction<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationVariables>;

/**
 * __useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation, { data, loading, error }] = useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationVariables>(UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemDocument, options);
      }
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationHookResult = ReturnType<typeof useUpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation>;
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationResult = Apollo.MutationResult<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation>;
export type UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutation, UpdateContentIdeaPublishMetadataForContentIdeaPlatformsMenuItemMutationVariables>;
export const SavePostsToCollectionsForContentIdeaPreviewDocument = gql`
    mutation SavePostsToCollectionsForContentIdeaPreview($data: SavePostsToCollectionsInput!) {
  savePostsToCollections(data: $data) {
    success
    message
  }
}
    `;
export type SavePostsToCollectionsForContentIdeaPreviewMutationFn = Apollo.MutationFunction<SavePostsToCollectionsForContentIdeaPreviewMutation, SavePostsToCollectionsForContentIdeaPreviewMutationVariables>;

/**
 * __useSavePostsToCollectionsForContentIdeaPreviewMutation__
 *
 * To run a mutation, you first call `useSavePostsToCollectionsForContentIdeaPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostsToCollectionsForContentIdeaPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostsToCollectionsForContentIdeaPreviewMutation, { data, loading, error }] = useSavePostsToCollectionsForContentIdeaPreviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSavePostsToCollectionsForContentIdeaPreviewMutation(baseOptions?: Apollo.MutationHookOptions<SavePostsToCollectionsForContentIdeaPreviewMutation, SavePostsToCollectionsForContentIdeaPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePostsToCollectionsForContentIdeaPreviewMutation, SavePostsToCollectionsForContentIdeaPreviewMutationVariables>(SavePostsToCollectionsForContentIdeaPreviewDocument, options);
      }
export type SavePostsToCollectionsForContentIdeaPreviewMutationHookResult = ReturnType<typeof useSavePostsToCollectionsForContentIdeaPreviewMutation>;
export type SavePostsToCollectionsForContentIdeaPreviewMutationResult = Apollo.MutationResult<SavePostsToCollectionsForContentIdeaPreviewMutation>;
export type SavePostsToCollectionsForContentIdeaPreviewMutationOptions = Apollo.BaseMutationOptions<SavePostsToCollectionsForContentIdeaPreviewMutation, SavePostsToCollectionsForContentIdeaPreviewMutationVariables>;
export const UpdateCollectionPreviewForContentIdeaPreviewDocument = gql`
    mutation UpdateCollectionPreviewForContentIdeaPreview($data: UpdateCollectionPreviewInput!) {
  updateCollectionPreview(data: $data) {
    id
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export type UpdateCollectionPreviewForContentIdeaPreviewMutationFn = Apollo.MutationFunction<UpdateCollectionPreviewForContentIdeaPreviewMutation, UpdateCollectionPreviewForContentIdeaPreviewMutationVariables>;

/**
 * __useUpdateCollectionPreviewForContentIdeaPreviewMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionPreviewForContentIdeaPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionPreviewForContentIdeaPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionPreviewForContentIdeaPreviewMutation, { data, loading, error }] = useUpdateCollectionPreviewForContentIdeaPreviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCollectionPreviewForContentIdeaPreviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionPreviewForContentIdeaPreviewMutation, UpdateCollectionPreviewForContentIdeaPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionPreviewForContentIdeaPreviewMutation, UpdateCollectionPreviewForContentIdeaPreviewMutationVariables>(UpdateCollectionPreviewForContentIdeaPreviewDocument, options);
      }
export type UpdateCollectionPreviewForContentIdeaPreviewMutationHookResult = ReturnType<typeof useUpdateCollectionPreviewForContentIdeaPreviewMutation>;
export type UpdateCollectionPreviewForContentIdeaPreviewMutationResult = Apollo.MutationResult<UpdateCollectionPreviewForContentIdeaPreviewMutation>;
export type UpdateCollectionPreviewForContentIdeaPreviewMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionPreviewForContentIdeaPreviewMutation, UpdateCollectionPreviewForContentIdeaPreviewMutationVariables>;
export const UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldDocument = gql`
    mutation UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomField($data: UpdateContentIdeaPublishMetadataInput!) {
  updateContentIdeaPublishMetadata(data: $data) {
    id
    ...ContentIdeaPublishMetadataFragmentContentIdeaPublishMetadataPublishUrlCustomField
  }
}
    ${ContentIdeaPublishMetadataFragmentContentIdeaPublishMetadataPublishUrlCustomFieldFragmentDoc}`;
export type UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationFn = Apollo.MutationFunction<UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation, UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationVariables>;

/**
 * __useUpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation, { data, loading, error }] = useUpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation, UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation, UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationVariables>(UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldDocument, options);
      }
export type UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationHookResult = ReturnType<typeof useUpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation>;
export type UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationResult = Apollo.MutationResult<UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation>;
export type UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutation, UpdateContentIdeaPublishMetadataForContentIdeaPublishMetadataPublishUrlCustomFieldMutationVariables>;
export const UpdateContentIdeaFieldValueForContentIdeaReminderModalDocument = gql`
    mutation UpdateContentIdeaFieldValueForContentIdeaReminderModal($data: UpdateContentIdeaFieldValueInput!) {
  updateContentIdeaFieldValue(data: $data) {
    id
    value {
      id
      date
    }
  }
}
    `;
export type UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationFn = Apollo.MutationFunction<UpdateContentIdeaFieldValueForContentIdeaReminderModalMutation, UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationVariables>;

/**
 * __useUpdateContentIdeaFieldValueForContentIdeaReminderModalMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaFieldValueForContentIdeaReminderModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaFieldValueForContentIdeaReminderModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaFieldValueForContentIdeaReminderModalMutation, { data, loading, error }] = useUpdateContentIdeaFieldValueForContentIdeaReminderModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaFieldValueForContentIdeaReminderModalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaFieldValueForContentIdeaReminderModalMutation, UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaFieldValueForContentIdeaReminderModalMutation, UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationVariables>(UpdateContentIdeaFieldValueForContentIdeaReminderModalDocument, options);
      }
export type UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationHookResult = ReturnType<typeof useUpdateContentIdeaFieldValueForContentIdeaReminderModalMutation>;
export type UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationResult = Apollo.MutationResult<UpdateContentIdeaFieldValueForContentIdeaReminderModalMutation>;
export type UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaFieldValueForContentIdeaReminderModalMutation, UpdateContentIdeaFieldValueForContentIdeaReminderModalMutationVariables>;
export const UpdateContentIdeaForContentIdeaSnoozeDateDocument = gql`
    mutation UpdateContentIdeaForContentIdeaSnoozeDate($data: UpdateContentIdeaInput!) {
  updateContentIdea(data: $data) {
    id
    ...ContentIdeaFragmentContentIdeaSnoozeDate
  }
}
    ${ContentIdeaFragmentContentIdeaSnoozeDateFragmentDoc}`;
export type UpdateContentIdeaForContentIdeaSnoozeDateMutationFn = Apollo.MutationFunction<UpdateContentIdeaForContentIdeaSnoozeDateMutation, UpdateContentIdeaForContentIdeaSnoozeDateMutationVariables>;

/**
 * __useUpdateContentIdeaForContentIdeaSnoozeDateMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaForContentIdeaSnoozeDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaForContentIdeaSnoozeDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaForContentIdeaSnoozeDateMutation, { data, loading, error }] = useUpdateContentIdeaForContentIdeaSnoozeDateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaForContentIdeaSnoozeDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaForContentIdeaSnoozeDateMutation, UpdateContentIdeaForContentIdeaSnoozeDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaForContentIdeaSnoozeDateMutation, UpdateContentIdeaForContentIdeaSnoozeDateMutationVariables>(UpdateContentIdeaForContentIdeaSnoozeDateDocument, options);
      }
export type UpdateContentIdeaForContentIdeaSnoozeDateMutationHookResult = ReturnType<typeof useUpdateContentIdeaForContentIdeaSnoozeDateMutation>;
export type UpdateContentIdeaForContentIdeaSnoozeDateMutationResult = Apollo.MutationResult<UpdateContentIdeaForContentIdeaSnoozeDateMutation>;
export type UpdateContentIdeaForContentIdeaSnoozeDateMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaForContentIdeaSnoozeDateMutation, UpdateContentIdeaForContentIdeaSnoozeDateMutationVariables>;
export const RemoveSnoozeForContentIdeaSnoozeDateDocument = gql`
    mutation RemoveSnoozeForContentIdeaSnoozeDate($contentIdeaId: String!) {
  removeContentIdeaFromSnooze(contentIdeaId: $contentIdeaId) {
    id
    ...ContentIdeaFragmentContentIdeaSnoozeDate
  }
}
    ${ContentIdeaFragmentContentIdeaSnoozeDateFragmentDoc}`;
export type RemoveSnoozeForContentIdeaSnoozeDateMutationFn = Apollo.MutationFunction<RemoveSnoozeForContentIdeaSnoozeDateMutation, RemoveSnoozeForContentIdeaSnoozeDateMutationVariables>;

/**
 * __useRemoveSnoozeForContentIdeaSnoozeDateMutation__
 *
 * To run a mutation, you first call `useRemoveSnoozeForContentIdeaSnoozeDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSnoozeForContentIdeaSnoozeDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSnoozeForContentIdeaSnoozeDateMutation, { data, loading, error }] = useRemoveSnoozeForContentIdeaSnoozeDateMutation({
 *   variables: {
 *      contentIdeaId: // value for 'contentIdeaId'
 *   },
 * });
 */
export function useRemoveSnoozeForContentIdeaSnoozeDateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSnoozeForContentIdeaSnoozeDateMutation, RemoveSnoozeForContentIdeaSnoozeDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSnoozeForContentIdeaSnoozeDateMutation, RemoveSnoozeForContentIdeaSnoozeDateMutationVariables>(RemoveSnoozeForContentIdeaSnoozeDateDocument, options);
      }
export type RemoveSnoozeForContentIdeaSnoozeDateMutationHookResult = ReturnType<typeof useRemoveSnoozeForContentIdeaSnoozeDateMutation>;
export type RemoveSnoozeForContentIdeaSnoozeDateMutationResult = Apollo.MutationResult<RemoveSnoozeForContentIdeaSnoozeDateMutation>;
export type RemoveSnoozeForContentIdeaSnoozeDateMutationOptions = Apollo.BaseMutationOptions<RemoveSnoozeForContentIdeaSnoozeDateMutation, RemoveSnoozeForContentIdeaSnoozeDateMutationVariables>;
export const GetContentIdeaForContentIdeaStatusDocument = gql`
    query GetContentIdeaForContentIdeaStatus($id: String!) {
  contentIdea(id: $id) {
    id
    stage
  }
}
    `;

/**
 * __useGetContentIdeaForContentIdeaStatusQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaForContentIdeaStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaForContentIdeaStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaForContentIdeaStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentIdeaForContentIdeaStatusQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeaForContentIdeaStatusQuery, GetContentIdeaForContentIdeaStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaForContentIdeaStatusQuery, GetContentIdeaForContentIdeaStatusQueryVariables>(GetContentIdeaForContentIdeaStatusDocument, options);
      }
export function useGetContentIdeaForContentIdeaStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaForContentIdeaStatusQuery, GetContentIdeaForContentIdeaStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaForContentIdeaStatusQuery, GetContentIdeaForContentIdeaStatusQueryVariables>(GetContentIdeaForContentIdeaStatusDocument, options);
        }
export type GetContentIdeaForContentIdeaStatusQueryHookResult = ReturnType<typeof useGetContentIdeaForContentIdeaStatusQuery>;
export type GetContentIdeaForContentIdeaStatusLazyQueryHookResult = ReturnType<typeof useGetContentIdeaForContentIdeaStatusLazyQuery>;
export type GetContentIdeaForContentIdeaStatusQueryResult = Apollo.QueryResult<GetContentIdeaForContentIdeaStatusQuery, GetContentIdeaForContentIdeaStatusQueryVariables>;
export const GetContentIdeaViewersDocument = gql`
    query GetContentIdeaViewers($id: String!) {
  contentIdea(id: $id) {
    ...ContentIdeaFragmentContentIdeaViewers
  }
}
    ${ContentIdeaFragmentContentIdeaViewersFragmentDoc}`;

/**
 * __useGetContentIdeaViewersQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaViewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaViewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaViewersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentIdeaViewersQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeaViewersQuery, GetContentIdeaViewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaViewersQuery, GetContentIdeaViewersQueryVariables>(GetContentIdeaViewersDocument, options);
      }
export function useGetContentIdeaViewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaViewersQuery, GetContentIdeaViewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaViewersQuery, GetContentIdeaViewersQueryVariables>(GetContentIdeaViewersDocument, options);
        }
export type GetContentIdeaViewersQueryHookResult = ReturnType<typeof useGetContentIdeaViewersQuery>;
export type GetContentIdeaViewersLazyQueryHookResult = ReturnType<typeof useGetContentIdeaViewersLazyQuery>;
export type GetContentIdeaViewersQueryResult = Apollo.QueryResult<GetContentIdeaViewersQuery, GetContentIdeaViewersQueryVariables>;
export const CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersDocument = gql`
    mutation CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlers($data: CreateContentIdeaFieldOptionInput!) {
  createContentIdeaFieldOption(data: $data) {
    ...ContentIdeaFieldOptionFragmentMultiSelectField
    ...ContentIdeaFieldOptionFragmentSelectField
  }
}
    ${ContentIdeaFieldOptionFragmentMultiSelectFieldFragmentDoc}
${ContentIdeaFieldOptionFragmentSelectFieldFragmentDoc}`;
export type CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationFn = Apollo.MutationFunction<CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>;

/**
 * __useCreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation__
 *
 * To run a mutation, you first call `useCreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, { data, loading, error }] = useCreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>(CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersDocument, options);
      }
export type CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationHookResult = ReturnType<typeof useCreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation>;
export type CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationResult = Apollo.MutationResult<CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation>;
export type CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationOptions = Apollo.BaseMutationOptions<CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, CreateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>;
export const DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersDocument = gql`
    mutation DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlers($data: DeleteContentIdeaFieldOptionInput!) {
  deleteContentIdeaFieldOption(data: $data) {
    message
    success
  }
}
    `;
export type DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationFn = Apollo.MutationFunction<DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>;

/**
 * __useDeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, { data, loading, error }] = useDeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>(DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersDocument, options);
      }
export type DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationHookResult = ReturnType<typeof useDeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation>;
export type DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationResult = Apollo.MutationResult<DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation>;
export type DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, DeleteContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>;
export const UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersDocument = gql`
    mutation UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlers($data: UpdateContentIdeaFieldOptionInput!) {
  updateContentIdeaFieldOption(data: $data) {
    ...ContentIdeaFieldOptionFragmentMultiSelectField
    ...ContentIdeaFieldOptionFragmentSelectField
  }
}
    ${ContentIdeaFieldOptionFragmentMultiSelectFieldFragmentDoc}
${ContentIdeaFieldOptionFragmentSelectFieldFragmentDoc}`;
export type UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationFn = Apollo.MutationFunction<UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>;

/**
 * __useUpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, { data, loading, error }] = useUpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>(UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersDocument, options);
      }
export type UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationHookResult = ReturnType<typeof useUpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation>;
export type UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationResult = Apollo.MutationResult<UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation>;
export type UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutation, UpdateContentIdeaFieldOptionForContentIdeaFieldOptionHandlersMutationVariables>;
export const CreateContentIdeaFieldForContentIdeaDetailViewDocument = gql`
    mutation CreateContentIdeaFieldForContentIdeaDetailView($data: CreateContentIdeaFieldInput!) {
  createContentIdeaField(data: $data) {
    id
    ...ContentIdeaFieldFragmentContentIdeaFieldName
  }
}
    ${ContentIdeaFieldFragmentContentIdeaFieldNameFragmentDoc}`;
export type CreateContentIdeaFieldForContentIdeaDetailViewMutationFn = Apollo.MutationFunction<CreateContentIdeaFieldForContentIdeaDetailViewMutation, CreateContentIdeaFieldForContentIdeaDetailViewMutationVariables>;

/**
 * __useCreateContentIdeaFieldForContentIdeaDetailViewMutation__
 *
 * To run a mutation, you first call `useCreateContentIdeaFieldForContentIdeaDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentIdeaFieldForContentIdeaDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentIdeaFieldForContentIdeaDetailViewMutation, { data, loading, error }] = useCreateContentIdeaFieldForContentIdeaDetailViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentIdeaFieldForContentIdeaDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentIdeaFieldForContentIdeaDetailViewMutation, CreateContentIdeaFieldForContentIdeaDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentIdeaFieldForContentIdeaDetailViewMutation, CreateContentIdeaFieldForContentIdeaDetailViewMutationVariables>(CreateContentIdeaFieldForContentIdeaDetailViewDocument, options);
      }
export type CreateContentIdeaFieldForContentIdeaDetailViewMutationHookResult = ReturnType<typeof useCreateContentIdeaFieldForContentIdeaDetailViewMutation>;
export type CreateContentIdeaFieldForContentIdeaDetailViewMutationResult = Apollo.MutationResult<CreateContentIdeaFieldForContentIdeaDetailViewMutation>;
export type CreateContentIdeaFieldForContentIdeaDetailViewMutationOptions = Apollo.BaseMutationOptions<CreateContentIdeaFieldForContentIdeaDetailViewMutation, CreateContentIdeaFieldForContentIdeaDetailViewMutationVariables>;
export const GetCollectionForContentIdeaDetailViewDocument = gql`
    query GetCollectionForContentIdeaDetailView($id: String!) {
  collection(id: $id) {
    id
    ...CollectionFragmentCollectionField
  }
}
    ${CollectionFragmentCollectionFieldFragmentDoc}`;

/**
 * __useGetCollectionForContentIdeaDetailViewQuery__
 *
 * To run a query within a React component, call `useGetCollectionForContentIdeaDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForContentIdeaDetailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForContentIdeaDetailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionForContentIdeaDetailViewQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForContentIdeaDetailViewQuery, GetCollectionForContentIdeaDetailViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForContentIdeaDetailViewQuery, GetCollectionForContentIdeaDetailViewQueryVariables>(GetCollectionForContentIdeaDetailViewDocument, options);
      }
export function useGetCollectionForContentIdeaDetailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForContentIdeaDetailViewQuery, GetCollectionForContentIdeaDetailViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForContentIdeaDetailViewQuery, GetCollectionForContentIdeaDetailViewQueryVariables>(GetCollectionForContentIdeaDetailViewDocument, options);
        }
export type GetCollectionForContentIdeaDetailViewQueryHookResult = ReturnType<typeof useGetCollectionForContentIdeaDetailViewQuery>;
export type GetCollectionForContentIdeaDetailViewLazyQueryHookResult = ReturnType<typeof useGetCollectionForContentIdeaDetailViewLazyQuery>;
export type GetCollectionForContentIdeaDetailViewQueryResult = Apollo.QueryResult<GetCollectionForContentIdeaDetailViewQuery, GetCollectionForContentIdeaDetailViewQueryVariables>;
export const UpdateContentIdeaFieldForContentIdeaDetailViewDocument = gql`
    mutation UpdateContentIdeaFieldForContentIdeaDetailView($data: UpdateContentIdeaFieldInput!) {
  updateContentIdeaField(data: $data) {
    id
    ...ContentIdeaFieldFragmentContentIdeaDetailView
  }
}
    ${ContentIdeaFieldFragmentContentIdeaDetailViewFragmentDoc}`;
export type UpdateContentIdeaFieldForContentIdeaDetailViewMutationFn = Apollo.MutationFunction<UpdateContentIdeaFieldForContentIdeaDetailViewMutation, UpdateContentIdeaFieldForContentIdeaDetailViewMutationVariables>;

/**
 * __useUpdateContentIdeaFieldForContentIdeaDetailViewMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaFieldForContentIdeaDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaFieldForContentIdeaDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaFieldForContentIdeaDetailViewMutation, { data, loading, error }] = useUpdateContentIdeaFieldForContentIdeaDetailViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaFieldForContentIdeaDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaFieldForContentIdeaDetailViewMutation, UpdateContentIdeaFieldForContentIdeaDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaFieldForContentIdeaDetailViewMutation, UpdateContentIdeaFieldForContentIdeaDetailViewMutationVariables>(UpdateContentIdeaFieldForContentIdeaDetailViewDocument, options);
      }
export type UpdateContentIdeaFieldForContentIdeaDetailViewMutationHookResult = ReturnType<typeof useUpdateContentIdeaFieldForContentIdeaDetailViewMutation>;
export type UpdateContentIdeaFieldForContentIdeaDetailViewMutationResult = Apollo.MutationResult<UpdateContentIdeaFieldForContentIdeaDetailViewMutation>;
export type UpdateContentIdeaFieldForContentIdeaDetailViewMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaFieldForContentIdeaDetailViewMutation, UpdateContentIdeaFieldForContentIdeaDetailViewMutationVariables>;
export const GetContentIdeasForContentIdeaTableViewDocument = gql`
    query GetContentIdeasForContentIdeaTableView($filters: ContentIdeaFilters!, $sortBy: SortByInputData, $before: String, $after: String, $skip: Int, $take: Int) {
  contentIdeas(
    filters: $filters
    sortBy: $sortBy
    before: $before
    after: $after
    skip: $skip
    take: $take
  ) {
    data {
      id
      ...ContentIdeaFragmentContentIdeaTableView
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ContentIdeaFragmentContentIdeaTableViewFragmentDoc}`;

/**
 * __useGetContentIdeasForContentIdeaTableViewQuery__
 *
 * To run a query within a React component, call `useGetContentIdeasForContentIdeaTableViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeasForContentIdeaTableViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeasForContentIdeaTableViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetContentIdeasForContentIdeaTableViewQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeasForContentIdeaTableViewQuery, GetContentIdeasForContentIdeaTableViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeasForContentIdeaTableViewQuery, GetContentIdeasForContentIdeaTableViewQueryVariables>(GetContentIdeasForContentIdeaTableViewDocument, options);
      }
export function useGetContentIdeasForContentIdeaTableViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeasForContentIdeaTableViewQuery, GetContentIdeasForContentIdeaTableViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeasForContentIdeaTableViewQuery, GetContentIdeasForContentIdeaTableViewQueryVariables>(GetContentIdeasForContentIdeaTableViewDocument, options);
        }
export type GetContentIdeasForContentIdeaTableViewQueryHookResult = ReturnType<typeof useGetContentIdeasForContentIdeaTableViewQuery>;
export type GetContentIdeasForContentIdeaTableViewLazyQueryHookResult = ReturnType<typeof useGetContentIdeasForContentIdeaTableViewLazyQuery>;
export type GetContentIdeasForContentIdeaTableViewQueryResult = Apollo.QueryResult<GetContentIdeasForContentIdeaTableViewQuery, GetContentIdeasForContentIdeaTableViewQueryVariables>;
export const CreateContentIdeaForContentIdeaTableViewDocument = gql`
    mutation CreateContentIdeaForContentIdeaTableView($data: CreateContentIdeaInput!) {
  createContentIdea(data: $data) {
    id
    ...ContentIdeaFragmentContentIdeaTableView
  }
}
    ${ContentIdeaFragmentContentIdeaTableViewFragmentDoc}`;
export type CreateContentIdeaForContentIdeaTableViewMutationFn = Apollo.MutationFunction<CreateContentIdeaForContentIdeaTableViewMutation, CreateContentIdeaForContentIdeaTableViewMutationVariables>;

/**
 * __useCreateContentIdeaForContentIdeaTableViewMutation__
 *
 * To run a mutation, you first call `useCreateContentIdeaForContentIdeaTableViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentIdeaForContentIdeaTableViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentIdeaForContentIdeaTableViewMutation, { data, loading, error }] = useCreateContentIdeaForContentIdeaTableViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentIdeaForContentIdeaTableViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentIdeaForContentIdeaTableViewMutation, CreateContentIdeaForContentIdeaTableViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentIdeaForContentIdeaTableViewMutation, CreateContentIdeaForContentIdeaTableViewMutationVariables>(CreateContentIdeaForContentIdeaTableViewDocument, options);
      }
export type CreateContentIdeaForContentIdeaTableViewMutationHookResult = ReturnType<typeof useCreateContentIdeaForContentIdeaTableViewMutation>;
export type CreateContentIdeaForContentIdeaTableViewMutationResult = Apollo.MutationResult<CreateContentIdeaForContentIdeaTableViewMutation>;
export type CreateContentIdeaForContentIdeaTableViewMutationOptions = Apollo.BaseMutationOptions<CreateContentIdeaForContentIdeaTableViewMutation, CreateContentIdeaForContentIdeaTableViewMutationVariables>;
export const GetCollectionByIdsForDndCollectionDragPreviewDocument = gql`
    query GetCollectionByIdsForDndCollectionDragPreview($input: GetCollectionByIdsInput!) {
  collectionByIds(input: $input) {
    id
    ...CollectionFragmentCollectionCardView
  }
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;

/**
 * __useGetCollectionByIdsForDndCollectionDragPreviewQuery__
 *
 * To run a query within a React component, call `useGetCollectionByIdsForDndCollectionDragPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionByIdsForDndCollectionDragPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionByIdsForDndCollectionDragPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCollectionByIdsForDndCollectionDragPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionByIdsForDndCollectionDragPreviewQuery, GetCollectionByIdsForDndCollectionDragPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionByIdsForDndCollectionDragPreviewQuery, GetCollectionByIdsForDndCollectionDragPreviewQueryVariables>(GetCollectionByIdsForDndCollectionDragPreviewDocument, options);
      }
export function useGetCollectionByIdsForDndCollectionDragPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionByIdsForDndCollectionDragPreviewQuery, GetCollectionByIdsForDndCollectionDragPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionByIdsForDndCollectionDragPreviewQuery, GetCollectionByIdsForDndCollectionDragPreviewQueryVariables>(GetCollectionByIdsForDndCollectionDragPreviewDocument, options);
        }
export type GetCollectionByIdsForDndCollectionDragPreviewQueryHookResult = ReturnType<typeof useGetCollectionByIdsForDndCollectionDragPreviewQuery>;
export type GetCollectionByIdsForDndCollectionDragPreviewLazyQueryHookResult = ReturnType<typeof useGetCollectionByIdsForDndCollectionDragPreviewLazyQuery>;
export type GetCollectionByIdsForDndCollectionDragPreviewQueryResult = Apollo.QueryResult<GetCollectionByIdsForDndCollectionDragPreviewQuery, GetCollectionByIdsForDndCollectionDragPreviewQueryVariables>;
export const GetPostByIdsForDndPostDragPreviewDocument = gql`
    query GetPostByIdsForDndPostDragPreview($input: GetPostByIdsInput!) {
  postByIds(input: $input) {
    id
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetPostByIdsForDndPostDragPreviewQuery__
 *
 * To run a query within a React component, call `useGetPostByIdsForDndPostDragPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdsForDndPostDragPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdsForDndPostDragPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostByIdsForDndPostDragPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetPostByIdsForDndPostDragPreviewQuery, GetPostByIdsForDndPostDragPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostByIdsForDndPostDragPreviewQuery, GetPostByIdsForDndPostDragPreviewQueryVariables>(GetPostByIdsForDndPostDragPreviewDocument, options);
      }
export function useGetPostByIdsForDndPostDragPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostByIdsForDndPostDragPreviewQuery, GetPostByIdsForDndPostDragPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostByIdsForDndPostDragPreviewQuery, GetPostByIdsForDndPostDragPreviewQueryVariables>(GetPostByIdsForDndPostDragPreviewDocument, options);
        }
export type GetPostByIdsForDndPostDragPreviewQueryHookResult = ReturnType<typeof useGetPostByIdsForDndPostDragPreviewQuery>;
export type GetPostByIdsForDndPostDragPreviewLazyQueryHookResult = ReturnType<typeof useGetPostByIdsForDndPostDragPreviewLazyQuery>;
export type GetPostByIdsForDndPostDragPreviewQueryResult = Apollo.QueryResult<GetPostByIdsForDndPostDragPreviewQuery, GetPostByIdsForDndPostDragPreviewQueryVariables>;
export const ConsumeShareLinkForUseInvitationThroughLinkDocument = gql`
    mutation ConsumeShareLinkForUseInvitationThroughLink($data: ConsumeShareLinkInput!) {
  consumeShareLink(data: $data) {
    success
    message
  }
}
    `;
export type ConsumeShareLinkForUseInvitationThroughLinkMutationFn = Apollo.MutationFunction<ConsumeShareLinkForUseInvitationThroughLinkMutation, ConsumeShareLinkForUseInvitationThroughLinkMutationVariables>;

/**
 * __useConsumeShareLinkForUseInvitationThroughLinkMutation__
 *
 * To run a mutation, you first call `useConsumeShareLinkForUseInvitationThroughLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeShareLinkForUseInvitationThroughLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeShareLinkForUseInvitationThroughLinkMutation, { data, loading, error }] = useConsumeShareLinkForUseInvitationThroughLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConsumeShareLinkForUseInvitationThroughLinkMutation(baseOptions?: Apollo.MutationHookOptions<ConsumeShareLinkForUseInvitationThroughLinkMutation, ConsumeShareLinkForUseInvitationThroughLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumeShareLinkForUseInvitationThroughLinkMutation, ConsumeShareLinkForUseInvitationThroughLinkMutationVariables>(ConsumeShareLinkForUseInvitationThroughLinkDocument, options);
      }
export type ConsumeShareLinkForUseInvitationThroughLinkMutationHookResult = ReturnType<typeof useConsumeShareLinkForUseInvitationThroughLinkMutation>;
export type ConsumeShareLinkForUseInvitationThroughLinkMutationResult = Apollo.MutationResult<ConsumeShareLinkForUseInvitationThroughLinkMutation>;
export type ConsumeShareLinkForUseInvitationThroughLinkMutationOptions = Apollo.BaseMutationOptions<ConsumeShareLinkForUseInvitationThroughLinkMutation, ConsumeShareLinkForUseInvitationThroughLinkMutationVariables>;
export const GetCollectionForInvitationThroughLinkInvitedToCollectionViewDocument = gql`
    query GetCollectionForInvitationThroughLinkInvitedToCollectionView($id: String!) {
  collection(id: $id) {
    id
    name
    totalPosts
    creator {
      id
      ...UserFragmentAvatarGroup
    }
    inviteMembers {
      id
      user {
        id
        ...UserFragmentAvatarGroup
      }
      createdByUser {
        id
        ...UserFragmentAvatarGroup
      }
    }
    ...CollectionFragmentCollectionMultiPostPreview
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}
${CollectionFragmentCollectionMultiPostPreviewFragmentDoc}`;

/**
 * __useGetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery__
 *
 * To run a query within a React component, call `useGetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery, GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery, GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryVariables>(GetCollectionForInvitationThroughLinkInvitedToCollectionViewDocument, options);
      }
export function useGetCollectionForInvitationThroughLinkInvitedToCollectionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery, GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery, GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryVariables>(GetCollectionForInvitationThroughLinkInvitedToCollectionViewDocument, options);
        }
export type GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryHookResult = ReturnType<typeof useGetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery>;
export type GetCollectionForInvitationThroughLinkInvitedToCollectionViewLazyQueryHookResult = ReturnType<typeof useGetCollectionForInvitationThroughLinkInvitedToCollectionViewLazyQuery>;
export type GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryResult = Apollo.QueryResult<GetCollectionForInvitationThroughLinkInvitedToCollectionViewQuery, GetCollectionForInvitationThroughLinkInvitedToCollectionViewQueryVariables>;
export const UpdateUserOnboardingStateForJuiceboxIntroPopupDocument = gql`
    mutation UpdateUserOnboardingStateForJuiceboxIntroPopup($data: UpdateUserOnboardingStateInput!) {
  updateUserOnboardingState(data: $data) {
    id
    onboardingState {
      haveSeenJuiceBoxIntro
      haveClickedJuiceBoxBtn
    }
  }
}
    `;
export type UpdateUserOnboardingStateForJuiceboxIntroPopupMutationFn = Apollo.MutationFunction<UpdateUserOnboardingStateForJuiceboxIntroPopupMutation, UpdateUserOnboardingStateForJuiceboxIntroPopupMutationVariables>;

/**
 * __useUpdateUserOnboardingStateForJuiceboxIntroPopupMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingStateForJuiceboxIntroPopupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingStateForJuiceboxIntroPopupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingStateForJuiceboxIntroPopupMutation, { data, loading, error }] = useUpdateUserOnboardingStateForJuiceboxIntroPopupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOnboardingStateForJuiceboxIntroPopupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingStateForJuiceboxIntroPopupMutation, UpdateUserOnboardingStateForJuiceboxIntroPopupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingStateForJuiceboxIntroPopupMutation, UpdateUserOnboardingStateForJuiceboxIntroPopupMutationVariables>(UpdateUserOnboardingStateForJuiceboxIntroPopupDocument, options);
      }
export type UpdateUserOnboardingStateForJuiceboxIntroPopupMutationHookResult = ReturnType<typeof useUpdateUserOnboardingStateForJuiceboxIntroPopupMutation>;
export type UpdateUserOnboardingStateForJuiceboxIntroPopupMutationResult = Apollo.MutationResult<UpdateUserOnboardingStateForJuiceboxIntroPopupMutation>;
export type UpdateUserOnboardingStateForJuiceboxIntroPopupMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingStateForJuiceboxIntroPopupMutation, UpdateUserOnboardingStateForJuiceboxIntroPopupMutationVariables>;
export const GetCollectionForJuiceboxPostLayoutDocument = gql`
    query GetCollectionForJuiceboxPostLayout($collectionId: String!) {
  collection(id: $collectionId) {
    id
    name
    myPermissions
    creator {
      ...UserFragmentAvatarGroup
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;

/**
 * __useGetCollectionForJuiceboxPostLayoutQuery__
 *
 * To run a query within a React component, call `useGetCollectionForJuiceboxPostLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForJuiceboxPostLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForJuiceboxPostLayoutQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForJuiceboxPostLayoutQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForJuiceboxPostLayoutQuery, GetCollectionForJuiceboxPostLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForJuiceboxPostLayoutQuery, GetCollectionForJuiceboxPostLayoutQueryVariables>(GetCollectionForJuiceboxPostLayoutDocument, options);
      }
export function useGetCollectionForJuiceboxPostLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForJuiceboxPostLayoutQuery, GetCollectionForJuiceboxPostLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForJuiceboxPostLayoutQuery, GetCollectionForJuiceboxPostLayoutQueryVariables>(GetCollectionForJuiceboxPostLayoutDocument, options);
        }
export type GetCollectionForJuiceboxPostLayoutQueryHookResult = ReturnType<typeof useGetCollectionForJuiceboxPostLayoutQuery>;
export type GetCollectionForJuiceboxPostLayoutLazyQueryHookResult = ReturnType<typeof useGetCollectionForJuiceboxPostLayoutLazyQuery>;
export type GetCollectionForJuiceboxPostLayoutQueryResult = Apollo.QueryResult<GetCollectionForJuiceboxPostLayoutQuery, GetCollectionForJuiceboxPostLayoutQueryVariables>;
export const GetAttachmentsForJuiceboxAttachmentSearchResultDocument = gql`
    query GetAttachmentsForJuiceboxAttachmentSearchResult($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    attachmentSearchResult {
      hits {
        item {
          ...PostFragmentJuiceboxAttachmentSearchItem
        }
      }
      totalCount
    }
    pageInfo {
      endCursor
    }
  }
}
    ${PostFragmentJuiceboxAttachmentSearchItemFragmentDoc}`;

/**
 * __useGetAttachmentsForJuiceboxAttachmentSearchResultQuery__
 *
 * To run a query within a React component, call `useGetAttachmentsForJuiceboxAttachmentSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentsForJuiceboxAttachmentSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentsForJuiceboxAttachmentSearchResultQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAttachmentsForJuiceboxAttachmentSearchResultQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentsForJuiceboxAttachmentSearchResultQuery, GetAttachmentsForJuiceboxAttachmentSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentsForJuiceboxAttachmentSearchResultQuery, GetAttachmentsForJuiceboxAttachmentSearchResultQueryVariables>(GetAttachmentsForJuiceboxAttachmentSearchResultDocument, options);
      }
export function useGetAttachmentsForJuiceboxAttachmentSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentsForJuiceboxAttachmentSearchResultQuery, GetAttachmentsForJuiceboxAttachmentSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentsForJuiceboxAttachmentSearchResultQuery, GetAttachmentsForJuiceboxAttachmentSearchResultQueryVariables>(GetAttachmentsForJuiceboxAttachmentSearchResultDocument, options);
        }
export type GetAttachmentsForJuiceboxAttachmentSearchResultQueryHookResult = ReturnType<typeof useGetAttachmentsForJuiceboxAttachmentSearchResultQuery>;
export type GetAttachmentsForJuiceboxAttachmentSearchResultLazyQueryHookResult = ReturnType<typeof useGetAttachmentsForJuiceboxAttachmentSearchResultLazyQuery>;
export type GetAttachmentsForJuiceboxAttachmentSearchResultQueryResult = Apollo.QueryResult<GetAttachmentsForJuiceboxAttachmentSearchResultQuery, GetAttachmentsForJuiceboxAttachmentSearchResultQueryVariables>;
export const GetCollectionsForJuiceboxCollectionSearchResultDocument = gql`
    query GetCollectionsForJuiceboxCollectionSearchResult($data: UniversalSearchInput!, $postCount: Int, $previewableFirst: Boolean) {
  universalSearch(data: $data) {
    collectionSearchResult {
      totalCount
      hits {
        item {
          ...CollectionFragmentJuiceboxCollectionSearchItem
          posts(postCount: $postCount, previewableFirst: $previewableFirst) {
            ...PostFragmentPostPreview
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${CollectionFragmentJuiceboxCollectionSearchItemFragmentDoc}
${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetCollectionsForJuiceboxCollectionSearchResultQuery__
 *
 * To run a query within a React component, call `useGetCollectionsForJuiceboxCollectionSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsForJuiceboxCollectionSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsForJuiceboxCollectionSearchResultQuery({
 *   variables: {
 *      data: // value for 'data'
 *      postCount: // value for 'postCount'
 *      previewableFirst: // value for 'previewableFirst'
 *   },
 * });
 */
export function useGetCollectionsForJuiceboxCollectionSearchResultQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsForJuiceboxCollectionSearchResultQuery, GetCollectionsForJuiceboxCollectionSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsForJuiceboxCollectionSearchResultQuery, GetCollectionsForJuiceboxCollectionSearchResultQueryVariables>(GetCollectionsForJuiceboxCollectionSearchResultDocument, options);
      }
export function useGetCollectionsForJuiceboxCollectionSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsForJuiceboxCollectionSearchResultQuery, GetCollectionsForJuiceboxCollectionSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsForJuiceboxCollectionSearchResultQuery, GetCollectionsForJuiceboxCollectionSearchResultQueryVariables>(GetCollectionsForJuiceboxCollectionSearchResultDocument, options);
        }
export type GetCollectionsForJuiceboxCollectionSearchResultQueryHookResult = ReturnType<typeof useGetCollectionsForJuiceboxCollectionSearchResultQuery>;
export type GetCollectionsForJuiceboxCollectionSearchResultLazyQueryHookResult = ReturnType<typeof useGetCollectionsForJuiceboxCollectionSearchResultLazyQuery>;
export type GetCollectionsForJuiceboxCollectionSearchResultQueryResult = Apollo.QueryResult<GetCollectionsForJuiceboxCollectionSearchResultQuery, GetCollectionsForJuiceboxCollectionSearchResultQueryVariables>;
export const GetLinksForJuiceboxLinkSearchResultDocument = gql`
    query GetLinksForJuiceboxLinkSearchResult($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    linkSearchResult {
      hits {
        item {
          ...PostFragmentJuiceboxLinkSearchItem
        }
      }
      totalCount
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PostFragmentJuiceboxLinkSearchItemFragmentDoc}`;

/**
 * __useGetLinksForJuiceboxLinkSearchResultQuery__
 *
 * To run a query within a React component, call `useGetLinksForJuiceboxLinkSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinksForJuiceboxLinkSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinksForJuiceboxLinkSearchResultQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetLinksForJuiceboxLinkSearchResultQuery(baseOptions: Apollo.QueryHookOptions<GetLinksForJuiceboxLinkSearchResultQuery, GetLinksForJuiceboxLinkSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinksForJuiceboxLinkSearchResultQuery, GetLinksForJuiceboxLinkSearchResultQueryVariables>(GetLinksForJuiceboxLinkSearchResultDocument, options);
      }
export function useGetLinksForJuiceboxLinkSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinksForJuiceboxLinkSearchResultQuery, GetLinksForJuiceboxLinkSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinksForJuiceboxLinkSearchResultQuery, GetLinksForJuiceboxLinkSearchResultQueryVariables>(GetLinksForJuiceboxLinkSearchResultDocument, options);
        }
export type GetLinksForJuiceboxLinkSearchResultQueryHookResult = ReturnType<typeof useGetLinksForJuiceboxLinkSearchResultQuery>;
export type GetLinksForJuiceboxLinkSearchResultLazyQueryHookResult = ReturnType<typeof useGetLinksForJuiceboxLinkSearchResultLazyQuery>;
export type GetLinksForJuiceboxLinkSearchResultQueryResult = Apollo.QueryResult<GetLinksForJuiceboxLinkSearchResultQuery, GetLinksForJuiceboxLinkSearchResultQueryVariables>;
export const GetNotesForJuiceboxLinkSearchResultDocument = gql`
    query GetNotesForJuiceboxLinkSearchResult($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    noteSearchResult {
      hits {
        item {
          ...PostFragmentJuiceboxNoteSearchItem
        }
      }
      totalCount
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PostFragmentJuiceboxNoteSearchItemFragmentDoc}`;

/**
 * __useGetNotesForJuiceboxLinkSearchResultQuery__
 *
 * To run a query within a React component, call `useGetNotesForJuiceboxLinkSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForJuiceboxLinkSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForJuiceboxLinkSearchResultQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetNotesForJuiceboxLinkSearchResultQuery(baseOptions: Apollo.QueryHookOptions<GetNotesForJuiceboxLinkSearchResultQuery, GetNotesForJuiceboxLinkSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesForJuiceboxLinkSearchResultQuery, GetNotesForJuiceboxLinkSearchResultQueryVariables>(GetNotesForJuiceboxLinkSearchResultDocument, options);
      }
export function useGetNotesForJuiceboxLinkSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesForJuiceboxLinkSearchResultQuery, GetNotesForJuiceboxLinkSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesForJuiceboxLinkSearchResultQuery, GetNotesForJuiceboxLinkSearchResultQueryVariables>(GetNotesForJuiceboxLinkSearchResultDocument, options);
        }
export type GetNotesForJuiceboxLinkSearchResultQueryHookResult = ReturnType<typeof useGetNotesForJuiceboxLinkSearchResultQuery>;
export type GetNotesForJuiceboxLinkSearchResultLazyQueryHookResult = ReturnType<typeof useGetNotesForJuiceboxLinkSearchResultLazyQuery>;
export type GetNotesForJuiceboxLinkSearchResultQueryResult = Apollo.QueryResult<GetNotesForJuiceboxLinkSearchResultQuery, GetNotesForJuiceboxLinkSearchResultQueryVariables>;
export const GetRecentSearchQueriesForJuiceboxRecentSearchResultDocument = gql`
    query GetRecentSearchQueriesForJuiceboxRecentSearchResult($take: Int, $after: String) {
  getRecentSearchQueries(take: $take, after: $after) {
    data {
      query
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetRecentSearchQueriesForJuiceboxRecentSearchResultQuery__
 *
 * To run a query within a React component, call `useGetRecentSearchQueriesForJuiceboxRecentSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentSearchQueriesForJuiceboxRecentSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentSearchQueriesForJuiceboxRecentSearchResultQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetRecentSearchQueriesForJuiceboxRecentSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentSearchQueriesForJuiceboxRecentSearchResultQuery, GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentSearchQueriesForJuiceboxRecentSearchResultQuery, GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryVariables>(GetRecentSearchQueriesForJuiceboxRecentSearchResultDocument, options);
      }
export function useGetRecentSearchQueriesForJuiceboxRecentSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentSearchQueriesForJuiceboxRecentSearchResultQuery, GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentSearchQueriesForJuiceboxRecentSearchResultQuery, GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryVariables>(GetRecentSearchQueriesForJuiceboxRecentSearchResultDocument, options);
        }
export type GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryHookResult = ReturnType<typeof useGetRecentSearchQueriesForJuiceboxRecentSearchResultQuery>;
export type GetRecentSearchQueriesForJuiceboxRecentSearchResultLazyQueryHookResult = ReturnType<typeof useGetRecentSearchQueriesForJuiceboxRecentSearchResultLazyQuery>;
export type GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryResult = Apollo.QueryResult<GetRecentSearchQueriesForJuiceboxRecentSearchResultQuery, GetRecentSearchQueriesForJuiceboxRecentSearchResultQueryVariables>;
export const GetRecentlyOpenedQueriesForJuiceboxSearchResultDocument = gql`
    query GetRecentlyOpenedQueriesForJuiceboxSearchResult($searchableEntityTypes: [SearchableEntityType!]!, $take: Int, $after: String, $postCount: Int, $previewableFirst: Boolean) {
  getSearchesClicked(
    searchableEntityTypes: $searchableEntityTypes
    take: $take
    after: $after
  ) {
    data {
      collection {
        ...CollectionFragmentJuiceboxCollectionSearchItem
        posts(postCount: $postCount, previewableFirst: $previewableFirst) {
          ...PostFragmentPostPreview
        }
      }
      post {
        ...PostFragmentJuiceboxNoteSearchItem
        ...PostFragmentJuiceboxAttachmentSearchItem
        ...PostFragmentJuiceboxLinkSearchItem
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionFragmentJuiceboxCollectionSearchItemFragmentDoc}
${PostFragmentPostPreviewFragmentDoc}
${PostFragmentJuiceboxNoteSearchItemFragmentDoc}
${PostFragmentJuiceboxAttachmentSearchItemFragmentDoc}
${PostFragmentJuiceboxLinkSearchItemFragmentDoc}`;

/**
 * __useGetRecentlyOpenedQueriesForJuiceboxSearchResultQuery__
 *
 * To run a query within a React component, call `useGetRecentlyOpenedQueriesForJuiceboxSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentlyOpenedQueriesForJuiceboxSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentlyOpenedQueriesForJuiceboxSearchResultQuery({
 *   variables: {
 *      searchableEntityTypes: // value for 'searchableEntityTypes'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      postCount: // value for 'postCount'
 *      previewableFirst: // value for 'previewableFirst'
 *   },
 * });
 */
export function useGetRecentlyOpenedQueriesForJuiceboxSearchResultQuery(baseOptions: Apollo.QueryHookOptions<GetRecentlyOpenedQueriesForJuiceboxSearchResultQuery, GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentlyOpenedQueriesForJuiceboxSearchResultQuery, GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryVariables>(GetRecentlyOpenedQueriesForJuiceboxSearchResultDocument, options);
      }
export function useGetRecentlyOpenedQueriesForJuiceboxSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentlyOpenedQueriesForJuiceboxSearchResultQuery, GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentlyOpenedQueriesForJuiceboxSearchResultQuery, GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryVariables>(GetRecentlyOpenedQueriesForJuiceboxSearchResultDocument, options);
        }
export type GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryHookResult = ReturnType<typeof useGetRecentlyOpenedQueriesForJuiceboxSearchResultQuery>;
export type GetRecentlyOpenedQueriesForJuiceboxSearchResultLazyQueryHookResult = ReturnType<typeof useGetRecentlyOpenedQueriesForJuiceboxSearchResultLazyQuery>;
export type GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryResult = Apollo.QueryResult<GetRecentlyOpenedQueriesForJuiceboxSearchResultQuery, GetRecentlyOpenedQueriesForJuiceboxSearchResultQueryVariables>;
export const GetPostByIdsForJuiceboxSelectContextDocument = gql`
    query GetPostByIdsForJuiceboxSelectContext($input: GetPostByIdsInput!) {
  postByIds(input: $input) {
    ...PostFragmentJuiceboxSelectContext
  }
}
    ${PostFragmentJuiceboxSelectContextFragmentDoc}`;

/**
 * __useGetPostByIdsForJuiceboxSelectContextQuery__
 *
 * To run a query within a React component, call `useGetPostByIdsForJuiceboxSelectContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdsForJuiceboxSelectContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdsForJuiceboxSelectContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostByIdsForJuiceboxSelectContextQuery(baseOptions: Apollo.QueryHookOptions<GetPostByIdsForJuiceboxSelectContextQuery, GetPostByIdsForJuiceboxSelectContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostByIdsForJuiceboxSelectContextQuery, GetPostByIdsForJuiceboxSelectContextQueryVariables>(GetPostByIdsForJuiceboxSelectContextDocument, options);
      }
export function useGetPostByIdsForJuiceboxSelectContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostByIdsForJuiceboxSelectContextQuery, GetPostByIdsForJuiceboxSelectContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostByIdsForJuiceboxSelectContextQuery, GetPostByIdsForJuiceboxSelectContextQueryVariables>(GetPostByIdsForJuiceboxSelectContextDocument, options);
        }
export type GetPostByIdsForJuiceboxSelectContextQueryHookResult = ReturnType<typeof useGetPostByIdsForJuiceboxSelectContextQuery>;
export type GetPostByIdsForJuiceboxSelectContextLazyQueryHookResult = ReturnType<typeof useGetPostByIdsForJuiceboxSelectContextLazyQuery>;
export type GetPostByIdsForJuiceboxSelectContextQueryResult = Apollo.QueryResult<GetPostByIdsForJuiceboxSelectContextQuery, GetPostByIdsForJuiceboxSelectContextQueryVariables>;
export const GetCollectionByIdsForJuiceboxSelectContextDocument = gql`
    query GetCollectionByIdsForJuiceboxSelectContext($input: GetCollectionByIdsInput!) {
  collectionByIds(input: $input) {
    ...CollectionFragmentJuiceboxSelectContext
  }
}
    ${CollectionFragmentJuiceboxSelectContextFragmentDoc}`;

/**
 * __useGetCollectionByIdsForJuiceboxSelectContextQuery__
 *
 * To run a query within a React component, call `useGetCollectionByIdsForJuiceboxSelectContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionByIdsForJuiceboxSelectContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionByIdsForJuiceboxSelectContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCollectionByIdsForJuiceboxSelectContextQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionByIdsForJuiceboxSelectContextQuery, GetCollectionByIdsForJuiceboxSelectContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionByIdsForJuiceboxSelectContextQuery, GetCollectionByIdsForJuiceboxSelectContextQueryVariables>(GetCollectionByIdsForJuiceboxSelectContextDocument, options);
      }
export function useGetCollectionByIdsForJuiceboxSelectContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionByIdsForJuiceboxSelectContextQuery, GetCollectionByIdsForJuiceboxSelectContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionByIdsForJuiceboxSelectContextQuery, GetCollectionByIdsForJuiceboxSelectContextQueryVariables>(GetCollectionByIdsForJuiceboxSelectContextDocument, options);
        }
export type GetCollectionByIdsForJuiceboxSelectContextQueryHookResult = ReturnType<typeof useGetCollectionByIdsForJuiceboxSelectContextQuery>;
export type GetCollectionByIdsForJuiceboxSelectContextLazyQueryHookResult = ReturnType<typeof useGetCollectionByIdsForJuiceboxSelectContextLazyQuery>;
export type GetCollectionByIdsForJuiceboxSelectContextQueryResult = Apollo.QueryResult<GetCollectionByIdsForJuiceboxSelectContextQuery, GetCollectionByIdsForJuiceboxSelectContextQueryVariables>;
export const GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterDocument = gql`
    query GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilter($filters: CollectionFilters!, $take: Int, $sortType: SortType, $after: String) {
  collectionsSmartSearch(
    filters: $filters
    take: $take
    sortType: $sortType
    after: $after
  ) {
    data {
      item {
        ...CollectionFragmentJuiceboxCollectionSelectButtonFilter
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionFragmentJuiceboxCollectionSelectButtonFilterFragmentDoc}`;

/**
 * __useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery__
 *
 * To run a query within a React component, call `useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      sortType: // value for 'sortType'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery, GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery, GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryVariables>(GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterDocument, options);
      }
export function useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery, GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery, GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryVariables>(GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterDocument, options);
        }
export type GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery>;
export type GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterLazyQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterLazyQuery>;
export type GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryResult = Apollo.QueryResult<GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQuery, GetCollectionsSmartSearchForJuiceboxCollectionSelectButtonFilterQueryVariables>;
export const DeletePostsForCollectionPostContextMenuDocument = gql`
    mutation DeletePostsForCollectionPostContextMenu($data: DeletePostsInput!) {
  deletePosts(data: $data) {
    message
    success
  }
}
    `;
export type DeletePostsForCollectionPostContextMenuMutationFn = Apollo.MutationFunction<DeletePostsForCollectionPostContextMenuMutation, DeletePostsForCollectionPostContextMenuMutationVariables>;

/**
 * __useDeletePostsForCollectionPostContextMenuMutation__
 *
 * To run a mutation, you first call `useDeletePostsForCollectionPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostsForCollectionPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostsForCollectionPostContextMenuMutation, { data, loading, error }] = useDeletePostsForCollectionPostContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePostsForCollectionPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostsForCollectionPostContextMenuMutation, DeletePostsForCollectionPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostsForCollectionPostContextMenuMutation, DeletePostsForCollectionPostContextMenuMutationVariables>(DeletePostsForCollectionPostContextMenuDocument, options);
      }
export type DeletePostsForCollectionPostContextMenuMutationHookResult = ReturnType<typeof useDeletePostsForCollectionPostContextMenuMutation>;
export type DeletePostsForCollectionPostContextMenuMutationResult = Apollo.MutationResult<DeletePostsForCollectionPostContextMenuMutation>;
export type DeletePostsForCollectionPostContextMenuMutationOptions = Apollo.BaseMutationOptions<DeletePostsForCollectionPostContextMenuMutation, DeletePostsForCollectionPostContextMenuMutationVariables>;
export const DeleteCollectionsForCollectionPostContextMenuDocument = gql`
    mutation DeleteCollectionsForCollectionPostContextMenu($data: DeleteCollectionsInput!) {
  deleteCollections(data: $data) {
    message
    success
  }
}
    `;
export type DeleteCollectionsForCollectionPostContextMenuMutationFn = Apollo.MutationFunction<DeleteCollectionsForCollectionPostContextMenuMutation, DeleteCollectionsForCollectionPostContextMenuMutationVariables>;

/**
 * __useDeleteCollectionsForCollectionPostContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionsForCollectionPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionsForCollectionPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionsForCollectionPostContextMenuMutation, { data, loading, error }] = useDeleteCollectionsForCollectionPostContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCollectionsForCollectionPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollectionsForCollectionPostContextMenuMutation, DeleteCollectionsForCollectionPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollectionsForCollectionPostContextMenuMutation, DeleteCollectionsForCollectionPostContextMenuMutationVariables>(DeleteCollectionsForCollectionPostContextMenuDocument, options);
      }
export type DeleteCollectionsForCollectionPostContextMenuMutationHookResult = ReturnType<typeof useDeleteCollectionsForCollectionPostContextMenuMutation>;
export type DeleteCollectionsForCollectionPostContextMenuMutationResult = Apollo.MutationResult<DeleteCollectionsForCollectionPostContextMenuMutation>;
export type DeleteCollectionsForCollectionPostContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteCollectionsForCollectionPostContextMenuMutation, DeleteCollectionsForCollectionPostContextMenuMutationVariables>;
export const AddPostsToCollectionForCollectionPostContextMenuDocument = gql`
    mutation AddPostsToCollectionForCollectionPostContextMenu($data: SavePostsToCollectionsInput!) {
  savePostsToCollections(data: $data) {
    message
    success
  }
}
    `;
export type AddPostsToCollectionForCollectionPostContextMenuMutationFn = Apollo.MutationFunction<AddPostsToCollectionForCollectionPostContextMenuMutation, AddPostsToCollectionForCollectionPostContextMenuMutationVariables>;

/**
 * __useAddPostsToCollectionForCollectionPostContextMenuMutation__
 *
 * To run a mutation, you first call `useAddPostsToCollectionForCollectionPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostsToCollectionForCollectionPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostsToCollectionForCollectionPostContextMenuMutation, { data, loading, error }] = useAddPostsToCollectionForCollectionPostContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPostsToCollectionForCollectionPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<AddPostsToCollectionForCollectionPostContextMenuMutation, AddPostsToCollectionForCollectionPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostsToCollectionForCollectionPostContextMenuMutation, AddPostsToCollectionForCollectionPostContextMenuMutationVariables>(AddPostsToCollectionForCollectionPostContextMenuDocument, options);
      }
export type AddPostsToCollectionForCollectionPostContextMenuMutationHookResult = ReturnType<typeof useAddPostsToCollectionForCollectionPostContextMenuMutation>;
export type AddPostsToCollectionForCollectionPostContextMenuMutationResult = Apollo.MutationResult<AddPostsToCollectionForCollectionPostContextMenuMutation>;
export type AddPostsToCollectionForCollectionPostContextMenuMutationOptions = Apollo.BaseMutationOptions<AddPostsToCollectionForCollectionPostContextMenuMutation, AddPostsToCollectionForCollectionPostContextMenuMutationVariables>;
export const CreatePostsFavoriteForCollectionPostContextMenuDocument = gql`
    mutation CreatePostsFavoriteForCollectionPostContextMenu($data: CreatePostsFavoriteInput!) {
  createPostsFavorite(data: $data) {
    id
  }
}
    `;
export type CreatePostsFavoriteForCollectionPostContextMenuMutationFn = Apollo.MutationFunction<CreatePostsFavoriteForCollectionPostContextMenuMutation, CreatePostsFavoriteForCollectionPostContextMenuMutationVariables>;

/**
 * __useCreatePostsFavoriteForCollectionPostContextMenuMutation__
 *
 * To run a mutation, you first call `useCreatePostsFavoriteForCollectionPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostsFavoriteForCollectionPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostsFavoriteForCollectionPostContextMenuMutation, { data, loading, error }] = useCreatePostsFavoriteForCollectionPostContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostsFavoriteForCollectionPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostsFavoriteForCollectionPostContextMenuMutation, CreatePostsFavoriteForCollectionPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostsFavoriteForCollectionPostContextMenuMutation, CreatePostsFavoriteForCollectionPostContextMenuMutationVariables>(CreatePostsFavoriteForCollectionPostContextMenuDocument, options);
      }
export type CreatePostsFavoriteForCollectionPostContextMenuMutationHookResult = ReturnType<typeof useCreatePostsFavoriteForCollectionPostContextMenuMutation>;
export type CreatePostsFavoriteForCollectionPostContextMenuMutationResult = Apollo.MutationResult<CreatePostsFavoriteForCollectionPostContextMenuMutation>;
export type CreatePostsFavoriteForCollectionPostContextMenuMutationOptions = Apollo.BaseMutationOptions<CreatePostsFavoriteForCollectionPostContextMenuMutation, CreatePostsFavoriteForCollectionPostContextMenuMutationVariables>;
export const DeletePostsFavoriteForCollectionPostContextMenuDocument = gql`
    mutation DeletePostsFavoriteForCollectionPostContextMenu($data: DeletePostsFavoriteInput!) {
  deletePostsFavorite(data: $data) {
    success
    message
  }
}
    `;
export type DeletePostsFavoriteForCollectionPostContextMenuMutationFn = Apollo.MutationFunction<DeletePostsFavoriteForCollectionPostContextMenuMutation, DeletePostsFavoriteForCollectionPostContextMenuMutationVariables>;

/**
 * __useDeletePostsFavoriteForCollectionPostContextMenuMutation__
 *
 * To run a mutation, you first call `useDeletePostsFavoriteForCollectionPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostsFavoriteForCollectionPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostsFavoriteForCollectionPostContextMenuMutation, { data, loading, error }] = useDeletePostsFavoriteForCollectionPostContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePostsFavoriteForCollectionPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostsFavoriteForCollectionPostContextMenuMutation, DeletePostsFavoriteForCollectionPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostsFavoriteForCollectionPostContextMenuMutation, DeletePostsFavoriteForCollectionPostContextMenuMutationVariables>(DeletePostsFavoriteForCollectionPostContextMenuDocument, options);
      }
export type DeletePostsFavoriteForCollectionPostContextMenuMutationHookResult = ReturnType<typeof useDeletePostsFavoriteForCollectionPostContextMenuMutation>;
export type DeletePostsFavoriteForCollectionPostContextMenuMutationResult = Apollo.MutationResult<DeletePostsFavoriteForCollectionPostContextMenuMutation>;
export type DeletePostsFavoriteForCollectionPostContextMenuMutationOptions = Apollo.BaseMutationOptions<DeletePostsFavoriteForCollectionPostContextMenuMutation, DeletePostsFavoriteForCollectionPostContextMenuMutationVariables>;
export const MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalDocument = gql`
    mutation MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModal($data: MoveCollectionsToCollectionInput!) {
  moveCollectionsToCollection(data: $data) {
    success
    message
  }
}
    `;
export type MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationFn = Apollo.MutationFunction<MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>;

/**
 * __useMoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation__
 *
 * To run a mutation, you first call `useMoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, { data, loading, error }] = useMoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation(baseOptions?: Apollo.MutationHookOptions<MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>(MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalDocument, options);
      }
export type MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationHookResult = ReturnType<typeof useMoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation>;
export type MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationResult = Apollo.MutationResult<MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation>;
export type MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationOptions = Apollo.BaseMutationOptions<MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MoveCollectionsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>;
export const MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalDocument = gql`
    mutation MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModal($data: MovePostsToCollectionInput!) {
  movePostsToCollection(data: $data) {
    success
    message
  }
}
    `;
export type MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationFn = Apollo.MutationFunction<MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>;

/**
 * __useMovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation__
 *
 * To run a mutation, you first call `useMovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, { data, loading, error }] = useMovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation(baseOptions?: Apollo.MutationHookOptions<MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>(MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalDocument, options);
      }
export type MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationHookResult = ReturnType<typeof useMovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation>;
export type MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationResult = Apollo.MutationResult<MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation>;
export type MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationOptions = Apollo.BaseMutationOptions<MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseCollectionPostMoveToAnotherCollectionModalMutationVariables>;
export const IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostDocument = gql`
    query IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPost($data: IsCollectionsPermissionLessThanParentCollectionPermissionInput!) {
  isCollectionsPermissionLessThanParentCollectionPermission(data: $data)
}
    `;

/**
 * __useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery__
 *
 * To run a query within a React component, call `useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery(baseOptions: Apollo.QueryHookOptions<IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>(IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostDocument, options);
      }
export function useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>(IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostDocument, options);
        }
export type IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryHookResult = ReturnType<typeof useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery>;
export type IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostLazyQueryHookResult = ReturnType<typeof useIsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostLazyQuery>;
export type IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryResult = Apollo.QueryResult<IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsCollectionsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>;
export const IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostDocument = gql`
    query IsPostsPermissionLessThanParentCollectionPermissionForCollectionPost($data: IsPostsPermissionLessThanParentCollectionPermissionInput!) {
  isPostsPermissionLessThanParentCollectionPermission(data: $data)
}
    `;

/**
 * __useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery__
 *
 * To run a query within a React component, call `useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery(baseOptions: Apollo.QueryHookOptions<IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>(IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostDocument, options);
      }
export function useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>(IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostDocument, options);
        }
export type IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryHookResult = ReturnType<typeof useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery>;
export type IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostLazyQueryHookResult = ReturnType<typeof useIsPostsPermissionLessThanParentCollectionPermissionForCollectionPostLazyQuery>;
export type IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryResult = Apollo.QueryResult<IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQuery, IsPostsPermissionLessThanParentCollectionPermissionForCollectionPostQueryVariables>;
export const GetFiltersSearchForJuiceboxFilterSuggestionViewDocument = gql`
    query GetFiltersSearchForJuiceboxFilterSuggestionView($data: FilterSearchInput!) {
  filtersSearch(data: $data) {
    collections {
      id
      name
    }
    createdBy {
      ...UserFragmentAvatarGroup
    }
    sharedBy {
      ...UserFragmentAvatarGroup
    }
    type
    reaction
    dateModified
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;

/**
 * __useGetFiltersSearchForJuiceboxFilterSuggestionViewQuery__
 *
 * To run a query within a React component, call `useGetFiltersSearchForJuiceboxFilterSuggestionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltersSearchForJuiceboxFilterSuggestionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltersSearchForJuiceboxFilterSuggestionViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetFiltersSearchForJuiceboxFilterSuggestionViewQuery(baseOptions: Apollo.QueryHookOptions<GetFiltersSearchForJuiceboxFilterSuggestionViewQuery, GetFiltersSearchForJuiceboxFilterSuggestionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFiltersSearchForJuiceboxFilterSuggestionViewQuery, GetFiltersSearchForJuiceboxFilterSuggestionViewQueryVariables>(GetFiltersSearchForJuiceboxFilterSuggestionViewDocument, options);
      }
export function useGetFiltersSearchForJuiceboxFilterSuggestionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFiltersSearchForJuiceboxFilterSuggestionViewQuery, GetFiltersSearchForJuiceboxFilterSuggestionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFiltersSearchForJuiceboxFilterSuggestionViewQuery, GetFiltersSearchForJuiceboxFilterSuggestionViewQueryVariables>(GetFiltersSearchForJuiceboxFilterSuggestionViewDocument, options);
        }
export type GetFiltersSearchForJuiceboxFilterSuggestionViewQueryHookResult = ReturnType<typeof useGetFiltersSearchForJuiceboxFilterSuggestionViewQuery>;
export type GetFiltersSearchForJuiceboxFilterSuggestionViewLazyQueryHookResult = ReturnType<typeof useGetFiltersSearchForJuiceboxFilterSuggestionViewLazyQuery>;
export type GetFiltersSearchForJuiceboxFilterSuggestionViewQueryResult = Apollo.QueryResult<GetFiltersSearchForJuiceboxFilterSuggestionViewQuery, GetFiltersSearchForJuiceboxFilterSuggestionViewQueryVariables>;
export const GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewDocument = gql`
    query GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionView($searchableEntityTypes: [SearchableEntityType!]!, $take: Int, $postCount: Int, $previewableFirst: Boolean) {
  getSearchesClicked(searchableEntityTypes: $searchableEntityTypes, take: $take) {
    data {
      collection {
        ...CollectionFragmentJuiceboxCollectionSearchItem
        posts(postCount: $postCount, previewableFirst: $previewableFirst) {
          ...PostFragmentPostPreview
        }
      }
      post {
        ...PostFragmentJuiceboxNoteSearchItem
        ...PostFragmentJuiceboxAttachmentSearchItem
        ...PostFragmentJuiceboxLinkSearchItem
      }
    }
  }
}
    ${CollectionFragmentJuiceboxCollectionSearchItemFragmentDoc}
${PostFragmentPostPreviewFragmentDoc}
${PostFragmentJuiceboxNoteSearchItemFragmentDoc}
${PostFragmentJuiceboxAttachmentSearchItemFragmentDoc}
${PostFragmentJuiceboxLinkSearchItemFragmentDoc}`;

/**
 * __useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery__
 *
 * To run a query within a React component, call `useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery({
 *   variables: {
 *      searchableEntityTypes: // value for 'searchableEntityTypes'
 *      take: // value for 'take'
 *      postCount: // value for 'postCount'
 *      previewableFirst: // value for 'previewableFirst'
 *   },
 * });
 */
export function useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery(baseOptions: Apollo.QueryHookOptions<GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryVariables>(GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewDocument, options);
      }
export function useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryVariables>(GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewDocument, options);
        }
export type GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryHookResult = ReturnType<typeof useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery>;
export type GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewLazyQueryHookResult = ReturnType<typeof useGetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewLazyQuery>;
export type GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryResult = Apollo.QueryResult<GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentlyOpenedQueriesForJuiceboxFilterSuggestionViewQueryVariables>;
export const GetRecentSearchQueriesForJuiceboxFilterSuggestionViewDocument = gql`
    query GetRecentSearchQueriesForJuiceboxFilterSuggestionView($take: Int) {
  getRecentSearchQueries(take: $take) {
    data {
      query
    }
  }
}
    `;

/**
 * __useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery__
 *
 * To run a query within a React component, call `useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryVariables>(GetRecentSearchQueriesForJuiceboxFilterSuggestionViewDocument, options);
      }
export function useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryVariables>(GetRecentSearchQueriesForJuiceboxFilterSuggestionViewDocument, options);
        }
export type GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryHookResult = ReturnType<typeof useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery>;
export type GetRecentSearchQueriesForJuiceboxFilterSuggestionViewLazyQueryHookResult = ReturnType<typeof useGetRecentSearchQueriesForJuiceboxFilterSuggestionViewLazyQuery>;
export type GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryResult = Apollo.QueryResult<GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQuery, GetRecentSearchQueriesForJuiceboxFilterSuggestionViewQueryVariables>;
export const GetUniversalSearchForJuiceboxFilterSuggestionViewDocument = gql`
    query GetUniversalSearchForJuiceboxFilterSuggestionView($data: UniversalSearchInput!, $postCount: Int, $previewableFirst: Boolean) {
  universalSearch(data: $data) {
    noteSearchResult {
      hits {
        item {
          ...PostFragmentJuiceboxNoteSearchItem
        }
      }
      totalCount
    }
    linkSearchResult {
      hits {
        item {
          ...PostFragmentJuiceboxLinkSearchItem
        }
      }
      totalCount
    }
    collectionSearchResult {
      totalCount
      hits {
        item {
          ...CollectionFragmentJuiceboxCollectionSearchItem
          posts(postCount: $postCount, previewableFirst: $previewableFirst) {
            ...PostFragmentPostPreview
          }
        }
      }
    }
    attachmentSearchResult {
      hits {
        item {
          ...PostFragmentJuiceboxAttachmentSearchItem
        }
      }
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentJuiceboxNoteSearchItemFragmentDoc}
${PostFragmentJuiceboxLinkSearchItemFragmentDoc}
${CollectionFragmentJuiceboxCollectionSearchItemFragmentDoc}
${PostFragmentPostPreviewFragmentDoc}
${PostFragmentJuiceboxAttachmentSearchItemFragmentDoc}`;

/**
 * __useGetUniversalSearchForJuiceboxFilterSuggestionViewQuery__
 *
 * To run a query within a React component, call `useGetUniversalSearchForJuiceboxFilterSuggestionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversalSearchForJuiceboxFilterSuggestionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversalSearchForJuiceboxFilterSuggestionViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *      postCount: // value for 'postCount'
 *      previewableFirst: // value for 'previewableFirst'
 *   },
 * });
 */
export function useGetUniversalSearchForJuiceboxFilterSuggestionViewQuery(baseOptions: Apollo.QueryHookOptions<GetUniversalSearchForJuiceboxFilterSuggestionViewQuery, GetUniversalSearchForJuiceboxFilterSuggestionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniversalSearchForJuiceboxFilterSuggestionViewQuery, GetUniversalSearchForJuiceboxFilterSuggestionViewQueryVariables>(GetUniversalSearchForJuiceboxFilterSuggestionViewDocument, options);
      }
export function useGetUniversalSearchForJuiceboxFilterSuggestionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniversalSearchForJuiceboxFilterSuggestionViewQuery, GetUniversalSearchForJuiceboxFilterSuggestionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniversalSearchForJuiceboxFilterSuggestionViewQuery, GetUniversalSearchForJuiceboxFilterSuggestionViewQueryVariables>(GetUniversalSearchForJuiceboxFilterSuggestionViewDocument, options);
        }
export type GetUniversalSearchForJuiceboxFilterSuggestionViewQueryHookResult = ReturnType<typeof useGetUniversalSearchForJuiceboxFilterSuggestionViewQuery>;
export type GetUniversalSearchForJuiceboxFilterSuggestionViewLazyQueryHookResult = ReturnType<typeof useGetUniversalSearchForJuiceboxFilterSuggestionViewLazyQuery>;
export type GetUniversalSearchForJuiceboxFilterSuggestionViewQueryResult = Apollo.QueryResult<GetUniversalSearchForJuiceboxFilterSuggestionViewQuery, GetUniversalSearchForJuiceboxFilterSuggestionViewQueryVariables>;
export const CreateSearchHitForJuiceboxFilterSuggestionViewDocument = gql`
    mutation CreateSearchHitForJuiceboxFilterSuggestionView($data: SearchHitClickInput!) {
  createSearchClicked(data: $data) {
    query
  }
}
    `;
export type CreateSearchHitForJuiceboxFilterSuggestionViewMutationFn = Apollo.MutationFunction<CreateSearchHitForJuiceboxFilterSuggestionViewMutation, CreateSearchHitForJuiceboxFilterSuggestionViewMutationVariables>;

/**
 * __useCreateSearchHitForJuiceboxFilterSuggestionViewMutation__
 *
 * To run a mutation, you first call `useCreateSearchHitForJuiceboxFilterSuggestionViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSearchHitForJuiceboxFilterSuggestionViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSearchHitForJuiceboxFilterSuggestionViewMutation, { data, loading, error }] = useCreateSearchHitForJuiceboxFilterSuggestionViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSearchHitForJuiceboxFilterSuggestionViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateSearchHitForJuiceboxFilterSuggestionViewMutation, CreateSearchHitForJuiceboxFilterSuggestionViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSearchHitForJuiceboxFilterSuggestionViewMutation, CreateSearchHitForJuiceboxFilterSuggestionViewMutationVariables>(CreateSearchHitForJuiceboxFilterSuggestionViewDocument, options);
      }
export type CreateSearchHitForJuiceboxFilterSuggestionViewMutationHookResult = ReturnType<typeof useCreateSearchHitForJuiceboxFilterSuggestionViewMutation>;
export type CreateSearchHitForJuiceboxFilterSuggestionViewMutationResult = Apollo.MutationResult<CreateSearchHitForJuiceboxFilterSuggestionViewMutation>;
export type CreateSearchHitForJuiceboxFilterSuggestionViewMutationOptions = Apollo.BaseMutationOptions<CreateSearchHitForJuiceboxFilterSuggestionViewMutation, CreateSearchHitForJuiceboxFilterSuggestionViewMutationVariables>;
export const GetPostsSmartSearchForUseCustomCollectionNestedTableDataDocument = gql`
    query GetPostsSmartSearchForUseCustomCollectionNestedTableData($filters: PostFiltersForSmartSearch!, $take: Int, $after: String, $sortType: SortType) {
  postsSmartSearch(
    filters: $filters
    take: $take
    after: $after
    sortType: $sortType
  ) {
    data {
      item {
        id
        ...PostFragmentUseCustomCollectionNestedTableData
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentUseCustomCollectionNestedTableDataFragmentDoc}`;

/**
 * __useGetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery__
 *
 * To run a query within a React component, call `useGetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery(baseOptions: Apollo.QueryHookOptions<GetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery, GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery, GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryVariables>(GetPostsSmartSearchForUseCustomCollectionNestedTableDataDocument, options);
      }
export function useGetPostsSmartSearchForUseCustomCollectionNestedTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery, GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery, GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryVariables>(GetPostsSmartSearchForUseCustomCollectionNestedTableDataDocument, options);
        }
export type GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery>;
export type GetPostsSmartSearchForUseCustomCollectionNestedTableDataLazyQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForUseCustomCollectionNestedTableDataLazyQuery>;
export type GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryResult = Apollo.QueryResult<GetPostsSmartSearchForUseCustomCollectionNestedTableDataQuery, GetPostsSmartSearchForUseCustomCollectionNestedTableDataQueryVariables>;
export const GetContentIdeaCollectionsForCustomCollectionNestedTableDataDocument = gql`
    query GetContentIdeaCollectionsForCustomCollectionNestedTableData($after: String, $take: Int, $skip: Int, $sortBy: SortByInputData) {
  contentIdeaCollections(after: $after, take: $take, skip: $skip, sortBy: $sortBy) {
    data {
      ...CollectionFragmentUseCustomCollectionNestedTableData
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${CollectionFragmentUseCustomCollectionNestedTableDataFragmentDoc}`;

/**
 * __useGetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery({
 *   variables: {
 *      after: // value for 'after'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery, GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery, GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryVariables>(GetContentIdeaCollectionsForCustomCollectionNestedTableDataDocument, options);
      }
export function useGetContentIdeaCollectionsForCustomCollectionNestedTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery, GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery, GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryVariables>(GetContentIdeaCollectionsForCustomCollectionNestedTableDataDocument, options);
        }
export type GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryHookResult = ReturnType<typeof useGetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery>;
export type GetContentIdeaCollectionsForCustomCollectionNestedTableDataLazyQueryHookResult = ReturnType<typeof useGetContentIdeaCollectionsForCustomCollectionNestedTableDataLazyQuery>;
export type GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryResult = Apollo.QueryResult<GetContentIdeaCollectionsForCustomCollectionNestedTableDataQuery, GetContentIdeaCollectionsForCustomCollectionNestedTableDataQueryVariables>;
export const CollectionsSmartSearchForUseNormalCollectionNestedTableDataDocument = gql`
    query CollectionsSmartSearchForUseNormalCollectionNestedTableData($filters: CollectionFilters!, $after: String, $take: Int) {
  collectionsSmartSearch(filters: $filters, after: $after, take: $take) {
    meta {
      totalCount
    }
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
    data {
      type
      item {
        id
        ...CollectionFragmentUseNormalCollectionNestedTableData
      }
    }
  }
}
    ${CollectionFragmentUseNormalCollectionNestedTableDataFragmentDoc}`;

/**
 * __useCollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery__
 *
 * To run a query within a React component, call `useCollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery(baseOptions: Apollo.QueryHookOptions<CollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery, CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery, CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>(CollectionsSmartSearchForUseNormalCollectionNestedTableDataDocument, options);
      }
export function useCollectionsSmartSearchForUseNormalCollectionNestedTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery, CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery, CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>(CollectionsSmartSearchForUseNormalCollectionNestedTableDataDocument, options);
        }
export type CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryHookResult = ReturnType<typeof useCollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery>;
export type CollectionsSmartSearchForUseNormalCollectionNestedTableDataLazyQueryHookResult = ReturnType<typeof useCollectionsSmartSearchForUseNormalCollectionNestedTableDataLazyQuery>;
export type CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryResult = Apollo.QueryResult<CollectionsSmartSearchForUseNormalCollectionNestedTableDataQuery, CollectionsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>;
export const GetPostsSmartSearchForUseNormalCollectionNestedTableDataDocument = gql`
    query GetPostsSmartSearchForUseNormalCollectionNestedTableData($filters: PostFiltersForSmartSearch!, $take: Int, $after: String, $sortType: SortType) {
  postsSmartSearch(
    filters: $filters
    take: $take
    after: $after
    sortType: $sortType
  ) {
    data {
      item {
        id
        ...PostFragmentUseNormalCollectionNestedTableData
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentUseNormalCollectionNestedTableDataFragmentDoc}`;

/**
 * __useGetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery__
 *
 * To run a query within a React component, call `useGetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery(baseOptions: Apollo.QueryHookOptions<GetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery, GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery, GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>(GetPostsSmartSearchForUseNormalCollectionNestedTableDataDocument, options);
      }
export function useGetPostsSmartSearchForUseNormalCollectionNestedTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery, GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery, GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>(GetPostsSmartSearchForUseNormalCollectionNestedTableDataDocument, options);
        }
export type GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery>;
export type GetPostsSmartSearchForUseNormalCollectionNestedTableDataLazyQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForUseNormalCollectionNestedTableDataLazyQuery>;
export type GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryResult = Apollo.QueryResult<GetPostsSmartSearchForUseNormalCollectionNestedTableDataQuery, GetPostsSmartSearchForUseNormalCollectionNestedTableDataQueryVariables>;
export const GetCollectionForCjbWindowCollectionListSectionDocument = gql`
    query GetCollectionForCJBWindowCollectionListSection($id: String!) {
  collection(id: $id) {
    id
    ...CollectionFragmentCollectionCardView
  }
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;

/**
 * __useGetCollectionForCjbWindowCollectionListSectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCjbWindowCollectionListSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCjbWindowCollectionListSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCjbWindowCollectionListSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionForCjbWindowCollectionListSectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCjbWindowCollectionListSectionQuery, GetCollectionForCjbWindowCollectionListSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCjbWindowCollectionListSectionQuery, GetCollectionForCjbWindowCollectionListSectionQueryVariables>(GetCollectionForCjbWindowCollectionListSectionDocument, options);
      }
export function useGetCollectionForCjbWindowCollectionListSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCjbWindowCollectionListSectionQuery, GetCollectionForCjbWindowCollectionListSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCjbWindowCollectionListSectionQuery, GetCollectionForCjbWindowCollectionListSectionQueryVariables>(GetCollectionForCjbWindowCollectionListSectionDocument, options);
        }
export type GetCollectionForCjbWindowCollectionListSectionQueryHookResult = ReturnType<typeof useGetCollectionForCjbWindowCollectionListSectionQuery>;
export type GetCollectionForCjbWindowCollectionListSectionLazyQueryHookResult = ReturnType<typeof useGetCollectionForCjbWindowCollectionListSectionLazyQuery>;
export type GetCollectionForCjbWindowCollectionListSectionQueryResult = Apollo.QueryResult<GetCollectionForCjbWindowCollectionListSectionQuery, GetCollectionForCjbWindowCollectionListSectionQueryVariables>;
export const DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardDocument = gql`
    mutation DeleteManuallyParsedSocialPostTrackerForMPSPTOutboundCommentCard($data: DeleteManuallyParsedSocialPostTrackerInput!) {
  deleteManuallyParsedSocialPostTracker(data: $data) {
    success
    message
  }
}
    `;
export type DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationFn = Apollo.MutationFunction<DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation, DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationVariables>;

/**
 * __useDeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation__
 *
 * To run a mutation, you first call `useDeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation, { data, loading, error }] = useDeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation, DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation, DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationVariables>(DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardDocument, options);
      }
export type DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationHookResult = ReturnType<typeof useDeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation>;
export type DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationResult = Apollo.MutationResult<DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation>;
export type DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationOptions = Apollo.BaseMutationOptions<DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutation, DeleteManuallyParsedSocialPostTrackerForMpsptOutboundCommentCardMutationVariables>;
export const GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewDocument = gql`
    query GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogView($filters: ManuallyParsedSocialPostTrackerFilters!, $after: String) {
  manuallyParsedSocialPostTrackers(filters: $filters, after: $after) {
    data {
      id
      ...ManuallyParsedSocialPostTrackerFragmentMPSPTOutboundCommentCard
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    meta {
      totalCount
    }
  }
}
    ${ManuallyParsedSocialPostTrackerFragmentMpsptOutboundCommentCardFragmentDoc}`;

/**
 * __useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery__
 *
 * To run a query within a React component, call `useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery, GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery, GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryVariables>(GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewDocument, options);
      }
export function useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery, GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery, GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryVariables>(GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewDocument, options);
        }
export type GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryHookResult = ReturnType<typeof useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery>;
export type GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewLazyQueryHookResult = ReturnType<typeof useGetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewLazyQuery>;
export type GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryResult = Apollo.QueryResult<GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQuery, GetManuallyParsedSocialPostTrackersForManuallyParsedSocialPostTrackerDialogViewQueryVariables>;
export const UpdateUserPersonalSettingsDocument = gql`
    mutation UpdateUserPersonalSettings($data: UpdateUserPersonalSettingsInput!) {
  updateUserPersonalSettings(data: $data) {
    id
    personalSettings {
      postGeneralPermissionDefault
      postGeneralPermissionDefaultPermissionLevel
      collectionGeneralPermissionDefault
      collectionGeneralPermissionDefaultPermissionLevel
    }
  }
}
    `;
export type UpdateUserPersonalSettingsMutationFn = Apollo.MutationFunction<UpdateUserPersonalSettingsMutation, UpdateUserPersonalSettingsMutationVariables>;

/**
 * __useUpdateUserPersonalSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserPersonalSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPersonalSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPersonalSettingsMutation, { data, loading, error }] = useUpdateUserPersonalSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserPersonalSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPersonalSettingsMutation, UpdateUserPersonalSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPersonalSettingsMutation, UpdateUserPersonalSettingsMutationVariables>(UpdateUserPersonalSettingsDocument, options);
      }
export type UpdateUserPersonalSettingsMutationHookResult = ReturnType<typeof useUpdateUserPersonalSettingsMutation>;
export type UpdateUserPersonalSettingsMutationResult = Apollo.MutationResult<UpdateUserPersonalSettingsMutation>;
export type UpdateUserPersonalSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserPersonalSettingsMutation, UpdateUserPersonalSettingsMutationVariables>;
export const UpdateNoteColorDocument = gql`
    mutation UpdateNoteColor($data: UpdatePostInput!) {
  updatePost(data: $data) {
    id
    color
  }
}
    `;
export type UpdateNoteColorMutationFn = Apollo.MutationFunction<UpdateNoteColorMutation, UpdateNoteColorMutationVariables>;

/**
 * __useUpdateNoteColorMutation__
 *
 * To run a mutation, you first call `useUpdateNoteColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteColorMutation, { data, loading, error }] = useUpdateNoteColorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNoteColorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteColorMutation, UpdateNoteColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteColorMutation, UpdateNoteColorMutationVariables>(UpdateNoteColorDocument, options);
      }
export type UpdateNoteColorMutationHookResult = ReturnType<typeof useUpdateNoteColorMutation>;
export type UpdateNoteColorMutationResult = Apollo.MutationResult<UpdateNoteColorMutation>;
export type UpdateNoteColorMutationOptions = Apollo.BaseMutationOptions<UpdateNoteColorMutation, UpdateNoteColorMutationVariables>;
export const GetPostAnnotationsForUseValidateCommentsDocument = gql`
    query GetPostAnnotationsForUseValidateComments($filters: PostAnnotationFilters) {
  postAnnotations(filters: $filters) {
    id
    noteCommentAnchorId
  }
}
    `;

/**
 * __useGetPostAnnotationsForUseValidateCommentsQuery__
 *
 * To run a query within a React component, call `useGetPostAnnotationsForUseValidateCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostAnnotationsForUseValidateCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostAnnotationsForUseValidateCommentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPostAnnotationsForUseValidateCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPostAnnotationsForUseValidateCommentsQuery, GetPostAnnotationsForUseValidateCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostAnnotationsForUseValidateCommentsQuery, GetPostAnnotationsForUseValidateCommentsQueryVariables>(GetPostAnnotationsForUseValidateCommentsDocument, options);
      }
export function useGetPostAnnotationsForUseValidateCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostAnnotationsForUseValidateCommentsQuery, GetPostAnnotationsForUseValidateCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostAnnotationsForUseValidateCommentsQuery, GetPostAnnotationsForUseValidateCommentsQueryVariables>(GetPostAnnotationsForUseValidateCommentsDocument, options);
        }
export type GetPostAnnotationsForUseValidateCommentsQueryHookResult = ReturnType<typeof useGetPostAnnotationsForUseValidateCommentsQuery>;
export type GetPostAnnotationsForUseValidateCommentsLazyQueryHookResult = ReturnType<typeof useGetPostAnnotationsForUseValidateCommentsLazyQuery>;
export type GetPostAnnotationsForUseValidateCommentsQueryResult = Apollo.QueryResult<GetPostAnnotationsForUseValidateCommentsQuery, GetPostAnnotationsForUseValidateCommentsQueryVariables>;
export const UpdateNoteTitleDocument = gql`
    mutation UpdateNoteTitle($data: UpdatePostInput!) {
  updatePost(data: $data) {
    id
    title
  }
}
    `;
export type UpdateNoteTitleMutationFn = Apollo.MutationFunction<UpdateNoteTitleMutation, UpdateNoteTitleMutationVariables>;

/**
 * __useUpdateNoteTitleMutation__
 *
 * To run a mutation, you first call `useUpdateNoteTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteTitleMutation, { data, loading, error }] = useUpdateNoteTitleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNoteTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteTitleMutation, UpdateNoteTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteTitleMutation, UpdateNoteTitleMutationVariables>(UpdateNoteTitleDocument, options);
      }
export type UpdateNoteTitleMutationHookResult = ReturnType<typeof useUpdateNoteTitleMutation>;
export type UpdateNoteTitleMutationResult = Apollo.MutationResult<UpdateNoteTitleMutation>;
export type UpdateNoteTitleMutationOptions = Apollo.BaseMutationOptions<UpdateNoteTitleMutation, UpdateNoteTitleMutationVariables>;
export const UpdateNoteBodyDocument = gql`
    mutation UpdateNoteBody($data: UpdatePostInput!) {
  updatePost(data: $data) {
    id
    body
  }
}
    `;
export type UpdateNoteBodyMutationFn = Apollo.MutationFunction<UpdateNoteBodyMutation, UpdateNoteBodyMutationVariables>;

/**
 * __useUpdateNoteBodyMutation__
 *
 * To run a mutation, you first call `useUpdateNoteBodyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteBodyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteBodyMutation, { data, loading, error }] = useUpdateNoteBodyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNoteBodyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteBodyMutation, UpdateNoteBodyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteBodyMutation, UpdateNoteBodyMutationVariables>(UpdateNoteBodyDocument, options);
      }
export type UpdateNoteBodyMutationHookResult = ReturnType<typeof useUpdateNoteBodyMutation>;
export type UpdateNoteBodyMutationResult = Apollo.MutationResult<UpdateNoteBodyMutation>;
export type UpdateNoteBodyMutationOptions = Apollo.BaseMutationOptions<UpdateNoteBodyMutation, UpdateNoteBodyMutationVariables>;
export const UpdateNoteForNoteDetailContentViewDocument = gql`
    mutation UpdateNoteForNoteDetailContentView($data: UpdatePostInput!) {
  updatePost(data: $data) {
    ...PostFragmentJuiceModal
  }
}
    ${PostFragmentJuiceModalFragmentDoc}`;
export type UpdateNoteForNoteDetailContentViewMutationFn = Apollo.MutationFunction<UpdateNoteForNoteDetailContentViewMutation, UpdateNoteForNoteDetailContentViewMutationVariables>;

/**
 * __useUpdateNoteForNoteDetailContentViewMutation__
 *
 * To run a mutation, you first call `useUpdateNoteForNoteDetailContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteForNoteDetailContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteForNoteDetailContentViewMutation, { data, loading, error }] = useUpdateNoteForNoteDetailContentViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNoteForNoteDetailContentViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteForNoteDetailContentViewMutation, UpdateNoteForNoteDetailContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteForNoteDetailContentViewMutation, UpdateNoteForNoteDetailContentViewMutationVariables>(UpdateNoteForNoteDetailContentViewDocument, options);
      }
export type UpdateNoteForNoteDetailContentViewMutationHookResult = ReturnType<typeof useUpdateNoteForNoteDetailContentViewMutation>;
export type UpdateNoteForNoteDetailContentViewMutationResult = Apollo.MutationResult<UpdateNoteForNoteDetailContentViewMutation>;
export type UpdateNoteForNoteDetailContentViewMutationOptions = Apollo.BaseMutationOptions<UpdateNoteForNoteDetailContentViewMutation, UpdateNoteForNoteDetailContentViewMutationVariables>;
export const UnreadNotificationForNotificationMoreMenuDocument = gql`
    mutation UnreadNotificationForNotificationMoreMenu($id: String!) {
  unreadNotification(id: $id) {
    id
    status
  }
}
    `;
export type UnreadNotificationForNotificationMoreMenuMutationFn = Apollo.MutationFunction<UnreadNotificationForNotificationMoreMenuMutation, UnreadNotificationForNotificationMoreMenuMutationVariables>;

/**
 * __useUnreadNotificationForNotificationMoreMenuMutation__
 *
 * To run a mutation, you first call `useUnreadNotificationForNotificationMoreMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationForNotificationMoreMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unreadNotificationForNotificationMoreMenuMutation, { data, loading, error }] = useUnreadNotificationForNotificationMoreMenuMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnreadNotificationForNotificationMoreMenuMutation(baseOptions?: Apollo.MutationHookOptions<UnreadNotificationForNotificationMoreMenuMutation, UnreadNotificationForNotificationMoreMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnreadNotificationForNotificationMoreMenuMutation, UnreadNotificationForNotificationMoreMenuMutationVariables>(UnreadNotificationForNotificationMoreMenuDocument, options);
      }
export type UnreadNotificationForNotificationMoreMenuMutationHookResult = ReturnType<typeof useUnreadNotificationForNotificationMoreMenuMutation>;
export type UnreadNotificationForNotificationMoreMenuMutationResult = Apollo.MutationResult<UnreadNotificationForNotificationMoreMenuMutation>;
export type UnreadNotificationForNotificationMoreMenuMutationOptions = Apollo.BaseMutationOptions<UnreadNotificationForNotificationMoreMenuMutation, UnreadNotificationForNotificationMoreMenuMutationVariables>;
export const ReadNotificationForNotificationMoreMenuDocument = gql`
    mutation ReadNotificationForNotificationMoreMenu($id: String!) {
  readNotification(id: $id) {
    id
    status
  }
}
    `;
export type ReadNotificationForNotificationMoreMenuMutationFn = Apollo.MutationFunction<ReadNotificationForNotificationMoreMenuMutation, ReadNotificationForNotificationMoreMenuMutationVariables>;

/**
 * __useReadNotificationForNotificationMoreMenuMutation__
 *
 * To run a mutation, you first call `useReadNotificationForNotificationMoreMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationForNotificationMoreMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationForNotificationMoreMenuMutation, { data, loading, error }] = useReadNotificationForNotificationMoreMenuMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadNotificationForNotificationMoreMenuMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationForNotificationMoreMenuMutation, ReadNotificationForNotificationMoreMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationForNotificationMoreMenuMutation, ReadNotificationForNotificationMoreMenuMutationVariables>(ReadNotificationForNotificationMoreMenuDocument, options);
      }
export type ReadNotificationForNotificationMoreMenuMutationHookResult = ReturnType<typeof useReadNotificationForNotificationMoreMenuMutation>;
export type ReadNotificationForNotificationMoreMenuMutationResult = Apollo.MutationResult<ReadNotificationForNotificationMoreMenuMutation>;
export type ReadNotificationForNotificationMoreMenuMutationOptions = Apollo.BaseMutationOptions<ReadNotificationForNotificationMoreMenuMutation, ReadNotificationForNotificationMoreMenuMutationVariables>;
export const CreateNotePostForOnboardingNoteDocument = gql`
    mutation CreateNotePostForOnboardingNote($data: CreateNotePostInput!) {
  createNotePost(data: $data) {
    ...PostFragmentOnboardingPostNoteCard
  }
}
    ${PostFragmentOnboardingPostNoteCardFragmentDoc}`;
export type CreateNotePostForOnboardingNoteMutationFn = Apollo.MutationFunction<CreateNotePostForOnboardingNoteMutation, CreateNotePostForOnboardingNoteMutationVariables>;

/**
 * __useCreateNotePostForOnboardingNoteMutation__
 *
 * To run a mutation, you first call `useCreateNotePostForOnboardingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotePostForOnboardingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotePostForOnboardingNoteMutation, { data, loading, error }] = useCreateNotePostForOnboardingNoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNotePostForOnboardingNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotePostForOnboardingNoteMutation, CreateNotePostForOnboardingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotePostForOnboardingNoteMutation, CreateNotePostForOnboardingNoteMutationVariables>(CreateNotePostForOnboardingNoteDocument, options);
      }
export type CreateNotePostForOnboardingNoteMutationHookResult = ReturnType<typeof useCreateNotePostForOnboardingNoteMutation>;
export type CreateNotePostForOnboardingNoteMutationResult = Apollo.MutationResult<CreateNotePostForOnboardingNoteMutation>;
export type CreateNotePostForOnboardingNoteMutationOptions = Apollo.BaseMutationOptions<CreateNotePostForOnboardingNoteMutation, CreateNotePostForOnboardingNoteMutationVariables>;
export const UpdatePostForOnboardingNoteDocument = gql`
    mutation UpdatePostForOnboardingNote($data: UpdatePostInput!) {
  updatePost(data: $data) {
    ...PostFragmentOnboardingPostNoteCard
  }
}
    ${PostFragmentOnboardingPostNoteCardFragmentDoc}`;
export type UpdatePostForOnboardingNoteMutationFn = Apollo.MutationFunction<UpdatePostForOnboardingNoteMutation, UpdatePostForOnboardingNoteMutationVariables>;

/**
 * __useUpdatePostForOnboardingNoteMutation__
 *
 * To run a mutation, you first call `useUpdatePostForOnboardingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostForOnboardingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostForOnboardingNoteMutation, { data, loading, error }] = useUpdatePostForOnboardingNoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePostForOnboardingNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostForOnboardingNoteMutation, UpdatePostForOnboardingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostForOnboardingNoteMutation, UpdatePostForOnboardingNoteMutationVariables>(UpdatePostForOnboardingNoteDocument, options);
      }
export type UpdatePostForOnboardingNoteMutationHookResult = ReturnType<typeof useUpdatePostForOnboardingNoteMutation>;
export type UpdatePostForOnboardingNoteMutationResult = Apollo.MutationResult<UpdatePostForOnboardingNoteMutation>;
export type UpdatePostForOnboardingNoteMutationOptions = Apollo.BaseMutationOptions<UpdatePostForOnboardingNoteMutation, UpdatePostForOnboardingNoteMutationVariables>;
export const GetPostByIdForOnboardingPostCardDocument = gql`
    query GetPostByIdForOnboardingPostCard($postId: String!) {
  post(id: $postId) {
    ...PostFragmentPostQueryForOnboardingPostCard
    ...PostFragmentPostCommand
  }
}
    ${PostFragmentPostQueryForOnboardingPostCardFragmentDoc}
${PostFragmentPostCommandFragmentDoc}`;

/**
 * __useGetPostByIdForOnboardingPostCardQuery__
 *
 * To run a query within a React component, call `useGetPostByIdForOnboardingPostCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdForOnboardingPostCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdForOnboardingPostCardQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostByIdForOnboardingPostCardQuery(baseOptions: Apollo.QueryHookOptions<GetPostByIdForOnboardingPostCardQuery, GetPostByIdForOnboardingPostCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostByIdForOnboardingPostCardQuery, GetPostByIdForOnboardingPostCardQueryVariables>(GetPostByIdForOnboardingPostCardDocument, options);
      }
export function useGetPostByIdForOnboardingPostCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostByIdForOnboardingPostCardQuery, GetPostByIdForOnboardingPostCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostByIdForOnboardingPostCardQuery, GetPostByIdForOnboardingPostCardQueryVariables>(GetPostByIdForOnboardingPostCardDocument, options);
        }
export type GetPostByIdForOnboardingPostCardQueryHookResult = ReturnType<typeof useGetPostByIdForOnboardingPostCardQuery>;
export type GetPostByIdForOnboardingPostCardLazyQueryHookResult = ReturnType<typeof useGetPostByIdForOnboardingPostCardLazyQuery>;
export type GetPostByIdForOnboardingPostCardQueryResult = Apollo.QueryResult<GetPostByIdForOnboardingPostCardQuery, GetPostByIdForOnboardingPostCardQueryVariables>;
export const GetPostsForOnboardingPostCardDocument = gql`
    query GetPostsForOnboardingPostCard($filters: PostFilters!, $take: Int, $after: String) {
  posts(filters: $filters, take: $take, after: $after) {
    data {
      ...PostFragmentPostQueryForOnboardingPostCard
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentPostQueryForOnboardingPostCardFragmentDoc}`;

/**
 * __useGetPostsForOnboardingPostCardQuery__
 *
 * To run a query within a React component, call `useGetPostsForOnboardingPostCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForOnboardingPostCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForOnboardingPostCardQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPostsForOnboardingPostCardQuery(baseOptions: Apollo.QueryHookOptions<GetPostsForOnboardingPostCardQuery, GetPostsForOnboardingPostCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsForOnboardingPostCardQuery, GetPostsForOnboardingPostCardQueryVariables>(GetPostsForOnboardingPostCardDocument, options);
      }
export function useGetPostsForOnboardingPostCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsForOnboardingPostCardQuery, GetPostsForOnboardingPostCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsForOnboardingPostCardQuery, GetPostsForOnboardingPostCardQueryVariables>(GetPostsForOnboardingPostCardDocument, options);
        }
export type GetPostsForOnboardingPostCardQueryHookResult = ReturnType<typeof useGetPostsForOnboardingPostCardQuery>;
export type GetPostsForOnboardingPostCardLazyQueryHookResult = ReturnType<typeof useGetPostsForOnboardingPostCardLazyQuery>;
export type GetPostsForOnboardingPostCardQueryResult = Apollo.QueryResult<GetPostsForOnboardingPostCardQuery, GetPostsForOnboardingPostCardQueryVariables>;
export const GetPermittedCollectionsForOrganizationMembersPermittedCollectionsDocument = gql`
    query GetPermittedCollectionsForOrganizationMembersPermittedCollections($filters: PermittedCollectionFilters!) {
  permittedCollections(filters: $filters) {
    id
    permissionLevel
    collection {
      id
      name
      parentCollection {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery__
 *
 * To run a query within a React component, call `useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery, GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery, GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryVariables>(GetPermittedCollectionsForOrganizationMembersPermittedCollectionsDocument, options);
      }
export function useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery, GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery, GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryVariables>(GetPermittedCollectionsForOrganizationMembersPermittedCollectionsDocument, options);
        }
export type GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryHookResult = ReturnType<typeof useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery>;
export type GetPermittedCollectionsForOrganizationMembersPermittedCollectionsLazyQueryHookResult = ReturnType<typeof useGetPermittedCollectionsForOrganizationMembersPermittedCollectionsLazyQuery>;
export type GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryResult = Apollo.QueryResult<GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQuery, GetPermittedCollectionsForOrganizationMembersPermittedCollectionsQueryVariables>;
export const GetPermittedPostsForOrganizationMembersPermittedCollectionListItemDocument = gql`
    query GetPermittedPostsForOrganizationMembersPermittedCollectionListItem($filters: PermittedPostFilters!) {
  permittedPosts(filters: $filters) {
    id
    permissionLevel
    post {
      id
      ...PostFragmentPostPreview
    }
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery__
 *
 * To run a query within a React component, call `useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery(baseOptions: Apollo.QueryHookOptions<GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery, GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery, GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryVariables>(GetPermittedPostsForOrganizationMembersPermittedCollectionListItemDocument, options);
      }
export function useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery, GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery, GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryVariables>(GetPermittedPostsForOrganizationMembersPermittedCollectionListItemDocument, options);
        }
export type GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryHookResult = ReturnType<typeof useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery>;
export type GetPermittedPostsForOrganizationMembersPermittedCollectionListItemLazyQueryHookResult = ReturnType<typeof useGetPermittedPostsForOrganizationMembersPermittedCollectionListItemLazyQuery>;
export type GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryResult = Apollo.QueryResult<GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQuery, GetPermittedPostsForOrganizationMembersPermittedCollectionListItemQueryVariables>;
export const InviteUsersToCurrentOrgForUseOrgMemberManagementDocument = gql`
    mutation InviteUsersToCurrentOrgForUseOrgMemberManagement($data: InviteUsersToCurrentOrgInput!) {
  inviteUsersToCurrentOrg(data: $data) {
    id
  }
}
    `;
export type InviteUsersToCurrentOrgForUseOrgMemberManagementMutationFn = Apollo.MutationFunction<InviteUsersToCurrentOrgForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgForUseOrgMemberManagementMutationVariables>;

/**
 * __useInviteUsersToCurrentOrgForUseOrgMemberManagementMutation__
 *
 * To run a mutation, you first call `useInviteUsersToCurrentOrgForUseOrgMemberManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersToCurrentOrgForUseOrgMemberManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersToCurrentOrgForUseOrgMemberManagementMutation, { data, loading, error }] = useInviteUsersToCurrentOrgForUseOrgMemberManagementMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteUsersToCurrentOrgForUseOrgMemberManagementMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersToCurrentOrgForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgForUseOrgMemberManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersToCurrentOrgForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgForUseOrgMemberManagementMutationVariables>(InviteUsersToCurrentOrgForUseOrgMemberManagementDocument, options);
      }
export type InviteUsersToCurrentOrgForUseOrgMemberManagementMutationHookResult = ReturnType<typeof useInviteUsersToCurrentOrgForUseOrgMemberManagementMutation>;
export type InviteUsersToCurrentOrgForUseOrgMemberManagementMutationResult = Apollo.MutationResult<InviteUsersToCurrentOrgForUseOrgMemberManagementMutation>;
export type InviteUsersToCurrentOrgForUseOrgMemberManagementMutationOptions = Apollo.BaseMutationOptions<InviteUsersToCurrentOrgForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgForUseOrgMemberManagementMutationVariables>;
export const InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementDocument = gql`
    mutation InviteUsersToCurrentOrgByRolesForUseOrgMemberManagement($data: InviteUsersToCurrentOrgByRoleInput!) {
  inviteUsersToCurrentOrgByRoles(data: $data) {
    id
  }
}
    `;
export type InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationFn = Apollo.MutationFunction<InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationVariables>;

/**
 * __useInviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation__
 *
 * To run a mutation, you first call `useInviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation, { data, loading, error }] = useInviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationVariables>(InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementDocument, options);
      }
export type InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationHookResult = ReturnType<typeof useInviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation>;
export type InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationResult = Apollo.MutationResult<InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation>;
export type InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationOptions = Apollo.BaseMutationOptions<InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutation, InviteUsersToCurrentOrgByRolesForUseOrgMemberManagementMutationVariables>;
export const UpdateBrandPermissionsForInternalMembersDocument = gql`
    mutation UpdateBrandPermissionsForInternalMembers($data: UpdateBrandPermissionsInput!) {
  updateBrandPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateBrandPermissionsForInternalMembersMutationFn = Apollo.MutationFunction<UpdateBrandPermissionsForInternalMembersMutation, UpdateBrandPermissionsForInternalMembersMutationVariables>;

/**
 * __useUpdateBrandPermissionsForInternalMembersMutation__
 *
 * To run a mutation, you first call `useUpdateBrandPermissionsForInternalMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandPermissionsForInternalMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandPermissionsForInternalMembersMutation, { data, loading, error }] = useUpdateBrandPermissionsForInternalMembersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandPermissionsForInternalMembersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandPermissionsForInternalMembersMutation, UpdateBrandPermissionsForInternalMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandPermissionsForInternalMembersMutation, UpdateBrandPermissionsForInternalMembersMutationVariables>(UpdateBrandPermissionsForInternalMembersDocument, options);
      }
export type UpdateBrandPermissionsForInternalMembersMutationHookResult = ReturnType<typeof useUpdateBrandPermissionsForInternalMembersMutation>;
export type UpdateBrandPermissionsForInternalMembersMutationResult = Apollo.MutationResult<UpdateBrandPermissionsForInternalMembersMutation>;
export type UpdateBrandPermissionsForInternalMembersMutationOptions = Apollo.BaseMutationOptions<UpdateBrandPermissionsForInternalMembersMutation, UpdateBrandPermissionsForInternalMembersMutationVariables>;
export const UpdateBrandPermissionsForMembersViewDocument = gql`
    mutation UpdateBrandPermissionsForMembersView($data: UpdateBrandPermissionsInput!) {
  updateBrandPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateBrandPermissionsForMembersViewMutationFn = Apollo.MutationFunction<UpdateBrandPermissionsForMembersViewMutation, UpdateBrandPermissionsForMembersViewMutationVariables>;

/**
 * __useUpdateBrandPermissionsForMembersViewMutation__
 *
 * To run a mutation, you first call `useUpdateBrandPermissionsForMembersViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandPermissionsForMembersViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandPermissionsForMembersViewMutation, { data, loading, error }] = useUpdateBrandPermissionsForMembersViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandPermissionsForMembersViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandPermissionsForMembersViewMutation, UpdateBrandPermissionsForMembersViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandPermissionsForMembersViewMutation, UpdateBrandPermissionsForMembersViewMutationVariables>(UpdateBrandPermissionsForMembersViewDocument, options);
      }
export type UpdateBrandPermissionsForMembersViewMutationHookResult = ReturnType<typeof useUpdateBrandPermissionsForMembersViewMutation>;
export type UpdateBrandPermissionsForMembersViewMutationResult = Apollo.MutationResult<UpdateBrandPermissionsForMembersViewMutation>;
export type UpdateBrandPermissionsForMembersViewMutationOptions = Apollo.BaseMutationOptions<UpdateBrandPermissionsForMembersViewMutation, UpdateBrandPermissionsForMembersViewMutationVariables>;
export const UpdateBrandPermissionsForUserApprovalRequestsTableDocument = gql`
    mutation UpdateBrandPermissionsForUserApprovalRequestsTable($data: UpdateBrandPermissionsInput!) {
  updateBrandPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateBrandPermissionsForUserApprovalRequestsTableMutationFn = Apollo.MutationFunction<UpdateBrandPermissionsForUserApprovalRequestsTableMutation, UpdateBrandPermissionsForUserApprovalRequestsTableMutationVariables>;

/**
 * __useUpdateBrandPermissionsForUserApprovalRequestsTableMutation__
 *
 * To run a mutation, you first call `useUpdateBrandPermissionsForUserApprovalRequestsTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandPermissionsForUserApprovalRequestsTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandPermissionsForUserApprovalRequestsTableMutation, { data, loading, error }] = useUpdateBrandPermissionsForUserApprovalRequestsTableMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandPermissionsForUserApprovalRequestsTableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandPermissionsForUserApprovalRequestsTableMutation, UpdateBrandPermissionsForUserApprovalRequestsTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandPermissionsForUserApprovalRequestsTableMutation, UpdateBrandPermissionsForUserApprovalRequestsTableMutationVariables>(UpdateBrandPermissionsForUserApprovalRequestsTableDocument, options);
      }
export type UpdateBrandPermissionsForUserApprovalRequestsTableMutationHookResult = ReturnType<typeof useUpdateBrandPermissionsForUserApprovalRequestsTableMutation>;
export type UpdateBrandPermissionsForUserApprovalRequestsTableMutationResult = Apollo.MutationResult<UpdateBrandPermissionsForUserApprovalRequestsTableMutation>;
export type UpdateBrandPermissionsForUserApprovalRequestsTableMutationOptions = Apollo.BaseMutationOptions<UpdateBrandPermissionsForUserApprovalRequestsTableMutation, UpdateBrandPermissionsForUserApprovalRequestsTableMutationVariables>;
export const UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableDocument = gql`
    mutation UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTable($data: UpdateOrganizationUserAccessRequestInput!) {
  updatePendingOrganizationAccessRequest(data: $data) {
    id
  }
}
    `;
export type UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationFn = Apollo.MutationFunction<UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation, UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationVariables>;

/**
 * __useUpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation__
 *
 * To run a mutation, you first call `useUpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation, { data, loading, error }] = useUpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation, UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation, UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationVariables>(UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableDocument, options);
      }
export type UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationHookResult = ReturnType<typeof useUpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation>;
export type UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationResult = Apollo.MutationResult<UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation>;
export type UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationOptions = Apollo.BaseMutationOptions<UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutation, UpdatePendingOrganizationAccessRequestForUserApprovalRequestsTableMutationVariables>;
export const RestrictAccessForUserForMembersViewDocument = gql`
    mutation RestrictAccessForUserForMembersView {
  restrictAccessForUser {
    message
    success
  }
}
    `;
export type RestrictAccessForUserForMembersViewMutationFn = Apollo.MutationFunction<RestrictAccessForUserForMembersViewMutation, RestrictAccessForUserForMembersViewMutationVariables>;

/**
 * __useRestrictAccessForUserForMembersViewMutation__
 *
 * To run a mutation, you first call `useRestrictAccessForUserForMembersViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestrictAccessForUserForMembersViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restrictAccessForUserForMembersViewMutation, { data, loading, error }] = useRestrictAccessForUserForMembersViewMutation({
 *   variables: {
 *   },
 * });
 */
export function useRestrictAccessForUserForMembersViewMutation(baseOptions?: Apollo.MutationHookOptions<RestrictAccessForUserForMembersViewMutation, RestrictAccessForUserForMembersViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestrictAccessForUserForMembersViewMutation, RestrictAccessForUserForMembersViewMutationVariables>(RestrictAccessForUserForMembersViewDocument, options);
      }
export type RestrictAccessForUserForMembersViewMutationHookResult = ReturnType<typeof useRestrictAccessForUserForMembersViewMutation>;
export type RestrictAccessForUserForMembersViewMutationResult = Apollo.MutationResult<RestrictAccessForUserForMembersViewMutation>;
export type RestrictAccessForUserForMembersViewMutationOptions = Apollo.BaseMutationOptions<RestrictAccessForUserForMembersViewMutation, RestrictAccessForUserForMembersViewMutationVariables>;
export const UnrestrictAccessForUserForMembersViewDocument = gql`
    mutation UnrestrictAccessForUserForMembersView {
  unrestrictAccessForUser {
    message
    success
  }
}
    `;
export type UnrestrictAccessForUserForMembersViewMutationFn = Apollo.MutationFunction<UnrestrictAccessForUserForMembersViewMutation, UnrestrictAccessForUserForMembersViewMutationVariables>;

/**
 * __useUnrestrictAccessForUserForMembersViewMutation__
 *
 * To run a mutation, you first call `useUnrestrictAccessForUserForMembersViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnrestrictAccessForUserForMembersViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unrestrictAccessForUserForMembersViewMutation, { data, loading, error }] = useUnrestrictAccessForUserForMembersViewMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnrestrictAccessForUserForMembersViewMutation(baseOptions?: Apollo.MutationHookOptions<UnrestrictAccessForUserForMembersViewMutation, UnrestrictAccessForUserForMembersViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnrestrictAccessForUserForMembersViewMutation, UnrestrictAccessForUserForMembersViewMutationVariables>(UnrestrictAccessForUserForMembersViewDocument, options);
      }
export type UnrestrictAccessForUserForMembersViewMutationHookResult = ReturnType<typeof useUnrestrictAccessForUserForMembersViewMutation>;
export type UnrestrictAccessForUserForMembersViewMutationResult = Apollo.MutationResult<UnrestrictAccessForUserForMembersViewMutation>;
export type UnrestrictAccessForUserForMembersViewMutationOptions = Apollo.BaseMutationOptions<UnrestrictAccessForUserForMembersViewMutation, UnrestrictAccessForUserForMembersViewMutationVariables>;
export const GetMyPendingOrganizationAccessRequestsForAdminDocument = gql`
    query GetMyPendingOrganizationAccessRequestsForAdmin {
  myPendingOrganizationAccessRequestsForAdmin {
    ...OrganizationUserAccessRequestFragmentUserApprovalRequestsTable
  }
}
    ${OrganizationUserAccessRequestFragmentUserApprovalRequestsTableFragmentDoc}`;

/**
 * __useGetMyPendingOrganizationAccessRequestsForAdminQuery__
 *
 * To run a query within a React component, call `useGetMyPendingOrganizationAccessRequestsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPendingOrganizationAccessRequestsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPendingOrganizationAccessRequestsForAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPendingOrganizationAccessRequestsForAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPendingOrganizationAccessRequestsForAdminQuery, GetMyPendingOrganizationAccessRequestsForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPendingOrganizationAccessRequestsForAdminQuery, GetMyPendingOrganizationAccessRequestsForAdminQueryVariables>(GetMyPendingOrganizationAccessRequestsForAdminDocument, options);
      }
export function useGetMyPendingOrganizationAccessRequestsForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPendingOrganizationAccessRequestsForAdminQuery, GetMyPendingOrganizationAccessRequestsForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPendingOrganizationAccessRequestsForAdminQuery, GetMyPendingOrganizationAccessRequestsForAdminQueryVariables>(GetMyPendingOrganizationAccessRequestsForAdminDocument, options);
        }
export type GetMyPendingOrganizationAccessRequestsForAdminQueryHookResult = ReturnType<typeof useGetMyPendingOrganizationAccessRequestsForAdminQuery>;
export type GetMyPendingOrganizationAccessRequestsForAdminLazyQueryHookResult = ReturnType<typeof useGetMyPendingOrganizationAccessRequestsForAdminLazyQuery>;
export type GetMyPendingOrganizationAccessRequestsForAdminQueryResult = Apollo.QueryResult<GetMyPendingOrganizationAccessRequestsForAdminQuery, GetMyPendingOrganizationAccessRequestsForAdminQueryVariables>;
export const GenerateShareLinkForUseCopyLinkDocument = gql`
    mutation GenerateShareLinkForUseCopyLink($data: GenerateShareLinkInput!) {
  generateShareLink(data: $data) {
    id
    entityId
    entityType
    validationToken
  }
}
    `;
export type GenerateShareLinkForUseCopyLinkMutationFn = Apollo.MutationFunction<GenerateShareLinkForUseCopyLinkMutation, GenerateShareLinkForUseCopyLinkMutationVariables>;

/**
 * __useGenerateShareLinkForUseCopyLinkMutation__
 *
 * To run a mutation, you first call `useGenerateShareLinkForUseCopyLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateShareLinkForUseCopyLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateShareLinkForUseCopyLinkMutation, { data, loading, error }] = useGenerateShareLinkForUseCopyLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateShareLinkForUseCopyLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateShareLinkForUseCopyLinkMutation, GenerateShareLinkForUseCopyLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateShareLinkForUseCopyLinkMutation, GenerateShareLinkForUseCopyLinkMutationVariables>(GenerateShareLinkForUseCopyLinkDocument, options);
      }
export type GenerateShareLinkForUseCopyLinkMutationHookResult = ReturnType<typeof useGenerateShareLinkForUseCopyLinkMutation>;
export type GenerateShareLinkForUseCopyLinkMutationResult = Apollo.MutationResult<GenerateShareLinkForUseCopyLinkMutation>;
export type GenerateShareLinkForUseCopyLinkMutationOptions = Apollo.BaseMutationOptions<GenerateShareLinkForUseCopyLinkMutation, GenerateShareLinkForUseCopyLinkMutationVariables>;
export const CreatePermissionRequestForPermissionRequestHandlersDocument = gql`
    mutation CreatePermissionRequestForPermissionRequestHandlers($data: CreatePermissionRequestInput!) {
  createPermissionRequest(data: $data) {
    postId
    collectionId
    brandId
    ...PermissionRequestFragmentUsePermissionRequestHandler
  }
}
    ${PermissionRequestFragmentUsePermissionRequestHandlerFragmentDoc}`;
export type CreatePermissionRequestForPermissionRequestHandlersMutationFn = Apollo.MutationFunction<CreatePermissionRequestForPermissionRequestHandlersMutation, CreatePermissionRequestForPermissionRequestHandlersMutationVariables>;

/**
 * __useCreatePermissionRequestForPermissionRequestHandlersMutation__
 *
 * To run a mutation, you first call `useCreatePermissionRequestForPermissionRequestHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionRequestForPermissionRequestHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionRequestForPermissionRequestHandlersMutation, { data, loading, error }] = useCreatePermissionRequestForPermissionRequestHandlersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePermissionRequestForPermissionRequestHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionRequestForPermissionRequestHandlersMutation, CreatePermissionRequestForPermissionRequestHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionRequestForPermissionRequestHandlersMutation, CreatePermissionRequestForPermissionRequestHandlersMutationVariables>(CreatePermissionRequestForPermissionRequestHandlersDocument, options);
      }
export type CreatePermissionRequestForPermissionRequestHandlersMutationHookResult = ReturnType<typeof useCreatePermissionRequestForPermissionRequestHandlersMutation>;
export type CreatePermissionRequestForPermissionRequestHandlersMutationResult = Apollo.MutationResult<CreatePermissionRequestForPermissionRequestHandlersMutation>;
export type CreatePermissionRequestForPermissionRequestHandlersMutationOptions = Apollo.BaseMutationOptions<CreatePermissionRequestForPermissionRequestHandlersMutation, CreatePermissionRequestForPermissionRequestHandlersMutationVariables>;
export const ApprovePermissionRequestForPermissionRequestHandlersDocument = gql`
    mutation ApprovePermissionRequestForPermissionRequestHandlers($data: ApprovePermissionRequestInput!) {
  approvePermissionRequest(data: $data) {
    ...PermissionRequestFragmentUsePermissionRequestHandler
  }
}
    ${PermissionRequestFragmentUsePermissionRequestHandlerFragmentDoc}`;
export type ApprovePermissionRequestForPermissionRequestHandlersMutationFn = Apollo.MutationFunction<ApprovePermissionRequestForPermissionRequestHandlersMutation, ApprovePermissionRequestForPermissionRequestHandlersMutationVariables>;

/**
 * __useApprovePermissionRequestForPermissionRequestHandlersMutation__
 *
 * To run a mutation, you first call `useApprovePermissionRequestForPermissionRequestHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePermissionRequestForPermissionRequestHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePermissionRequestForPermissionRequestHandlersMutation, { data, loading, error }] = useApprovePermissionRequestForPermissionRequestHandlersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApprovePermissionRequestForPermissionRequestHandlersMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePermissionRequestForPermissionRequestHandlersMutation, ApprovePermissionRequestForPermissionRequestHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePermissionRequestForPermissionRequestHandlersMutation, ApprovePermissionRequestForPermissionRequestHandlersMutationVariables>(ApprovePermissionRequestForPermissionRequestHandlersDocument, options);
      }
export type ApprovePermissionRequestForPermissionRequestHandlersMutationHookResult = ReturnType<typeof useApprovePermissionRequestForPermissionRequestHandlersMutation>;
export type ApprovePermissionRequestForPermissionRequestHandlersMutationResult = Apollo.MutationResult<ApprovePermissionRequestForPermissionRequestHandlersMutation>;
export type ApprovePermissionRequestForPermissionRequestHandlersMutationOptions = Apollo.BaseMutationOptions<ApprovePermissionRequestForPermissionRequestHandlersMutation, ApprovePermissionRequestForPermissionRequestHandlersMutationVariables>;
export const RejectPermissionRequestForPermissionRequestHandlersDocument = gql`
    mutation RejectPermissionRequestForPermissionRequestHandlers($data: RejectPermissionRequestInput!) {
  rejectPermissionRequest(data: $data) {
    ...PermissionRequestFragmentUsePermissionRequestHandler
  }
}
    ${PermissionRequestFragmentUsePermissionRequestHandlerFragmentDoc}`;
export type RejectPermissionRequestForPermissionRequestHandlersMutationFn = Apollo.MutationFunction<RejectPermissionRequestForPermissionRequestHandlersMutation, RejectPermissionRequestForPermissionRequestHandlersMutationVariables>;

/**
 * __useRejectPermissionRequestForPermissionRequestHandlersMutation__
 *
 * To run a mutation, you first call `useRejectPermissionRequestForPermissionRequestHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPermissionRequestForPermissionRequestHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPermissionRequestForPermissionRequestHandlersMutation, { data, loading, error }] = useRejectPermissionRequestForPermissionRequestHandlersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRejectPermissionRequestForPermissionRequestHandlersMutation(baseOptions?: Apollo.MutationHookOptions<RejectPermissionRequestForPermissionRequestHandlersMutation, RejectPermissionRequestForPermissionRequestHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectPermissionRequestForPermissionRequestHandlersMutation, RejectPermissionRequestForPermissionRequestHandlersMutationVariables>(RejectPermissionRequestForPermissionRequestHandlersDocument, options);
      }
export type RejectPermissionRequestForPermissionRequestHandlersMutationHookResult = ReturnType<typeof useRejectPermissionRequestForPermissionRequestHandlersMutation>;
export type RejectPermissionRequestForPermissionRequestHandlersMutationResult = Apollo.MutationResult<RejectPermissionRequestForPermissionRequestHandlersMutation>;
export type RejectPermissionRequestForPermissionRequestHandlersMutationOptions = Apollo.BaseMutationOptions<RejectPermissionRequestForPermissionRequestHandlersMutation, RejectPermissionRequestForPermissionRequestHandlersMutationVariables>;
export const MyPermissionRequestsDocument = gql`
    query MyPermissionRequests {
  myPermissionRequests {
    id
    postId
    collectionId
    brandId
    status
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useMyPermissionRequestsQuery__
 *
 * To run a query within a React component, call `useMyPermissionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPermissionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPermissionRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPermissionRequestsQuery(baseOptions?: Apollo.QueryHookOptions<MyPermissionRequestsQuery, MyPermissionRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPermissionRequestsQuery, MyPermissionRequestsQueryVariables>(MyPermissionRequestsDocument, options);
      }
export function useMyPermissionRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPermissionRequestsQuery, MyPermissionRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPermissionRequestsQuery, MyPermissionRequestsQueryVariables>(MyPermissionRequestsDocument, options);
        }
export type MyPermissionRequestsQueryHookResult = ReturnType<typeof useMyPermissionRequestsQuery>;
export type MyPermissionRequestsLazyQueryHookResult = ReturnType<typeof useMyPermissionRequestsLazyQuery>;
export type MyPermissionRequestsQueryResult = Apollo.QueryResult<MyPermissionRequestsQuery, MyPermissionRequestsQueryVariables>;
export const GetOrganizationUsersForUsePermissionUsersSearchDocument = gql`
    query GetOrganizationUsersForUsePermissionUsersSearch {
  me {
    id
    organization {
      id
      domain
      externalUsers {
        ...UserProfileFragmentUserProfilePermissionItemView
      }
      users {
        ...UserProfileFragmentUserProfilePermissionItemView
      }
    }
  }
}
    ${UserProfileFragmentUserProfilePermissionItemViewFragmentDoc}`;

/**
 * __useGetOrganizationUsersForUsePermissionUsersSearchQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersForUsePermissionUsersSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersForUsePermissionUsersSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersForUsePermissionUsersSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationUsersForUsePermissionUsersSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationUsersForUsePermissionUsersSearchQuery, GetOrganizationUsersForUsePermissionUsersSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersForUsePermissionUsersSearchQuery, GetOrganizationUsersForUsePermissionUsersSearchQueryVariables>(GetOrganizationUsersForUsePermissionUsersSearchDocument, options);
      }
export function useGetOrganizationUsersForUsePermissionUsersSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersForUsePermissionUsersSearchQuery, GetOrganizationUsersForUsePermissionUsersSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersForUsePermissionUsersSearchQuery, GetOrganizationUsersForUsePermissionUsersSearchQueryVariables>(GetOrganizationUsersForUsePermissionUsersSearchDocument, options);
        }
export type GetOrganizationUsersForUsePermissionUsersSearchQueryHookResult = ReturnType<typeof useGetOrganizationUsersForUsePermissionUsersSearchQuery>;
export type GetOrganizationUsersForUsePermissionUsersSearchLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersForUsePermissionUsersSearchLazyQuery>;
export type GetOrganizationUsersForUsePermissionUsersSearchQueryResult = Apollo.QueryResult<GetOrganizationUsersForUsePermissionUsersSearchQuery, GetOrganizationUsersForUsePermissionUsersSearchQueryVariables>;
export const PinManyCollectionsToParentDocument = gql`
    mutation PinManyCollectionsToParent($data: PinManyCollectionsToParentInput!) {
  pinManyCollectionsToParent(data: $data) {
    id
  }
}
    `;
export type PinManyCollectionsToParentMutationFn = Apollo.MutationFunction<PinManyCollectionsToParentMutation, PinManyCollectionsToParentMutationVariables>;

/**
 * __usePinManyCollectionsToParentMutation__
 *
 * To run a mutation, you first call `usePinManyCollectionsToParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinManyCollectionsToParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinManyCollectionsToParentMutation, { data, loading, error }] = usePinManyCollectionsToParentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePinManyCollectionsToParentMutation(baseOptions?: Apollo.MutationHookOptions<PinManyCollectionsToParentMutation, PinManyCollectionsToParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinManyCollectionsToParentMutation, PinManyCollectionsToParentMutationVariables>(PinManyCollectionsToParentDocument, options);
      }
export type PinManyCollectionsToParentMutationHookResult = ReturnType<typeof usePinManyCollectionsToParentMutation>;
export type PinManyCollectionsToParentMutationResult = Apollo.MutationResult<PinManyCollectionsToParentMutation>;
export type PinManyCollectionsToParentMutationOptions = Apollo.BaseMutationOptions<PinManyCollectionsToParentMutation, PinManyCollectionsToParentMutationVariables>;
export const UnpinManyCollectionsFromParentDocument = gql`
    mutation UnpinManyCollectionsFromParent($data: UnpinManyCollectionsFromParentInput!) {
  unpinManyCollectionsFromParent(data: $data) {
    success
    message
    deleted {
      id
    }
  }
}
    `;
export type UnpinManyCollectionsFromParentMutationFn = Apollo.MutationFunction<UnpinManyCollectionsFromParentMutation, UnpinManyCollectionsFromParentMutationVariables>;

/**
 * __useUnpinManyCollectionsFromParentMutation__
 *
 * To run a mutation, you first call `useUnpinManyCollectionsFromParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinManyCollectionsFromParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinManyCollectionsFromParentMutation, { data, loading, error }] = useUnpinManyCollectionsFromParentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnpinManyCollectionsFromParentMutation(baseOptions?: Apollo.MutationHookOptions<UnpinManyCollectionsFromParentMutation, UnpinManyCollectionsFromParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinManyCollectionsFromParentMutation, UnpinManyCollectionsFromParentMutationVariables>(UnpinManyCollectionsFromParentDocument, options);
      }
export type UnpinManyCollectionsFromParentMutationHookResult = ReturnType<typeof useUnpinManyCollectionsFromParentMutation>;
export type UnpinManyCollectionsFromParentMutationResult = Apollo.MutationResult<UnpinManyCollectionsFromParentMutation>;
export type UnpinManyCollectionsFromParentMutationOptions = Apollo.BaseMutationOptions<UnpinManyCollectionsFromParentMutation, UnpinManyCollectionsFromParentMutationVariables>;
export const UnpinManyCollectionsFromRootDocument = gql`
    mutation UnpinManyCollectionsFromRoot($data: UnpinCollectionsInput!) {
  unpinCollectionsFromRoot(data: $data) {
    success
    message
    deleted {
      id
    }
  }
}
    `;
export type UnpinManyCollectionsFromRootMutationFn = Apollo.MutationFunction<UnpinManyCollectionsFromRootMutation, UnpinManyCollectionsFromRootMutationVariables>;

/**
 * __useUnpinManyCollectionsFromRootMutation__
 *
 * To run a mutation, you first call `useUnpinManyCollectionsFromRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinManyCollectionsFromRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinManyCollectionsFromRootMutation, { data, loading, error }] = useUnpinManyCollectionsFromRootMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnpinManyCollectionsFromRootMutation(baseOptions?: Apollo.MutationHookOptions<UnpinManyCollectionsFromRootMutation, UnpinManyCollectionsFromRootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinManyCollectionsFromRootMutation, UnpinManyCollectionsFromRootMutationVariables>(UnpinManyCollectionsFromRootDocument, options);
      }
export type UnpinManyCollectionsFromRootMutationHookResult = ReturnType<typeof useUnpinManyCollectionsFromRootMutation>;
export type UnpinManyCollectionsFromRootMutationResult = Apollo.MutationResult<UnpinManyCollectionsFromRootMutation>;
export type UnpinManyCollectionsFromRootMutationOptions = Apollo.BaseMutationOptions<UnpinManyCollectionsFromRootMutation, UnpinManyCollectionsFromRootMutationVariables>;
export const PinCollectionToRootDocument = gql`
    mutation PinCollectionToRoot($data: PinCollectionInput!) {
  pinCollectionToRoot(data: $data) {
    id
    collection {
      ...CollectionFragmentCollectionCardView
    }
  }
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;
export type PinCollectionToRootMutationFn = Apollo.MutationFunction<PinCollectionToRootMutation, PinCollectionToRootMutationVariables>;

/**
 * __usePinCollectionToRootMutation__
 *
 * To run a mutation, you first call `usePinCollectionToRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinCollectionToRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinCollectionToRootMutation, { data, loading, error }] = usePinCollectionToRootMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePinCollectionToRootMutation(baseOptions?: Apollo.MutationHookOptions<PinCollectionToRootMutation, PinCollectionToRootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinCollectionToRootMutation, PinCollectionToRootMutationVariables>(PinCollectionToRootDocument, options);
      }
export type PinCollectionToRootMutationHookResult = ReturnType<typeof usePinCollectionToRootMutation>;
export type PinCollectionToRootMutationResult = Apollo.MutationResult<PinCollectionToRootMutation>;
export type PinCollectionToRootMutationOptions = Apollo.BaseMutationOptions<PinCollectionToRootMutation, PinCollectionToRootMutationVariables>;
export const PinCollectionsToRootDocument = gql`
    mutation PinCollectionsToRoot($data: PinCollectionsInput!) {
  pinCollectionsToRoot(data: $data) {
    id
    collection {
      ...CollectionFragmentCollectionCardView
    }
  }
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;
export type PinCollectionsToRootMutationFn = Apollo.MutationFunction<PinCollectionsToRootMutation, PinCollectionsToRootMutationVariables>;

/**
 * __usePinCollectionsToRootMutation__
 *
 * To run a mutation, you first call `usePinCollectionsToRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinCollectionsToRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinCollectionsToRootMutation, { data, loading, error }] = usePinCollectionsToRootMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePinCollectionsToRootMutation(baseOptions?: Apollo.MutationHookOptions<PinCollectionsToRootMutation, PinCollectionsToRootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinCollectionsToRootMutation, PinCollectionsToRootMutationVariables>(PinCollectionsToRootDocument, options);
      }
export type PinCollectionsToRootMutationHookResult = ReturnType<typeof usePinCollectionsToRootMutation>;
export type PinCollectionsToRootMutationResult = Apollo.MutationResult<PinCollectionsToRootMutation>;
export type PinCollectionsToRootMutationOptions = Apollo.BaseMutationOptions<PinCollectionsToRootMutation, PinCollectionsToRootMutationVariables>;
export const UnpinCollectionFromRootDocument = gql`
    mutation UnpinCollectionFromRoot($data: UnpinCollectionInput!) {
  unpinCollectionFromRoot(data: $data) {
    success
    message
    deleted {
      id
    }
  }
}
    `;
export type UnpinCollectionFromRootMutationFn = Apollo.MutationFunction<UnpinCollectionFromRootMutation, UnpinCollectionFromRootMutationVariables>;

/**
 * __useUnpinCollectionFromRootMutation__
 *
 * To run a mutation, you first call `useUnpinCollectionFromRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinCollectionFromRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinCollectionFromRootMutation, { data, loading, error }] = useUnpinCollectionFromRootMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnpinCollectionFromRootMutation(baseOptions?: Apollo.MutationHookOptions<UnpinCollectionFromRootMutation, UnpinCollectionFromRootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinCollectionFromRootMutation, UnpinCollectionFromRootMutationVariables>(UnpinCollectionFromRootDocument, options);
      }
export type UnpinCollectionFromRootMutationHookResult = ReturnType<typeof useUnpinCollectionFromRootMutation>;
export type UnpinCollectionFromRootMutationResult = Apollo.MutationResult<UnpinCollectionFromRootMutation>;
export type UnpinCollectionFromRootMutationOptions = Apollo.BaseMutationOptions<UnpinCollectionFromRootMutation, UnpinCollectionFromRootMutationVariables>;
export const PinManyPostsToCollectionDocument = gql`
    mutation PinManyPostsToCollection($data: PinManyPostsToCollectionInput!) {
  pinManyPostsToCollection(data: $data) {
    id
  }
}
    `;
export type PinManyPostsToCollectionMutationFn = Apollo.MutationFunction<PinManyPostsToCollectionMutation, PinManyPostsToCollectionMutationVariables>;

/**
 * __usePinManyPostsToCollectionMutation__
 *
 * To run a mutation, you first call `usePinManyPostsToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinManyPostsToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinManyPostsToCollectionMutation, { data, loading, error }] = usePinManyPostsToCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePinManyPostsToCollectionMutation(baseOptions?: Apollo.MutationHookOptions<PinManyPostsToCollectionMutation, PinManyPostsToCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinManyPostsToCollectionMutation, PinManyPostsToCollectionMutationVariables>(PinManyPostsToCollectionDocument, options);
      }
export type PinManyPostsToCollectionMutationHookResult = ReturnType<typeof usePinManyPostsToCollectionMutation>;
export type PinManyPostsToCollectionMutationResult = Apollo.MutationResult<PinManyPostsToCollectionMutation>;
export type PinManyPostsToCollectionMutationOptions = Apollo.BaseMutationOptions<PinManyPostsToCollectionMutation, PinManyPostsToCollectionMutationVariables>;
export const UnpinManyPostsFromCollectionDocument = gql`
    mutation UnpinManyPostsFromCollection($data: UnpinManyPostsFromCollectionInput!) {
  unpinManyPostsFromCollection(data: $data) {
    success
    message
    deleted {
      id
    }
  }
}
    `;
export type UnpinManyPostsFromCollectionMutationFn = Apollo.MutationFunction<UnpinManyPostsFromCollectionMutation, UnpinManyPostsFromCollectionMutationVariables>;

/**
 * __useUnpinManyPostsFromCollectionMutation__
 *
 * To run a mutation, you first call `useUnpinManyPostsFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinManyPostsFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinManyPostsFromCollectionMutation, { data, loading, error }] = useUnpinManyPostsFromCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnpinManyPostsFromCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UnpinManyPostsFromCollectionMutation, UnpinManyPostsFromCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinManyPostsFromCollectionMutation, UnpinManyPostsFromCollectionMutationVariables>(UnpinManyPostsFromCollectionDocument, options);
      }
export type UnpinManyPostsFromCollectionMutationHookResult = ReturnType<typeof useUnpinManyPostsFromCollectionMutation>;
export type UnpinManyPostsFromCollectionMutationResult = Apollo.MutationResult<UnpinManyPostsFromCollectionMutation>;
export type UnpinManyPostsFromCollectionMutationOptions = Apollo.BaseMutationOptions<UnpinManyPostsFromCollectionMutation, UnpinManyPostsFromCollectionMutationVariables>;
export const GetPostForUsePostPermissionsDialogViewDocument = gql`
    query GetPostForUsePostPermissionsDialogView($postId: String!) {
  post(id: $postId) {
    id
    ...PostFragmentPostPermissionDialogView
  }
}
    ${PostFragmentPostPermissionDialogViewFragmentDoc}`;

/**
 * __useGetPostForUsePostPermissionsDialogViewQuery__
 *
 * To run a query within a React component, call `useGetPostForUsePostPermissionsDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForUsePostPermissionsDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForUsePostPermissionsDialogViewQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostForUsePostPermissionsDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetPostForUsePostPermissionsDialogViewQuery, GetPostForUsePostPermissionsDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForUsePostPermissionsDialogViewQuery, GetPostForUsePostPermissionsDialogViewQueryVariables>(GetPostForUsePostPermissionsDialogViewDocument, options);
      }
export function useGetPostForUsePostPermissionsDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForUsePostPermissionsDialogViewQuery, GetPostForUsePostPermissionsDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForUsePostPermissionsDialogViewQuery, GetPostForUsePostPermissionsDialogViewQueryVariables>(GetPostForUsePostPermissionsDialogViewDocument, options);
        }
export type GetPostForUsePostPermissionsDialogViewQueryHookResult = ReturnType<typeof useGetPostForUsePostPermissionsDialogViewQuery>;
export type GetPostForUsePostPermissionsDialogViewLazyQueryHookResult = ReturnType<typeof useGetPostForUsePostPermissionsDialogViewLazyQuery>;
export type GetPostForUsePostPermissionsDialogViewQueryResult = Apollo.QueryResult<GetPostForUsePostPermissionsDialogViewQuery, GetPostForUsePostPermissionsDialogViewQueryVariables>;
export const UpdatePostPermissionsDocument = gql`
    mutation UpdatePostPermissions($data: UpdatePostPermissionsInputV2!) {
  updatePostPermissionsV2(data: $data) {
    message
    success
  }
}
    `;
export type UpdatePostPermissionsMutationFn = Apollo.MutationFunction<UpdatePostPermissionsMutation, UpdatePostPermissionsMutationVariables>;

/**
 * __useUpdatePostPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdatePostPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostPermissionsMutation, { data, loading, error }] = useUpdatePostPermissionsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePostPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostPermissionsMutation, UpdatePostPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostPermissionsMutation, UpdatePostPermissionsMutationVariables>(UpdatePostPermissionsDocument, options);
      }
export type UpdatePostPermissionsMutationHookResult = ReturnType<typeof useUpdatePostPermissionsMutation>;
export type UpdatePostPermissionsMutationResult = Apollo.MutationResult<UpdatePostPermissionsMutation>;
export type UpdatePostPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdatePostPermissionsMutation, UpdatePostPermissionsMutationVariables>;
export const IsPostsPermissionLessThanParentCollectionPermissionDocument = gql`
    query IsPostsPermissionLessThanParentCollectionPermission($data: IsPostsPermissionLessThanParentCollectionPermissionInput!) {
  isPostsPermissionLessThanParentCollectionPermission(data: $data)
}
    `;

/**
 * __useIsPostsPermissionLessThanParentCollectionPermissionQuery__
 *
 * To run a query within a React component, call `useIsPostsPermissionLessThanParentCollectionPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPostsPermissionLessThanParentCollectionPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPostsPermissionLessThanParentCollectionPermissionQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIsPostsPermissionLessThanParentCollectionPermissionQuery(baseOptions: Apollo.QueryHookOptions<IsPostsPermissionLessThanParentCollectionPermissionQuery, IsPostsPermissionLessThanParentCollectionPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPostsPermissionLessThanParentCollectionPermissionQuery, IsPostsPermissionLessThanParentCollectionPermissionQueryVariables>(IsPostsPermissionLessThanParentCollectionPermissionDocument, options);
      }
export function useIsPostsPermissionLessThanParentCollectionPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPostsPermissionLessThanParentCollectionPermissionQuery, IsPostsPermissionLessThanParentCollectionPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPostsPermissionLessThanParentCollectionPermissionQuery, IsPostsPermissionLessThanParentCollectionPermissionQueryVariables>(IsPostsPermissionLessThanParentCollectionPermissionDocument, options);
        }
export type IsPostsPermissionLessThanParentCollectionPermissionQueryHookResult = ReturnType<typeof useIsPostsPermissionLessThanParentCollectionPermissionQuery>;
export type IsPostsPermissionLessThanParentCollectionPermissionLazyQueryHookResult = ReturnType<typeof useIsPostsPermissionLessThanParentCollectionPermissionLazyQuery>;
export type IsPostsPermissionLessThanParentCollectionPermissionQueryResult = Apollo.QueryResult<IsPostsPermissionLessThanParentCollectionPermissionQuery, IsPostsPermissionLessThanParentCollectionPermissionQueryVariables>;
export const GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionDocument = gql`
    query GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermission($id: String!) {
  collection(id: $id) {
    id
    ...CollectionFragmentUpdatePostPermissionAlertView
  }
}
    ${CollectionFragmentUpdatePostPermissionAlertViewFragmentDoc}`;

/**
 * __useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery__
 *
 * To run a query within a React component, call `useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery, GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery, GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryVariables>(GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionDocument, options);
      }
export function useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery, GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery, GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryVariables>(GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionDocument, options);
        }
export type GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryHookResult = ReturnType<typeof useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery>;
export type GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionLazyQueryHookResult = ReturnType<typeof useGetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionLazyQuery>;
export type GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryResult = Apollo.QueryResult<GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQuery, GetCollectionForUsePostPermissionUpdatePostPermissionToCollectionPermissionQueryVariables>;
export const GetPostPermissionForDialogViewDocument = gql`
    query GetPostPermissionForDialogView($postId: String!) {
  post(id: $postId) {
    ...PostFragmentPostPermissionDialogBody
  }
}
    ${PostFragmentPostPermissionDialogBodyFragmentDoc}`;

/**
 * __useGetPostPermissionForDialogViewQuery__
 *
 * To run a query within a React component, call `useGetPostPermissionForDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostPermissionForDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostPermissionForDialogViewQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostPermissionForDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetPostPermissionForDialogViewQuery, GetPostPermissionForDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostPermissionForDialogViewQuery, GetPostPermissionForDialogViewQueryVariables>(GetPostPermissionForDialogViewDocument, options);
      }
export function useGetPostPermissionForDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostPermissionForDialogViewQuery, GetPostPermissionForDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostPermissionForDialogViewQuery, GetPostPermissionForDialogViewQueryVariables>(GetPostPermissionForDialogViewDocument, options);
        }
export type GetPostPermissionForDialogViewQueryHookResult = ReturnType<typeof useGetPostPermissionForDialogViewQuery>;
export type GetPostPermissionForDialogViewLazyQueryHookResult = ReturnType<typeof useGetPostPermissionForDialogViewLazyQuery>;
export type GetPostPermissionForDialogViewQueryResult = Apollo.QueryResult<GetPostPermissionForDialogViewQuery, GetPostPermissionForDialogViewQueryVariables>;
export const GetPostSuggestedAuthForPostPermissionSuggestedDialogDocument = gql`
    query GetPostSuggestedAuthForPostPermissionSuggestedDialog($collectionIds: [String!]!) {
  getPostSuggestedAuth(collectionIds: $collectionIds) {
    ...PostSuggestedAuthFragmentPostPermissionSuggestedAuthDialogBody
  }
}
    ${PostSuggestedAuthFragmentPostPermissionSuggestedAuthDialogBodyFragmentDoc}`;

/**
 * __useGetPostSuggestedAuthForPostPermissionSuggestedDialogQuery__
 *
 * To run a query within a React component, call `useGetPostSuggestedAuthForPostPermissionSuggestedDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostSuggestedAuthForPostPermissionSuggestedDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostSuggestedAuthForPostPermissionSuggestedDialogQuery({
 *   variables: {
 *      collectionIds: // value for 'collectionIds'
 *   },
 * });
 */
export function useGetPostSuggestedAuthForPostPermissionSuggestedDialogQuery(baseOptions: Apollo.QueryHookOptions<GetPostSuggestedAuthForPostPermissionSuggestedDialogQuery, GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostSuggestedAuthForPostPermissionSuggestedDialogQuery, GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryVariables>(GetPostSuggestedAuthForPostPermissionSuggestedDialogDocument, options);
      }
export function useGetPostSuggestedAuthForPostPermissionSuggestedDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostSuggestedAuthForPostPermissionSuggestedDialogQuery, GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostSuggestedAuthForPostPermissionSuggestedDialogQuery, GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryVariables>(GetPostSuggestedAuthForPostPermissionSuggestedDialogDocument, options);
        }
export type GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryHookResult = ReturnType<typeof useGetPostSuggestedAuthForPostPermissionSuggestedDialogQuery>;
export type GetPostSuggestedAuthForPostPermissionSuggestedDialogLazyQueryHookResult = ReturnType<typeof useGetPostSuggestedAuthForPostPermissionSuggestedDialogLazyQuery>;
export type GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryResult = Apollo.QueryResult<GetPostSuggestedAuthForPostPermissionSuggestedDialogQuery, GetPostSuggestedAuthForPostPermissionSuggestedDialogQueryVariables>;
export const UpdatePostPermissionToCollectionPermissionDocument = gql`
    mutation UpdatePostPermissionToCollectionPermission($data: UpdatePostPermissionToCollectionPermissionInput!) {
  updatePostPermissionToCollectionPermission(data: $data) {
    success
    message
  }
}
    `;
export type UpdatePostPermissionToCollectionPermissionMutationFn = Apollo.MutationFunction<UpdatePostPermissionToCollectionPermissionMutation, UpdatePostPermissionToCollectionPermissionMutationVariables>;

/**
 * __useUpdatePostPermissionToCollectionPermissionMutation__
 *
 * To run a mutation, you first call `useUpdatePostPermissionToCollectionPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostPermissionToCollectionPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostPermissionToCollectionPermissionMutation, { data, loading, error }] = useUpdatePostPermissionToCollectionPermissionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePostPermissionToCollectionPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostPermissionToCollectionPermissionMutation, UpdatePostPermissionToCollectionPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostPermissionToCollectionPermissionMutation, UpdatePostPermissionToCollectionPermissionMutationVariables>(UpdatePostPermissionToCollectionPermissionDocument, options);
      }
export type UpdatePostPermissionToCollectionPermissionMutationHookResult = ReturnType<typeof useUpdatePostPermissionToCollectionPermissionMutation>;
export type UpdatePostPermissionToCollectionPermissionMutationResult = Apollo.MutationResult<UpdatePostPermissionToCollectionPermissionMutation>;
export type UpdatePostPermissionToCollectionPermissionMutationOptions = Apollo.BaseMutationOptions<UpdatePostPermissionToCollectionPermissionMutation, UpdatePostPermissionToCollectionPermissionMutationVariables>;
export const UpdateCollectionPermissionToParentCollectionPermissionDocument = gql`
    mutation UpdateCollectionPermissionToParentCollectionPermission($data: UpdateCollectionPermissionToParentCollectionPermissionInput!) {
  updateCollectionPermissionToParentCollectionPermission(data: $data) {
    success
    message
  }
}
    `;
export type UpdateCollectionPermissionToParentCollectionPermissionMutationFn = Apollo.MutationFunction<UpdateCollectionPermissionToParentCollectionPermissionMutation, UpdateCollectionPermissionToParentCollectionPermissionMutationVariables>;

/**
 * __useUpdateCollectionPermissionToParentCollectionPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionPermissionToParentCollectionPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionPermissionToParentCollectionPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionPermissionToParentCollectionPermissionMutation, { data, loading, error }] = useUpdateCollectionPermissionToParentCollectionPermissionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCollectionPermissionToParentCollectionPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionPermissionToParentCollectionPermissionMutation, UpdateCollectionPermissionToParentCollectionPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionPermissionToParentCollectionPermissionMutation, UpdateCollectionPermissionToParentCollectionPermissionMutationVariables>(UpdateCollectionPermissionToParentCollectionPermissionDocument, options);
      }
export type UpdateCollectionPermissionToParentCollectionPermissionMutationHookResult = ReturnType<typeof useUpdateCollectionPermissionToParentCollectionPermissionMutation>;
export type UpdateCollectionPermissionToParentCollectionPermissionMutationResult = Apollo.MutationResult<UpdateCollectionPermissionToParentCollectionPermissionMutation>;
export type UpdateCollectionPermissionToParentCollectionPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionPermissionToParentCollectionPermissionMutation, UpdateCollectionPermissionToParentCollectionPermissionMutationVariables>;
export const GetPostForPostBookmarkPopoverDocument = gql`
    query GetPostForPostBookmarkPopover($id: String!) {
  post(id: $id) {
    id
    ...PostFragmentPostPreview
    collections {
      id
      ...CollectionFragmentCollectionMenuItemView
    }
  }
}
    ${PostFragmentPostPreviewFragmentDoc}
${CollectionFragmentCollectionMenuItemViewFragmentDoc}`;

/**
 * __useGetPostForPostBookmarkPopoverQuery__
 *
 * To run a query within a React component, call `useGetPostForPostBookmarkPopoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForPostBookmarkPopoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForPostBookmarkPopoverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForPostBookmarkPopoverQuery(baseOptions: Apollo.QueryHookOptions<GetPostForPostBookmarkPopoverQuery, GetPostForPostBookmarkPopoverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForPostBookmarkPopoverQuery, GetPostForPostBookmarkPopoverQueryVariables>(GetPostForPostBookmarkPopoverDocument, options);
      }
export function useGetPostForPostBookmarkPopoverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForPostBookmarkPopoverQuery, GetPostForPostBookmarkPopoverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForPostBookmarkPopoverQuery, GetPostForPostBookmarkPopoverQueryVariables>(GetPostForPostBookmarkPopoverDocument, options);
        }
export type GetPostForPostBookmarkPopoverQueryHookResult = ReturnType<typeof useGetPostForPostBookmarkPopoverQuery>;
export type GetPostForPostBookmarkPopoverLazyQueryHookResult = ReturnType<typeof useGetPostForPostBookmarkPopoverLazyQuery>;
export type GetPostForPostBookmarkPopoverQueryResult = Apollo.QueryResult<GetPostForPostBookmarkPopoverQuery, GetPostForPostBookmarkPopoverQueryVariables>;
export const CreatePostFavoriteForPostBookmarkButtonDocument = gql`
    mutation CreatePostFavoriteForPostBookmarkButton($data: CreatePostFavoriteInputV2!) {
  createPostFavoriteV2(data: $data) {
    id
  }
}
    `;
export type CreatePostFavoriteForPostBookmarkButtonMutationFn = Apollo.MutationFunction<CreatePostFavoriteForPostBookmarkButtonMutation, CreatePostFavoriteForPostBookmarkButtonMutationVariables>;

/**
 * __useCreatePostFavoriteForPostBookmarkButtonMutation__
 *
 * To run a mutation, you first call `useCreatePostFavoriteForPostBookmarkButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostFavoriteForPostBookmarkButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostFavoriteForPostBookmarkButtonMutation, { data, loading, error }] = useCreatePostFavoriteForPostBookmarkButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostFavoriteForPostBookmarkButtonMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostFavoriteForPostBookmarkButtonMutation, CreatePostFavoriteForPostBookmarkButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostFavoriteForPostBookmarkButtonMutation, CreatePostFavoriteForPostBookmarkButtonMutationVariables>(CreatePostFavoriteForPostBookmarkButtonDocument, options);
      }
export type CreatePostFavoriteForPostBookmarkButtonMutationHookResult = ReturnType<typeof useCreatePostFavoriteForPostBookmarkButtonMutation>;
export type CreatePostFavoriteForPostBookmarkButtonMutationResult = Apollo.MutationResult<CreatePostFavoriteForPostBookmarkButtonMutation>;
export type CreatePostFavoriteForPostBookmarkButtonMutationOptions = Apollo.BaseMutationOptions<CreatePostFavoriteForPostBookmarkButtonMutation, CreatePostFavoriteForPostBookmarkButtonMutationVariables>;
export const DeletePostFavoriteForPostBookmarkButtonDocument = gql`
    mutation DeletePostFavoriteForPostBookmarkButton($data: DeletePostFavoriteInputV2!) {
  deletePostFavoriteV2(data: $data) {
    success
    message
  }
}
    `;
export type DeletePostFavoriteForPostBookmarkButtonMutationFn = Apollo.MutationFunction<DeletePostFavoriteForPostBookmarkButtonMutation, DeletePostFavoriteForPostBookmarkButtonMutationVariables>;

/**
 * __useDeletePostFavoriteForPostBookmarkButtonMutation__
 *
 * To run a mutation, you first call `useDeletePostFavoriteForPostBookmarkButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostFavoriteForPostBookmarkButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostFavoriteForPostBookmarkButtonMutation, { data, loading, error }] = useDeletePostFavoriteForPostBookmarkButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePostFavoriteForPostBookmarkButtonMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostFavoriteForPostBookmarkButtonMutation, DeletePostFavoriteForPostBookmarkButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostFavoriteForPostBookmarkButtonMutation, DeletePostFavoriteForPostBookmarkButtonMutationVariables>(DeletePostFavoriteForPostBookmarkButtonDocument, options);
      }
export type DeletePostFavoriteForPostBookmarkButtonMutationHookResult = ReturnType<typeof useDeletePostFavoriteForPostBookmarkButtonMutation>;
export type DeletePostFavoriteForPostBookmarkButtonMutationResult = Apollo.MutationResult<DeletePostFavoriteForPostBookmarkButtonMutation>;
export type DeletePostFavoriteForPostBookmarkButtonMutationOptions = Apollo.BaseMutationOptions<DeletePostFavoriteForPostBookmarkButtonMutation, DeletePostFavoriteForPostBookmarkButtonMutationVariables>;
export const AddPostToCollectionForPostBookmarkPopoverDocument = gql`
    mutation AddPostToCollectionForPostBookmarkPopover($data: AddPostToCollectionInput!) {
  addPostToCollection(data: $data) {
    success
    message
  }
}
    `;
export type AddPostToCollectionForPostBookmarkPopoverMutationFn = Apollo.MutationFunction<AddPostToCollectionForPostBookmarkPopoverMutation, AddPostToCollectionForPostBookmarkPopoverMutationVariables>;

/**
 * __useAddPostToCollectionForPostBookmarkPopoverMutation__
 *
 * To run a mutation, you first call `useAddPostToCollectionForPostBookmarkPopoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostToCollectionForPostBookmarkPopoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostToCollectionForPostBookmarkPopoverMutation, { data, loading, error }] = useAddPostToCollectionForPostBookmarkPopoverMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPostToCollectionForPostBookmarkPopoverMutation(baseOptions?: Apollo.MutationHookOptions<AddPostToCollectionForPostBookmarkPopoverMutation, AddPostToCollectionForPostBookmarkPopoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostToCollectionForPostBookmarkPopoverMutation, AddPostToCollectionForPostBookmarkPopoverMutationVariables>(AddPostToCollectionForPostBookmarkPopoverDocument, options);
      }
export type AddPostToCollectionForPostBookmarkPopoverMutationHookResult = ReturnType<typeof useAddPostToCollectionForPostBookmarkPopoverMutation>;
export type AddPostToCollectionForPostBookmarkPopoverMutationResult = Apollo.MutationResult<AddPostToCollectionForPostBookmarkPopoverMutation>;
export type AddPostToCollectionForPostBookmarkPopoverMutationOptions = Apollo.BaseMutationOptions<AddPostToCollectionForPostBookmarkPopoverMutation, AddPostToCollectionForPostBookmarkPopoverMutationVariables>;
export const RemovePostFromCollectionForPostBookmarkPopoverDocument = gql`
    mutation RemovePostFromCollectionForPostBookmarkPopover($data: RemovePostFromCollectionInput!) {
  removePostFromCollection(data: $data) {
    success
    message
  }
}
    `;
export type RemovePostFromCollectionForPostBookmarkPopoverMutationFn = Apollo.MutationFunction<RemovePostFromCollectionForPostBookmarkPopoverMutation, RemovePostFromCollectionForPostBookmarkPopoverMutationVariables>;

/**
 * __useRemovePostFromCollectionForPostBookmarkPopoverMutation__
 *
 * To run a mutation, you first call `useRemovePostFromCollectionForPostBookmarkPopoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePostFromCollectionForPostBookmarkPopoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePostFromCollectionForPostBookmarkPopoverMutation, { data, loading, error }] = useRemovePostFromCollectionForPostBookmarkPopoverMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePostFromCollectionForPostBookmarkPopoverMutation(baseOptions?: Apollo.MutationHookOptions<RemovePostFromCollectionForPostBookmarkPopoverMutation, RemovePostFromCollectionForPostBookmarkPopoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePostFromCollectionForPostBookmarkPopoverMutation, RemovePostFromCollectionForPostBookmarkPopoverMutationVariables>(RemovePostFromCollectionForPostBookmarkPopoverDocument, options);
      }
export type RemovePostFromCollectionForPostBookmarkPopoverMutationHookResult = ReturnType<typeof useRemovePostFromCollectionForPostBookmarkPopoverMutation>;
export type RemovePostFromCollectionForPostBookmarkPopoverMutationResult = Apollo.MutationResult<RemovePostFromCollectionForPostBookmarkPopoverMutation>;
export type RemovePostFromCollectionForPostBookmarkPopoverMutationOptions = Apollo.BaseMutationOptions<RemovePostFromCollectionForPostBookmarkPopoverMutation, RemovePostFromCollectionForPostBookmarkPopoverMutationVariables>;
export const DeleteTrendFavoriteForPostCollectionListDocument = gql`
    mutation DeleteTrendFavoriteForPostCollectionList($data: DeleteTrendFavoriteInput!) {
  deleteTrendFavorite(data: $data) {
    success
    message
  }
}
    `;
export type DeleteTrendFavoriteForPostCollectionListMutationFn = Apollo.MutationFunction<DeleteTrendFavoriteForPostCollectionListMutation, DeleteTrendFavoriteForPostCollectionListMutationVariables>;

/**
 * __useDeleteTrendFavoriteForPostCollectionListMutation__
 *
 * To run a mutation, you first call `useDeleteTrendFavoriteForPostCollectionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrendFavoriteForPostCollectionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrendFavoriteForPostCollectionListMutation, { data, loading, error }] = useDeleteTrendFavoriteForPostCollectionListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteTrendFavoriteForPostCollectionListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrendFavoriteForPostCollectionListMutation, DeleteTrendFavoriteForPostCollectionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrendFavoriteForPostCollectionListMutation, DeleteTrendFavoriteForPostCollectionListMutationVariables>(DeleteTrendFavoriteForPostCollectionListDocument, options);
      }
export type DeleteTrendFavoriteForPostCollectionListMutationHookResult = ReturnType<typeof useDeleteTrendFavoriteForPostCollectionListMutation>;
export type DeleteTrendFavoriteForPostCollectionListMutationResult = Apollo.MutationResult<DeleteTrendFavoriteForPostCollectionListMutation>;
export type DeleteTrendFavoriteForPostCollectionListMutationOptions = Apollo.BaseMutationOptions<DeleteTrendFavoriteForPostCollectionListMutation, DeleteTrendFavoriteForPostCollectionListMutationVariables>;
export const GetPostForPostCollectionListDocument = gql`
    query GetPostForPostCollectionList($id: String!) {
  post(id: $id) {
    id
    collections {
      id
      name
      myPermissions
      breadcrumbsFromRoot {
        id
        contentIdeaId
      }
      ...CollectionFragmentCollectionBreadcrumbs
    }
  }
}
    ${CollectionFragmentCollectionBreadcrumbsFragmentDoc}`;

/**
 * __useGetPostForPostCollectionListQuery__
 *
 * To run a query within a React component, call `useGetPostForPostCollectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForPostCollectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForPostCollectionListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForPostCollectionListQuery(baseOptions: Apollo.QueryHookOptions<GetPostForPostCollectionListQuery, GetPostForPostCollectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForPostCollectionListQuery, GetPostForPostCollectionListQueryVariables>(GetPostForPostCollectionListDocument, options);
      }
export function useGetPostForPostCollectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForPostCollectionListQuery, GetPostForPostCollectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForPostCollectionListQuery, GetPostForPostCollectionListQueryVariables>(GetPostForPostCollectionListDocument, options);
        }
export type GetPostForPostCollectionListQueryHookResult = ReturnType<typeof useGetPostForPostCollectionListQuery>;
export type GetPostForPostCollectionListLazyQueryHookResult = ReturnType<typeof useGetPostForPostCollectionListLazyQuery>;
export type GetPostForPostCollectionListQueryResult = Apollo.QueryResult<GetPostForPostCollectionListQuery, GetPostForPostCollectionListQueryVariables>;
export const AddPostToCollectionForPostCollectionListDocument = gql`
    mutation AddPostToCollectionForPostCollectionList($data: AddPostToCollectionInput!) {
  addPostToCollection(data: $data) {
    success
    message
  }
}
    `;
export type AddPostToCollectionForPostCollectionListMutationFn = Apollo.MutationFunction<AddPostToCollectionForPostCollectionListMutation, AddPostToCollectionForPostCollectionListMutationVariables>;

/**
 * __useAddPostToCollectionForPostCollectionListMutation__
 *
 * To run a mutation, you first call `useAddPostToCollectionForPostCollectionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostToCollectionForPostCollectionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostToCollectionForPostCollectionListMutation, { data, loading, error }] = useAddPostToCollectionForPostCollectionListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPostToCollectionForPostCollectionListMutation(baseOptions?: Apollo.MutationHookOptions<AddPostToCollectionForPostCollectionListMutation, AddPostToCollectionForPostCollectionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostToCollectionForPostCollectionListMutation, AddPostToCollectionForPostCollectionListMutationVariables>(AddPostToCollectionForPostCollectionListDocument, options);
      }
export type AddPostToCollectionForPostCollectionListMutationHookResult = ReturnType<typeof useAddPostToCollectionForPostCollectionListMutation>;
export type AddPostToCollectionForPostCollectionListMutationResult = Apollo.MutationResult<AddPostToCollectionForPostCollectionListMutation>;
export type AddPostToCollectionForPostCollectionListMutationOptions = Apollo.BaseMutationOptions<AddPostToCollectionForPostCollectionListMutation, AddPostToCollectionForPostCollectionListMutationVariables>;
export const RemovePostFromCollectionForPostCollectionListDocument = gql`
    mutation RemovePostFromCollectionForPostCollectionList($data: RemovePostFromCollectionInput!) {
  removePostFromCollection(data: $data) {
    success
    message
  }
}
    `;
export type RemovePostFromCollectionForPostCollectionListMutationFn = Apollo.MutationFunction<RemovePostFromCollectionForPostCollectionListMutation, RemovePostFromCollectionForPostCollectionListMutationVariables>;

/**
 * __useRemovePostFromCollectionForPostCollectionListMutation__
 *
 * To run a mutation, you first call `useRemovePostFromCollectionForPostCollectionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePostFromCollectionForPostCollectionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePostFromCollectionForPostCollectionListMutation, { data, loading, error }] = useRemovePostFromCollectionForPostCollectionListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePostFromCollectionForPostCollectionListMutation(baseOptions?: Apollo.MutationHookOptions<RemovePostFromCollectionForPostCollectionListMutation, RemovePostFromCollectionForPostCollectionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePostFromCollectionForPostCollectionListMutation, RemovePostFromCollectionForPostCollectionListMutationVariables>(RemovePostFromCollectionForPostCollectionListDocument, options);
      }
export type RemovePostFromCollectionForPostCollectionListMutationHookResult = ReturnType<typeof useRemovePostFromCollectionForPostCollectionListMutation>;
export type RemovePostFromCollectionForPostCollectionListMutationResult = Apollo.MutationResult<RemovePostFromCollectionForPostCollectionListMutation>;
export type RemovePostFromCollectionForPostCollectionListMutationOptions = Apollo.BaseMutationOptions<RemovePostFromCollectionForPostCollectionListMutation, RemovePostFromCollectionForPostCollectionListMutationVariables>;
export const RemovePostFromCollectionForPostContextMenuDocument = gql`
    mutation RemovePostFromCollectionForPostContextMenu($data: RemovePostFromCollectionInput!) {
  removePostFromCollection(data: $data) {
    message
    success
  }
}
    `;
export type RemovePostFromCollectionForPostContextMenuMutationFn = Apollo.MutationFunction<RemovePostFromCollectionForPostContextMenuMutation, RemovePostFromCollectionForPostContextMenuMutationVariables>;

/**
 * __useRemovePostFromCollectionForPostContextMenuMutation__
 *
 * To run a mutation, you first call `useRemovePostFromCollectionForPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePostFromCollectionForPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePostFromCollectionForPostContextMenuMutation, { data, loading, error }] = useRemovePostFromCollectionForPostContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePostFromCollectionForPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<RemovePostFromCollectionForPostContextMenuMutation, RemovePostFromCollectionForPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePostFromCollectionForPostContextMenuMutation, RemovePostFromCollectionForPostContextMenuMutationVariables>(RemovePostFromCollectionForPostContextMenuDocument, options);
      }
export type RemovePostFromCollectionForPostContextMenuMutationHookResult = ReturnType<typeof useRemovePostFromCollectionForPostContextMenuMutation>;
export type RemovePostFromCollectionForPostContextMenuMutationResult = Apollo.MutationResult<RemovePostFromCollectionForPostContextMenuMutation>;
export type RemovePostFromCollectionForPostContextMenuMutationOptions = Apollo.BaseMutationOptions<RemovePostFromCollectionForPostContextMenuMutation, RemovePostFromCollectionForPostContextMenuMutationVariables>;
export const DeletePostForPostContextMenuDocument = gql`
    mutation DeletePostForPostContextMenu($id: String!) {
  deletePost(id: $id) {
    message
    success
  }
}
    `;
export type DeletePostForPostContextMenuMutationFn = Apollo.MutationFunction<DeletePostForPostContextMenuMutation, DeletePostForPostContextMenuMutationVariables>;

/**
 * __useDeletePostForPostContextMenuMutation__
 *
 * To run a mutation, you first call `useDeletePostForPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostForPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostForPostContextMenuMutation, { data, loading, error }] = useDeletePostForPostContextMenuMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostForPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostForPostContextMenuMutation, DeletePostForPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostForPostContextMenuMutation, DeletePostForPostContextMenuMutationVariables>(DeletePostForPostContextMenuDocument, options);
      }
export type DeletePostForPostContextMenuMutationHookResult = ReturnType<typeof useDeletePostForPostContextMenuMutation>;
export type DeletePostForPostContextMenuMutationResult = Apollo.MutationResult<DeletePostForPostContextMenuMutation>;
export type DeletePostForPostContextMenuMutationOptions = Apollo.BaseMutationOptions<DeletePostForPostContextMenuMutation, DeletePostForPostContextMenuMutationVariables>;
export const DuplicatePostForPostContextMenuDocument = gql`
    mutation DuplicatePostForPostContextMenu($data: DuplicatePostInput!) {
  duplicatePost(data: $data) {
    id
    collections {
      id
    }
    ...PostFragmentPostMasonryCardView
  }
}
    ${PostFragmentPostMasonryCardViewFragmentDoc}`;
export type DuplicatePostForPostContextMenuMutationFn = Apollo.MutationFunction<DuplicatePostForPostContextMenuMutation, DuplicatePostForPostContextMenuMutationVariables>;

/**
 * __useDuplicatePostForPostContextMenuMutation__
 *
 * To run a mutation, you first call `useDuplicatePostForPostContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePostForPostContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePostForPostContextMenuMutation, { data, loading, error }] = useDuplicatePostForPostContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDuplicatePostForPostContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePostForPostContextMenuMutation, DuplicatePostForPostContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePostForPostContextMenuMutation, DuplicatePostForPostContextMenuMutationVariables>(DuplicatePostForPostContextMenuDocument, options);
      }
export type DuplicatePostForPostContextMenuMutationHookResult = ReturnType<typeof useDuplicatePostForPostContextMenuMutation>;
export type DuplicatePostForPostContextMenuMutationResult = Apollo.MutationResult<DuplicatePostForPostContextMenuMutation>;
export type DuplicatePostForPostContextMenuMutationOptions = Apollo.BaseMutationOptions<DuplicatePostForPostContextMenuMutation, DuplicatePostForPostContextMenuMutationVariables>;
export const UpdatePostForPostDescriptionDocument = gql`
    mutation UpdatePostForPostDescription($data: UpdatePostInput!) {
  updatePost(data: $data) {
    id
    ...PostFragmentPostDescription
  }
}
    ${PostFragmentPostDescriptionFragmentDoc}`;
export type UpdatePostForPostDescriptionMutationFn = Apollo.MutationFunction<UpdatePostForPostDescriptionMutation, UpdatePostForPostDescriptionMutationVariables>;

/**
 * __useUpdatePostForPostDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdatePostForPostDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostForPostDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostForPostDescriptionMutation, { data, loading, error }] = useUpdatePostForPostDescriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePostForPostDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostForPostDescriptionMutation, UpdatePostForPostDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostForPostDescriptionMutation, UpdatePostForPostDescriptionMutationVariables>(UpdatePostForPostDescriptionDocument, options);
      }
export type UpdatePostForPostDescriptionMutationHookResult = ReturnType<typeof useUpdatePostForPostDescriptionMutation>;
export type UpdatePostForPostDescriptionMutationResult = Apollo.MutationResult<UpdatePostForPostDescriptionMutation>;
export type UpdatePostForPostDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdatePostForPostDescriptionMutation, UpdatePostForPostDescriptionMutationVariables>;
export const ReactToPostForPostReactionButtonDocument = gql`
    mutation ReactToPostForPostReactionButton($data: ReactToPostInput!) {
  reactToPost(data: $data) {
    success
    message
  }
}
    `;
export type ReactToPostForPostReactionButtonMutationFn = Apollo.MutationFunction<ReactToPostForPostReactionButtonMutation, ReactToPostForPostReactionButtonMutationVariables>;

/**
 * __useReactToPostForPostReactionButtonMutation__
 *
 * To run a mutation, you first call `useReactToPostForPostReactionButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToPostForPostReactionButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToPostForPostReactionButtonMutation, { data, loading, error }] = useReactToPostForPostReactionButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReactToPostForPostReactionButtonMutation(baseOptions?: Apollo.MutationHookOptions<ReactToPostForPostReactionButtonMutation, ReactToPostForPostReactionButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactToPostForPostReactionButtonMutation, ReactToPostForPostReactionButtonMutationVariables>(ReactToPostForPostReactionButtonDocument, options);
      }
export type ReactToPostForPostReactionButtonMutationHookResult = ReturnType<typeof useReactToPostForPostReactionButtonMutation>;
export type ReactToPostForPostReactionButtonMutationResult = Apollo.MutationResult<ReactToPostForPostReactionButtonMutation>;
export type ReactToPostForPostReactionButtonMutationOptions = Apollo.BaseMutationOptions<ReactToPostForPostReactionButtonMutation, ReactToPostForPostReactionButtonMutationVariables>;
export const ReactToPostForPostReactionListDocument = gql`
    mutation ReactToPostForPostReactionList($data: ReactToPostInput!) {
  reactToPost(data: $data) {
    success
    message
  }
}
    `;
export type ReactToPostForPostReactionListMutationFn = Apollo.MutationFunction<ReactToPostForPostReactionListMutation, ReactToPostForPostReactionListMutationVariables>;

/**
 * __useReactToPostForPostReactionListMutation__
 *
 * To run a mutation, you first call `useReactToPostForPostReactionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToPostForPostReactionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToPostForPostReactionListMutation, { data, loading, error }] = useReactToPostForPostReactionListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReactToPostForPostReactionListMutation(baseOptions?: Apollo.MutationHookOptions<ReactToPostForPostReactionListMutation, ReactToPostForPostReactionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactToPostForPostReactionListMutation, ReactToPostForPostReactionListMutationVariables>(ReactToPostForPostReactionListDocument, options);
      }
export type ReactToPostForPostReactionListMutationHookResult = ReturnType<typeof useReactToPostForPostReactionListMutation>;
export type ReactToPostForPostReactionListMutationResult = Apollo.MutationResult<ReactToPostForPostReactionListMutation>;
export type ReactToPostForPostReactionListMutationOptions = Apollo.BaseMutationOptions<ReactToPostForPostReactionListMutation, ReactToPostForPostReactionListMutationVariables>;
export const AddPostsToContentCalendarForPostContentCalendarButtonDocument = gql`
    mutation AddPostsToContentCalendarForPostContentCalendarButton($data: AddPostsToContentCalendarInput!) {
  addPostsToContentCalendar(data: $data) {
    message
    success
  }
}
    `;
export type AddPostsToContentCalendarForPostContentCalendarButtonMutationFn = Apollo.MutationFunction<AddPostsToContentCalendarForPostContentCalendarButtonMutation, AddPostsToContentCalendarForPostContentCalendarButtonMutationVariables>;

/**
 * __useAddPostsToContentCalendarForPostContentCalendarButtonMutation__
 *
 * To run a mutation, you first call `useAddPostsToContentCalendarForPostContentCalendarButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostsToContentCalendarForPostContentCalendarButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostsToContentCalendarForPostContentCalendarButtonMutation, { data, loading, error }] = useAddPostsToContentCalendarForPostContentCalendarButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPostsToContentCalendarForPostContentCalendarButtonMutation(baseOptions?: Apollo.MutationHookOptions<AddPostsToContentCalendarForPostContentCalendarButtonMutation, AddPostsToContentCalendarForPostContentCalendarButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostsToContentCalendarForPostContentCalendarButtonMutation, AddPostsToContentCalendarForPostContentCalendarButtonMutationVariables>(AddPostsToContentCalendarForPostContentCalendarButtonDocument, options);
      }
export type AddPostsToContentCalendarForPostContentCalendarButtonMutationHookResult = ReturnType<typeof useAddPostsToContentCalendarForPostContentCalendarButtonMutation>;
export type AddPostsToContentCalendarForPostContentCalendarButtonMutationResult = Apollo.MutationResult<AddPostsToContentCalendarForPostContentCalendarButtonMutation>;
export type AddPostsToContentCalendarForPostContentCalendarButtonMutationOptions = Apollo.BaseMutationOptions<AddPostsToContentCalendarForPostContentCalendarButtonMutation, AddPostsToContentCalendarForPostContentCalendarButtonMutationVariables>;
export const UpdatePostTitleDocument = gql`
    mutation UpdatePostTitle($data: UpdatePostInput!) {
  updatePost(data: $data) {
    id
    title
  }
}
    `;
export type UpdatePostTitleMutationFn = Apollo.MutationFunction<UpdatePostTitleMutation, UpdatePostTitleMutationVariables>;

/**
 * __useUpdatePostTitleMutation__
 *
 * To run a mutation, you first call `useUpdatePostTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostTitleMutation, { data, loading, error }] = useUpdatePostTitleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePostTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostTitleMutation, UpdatePostTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostTitleMutation, UpdatePostTitleMutationVariables>(UpdatePostTitleDocument, options);
      }
export type UpdatePostTitleMutationHookResult = ReturnType<typeof useUpdatePostTitleMutation>;
export type UpdatePostTitleMutationResult = Apollo.MutationResult<UpdatePostTitleMutation>;
export type UpdatePostTitleMutationOptions = Apollo.BaseMutationOptions<UpdatePostTitleMutation, UpdatePostTitleMutationVariables>;
export const GetPostViewersDocument = gql`
    query GetPostViewers($id: String!) {
  post(id: $id) {
    ...PostFragmentPostViewers
  }
}
    ${PostFragmentPostViewersFragmentDoc}`;

/**
 * __useGetPostViewersQuery__
 *
 * To run a query within a React component, call `useGetPostViewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostViewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostViewersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostViewersQuery(baseOptions: Apollo.QueryHookOptions<GetPostViewersQuery, GetPostViewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostViewersQuery, GetPostViewersQueryVariables>(GetPostViewersDocument, options);
      }
export function useGetPostViewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostViewersQuery, GetPostViewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostViewersQuery, GetPostViewersQueryVariables>(GetPostViewersDocument, options);
        }
export type GetPostViewersQueryHookResult = ReturnType<typeof useGetPostViewersQuery>;
export type GetPostViewersLazyQueryHookResult = ReturnType<typeof useGetPostViewersLazyQuery>;
export type GetPostViewersQueryResult = Apollo.QueryResult<GetPostViewersQuery, GetPostViewersQueryVariables>;
export const MovePostsToCollectionForUseMoveToAnotherCollectionModalDocument = gql`
    mutation MovePostsToCollectionForUseMoveToAnotherCollectionModal($data: MovePostsToCollectionInput!) {
  movePostsToCollection(data: $data) {
    success
    message
  }
}
    `;
export type MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationFn = Apollo.MutationFunction<MovePostsToCollectionForUseMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>;

/**
 * __useMovePostsToCollectionForUseMoveToAnotherCollectionModalMutation__
 *
 * To run a mutation, you first call `useMovePostsToCollectionForUseMoveToAnotherCollectionModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePostsToCollectionForUseMoveToAnotherCollectionModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePostsToCollectionForUseMoveToAnotherCollectionModalMutation, { data, loading, error }] = useMovePostsToCollectionForUseMoveToAnotherCollectionModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMovePostsToCollectionForUseMoveToAnotherCollectionModalMutation(baseOptions?: Apollo.MutationHookOptions<MovePostsToCollectionForUseMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePostsToCollectionForUseMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>(MovePostsToCollectionForUseMoveToAnotherCollectionModalDocument, options);
      }
export type MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationHookResult = ReturnType<typeof useMovePostsToCollectionForUseMoveToAnotherCollectionModalMutation>;
export type MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationResult = Apollo.MutationResult<MovePostsToCollectionForUseMoveToAnotherCollectionModalMutation>;
export type MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationOptions = Apollo.BaseMutationOptions<MovePostsToCollectionForUseMoveToAnotherCollectionModalMutation, MovePostsToCollectionForUseMoveToAnotherCollectionModalMutationVariables>;
export const GetPostsSmartSearchForPostNavigationSearchParamsDocument = gql`
    query GetPostsSmartSearchForPostNavigationSearchParams($filters: PostFiltersForSmartSearch!, $take: Int, $after: String, $before: String, $sortType: SortType, $sortBy: SortByInputData) {
  postsSmartSearch(
    filters: $filters
    take: $take
    after: $after
    before: $before
    sortType: $sortType
    sortBy: $sortBy
  ) {
    data {
      item {
        ...PostFragmentUseNavigatePostSearchParams
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentUseNavigatePostSearchParamsFragmentDoc}`;

/**
 * __useGetPostsSmartSearchForPostNavigationSearchParamsQuery__
 *
 * To run a query within a React component, call `useGetPostsSmartSearchForPostNavigationSearchParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSmartSearchForPostNavigationSearchParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSmartSearchForPostNavigationSearchParamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sortType: // value for 'sortType'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetPostsSmartSearchForPostNavigationSearchParamsQuery(baseOptions: Apollo.QueryHookOptions<GetPostsSmartSearchForPostNavigationSearchParamsQuery, GetPostsSmartSearchForPostNavigationSearchParamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsSmartSearchForPostNavigationSearchParamsQuery, GetPostsSmartSearchForPostNavigationSearchParamsQueryVariables>(GetPostsSmartSearchForPostNavigationSearchParamsDocument, options);
      }
export function useGetPostsSmartSearchForPostNavigationSearchParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsSmartSearchForPostNavigationSearchParamsQuery, GetPostsSmartSearchForPostNavigationSearchParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsSmartSearchForPostNavigationSearchParamsQuery, GetPostsSmartSearchForPostNavigationSearchParamsQueryVariables>(GetPostsSmartSearchForPostNavigationSearchParamsDocument, options);
        }
export type GetPostsSmartSearchForPostNavigationSearchParamsQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForPostNavigationSearchParamsQuery>;
export type GetPostsSmartSearchForPostNavigationSearchParamsLazyQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForPostNavigationSearchParamsLazyQuery>;
export type GetPostsSmartSearchForPostNavigationSearchParamsQueryResult = Apollo.QueryResult<GetPostsSmartSearchForPostNavigationSearchParamsQuery, GetPostsSmartSearchForPostNavigationSearchParamsQueryVariables>;
export const ViewEntitiesForPostDocument = gql`
    mutation ViewEntitiesForPost($data: ViewEntitiesInput!) {
  viewEntities(data: $data) {
    message
    success
  }
}
    `;
export type ViewEntitiesForPostMutationFn = Apollo.MutationFunction<ViewEntitiesForPostMutation, ViewEntitiesForPostMutationVariables>;

/**
 * __useViewEntitiesForPostMutation__
 *
 * To run a mutation, you first call `useViewEntitiesForPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewEntitiesForPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewEntitiesForPostMutation, { data, loading, error }] = useViewEntitiesForPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useViewEntitiesForPostMutation(baseOptions?: Apollo.MutationHookOptions<ViewEntitiesForPostMutation, ViewEntitiesForPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewEntitiesForPostMutation, ViewEntitiesForPostMutationVariables>(ViewEntitiesForPostDocument, options);
      }
export type ViewEntitiesForPostMutationHookResult = ReturnType<typeof useViewEntitiesForPostMutation>;
export type ViewEntitiesForPostMutationResult = Apollo.MutationResult<ViewEntitiesForPostMutation>;
export type ViewEntitiesForPostMutationOptions = Apollo.BaseMutationOptions<ViewEntitiesForPostMutation, ViewEntitiesForPostMutationVariables>;
export const CreatePostAnnotationForPostDetailContentViewDocument = gql`
    mutation CreatePostAnnotationForPostDetailContentView($data: CreatePostAnnotationInput!) {
  createPostAnnotation(data: $data) {
    ...PostAnnotationFragmentAnnotation
  }
}
    ${PostAnnotationFragmentAnnotationFragmentDoc}`;
export type CreatePostAnnotationForPostDetailContentViewMutationFn = Apollo.MutationFunction<CreatePostAnnotationForPostDetailContentViewMutation, CreatePostAnnotationForPostDetailContentViewMutationVariables>;

/**
 * __useCreatePostAnnotationForPostDetailContentViewMutation__
 *
 * To run a mutation, you first call `useCreatePostAnnotationForPostDetailContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostAnnotationForPostDetailContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostAnnotationForPostDetailContentViewMutation, { data, loading, error }] = useCreatePostAnnotationForPostDetailContentViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostAnnotationForPostDetailContentViewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostAnnotationForPostDetailContentViewMutation, CreatePostAnnotationForPostDetailContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostAnnotationForPostDetailContentViewMutation, CreatePostAnnotationForPostDetailContentViewMutationVariables>(CreatePostAnnotationForPostDetailContentViewDocument, options);
      }
export type CreatePostAnnotationForPostDetailContentViewMutationHookResult = ReturnType<typeof useCreatePostAnnotationForPostDetailContentViewMutation>;
export type CreatePostAnnotationForPostDetailContentViewMutationResult = Apollo.MutationResult<CreatePostAnnotationForPostDetailContentViewMutation>;
export type CreatePostAnnotationForPostDetailContentViewMutationOptions = Apollo.BaseMutationOptions<CreatePostAnnotationForPostDetailContentViewMutation, CreatePostAnnotationForPostDetailContentViewMutationVariables>;
export const DeletePostAnnotationForPostDetailContentViewDocument = gql`
    mutation DeletePostAnnotationForPostDetailContentView($data: DeletePostAnnotationInput!) {
  deletePostAnnotation(data: $data) {
    message
    success
  }
}
    `;
export type DeletePostAnnotationForPostDetailContentViewMutationFn = Apollo.MutationFunction<DeletePostAnnotationForPostDetailContentViewMutation, DeletePostAnnotationForPostDetailContentViewMutationVariables>;

/**
 * __useDeletePostAnnotationForPostDetailContentViewMutation__
 *
 * To run a mutation, you first call `useDeletePostAnnotationForPostDetailContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostAnnotationForPostDetailContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostAnnotationForPostDetailContentViewMutation, { data, loading, error }] = useDeletePostAnnotationForPostDetailContentViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePostAnnotationForPostDetailContentViewMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostAnnotationForPostDetailContentViewMutation, DeletePostAnnotationForPostDetailContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostAnnotationForPostDetailContentViewMutation, DeletePostAnnotationForPostDetailContentViewMutationVariables>(DeletePostAnnotationForPostDetailContentViewDocument, options);
      }
export type DeletePostAnnotationForPostDetailContentViewMutationHookResult = ReturnType<typeof useDeletePostAnnotationForPostDetailContentViewMutation>;
export type DeletePostAnnotationForPostDetailContentViewMutationResult = Apollo.MutationResult<DeletePostAnnotationForPostDetailContentViewMutation>;
export type DeletePostAnnotationForPostDetailContentViewMutationOptions = Apollo.BaseMutationOptions<DeletePostAnnotationForPostDetailContentViewMutation, DeletePostAnnotationForPostDetailContentViewMutationVariables>;
export const CreateCommentForPostDetailContentViewDocument = gql`
    mutation CreateCommentForPostDetailContentView($data: CreateCommentInput!) {
  createComment(data: $data) {
    ...CommentFragmentCommentContainerView
  }
}
    ${CommentFragmentCommentContainerViewFragmentDoc}`;
export type CreateCommentForPostDetailContentViewMutationFn = Apollo.MutationFunction<CreateCommentForPostDetailContentViewMutation, CreateCommentForPostDetailContentViewMutationVariables>;

/**
 * __useCreateCommentForPostDetailContentViewMutation__
 *
 * To run a mutation, you first call `useCreateCommentForPostDetailContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentForPostDetailContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentForPostDetailContentViewMutation, { data, loading, error }] = useCreateCommentForPostDetailContentViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCommentForPostDetailContentViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentForPostDetailContentViewMutation, CreateCommentForPostDetailContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentForPostDetailContentViewMutation, CreateCommentForPostDetailContentViewMutationVariables>(CreateCommentForPostDetailContentViewDocument, options);
      }
export type CreateCommentForPostDetailContentViewMutationHookResult = ReturnType<typeof useCreateCommentForPostDetailContentViewMutation>;
export type CreateCommentForPostDetailContentViewMutationResult = Apollo.MutationResult<CreateCommentForPostDetailContentViewMutation>;
export type CreateCommentForPostDetailContentViewMutationOptions = Apollo.BaseMutationOptions<CreateCommentForPostDetailContentViewMutation, CreateCommentForPostDetailContentViewMutationVariables>;
export const ReactToCommentForPostDetailContentViewDocument = gql`
    mutation ReactToCommentForPostDetailContentView($data: ReactInput!) {
  react(data: $data) {
    message
    success
  }
}
    `;
export type ReactToCommentForPostDetailContentViewMutationFn = Apollo.MutationFunction<ReactToCommentForPostDetailContentViewMutation, ReactToCommentForPostDetailContentViewMutationVariables>;

/**
 * __useReactToCommentForPostDetailContentViewMutation__
 *
 * To run a mutation, you first call `useReactToCommentForPostDetailContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToCommentForPostDetailContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToCommentForPostDetailContentViewMutation, { data, loading, error }] = useReactToCommentForPostDetailContentViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReactToCommentForPostDetailContentViewMutation(baseOptions?: Apollo.MutationHookOptions<ReactToCommentForPostDetailContentViewMutation, ReactToCommentForPostDetailContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactToCommentForPostDetailContentViewMutation, ReactToCommentForPostDetailContentViewMutationVariables>(ReactToCommentForPostDetailContentViewDocument, options);
      }
export type ReactToCommentForPostDetailContentViewMutationHookResult = ReturnType<typeof useReactToCommentForPostDetailContentViewMutation>;
export type ReactToCommentForPostDetailContentViewMutationResult = Apollo.MutationResult<ReactToCommentForPostDetailContentViewMutation>;
export type ReactToCommentForPostDetailContentViewMutationOptions = Apollo.BaseMutationOptions<ReactToCommentForPostDetailContentViewMutation, ReactToCommentForPostDetailContentViewMutationVariables>;
export const UpdateCommentForPostDetailContentViewDocument = gql`
    mutation UpdateCommentForPostDetailContentView($data: UpdateCommentInput!) {
  updateComment(data: $data) {
    ...CommentFragmentCommentContainerView
  }
}
    ${CommentFragmentCommentContainerViewFragmentDoc}`;
export type UpdateCommentForPostDetailContentViewMutationFn = Apollo.MutationFunction<UpdateCommentForPostDetailContentViewMutation, UpdateCommentForPostDetailContentViewMutationVariables>;

/**
 * __useUpdateCommentForPostDetailContentViewMutation__
 *
 * To run a mutation, you first call `useUpdateCommentForPostDetailContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentForPostDetailContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentForPostDetailContentViewMutation, { data, loading, error }] = useUpdateCommentForPostDetailContentViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCommentForPostDetailContentViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentForPostDetailContentViewMutation, UpdateCommentForPostDetailContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentForPostDetailContentViewMutation, UpdateCommentForPostDetailContentViewMutationVariables>(UpdateCommentForPostDetailContentViewDocument, options);
      }
export type UpdateCommentForPostDetailContentViewMutationHookResult = ReturnType<typeof useUpdateCommentForPostDetailContentViewMutation>;
export type UpdateCommentForPostDetailContentViewMutationResult = Apollo.MutationResult<UpdateCommentForPostDetailContentViewMutation>;
export type UpdateCommentForPostDetailContentViewMutationOptions = Apollo.BaseMutationOptions<UpdateCommentForPostDetailContentViewMutation, UpdateCommentForPostDetailContentViewMutationVariables>;
export const DeleteCommentForPostDetailContentViewDocument = gql`
    mutation DeleteCommentForPostDetailContentView($data: DeleteCommentInput!) {
  deleteComment(data: $data) {
    message
    success
  }
}
    `;
export type DeleteCommentForPostDetailContentViewMutationFn = Apollo.MutationFunction<DeleteCommentForPostDetailContentViewMutation, DeleteCommentForPostDetailContentViewMutationVariables>;

/**
 * __useDeleteCommentForPostDetailContentViewMutation__
 *
 * To run a mutation, you first call `useDeleteCommentForPostDetailContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentForPostDetailContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentForPostDetailContentViewMutation, { data, loading, error }] = useDeleteCommentForPostDetailContentViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCommentForPostDetailContentViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentForPostDetailContentViewMutation, DeleteCommentForPostDetailContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentForPostDetailContentViewMutation, DeleteCommentForPostDetailContentViewMutationVariables>(DeleteCommentForPostDetailContentViewDocument, options);
      }
export type DeleteCommentForPostDetailContentViewMutationHookResult = ReturnType<typeof useDeleteCommentForPostDetailContentViewMutation>;
export type DeleteCommentForPostDetailContentViewMutationResult = Apollo.MutationResult<DeleteCommentForPostDetailContentViewMutation>;
export type DeleteCommentForPostDetailContentViewMutationOptions = Apollo.BaseMutationOptions<DeleteCommentForPostDetailContentViewMutation, DeleteCommentForPostDetailContentViewMutationVariables>;
export const GetCollectionForPostMoveToAnotherCollectionDocument = gql`
    query GetCollectionForPostMoveToAnotherCollection($collectionId: String!) {
  collection(id: $collectionId) {
    id
    ...CollectionFragmentUseMoveToAnotherCollectionModal
  }
}
    ${CollectionFragmentUseMoveToAnotherCollectionModalFragmentDoc}`;

/**
 * __useGetCollectionForPostMoveToAnotherCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionForPostMoveToAnotherCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForPostMoveToAnotherCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForPostMoveToAnotherCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForPostMoveToAnotherCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForPostMoveToAnotherCollectionQuery, GetCollectionForPostMoveToAnotherCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForPostMoveToAnotherCollectionQuery, GetCollectionForPostMoveToAnotherCollectionQueryVariables>(GetCollectionForPostMoveToAnotherCollectionDocument, options);
      }
export function useGetCollectionForPostMoveToAnotherCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForPostMoveToAnotherCollectionQuery, GetCollectionForPostMoveToAnotherCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForPostMoveToAnotherCollectionQuery, GetCollectionForPostMoveToAnotherCollectionQueryVariables>(GetCollectionForPostMoveToAnotherCollectionDocument, options);
        }
export type GetCollectionForPostMoveToAnotherCollectionQueryHookResult = ReturnType<typeof useGetCollectionForPostMoveToAnotherCollectionQuery>;
export type GetCollectionForPostMoveToAnotherCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionForPostMoveToAnotherCollectionLazyQuery>;
export type GetCollectionForPostMoveToAnotherCollectionQueryResult = Apollo.QueryResult<GetCollectionForPostMoveToAnotherCollectionQuery, GetCollectionForPostMoveToAnotherCollectionQueryVariables>;
export const GetPostForPostMoveToAnotherCollectionDocument = gql`
    query GetPostForPostMoveToAnotherCollection($postId: String!) {
  post(id: $postId) {
    id
    ...PostFragmentPostMoveToAnotherCollection
  }
}
    ${PostFragmentPostMoveToAnotherCollectionFragmentDoc}`;

/**
 * __useGetPostForPostMoveToAnotherCollectionQuery__
 *
 * To run a query within a React component, call `useGetPostForPostMoveToAnotherCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForPostMoveToAnotherCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForPostMoveToAnotherCollectionQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostForPostMoveToAnotherCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetPostForPostMoveToAnotherCollectionQuery, GetPostForPostMoveToAnotherCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForPostMoveToAnotherCollectionQuery, GetPostForPostMoveToAnotherCollectionQueryVariables>(GetPostForPostMoveToAnotherCollectionDocument, options);
      }
export function useGetPostForPostMoveToAnotherCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForPostMoveToAnotherCollectionQuery, GetPostForPostMoveToAnotherCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForPostMoveToAnotherCollectionQuery, GetPostForPostMoveToAnotherCollectionQueryVariables>(GetPostForPostMoveToAnotherCollectionDocument, options);
        }
export type GetPostForPostMoveToAnotherCollectionQueryHookResult = ReturnType<typeof useGetPostForPostMoveToAnotherCollectionQuery>;
export type GetPostForPostMoveToAnotherCollectionLazyQueryHookResult = ReturnType<typeof useGetPostForPostMoveToAnotherCollectionLazyQuery>;
export type GetPostForPostMoveToAnotherCollectionQueryResult = Apollo.QueryResult<GetPostForPostMoveToAnotherCollectionQuery, GetPostForPostMoveToAnotherCollectionQueryVariables>;
export const GetCollectionsSmartSearchForPostSmartSearchResultViewDocument = gql`
    query GetCollectionsSmartSearchForPostSmartSearchResultView($filters: CollectionFilters!, $take: Int, $sortType: SortType, $after: String) {
  collectionsSmartSearch(
    filters: $filters
    take: $take
    sortType: $sortType
    after: $after
  ) {
    data {
      item {
        ...CollectionFragmentCollectionPostDndCollectionCard
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionFragmentCollectionPostDndCollectionCardFragmentDoc}`;

/**
 * __useGetCollectionsSmartSearchForPostSmartSearchResultViewQuery__
 *
 * To run a query within a React component, call `useGetCollectionsSmartSearchForPostSmartSearchResultViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsSmartSearchForPostSmartSearchResultViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsSmartSearchForPostSmartSearchResultViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      sortType: // value for 'sortType'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCollectionsSmartSearchForPostSmartSearchResultViewQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsSmartSearchForPostSmartSearchResultViewQuery, GetCollectionsSmartSearchForPostSmartSearchResultViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsSmartSearchForPostSmartSearchResultViewQuery, GetCollectionsSmartSearchForPostSmartSearchResultViewQueryVariables>(GetCollectionsSmartSearchForPostSmartSearchResultViewDocument, options);
      }
export function useGetCollectionsSmartSearchForPostSmartSearchResultViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsSmartSearchForPostSmartSearchResultViewQuery, GetCollectionsSmartSearchForPostSmartSearchResultViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsSmartSearchForPostSmartSearchResultViewQuery, GetCollectionsSmartSearchForPostSmartSearchResultViewQueryVariables>(GetCollectionsSmartSearchForPostSmartSearchResultViewDocument, options);
        }
export type GetCollectionsSmartSearchForPostSmartSearchResultViewQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForPostSmartSearchResultViewQuery>;
export type GetCollectionsSmartSearchForPostSmartSearchResultViewLazyQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForPostSmartSearchResultViewLazyQuery>;
export type GetCollectionsSmartSearchForPostSmartSearchResultViewQueryResult = Apollo.QueryResult<GetCollectionsSmartSearchForPostSmartSearchResultViewQuery, GetCollectionsSmartSearchForPostSmartSearchResultViewQueryVariables>;
export const GetPostsSmartSearchForPostSmartSearchResultViewDocument = gql`
    query GetPostsSmartSearchForPostSmartSearchResultView($filters: PostFiltersForSmartSearch!, $take: Int, $after: String, $sortType: SortType) {
  postsSmartSearch(
    filters: $filters
    take: $take
    after: $after
    sortType: $sortType
  ) {
    data {
      score
      type
      item {
        id
        ...PostFragmentCollectionPostDndPostCard
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentCollectionPostDndPostCardFragmentDoc}`;

/**
 * __useGetPostsSmartSearchForPostSmartSearchResultViewQuery__
 *
 * To run a query within a React component, call `useGetPostsSmartSearchForPostSmartSearchResultViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSmartSearchForPostSmartSearchResultViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSmartSearchForPostSmartSearchResultViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetPostsSmartSearchForPostSmartSearchResultViewQuery(baseOptions: Apollo.QueryHookOptions<GetPostsSmartSearchForPostSmartSearchResultViewQuery, GetPostsSmartSearchForPostSmartSearchResultViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsSmartSearchForPostSmartSearchResultViewQuery, GetPostsSmartSearchForPostSmartSearchResultViewQueryVariables>(GetPostsSmartSearchForPostSmartSearchResultViewDocument, options);
      }
export function useGetPostsSmartSearchForPostSmartSearchResultViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsSmartSearchForPostSmartSearchResultViewQuery, GetPostsSmartSearchForPostSmartSearchResultViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsSmartSearchForPostSmartSearchResultViewQuery, GetPostsSmartSearchForPostSmartSearchResultViewQueryVariables>(GetPostsSmartSearchForPostSmartSearchResultViewDocument, options);
        }
export type GetPostsSmartSearchForPostSmartSearchResultViewQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForPostSmartSearchResultViewQuery>;
export type GetPostsSmartSearchForPostSmartSearchResultViewLazyQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForPostSmartSearchResultViewLazyQuery>;
export type GetPostsSmartSearchForPostSmartSearchResultViewQueryResult = Apollo.QueryResult<GetPostsSmartSearchForPostSmartSearchResultViewQuery, GetPostsSmartSearchForPostSmartSearchResultViewQueryVariables>;
export const GetRadarEventForRadarEventCommunityUpdateItemViewDocument = gql`
    query GetRadarEventForRadarEventCommunityUpdateItemView($id: String!) {
  radarEvent(id: $id) {
    id
    radarEventActivities {
      id
      title
    }
  }
}
    `;

/**
 * __useGetRadarEventForRadarEventCommunityUpdateItemViewQuery__
 *
 * To run a query within a React component, call `useGetRadarEventForRadarEventCommunityUpdateItemViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRadarEventForRadarEventCommunityUpdateItemViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRadarEventForRadarEventCommunityUpdateItemViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRadarEventForRadarEventCommunityUpdateItemViewQuery(baseOptions: Apollo.QueryHookOptions<GetRadarEventForRadarEventCommunityUpdateItemViewQuery, GetRadarEventForRadarEventCommunityUpdateItemViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRadarEventForRadarEventCommunityUpdateItemViewQuery, GetRadarEventForRadarEventCommunityUpdateItemViewQueryVariables>(GetRadarEventForRadarEventCommunityUpdateItemViewDocument, options);
      }
export function useGetRadarEventForRadarEventCommunityUpdateItemViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRadarEventForRadarEventCommunityUpdateItemViewQuery, GetRadarEventForRadarEventCommunityUpdateItemViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRadarEventForRadarEventCommunityUpdateItemViewQuery, GetRadarEventForRadarEventCommunityUpdateItemViewQueryVariables>(GetRadarEventForRadarEventCommunityUpdateItemViewDocument, options);
        }
export type GetRadarEventForRadarEventCommunityUpdateItemViewQueryHookResult = ReturnType<typeof useGetRadarEventForRadarEventCommunityUpdateItemViewQuery>;
export type GetRadarEventForRadarEventCommunityUpdateItemViewLazyQueryHookResult = ReturnType<typeof useGetRadarEventForRadarEventCommunityUpdateItemViewLazyQuery>;
export type GetRadarEventForRadarEventCommunityUpdateItemViewQueryResult = Apollo.QueryResult<GetRadarEventForRadarEventCommunityUpdateItemViewQuery, GetRadarEventForRadarEventCommunityUpdateItemViewQueryVariables>;
export const GetSearchResultForRichTextDocument = gql`
    query GetSearchResultForRichText($data: SearchInput!) {
  searchEntities(data: $data) {
    ...SearchResultFragmentRichText
  }
}
    ${SearchResultFragmentRichTextFragmentDoc}`;

/**
 * __useGetSearchResultForRichTextQuery__
 *
 * To run a query within a React component, call `useGetSearchResultForRichTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultForRichTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultForRichTextQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSearchResultForRichTextQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultForRichTextQuery, GetSearchResultForRichTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultForRichTextQuery, GetSearchResultForRichTextQueryVariables>(GetSearchResultForRichTextDocument, options);
      }
export function useGetSearchResultForRichTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultForRichTextQuery, GetSearchResultForRichTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultForRichTextQuery, GetSearchResultForRichTextQueryVariables>(GetSearchResultForRichTextDocument, options);
        }
export type GetSearchResultForRichTextQueryHookResult = ReturnType<typeof useGetSearchResultForRichTextQuery>;
export type GetSearchResultForRichTextLazyQueryHookResult = ReturnType<typeof useGetSearchResultForRichTextLazyQuery>;
export type GetSearchResultForRichTextQueryResult = Apollo.QueryResult<GetSearchResultForRichTextQuery, GetSearchResultForRichTextQueryVariables>;
export const CreatePostSearchClickForSearchHandlerDocument = gql`
    mutation CreatePostSearchClickForSearchHandler($data: SearchHitClickInput!) {
  createSearchClicked(data: $data) {
    post {
      id
      __typename
    }
  }
}
    `;
export type CreatePostSearchClickForSearchHandlerMutationFn = Apollo.MutationFunction<CreatePostSearchClickForSearchHandlerMutation, CreatePostSearchClickForSearchHandlerMutationVariables>;

/**
 * __useCreatePostSearchClickForSearchHandlerMutation__
 *
 * To run a mutation, you first call `useCreatePostSearchClickForSearchHandlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostSearchClickForSearchHandlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostSearchClickForSearchHandlerMutation, { data, loading, error }] = useCreatePostSearchClickForSearchHandlerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostSearchClickForSearchHandlerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostSearchClickForSearchHandlerMutation, CreatePostSearchClickForSearchHandlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostSearchClickForSearchHandlerMutation, CreatePostSearchClickForSearchHandlerMutationVariables>(CreatePostSearchClickForSearchHandlerDocument, options);
      }
export type CreatePostSearchClickForSearchHandlerMutationHookResult = ReturnType<typeof useCreatePostSearchClickForSearchHandlerMutation>;
export type CreatePostSearchClickForSearchHandlerMutationResult = Apollo.MutationResult<CreatePostSearchClickForSearchHandlerMutation>;
export type CreatePostSearchClickForSearchHandlerMutationOptions = Apollo.BaseMutationOptions<CreatePostSearchClickForSearchHandlerMutation, CreatePostSearchClickForSearchHandlerMutationVariables>;
export const CreateTaskSearchClickDocument = gql`
    mutation CreateTaskSearchClick($data: SearchHitClickInput!) {
  createSearchClicked(data: $data) {
    task {
      id
    }
  }
}
    `;
export type CreateTaskSearchClickMutationFn = Apollo.MutationFunction<CreateTaskSearchClickMutation, CreateTaskSearchClickMutationVariables>;

/**
 * __useCreateTaskSearchClickMutation__
 *
 * To run a mutation, you first call `useCreateTaskSearchClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskSearchClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskSearchClickMutation, { data, loading, error }] = useCreateTaskSearchClickMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTaskSearchClickMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskSearchClickMutation, CreateTaskSearchClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskSearchClickMutation, CreateTaskSearchClickMutationVariables>(CreateTaskSearchClickDocument, options);
      }
export type CreateTaskSearchClickMutationHookResult = ReturnType<typeof useCreateTaskSearchClickMutation>;
export type CreateTaskSearchClickMutationResult = Apollo.MutationResult<CreateTaskSearchClickMutation>;
export type CreateTaskSearchClickMutationOptions = Apollo.BaseMutationOptions<CreateTaskSearchClickMutation, CreateTaskSearchClickMutationVariables>;
export const CreateCollectionSearchClickDocument = gql`
    mutation CreateCollectionSearchClick($data: SearchHitClickInput!) {
  createSearchClicked(data: $data) {
    collection {
      id
    }
  }
}
    `;
export type CreateCollectionSearchClickMutationFn = Apollo.MutationFunction<CreateCollectionSearchClickMutation, CreateCollectionSearchClickMutationVariables>;

/**
 * __useCreateCollectionSearchClickMutation__
 *
 * To run a mutation, you first call `useCreateCollectionSearchClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionSearchClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionSearchClickMutation, { data, loading, error }] = useCreateCollectionSearchClickMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCollectionSearchClickMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionSearchClickMutation, CreateCollectionSearchClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionSearchClickMutation, CreateCollectionSearchClickMutationVariables>(CreateCollectionSearchClickDocument, options);
      }
export type CreateCollectionSearchClickMutationHookResult = ReturnType<typeof useCreateCollectionSearchClickMutation>;
export type CreateCollectionSearchClickMutationResult = Apollo.MutationResult<CreateCollectionSearchClickMutation>;
export type CreateCollectionSearchClickMutationOptions = Apollo.BaseMutationOptions<CreateCollectionSearchClickMutation, CreateCollectionSearchClickMutationVariables>;
export const PaginatedAttachmentsForAttachmentSearchResultsDocument = gql`
    query PaginatedAttachmentsForAttachmentSearchResults($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    attachmentSearchResult {
      ...AttachmentSearchResultFragmentSectionView
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${AttachmentSearchResultFragmentSectionViewFragmentDoc}`;

/**
 * __usePaginatedAttachmentsForAttachmentSearchResultsQuery__
 *
 * To run a query within a React component, call `usePaginatedAttachmentsForAttachmentSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAttachmentsForAttachmentSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAttachmentsForAttachmentSearchResultsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaginatedAttachmentsForAttachmentSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedAttachmentsForAttachmentSearchResultsQuery, PaginatedAttachmentsForAttachmentSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedAttachmentsForAttachmentSearchResultsQuery, PaginatedAttachmentsForAttachmentSearchResultsQueryVariables>(PaginatedAttachmentsForAttachmentSearchResultsDocument, options);
      }
export function usePaginatedAttachmentsForAttachmentSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedAttachmentsForAttachmentSearchResultsQuery, PaginatedAttachmentsForAttachmentSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedAttachmentsForAttachmentSearchResultsQuery, PaginatedAttachmentsForAttachmentSearchResultsQueryVariables>(PaginatedAttachmentsForAttachmentSearchResultsDocument, options);
        }
export type PaginatedAttachmentsForAttachmentSearchResultsQueryHookResult = ReturnType<typeof usePaginatedAttachmentsForAttachmentSearchResultsQuery>;
export type PaginatedAttachmentsForAttachmentSearchResultsLazyQueryHookResult = ReturnType<typeof usePaginatedAttachmentsForAttachmentSearchResultsLazyQuery>;
export type PaginatedAttachmentsForAttachmentSearchResultsQueryResult = Apollo.QueryResult<PaginatedAttachmentsForAttachmentSearchResultsQuery, PaginatedAttachmentsForAttachmentSearchResultsQueryVariables>;
export const PaginatedCollectionsForCollectionSearchResultsDocument = gql`
    query PaginatedCollectionsForCollectionSearchResults($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    collectionSearchResult {
      ...CollectionSearchResultFragmentSectionView
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${CollectionSearchResultFragmentSectionViewFragmentDoc}`;

/**
 * __usePaginatedCollectionsForCollectionSearchResultsQuery__
 *
 * To run a query within a React component, call `usePaginatedCollectionsForCollectionSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCollectionsForCollectionSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCollectionsForCollectionSearchResultsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaginatedCollectionsForCollectionSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedCollectionsForCollectionSearchResultsQuery, PaginatedCollectionsForCollectionSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedCollectionsForCollectionSearchResultsQuery, PaginatedCollectionsForCollectionSearchResultsQueryVariables>(PaginatedCollectionsForCollectionSearchResultsDocument, options);
      }
export function usePaginatedCollectionsForCollectionSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedCollectionsForCollectionSearchResultsQuery, PaginatedCollectionsForCollectionSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedCollectionsForCollectionSearchResultsQuery, PaginatedCollectionsForCollectionSearchResultsQueryVariables>(PaginatedCollectionsForCollectionSearchResultsDocument, options);
        }
export type PaginatedCollectionsForCollectionSearchResultsQueryHookResult = ReturnType<typeof usePaginatedCollectionsForCollectionSearchResultsQuery>;
export type PaginatedCollectionsForCollectionSearchResultsLazyQueryHookResult = ReturnType<typeof usePaginatedCollectionsForCollectionSearchResultsLazyQuery>;
export type PaginatedCollectionsForCollectionSearchResultsQueryResult = Apollo.QueryResult<PaginatedCollectionsForCollectionSearchResultsQuery, PaginatedCollectionsForCollectionSearchResultsQueryVariables>;
export const PaginatedLinksForLinkSearchResultsDocument = gql`
    query PaginatedLinksForLinkSearchResults($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    linkSearchResult {
      ...LinkSearchResultFragmentSectionView
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${LinkSearchResultFragmentSectionViewFragmentDoc}`;

/**
 * __usePaginatedLinksForLinkSearchResultsQuery__
 *
 * To run a query within a React component, call `usePaginatedLinksForLinkSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedLinksForLinkSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedLinksForLinkSearchResultsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaginatedLinksForLinkSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedLinksForLinkSearchResultsQuery, PaginatedLinksForLinkSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedLinksForLinkSearchResultsQuery, PaginatedLinksForLinkSearchResultsQueryVariables>(PaginatedLinksForLinkSearchResultsDocument, options);
      }
export function usePaginatedLinksForLinkSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedLinksForLinkSearchResultsQuery, PaginatedLinksForLinkSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedLinksForLinkSearchResultsQuery, PaginatedLinksForLinkSearchResultsQueryVariables>(PaginatedLinksForLinkSearchResultsDocument, options);
        }
export type PaginatedLinksForLinkSearchResultsQueryHookResult = ReturnType<typeof usePaginatedLinksForLinkSearchResultsQuery>;
export type PaginatedLinksForLinkSearchResultsLazyQueryHookResult = ReturnType<typeof usePaginatedLinksForLinkSearchResultsLazyQuery>;
export type PaginatedLinksForLinkSearchResultsQueryResult = Apollo.QueryResult<PaginatedLinksForLinkSearchResultsQuery, PaginatedLinksForLinkSearchResultsQueryVariables>;
export const PaginatedNotesForNoteSearchResultsDocument = gql`
    query PaginatedNotesForNoteSearchResults($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    noteSearchResult {
      ...NoteSearchResultFragmentSectionView
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${NoteSearchResultFragmentSectionViewFragmentDoc}`;

/**
 * __usePaginatedNotesForNoteSearchResultsQuery__
 *
 * To run a query within a React component, call `usePaginatedNotesForNoteSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedNotesForNoteSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedNotesForNoteSearchResultsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaginatedNotesForNoteSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedNotesForNoteSearchResultsQuery, PaginatedNotesForNoteSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedNotesForNoteSearchResultsQuery, PaginatedNotesForNoteSearchResultsQueryVariables>(PaginatedNotesForNoteSearchResultsDocument, options);
      }
export function usePaginatedNotesForNoteSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedNotesForNoteSearchResultsQuery, PaginatedNotesForNoteSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedNotesForNoteSearchResultsQuery, PaginatedNotesForNoteSearchResultsQueryVariables>(PaginatedNotesForNoteSearchResultsDocument, options);
        }
export type PaginatedNotesForNoteSearchResultsQueryHookResult = ReturnType<typeof usePaginatedNotesForNoteSearchResultsQuery>;
export type PaginatedNotesForNoteSearchResultsLazyQueryHookResult = ReturnType<typeof usePaginatedNotesForNoteSearchResultsLazyQuery>;
export type PaginatedNotesForNoteSearchResultsQueryResult = Apollo.QueryResult<PaginatedNotesForNoteSearchResultsQuery, PaginatedNotesForNoteSearchResultsQueryVariables>;
export const PaginatedTasksForTaskSearchResultsDocument = gql`
    query PaginatedTasksForTaskSearchResults($data: UniversalSearchInput!) {
  universalSearch(data: $data) {
    taskSearchResult {
      ...TaskSearchResultFragmentSectionView
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${TaskSearchResultFragmentSectionViewFragmentDoc}`;

/**
 * __usePaginatedTasksForTaskSearchResultsQuery__
 *
 * To run a query within a React component, call `usePaginatedTasksForTaskSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTasksForTaskSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTasksForTaskSearchResultsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaginatedTasksForTaskSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedTasksForTaskSearchResultsQuery, PaginatedTasksForTaskSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedTasksForTaskSearchResultsQuery, PaginatedTasksForTaskSearchResultsQueryVariables>(PaginatedTasksForTaskSearchResultsDocument, options);
      }
export function usePaginatedTasksForTaskSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedTasksForTaskSearchResultsQuery, PaginatedTasksForTaskSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedTasksForTaskSearchResultsQuery, PaginatedTasksForTaskSearchResultsQueryVariables>(PaginatedTasksForTaskSearchResultsDocument, options);
        }
export type PaginatedTasksForTaskSearchResultsQueryHookResult = ReturnType<typeof usePaginatedTasksForTaskSearchResultsQuery>;
export type PaginatedTasksForTaskSearchResultsLazyQueryHookResult = ReturnType<typeof usePaginatedTasksForTaskSearchResultsLazyQuery>;
export type PaginatedTasksForTaskSearchResultsQueryResult = Apollo.QueryResult<PaginatedTasksForTaskSearchResultsQuery, PaginatedTasksForTaskSearchResultsQueryVariables>;
export const GetAttributesForSlaAnalyticsFilterByAttributesDocument = gql`
    query GetAttributesForSLAAnalyticsFilterByAttributes($input: PaginatedCapturedProductAllLabelsInput!) {
  attributesForCapturedProductAllLabels(input: $input) {
    data {
      id
      value
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetAttributesForSlaAnalyticsFilterByAttributesQuery__
 *
 * To run a query within a React component, call `useGetAttributesForSlaAnalyticsFilterByAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributesForSlaAnalyticsFilterByAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttributesForSlaAnalyticsFilterByAttributesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAttributesForSlaAnalyticsFilterByAttributesQuery(baseOptions: Apollo.QueryHookOptions<GetAttributesForSlaAnalyticsFilterByAttributesQuery, GetAttributesForSlaAnalyticsFilterByAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttributesForSlaAnalyticsFilterByAttributesQuery, GetAttributesForSlaAnalyticsFilterByAttributesQueryVariables>(GetAttributesForSlaAnalyticsFilterByAttributesDocument, options);
      }
export function useGetAttributesForSlaAnalyticsFilterByAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttributesForSlaAnalyticsFilterByAttributesQuery, GetAttributesForSlaAnalyticsFilterByAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttributesForSlaAnalyticsFilterByAttributesQuery, GetAttributesForSlaAnalyticsFilterByAttributesQueryVariables>(GetAttributesForSlaAnalyticsFilterByAttributesDocument, options);
        }
export type GetAttributesForSlaAnalyticsFilterByAttributesQueryHookResult = ReturnType<typeof useGetAttributesForSlaAnalyticsFilterByAttributesQuery>;
export type GetAttributesForSlaAnalyticsFilterByAttributesLazyQueryHookResult = ReturnType<typeof useGetAttributesForSlaAnalyticsFilterByAttributesLazyQuery>;
export type GetAttributesForSlaAnalyticsFilterByAttributesQueryResult = Apollo.QueryResult<GetAttributesForSlaAnalyticsFilterByAttributesQuery, GetAttributesForSlaAnalyticsFilterByAttributesQueryVariables>;
export const GetBrandsForSlaAnalyticsFilterByBrandsDocument = gql`
    query GetBrandsForSLAAnalyticsFilterByBrands($input: PaginatedCapturedProductAllLabelsInput!) {
  brandsForCapturedProductAllLabels(input: $input) {
    data {
      id
      name
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetBrandsForSlaAnalyticsFilterByBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsForSlaAnalyticsFilterByBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsForSlaAnalyticsFilterByBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsForSlaAnalyticsFilterByBrandsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBrandsForSlaAnalyticsFilterByBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandsForSlaAnalyticsFilterByBrandsQuery, GetBrandsForSlaAnalyticsFilterByBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsForSlaAnalyticsFilterByBrandsQuery, GetBrandsForSlaAnalyticsFilterByBrandsQueryVariables>(GetBrandsForSlaAnalyticsFilterByBrandsDocument, options);
      }
export function useGetBrandsForSlaAnalyticsFilterByBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsForSlaAnalyticsFilterByBrandsQuery, GetBrandsForSlaAnalyticsFilterByBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsForSlaAnalyticsFilterByBrandsQuery, GetBrandsForSlaAnalyticsFilterByBrandsQueryVariables>(GetBrandsForSlaAnalyticsFilterByBrandsDocument, options);
        }
export type GetBrandsForSlaAnalyticsFilterByBrandsQueryHookResult = ReturnType<typeof useGetBrandsForSlaAnalyticsFilterByBrandsQuery>;
export type GetBrandsForSlaAnalyticsFilterByBrandsLazyQueryHookResult = ReturnType<typeof useGetBrandsForSlaAnalyticsFilterByBrandsLazyQuery>;
export type GetBrandsForSlaAnalyticsFilterByBrandsQueryResult = Apollo.QueryResult<GetBrandsForSlaAnalyticsFilterByBrandsQuery, GetBrandsForSlaAnalyticsFilterByBrandsQueryVariables>;
export const GetCategoriesForSlaAnalyticsFilterByCategoryDocument = gql`
    query GetCategoriesForSLAAnalyticsFilterByCategory($input: PaginatedCapturedProductAllLabelsInput!) {
  categoriesForCapturedProductAllLabels(input: $input) {
    data {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetCategoriesForSlaAnalyticsFilterByCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForSlaAnalyticsFilterByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForSlaAnalyticsFilterByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForSlaAnalyticsFilterByCategoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCategoriesForSlaAnalyticsFilterByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForSlaAnalyticsFilterByCategoryQuery, GetCategoriesForSlaAnalyticsFilterByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForSlaAnalyticsFilterByCategoryQuery, GetCategoriesForSlaAnalyticsFilterByCategoryQueryVariables>(GetCategoriesForSlaAnalyticsFilterByCategoryDocument, options);
      }
export function useGetCategoriesForSlaAnalyticsFilterByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForSlaAnalyticsFilterByCategoryQuery, GetCategoriesForSlaAnalyticsFilterByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForSlaAnalyticsFilterByCategoryQuery, GetCategoriesForSlaAnalyticsFilterByCategoryQueryVariables>(GetCategoriesForSlaAnalyticsFilterByCategoryDocument, options);
        }
export type GetCategoriesForSlaAnalyticsFilterByCategoryQueryHookResult = ReturnType<typeof useGetCategoriesForSlaAnalyticsFilterByCategoryQuery>;
export type GetCategoriesForSlaAnalyticsFilterByCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoriesForSlaAnalyticsFilterByCategoryLazyQuery>;
export type GetCategoriesForSlaAnalyticsFilterByCategoryQueryResult = Apollo.QueryResult<GetCategoriesForSlaAnalyticsFilterByCategoryQuery, GetCategoriesForSlaAnalyticsFilterByCategoryQueryVariables>;
export const GetLanguagesForSlaAnalyticsFilterByLanguageDocument = gql`
    query GetLanguagesForSLAAnalyticsFilterByLanguage {
  languages {
    name
  }
}
    `;

/**
 * __useGetLanguagesForSlaAnalyticsFilterByLanguageQuery__
 *
 * To run a query within a React component, call `useGetLanguagesForSlaAnalyticsFilterByLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesForSlaAnalyticsFilterByLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesForSlaAnalyticsFilterByLanguageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesForSlaAnalyticsFilterByLanguageQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesForSlaAnalyticsFilterByLanguageQuery, GetLanguagesForSlaAnalyticsFilterByLanguageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesForSlaAnalyticsFilterByLanguageQuery, GetLanguagesForSlaAnalyticsFilterByLanguageQueryVariables>(GetLanguagesForSlaAnalyticsFilterByLanguageDocument, options);
      }
export function useGetLanguagesForSlaAnalyticsFilterByLanguageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesForSlaAnalyticsFilterByLanguageQuery, GetLanguagesForSlaAnalyticsFilterByLanguageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesForSlaAnalyticsFilterByLanguageQuery, GetLanguagesForSlaAnalyticsFilterByLanguageQueryVariables>(GetLanguagesForSlaAnalyticsFilterByLanguageDocument, options);
        }
export type GetLanguagesForSlaAnalyticsFilterByLanguageQueryHookResult = ReturnType<typeof useGetLanguagesForSlaAnalyticsFilterByLanguageQuery>;
export type GetLanguagesForSlaAnalyticsFilterByLanguageLazyQueryHookResult = ReturnType<typeof useGetLanguagesForSlaAnalyticsFilterByLanguageLazyQuery>;
export type GetLanguagesForSlaAnalyticsFilterByLanguageQueryResult = Apollo.QueryResult<GetLanguagesForSlaAnalyticsFilterByLanguageQuery, GetLanguagesForSlaAnalyticsFilterByLanguageQueryVariables>;
export const GetBrandForSlaAnalyticsFilterByPlatformDocument = gql`
    query GetBrandForSLAAnalyticsFilterByPlatform($brandId: String!) {
  brand(id: $brandId) {
    id
    creators {
      id
      handle
      platform
    }
  }
}
    `;

/**
 * __useGetBrandForSlaAnalyticsFilterByPlatformQuery__
 *
 * To run a query within a React component, call `useGetBrandForSlaAnalyticsFilterByPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSlaAnalyticsFilterByPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSlaAnalyticsFilterByPlatformQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForSlaAnalyticsFilterByPlatformQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSlaAnalyticsFilterByPlatformQuery, GetBrandForSlaAnalyticsFilterByPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSlaAnalyticsFilterByPlatformQuery, GetBrandForSlaAnalyticsFilterByPlatformQueryVariables>(GetBrandForSlaAnalyticsFilterByPlatformDocument, options);
      }
export function useGetBrandForSlaAnalyticsFilterByPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSlaAnalyticsFilterByPlatformQuery, GetBrandForSlaAnalyticsFilterByPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSlaAnalyticsFilterByPlatformQuery, GetBrandForSlaAnalyticsFilterByPlatformQueryVariables>(GetBrandForSlaAnalyticsFilterByPlatformDocument, options);
        }
export type GetBrandForSlaAnalyticsFilterByPlatformQueryHookResult = ReturnType<typeof useGetBrandForSlaAnalyticsFilterByPlatformQuery>;
export type GetBrandForSlaAnalyticsFilterByPlatformLazyQueryHookResult = ReturnType<typeof useGetBrandForSlaAnalyticsFilterByPlatformLazyQuery>;
export type GetBrandForSlaAnalyticsFilterByPlatformQueryResult = Apollo.QueryResult<GetBrandForSlaAnalyticsFilterByPlatformQuery, GetBrandForSlaAnalyticsFilterByPlatformQueryVariables>;
export const GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelDocument = gql`
    query GetProductLinesModelsForSLAAnalyticsFilterByProductLineModel($input: PaginatedCapturedProductAllLabelsInput!) {
  productLinesModelsForCapturedProductAllLabels(input: $input) {
    data {
      productModel
      productLine
    }
    pageInfo {
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery__
 *
 * To run a query within a React component, call `useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery(baseOptions: Apollo.QueryHookOptions<GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery, GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery, GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryVariables>(GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelDocument, options);
      }
export function useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery, GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery, GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryVariables>(GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelDocument, options);
        }
export type GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryHookResult = ReturnType<typeof useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery>;
export type GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelLazyQueryHookResult = ReturnType<typeof useGetProductLinesModelsForSlaAnalyticsFilterByProductLineModelLazyQuery>;
export type GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryResult = Apollo.QueryResult<GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQuery, GetProductLinesModelsForSlaAnalyticsFilterByProductLineModelQueryVariables>;
export const GetTopicForSlaAnalyticsFiltersDocument = gql`
    query GetTopicForSLAAnalyticsFilters($topicId: String!) {
  topic(id: $topicId) {
    id
    topicSignalDefinitions {
      id
      signalDefinition {
        ...SignalDefinitionFragmentSLAAnalyticsFilterBySignals
      }
    }
  }
}
    ${SignalDefinitionFragmentSlaAnalyticsFilterBySignalsFragmentDoc}`;

/**
 * __useGetTopicForSlaAnalyticsFiltersQuery__
 *
 * To run a query within a React component, call `useGetTopicForSlaAnalyticsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicForSlaAnalyticsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicForSlaAnalyticsFiltersQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetTopicForSlaAnalyticsFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetTopicForSlaAnalyticsFiltersQuery, GetTopicForSlaAnalyticsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicForSlaAnalyticsFiltersQuery, GetTopicForSlaAnalyticsFiltersQueryVariables>(GetTopicForSlaAnalyticsFiltersDocument, options);
      }
export function useGetTopicForSlaAnalyticsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicForSlaAnalyticsFiltersQuery, GetTopicForSlaAnalyticsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicForSlaAnalyticsFiltersQuery, GetTopicForSlaAnalyticsFiltersQueryVariables>(GetTopicForSlaAnalyticsFiltersDocument, options);
        }
export type GetTopicForSlaAnalyticsFiltersQueryHookResult = ReturnType<typeof useGetTopicForSlaAnalyticsFiltersQuery>;
export type GetTopicForSlaAnalyticsFiltersLazyQueryHookResult = ReturnType<typeof useGetTopicForSlaAnalyticsFiltersLazyQuery>;
export type GetTopicForSlaAnalyticsFiltersQueryResult = Apollo.QueryResult<GetTopicForSlaAnalyticsFiltersQuery, GetTopicForSlaAnalyticsFiltersQueryVariables>;
export const GetOldestSocialPostForSlaAnalyticsFiltersDocument = gql`
    query GetOldestSocialPostForSLAAnalyticsFilters($data: BrandInboundFiltersInput!) {
  oldestSocialPostForBrandInboundFiltersInput(data: $data) {
    id
    platformCreateTime
  }
}
    `;

/**
 * __useGetOldestSocialPostForSlaAnalyticsFiltersQuery__
 *
 * To run a query within a React component, call `useGetOldestSocialPostForSlaAnalyticsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOldestSocialPostForSlaAnalyticsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOldestSocialPostForSlaAnalyticsFiltersQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetOldestSocialPostForSlaAnalyticsFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetOldestSocialPostForSlaAnalyticsFiltersQuery, GetOldestSocialPostForSlaAnalyticsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOldestSocialPostForSlaAnalyticsFiltersQuery, GetOldestSocialPostForSlaAnalyticsFiltersQueryVariables>(GetOldestSocialPostForSlaAnalyticsFiltersDocument, options);
      }
export function useGetOldestSocialPostForSlaAnalyticsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOldestSocialPostForSlaAnalyticsFiltersQuery, GetOldestSocialPostForSlaAnalyticsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOldestSocialPostForSlaAnalyticsFiltersQuery, GetOldestSocialPostForSlaAnalyticsFiltersQueryVariables>(GetOldestSocialPostForSlaAnalyticsFiltersDocument, options);
        }
export type GetOldestSocialPostForSlaAnalyticsFiltersQueryHookResult = ReturnType<typeof useGetOldestSocialPostForSlaAnalyticsFiltersQuery>;
export type GetOldestSocialPostForSlaAnalyticsFiltersLazyQueryHookResult = ReturnType<typeof useGetOldestSocialPostForSlaAnalyticsFiltersLazyQuery>;
export type GetOldestSocialPostForSlaAnalyticsFiltersQueryResult = Apollo.QueryResult<GetOldestSocialPostForSlaAnalyticsFiltersQuery, GetOldestSocialPostForSlaAnalyticsFiltersQueryVariables>;
export const GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemDocument = gql`
    query GetCapturedProductAttributeByIdsForSLAAnalyticsSelectedFilterItem($input: GetCapturedProductAttributeByIdsInput!) {
  attributeForCapturedProductAllLabelsByIds(input: $input) {
    id
    value
  }
}
    `;

/**
 * __useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>(GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemDocument, options);
      }
export function useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>(GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemDocument, options);
        }
export type GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryHookResult = ReturnType<typeof useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery>;
export type GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemLazyQueryHookResult = ReturnType<typeof useGetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemLazyQuery>;
export type GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryResult = Apollo.QueryResult<GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductAttributeByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>;
export const GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemDocument = gql`
    query GetCapturedProductCategoryByIdsForSLAAnalyticsSelectedFilterItem($input: GetCapturedProductCategoryByIdsInput!) {
  categoryForCapturedProductAllLabelsByIds(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>(GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemDocument, options);
      }
export function useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>(GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemDocument, options);
        }
export type GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryHookResult = ReturnType<typeof useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery>;
export type GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemLazyQueryHookResult = ReturnType<typeof useGetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemLazyQuery>;
export type GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryResult = Apollo.QueryResult<GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductCategoryByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>;
export const GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemDocument = gql`
    query GetCapturedProductBrandByIdsForSLAAnalyticsSelectedFilterItem($input: GetBrandByIdsInput!) {
  brandByIds(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>(GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemDocument, options);
      }
export function useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>(GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemDocument, options);
        }
export type GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryHookResult = ReturnType<typeof useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery>;
export type GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemLazyQueryHookResult = ReturnType<typeof useGetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemLazyQuery>;
export type GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryResult = Apollo.QueryResult<GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQuery, GetCapturedProductBrandByIdsForSlaAnalyticsSelectedFilterItemQueryVariables>;
export const GetCapturedProductsForSlaRankingTableDocument = gql`
    query GetCapturedProductsForSLARankingTable($data: BrandInboundFiltersInputForCapturedProduct!, $count: Int!) {
  capturedProductsPaginatedForInbound(data: $data) {
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      ...CapturedProductFragmentForSLARankingTable
    }
    meta {
      totalPostsCount
    }
  }
}
    ${CapturedProductFragmentForSlaRankingTableFragmentDoc}`;

/**
 * __useGetCapturedProductsForSlaRankingTableQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductsForSlaRankingTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductsForSlaRankingTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductsForSlaRankingTableQuery({
 *   variables: {
 *      data: // value for 'data'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetCapturedProductsForSlaRankingTableQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductsForSlaRankingTableQuery, GetCapturedProductsForSlaRankingTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductsForSlaRankingTableQuery, GetCapturedProductsForSlaRankingTableQueryVariables>(GetCapturedProductsForSlaRankingTableDocument, options);
      }
export function useGetCapturedProductsForSlaRankingTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductsForSlaRankingTableQuery, GetCapturedProductsForSlaRankingTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductsForSlaRankingTableQuery, GetCapturedProductsForSlaRankingTableQueryVariables>(GetCapturedProductsForSlaRankingTableDocument, options);
        }
export type GetCapturedProductsForSlaRankingTableQueryHookResult = ReturnType<typeof useGetCapturedProductsForSlaRankingTableQuery>;
export type GetCapturedProductsForSlaRankingTableLazyQueryHookResult = ReturnType<typeof useGetCapturedProductsForSlaRankingTableLazyQuery>;
export type GetCapturedProductsForSlaRankingTableQueryResult = Apollo.QueryResult<GetCapturedProductsForSlaRankingTableQuery, GetCapturedProductsForSlaRankingTableQueryVariables>;
export const GetCapturedProductsForSlaRankingTableCompetitorDocument = gql`
    query GetCapturedProductsForSLARankingTableCompetitor($data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct!, $count: Int!) {
  capturedProductsPaginatedForCompetitors(data: $data) {
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      ...CapturedProductFragmentForSLARankingTableCompetitor
    }
    meta {
      totalPostsCount
    }
  }
}
    ${CapturedProductFragmentForSlaRankingTableCompetitorFragmentDoc}`;

/**
 * __useGetCapturedProductsForSlaRankingTableCompetitorQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductsForSlaRankingTableCompetitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductsForSlaRankingTableCompetitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductsForSlaRankingTableCompetitorQuery({
 *   variables: {
 *      data: // value for 'data'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetCapturedProductsForSlaRankingTableCompetitorQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductsForSlaRankingTableCompetitorQuery, GetCapturedProductsForSlaRankingTableCompetitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductsForSlaRankingTableCompetitorQuery, GetCapturedProductsForSlaRankingTableCompetitorQueryVariables>(GetCapturedProductsForSlaRankingTableCompetitorDocument, options);
      }
export function useGetCapturedProductsForSlaRankingTableCompetitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductsForSlaRankingTableCompetitorQuery, GetCapturedProductsForSlaRankingTableCompetitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductsForSlaRankingTableCompetitorQuery, GetCapturedProductsForSlaRankingTableCompetitorQueryVariables>(GetCapturedProductsForSlaRankingTableCompetitorDocument, options);
        }
export type GetCapturedProductsForSlaRankingTableCompetitorQueryHookResult = ReturnType<typeof useGetCapturedProductsForSlaRankingTableCompetitorQuery>;
export type GetCapturedProductsForSlaRankingTableCompetitorLazyQueryHookResult = ReturnType<typeof useGetCapturedProductsForSlaRankingTableCompetitorLazyQuery>;
export type GetCapturedProductsForSlaRankingTableCompetitorQueryResult = Apollo.QueryResult<GetCapturedProductsForSlaRankingTableCompetitorQuery, GetCapturedProductsForSlaRankingTableCompetitorQueryVariables>;
export const GetBrandForTopicSelectorDocument = gql`
    query GetBrandForTopicSelector($brandId: String!) {
  brand(id: $brandId) {
    id
    topics {
      ...TopicFragmentTopicSelector
    }
  }
}
    ${TopicFragmentTopicSelectorFragmentDoc}`;

/**
 * __useGetBrandForTopicSelectorQuery__
 *
 * To run a query within a React component, call `useGetBrandForTopicSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForTopicSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForTopicSelectorQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForTopicSelectorQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForTopicSelectorQuery, GetBrandForTopicSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForTopicSelectorQuery, GetBrandForTopicSelectorQueryVariables>(GetBrandForTopicSelectorDocument, options);
      }
export function useGetBrandForTopicSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForTopicSelectorQuery, GetBrandForTopicSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForTopicSelectorQuery, GetBrandForTopicSelectorQueryVariables>(GetBrandForTopicSelectorDocument, options);
        }
export type GetBrandForTopicSelectorQueryHookResult = ReturnType<typeof useGetBrandForTopicSelectorQuery>;
export type GetBrandForTopicSelectorLazyQueryHookResult = ReturnType<typeof useGetBrandForTopicSelectorLazyQuery>;
export type GetBrandForTopicSelectorQueryResult = Apollo.QueryResult<GetBrandForTopicSelectorQuery, GetBrandForTopicSelectorQueryVariables>;
export const CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersDocument = gql`
    mutation CreateBookmarkForSocialListeningAnalyticsBookmarkHandlers($input: CreateBrandBookmarkInput!) {
  createBrandBookmark(input: $input) {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;
export type CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationFn = Apollo.MutationFunction<CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>;

/**
 * __useCreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, { data, loading, error }] = useCreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>(CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersDocument, options);
      }
export type CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationHookResult = ReturnType<typeof useCreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation>;
export type CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationResult = Apollo.MutationResult<CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation>;
export type CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, CreateBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>;
export const DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersDocument = gql`
    mutation DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlers($input: DeleteBrandBookmarkInput!) {
  deleteBrandBookmark(input: $input) {
    message
    success
    deleted {
      id
    }
  }
}
    `;
export type DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationFn = Apollo.MutationFunction<DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>;

/**
 * __useDeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, { data, loading, error }] = useDeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>(DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersDocument, options);
      }
export type DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationHookResult = ReturnType<typeof useDeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation>;
export type DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationResult = Apollo.MutationResult<DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation>;
export type DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutation, DeleteBookmarkForSocialListeningAnalyticsBookmarkHandlersMutationVariables>;
export const GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewDocument = gql`
    query GetSocialPostsCountriesDataForSLABrandAnalyticsCountriesDialogView($data: BrandInboundFiltersInput!) {
  getSocialPostsCountriesData(data: $data) {
    country
    totalEngagement
    totalImpressions
    totalPosts
    statsForFirstDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
    statsForLastDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
  }
}
    `;

/**
 * __useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryVariables>(GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewDocument, options);
      }
export function useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryVariables>(GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewDocument, options);
        }
export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryHookResult = ReturnType<typeof useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery>;
export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewLazyQuery>;
export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryResult = Apollo.QueryResult<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesDialogViewQueryVariables>;
export const GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewDocument = gql`
    query GetSocialPostsForSLABrandAnalyticsCountriesDialogView($data: PaginatedBrandInboundFiltersInputForSocialPosts!) {
  getBrandInboundSocialPosts(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    meta {
      totalCount
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryVariables>(GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewDocument, options);
      }
export function useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryVariables>(GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewDocument, options);
        }
export type GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryHookResult = ReturnType<typeof useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery>;
export type GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsForSlaBrandAnalyticsCountriesDialogViewLazyQuery>;
export type GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryResult = Apollo.QueryResult<GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsCountriesDialogViewQueryVariables>;
export const GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewDocument = gql`
    query GetSocialPostsCountriesDataForSLABrandAnalyticsCountriesView($data: BrandInboundFiltersInput!) {
  getSocialPostsCountriesData(data: $data) {
    country
    totalEngagement
    totalImpressions
    totalPosts
    statsForFirstDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
    statsForLastDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
  }
}
    `;

/**
 * __useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryVariables>(GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewDocument, options);
      }
export function useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryVariables>(GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewDocument, options);
        }
export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryHookResult = ReturnType<typeof useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery>;
export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewLazyQuery>;
export type GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryResult = Apollo.QueryResult<GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQuery, GetSocialPostsCountriesDataForSlaBrandAnalyticsCountriesViewQueryVariables>;
export const GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewDocument = gql`
    query GetCountriesWithSocialPostsForSLABrandAnalyticsInboundView($data: BrandInboundFiltersInput!) {
  countriesWithSocialPosts(data: $data) {
    code
  }
}
    `;

/**
 * __useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery__
 *
 * To run a query within a React component, call `useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery(baseOptions: Apollo.QueryHookOptions<GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryVariables>(GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewDocument, options);
      }
export function useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryVariables>(GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewDocument, options);
        }
export type GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryHookResult = ReturnType<typeof useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery>;
export type GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewLazyQueryHookResult = ReturnType<typeof useGetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewLazyQuery>;
export type GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryResult = Apollo.QueryResult<GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsInboundViewQueryVariables>;
export const GetBrandForSlaBrandAnalyticsInboundViewDocument = gql`
    query GetBrandForSLABrandAnalyticsInboundView($brandId: String!) {
  brand(id: $brandId) {
    id
    name
    topics {
      id
      type
    }
    ...BrandFragmentSLABrandContentTypeSelector
  }
}
    ${BrandFragmentSlaBrandContentTypeSelectorFragmentDoc}`;

/**
 * __useGetBrandForSlaBrandAnalyticsInboundViewQuery__
 *
 * To run a query within a React component, call `useGetBrandForSlaBrandAnalyticsInboundViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSlaBrandAnalyticsInboundViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSlaBrandAnalyticsInboundViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForSlaBrandAnalyticsInboundViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSlaBrandAnalyticsInboundViewQuery, GetBrandForSlaBrandAnalyticsInboundViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSlaBrandAnalyticsInboundViewQuery, GetBrandForSlaBrandAnalyticsInboundViewQueryVariables>(GetBrandForSlaBrandAnalyticsInboundViewDocument, options);
      }
export function useGetBrandForSlaBrandAnalyticsInboundViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSlaBrandAnalyticsInboundViewQuery, GetBrandForSlaBrandAnalyticsInboundViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSlaBrandAnalyticsInboundViewQuery, GetBrandForSlaBrandAnalyticsInboundViewQueryVariables>(GetBrandForSlaBrandAnalyticsInboundViewDocument, options);
        }
export type GetBrandForSlaBrandAnalyticsInboundViewQueryHookResult = ReturnType<typeof useGetBrandForSlaBrandAnalyticsInboundViewQuery>;
export type GetBrandForSlaBrandAnalyticsInboundViewLazyQueryHookResult = ReturnType<typeof useGetBrandForSlaBrandAnalyticsInboundViewLazyQuery>;
export type GetBrandForSlaBrandAnalyticsInboundViewQueryResult = Apollo.QueryResult<GetBrandForSlaBrandAnalyticsInboundViewQuery, GetBrandForSlaBrandAnalyticsInboundViewQueryVariables>;
export const GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewDocument = gql`
    query GetSocialPostsLanguagesDataForSLABrandAnalyticsLanguagesDialogView($data: BrandInboundFiltersInput!) {
  getSocialPostsLanguagesData(data: $data) {
    language
    totalEngagement
    totalImpressions
    totalPosts
    statsForFirstDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
    statsForLastDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
  }
}
    `;

/**
 * __useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>(GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewDocument, options);
      }
export function useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>(GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewDocument, options);
        }
export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryHookResult = ReturnType<typeof useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery>;
export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewLazyQuery>;
export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryResult = Apollo.QueryResult<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>;
export const GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewDocument = gql`
    query GetSocialPostsForSLABrandAnalyticsLanguagesDialogView($data: PaginatedBrandInboundFiltersInputForSocialPosts!) {
  getBrandInboundSocialPosts(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    meta {
      totalCount
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>(GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewDocument, options);
      }
export function useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>(GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewDocument, options);
        }
export type GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryHookResult = ReturnType<typeof useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery>;
export type GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewLazyQuery>;
export type GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryResult = Apollo.QueryResult<GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQuery, GetSocialPostsForSlaBrandAnalyticsLanguagesDialogViewQueryVariables>;
export const GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewDocument = gql`
    query GetSocialPostsLanguagesDataForSLABrandAnalyticsLanguagesView($data: BrandInboundFiltersInput!) {
  getSocialPostsLanguagesData(data: $data) {
    language
    totalEngagement
    totalImpressions
    totalPosts
    statsForFirstDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
    statsForLastDate {
      totalEngagement
      totalImpressions
      totalPosts
    }
  }
}
    `;

/**
 * __useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryVariables>(GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewDocument, options);
      }
export function useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryVariables>(GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewDocument, options);
        }
export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryHookResult = ReturnType<typeof useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery>;
export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewLazyQuery>;
export type GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryResult = Apollo.QueryResult<GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQuery, GetSocialPostsLanguagesDataForSlaBrandAnalyticsLanguagesViewQueryVariables>;
export const GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewDocument = gql`
    query GetCountriesWithSocialPostsForSLABrandAnalyticsTopicsView($data: BrandInboundFiltersInput!) {
  countriesWithSocialPosts(data: $data) {
    code
  }
}
    `;

/**
 * __useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery__
 *
 * To run a query within a React component, call `useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery(baseOptions: Apollo.QueryHookOptions<GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryVariables>(GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewDocument, options);
      }
export function useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryVariables>(GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewDocument, options);
        }
export type GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryHookResult = ReturnType<typeof useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery>;
export type GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewLazyQueryHookResult = ReturnType<typeof useGetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewLazyQuery>;
export type GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryResult = Apollo.QueryResult<GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQuery, GetCountriesWithSocialPostsForSlaBrandAnalyticsTopicsViewQueryVariables>;
export const GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewDocument = gql`
    query GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsView($data: BrandInboundFiltersInput!) {
  getBrandInboundCreatorDemographics(data: $data) {
    ...SocialPostCreatorDemographicFragmentSLACreatorDemographics
  }
}
    ${SocialPostCreatorDemographicFragmentSlaCreatorDemographicsFragmentDoc}`;

/**
 * __useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery__
 *
 * To run a query within a React component, call `useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery, GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery, GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryVariables>(GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewDocument, options);
      }
export function useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery, GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery, GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryVariables>(GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewDocument, options);
        }
export type GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryHookResult = ReturnType<typeof useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery>;
export type GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewLazyQueryHookResult = ReturnType<typeof useGetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewLazyQuery>;
export type GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryResult = Apollo.QueryResult<GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQuery, GetBrandInboundCreatorDemographicsForSlaBrandInboundCreatorDemographicsViewQueryVariables>;
export const GetTopicForSlaBrandInboundGraphViewDocument = gql`
    query GetTopicForSLABrandInboundGraphView($topicId: String!) {
  topic(id: $topicId) {
    id
    topicSignalDefinitions {
      id
      signalDefinition {
        ...SignalDefinitionFragmentSLAAnalyticsFilterBySignals
      }
    }
  }
}
    ${SignalDefinitionFragmentSlaAnalyticsFilterBySignalsFragmentDoc}`;

/**
 * __useGetTopicForSlaBrandInboundGraphViewQuery__
 *
 * To run a query within a React component, call `useGetTopicForSlaBrandInboundGraphViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicForSlaBrandInboundGraphViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicForSlaBrandInboundGraphViewQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetTopicForSlaBrandInboundGraphViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopicForSlaBrandInboundGraphViewQuery, GetTopicForSlaBrandInboundGraphViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicForSlaBrandInboundGraphViewQuery, GetTopicForSlaBrandInboundGraphViewQueryVariables>(GetTopicForSlaBrandInboundGraphViewDocument, options);
      }
export function useGetTopicForSlaBrandInboundGraphViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicForSlaBrandInboundGraphViewQuery, GetTopicForSlaBrandInboundGraphViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicForSlaBrandInboundGraphViewQuery, GetTopicForSlaBrandInboundGraphViewQueryVariables>(GetTopicForSlaBrandInboundGraphViewDocument, options);
        }
export type GetTopicForSlaBrandInboundGraphViewQueryHookResult = ReturnType<typeof useGetTopicForSlaBrandInboundGraphViewQuery>;
export type GetTopicForSlaBrandInboundGraphViewLazyQueryHookResult = ReturnType<typeof useGetTopicForSlaBrandInboundGraphViewLazyQuery>;
export type GetTopicForSlaBrandInboundGraphViewQueryResult = Apollo.QueryResult<GetTopicForSlaBrandInboundGraphViewQuery, GetTopicForSlaBrandInboundGraphViewQueryVariables>;
export const GetChartDataPointsForSlaBrandInboundGraphViewDocument = gql`
    query GetChartDataPointsForSLABrandInboundGraphView($data: BrandInboundFiltersInputForGraphData!) {
  brandInboundGraphData(data: $data) {
    chartDataPoints {
      Y
      X
    }
    multiChartDataPoints {
      id
      label
      parsingSince
      chartDataPoints {
        Y
        X
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetChartDataPointsForSlaBrandInboundGraphViewQuery__
 *
 * To run a query within a React component, call `useGetChartDataPointsForSlaBrandInboundGraphViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartDataPointsForSlaBrandInboundGraphViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartDataPointsForSlaBrandInboundGraphViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetChartDataPointsForSlaBrandInboundGraphViewQuery(baseOptions: Apollo.QueryHookOptions<GetChartDataPointsForSlaBrandInboundGraphViewQuery, GetChartDataPointsForSlaBrandInboundGraphViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartDataPointsForSlaBrandInboundGraphViewQuery, GetChartDataPointsForSlaBrandInboundGraphViewQueryVariables>(GetChartDataPointsForSlaBrandInboundGraphViewDocument, options);
      }
export function useGetChartDataPointsForSlaBrandInboundGraphViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartDataPointsForSlaBrandInboundGraphViewQuery, GetChartDataPointsForSlaBrandInboundGraphViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartDataPointsForSlaBrandInboundGraphViewQuery, GetChartDataPointsForSlaBrandInboundGraphViewQueryVariables>(GetChartDataPointsForSlaBrandInboundGraphViewDocument, options);
        }
export type GetChartDataPointsForSlaBrandInboundGraphViewQueryHookResult = ReturnType<typeof useGetChartDataPointsForSlaBrandInboundGraphViewQuery>;
export type GetChartDataPointsForSlaBrandInboundGraphViewLazyQueryHookResult = ReturnType<typeof useGetChartDataPointsForSlaBrandInboundGraphViewLazyQuery>;
export type GetChartDataPointsForSlaBrandInboundGraphViewQueryResult = Apollo.QueryResult<GetChartDataPointsForSlaBrandInboundGraphViewQuery, GetChartDataPointsForSlaBrandInboundGraphViewQueryVariables>;
export const GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewDocument = gql`
    query GetBrandInboundSocialPostsForSLABrandInboundGraphPostsView($data: PaginatedBrandInboundFiltersInputForSocialPosts!) {
  getBrandInboundSocialPosts(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    meta {
      totalCount
      totalEngagement
      totalViewCount
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery__
 *
 * To run a query within a React component, call `useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryVariables>(GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewDocument, options);
      }
export function useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryVariables>(GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewDocument, options);
        }
export type GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery>;
export type GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewLazyQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewLazyQuery>;
export type GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryResult = Apollo.QueryResult<GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundGraphPostsViewQueryVariables>;
export const GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewDocument = gql`
    query GetCapturedProductsSocialPostsForSLABrandInboundRankingProductCompetitorDialogView($data: PaginatedCompetitorFlatAnalyticFiltersInputForCapturedProductSocialPosts!) {
  capturedProductsSocialPostsPaginatedForCompetitors(data: $data) {
    data {
      ...SocialPostFragmentSLARankingProductSocialPosts
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${SocialPostFragmentSlaRankingProductSocialPostsFragmentDoc}`;

/**
 * __useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>(GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewDocument, options);
      }
export function useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>(GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewDocument, options);
        }
export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryHookResult = ReturnType<typeof useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery>;
export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQueryHookResult = ReturnType<typeof useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQuery>;
export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryResult = Apollo.QueryResult<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>;
export const GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewDocument = gql`
    query GetCapturedProductStatsForSLABrandInboundRankingProductCompetitorDialogView($data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct!) {
  capturedProductDataForCompetitorsStats(data: $data) {
    percentChange
    totalEngagement
    totalPostsCount
    totalViewCount
    graphData {
      ...CapturedProductGraphDataFragmentForSLARankingGraphData
    }
    attributeUsage {
      count
      attribute
    }
  }
}
    ${CapturedProductGraphDataFragmentForSlaRankingGraphDataFragmentDoc}`;

/**
 * __useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>(GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewDocument, options);
      }
export function useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>(GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewDocument, options);
        }
export type GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryHookResult = ReturnType<typeof useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery>;
export type GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQueryHookResult = ReturnType<typeof useGetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQuery>;
export type GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryResult = Apollo.QueryResult<GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>;
export const GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewDocument = gql`
    query GetTopProductsForSLABrandInboundRankingProductCompetitorDialogView($data: CompetitorFlatCreatorAnalyticFiltersInputForCapturedProduct!, $count: Int!) {
  capturedProductsPaginatedForCompetitors(data: $data) {
    data {
      ...CapturedProductFragmentForTopProductsSection
    }
  }
}
    ${CapturedProductFragmentForTopProductsSectionFragmentDoc}`;

/**
 * __useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery__
 *
 * To run a query within a React component, call `useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>(GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewDocument, options);
      }
export function useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>(GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewDocument, options);
        }
export type GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryHookResult = ReturnType<typeof useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery>;
export type GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQueryHookResult = ReturnType<typeof useGetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewLazyQuery>;
export type GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryResult = Apollo.QueryResult<GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductCompetitorDialogViewQueryVariables>;
export const GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewDocument = gql`
    query GetCapturedProductsSocialPostsForSLABrandInboundRankingProductDialogView($data: PaginatedBrandInboundFiltersInputForCapturedProductSocialPosts!) {
  capturedProductsSocialPostsPaginatedForInbound(data: $data) {
    data {
      ...SocialPostFragmentSLARankingProductSocialPosts
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${SocialPostFragmentSlaRankingProductSocialPostsFragmentDoc}`;

/**
 * __useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryVariables>(GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewDocument, options);
      }
export function useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryVariables>(GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewDocument, options);
        }
export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryHookResult = ReturnType<typeof useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery>;
export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewLazyQueryHookResult = ReturnType<typeof useGetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewLazyQuery>;
export type GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryResult = Apollo.QueryResult<GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductsSocialPostsForSlaBrandInboundRankingProductDialogViewQueryVariables>;
export const GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewDocument = gql`
    query GetCapturedProductStatsForSLABrandInboundRankingProductDialogView($data: BrandInboundFiltersInputForCapturedProduct!) {
  capturedProductDataForInboundStats(data: $data) {
    percentChange
    totalEngagement
    totalPostsCount
    totalViewCount
    graphData {
      ...CapturedProductGraphDataFragmentForSLARankingGraphData
    }
    attributeUsage {
      count
      attribute
    }
  }
}
    ${CapturedProductGraphDataFragmentForSlaRankingGraphDataFragmentDoc}`;

/**
 * __useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryVariables>(GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewDocument, options);
      }
export function useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryVariables>(GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewDocument, options);
        }
export type GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryHookResult = ReturnType<typeof useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery>;
export type GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewLazyQueryHookResult = ReturnType<typeof useGetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewLazyQuery>;
export type GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryResult = Apollo.QueryResult<GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQuery, GetCapturedProductStatsForSlaBrandInboundRankingProductDialogViewQueryVariables>;
export const GetTopProductsForSlaBrandInboundRankingProductDialogViewDocument = gql`
    query GetTopProductsForSLABrandInboundRankingProductDialogView($data: BrandInboundFiltersInputForCapturedProduct!, $count: Int!) {
  capturedProductsPaginatedForInbound(data: $data) {
    data {
      ...CapturedProductFragmentForTopProductsSection
    }
  }
}
    ${CapturedProductFragmentForTopProductsSectionFragmentDoc}`;

/**
 * __useGetTopProductsForSlaBrandInboundRankingProductDialogViewQuery__
 *
 * To run a query within a React component, call `useGetTopProductsForSlaBrandInboundRankingProductDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopProductsForSlaBrandInboundRankingProductDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopProductsForSlaBrandInboundRankingProductDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetTopProductsForSlaBrandInboundRankingProductDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopProductsForSlaBrandInboundRankingProductDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopProductsForSlaBrandInboundRankingProductDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryVariables>(GetTopProductsForSlaBrandInboundRankingProductDialogViewDocument, options);
      }
export function useGetTopProductsForSlaBrandInboundRankingProductDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopProductsForSlaBrandInboundRankingProductDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopProductsForSlaBrandInboundRankingProductDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryVariables>(GetTopProductsForSlaBrandInboundRankingProductDialogViewDocument, options);
        }
export type GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryHookResult = ReturnType<typeof useGetTopProductsForSlaBrandInboundRankingProductDialogViewQuery>;
export type GetTopProductsForSlaBrandInboundRankingProductDialogViewLazyQueryHookResult = ReturnType<typeof useGetTopProductsForSlaBrandInboundRankingProductDialogViewLazyQuery>;
export type GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryResult = Apollo.QueryResult<GetTopProductsForSlaBrandInboundRankingProductDialogViewQuery, GetTopProductsForSlaBrandInboundRankingProductDialogViewQueryVariables>;
export const GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalDocument = gql`
    query GetBrandSentimentInteractionsForSLABrandInboundSentimentClaimModal($data: PaginatedBrandInboundFiltersInputForSentimentClaimInteractions!, $brandId: String!) {
  getBrandSentimentInteractions(data: $data) {
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      socialPosts {
        id
        ...SocialPostFragmentSocialPostClaimsCard
        brandAnalysis {
          id
          brandId
          sentimentScore
          brandClaims {
            attribute
            claim
            id
          }
        }
      }
      socialPostComments {
        id
        text
        socialPostCommentClaims {
          id
          claim
          claimAttribute
          brandId
        }
        socialPost {
          id
          ...SocialPostFragmentSocialPostClaimsCard
          brandAnalysis {
            id
            brandId
            sentimentScore
            brandClaims {
              claim
              id
            }
          }
        }
      }
    }
  }
}
    ${SocialPostFragmentSocialPostClaimsCardFragmentDoc}`;

/**
 * __useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery__
 *
 * To run a query within a React component, call `useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery({
 *   variables: {
 *      data: // value for 'data'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery(baseOptions: Apollo.QueryHookOptions<GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery, GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery, GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryVariables>(GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalDocument, options);
      }
export function useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery, GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery, GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryVariables>(GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalDocument, options);
        }
export type GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryHookResult = ReturnType<typeof useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery>;
export type GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalLazyQueryHookResult = ReturnType<typeof useGetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalLazyQuery>;
export type GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryResult = Apollo.QueryResult<GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQuery, GetBrandSentimentInteractionsForSlaBrandInboundSentimentClaimModalQueryVariables>;
export const GetBrandInboundSentimentMetricsDocument = gql`
    query GetBrandInboundSentimentMetrics($data: BrandInboundFiltersInputForSentimentMetrics!) {
  brandInboundSentimentMetrics(data: $data) {
    sentimentMetrics {
      averageCountPerDay
      chartDataPoints {
        Y
        X
      }
      totalCount
    }
    claimMetrics {
      numberOfMentions
      attribute
    }
  }
}
    `;

/**
 * __useGetBrandInboundSentimentMetricsQuery__
 *
 * To run a query within a React component, call `useGetBrandInboundSentimentMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInboundSentimentMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInboundSentimentMetricsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandInboundSentimentMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInboundSentimentMetricsQuery, GetBrandInboundSentimentMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInboundSentimentMetricsQuery, GetBrandInboundSentimentMetricsQueryVariables>(GetBrandInboundSentimentMetricsDocument, options);
      }
export function useGetBrandInboundSentimentMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInboundSentimentMetricsQuery, GetBrandInboundSentimentMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInboundSentimentMetricsQuery, GetBrandInboundSentimentMetricsQueryVariables>(GetBrandInboundSentimentMetricsDocument, options);
        }
export type GetBrandInboundSentimentMetricsQueryHookResult = ReturnType<typeof useGetBrandInboundSentimentMetricsQuery>;
export type GetBrandInboundSentimentMetricsLazyQueryHookResult = ReturnType<typeof useGetBrandInboundSentimentMetricsLazyQuery>;
export type GetBrandInboundSentimentMetricsQueryResult = Apollo.QueryResult<GetBrandInboundSentimentMetricsQuery, GetBrandInboundSentimentMetricsQueryVariables>;
export const GetBrandForSlaBrandInboundSummaryViewDocument = gql`
    query GetBrandForSLABrandInboundSummaryView($brandId: String!, $data: BrandInboundFiltersInput!) {
  brand(id: $brandId) {
    id
    name
    __typename
    brandSummary(data: $data) {
      __typename
      averageLikes
      averageViewCount
      followers
      postsPerWeek
      totalEngagements
      totalPosts
      totalViewCount
    }
  }
}
    `;

/**
 * __useGetBrandForSlaBrandInboundSummaryViewQuery__
 *
 * To run a query within a React component, call `useGetBrandForSlaBrandInboundSummaryViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSlaBrandInboundSummaryViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSlaBrandInboundSummaryViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandForSlaBrandInboundSummaryViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSlaBrandInboundSummaryViewQuery, GetBrandForSlaBrandInboundSummaryViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSlaBrandInboundSummaryViewQuery, GetBrandForSlaBrandInboundSummaryViewQueryVariables>(GetBrandForSlaBrandInboundSummaryViewDocument, options);
      }
export function useGetBrandForSlaBrandInboundSummaryViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSlaBrandInboundSummaryViewQuery, GetBrandForSlaBrandInboundSummaryViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSlaBrandInboundSummaryViewQuery, GetBrandForSlaBrandInboundSummaryViewQueryVariables>(GetBrandForSlaBrandInboundSummaryViewDocument, options);
        }
export type GetBrandForSlaBrandInboundSummaryViewQueryHookResult = ReturnType<typeof useGetBrandForSlaBrandInboundSummaryViewQuery>;
export type GetBrandForSlaBrandInboundSummaryViewLazyQueryHookResult = ReturnType<typeof useGetBrandForSlaBrandInboundSummaryViewLazyQuery>;
export type GetBrandForSlaBrandInboundSummaryViewQueryResult = Apollo.QueryResult<GetBrandForSlaBrandInboundSummaryViewQuery, GetBrandForSlaBrandInboundSummaryViewQueryVariables>;
export const GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewDocument = gql`
    query GetBrandInboundTopCreatorsForSLABrandInboundTopCreatorsView($data: PaginatedBrandInboundFiltersInputForTopCreators!) {
  brandInboundTopCreators(data: $data) {
    data {
      __typename
      id
      ...CreatorFragmentSLATopCreators
    }
  }
}
    ${CreatorFragmentSlaTopCreatorsFragmentDoc}`;

/**
 * __useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery__
 *
 * To run a query within a React component, call `useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery, GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery, GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryVariables>(GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewDocument, options);
      }
export function useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery, GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery, GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryVariables>(GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewDocument, options);
        }
export type GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryHookResult = ReturnType<typeof useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery>;
export type GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewLazyQueryHookResult = ReturnType<typeof useGetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewLazyQuery>;
export type GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryResult = Apollo.QueryResult<GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQuery, GetBrandInboundTopCreatorsForSlaBrandInboundTopCreatorsViewQueryVariables>;
export const GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewDocument = gql`
    query GetHashtagsForBrandForSLABrandInboundTopHashtagsView($data: BrandInboundFiltersInputForHashtagsUsed!) {
  hashtagsForBrand(data: $data) {
    name
    isHidden
    averageEngagementRate
    numberOfTimesUsed
  }
}
    `;

/**
 * __useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery__
 *
 * To run a query within a React component, call `useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery(baseOptions: Apollo.QueryHookOptions<GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery, GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery, GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryVariables>(GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewDocument, options);
      }
export function useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery, GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery, GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryVariables>(GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewDocument, options);
        }
export type GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryHookResult = ReturnType<typeof useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery>;
export type GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewLazyQueryHookResult = ReturnType<typeof useGetHashtagsForBrandForSlaBrandInboundTopHashtagsViewLazyQuery>;
export type GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryResult = Apollo.QueryResult<GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQuery, GetHashtagsForBrandForSlaBrandInboundTopHashtagsViewQueryVariables>;
export const HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewDocument = gql`
    mutation HideHashtagUsedForSlaBrandForSLABrandInboundTopHashtagsView($data: HideHashtagUsedForBrandInput!) {
  hideHashtagUsedForBrand(data: $data) {
    success
  }
}
    `;
export type HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationFn = Apollo.MutationFunction<HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>;

/**
 * __useHideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation__
 *
 * To run a mutation, you first call `useHideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, { data, loading, error }] = useHideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation(baseOptions?: Apollo.MutationHookOptions<HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>(HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewDocument, options);
      }
export type HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationHookResult = ReturnType<typeof useHideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation>;
export type HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationResult = Apollo.MutationResult<HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation>;
export type HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationOptions = Apollo.BaseMutationOptions<HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, HideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>;
export const UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewDocument = gql`
    mutation UnhideHashtagUsedForSlaBrandForSLABrandInboundTopHashtagsView($data: HideHashtagUsedForBrandInput!) {
  unhideHashtagUsedForBrand(data: $data) {
    success
  }
}
    `;
export type UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationFn = Apollo.MutationFunction<UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>;

/**
 * __useUnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation__
 *
 * To run a mutation, you first call `useUnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, { data, loading, error }] = useUnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation(baseOptions?: Apollo.MutationHookOptions<UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>(UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewDocument, options);
      }
export type UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationHookResult = ReturnType<typeof useUnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation>;
export type UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationResult = Apollo.MutationResult<UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation>;
export type UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationOptions = Apollo.BaseMutationOptions<UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutation, UnhideHashtagUsedForSlaBrandForSlaBrandInboundTopHashtagsViewMutationVariables>;
export const GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewDocument = gql`
    query GetBrandInboundSocialPostsForSLABrandInboundTopPostsView($data: PaginatedBrandInboundFiltersInputForSocialPosts!) {
  getBrandInboundSocialPosts(data: $data) {
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      ...SocialPostFragmentSLAInfinitePostsGrid
    }
  }
}
    ${SocialPostFragmentSlaInfinitePostsGridFragmentDoc}`;

/**
 * __useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery__
 *
 * To run a query within a React component, call `useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryVariables>(GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewDocument, options);
      }
export function useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryVariables>(GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewDocument, options);
        }
export type GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery>;
export type GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewLazyQueryHookResult = ReturnType<typeof useGetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewLazyQuery>;
export type GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryResult = Apollo.QueryResult<GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQuery, GetBrandInboundSocialPostsForSlaBrandInboundTopPostsViewQueryVariables>;
export const GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewDocument = gql`
    query GetCreatorForBrandTopCreatorPostsForSLABrandTopCreatorPostsView($data: GetCreatorInput!) {
  getCreator(data: $data) {
    ...CreatorFragmentSLABrandTopCreatorPostsView
  }
}
    ${CreatorFragmentSlaBrandTopCreatorPostsViewFragmentDoc}`;

/**
 * __useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery__
 *
 * To run a query within a React component, call `useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery, GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery, GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryVariables>(GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewDocument, options);
      }
export function useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery, GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery, GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryVariables>(GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewDocument, options);
        }
export type GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryHookResult = ReturnType<typeof useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery>;
export type GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewLazyQueryHookResult = ReturnType<typeof useGetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewLazyQuery>;
export type GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryResult = Apollo.QueryResult<GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQuery, GetCreatorForBrandTopCreatorPostsForSlaBrandTopCreatorPostsViewQueryVariables>;
export const GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewDocument = gql`
    query GetTopCreatorPostsThatMentionedBrandForSLABrandTopCreatorPostsView($data: GetTopCreatorPostsThatMentionedBrandInput!) {
  topCreatorPostsThatMentionedBrand(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    meta {
      totalCount
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery__
 *
 * To run a query within a React component, call `useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery, GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery, GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryVariables>(GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewDocument, options);
      }
export function useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery, GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery, GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryVariables>(GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewDocument, options);
        }
export type GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryHookResult = ReturnType<typeof useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery>;
export type GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewLazyQueryHookResult = ReturnType<typeof useGetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewLazyQuery>;
export type GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryResult = Apollo.QueryResult<GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQuery, GetTopCreatorPostsThatMentionedBrandForSlaBrandTopCreatorPostsViewQueryVariables>;
export const GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewDocument = gql`
    query GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsView($data: GetTopHashtagsPostsForBrandInput!) {
  getSocialPostsByHashtagsForBrand(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    meta {
      totalCount
      averageEngagementRate
      numberOfTimesUsed
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery__
 *
 * To run a query within a React component, call `useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery, GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery, GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryVariables>(GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewDocument, options);
      }
export function useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery, GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery, GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryVariables>(GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewDocument, options);
        }
export type GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryHookResult = ReturnType<typeof useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery>;
export type GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewLazyQueryHookResult = ReturnType<typeof useGetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewLazyQuery>;
export type GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryResult = Apollo.QueryResult<GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQuery, GetTopHashtagsPostsForBrandForSlaBrandTopHashtagPostsViewQueryVariables>;
export const AddBrandExclusionForSlaRelatedBrandsViewDocument = gql`
    mutation AddBrandExclusionForSLARelatedBrandsView($data: ExcludeBrandInput!) {
  addBrandExclusion(data: $data) {
    message
    success
  }
}
    `;
export type AddBrandExclusionForSlaRelatedBrandsViewMutationFn = Apollo.MutationFunction<AddBrandExclusionForSlaRelatedBrandsViewMutation, AddBrandExclusionForSlaRelatedBrandsViewMutationVariables>;

/**
 * __useAddBrandExclusionForSlaRelatedBrandsViewMutation__
 *
 * To run a mutation, you first call `useAddBrandExclusionForSlaRelatedBrandsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBrandExclusionForSlaRelatedBrandsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBrandExclusionForSlaRelatedBrandsViewMutation, { data, loading, error }] = useAddBrandExclusionForSlaRelatedBrandsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddBrandExclusionForSlaRelatedBrandsViewMutation(baseOptions?: Apollo.MutationHookOptions<AddBrandExclusionForSlaRelatedBrandsViewMutation, AddBrandExclusionForSlaRelatedBrandsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBrandExclusionForSlaRelatedBrandsViewMutation, AddBrandExclusionForSlaRelatedBrandsViewMutationVariables>(AddBrandExclusionForSlaRelatedBrandsViewDocument, options);
      }
export type AddBrandExclusionForSlaRelatedBrandsViewMutationHookResult = ReturnType<typeof useAddBrandExclusionForSlaRelatedBrandsViewMutation>;
export type AddBrandExclusionForSlaRelatedBrandsViewMutationResult = Apollo.MutationResult<AddBrandExclusionForSlaRelatedBrandsViewMutation>;
export type AddBrandExclusionForSlaRelatedBrandsViewMutationOptions = Apollo.BaseMutationOptions<AddBrandExclusionForSlaRelatedBrandsViewMutation, AddBrandExclusionForSlaRelatedBrandsViewMutationVariables>;
export const GetRelatedBrandsForSlaRelatedBrandsViewDocument = gql`
    query GetRelatedBrandsForSLARelatedBrandsView($data: BrandInboundFiltersInputForRelatedBrands!) {
  getRelatedBrands(data: $data) {
    meta {
      totalCount
    }
    data {
      ...RelatedBrandForSLARelatedBrandsView
    }
  }
}
    ${RelatedBrandForSlaRelatedBrandsViewFragmentDoc}`;

/**
 * __useGetRelatedBrandsForSlaRelatedBrandsViewQuery__
 *
 * To run a query within a React component, call `useGetRelatedBrandsForSlaRelatedBrandsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedBrandsForSlaRelatedBrandsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedBrandsForSlaRelatedBrandsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetRelatedBrandsForSlaRelatedBrandsViewQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedBrandsForSlaRelatedBrandsViewQuery, GetRelatedBrandsForSlaRelatedBrandsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedBrandsForSlaRelatedBrandsViewQuery, GetRelatedBrandsForSlaRelatedBrandsViewQueryVariables>(GetRelatedBrandsForSlaRelatedBrandsViewDocument, options);
      }
export function useGetRelatedBrandsForSlaRelatedBrandsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedBrandsForSlaRelatedBrandsViewQuery, GetRelatedBrandsForSlaRelatedBrandsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedBrandsForSlaRelatedBrandsViewQuery, GetRelatedBrandsForSlaRelatedBrandsViewQueryVariables>(GetRelatedBrandsForSlaRelatedBrandsViewDocument, options);
        }
export type GetRelatedBrandsForSlaRelatedBrandsViewQueryHookResult = ReturnType<typeof useGetRelatedBrandsForSlaRelatedBrandsViewQuery>;
export type GetRelatedBrandsForSlaRelatedBrandsViewLazyQueryHookResult = ReturnType<typeof useGetRelatedBrandsForSlaRelatedBrandsViewLazyQuery>;
export type GetRelatedBrandsForSlaRelatedBrandsViewQueryResult = Apollo.QueryResult<GetRelatedBrandsForSlaRelatedBrandsViewQuery, GetRelatedBrandsForSlaRelatedBrandsViewQueryVariables>;
export const GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewDocument = gql`
    query GetPaginatedRelatedBrandsSocialPostsForSLARelatedBrandsTopPostsView($data: PaginatedBrandInboundFiltersInputForRelatedBrands!) {
  getPaginatedRelatedBrandsSocialPosts(data: $data) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    meta {
      totalCount
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery__
 *
 * To run a query within a React component, call `useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery, GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery, GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryVariables>(GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewDocument, options);
      }
export function useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery, GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery, GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryVariables>(GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewDocument, options);
        }
export type GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryHookResult = ReturnType<typeof useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery>;
export type GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewLazyQueryHookResult = ReturnType<typeof useGetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewLazyQuery>;
export type GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryResult = Apollo.QueryResult<GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQuery, GetPaginatedRelatedBrandsSocialPostsForSlaRelatedBrandsTopPostsViewQueryVariables>;
export const GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewDocument = gql`
    query GetBrandSentimentInteractionsForSLATopicInboundSentimentClaimsInteractionsModalView($data: PaginatedBrandInboundFiltersInputForSentimentClaimInteractions!, $brandId: String!) {
  sentimentClaimInteractions(data: $data) {
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    data {
      socialPosts {
        id
        ...SocialPostFragmentSocialPostClaimsCard
        socialPostSentimentSubjectClaims {
          id
          claim
          attribute
          isConfident
        }
      }
      socialPostComments {
        id
        text
        socialPostCommentClaims {
          id
          claim
          claimAttribute
          brandId
        }
        socialPost {
          id
          ...SocialPostFragmentSocialPostClaimsCard
          brandAnalysis {
            id
            brandId
            sentimentScore
            brandClaims {
              claim
              id
            }
          }
        }
      }
    }
  }
}
    ${SocialPostFragmentSocialPostClaimsCardFragmentDoc}`;

/**
 * __useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery__
 *
 * To run a query within a React component, call `useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery, GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery, GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryVariables>(GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewDocument, options);
      }
export function useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery, GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery, GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryVariables>(GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewDocument, options);
        }
export type GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryHookResult = ReturnType<typeof useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery>;
export type GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewLazyQueryHookResult = ReturnType<typeof useGetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewLazyQuery>;
export type GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryResult = Apollo.QueryResult<GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQuery, GetBrandSentimentInteractionsForSlaTopicInboundSentimentClaimsInteractionsModalViewQueryVariables>;
export const GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsDocument = gql`
    query GetSentimentSubjectClaimMetricsForSLATopicInboundSentiments($data: BrandInboundFiltersInputForSentimentMetrics!) {
  sentimentSubjectClaimMetricsForTopicInbound(data: $data) {
    sentimentMetrics {
      totalCount
      chartDataPoints {
        X
        Y
      }
      averageCountPerDay
    }
    claimMetrics {
      numberOfMentions
      attribute
    }
  }
}
    `;

/**
 * __useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery__
 *
 * To run a query within a React component, call `useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery(baseOptions: Apollo.QueryHookOptions<GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery, GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery, GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryVariables>(GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsDocument, options);
      }
export function useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery, GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery, GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryVariables>(GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsDocument, options);
        }
export type GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryHookResult = ReturnType<typeof useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery>;
export type GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsLazyQueryHookResult = ReturnType<typeof useGetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsLazyQuery>;
export type GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryResult = Apollo.QueryResult<GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQuery, GetSentimentSubjectClaimMetricsForSlaTopicInboundSentimentsQueryVariables>;
export const GetTopicForSlaTopicInboundSentimentsViewDocument = gql`
    query GetTopicForSLATopicInboundSentimentsView($topicId: String!) {
  topic(id: $topicId) {
    id
    sentimentSubjects {
      ...SentimentSubjectFragmentSLATopicInboundSentimentsView
    }
  }
}
    ${SentimentSubjectFragmentSlaTopicInboundSentimentsViewFragmentDoc}`;

/**
 * __useGetTopicForSlaTopicInboundSentimentsViewQuery__
 *
 * To run a query within a React component, call `useGetTopicForSlaTopicInboundSentimentsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicForSlaTopicInboundSentimentsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicForSlaTopicInboundSentimentsViewQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetTopicForSlaTopicInboundSentimentsViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopicForSlaTopicInboundSentimentsViewQuery, GetTopicForSlaTopicInboundSentimentsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicForSlaTopicInboundSentimentsViewQuery, GetTopicForSlaTopicInboundSentimentsViewQueryVariables>(GetTopicForSlaTopicInboundSentimentsViewDocument, options);
      }
export function useGetTopicForSlaTopicInboundSentimentsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicForSlaTopicInboundSentimentsViewQuery, GetTopicForSlaTopicInboundSentimentsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicForSlaTopicInboundSentimentsViewQuery, GetTopicForSlaTopicInboundSentimentsViewQueryVariables>(GetTopicForSlaTopicInboundSentimentsViewDocument, options);
        }
export type GetTopicForSlaTopicInboundSentimentsViewQueryHookResult = ReturnType<typeof useGetTopicForSlaTopicInboundSentimentsViewQuery>;
export type GetTopicForSlaTopicInboundSentimentsViewLazyQueryHookResult = ReturnType<typeof useGetTopicForSlaTopicInboundSentimentsViewLazyQuery>;
export type GetTopicForSlaTopicInboundSentimentsViewQueryResult = Apollo.QueryResult<GetTopicForSlaTopicInboundSentimentsViewQuery, GetTopicForSlaTopicInboundSentimentsViewQueryVariables>;
export const GetCreatorProfileLabelsForSlLabelSelectorDocument = gql`
    query getCreatorProfileLabelsForSLLabelSelector($input: PaginatedOrganizationCreatorProfileLabelInput!) {
  paginatedOrganizationCreatorProfileLabels(input: $input) {
    data {
      ...OrganizationCreatorProfileLabelFragmentSLLabelSelector
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${OrganizationCreatorProfileLabelFragmentSlLabelSelectorFragmentDoc}`;

/**
 * __useGetCreatorProfileLabelsForSlLabelSelectorQuery__
 *
 * To run a query within a React component, call `useGetCreatorProfileLabelsForSlLabelSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorProfileLabelsForSlLabelSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorProfileLabelsForSlLabelSelectorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCreatorProfileLabelsForSlLabelSelectorQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorProfileLabelsForSlLabelSelectorQuery, GetCreatorProfileLabelsForSlLabelSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorProfileLabelsForSlLabelSelectorQuery, GetCreatorProfileLabelsForSlLabelSelectorQueryVariables>(GetCreatorProfileLabelsForSlLabelSelectorDocument, options);
      }
export function useGetCreatorProfileLabelsForSlLabelSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorProfileLabelsForSlLabelSelectorQuery, GetCreatorProfileLabelsForSlLabelSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorProfileLabelsForSlLabelSelectorQuery, GetCreatorProfileLabelsForSlLabelSelectorQueryVariables>(GetCreatorProfileLabelsForSlLabelSelectorDocument, options);
        }
export type GetCreatorProfileLabelsForSlLabelSelectorQueryHookResult = ReturnType<typeof useGetCreatorProfileLabelsForSlLabelSelectorQuery>;
export type GetCreatorProfileLabelsForSlLabelSelectorLazyQueryHookResult = ReturnType<typeof useGetCreatorProfileLabelsForSlLabelSelectorLazyQuery>;
export type GetCreatorProfileLabelsForSlLabelSelectorQueryResult = Apollo.QueryResult<GetCreatorProfileLabelsForSlLabelSelectorQuery, GetCreatorProfileLabelsForSlLabelSelectorQueryVariables>;
export const CreateCreatorProfileLabelForSlLabelSelectorDocument = gql`
    mutation CreateCreatorProfileLabelForSLLabelSelector($input: CreateOrganizationCreatorProfileLabelInput!) {
  createOrganizationCreatorProfileLabel(input: $input) {
    ...OrganizationCreatorProfileLabelFragmentSLLabelSelector
  }
}
    ${OrganizationCreatorProfileLabelFragmentSlLabelSelectorFragmentDoc}`;
export type CreateCreatorProfileLabelForSlLabelSelectorMutationFn = Apollo.MutationFunction<CreateCreatorProfileLabelForSlLabelSelectorMutation, CreateCreatorProfileLabelForSlLabelSelectorMutationVariables>;

/**
 * __useCreateCreatorProfileLabelForSlLabelSelectorMutation__
 *
 * To run a mutation, you first call `useCreateCreatorProfileLabelForSlLabelSelectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreatorProfileLabelForSlLabelSelectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreatorProfileLabelForSlLabelSelectorMutation, { data, loading, error }] = useCreateCreatorProfileLabelForSlLabelSelectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCreatorProfileLabelForSlLabelSelectorMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreatorProfileLabelForSlLabelSelectorMutation, CreateCreatorProfileLabelForSlLabelSelectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreatorProfileLabelForSlLabelSelectorMutation, CreateCreatorProfileLabelForSlLabelSelectorMutationVariables>(CreateCreatorProfileLabelForSlLabelSelectorDocument, options);
      }
export type CreateCreatorProfileLabelForSlLabelSelectorMutationHookResult = ReturnType<typeof useCreateCreatorProfileLabelForSlLabelSelectorMutation>;
export type CreateCreatorProfileLabelForSlLabelSelectorMutationResult = Apollo.MutationResult<CreateCreatorProfileLabelForSlLabelSelectorMutation>;
export type CreateCreatorProfileLabelForSlLabelSelectorMutationOptions = Apollo.BaseMutationOptions<CreateCreatorProfileLabelForSlLabelSelectorMutation, CreateCreatorProfileLabelForSlLabelSelectorMutationVariables>;
export const AddLabelToCreatorProfileForSlLabelSelectorDocument = gql`
    mutation AddLabelToCreatorProfileForSLLabelSelector($input: AddOrganizationCreatorProfileLabelToCreatorProfileInput!) {
  addOrganizationCreatorProfileLabelToCreatorProfile(input: $input) {
    message
    success
  }
}
    `;
export type AddLabelToCreatorProfileForSlLabelSelectorMutationFn = Apollo.MutationFunction<AddLabelToCreatorProfileForSlLabelSelectorMutation, AddLabelToCreatorProfileForSlLabelSelectorMutationVariables>;

/**
 * __useAddLabelToCreatorProfileForSlLabelSelectorMutation__
 *
 * To run a mutation, you first call `useAddLabelToCreatorProfileForSlLabelSelectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLabelToCreatorProfileForSlLabelSelectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLabelToCreatorProfileForSlLabelSelectorMutation, { data, loading, error }] = useAddLabelToCreatorProfileForSlLabelSelectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLabelToCreatorProfileForSlLabelSelectorMutation(baseOptions?: Apollo.MutationHookOptions<AddLabelToCreatorProfileForSlLabelSelectorMutation, AddLabelToCreatorProfileForSlLabelSelectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLabelToCreatorProfileForSlLabelSelectorMutation, AddLabelToCreatorProfileForSlLabelSelectorMutationVariables>(AddLabelToCreatorProfileForSlLabelSelectorDocument, options);
      }
export type AddLabelToCreatorProfileForSlLabelSelectorMutationHookResult = ReturnType<typeof useAddLabelToCreatorProfileForSlLabelSelectorMutation>;
export type AddLabelToCreatorProfileForSlLabelSelectorMutationResult = Apollo.MutationResult<AddLabelToCreatorProfileForSlLabelSelectorMutation>;
export type AddLabelToCreatorProfileForSlLabelSelectorMutationOptions = Apollo.BaseMutationOptions<AddLabelToCreatorProfileForSlLabelSelectorMutation, AddLabelToCreatorProfileForSlLabelSelectorMutationVariables>;
export const RemoveLabelFromCreatorProfileForSlLabelSelectorDocument = gql`
    mutation RemoveLabelFromCreatorProfileForSLLabelSelector($input: RemoveOrganizationCreatorProfileLabelFromCreatorProfileInput!) {
  removeOrganizationCreatorProfileLabelFromCreatorProfile(input: $input) {
    message
    success
  }
}
    `;
export type RemoveLabelFromCreatorProfileForSlLabelSelectorMutationFn = Apollo.MutationFunction<RemoveLabelFromCreatorProfileForSlLabelSelectorMutation, RemoveLabelFromCreatorProfileForSlLabelSelectorMutationVariables>;

/**
 * __useRemoveLabelFromCreatorProfileForSlLabelSelectorMutation__
 *
 * To run a mutation, you first call `useRemoveLabelFromCreatorProfileForSlLabelSelectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabelFromCreatorProfileForSlLabelSelectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabelFromCreatorProfileForSlLabelSelectorMutation, { data, loading, error }] = useRemoveLabelFromCreatorProfileForSlLabelSelectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLabelFromCreatorProfileForSlLabelSelectorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabelFromCreatorProfileForSlLabelSelectorMutation, RemoveLabelFromCreatorProfileForSlLabelSelectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabelFromCreatorProfileForSlLabelSelectorMutation, RemoveLabelFromCreatorProfileForSlLabelSelectorMutationVariables>(RemoveLabelFromCreatorProfileForSlLabelSelectorDocument, options);
      }
export type RemoveLabelFromCreatorProfileForSlLabelSelectorMutationHookResult = ReturnType<typeof useRemoveLabelFromCreatorProfileForSlLabelSelectorMutation>;
export type RemoveLabelFromCreatorProfileForSlLabelSelectorMutationResult = Apollo.MutationResult<RemoveLabelFromCreatorProfileForSlLabelSelectorMutation>;
export type RemoveLabelFromCreatorProfileForSlLabelSelectorMutationOptions = Apollo.BaseMutationOptions<RemoveLabelFromCreatorProfileForSlLabelSelectorMutation, RemoveLabelFromCreatorProfileForSlLabelSelectorMutationVariables>;
export const CreateBookmarkForSocialListeningCommunityBookmarkHandlersDocument = gql`
    mutation CreateBookmarkForSocialListeningCommunityBookmarkHandlers($input: CreateBrandBookmarkInput!) {
  createBrandBookmark(input: $input) {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;
export type CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationFn = Apollo.MutationFunction<CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation, CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>;

/**
 * __useCreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkForSocialListeningCommunityBookmarkHandlersMutation, { data, loading, error }] = useCreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation, CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation, CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>(CreateBookmarkForSocialListeningCommunityBookmarkHandlersDocument, options);
      }
export type CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationHookResult = ReturnType<typeof useCreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation>;
export type CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationResult = Apollo.MutationResult<CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation>;
export type CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutation, CreateBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>;
export const DeleteBookmarkForSocialListeningCommunityBookmarkHandlersDocument = gql`
    mutation DeleteBookmarkForSocialListeningCommunityBookmarkHandlers($input: DeleteBrandBookmarkInput!) {
  deleteBrandBookmark(input: $input) {
    message
    success
    deleted {
      id
    }
  }
}
    `;
export type DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationFn = Apollo.MutationFunction<DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation, DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>;

/**
 * __useDeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation, { data, loading, error }] = useDeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation, DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation, DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>(DeleteBookmarkForSocialListeningCommunityBookmarkHandlersDocument, options);
      }
export type DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationHookResult = ReturnType<typeof useDeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation>;
export type DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationResult = Apollo.MutationResult<DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation>;
export type DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutation, DeleteBookmarkForSocialListeningCommunityBookmarkHandlersMutationVariables>;
export const GetPaginatedRadarEventsForSlCommunityInfoViewDocument = gql`
    query GetPaginatedRadarEventsForSLCommunityInfoView($input: PaginatedRadarEventInput!) {
  getPaginatedRadarEvents(input: $input) {
    data {
      id
      eventType
      eventTypeCounter
      message
      creatorProfile {
        id
        fullName
      }
      socialPost {
        id
        thumbnailUrl
        videoUrl
      }
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useGetPaginatedRadarEventsForSlCommunityInfoViewQuery__
 *
 * To run a query within a React component, call `useGetPaginatedRadarEventsForSlCommunityInfoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedRadarEventsForSlCommunityInfoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedRadarEventsForSlCommunityInfoViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedRadarEventsForSlCommunityInfoViewQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedRadarEventsForSlCommunityInfoViewQuery, GetPaginatedRadarEventsForSlCommunityInfoViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedRadarEventsForSlCommunityInfoViewQuery, GetPaginatedRadarEventsForSlCommunityInfoViewQueryVariables>(GetPaginatedRadarEventsForSlCommunityInfoViewDocument, options);
      }
export function useGetPaginatedRadarEventsForSlCommunityInfoViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedRadarEventsForSlCommunityInfoViewQuery, GetPaginatedRadarEventsForSlCommunityInfoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedRadarEventsForSlCommunityInfoViewQuery, GetPaginatedRadarEventsForSlCommunityInfoViewQueryVariables>(GetPaginatedRadarEventsForSlCommunityInfoViewDocument, options);
        }
export type GetPaginatedRadarEventsForSlCommunityInfoViewQueryHookResult = ReturnType<typeof useGetPaginatedRadarEventsForSlCommunityInfoViewQuery>;
export type GetPaginatedRadarEventsForSlCommunityInfoViewLazyQueryHookResult = ReturnType<typeof useGetPaginatedRadarEventsForSlCommunityInfoViewLazyQuery>;
export type GetPaginatedRadarEventsForSlCommunityInfoViewQueryResult = Apollo.QueryResult<GetPaginatedRadarEventsForSlCommunityInfoViewQuery, GetPaginatedRadarEventsForSlCommunityInfoViewQueryVariables>;
export const UpdateUserOnboardingStateForSlCommunityIntroDialogViewDocument = gql`
    mutation UpdateUserOnboardingStateForSLCommunityIntroDialogView($data: UpdateUserOnboardingStateInput!) {
  updateUserOnboardingState(data: $data) {
    id
    onboardingState {
      hasSeenSLCommunityIntroduction
    }
  }
}
    `;
export type UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationFn = Apollo.MutationFunction<UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation, UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationVariables>;

/**
 * __useUpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingStateForSlCommunityIntroDialogViewMutation, { data, loading, error }] = useUpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation, UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation, UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationVariables>(UpdateUserOnboardingStateForSlCommunityIntroDialogViewDocument, options);
      }
export type UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationHookResult = ReturnType<typeof useUpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation>;
export type UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationResult = Apollo.MutationResult<UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation>;
export type UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutation, UpdateUserOnboardingStateForSlCommunityIntroDialogViewMutationVariables>;
export const GetTopicsTrackingListForSlPeekCreatorDialogViewDocument = gql`
    query GetTopicsTrackingListForSLPeekCreatorDialogView($data: CreatorTopicTrackingInput!) {
  getTopicsTrackingList(data: $data) {
    isTracking
    topic {
      ...TopicFragmentCreatorPeekingContent
      active
    }
  }
}
    ${TopicFragmentCreatorPeekingContentFragmentDoc}`;

/**
 * __useGetTopicsTrackingListForSlPeekCreatorDialogViewQuery__
 *
 * To run a query within a React component, call `useGetTopicsTrackingListForSlPeekCreatorDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsTrackingListForSlPeekCreatorDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsTrackingListForSlPeekCreatorDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTopicsTrackingListForSlPeekCreatorDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopicsTrackingListForSlPeekCreatorDialogViewQuery, GetTopicsTrackingListForSlPeekCreatorDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicsTrackingListForSlPeekCreatorDialogViewQuery, GetTopicsTrackingListForSlPeekCreatorDialogViewQueryVariables>(GetTopicsTrackingListForSlPeekCreatorDialogViewDocument, options);
      }
export function useGetTopicsTrackingListForSlPeekCreatorDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicsTrackingListForSlPeekCreatorDialogViewQuery, GetTopicsTrackingListForSlPeekCreatorDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicsTrackingListForSlPeekCreatorDialogViewQuery, GetTopicsTrackingListForSlPeekCreatorDialogViewQueryVariables>(GetTopicsTrackingListForSlPeekCreatorDialogViewDocument, options);
        }
export type GetTopicsTrackingListForSlPeekCreatorDialogViewQueryHookResult = ReturnType<typeof useGetTopicsTrackingListForSlPeekCreatorDialogViewQuery>;
export type GetTopicsTrackingListForSlPeekCreatorDialogViewLazyQueryHookResult = ReturnType<typeof useGetTopicsTrackingListForSlPeekCreatorDialogViewLazyQuery>;
export type GetTopicsTrackingListForSlPeekCreatorDialogViewQueryResult = Apollo.QueryResult<GetTopicsTrackingListForSlPeekCreatorDialogViewQuery, GetTopicsTrackingListForSlPeekCreatorDialogViewQueryVariables>;
export const UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewDocument = gql`
    mutation UpdateCreatorTrackingTopicStatusForSLPeekCreatorDialogView($input: UpdateCreatorTrackingTopicStatusInput!) {
  updateCreatorTrackingTopicStatus(input: $input) {
    message
    success
  }
}
    `;
export type UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationFn = Apollo.MutationFunction<UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation, UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationVariables>;

/**
 * __useUpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation, { data, loading, error }] = useUpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation, UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation, UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationVariables>(UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewDocument, options);
      }
export type UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationHookResult = ReturnType<typeof useUpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation>;
export type UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationResult = Apollo.MutationResult<UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation>;
export type UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutation, UpdateCreatorTrackingTopicStatusForSlPeekCreatorDialogViewMutationVariables>;
export const UpdateCreatorProfileForSlPeekCreatorDialogViewDocument = gql`
    mutation UpdateCreatorProfileForSLPeekCreatorDialogView($input: UpdateCreatorProfileInput!) {
  updateCreatorProfile(input: $input) {
    message
    success
  }
}
    `;
export type UpdateCreatorProfileForSlPeekCreatorDialogViewMutationFn = Apollo.MutationFunction<UpdateCreatorProfileForSlPeekCreatorDialogViewMutation, UpdateCreatorProfileForSlPeekCreatorDialogViewMutationVariables>;

/**
 * __useUpdateCreatorProfileForSlPeekCreatorDialogViewMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorProfileForSlPeekCreatorDialogViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorProfileForSlPeekCreatorDialogViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorProfileForSlPeekCreatorDialogViewMutation, { data, loading, error }] = useUpdateCreatorProfileForSlPeekCreatorDialogViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreatorProfileForSlPeekCreatorDialogViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorProfileForSlPeekCreatorDialogViewMutation, UpdateCreatorProfileForSlPeekCreatorDialogViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorProfileForSlPeekCreatorDialogViewMutation, UpdateCreatorProfileForSlPeekCreatorDialogViewMutationVariables>(UpdateCreatorProfileForSlPeekCreatorDialogViewDocument, options);
      }
export type UpdateCreatorProfileForSlPeekCreatorDialogViewMutationHookResult = ReturnType<typeof useUpdateCreatorProfileForSlPeekCreatorDialogViewMutation>;
export type UpdateCreatorProfileForSlPeekCreatorDialogViewMutationResult = Apollo.MutationResult<UpdateCreatorProfileForSlPeekCreatorDialogViewMutation>;
export type UpdateCreatorProfileForSlPeekCreatorDialogViewMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorProfileForSlPeekCreatorDialogViewMutation, UpdateCreatorProfileForSlPeekCreatorDialogViewMutationVariables>;
export const GetCreatorProfileForSlCommunityTableRowDocument = gql`
    query GetCreatorProfileForSLCommunityTableRow($id: String!, $brandId: String!) {
  creatorProfile(id: $id) {
    id
    isTrackingInsights
    creatorTrackedTopics(brandId: $brandId) {
      id
    }
    latestRadarEventActivity {
      id
      direction
      title
      dateTime
      createdByUser {
        id
        ...UserFragmentAvatarGroup
      }
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;

/**
 * __useGetCreatorProfileForSlCommunityTableRowQuery__
 *
 * To run a query within a React component, call `useGetCreatorProfileForSlCommunityTableRowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorProfileForSlCommunityTableRowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorProfileForSlCommunityTableRowQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetCreatorProfileForSlCommunityTableRowQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorProfileForSlCommunityTableRowQuery, GetCreatorProfileForSlCommunityTableRowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorProfileForSlCommunityTableRowQuery, GetCreatorProfileForSlCommunityTableRowQueryVariables>(GetCreatorProfileForSlCommunityTableRowDocument, options);
      }
export function useGetCreatorProfileForSlCommunityTableRowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorProfileForSlCommunityTableRowQuery, GetCreatorProfileForSlCommunityTableRowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorProfileForSlCommunityTableRowQuery, GetCreatorProfileForSlCommunityTableRowQueryVariables>(GetCreatorProfileForSlCommunityTableRowDocument, options);
        }
export type GetCreatorProfileForSlCommunityTableRowQueryHookResult = ReturnType<typeof useGetCreatorProfileForSlCommunityTableRowQuery>;
export type GetCreatorProfileForSlCommunityTableRowLazyQueryHookResult = ReturnType<typeof useGetCreatorProfileForSlCommunityTableRowLazyQuery>;
export type GetCreatorProfileForSlCommunityTableRowQueryResult = Apollo.QueryResult<GetCreatorProfileForSlCommunityTableRowQuery, GetCreatorProfileForSlCommunityTableRowQueryVariables>;
export const BlockCreatorFromCreatorProfileForSlCommunityTableRowDocument = gql`
    mutation BlockCreatorFromCreatorProfileForSLCommunityTableRow($input: BlockCreatorFromCreatorProfileInput!) {
  blockCreatorFromCreatorProfile(input: $input) {
    success
  }
}
    `;
export type BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationFn = Apollo.MutationFunction<BlockCreatorFromCreatorProfileForSlCommunityTableRowMutation, BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>;

/**
 * __useBlockCreatorFromCreatorProfileForSlCommunityTableRowMutation__
 *
 * To run a mutation, you first call `useBlockCreatorFromCreatorProfileForSlCommunityTableRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCreatorFromCreatorProfileForSlCommunityTableRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCreatorFromCreatorProfileForSlCommunityTableRowMutation, { data, loading, error }] = useBlockCreatorFromCreatorProfileForSlCommunityTableRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockCreatorFromCreatorProfileForSlCommunityTableRowMutation(baseOptions?: Apollo.MutationHookOptions<BlockCreatorFromCreatorProfileForSlCommunityTableRowMutation, BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCreatorFromCreatorProfileForSlCommunityTableRowMutation, BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>(BlockCreatorFromCreatorProfileForSlCommunityTableRowDocument, options);
      }
export type BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationHookResult = ReturnType<typeof useBlockCreatorFromCreatorProfileForSlCommunityTableRowMutation>;
export type BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationResult = Apollo.MutationResult<BlockCreatorFromCreatorProfileForSlCommunityTableRowMutation>;
export type BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationOptions = Apollo.BaseMutationOptions<BlockCreatorFromCreatorProfileForSlCommunityTableRowMutation, BlockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>;
export const UnblockCreatorFromCreatorProfileForSlCommunityTableRowDocument = gql`
    mutation UnblockCreatorFromCreatorProfileForSLCommunityTableRow($input: UnblockCreatorFromCreatorProfileInput!) {
  unblockCreatorFromCreatorProfile(input: $input) {
    success
  }
}
    `;
export type UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationFn = Apollo.MutationFunction<UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation, UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>;

/**
 * __useUnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation__
 *
 * To run a mutation, you first call `useUnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockCreatorFromCreatorProfileForSlCommunityTableRowMutation, { data, loading, error }] = useUnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation(baseOptions?: Apollo.MutationHookOptions<UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation, UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation, UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>(UnblockCreatorFromCreatorProfileForSlCommunityTableRowDocument, options);
      }
export type UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationHookResult = ReturnType<typeof useUnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation>;
export type UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationResult = Apollo.MutationResult<UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation>;
export type UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationOptions = Apollo.BaseMutationOptions<UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutation, UnblockCreatorFromCreatorProfileForSlCommunityTableRowMutationVariables>;
export const BlockCreatorForSlCommunityTableRowDocument = gql`
    mutation BlockCreatorForSLCommunityTableRow($data: BlockCreatorInput!) {
  blockCreator(data: $data) {
    success
  }
}
    `;
export type BlockCreatorForSlCommunityTableRowMutationFn = Apollo.MutationFunction<BlockCreatorForSlCommunityTableRowMutation, BlockCreatorForSlCommunityTableRowMutationVariables>;

/**
 * __useBlockCreatorForSlCommunityTableRowMutation__
 *
 * To run a mutation, you first call `useBlockCreatorForSlCommunityTableRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCreatorForSlCommunityTableRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCreatorForSlCommunityTableRowMutation, { data, loading, error }] = useBlockCreatorForSlCommunityTableRowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBlockCreatorForSlCommunityTableRowMutation(baseOptions?: Apollo.MutationHookOptions<BlockCreatorForSlCommunityTableRowMutation, BlockCreatorForSlCommunityTableRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCreatorForSlCommunityTableRowMutation, BlockCreatorForSlCommunityTableRowMutationVariables>(BlockCreatorForSlCommunityTableRowDocument, options);
      }
export type BlockCreatorForSlCommunityTableRowMutationHookResult = ReturnType<typeof useBlockCreatorForSlCommunityTableRowMutation>;
export type BlockCreatorForSlCommunityTableRowMutationResult = Apollo.MutationResult<BlockCreatorForSlCommunityTableRowMutation>;
export type BlockCreatorForSlCommunityTableRowMutationOptions = Apollo.BaseMutationOptions<BlockCreatorForSlCommunityTableRowMutation, BlockCreatorForSlCommunityTableRowMutationVariables>;
export const GetCreatorProfilesForSlCommunityTableDocument = gql`
    query GetCreatorProfilesForSLCommunityTable($input: PaginatedCreatorProfileInput!, $brandId: String!) {
  paginatedCreatorProfiles(input: $input) {
    data {
      ...CreatorProfileFragmentSLCommunityTable
    }
    pageInfo {
      hasNextPage
    }
    meta {
      totalCount
    }
  }
}
    ${CreatorProfileFragmentSlCommunityTableFragmentDoc}`;

/**
 * __useGetCreatorProfilesForSlCommunityTableQuery__
 *
 * To run a query within a React component, call `useGetCreatorProfilesForSlCommunityTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorProfilesForSlCommunityTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorProfilesForSlCommunityTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetCreatorProfilesForSlCommunityTableQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorProfilesForSlCommunityTableQuery, GetCreatorProfilesForSlCommunityTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorProfilesForSlCommunityTableQuery, GetCreatorProfilesForSlCommunityTableQueryVariables>(GetCreatorProfilesForSlCommunityTableDocument, options);
      }
export function useGetCreatorProfilesForSlCommunityTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorProfilesForSlCommunityTableQuery, GetCreatorProfilesForSlCommunityTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorProfilesForSlCommunityTableQuery, GetCreatorProfilesForSlCommunityTableQueryVariables>(GetCreatorProfilesForSlCommunityTableDocument, options);
        }
export type GetCreatorProfilesForSlCommunityTableQueryHookResult = ReturnType<typeof useGetCreatorProfilesForSlCommunityTableQuery>;
export type GetCreatorProfilesForSlCommunityTableLazyQueryHookResult = ReturnType<typeof useGetCreatorProfilesForSlCommunityTableLazyQuery>;
export type GetCreatorProfilesForSlCommunityTableQueryResult = Apollo.QueryResult<GetCreatorProfilesForSlCommunityTableQuery, GetCreatorProfilesForSlCommunityTableQueryVariables>;
export const GetBrandMentionStatsForSlCreatorProfileBrandMentionViewDocument = gql`
    query GetBrandMentionStatsForSLCreatorProfileBrandMentionView($input: CreatorProfileBrandMentionedStatsInput!) {
  creatorProfileBrandMentionStats(input: $input) {
    brandMentionCount
    engagementRate
    sentiment
    totalLikes
    totalViews
    sentimentScore
  }
}
    `;

/**
 * __useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery__
 *
 * To run a query within a React component, call `useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery, GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery, GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryVariables>(GetBrandMentionStatsForSlCreatorProfileBrandMentionViewDocument, options);
      }
export function useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery, GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery, GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryVariables>(GetBrandMentionStatsForSlCreatorProfileBrandMentionViewDocument, options);
        }
export type GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery>;
export type GetBrandMentionStatsForSlCreatorProfileBrandMentionViewLazyQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileBrandMentionViewLazyQuery>;
export type GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryResult = Apollo.QueryResult<GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQuery, GetBrandMentionStatsForSlCreatorProfileBrandMentionViewQueryVariables>;
export const GetSocialPostsForSlCreatorProfileBrandMentionViewDocument = gql`
    query GetSocialPostsForSLCreatorProfileBrandMentionView($input: CreatorProfilePaginatedBrandMentionsInput!) {
  creatorProfileBrandMentions(input: $input) {
    data {
      ...SocialPostFragmentSocialPostCardView
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${SocialPostFragmentSocialPostCardViewFragmentDoc}`;

/**
 * __useGetSocialPostsForSlCreatorProfileBrandMentionViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsForSlCreatorProfileBrandMentionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsForSlCreatorProfileBrandMentionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsForSlCreatorProfileBrandMentionViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSocialPostsForSlCreatorProfileBrandMentionViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsForSlCreatorProfileBrandMentionViewQuery, GetSocialPostsForSlCreatorProfileBrandMentionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsForSlCreatorProfileBrandMentionViewQuery, GetSocialPostsForSlCreatorProfileBrandMentionViewQueryVariables>(GetSocialPostsForSlCreatorProfileBrandMentionViewDocument, options);
      }
export function useGetSocialPostsForSlCreatorProfileBrandMentionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsForSlCreatorProfileBrandMentionViewQuery, GetSocialPostsForSlCreatorProfileBrandMentionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsForSlCreatorProfileBrandMentionViewQuery, GetSocialPostsForSlCreatorProfileBrandMentionViewQueryVariables>(GetSocialPostsForSlCreatorProfileBrandMentionViewDocument, options);
        }
export type GetSocialPostsForSlCreatorProfileBrandMentionViewQueryHookResult = ReturnType<typeof useGetSocialPostsForSlCreatorProfileBrandMentionViewQuery>;
export type GetSocialPostsForSlCreatorProfileBrandMentionViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsForSlCreatorProfileBrandMentionViewLazyQuery>;
export type GetSocialPostsForSlCreatorProfileBrandMentionViewQueryResult = Apollo.QueryResult<GetSocialPostsForSlCreatorProfileBrandMentionViewQuery, GetSocialPostsForSlCreatorProfileBrandMentionViewQueryVariables>;
export const GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewDocument = gql`
    query GetCreatorProfilesByCreatorIdForSLCreatorProfileDetailsView($input: CreatorProfilesByCreatorIdInput!) {
  creatorProfilesByCreatorId(input: $input) {
    data {
      ...CreatorProfileFragmentSLCreatorProfileDetailsView
    }
  }
}
    ${CreatorProfileFragmentSlCreatorProfileDetailsViewFragmentDoc}`;

/**
 * __useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery__
 *
 * To run a query within a React component, call `useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery, GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery, GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryVariables>(GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewDocument, options);
      }
export function useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery, GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery, GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryVariables>(GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewDocument, options);
        }
export type GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryHookResult = ReturnType<typeof useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery>;
export type GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewLazyQueryHookResult = ReturnType<typeof useGetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewLazyQuery>;
export type GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryResult = Apollo.QueryResult<GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQuery, GetCreatorProfilesByCreatorIdForSlCreatorProfileDetailsViewQueryVariables>;
export const UpdateCreatorProfileForSlCreatorProfileDetailsViewDocument = gql`
    mutation UpdateCreatorProfileForSLCreatorProfileDetailsView($input: UpdateCreatorProfileInput!) {
  updateCreatorProfile(input: $input) {
    success
  }
}
    `;
export type UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationFn = Apollo.MutationFunction<UpdateCreatorProfileForSlCreatorProfileDetailsViewMutation, UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>;

/**
 * __useUpdateCreatorProfileForSlCreatorProfileDetailsViewMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorProfileForSlCreatorProfileDetailsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorProfileForSlCreatorProfileDetailsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorProfileForSlCreatorProfileDetailsViewMutation, { data, loading, error }] = useUpdateCreatorProfileForSlCreatorProfileDetailsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreatorProfileForSlCreatorProfileDetailsViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorProfileForSlCreatorProfileDetailsViewMutation, UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorProfileForSlCreatorProfileDetailsViewMutation, UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>(UpdateCreatorProfileForSlCreatorProfileDetailsViewDocument, options);
      }
export type UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationHookResult = ReturnType<typeof useUpdateCreatorProfileForSlCreatorProfileDetailsViewMutation>;
export type UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationResult = Apollo.MutationResult<UpdateCreatorProfileForSlCreatorProfileDetailsViewMutation>;
export type UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorProfileForSlCreatorProfileDetailsViewMutation, UpdateCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>;
export const RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewDocument = gql`
    mutation RemoveCreatorFromCreatorProfileForSLCreatorProfileDetailsView($input: RemoveCreatorFromCreatorProfileInput!) {
  removeCreatorFromCreatorProfile(input: $input) {
    success
  }
}
    `;
export type RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationFn = Apollo.MutationFunction<RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation, RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>;

/**
 * __useRemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation__
 *
 * To run a mutation, you first call `useRemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation, { data, loading, error }] = useRemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation, RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation, RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>(RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewDocument, options);
      }
export type RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationHookResult = ReturnType<typeof useRemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation>;
export type RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationResult = Apollo.MutationResult<RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation>;
export type RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationOptions = Apollo.BaseMutationOptions<RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutation, RemoveCreatorFromCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>;
export const CreateCreatorForSlCreatorProfileDetailsViewDocument = gql`
    mutation CreateCreatorForSLCreatorProfileDetailsView($data: CreateCreatorInput!) {
  createCreator(data: $data) {
    id
    ...SocialListeningCreatorProfileMergeViewFragmentCreator
  }
}
    ${SocialListeningCreatorProfileMergeViewFragmentCreatorFragmentDoc}`;
export type CreateCreatorForSlCreatorProfileDetailsViewMutationFn = Apollo.MutationFunction<CreateCreatorForSlCreatorProfileDetailsViewMutation, CreateCreatorForSlCreatorProfileDetailsViewMutationVariables>;

/**
 * __useCreateCreatorForSlCreatorProfileDetailsViewMutation__
 *
 * To run a mutation, you first call `useCreateCreatorForSlCreatorProfileDetailsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreatorForSlCreatorProfileDetailsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreatorForSlCreatorProfileDetailsViewMutation, { data, loading, error }] = useCreateCreatorForSlCreatorProfileDetailsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCreatorForSlCreatorProfileDetailsViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreatorForSlCreatorProfileDetailsViewMutation, CreateCreatorForSlCreatorProfileDetailsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreatorForSlCreatorProfileDetailsViewMutation, CreateCreatorForSlCreatorProfileDetailsViewMutationVariables>(CreateCreatorForSlCreatorProfileDetailsViewDocument, options);
      }
export type CreateCreatorForSlCreatorProfileDetailsViewMutationHookResult = ReturnType<typeof useCreateCreatorForSlCreatorProfileDetailsViewMutation>;
export type CreateCreatorForSlCreatorProfileDetailsViewMutationResult = Apollo.MutationResult<CreateCreatorForSlCreatorProfileDetailsViewMutation>;
export type CreateCreatorForSlCreatorProfileDetailsViewMutationOptions = Apollo.BaseMutationOptions<CreateCreatorForSlCreatorProfileDetailsViewMutation, CreateCreatorForSlCreatorProfileDetailsViewMutationVariables>;
export const AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewDocument = gql`
    mutation AddCreatorToCreatorProfileForSLCreatorProfileDetailsView($input: AddCreatorToCreatorProfileInput!) {
  addCreatorToCreatorProfile(input: $input) {
    success
  }
}
    `;
export type AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationFn = Apollo.MutationFunction<AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation, AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>;

/**
 * __useAddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation__
 *
 * To run a mutation, you first call `useAddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation, { data, loading, error }] = useAddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation(baseOptions?: Apollo.MutationHookOptions<AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation, AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation, AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>(AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewDocument, options);
      }
export type AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationHookResult = ReturnType<typeof useAddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation>;
export type AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationResult = Apollo.MutationResult<AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation>;
export type AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationOptions = Apollo.BaseMutationOptions<AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutation, AddCreatorToCreatorProfileForSlCreatorProfileDetailsViewMutationVariables>;
export const MergeCreatorProfilesForSlCreatorProfileDetailsViewDocument = gql`
    mutation MergeCreatorProfilesForSLCreatorProfileDetailsView($input: MergeCreatorProfilesInput!) {
  mergeCreatorProfiles(input: $input) {
    success
  }
}
    `;
export type MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationFn = Apollo.MutationFunction<MergeCreatorProfilesForSlCreatorProfileDetailsViewMutation, MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationVariables>;

/**
 * __useMergeCreatorProfilesForSlCreatorProfileDetailsViewMutation__
 *
 * To run a mutation, you first call `useMergeCreatorProfilesForSlCreatorProfileDetailsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCreatorProfilesForSlCreatorProfileDetailsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCreatorProfilesForSlCreatorProfileDetailsViewMutation, { data, loading, error }] = useMergeCreatorProfilesForSlCreatorProfileDetailsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeCreatorProfilesForSlCreatorProfileDetailsViewMutation(baseOptions?: Apollo.MutationHookOptions<MergeCreatorProfilesForSlCreatorProfileDetailsViewMutation, MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCreatorProfilesForSlCreatorProfileDetailsViewMutation, MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationVariables>(MergeCreatorProfilesForSlCreatorProfileDetailsViewDocument, options);
      }
export type MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationHookResult = ReturnType<typeof useMergeCreatorProfilesForSlCreatorProfileDetailsViewMutation>;
export type MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationResult = Apollo.MutationResult<MergeCreatorProfilesForSlCreatorProfileDetailsViewMutation>;
export type MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationOptions = Apollo.BaseMutationOptions<MergeCreatorProfilesForSlCreatorProfileDetailsViewMutation, MergeCreatorProfilesForSlCreatorProfileDetailsViewMutationVariables>;
export const GetSearchDbCreatorsForSocialHandleInputDocument = gql`
    query GetSearchDbCreatorsForSocialHandleInput($query: String!, $skip: Int, $take: Int, $platform: Platform) {
  searchDbCreators(query: $query, skip: $skip, take: $take, platform: $platform) {
    ...CreatorFragmentSocialListeningCreatorProfileDetailsView
  }
}
    ${CreatorFragmentSocialListeningCreatorProfileDetailsViewFragmentDoc}`;

/**
 * __useGetSearchDbCreatorsForSocialHandleInputQuery__
 *
 * To run a query within a React component, call `useGetSearchDbCreatorsForSocialHandleInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchDbCreatorsForSocialHandleInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchDbCreatorsForSocialHandleInputQuery({
 *   variables: {
 *      query: // value for 'query'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetSearchDbCreatorsForSocialHandleInputQuery(baseOptions: Apollo.QueryHookOptions<GetSearchDbCreatorsForSocialHandleInputQuery, GetSearchDbCreatorsForSocialHandleInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchDbCreatorsForSocialHandleInputQuery, GetSearchDbCreatorsForSocialHandleInputQueryVariables>(GetSearchDbCreatorsForSocialHandleInputDocument, options);
      }
export function useGetSearchDbCreatorsForSocialHandleInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchDbCreatorsForSocialHandleInputQuery, GetSearchDbCreatorsForSocialHandleInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchDbCreatorsForSocialHandleInputQuery, GetSearchDbCreatorsForSocialHandleInputQueryVariables>(GetSearchDbCreatorsForSocialHandleInputDocument, options);
        }
export type GetSearchDbCreatorsForSocialHandleInputQueryHookResult = ReturnType<typeof useGetSearchDbCreatorsForSocialHandleInputQuery>;
export type GetSearchDbCreatorsForSocialHandleInputLazyQueryHookResult = ReturnType<typeof useGetSearchDbCreatorsForSocialHandleInputLazyQuery>;
export type GetSearchDbCreatorsForSocialHandleInputQueryResult = Apollo.QueryResult<GetSearchDbCreatorsForSocialHandleInputQuery, GetSearchDbCreatorsForSocialHandleInputQueryVariables>;
export const GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewDocument = gql`
    query GetMentionedBrandsForSLCreatorProfileMentionedBrandsView($input: CreatorProfileMentionedBrandsInput!) {
  creatorProfileMentionedBrands(input: $input) {
    data {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery__
 *
 * To run a query within a React component, call `useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery(baseOptions: Apollo.QueryHookOptions<GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery, GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery, GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryVariables>(GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewDocument, options);
      }
export function useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery, GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery, GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryVariables>(GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewDocument, options);
        }
export type GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryHookResult = ReturnType<typeof useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery>;
export type GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewLazyQueryHookResult = ReturnType<typeof useGetMentionedBrandsForSlCreatorProfileMentionedBrandsViewLazyQuery>;
export type GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryResult = Apollo.QueryResult<GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQuery, GetMentionedBrandsForSlCreatorProfileMentionedBrandsViewQueryVariables>;
export const GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewDocument = gql`
    query GetBrandMentionStatsForSLCreatorProfileMentionedBrandsView($input: CreatorProfileBrandMentionedStatsInput!) {
  creatorProfileBrandMentionStats(input: $input) {
    brandMentionCount
    engagementRate
    sentiment
    totalLikes
    totalViews
    totalComments
  }
}
    `;

/**
 * __useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery__
 *
 * To run a query within a React component, call `useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery, GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery, GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryVariables>(GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewDocument, options);
      }
export function useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery, GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery, GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryVariables>(GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewDocument, options);
        }
export type GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery>;
export type GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewLazyQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewLazyQuery>;
export type GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryResult = Apollo.QueryResult<GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQuery, GetBrandMentionStatsForSlCreatorProfileMentionedBrandsViewQueryVariables>;
export const GetSocialPostsForSlCreatorProfileMentionedBrandsViewDocument = gql`
    query GetSocialPostsForSLCreatorProfileMentionedBrandsView($input: CreatorProfilePaginatedBrandMentionsInput!) {
  creatorProfileBrandMentions(input: $input) {
    data {
      id
      thumbnailUrl
      videoUrl
      ...SocialPostFragmentUseSocialListeningPostLinkGenerator
    }
  }
}
    ${SocialPostFragmentUseSocialListeningPostLinkGeneratorFragmentDoc}`;

/**
 * __useGetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery, GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery, GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryVariables>(GetSocialPostsForSlCreatorProfileMentionedBrandsViewDocument, options);
      }
export function useGetSocialPostsForSlCreatorProfileMentionedBrandsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery, GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery, GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryVariables>(GetSocialPostsForSlCreatorProfileMentionedBrandsViewDocument, options);
        }
export type GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryHookResult = ReturnType<typeof useGetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery>;
export type GetSocialPostsForSlCreatorProfileMentionedBrandsViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostsForSlCreatorProfileMentionedBrandsViewLazyQuery>;
export type GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryResult = Apollo.QueryResult<GetSocialPostsForSlCreatorProfileMentionedBrandsViewQuery, GetSocialPostsForSlCreatorProfileMentionedBrandsViewQueryVariables>;
export const GetBrandMentionStatsForSlCreatorProfileMergeViewDocument = gql`
    query GetBrandMentionStatsForSLCreatorProfileMergeView($input: CreatorProfileBrandMentionedStatsInput!) {
  creatorProfileBrandMentionStats(input: $input) {
    brandMentionCount
    totalComments
    sentimentScore
  }
}
    `;

/**
 * __useGetBrandMentionStatsForSlCreatorProfileMergeViewQuery__
 *
 * To run a query within a React component, call `useGetBrandMentionStatsForSlCreatorProfileMergeViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandMentionStatsForSlCreatorProfileMergeViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandMentionStatsForSlCreatorProfileMergeViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBrandMentionStatsForSlCreatorProfileMergeViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandMentionStatsForSlCreatorProfileMergeViewQuery, GetBrandMentionStatsForSlCreatorProfileMergeViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandMentionStatsForSlCreatorProfileMergeViewQuery, GetBrandMentionStatsForSlCreatorProfileMergeViewQueryVariables>(GetBrandMentionStatsForSlCreatorProfileMergeViewDocument, options);
      }
export function useGetBrandMentionStatsForSlCreatorProfileMergeViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandMentionStatsForSlCreatorProfileMergeViewQuery, GetBrandMentionStatsForSlCreatorProfileMergeViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandMentionStatsForSlCreatorProfileMergeViewQuery, GetBrandMentionStatsForSlCreatorProfileMergeViewQueryVariables>(GetBrandMentionStatsForSlCreatorProfileMergeViewDocument, options);
        }
export type GetBrandMentionStatsForSlCreatorProfileMergeViewQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileMergeViewQuery>;
export type GetBrandMentionStatsForSlCreatorProfileMergeViewLazyQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileMergeViewLazyQuery>;
export type GetBrandMentionStatsForSlCreatorProfileMergeViewQueryResult = Apollo.QueryResult<GetBrandMentionStatsForSlCreatorProfileMergeViewQuery, GetBrandMentionStatsForSlCreatorProfileMergeViewQueryVariables>;
export const GetSuperfanEngagementStatsForSlCreatorProfileMergeViewDocument = gql`
    query GetSuperfanEngagementStatsForSLCreatorProfileMergeView($input: CreatorProfileSuperfanEngagementStatsInput!) {
  getCreatorProfileSuperfanEngagementStats(input: $input) {
    sentimentScore
  }
}
    `;

/**
 * __useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery__
 *
 * To run a query within a React component, call `useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery(baseOptions: Apollo.QueryHookOptions<GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery, GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery, GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryVariables>(GetSuperfanEngagementStatsForSlCreatorProfileMergeViewDocument, options);
      }
export function useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery, GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery, GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryVariables>(GetSuperfanEngagementStatsForSlCreatorProfileMergeViewDocument, options);
        }
export type GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryHookResult = ReturnType<typeof useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery>;
export type GetSuperfanEngagementStatsForSlCreatorProfileMergeViewLazyQueryHookResult = ReturnType<typeof useGetSuperfanEngagementStatsForSlCreatorProfileMergeViewLazyQuery>;
export type GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryResult = Apollo.QueryResult<GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQuery, GetSuperfanEngagementStatsForSlCreatorProfileMergeViewQueryVariables>;
export const GetRadarEventsForSlCreatorMomentsViewDocument = gql`
    query GetRadarEventsForSLCreatorMomentsView($input: PaginatedRadarEventInput!) {
  getPaginatedRadarEvents(input: $input) {
    data {
      id
      eventType
      eventTypeCounter
      message
      creatorProfileId
      platformCreateTime
      socialPost {
        id
        thumbnailUrl
        videoUrl
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetRadarEventsForSlCreatorMomentsViewQuery__
 *
 * To run a query within a React component, call `useGetRadarEventsForSlCreatorMomentsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRadarEventsForSlCreatorMomentsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRadarEventsForSlCreatorMomentsViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRadarEventsForSlCreatorMomentsViewQuery(baseOptions: Apollo.QueryHookOptions<GetRadarEventsForSlCreatorMomentsViewQuery, GetRadarEventsForSlCreatorMomentsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRadarEventsForSlCreatorMomentsViewQuery, GetRadarEventsForSlCreatorMomentsViewQueryVariables>(GetRadarEventsForSlCreatorMomentsViewDocument, options);
      }
export function useGetRadarEventsForSlCreatorMomentsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRadarEventsForSlCreatorMomentsViewQuery, GetRadarEventsForSlCreatorMomentsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRadarEventsForSlCreatorMomentsViewQuery, GetRadarEventsForSlCreatorMomentsViewQueryVariables>(GetRadarEventsForSlCreatorMomentsViewDocument, options);
        }
export type GetRadarEventsForSlCreatorMomentsViewQueryHookResult = ReturnType<typeof useGetRadarEventsForSlCreatorMomentsViewQuery>;
export type GetRadarEventsForSlCreatorMomentsViewLazyQueryHookResult = ReturnType<typeof useGetRadarEventsForSlCreatorMomentsViewLazyQuery>;
export type GetRadarEventsForSlCreatorMomentsViewQueryResult = Apollo.QueryResult<GetRadarEventsForSlCreatorMomentsViewQuery, GetRadarEventsForSlCreatorMomentsViewQueryVariables>;
export const GetProductsForSlCreatorProfileProductsViewDocument = gql`
    query GetProductsForSLCreatorProfileProductsView($data: BrandInboundFiltersInputForCapturedProduct!, $count: Int!) {
  capturedProductsPaginatedForInbound(data: $data) {
    data {
      id
      ...CapturedProductFragmentForSocialListeningCreatorProfileProductsView
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${CapturedProductFragmentForSocialListeningCreatorProfileProductsViewFragmentDoc}`;

/**
 * __useGetProductsForSlCreatorProfileProductsViewQuery__
 *
 * To run a query within a React component, call `useGetProductsForSlCreatorProfileProductsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForSlCreatorProfileProductsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForSlCreatorProfileProductsViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetProductsForSlCreatorProfileProductsViewQuery(baseOptions: Apollo.QueryHookOptions<GetProductsForSlCreatorProfileProductsViewQuery, GetProductsForSlCreatorProfileProductsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForSlCreatorProfileProductsViewQuery, GetProductsForSlCreatorProfileProductsViewQueryVariables>(GetProductsForSlCreatorProfileProductsViewDocument, options);
      }
export function useGetProductsForSlCreatorProfileProductsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForSlCreatorProfileProductsViewQuery, GetProductsForSlCreatorProfileProductsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForSlCreatorProfileProductsViewQuery, GetProductsForSlCreatorProfileProductsViewQueryVariables>(GetProductsForSlCreatorProfileProductsViewDocument, options);
        }
export type GetProductsForSlCreatorProfileProductsViewQueryHookResult = ReturnType<typeof useGetProductsForSlCreatorProfileProductsViewQuery>;
export type GetProductsForSlCreatorProfileProductsViewLazyQueryHookResult = ReturnType<typeof useGetProductsForSlCreatorProfileProductsViewLazyQuery>;
export type GetProductsForSlCreatorProfileProductsViewQueryResult = Apollo.QueryResult<GetProductsForSlCreatorProfileProductsViewQuery, GetProductsForSlCreatorProfileProductsViewQueryVariables>;
export const GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewDocument = gql`
    query GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogView($data: PaginatedBrandInboundFiltersInputForCapturedProductSocialPosts!) {
  capturedProductsSocialPostsPaginatedForInbound(data: $data) {
    data {
      ...SocialPostFragmentSLARankingProductSocialPosts
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${SocialPostFragmentSlaRankingProductSocialPostsFragmentDoc}`;

/**
 * __useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery, GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery, GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryVariables>(GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewDocument, options);
      }
export function useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery, GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery, GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryVariables>(GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewDocument, options);
        }
export type GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryHookResult = ReturnType<typeof useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery>;
export type GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewLazyQueryHookResult = ReturnType<typeof useGetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewLazyQuery>;
export type GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryResult = Apollo.QueryResult<GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQuery, GetCapturedProductsSocialPostsForSocialListeningCreatorProfileProductsDialogViewQueryVariables>;
export const GetStatsForSlCreatorProfileSuperfanEngagementViewDocument = gql`
    query GetStatsForSLCreatorProfileSuperfanEngagementView($input: CreatorProfileSuperfanEngagementStatsInput!) {
  getCreatorProfileSuperfanEngagementStats(input: $input) {
    maxLikes
    sentiment
    totalComments
    totalEngagement
    sentimentScore
  }
}
    `;

/**
 * __useGetStatsForSlCreatorProfileSuperfanEngagementViewQuery__
 *
 * To run a query within a React component, call `useGetStatsForSlCreatorProfileSuperfanEngagementViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsForSlCreatorProfileSuperfanEngagementViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsForSlCreatorProfileSuperfanEngagementViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStatsForSlCreatorProfileSuperfanEngagementViewQuery(baseOptions: Apollo.QueryHookOptions<GetStatsForSlCreatorProfileSuperfanEngagementViewQuery, GetStatsForSlCreatorProfileSuperfanEngagementViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatsForSlCreatorProfileSuperfanEngagementViewQuery, GetStatsForSlCreatorProfileSuperfanEngagementViewQueryVariables>(GetStatsForSlCreatorProfileSuperfanEngagementViewDocument, options);
      }
export function useGetStatsForSlCreatorProfileSuperfanEngagementViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatsForSlCreatorProfileSuperfanEngagementViewQuery, GetStatsForSlCreatorProfileSuperfanEngagementViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatsForSlCreatorProfileSuperfanEngagementViewQuery, GetStatsForSlCreatorProfileSuperfanEngagementViewQueryVariables>(GetStatsForSlCreatorProfileSuperfanEngagementViewDocument, options);
        }
export type GetStatsForSlCreatorProfileSuperfanEngagementViewQueryHookResult = ReturnType<typeof useGetStatsForSlCreatorProfileSuperfanEngagementViewQuery>;
export type GetStatsForSlCreatorProfileSuperfanEngagementViewLazyQueryHookResult = ReturnType<typeof useGetStatsForSlCreatorProfileSuperfanEngagementViewLazyQuery>;
export type GetStatsForSlCreatorProfileSuperfanEngagementViewQueryResult = Apollo.QueryResult<GetStatsForSlCreatorProfileSuperfanEngagementViewQuery, GetStatsForSlCreatorProfileSuperfanEngagementViewQueryVariables>;
export const GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewDocument = gql`
    query GetSocialPostCommentsForSLCreatorProfileSuperfanEngagementView($brandId: String!, $input: CreatorProfilePaginatedSuperfanEngagementInput!) {
  getCreatorProfileSuperfanEngagement(input: $input) {
    data {
      ...SocialPostCommentFragmentSocialPostCommentCardView
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${SocialPostCommentFragmentSocialPostCommentCardViewFragmentDoc}`;

/**
 * __useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery, GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery, GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryVariables>(GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewDocument, options);
      }
export function useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery, GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery, GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryVariables>(GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewDocument, options);
        }
export type GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryHookResult = ReturnType<typeof useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery>;
export type GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewLazyQuery>;
export type GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryResult = Apollo.QueryResult<GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQuery, GetSocialPostCommentsForSlCreatorProfileSuperfanEngagementViewQueryVariables>;
export const UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersDocument = gql`
    mutation UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembers($data: UpdateBrandPermissionsInput!) {
  updateBrandPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationFn = Apollo.MutationFunction<UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation, UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationVariables>;

/**
 * __useUpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation__
 *
 * To run a mutation, you first call `useUpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation, { data, loading, error }] = useUpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation, UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation, UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationVariables>(UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersDocument, options);
      }
export type UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationHookResult = ReturnType<typeof useUpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation>;
export type UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationResult = Apollo.MutationResult<UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation>;
export type UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationOptions = Apollo.BaseMutationOptions<UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutation, UpdateBrandPermissionsForUseSocialListeningPermissionsManageMembersMutationVariables>;
export const InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersDocument = gql`
    mutation InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembers($data: InviteUsersToCurrentOrgByRoleInput!) {
  inviteUsersToCurrentOrgByRoles(data: $data) {
    id
  }
}
    `;
export type InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationFn = Apollo.MutationFunction<InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation, InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationVariables>;

/**
 * __useInviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation__
 *
 * To run a mutation, you first call `useInviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation, { data, loading, error }] = useInviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation, InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation, InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationVariables>(InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersDocument, options);
      }
export type InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationHookResult = ReturnType<typeof useInviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation>;
export type InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationResult = Apollo.MutationResult<InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation>;
export type InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationOptions = Apollo.BaseMutationOptions<InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutation, InviteUsersToCurrentOrgByRolesForUseSocialListeningPermissionsManageMembersMutationVariables>;
export const CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewDocument = gql`
    mutation CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyView($data: CreatePermissionRequestInput!) {
  createPermissionRequest(data: $data) {
    id
  }
}
    `;
export type CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationFn = Apollo.MutationFunction<CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation, CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationVariables>;

/**
 * __useCreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation__
 *
 * To run a mutation, you first call `useCreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation, { data, loading, error }] = useCreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation, CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation, CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationVariables>(CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewDocument, options);
      }
export type CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationHookResult = ReturnType<typeof useCreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation>;
export type CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationResult = Apollo.MutationResult<CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation>;
export type CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationOptions = Apollo.BaseMutationOptions<CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutation, CreatePermissionRequestForSocialListeningUserPermissionsDialogBodyViewMutationVariables>;
export const GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewDocument = gql`
    query GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyView($brandId: String!) {
  pendingPermissionRequestsForBrand(brandId: $brandId) {
    id
    user {
      id
      email
      ...UserProfileFragmentSocialListeningPermissionMember
    }
    status
  }
}
    ${UserProfileFragmentSocialListeningPermissionMemberFragmentDoc}`;

/**
 * __useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery__
 *
 * To run a query within a React component, call `useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery(baseOptions: Apollo.QueryHookOptions<GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery, GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery, GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryVariables>(GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewDocument, options);
      }
export function useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery, GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery, GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryVariables>(GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewDocument, options);
        }
export type GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryHookResult = ReturnType<typeof useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery>;
export type GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewLazyQueryHookResult = ReturnType<typeof useGetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewLazyQuery>;
export type GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryResult = Apollo.QueryResult<GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQuery, GetPendingPermissionRequestsForSocialListeningUserPermissionsDialogBodyViewQueryVariables>;
export const GetBrandForSocialListeningUserPermissionsDialogBodyViewDocument = gql`
    query GetBrandForSocialListeningUserPermissionsDialogBodyView($brandId: String!) {
  brand(id: $brandId) {
    id
    name
    organizationId
    creators {
      id
      ...CreatorFragmentCreatorAvatarWithNameView
    }
    organization {
      id
      name
    }
    myPermissions
    generalPermission
    permissionLevel
    inviteMembers {
      ...BrandInviteMemberModelFragmentSocialListeningUserPermissionsDialogBodyView
    }
  }
}
    ${CreatorFragmentCreatorAvatarWithNameViewFragmentDoc}
${BrandInviteMemberModelFragmentSocialListeningUserPermissionsDialogBodyViewFragmentDoc}`;

/**
 * __useGetBrandForSocialListeningUserPermissionsDialogBodyViewQuery__
 *
 * To run a query within a React component, call `useGetBrandForSocialListeningUserPermissionsDialogBodyViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSocialListeningUserPermissionsDialogBodyViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSocialListeningUserPermissionsDialogBodyViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForSocialListeningUserPermissionsDialogBodyViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSocialListeningUserPermissionsDialogBodyViewQuery, GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSocialListeningUserPermissionsDialogBodyViewQuery, GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryVariables>(GetBrandForSocialListeningUserPermissionsDialogBodyViewDocument, options);
      }
export function useGetBrandForSocialListeningUserPermissionsDialogBodyViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSocialListeningUserPermissionsDialogBodyViewQuery, GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSocialListeningUserPermissionsDialogBodyViewQuery, GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryVariables>(GetBrandForSocialListeningUserPermissionsDialogBodyViewDocument, options);
        }
export type GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryHookResult = ReturnType<typeof useGetBrandForSocialListeningUserPermissionsDialogBodyViewQuery>;
export type GetBrandForSocialListeningUserPermissionsDialogBodyViewLazyQueryHookResult = ReturnType<typeof useGetBrandForSocialListeningUserPermissionsDialogBodyViewLazyQuery>;
export type GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryResult = Apollo.QueryResult<GetBrandForSocialListeningUserPermissionsDialogBodyViewQuery, GetBrandForSocialListeningUserPermissionsDialogBodyViewQueryVariables>;
export const UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewDocument = gql`
    mutation UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyView($data: UpdateBrandPermissionsInput!) {
  updateBrandPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationFn = Apollo.MutationFunction<UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation, UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationVariables>;

/**
 * __useUpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation__
 *
 * To run a mutation, you first call `useUpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation, { data, loading, error }] = useUpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation, UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation, UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationVariables>(UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewDocument, options);
      }
export type UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationHookResult = ReturnType<typeof useUpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation>;
export type UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationResult = Apollo.MutationResult<UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation>;
export type UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationOptions = Apollo.BaseMutationOptions<UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutation, UpdateBrandPermissionsForSocialListeningUserPermissionsDialogBodyViewMutationVariables>;
export const GetPostByIdsForSlAssetsSelectorDocument = gql`
    query GetPostByIdsForSLAssetsSelector($input: GetPostByIdsInput!) {
  postByIds(input: $input) {
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetPostByIdsForSlAssetsSelectorQuery__
 *
 * To run a query within a React component, call `useGetPostByIdsForSlAssetsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdsForSlAssetsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdsForSlAssetsSelectorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostByIdsForSlAssetsSelectorQuery(baseOptions: Apollo.QueryHookOptions<GetPostByIdsForSlAssetsSelectorQuery, GetPostByIdsForSlAssetsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostByIdsForSlAssetsSelectorQuery, GetPostByIdsForSlAssetsSelectorQueryVariables>(GetPostByIdsForSlAssetsSelectorDocument, options);
      }
export function useGetPostByIdsForSlAssetsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostByIdsForSlAssetsSelectorQuery, GetPostByIdsForSlAssetsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostByIdsForSlAssetsSelectorQuery, GetPostByIdsForSlAssetsSelectorQueryVariables>(GetPostByIdsForSlAssetsSelectorDocument, options);
        }
export type GetPostByIdsForSlAssetsSelectorQueryHookResult = ReturnType<typeof useGetPostByIdsForSlAssetsSelectorQuery>;
export type GetPostByIdsForSlAssetsSelectorLazyQueryHookResult = ReturnType<typeof useGetPostByIdsForSlAssetsSelectorLazyQuery>;
export type GetPostByIdsForSlAssetsSelectorQueryResult = Apollo.QueryResult<GetPostByIdsForSlAssetsSelectorQuery, GetPostByIdsForSlAssetsSelectorQueryVariables>;
export const GetCreatorProfilesForSlRadarCreatorAutocompleteDocument = gql`
    query GetCreatorProfilesForSLRadarCreatorAutocomplete($input: PaginatedCreatorProfileInput!) {
  paginatedCreatorProfiles(input: $input) {
    data {
      ...CreatorProfileFragmentSLRadarCreatorAutocomplete
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${CreatorProfileFragmentSlRadarCreatorAutocompleteFragmentDoc}`;

/**
 * __useGetCreatorProfilesForSlRadarCreatorAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetCreatorProfilesForSlRadarCreatorAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorProfilesForSlRadarCreatorAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorProfilesForSlRadarCreatorAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCreatorProfilesForSlRadarCreatorAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorProfilesForSlRadarCreatorAutocompleteQuery, GetCreatorProfilesForSlRadarCreatorAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorProfilesForSlRadarCreatorAutocompleteQuery, GetCreatorProfilesForSlRadarCreatorAutocompleteQueryVariables>(GetCreatorProfilesForSlRadarCreatorAutocompleteDocument, options);
      }
export function useGetCreatorProfilesForSlRadarCreatorAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorProfilesForSlRadarCreatorAutocompleteQuery, GetCreatorProfilesForSlRadarCreatorAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorProfilesForSlRadarCreatorAutocompleteQuery, GetCreatorProfilesForSlRadarCreatorAutocompleteQueryVariables>(GetCreatorProfilesForSlRadarCreatorAutocompleteDocument, options);
        }
export type GetCreatorProfilesForSlRadarCreatorAutocompleteQueryHookResult = ReturnType<typeof useGetCreatorProfilesForSlRadarCreatorAutocompleteQuery>;
export type GetCreatorProfilesForSlRadarCreatorAutocompleteLazyQueryHookResult = ReturnType<typeof useGetCreatorProfilesForSlRadarCreatorAutocompleteLazyQuery>;
export type GetCreatorProfilesForSlRadarCreatorAutocompleteQueryResult = Apollo.QueryResult<GetCreatorProfilesForSlRadarCreatorAutocompleteQuery, GetCreatorProfilesForSlRadarCreatorAutocompleteQueryVariables>;
export const GetCreatorProfileByIdsForSlRadarCreatorAutocompleteDocument = gql`
    query GetCreatorProfileByIdsForSLRadarCreatorAutocomplete($input: CreatorProfilesByIdsInput!) {
  creatorProfileByIds(input: $input) {
    ...CreatorProfileFragmentSLRadarCreatorAutocomplete
  }
}
    ${CreatorProfileFragmentSlRadarCreatorAutocompleteFragmentDoc}`;

/**
 * __useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery, GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery, GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryVariables>(GetCreatorProfileByIdsForSlRadarCreatorAutocompleteDocument, options);
      }
export function useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery, GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery, GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryVariables>(GetCreatorProfileByIdsForSlRadarCreatorAutocompleteDocument, options);
        }
export type GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryHookResult = ReturnType<typeof useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery>;
export type GetCreatorProfileByIdsForSlRadarCreatorAutocompleteLazyQueryHookResult = ReturnType<typeof useGetCreatorProfileByIdsForSlRadarCreatorAutocompleteLazyQuery>;
export type GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryResult = Apollo.QueryResult<GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQuery, GetCreatorProfileByIdsForSlRadarCreatorAutocompleteQueryVariables>;
export const GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersDocument = gql`
    query GetCommunicationChannelByIdsForSLRadarActivityCommunicationChannelHandlers($input: RadarEventActivityCommunicationChannelByIdsInput!) {
  radarEventActivityCommunicationChannelByIds(input: $input) {
    ...RadarEventActivityCommunicationChannelFragmentSLRadarActivityCommunicationChannelHandlers
  }
}
    ${RadarEventActivityCommunicationChannelFragmentSlRadarActivityCommunicationChannelHandlersFragmentDoc}`;

/**
 * __useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery__
 *
 * To run a query within a React component, call `useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery(baseOptions: Apollo.QueryHookOptions<GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryVariables>(GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersDocument, options);
      }
export function useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryVariables>(GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersDocument, options);
        }
export type GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryHookResult = ReturnType<typeof useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery>;
export type GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersLazyQueryHookResult = ReturnType<typeof useGetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersLazyQuery>;
export type GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryResult = Apollo.QueryResult<GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelByIdsForSlRadarActivityCommunicationChannelHandlersQueryVariables>;
export const GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersDocument = gql`
    query GetCommunicationChannelForSLRadarActivityCommunicationChannelHandlers($input: PaginatedRadarEventActivityCommunicationChannelInput!) {
  paginatedRadarEventActivityCommunicationChannels(input: $input) {
    data {
      ...RadarEventActivityCommunicationChannelFragmentSLRadarActivityCommunicationChannelHandlers
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${RadarEventActivityCommunicationChannelFragmentSlRadarActivityCommunicationChannelHandlersFragmentDoc}`;

/**
 * __useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery__
 *
 * To run a query within a React component, call `useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery(baseOptions: Apollo.QueryHookOptions<GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryVariables>(GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersDocument, options);
      }
export function useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryVariables>(GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersDocument, options);
        }
export type GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryHookResult = ReturnType<typeof useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery>;
export type GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersLazyQueryHookResult = ReturnType<typeof useGetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersLazyQuery>;
export type GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryResult = Apollo.QueryResult<GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQuery, GetCommunicationChannelForSlRadarActivityCommunicationChannelHandlersQueryVariables>;
export const CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersDocument = gql`
    mutation CreateCommunicationChannelForSLRadarActivityCommunicationChannelHandlers($input: CreateRadarEventActivityCommunicationChannelInput!) {
  createRadarEventActivityCommunicationChannel(input: $input) {
    ...RadarEventActivityCommunicationChannelFragmentSLRadarActivityCommunicationChannelHandlers
  }
}
    ${RadarEventActivityCommunicationChannelFragmentSlRadarActivityCommunicationChannelHandlersFragmentDoc}`;
export type CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationFn = Apollo.MutationFunction<CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation, CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationVariables>;

/**
 * __useCreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation__
 *
 * To run a mutation, you first call `useCreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation, { data, loading, error }] = useCreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation, CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation, CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationVariables>(CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersDocument, options);
      }
export type CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationHookResult = ReturnType<typeof useCreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation>;
export type CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationResult = Apollo.MutationResult<CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation>;
export type CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationOptions = Apollo.BaseMutationOptions<CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutation, CreateCommunicationChannelForSlRadarActivityCommunicationChannelHandlersMutationVariables>;
export const GetRadarEventActivitiesForSlRadarActivityHandlersDocument = gql`
    query GetRadarEventActivitiesForSLRadarActivityHandlers($input: PaginatedRadarEventActivityInput!) {
  paginatedRadarEventActivities(input: $input) {
    data {
      ...RadarEventActivityFragmentSLRadarActivityHandlers
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${RadarEventActivityFragmentSlRadarActivityHandlersFragmentDoc}`;

/**
 * __useGetRadarEventActivitiesForSlRadarActivityHandlersQuery__
 *
 * To run a query within a React component, call `useGetRadarEventActivitiesForSlRadarActivityHandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRadarEventActivitiesForSlRadarActivityHandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRadarEventActivitiesForSlRadarActivityHandlersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRadarEventActivitiesForSlRadarActivityHandlersQuery(baseOptions: Apollo.QueryHookOptions<GetRadarEventActivitiesForSlRadarActivityHandlersQuery, GetRadarEventActivitiesForSlRadarActivityHandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRadarEventActivitiesForSlRadarActivityHandlersQuery, GetRadarEventActivitiesForSlRadarActivityHandlersQueryVariables>(GetRadarEventActivitiesForSlRadarActivityHandlersDocument, options);
      }
export function useGetRadarEventActivitiesForSlRadarActivityHandlersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRadarEventActivitiesForSlRadarActivityHandlersQuery, GetRadarEventActivitiesForSlRadarActivityHandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRadarEventActivitiesForSlRadarActivityHandlersQuery, GetRadarEventActivitiesForSlRadarActivityHandlersQueryVariables>(GetRadarEventActivitiesForSlRadarActivityHandlersDocument, options);
        }
export type GetRadarEventActivitiesForSlRadarActivityHandlersQueryHookResult = ReturnType<typeof useGetRadarEventActivitiesForSlRadarActivityHandlersQuery>;
export type GetRadarEventActivitiesForSlRadarActivityHandlersLazyQueryHookResult = ReturnType<typeof useGetRadarEventActivitiesForSlRadarActivityHandlersLazyQuery>;
export type GetRadarEventActivitiesForSlRadarActivityHandlersQueryResult = Apollo.QueryResult<GetRadarEventActivitiesForSlRadarActivityHandlersQuery, GetRadarEventActivitiesForSlRadarActivityHandlersQueryVariables>;
export const CreateRadarEventActivityForSlRadarActivityHandlersDocument = gql`
    mutation CreateRadarEventActivityForSLRadarActivityHandlers($input: CreateRadarEventActivityInput!) {
  createRadarEventActivity(input: $input) {
    ...RadarEventActivityFragmentSLRadarActivityHandlers
  }
}
    ${RadarEventActivityFragmentSlRadarActivityHandlersFragmentDoc}`;
export type CreateRadarEventActivityForSlRadarActivityHandlersMutationFn = Apollo.MutationFunction<CreateRadarEventActivityForSlRadarActivityHandlersMutation, CreateRadarEventActivityForSlRadarActivityHandlersMutationVariables>;

/**
 * __useCreateRadarEventActivityForSlRadarActivityHandlersMutation__
 *
 * To run a mutation, you first call `useCreateRadarEventActivityForSlRadarActivityHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRadarEventActivityForSlRadarActivityHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRadarEventActivityForSlRadarActivityHandlersMutation, { data, loading, error }] = useCreateRadarEventActivityForSlRadarActivityHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRadarEventActivityForSlRadarActivityHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateRadarEventActivityForSlRadarActivityHandlersMutation, CreateRadarEventActivityForSlRadarActivityHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRadarEventActivityForSlRadarActivityHandlersMutation, CreateRadarEventActivityForSlRadarActivityHandlersMutationVariables>(CreateRadarEventActivityForSlRadarActivityHandlersDocument, options);
      }
export type CreateRadarEventActivityForSlRadarActivityHandlersMutationHookResult = ReturnType<typeof useCreateRadarEventActivityForSlRadarActivityHandlersMutation>;
export type CreateRadarEventActivityForSlRadarActivityHandlersMutationResult = Apollo.MutationResult<CreateRadarEventActivityForSlRadarActivityHandlersMutation>;
export type CreateRadarEventActivityForSlRadarActivityHandlersMutationOptions = Apollo.BaseMutationOptions<CreateRadarEventActivityForSlRadarActivityHandlersMutation, CreateRadarEventActivityForSlRadarActivityHandlersMutationVariables>;
export const UpdateRadarEventActivityForSlRadarActivityHandlersDocument = gql`
    mutation UpdateRadarEventActivityForSLRadarActivityHandlers($input: UpdateRadarEventActivityInput!) {
  updateRadarEventActivity(input: $input) {
    ...RadarEventActivityFragmentSLRadarActivityHandlers
  }
}
    ${RadarEventActivityFragmentSlRadarActivityHandlersFragmentDoc}`;
export type UpdateRadarEventActivityForSlRadarActivityHandlersMutationFn = Apollo.MutationFunction<UpdateRadarEventActivityForSlRadarActivityHandlersMutation, UpdateRadarEventActivityForSlRadarActivityHandlersMutationVariables>;

/**
 * __useUpdateRadarEventActivityForSlRadarActivityHandlersMutation__
 *
 * To run a mutation, you first call `useUpdateRadarEventActivityForSlRadarActivityHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRadarEventActivityForSlRadarActivityHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRadarEventActivityForSlRadarActivityHandlersMutation, { data, loading, error }] = useUpdateRadarEventActivityForSlRadarActivityHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRadarEventActivityForSlRadarActivityHandlersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRadarEventActivityForSlRadarActivityHandlersMutation, UpdateRadarEventActivityForSlRadarActivityHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRadarEventActivityForSlRadarActivityHandlersMutation, UpdateRadarEventActivityForSlRadarActivityHandlersMutationVariables>(UpdateRadarEventActivityForSlRadarActivityHandlersDocument, options);
      }
export type UpdateRadarEventActivityForSlRadarActivityHandlersMutationHookResult = ReturnType<typeof useUpdateRadarEventActivityForSlRadarActivityHandlersMutation>;
export type UpdateRadarEventActivityForSlRadarActivityHandlersMutationResult = Apollo.MutationResult<UpdateRadarEventActivityForSlRadarActivityHandlersMutation>;
export type UpdateRadarEventActivityForSlRadarActivityHandlersMutationOptions = Apollo.BaseMutationOptions<UpdateRadarEventActivityForSlRadarActivityHandlersMutation, UpdateRadarEventActivityForSlRadarActivityHandlersMutationVariables>;
export const GetPaginatedRadarEventsForSlRadarEventsViewDocument = gql`
    query GetPaginatedRadarEventsForSLRadarEventsView($input: PaginatedRadarEventInput!) {
  getPaginatedRadarEvents(input: $input) {
    data {
      id
      ...RadarEventFragmentRadarEventCommunityUpdateItemView
    }
    pageInfo {
      hasNextPage
    }
    meta {
      totalCount
    }
  }
}
    ${RadarEventFragmentRadarEventCommunityUpdateItemViewFragmentDoc}`;

/**
 * __useGetPaginatedRadarEventsForSlRadarEventsViewQuery__
 *
 * To run a query within a React component, call `useGetPaginatedRadarEventsForSlRadarEventsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedRadarEventsForSlRadarEventsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedRadarEventsForSlRadarEventsViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedRadarEventsForSlRadarEventsViewQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedRadarEventsForSlRadarEventsViewQuery, GetPaginatedRadarEventsForSlRadarEventsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedRadarEventsForSlRadarEventsViewQuery, GetPaginatedRadarEventsForSlRadarEventsViewQueryVariables>(GetPaginatedRadarEventsForSlRadarEventsViewDocument, options);
      }
export function useGetPaginatedRadarEventsForSlRadarEventsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedRadarEventsForSlRadarEventsViewQuery, GetPaginatedRadarEventsForSlRadarEventsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedRadarEventsForSlRadarEventsViewQuery, GetPaginatedRadarEventsForSlRadarEventsViewQueryVariables>(GetPaginatedRadarEventsForSlRadarEventsViewDocument, options);
        }
export type GetPaginatedRadarEventsForSlRadarEventsViewQueryHookResult = ReturnType<typeof useGetPaginatedRadarEventsForSlRadarEventsViewQuery>;
export type GetPaginatedRadarEventsForSlRadarEventsViewLazyQueryHookResult = ReturnType<typeof useGetPaginatedRadarEventsForSlRadarEventsViewLazyQuery>;
export type GetPaginatedRadarEventsForSlRadarEventsViewQueryResult = Apollo.QueryResult<GetPaginatedRadarEventsForSlRadarEventsViewQuery, GetPaginatedRadarEventsForSlRadarEventsViewQueryVariables>;
export const MarkRadarEventAsReadForSlRadarEventsViewDocument = gql`
    mutation MarkRadarEventAsReadForSLRadarEventsView($input: MarkRadarEventAsReadInput!) {
  markRadarEventAsRead(input: $input) {
    message
    success
  }
}
    `;
export type MarkRadarEventAsReadForSlRadarEventsViewMutationFn = Apollo.MutationFunction<MarkRadarEventAsReadForSlRadarEventsViewMutation, MarkRadarEventAsReadForSlRadarEventsViewMutationVariables>;

/**
 * __useMarkRadarEventAsReadForSlRadarEventsViewMutation__
 *
 * To run a mutation, you first call `useMarkRadarEventAsReadForSlRadarEventsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRadarEventAsReadForSlRadarEventsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRadarEventAsReadForSlRadarEventsViewMutation, { data, loading, error }] = useMarkRadarEventAsReadForSlRadarEventsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkRadarEventAsReadForSlRadarEventsViewMutation(baseOptions?: Apollo.MutationHookOptions<MarkRadarEventAsReadForSlRadarEventsViewMutation, MarkRadarEventAsReadForSlRadarEventsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkRadarEventAsReadForSlRadarEventsViewMutation, MarkRadarEventAsReadForSlRadarEventsViewMutationVariables>(MarkRadarEventAsReadForSlRadarEventsViewDocument, options);
      }
export type MarkRadarEventAsReadForSlRadarEventsViewMutationHookResult = ReturnType<typeof useMarkRadarEventAsReadForSlRadarEventsViewMutation>;
export type MarkRadarEventAsReadForSlRadarEventsViewMutationResult = Apollo.MutationResult<MarkRadarEventAsReadForSlRadarEventsViewMutation>;
export type MarkRadarEventAsReadForSlRadarEventsViewMutationOptions = Apollo.BaseMutationOptions<MarkRadarEventAsReadForSlRadarEventsViewMutation, MarkRadarEventAsReadForSlRadarEventsViewMutationVariables>;
export const GetSocialCreatorForSocialListeningSettingsSocialHandleInputDocument = gql`
    query GetSocialCreatorForSocialListeningSettingsSocialHandleInput($filters: SocialCreatorFilters!) {
  getSocialCreator(filters: $filters) {
    id
    ...CreatorFragmentSocialListeningSettingsSocialHandleInput
  }
}
    ${CreatorFragmentSocialListeningSettingsSocialHandleInputFragmentDoc}`;

/**
 * __useGetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery__
 *
 * To run a query within a React component, call `useGetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery(baseOptions: Apollo.QueryHookOptions<GetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery, GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery, GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryVariables>(GetSocialCreatorForSocialListeningSettingsSocialHandleInputDocument, options);
      }
export function useGetSocialCreatorForSocialListeningSettingsSocialHandleInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery, GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery, GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryVariables>(GetSocialCreatorForSocialListeningSettingsSocialHandleInputDocument, options);
        }
export type GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryHookResult = ReturnType<typeof useGetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery>;
export type GetSocialCreatorForSocialListeningSettingsSocialHandleInputLazyQueryHookResult = ReturnType<typeof useGetSocialCreatorForSocialListeningSettingsSocialHandleInputLazyQuery>;
export type GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryResult = Apollo.QueryResult<GetSocialCreatorForSocialListeningSettingsSocialHandleInputQuery, GetSocialCreatorForSocialListeningSettingsSocialHandleInputQueryVariables>;
export const BlockCreatorForBlockCreatorFormDocument = gql`
    mutation BlockCreatorForBlockCreatorForm($data: BlockCreatorInput!) {
  blockCreator(data: $data) {
    success
  }
}
    `;
export type BlockCreatorForBlockCreatorFormMutationFn = Apollo.MutationFunction<BlockCreatorForBlockCreatorFormMutation, BlockCreatorForBlockCreatorFormMutationVariables>;

/**
 * __useBlockCreatorForBlockCreatorFormMutation__
 *
 * To run a mutation, you first call `useBlockCreatorForBlockCreatorFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCreatorForBlockCreatorFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCreatorForBlockCreatorFormMutation, { data, loading, error }] = useBlockCreatorForBlockCreatorFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBlockCreatorForBlockCreatorFormMutation(baseOptions?: Apollo.MutationHookOptions<BlockCreatorForBlockCreatorFormMutation, BlockCreatorForBlockCreatorFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCreatorForBlockCreatorFormMutation, BlockCreatorForBlockCreatorFormMutationVariables>(BlockCreatorForBlockCreatorFormDocument, options);
      }
export type BlockCreatorForBlockCreatorFormMutationHookResult = ReturnType<typeof useBlockCreatorForBlockCreatorFormMutation>;
export type BlockCreatorForBlockCreatorFormMutationResult = Apollo.MutationResult<BlockCreatorForBlockCreatorFormMutation>;
export type BlockCreatorForBlockCreatorFormMutationOptions = Apollo.BaseMutationOptions<BlockCreatorForBlockCreatorFormMutation, BlockCreatorForBlockCreatorFormMutationVariables>;
export const RemoveBlockFromCreatorForBlockedAccountsDialogDocument = gql`
    mutation RemoveBlockFromCreatorForBlockedAccountsDialog($data: RemoveCreatorBlockingByHandleInput!) {
  removeCreatorBlockingByHandle(data: $data) {
    success
  }
}
    `;
export type RemoveBlockFromCreatorForBlockedAccountsDialogMutationFn = Apollo.MutationFunction<RemoveBlockFromCreatorForBlockedAccountsDialogMutation, RemoveBlockFromCreatorForBlockedAccountsDialogMutationVariables>;

/**
 * __useRemoveBlockFromCreatorForBlockedAccountsDialogMutation__
 *
 * To run a mutation, you first call `useRemoveBlockFromCreatorForBlockedAccountsDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBlockFromCreatorForBlockedAccountsDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBlockFromCreatorForBlockedAccountsDialogMutation, { data, loading, error }] = useRemoveBlockFromCreatorForBlockedAccountsDialogMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveBlockFromCreatorForBlockedAccountsDialogMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBlockFromCreatorForBlockedAccountsDialogMutation, RemoveBlockFromCreatorForBlockedAccountsDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBlockFromCreatorForBlockedAccountsDialogMutation, RemoveBlockFromCreatorForBlockedAccountsDialogMutationVariables>(RemoveBlockFromCreatorForBlockedAccountsDialogDocument, options);
      }
export type RemoveBlockFromCreatorForBlockedAccountsDialogMutationHookResult = ReturnType<typeof useRemoveBlockFromCreatorForBlockedAccountsDialogMutation>;
export type RemoveBlockFromCreatorForBlockedAccountsDialogMutationResult = Apollo.MutationResult<RemoveBlockFromCreatorForBlockedAccountsDialogMutation>;
export type RemoveBlockFromCreatorForBlockedAccountsDialogMutationOptions = Apollo.BaseMutationOptions<RemoveBlockFromCreatorForBlockedAccountsDialogMutation, RemoveBlockFromCreatorForBlockedAccountsDialogMutationVariables>;
export const GetCreatorByHandleForBlockAccountFormDocument = gql`
    query GetCreatorByHandleForBlockAccountForm($filters: SocialCreatorFilters!) {
  getSocialCreator(filters: $filters) {
    handle
  }
}
    `;

/**
 * __useGetCreatorByHandleForBlockAccountFormQuery__
 *
 * To run a query within a React component, call `useGetCreatorByHandleForBlockAccountFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorByHandleForBlockAccountFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorByHandleForBlockAccountFormQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCreatorByHandleForBlockAccountFormQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorByHandleForBlockAccountFormQuery, GetCreatorByHandleForBlockAccountFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorByHandleForBlockAccountFormQuery, GetCreatorByHandleForBlockAccountFormQueryVariables>(GetCreatorByHandleForBlockAccountFormDocument, options);
      }
export function useGetCreatorByHandleForBlockAccountFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorByHandleForBlockAccountFormQuery, GetCreatorByHandleForBlockAccountFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorByHandleForBlockAccountFormQuery, GetCreatorByHandleForBlockAccountFormQueryVariables>(GetCreatorByHandleForBlockAccountFormDocument, options);
        }
export type GetCreatorByHandleForBlockAccountFormQueryHookResult = ReturnType<typeof useGetCreatorByHandleForBlockAccountFormQuery>;
export type GetCreatorByHandleForBlockAccountFormLazyQueryHookResult = ReturnType<typeof useGetCreatorByHandleForBlockAccountFormLazyQuery>;
export type GetCreatorByHandleForBlockAccountFormQueryResult = Apollo.QueryResult<GetCreatorByHandleForBlockAccountFormQuery, GetCreatorByHandleForBlockAccountFormQueryVariables>;
export const GetNotificationConfigsForNotificationsSectionDocument = gql`
    query GetNotificationConfigsForNotificationsSection {
  getNotificationConfigs {
    id
    ...SocialPostNotificationConfigFragmentNotificationsSection
  }
}
    ${SocialPostNotificationConfigFragmentNotificationsSectionFragmentDoc}`;

/**
 * __useGetNotificationConfigsForNotificationsSectionQuery__
 *
 * To run a query within a React component, call `useGetNotificationConfigsForNotificationsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationConfigsForNotificationsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationConfigsForNotificationsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationConfigsForNotificationsSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationConfigsForNotificationsSectionQuery, GetNotificationConfigsForNotificationsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationConfigsForNotificationsSectionQuery, GetNotificationConfigsForNotificationsSectionQueryVariables>(GetNotificationConfigsForNotificationsSectionDocument, options);
      }
export function useGetNotificationConfigsForNotificationsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationConfigsForNotificationsSectionQuery, GetNotificationConfigsForNotificationsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationConfigsForNotificationsSectionQuery, GetNotificationConfigsForNotificationsSectionQueryVariables>(GetNotificationConfigsForNotificationsSectionDocument, options);
        }
export type GetNotificationConfigsForNotificationsSectionQueryHookResult = ReturnType<typeof useGetNotificationConfigsForNotificationsSectionQuery>;
export type GetNotificationConfigsForNotificationsSectionLazyQueryHookResult = ReturnType<typeof useGetNotificationConfigsForNotificationsSectionLazyQuery>;
export type GetNotificationConfigsForNotificationsSectionQueryResult = Apollo.QueryResult<GetNotificationConfigsForNotificationsSectionQuery, GetNotificationConfigsForNotificationsSectionQueryVariables>;
export const CreateSocialPostNotificationConfigForNotificationsSectionDocument = gql`
    mutation CreateSocialPostNotificationConfigForNotificationsSection($data: CreateSocialPostNotificationConfigInput!) {
  createSocialPostNotificationConfig(data: $data) {
    id
    ...SocialPostNotificationConfigFragmentNotificationsSection
  }
}
    ${SocialPostNotificationConfigFragmentNotificationsSectionFragmentDoc}`;
export type CreateSocialPostNotificationConfigForNotificationsSectionMutationFn = Apollo.MutationFunction<CreateSocialPostNotificationConfigForNotificationsSectionMutation, CreateSocialPostNotificationConfigForNotificationsSectionMutationVariables>;

/**
 * __useCreateSocialPostNotificationConfigForNotificationsSectionMutation__
 *
 * To run a mutation, you first call `useCreateSocialPostNotificationConfigForNotificationsSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocialPostNotificationConfigForNotificationsSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocialPostNotificationConfigForNotificationsSectionMutation, { data, loading, error }] = useCreateSocialPostNotificationConfigForNotificationsSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSocialPostNotificationConfigForNotificationsSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocialPostNotificationConfigForNotificationsSectionMutation, CreateSocialPostNotificationConfigForNotificationsSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocialPostNotificationConfigForNotificationsSectionMutation, CreateSocialPostNotificationConfigForNotificationsSectionMutationVariables>(CreateSocialPostNotificationConfigForNotificationsSectionDocument, options);
      }
export type CreateSocialPostNotificationConfigForNotificationsSectionMutationHookResult = ReturnType<typeof useCreateSocialPostNotificationConfigForNotificationsSectionMutation>;
export type CreateSocialPostNotificationConfigForNotificationsSectionMutationResult = Apollo.MutationResult<CreateSocialPostNotificationConfigForNotificationsSectionMutation>;
export type CreateSocialPostNotificationConfigForNotificationsSectionMutationOptions = Apollo.BaseMutationOptions<CreateSocialPostNotificationConfigForNotificationsSectionMutation, CreateSocialPostNotificationConfigForNotificationsSectionMutationVariables>;
export const UpdateSocialPostNotificationConfigForNotificationsSectionDocument = gql`
    mutation UpdateSocialPostNotificationConfigForNotificationsSection($data: UpdateSocialPostNotificationConfigInput!) {
  updateSocialPostNotificationConfig(data: $data) {
    id
    ...SocialPostNotificationConfigFragmentNotificationsSection
  }
}
    ${SocialPostNotificationConfigFragmentNotificationsSectionFragmentDoc}`;
export type UpdateSocialPostNotificationConfigForNotificationsSectionMutationFn = Apollo.MutationFunction<UpdateSocialPostNotificationConfigForNotificationsSectionMutation, UpdateSocialPostNotificationConfigForNotificationsSectionMutationVariables>;

/**
 * __useUpdateSocialPostNotificationConfigForNotificationsSectionMutation__
 *
 * To run a mutation, you first call `useUpdateSocialPostNotificationConfigForNotificationsSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialPostNotificationConfigForNotificationsSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialPostNotificationConfigForNotificationsSectionMutation, { data, loading, error }] = useUpdateSocialPostNotificationConfigForNotificationsSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSocialPostNotificationConfigForNotificationsSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialPostNotificationConfigForNotificationsSectionMutation, UpdateSocialPostNotificationConfigForNotificationsSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialPostNotificationConfigForNotificationsSectionMutation, UpdateSocialPostNotificationConfigForNotificationsSectionMutationVariables>(UpdateSocialPostNotificationConfigForNotificationsSectionDocument, options);
      }
export type UpdateSocialPostNotificationConfigForNotificationsSectionMutationHookResult = ReturnType<typeof useUpdateSocialPostNotificationConfigForNotificationsSectionMutation>;
export type UpdateSocialPostNotificationConfigForNotificationsSectionMutationResult = Apollo.MutationResult<UpdateSocialPostNotificationConfigForNotificationsSectionMutation>;
export type UpdateSocialPostNotificationConfigForNotificationsSectionMutationOptions = Apollo.BaseMutationOptions<UpdateSocialPostNotificationConfigForNotificationsSectionMutation, UpdateSocialPostNotificationConfigForNotificationsSectionMutationVariables>;
export const DeleteSocialPostNotificationConfigForNotificationsSectionDocument = gql`
    mutation DeleteSocialPostNotificationConfigForNotificationsSection($id: String!) {
  deleteSocialPostNotificationConfig(id: $id) {
    success
    message
  }
}
    `;
export type DeleteSocialPostNotificationConfigForNotificationsSectionMutationFn = Apollo.MutationFunction<DeleteSocialPostNotificationConfigForNotificationsSectionMutation, DeleteSocialPostNotificationConfigForNotificationsSectionMutationVariables>;

/**
 * __useDeleteSocialPostNotificationConfigForNotificationsSectionMutation__
 *
 * To run a mutation, you first call `useDeleteSocialPostNotificationConfigForNotificationsSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialPostNotificationConfigForNotificationsSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialPostNotificationConfigForNotificationsSectionMutation, { data, loading, error }] = useDeleteSocialPostNotificationConfigForNotificationsSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSocialPostNotificationConfigForNotificationsSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSocialPostNotificationConfigForNotificationsSectionMutation, DeleteSocialPostNotificationConfigForNotificationsSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSocialPostNotificationConfigForNotificationsSectionMutation, DeleteSocialPostNotificationConfigForNotificationsSectionMutationVariables>(DeleteSocialPostNotificationConfigForNotificationsSectionDocument, options);
      }
export type DeleteSocialPostNotificationConfigForNotificationsSectionMutationHookResult = ReturnType<typeof useDeleteSocialPostNotificationConfigForNotificationsSectionMutation>;
export type DeleteSocialPostNotificationConfigForNotificationsSectionMutationResult = Apollo.MutationResult<DeleteSocialPostNotificationConfigForNotificationsSectionMutation>;
export type DeleteSocialPostNotificationConfigForNotificationsSectionMutationOptions = Apollo.BaseMutationOptions<DeleteSocialPostNotificationConfigForNotificationsSectionMutation, DeleteSocialPostNotificationConfigForNotificationsSectionMutationVariables>;
export const GetBrandForNotificationSectionDocument = gql`
    query GetBrandForNotificationSection($brandId: String!) {
  brand(id: $brandId) {
    id
    topics {
      id
      ...TopicFragmentNotificationsSection
    }
  }
}
    ${TopicFragmentNotificationsSectionFragmentDoc}`;

/**
 * __useGetBrandForNotificationSectionQuery__
 *
 * To run a query within a React component, call `useGetBrandForNotificationSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForNotificationSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForNotificationSectionQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForNotificationSectionQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForNotificationSectionQuery, GetBrandForNotificationSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForNotificationSectionQuery, GetBrandForNotificationSectionQueryVariables>(GetBrandForNotificationSectionDocument, options);
      }
export function useGetBrandForNotificationSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForNotificationSectionQuery, GetBrandForNotificationSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForNotificationSectionQuery, GetBrandForNotificationSectionQueryVariables>(GetBrandForNotificationSectionDocument, options);
        }
export type GetBrandForNotificationSectionQueryHookResult = ReturnType<typeof useGetBrandForNotificationSectionQuery>;
export type GetBrandForNotificationSectionLazyQueryHookResult = ReturnType<typeof useGetBrandForNotificationSectionLazyQuery>;
export type GetBrandForNotificationSectionQueryResult = Apollo.QueryResult<GetBrandForNotificationSectionQuery, GetBrandForNotificationSectionQueryVariables>;
export const GetBrandRadarEventsConfigForCommunityHubDocument = gql`
    query GetBrandRadarEventsConfigForCommunityHub($brandId: String!) {
  getBrandRadarEventsConfig(brandId: $brandId) {
    id
    engagementRateThreshold
    engagementThreshold
    mentionsThreshold
    brandId
  }
}
    `;

/**
 * __useGetBrandRadarEventsConfigForCommunityHubQuery__
 *
 * To run a query within a React component, call `useGetBrandRadarEventsConfigForCommunityHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandRadarEventsConfigForCommunityHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandRadarEventsConfigForCommunityHubQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandRadarEventsConfigForCommunityHubQuery(baseOptions: Apollo.QueryHookOptions<GetBrandRadarEventsConfigForCommunityHubQuery, GetBrandRadarEventsConfigForCommunityHubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandRadarEventsConfigForCommunityHubQuery, GetBrandRadarEventsConfigForCommunityHubQueryVariables>(GetBrandRadarEventsConfigForCommunityHubDocument, options);
      }
export function useGetBrandRadarEventsConfigForCommunityHubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandRadarEventsConfigForCommunityHubQuery, GetBrandRadarEventsConfigForCommunityHubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandRadarEventsConfigForCommunityHubQuery, GetBrandRadarEventsConfigForCommunityHubQueryVariables>(GetBrandRadarEventsConfigForCommunityHubDocument, options);
        }
export type GetBrandRadarEventsConfigForCommunityHubQueryHookResult = ReturnType<typeof useGetBrandRadarEventsConfigForCommunityHubQuery>;
export type GetBrandRadarEventsConfigForCommunityHubLazyQueryHookResult = ReturnType<typeof useGetBrandRadarEventsConfigForCommunityHubLazyQuery>;
export type GetBrandRadarEventsConfigForCommunityHubQueryResult = Apollo.QueryResult<GetBrandRadarEventsConfigForCommunityHubQuery, GetBrandRadarEventsConfigForCommunityHubQueryVariables>;
export const UpdateBrandRadarEventsConfigForCommunityHubDocument = gql`
    mutation UpdateBrandRadarEventsConfigForCommunityHub($brandId: String!, $input: UpdateBrandRadarEventsConfigInput!) {
  updateBrandRadarEventsConfig(brandId: $brandId, input: $input) {
    success
    message
  }
}
    `;
export type UpdateBrandRadarEventsConfigForCommunityHubMutationFn = Apollo.MutationFunction<UpdateBrandRadarEventsConfigForCommunityHubMutation, UpdateBrandRadarEventsConfigForCommunityHubMutationVariables>;

/**
 * __useUpdateBrandRadarEventsConfigForCommunityHubMutation__
 *
 * To run a mutation, you first call `useUpdateBrandRadarEventsConfigForCommunityHubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandRadarEventsConfigForCommunityHubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandRadarEventsConfigForCommunityHubMutation, { data, loading, error }] = useUpdateBrandRadarEventsConfigForCommunityHubMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandRadarEventsConfigForCommunityHubMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandRadarEventsConfigForCommunityHubMutation, UpdateBrandRadarEventsConfigForCommunityHubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandRadarEventsConfigForCommunityHubMutation, UpdateBrandRadarEventsConfigForCommunityHubMutationVariables>(UpdateBrandRadarEventsConfigForCommunityHubDocument, options);
      }
export type UpdateBrandRadarEventsConfigForCommunityHubMutationHookResult = ReturnType<typeof useUpdateBrandRadarEventsConfigForCommunityHubMutation>;
export type UpdateBrandRadarEventsConfigForCommunityHubMutationResult = Apollo.MutationResult<UpdateBrandRadarEventsConfigForCommunityHubMutation>;
export type UpdateBrandRadarEventsConfigForCommunityHubMutationOptions = Apollo.BaseMutationOptions<UpdateBrandRadarEventsConfigForCommunityHubMutation, UpdateBrandRadarEventsConfigForCommunityHubMutationVariables>;
export const UpdateCompetitorsForCompetitorEditDocument = gql`
    mutation UpdateCompetitorsForCompetitorEdit($data: UpdateCompetitorInput!) {
  updateCompetitors(data: $data) {
    id
    searchTerms {
      id
      term
    }
    trackingBrand {
      id
      name
      creators {
        id
        ...CreatorFragmentSocialListeningSettingsSocialHandleInput
      }
    }
  }
}
    ${CreatorFragmentSocialListeningSettingsSocialHandleInputFragmentDoc}`;
export type UpdateCompetitorsForCompetitorEditMutationFn = Apollo.MutationFunction<UpdateCompetitorsForCompetitorEditMutation, UpdateCompetitorsForCompetitorEditMutationVariables>;

/**
 * __useUpdateCompetitorsForCompetitorEditMutation__
 *
 * To run a mutation, you first call `useUpdateCompetitorsForCompetitorEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompetitorsForCompetitorEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompetitorsForCompetitorEditMutation, { data, loading, error }] = useUpdateCompetitorsForCompetitorEditMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompetitorsForCompetitorEditMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompetitorsForCompetitorEditMutation, UpdateCompetitorsForCompetitorEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompetitorsForCompetitorEditMutation, UpdateCompetitorsForCompetitorEditMutationVariables>(UpdateCompetitorsForCompetitorEditDocument, options);
      }
export type UpdateCompetitorsForCompetitorEditMutationHookResult = ReturnType<typeof useUpdateCompetitorsForCompetitorEditMutation>;
export type UpdateCompetitorsForCompetitorEditMutationResult = Apollo.MutationResult<UpdateCompetitorsForCompetitorEditMutation>;
export type UpdateCompetitorsForCompetitorEditMutationOptions = Apollo.BaseMutationOptions<UpdateCompetitorsForCompetitorEditMutation, UpdateCompetitorsForCompetitorEditMutationVariables>;
export const RemoveCompetitorsForCompetitorEditDocument = gql`
    mutation RemoveCompetitorsForCompetitorEdit($data: RemoveCompetitorsInput!) {
  removeCompetitors(data: $data) {
    id
  }
}
    `;
export type RemoveCompetitorsForCompetitorEditMutationFn = Apollo.MutationFunction<RemoveCompetitorsForCompetitorEditMutation, RemoveCompetitorsForCompetitorEditMutationVariables>;

/**
 * __useRemoveCompetitorsForCompetitorEditMutation__
 *
 * To run a mutation, you first call `useRemoveCompetitorsForCompetitorEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompetitorsForCompetitorEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompetitorsForCompetitorEditMutation, { data, loading, error }] = useRemoveCompetitorsForCompetitorEditMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCompetitorsForCompetitorEditMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompetitorsForCompetitorEditMutation, RemoveCompetitorsForCompetitorEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompetitorsForCompetitorEditMutation, RemoveCompetitorsForCompetitorEditMutationVariables>(RemoveCompetitorsForCompetitorEditDocument, options);
      }
export type RemoveCompetitorsForCompetitorEditMutationHookResult = ReturnType<typeof useRemoveCompetitorsForCompetitorEditMutation>;
export type RemoveCompetitorsForCompetitorEditMutationResult = Apollo.MutationResult<RemoveCompetitorsForCompetitorEditMutation>;
export type RemoveCompetitorsForCompetitorEditMutationOptions = Apollo.BaseMutationOptions<RemoveCompetitorsForCompetitorEditMutation, RemoveCompetitorsForCompetitorEditMutationVariables>;
export const GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewDocument = gql`
    query GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsView($brandId: String!) {
  organizationCompetitors(brandId: $brandId) {
    id
    ...CompetitorFragmentCompetitorEdit
  }
}
    ${CompetitorFragmentCompetitorEditFragmentDoc}`;

/**
 * __useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery, GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery, GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryVariables>(GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewDocument, options);
      }
export function useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery, GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery, GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryVariables>(GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewDocument, options);
        }
export type GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryHookResult = ReturnType<typeof useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery>;
export type GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewLazyQueryHookResult = ReturnType<typeof useGetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewLazyQuery>;
export type GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryResult = Apollo.QueryResult<GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQuery, GetOrganizationCompetitorsForSocialListeningSettingsCompetitorsViewQueryVariables>;
export const CreateCreatorForSocialMediaListeningSettingsGeneralDocument = gql`
    mutation CreateCreatorForSocialMediaListeningSettingsGeneral($data: CreateCreatorInput!) {
  createCreator(data: $data) {
    id
    ...CreatorFragmentSocialListeningSettingsSocialHandleInput
  }
}
    ${CreatorFragmentSocialListeningSettingsSocialHandleInputFragmentDoc}`;
export type CreateCreatorForSocialMediaListeningSettingsGeneralMutationFn = Apollo.MutationFunction<CreateCreatorForSocialMediaListeningSettingsGeneralMutation, CreateCreatorForSocialMediaListeningSettingsGeneralMutationVariables>;

/**
 * __useCreateCreatorForSocialMediaListeningSettingsGeneralMutation__
 *
 * To run a mutation, you first call `useCreateCreatorForSocialMediaListeningSettingsGeneralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreatorForSocialMediaListeningSettingsGeneralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreatorForSocialMediaListeningSettingsGeneralMutation, { data, loading, error }] = useCreateCreatorForSocialMediaListeningSettingsGeneralMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCreatorForSocialMediaListeningSettingsGeneralMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreatorForSocialMediaListeningSettingsGeneralMutation, CreateCreatorForSocialMediaListeningSettingsGeneralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreatorForSocialMediaListeningSettingsGeneralMutation, CreateCreatorForSocialMediaListeningSettingsGeneralMutationVariables>(CreateCreatorForSocialMediaListeningSettingsGeneralDocument, options);
      }
export type CreateCreatorForSocialMediaListeningSettingsGeneralMutationHookResult = ReturnType<typeof useCreateCreatorForSocialMediaListeningSettingsGeneralMutation>;
export type CreateCreatorForSocialMediaListeningSettingsGeneralMutationResult = Apollo.MutationResult<CreateCreatorForSocialMediaListeningSettingsGeneralMutation>;
export type CreateCreatorForSocialMediaListeningSettingsGeneralMutationOptions = Apollo.BaseMutationOptions<CreateCreatorForSocialMediaListeningSettingsGeneralMutation, CreateCreatorForSocialMediaListeningSettingsGeneralMutationVariables>;
export const RemoveCreatorForSocialMediaListeningSettingsGeneralDocument = gql`
    mutation RemoveCreatorForSocialMediaListeningSettingsGeneral($data: RemoveCreatorInput!) {
  removeCreator(data: $data) {
    message
    success
  }
}
    `;
export type RemoveCreatorForSocialMediaListeningSettingsGeneralMutationFn = Apollo.MutationFunction<RemoveCreatorForSocialMediaListeningSettingsGeneralMutation, RemoveCreatorForSocialMediaListeningSettingsGeneralMutationVariables>;

/**
 * __useRemoveCreatorForSocialMediaListeningSettingsGeneralMutation__
 *
 * To run a mutation, you first call `useRemoveCreatorForSocialMediaListeningSettingsGeneralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreatorForSocialMediaListeningSettingsGeneralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreatorForSocialMediaListeningSettingsGeneralMutation, { data, loading, error }] = useRemoveCreatorForSocialMediaListeningSettingsGeneralMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCreatorForSocialMediaListeningSettingsGeneralMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCreatorForSocialMediaListeningSettingsGeneralMutation, RemoveCreatorForSocialMediaListeningSettingsGeneralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCreatorForSocialMediaListeningSettingsGeneralMutation, RemoveCreatorForSocialMediaListeningSettingsGeneralMutationVariables>(RemoveCreatorForSocialMediaListeningSettingsGeneralDocument, options);
      }
export type RemoveCreatorForSocialMediaListeningSettingsGeneralMutationHookResult = ReturnType<typeof useRemoveCreatorForSocialMediaListeningSettingsGeneralMutation>;
export type RemoveCreatorForSocialMediaListeningSettingsGeneralMutationResult = Apollo.MutationResult<RemoveCreatorForSocialMediaListeningSettingsGeneralMutation>;
export type RemoveCreatorForSocialMediaListeningSettingsGeneralMutationOptions = Apollo.BaseMutationOptions<RemoveCreatorForSocialMediaListeningSettingsGeneralMutation, RemoveCreatorForSocialMediaListeningSettingsGeneralMutationVariables>;
export const GetSentimentSubjectsByTopicForSettingsSentimentSubjectDocument = gql`
    query GetSentimentSubjectsByTopicForSettingsSentimentSubject($topicId: String!) {
  sentimentSubjectsByTopic(topicId: $topicId) {
    id
    subject
    topicId
    status
  }
}
    `;

/**
 * __useGetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery__
 *
 * To run a query within a React component, call `useGetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery(baseOptions: Apollo.QueryHookOptions<GetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery, GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery, GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryVariables>(GetSentimentSubjectsByTopicForSettingsSentimentSubjectDocument, options);
      }
export function useGetSentimentSubjectsByTopicForSettingsSentimentSubjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery, GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery, GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryVariables>(GetSentimentSubjectsByTopicForSettingsSentimentSubjectDocument, options);
        }
export type GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryHookResult = ReturnType<typeof useGetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery>;
export type GetSentimentSubjectsByTopicForSettingsSentimentSubjectLazyQueryHookResult = ReturnType<typeof useGetSentimentSubjectsByTopicForSettingsSentimentSubjectLazyQuery>;
export type GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryResult = Apollo.QueryResult<GetSentimentSubjectsByTopicForSettingsSentimentSubjectQuery, GetSentimentSubjectsByTopicForSettingsSentimentSubjectQueryVariables>;
export const UpsertSentimentSubjectsForSettingsSentimentSubjectDocument = gql`
    mutation UpsertSentimentSubjectsForSettingsSentimentSubject($data: UpsertSentimentSubjectInput!) {
  upsertSentimentSubjects(data: $data) {
    id
    subject
    topicId
    status
  }
}
    `;
export type UpsertSentimentSubjectsForSettingsSentimentSubjectMutationFn = Apollo.MutationFunction<UpsertSentimentSubjectsForSettingsSentimentSubjectMutation, UpsertSentimentSubjectsForSettingsSentimentSubjectMutationVariables>;

/**
 * __useUpsertSentimentSubjectsForSettingsSentimentSubjectMutation__
 *
 * To run a mutation, you first call `useUpsertSentimentSubjectsForSettingsSentimentSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSentimentSubjectsForSettingsSentimentSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSentimentSubjectsForSettingsSentimentSubjectMutation, { data, loading, error }] = useUpsertSentimentSubjectsForSettingsSentimentSubjectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertSentimentSubjectsForSettingsSentimentSubjectMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSentimentSubjectsForSettingsSentimentSubjectMutation, UpsertSentimentSubjectsForSettingsSentimentSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSentimentSubjectsForSettingsSentimentSubjectMutation, UpsertSentimentSubjectsForSettingsSentimentSubjectMutationVariables>(UpsertSentimentSubjectsForSettingsSentimentSubjectDocument, options);
      }
export type UpsertSentimentSubjectsForSettingsSentimentSubjectMutationHookResult = ReturnType<typeof useUpsertSentimentSubjectsForSettingsSentimentSubjectMutation>;
export type UpsertSentimentSubjectsForSettingsSentimentSubjectMutationResult = Apollo.MutationResult<UpsertSentimentSubjectsForSettingsSentimentSubjectMutation>;
export type UpsertSentimentSubjectsForSettingsSentimentSubjectMutationOptions = Apollo.BaseMutationOptions<UpsertSentimentSubjectsForSettingsSentimentSubjectMutation, UpsertSentimentSubjectsForSettingsSentimentSubjectMutationVariables>;
export const UpdateSentimentSubjectForSettingsSentimentSubjectDocument = gql`
    mutation UpdateSentimentSubjectForSettingsSentimentSubject($data: UpdateSentimentSubjectInput!) {
  updateSentimentSubject(data: $data) {
    success
  }
}
    `;
export type UpdateSentimentSubjectForSettingsSentimentSubjectMutationFn = Apollo.MutationFunction<UpdateSentimentSubjectForSettingsSentimentSubjectMutation, UpdateSentimentSubjectForSettingsSentimentSubjectMutationVariables>;

/**
 * __useUpdateSentimentSubjectForSettingsSentimentSubjectMutation__
 *
 * To run a mutation, you first call `useUpdateSentimentSubjectForSettingsSentimentSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSentimentSubjectForSettingsSentimentSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSentimentSubjectForSettingsSentimentSubjectMutation, { data, loading, error }] = useUpdateSentimentSubjectForSettingsSentimentSubjectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSentimentSubjectForSettingsSentimentSubjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSentimentSubjectForSettingsSentimentSubjectMutation, UpdateSentimentSubjectForSettingsSentimentSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSentimentSubjectForSettingsSentimentSubjectMutation, UpdateSentimentSubjectForSettingsSentimentSubjectMutationVariables>(UpdateSentimentSubjectForSettingsSentimentSubjectDocument, options);
      }
export type UpdateSentimentSubjectForSettingsSentimentSubjectMutationHookResult = ReturnType<typeof useUpdateSentimentSubjectForSettingsSentimentSubjectMutation>;
export type UpdateSentimentSubjectForSettingsSentimentSubjectMutationResult = Apollo.MutationResult<UpdateSentimentSubjectForSettingsSentimentSubjectMutation>;
export type UpdateSentimentSubjectForSettingsSentimentSubjectMutationOptions = Apollo.BaseMutationOptions<UpdateSentimentSubjectForSettingsSentimentSubjectMutation, UpdateSentimentSubjectForSettingsSentimentSubjectMutationVariables>;
export const GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewDocument = gql`
    query GetTopicSignalDefinitionsForSocialListeningSettingsTopicsView($topicId: String!) {
  topicSignalDefinitions(topicId: $topicId) {
    ...SignalDefinitionFragmentTopicSignal
  }
}
    ${SignalDefinitionFragmentTopicSignalFragmentDoc}`;

/**
 * __useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery__
 *
 * To run a query within a React component, call `useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery, GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery, GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryVariables>(GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewDocument, options);
      }
export function useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery, GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery, GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryVariables>(GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewDocument, options);
        }
export type GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryHookResult = ReturnType<typeof useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery>;
export type GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewLazyQueryHookResult = ReturnType<typeof useGetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewLazyQuery>;
export type GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryResult = Apollo.QueryResult<GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQuery, GetTopicSignalDefinitionsForSocialListeningSettingsTopicsViewQueryVariables>;
export const CreateSignalDefinitionForSocialListeningSettingsTopicsViewDocument = gql`
    mutation CreateSignalDefinitionForSocialListeningSettingsTopicsView($data: CreateSignalDefinitionInput!) {
  createSignalDefinition(data: $data) {
    ...SignalDefinitionFragmentTopicSignal
  }
}
    ${SignalDefinitionFragmentTopicSignalFragmentDoc}`;
export type CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationFn = Apollo.MutationFunction<CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation, CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationVariables>;

/**
 * __useCreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation__
 *
 * To run a mutation, you first call `useCreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignalDefinitionForSocialListeningSettingsTopicsViewMutation, { data, loading, error }] = useCreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation, CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation, CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationVariables>(CreateSignalDefinitionForSocialListeningSettingsTopicsViewDocument, options);
      }
export type CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationHookResult = ReturnType<typeof useCreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation>;
export type CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationResult = Apollo.MutationResult<CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation>;
export type CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationOptions = Apollo.BaseMutationOptions<CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutation, CreateSignalDefinitionForSocialListeningSettingsTopicsViewMutationVariables>;
export const GetBrandForSocialListeningUsersViewDocument = gql`
    query GetBrandForSocialListeningUsersView($brandId: String!) {
  brand(id: $brandId) {
    id
    inviteMembers {
      id
      userId
      permissionLevel
      user {
        isInvitedBy {
          id
          lastName
          firstName
          email
        }
        ...UserFragmentAvatarGroup
      }
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;

/**
 * __useGetBrandForSocialListeningUsersViewQuery__
 *
 * To run a query within a React component, call `useGetBrandForSocialListeningUsersViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSocialListeningUsersViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSocialListeningUsersViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForSocialListeningUsersViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSocialListeningUsersViewQuery, GetBrandForSocialListeningUsersViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSocialListeningUsersViewQuery, GetBrandForSocialListeningUsersViewQueryVariables>(GetBrandForSocialListeningUsersViewDocument, options);
      }
export function useGetBrandForSocialListeningUsersViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSocialListeningUsersViewQuery, GetBrandForSocialListeningUsersViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSocialListeningUsersViewQuery, GetBrandForSocialListeningUsersViewQueryVariables>(GetBrandForSocialListeningUsersViewDocument, options);
        }
export type GetBrandForSocialListeningUsersViewQueryHookResult = ReturnType<typeof useGetBrandForSocialListeningUsersViewQuery>;
export type GetBrandForSocialListeningUsersViewLazyQueryHookResult = ReturnType<typeof useGetBrandForSocialListeningUsersViewLazyQuery>;
export type GetBrandForSocialListeningUsersViewQueryResult = Apollo.QueryResult<GetBrandForSocialListeningUsersViewQuery, GetBrandForSocialListeningUsersViewQueryVariables>;
export const UpdateBrandPermissionsForSocialListeningUsersViewDocument = gql`
    mutation UpdateBrandPermissionsForSocialListeningUsersView($data: UpdateBrandPermissionsInput!) {
  updateBrandPermissions(data: $data) {
    success
    message
  }
}
    `;
export type UpdateBrandPermissionsForSocialListeningUsersViewMutationFn = Apollo.MutationFunction<UpdateBrandPermissionsForSocialListeningUsersViewMutation, UpdateBrandPermissionsForSocialListeningUsersViewMutationVariables>;

/**
 * __useUpdateBrandPermissionsForSocialListeningUsersViewMutation__
 *
 * To run a mutation, you first call `useUpdateBrandPermissionsForSocialListeningUsersViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandPermissionsForSocialListeningUsersViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandPermissionsForSocialListeningUsersViewMutation, { data, loading, error }] = useUpdateBrandPermissionsForSocialListeningUsersViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandPermissionsForSocialListeningUsersViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandPermissionsForSocialListeningUsersViewMutation, UpdateBrandPermissionsForSocialListeningUsersViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandPermissionsForSocialListeningUsersViewMutation, UpdateBrandPermissionsForSocialListeningUsersViewMutationVariables>(UpdateBrandPermissionsForSocialListeningUsersViewDocument, options);
      }
export type UpdateBrandPermissionsForSocialListeningUsersViewMutationHookResult = ReturnType<typeof useUpdateBrandPermissionsForSocialListeningUsersViewMutation>;
export type UpdateBrandPermissionsForSocialListeningUsersViewMutationResult = Apollo.MutationResult<UpdateBrandPermissionsForSocialListeningUsersViewMutation>;
export type UpdateBrandPermissionsForSocialListeningUsersViewMutationOptions = Apollo.BaseMutationOptions<UpdateBrandPermissionsForSocialListeningUsersViewMutation, UpdateBrandPermissionsForSocialListeningUsersViewMutationVariables>;
export const GetCreatorTrackingTopicsForBlockingCreatorDialogDocument = gql`
    query GetCreatorTrackingTopicsForBlockingCreatorDialog($data: CreatorTopicTrackingInput!) {
  getTopicsTrackingList(data: $data) {
    isTracking
    topic {
      id
    }
  }
}
    `;

/**
 * __useGetCreatorTrackingTopicsForBlockingCreatorDialogQuery__
 *
 * To run a query within a React component, call `useGetCreatorTrackingTopicsForBlockingCreatorDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorTrackingTopicsForBlockingCreatorDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorTrackingTopicsForBlockingCreatorDialogQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCreatorTrackingTopicsForBlockingCreatorDialogQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorTrackingTopicsForBlockingCreatorDialogQuery, GetCreatorTrackingTopicsForBlockingCreatorDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorTrackingTopicsForBlockingCreatorDialogQuery, GetCreatorTrackingTopicsForBlockingCreatorDialogQueryVariables>(GetCreatorTrackingTopicsForBlockingCreatorDialogDocument, options);
      }
export function useGetCreatorTrackingTopicsForBlockingCreatorDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorTrackingTopicsForBlockingCreatorDialogQuery, GetCreatorTrackingTopicsForBlockingCreatorDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorTrackingTopicsForBlockingCreatorDialogQuery, GetCreatorTrackingTopicsForBlockingCreatorDialogQueryVariables>(GetCreatorTrackingTopicsForBlockingCreatorDialogDocument, options);
        }
export type GetCreatorTrackingTopicsForBlockingCreatorDialogQueryHookResult = ReturnType<typeof useGetCreatorTrackingTopicsForBlockingCreatorDialogQuery>;
export type GetCreatorTrackingTopicsForBlockingCreatorDialogLazyQueryHookResult = ReturnType<typeof useGetCreatorTrackingTopicsForBlockingCreatorDialogLazyQuery>;
export type GetCreatorTrackingTopicsForBlockingCreatorDialogQueryResult = Apollo.QueryResult<GetCreatorTrackingTopicsForBlockingCreatorDialogQuery, GetCreatorTrackingTopicsForBlockingCreatorDialogQueryVariables>;
export const BlockCreatorForBlockCreatorDialogDocument = gql`
    mutation BlockCreatorForBlockCreatorDialog($data: BlockCreatorInput!) {
  blockCreator(data: $data) {
    success
  }
}
    `;
export type BlockCreatorForBlockCreatorDialogMutationFn = Apollo.MutationFunction<BlockCreatorForBlockCreatorDialogMutation, BlockCreatorForBlockCreatorDialogMutationVariables>;

/**
 * __useBlockCreatorForBlockCreatorDialogMutation__
 *
 * To run a mutation, you first call `useBlockCreatorForBlockCreatorDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCreatorForBlockCreatorDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCreatorForBlockCreatorDialogMutation, { data, loading, error }] = useBlockCreatorForBlockCreatorDialogMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBlockCreatorForBlockCreatorDialogMutation(baseOptions?: Apollo.MutationHookOptions<BlockCreatorForBlockCreatorDialogMutation, BlockCreatorForBlockCreatorDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCreatorForBlockCreatorDialogMutation, BlockCreatorForBlockCreatorDialogMutationVariables>(BlockCreatorForBlockCreatorDialogDocument, options);
      }
export type BlockCreatorForBlockCreatorDialogMutationHookResult = ReturnType<typeof useBlockCreatorForBlockCreatorDialogMutation>;
export type BlockCreatorForBlockCreatorDialogMutationResult = Apollo.MutationResult<BlockCreatorForBlockCreatorDialogMutation>;
export type BlockCreatorForBlockCreatorDialogMutationOptions = Apollo.BaseMutationOptions<BlockCreatorForBlockCreatorDialogMutation, BlockCreatorForBlockCreatorDialogMutationVariables>;
export const GetBrandsParsedHoursDocument = gql`
    query GetBrandsParsedHours($totalHoursParsedData: BrandHoursParsedInput) {
  me {
    id
    organization {
      id
      billing {
        id
        brandHoursParseLimit
      }
      socialListeningBrands {
        id
        name
        creators {
          id
          profilePictureUrl
        }
        totalHoursParsedCount(data: $totalHoursParsedData)
      }
    }
  }
}
    `;

/**
 * __useGetBrandsParsedHoursQuery__
 *
 * To run a query within a React component, call `useGetBrandsParsedHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsParsedHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsParsedHoursQuery({
 *   variables: {
 *      totalHoursParsedData: // value for 'totalHoursParsedData'
 *   },
 * });
 */
export function useGetBrandsParsedHoursQuery(baseOptions?: Apollo.QueryHookOptions<GetBrandsParsedHoursQuery, GetBrandsParsedHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsParsedHoursQuery, GetBrandsParsedHoursQueryVariables>(GetBrandsParsedHoursDocument, options);
      }
export function useGetBrandsParsedHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsParsedHoursQuery, GetBrandsParsedHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsParsedHoursQuery, GetBrandsParsedHoursQueryVariables>(GetBrandsParsedHoursDocument, options);
        }
export type GetBrandsParsedHoursQueryHookResult = ReturnType<typeof useGetBrandsParsedHoursQuery>;
export type GetBrandsParsedHoursLazyQueryHookResult = ReturnType<typeof useGetBrandsParsedHoursLazyQuery>;
export type GetBrandsParsedHoursQueryResult = Apollo.QueryResult<GetBrandsParsedHoursQuery, GetBrandsParsedHoursQueryVariables>;
export const GetTopicsTrackingListForCreatorPeekingDocument = gql`
    query GetTopicsTrackingListForCreatorPeeking($data: CreatorTopicTrackingInput!) {
  getTopicsTrackingList(data: $data) {
    isTracking
    topic {
      ...TopicFragmentCreatorPeekingContent
      active
    }
  }
}
    ${TopicFragmentCreatorPeekingContentFragmentDoc}`;

/**
 * __useGetTopicsTrackingListForCreatorPeekingQuery__
 *
 * To run a query within a React component, call `useGetTopicsTrackingListForCreatorPeekingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsTrackingListForCreatorPeekingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsTrackingListForCreatorPeekingQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTopicsTrackingListForCreatorPeekingQuery(baseOptions: Apollo.QueryHookOptions<GetTopicsTrackingListForCreatorPeekingQuery, GetTopicsTrackingListForCreatorPeekingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicsTrackingListForCreatorPeekingQuery, GetTopicsTrackingListForCreatorPeekingQueryVariables>(GetTopicsTrackingListForCreatorPeekingDocument, options);
      }
export function useGetTopicsTrackingListForCreatorPeekingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicsTrackingListForCreatorPeekingQuery, GetTopicsTrackingListForCreatorPeekingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicsTrackingListForCreatorPeekingQuery, GetTopicsTrackingListForCreatorPeekingQueryVariables>(GetTopicsTrackingListForCreatorPeekingDocument, options);
        }
export type GetTopicsTrackingListForCreatorPeekingQueryHookResult = ReturnType<typeof useGetTopicsTrackingListForCreatorPeekingQuery>;
export type GetTopicsTrackingListForCreatorPeekingLazyQueryHookResult = ReturnType<typeof useGetTopicsTrackingListForCreatorPeekingLazyQuery>;
export type GetTopicsTrackingListForCreatorPeekingQueryResult = Apollo.QueryResult<GetTopicsTrackingListForCreatorPeekingQuery, GetTopicsTrackingListForCreatorPeekingQueryVariables>;
export const GetCreatorInsightsByCreatorIdForCreatorPeekingDocument = gql`
    query GetCreatorInsightsByCreatorIdForCreatorPeeking($input: IsTrackingCreatorProfileInsightsByCreatorIdInput!) {
  isTrackingCreatorProfileInsightsByCreatorId(input: $input)
}
    `;

/**
 * __useGetCreatorInsightsByCreatorIdForCreatorPeekingQuery__
 *
 * To run a query within a React component, call `useGetCreatorInsightsByCreatorIdForCreatorPeekingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorInsightsByCreatorIdForCreatorPeekingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorInsightsByCreatorIdForCreatorPeekingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCreatorInsightsByCreatorIdForCreatorPeekingQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorInsightsByCreatorIdForCreatorPeekingQuery, GetCreatorInsightsByCreatorIdForCreatorPeekingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorInsightsByCreatorIdForCreatorPeekingQuery, GetCreatorInsightsByCreatorIdForCreatorPeekingQueryVariables>(GetCreatorInsightsByCreatorIdForCreatorPeekingDocument, options);
      }
export function useGetCreatorInsightsByCreatorIdForCreatorPeekingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorInsightsByCreatorIdForCreatorPeekingQuery, GetCreatorInsightsByCreatorIdForCreatorPeekingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorInsightsByCreatorIdForCreatorPeekingQuery, GetCreatorInsightsByCreatorIdForCreatorPeekingQueryVariables>(GetCreatorInsightsByCreatorIdForCreatorPeekingDocument, options);
        }
export type GetCreatorInsightsByCreatorIdForCreatorPeekingQueryHookResult = ReturnType<typeof useGetCreatorInsightsByCreatorIdForCreatorPeekingQuery>;
export type GetCreatorInsightsByCreatorIdForCreatorPeekingLazyQueryHookResult = ReturnType<typeof useGetCreatorInsightsByCreatorIdForCreatorPeekingLazyQuery>;
export type GetCreatorInsightsByCreatorIdForCreatorPeekingQueryResult = Apollo.QueryResult<GetCreatorInsightsByCreatorIdForCreatorPeekingQuery, GetCreatorInsightsByCreatorIdForCreatorPeekingQueryVariables>;
export const GetTopicsTrackingListForCreatorTrackingListDocument = gql`
    query GetTopicsTrackingListForCreatorTrackingList($data: CreatorTopicTrackingInput!) {
  getTopicsTrackingList(data: $data) {
    isTracking
    topic {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTopicsTrackingListForCreatorTrackingListQuery__
 *
 * To run a query within a React component, call `useGetTopicsTrackingListForCreatorTrackingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsTrackingListForCreatorTrackingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsTrackingListForCreatorTrackingListQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTopicsTrackingListForCreatorTrackingListQuery(baseOptions: Apollo.QueryHookOptions<GetTopicsTrackingListForCreatorTrackingListQuery, GetTopicsTrackingListForCreatorTrackingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicsTrackingListForCreatorTrackingListQuery, GetTopicsTrackingListForCreatorTrackingListQueryVariables>(GetTopicsTrackingListForCreatorTrackingListDocument, options);
      }
export function useGetTopicsTrackingListForCreatorTrackingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicsTrackingListForCreatorTrackingListQuery, GetTopicsTrackingListForCreatorTrackingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicsTrackingListForCreatorTrackingListQuery, GetTopicsTrackingListForCreatorTrackingListQueryVariables>(GetTopicsTrackingListForCreatorTrackingListDocument, options);
        }
export type GetTopicsTrackingListForCreatorTrackingListQueryHookResult = ReturnType<typeof useGetTopicsTrackingListForCreatorTrackingListQuery>;
export type GetTopicsTrackingListForCreatorTrackingListLazyQueryHookResult = ReturnType<typeof useGetTopicsTrackingListForCreatorTrackingListLazyQuery>;
export type GetTopicsTrackingListForCreatorTrackingListQueryResult = Apollo.QueryResult<GetTopicsTrackingListForCreatorTrackingListQuery, GetTopicsTrackingListForCreatorTrackingListQueryVariables>;
export const GetLanguagesForFilterByLanguageDocument = gql`
    query GetLanguagesForFilterByLanguage {
  languages {
    name
  }
}
    `;

/**
 * __useGetLanguagesForFilterByLanguageQuery__
 *
 * To run a query within a React component, call `useGetLanguagesForFilterByLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesForFilterByLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesForFilterByLanguageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesForFilterByLanguageQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesForFilterByLanguageQuery, GetLanguagesForFilterByLanguageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesForFilterByLanguageQuery, GetLanguagesForFilterByLanguageQueryVariables>(GetLanguagesForFilterByLanguageDocument, options);
      }
export function useGetLanguagesForFilterByLanguageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesForFilterByLanguageQuery, GetLanguagesForFilterByLanguageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesForFilterByLanguageQuery, GetLanguagesForFilterByLanguageQueryVariables>(GetLanguagesForFilterByLanguageDocument, options);
        }
export type GetLanguagesForFilterByLanguageQueryHookResult = ReturnType<typeof useGetLanguagesForFilterByLanguageQuery>;
export type GetLanguagesForFilterByLanguageLazyQueryHookResult = ReturnType<typeof useGetLanguagesForFilterByLanguageLazyQuery>;
export type GetLanguagesForFilterByLanguageQueryResult = Apollo.QueryResult<GetLanguagesForFilterByLanguageQuery, GetLanguagesForFilterByLanguageQueryVariables>;
export const GetSignalDefinitionsByBrandIdForFilterBySignalsDocument = gql`
    query GetSignalDefinitionsByBrandIdForFilterBySignals($brandId: String!) {
  signalDefinitionsByBrandId(brandId: $brandId) {
    ...SignalDefinitionFragmentFilterBySignals
  }
}
    ${SignalDefinitionFragmentFilterBySignalsFragmentDoc}`;

/**
 * __useGetSignalDefinitionsByBrandIdForFilterBySignalsQuery__
 *
 * To run a query within a React component, call `useGetSignalDefinitionsByBrandIdForFilterBySignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalDefinitionsByBrandIdForFilterBySignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalDefinitionsByBrandIdForFilterBySignalsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetSignalDefinitionsByBrandIdForFilterBySignalsQuery(baseOptions: Apollo.QueryHookOptions<GetSignalDefinitionsByBrandIdForFilterBySignalsQuery, GetSignalDefinitionsByBrandIdForFilterBySignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignalDefinitionsByBrandIdForFilterBySignalsQuery, GetSignalDefinitionsByBrandIdForFilterBySignalsQueryVariables>(GetSignalDefinitionsByBrandIdForFilterBySignalsDocument, options);
      }
export function useGetSignalDefinitionsByBrandIdForFilterBySignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignalDefinitionsByBrandIdForFilterBySignalsQuery, GetSignalDefinitionsByBrandIdForFilterBySignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignalDefinitionsByBrandIdForFilterBySignalsQuery, GetSignalDefinitionsByBrandIdForFilterBySignalsQueryVariables>(GetSignalDefinitionsByBrandIdForFilterBySignalsDocument, options);
        }
export type GetSignalDefinitionsByBrandIdForFilterBySignalsQueryHookResult = ReturnType<typeof useGetSignalDefinitionsByBrandIdForFilterBySignalsQuery>;
export type GetSignalDefinitionsByBrandIdForFilterBySignalsLazyQueryHookResult = ReturnType<typeof useGetSignalDefinitionsByBrandIdForFilterBySignalsLazyQuery>;
export type GetSignalDefinitionsByBrandIdForFilterBySignalsQueryResult = Apollo.QueryResult<GetSignalDefinitionsByBrandIdForFilterBySignalsQuery, GetSignalDefinitionsByBrandIdForFilterBySignalsQueryVariables>;
export const GetSearchTermsForSocialMediaListeningKeywordsDocument = gql`
    query GetSearchTermsForSocialMediaListeningKeywords($data: GetSearchTermsArgs!) {
  getSearchTerms(data: $data) {
    pageInfo {
      endCursor
      hasNextPage
    }
    data {
      id
      term
    }
  }
}
    `;

/**
 * __useGetSearchTermsForSocialMediaListeningKeywordsQuery__
 *
 * To run a query within a React component, call `useGetSearchTermsForSocialMediaListeningKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchTermsForSocialMediaListeningKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchTermsForSocialMediaListeningKeywordsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSearchTermsForSocialMediaListeningKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchTermsForSocialMediaListeningKeywordsQuery, GetSearchTermsForSocialMediaListeningKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchTermsForSocialMediaListeningKeywordsQuery, GetSearchTermsForSocialMediaListeningKeywordsQueryVariables>(GetSearchTermsForSocialMediaListeningKeywordsDocument, options);
      }
export function useGetSearchTermsForSocialMediaListeningKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchTermsForSocialMediaListeningKeywordsQuery, GetSearchTermsForSocialMediaListeningKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchTermsForSocialMediaListeningKeywordsQuery, GetSearchTermsForSocialMediaListeningKeywordsQueryVariables>(GetSearchTermsForSocialMediaListeningKeywordsDocument, options);
        }
export type GetSearchTermsForSocialMediaListeningKeywordsQueryHookResult = ReturnType<typeof useGetSearchTermsForSocialMediaListeningKeywordsQuery>;
export type GetSearchTermsForSocialMediaListeningKeywordsLazyQueryHookResult = ReturnType<typeof useGetSearchTermsForSocialMediaListeningKeywordsLazyQuery>;
export type GetSearchTermsForSocialMediaListeningKeywordsQueryResult = Apollo.QueryResult<GetSearchTermsForSocialMediaListeningKeywordsQuery, GetSearchTermsForSocialMediaListeningKeywordsQueryVariables>;
export const GetSocialPostForSocialPostContextMenuDocument = gql`
    query GetSocialPostForSocialPostContextMenu($socialPostId: String!) {
  socialPost(id: $socialPostId) {
    ...SocialPostFragmentSocialMediaListeningPostContextMenu
  }
}
    ${SocialPostFragmentSocialMediaListeningPostContextMenuFragmentDoc}`;

/**
 * __useGetSocialPostForSocialPostContextMenuQuery__
 *
 * To run a query within a React component, call `useGetSocialPostForSocialPostContextMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostForSocialPostContextMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostForSocialPostContextMenuQuery({
 *   variables: {
 *      socialPostId: // value for 'socialPostId'
 *   },
 * });
 */
export function useGetSocialPostForSocialPostContextMenuQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostForSocialPostContextMenuQuery, GetSocialPostForSocialPostContextMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostForSocialPostContextMenuQuery, GetSocialPostForSocialPostContextMenuQueryVariables>(GetSocialPostForSocialPostContextMenuDocument, options);
      }
export function useGetSocialPostForSocialPostContextMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostForSocialPostContextMenuQuery, GetSocialPostForSocialPostContextMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostForSocialPostContextMenuQuery, GetSocialPostForSocialPostContextMenuQueryVariables>(GetSocialPostForSocialPostContextMenuDocument, options);
        }
export type GetSocialPostForSocialPostContextMenuQueryHookResult = ReturnType<typeof useGetSocialPostForSocialPostContextMenuQuery>;
export type GetSocialPostForSocialPostContextMenuLazyQueryHookResult = ReturnType<typeof useGetSocialPostForSocialPostContextMenuLazyQuery>;
export type GetSocialPostForSocialPostContextMenuQueryResult = Apollo.QueryResult<GetSocialPostForSocialPostContextMenuQuery, GetSocialPostForSocialPostContextMenuQueryVariables>;
export const GetBrandsDataForWeeklySnapShotSummaryDocument = gql`
    query GetBrandsDataForWeeklySnapShotSummary($brandId: String!, $data: BrandHoursParsedInput) {
  brand(id: $brandId) {
    id
    brandMentionedStats {
      count
      percentageChange
      previousCount
    }
    outboundCommentsStats {
      count
      previousCount
      percentageChange
    }
    totalHoursParsedCount(data: $data)
  }
}
    `;

/**
 * __useGetBrandsDataForWeeklySnapShotSummaryQuery__
 *
 * To run a query within a React component, call `useGetBrandsDataForWeeklySnapShotSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsDataForWeeklySnapShotSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsDataForWeeklySnapShotSummaryQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandsDataForWeeklySnapShotSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandsDataForWeeklySnapShotSummaryQuery, GetBrandsDataForWeeklySnapShotSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsDataForWeeklySnapShotSummaryQuery, GetBrandsDataForWeeklySnapShotSummaryQueryVariables>(GetBrandsDataForWeeklySnapShotSummaryDocument, options);
      }
export function useGetBrandsDataForWeeklySnapShotSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsDataForWeeklySnapShotSummaryQuery, GetBrandsDataForWeeklySnapShotSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsDataForWeeklySnapShotSummaryQuery, GetBrandsDataForWeeklySnapShotSummaryQueryVariables>(GetBrandsDataForWeeklySnapShotSummaryDocument, options);
        }
export type GetBrandsDataForWeeklySnapShotSummaryQueryHookResult = ReturnType<typeof useGetBrandsDataForWeeklySnapShotSummaryQuery>;
export type GetBrandsDataForWeeklySnapShotSummaryLazyQueryHookResult = ReturnType<typeof useGetBrandsDataForWeeklySnapShotSummaryLazyQuery>;
export type GetBrandsDataForWeeklySnapShotSummaryQueryResult = Apollo.QueryResult<GetBrandsDataForWeeklySnapShotSummaryQuery, GetBrandsDataForWeeklySnapShotSummaryQueryVariables>;
export const GetBrandForUseSocialListeningOnboardingDocument = gql`
    query GetBrandForUseSocialListeningOnboarding($brandId: String!) {
  brand(id: $brandId) {
    ...BrandFragmentUseSocialListeningOnboardingBrand
  }
}
    ${BrandFragmentUseSocialListeningOnboardingBrandFragmentDoc}`;

/**
 * __useGetBrandForUseSocialListeningOnboardingQuery__
 *
 * To run a query within a React component, call `useGetBrandForUseSocialListeningOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForUseSocialListeningOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForUseSocialListeningOnboardingQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForUseSocialListeningOnboardingQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForUseSocialListeningOnboardingQuery, GetBrandForUseSocialListeningOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForUseSocialListeningOnboardingQuery, GetBrandForUseSocialListeningOnboardingQueryVariables>(GetBrandForUseSocialListeningOnboardingDocument, options);
      }
export function useGetBrandForUseSocialListeningOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForUseSocialListeningOnboardingQuery, GetBrandForUseSocialListeningOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForUseSocialListeningOnboardingQuery, GetBrandForUseSocialListeningOnboardingQueryVariables>(GetBrandForUseSocialListeningOnboardingDocument, options);
        }
export type GetBrandForUseSocialListeningOnboardingQueryHookResult = ReturnType<typeof useGetBrandForUseSocialListeningOnboardingQuery>;
export type GetBrandForUseSocialListeningOnboardingLazyQueryHookResult = ReturnType<typeof useGetBrandForUseSocialListeningOnboardingLazyQuery>;
export type GetBrandForUseSocialListeningOnboardingQueryResult = Apollo.QueryResult<GetBrandForUseSocialListeningOnboardingQuery, GetBrandForUseSocialListeningOnboardingQueryVariables>;
export const CreateBrandForUseSocialListeningOnboardingDocument = gql`
    mutation CreateBrandForUseSocialListeningOnboarding($data: CreateBrandInput!) {
  createBrand(data: $data) {
    id
  }
}
    `;
export type CreateBrandForUseSocialListeningOnboardingMutationFn = Apollo.MutationFunction<CreateBrandForUseSocialListeningOnboardingMutation, CreateBrandForUseSocialListeningOnboardingMutationVariables>;

/**
 * __useCreateBrandForUseSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateBrandForUseSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandForUseSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandForUseSocialListeningOnboardingMutation, { data, loading, error }] = useCreateBrandForUseSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBrandForUseSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrandForUseSocialListeningOnboardingMutation, CreateBrandForUseSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrandForUseSocialListeningOnboardingMutation, CreateBrandForUseSocialListeningOnboardingMutationVariables>(CreateBrandForUseSocialListeningOnboardingDocument, options);
      }
export type CreateBrandForUseSocialListeningOnboardingMutationHookResult = ReturnType<typeof useCreateBrandForUseSocialListeningOnboardingMutation>;
export type CreateBrandForUseSocialListeningOnboardingMutationResult = Apollo.MutationResult<CreateBrandForUseSocialListeningOnboardingMutation>;
export type CreateBrandForUseSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<CreateBrandForUseSocialListeningOnboardingMutation, CreateBrandForUseSocialListeningOnboardingMutationVariables>;
export const UpdateBrandForUseSocialListeningOnboardingDocument = gql`
    mutation UpdateBrandForUseSocialListeningOnboarding($data: UpdateBrandInput!) {
  updateBrand(data: $data) {
    id
  }
}
    `;
export type UpdateBrandForUseSocialListeningOnboardingMutationFn = Apollo.MutationFunction<UpdateBrandForUseSocialListeningOnboardingMutation, UpdateBrandForUseSocialListeningOnboardingMutationVariables>;

/**
 * __useUpdateBrandForUseSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateBrandForUseSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandForUseSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandForUseSocialListeningOnboardingMutation, { data, loading, error }] = useUpdateBrandForUseSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandForUseSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandForUseSocialListeningOnboardingMutation, UpdateBrandForUseSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandForUseSocialListeningOnboardingMutation, UpdateBrandForUseSocialListeningOnboardingMutationVariables>(UpdateBrandForUseSocialListeningOnboardingDocument, options);
      }
export type UpdateBrandForUseSocialListeningOnboardingMutationHookResult = ReturnType<typeof useUpdateBrandForUseSocialListeningOnboardingMutation>;
export type UpdateBrandForUseSocialListeningOnboardingMutationResult = Apollo.MutationResult<UpdateBrandForUseSocialListeningOnboardingMutation>;
export type UpdateBrandForUseSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateBrandForUseSocialListeningOnboardingMutation, UpdateBrandForUseSocialListeningOnboardingMutationVariables>;
export const GetAiGeneratedBrandDescriptionDocument = gql`
    query GetAIGeneratedBrandDescription($brandName: String!) {
  aiGeneratedBrandDescription(brandName: $brandName)
}
    `;

/**
 * __useGetAiGeneratedBrandDescriptionQuery__
 *
 * To run a query within a React component, call `useGetAiGeneratedBrandDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiGeneratedBrandDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiGeneratedBrandDescriptionQuery({
 *   variables: {
 *      brandName: // value for 'brandName'
 *   },
 * });
 */
export function useGetAiGeneratedBrandDescriptionQuery(baseOptions: Apollo.QueryHookOptions<GetAiGeneratedBrandDescriptionQuery, GetAiGeneratedBrandDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiGeneratedBrandDescriptionQuery, GetAiGeneratedBrandDescriptionQueryVariables>(GetAiGeneratedBrandDescriptionDocument, options);
      }
export function useGetAiGeneratedBrandDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiGeneratedBrandDescriptionQuery, GetAiGeneratedBrandDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiGeneratedBrandDescriptionQuery, GetAiGeneratedBrandDescriptionQueryVariables>(GetAiGeneratedBrandDescriptionDocument, options);
        }
export type GetAiGeneratedBrandDescriptionQueryHookResult = ReturnType<typeof useGetAiGeneratedBrandDescriptionQuery>;
export type GetAiGeneratedBrandDescriptionLazyQueryHookResult = ReturnType<typeof useGetAiGeneratedBrandDescriptionLazyQuery>;
export type GetAiGeneratedBrandDescriptionQueryResult = Apollo.QueryResult<GetAiGeneratedBrandDescriptionQuery, GetAiGeneratedBrandDescriptionQueryVariables>;
export const CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingDocument = gql`
    mutation CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboarding($data: CreateSearchTermInput!) {
  createSearchTerms(data: $data) {
    id
    ...SearchTermFragmentForUseBrandSearchTermsForSocialListeningOnboarding
  }
}
    ${SearchTermFragmentForUseBrandSearchTermsForSocialListeningOnboardingFragmentDoc}`;
export type CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation, CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationVariables>;

/**
 * __useCreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation, { data, loading, error }] = useCreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation, CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation, CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationVariables>(CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingDocument, options);
      }
export type CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useCreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation>;
export type CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationResult = Apollo.MutationResult<CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation>;
export type CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutation, CreateSearchTermForUseBrandSearchTermsForSocialListeningOnboardingMutationVariables>;
export const GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingDocument = gql`
    query GetSocialCreatorForUseCreatorDataForSocialListeningOnboarding($filters: SocialCreatorFilters!) {
  getSocialCreator(filters: $filters) {
    ...CreatorFragmentForUseCreatorDataForSocialListeningOnboarding
  }
}
    ${CreatorFragmentForUseCreatorDataForSocialListeningOnboardingFragmentDoc}`;

/**
 * __useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery__
 *
 * To run a query within a React component, call `useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery(baseOptions: Apollo.QueryHookOptions<GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery, GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery, GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryVariables>(GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingDocument, options);
      }
export function useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery, GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery, GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryVariables>(GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingDocument, options);
        }
export type GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryHookResult = ReturnType<typeof useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery>;
export type GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingLazyQueryHookResult = ReturnType<typeof useGetSocialCreatorForUseCreatorDataForSocialListeningOnboardingLazyQuery>;
export type GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryResult = Apollo.QueryResult<GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQuery, GetSocialCreatorForUseCreatorDataForSocialListeningOnboardingQueryVariables>;
export const CreateCreatorForUseSocialListeningOnboardingBrandDocument = gql`
    mutation CreateCreatorForUseSocialListeningOnboardingBrand($data: CreateCreatorInput!) {
  createCreator(data: $data) {
    ...CreatorFragmentForUseCreatorDataForSocialListeningOnboarding
  }
}
    ${CreatorFragmentForUseCreatorDataForSocialListeningOnboardingFragmentDoc}`;
export type CreateCreatorForUseSocialListeningOnboardingBrandMutationFn = Apollo.MutationFunction<CreateCreatorForUseSocialListeningOnboardingBrandMutation, CreateCreatorForUseSocialListeningOnboardingBrandMutationVariables>;

/**
 * __useCreateCreatorForUseSocialListeningOnboardingBrandMutation__
 *
 * To run a mutation, you first call `useCreateCreatorForUseSocialListeningOnboardingBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreatorForUseSocialListeningOnboardingBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreatorForUseSocialListeningOnboardingBrandMutation, { data, loading, error }] = useCreateCreatorForUseSocialListeningOnboardingBrandMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCreatorForUseSocialListeningOnboardingBrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreatorForUseSocialListeningOnboardingBrandMutation, CreateCreatorForUseSocialListeningOnboardingBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreatorForUseSocialListeningOnboardingBrandMutation, CreateCreatorForUseSocialListeningOnboardingBrandMutationVariables>(CreateCreatorForUseSocialListeningOnboardingBrandDocument, options);
      }
export type CreateCreatorForUseSocialListeningOnboardingBrandMutationHookResult = ReturnType<typeof useCreateCreatorForUseSocialListeningOnboardingBrandMutation>;
export type CreateCreatorForUseSocialListeningOnboardingBrandMutationResult = Apollo.MutationResult<CreateCreatorForUseSocialListeningOnboardingBrandMutation>;
export type CreateCreatorForUseSocialListeningOnboardingBrandMutationOptions = Apollo.BaseMutationOptions<CreateCreatorForUseSocialListeningOnboardingBrandMutation, CreateCreatorForUseSocialListeningOnboardingBrandMutationVariables>;
export const RemoveCreatorForUseSocialListeningOnboardingBrandDocument = gql`
    mutation RemoveCreatorForUseSocialListeningOnboardingBrand($data: RemoveCreatorInput!) {
  removeCreator(data: $data) {
    success
    message
  }
}
    `;
export type RemoveCreatorForUseSocialListeningOnboardingBrandMutationFn = Apollo.MutationFunction<RemoveCreatorForUseSocialListeningOnboardingBrandMutation, RemoveCreatorForUseSocialListeningOnboardingBrandMutationVariables>;

/**
 * __useRemoveCreatorForUseSocialListeningOnboardingBrandMutation__
 *
 * To run a mutation, you first call `useRemoveCreatorForUseSocialListeningOnboardingBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreatorForUseSocialListeningOnboardingBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreatorForUseSocialListeningOnboardingBrandMutation, { data, loading, error }] = useRemoveCreatorForUseSocialListeningOnboardingBrandMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCreatorForUseSocialListeningOnboardingBrandMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCreatorForUseSocialListeningOnboardingBrandMutation, RemoveCreatorForUseSocialListeningOnboardingBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCreatorForUseSocialListeningOnboardingBrandMutation, RemoveCreatorForUseSocialListeningOnboardingBrandMutationVariables>(RemoveCreatorForUseSocialListeningOnboardingBrandDocument, options);
      }
export type RemoveCreatorForUseSocialListeningOnboardingBrandMutationHookResult = ReturnType<typeof useRemoveCreatorForUseSocialListeningOnboardingBrandMutation>;
export type RemoveCreatorForUseSocialListeningOnboardingBrandMutationResult = Apollo.MutationResult<RemoveCreatorForUseSocialListeningOnboardingBrandMutation>;
export type RemoveCreatorForUseSocialListeningOnboardingBrandMutationOptions = Apollo.BaseMutationOptions<RemoveCreatorForUseSocialListeningOnboardingBrandMutation, RemoveCreatorForUseSocialListeningOnboardingBrandMutationVariables>;
export const GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingDocument = gql`
    query GetAIGeneratedTopicPromptForUseTopicDataForSocialListeningOnboarding($topicId: String!) {
  aiGeneratedTopicPrompt(topicId: $topicId) {
    engagementPlan
    priorityContent
    relevantContent
  }
}
    `;

/**
 * __useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery__
 *
 * To run a query within a React component, call `useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery(baseOptions: Apollo.QueryHookOptions<GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery, GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery, GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryVariables>(GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export function useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery, GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery, GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryVariables>(GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingDocument, options);
        }
export type GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryHookResult = ReturnType<typeof useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery>;
export type GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingLazyQueryHookResult = ReturnType<typeof useGetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingLazyQuery>;
export type GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryResult = Apollo.QueryResult<GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQuery, GetAiGeneratedTopicPromptForUseTopicDataForSocialListeningOnboardingQueryVariables>;
export const CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboarding($data: CreateBrandMentionTopicInput!) {
  createBrandMentionTopic(data: $data) {
    id
    ...TopicFragmentForUseTopicDataForSocialListeningOnboarding
  }
}
    ${TopicFragmentForUseTopicDataForSocialListeningOnboardingFragmentDoc}`;
export type CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useCreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useCreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useCreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboarding($data: UpdateBrandMentionTopicInput!) {
  updateBrandMentionTopic(data: $data) {
    id
    ...TopicFragmentForUseTopicDataForSocialListeningOnboarding
  }
}
    ${TopicFragmentForUseTopicDataForSocialListeningOnboardingFragmentDoc}`;
export type UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useUpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useUpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useUpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateBrandMentionedTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation CreateEngagementTopicForUseTopicDataForSocialListeningOnboarding($data: CreateEngagementTopicInput!) {
  createEngagementTopic(data: $data) {
    id
    ...TopicFragmentForUseTopicDataForSocialListeningOnboarding
  }
}
    ${TopicFragmentForUseTopicDataForSocialListeningOnboardingFragmentDoc}`;
export type CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useCreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useCreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useCreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation UpdateEngagementTopicForUseTopicDataForSocialListeningOnboarding($data: UpdateEngagementTopicInput!) {
  updateEngagementTopic(data: $data) {
    id
    ...TopicFragmentForUseTopicDataForSocialListeningOnboarding
  }
}
    ${TopicFragmentForUseTopicDataForSocialListeningOnboardingFragmentDoc}`;
export type UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useUpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useUpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useUpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateEngagementTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboarding($data: CreateCreatorTrackingTopicInput!) {
  createCreatorTrackingTopic(data: $data) {
    id
  }
}
    `;
export type CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useCreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useCreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useCreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, CreateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboarding($data: UpdateCreatorTrackingTopicInput!) {
  updateCreatorTrackingTopic(data: $data) {
    id
  }
}
    `;
export type UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useUpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useUpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useUpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutation, UpdateCreatorTrackingTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const DeleteTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation DeleteTopicForUseTopicDataForSocialListeningOnboarding($topicId: String!) {
  deleteTopic(topicId: $topicId) {
    message
    success
  }
}
    `;
export type DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<DeleteTopicForUseTopicDataForSocialListeningOnboardingMutation, DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useDeleteTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useDeleteTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useDeleteTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useDeleteTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTopicForUseTopicDataForSocialListeningOnboardingMutation, DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTopicForUseTopicDataForSocialListeningOnboardingMutation, DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(DeleteTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useDeleteTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<DeleteTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<DeleteTopicForUseTopicDataForSocialListeningOnboardingMutation, DeleteTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const PauseTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation PauseTopicForUseTopicDataForSocialListeningOnboarding($data: PauseTopicInput!) {
  pauseTopic(data: $data) {
    id
    status
    resetOnNextCycle
  }
}
    `;
export type PauseTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<PauseTopicForUseTopicDataForSocialListeningOnboardingMutation, PauseTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __usePauseTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `usePauseTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = usePauseTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePauseTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<PauseTopicForUseTopicDataForSocialListeningOnboardingMutation, PauseTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseTopicForUseTopicDataForSocialListeningOnboardingMutation, PauseTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(PauseTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type PauseTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof usePauseTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type PauseTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<PauseTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type PauseTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<PauseTopicForUseTopicDataForSocialListeningOnboardingMutation, PauseTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const ResumeTopicForUseTopicDataForSocialListeningOnboardingDocument = gql`
    mutation ResumeTopicForUseTopicDataForSocialListeningOnboarding($data: ResumeTopicInput!) {
  resumeTopic(data: $data) {
    id
    status
    resetOnNextCycle
  }
}
    `;
export type ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationFn = Apollo.MutationFunction<ResumeTopicForUseTopicDataForSocialListeningOnboardingMutation, ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;

/**
 * __useResumeTopicForUseTopicDataForSocialListeningOnboardingMutation__
 *
 * To run a mutation, you first call `useResumeTopicForUseTopicDataForSocialListeningOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeTopicForUseTopicDataForSocialListeningOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeTopicForUseTopicDataForSocialListeningOnboardingMutation, { data, loading, error }] = useResumeTopicForUseTopicDataForSocialListeningOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResumeTopicForUseTopicDataForSocialListeningOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<ResumeTopicForUseTopicDataForSocialListeningOnboardingMutation, ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeTopicForUseTopicDataForSocialListeningOnboardingMutation, ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>(ResumeTopicForUseTopicDataForSocialListeningOnboardingDocument, options);
      }
export type ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationHookResult = ReturnType<typeof useResumeTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationResult = Apollo.MutationResult<ResumeTopicForUseTopicDataForSocialListeningOnboardingMutation>;
export type ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationOptions = Apollo.BaseMutationOptions<ResumeTopicForUseTopicDataForSocialListeningOnboardingMutation, ResumeTopicForUseTopicDataForSocialListeningOnboardingMutationVariables>;
export const GetBrandsDocument = gql`
    query GetBrands {
  brands {
    id
    ...BrandFragmentUseBrandDetails
  }
}
    ${BrandFragmentUseBrandDetailsFragmentDoc}`;

/**
 * __useGetBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
      }
export function useGetBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export type GetBrandsQueryHookResult = ReturnType<typeof useGetBrandsQuery>;
export type GetBrandsLazyQueryHookResult = ReturnType<typeof useGetBrandsLazyQuery>;
export type GetBrandsQueryResult = Apollo.QueryResult<GetBrandsQuery, GetBrandsQueryVariables>;
export const CreatePostForSocialListeningPostDocument = gql`
    mutation CreatePostForSocialListeningPost($data: CreatePostForSocialListeningPostInput!) {
  createPostForSocialListeningPost(data: $data) {
    id
  }
}
    `;
export type CreatePostForSocialListeningPostMutationFn = Apollo.MutationFunction<CreatePostForSocialListeningPostMutation, CreatePostForSocialListeningPostMutationVariables>;

/**
 * __useCreatePostForSocialListeningPostMutation__
 *
 * To run a mutation, you first call `useCreatePostForSocialListeningPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostForSocialListeningPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostForSocialListeningPostMutation, { data, loading, error }] = useCreatePostForSocialListeningPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostForSocialListeningPostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostForSocialListeningPostMutation, CreatePostForSocialListeningPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostForSocialListeningPostMutation, CreatePostForSocialListeningPostMutationVariables>(CreatePostForSocialListeningPostDocument, options);
      }
export type CreatePostForSocialListeningPostMutationHookResult = ReturnType<typeof useCreatePostForSocialListeningPostMutation>;
export type CreatePostForSocialListeningPostMutationResult = Apollo.MutationResult<CreatePostForSocialListeningPostMutation>;
export type CreatePostForSocialListeningPostMutationOptions = Apollo.BaseMutationOptions<CreatePostForSocialListeningPostMutation, CreatePostForSocialListeningPostMutationVariables>;
export const AddToContentCalendarForSocialListeningPostDocument = gql`
    mutation AddToContentCalendarForSocialListeningPost($data: AddToContentCalendarForSocialListeningPostInput!) {
  addToContentCalendarForSocialListeningPost(data: $data) {
    id
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export type AddToContentCalendarForSocialListeningPostMutationFn = Apollo.MutationFunction<AddToContentCalendarForSocialListeningPostMutation, AddToContentCalendarForSocialListeningPostMutationVariables>;

/**
 * __useAddToContentCalendarForSocialListeningPostMutation__
 *
 * To run a mutation, you first call `useAddToContentCalendarForSocialListeningPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToContentCalendarForSocialListeningPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToContentCalendarForSocialListeningPostMutation, { data, loading, error }] = useAddToContentCalendarForSocialListeningPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddToContentCalendarForSocialListeningPostMutation(baseOptions?: Apollo.MutationHookOptions<AddToContentCalendarForSocialListeningPostMutation, AddToContentCalendarForSocialListeningPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToContentCalendarForSocialListeningPostMutation, AddToContentCalendarForSocialListeningPostMutationVariables>(AddToContentCalendarForSocialListeningPostDocument, options);
      }
export type AddToContentCalendarForSocialListeningPostMutationHookResult = ReturnType<typeof useAddToContentCalendarForSocialListeningPostMutation>;
export type AddToContentCalendarForSocialListeningPostMutationResult = Apollo.MutationResult<AddToContentCalendarForSocialListeningPostMutation>;
export type AddToContentCalendarForSocialListeningPostMutationOptions = Apollo.BaseMutationOptions<AddToContentCalendarForSocialListeningPostMutation, AddToContentCalendarForSocialListeningPostMutationVariables>;
export const TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingDocument = gql`
    mutation TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTracking($data: TrackCreatorInput!, $trackingInsightsBrandId: String!, $creatorTrackedTopicBrandId: String!) {
  trackCreatorForCreatorTrackingTopic(data: $data) {
    ...CreatorFragmentUseCreatorsTopicTrackingForSocialListening
  }
}
    ${CreatorFragmentUseCreatorsTopicTrackingForSocialListeningFragmentDoc}`;
export type TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationFn = Apollo.MutationFunction<TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>;

/**
 * __useTrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation__
 *
 * To run a mutation, you first call `useTrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, { data, loading, error }] = useTrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      trackingInsightsBrandId: // value for 'trackingInsightsBrandId'
 *      creatorTrackedTopicBrandId: // value for 'creatorTrackedTopicBrandId'
 *   },
 * });
 */
export function useTrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation(baseOptions?: Apollo.MutationHookOptions<TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>(TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingDocument, options);
      }
export type TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationHookResult = ReturnType<typeof useTrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation>;
export type TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationResult = Apollo.MutationResult<TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation>;
export type TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationOptions = Apollo.BaseMutationOptions<TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, TrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>;
export const UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingDocument = gql`
    mutation UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTracking($data: TrackCreatorInput!, $trackingInsightsBrandId: String!, $creatorTrackedTopicBrandId: String!) {
  untrackCreatorForCreatorTrackingTopic(data: $data) {
    ...CreatorFragmentUseCreatorsTopicTrackingForSocialListening
  }
}
    ${CreatorFragmentUseCreatorsTopicTrackingForSocialListeningFragmentDoc}`;
export type UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationFn = Apollo.MutationFunction<UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>;

/**
 * __useUntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation__
 *
 * To run a mutation, you first call `useUntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, { data, loading, error }] = useUntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      trackingInsightsBrandId: // value for 'trackingInsightsBrandId'
 *      creatorTrackedTopicBrandId: // value for 'creatorTrackedTopicBrandId'
 *   },
 * });
 */
export function useUntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation(baseOptions?: Apollo.MutationHookOptions<UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>(UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingDocument, options);
      }
export type UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationHookResult = ReturnType<typeof useUntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation>;
export type UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationResult = Apollo.MutationResult<UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation>;
export type UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationOptions = Apollo.BaseMutationOptions<UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicForUseCreatorTopicTrackingMutationVariables>;
export const UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingDocument = gql`
    mutation UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTracking($data: UntrackCreatorForTopicsInput!, $trackingInsightsBrandId: String!, $creatorTrackedTopicBrandId: String!) {
  untrackCreatorForCreatorTrackingTopics(data: $data) {
    ...CreatorFragmentUseCreatorsTopicTrackingForSocialListening
  }
}
    ${CreatorFragmentUseCreatorsTopicTrackingForSocialListeningFragmentDoc}`;
export type UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationFn = Apollo.MutationFunction<UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationVariables>;

/**
 * __useUntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation__
 *
 * To run a mutation, you first call `useUntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation, { data, loading, error }] = useUntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      trackingInsightsBrandId: // value for 'trackingInsightsBrandId'
 *      creatorTrackedTopicBrandId: // value for 'creatorTrackedTopicBrandId'
 *   },
 * });
 */
export function useUntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation(baseOptions?: Apollo.MutationHookOptions<UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationVariables>(UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingDocument, options);
      }
export type UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationHookResult = ReturnType<typeof useUntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation>;
export type UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationResult = Apollo.MutationResult<UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation>;
export type UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationOptions = Apollo.BaseMutationOptions<UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutation, UntrackCreatorForCreatorTrackingTopicsForUseCreatorTopicTrackingMutationVariables>;
export const GetTrackedCreatorsForTopicDocument = gql`
    query GetTrackedCreatorsForTopic($data: TopicTrackedCreatorsInput!, $trackingInsightsBrandId: String!, $creatorTrackedTopicBrandId: String!) {
  getTrackedCreatorsForTopic(data: $data) {
    ...CreatorFragmentUseCreatorsTopicTrackingForSocialListening
  }
}
    ${CreatorFragmentUseCreatorsTopicTrackingForSocialListeningFragmentDoc}`;

/**
 * __useGetTrackedCreatorsForTopicQuery__
 *
 * To run a query within a React component, call `useGetTrackedCreatorsForTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedCreatorsForTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedCreatorsForTopicQuery({
 *   variables: {
 *      data: // value for 'data'
 *      trackingInsightsBrandId: // value for 'trackingInsightsBrandId'
 *      creatorTrackedTopicBrandId: // value for 'creatorTrackedTopicBrandId'
 *   },
 * });
 */
export function useGetTrackedCreatorsForTopicQuery(baseOptions: Apollo.QueryHookOptions<GetTrackedCreatorsForTopicQuery, GetTrackedCreatorsForTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackedCreatorsForTopicQuery, GetTrackedCreatorsForTopicQueryVariables>(GetTrackedCreatorsForTopicDocument, options);
      }
export function useGetTrackedCreatorsForTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackedCreatorsForTopicQuery, GetTrackedCreatorsForTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackedCreatorsForTopicQuery, GetTrackedCreatorsForTopicQueryVariables>(GetTrackedCreatorsForTopicDocument, options);
        }
export type GetTrackedCreatorsForTopicQueryHookResult = ReturnType<typeof useGetTrackedCreatorsForTopicQuery>;
export type GetTrackedCreatorsForTopicLazyQueryHookResult = ReturnType<typeof useGetTrackedCreatorsForTopicLazyQuery>;
export type GetTrackedCreatorsForTopicQueryResult = Apollo.QueryResult<GetTrackedCreatorsForTopicQuery, GetTrackedCreatorsForTopicQueryVariables>;
export const GetFollowingForUseCreatorsTopicTrackingForSocialListeningDocument = gql`
    query GetFollowingForUseCreatorsTopicTrackingForSocialListening($filters: SocialCreatorFilters!) {
  getFollowing(filters: $filters) {
    id
    nickName
    platform
    platformId
    profilePictureUrl
    updatedAt
    handle
    followingCount
    followerCount
    createdAt
  }
}
    `;

/**
 * __useGetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery__
 *
 * To run a query within a React component, call `useGetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery(baseOptions: Apollo.QueryHookOptions<GetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery, GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery, GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryVariables>(GetFollowingForUseCreatorsTopicTrackingForSocialListeningDocument, options);
      }
export function useGetFollowingForUseCreatorsTopicTrackingForSocialListeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery, GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery, GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryVariables>(GetFollowingForUseCreatorsTopicTrackingForSocialListeningDocument, options);
        }
export type GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryHookResult = ReturnType<typeof useGetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery>;
export type GetFollowingForUseCreatorsTopicTrackingForSocialListeningLazyQueryHookResult = ReturnType<typeof useGetFollowingForUseCreatorsTopicTrackingForSocialListeningLazyQuery>;
export type GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryResult = Apollo.QueryResult<GetFollowingForUseCreatorsTopicTrackingForSocialListeningQuery, GetFollowingForUseCreatorsTopicTrackingForSocialListeningQueryVariables>;
export const SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningDocument = gql`
    query SearchCreatorsForUseCreatorsTopicTrackingForSocialListening($query: String!, $filters: SocialCreatorFilters!) {
  searchCreators(query: $query, filters: $filters) {
    id
    nickName
    platform
    platformId
    profilePictureUrl
    updatedAt
    handle
    followingCount
    followerCount
    createdAt
  }
}
    `;

/**
 * __useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery__
 *
 * To run a query within a React component, call `useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery({
 *   variables: {
 *      query: // value for 'query'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery(baseOptions: Apollo.QueryHookOptions<SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery, SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery, SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryVariables>(SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningDocument, options);
      }
export function useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery, SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery, SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryVariables>(SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningDocument, options);
        }
export type SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryHookResult = ReturnType<typeof useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery>;
export type SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningLazyQueryHookResult = ReturnType<typeof useSearchCreatorsForUseCreatorsTopicTrackingForSocialListeningLazyQuery>;
export type SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryResult = Apollo.QueryResult<SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQuery, SearchCreatorsForUseCreatorsTopicTrackingForSocialListeningQueryVariables>;
export const UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningDocument = gql`
    mutation UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListening($input: UpdateTrackingInsightsForCreatorProfileByCreatorIdInput!, $trackingInsightsBrandId: String!, $creatorTrackedTopicBrandId: String!) {
  updateTrackingInsightsForCreatorProfileByCreatorId(input: $input) {
    ...CreatorFragmentUseCreatorsTopicTrackingForSocialListening
  }
}
    ${CreatorFragmentUseCreatorsTopicTrackingForSocialListeningFragmentDoc}`;
export type UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationFn = Apollo.MutationFunction<UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation, UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationVariables>;

/**
 * __useUpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation, { data, loading, error }] = useUpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation({
 *   variables: {
 *      input: // value for 'input'
 *      trackingInsightsBrandId: // value for 'trackingInsightsBrandId'
 *      creatorTrackedTopicBrandId: // value for 'creatorTrackedTopicBrandId'
 *   },
 * });
 */
export function useUpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation, UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation, UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationVariables>(UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningDocument, options);
      }
export type UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationHookResult = ReturnType<typeof useUpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation>;
export type UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationResult = Apollo.MutationResult<UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation>;
export type UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutation, UpdateCreatorTrackingInsightsForUseCreatorsTopicTrackingForSocialListeningMutationVariables>;
export const GetBrandForUseSlBrandPermissionsDocument = gql`
    query GetBrandForUseSLBrandPermissions($brandId: String!) {
  brand(id: $brandId) {
    id
    myPermissions
  }
}
    `;

/**
 * __useGetBrandForUseSlBrandPermissionsQuery__
 *
 * To run a query within a React component, call `useGetBrandForUseSlBrandPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForUseSlBrandPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForUseSlBrandPermissionsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForUseSlBrandPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForUseSlBrandPermissionsQuery, GetBrandForUseSlBrandPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForUseSlBrandPermissionsQuery, GetBrandForUseSlBrandPermissionsQueryVariables>(GetBrandForUseSlBrandPermissionsDocument, options);
      }
export function useGetBrandForUseSlBrandPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForUseSlBrandPermissionsQuery, GetBrandForUseSlBrandPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForUseSlBrandPermissionsQuery, GetBrandForUseSlBrandPermissionsQueryVariables>(GetBrandForUseSlBrandPermissionsDocument, options);
        }
export type GetBrandForUseSlBrandPermissionsQueryHookResult = ReturnType<typeof useGetBrandForUseSlBrandPermissionsQuery>;
export type GetBrandForUseSlBrandPermissionsLazyQueryHookResult = ReturnType<typeof useGetBrandForUseSlBrandPermissionsLazyQuery>;
export type GetBrandForUseSlBrandPermissionsQueryResult = Apollo.QueryResult<GetBrandForUseSlBrandPermissionsQuery, GetBrandForUseSlBrandPermissionsQueryVariables>;
export const CreateBookmarkForSocialListeningBookmarkHandlersDocument = gql`
    mutation CreateBookmarkForSocialListeningBookmarkHandlers($input: CreateBrandBookmarkInput!) {
  createBrandBookmark(input: $input) {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;
export type CreateBookmarkForSocialListeningBookmarkHandlersMutationFn = Apollo.MutationFunction<CreateBookmarkForSocialListeningBookmarkHandlersMutation, CreateBookmarkForSocialListeningBookmarkHandlersMutationVariables>;

/**
 * __useCreateBookmarkForSocialListeningBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkForSocialListeningBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkForSocialListeningBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkForSocialListeningBookmarkHandlersMutation, { data, loading, error }] = useCreateBookmarkForSocialListeningBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookmarkForSocialListeningBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkForSocialListeningBookmarkHandlersMutation, CreateBookmarkForSocialListeningBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkForSocialListeningBookmarkHandlersMutation, CreateBookmarkForSocialListeningBookmarkHandlersMutationVariables>(CreateBookmarkForSocialListeningBookmarkHandlersDocument, options);
      }
export type CreateBookmarkForSocialListeningBookmarkHandlersMutationHookResult = ReturnType<typeof useCreateBookmarkForSocialListeningBookmarkHandlersMutation>;
export type CreateBookmarkForSocialListeningBookmarkHandlersMutationResult = Apollo.MutationResult<CreateBookmarkForSocialListeningBookmarkHandlersMutation>;
export type CreateBookmarkForSocialListeningBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkForSocialListeningBookmarkHandlersMutation, CreateBookmarkForSocialListeningBookmarkHandlersMutationVariables>;
export const DeleteBookmarkForSocialListeningBookmarkHandlersDocument = gql`
    mutation DeleteBookmarkForSocialListeningBookmarkHandlers($input: DeleteBrandBookmarkInput!) {
  deleteBrandBookmark(input: $input) {
    message
    success
    deleted {
      id
    }
  }
}
    `;
export type DeleteBookmarkForSocialListeningBookmarkHandlersMutationFn = Apollo.MutationFunction<DeleteBookmarkForSocialListeningBookmarkHandlersMutation, DeleteBookmarkForSocialListeningBookmarkHandlersMutationVariables>;

/**
 * __useDeleteBookmarkForSocialListeningBookmarkHandlersMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkForSocialListeningBookmarkHandlersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkForSocialListeningBookmarkHandlersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkForSocialListeningBookmarkHandlersMutation, { data, loading, error }] = useDeleteBookmarkForSocialListeningBookmarkHandlersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBookmarkForSocialListeningBookmarkHandlersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkForSocialListeningBookmarkHandlersMutation, DeleteBookmarkForSocialListeningBookmarkHandlersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkForSocialListeningBookmarkHandlersMutation, DeleteBookmarkForSocialListeningBookmarkHandlersMutationVariables>(DeleteBookmarkForSocialListeningBookmarkHandlersDocument, options);
      }
export type DeleteBookmarkForSocialListeningBookmarkHandlersMutationHookResult = ReturnType<typeof useDeleteBookmarkForSocialListeningBookmarkHandlersMutation>;
export type DeleteBookmarkForSocialListeningBookmarkHandlersMutationResult = Apollo.MutationResult<DeleteBookmarkForSocialListeningBookmarkHandlersMutation>;
export type DeleteBookmarkForSocialListeningBookmarkHandlersMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkForSocialListeningBookmarkHandlersMutation, DeleteBookmarkForSocialListeningBookmarkHandlersMutationVariables>;
export const GetSocialPostsDocument = gql`
    query GetSocialPosts($filters: GetPaginatedSocialPostFilterInput, $after: String, $before: String, $sortBy: SocialListeningPostsSortBy, $sortOrder: SortOrder, $take: Int, $topicIds: [String!], $brandId: String!, $searchType: SocialPostSearchType, $contextualSearch: String) {
  getPaginatedSocialPosts(
    filters: $filters
    after: $after
    before: $before
    sortBy: $sortBy
    sortOrder: $sortOrder
    take: $take
    brandId: $brandId
    searchType: $searchType
    contextualSearch: $contextualSearch
  ) {
    data {
      id
      __typename
      ...SocialPostFragmentSocialMediaListeningListItem
      ...SocialPostFragmentSocialMediaListeningPostCard
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    meta {
      totalCount
    }
  }
}
    ${SocialPostFragmentSocialMediaListeningListItemFragmentDoc}
${SocialPostFragmentSocialMediaListeningPostCardFragmentDoc}`;

/**
 * __useGetSocialPostsQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      take: // value for 'take'
 *      topicIds: // value for 'topicIds'
 *      brandId: // value for 'brandId'
 *      searchType: // value for 'searchType'
 *      contextualSearch: // value for 'contextualSearch'
 *   },
 * });
 */
export function useGetSocialPostsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsQuery, GetSocialPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsQuery, GetSocialPostsQueryVariables>(GetSocialPostsDocument, options);
      }
export function useGetSocialPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsQuery, GetSocialPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsQuery, GetSocialPostsQueryVariables>(GetSocialPostsDocument, options);
        }
export type GetSocialPostsQueryHookResult = ReturnType<typeof useGetSocialPostsQuery>;
export type GetSocialPostsLazyQueryHookResult = ReturnType<typeof useGetSocialPostsLazyQuery>;
export type GetSocialPostsQueryResult = Apollo.QueryResult<GetSocialPostsQuery, GetSocialPostsQueryVariables>;
export const AddBrandExclusionDocument = gql`
    mutation AddBrandExclusion($data: ExcludeBrandInput!) {
  addBrandExclusion(data: $data) {
    message
    success
  }
}
    `;
export type AddBrandExclusionMutationFn = Apollo.MutationFunction<AddBrandExclusionMutation, AddBrandExclusionMutationVariables>;

/**
 * __useAddBrandExclusionMutation__
 *
 * To run a mutation, you first call `useAddBrandExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBrandExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBrandExclusionMutation, { data, loading, error }] = useAddBrandExclusionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddBrandExclusionMutation(baseOptions?: Apollo.MutationHookOptions<AddBrandExclusionMutation, AddBrandExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBrandExclusionMutation, AddBrandExclusionMutationVariables>(AddBrandExclusionDocument, options);
      }
export type AddBrandExclusionMutationHookResult = ReturnType<typeof useAddBrandExclusionMutation>;
export type AddBrandExclusionMutationResult = Apollo.MutationResult<AddBrandExclusionMutation>;
export type AddBrandExclusionMutationOptions = Apollo.BaseMutationOptions<AddBrandExclusionMutation, AddBrandExclusionMutationVariables>;
export const GetBrandForSentimentTrendsByBrandDialogDocument = gql`
    query GetBrandForSentimentTrendsByBrandDialog($brandId: String!, $data: AllSentimentTrendsInput!) {
  brand(id: $brandId) {
    id
    allBrandTrends(data: $data) {
      score
      data {
        name
        sentiment
        brandId
      }
    }
  }
}
    `;

/**
 * __useGetBrandForSentimentTrendsByBrandDialogQuery__
 *
 * To run a query within a React component, call `useGetBrandForSentimentTrendsByBrandDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSentimentTrendsByBrandDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSentimentTrendsByBrandDialogQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetBrandForSentimentTrendsByBrandDialogQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSentimentTrendsByBrandDialogQuery, GetBrandForSentimentTrendsByBrandDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSentimentTrendsByBrandDialogQuery, GetBrandForSentimentTrendsByBrandDialogQueryVariables>(GetBrandForSentimentTrendsByBrandDialogDocument, options);
      }
export function useGetBrandForSentimentTrendsByBrandDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSentimentTrendsByBrandDialogQuery, GetBrandForSentimentTrendsByBrandDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSentimentTrendsByBrandDialogQuery, GetBrandForSentimentTrendsByBrandDialogQueryVariables>(GetBrandForSentimentTrendsByBrandDialogDocument, options);
        }
export type GetBrandForSentimentTrendsByBrandDialogQueryHookResult = ReturnType<typeof useGetBrandForSentimentTrendsByBrandDialogQuery>;
export type GetBrandForSentimentTrendsByBrandDialogLazyQueryHookResult = ReturnType<typeof useGetBrandForSentimentTrendsByBrandDialogLazyQuery>;
export type GetBrandForSentimentTrendsByBrandDialogQueryResult = Apollo.QueryResult<GetBrandForSentimentTrendsByBrandDialogQuery, GetBrandForSentimentTrendsByBrandDialogQueryVariables>;
export const GetBrandDataForSocialListeningAnalyticsCompetitorsDocument = gql`
    query GetBrandDataForSocialListeningAnalyticsCompetitors($id: String!, $competitorsDataInput: BrandCompetitorsInput!) {
  brand(id: $id) {
    id
    ...BrandFragmentSocialMediaListeningAnalyticsCompetitorsView
  }
}
    ${BrandFragmentSocialMediaListeningAnalyticsCompetitorsViewFragmentDoc}`;

/**
 * __useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery__
 *
 * To run a query within a React component, call `useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      competitorsDataInput: // value for 'competitorsDataInput'
 *   },
 * });
 */
export function useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandDataForSocialListeningAnalyticsCompetitorsQuery, GetBrandDataForSocialListeningAnalyticsCompetitorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandDataForSocialListeningAnalyticsCompetitorsQuery, GetBrandDataForSocialListeningAnalyticsCompetitorsQueryVariables>(GetBrandDataForSocialListeningAnalyticsCompetitorsDocument, options);
      }
export function useGetBrandDataForSocialListeningAnalyticsCompetitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandDataForSocialListeningAnalyticsCompetitorsQuery, GetBrandDataForSocialListeningAnalyticsCompetitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandDataForSocialListeningAnalyticsCompetitorsQuery, GetBrandDataForSocialListeningAnalyticsCompetitorsQueryVariables>(GetBrandDataForSocialListeningAnalyticsCompetitorsDocument, options);
        }
export type GetBrandDataForSocialListeningAnalyticsCompetitorsQueryHookResult = ReturnType<typeof useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery>;
export type GetBrandDataForSocialListeningAnalyticsCompetitorsLazyQueryHookResult = ReturnType<typeof useGetBrandDataForSocialListeningAnalyticsCompetitorsLazyQuery>;
export type GetBrandDataForSocialListeningAnalyticsCompetitorsQueryResult = Apollo.QueryResult<GetBrandDataForSocialListeningAnalyticsCompetitorsQuery, GetBrandDataForSocialListeningAnalyticsCompetitorsQueryVariables>;
export const GetAllBrandClaimsTrendsForAllCategoriesDialogDocument = gql`
    query GetAllBrandClaimsTrendsForAllCategoriesDialog($data: AllSentimentTrendsInput!) {
  brands {
    id
    allBrandTrends(data: $data) {
      score
      data {
        __typename
        sentiment
        name
        brandId
      }
    }
  }
}
    `;

/**
 * __useGetAllBrandClaimsTrendsForAllCategoriesDialogQuery__
 *
 * To run a query within a React component, call `useGetAllBrandClaimsTrendsForAllCategoriesDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBrandClaimsTrendsForAllCategoriesDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBrandClaimsTrendsForAllCategoriesDialogQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAllBrandClaimsTrendsForAllCategoriesDialogQuery(baseOptions: Apollo.QueryHookOptions<GetAllBrandClaimsTrendsForAllCategoriesDialogQuery, GetAllBrandClaimsTrendsForAllCategoriesDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBrandClaimsTrendsForAllCategoriesDialogQuery, GetAllBrandClaimsTrendsForAllCategoriesDialogQueryVariables>(GetAllBrandClaimsTrendsForAllCategoriesDialogDocument, options);
      }
export function useGetAllBrandClaimsTrendsForAllCategoriesDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBrandClaimsTrendsForAllCategoriesDialogQuery, GetAllBrandClaimsTrendsForAllCategoriesDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBrandClaimsTrendsForAllCategoriesDialogQuery, GetAllBrandClaimsTrendsForAllCategoriesDialogQueryVariables>(GetAllBrandClaimsTrendsForAllCategoriesDialogDocument, options);
        }
export type GetAllBrandClaimsTrendsForAllCategoriesDialogQueryHookResult = ReturnType<typeof useGetAllBrandClaimsTrendsForAllCategoriesDialogQuery>;
export type GetAllBrandClaimsTrendsForAllCategoriesDialogLazyQueryHookResult = ReturnType<typeof useGetAllBrandClaimsTrendsForAllCategoriesDialogLazyQuery>;
export type GetAllBrandClaimsTrendsForAllCategoriesDialogQueryResult = Apollo.QueryResult<GetAllBrandClaimsTrendsForAllCategoriesDialogQuery, GetAllBrandClaimsTrendsForAllCategoriesDialogQueryVariables>;
export const GetSocialPostsByTrendDocument = gql`
    query GetSocialPostsByTrend($categoryName: String!, $sentiment: Sentiment!, $topicIds: [String!]!, $brandId: String!, $after: String, $timeRange: MetricsTimeRange) {
  getSocialPostsByTrend(
    categoryName: $categoryName
    sentiment: $sentiment
    topicIds: $topicIds
    brandId: $brandId
    timeRange: $timeRange
    after: $after
  ) {
    meta {
      totalCount
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    data {
      id
      ...SocialPostFragmentPostVideoDialog
      ...SocialPostFragmentSocialPostClaimsCard
      brandAnalysis {
        id
        sentimentScore
        sentimentTone
        brandClaims {
          id
          claim
          attribute
          sentimentScore
          brandId
        }
      }
    }
  }
}
    ${SocialPostFragmentPostVideoDialogFragmentDoc}
${SocialPostFragmentSocialPostClaimsCardFragmentDoc}`;

/**
 * __useGetSocialPostsByTrendQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsByTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsByTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsByTrendQuery({
 *   variables: {
 *      categoryName: // value for 'categoryName'
 *      sentiment: // value for 'sentiment'
 *      topicIds: // value for 'topicIds'
 *      brandId: // value for 'brandId'
 *      after: // value for 'after'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useGetSocialPostsByTrendQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsByTrendQuery, GetSocialPostsByTrendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsByTrendQuery, GetSocialPostsByTrendQueryVariables>(GetSocialPostsByTrendDocument, options);
      }
export function useGetSocialPostsByTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsByTrendQuery, GetSocialPostsByTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsByTrendQuery, GetSocialPostsByTrendQueryVariables>(GetSocialPostsByTrendDocument, options);
        }
export type GetSocialPostsByTrendQueryHookResult = ReturnType<typeof useGetSocialPostsByTrendQuery>;
export type GetSocialPostsByTrendLazyQueryHookResult = ReturnType<typeof useGetSocialPostsByTrendLazyQuery>;
export type GetSocialPostsByTrendQueryResult = Apollo.QueryResult<GetSocialPostsByTrendQuery, GetSocialPostsByTrendQueryVariables>;
export const GetBrandDataForSocialListeningAnalyticsDocument = gql`
    query GetBrandDataForSocialListeningAnalytics($brandId: String!, $brandMentionedMetricsData: BrandMentionedMetricsInput!, $sentimentMetricsData: SentimentMetricsInput!, $brandTrendsBySentiment: SentimentMetricsInput!) {
  brand(id: $brandId) {
    id
    __typename
    name
    topics {
      id
      __typename
      name
      type
      topicContentStrategy
    }
    ...BrandFragmentSLABrandContentTypeSelector
    brandMentionsMetrics(data: $brandMentionedMetricsData) {
      ...BrandMentionedMetricsFragmentSocialListeningAnalyticsInbound
    }
    sentimentMetrics(data: $sentimentMetricsData) {
      neutral {
        ...SentimentMetricsFragmentSentimentThemeCard
      }
      negative {
        ...SentimentMetricsFragmentSentimentThemeCard
      }
      positive {
        ...SentimentMetricsFragmentSentimentThemeCard
      }
    }
    brandTrendsBySentiment(data: $brandTrendsBySentiment) {
      positive {
        ...BrandSentimentTrendBySentimentDataFragmentSentimentTrendTableData
      }
      negative {
        ...BrandSentimentTrendBySentimentDataFragmentSentimentTrendTableData
      }
      neutral {
        ...BrandSentimentTrendBySentimentDataFragmentSentimentTrendTableData
      }
    }
  }
}
    ${BrandFragmentSlaBrandContentTypeSelectorFragmentDoc}
${BrandMentionedMetricsFragmentSocialListeningAnalyticsInboundFragmentDoc}
${SentimentMetricsFragmentSentimentThemeCardFragmentDoc}
${BrandSentimentTrendBySentimentDataFragmentSentimentTrendTableDataFragmentDoc}`;

/**
 * __useGetBrandDataForSocialListeningAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetBrandDataForSocialListeningAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandDataForSocialListeningAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandDataForSocialListeningAnalyticsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      brandMentionedMetricsData: // value for 'brandMentionedMetricsData'
 *      sentimentMetricsData: // value for 'sentimentMetricsData'
 *      brandTrendsBySentiment: // value for 'brandTrendsBySentiment'
 *   },
 * });
 */
export function useGetBrandDataForSocialListeningAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandDataForSocialListeningAnalyticsQuery, GetBrandDataForSocialListeningAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandDataForSocialListeningAnalyticsQuery, GetBrandDataForSocialListeningAnalyticsQueryVariables>(GetBrandDataForSocialListeningAnalyticsDocument, options);
      }
export function useGetBrandDataForSocialListeningAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandDataForSocialListeningAnalyticsQuery, GetBrandDataForSocialListeningAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandDataForSocialListeningAnalyticsQuery, GetBrandDataForSocialListeningAnalyticsQueryVariables>(GetBrandDataForSocialListeningAnalyticsDocument, options);
        }
export type GetBrandDataForSocialListeningAnalyticsQueryHookResult = ReturnType<typeof useGetBrandDataForSocialListeningAnalyticsQuery>;
export type GetBrandDataForSocialListeningAnalyticsLazyQueryHookResult = ReturnType<typeof useGetBrandDataForSocialListeningAnalyticsLazyQuery>;
export type GetBrandDataForSocialListeningAnalyticsQueryResult = Apollo.QueryResult<GetBrandDataForSocialListeningAnalyticsQuery, GetBrandDataForSocialListeningAnalyticsQueryVariables>;
export const GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewDocument = gql`
    query GetBrandsDataForSocialMediaListeningAnalyticsOutboundView {
  brands {
    id
    name
    ...BrandFragmentBrandConnectedCreators
    topics {
      id
      name
      ...TopicFragmentSocialMediaListeningFilterByTopicsButton
    }
  }
}
    ${BrandFragmentBrandConnectedCreatorsFragmentDoc}
${TopicFragmentSocialMediaListeningFilterByTopicsButtonFragmentDoc}`;

/**
 * __useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery__
 *
 * To run a query within a React component, call `useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery(baseOptions?: Apollo.QueryHookOptions<GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewDocument, options);
      }
export function useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewDocument, options);
        }
export type GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryHookResult = ReturnType<typeof useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery>;
export type GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewLazyQueryHookResult = ReturnType<typeof useGetBrandsDataForSocialMediaListeningAnalyticsOutboundViewLazyQuery>;
export type GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryResult = Apollo.QueryResult<GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandsDataForSocialMediaListeningAnalyticsOutboundViewQueryVariables>;
export const GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewDocument = gql`
    query GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundView($brandId: String!, $filters: BrandMetricsFilters!) {
  brandOutboundResponseMetrics(filters: $filters, brandId: $brandId) {
    ...BrandMetricsResponseFragmentMetricsChart
  }
}
    ${BrandMetricsResponseFragmentMetricsChartFragmentDoc}`;

/**
 * __useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery__
 *
 * To run a query within a React component, call `useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewDocument, options);
      }
export function useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewDocument, options);
        }
export type GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryHookResult = ReturnType<typeof useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery>;
export type GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQueryHookResult = ReturnType<typeof useGetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQuery>;
export type GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryResult = Apollo.QueryResult<GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundResponseMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>;
export const GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewDocument = gql`
    query GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundView($brandId: String!, $filters: BrandMetricsFilters!) {
  brandOutboundLikeMetrics(filters: $filters, brandId: $brandId) {
    ...BrandMetricsResponseFragmentMetricsChart
  }
}
    ${BrandMetricsResponseFragmentMetricsChartFragmentDoc}`;

/**
 * __useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery__
 *
 * To run a query within a React component, call `useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewDocument, options);
      }
export function useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewDocument, options);
        }
export type GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryHookResult = ReturnType<typeof useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery>;
export type GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQueryHookResult = ReturnType<typeof useGetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQuery>;
export type GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryResult = Apollo.QueryResult<GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundLikeMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>;
export const GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewDocument = gql`
    query GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundView($brandId: String!, $filters: BrandMetricsFilters!) {
  brandOutboundReplyMetrics(filters: $filters, brandId: $brandId) {
    ...BrandMetricsResponseFragmentMetricsChart
  }
}
    ${BrandMetricsResponseFragmentMetricsChartFragmentDoc}`;

/**
 * __useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery__
 *
 * To run a query within a React component, call `useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewDocument, options);
      }
export function useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>(GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewDocument, options);
        }
export type GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryHookResult = ReturnType<typeof useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery>;
export type GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQueryHookResult = ReturnType<typeof useGetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewLazyQuery>;
export type GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryResult = Apollo.QueryResult<GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQuery, GetBrandOutboundReplyMetricsForSocialMediaListeningAnalyticsOutboundViewQueryVariables>;
export const GetSocialPostCommentsForLeaderboardDetailViewDocument = gql`
    query GetSocialPostCommentsForLeaderboardDetailView($brandId: String!, $data: SocialPostCommentsInput!) {
  socialPostComments(data: $data) {
    data {
      ...SocialPostCommentFragmentSocialPostCommentCardView
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${SocialPostCommentFragmentSocialPostCommentCardViewFragmentDoc}`;

/**
 * __useGetSocialPostCommentsForLeaderboardDetailViewQuery__
 *
 * To run a query within a React component, call `useGetSocialPostCommentsForLeaderboardDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostCommentsForLeaderboardDetailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostCommentsForLeaderboardDetailViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostCommentsForLeaderboardDetailViewQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostCommentsForLeaderboardDetailViewQuery, GetSocialPostCommentsForLeaderboardDetailViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostCommentsForLeaderboardDetailViewQuery, GetSocialPostCommentsForLeaderboardDetailViewQueryVariables>(GetSocialPostCommentsForLeaderboardDetailViewDocument, options);
      }
export function useGetSocialPostCommentsForLeaderboardDetailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostCommentsForLeaderboardDetailViewQuery, GetSocialPostCommentsForLeaderboardDetailViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostCommentsForLeaderboardDetailViewQuery, GetSocialPostCommentsForLeaderboardDetailViewQueryVariables>(GetSocialPostCommentsForLeaderboardDetailViewDocument, options);
        }
export type GetSocialPostCommentsForLeaderboardDetailViewQueryHookResult = ReturnType<typeof useGetSocialPostCommentsForLeaderboardDetailViewQuery>;
export type GetSocialPostCommentsForLeaderboardDetailViewLazyQueryHookResult = ReturnType<typeof useGetSocialPostCommentsForLeaderboardDetailViewLazyQuery>;
export type GetSocialPostCommentsForLeaderboardDetailViewQueryResult = Apollo.QueryResult<GetSocialPostCommentsForLeaderboardDetailViewQuery, GetSocialPostCommentsForLeaderboardDetailViewQueryVariables>;
export const GetBrandOutboundLeaderboardForLeaderboardSectionDocument = gql`
    query GetBrandOutboundLeaderboardForLeaderboardSection($brandIds: [String!]!, $filters: BrandOutboundLeaderboardFilters!, $sortBy: SortByInputData, $take: Int, $after: String) {
  brandOutboundLeaderboard(
    brandIds: $brandIds
    filters: $filters
    sortBy: $sortBy
    take: $take
    after: $after
  ) {
    data {
      id
      ...BrandOutboundLeaderboardItemFragmentLeaderboardSection
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${BrandOutboundLeaderboardItemFragmentLeaderboardSectionFragmentDoc}`;

/**
 * __useGetBrandOutboundLeaderboardForLeaderboardSectionQuery__
 *
 * To run a query within a React component, call `useGetBrandOutboundLeaderboardForLeaderboardSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOutboundLeaderboardForLeaderboardSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOutboundLeaderboardForLeaderboardSectionQuery({
 *   variables: {
 *      brandIds: // value for 'brandIds'
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBrandOutboundLeaderboardForLeaderboardSectionQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOutboundLeaderboardForLeaderboardSectionQuery, GetBrandOutboundLeaderboardForLeaderboardSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOutboundLeaderboardForLeaderboardSectionQuery, GetBrandOutboundLeaderboardForLeaderboardSectionQueryVariables>(GetBrandOutboundLeaderboardForLeaderboardSectionDocument, options);
      }
export function useGetBrandOutboundLeaderboardForLeaderboardSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOutboundLeaderboardForLeaderboardSectionQuery, GetBrandOutboundLeaderboardForLeaderboardSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOutboundLeaderboardForLeaderboardSectionQuery, GetBrandOutboundLeaderboardForLeaderboardSectionQueryVariables>(GetBrandOutboundLeaderboardForLeaderboardSectionDocument, options);
        }
export type GetBrandOutboundLeaderboardForLeaderboardSectionQueryHookResult = ReturnType<typeof useGetBrandOutboundLeaderboardForLeaderboardSectionQuery>;
export type GetBrandOutboundLeaderboardForLeaderboardSectionLazyQueryHookResult = ReturnType<typeof useGetBrandOutboundLeaderboardForLeaderboardSectionLazyQuery>;
export type GetBrandOutboundLeaderboardForLeaderboardSectionQueryResult = Apollo.QueryResult<GetBrandOutboundLeaderboardForLeaderboardSectionQuery, GetBrandOutboundLeaderboardForLeaderboardSectionQueryVariables>;
export const GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesDocument = gql`
    query GetSocialPostCommentsForSocialMediaListeningMostEngagedResponses($brandId: String!, $data: SocialPostCommentsInput!) {
  socialPostComments(data: $data) {
    data {
      ...SocialPostCommentFragmentSocialPostCommentCardView
    }
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${SocialPostCommentFragmentSocialPostCommentCardViewFragmentDoc}`;

/**
 * __useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery__
 *
 * To run a query within a React component, call `useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery, GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery, GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryVariables>(GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesDocument, options);
      }
export function useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery, GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery, GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryVariables>(GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesDocument, options);
        }
export type GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryHookResult = ReturnType<typeof useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery>;
export type GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesLazyQueryHookResult = ReturnType<typeof useGetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesLazyQuery>;
export type GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryResult = Apollo.QueryResult<GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQuery, GetSocialPostCommentsForSocialMediaListeningMostEngagedResponsesQueryVariables>;
export const GetBrandTopicsForCreatorsListingDocument = gql`
    query GetBrandTopicsForCreatorsListing($brandId: String!) {
  brand(id: $brandId) {
    id
    topics {
      ...TopicFragmentCreatorPeekingContent
      active
      creatorTrackingTopics {
        id
        creatorId
      }
    }
  }
}
    ${TopicFragmentCreatorPeekingContentFragmentDoc}`;

/**
 * __useGetBrandTopicsForCreatorsListingQuery__
 *
 * To run a query within a React component, call `useGetBrandTopicsForCreatorsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandTopicsForCreatorsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandTopicsForCreatorsListingQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandTopicsForCreatorsListingQuery(baseOptions: Apollo.QueryHookOptions<GetBrandTopicsForCreatorsListingQuery, GetBrandTopicsForCreatorsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandTopicsForCreatorsListingQuery, GetBrandTopicsForCreatorsListingQueryVariables>(GetBrandTopicsForCreatorsListingDocument, options);
      }
export function useGetBrandTopicsForCreatorsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandTopicsForCreatorsListingQuery, GetBrandTopicsForCreatorsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandTopicsForCreatorsListingQuery, GetBrandTopicsForCreatorsListingQueryVariables>(GetBrandTopicsForCreatorsListingDocument, options);
        }
export type GetBrandTopicsForCreatorsListingQueryHookResult = ReturnType<typeof useGetBrandTopicsForCreatorsListingQuery>;
export type GetBrandTopicsForCreatorsListingLazyQueryHookResult = ReturnType<typeof useGetBrandTopicsForCreatorsListingLazyQuery>;
export type GetBrandTopicsForCreatorsListingQueryResult = Apollo.QueryResult<GetBrandTopicsForCreatorsListingQuery, GetBrandTopicsForCreatorsListingQueryVariables>;
export const SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewDocument = gql`
    mutation SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingView($topicId: String!, $daysCount: Int!, $includeTiktok: Boolean, $includeInstagram: Boolean) {
  submitInitialTopicParsing(
    topicId: $topicId
    daysCount: $daysCount
    includeTiktok: $includeTiktok
    includeInstagram: $includeInstagram
  ) {
    message
    success
  }
}
    `;
export type SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationFn = Apollo.MutationFunction<SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationVariables>;

/**
 * __useSubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation__
 *
 * To run a mutation, you first call `useSubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation, { data, loading, error }] = useSubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      daysCount: // value for 'daysCount'
 *      includeTiktok: // value for 'includeTiktok'
 *      includeInstagram: // value for 'includeInstagram'
 *   },
 * });
 */
export function useSubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationVariables>(SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewDocument, options);
      }
export type SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationHookResult = ReturnType<typeof useSubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation>;
export type SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationResult = Apollo.MutationResult<SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation>;
export type SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationOptions = Apollo.BaseMutationOptions<SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningBrandOnboardingViewMutationVariables>;
export const CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewDocument = gql`
    mutation CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingView($data: CreateCompetitorInput!) {
  createCompetitors(data: $data) {
    id
  }
}
    `;
export type CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationFn = Apollo.MutationFunction<CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation, CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationVariables>;

/**
 * __useCreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation__
 *
 * To run a mutation, you first call `useCreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation, { data, loading, error }] = useCreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation, CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation, CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationVariables>(CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewDocument, options);
      }
export type CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationHookResult = ReturnType<typeof useCreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation>;
export type CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationResult = Apollo.MutationResult<CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation>;
export type CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationOptions = Apollo.BaseMutationOptions<CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutation, CreateCompetitorsForSocialMediaListeningCompetitorsOnboardingViewMutationVariables>;
export const SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewDocument = gql`
    mutation SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingView($daysCount: Int!, $topicId: String!) {
  submitCreatorTrackingTopicParsing(daysCount: $daysCount, topicId: $topicId) {
    message
    success
  }
}
    `;
export type SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationFn = Apollo.MutationFunction<SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationVariables>;

/**
 * __useSubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation__
 *
 * To run a mutation, you first call `useSubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation, { data, loading, error }] = useSubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation({
 *   variables: {
 *      daysCount: // value for 'daysCount'
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useSubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationVariables>(SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewDocument, options);
      }
export type SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationHookResult = ReturnType<typeof useSubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation>;
export type SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationResult = Apollo.MutationResult<SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation>;
export type SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationOptions = Apollo.BaseMutationOptions<SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningOnboardingCreatorTrackingViewMutationVariables>;
export const SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewDocument = gql`
    mutation SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingView($topicId: String!, $daysCount: Int!, $includeTiktok: Boolean, $includeInstagram: Boolean) {
  submitInitialTopicParsing(
    topicId: $topicId
    daysCount: $daysCount
    includeTiktok: $includeTiktok
    includeInstagram: $includeInstagram
  ) {
    message
    success
  }
}
    `;
export type SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationFn = Apollo.MutationFunction<SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationVariables>;

/**
 * __useSubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation__
 *
 * To run a mutation, you first call `useSubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation, { data, loading, error }] = useSubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      daysCount: // value for 'daysCount'
 *      includeTiktok: // value for 'includeTiktok'
 *      includeInstagram: // value for 'includeInstagram'
 *   },
 * });
 */
export function useSubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationVariables>(SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewDocument, options);
      }
export type SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationHookResult = ReturnType<typeof useSubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation>;
export type SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationResult = Apollo.MutationResult<SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation>;
export type SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationOptions = Apollo.BaseMutationOptions<SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutation, SubmitInitialTopicParsingForSocialMediaListeningTopicOnboardingViewMutationVariables>;
export const GetBrandForSmlOnboardingBrandParsingSettingsDocument = gql`
    query GetBrandForSMLOnboardingBrandParsingSettings($id: String!) {
  brand(id: $id) {
    id
    topics {
      id
      type
    }
    ...BrandFragmentBrandParsingSettingsView
  }
}
    ${BrandFragmentBrandParsingSettingsViewFragmentDoc}`;

/**
 * __useGetBrandForSmlOnboardingBrandParsingSettingsQuery__
 *
 * To run a query within a React component, call `useGetBrandForSmlOnboardingBrandParsingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSmlOnboardingBrandParsingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSmlOnboardingBrandParsingSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandForSmlOnboardingBrandParsingSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSmlOnboardingBrandParsingSettingsQuery, GetBrandForSmlOnboardingBrandParsingSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSmlOnboardingBrandParsingSettingsQuery, GetBrandForSmlOnboardingBrandParsingSettingsQueryVariables>(GetBrandForSmlOnboardingBrandParsingSettingsDocument, options);
      }
export function useGetBrandForSmlOnboardingBrandParsingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSmlOnboardingBrandParsingSettingsQuery, GetBrandForSmlOnboardingBrandParsingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSmlOnboardingBrandParsingSettingsQuery, GetBrandForSmlOnboardingBrandParsingSettingsQueryVariables>(GetBrandForSmlOnboardingBrandParsingSettingsDocument, options);
        }
export type GetBrandForSmlOnboardingBrandParsingSettingsQueryHookResult = ReturnType<typeof useGetBrandForSmlOnboardingBrandParsingSettingsQuery>;
export type GetBrandForSmlOnboardingBrandParsingSettingsLazyQueryHookResult = ReturnType<typeof useGetBrandForSmlOnboardingBrandParsingSettingsLazyQuery>;
export type GetBrandForSmlOnboardingBrandParsingSettingsQueryResult = Apollo.QueryResult<GetBrandForSmlOnboardingBrandParsingSettingsQuery, GetBrandForSmlOnboardingBrandParsingSettingsQueryVariables>;
export const UpdateTopicForSmlOnboardingBrandParsingSettingsDocument = gql`
    mutation UpdateTopicForSMLOnboardingBrandParsingSettings($data: UpdateTopicInput!) {
  updateTopic(data: $data) {
    id
    ...TopicFragmentTopicParsingSettingsView
  }
}
    ${TopicFragmentTopicParsingSettingsViewFragmentDoc}`;
export type UpdateTopicForSmlOnboardingBrandParsingSettingsMutationFn = Apollo.MutationFunction<UpdateTopicForSmlOnboardingBrandParsingSettingsMutation, UpdateTopicForSmlOnboardingBrandParsingSettingsMutationVariables>;

/**
 * __useUpdateTopicForSmlOnboardingBrandParsingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTopicForSmlOnboardingBrandParsingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicForSmlOnboardingBrandParsingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicForSmlOnboardingBrandParsingSettingsMutation, { data, loading, error }] = useUpdateTopicForSmlOnboardingBrandParsingSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTopicForSmlOnboardingBrandParsingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTopicForSmlOnboardingBrandParsingSettingsMutation, UpdateTopicForSmlOnboardingBrandParsingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTopicForSmlOnboardingBrandParsingSettingsMutation, UpdateTopicForSmlOnboardingBrandParsingSettingsMutationVariables>(UpdateTopicForSmlOnboardingBrandParsingSettingsDocument, options);
      }
export type UpdateTopicForSmlOnboardingBrandParsingSettingsMutationHookResult = ReturnType<typeof useUpdateTopicForSmlOnboardingBrandParsingSettingsMutation>;
export type UpdateTopicForSmlOnboardingBrandParsingSettingsMutationResult = Apollo.MutationResult<UpdateTopicForSmlOnboardingBrandParsingSettingsMutation>;
export type UpdateTopicForSmlOnboardingBrandParsingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTopicForSmlOnboardingBrandParsingSettingsMutation, UpdateTopicForSmlOnboardingBrandParsingSettingsMutationVariables>;
export const TriggerFetchNewCreatorIntoDbForCompetitorDetailDocument = gql`
    mutation TriggerFetchNewCreatorIntoDbForCompetitorDetail($handle: String!, $platform: String!) {
  fetchNewCreatorIntoDb(handle: $handle, platform: $platform) {
    success
  }
}
    `;
export type TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationFn = Apollo.MutationFunction<TriggerFetchNewCreatorIntoDbForCompetitorDetailMutation, TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationVariables>;

/**
 * __useTriggerFetchNewCreatorIntoDbForCompetitorDetailMutation__
 *
 * To run a mutation, you first call `useTriggerFetchNewCreatorIntoDbForCompetitorDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerFetchNewCreatorIntoDbForCompetitorDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerFetchNewCreatorIntoDbForCompetitorDetailMutation, { data, loading, error }] = useTriggerFetchNewCreatorIntoDbForCompetitorDetailMutation({
 *   variables: {
 *      handle: // value for 'handle'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useTriggerFetchNewCreatorIntoDbForCompetitorDetailMutation(baseOptions?: Apollo.MutationHookOptions<TriggerFetchNewCreatorIntoDbForCompetitorDetailMutation, TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerFetchNewCreatorIntoDbForCompetitorDetailMutation, TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationVariables>(TriggerFetchNewCreatorIntoDbForCompetitorDetailDocument, options);
      }
export type TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationHookResult = ReturnType<typeof useTriggerFetchNewCreatorIntoDbForCompetitorDetailMutation>;
export type TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationResult = Apollo.MutationResult<TriggerFetchNewCreatorIntoDbForCompetitorDetailMutation>;
export type TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationOptions = Apollo.BaseMutationOptions<TriggerFetchNewCreatorIntoDbForCompetitorDetailMutation, TriggerFetchNewCreatorIntoDbForCompetitorDetailMutationVariables>;
export const GetAiGeneratedBrandDescriptionForCompetitorDetailDocument = gql`
    query GetAIGeneratedBrandDescriptionForCompetitorDetail($brandName: String!) {
  aiGeneratedBrandDescription(brandName: $brandName)
}
    `;

/**
 * __useGetAiGeneratedBrandDescriptionForCompetitorDetailQuery__
 *
 * To run a query within a React component, call `useGetAiGeneratedBrandDescriptionForCompetitorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiGeneratedBrandDescriptionForCompetitorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiGeneratedBrandDescriptionForCompetitorDetailQuery({
 *   variables: {
 *      brandName: // value for 'brandName'
 *   },
 * });
 */
export function useGetAiGeneratedBrandDescriptionForCompetitorDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAiGeneratedBrandDescriptionForCompetitorDetailQuery, GetAiGeneratedBrandDescriptionForCompetitorDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiGeneratedBrandDescriptionForCompetitorDetailQuery, GetAiGeneratedBrandDescriptionForCompetitorDetailQueryVariables>(GetAiGeneratedBrandDescriptionForCompetitorDetailDocument, options);
      }
export function useGetAiGeneratedBrandDescriptionForCompetitorDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiGeneratedBrandDescriptionForCompetitorDetailQuery, GetAiGeneratedBrandDescriptionForCompetitorDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiGeneratedBrandDescriptionForCompetitorDetailQuery, GetAiGeneratedBrandDescriptionForCompetitorDetailQueryVariables>(GetAiGeneratedBrandDescriptionForCompetitorDetailDocument, options);
        }
export type GetAiGeneratedBrandDescriptionForCompetitorDetailQueryHookResult = ReturnType<typeof useGetAiGeneratedBrandDescriptionForCompetitorDetailQuery>;
export type GetAiGeneratedBrandDescriptionForCompetitorDetailLazyQueryHookResult = ReturnType<typeof useGetAiGeneratedBrandDescriptionForCompetitorDetailLazyQuery>;
export type GetAiGeneratedBrandDescriptionForCompetitorDetailQueryResult = Apollo.QueryResult<GetAiGeneratedBrandDescriptionForCompetitorDetailQuery, GetAiGeneratedBrandDescriptionForCompetitorDetailQueryVariables>;
export const GetAiGeneratedKeywordsForCompetitorDetailDocument = gql`
    query GetAIGeneratedKeywordsForCompetitorDetail($description: String!) {
  getAIKeywordsForBrandDescription(description: $description)
}
    `;

/**
 * __useGetAiGeneratedKeywordsForCompetitorDetailQuery__
 *
 * To run a query within a React component, call `useGetAiGeneratedKeywordsForCompetitorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiGeneratedKeywordsForCompetitorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiGeneratedKeywordsForCompetitorDetailQuery({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGetAiGeneratedKeywordsForCompetitorDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAiGeneratedKeywordsForCompetitorDetailQuery, GetAiGeneratedKeywordsForCompetitorDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiGeneratedKeywordsForCompetitorDetailQuery, GetAiGeneratedKeywordsForCompetitorDetailQueryVariables>(GetAiGeneratedKeywordsForCompetitorDetailDocument, options);
      }
export function useGetAiGeneratedKeywordsForCompetitorDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiGeneratedKeywordsForCompetitorDetailQuery, GetAiGeneratedKeywordsForCompetitorDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiGeneratedKeywordsForCompetitorDetailQuery, GetAiGeneratedKeywordsForCompetitorDetailQueryVariables>(GetAiGeneratedKeywordsForCompetitorDetailDocument, options);
        }
export type GetAiGeneratedKeywordsForCompetitorDetailQueryHookResult = ReturnType<typeof useGetAiGeneratedKeywordsForCompetitorDetailQuery>;
export type GetAiGeneratedKeywordsForCompetitorDetailLazyQueryHookResult = ReturnType<typeof useGetAiGeneratedKeywordsForCompetitorDetailLazyQuery>;
export type GetAiGeneratedKeywordsForCompetitorDetailQueryResult = Apollo.QueryResult<GetAiGeneratedKeywordsForCompetitorDetailQuery, GetAiGeneratedKeywordsForCompetitorDetailQueryVariables>;
export const GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingDocument = gql`
    query GetSuggestedCreatorsForSocialListeningOnboardingCreatorTracking($brandId: String!, $filters: SocialCreatorFilters!) {
  getSuggestedCreators(brandId: $brandId, filters: $filters) {
    id
    ...CreatorProfileFragmentSocialMediaListeningCreatorProfile
  }
}
    ${CreatorProfileFragmentSocialMediaListeningCreatorProfileFragmentDoc}`;

/**
 * __useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery__
 *
 * To run a query within a React component, call `useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery, GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery, GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryVariables>(GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingDocument, options);
      }
export function useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery, GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery, GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryVariables>(GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingDocument, options);
        }
export type GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryHookResult = ReturnType<typeof useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery>;
export type GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingLazyQueryHookResult = ReturnType<typeof useGetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingLazyQuery>;
export type GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryResult = Apollo.QueryResult<GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQuery, GetSuggestedCreatorsForSocialListeningOnboardingCreatorTrackingQueryVariables>;
export const GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectDocument = gql`
    query GetSentimentSubjectsByTopicForSLOnboardingSentimentSubject($topicId: String!) {
  sentimentSubjectsByTopic(topicId: $topicId) {
    id
    subject
    topicId
  }
}
    `;

/**
 * __useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery__
 *
 * To run a query within a React component, call `useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery(baseOptions: Apollo.QueryHookOptions<GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery, GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery, GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryVariables>(GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectDocument, options);
      }
export function useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery, GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery, GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryVariables>(GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectDocument, options);
        }
export type GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryHookResult = ReturnType<typeof useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery>;
export type GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectLazyQueryHookResult = ReturnType<typeof useGetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectLazyQuery>;
export type GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryResult = Apollo.QueryResult<GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQuery, GetSentimentSubjectsByTopicForSlOnboardingSentimentSubjectQueryVariables>;
export const UpsertSentimentSubjectsDocument = gql`
    mutation UpsertSentimentSubjects($data: UpsertSentimentSubjectInput!) {
  upsertSentimentSubjects(data: $data) {
    id
  }
}
    `;
export type UpsertSentimentSubjectsMutationFn = Apollo.MutationFunction<UpsertSentimentSubjectsMutation, UpsertSentimentSubjectsMutationVariables>;

/**
 * __useUpsertSentimentSubjectsMutation__
 *
 * To run a mutation, you first call `useUpsertSentimentSubjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSentimentSubjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSentimentSubjectsMutation, { data, loading, error }] = useUpsertSentimentSubjectsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertSentimentSubjectsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSentimentSubjectsMutation, UpsertSentimentSubjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSentimentSubjectsMutation, UpsertSentimentSubjectsMutationVariables>(UpsertSentimentSubjectsDocument, options);
      }
export type UpsertSentimentSubjectsMutationHookResult = ReturnType<typeof useUpsertSentimentSubjectsMutation>;
export type UpsertSentimentSubjectsMutationResult = Apollo.MutationResult<UpsertSentimentSubjectsMutation>;
export type UpsertSentimentSubjectsMutationOptions = Apollo.BaseMutationOptions<UpsertSentimentSubjectsMutation, UpsertSentimentSubjectsMutationVariables>;
export const GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsDocument = gql`
    query GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignals($topicId: String!) {
  topicSignalDefinitions(topicId: $topicId) {
    ...SignalDefinitionFragmentTopicSignal
  }
}
    ${SignalDefinitionFragmentTopicSignalFragmentDoc}`;

/**
 * __useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery__
 *
 * To run a query within a React component, call `useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery(baseOptions: Apollo.QueryHookOptions<GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery, GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery, GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryVariables>(GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsDocument, options);
      }
export function useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery, GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery, GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryVariables>(GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsDocument, options);
        }
export type GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryHookResult = ReturnType<typeof useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery>;
export type GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsLazyQueryHookResult = ReturnType<typeof useGetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsLazyQuery>;
export type GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryResult = Apollo.QueryResult<GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQuery, GetTopicSignalDefinitionsForSocialMediaListeningOnboardingSignalsQueryVariables>;
export const CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsDocument = gql`
    mutation CreateSignalDefinitionForSocialMediaListeningOnboardingSignals($data: CreateSignalDefinitionInput!) {
  createSignalDefinition(data: $data) {
    ...SignalDefinitionFragmentTopicSignal
  }
}
    ${SignalDefinitionFragmentTopicSignalFragmentDoc}`;
export type CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationFn = Apollo.MutationFunction<CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation, CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationVariables>;

/**
 * __useCreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation__
 *
 * To run a mutation, you first call `useCreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation, { data, loading, error }] = useCreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation, CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation, CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationVariables>(CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsDocument, options);
      }
export type CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationHookResult = ReturnType<typeof useCreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation>;
export type CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationResult = Apollo.MutationResult<CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation>;
export type CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationOptions = Apollo.BaseMutationOptions<CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutation, CreateSignalDefinitionForSocialMediaListeningOnboardingSignalsMutationVariables>;
export const GetTopicForSmlOnboardingTopicParsingSettingsDocument = gql`
    query GetTopicForSMLOnboardingTopicParsingSettings($id: String!) {
  topic(id: $id) {
    id
    ...TopicFragmentTopicParsingSettingsView
  }
}
    ${TopicFragmentTopicParsingSettingsViewFragmentDoc}`;

/**
 * __useGetTopicForSmlOnboardingTopicParsingSettingsQuery__
 *
 * To run a query within a React component, call `useGetTopicForSmlOnboardingTopicParsingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicForSmlOnboardingTopicParsingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicForSmlOnboardingTopicParsingSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTopicForSmlOnboardingTopicParsingSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetTopicForSmlOnboardingTopicParsingSettingsQuery, GetTopicForSmlOnboardingTopicParsingSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicForSmlOnboardingTopicParsingSettingsQuery, GetTopicForSmlOnboardingTopicParsingSettingsQueryVariables>(GetTopicForSmlOnboardingTopicParsingSettingsDocument, options);
      }
export function useGetTopicForSmlOnboardingTopicParsingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicForSmlOnboardingTopicParsingSettingsQuery, GetTopicForSmlOnboardingTopicParsingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicForSmlOnboardingTopicParsingSettingsQuery, GetTopicForSmlOnboardingTopicParsingSettingsQueryVariables>(GetTopicForSmlOnboardingTopicParsingSettingsDocument, options);
        }
export type GetTopicForSmlOnboardingTopicParsingSettingsQueryHookResult = ReturnType<typeof useGetTopicForSmlOnboardingTopicParsingSettingsQuery>;
export type GetTopicForSmlOnboardingTopicParsingSettingsLazyQueryHookResult = ReturnType<typeof useGetTopicForSmlOnboardingTopicParsingSettingsLazyQuery>;
export type GetTopicForSmlOnboardingTopicParsingSettingsQueryResult = Apollo.QueryResult<GetTopicForSmlOnboardingTopicParsingSettingsQuery, GetTopicForSmlOnboardingTopicParsingSettingsQueryVariables>;
export const CreatePermissionRequestForSocialListeningPermissionRequestDocument = gql`
    mutation CreatePermissionRequestForSocialListeningPermissionRequest($data: CreatePermissionRequestInput!) {
  createPermissionRequest(data: $data) {
    id
  }
}
    `;
export type CreatePermissionRequestForSocialListeningPermissionRequestMutationFn = Apollo.MutationFunction<CreatePermissionRequestForSocialListeningPermissionRequestMutation, CreatePermissionRequestForSocialListeningPermissionRequestMutationVariables>;

/**
 * __useCreatePermissionRequestForSocialListeningPermissionRequestMutation__
 *
 * To run a mutation, you first call `useCreatePermissionRequestForSocialListeningPermissionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionRequestForSocialListeningPermissionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionRequestForSocialListeningPermissionRequestMutation, { data, loading, error }] = useCreatePermissionRequestForSocialListeningPermissionRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePermissionRequestForSocialListeningPermissionRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionRequestForSocialListeningPermissionRequestMutation, CreatePermissionRequestForSocialListeningPermissionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionRequestForSocialListeningPermissionRequestMutation, CreatePermissionRequestForSocialListeningPermissionRequestMutationVariables>(CreatePermissionRequestForSocialListeningPermissionRequestDocument, options);
      }
export type CreatePermissionRequestForSocialListeningPermissionRequestMutationHookResult = ReturnType<typeof useCreatePermissionRequestForSocialListeningPermissionRequestMutation>;
export type CreatePermissionRequestForSocialListeningPermissionRequestMutationResult = Apollo.MutationResult<CreatePermissionRequestForSocialListeningPermissionRequestMutation>;
export type CreatePermissionRequestForSocialListeningPermissionRequestMutationOptions = Apollo.BaseMutationOptions<CreatePermissionRequestForSocialListeningPermissionRequestMutation, CreatePermissionRequestForSocialListeningPermissionRequestMutationVariables>;
export const GetSocialPostForSocialMediaListeningPostDetailDocument = gql`
    query GetSocialPostForSocialMediaListeningPostDetail($socialPostId: String!, $topicIds: [String!], $brandId: String!) {
  socialPost(id: $socialPostId) {
    id
    expiresAt
    totalContentCalendarSaves
    isSavedToContentCalendar
    savedPost {
      id
      isFavorite
      isFavoriteTrend
    }
    type
    carouselMedias {
      id
      type
      url
    }
    totalPostSaves
    sentimentTexts {
      id
      sentiment
      keyword
      category
      subCategory
      brandId
    }
    ...SocialPostFragmentSocialMediaListeningPostSummary
    ...SocialPostFragmentBrandSocialPostEngagementStatus
    socialPostEngagementSuggestionsWithTopic(topicIds: $topicIds, brandId: $brandId) {
      id
      __typename
      sentiment
      score
      suggestedComment
      oneLineSummary
      reason
      topic {
        id
        name
        ...TopicFragmentTopicLabel
      }
    }
    socialPostEngagementSuggestions(brandId: $brandId) {
      id
      __typename
      sentiment
      score
      suggestedComment
      oneLineSummary
      reason
      topic {
        id
        name
        ...TopicFragmentTopicLabel
      }
    }
    ...SocialPostFragmentWhatYouCanSay
  }
}
    ${SocialPostFragmentSocialMediaListeningPostSummaryFragmentDoc}
${SocialPostFragmentBrandSocialPostEngagementStatusFragmentDoc}
${TopicFragmentTopicLabelFragmentDoc}
${SocialPostFragmentWhatYouCanSayFragmentDoc}`;

/**
 * __useGetSocialPostForSocialMediaListeningPostDetailQuery__
 *
 * To run a query within a React component, call `useGetSocialPostForSocialMediaListeningPostDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostForSocialMediaListeningPostDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostForSocialMediaListeningPostDetailQuery({
 *   variables: {
 *      socialPostId: // value for 'socialPostId'
 *      topicIds: // value for 'topicIds'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetSocialPostForSocialMediaListeningPostDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostForSocialMediaListeningPostDetailQuery, GetSocialPostForSocialMediaListeningPostDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostForSocialMediaListeningPostDetailQuery, GetSocialPostForSocialMediaListeningPostDetailQueryVariables>(GetSocialPostForSocialMediaListeningPostDetailDocument, options);
      }
export function useGetSocialPostForSocialMediaListeningPostDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostForSocialMediaListeningPostDetailQuery, GetSocialPostForSocialMediaListeningPostDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostForSocialMediaListeningPostDetailQuery, GetSocialPostForSocialMediaListeningPostDetailQueryVariables>(GetSocialPostForSocialMediaListeningPostDetailDocument, options);
        }
export type GetSocialPostForSocialMediaListeningPostDetailQueryHookResult = ReturnType<typeof useGetSocialPostForSocialMediaListeningPostDetailQuery>;
export type GetSocialPostForSocialMediaListeningPostDetailLazyQueryHookResult = ReturnType<typeof useGetSocialPostForSocialMediaListeningPostDetailLazyQuery>;
export type GetSocialPostForSocialMediaListeningPostDetailQueryResult = Apollo.QueryResult<GetSocialPostForSocialMediaListeningPostDetailQuery, GetSocialPostForSocialMediaListeningPostDetailQueryVariables>;
export const GetExistingSocialPostReportReasonsForSocialListeningReportPostViewDocument = gql`
    query GetExistingSocialPostReportReasonsForSocialListeningReportPostView($brandId: String!) {
  existingSocialPostReportReasons(brandId: $brandId)
}
    `;

/**
 * __useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery__
 *
 * To run a query within a React component, call `useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery(baseOptions: Apollo.QueryHookOptions<GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery, GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery, GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryVariables>(GetExistingSocialPostReportReasonsForSocialListeningReportPostViewDocument, options);
      }
export function useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery, GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery, GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryVariables>(GetExistingSocialPostReportReasonsForSocialListeningReportPostViewDocument, options);
        }
export type GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryHookResult = ReturnType<typeof useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery>;
export type GetExistingSocialPostReportReasonsForSocialListeningReportPostViewLazyQueryHookResult = ReturnType<typeof useGetExistingSocialPostReportReasonsForSocialListeningReportPostViewLazyQuery>;
export type GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryResult = Apollo.QueryResult<GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQuery, GetExistingSocialPostReportReasonsForSocialListeningReportPostViewQueryVariables>;
export const CreateSocialPostReportForSocialListeningReportPostViewDocument = gql`
    mutation CreateSocialPostReportForSocialListeningReportPostView($data: CreateSocialPostReportInput!) {
  createSocialPostReport(data: $data) {
    id
  }
}
    `;
export type CreateSocialPostReportForSocialListeningReportPostViewMutationFn = Apollo.MutationFunction<CreateSocialPostReportForSocialListeningReportPostViewMutation, CreateSocialPostReportForSocialListeningReportPostViewMutationVariables>;

/**
 * __useCreateSocialPostReportForSocialListeningReportPostViewMutation__
 *
 * To run a mutation, you first call `useCreateSocialPostReportForSocialListeningReportPostViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocialPostReportForSocialListeningReportPostViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocialPostReportForSocialListeningReportPostViewMutation, { data, loading, error }] = useCreateSocialPostReportForSocialListeningReportPostViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSocialPostReportForSocialListeningReportPostViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocialPostReportForSocialListeningReportPostViewMutation, CreateSocialPostReportForSocialListeningReportPostViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocialPostReportForSocialListeningReportPostViewMutation, CreateSocialPostReportForSocialListeningReportPostViewMutationVariables>(CreateSocialPostReportForSocialListeningReportPostViewDocument, options);
      }
export type CreateSocialPostReportForSocialListeningReportPostViewMutationHookResult = ReturnType<typeof useCreateSocialPostReportForSocialListeningReportPostViewMutation>;
export type CreateSocialPostReportForSocialListeningReportPostViewMutationResult = Apollo.MutationResult<CreateSocialPostReportForSocialListeningReportPostViewMutation>;
export type CreateSocialPostReportForSocialListeningReportPostViewMutationOptions = Apollo.BaseMutationOptions<CreateSocialPostReportForSocialListeningReportPostViewMutation, CreateSocialPostReportForSocialListeningReportPostViewMutationVariables>;
export const UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusDocument = gql`
    mutation UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatus($data: UpdateBrandSocialPostEngagementInput!) {
  updateBrandSocialPostEngagement(data: $data) {
    id
    status
  }
}
    `;
export type UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationFn = Apollo.MutationFunction<UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation, UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationVariables>;

/**
 * __useUpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation, { data, loading, error }] = useUpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation, UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation, UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationVariables>(UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusDocument, options);
      }
export type UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationHookResult = ReturnType<typeof useUpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation>;
export type UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationResult = Apollo.MutationResult<UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation>;
export type UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutation, UpdateBrandSocialPostEngagementForSocialPostBrandEngagementStatusMutationVariables>;
export const UpdateBrandSocialPostEngagementDocument = gql`
    mutation UpdateBrandSocialPostEngagement($data: UpdateBrandSocialPostEngagementInput!) {
  updateBrandSocialPostEngagement(data: $data) {
    id
  }
}
    `;
export type UpdateBrandSocialPostEngagementMutationFn = Apollo.MutationFunction<UpdateBrandSocialPostEngagementMutation, UpdateBrandSocialPostEngagementMutationVariables>;

/**
 * __useUpdateBrandSocialPostEngagementMutation__
 *
 * To run a mutation, you first call `useUpdateBrandSocialPostEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandSocialPostEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandSocialPostEngagementMutation, { data, loading, error }] = useUpdateBrandSocialPostEngagementMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandSocialPostEngagementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandSocialPostEngagementMutation, UpdateBrandSocialPostEngagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandSocialPostEngagementMutation, UpdateBrandSocialPostEngagementMutationVariables>(UpdateBrandSocialPostEngagementDocument, options);
      }
export type UpdateBrandSocialPostEngagementMutationHookResult = ReturnType<typeof useUpdateBrandSocialPostEngagementMutation>;
export type UpdateBrandSocialPostEngagementMutationResult = Apollo.MutationResult<UpdateBrandSocialPostEngagementMutation>;
export type UpdateBrandSocialPostEngagementMutationOptions = Apollo.BaseMutationOptions<UpdateBrandSocialPostEngagementMutation, UpdateBrandSocialPostEngagementMutationVariables>;
export const UpdateBrandSocialPostEngagementResponderForUseResponderChangeDocument = gql`
    mutation UpdateBrandSocialPostEngagementResponderForUseResponderChange($data: UpdateBrandSocialPostEngagementResponderInput!) {
  updateBrandSocialPostEngagementResponder(data: $data) {
    success
    message
  }
}
    `;
export type UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationFn = Apollo.MutationFunction<UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation, UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationVariables>;

/**
 * __useUpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation__
 *
 * To run a mutation, you first call `useUpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandSocialPostEngagementResponderForUseResponderChangeMutation, { data, loading, error }] = useUpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation, UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation, UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationVariables>(UpdateBrandSocialPostEngagementResponderForUseResponderChangeDocument, options);
      }
export type UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationHookResult = ReturnType<typeof useUpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation>;
export type UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationResult = Apollo.MutationResult<UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation>;
export type UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationOptions = Apollo.BaseMutationOptions<UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutation, UpdateBrandSocialPostEngagementResponderForUseResponderChangeMutationVariables>;
export const UpdateTaskForTaskAssigneeDocument = gql`
    mutation UpdateTaskForTaskAssignee($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    ...TaskFragmentTaskAssignee
  }
}
    ${TaskFragmentTaskAssigneeFragmentDoc}`;
export type UpdateTaskForTaskAssigneeMutationFn = Apollo.MutationFunction<UpdateTaskForTaskAssigneeMutation, UpdateTaskForTaskAssigneeMutationVariables>;

/**
 * __useUpdateTaskForTaskAssigneeMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskAssigneeMutation, { data, loading, error }] = useUpdateTaskForTaskAssigneeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskAssigneeMutation, UpdateTaskForTaskAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskAssigneeMutation, UpdateTaskForTaskAssigneeMutationVariables>(UpdateTaskForTaskAssigneeDocument, options);
      }
export type UpdateTaskForTaskAssigneeMutationHookResult = ReturnType<typeof useUpdateTaskForTaskAssigneeMutation>;
export type UpdateTaskForTaskAssigneeMutationResult = Apollo.MutationResult<UpdateTaskForTaskAssigneeMutation>;
export type UpdateTaskForTaskAssigneeMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskAssigneeMutation, UpdateTaskForTaskAssigneeMutationVariables>;
export const DeleteTaskForTaskContextMenuDocument = gql`
    mutation DeleteTaskForTaskContextMenu($data: DeleteTaskInput!) {
  deleteTask(data: $data) {
    message
    success
  }
}
    `;
export type DeleteTaskForTaskContextMenuMutationFn = Apollo.MutationFunction<DeleteTaskForTaskContextMenuMutation, DeleteTaskForTaskContextMenuMutationVariables>;

/**
 * __useDeleteTaskForTaskContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteTaskForTaskContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskForTaskContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskForTaskContextMenuMutation, { data, loading, error }] = useDeleteTaskForTaskContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteTaskForTaskContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskForTaskContextMenuMutation, DeleteTaskForTaskContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskForTaskContextMenuMutation, DeleteTaskForTaskContextMenuMutationVariables>(DeleteTaskForTaskContextMenuDocument, options);
      }
export type DeleteTaskForTaskContextMenuMutationHookResult = ReturnType<typeof useDeleteTaskForTaskContextMenuMutation>;
export type DeleteTaskForTaskContextMenuMutationResult = Apollo.MutationResult<DeleteTaskForTaskContextMenuMutation>;
export type DeleteTaskForTaskContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteTaskForTaskContextMenuMutation, DeleteTaskForTaskContextMenuMutationVariables>;
export const UpdateTaskForTaskDescriptionDocument = gql`
    mutation UpdateTaskForTaskDescription($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    description
  }
}
    `;
export type UpdateTaskForTaskDescriptionMutationFn = Apollo.MutationFunction<UpdateTaskForTaskDescriptionMutation, UpdateTaskForTaskDescriptionMutationVariables>;

/**
 * __useUpdateTaskForTaskDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskDescriptionMutation, { data, loading, error }] = useUpdateTaskForTaskDescriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskDescriptionMutation, UpdateTaskForTaskDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskDescriptionMutation, UpdateTaskForTaskDescriptionMutationVariables>(UpdateTaskForTaskDescriptionDocument, options);
      }
export type UpdateTaskForTaskDescriptionMutationHookResult = ReturnType<typeof useUpdateTaskForTaskDescriptionMutation>;
export type UpdateTaskForTaskDescriptionMutationResult = Apollo.MutationResult<UpdateTaskForTaskDescriptionMutation>;
export type UpdateTaskForTaskDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskDescriptionMutation, UpdateTaskForTaskDescriptionMutationVariables>;
export const UpdateTaskForTaskDueDateDocument = gql`
    mutation UpdateTaskForTaskDueDate($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    ...TaskFragmentTaskDueDate
  }
}
    ${TaskFragmentTaskDueDateFragmentDoc}`;
export type UpdateTaskForTaskDueDateMutationFn = Apollo.MutationFunction<UpdateTaskForTaskDueDateMutation, UpdateTaskForTaskDueDateMutationVariables>;

/**
 * __useUpdateTaskForTaskDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskDueDateMutation, { data, loading, error }] = useUpdateTaskForTaskDueDateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskDueDateMutation, UpdateTaskForTaskDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskDueDateMutation, UpdateTaskForTaskDueDateMutationVariables>(UpdateTaskForTaskDueDateDocument, options);
      }
export type UpdateTaskForTaskDueDateMutationHookResult = ReturnType<typeof useUpdateTaskForTaskDueDateMutation>;
export type UpdateTaskForTaskDueDateMutationResult = Apollo.MutationResult<UpdateTaskForTaskDueDateMutation>;
export type UpdateTaskForTaskDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskDueDateMutation, UpdateTaskForTaskDueDateMutationVariables>;
export const UpdateTaskForTaskDueDateRangeDocument = gql`
    mutation UpdateTaskForTaskDueDateRange($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    ...TaskFragmentTaskDueDateRange
  }
}
    ${TaskFragmentTaskDueDateRangeFragmentDoc}`;
export type UpdateTaskForTaskDueDateRangeMutationFn = Apollo.MutationFunction<UpdateTaskForTaskDueDateRangeMutation, UpdateTaskForTaskDueDateRangeMutationVariables>;

/**
 * __useUpdateTaskForTaskDueDateRangeMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskDueDateRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskDueDateRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskDueDateRangeMutation, { data, loading, error }] = useUpdateTaskForTaskDueDateRangeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskDueDateRangeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskDueDateRangeMutation, UpdateTaskForTaskDueDateRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskDueDateRangeMutation, UpdateTaskForTaskDueDateRangeMutationVariables>(UpdateTaskForTaskDueDateRangeDocument, options);
      }
export type UpdateTaskForTaskDueDateRangeMutationHookResult = ReturnType<typeof useUpdateTaskForTaskDueDateRangeMutation>;
export type UpdateTaskForTaskDueDateRangeMutationResult = Apollo.MutationResult<UpdateTaskForTaskDueDateRangeMutation>;
export type UpdateTaskForTaskDueDateRangeMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskDueDateRangeMutation, UpdateTaskForTaskDueDateRangeMutationVariables>;
export const UpdateTaskNameDocument = gql`
    mutation UpdateTaskName($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    name
  }
}
    `;
export type UpdateTaskNameMutationFn = Apollo.MutationFunction<UpdateTaskNameMutation, UpdateTaskNameMutationVariables>;

/**
 * __useUpdateTaskNameMutation__
 *
 * To run a mutation, you first call `useUpdateTaskNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskNameMutation, { data, loading, error }] = useUpdateTaskNameMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskNameMutation, UpdateTaskNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskNameMutation, UpdateTaskNameMutationVariables>(UpdateTaskNameDocument, options);
      }
export type UpdateTaskNameMutationHookResult = ReturnType<typeof useUpdateTaskNameMutation>;
export type UpdateTaskNameMutationResult = Apollo.MutationResult<UpdateTaskNameMutation>;
export type UpdateTaskNameMutationOptions = Apollo.BaseMutationOptions<UpdateTaskNameMutation, UpdateTaskNameMutationVariables>;
export const UpdateTaskForTaskPriorityComponentDocument = gql`
    mutation UpdateTaskForTaskPriorityComponent($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    ...TaskFragmentTaskPriorityComponent
  }
}
    ${TaskFragmentTaskPriorityComponentFragmentDoc}`;
export type UpdateTaskForTaskPriorityComponentMutationFn = Apollo.MutationFunction<UpdateTaskForTaskPriorityComponentMutation, UpdateTaskForTaskPriorityComponentMutationVariables>;

/**
 * __useUpdateTaskForTaskPriorityComponentMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskPriorityComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskPriorityComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskPriorityComponentMutation, { data, loading, error }] = useUpdateTaskForTaskPriorityComponentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskPriorityComponentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskPriorityComponentMutation, UpdateTaskForTaskPriorityComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskPriorityComponentMutation, UpdateTaskForTaskPriorityComponentMutationVariables>(UpdateTaskForTaskPriorityComponentDocument, options);
      }
export type UpdateTaskForTaskPriorityComponentMutationHookResult = ReturnType<typeof useUpdateTaskForTaskPriorityComponentMutation>;
export type UpdateTaskForTaskPriorityComponentMutationResult = Apollo.MutationResult<UpdateTaskForTaskPriorityComponentMutation>;
export type UpdateTaskForTaskPriorityComponentMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskPriorityComponentMutation, UpdateTaskForTaskPriorityComponentMutationVariables>;
export const UpdateTaskForTaskStatusDocument = gql`
    mutation UpdateTaskForTaskStatus($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    ...TaskFragmentTaskStatus
  }
}
    ${TaskFragmentTaskStatusFragmentDoc}`;
export type UpdateTaskForTaskStatusMutationFn = Apollo.MutationFunction<UpdateTaskForTaskStatusMutation, UpdateTaskForTaskStatusMutationVariables>;

/**
 * __useUpdateTaskForTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskStatusMutation, { data, loading, error }] = useUpdateTaskForTaskStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskStatusMutation, UpdateTaskForTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskStatusMutation, UpdateTaskForTaskStatusMutationVariables>(UpdateTaskForTaskStatusDocument, options);
      }
export type UpdateTaskForTaskStatusMutationHookResult = ReturnType<typeof useUpdateTaskForTaskStatusMutation>;
export type UpdateTaskForTaskStatusMutationResult = Apollo.MutationResult<UpdateTaskForTaskStatusMutation>;
export type UpdateTaskForTaskStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskStatusMutation, UpdateTaskForTaskStatusMutationVariables>;
export const GetTaskPermissionsDocument = gql`
    query GetTaskPermissions($id: String!) {
  task(id: $id) {
    id
    myPermissions
  }
}
    `;

/**
 * __useGetTaskPermissionsQuery__
 *
 * To run a query within a React component, call `useGetTaskPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskPermissionsQuery, GetTaskPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskPermissionsQuery, GetTaskPermissionsQueryVariables>(GetTaskPermissionsDocument, options);
      }
export function useGetTaskPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskPermissionsQuery, GetTaskPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskPermissionsQuery, GetTaskPermissionsQueryVariables>(GetTaskPermissionsDocument, options);
        }
export type GetTaskPermissionsQueryHookResult = ReturnType<typeof useGetTaskPermissionsQuery>;
export type GetTaskPermissionsLazyQueryHookResult = ReturnType<typeof useGetTaskPermissionsLazyQuery>;
export type GetTaskPermissionsQueryResult = Apollo.QueryResult<GetTaskPermissionsQuery, GetTaskPermissionsQueryVariables>;
export const CreateSubtaskForTaskDetailViewDocument = gql`
    mutation CreateSubtaskForTaskDetailView($data: CreateTaskInput!) {
  createTask(data: $data) {
    parentTaskId
    sortOrder
    ...TaskFragmentTaskSubtaskSection
  }
}
    ${TaskFragmentTaskSubtaskSectionFragmentDoc}`;
export type CreateSubtaskForTaskDetailViewMutationFn = Apollo.MutationFunction<CreateSubtaskForTaskDetailViewMutation, CreateSubtaskForTaskDetailViewMutationVariables>;

/**
 * __useCreateSubtaskForTaskDetailViewMutation__
 *
 * To run a mutation, you first call `useCreateSubtaskForTaskDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubtaskForTaskDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubtaskForTaskDetailViewMutation, { data, loading, error }] = useCreateSubtaskForTaskDetailViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSubtaskForTaskDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubtaskForTaskDetailViewMutation, CreateSubtaskForTaskDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubtaskForTaskDetailViewMutation, CreateSubtaskForTaskDetailViewMutationVariables>(CreateSubtaskForTaskDetailViewDocument, options);
      }
export type CreateSubtaskForTaskDetailViewMutationHookResult = ReturnType<typeof useCreateSubtaskForTaskDetailViewMutation>;
export type CreateSubtaskForTaskDetailViewMutationResult = Apollo.MutationResult<CreateSubtaskForTaskDetailViewMutation>;
export type CreateSubtaskForTaskDetailViewMutationOptions = Apollo.BaseMutationOptions<CreateSubtaskForTaskDetailViewMutation, CreateSubtaskForTaskDetailViewMutationVariables>;
export const UpdateSubtaskForTaskDetailViewDocument = gql`
    mutation UpdateSubtaskForTaskDetailView($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    name
    status
    startDate
    endDate
    priority
    taskMembers {
      id
    }
  }
}
    `;
export type UpdateSubtaskForTaskDetailViewMutationFn = Apollo.MutationFunction<UpdateSubtaskForTaskDetailViewMutation, UpdateSubtaskForTaskDetailViewMutationVariables>;

/**
 * __useUpdateSubtaskForTaskDetailViewMutation__
 *
 * To run a mutation, you first call `useUpdateSubtaskForTaskDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubtaskForTaskDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubtaskForTaskDetailViewMutation, { data, loading, error }] = useUpdateSubtaskForTaskDetailViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSubtaskForTaskDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubtaskForTaskDetailViewMutation, UpdateSubtaskForTaskDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubtaskForTaskDetailViewMutation, UpdateSubtaskForTaskDetailViewMutationVariables>(UpdateSubtaskForTaskDetailViewDocument, options);
      }
export type UpdateSubtaskForTaskDetailViewMutationHookResult = ReturnType<typeof useUpdateSubtaskForTaskDetailViewMutation>;
export type UpdateSubtaskForTaskDetailViewMutationResult = Apollo.MutationResult<UpdateSubtaskForTaskDetailViewMutation>;
export type UpdateSubtaskForTaskDetailViewMutationOptions = Apollo.BaseMutationOptions<UpdateSubtaskForTaskDetailViewMutation, UpdateSubtaskForTaskDetailViewMutationVariables>;
export const DeleteSubtaskForTaskDetailViewDocument = gql`
    mutation DeleteSubtaskForTaskDetailView($data: DeleteTaskInput!) {
  deleteTask(data: $data) {
    success
    message
  }
}
    `;
export type DeleteSubtaskForTaskDetailViewMutationFn = Apollo.MutationFunction<DeleteSubtaskForTaskDetailViewMutation, DeleteSubtaskForTaskDetailViewMutationVariables>;

/**
 * __useDeleteSubtaskForTaskDetailViewMutation__
 *
 * To run a mutation, you first call `useDeleteSubtaskForTaskDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubtaskForTaskDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubtaskForTaskDetailViewMutation, { data, loading, error }] = useDeleteSubtaskForTaskDetailViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteSubtaskForTaskDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubtaskForTaskDetailViewMutation, DeleteSubtaskForTaskDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubtaskForTaskDetailViewMutation, DeleteSubtaskForTaskDetailViewMutationVariables>(DeleteSubtaskForTaskDetailViewDocument, options);
      }
export type DeleteSubtaskForTaskDetailViewMutationHookResult = ReturnType<typeof useDeleteSubtaskForTaskDetailViewMutation>;
export type DeleteSubtaskForTaskDetailViewMutationResult = Apollo.MutationResult<DeleteSubtaskForTaskDetailViewMutation>;
export type DeleteSubtaskForTaskDetailViewMutationOptions = Apollo.BaseMutationOptions<DeleteSubtaskForTaskDetailViewMutation, DeleteSubtaskForTaskDetailViewMutationVariables>;
export const UpdateTaskForTaskDetailViewDocument = gql`
    mutation UpdateTaskForTaskDetailView($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    name
    description
    status
    startDate
    endDate
    taskMembers {
      id
    }
  }
}
    `;
export type UpdateTaskForTaskDetailViewMutationFn = Apollo.MutationFunction<UpdateTaskForTaskDetailViewMutation, UpdateTaskForTaskDetailViewMutationVariables>;

/**
 * __useUpdateTaskForTaskDetailViewMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskDetailViewMutation, { data, loading, error }] = useUpdateTaskForTaskDetailViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskDetailViewMutation, UpdateTaskForTaskDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskDetailViewMutation, UpdateTaskForTaskDetailViewMutationVariables>(UpdateTaskForTaskDetailViewDocument, options);
      }
export type UpdateTaskForTaskDetailViewMutationHookResult = ReturnType<typeof useUpdateTaskForTaskDetailViewMutation>;
export type UpdateTaskForTaskDetailViewMutationResult = Apollo.MutationResult<UpdateTaskForTaskDetailViewMutation>;
export type UpdateTaskForTaskDetailViewMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskDetailViewMutation, UpdateTaskForTaskDetailViewMutationVariables>;
export const DeleteTaskForTaskDetailViewDocument = gql`
    mutation DeleteTaskForTaskDetailView($data: DeleteTaskInput!) {
  deleteTask(data: $data) {
    success
    message
  }
}
    `;
export type DeleteTaskForTaskDetailViewMutationFn = Apollo.MutationFunction<DeleteTaskForTaskDetailViewMutation, DeleteTaskForTaskDetailViewMutationVariables>;

/**
 * __useDeleteTaskForTaskDetailViewMutation__
 *
 * To run a mutation, you first call `useDeleteTaskForTaskDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskForTaskDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskForTaskDetailViewMutation, { data, loading, error }] = useDeleteTaskForTaskDetailViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteTaskForTaskDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskForTaskDetailViewMutation, DeleteTaskForTaskDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskForTaskDetailViewMutation, DeleteTaskForTaskDetailViewMutationVariables>(DeleteTaskForTaskDetailViewDocument, options);
      }
export type DeleteTaskForTaskDetailViewMutationHookResult = ReturnType<typeof useDeleteTaskForTaskDetailViewMutation>;
export type DeleteTaskForTaskDetailViewMutationResult = Apollo.MutationResult<DeleteTaskForTaskDetailViewMutation>;
export type DeleteTaskForTaskDetailViewMutationOptions = Apollo.BaseMutationOptions<DeleteTaskForTaskDetailViewMutation, DeleteTaskForTaskDetailViewMutationVariables>;
export const GetPostForTaskDetailViewHeadingSectionDocument = gql`
    query GetPostForTaskDetailViewHeadingSection($id: String!) {
  post(id: $id) {
    id
    ...PostFragmentTaskHeadingSection
  }
}
    ${PostFragmentTaskHeadingSectionFragmentDoc}`;

/**
 * __useGetPostForTaskDetailViewHeadingSectionQuery__
 *
 * To run a query within a React component, call `useGetPostForTaskDetailViewHeadingSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForTaskDetailViewHeadingSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForTaskDetailViewHeadingSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForTaskDetailViewHeadingSectionQuery(baseOptions: Apollo.QueryHookOptions<GetPostForTaskDetailViewHeadingSectionQuery, GetPostForTaskDetailViewHeadingSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForTaskDetailViewHeadingSectionQuery, GetPostForTaskDetailViewHeadingSectionQueryVariables>(GetPostForTaskDetailViewHeadingSectionDocument, options);
      }
export function useGetPostForTaskDetailViewHeadingSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForTaskDetailViewHeadingSectionQuery, GetPostForTaskDetailViewHeadingSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForTaskDetailViewHeadingSectionQuery, GetPostForTaskDetailViewHeadingSectionQueryVariables>(GetPostForTaskDetailViewHeadingSectionDocument, options);
        }
export type GetPostForTaskDetailViewHeadingSectionQueryHookResult = ReturnType<typeof useGetPostForTaskDetailViewHeadingSectionQuery>;
export type GetPostForTaskDetailViewHeadingSectionLazyQueryHookResult = ReturnType<typeof useGetPostForTaskDetailViewHeadingSectionLazyQuery>;
export type GetPostForTaskDetailViewHeadingSectionQueryResult = Apollo.QueryResult<GetPostForTaskDetailViewHeadingSectionQuery, GetPostForTaskDetailViewHeadingSectionQueryVariables>;
export const UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonDocument = gql`
    mutation UpdateTaskForTaskDetailViewMediaSectionAddPostsButton($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    posts {
      id
      ...PostFragmentPostCommand
    }
  }
}
    ${PostFragmentPostCommandFragmentDoc}`;
export type UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationFn = Apollo.MutationFunction<UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation, UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationVariables>;

/**
 * __useUpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation, { data, loading, error }] = useUpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation, UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation, UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationVariables>(UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonDocument, options);
      }
export type UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationHookResult = ReturnType<typeof useUpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation>;
export type UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationResult = Apollo.MutationResult<UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation>;
export type UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutation, UpdateTaskForTaskDetailViewMediaSectionAddPostsButtonMutationVariables>;
export const GetTaskForTaskDetailViewMediaSectionDocument = gql`
    query GetTaskForTaskDetailViewMediaSection($id: String!) {
  task(id: $id) {
    id
    posts {
      id
      ...PostFragmentPostMasonryCardView
    }
  }
}
    ${PostFragmentPostMasonryCardViewFragmentDoc}`;

/**
 * __useGetTaskForTaskDetailViewMediaSectionQuery__
 *
 * To run a query within a React component, call `useGetTaskForTaskDetailViewMediaSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskForTaskDetailViewMediaSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskForTaskDetailViewMediaSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskForTaskDetailViewMediaSectionQuery(baseOptions: Apollo.QueryHookOptions<GetTaskForTaskDetailViewMediaSectionQuery, GetTaskForTaskDetailViewMediaSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskForTaskDetailViewMediaSectionQuery, GetTaskForTaskDetailViewMediaSectionQueryVariables>(GetTaskForTaskDetailViewMediaSectionDocument, options);
      }
export function useGetTaskForTaskDetailViewMediaSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskForTaskDetailViewMediaSectionQuery, GetTaskForTaskDetailViewMediaSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskForTaskDetailViewMediaSectionQuery, GetTaskForTaskDetailViewMediaSectionQueryVariables>(GetTaskForTaskDetailViewMediaSectionDocument, options);
        }
export type GetTaskForTaskDetailViewMediaSectionQueryHookResult = ReturnType<typeof useGetTaskForTaskDetailViewMediaSectionQuery>;
export type GetTaskForTaskDetailViewMediaSectionLazyQueryHookResult = ReturnType<typeof useGetTaskForTaskDetailViewMediaSectionLazyQuery>;
export type GetTaskForTaskDetailViewMediaSectionQueryResult = Apollo.QueryResult<GetTaskForTaskDetailViewMediaSectionQuery, GetTaskForTaskDetailViewMediaSectionQueryVariables>;
export const GetTaskForTaskDetailViewDocument = gql`
    query GetTaskForTaskDetailView($id: String!) {
  task(id: $id) {
    ...TaskFragmentTaskDetailView
  }
}
    ${TaskFragmentTaskDetailViewFragmentDoc}`;

/**
 * __useGetTaskForTaskDetailViewQuery__
 *
 * To run a query within a React component, call `useGetTaskForTaskDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskForTaskDetailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskForTaskDetailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskForTaskDetailViewQuery(baseOptions: Apollo.QueryHookOptions<GetTaskForTaskDetailViewQuery, GetTaskForTaskDetailViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskForTaskDetailViewQuery, GetTaskForTaskDetailViewQueryVariables>(GetTaskForTaskDetailViewDocument, options);
      }
export function useGetTaskForTaskDetailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskForTaskDetailViewQuery, GetTaskForTaskDetailViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskForTaskDetailViewQuery, GetTaskForTaskDetailViewQueryVariables>(GetTaskForTaskDetailViewDocument, options);
        }
export type GetTaskForTaskDetailViewQueryHookResult = ReturnType<typeof useGetTaskForTaskDetailViewQuery>;
export type GetTaskForTaskDetailViewLazyQueryHookResult = ReturnType<typeof useGetTaskForTaskDetailViewLazyQuery>;
export type GetTaskForTaskDetailViewQueryResult = Apollo.QueryResult<GetTaskForTaskDetailViewQuery, GetTaskForTaskDetailViewQueryVariables>;
export const GetTaskWithTaskMembersForTaskDetailViewDocument = gql`
    query GetTaskWithTaskMembersForTaskDetailView($id: String!) {
  task(id: $id) {
    id
    taskMembers {
      ...UserProfileFragmentAssigneeList
    }
  }
}
    ${UserProfileFragmentAssigneeListFragmentDoc}`;

/**
 * __useGetTaskWithTaskMembersForTaskDetailViewQuery__
 *
 * To run a query within a React component, call `useGetTaskWithTaskMembersForTaskDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskWithTaskMembersForTaskDetailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskWithTaskMembersForTaskDetailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskWithTaskMembersForTaskDetailViewQuery(baseOptions: Apollo.QueryHookOptions<GetTaskWithTaskMembersForTaskDetailViewQuery, GetTaskWithTaskMembersForTaskDetailViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskWithTaskMembersForTaskDetailViewQuery, GetTaskWithTaskMembersForTaskDetailViewQueryVariables>(GetTaskWithTaskMembersForTaskDetailViewDocument, options);
      }
export function useGetTaskWithTaskMembersForTaskDetailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskWithTaskMembersForTaskDetailViewQuery, GetTaskWithTaskMembersForTaskDetailViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskWithTaskMembersForTaskDetailViewQuery, GetTaskWithTaskMembersForTaskDetailViewQueryVariables>(GetTaskWithTaskMembersForTaskDetailViewDocument, options);
        }
export type GetTaskWithTaskMembersForTaskDetailViewQueryHookResult = ReturnType<typeof useGetTaskWithTaskMembersForTaskDetailViewQuery>;
export type GetTaskWithTaskMembersForTaskDetailViewLazyQueryHookResult = ReturnType<typeof useGetTaskWithTaskMembersForTaskDetailViewLazyQuery>;
export type GetTaskWithTaskMembersForTaskDetailViewQueryResult = Apollo.QueryResult<GetTaskWithTaskMembersForTaskDetailViewQuery, GetTaskWithTaskMembersForTaskDetailViewQueryVariables>;
export const UpdateTaskForTaskListItemViewDocument = gql`
    mutation UpdateTaskForTaskListItemView($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    ...TaskFragmentTaskListItemView
  }
}
    ${TaskFragmentTaskListItemViewFragmentDoc}`;
export type UpdateTaskForTaskListItemViewMutationFn = Apollo.MutationFunction<UpdateTaskForTaskListItemViewMutation, UpdateTaskForTaskListItemViewMutationVariables>;

/**
 * __useUpdateTaskForTaskListItemViewMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForTaskListItemViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForTaskListItemViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForTaskListItemViewMutation, { data, loading, error }] = useUpdateTaskForTaskListItemViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForTaskListItemViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForTaskListItemViewMutation, UpdateTaskForTaskListItemViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForTaskListItemViewMutation, UpdateTaskForTaskListItemViewMutationVariables>(UpdateTaskForTaskListItemViewDocument, options);
      }
export type UpdateTaskForTaskListItemViewMutationHookResult = ReturnType<typeof useUpdateTaskForTaskListItemViewMutation>;
export type UpdateTaskForTaskListItemViewMutationResult = Apollo.MutationResult<UpdateTaskForTaskListItemViewMutation>;
export type UpdateTaskForTaskListItemViewMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForTaskListItemViewMutation, UpdateTaskForTaskListItemViewMutationVariables>;
export const GetTaskForTaskPeekingCardViewDocument = gql`
    query GetTaskForTaskPeekingCardView($taskId: String!) {
  task(id: $taskId) {
    ...TaskFragmentTaskPeekingCardView
  }
}
    ${TaskFragmentTaskPeekingCardViewFragmentDoc}`;

/**
 * __useGetTaskForTaskPeekingCardViewQuery__
 *
 * To run a query within a React component, call `useGetTaskForTaskPeekingCardViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskForTaskPeekingCardViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskForTaskPeekingCardViewQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskForTaskPeekingCardViewQuery(baseOptions: Apollo.QueryHookOptions<GetTaskForTaskPeekingCardViewQuery, GetTaskForTaskPeekingCardViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskForTaskPeekingCardViewQuery, GetTaskForTaskPeekingCardViewQueryVariables>(GetTaskForTaskPeekingCardViewDocument, options);
      }
export function useGetTaskForTaskPeekingCardViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskForTaskPeekingCardViewQuery, GetTaskForTaskPeekingCardViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskForTaskPeekingCardViewQuery, GetTaskForTaskPeekingCardViewQueryVariables>(GetTaskForTaskPeekingCardViewDocument, options);
        }
export type GetTaskForTaskPeekingCardViewQueryHookResult = ReturnType<typeof useGetTaskForTaskPeekingCardViewQuery>;
export type GetTaskForTaskPeekingCardViewLazyQueryHookResult = ReturnType<typeof useGetTaskForTaskPeekingCardViewLazyQuery>;
export type GetTaskForTaskPeekingCardViewQueryResult = Apollo.QueryResult<GetTaskForTaskPeekingCardViewQuery, GetTaskForTaskPeekingCardViewQueryVariables>;
export const GetTasksForUseTaskListWithKeyboardShortcutsDocument = gql`
    query GetTasksForUseTaskListWithKeyboardShortcuts($filters: TaskFilters!, $take: Int, $after: String) {
  tasks(filters: $filters, take: $take, after: $after) {
    data {
      id
      subtasks(args: {filters: $filters}) {
        id
        ...TaskFragmentUseTaskListWithKeyboardShortcuts
      }
      ...TaskFragmentUseTaskListWithKeyboardShortcuts
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${TaskFragmentUseTaskListWithKeyboardShortcutsFragmentDoc}`;

/**
 * __useGetTasksForUseTaskListWithKeyboardShortcutsQuery__
 *
 * To run a query within a React component, call `useGetTasksForUseTaskListWithKeyboardShortcutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForUseTaskListWithKeyboardShortcutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksForUseTaskListWithKeyboardShortcutsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTasksForUseTaskListWithKeyboardShortcutsQuery(baseOptions: Apollo.QueryHookOptions<GetTasksForUseTaskListWithKeyboardShortcutsQuery, GetTasksForUseTaskListWithKeyboardShortcutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksForUseTaskListWithKeyboardShortcutsQuery, GetTasksForUseTaskListWithKeyboardShortcutsQueryVariables>(GetTasksForUseTaskListWithKeyboardShortcutsDocument, options);
      }
export function useGetTasksForUseTaskListWithKeyboardShortcutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksForUseTaskListWithKeyboardShortcutsQuery, GetTasksForUseTaskListWithKeyboardShortcutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksForUseTaskListWithKeyboardShortcutsQuery, GetTasksForUseTaskListWithKeyboardShortcutsQueryVariables>(GetTasksForUseTaskListWithKeyboardShortcutsDocument, options);
        }
export type GetTasksForUseTaskListWithKeyboardShortcutsQueryHookResult = ReturnType<typeof useGetTasksForUseTaskListWithKeyboardShortcutsQuery>;
export type GetTasksForUseTaskListWithKeyboardShortcutsLazyQueryHookResult = ReturnType<typeof useGetTasksForUseTaskListWithKeyboardShortcutsLazyQuery>;
export type GetTasksForUseTaskListWithKeyboardShortcutsQueryResult = Apollo.QueryResult<GetTasksForUseTaskListWithKeyboardShortcutsQuery, GetTasksForUseTaskListWithKeyboardShortcutsQueryVariables>;
export const UpdateTaskForUseTaskListWithKeyboardShortcutsDocument = gql`
    mutation UpdateTaskForUseTaskListWithKeyboardShortcuts($data: UpdateTaskInput!) {
  updateTask(data: $data) {
    id
    subtasks {
      id
      ...TaskFragmentUseTaskListWithKeyboardShortcuts
    }
    ...TaskFragmentUseTaskListWithKeyboardShortcuts
  }
}
    ${TaskFragmentUseTaskListWithKeyboardShortcutsFragmentDoc}`;
export type UpdateTaskForUseTaskListWithKeyboardShortcutsMutationFn = Apollo.MutationFunction<UpdateTaskForUseTaskListWithKeyboardShortcutsMutation, UpdateTaskForUseTaskListWithKeyboardShortcutsMutationVariables>;

/**
 * __useUpdateTaskForUseTaskListWithKeyboardShortcutsMutation__
 *
 * To run a mutation, you first call `useUpdateTaskForUseTaskListWithKeyboardShortcutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskForUseTaskListWithKeyboardShortcutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskForUseTaskListWithKeyboardShortcutsMutation, { data, loading, error }] = useUpdateTaskForUseTaskListWithKeyboardShortcutsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaskForUseTaskListWithKeyboardShortcutsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskForUseTaskListWithKeyboardShortcutsMutation, UpdateTaskForUseTaskListWithKeyboardShortcutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskForUseTaskListWithKeyboardShortcutsMutation, UpdateTaskForUseTaskListWithKeyboardShortcutsMutationVariables>(UpdateTaskForUseTaskListWithKeyboardShortcutsDocument, options);
      }
export type UpdateTaskForUseTaskListWithKeyboardShortcutsMutationHookResult = ReturnType<typeof useUpdateTaskForUseTaskListWithKeyboardShortcutsMutation>;
export type UpdateTaskForUseTaskListWithKeyboardShortcutsMutationResult = Apollo.MutationResult<UpdateTaskForUseTaskListWithKeyboardShortcutsMutation>;
export type UpdateTaskForUseTaskListWithKeyboardShortcutsMutationOptions = Apollo.BaseMutationOptions<UpdateTaskForUseTaskListWithKeyboardShortcutsMutation, UpdateTaskForUseTaskListWithKeyboardShortcutsMutationVariables>;
export const GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewDocument = gql`
    query GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListView($groupBy: TaskGroupBy!, $after: String, $taskSearchArgs: GetTasksArgs!) {
  taskGroups(groupBy: $groupBy, after: $after, taskSearchArgs: $taskSearchArgs) {
    data {
      id
      tasks {
        meta {
          totalCount
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery__
 *
 * To run a query within a React component, call `useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      after: // value for 'after'
 *      taskSearchArgs: // value for 'taskSearchArgs'
 *   },
 * });
 */
export function useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery(baseOptions: Apollo.QueryHookOptions<GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery, GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery, GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryVariables>(GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewDocument, options);
      }
export function useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery, GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery, GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryVariables>(GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewDocument, options);
        }
export type GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryHookResult = ReturnType<typeof useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery>;
export type GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewLazyQueryHookResult = ReturnType<typeof useGetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewLazyQuery>;
export type GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryResult = Apollo.QueryResult<GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQuery, GetTaskGroupsForTaskListWithKeyboardShortcutsGroupListViewQueryVariables>;
export const GetPostForTaskListWithKeyboardShortcutsGroupListItemViewDocument = gql`
    query GetPostForTaskListWithKeyboardShortcutsGroupListItemView($id: String!) {
  post(id: $id) {
    id
    ...PostFragmentPostSectionHeaderView
  }
}
    ${PostFragmentPostSectionHeaderViewFragmentDoc}`;

/**
 * __useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery__
 *
 * To run a query within a React component, call `useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery(baseOptions: Apollo.QueryHookOptions<GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>(GetPostForTaskListWithKeyboardShortcutsGroupListItemViewDocument, options);
      }
export function useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>(GetPostForTaskListWithKeyboardShortcutsGroupListItemViewDocument, options);
        }
export type GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryHookResult = ReturnType<typeof useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery>;
export type GetPostForTaskListWithKeyboardShortcutsGroupListItemViewLazyQueryHookResult = ReturnType<typeof useGetPostForTaskListWithKeyboardShortcutsGroupListItemViewLazyQuery>;
export type GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryResult = Apollo.QueryResult<GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetPostForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>;
export const GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewDocument = gql`
    query GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemView($id: String!) {
  userProfile(id: $id) {
    id
    ...UserFragmentAvatarGroup
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;

/**
 * __useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery__
 *
 * To run a query within a React component, call `useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>(GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewDocument, options);
      }
export function useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>(GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewDocument, options);
        }
export type GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryHookResult = ReturnType<typeof useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery>;
export type GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewLazyQueryHookResult = ReturnType<typeof useGetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewLazyQuery>;
export type GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryResult = Apollo.QueryResult<GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQuery, GetUserProfileForTaskListWithKeyboardShortcutsGroupListItemViewQueryVariables>;
export const GetPostAnnotationsForCommentThreadsPopoverDocument = gql`
    query GetPostAnnotationsForCommentThreadsPopover($filters: PostAnnotationFilters) {
  postAnnotations(filters: $filters) {
    id
    ...PostAnnotationFragmentAnnotation
  }
}
    ${PostAnnotationFragmentAnnotationFragmentDoc}`;

/**
 * __useGetPostAnnotationsForCommentThreadsPopoverQuery__
 *
 * To run a query within a React component, call `useGetPostAnnotationsForCommentThreadsPopoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostAnnotationsForCommentThreadsPopoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostAnnotationsForCommentThreadsPopoverQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPostAnnotationsForCommentThreadsPopoverQuery(baseOptions?: Apollo.QueryHookOptions<GetPostAnnotationsForCommentThreadsPopoverQuery, GetPostAnnotationsForCommentThreadsPopoverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostAnnotationsForCommentThreadsPopoverQuery, GetPostAnnotationsForCommentThreadsPopoverQueryVariables>(GetPostAnnotationsForCommentThreadsPopoverDocument, options);
      }
export function useGetPostAnnotationsForCommentThreadsPopoverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostAnnotationsForCommentThreadsPopoverQuery, GetPostAnnotationsForCommentThreadsPopoverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostAnnotationsForCommentThreadsPopoverQuery, GetPostAnnotationsForCommentThreadsPopoverQueryVariables>(GetPostAnnotationsForCommentThreadsPopoverDocument, options);
        }
export type GetPostAnnotationsForCommentThreadsPopoverQueryHookResult = ReturnType<typeof useGetPostAnnotationsForCommentThreadsPopoverQuery>;
export type GetPostAnnotationsForCommentThreadsPopoverLazyQueryHookResult = ReturnType<typeof useGetPostAnnotationsForCommentThreadsPopoverLazyQuery>;
export type GetPostAnnotationsForCommentThreadsPopoverQueryResult = Apollo.QueryResult<GetPostAnnotationsForCommentThreadsPopoverQuery, GetPostAnnotationsForCommentThreadsPopoverQueryVariables>;
export const GetPostForEmbedNodeViewPostRendererDocument = gql`
    query GetPostForEmbedNodeViewPostRenderer($id: String!) {
  post(id: $id) {
    type
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetPostForEmbedNodeViewPostRendererQuery__
 *
 * To run a query within a React component, call `useGetPostForEmbedNodeViewPostRendererQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForEmbedNodeViewPostRendererQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForEmbedNodeViewPostRendererQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForEmbedNodeViewPostRendererQuery(baseOptions: Apollo.QueryHookOptions<GetPostForEmbedNodeViewPostRendererQuery, GetPostForEmbedNodeViewPostRendererQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForEmbedNodeViewPostRendererQuery, GetPostForEmbedNodeViewPostRendererQueryVariables>(GetPostForEmbedNodeViewPostRendererDocument, options);
      }
export function useGetPostForEmbedNodeViewPostRendererLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForEmbedNodeViewPostRendererQuery, GetPostForEmbedNodeViewPostRendererQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForEmbedNodeViewPostRendererQuery, GetPostForEmbedNodeViewPostRendererQueryVariables>(GetPostForEmbedNodeViewPostRendererDocument, options);
        }
export type GetPostForEmbedNodeViewPostRendererQueryHookResult = ReturnType<typeof useGetPostForEmbedNodeViewPostRendererQuery>;
export type GetPostForEmbedNodeViewPostRendererLazyQueryHookResult = ReturnType<typeof useGetPostForEmbedNodeViewPostRendererLazyQuery>;
export type GetPostForEmbedNodeViewPostRendererQueryResult = Apollo.QueryResult<GetPostForEmbedNodeViewPostRendererQuery, GetPostForEmbedNodeViewPostRendererQueryVariables>;
export const GetTaskForTaskItemExtensionDocument = gql`
    query GetTaskForTaskItemExtension($id: String!) {
  task(id: $id) {
    id
    ...TaskFragmentTaskItemExtension
  }
}
    ${TaskFragmentTaskItemExtensionFragmentDoc}`;

/**
 * __useGetTaskForTaskItemExtensionQuery__
 *
 * To run a query within a React component, call `useGetTaskForTaskItemExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskForTaskItemExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskForTaskItemExtensionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskForTaskItemExtensionQuery(baseOptions: Apollo.QueryHookOptions<GetTaskForTaskItemExtensionQuery, GetTaskForTaskItemExtensionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskForTaskItemExtensionQuery, GetTaskForTaskItemExtensionQueryVariables>(GetTaskForTaskItemExtensionDocument, options);
      }
export function useGetTaskForTaskItemExtensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskForTaskItemExtensionQuery, GetTaskForTaskItemExtensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskForTaskItemExtensionQuery, GetTaskForTaskItemExtensionQueryVariables>(GetTaskForTaskItemExtensionDocument, options);
        }
export type GetTaskForTaskItemExtensionQueryHookResult = ReturnType<typeof useGetTaskForTaskItemExtensionQuery>;
export type GetTaskForTaskItemExtensionLazyQueryHookResult = ReturnType<typeof useGetTaskForTaskItemExtensionLazyQuery>;
export type GetTaskForTaskItemExtensionQueryResult = Apollo.QueryResult<GetTaskForTaskItemExtensionQuery, GetTaskForTaskItemExtensionQueryVariables>;
export const DeleteTopicForTopicMoreContextMenuDocument = gql`
    mutation DeleteTopicForTopicMoreContextMenu($topicId: String!) {
  deleteTopic(topicId: $topicId) {
    success
    message
  }
}
    `;
export type DeleteTopicForTopicMoreContextMenuMutationFn = Apollo.MutationFunction<DeleteTopicForTopicMoreContextMenuMutation, DeleteTopicForTopicMoreContextMenuMutationVariables>;

/**
 * __useDeleteTopicForTopicMoreContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteTopicForTopicMoreContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTopicForTopicMoreContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTopicForTopicMoreContextMenuMutation, { data, loading, error }] = useDeleteTopicForTopicMoreContextMenuMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useDeleteTopicForTopicMoreContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTopicForTopicMoreContextMenuMutation, DeleteTopicForTopicMoreContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTopicForTopicMoreContextMenuMutation, DeleteTopicForTopicMoreContextMenuMutationVariables>(DeleteTopicForTopicMoreContextMenuDocument, options);
      }
export type DeleteTopicForTopicMoreContextMenuMutationHookResult = ReturnType<typeof useDeleteTopicForTopicMoreContextMenuMutation>;
export type DeleteTopicForTopicMoreContextMenuMutationResult = Apollo.MutationResult<DeleteTopicForTopicMoreContextMenuMutation>;
export type DeleteTopicForTopicMoreContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteTopicForTopicMoreContextMenuMutation, DeleteTopicForTopicMoreContextMenuMutationVariables>;
export const CreateTopicBookmarkForTopicMoreContextMenuDocument = gql`
    mutation CreateTopicBookmarkForTopicMoreContextMenu($input: CreateTopicBookmarkInput!) {
  createTopicBookmark(input: $input) {
    ...BookmarkFragmentForBookmarkHandlers
  }
}
    ${BookmarkFragmentForBookmarkHandlersFragmentDoc}`;
export type CreateTopicBookmarkForTopicMoreContextMenuMutationFn = Apollo.MutationFunction<CreateTopicBookmarkForTopicMoreContextMenuMutation, CreateTopicBookmarkForTopicMoreContextMenuMutationVariables>;

/**
 * __useCreateTopicBookmarkForTopicMoreContextMenuMutation__
 *
 * To run a mutation, you first call `useCreateTopicBookmarkForTopicMoreContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopicBookmarkForTopicMoreContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopicBookmarkForTopicMoreContextMenuMutation, { data, loading, error }] = useCreateTopicBookmarkForTopicMoreContextMenuMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTopicBookmarkForTopicMoreContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<CreateTopicBookmarkForTopicMoreContextMenuMutation, CreateTopicBookmarkForTopicMoreContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTopicBookmarkForTopicMoreContextMenuMutation, CreateTopicBookmarkForTopicMoreContextMenuMutationVariables>(CreateTopicBookmarkForTopicMoreContextMenuDocument, options);
      }
export type CreateTopicBookmarkForTopicMoreContextMenuMutationHookResult = ReturnType<typeof useCreateTopicBookmarkForTopicMoreContextMenuMutation>;
export type CreateTopicBookmarkForTopicMoreContextMenuMutationResult = Apollo.MutationResult<CreateTopicBookmarkForTopicMoreContextMenuMutation>;
export type CreateTopicBookmarkForTopicMoreContextMenuMutationOptions = Apollo.BaseMutationOptions<CreateTopicBookmarkForTopicMoreContextMenuMutation, CreateTopicBookmarkForTopicMoreContextMenuMutationVariables>;
export const DeleteTopicBookmarkForTopicMoreContextMenuDocument = gql`
    mutation DeleteTopicBookmarkForTopicMoreContextMenu($input: DeleteTopicBookmarkInput!) {
  deleteTopicBookmark(input: $input) {
    message
    success
    deleted {
      id
    }
  }
}
    `;
export type DeleteTopicBookmarkForTopicMoreContextMenuMutationFn = Apollo.MutationFunction<DeleteTopicBookmarkForTopicMoreContextMenuMutation, DeleteTopicBookmarkForTopicMoreContextMenuMutationVariables>;

/**
 * __useDeleteTopicBookmarkForTopicMoreContextMenuMutation__
 *
 * To run a mutation, you first call `useDeleteTopicBookmarkForTopicMoreContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTopicBookmarkForTopicMoreContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTopicBookmarkForTopicMoreContextMenuMutation, { data, loading, error }] = useDeleteTopicBookmarkForTopicMoreContextMenuMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTopicBookmarkForTopicMoreContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTopicBookmarkForTopicMoreContextMenuMutation, DeleteTopicBookmarkForTopicMoreContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTopicBookmarkForTopicMoreContextMenuMutation, DeleteTopicBookmarkForTopicMoreContextMenuMutationVariables>(DeleteTopicBookmarkForTopicMoreContextMenuDocument, options);
      }
export type DeleteTopicBookmarkForTopicMoreContextMenuMutationHookResult = ReturnType<typeof useDeleteTopicBookmarkForTopicMoreContextMenuMutation>;
export type DeleteTopicBookmarkForTopicMoreContextMenuMutationResult = Apollo.MutationResult<DeleteTopicBookmarkForTopicMoreContextMenuMutation>;
export type DeleteTopicBookmarkForTopicMoreContextMenuMutationOptions = Apollo.BaseMutationOptions<DeleteTopicBookmarkForTopicMoreContextMenuMutation, DeleteTopicBookmarkForTopicMoreContextMenuMutationVariables>;
export const PauseTopicForTopicPauseContextMenuDocument = gql`
    mutation PauseTopicForTopicPauseContextMenu($data: PauseTopicInput!) {
  pauseTopic(data: $data) {
    id
    ...TopicFragmentTopicPauseContextMenu
  }
}
    ${TopicFragmentTopicPauseContextMenuFragmentDoc}`;
export type PauseTopicForTopicPauseContextMenuMutationFn = Apollo.MutationFunction<PauseTopicForTopicPauseContextMenuMutation, PauseTopicForTopicPauseContextMenuMutationVariables>;

/**
 * __usePauseTopicForTopicPauseContextMenuMutation__
 *
 * To run a mutation, you first call `usePauseTopicForTopicPauseContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseTopicForTopicPauseContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseTopicForTopicPauseContextMenuMutation, { data, loading, error }] = usePauseTopicForTopicPauseContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePauseTopicForTopicPauseContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<PauseTopicForTopicPauseContextMenuMutation, PauseTopicForTopicPauseContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseTopicForTopicPauseContextMenuMutation, PauseTopicForTopicPauseContextMenuMutationVariables>(PauseTopicForTopicPauseContextMenuDocument, options);
      }
export type PauseTopicForTopicPauseContextMenuMutationHookResult = ReturnType<typeof usePauseTopicForTopicPauseContextMenuMutation>;
export type PauseTopicForTopicPauseContextMenuMutationResult = Apollo.MutationResult<PauseTopicForTopicPauseContextMenuMutation>;
export type PauseTopicForTopicPauseContextMenuMutationOptions = Apollo.BaseMutationOptions<PauseTopicForTopicPauseContextMenuMutation, PauseTopicForTopicPauseContextMenuMutationVariables>;
export const ResumeTopicForTopicPauseContextMenuDocument = gql`
    mutation ResumeTopicForTopicPauseContextMenu($data: ResumeTopicInput!) {
  resumeTopic(data: $data) {
    id
    ...TopicFragmentTopicPauseContextMenu
  }
}
    ${TopicFragmentTopicPauseContextMenuFragmentDoc}`;
export type ResumeTopicForTopicPauseContextMenuMutationFn = Apollo.MutationFunction<ResumeTopicForTopicPauseContextMenuMutation, ResumeTopicForTopicPauseContextMenuMutationVariables>;

/**
 * __useResumeTopicForTopicPauseContextMenuMutation__
 *
 * To run a mutation, you first call `useResumeTopicForTopicPauseContextMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeTopicForTopicPauseContextMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeTopicForTopicPauseContextMenuMutation, { data, loading, error }] = useResumeTopicForTopicPauseContextMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResumeTopicForTopicPauseContextMenuMutation(baseOptions?: Apollo.MutationHookOptions<ResumeTopicForTopicPauseContextMenuMutation, ResumeTopicForTopicPauseContextMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeTopicForTopicPauseContextMenuMutation, ResumeTopicForTopicPauseContextMenuMutationVariables>(ResumeTopicForTopicPauseContextMenuDocument, options);
      }
export type ResumeTopicForTopicPauseContextMenuMutationHookResult = ReturnType<typeof useResumeTopicForTopicPauseContextMenuMutation>;
export type ResumeTopicForTopicPauseContextMenuMutationResult = Apollo.MutationResult<ResumeTopicForTopicPauseContextMenuMutation>;
export type ResumeTopicForTopicPauseContextMenuMutationOptions = Apollo.BaseMutationOptions<ResumeTopicForTopicPauseContextMenuMutation, ResumeTopicForTopicPauseContextMenuMutationVariables>;
export const UpdateSignalDefinitionForTopicSignalDocument = gql`
    mutation UpdateSignalDefinitionForTopicSignal($data: UpdateSignalDefinitionInput!) {
  updateSignalDefinition(data: $data) {
    ...SignalDefinitionFragmentTopicSignal
  }
}
    ${SignalDefinitionFragmentTopicSignalFragmentDoc}`;
export type UpdateSignalDefinitionForTopicSignalMutationFn = Apollo.MutationFunction<UpdateSignalDefinitionForTopicSignalMutation, UpdateSignalDefinitionForTopicSignalMutationVariables>;

/**
 * __useUpdateSignalDefinitionForTopicSignalMutation__
 *
 * To run a mutation, you first call `useUpdateSignalDefinitionForTopicSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignalDefinitionForTopicSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignalDefinitionForTopicSignalMutation, { data, loading, error }] = useUpdateSignalDefinitionForTopicSignalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSignalDefinitionForTopicSignalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignalDefinitionForTopicSignalMutation, UpdateSignalDefinitionForTopicSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignalDefinitionForTopicSignalMutation, UpdateSignalDefinitionForTopicSignalMutationVariables>(UpdateSignalDefinitionForTopicSignalDocument, options);
      }
export type UpdateSignalDefinitionForTopicSignalMutationHookResult = ReturnType<typeof useUpdateSignalDefinitionForTopicSignalMutation>;
export type UpdateSignalDefinitionForTopicSignalMutationResult = Apollo.MutationResult<UpdateSignalDefinitionForTopicSignalMutation>;
export type UpdateSignalDefinitionForTopicSignalMutationOptions = Apollo.BaseMutationOptions<UpdateSignalDefinitionForTopicSignalMutation, UpdateSignalDefinitionForTopicSignalMutationVariables>;
export const DeleteSignalDefinitionForTopicSignalDocument = gql`
    mutation DeleteSignalDefinitionForTopicSignal($data: DeleteSignalDefinitionInput!) {
  deleteSignalDefinition(data: $data) {
    message
    success
  }
}
    `;
export type DeleteSignalDefinitionForTopicSignalMutationFn = Apollo.MutationFunction<DeleteSignalDefinitionForTopicSignalMutation, DeleteSignalDefinitionForTopicSignalMutationVariables>;

/**
 * __useDeleteSignalDefinitionForTopicSignalMutation__
 *
 * To run a mutation, you first call `useDeleteSignalDefinitionForTopicSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignalDefinitionForTopicSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignalDefinitionForTopicSignalMutation, { data, loading, error }] = useDeleteSignalDefinitionForTopicSignalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteSignalDefinitionForTopicSignalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignalDefinitionForTopicSignalMutation, DeleteSignalDefinitionForTopicSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignalDefinitionForTopicSignalMutation, DeleteSignalDefinitionForTopicSignalMutationVariables>(DeleteSignalDefinitionForTopicSignalDocument, options);
      }
export type DeleteSignalDefinitionForTopicSignalMutationHookResult = ReturnType<typeof useDeleteSignalDefinitionForTopicSignalMutation>;
export type DeleteSignalDefinitionForTopicSignalMutationResult = Apollo.MutationResult<DeleteSignalDefinitionForTopicSignalMutation>;
export type DeleteSignalDefinitionForTopicSignalMutationOptions = Apollo.BaseMutationOptions<DeleteSignalDefinitionForTopicSignalMutation, DeleteSignalDefinitionForTopicSignalMutationVariables>;
export const CreateSignalCategoryOptionForTopicSignalDocument = gql`
    mutation CreateSignalCategoryOptionForTopicSignal($data: CreateSignalCategoryOptionInput!) {
  createSignalCategoryOption(data: $data) {
    id
    label
  }
}
    `;
export type CreateSignalCategoryOptionForTopicSignalMutationFn = Apollo.MutationFunction<CreateSignalCategoryOptionForTopicSignalMutation, CreateSignalCategoryOptionForTopicSignalMutationVariables>;

/**
 * __useCreateSignalCategoryOptionForTopicSignalMutation__
 *
 * To run a mutation, you first call `useCreateSignalCategoryOptionForTopicSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignalCategoryOptionForTopicSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignalCategoryOptionForTopicSignalMutation, { data, loading, error }] = useCreateSignalCategoryOptionForTopicSignalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSignalCategoryOptionForTopicSignalMutation(baseOptions?: Apollo.MutationHookOptions<CreateSignalCategoryOptionForTopicSignalMutation, CreateSignalCategoryOptionForTopicSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSignalCategoryOptionForTopicSignalMutation, CreateSignalCategoryOptionForTopicSignalMutationVariables>(CreateSignalCategoryOptionForTopicSignalDocument, options);
      }
export type CreateSignalCategoryOptionForTopicSignalMutationHookResult = ReturnType<typeof useCreateSignalCategoryOptionForTopicSignalMutation>;
export type CreateSignalCategoryOptionForTopicSignalMutationResult = Apollo.MutationResult<CreateSignalCategoryOptionForTopicSignalMutation>;
export type CreateSignalCategoryOptionForTopicSignalMutationOptions = Apollo.BaseMutationOptions<CreateSignalCategoryOptionForTopicSignalMutation, CreateSignalCategoryOptionForTopicSignalMutationVariables>;
export const UpdateSignalCategoryOptionForTopicSignalDocument = gql`
    mutation UpdateSignalCategoryOptionForTopicSignal($data: UpdateSignalCategoryOptionInput!) {
  updateSignalCategoryOption(data: $data) {
    id
    label
  }
}
    `;
export type UpdateSignalCategoryOptionForTopicSignalMutationFn = Apollo.MutationFunction<UpdateSignalCategoryOptionForTopicSignalMutation, UpdateSignalCategoryOptionForTopicSignalMutationVariables>;

/**
 * __useUpdateSignalCategoryOptionForTopicSignalMutation__
 *
 * To run a mutation, you first call `useUpdateSignalCategoryOptionForTopicSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignalCategoryOptionForTopicSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignalCategoryOptionForTopicSignalMutation, { data, loading, error }] = useUpdateSignalCategoryOptionForTopicSignalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSignalCategoryOptionForTopicSignalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignalCategoryOptionForTopicSignalMutation, UpdateSignalCategoryOptionForTopicSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignalCategoryOptionForTopicSignalMutation, UpdateSignalCategoryOptionForTopicSignalMutationVariables>(UpdateSignalCategoryOptionForTopicSignalDocument, options);
      }
export type UpdateSignalCategoryOptionForTopicSignalMutationHookResult = ReturnType<typeof useUpdateSignalCategoryOptionForTopicSignalMutation>;
export type UpdateSignalCategoryOptionForTopicSignalMutationResult = Apollo.MutationResult<UpdateSignalCategoryOptionForTopicSignalMutation>;
export type UpdateSignalCategoryOptionForTopicSignalMutationOptions = Apollo.BaseMutationOptions<UpdateSignalCategoryOptionForTopicSignalMutation, UpdateSignalCategoryOptionForTopicSignalMutationVariables>;
export const DeleteSignalCategoryOptionForTopicSignalDocument = gql`
    mutation DeleteSignalCategoryOptionForTopicSignal($data: DeleteSignalCategoryOptionInput!) {
  deleteSignalCategoryOption(data: $data) {
    message
    success
  }
}
    `;
export type DeleteSignalCategoryOptionForTopicSignalMutationFn = Apollo.MutationFunction<DeleteSignalCategoryOptionForTopicSignalMutation, DeleteSignalCategoryOptionForTopicSignalMutationVariables>;

/**
 * __useDeleteSignalCategoryOptionForTopicSignalMutation__
 *
 * To run a mutation, you first call `useDeleteSignalCategoryOptionForTopicSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignalCategoryOptionForTopicSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignalCategoryOptionForTopicSignalMutation, { data, loading, error }] = useDeleteSignalCategoryOptionForTopicSignalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteSignalCategoryOptionForTopicSignalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignalCategoryOptionForTopicSignalMutation, DeleteSignalCategoryOptionForTopicSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignalCategoryOptionForTopicSignalMutation, DeleteSignalCategoryOptionForTopicSignalMutationVariables>(DeleteSignalCategoryOptionForTopicSignalDocument, options);
      }
export type DeleteSignalCategoryOptionForTopicSignalMutationHookResult = ReturnType<typeof useDeleteSignalCategoryOptionForTopicSignalMutation>;
export type DeleteSignalCategoryOptionForTopicSignalMutationResult = Apollo.MutationResult<DeleteSignalCategoryOptionForTopicSignalMutation>;
export type DeleteSignalCategoryOptionForTopicSignalMutationOptions = Apollo.BaseMutationOptions<DeleteSignalCategoryOptionForTopicSignalMutation, DeleteSignalCategoryOptionForTopicSignalMutationVariables>;
export const GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewDocument = gql`
    query GetAggregatedTopicDurationUsageForTopicBreakdownPopoverView($filters: AggregatedTopicDurationUsageFilters!, $brandId: String!) {
  aggregatedTopicDurationUsage(filters: $filters, brandId: $brandId) {
    topicId
    topic {
      id
      ...TopicFragmentTopicBreakdownPopoverView
      ...TopicFragmentTopicMoreContextMenu
    }
    durationUsed
  }
}
    ${TopicFragmentTopicBreakdownPopoverViewFragmentDoc}
${TopicFragmentTopicMoreContextMenuFragmentDoc}`;

/**
 * __useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery__
 *
 * To run a query within a React component, call `useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryVariables>(GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewDocument, options);
      }
export function useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryVariables>(GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewDocument, options);
        }
export type GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryHookResult = ReturnType<typeof useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery>;
export type GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewLazyQueryHookResult = ReturnType<typeof useGetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewLazyQuery>;
export type GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryResult = Apollo.QueryResult<GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownPopoverViewQueryVariables>;
export const GetAggregatedTopicDurationUsageForTopicBreakdownTableViewDocument = gql`
    query GetAggregatedTopicDurationUsageForTopicBreakdownTableView($filters: AggregatedTopicDurationUsageFilters!, $brandId: String!) {
  aggregatedTopicDurationUsage(filters: $filters, brandId: $brandId) {
    topicId
    topic {
      id
      ...TopicFragmentTopicBreakdownTableView
      ...TopicFragmentTopicMoreContextMenu
      ...TopicFragmentTopicLabel
    }
    durationUsed
    totalParsedPostsCount
    totalPositivelyParsedPostsCount
  }
}
    ${TopicFragmentTopicBreakdownTableViewFragmentDoc}
${TopicFragmentTopicMoreContextMenuFragmentDoc}
${TopicFragmentTopicLabelFragmentDoc}`;

/**
 * __useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery__
 *
 * To run a query within a React component, call `useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryVariables>(GetAggregatedTopicDurationUsageForTopicBreakdownTableViewDocument, options);
      }
export function useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryVariables>(GetAggregatedTopicDurationUsageForTopicBreakdownTableViewDocument, options);
        }
export type GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryHookResult = ReturnType<typeof useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery>;
export type GetAggregatedTopicDurationUsageForTopicBreakdownTableViewLazyQueryHookResult = ReturnType<typeof useGetAggregatedTopicDurationUsageForTopicBreakdownTableViewLazyQuery>;
export type GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryResult = Apollo.QueryResult<GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQuery, GetAggregatedTopicDurationUsageForTopicBreakdownTableViewQueryVariables>;
export const GetTopicForTopicContentFilterSettingsViewDocument = gql`
    query GetTopicForTopicContentFilterSettingsView($id: String!) {
  topic(id: $id) {
    id
    ...TopicFragmentTopicContentFilterSettingsView
  }
}
    ${TopicFragmentTopicContentFilterSettingsViewFragmentDoc}`;

/**
 * __useGetTopicForTopicContentFilterSettingsViewQuery__
 *
 * To run a query within a React component, call `useGetTopicForTopicContentFilterSettingsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicForTopicContentFilterSettingsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicForTopicContentFilterSettingsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTopicForTopicContentFilterSettingsViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopicForTopicContentFilterSettingsViewQuery, GetTopicForTopicContentFilterSettingsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicForTopicContentFilterSettingsViewQuery, GetTopicForTopicContentFilterSettingsViewQueryVariables>(GetTopicForTopicContentFilterSettingsViewDocument, options);
      }
export function useGetTopicForTopicContentFilterSettingsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicForTopicContentFilterSettingsViewQuery, GetTopicForTopicContentFilterSettingsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicForTopicContentFilterSettingsViewQuery, GetTopicForTopicContentFilterSettingsViewQueryVariables>(GetTopicForTopicContentFilterSettingsViewDocument, options);
        }
export type GetTopicForTopicContentFilterSettingsViewQueryHookResult = ReturnType<typeof useGetTopicForTopicContentFilterSettingsViewQuery>;
export type GetTopicForTopicContentFilterSettingsViewLazyQueryHookResult = ReturnType<typeof useGetTopicForTopicContentFilterSettingsViewLazyQuery>;
export type GetTopicForTopicContentFilterSettingsViewQueryResult = Apollo.QueryResult<GetTopicForTopicContentFilterSettingsViewQuery, GetTopicForTopicContentFilterSettingsViewQueryVariables>;
export const UpdateTopicForTopicContentFilterSettingsViewDocument = gql`
    mutation UpdateTopicForTopicContentFilterSettingsView($data: UpdateTopicInput!) {
  updateTopic(data: $data) {
    id
    ...TopicFragmentTopicContentFilterSettingsView
  }
}
    ${TopicFragmentTopicContentFilterSettingsViewFragmentDoc}`;
export type UpdateTopicForTopicContentFilterSettingsViewMutationFn = Apollo.MutationFunction<UpdateTopicForTopicContentFilterSettingsViewMutation, UpdateTopicForTopicContentFilterSettingsViewMutationVariables>;

/**
 * __useUpdateTopicForTopicContentFilterSettingsViewMutation__
 *
 * To run a mutation, you first call `useUpdateTopicForTopicContentFilterSettingsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicForTopicContentFilterSettingsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicForTopicContentFilterSettingsViewMutation, { data, loading, error }] = useUpdateTopicForTopicContentFilterSettingsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTopicForTopicContentFilterSettingsViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTopicForTopicContentFilterSettingsViewMutation, UpdateTopicForTopicContentFilterSettingsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTopicForTopicContentFilterSettingsViewMutation, UpdateTopicForTopicContentFilterSettingsViewMutationVariables>(UpdateTopicForTopicContentFilterSettingsViewDocument, options);
      }
export type UpdateTopicForTopicContentFilterSettingsViewMutationHookResult = ReturnType<typeof useUpdateTopicForTopicContentFilterSettingsViewMutation>;
export type UpdateTopicForTopicContentFilterSettingsViewMutationResult = Apollo.MutationResult<UpdateTopicForTopicContentFilterSettingsViewMutation>;
export type UpdateTopicForTopicContentFilterSettingsViewMutationOptions = Apollo.BaseMutationOptions<UpdateTopicForTopicContentFilterSettingsViewMutation, UpdateTopicForTopicContentFilterSettingsViewMutationVariables>;
export const GetTopicForTopicParsingSettingsViewDocument = gql`
    query GetTopicForTopicParsingSettingsView($id: String!) {
  topic(id: $id) {
    id
    ...TopicFragmentTopicParsingSettingsView
  }
}
    ${TopicFragmentTopicParsingSettingsViewFragmentDoc}`;

/**
 * __useGetTopicForTopicParsingSettingsViewQuery__
 *
 * To run a query within a React component, call `useGetTopicForTopicParsingSettingsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicForTopicParsingSettingsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicForTopicParsingSettingsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTopicForTopicParsingSettingsViewQuery(baseOptions: Apollo.QueryHookOptions<GetTopicForTopicParsingSettingsViewQuery, GetTopicForTopicParsingSettingsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicForTopicParsingSettingsViewQuery, GetTopicForTopicParsingSettingsViewQueryVariables>(GetTopicForTopicParsingSettingsViewDocument, options);
      }
export function useGetTopicForTopicParsingSettingsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicForTopicParsingSettingsViewQuery, GetTopicForTopicParsingSettingsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicForTopicParsingSettingsViewQuery, GetTopicForTopicParsingSettingsViewQueryVariables>(GetTopicForTopicParsingSettingsViewDocument, options);
        }
export type GetTopicForTopicParsingSettingsViewQueryHookResult = ReturnType<typeof useGetTopicForTopicParsingSettingsViewQuery>;
export type GetTopicForTopicParsingSettingsViewLazyQueryHookResult = ReturnType<typeof useGetTopicForTopicParsingSettingsViewLazyQuery>;
export type GetTopicForTopicParsingSettingsViewQueryResult = Apollo.QueryResult<GetTopicForTopicParsingSettingsViewQuery, GetTopicForTopicParsingSettingsViewQueryVariables>;
export const UpdateTopicForTopicParsingSettingsViewDocument = gql`
    mutation UpdateTopicForTopicParsingSettingsView($data: UpdateTopicInput!) {
  updateTopic(data: $data) {
    id
    ...TopicFragmentTopicParsingSettingsView
  }
}
    ${TopicFragmentTopicParsingSettingsViewFragmentDoc}`;
export type UpdateTopicForTopicParsingSettingsViewMutationFn = Apollo.MutationFunction<UpdateTopicForTopicParsingSettingsViewMutation, UpdateTopicForTopicParsingSettingsViewMutationVariables>;

/**
 * __useUpdateTopicForTopicParsingSettingsViewMutation__
 *
 * To run a mutation, you first call `useUpdateTopicForTopicParsingSettingsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicForTopicParsingSettingsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicForTopicParsingSettingsViewMutation, { data, loading, error }] = useUpdateTopicForTopicParsingSettingsViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTopicForTopicParsingSettingsViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTopicForTopicParsingSettingsViewMutation, UpdateTopicForTopicParsingSettingsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTopicForTopicParsingSettingsViewMutation, UpdateTopicForTopicParsingSettingsViewMutationVariables>(UpdateTopicForTopicParsingSettingsViewDocument, options);
      }
export type UpdateTopicForTopicParsingSettingsViewMutationHookResult = ReturnType<typeof useUpdateTopicForTopicParsingSettingsViewMutation>;
export type UpdateTopicForTopicParsingSettingsViewMutationResult = Apollo.MutationResult<UpdateTopicForTopicParsingSettingsViewMutation>;
export type UpdateTopicForTopicParsingSettingsViewMutationOptions = Apollo.BaseMutationOptions<UpdateTopicForTopicParsingSettingsViewMutation, UpdateTopicForTopicParsingSettingsViewMutationVariables>;
export const AudioTrendGroupForPaginationDocument = gql`
    query AudioTrendGroupForPagination($take: Int, $skip: Int, $filters: AudioTrendGroupFilters!, $after: String, $before: String) {
  audioTrendGroups(
    take: $take
    skip: $skip
    filters: $filters
    after: $after
    before: $before
  ) {
    data {
      ...AudioTrendGroupFragmentUseTrendAudioGroupNavigatorHandler
    }
  }
}
    ${AudioTrendGroupFragmentUseTrendAudioGroupNavigatorHandlerFragmentDoc}`;

/**
 * __useAudioTrendGroupForPaginationQuery__
 *
 * To run a query within a React component, call `useAudioTrendGroupForPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudioTrendGroupForPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudioTrendGroupForPaginationQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useAudioTrendGroupForPaginationQuery(baseOptions: Apollo.QueryHookOptions<AudioTrendGroupForPaginationQuery, AudioTrendGroupForPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudioTrendGroupForPaginationQuery, AudioTrendGroupForPaginationQueryVariables>(AudioTrendGroupForPaginationDocument, options);
      }
export function useAudioTrendGroupForPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudioTrendGroupForPaginationQuery, AudioTrendGroupForPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudioTrendGroupForPaginationQuery, AudioTrendGroupForPaginationQueryVariables>(AudioTrendGroupForPaginationDocument, options);
        }
export type AudioTrendGroupForPaginationQueryHookResult = ReturnType<typeof useAudioTrendGroupForPaginationQuery>;
export type AudioTrendGroupForPaginationLazyQueryHookResult = ReturnType<typeof useAudioTrendGroupForPaginationLazyQuery>;
export type AudioTrendGroupForPaginationQueryResult = Apollo.QueryResult<AudioTrendGroupForPaginationQuery, AudioTrendGroupForPaginationQueryVariables>;
export const CreatePostForTrendDocument = gql`
    mutation CreatePostForTrend($data: CreatePostForTrendInput!) {
  createPostForTrend(data: $data) {
    id
    isFavoriteTrend
    creator {
      id
    }
    urlMetadata {
      id
    }
    ...LinkedPostFragmentTrendLinkPosts
  }
}
    ${LinkedPostFragmentTrendLinkPostsFragmentDoc}`;
export type CreatePostForTrendMutationFn = Apollo.MutationFunction<CreatePostForTrendMutation, CreatePostForTrendMutationVariables>;

/**
 * __useCreatePostForTrendMutation__
 *
 * To run a mutation, you first call `useCreatePostForTrendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostForTrendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostForTrendMutation, { data, loading, error }] = useCreatePostForTrendMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostForTrendMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostForTrendMutation, CreatePostForTrendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostForTrendMutation, CreatePostForTrendMutationVariables>(CreatePostForTrendDocument, options);
      }
export type CreatePostForTrendMutationHookResult = ReturnType<typeof useCreatePostForTrendMutation>;
export type CreatePostForTrendMutationResult = Apollo.MutationResult<CreatePostForTrendMutation>;
export type CreatePostForTrendMutationOptions = Apollo.BaseMutationOptions<CreatePostForTrendMutation, CreatePostForTrendMutationVariables>;
export const SaveTrendForTrendingPageDocument = gql`
    mutation SaveTrendForTrendingPage($data: CreateTrendFavoriteInput!) {
  createTrendFavorite(data: $data) {
    id
    post {
      ...PostFragmentPostPreview
    }
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export type SaveTrendForTrendingPageMutationFn = Apollo.MutationFunction<SaveTrendForTrendingPageMutation, SaveTrendForTrendingPageMutationVariables>;

/**
 * __useSaveTrendForTrendingPageMutation__
 *
 * To run a mutation, you first call `useSaveTrendForTrendingPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTrendForTrendingPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTrendForTrendingPageMutation, { data, loading, error }] = useSaveTrendForTrendingPageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveTrendForTrendingPageMutation(baseOptions?: Apollo.MutationHookOptions<SaveTrendForTrendingPageMutation, SaveTrendForTrendingPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTrendForTrendingPageMutation, SaveTrendForTrendingPageMutationVariables>(SaveTrendForTrendingPageDocument, options);
      }
export type SaveTrendForTrendingPageMutationHookResult = ReturnType<typeof useSaveTrendForTrendingPageMutation>;
export type SaveTrendForTrendingPageMutationResult = Apollo.MutationResult<SaveTrendForTrendingPageMutation>;
export type SaveTrendForTrendingPageMutationOptions = Apollo.BaseMutationOptions<SaveTrendForTrendingPageMutation, SaveTrendForTrendingPageMutationVariables>;
export const UnsaveTrendForTrendingPageDocument = gql`
    mutation UnsaveTrendForTrendingPage($data: DeleteTrendFavoriteInput!) {
  deleteTrendFavorite(data: $data) {
    success
    message
  }
}
    `;
export type UnsaveTrendForTrendingPageMutationFn = Apollo.MutationFunction<UnsaveTrendForTrendingPageMutation, UnsaveTrendForTrendingPageMutationVariables>;

/**
 * __useUnsaveTrendForTrendingPageMutation__
 *
 * To run a mutation, you first call `useUnsaveTrendForTrendingPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveTrendForTrendingPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveTrendForTrendingPageMutation, { data, loading, error }] = useUnsaveTrendForTrendingPageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnsaveTrendForTrendingPageMutation(baseOptions?: Apollo.MutationHookOptions<UnsaveTrendForTrendingPageMutation, UnsaveTrendForTrendingPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsaveTrendForTrendingPageMutation, UnsaveTrendForTrendingPageMutationVariables>(UnsaveTrendForTrendingPageDocument, options);
      }
export type UnsaveTrendForTrendingPageMutationHookResult = ReturnType<typeof useUnsaveTrendForTrendingPageMutation>;
export type UnsaveTrendForTrendingPageMutationResult = Apollo.MutationResult<UnsaveTrendForTrendingPageMutation>;
export type UnsaveTrendForTrendingPageMutationOptions = Apollo.BaseMutationOptions<UnsaveTrendForTrendingPageMutation, UnsaveTrendForTrendingPageMutationVariables>;
export const TrendsForPaginationDocument = gql`
    query TrendsForPagination($take: Int, $filters: TrendFilters!, $after: String) {
  trends(take: $take, filters: $filters, after: $after) {
    data {
      ...TrendFragmentUseTrendNavigatorHandler
    }
  }
}
    ${TrendFragmentUseTrendNavigatorHandlerFragmentDoc}`;

/**
 * __useTrendsForPaginationQuery__
 *
 * To run a query within a React component, call `useTrendsForPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendsForPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendsForPaginationQuery({
 *   variables: {
 *      take: // value for 'take'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTrendsForPaginationQuery(baseOptions: Apollo.QueryHookOptions<TrendsForPaginationQuery, TrendsForPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrendsForPaginationQuery, TrendsForPaginationQueryVariables>(TrendsForPaginationDocument, options);
      }
export function useTrendsForPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrendsForPaginationQuery, TrendsForPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrendsForPaginationQuery, TrendsForPaginationQueryVariables>(TrendsForPaginationDocument, options);
        }
export type TrendsForPaginationQueryHookResult = ReturnType<typeof useTrendsForPaginationQuery>;
export type TrendsForPaginationLazyQueryHookResult = ReturnType<typeof useTrendsForPaginationLazyQuery>;
export type TrendsForPaginationQueryResult = Apollo.QueryResult<TrendsForPaginationQuery, TrendsForPaginationQueryVariables>;
export const TrendQueryForTrendingDetailViewDocument = gql`
    query TrendQueryForTrendingDetailView($trendId: String!) {
  trend(id: $trendId) {
    ...TrendFragmentTrendingDetailView
  }
}
    ${TrendFragmentTrendingDetailViewFragmentDoc}`;

/**
 * __useTrendQueryForTrendingDetailViewQuery__
 *
 * To run a query within a React component, call `useTrendQueryForTrendingDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendQueryForTrendingDetailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendQueryForTrendingDetailViewQuery({
 *   variables: {
 *      trendId: // value for 'trendId'
 *   },
 * });
 */
export function useTrendQueryForTrendingDetailViewQuery(baseOptions: Apollo.QueryHookOptions<TrendQueryForTrendingDetailViewQuery, TrendQueryForTrendingDetailViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrendQueryForTrendingDetailViewQuery, TrendQueryForTrendingDetailViewQueryVariables>(TrendQueryForTrendingDetailViewDocument, options);
      }
export function useTrendQueryForTrendingDetailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrendQueryForTrendingDetailViewQuery, TrendQueryForTrendingDetailViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrendQueryForTrendingDetailViewQuery, TrendQueryForTrendingDetailViewQueryVariables>(TrendQueryForTrendingDetailViewDocument, options);
        }
export type TrendQueryForTrendingDetailViewQueryHookResult = ReturnType<typeof useTrendQueryForTrendingDetailViewQuery>;
export type TrendQueryForTrendingDetailViewLazyQueryHookResult = ReturnType<typeof useTrendQueryForTrendingDetailViewLazyQuery>;
export type TrendQueryForTrendingDetailViewQueryResult = Apollo.QueryResult<TrendQueryForTrendingDetailViewQuery, TrendQueryForTrendingDetailViewQueryVariables>;
export const AddTrendToContentCalendarForTrendContentCalendarButtonDocument = gql`
    mutation AddTrendToContentCalendarForTrendContentCalendarButton($data: AddTrendToContentCalendarInput!) {
  addTrendToContentCalendar(data: $data) {
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;
export type AddTrendToContentCalendarForTrendContentCalendarButtonMutationFn = Apollo.MutationFunction<AddTrendToContentCalendarForTrendContentCalendarButtonMutation, AddTrendToContentCalendarForTrendContentCalendarButtonMutationVariables>;

/**
 * __useAddTrendToContentCalendarForTrendContentCalendarButtonMutation__
 *
 * To run a mutation, you first call `useAddTrendToContentCalendarForTrendContentCalendarButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrendToContentCalendarForTrendContentCalendarButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrendToContentCalendarForTrendContentCalendarButtonMutation, { data, loading, error }] = useAddTrendToContentCalendarForTrendContentCalendarButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddTrendToContentCalendarForTrendContentCalendarButtonMutation(baseOptions?: Apollo.MutationHookOptions<AddTrendToContentCalendarForTrendContentCalendarButtonMutation, AddTrendToContentCalendarForTrendContentCalendarButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrendToContentCalendarForTrendContentCalendarButtonMutation, AddTrendToContentCalendarForTrendContentCalendarButtonMutationVariables>(AddTrendToContentCalendarForTrendContentCalendarButtonDocument, options);
      }
export type AddTrendToContentCalendarForTrendContentCalendarButtonMutationHookResult = ReturnType<typeof useAddTrendToContentCalendarForTrendContentCalendarButtonMutation>;
export type AddTrendToContentCalendarForTrendContentCalendarButtonMutationResult = Apollo.MutationResult<AddTrendToContentCalendarForTrendContentCalendarButtonMutation>;
export type AddTrendToContentCalendarForTrendContentCalendarButtonMutationOptions = Apollo.BaseMutationOptions<AddTrendToContentCalendarForTrendContentCalendarButtonMutation, AddTrendToContentCalendarForTrendContentCalendarButtonMutationVariables>;
export const GetCollectionForCollectionPermissionsDocument = gql`
    query GetCollectionForCollectionPermissions($collectionId: String!) {
  collection(id: $collectionId) {
    id
    myPermissions
  }
}
    `;

/**
 * __useGetCollectionForCollectionPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCollectionPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCollectionPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCollectionPermissionsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForCollectionPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCollectionPermissionsQuery, GetCollectionForCollectionPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCollectionPermissionsQuery, GetCollectionForCollectionPermissionsQueryVariables>(GetCollectionForCollectionPermissionsDocument, options);
      }
export function useGetCollectionForCollectionPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCollectionPermissionsQuery, GetCollectionForCollectionPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCollectionPermissionsQuery, GetCollectionForCollectionPermissionsQueryVariables>(GetCollectionForCollectionPermissionsDocument, options);
        }
export type GetCollectionForCollectionPermissionsQueryHookResult = ReturnType<typeof useGetCollectionForCollectionPermissionsQuery>;
export type GetCollectionForCollectionPermissionsLazyQueryHookResult = ReturnType<typeof useGetCollectionForCollectionPermissionsLazyQuery>;
export type GetCollectionForCollectionPermissionsQueryResult = Apollo.QueryResult<GetCollectionForCollectionPermissionsQuery, GetCollectionForCollectionPermissionsQueryVariables>;
export const GetPostForPostPermissionsDocument = gql`
    query GetPostForPostPermissions($postId: String!) {
  post(id: $postId) {
    id
    myPermissions
  }
}
    `;

/**
 * __useGetPostForPostPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPostForPostPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForPostPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForPostPermissionsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostForPostPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetPostForPostPermissionsQuery, GetPostForPostPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForPostPermissionsQuery, GetPostForPostPermissionsQueryVariables>(GetPostForPostPermissionsDocument, options);
      }
export function useGetPostForPostPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForPostPermissionsQuery, GetPostForPostPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForPostPermissionsQuery, GetPostForPostPermissionsQueryVariables>(GetPostForPostPermissionsDocument, options);
        }
export type GetPostForPostPermissionsQueryHookResult = ReturnType<typeof useGetPostForPostPermissionsQuery>;
export type GetPostForPostPermissionsLazyQueryHookResult = ReturnType<typeof useGetPostForPostPermissionsLazyQuery>;
export type GetPostForPostPermissionsQueryResult = Apollo.QueryResult<GetPostForPostPermissionsQuery, GetPostForPostPermissionsQueryVariables>;
export const GetTaskForTaskPermissionsDocument = gql`
    query GetTaskForTaskPermissions($id: String!) {
  task(id: $id) {
    id
    myPermissions
  }
}
    `;

/**
 * __useGetTaskForTaskPermissionsQuery__
 *
 * To run a query within a React component, call `useGetTaskForTaskPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskForTaskPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskForTaskPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskForTaskPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskForTaskPermissionsQuery, GetTaskForTaskPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskForTaskPermissionsQuery, GetTaskForTaskPermissionsQueryVariables>(GetTaskForTaskPermissionsDocument, options);
      }
export function useGetTaskForTaskPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskForTaskPermissionsQuery, GetTaskForTaskPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskForTaskPermissionsQuery, GetTaskForTaskPermissionsQueryVariables>(GetTaskForTaskPermissionsDocument, options);
        }
export type GetTaskForTaskPermissionsQueryHookResult = ReturnType<typeof useGetTaskForTaskPermissionsQuery>;
export type GetTaskForTaskPermissionsLazyQueryHookResult = ReturnType<typeof useGetTaskForTaskPermissionsLazyQuery>;
export type GetTaskForTaskPermissionsQueryResult = Apollo.QueryResult<GetTaskForTaskPermissionsQuery, GetTaskForTaskPermissionsQueryVariables>;
export const TrackEventForAnalyticsDocument = gql`
    mutation TrackEventForAnalytics($data: TrackEventInput!) {
  trackEvent(data: $data) {
    success
  }
}
    `;
export type TrackEventForAnalyticsMutationFn = Apollo.MutationFunction<TrackEventForAnalyticsMutation, TrackEventForAnalyticsMutationVariables>;

/**
 * __useTrackEventForAnalyticsMutation__
 *
 * To run a mutation, you first call `useTrackEventForAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackEventForAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackEventForAnalyticsMutation, { data, loading, error }] = useTrackEventForAnalyticsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrackEventForAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<TrackEventForAnalyticsMutation, TrackEventForAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackEventForAnalyticsMutation, TrackEventForAnalyticsMutationVariables>(TrackEventForAnalyticsDocument, options);
      }
export type TrackEventForAnalyticsMutationHookResult = ReturnType<typeof useTrackEventForAnalyticsMutation>;
export type TrackEventForAnalyticsMutationResult = Apollo.MutationResult<TrackEventForAnalyticsMutation>;
export type TrackEventForAnalyticsMutationOptions = Apollo.BaseMutationOptions<TrackEventForAnalyticsMutation, TrackEventForAnalyticsMutationVariables>;
export const GetNonWorkDomainsDocument = gql`
    query GetNonWorkDomains {
  nonWorkDomains
}
    `;

/**
 * __useGetNonWorkDomainsQuery__
 *
 * To run a query within a React component, call `useGetNonWorkDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonWorkDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonWorkDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNonWorkDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetNonWorkDomainsQuery, GetNonWorkDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonWorkDomainsQuery, GetNonWorkDomainsQueryVariables>(GetNonWorkDomainsDocument, options);
      }
export function useGetNonWorkDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonWorkDomainsQuery, GetNonWorkDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonWorkDomainsQuery, GetNonWorkDomainsQueryVariables>(GetNonWorkDomainsDocument, options);
        }
export type GetNonWorkDomainsQueryHookResult = ReturnType<typeof useGetNonWorkDomainsQuery>;
export type GetNonWorkDomainsLazyQueryHookResult = ReturnType<typeof useGetNonWorkDomainsLazyQuery>;
export type GetNonWorkDomainsQueryResult = Apollo.QueryResult<GetNonWorkDomainsQuery, GetNonWorkDomainsQueryVariables>;
export const ViewEntityDocument = gql`
    mutation ViewEntity($data: ViewEntityInput!) {
  viewEntity(data: $data) {
    message
    success
  }
}
    `;
export type ViewEntityMutationFn = Apollo.MutationFunction<ViewEntityMutation, ViewEntityMutationVariables>;

/**
 * __useViewEntityMutation__
 *
 * To run a mutation, you first call `useViewEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewEntityMutation, { data, loading, error }] = useViewEntityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useViewEntityMutation(baseOptions?: Apollo.MutationHookOptions<ViewEntityMutation, ViewEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewEntityMutation, ViewEntityMutationVariables>(ViewEntityDocument, options);
      }
export type ViewEntityMutationHookResult = ReturnType<typeof useViewEntityMutation>;
export type ViewEntityMutationResult = Apollo.MutationResult<ViewEntityMutation>;
export type ViewEntityMutationOptions = Apollo.BaseMutationOptions<ViewEntityMutation, ViewEntityMutationVariables>;
export const GetSuggestedPostsForAiOrganizePageDocument = gql`
    query GetSuggestedPostsForAiOrganizePage {
  suggestedPostsForUser {
    ...PostFragmentAiOrganizePage
  }
}
    ${PostFragmentAiOrganizePageFragmentDoc}`;

/**
 * __useGetSuggestedPostsForAiOrganizePageQuery__
 *
 * To run a query within a React component, call `useGetSuggestedPostsForAiOrganizePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedPostsForAiOrganizePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedPostsForAiOrganizePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuggestedPostsForAiOrganizePageQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestedPostsForAiOrganizePageQuery, GetSuggestedPostsForAiOrganizePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedPostsForAiOrganizePageQuery, GetSuggestedPostsForAiOrganizePageQueryVariables>(GetSuggestedPostsForAiOrganizePageDocument, options);
      }
export function useGetSuggestedPostsForAiOrganizePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedPostsForAiOrganizePageQuery, GetSuggestedPostsForAiOrganizePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedPostsForAiOrganizePageQuery, GetSuggestedPostsForAiOrganizePageQueryVariables>(GetSuggestedPostsForAiOrganizePageDocument, options);
        }
export type GetSuggestedPostsForAiOrganizePageQueryHookResult = ReturnType<typeof useGetSuggestedPostsForAiOrganizePageQuery>;
export type GetSuggestedPostsForAiOrganizePageLazyQueryHookResult = ReturnType<typeof useGetSuggestedPostsForAiOrganizePageLazyQuery>;
export type GetSuggestedPostsForAiOrganizePageQueryResult = Apollo.QueryResult<GetSuggestedPostsForAiOrganizePageQuery, GetSuggestedPostsForAiOrganizePageQueryVariables>;
export const OrganizePostsForAiOrganizePageDocument = gql`
    mutation OrganizePostsForAiOrganizePage($data: OrganizePostsInput!) {
  organizePosts(data: $data) {
    success
    message
  }
}
    `;
export type OrganizePostsForAiOrganizePageMutationFn = Apollo.MutationFunction<OrganizePostsForAiOrganizePageMutation, OrganizePostsForAiOrganizePageMutationVariables>;

/**
 * __useOrganizePostsForAiOrganizePageMutation__
 *
 * To run a mutation, you first call `useOrganizePostsForAiOrganizePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizePostsForAiOrganizePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizePostsForAiOrganizePageMutation, { data, loading, error }] = useOrganizePostsForAiOrganizePageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrganizePostsForAiOrganizePageMutation(baseOptions?: Apollo.MutationHookOptions<OrganizePostsForAiOrganizePageMutation, OrganizePostsForAiOrganizePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizePostsForAiOrganizePageMutation, OrganizePostsForAiOrganizePageMutationVariables>(OrganizePostsForAiOrganizePageDocument, options);
      }
export type OrganizePostsForAiOrganizePageMutationHookResult = ReturnType<typeof useOrganizePostsForAiOrganizePageMutation>;
export type OrganizePostsForAiOrganizePageMutationResult = Apollo.MutationResult<OrganizePostsForAiOrganizePageMutation>;
export type OrganizePostsForAiOrganizePageMutationOptions = Apollo.BaseMutationOptions<OrganizePostsForAiOrganizePageMutation, OrganizePostsForAiOrganizePageMutationVariables>;
export const GetAttachmentForAttachmentDetailPageDocument = gql`
    query GetAttachmentForAttachmentDetailPage($id: String!) {
  attachment(id: $id) {
    id
    ...AttachmentFragmentAttachmentPreview
  }
}
    ${AttachmentFragmentAttachmentPreviewFragmentDoc}`;

/**
 * __useGetAttachmentForAttachmentDetailPageQuery__
 *
 * To run a query within a React component, call `useGetAttachmentForAttachmentDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentForAttachmentDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentForAttachmentDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttachmentForAttachmentDetailPageQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentForAttachmentDetailPageQuery, GetAttachmentForAttachmentDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentForAttachmentDetailPageQuery, GetAttachmentForAttachmentDetailPageQueryVariables>(GetAttachmentForAttachmentDetailPageDocument, options);
      }
export function useGetAttachmentForAttachmentDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentForAttachmentDetailPageQuery, GetAttachmentForAttachmentDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentForAttachmentDetailPageQuery, GetAttachmentForAttachmentDetailPageQueryVariables>(GetAttachmentForAttachmentDetailPageDocument, options);
        }
export type GetAttachmentForAttachmentDetailPageQueryHookResult = ReturnType<typeof useGetAttachmentForAttachmentDetailPageQuery>;
export type GetAttachmentForAttachmentDetailPageLazyQueryHookResult = ReturnType<typeof useGetAttachmentForAttachmentDetailPageLazyQuery>;
export type GetAttachmentForAttachmentDetailPageQueryResult = Apollo.QueryResult<GetAttachmentForAttachmentDetailPageQuery, GetAttachmentForAttachmentDetailPageQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($data: ForgotPasswordInput!) {
  forgotPassword(data: $data) {
    message
    success
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ValidateWorkosSignupDocument = gql`
    mutation ValidateWorkosSignup($data: String!, $source: LoginSource) {
  validateWorkosSignup(data: $data, source: $source) {
    ...AuthFragmentUserContext
  }
}
    ${AuthFragmentUserContextFragmentDoc}`;
export type ValidateWorkosSignupMutationFn = Apollo.MutationFunction<ValidateWorkosSignupMutation, ValidateWorkosSignupMutationVariables>;

/**
 * __useValidateWorkosSignupMutation__
 *
 * To run a mutation, you first call `useValidateWorkosSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateWorkosSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateWorkosSignupMutation, { data, loading, error }] = useValidateWorkosSignupMutation({
 *   variables: {
 *      data: // value for 'data'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useValidateWorkosSignupMutation(baseOptions?: Apollo.MutationHookOptions<ValidateWorkosSignupMutation, ValidateWorkosSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateWorkosSignupMutation, ValidateWorkosSignupMutationVariables>(ValidateWorkosSignupDocument, options);
      }
export type ValidateWorkosSignupMutationHookResult = ReturnType<typeof useValidateWorkosSignupMutation>;
export type ValidateWorkosSignupMutationResult = Apollo.MutationResult<ValidateWorkosSignupMutation>;
export type ValidateWorkosSignupMutationOptions = Apollo.BaseMutationOptions<ValidateWorkosSignupMutation, ValidateWorkosSignupMutationVariables>;
export const GenerateAuthUrlDocument = gql`
    query GenerateAuthURL {
  workosAuthUrl {
    loginUrl
    signupUrl
  }
}
    `;

/**
 * __useGenerateAuthUrlQuery__
 *
 * To run a query within a React component, call `useGenerateAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateAuthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateAuthUrlQuery(baseOptions?: Apollo.QueryHookOptions<GenerateAuthUrlQuery, GenerateAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateAuthUrlQuery, GenerateAuthUrlQueryVariables>(GenerateAuthUrlDocument, options);
      }
export function useGenerateAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateAuthUrlQuery, GenerateAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateAuthUrlQuery, GenerateAuthUrlQueryVariables>(GenerateAuthUrlDocument, options);
        }
export type GenerateAuthUrlQueryHookResult = ReturnType<typeof useGenerateAuthUrlQuery>;
export type GenerateAuthUrlLazyQueryHookResult = ReturnType<typeof useGenerateAuthUrlLazyQuery>;
export type GenerateAuthUrlQueryResult = Apollo.QueryResult<GenerateAuthUrlQuery, GenerateAuthUrlQueryVariables>;
export const GetBillingPricesForPlanDocument = gql`
    query GetBillingPricesForPlan($planName: String!) {
  getPricesForPlan(planName: $planName) {
    id
    currency
    recurringInterval
    amount
    unitAmountDecimal
  }
}
    `;

/**
 * __useGetBillingPricesForPlanQuery__
 *
 * To run a query within a React component, call `useGetBillingPricesForPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingPricesForPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingPricesForPlanQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useGetBillingPricesForPlanQuery(baseOptions: Apollo.QueryHookOptions<GetBillingPricesForPlanQuery, GetBillingPricesForPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingPricesForPlanQuery, GetBillingPricesForPlanQueryVariables>(GetBillingPricesForPlanDocument, options);
      }
export function useGetBillingPricesForPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingPricesForPlanQuery, GetBillingPricesForPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingPricesForPlanQuery, GetBillingPricesForPlanQueryVariables>(GetBillingPricesForPlanDocument, options);
        }
export type GetBillingPricesForPlanQueryHookResult = ReturnType<typeof useGetBillingPricesForPlanQuery>;
export type GetBillingPricesForPlanLazyQueryHookResult = ReturnType<typeof useGetBillingPricesForPlanLazyQuery>;
export type GetBillingPricesForPlanQueryResult = Apollo.QueryResult<GetBillingPricesForPlanQuery, GetBillingPricesForPlanQueryVariables>;
export const GetBillingCouponDocument = gql`
    mutation GetBillingCoupon($promotionCode: String!) {
  getCoupon(promotionCode: $promotionCode) {
    id
    amountOff
    percentOff
    duration
  }
}
    `;
export type GetBillingCouponMutationFn = Apollo.MutationFunction<GetBillingCouponMutation, GetBillingCouponMutationVariables>;

/**
 * __useGetBillingCouponMutation__
 *
 * To run a mutation, you first call `useGetBillingCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetBillingCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getBillingCouponMutation, { data, loading, error }] = useGetBillingCouponMutation({
 *   variables: {
 *      promotionCode: // value for 'promotionCode'
 *   },
 * });
 */
export function useGetBillingCouponMutation(baseOptions?: Apollo.MutationHookOptions<GetBillingCouponMutation, GetBillingCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetBillingCouponMutation, GetBillingCouponMutationVariables>(GetBillingCouponDocument, options);
      }
export type GetBillingCouponMutationHookResult = ReturnType<typeof useGetBillingCouponMutation>;
export type GetBillingCouponMutationResult = Apollo.MutationResult<GetBillingCouponMutation>;
export type GetBillingCouponMutationOptions = Apollo.BaseMutationOptions<GetBillingCouponMutation, GetBillingCouponMutationVariables>;
export const GetDefaultPaymentMethodForCheckoutDocument = gql`
    query GetDefaultPaymentMethodForCheckout {
  getDefaultPaymentMethod {
    ...BillingPaymentMethodFragmentPaymentDetails
  }
}
    ${BillingPaymentMethodFragmentPaymentDetailsFragmentDoc}`;

/**
 * __useGetDefaultPaymentMethodForCheckoutQuery__
 *
 * To run a query within a React component, call `useGetDefaultPaymentMethodForCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultPaymentMethodForCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultPaymentMethodForCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultPaymentMethodForCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultPaymentMethodForCheckoutQuery, GetDefaultPaymentMethodForCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultPaymentMethodForCheckoutQuery, GetDefaultPaymentMethodForCheckoutQueryVariables>(GetDefaultPaymentMethodForCheckoutDocument, options);
      }
export function useGetDefaultPaymentMethodForCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultPaymentMethodForCheckoutQuery, GetDefaultPaymentMethodForCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultPaymentMethodForCheckoutQuery, GetDefaultPaymentMethodForCheckoutQueryVariables>(GetDefaultPaymentMethodForCheckoutDocument, options);
        }
export type GetDefaultPaymentMethodForCheckoutQueryHookResult = ReturnType<typeof useGetDefaultPaymentMethodForCheckoutQuery>;
export type GetDefaultPaymentMethodForCheckoutLazyQueryHookResult = ReturnType<typeof useGetDefaultPaymentMethodForCheckoutLazyQuery>;
export type GetDefaultPaymentMethodForCheckoutQueryResult = Apollo.QueryResult<GetDefaultPaymentMethodForCheckoutQuery, GetDefaultPaymentMethodForCheckoutQueryVariables>;
export const CreateBillingSubscriptionForCheckoutDocument = gql`
    mutation CreateBillingSubscriptionForCheckout($data: CreateBillingSubscriptionInput!) {
  createSubscription(data: $data) {
    id
    clientSecret
    status
  }
}
    `;
export type CreateBillingSubscriptionForCheckoutMutationFn = Apollo.MutationFunction<CreateBillingSubscriptionForCheckoutMutation, CreateBillingSubscriptionForCheckoutMutationVariables>;

/**
 * __useCreateBillingSubscriptionForCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateBillingSubscriptionForCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingSubscriptionForCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingSubscriptionForCheckoutMutation, { data, loading, error }] = useCreateBillingSubscriptionForCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBillingSubscriptionForCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingSubscriptionForCheckoutMutation, CreateBillingSubscriptionForCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingSubscriptionForCheckoutMutation, CreateBillingSubscriptionForCheckoutMutationVariables>(CreateBillingSubscriptionForCheckoutDocument, options);
      }
export type CreateBillingSubscriptionForCheckoutMutationHookResult = ReturnType<typeof useCreateBillingSubscriptionForCheckoutMutation>;
export type CreateBillingSubscriptionForCheckoutMutationResult = Apollo.MutationResult<CreateBillingSubscriptionForCheckoutMutation>;
export type CreateBillingSubscriptionForCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateBillingSubscriptionForCheckoutMutation, CreateBillingSubscriptionForCheckoutMutationVariables>;
export const UpdateBillingSubscriptionForCheckoutDocument = gql`
    mutation UpdateBillingSubscriptionForCheckout($data: UpdateBillingSubscriptionInput!) {
  updateSubscription(data: $data) {
    id
    status
    clientSecret
  }
}
    `;
export type UpdateBillingSubscriptionForCheckoutMutationFn = Apollo.MutationFunction<UpdateBillingSubscriptionForCheckoutMutation, UpdateBillingSubscriptionForCheckoutMutationVariables>;

/**
 * __useUpdateBillingSubscriptionForCheckoutMutation__
 *
 * To run a mutation, you first call `useUpdateBillingSubscriptionForCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingSubscriptionForCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingSubscriptionForCheckoutMutation, { data, loading, error }] = useUpdateBillingSubscriptionForCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBillingSubscriptionForCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingSubscriptionForCheckoutMutation, UpdateBillingSubscriptionForCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingSubscriptionForCheckoutMutation, UpdateBillingSubscriptionForCheckoutMutationVariables>(UpdateBillingSubscriptionForCheckoutDocument, options);
      }
export type UpdateBillingSubscriptionForCheckoutMutationHookResult = ReturnType<typeof useUpdateBillingSubscriptionForCheckoutMutation>;
export type UpdateBillingSubscriptionForCheckoutMutationResult = Apollo.MutationResult<UpdateBillingSubscriptionForCheckoutMutation>;
export type UpdateBillingSubscriptionForCheckoutMutationOptions = Apollo.BaseMutationOptions<UpdateBillingSubscriptionForCheckoutMutation, UpdateBillingSubscriptionForCheckoutMutationVariables>;
export const CreateSetupIntentForCheckoutDocument = gql`
    mutation CreateSetupIntentForCheckout($data: CreateSetupIntentInput!) {
  createSetupIntent(data: $data) {
    id
    clientSecret
  }
}
    `;
export type CreateSetupIntentForCheckoutMutationFn = Apollo.MutationFunction<CreateSetupIntentForCheckoutMutation, CreateSetupIntentForCheckoutMutationVariables>;

/**
 * __useCreateSetupIntentForCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentForCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentForCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentForCheckoutMutation, { data, loading, error }] = useCreateSetupIntentForCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSetupIntentForCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentForCheckoutMutation, CreateSetupIntentForCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentForCheckoutMutation, CreateSetupIntentForCheckoutMutationVariables>(CreateSetupIntentForCheckoutDocument, options);
      }
export type CreateSetupIntentForCheckoutMutationHookResult = ReturnType<typeof useCreateSetupIntentForCheckoutMutation>;
export type CreateSetupIntentForCheckoutMutationResult = Apollo.MutationResult<CreateSetupIntentForCheckoutMutation>;
export type CreateSetupIntentForCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentForCheckoutMutation, CreateSetupIntentForCheckoutMutationVariables>;
export const ResumeSubscriptionForCheckoutDocument = gql`
    mutation ResumeSubscriptionForCheckout($data: ResumeBillingSubscriptionInput!) {
  resumeSubscription(data: $data) {
    id
    status
  }
}
    `;
export type ResumeSubscriptionForCheckoutMutationFn = Apollo.MutationFunction<ResumeSubscriptionForCheckoutMutation, ResumeSubscriptionForCheckoutMutationVariables>;

/**
 * __useResumeSubscriptionForCheckoutMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionForCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionForCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionForCheckoutMutation, { data, loading, error }] = useResumeSubscriptionForCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResumeSubscriptionForCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSubscriptionForCheckoutMutation, ResumeSubscriptionForCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSubscriptionForCheckoutMutation, ResumeSubscriptionForCheckoutMutationVariables>(ResumeSubscriptionForCheckoutDocument, options);
      }
export type ResumeSubscriptionForCheckoutMutationHookResult = ReturnType<typeof useResumeSubscriptionForCheckoutMutation>;
export type ResumeSubscriptionForCheckoutMutationResult = Apollo.MutationResult<ResumeSubscriptionForCheckoutMutation>;
export type ResumeSubscriptionForCheckoutMutationOptions = Apollo.BaseMutationOptions<ResumeSubscriptionForCheckoutMutation, ResumeSubscriptionForCheckoutMutationVariables>;
export const UpgradeDuringFreeTrialForCheckoutDocument = gql`
    mutation UpgradeDuringFreeTrialForCheckout($data: UpgradeDuringTrialInput!) {
  upgradeDuringFreeTrial(data: $data) {
    id
    status
  }
}
    `;
export type UpgradeDuringFreeTrialForCheckoutMutationFn = Apollo.MutationFunction<UpgradeDuringFreeTrialForCheckoutMutation, UpgradeDuringFreeTrialForCheckoutMutationVariables>;

/**
 * __useUpgradeDuringFreeTrialForCheckoutMutation__
 *
 * To run a mutation, you first call `useUpgradeDuringFreeTrialForCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeDuringFreeTrialForCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeDuringFreeTrialForCheckoutMutation, { data, loading, error }] = useUpgradeDuringFreeTrialForCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpgradeDuringFreeTrialForCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeDuringFreeTrialForCheckoutMutation, UpgradeDuringFreeTrialForCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeDuringFreeTrialForCheckoutMutation, UpgradeDuringFreeTrialForCheckoutMutationVariables>(UpgradeDuringFreeTrialForCheckoutDocument, options);
      }
export type UpgradeDuringFreeTrialForCheckoutMutationHookResult = ReturnType<typeof useUpgradeDuringFreeTrialForCheckoutMutation>;
export type UpgradeDuringFreeTrialForCheckoutMutationResult = Apollo.MutationResult<UpgradeDuringFreeTrialForCheckoutMutation>;
export type UpgradeDuringFreeTrialForCheckoutMutationOptions = Apollo.BaseMutationOptions<UpgradeDuringFreeTrialForCheckoutMutation, UpgradeDuringFreeTrialForCheckoutMutationVariables>;
export const GetCollectionForCollectionPageDocument = gql`
    query GetCollectionForCollectionPage($collectionId: String!) {
  collection(id: $collectionId) {
    ...CollectionFragmentCollectionPage
  }
}
    ${CollectionFragmentCollectionPageFragmentDoc}`;

/**
 * __useGetCollectionForCollectionPageQuery__
 *
 * To run a query within a React component, call `useGetCollectionForCollectionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForCollectionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForCollectionPageQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForCollectionPageQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForCollectionPageQuery, GetCollectionForCollectionPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForCollectionPageQuery, GetCollectionForCollectionPageQueryVariables>(GetCollectionForCollectionPageDocument, options);
      }
export function useGetCollectionForCollectionPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForCollectionPageQuery, GetCollectionForCollectionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForCollectionPageQuery, GetCollectionForCollectionPageQueryVariables>(GetCollectionForCollectionPageDocument, options);
        }
export type GetCollectionForCollectionPageQueryHookResult = ReturnType<typeof useGetCollectionForCollectionPageQuery>;
export type GetCollectionForCollectionPageLazyQueryHookResult = ReturnType<typeof useGetCollectionForCollectionPageLazyQuery>;
export type GetCollectionForCollectionPageQueryResult = Apollo.QueryResult<GetCollectionForCollectionPageQuery, GetCollectionForCollectionPageQueryVariables>;
export const GetUnreadCollectionCommentsForCollectionPageDocument = gql`
    query GetUnreadCollectionCommentsForCollectionPage($collectionId: String!) {
  unreadCollectionComments(collectionId: $collectionId)
}
    `;

/**
 * __useGetUnreadCollectionCommentsForCollectionPageQuery__
 *
 * To run a query within a React component, call `useGetUnreadCollectionCommentsForCollectionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadCollectionCommentsForCollectionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadCollectionCommentsForCollectionPageQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetUnreadCollectionCommentsForCollectionPageQuery(baseOptions: Apollo.QueryHookOptions<GetUnreadCollectionCommentsForCollectionPageQuery, GetUnreadCollectionCommentsForCollectionPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadCollectionCommentsForCollectionPageQuery, GetUnreadCollectionCommentsForCollectionPageQueryVariables>(GetUnreadCollectionCommentsForCollectionPageDocument, options);
      }
export function useGetUnreadCollectionCommentsForCollectionPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadCollectionCommentsForCollectionPageQuery, GetUnreadCollectionCommentsForCollectionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadCollectionCommentsForCollectionPageQuery, GetUnreadCollectionCommentsForCollectionPageQueryVariables>(GetUnreadCollectionCommentsForCollectionPageDocument, options);
        }
export type GetUnreadCollectionCommentsForCollectionPageQueryHookResult = ReturnType<typeof useGetUnreadCollectionCommentsForCollectionPageQuery>;
export type GetUnreadCollectionCommentsForCollectionPageLazyQueryHookResult = ReturnType<typeof useGetUnreadCollectionCommentsForCollectionPageLazyQuery>;
export type GetUnreadCollectionCommentsForCollectionPageQueryResult = Apollo.QueryResult<GetUnreadCollectionCommentsForCollectionPageQuery, GetUnreadCollectionCommentsForCollectionPageQueryVariables>;
export const GetContentIdeaCollectionsForCustomCollectionDocument = gql`
    query GetContentIdeaCollectionsForCustomCollection($after: String, $take: Int, $skip: Int, $sortBy: SortByInputData) {
  contentIdeaCollections(after: $after, take: $take, skip: $skip, sortBy: $sortBy) {
    data {
      ...CollectionFragmentCollectionPostDndCollectionCard
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${CollectionFragmentCollectionPostDndCollectionCardFragmentDoc}`;

/**
 * __useGetContentIdeaCollectionsForCustomCollectionQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaCollectionsForCustomCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaCollectionsForCustomCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaCollectionsForCustomCollectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetContentIdeaCollectionsForCustomCollectionQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaCollectionsForCustomCollectionQuery, GetContentIdeaCollectionsForCustomCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaCollectionsForCustomCollectionQuery, GetContentIdeaCollectionsForCustomCollectionQueryVariables>(GetContentIdeaCollectionsForCustomCollectionDocument, options);
      }
export function useGetContentIdeaCollectionsForCustomCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaCollectionsForCustomCollectionQuery, GetContentIdeaCollectionsForCustomCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaCollectionsForCustomCollectionQuery, GetContentIdeaCollectionsForCustomCollectionQueryVariables>(GetContentIdeaCollectionsForCustomCollectionDocument, options);
        }
export type GetContentIdeaCollectionsForCustomCollectionQueryHookResult = ReturnType<typeof useGetContentIdeaCollectionsForCustomCollectionQuery>;
export type GetContentIdeaCollectionsForCustomCollectionLazyQueryHookResult = ReturnType<typeof useGetContentIdeaCollectionsForCustomCollectionLazyQuery>;
export type GetContentIdeaCollectionsForCustomCollectionQueryResult = Apollo.QueryResult<GetContentIdeaCollectionsForCustomCollectionQuery, GetContentIdeaCollectionsForCustomCollectionQueryVariables>;
export const GetPostsSmartSearchForCollectionPageCustomCollectionDocument = gql`
    query GetPostsSmartSearchForCollectionPageCustomCollection($filters: PostFiltersForSmartSearch!, $take: Int, $after: String, $sortType: SortType) {
  postsSmartSearch(
    filters: $filters
    take: $take
    after: $after
    sortType: $sortType
  ) {
    data {
      item {
        ...PostFragmentCollectionPostDndPostCard
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentCollectionPostDndPostCardFragmentDoc}`;

/**
 * __useGetPostsSmartSearchForCollectionPageCustomCollectionQuery__
 *
 * To run a query within a React component, call `useGetPostsSmartSearchForCollectionPageCustomCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSmartSearchForCollectionPageCustomCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSmartSearchForCollectionPageCustomCollectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetPostsSmartSearchForCollectionPageCustomCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetPostsSmartSearchForCollectionPageCustomCollectionQuery, GetPostsSmartSearchForCollectionPageCustomCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsSmartSearchForCollectionPageCustomCollectionQuery, GetPostsSmartSearchForCollectionPageCustomCollectionQueryVariables>(GetPostsSmartSearchForCollectionPageCustomCollectionDocument, options);
      }
export function useGetPostsSmartSearchForCollectionPageCustomCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsSmartSearchForCollectionPageCustomCollectionQuery, GetPostsSmartSearchForCollectionPageCustomCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsSmartSearchForCollectionPageCustomCollectionQuery, GetPostsSmartSearchForCollectionPageCustomCollectionQueryVariables>(GetPostsSmartSearchForCollectionPageCustomCollectionDocument, options);
        }
export type GetPostsSmartSearchForCollectionPageCustomCollectionQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForCollectionPageCustomCollectionQuery>;
export type GetPostsSmartSearchForCollectionPageCustomCollectionLazyQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForCollectionPageCustomCollectionLazyQuery>;
export type GetPostsSmartSearchForCollectionPageCustomCollectionQueryResult = Apollo.QueryResult<GetPostsSmartSearchForCollectionPageCustomCollectionQuery, GetPostsSmartSearchForCollectionPageCustomCollectionQueryVariables>;
export const GetPostsSmartSearchForCollectionPageNormalCollectionDocument = gql`
    query GetPostsSmartSearchForCollectionPageNormalCollection($filters: PostFiltersForSmartSearch!, $take: Int, $after: String, $sortType: SortType) {
  postsSmartSearch(
    filters: $filters
    take: $take
    after: $after
    sortType: $sortType
  ) {
    data {
      item {
        id
        ...PostFragmentCollectionPostDndPostCard
        ...PostFragmentJuiceboxTablePostTableRowWithContextMenu
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentCollectionPostDndPostCardFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowWithContextMenuFragmentDoc}`;

/**
 * __useGetPostsSmartSearchForCollectionPageNormalCollectionQuery__
 *
 * To run a query within a React component, call `useGetPostsSmartSearchForCollectionPageNormalCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSmartSearchForCollectionPageNormalCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSmartSearchForCollectionPageNormalCollectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetPostsSmartSearchForCollectionPageNormalCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetPostsSmartSearchForCollectionPageNormalCollectionQuery, GetPostsSmartSearchForCollectionPageNormalCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsSmartSearchForCollectionPageNormalCollectionQuery, GetPostsSmartSearchForCollectionPageNormalCollectionQueryVariables>(GetPostsSmartSearchForCollectionPageNormalCollectionDocument, options);
      }
export function useGetPostsSmartSearchForCollectionPageNormalCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsSmartSearchForCollectionPageNormalCollectionQuery, GetPostsSmartSearchForCollectionPageNormalCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsSmartSearchForCollectionPageNormalCollectionQuery, GetPostsSmartSearchForCollectionPageNormalCollectionQueryVariables>(GetPostsSmartSearchForCollectionPageNormalCollectionDocument, options);
        }
export type GetPostsSmartSearchForCollectionPageNormalCollectionQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForCollectionPageNormalCollectionQuery>;
export type GetPostsSmartSearchForCollectionPageNormalCollectionLazyQueryHookResult = ReturnType<typeof useGetPostsSmartSearchForCollectionPageNormalCollectionLazyQuery>;
export type GetPostsSmartSearchForCollectionPageNormalCollectionQueryResult = Apollo.QueryResult<GetPostsSmartSearchForCollectionPageNormalCollectionQuery, GetPostsSmartSearchForCollectionPageNormalCollectionQueryVariables>;
export const GetSuggestedPostsForCollectionPageDocument = gql`
    query GetSuggestedPostsForCollectionPage($filters: SuggestedPostsFilters!) {
  suggestedPosts(filters: $filters) {
    ...PostFragmentPostSuggestionCardView
    ...PostFragmentPostMasonryCardView
  }
}
    ${PostFragmentPostSuggestionCardViewFragmentDoc}
${PostFragmentPostMasonryCardViewFragmentDoc}`;

/**
 * __useGetSuggestedPostsForCollectionPageQuery__
 *
 * To run a query within a React component, call `useGetSuggestedPostsForCollectionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedPostsForCollectionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedPostsForCollectionPageQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSuggestedPostsForCollectionPageQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedPostsForCollectionPageQuery, GetSuggestedPostsForCollectionPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedPostsForCollectionPageQuery, GetSuggestedPostsForCollectionPageQueryVariables>(GetSuggestedPostsForCollectionPageDocument, options);
      }
export function useGetSuggestedPostsForCollectionPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedPostsForCollectionPageQuery, GetSuggestedPostsForCollectionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedPostsForCollectionPageQuery, GetSuggestedPostsForCollectionPageQueryVariables>(GetSuggestedPostsForCollectionPageDocument, options);
        }
export type GetSuggestedPostsForCollectionPageQueryHookResult = ReturnType<typeof useGetSuggestedPostsForCollectionPageQuery>;
export type GetSuggestedPostsForCollectionPageLazyQueryHookResult = ReturnType<typeof useGetSuggestedPostsForCollectionPageLazyQuery>;
export type GetSuggestedPostsForCollectionPageQueryResult = Apollo.QueryResult<GetSuggestedPostsForCollectionPageQuery, GetSuggestedPostsForCollectionPageQueryVariables>;
export const AddPostToCollectionForCollectionPageDocument = gql`
    mutation AddPostToCollectionForCollectionPage($data: AddPostToCollectionInput!) {
  addPostToCollection(data: $data) {
    success
    message
  }
}
    `;
export type AddPostToCollectionForCollectionPageMutationFn = Apollo.MutationFunction<AddPostToCollectionForCollectionPageMutation, AddPostToCollectionForCollectionPageMutationVariables>;

/**
 * __useAddPostToCollectionForCollectionPageMutation__
 *
 * To run a mutation, you first call `useAddPostToCollectionForCollectionPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostToCollectionForCollectionPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostToCollectionForCollectionPageMutation, { data, loading, error }] = useAddPostToCollectionForCollectionPageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPostToCollectionForCollectionPageMutation(baseOptions?: Apollo.MutationHookOptions<AddPostToCollectionForCollectionPageMutation, AddPostToCollectionForCollectionPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostToCollectionForCollectionPageMutation, AddPostToCollectionForCollectionPageMutationVariables>(AddPostToCollectionForCollectionPageDocument, options);
      }
export type AddPostToCollectionForCollectionPageMutationHookResult = ReturnType<typeof useAddPostToCollectionForCollectionPageMutation>;
export type AddPostToCollectionForCollectionPageMutationResult = Apollo.MutationResult<AddPostToCollectionForCollectionPageMutation>;
export type AddPostToCollectionForCollectionPageMutationOptions = Apollo.BaseMutationOptions<AddPostToCollectionForCollectionPageMutation, AddPostToCollectionForCollectionPageMutationVariables>;
export const DeletePostForCollectionPageDocument = gql`
    mutation DeletePostForCollectionPage($data: DeleteSuggestedPostInput!) {
  deleteSuggestedPost(data: $data) {
    message
    success
  }
}
    `;
export type DeletePostForCollectionPageMutationFn = Apollo.MutationFunction<DeletePostForCollectionPageMutation, DeletePostForCollectionPageMutationVariables>;

/**
 * __useDeletePostForCollectionPageMutation__
 *
 * To run a mutation, you first call `useDeletePostForCollectionPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostForCollectionPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostForCollectionPageMutation, { data, loading, error }] = useDeletePostForCollectionPageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePostForCollectionPageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostForCollectionPageMutation, DeletePostForCollectionPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostForCollectionPageMutation, DeletePostForCollectionPageMutationVariables>(DeletePostForCollectionPageDocument, options);
      }
export type DeletePostForCollectionPageMutationHookResult = ReturnType<typeof useDeletePostForCollectionPageMutation>;
export type DeletePostForCollectionPageMutationResult = Apollo.MutationResult<DeletePostForCollectionPageMutation>;
export type DeletePostForCollectionPageMutationOptions = Apollo.BaseMutationOptions<DeletePostForCollectionPageMutation, DeletePostForCollectionPageMutationVariables>;
export const GetContentIdeaMetaStatsForContentCalendarDocument = gql`
    query GetContentIdeaMetaStatsForContentCalendar($filters: ContentIdeaFilters) {
  contentIdeaMetaStats(filters: $filters) {
    braindumpTotalCount
    productionTotalCount
    publishTotalCount
    iceboxTotalCount
  }
}
    `;

/**
 * __useGetContentIdeaMetaStatsForContentCalendarQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaMetaStatsForContentCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaMetaStatsForContentCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaMetaStatsForContentCalendarQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetContentIdeaMetaStatsForContentCalendarQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaMetaStatsForContentCalendarQuery, GetContentIdeaMetaStatsForContentCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaMetaStatsForContentCalendarQuery, GetContentIdeaMetaStatsForContentCalendarQueryVariables>(GetContentIdeaMetaStatsForContentCalendarDocument, options);
      }
export function useGetContentIdeaMetaStatsForContentCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaMetaStatsForContentCalendarQuery, GetContentIdeaMetaStatsForContentCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaMetaStatsForContentCalendarQuery, GetContentIdeaMetaStatsForContentCalendarQueryVariables>(GetContentIdeaMetaStatsForContentCalendarDocument, options);
        }
export type GetContentIdeaMetaStatsForContentCalendarQueryHookResult = ReturnType<typeof useGetContentIdeaMetaStatsForContentCalendarQuery>;
export type GetContentIdeaMetaStatsForContentCalendarLazyQueryHookResult = ReturnType<typeof useGetContentIdeaMetaStatsForContentCalendarLazyQuery>;
export type GetContentIdeaMetaStatsForContentCalendarQueryResult = Apollo.QueryResult<GetContentIdeaMetaStatsForContentCalendarQuery, GetContentIdeaMetaStatsForContentCalendarQueryVariables>;
export const UpdateUserOnboardingStateForContentCalendarOnboardingViewDocument = gql`
    mutation UpdateUserOnboardingStateForContentCalendarOnboardingView($data: UpdateUserOnboardingStateInput!) {
  updateUserOnboardingState(data: $data) {
    id
    onboardingState {
      hasSeenContentCalendarOnboarding
    }
  }
}
    `;
export type UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationFn = Apollo.MutationFunction<UpdateUserOnboardingStateForContentCalendarOnboardingViewMutation, UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationVariables>;

/**
 * __useUpdateUserOnboardingStateForContentCalendarOnboardingViewMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingStateForContentCalendarOnboardingViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingStateForContentCalendarOnboardingViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingStateForContentCalendarOnboardingViewMutation, { data, loading, error }] = useUpdateUserOnboardingStateForContentCalendarOnboardingViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOnboardingStateForContentCalendarOnboardingViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingStateForContentCalendarOnboardingViewMutation, UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingStateForContentCalendarOnboardingViewMutation, UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationVariables>(UpdateUserOnboardingStateForContentCalendarOnboardingViewDocument, options);
      }
export type UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationHookResult = ReturnType<typeof useUpdateUserOnboardingStateForContentCalendarOnboardingViewMutation>;
export type UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationResult = Apollo.MutationResult<UpdateUserOnboardingStateForContentCalendarOnboardingViewMutation>;
export type UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingStateForContentCalendarOnboardingViewMutation, UpdateUserOnboardingStateForContentCalendarOnboardingViewMutationVariables>;
export const GetContentIdeaForContentCalendarPageSplitViewDocument = gql`
    query GetContentIdeaForContentCalendarPageSplitView($id: String!) {
  contentIdea(id: $id) {
    id
    ...ContentIdeaFragmentContentIdeaDetailView
  }
}
    ${ContentIdeaFragmentContentIdeaDetailViewFragmentDoc}`;

/**
 * __useGetContentIdeaForContentCalendarPageSplitViewQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaForContentCalendarPageSplitViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaForContentCalendarPageSplitViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaForContentCalendarPageSplitViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentIdeaForContentCalendarPageSplitViewQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeaForContentCalendarPageSplitViewQuery, GetContentIdeaForContentCalendarPageSplitViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaForContentCalendarPageSplitViewQuery, GetContentIdeaForContentCalendarPageSplitViewQueryVariables>(GetContentIdeaForContentCalendarPageSplitViewDocument, options);
      }
export function useGetContentIdeaForContentCalendarPageSplitViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaForContentCalendarPageSplitViewQuery, GetContentIdeaForContentCalendarPageSplitViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaForContentCalendarPageSplitViewQuery, GetContentIdeaForContentCalendarPageSplitViewQueryVariables>(GetContentIdeaForContentCalendarPageSplitViewDocument, options);
        }
export type GetContentIdeaForContentCalendarPageSplitViewQueryHookResult = ReturnType<typeof useGetContentIdeaForContentCalendarPageSplitViewQuery>;
export type GetContentIdeaForContentCalendarPageSplitViewLazyQueryHookResult = ReturnType<typeof useGetContentIdeaForContentCalendarPageSplitViewLazyQuery>;
export type GetContentIdeaForContentCalendarPageSplitViewQueryResult = Apollo.QueryResult<GetContentIdeaForContentCalendarPageSplitViewQuery, GetContentIdeaForContentCalendarPageSplitViewQueryVariables>;
export const GetContentIdeaFieldsForContentCalendarPageCalendarSectionDocument = gql`
    query GetContentIdeaFieldsForContentCalendarPageCalendarSection {
  contentIdeaFields {
    id
    name
    type
  }
}
    `;

/**
 * __useGetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery, GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery, GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryVariables>(GetContentIdeaFieldsForContentCalendarPageCalendarSectionDocument, options);
      }
export function useGetContentIdeaFieldsForContentCalendarPageCalendarSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery, GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery, GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryVariables>(GetContentIdeaFieldsForContentCalendarPageCalendarSectionDocument, options);
        }
export type GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery>;
export type GetContentIdeaFieldsForContentCalendarPageCalendarSectionLazyQueryHookResult = ReturnType<typeof useGetContentIdeaFieldsForContentCalendarPageCalendarSectionLazyQuery>;
export type GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryResult = Apollo.QueryResult<GetContentIdeaFieldsForContentCalendarPageCalendarSectionQuery, GetContentIdeaFieldsForContentCalendarPageCalendarSectionQueryVariables>;
export const GetContentIdeasForContentCalendarPageCalendarSectionDocument = gql`
    query GetContentIdeasForContentCalendarPageCalendarSection($filters: ContentIdeaFilters!, $sortBy: SortByInputData, $take: Int) {
  contentIdeas(filters: $filters, sortBy: $sortBy, take: $take) {
    data {
      id
      myPermissions
      ...ContentIdeaFragmentContentIdeaCalendarEventView
    }
  }
}
    ${ContentIdeaFragmentContentIdeaCalendarEventViewFragmentDoc}`;

/**
 * __useGetContentIdeasForContentCalendarPageCalendarSectionQuery__
 *
 * To run a query within a React component, call `useGetContentIdeasForContentCalendarPageCalendarSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeasForContentCalendarPageCalendarSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeasForContentCalendarPageCalendarSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetContentIdeasForContentCalendarPageCalendarSectionQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeasForContentCalendarPageCalendarSectionQuery, GetContentIdeasForContentCalendarPageCalendarSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeasForContentCalendarPageCalendarSectionQuery, GetContentIdeasForContentCalendarPageCalendarSectionQueryVariables>(GetContentIdeasForContentCalendarPageCalendarSectionDocument, options);
      }
export function useGetContentIdeasForContentCalendarPageCalendarSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeasForContentCalendarPageCalendarSectionQuery, GetContentIdeasForContentCalendarPageCalendarSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeasForContentCalendarPageCalendarSectionQuery, GetContentIdeasForContentCalendarPageCalendarSectionQueryVariables>(GetContentIdeasForContentCalendarPageCalendarSectionDocument, options);
        }
export type GetContentIdeasForContentCalendarPageCalendarSectionQueryHookResult = ReturnType<typeof useGetContentIdeasForContentCalendarPageCalendarSectionQuery>;
export type GetContentIdeasForContentCalendarPageCalendarSectionLazyQueryHookResult = ReturnType<typeof useGetContentIdeasForContentCalendarPageCalendarSectionLazyQuery>;
export type GetContentIdeasForContentCalendarPageCalendarSectionQueryResult = Apollo.QueryResult<GetContentIdeasForContentCalendarPageCalendarSectionQuery, GetContentIdeasForContentCalendarPageCalendarSectionQueryVariables>;
export const UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionDocument = gql`
    mutation UpdateContentIdeaFieldValueForContentCalendarPageCalendarSection($data: UpdateContentIdeaFieldValueInput!) {
  updateContentIdeaFieldValue(data: $data) {
    id
    value {
      id
      date
    }
  }
}
    `;
export type UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationFn = Apollo.MutationFunction<UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation, UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationVariables>;

/**
 * __useUpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation, { data, loading, error }] = useUpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation, UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation, UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationVariables>(UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionDocument, options);
      }
export type UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationHookResult = ReturnType<typeof useUpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation>;
export type UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationResult = Apollo.MutationResult<UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation>;
export type UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutation, UpdateContentIdeaFieldValueForContentCalendarPageCalendarSectionMutationVariables>;
export const ResyncFromSocialsDocument = gql`
    mutation ResyncFromSocials {
  resyncFromSocials {
    success
    message
  }
}
    `;
export type ResyncFromSocialsMutationFn = Apollo.MutationFunction<ResyncFromSocialsMutation, ResyncFromSocialsMutationVariables>;

/**
 * __useResyncFromSocialsMutation__
 *
 * To run a mutation, you first call `useResyncFromSocialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncFromSocialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncFromSocialsMutation, { data, loading, error }] = useResyncFromSocialsMutation({
 *   variables: {
 *   },
 * });
 */
export function useResyncFromSocialsMutation(baseOptions?: Apollo.MutationHookOptions<ResyncFromSocialsMutation, ResyncFromSocialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncFromSocialsMutation, ResyncFromSocialsMutationVariables>(ResyncFromSocialsDocument, options);
      }
export type ResyncFromSocialsMutationHookResult = ReturnType<typeof useResyncFromSocialsMutation>;
export type ResyncFromSocialsMutationResult = Apollo.MutationResult<ResyncFromSocialsMutation>;
export type ResyncFromSocialsMutationOptions = Apollo.BaseMutationOptions<ResyncFromSocialsMutation, ResyncFromSocialsMutationVariables>;
export const GetContentIdeasForContentCalendarPageListSectionDocument = gql`
    query GetContentIdeasForContentCalendarPageListSection($filters: ContentIdeaFilters!, $sortBy: SortByInputData, $before: String, $after: String, $skip: Int, $take: Int) {
  contentIdeas(
    filters: $filters
    sortBy: $sortBy
    before: $before
    after: $after
    skip: $skip
    take: $take
  ) {
    data {
      id
      ...ContentIdeaFragmentContentCalendarPageListSection
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ContentIdeaFragmentContentCalendarPageListSectionFragmentDoc}`;

/**
 * __useGetContentIdeasForContentCalendarPageListSectionQuery__
 *
 * To run a query within a React component, call `useGetContentIdeasForContentCalendarPageListSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeasForContentCalendarPageListSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeasForContentCalendarPageListSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetContentIdeasForContentCalendarPageListSectionQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeasForContentCalendarPageListSectionQuery, GetContentIdeasForContentCalendarPageListSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeasForContentCalendarPageListSectionQuery, GetContentIdeasForContentCalendarPageListSectionQueryVariables>(GetContentIdeasForContentCalendarPageListSectionDocument, options);
      }
export function useGetContentIdeasForContentCalendarPageListSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeasForContentCalendarPageListSectionQuery, GetContentIdeasForContentCalendarPageListSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeasForContentCalendarPageListSectionQuery, GetContentIdeasForContentCalendarPageListSectionQueryVariables>(GetContentIdeasForContentCalendarPageListSectionDocument, options);
        }
export type GetContentIdeasForContentCalendarPageListSectionQueryHookResult = ReturnType<typeof useGetContentIdeasForContentCalendarPageListSectionQuery>;
export type GetContentIdeasForContentCalendarPageListSectionLazyQueryHookResult = ReturnType<typeof useGetContentIdeasForContentCalendarPageListSectionLazyQuery>;
export type GetContentIdeasForContentCalendarPageListSectionQueryResult = Apollo.QueryResult<GetContentIdeasForContentCalendarPageListSectionQuery, GetContentIdeasForContentCalendarPageListSectionQueryVariables>;
export const CreateContentIdeaForContentCalendarPageListSectionDocument = gql`
    mutation CreateContentIdeaForContentCalendarPageListSection($data: CreateContentIdeaInput!) {
  createContentIdea(data: $data) {
    id
    ...ContentIdeaFragmentContentCalendarPageListSection
  }
}
    ${ContentIdeaFragmentContentCalendarPageListSectionFragmentDoc}`;
export type CreateContentIdeaForContentCalendarPageListSectionMutationFn = Apollo.MutationFunction<CreateContentIdeaForContentCalendarPageListSectionMutation, CreateContentIdeaForContentCalendarPageListSectionMutationVariables>;

/**
 * __useCreateContentIdeaForContentCalendarPageListSectionMutation__
 *
 * To run a mutation, you first call `useCreateContentIdeaForContentCalendarPageListSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentIdeaForContentCalendarPageListSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentIdeaForContentCalendarPageListSectionMutation, { data, loading, error }] = useCreateContentIdeaForContentCalendarPageListSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentIdeaForContentCalendarPageListSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentIdeaForContentCalendarPageListSectionMutation, CreateContentIdeaForContentCalendarPageListSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentIdeaForContentCalendarPageListSectionMutation, CreateContentIdeaForContentCalendarPageListSectionMutationVariables>(CreateContentIdeaForContentCalendarPageListSectionDocument, options);
      }
export type CreateContentIdeaForContentCalendarPageListSectionMutationHookResult = ReturnType<typeof useCreateContentIdeaForContentCalendarPageListSectionMutation>;
export type CreateContentIdeaForContentCalendarPageListSectionMutationResult = Apollo.MutationResult<CreateContentIdeaForContentCalendarPageListSectionMutation>;
export type CreateContentIdeaForContentCalendarPageListSectionMutationOptions = Apollo.BaseMutationOptions<CreateContentIdeaForContentCalendarPageListSectionMutation, CreateContentIdeaForContentCalendarPageListSectionMutationVariables>;
export const UpdateContentIdeaForContentCalendarPageListSectionDocument = gql`
    mutation UpdateContentIdeaForContentCalendarPageListSection($data: UpdateContentIdeaInput!) {
  updateContentIdea(data: $data) {
    id
  }
}
    `;
export type UpdateContentIdeaForContentCalendarPageListSectionMutationFn = Apollo.MutationFunction<UpdateContentIdeaForContentCalendarPageListSectionMutation, UpdateContentIdeaForContentCalendarPageListSectionMutationVariables>;

/**
 * __useUpdateContentIdeaForContentCalendarPageListSectionMutation__
 *
 * To run a mutation, you first call `useUpdateContentIdeaForContentCalendarPageListSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentIdeaForContentCalendarPageListSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentIdeaForContentCalendarPageListSectionMutation, { data, loading, error }] = useUpdateContentIdeaForContentCalendarPageListSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentIdeaForContentCalendarPageListSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentIdeaForContentCalendarPageListSectionMutation, UpdateContentIdeaForContentCalendarPageListSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentIdeaForContentCalendarPageListSectionMutation, UpdateContentIdeaForContentCalendarPageListSectionMutationVariables>(UpdateContentIdeaForContentCalendarPageListSectionDocument, options);
      }
export type UpdateContentIdeaForContentCalendarPageListSectionMutationHookResult = ReturnType<typeof useUpdateContentIdeaForContentCalendarPageListSectionMutation>;
export type UpdateContentIdeaForContentCalendarPageListSectionMutationResult = Apollo.MutationResult<UpdateContentIdeaForContentCalendarPageListSectionMutation>;
export type UpdateContentIdeaForContentCalendarPageListSectionMutationOptions = Apollo.BaseMutationOptions<UpdateContentIdeaForContentCalendarPageListSectionMutation, UpdateContentIdeaForContentCalendarPageListSectionMutationVariables>;
export const GetContentIdeaForContentIdeaPageDocument = gql`
    query GetContentIdeaForContentIdeaPage($id: String!) {
  contentIdea(id: $id) {
    id
    ...ContentIdeaFragmentContentIdeaPage
  }
}
    ${ContentIdeaFragmentContentIdeaPageFragmentDoc}`;

/**
 * __useGetContentIdeaForContentIdeaPageQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaForContentIdeaPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaForContentIdeaPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaForContentIdeaPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentIdeaForContentIdeaPageQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeaForContentIdeaPageQuery, GetContentIdeaForContentIdeaPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaForContentIdeaPageQuery, GetContentIdeaForContentIdeaPageQueryVariables>(GetContentIdeaForContentIdeaPageDocument, options);
      }
export function useGetContentIdeaForContentIdeaPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaForContentIdeaPageQuery, GetContentIdeaForContentIdeaPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaForContentIdeaPageQuery, GetContentIdeaForContentIdeaPageQueryVariables>(GetContentIdeaForContentIdeaPageDocument, options);
        }
export type GetContentIdeaForContentIdeaPageQueryHookResult = ReturnType<typeof useGetContentIdeaForContentIdeaPageQuery>;
export type GetContentIdeaForContentIdeaPageLazyQueryHookResult = ReturnType<typeof useGetContentIdeaForContentIdeaPageLazyQuery>;
export type GetContentIdeaForContentIdeaPageQueryResult = Apollo.QueryResult<GetContentIdeaForContentIdeaPageQuery, GetContentIdeaForContentIdeaPageQueryVariables>;
export const GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalDocument = gql`
    query GetOrganizationAccessRequestForInboxBrandInviteMemberApproval($organizationAccessRequestId: String!) {
  organizationAccessRequest(id: $organizationAccessRequestId) {
    id
    status
    user {
      id
      email
    }
    updatedBy {
      ...UserProfileFragmentInboxBrandInviteMemberApproval
    }
  }
}
    ${UserProfileFragmentInboxBrandInviteMemberApprovalFragmentDoc}`;

/**
 * __useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery({
 *   variables: {
 *      organizationAccessRequestId: // value for 'organizationAccessRequestId'
 *   },
 * });
 */
export function useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery, GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery, GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryVariables>(GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalDocument, options);
      }
export function useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery, GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery, GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryVariables>(GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalDocument, options);
        }
export type GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryHookResult = ReturnType<typeof useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery>;
export type GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalLazyQueryHookResult = ReturnType<typeof useGetOrganizationAccessRequestForInboxBrandInviteMemberApprovalLazyQuery>;
export type GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryResult = Apollo.QueryResult<GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQuery, GetOrganizationAccessRequestForInboxBrandInviteMemberApprovalQueryVariables>;
export const ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalDocument = gql`
    mutation ApproveOrganizationAccessRequestForInboxBrandInviteMemberApproval($data: ApproveOrganizationUserAccessRequestInput!) {
  approveOrganizationAccessRequest(data: $data) {
    id
    status
  }
}
    `;
export type ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationFn = Apollo.MutationFunction<ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>;

/**
 * __useApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation__
 *
 * To run a mutation, you first call `useApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, { data, loading, error }] = useApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>(ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalDocument, options);
      }
export type ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationHookResult = ReturnType<typeof useApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation>;
export type ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationResult = Apollo.MutationResult<ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation>;
export type ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationOptions = Apollo.BaseMutationOptions<ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, ApproveOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>;
export const RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalDocument = gql`
    mutation RejectOrganizationAccessRequestForInboxBrandInviteMemberApproval($data: RejectOrganizationUserAccessRequestInput!) {
  rejectOrganizationAccessRequest(data: $data) {
    id
    status
  }
}
    `;
export type RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationFn = Apollo.MutationFunction<RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>;

/**
 * __useRejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation__
 *
 * To run a mutation, you first call `useRejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, { data, loading, error }] = useRejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>(RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalDocument, options);
      }
export type RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationHookResult = ReturnType<typeof useRejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation>;
export type RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationResult = Apollo.MutationResult<RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation>;
export type RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationOptions = Apollo.BaseMutationOptions<RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutation, RejectOrganizationAccessRequestForInboxBrandInviteMemberApprovalMutationVariables>;
export const GetCollectionForInboxDocument = gql`
    query GetCollectionForInbox($id: String!) {
  collection(id: $id) {
    ...CollectionFragmentCollectionPage
  }
}
    ${CollectionFragmentCollectionPageFragmentDoc}`;

/**
 * __useGetCollectionForInboxQuery__
 *
 * To run a query within a React component, call `useGetCollectionForInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForInboxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionForInboxQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionForInboxQuery, GetCollectionForInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionForInboxQuery, GetCollectionForInboxQueryVariables>(GetCollectionForInboxDocument, options);
      }
export function useGetCollectionForInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionForInboxQuery, GetCollectionForInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionForInboxQuery, GetCollectionForInboxQueryVariables>(GetCollectionForInboxDocument, options);
        }
export type GetCollectionForInboxQueryHookResult = ReturnType<typeof useGetCollectionForInboxQuery>;
export type GetCollectionForInboxLazyQueryHookResult = ReturnType<typeof useGetCollectionForInboxLazyQuery>;
export type GetCollectionForInboxQueryResult = Apollo.QueryResult<GetCollectionForInboxQuery, GetCollectionForInboxQueryVariables>;
export const GetContentIdeaForInboxContentIdeaDocument = gql`
    query GetContentIdeaForInboxContentIdea($id: String!) {
  contentIdea(id: $id) {
    id
    ...ContentIdeaFragmentContentIdeaDetailView
  }
}
    ${ContentIdeaFragmentContentIdeaDetailViewFragmentDoc}`;

/**
 * __useGetContentIdeaForInboxContentIdeaQuery__
 *
 * To run a query within a React component, call `useGetContentIdeaForInboxContentIdeaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdeaForInboxContentIdeaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdeaForInboxContentIdeaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentIdeaForInboxContentIdeaQuery(baseOptions: Apollo.QueryHookOptions<GetContentIdeaForInboxContentIdeaQuery, GetContentIdeaForInboxContentIdeaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdeaForInboxContentIdeaQuery, GetContentIdeaForInboxContentIdeaQueryVariables>(GetContentIdeaForInboxContentIdeaDocument, options);
      }
export function useGetContentIdeaForInboxContentIdeaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdeaForInboxContentIdeaQuery, GetContentIdeaForInboxContentIdeaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdeaForInboxContentIdeaQuery, GetContentIdeaForInboxContentIdeaQueryVariables>(GetContentIdeaForInboxContentIdeaDocument, options);
        }
export type GetContentIdeaForInboxContentIdeaQueryHookResult = ReturnType<typeof useGetContentIdeaForInboxContentIdeaQuery>;
export type GetContentIdeaForInboxContentIdeaLazyQueryHookResult = ReturnType<typeof useGetContentIdeaForInboxContentIdeaLazyQuery>;
export type GetContentIdeaForInboxContentIdeaQueryResult = Apollo.QueryResult<GetContentIdeaForInboxContentIdeaQuery, GetContentIdeaForInboxContentIdeaQueryVariables>;
export const GetPostForInboxMultiplePostMentionDocument = gql`
    query GetPostForInboxMultiplePostMention($id: String!) {
  post(id: $id) {
    ...PostFragmentJuiceModal
  }
}
    ${PostFragmentJuiceModalFragmentDoc}`;

/**
 * __useGetPostForInboxMultiplePostMentionQuery__
 *
 * To run a query within a React component, call `useGetPostForInboxMultiplePostMentionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForInboxMultiplePostMentionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForInboxMultiplePostMentionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForInboxMultiplePostMentionQuery(baseOptions: Apollo.QueryHookOptions<GetPostForInboxMultiplePostMentionQuery, GetPostForInboxMultiplePostMentionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForInboxMultiplePostMentionQuery, GetPostForInboxMultiplePostMentionQueryVariables>(GetPostForInboxMultiplePostMentionDocument, options);
      }
export function useGetPostForInboxMultiplePostMentionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForInboxMultiplePostMentionQuery, GetPostForInboxMultiplePostMentionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForInboxMultiplePostMentionQuery, GetPostForInboxMultiplePostMentionQueryVariables>(GetPostForInboxMultiplePostMentionDocument, options);
        }
export type GetPostForInboxMultiplePostMentionQueryHookResult = ReturnType<typeof useGetPostForInboxMultiplePostMentionQuery>;
export type GetPostForInboxMultiplePostMentionLazyQueryHookResult = ReturnType<typeof useGetPostForInboxMultiplePostMentionLazyQuery>;
export type GetPostForInboxMultiplePostMentionQueryResult = Apollo.QueryResult<GetPostForInboxMultiplePostMentionQuery, GetPostForInboxMultiplePostMentionQueryVariables>;
export const GetOrganizationAccessRequestForInboxDocument = gql`
    query GetOrganizationAccessRequestForInbox($organizationAccessRequestId: String!) {
  organizationAccessRequest(id: $organizationAccessRequestId) {
    ...OrganizationUserAccessRequestFragmentInboxContent
  }
}
    ${OrganizationUserAccessRequestFragmentInboxContentFragmentDoc}`;

/**
 * __useGetOrganizationAccessRequestForInboxQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAccessRequestForInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAccessRequestForInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAccessRequestForInboxQuery({
 *   variables: {
 *      organizationAccessRequestId: // value for 'organizationAccessRequestId'
 *   },
 * });
 */
export function useGetOrganizationAccessRequestForInboxQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAccessRequestForInboxQuery, GetOrganizationAccessRequestForInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAccessRequestForInboxQuery, GetOrganizationAccessRequestForInboxQueryVariables>(GetOrganizationAccessRequestForInboxDocument, options);
      }
export function useGetOrganizationAccessRequestForInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAccessRequestForInboxQuery, GetOrganizationAccessRequestForInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAccessRequestForInboxQuery, GetOrganizationAccessRequestForInboxQueryVariables>(GetOrganizationAccessRequestForInboxDocument, options);
        }
export type GetOrganizationAccessRequestForInboxQueryHookResult = ReturnType<typeof useGetOrganizationAccessRequestForInboxQuery>;
export type GetOrganizationAccessRequestForInboxLazyQueryHookResult = ReturnType<typeof useGetOrganizationAccessRequestForInboxLazyQuery>;
export type GetOrganizationAccessRequestForInboxQueryResult = Apollo.QueryResult<GetOrganizationAccessRequestForInboxQuery, GetOrganizationAccessRequestForInboxQueryVariables>;
export const ApproveOrganizationAccessRequestForInboxNotificationDocument = gql`
    mutation ApproveOrganizationAccessRequestForInboxNotification($data: ApproveOrganizationUserAccessRequestInput!) {
  approveOrganizationAccessRequest(data: $data) {
    id
    status
    updatedBy {
      ...UserFragmentAvatarGroup
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export type ApproveOrganizationAccessRequestForInboxNotificationMutationFn = Apollo.MutationFunction<ApproveOrganizationAccessRequestForInboxNotificationMutation, ApproveOrganizationAccessRequestForInboxNotificationMutationVariables>;

/**
 * __useApproveOrganizationAccessRequestForInboxNotificationMutation__
 *
 * To run a mutation, you first call `useApproveOrganizationAccessRequestForInboxNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrganizationAccessRequestForInboxNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrganizationAccessRequestForInboxNotificationMutation, { data, loading, error }] = useApproveOrganizationAccessRequestForInboxNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApproveOrganizationAccessRequestForInboxNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrganizationAccessRequestForInboxNotificationMutation, ApproveOrganizationAccessRequestForInboxNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrganizationAccessRequestForInboxNotificationMutation, ApproveOrganizationAccessRequestForInboxNotificationMutationVariables>(ApproveOrganizationAccessRequestForInboxNotificationDocument, options);
      }
export type ApproveOrganizationAccessRequestForInboxNotificationMutationHookResult = ReturnType<typeof useApproveOrganizationAccessRequestForInboxNotificationMutation>;
export type ApproveOrganizationAccessRequestForInboxNotificationMutationResult = Apollo.MutationResult<ApproveOrganizationAccessRequestForInboxNotificationMutation>;
export type ApproveOrganizationAccessRequestForInboxNotificationMutationOptions = Apollo.BaseMutationOptions<ApproveOrganizationAccessRequestForInboxNotificationMutation, ApproveOrganizationAccessRequestForInboxNotificationMutationVariables>;
export const RejectOrganizationAccessRequestForInboxNotificationDocument = gql`
    mutation RejectOrganizationAccessRequestForInboxNotification($data: RejectOrganizationUserAccessRequestInput!) {
  rejectOrganizationAccessRequest(data: $data) {
    id
    status
    updatedBy {
      ...UserFragmentAvatarGroup
    }
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;
export type RejectOrganizationAccessRequestForInboxNotificationMutationFn = Apollo.MutationFunction<RejectOrganizationAccessRequestForInboxNotificationMutation, RejectOrganizationAccessRequestForInboxNotificationMutationVariables>;

/**
 * __useRejectOrganizationAccessRequestForInboxNotificationMutation__
 *
 * To run a mutation, you first call `useRejectOrganizationAccessRequestForInboxNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectOrganizationAccessRequestForInboxNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectOrganizationAccessRequestForInboxNotificationMutation, { data, loading, error }] = useRejectOrganizationAccessRequestForInboxNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRejectOrganizationAccessRequestForInboxNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RejectOrganizationAccessRequestForInboxNotificationMutation, RejectOrganizationAccessRequestForInboxNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectOrganizationAccessRequestForInboxNotificationMutation, RejectOrganizationAccessRequestForInboxNotificationMutationVariables>(RejectOrganizationAccessRequestForInboxNotificationDocument, options);
      }
export type RejectOrganizationAccessRequestForInboxNotificationMutationHookResult = ReturnType<typeof useRejectOrganizationAccessRequestForInboxNotificationMutation>;
export type RejectOrganizationAccessRequestForInboxNotificationMutationResult = Apollo.MutationResult<RejectOrganizationAccessRequestForInboxNotificationMutation>;
export type RejectOrganizationAccessRequestForInboxNotificationMutationOptions = Apollo.BaseMutationOptions<RejectOrganizationAccessRequestForInboxNotificationMutation, RejectOrganizationAccessRequestForInboxNotificationMutationVariables>;
export const GetPostForInboxDocument = gql`
    query GetPostForInbox($id: String!) {
  post(id: $id) {
    ...PostFragmentJuiceModal
  }
}
    ${PostFragmentJuiceModalFragmentDoc}`;

/**
 * __useGetPostForInboxQuery__
 *
 * To run a query within a React component, call `useGetPostForInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForInboxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForInboxQuery(baseOptions: Apollo.QueryHookOptions<GetPostForInboxQuery, GetPostForInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForInboxQuery, GetPostForInboxQueryVariables>(GetPostForInboxDocument, options);
      }
export function useGetPostForInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForInboxQuery, GetPostForInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForInboxQuery, GetPostForInboxQueryVariables>(GetPostForInboxDocument, options);
        }
export type GetPostForInboxQueryHookResult = ReturnType<typeof useGetPostForInboxQuery>;
export type GetPostForInboxLazyQueryHookResult = ReturnType<typeof useGetPostForInboxLazyQuery>;
export type GetPostForInboxQueryResult = Apollo.QueryResult<GetPostForInboxQuery, GetPostForInboxQueryVariables>;
export const GetPostNoteForInboxDocument = gql`
    query GetPostNoteForInbox($id: String!) {
  post(id: $id) {
    ...PostFragmentJuiceModal
  }
}
    ${PostFragmentJuiceModalFragmentDoc}`;

/**
 * __useGetPostNoteForInboxQuery__
 *
 * To run a query within a React component, call `useGetPostNoteForInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostNoteForInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostNoteForInboxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostNoteForInboxQuery(baseOptions: Apollo.QueryHookOptions<GetPostNoteForInboxQuery, GetPostNoteForInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostNoteForInboxQuery, GetPostNoteForInboxQueryVariables>(GetPostNoteForInboxDocument, options);
      }
export function useGetPostNoteForInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostNoteForInboxQuery, GetPostNoteForInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostNoteForInboxQuery, GetPostNoteForInboxQueryVariables>(GetPostNoteForInboxDocument, options);
        }
export type GetPostNoteForInboxQueryHookResult = ReturnType<typeof useGetPostNoteForInboxQuery>;
export type GetPostNoteForInboxLazyQueryHookResult = ReturnType<typeof useGetPostNoteForInboxLazyQuery>;
export type GetPostNoteForInboxQueryResult = Apollo.QueryResult<GetPostNoteForInboxQuery, GetPostNoteForInboxQueryVariables>;
export const GetSocialPostsForInboxSocialListeningContentDocument = gql`
    query GetSocialPostsForInboxSocialListeningContent($socialPostIds: [String!]!, $topicIds: [String!], $brandId: String!) {
  socialPosts(socialPostIds: $socialPostIds) {
    id
    ...SocialPostFragmentSocialMediaListeningPostCard
  }
}
    ${SocialPostFragmentSocialMediaListeningPostCardFragmentDoc}`;

/**
 * __useGetSocialPostsForInboxSocialListeningContentQuery__
 *
 * To run a query within a React component, call `useGetSocialPostsForInboxSocialListeningContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostsForInboxSocialListeningContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostsForInboxSocialListeningContentQuery({
 *   variables: {
 *      socialPostIds: // value for 'socialPostIds'
 *      topicIds: // value for 'topicIds'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetSocialPostsForInboxSocialListeningContentQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostsForInboxSocialListeningContentQuery, GetSocialPostsForInboxSocialListeningContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostsForInboxSocialListeningContentQuery, GetSocialPostsForInboxSocialListeningContentQueryVariables>(GetSocialPostsForInboxSocialListeningContentDocument, options);
      }
export function useGetSocialPostsForInboxSocialListeningContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostsForInboxSocialListeningContentQuery, GetSocialPostsForInboxSocialListeningContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostsForInboxSocialListeningContentQuery, GetSocialPostsForInboxSocialListeningContentQueryVariables>(GetSocialPostsForInboxSocialListeningContentDocument, options);
        }
export type GetSocialPostsForInboxSocialListeningContentQueryHookResult = ReturnType<typeof useGetSocialPostsForInboxSocialListeningContentQuery>;
export type GetSocialPostsForInboxSocialListeningContentLazyQueryHookResult = ReturnType<typeof useGetSocialPostsForInboxSocialListeningContentLazyQuery>;
export type GetSocialPostsForInboxSocialListeningContentQueryResult = Apollo.QueryResult<GetSocialPostsForInboxSocialListeningContentQuery, GetSocialPostsForInboxSocialListeningContentQueryVariables>;
export const GetPermissionRequestForInboxDocument = gql`
    query GetPermissionRequestForInbox($id: String!) {
  permissionRequest(id: $id) {
    id
    collectionId
    brandId
    brand {
      id
      name
      creators {
        id
        profilePictureUrl
      }
    }
    post {
      type
      ...PostFragmentPostDetailContentView
      ...PostFragmentNoteDetailContentView
    }
    ...PermissionRequestFragmentInboxPermissionRequestSideView
  }
}
    ${PostFragmentPostDetailContentViewFragmentDoc}
${PostFragmentNoteDetailContentViewFragmentDoc}
${PermissionRequestFragmentInboxPermissionRequestSideViewFragmentDoc}`;

/**
 * __useGetPermissionRequestForInboxQuery__
 *
 * To run a query within a React component, call `useGetPermissionRequestForInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionRequestForInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionRequestForInboxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPermissionRequestForInboxQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionRequestForInboxQuery, GetPermissionRequestForInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionRequestForInboxQuery, GetPermissionRequestForInboxQueryVariables>(GetPermissionRequestForInboxDocument, options);
      }
export function useGetPermissionRequestForInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionRequestForInboxQuery, GetPermissionRequestForInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionRequestForInboxQuery, GetPermissionRequestForInboxQueryVariables>(GetPermissionRequestForInboxDocument, options);
        }
export type GetPermissionRequestForInboxQueryHookResult = ReturnType<typeof useGetPermissionRequestForInboxQuery>;
export type GetPermissionRequestForInboxLazyQueryHookResult = ReturnType<typeof useGetPermissionRequestForInboxLazyQuery>;
export type GetPermissionRequestForInboxQueryResult = Apollo.QueryResult<GetPermissionRequestForInboxQuery, GetPermissionRequestForInboxQueryVariables>;
export const ApprovePermissionRequestForInboxPermissionRequestContentDocument = gql`
    mutation ApprovePermissionRequestForInboxPermissionRequestContent($data: ApprovePermissionRequestInput!) {
  approvePermissionRequest(data: $data) {
    id
  }
}
    `;
export type ApprovePermissionRequestForInboxPermissionRequestContentMutationFn = Apollo.MutationFunction<ApprovePermissionRequestForInboxPermissionRequestContentMutation, ApprovePermissionRequestForInboxPermissionRequestContentMutationVariables>;

/**
 * __useApprovePermissionRequestForInboxPermissionRequestContentMutation__
 *
 * To run a mutation, you first call `useApprovePermissionRequestForInboxPermissionRequestContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePermissionRequestForInboxPermissionRequestContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePermissionRequestForInboxPermissionRequestContentMutation, { data, loading, error }] = useApprovePermissionRequestForInboxPermissionRequestContentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApprovePermissionRequestForInboxPermissionRequestContentMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePermissionRequestForInboxPermissionRequestContentMutation, ApprovePermissionRequestForInboxPermissionRequestContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePermissionRequestForInboxPermissionRequestContentMutation, ApprovePermissionRequestForInboxPermissionRequestContentMutationVariables>(ApprovePermissionRequestForInboxPermissionRequestContentDocument, options);
      }
export type ApprovePermissionRequestForInboxPermissionRequestContentMutationHookResult = ReturnType<typeof useApprovePermissionRequestForInboxPermissionRequestContentMutation>;
export type ApprovePermissionRequestForInboxPermissionRequestContentMutationResult = Apollo.MutationResult<ApprovePermissionRequestForInboxPermissionRequestContentMutation>;
export type ApprovePermissionRequestForInboxPermissionRequestContentMutationOptions = Apollo.BaseMutationOptions<ApprovePermissionRequestForInboxPermissionRequestContentMutation, ApprovePermissionRequestForInboxPermissionRequestContentMutationVariables>;
export const RejectPermissionRequestForInboxPermissionRequestContentDocument = gql`
    mutation RejectPermissionRequestForInboxPermissionRequestContent($data: RejectPermissionRequestInput!) {
  rejectPermissionRequest(data: $data) {
    id
  }
}
    `;
export type RejectPermissionRequestForInboxPermissionRequestContentMutationFn = Apollo.MutationFunction<RejectPermissionRequestForInboxPermissionRequestContentMutation, RejectPermissionRequestForInboxPermissionRequestContentMutationVariables>;

/**
 * __useRejectPermissionRequestForInboxPermissionRequestContentMutation__
 *
 * To run a mutation, you first call `useRejectPermissionRequestForInboxPermissionRequestContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPermissionRequestForInboxPermissionRequestContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPermissionRequestForInboxPermissionRequestContentMutation, { data, loading, error }] = useRejectPermissionRequestForInboxPermissionRequestContentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRejectPermissionRequestForInboxPermissionRequestContentMutation(baseOptions?: Apollo.MutationHookOptions<RejectPermissionRequestForInboxPermissionRequestContentMutation, RejectPermissionRequestForInboxPermissionRequestContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectPermissionRequestForInboxPermissionRequestContentMutation, RejectPermissionRequestForInboxPermissionRequestContentMutationVariables>(RejectPermissionRequestForInboxPermissionRequestContentDocument, options);
      }
export type RejectPermissionRequestForInboxPermissionRequestContentMutationHookResult = ReturnType<typeof useRejectPermissionRequestForInboxPermissionRequestContentMutation>;
export type RejectPermissionRequestForInboxPermissionRequestContentMutationResult = Apollo.MutationResult<RejectPermissionRequestForInboxPermissionRequestContentMutation>;
export type RejectPermissionRequestForInboxPermissionRequestContentMutationOptions = Apollo.BaseMutationOptions<RejectPermissionRequestForInboxPermissionRequestContentMutation, RejectPermissionRequestForInboxPermissionRequestContentMutationVariables>;
export const ApprovePermissionRequestForInboxNotificationDocument = gql`
    mutation ApprovePermissionRequestForInboxNotification($data: ApprovePermissionRequestInput!) {
  approvePermissionRequest(data: $data) {
    id
    status
  }
}
    `;
export type ApprovePermissionRequestForInboxNotificationMutationFn = Apollo.MutationFunction<ApprovePermissionRequestForInboxNotificationMutation, ApprovePermissionRequestForInboxNotificationMutationVariables>;

/**
 * __useApprovePermissionRequestForInboxNotificationMutation__
 *
 * To run a mutation, you first call `useApprovePermissionRequestForInboxNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePermissionRequestForInboxNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePermissionRequestForInboxNotificationMutation, { data, loading, error }] = useApprovePermissionRequestForInboxNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApprovePermissionRequestForInboxNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePermissionRequestForInboxNotificationMutation, ApprovePermissionRequestForInboxNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePermissionRequestForInboxNotificationMutation, ApprovePermissionRequestForInboxNotificationMutationVariables>(ApprovePermissionRequestForInboxNotificationDocument, options);
      }
export type ApprovePermissionRequestForInboxNotificationMutationHookResult = ReturnType<typeof useApprovePermissionRequestForInboxNotificationMutation>;
export type ApprovePermissionRequestForInboxNotificationMutationResult = Apollo.MutationResult<ApprovePermissionRequestForInboxNotificationMutation>;
export type ApprovePermissionRequestForInboxNotificationMutationOptions = Apollo.BaseMutationOptions<ApprovePermissionRequestForInboxNotificationMutation, ApprovePermissionRequestForInboxNotificationMutationVariables>;
export const RejectPermissionRequestForInboxNotificationDocument = gql`
    mutation RejectPermissionRequestForInboxNotification($data: RejectPermissionRequestInput!) {
  rejectPermissionRequest(data: $data) {
    id
    status
  }
}
    `;
export type RejectPermissionRequestForInboxNotificationMutationFn = Apollo.MutationFunction<RejectPermissionRequestForInboxNotificationMutation, RejectPermissionRequestForInboxNotificationMutationVariables>;

/**
 * __useRejectPermissionRequestForInboxNotificationMutation__
 *
 * To run a mutation, you first call `useRejectPermissionRequestForInboxNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPermissionRequestForInboxNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPermissionRequestForInboxNotificationMutation, { data, loading, error }] = useRejectPermissionRequestForInboxNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRejectPermissionRequestForInboxNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RejectPermissionRequestForInboxNotificationMutation, RejectPermissionRequestForInboxNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectPermissionRequestForInboxNotificationMutation, RejectPermissionRequestForInboxNotificationMutationVariables>(RejectPermissionRequestForInboxNotificationDocument, options);
      }
export type RejectPermissionRequestForInboxNotificationMutationHookResult = ReturnType<typeof useRejectPermissionRequestForInboxNotificationMutation>;
export type RejectPermissionRequestForInboxNotificationMutationResult = Apollo.MutationResult<RejectPermissionRequestForInboxNotificationMutation>;
export type RejectPermissionRequestForInboxNotificationMutationOptions = Apollo.BaseMutationOptions<RejectPermissionRequestForInboxNotificationMutation, RejectPermissionRequestForInboxNotificationMutationVariables>;
export const RemovePermissionRequestInvitedUserForInboxNotificationDocument = gql`
    mutation RemovePermissionRequestInvitedUserForInboxNotification($data: RemovePermissionRequestInvitedMemberInput!) {
  removePermissionRequestInvitedUser(data: $data) {
    id
    status
  }
}
    `;
export type RemovePermissionRequestInvitedUserForInboxNotificationMutationFn = Apollo.MutationFunction<RemovePermissionRequestInvitedUserForInboxNotificationMutation, RemovePermissionRequestInvitedUserForInboxNotificationMutationVariables>;

/**
 * __useRemovePermissionRequestInvitedUserForInboxNotificationMutation__
 *
 * To run a mutation, you first call `useRemovePermissionRequestInvitedUserForInboxNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionRequestInvitedUserForInboxNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionRequestInvitedUserForInboxNotificationMutation, { data, loading, error }] = useRemovePermissionRequestInvitedUserForInboxNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePermissionRequestInvitedUserForInboxNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RemovePermissionRequestInvitedUserForInboxNotificationMutation, RemovePermissionRequestInvitedUserForInboxNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePermissionRequestInvitedUserForInboxNotificationMutation, RemovePermissionRequestInvitedUserForInboxNotificationMutationVariables>(RemovePermissionRequestInvitedUserForInboxNotificationDocument, options);
      }
export type RemovePermissionRequestInvitedUserForInboxNotificationMutationHookResult = ReturnType<typeof useRemovePermissionRequestInvitedUserForInboxNotificationMutation>;
export type RemovePermissionRequestInvitedUserForInboxNotificationMutationResult = Apollo.MutationResult<RemovePermissionRequestInvitedUserForInboxNotificationMutation>;
export type RemovePermissionRequestInvitedUserForInboxNotificationMutationOptions = Apollo.BaseMutationOptions<RemovePermissionRequestInvitedUserForInboxNotificationMutation, RemovePermissionRequestInvitedUserForInboxNotificationMutationVariables>;
export const GetNotificationsForInboxDocument = gql`
    query GetNotificationsForInbox($filters: InboxNotificationFilters!, $take: Int, $after: String) {
  inboxNotifications(filters: $filters, take: $take, after: $after) {
    notifications {
      ...NotificationFragmentCardView
    }
    meta {
      mentionsTotalCount
      commentsTotalCount
      reactionsTotalCount
      tasksTotalCount
      invitesTotalCount
      permissionRequestsTotalCount
      organizationUserAccessRequestsTotalCount
      contentIdeasTotalCount
      socialListeningTotalCount
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${NotificationFragmentCardViewFragmentDoc}`;

/**
 * __useGetNotificationsForInboxQuery__
 *
 * To run a query within a React component, call `useGetNotificationsForInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsForInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsForInboxQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNotificationsForInboxQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsForInboxQuery, GetNotificationsForInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsForInboxQuery, GetNotificationsForInboxQueryVariables>(GetNotificationsForInboxDocument, options);
      }
export function useGetNotificationsForInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsForInboxQuery, GetNotificationsForInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsForInboxQuery, GetNotificationsForInboxQueryVariables>(GetNotificationsForInboxDocument, options);
        }
export type GetNotificationsForInboxQueryHookResult = ReturnType<typeof useGetNotificationsForInboxQuery>;
export type GetNotificationsForInboxLazyQueryHookResult = ReturnType<typeof useGetNotificationsForInboxLazyQuery>;
export type GetNotificationsForInboxQueryResult = Apollo.QueryResult<GetNotificationsForInboxQuery, GetNotificationsForInboxQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: String!) {
  readNotification(id: $id) {
    id
    status
  }
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation MarkNotificationsAsRead($ids: [String!]!) {
  readNotifications(ids: $ids) {
    success
  }
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const DeleteNotificationsForInboxPageDocument = gql`
    mutation DeleteNotificationsForInboxPage($data: DeleteNotificationsInput!) {
  deleteNotifications(data: $data) {
    success
  }
}
    `;
export type DeleteNotificationsForInboxPageMutationFn = Apollo.MutationFunction<DeleteNotificationsForInboxPageMutation, DeleteNotificationsForInboxPageMutationVariables>;

/**
 * __useDeleteNotificationsForInboxPageMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationsForInboxPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationsForInboxPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationsForInboxPageMutation, { data, loading, error }] = useDeleteNotificationsForInboxPageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteNotificationsForInboxPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationsForInboxPageMutation, DeleteNotificationsForInboxPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationsForInboxPageMutation, DeleteNotificationsForInboxPageMutationVariables>(DeleteNotificationsForInboxPageDocument, options);
      }
export type DeleteNotificationsForInboxPageMutationHookResult = ReturnType<typeof useDeleteNotificationsForInboxPageMutation>;
export type DeleteNotificationsForInboxPageMutationResult = Apollo.MutationResult<DeleteNotificationsForInboxPageMutation>;
export type DeleteNotificationsForInboxPageMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationsForInboxPageMutation, DeleteNotificationsForInboxPageMutationVariables>;
export const GetSuggestedPostsForAiOrganizeSectionDocument = gql`
    query GetSuggestedPostsForAiOrganizeSection {
  suggestedPostsForUser {
    id
    ...PostFragmentPostPreview
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetSuggestedPostsForAiOrganizeSectionQuery__
 *
 * To run a query within a React component, call `useGetSuggestedPostsForAiOrganizeSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedPostsForAiOrganizeSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedPostsForAiOrganizeSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuggestedPostsForAiOrganizeSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestedPostsForAiOrganizeSectionQuery, GetSuggestedPostsForAiOrganizeSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedPostsForAiOrganizeSectionQuery, GetSuggestedPostsForAiOrganizeSectionQueryVariables>(GetSuggestedPostsForAiOrganizeSectionDocument, options);
      }
export function useGetSuggestedPostsForAiOrganizeSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedPostsForAiOrganizeSectionQuery, GetSuggestedPostsForAiOrganizeSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedPostsForAiOrganizeSectionQuery, GetSuggestedPostsForAiOrganizeSectionQueryVariables>(GetSuggestedPostsForAiOrganizeSectionDocument, options);
        }
export type GetSuggestedPostsForAiOrganizeSectionQueryHookResult = ReturnType<typeof useGetSuggestedPostsForAiOrganizeSectionQuery>;
export type GetSuggestedPostsForAiOrganizeSectionLazyQueryHookResult = ReturnType<typeof useGetSuggestedPostsForAiOrganizeSectionLazyQuery>;
export type GetSuggestedPostsForAiOrganizeSectionQueryResult = Apollo.QueryResult<GetSuggestedPostsForAiOrganizeSectionQuery, GetSuggestedPostsForAiOrganizeSectionQueryVariables>;
export const UpdateUserOnboardingStateForJuiceboxSectionDocument = gql`
    mutation UpdateUserOnboardingStateForJuiceboxSection($data: UpdateUserOnboardingStateInput!) {
  updateUserOnboardingState(data: $data) {
    id
    onboardingState {
      haveSeenJuiceBoxIntro
      haveClickedJuiceBoxBtn
    }
  }
}
    `;
export type UpdateUserOnboardingStateForJuiceboxSectionMutationFn = Apollo.MutationFunction<UpdateUserOnboardingStateForJuiceboxSectionMutation, UpdateUserOnboardingStateForJuiceboxSectionMutationVariables>;

/**
 * __useUpdateUserOnboardingStateForJuiceboxSectionMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingStateForJuiceboxSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingStateForJuiceboxSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingStateForJuiceboxSectionMutation, { data, loading, error }] = useUpdateUserOnboardingStateForJuiceboxSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOnboardingStateForJuiceboxSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingStateForJuiceboxSectionMutation, UpdateUserOnboardingStateForJuiceboxSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingStateForJuiceboxSectionMutation, UpdateUserOnboardingStateForJuiceboxSectionMutationVariables>(UpdateUserOnboardingStateForJuiceboxSectionDocument, options);
      }
export type UpdateUserOnboardingStateForJuiceboxSectionMutationHookResult = ReturnType<typeof useUpdateUserOnboardingStateForJuiceboxSectionMutation>;
export type UpdateUserOnboardingStateForJuiceboxSectionMutationResult = Apollo.MutationResult<UpdateUserOnboardingStateForJuiceboxSectionMutation>;
export type UpdateUserOnboardingStateForJuiceboxSectionMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingStateForJuiceboxSectionMutation, UpdateUserOnboardingStateForJuiceboxSectionMutationVariables>;
export const GetPostForJuiceModalDocument = gql`
    query GetPostForJuiceModal($id: String!) {
  post(id: $id) {
    ...PostFragmentJuiceModal
  }
}
    ${PostFragmentJuiceModalFragmentDoc}`;

/**
 * __useGetPostForJuiceModalQuery__
 *
 * To run a query within a React component, call `useGetPostForJuiceModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForJuiceModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForJuiceModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForJuiceModalQuery(baseOptions: Apollo.QueryHookOptions<GetPostForJuiceModalQuery, GetPostForJuiceModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForJuiceModalQuery, GetPostForJuiceModalQueryVariables>(GetPostForJuiceModalDocument, options);
      }
export function useGetPostForJuiceModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForJuiceModalQuery, GetPostForJuiceModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForJuiceModalQuery, GetPostForJuiceModalQueryVariables>(GetPostForJuiceModalDocument, options);
        }
export type GetPostForJuiceModalQueryHookResult = ReturnType<typeof useGetPostForJuiceModalQuery>;
export type GetPostForJuiceModalLazyQueryHookResult = ReturnType<typeof useGetPostForJuiceModalLazyQuery>;
export type GetPostForJuiceModalQueryResult = Apollo.QueryResult<GetPostForJuiceModalQuery, GetPostForJuiceModalQueryVariables>;
export const GetPostCommentsUnreadCountDocument = gql`
    query GetPostCommentsUnreadCount($postId: String!) {
  unreadPostComments(postId: $postId)
}
    `;

/**
 * __useGetPostCommentsUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetPostCommentsUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCommentsUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCommentsUnreadCountQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostCommentsUnreadCountQuery(baseOptions: Apollo.QueryHookOptions<GetPostCommentsUnreadCountQuery, GetPostCommentsUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCommentsUnreadCountQuery, GetPostCommentsUnreadCountQueryVariables>(GetPostCommentsUnreadCountDocument, options);
      }
export function useGetPostCommentsUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCommentsUnreadCountQuery, GetPostCommentsUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCommentsUnreadCountQuery, GetPostCommentsUnreadCountQueryVariables>(GetPostCommentsUnreadCountDocument, options);
        }
export type GetPostCommentsUnreadCountQueryHookResult = ReturnType<typeof useGetPostCommentsUnreadCountQuery>;
export type GetPostCommentsUnreadCountLazyQueryHookResult = ReturnType<typeof useGetPostCommentsUnreadCountLazyQuery>;
export type GetPostCommentsUnreadCountQueryResult = Apollo.QueryResult<GetPostCommentsUnreadCountQuery, GetPostCommentsUnreadCountQueryVariables>;
export const GetPostForPostPreviewPageDocument = gql`
    query GetPostForPostPreviewPage($id: String!) {
  post(id: $id) {
    id
    ...PostFragmentPostPreviewWindowView
    ...PostFragmentPostCommand
  }
}
    ${PostFragmentPostPreviewWindowViewFragmentDoc}
${PostFragmentPostCommandFragmentDoc}`;

/**
 * __useGetPostForPostPreviewPageQuery__
 *
 * To run a query within a React component, call `useGetPostForPostPreviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForPostPreviewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForPostPreviewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForPostPreviewPageQuery(baseOptions: Apollo.QueryHookOptions<GetPostForPostPreviewPageQuery, GetPostForPostPreviewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForPostPreviewPageQuery, GetPostForPostPreviewPageQueryVariables>(GetPostForPostPreviewPageDocument, options);
      }
export function useGetPostForPostPreviewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForPostPreviewPageQuery, GetPostForPostPreviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForPostPreviewPageQuery, GetPostForPostPreviewPageQueryVariables>(GetPostForPostPreviewPageDocument, options);
        }
export type GetPostForPostPreviewPageQueryHookResult = ReturnType<typeof useGetPostForPostPreviewPageQuery>;
export type GetPostForPostPreviewPageLazyQueryHookResult = ReturnType<typeof useGetPostForPostPreviewPageLazyQuery>;
export type GetPostForPostPreviewPageQueryResult = Apollo.QueryResult<GetPostForPostPreviewPageQuery, GetPostForPostPreviewPageQueryVariables>;
export const GetGhostSearchQueryForJuiceboxPageDocument = gql`
    query GetGhostSearchQueryForJuiceboxPage {
  ghostSearchQuery {
    query
  }
}
    `;

/**
 * __useGetGhostSearchQueryForJuiceboxPageQuery__
 *
 * To run a query within a React component, call `useGetGhostSearchQueryForJuiceboxPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGhostSearchQueryForJuiceboxPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGhostSearchQueryForJuiceboxPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGhostSearchQueryForJuiceboxPageQuery(baseOptions?: Apollo.QueryHookOptions<GetGhostSearchQueryForJuiceboxPageQuery, GetGhostSearchQueryForJuiceboxPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGhostSearchQueryForJuiceboxPageQuery, GetGhostSearchQueryForJuiceboxPageQueryVariables>(GetGhostSearchQueryForJuiceboxPageDocument, options);
      }
export function useGetGhostSearchQueryForJuiceboxPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGhostSearchQueryForJuiceboxPageQuery, GetGhostSearchQueryForJuiceboxPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGhostSearchQueryForJuiceboxPageQuery, GetGhostSearchQueryForJuiceboxPageQueryVariables>(GetGhostSearchQueryForJuiceboxPageDocument, options);
        }
export type GetGhostSearchQueryForJuiceboxPageQueryHookResult = ReturnType<typeof useGetGhostSearchQueryForJuiceboxPageQuery>;
export type GetGhostSearchQueryForJuiceboxPageLazyQueryHookResult = ReturnType<typeof useGetGhostSearchQueryForJuiceboxPageLazyQuery>;
export type GetGhostSearchQueryForJuiceboxPageQueryResult = Apollo.QueryResult<GetGhostSearchQueryForJuiceboxPageQuery, GetGhostSearchQueryForJuiceboxPageQueryVariables>;
export const GetPostsForJuiceboxDocument = gql`
    query GetPostsForJuicebox($filters: PostFilters!, $take: Int, $after: String) {
  posts(filters: $filters, take: $take, after: $after) {
    data {
      id
      ...PostFragmentPostMasonryCardView
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentPostMasonryCardViewFragmentDoc}`;

/**
 * __useGetPostsForJuiceboxQuery__
 *
 * To run a query within a React component, call `useGetPostsForJuiceboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForJuiceboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForJuiceboxQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPostsForJuiceboxQuery(baseOptions: Apollo.QueryHookOptions<GetPostsForJuiceboxQuery, GetPostsForJuiceboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsForJuiceboxQuery, GetPostsForJuiceboxQueryVariables>(GetPostsForJuiceboxDocument, options);
      }
export function useGetPostsForJuiceboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsForJuiceboxQuery, GetPostsForJuiceboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsForJuiceboxQuery, GetPostsForJuiceboxQueryVariables>(GetPostsForJuiceboxDocument, options);
        }
export type GetPostsForJuiceboxQueryHookResult = ReturnType<typeof useGetPostsForJuiceboxQuery>;
export type GetPostsForJuiceboxLazyQueryHookResult = ReturnType<typeof useGetPostsForJuiceboxLazyQuery>;
export type GetPostsForJuiceboxQueryResult = Apollo.QueryResult<GetPostsForJuiceboxQuery, GetPostsForJuiceboxQueryVariables>;
export const GetSmartSearchPostsForJuiceboxDocument = gql`
    query GetSmartSearchPostsForJuicebox($filters: PostFiltersForSmartSearch!, $take: Int, $after: String) {
  postsSmartSearch(filters: $filters, take: $take, after: $after) {
    data {
      score
      type
      item {
        id
        ...PostFragmentPostMasonryCardView
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PostFragmentPostMasonryCardViewFragmentDoc}`;

/**
 * __useGetSmartSearchPostsForJuiceboxQuery__
 *
 * To run a query within a React component, call `useGetSmartSearchPostsForJuiceboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmartSearchPostsForJuiceboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmartSearchPostsForJuiceboxQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSmartSearchPostsForJuiceboxQuery(baseOptions: Apollo.QueryHookOptions<GetSmartSearchPostsForJuiceboxQuery, GetSmartSearchPostsForJuiceboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmartSearchPostsForJuiceboxQuery, GetSmartSearchPostsForJuiceboxQueryVariables>(GetSmartSearchPostsForJuiceboxDocument, options);
      }
export function useGetSmartSearchPostsForJuiceboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmartSearchPostsForJuiceboxQuery, GetSmartSearchPostsForJuiceboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmartSearchPostsForJuiceboxQuery, GetSmartSearchPostsForJuiceboxQueryVariables>(GetSmartSearchPostsForJuiceboxDocument, options);
        }
export type GetSmartSearchPostsForJuiceboxQueryHookResult = ReturnType<typeof useGetSmartSearchPostsForJuiceboxQuery>;
export type GetSmartSearchPostsForJuiceboxLazyQueryHookResult = ReturnType<typeof useGetSmartSearchPostsForJuiceboxLazyQuery>;
export type GetSmartSearchPostsForJuiceboxQueryResult = Apollo.QueryResult<GetSmartSearchPostsForJuiceboxQuery, GetSmartSearchPostsForJuiceboxQueryVariables>;
export const GetCollectionsSmartSearchForGridViewAllCollectionsSectionDocument = gql`
    query GetCollectionsSmartSearchForGridViewAllCollectionsSection($filters: CollectionFilters!, $take: Int, $sortType: SortType, $after: String) {
  collectionsSmartSearch(
    filters: $filters
    take: $take
    sortType: $sortType
    after: $after
  ) {
    data {
      item {
        id
        ...CollectionFragmentCollectionCardView
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;

/**
 * __useGetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      sortType: // value for 'sortType'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryVariables>(GetCollectionsSmartSearchForGridViewAllCollectionsSectionDocument, options);
      }
export function useGetCollectionsSmartSearchForGridViewAllCollectionsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryVariables>(GetCollectionsSmartSearchForGridViewAllCollectionsSectionDocument, options);
        }
export type GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery>;
export type GetCollectionsSmartSearchForGridViewAllCollectionsSectionLazyQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForGridViewAllCollectionsSectionLazyQuery>;
export type GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryResult = Apollo.QueryResult<GetCollectionsSmartSearchForGridViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForGridViewAllCollectionsSectionQueryVariables>;
export const GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionDocument = gql`
    query GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSection($filters: PinnedEntityFilters!) {
  pinnedEntitiesToParent(filters: $filters) {
    id
    collection {
      id
      ...CollectionFragmentCollectionPostDndCollectionCard
      ...CollectionFragmentSelectMode
    }
    post {
      id
      ...PostFragmentCollectionPostDndPostCard
      ...PostFragmentSelectMode
    }
  }
}
    ${CollectionFragmentCollectionPostDndCollectionCardFragmentDoc}
${CollectionFragmentSelectModeFragmentDoc}
${PostFragmentCollectionPostDndPostCardFragmentDoc}
${PostFragmentSelectModeFragmentDoc}`;

/**
 * __useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery__
 *
 * To run a query within a React component, call `useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery(baseOptions: Apollo.QueryHookOptions<GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryVariables>(GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionDocument, options);
      }
export function useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryVariables>(GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionDocument, options);
        }
export type GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryHookResult = ReturnType<typeof useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery>;
export type GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionLazyQueryHookResult = ReturnType<typeof useGetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionLazyQuery>;
export type GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryResult = Apollo.QueryResult<GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForGridViewPinnedCollectionsAndPostsSectionQueryVariables>;
export const GetRecentCollectionsForGridViewRecentCollectionsSectionDocument = gql`
    query GetRecentCollectionsForGridViewRecentCollectionsSection {
  recentCollections {
    id
    ...CollectionFragmentCollectionCardView
  }
}
    ${CollectionFragmentCollectionCardViewFragmentDoc}`;

/**
 * __useGetRecentCollectionsForGridViewRecentCollectionsSectionQuery__
 *
 * To run a query within a React component, call `useGetRecentCollectionsForGridViewRecentCollectionsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentCollectionsForGridViewRecentCollectionsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentCollectionsForGridViewRecentCollectionsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentCollectionsForGridViewRecentCollectionsSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentCollectionsForGridViewRecentCollectionsSectionQuery, GetRecentCollectionsForGridViewRecentCollectionsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentCollectionsForGridViewRecentCollectionsSectionQuery, GetRecentCollectionsForGridViewRecentCollectionsSectionQueryVariables>(GetRecentCollectionsForGridViewRecentCollectionsSectionDocument, options);
      }
export function useGetRecentCollectionsForGridViewRecentCollectionsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentCollectionsForGridViewRecentCollectionsSectionQuery, GetRecentCollectionsForGridViewRecentCollectionsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentCollectionsForGridViewRecentCollectionsSectionQuery, GetRecentCollectionsForGridViewRecentCollectionsSectionQueryVariables>(GetRecentCollectionsForGridViewRecentCollectionsSectionDocument, options);
        }
export type GetRecentCollectionsForGridViewRecentCollectionsSectionQueryHookResult = ReturnType<typeof useGetRecentCollectionsForGridViewRecentCollectionsSectionQuery>;
export type GetRecentCollectionsForGridViewRecentCollectionsSectionLazyQueryHookResult = ReturnType<typeof useGetRecentCollectionsForGridViewRecentCollectionsSectionLazyQuery>;
export type GetRecentCollectionsForGridViewRecentCollectionsSectionQueryResult = Apollo.QueryResult<GetRecentCollectionsForGridViewRecentCollectionsSectionQuery, GetRecentCollectionsForGridViewRecentCollectionsSectionQueryVariables>;
export const GetCollectionsSmartSearchForListViewAllCollectionsSectionDocument = gql`
    query GetCollectionsSmartSearchForListViewAllCollectionsSection($filters: CollectionFilters!, $take: Int, $sortType: SortType, $after: String) {
  collectionsSmartSearch(
    filters: $filters
    take: $take
    sortType: $sortType
    after: $after
  ) {
    data {
      item {
        id
        ...CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenu
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragmentDoc}`;

/**
 * __useGetCollectionsSmartSearchForListViewAllCollectionsSectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionsSmartSearchForListViewAllCollectionsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsSmartSearchForListViewAllCollectionsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsSmartSearchForListViewAllCollectionsSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      sortType: // value for 'sortType'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCollectionsSmartSearchForListViewAllCollectionsSectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsSmartSearchForListViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsSmartSearchForListViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryVariables>(GetCollectionsSmartSearchForListViewAllCollectionsSectionDocument, options);
      }
export function useGetCollectionsSmartSearchForListViewAllCollectionsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsSmartSearchForListViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsSmartSearchForListViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryVariables>(GetCollectionsSmartSearchForListViewAllCollectionsSectionDocument, options);
        }
export type GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForListViewAllCollectionsSectionQuery>;
export type GetCollectionsSmartSearchForListViewAllCollectionsSectionLazyQueryHookResult = ReturnType<typeof useGetCollectionsSmartSearchForListViewAllCollectionsSectionLazyQuery>;
export type GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryResult = Apollo.QueryResult<GetCollectionsSmartSearchForListViewAllCollectionsSectionQuery, GetCollectionsSmartSearchForListViewAllCollectionsSectionQueryVariables>;
export const GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionDocument = gql`
    query GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSection($filters: PinnedEntityFilters!) {
  pinnedEntitiesToParent(filters: $filters) {
    id
    collection {
      id
      ...CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenu
    }
    post {
      id
      ...PostFragmentJuiceboxTablePostTableRowWithContextMenu
    }
  }
}
    ${CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragmentDoc}
${PostFragmentJuiceboxTablePostTableRowWithContextMenuFragmentDoc}`;

/**
 * __useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery__
 *
 * To run a query within a React component, call `useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery(baseOptions: Apollo.QueryHookOptions<GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryVariables>(GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionDocument, options);
      }
export function useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryVariables>(GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionDocument, options);
        }
export type GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryHookResult = ReturnType<typeof useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery>;
export type GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionLazyQueryHookResult = ReturnType<typeof useGetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionLazyQuery>;
export type GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryResult = Apollo.QueryResult<GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQuery, GetPinnedEntitiesToParentForListViewPinnedCollectionsAndPostsSectionQueryVariables>;
export const GetRecentCollectionsForListViewRecentCollectionsSectionDocument = gql`
    query GetRecentCollectionsForListViewRecentCollectionsSection {
  recentCollections {
    id
    ...CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenu
  }
}
    ${CollectionFragmentJuiceboxTableCollectionTableRowWithContextMenuFragmentDoc}`;

/**
 * __useGetRecentCollectionsForListViewRecentCollectionsSectionQuery__
 *
 * To run a query within a React component, call `useGetRecentCollectionsForListViewRecentCollectionsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentCollectionsForListViewRecentCollectionsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentCollectionsForListViewRecentCollectionsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentCollectionsForListViewRecentCollectionsSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentCollectionsForListViewRecentCollectionsSectionQuery, GetRecentCollectionsForListViewRecentCollectionsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentCollectionsForListViewRecentCollectionsSectionQuery, GetRecentCollectionsForListViewRecentCollectionsSectionQueryVariables>(GetRecentCollectionsForListViewRecentCollectionsSectionDocument, options);
      }
export function useGetRecentCollectionsForListViewRecentCollectionsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentCollectionsForListViewRecentCollectionsSectionQuery, GetRecentCollectionsForListViewRecentCollectionsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentCollectionsForListViewRecentCollectionsSectionQuery, GetRecentCollectionsForListViewRecentCollectionsSectionQueryVariables>(GetRecentCollectionsForListViewRecentCollectionsSectionDocument, options);
        }
export type GetRecentCollectionsForListViewRecentCollectionsSectionQueryHookResult = ReturnType<typeof useGetRecentCollectionsForListViewRecentCollectionsSectionQuery>;
export type GetRecentCollectionsForListViewRecentCollectionsSectionLazyQueryHookResult = ReturnType<typeof useGetRecentCollectionsForListViewRecentCollectionsSectionLazyQuery>;
export type GetRecentCollectionsForListViewRecentCollectionsSectionQueryResult = Apollo.QueryResult<GetRecentCollectionsForListViewRecentCollectionsSectionQuery, GetRecentCollectionsForListViewRecentCollectionsSectionQueryVariables>;
export const GetNotePostForJuiceboxNoteModalDocument = gql`
    query GetNotePostForJuiceboxNoteModal($id: String!) {
  post(id: $id) {
    ...PostFragmentJuiceModal
  }
}
    ${PostFragmentJuiceModalFragmentDoc}`;

/**
 * __useGetNotePostForJuiceboxNoteModalQuery__
 *
 * To run a query within a React component, call `useGetNotePostForJuiceboxNoteModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotePostForJuiceboxNoteModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotePostForJuiceboxNoteModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotePostForJuiceboxNoteModalQuery(baseOptions: Apollo.QueryHookOptions<GetNotePostForJuiceboxNoteModalQuery, GetNotePostForJuiceboxNoteModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotePostForJuiceboxNoteModalQuery, GetNotePostForJuiceboxNoteModalQueryVariables>(GetNotePostForJuiceboxNoteModalDocument, options);
      }
export function useGetNotePostForJuiceboxNoteModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotePostForJuiceboxNoteModalQuery, GetNotePostForJuiceboxNoteModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotePostForJuiceboxNoteModalQuery, GetNotePostForJuiceboxNoteModalQueryVariables>(GetNotePostForJuiceboxNoteModalDocument, options);
        }
export type GetNotePostForJuiceboxNoteModalQueryHookResult = ReturnType<typeof useGetNotePostForJuiceboxNoteModalQuery>;
export type GetNotePostForJuiceboxNoteModalLazyQueryHookResult = ReturnType<typeof useGetNotePostForJuiceboxNoteModalLazyQuery>;
export type GetNotePostForJuiceboxNoteModalQueryResult = Apollo.QueryResult<GetNotePostForJuiceboxNoteModalQuery, GetNotePostForJuiceboxNoteModalQueryVariables>;
export const GetTrendingAudioGroupsDocument = gql`
    query GetTrendingAudioGroups($filters: AudioTrendGroupFilters!, $after: String, $take: Int, $skip: Int) {
  audioTrendGroups(filters: $filters, after: $after, take: $take, skip: $skip) {
    data {
      id
      createdAt
      updatedAt
      ...AudioTrendGroupFragmentTrendAudioGroupCardView
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${AudioTrendGroupFragmentTrendAudioGroupCardViewFragmentDoc}`;

/**
 * __useGetTrendingAudioGroupsQuery__
 *
 * To run a query within a React component, call `useGetTrendingAudioGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingAudioGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingAudioGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetTrendingAudioGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingAudioGroupsQuery, GetTrendingAudioGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendingAudioGroupsQuery, GetTrendingAudioGroupsQueryVariables>(GetTrendingAudioGroupsDocument, options);
      }
export function useGetTrendingAudioGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingAudioGroupsQuery, GetTrendingAudioGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendingAudioGroupsQuery, GetTrendingAudioGroupsQueryVariables>(GetTrendingAudioGroupsDocument, options);
        }
export type GetTrendingAudioGroupsQueryHookResult = ReturnType<typeof useGetTrendingAudioGroupsQuery>;
export type GetTrendingAudioGroupsLazyQueryHookResult = ReturnType<typeof useGetTrendingAudioGroupsLazyQuery>;
export type GetTrendingAudioGroupsQueryResult = Apollo.QueryResult<GetTrendingAudioGroupsQuery, GetTrendingAudioGroupsQueryVariables>;
export const GetAudioTrendGroupForTrendingAudioGroupDetailPageDocument = gql`
    query GetAudioTrendGroupForTrendingAudioGroupDetailPage($audioTrendGroupId: String!) {
  audioTrendGroup(id: $audioTrendGroupId) {
    id
    audioArtist
    audioId
    audioTitle
    audioVideoCount
    createdAt
    posts {
      engagementRate
      platformId
      viralRate
    }
  }
}
    `;

/**
 * __useGetAudioTrendGroupForTrendingAudioGroupDetailPageQuery__
 *
 * To run a query within a React component, call `useGetAudioTrendGroupForTrendingAudioGroupDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudioTrendGroupForTrendingAudioGroupDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudioTrendGroupForTrendingAudioGroupDetailPageQuery({
 *   variables: {
 *      audioTrendGroupId: // value for 'audioTrendGroupId'
 *   },
 * });
 */
export function useGetAudioTrendGroupForTrendingAudioGroupDetailPageQuery(baseOptions: Apollo.QueryHookOptions<GetAudioTrendGroupForTrendingAudioGroupDetailPageQuery, GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudioTrendGroupForTrendingAudioGroupDetailPageQuery, GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryVariables>(GetAudioTrendGroupForTrendingAudioGroupDetailPageDocument, options);
      }
export function useGetAudioTrendGroupForTrendingAudioGroupDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudioTrendGroupForTrendingAudioGroupDetailPageQuery, GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudioTrendGroupForTrendingAudioGroupDetailPageQuery, GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryVariables>(GetAudioTrendGroupForTrendingAudioGroupDetailPageDocument, options);
        }
export type GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryHookResult = ReturnType<typeof useGetAudioTrendGroupForTrendingAudioGroupDetailPageQuery>;
export type GetAudioTrendGroupForTrendingAudioGroupDetailPageLazyQueryHookResult = ReturnType<typeof useGetAudioTrendGroupForTrendingAudioGroupDetailPageLazyQuery>;
export type GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryResult = Apollo.QueryResult<GetAudioTrendGroupForTrendingAudioGroupDetailPageQuery, GetAudioTrendGroupForTrendingAudioGroupDetailPageQueryVariables>;
export const GetTrendingPostsDocument = gql`
    query GetTrendingPosts($filters: TrendFilters!, $after: String, $take: Int) {
  trends(filters: $filters, after: $after, take: $take) {
    data {
      ...TrendFragmentTrendingCardView
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${TrendFragmentTrendingCardViewFragmentDoc}`;

/**
 * __useGetTrendingPostsQuery__
 *
 * To run a query within a React component, call `useGetTrendingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingPostsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetTrendingPostsQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>(GetTrendingPostsDocument, options);
      }
export function useGetTrendingPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>(GetTrendingPostsDocument, options);
        }
export type GetTrendingPostsQueryHookResult = ReturnType<typeof useGetTrendingPostsQuery>;
export type GetTrendingPostsLazyQueryHookResult = ReturnType<typeof useGetTrendingPostsLazyQuery>;
export type GetTrendingPostsQueryResult = Apollo.QueryResult<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>;
export const GetCustomTrendPersonasDocument = gql`
    query GetCustomTrendPersonas {
  personas {
    id
    name
    description
    emoji
  }
}
    `;

/**
 * __useGetCustomTrendPersonasQuery__
 *
 * To run a query within a React component, call `useGetCustomTrendPersonasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomTrendPersonasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomTrendPersonasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomTrendPersonasQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomTrendPersonasQuery, GetCustomTrendPersonasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomTrendPersonasQuery, GetCustomTrendPersonasQueryVariables>(GetCustomTrendPersonasDocument, options);
      }
export function useGetCustomTrendPersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomTrendPersonasQuery, GetCustomTrendPersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomTrendPersonasQuery, GetCustomTrendPersonasQueryVariables>(GetCustomTrendPersonasDocument, options);
        }
export type GetCustomTrendPersonasQueryHookResult = ReturnType<typeof useGetCustomTrendPersonasQuery>;
export type GetCustomTrendPersonasLazyQueryHookResult = ReturnType<typeof useGetCustomTrendPersonasLazyQuery>;
export type GetCustomTrendPersonasQueryResult = Apollo.QueryResult<GetCustomTrendPersonasQuery, GetCustomTrendPersonasQueryVariables>;
export const GetPostsForTrendingJuiceboxSavedTrendButtonDocument = gql`
    query GetPostsForTrendingJuiceboxSavedTrendButton($filters: PostFilters!, $take: Int) {
  posts(filters: $filters, take: $take) {
    data {
      ...PostFragmentPostPreview
    }
    meta {
      totalCount
    }
  }
}
    ${PostFragmentPostPreviewFragmentDoc}`;

/**
 * __useGetPostsForTrendingJuiceboxSavedTrendButtonQuery__
 *
 * To run a query within a React component, call `useGetPostsForTrendingJuiceboxSavedTrendButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForTrendingJuiceboxSavedTrendButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForTrendingJuiceboxSavedTrendButtonQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPostsForTrendingJuiceboxSavedTrendButtonQuery(baseOptions: Apollo.QueryHookOptions<GetPostsForTrendingJuiceboxSavedTrendButtonQuery, GetPostsForTrendingJuiceboxSavedTrendButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsForTrendingJuiceboxSavedTrendButtonQuery, GetPostsForTrendingJuiceboxSavedTrendButtonQueryVariables>(GetPostsForTrendingJuiceboxSavedTrendButtonDocument, options);
      }
export function useGetPostsForTrendingJuiceboxSavedTrendButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsForTrendingJuiceboxSavedTrendButtonQuery, GetPostsForTrendingJuiceboxSavedTrendButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsForTrendingJuiceboxSavedTrendButtonQuery, GetPostsForTrendingJuiceboxSavedTrendButtonQueryVariables>(GetPostsForTrendingJuiceboxSavedTrendButtonDocument, options);
        }
export type GetPostsForTrendingJuiceboxSavedTrendButtonQueryHookResult = ReturnType<typeof useGetPostsForTrendingJuiceboxSavedTrendButtonQuery>;
export type GetPostsForTrendingJuiceboxSavedTrendButtonLazyQueryHookResult = ReturnType<typeof useGetPostsForTrendingJuiceboxSavedTrendButtonLazyQuery>;
export type GetPostsForTrendingJuiceboxSavedTrendButtonQueryResult = Apollo.QueryResult<GetPostsForTrendingJuiceboxSavedTrendButtonQuery, GetPostsForTrendingJuiceboxSavedTrendButtonQueryVariables>;
export const GetTrendsForTrendingJuiceboxSearchBarDocument = gql`
    query GetTrendsForTrendingJuiceboxSearchBar($filters: TrendFilters!, $after: String, $take: Int) {
  trends(filters: $filters, after: $after, take: $take) {
    data {
      ...TrendFragmentTrendingJuiceboxSearchBarItem
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    meta {
      totalCount
    }
  }
}
    ${TrendFragmentTrendingJuiceboxSearchBarItemFragmentDoc}`;

/**
 * __useGetTrendsForTrendingJuiceboxSearchBarQuery__
 *
 * To run a query within a React component, call `useGetTrendsForTrendingJuiceboxSearchBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendsForTrendingJuiceboxSearchBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendsForTrendingJuiceboxSearchBarQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetTrendsForTrendingJuiceboxSearchBarQuery(baseOptions: Apollo.QueryHookOptions<GetTrendsForTrendingJuiceboxSearchBarQuery, GetTrendsForTrendingJuiceboxSearchBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendsForTrendingJuiceboxSearchBarQuery, GetTrendsForTrendingJuiceboxSearchBarQueryVariables>(GetTrendsForTrendingJuiceboxSearchBarDocument, options);
      }
export function useGetTrendsForTrendingJuiceboxSearchBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendsForTrendingJuiceboxSearchBarQuery, GetTrendsForTrendingJuiceboxSearchBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendsForTrendingJuiceboxSearchBarQuery, GetTrendsForTrendingJuiceboxSearchBarQueryVariables>(GetTrendsForTrendingJuiceboxSearchBarDocument, options);
        }
export type GetTrendsForTrendingJuiceboxSearchBarQueryHookResult = ReturnType<typeof useGetTrendsForTrendingJuiceboxSearchBarQuery>;
export type GetTrendsForTrendingJuiceboxSearchBarLazyQueryHookResult = ReturnType<typeof useGetTrendsForTrendingJuiceboxSearchBarLazyQuery>;
export type GetTrendsForTrendingJuiceboxSearchBarQueryResult = Apollo.QueryResult<GetTrendsForTrendingJuiceboxSearchBarQuery, GetTrendsForTrendingJuiceboxSearchBarQueryVariables>;
export const UpdateUserOnboardingDocument = gql`
    mutation UpdateUserOnboarding($data: UpdateUserOnboardingInput!) {
  updateUserOnboarding(data: $data) {
    id
    title
    organization {
      id
      name
    }
    onboardingAnswers {
      referralSource
    }
    invitedByUser {
      id
    }
  }
}
    `;
export type UpdateUserOnboardingMutationFn = Apollo.MutationFunction<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>;

/**
 * __useUpdateUserOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingMutation, { data, loading, error }] = useUpdateUserOnboardingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>(UpdateUserOnboardingDocument, options);
      }
export type UpdateUserOnboardingMutationHookResult = ReturnType<typeof useUpdateUserOnboardingMutation>;
export type UpdateUserOnboardingMutationResult = Apollo.MutationResult<UpdateUserOnboardingMutation>;
export type UpdateUserOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>;
export const UpdateUserProfileForProfileTabDocument = gql`
    mutation UpdateUserProfileForProfileTab($data: UpdateUserProfileInput!) {
  updateUserProfile(data: $data) {
    id
    firstName
    lastName
    email
    avatarUrl
  }
}
    `;
export type UpdateUserProfileForProfileTabMutationFn = Apollo.MutationFunction<UpdateUserProfileForProfileTabMutation, UpdateUserProfileForProfileTabMutationVariables>;

/**
 * __useUpdateUserProfileForProfileTabMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileForProfileTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileForProfileTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileForProfileTabMutation, { data, loading, error }] = useUpdateUserProfileForProfileTabMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserProfileForProfileTabMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileForProfileTabMutation, UpdateUserProfileForProfileTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileForProfileTabMutation, UpdateUserProfileForProfileTabMutationVariables>(UpdateUserProfileForProfileTabDocument, options);
      }
export type UpdateUserProfileForProfileTabMutationHookResult = ReturnType<typeof useUpdateUserProfileForProfileTabMutation>;
export type UpdateUserProfileForProfileTabMutationResult = Apollo.MutationResult<UpdateUserProfileForProfileTabMutation>;
export type UpdateUserProfileForProfileTabMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileForProfileTabMutation, UpdateUserProfileForProfileTabMutationVariables>;
export const GetBillingInvoicesDocument = gql`
    mutation GetBillingInvoices {
  getInvoices {
    id
    created
    amountDue
    status
    hostedInvoiceUrl
    description
    quantity
    interval
  }
}
    `;
export type GetBillingInvoicesMutationFn = Apollo.MutationFunction<GetBillingInvoicesMutation, GetBillingInvoicesMutationVariables>;

/**
 * __useGetBillingInvoicesMutation__
 *
 * To run a mutation, you first call `useGetBillingInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getBillingInvoicesMutation, { data, loading, error }] = useGetBillingInvoicesMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<GetBillingInvoicesMutation, GetBillingInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetBillingInvoicesMutation, GetBillingInvoicesMutationVariables>(GetBillingInvoicesDocument, options);
      }
export type GetBillingInvoicesMutationHookResult = ReturnType<typeof useGetBillingInvoicesMutation>;
export type GetBillingInvoicesMutationResult = Apollo.MutationResult<GetBillingInvoicesMutation>;
export type GetBillingInvoicesMutationOptions = Apollo.BaseMutationOptions<GetBillingInvoicesMutation, GetBillingInvoicesMutationVariables>;
export const GetDefaultPaymentMethodForCardDetailsDocument = gql`
    query GetDefaultPaymentMethodForCardDetails {
  getDefaultPaymentMethod {
    ...BillingPaymentMethodFragmentCardDetail
  }
}
    ${BillingPaymentMethodFragmentCardDetailFragmentDoc}`;

/**
 * __useGetDefaultPaymentMethodForCardDetailsQuery__
 *
 * To run a query within a React component, call `useGetDefaultPaymentMethodForCardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultPaymentMethodForCardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultPaymentMethodForCardDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultPaymentMethodForCardDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultPaymentMethodForCardDetailsQuery, GetDefaultPaymentMethodForCardDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultPaymentMethodForCardDetailsQuery, GetDefaultPaymentMethodForCardDetailsQueryVariables>(GetDefaultPaymentMethodForCardDetailsDocument, options);
      }
export function useGetDefaultPaymentMethodForCardDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultPaymentMethodForCardDetailsQuery, GetDefaultPaymentMethodForCardDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultPaymentMethodForCardDetailsQuery, GetDefaultPaymentMethodForCardDetailsQueryVariables>(GetDefaultPaymentMethodForCardDetailsDocument, options);
        }
export type GetDefaultPaymentMethodForCardDetailsQueryHookResult = ReturnType<typeof useGetDefaultPaymentMethodForCardDetailsQuery>;
export type GetDefaultPaymentMethodForCardDetailsLazyQueryHookResult = ReturnType<typeof useGetDefaultPaymentMethodForCardDetailsLazyQuery>;
export type GetDefaultPaymentMethodForCardDetailsQueryResult = Apollo.QueryResult<GetDefaultPaymentMethodForCardDetailsQuery, GetDefaultPaymentMethodForCardDetailsQueryVariables>;
export const UpdateCustomerDefaultPaymentMethodDocument = gql`
    mutation UpdateCustomerDefaultPaymentMethod($data: UpdateBillingCustomerDefaultPaymentMethodInput!) {
  updateCustomerDefaultPaymentMethod(data: $data) {
    id
    defaultPaymentMethod {
      ...BillingPaymentMethodFragmentCardDetail
    }
  }
}
    ${BillingPaymentMethodFragmentCardDetailFragmentDoc}`;
export type UpdateCustomerDefaultPaymentMethodMutationFn = Apollo.MutationFunction<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>;

/**
 * __useUpdateCustomerDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerDefaultPaymentMethodMutation, { data, loading, error }] = useUpdateCustomerDefaultPaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomerDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>(UpdateCustomerDefaultPaymentMethodDocument, options);
      }
export type UpdateCustomerDefaultPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCustomerDefaultPaymentMethodMutation>;
export type UpdateCustomerDefaultPaymentMethodMutationResult = Apollo.MutationResult<UpdateCustomerDefaultPaymentMethodMutation>;
export type UpdateCustomerDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>;
export const CreateBillingSetupIntentMethodDocument = gql`
    mutation CreateBillingSetupIntentMethod($data: CreateSetupIntentInput!) {
  createSetupIntent(data: $data) {
    id
    clientSecret
  }
}
    `;
export type CreateBillingSetupIntentMethodMutationFn = Apollo.MutationFunction<CreateBillingSetupIntentMethodMutation, CreateBillingSetupIntentMethodMutationVariables>;

/**
 * __useCreateBillingSetupIntentMethodMutation__
 *
 * To run a mutation, you first call `useCreateBillingSetupIntentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingSetupIntentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingSetupIntentMethodMutation, { data, loading, error }] = useCreateBillingSetupIntentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBillingSetupIntentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingSetupIntentMethodMutation, CreateBillingSetupIntentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingSetupIntentMethodMutation, CreateBillingSetupIntentMethodMutationVariables>(CreateBillingSetupIntentMethodDocument, options);
      }
export type CreateBillingSetupIntentMethodMutationHookResult = ReturnType<typeof useCreateBillingSetupIntentMethodMutation>;
export type CreateBillingSetupIntentMethodMutationResult = Apollo.MutationResult<CreateBillingSetupIntentMethodMutation>;
export type CreateBillingSetupIntentMethodMutationOptions = Apollo.BaseMutationOptions<CreateBillingSetupIntentMethodMutation, CreateBillingSetupIntentMethodMutationVariables>;
export const CancelBillingSetupIntentMethodDocument = gql`
    mutation CancelBillingSetupIntentMethod($data: CancelSetupIntentInput!) {
  cancelSetupIntent(data: $data) {
    id
  }
}
    `;
export type CancelBillingSetupIntentMethodMutationFn = Apollo.MutationFunction<CancelBillingSetupIntentMethodMutation, CancelBillingSetupIntentMethodMutationVariables>;

/**
 * __useCancelBillingSetupIntentMethodMutation__
 *
 * To run a mutation, you first call `useCancelBillingSetupIntentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBillingSetupIntentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBillingSetupIntentMethodMutation, { data, loading, error }] = useCancelBillingSetupIntentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelBillingSetupIntentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CancelBillingSetupIntentMethodMutation, CancelBillingSetupIntentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBillingSetupIntentMethodMutation, CancelBillingSetupIntentMethodMutationVariables>(CancelBillingSetupIntentMethodDocument, options);
      }
export type CancelBillingSetupIntentMethodMutationHookResult = ReturnType<typeof useCancelBillingSetupIntentMethodMutation>;
export type CancelBillingSetupIntentMethodMutationResult = Apollo.MutationResult<CancelBillingSetupIntentMethodMutation>;
export type CancelBillingSetupIntentMethodMutationOptions = Apollo.BaseMutationOptions<CancelBillingSetupIntentMethodMutation, CancelBillingSetupIntentMethodMutationVariables>;
export const UpdateOrganizationUserRoleDocument = gql`
    mutation UpdateOrganizationUserRole($data: UpdateOrganizationUserRoleInput!) {
  updateOrganizationUserRole(data: $data) {
    id
  }
}
    `;
export type UpdateOrganizationUserRoleMutationFn = Apollo.MutationFunction<UpdateOrganizationUserRoleMutation, UpdateOrganizationUserRoleMutationVariables>;

/**
 * __useUpdateOrganizationUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserRoleMutation, { data, loading, error }] = useUpdateOrganizationUserRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationUserRoleMutation, UpdateOrganizationUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationUserRoleMutation, UpdateOrganizationUserRoleMutationVariables>(UpdateOrganizationUserRoleDocument, options);
      }
export type UpdateOrganizationUserRoleMutationHookResult = ReturnType<typeof useUpdateOrganizationUserRoleMutation>;
export type UpdateOrganizationUserRoleMutationResult = Apollo.MutationResult<UpdateOrganizationUserRoleMutation>;
export type UpdateOrganizationUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationUserRoleMutation, UpdateOrganizationUserRoleMutationVariables>;
export const DeclinePendingUserRequestDocument = gql`
    mutation DeclinePendingUserRequest($data: DeclinePendingUserRequestInput!) {
  declinePendingUserRequest(data: $data) {
    message
    success
  }
}
    `;
export type DeclinePendingUserRequestMutationFn = Apollo.MutationFunction<DeclinePendingUserRequestMutation, DeclinePendingUserRequestMutationVariables>;

/**
 * __useDeclinePendingUserRequestMutation__
 *
 * To run a mutation, you first call `useDeclinePendingUserRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclinePendingUserRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declinePendingUserRequestMutation, { data, loading, error }] = useDeclinePendingUserRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeclinePendingUserRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeclinePendingUserRequestMutation, DeclinePendingUserRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclinePendingUserRequestMutation, DeclinePendingUserRequestMutationVariables>(DeclinePendingUserRequestDocument, options);
      }
export type DeclinePendingUserRequestMutationHookResult = ReturnType<typeof useDeclinePendingUserRequestMutation>;
export type DeclinePendingUserRequestMutationResult = Apollo.MutationResult<DeclinePendingUserRequestMutation>;
export type DeclinePendingUserRequestMutationOptions = Apollo.BaseMutationOptions<DeclinePendingUserRequestMutation, DeclinePendingUserRequestMutationVariables>;
export const DisableUsersDocument = gql`
    mutation DisableUsers($data: DisableUsersInput!) {
  disableUsers(data: $data) {
    success
    message
  }
}
    `;
export type DisableUsersMutationFn = Apollo.MutationFunction<DisableUsersMutation, DisableUsersMutationVariables>;

/**
 * __useDisableUsersMutation__
 *
 * To run a mutation, you first call `useDisableUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUsersMutation, { data, loading, error }] = useDisableUsersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDisableUsersMutation(baseOptions?: Apollo.MutationHookOptions<DisableUsersMutation, DisableUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUsersMutation, DisableUsersMutationVariables>(DisableUsersDocument, options);
      }
export type DisableUsersMutationHookResult = ReturnType<typeof useDisableUsersMutation>;
export type DisableUsersMutationResult = Apollo.MutationResult<DisableUsersMutation>;
export type DisableUsersMutationOptions = Apollo.BaseMutationOptions<DisableUsersMutation, DisableUsersMutationVariables>;
export const EnableOnlyTheseUsersDocument = gql`
    mutation EnableOnlyTheseUsers($data: EnableUsersInput!) {
  enableOnlyTheseUsers(data: $data) {
    success
    message
  }
}
    `;
export type EnableOnlyTheseUsersMutationFn = Apollo.MutationFunction<EnableOnlyTheseUsersMutation, EnableOnlyTheseUsersMutationVariables>;

/**
 * __useEnableOnlyTheseUsersMutation__
 *
 * To run a mutation, you first call `useEnableOnlyTheseUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableOnlyTheseUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableOnlyTheseUsersMutation, { data, loading, error }] = useEnableOnlyTheseUsersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEnableOnlyTheseUsersMutation(baseOptions?: Apollo.MutationHookOptions<EnableOnlyTheseUsersMutation, EnableOnlyTheseUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableOnlyTheseUsersMutation, EnableOnlyTheseUsersMutationVariables>(EnableOnlyTheseUsersDocument, options);
      }
export type EnableOnlyTheseUsersMutationHookResult = ReturnType<typeof useEnableOnlyTheseUsersMutation>;
export type EnableOnlyTheseUsersMutationResult = Apollo.MutationResult<EnableOnlyTheseUsersMutation>;
export type EnableOnlyTheseUsersMutationOptions = Apollo.BaseMutationOptions<EnableOnlyTheseUsersMutation, EnableOnlyTheseUsersMutationVariables>;
export const EnableUsersDocument = gql`
    mutation EnableUsers($data: EnableUsersInput!) {
  enableUsers(data: $data) {
    success
    message
  }
}
    `;
export type EnableUsersMutationFn = Apollo.MutationFunction<EnableUsersMutation, EnableUsersMutationVariables>;

/**
 * __useEnableUsersMutation__
 *
 * To run a mutation, you first call `useEnableUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableUsersMutation, { data, loading, error }] = useEnableUsersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEnableUsersMutation(baseOptions?: Apollo.MutationHookOptions<EnableUsersMutation, EnableUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableUsersMutation, EnableUsersMutationVariables>(EnableUsersDocument, options);
      }
export type EnableUsersMutationHookResult = ReturnType<typeof useEnableUsersMutation>;
export type EnableUsersMutationResult = Apollo.MutationResult<EnableUsersMutation>;
export type EnableUsersMutationOptions = Apollo.BaseMutationOptions<EnableUsersMutation, EnableUsersMutationVariables>;
export const RemoveGuestUserDocument = gql`
    mutation RemoveGuestUser($data: String!) {
  removeGuestUser(data: $data) {
    success
    message
  }
}
    `;
export type RemoveGuestUserMutationFn = Apollo.MutationFunction<RemoveGuestUserMutation, RemoveGuestUserMutationVariables>;

/**
 * __useRemoveGuestUserMutation__
 *
 * To run a mutation, you first call `useRemoveGuestUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGuestUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGuestUserMutation, { data, loading, error }] = useRemoveGuestUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveGuestUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGuestUserMutation, RemoveGuestUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGuestUserMutation, RemoveGuestUserMutationVariables>(RemoveGuestUserDocument, options);
      }
export type RemoveGuestUserMutationHookResult = ReturnType<typeof useRemoveGuestUserMutation>;
export type RemoveGuestUserMutationResult = Apollo.MutationResult<RemoveGuestUserMutation>;
export type RemoveGuestUserMutationOptions = Apollo.BaseMutationOptions<RemoveGuestUserMutation, RemoveGuestUserMutationVariables>;
export const UpdateNotificationSettingDocument = gql`
    mutation UpdateNotificationSetting($data: UpdateNotificationSettingInput!) {
  updateNotificationSetting(data: $data) {
    id
    ...NotificationSettingFragmentUseNotificationSettings
  }
}
    ${NotificationSettingFragmentUseNotificationSettingsFragmentDoc}`;
export type UpdateNotificationSettingMutationFn = Apollo.MutationFunction<UpdateNotificationSettingMutation, UpdateNotificationSettingMutationVariables>;

/**
 * __useUpdateNotificationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingMutation, { data, loading, error }] = useUpdateNotificationSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNotificationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingMutation, UpdateNotificationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingMutation, UpdateNotificationSettingMutationVariables>(UpdateNotificationSettingDocument, options);
      }
export type UpdateNotificationSettingMutationHookResult = ReturnType<typeof useUpdateNotificationSettingMutation>;
export type UpdateNotificationSettingMutationResult = Apollo.MutationResult<UpdateNotificationSettingMutation>;
export type UpdateNotificationSettingMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingMutation, UpdateNotificationSettingMutationVariables>;
export const GetMeForUseNotificationSettingsDocument = gql`
    query GetMeForUseNotificationSettings {
  me {
    id
    notificationSettings {
      id
      ...NotificationSettingFragmentUseNotificationSettings
    }
  }
}
    ${NotificationSettingFragmentUseNotificationSettingsFragmentDoc}`;

/**
 * __useGetMeForUseNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetMeForUseNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeForUseNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeForUseNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeForUseNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMeForUseNotificationSettingsQuery, GetMeForUseNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeForUseNotificationSettingsQuery, GetMeForUseNotificationSettingsQueryVariables>(GetMeForUseNotificationSettingsDocument, options);
      }
export function useGetMeForUseNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeForUseNotificationSettingsQuery, GetMeForUseNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeForUseNotificationSettingsQuery, GetMeForUseNotificationSettingsQueryVariables>(GetMeForUseNotificationSettingsDocument, options);
        }
export type GetMeForUseNotificationSettingsQueryHookResult = ReturnType<typeof useGetMeForUseNotificationSettingsQuery>;
export type GetMeForUseNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetMeForUseNotificationSettingsLazyQuery>;
export type GetMeForUseNotificationSettingsQueryResult = Apollo.QueryResult<GetMeForUseNotificationSettingsQuery, GetMeForUseNotificationSettingsQueryVariables>;
export const GetMeForSocialsPageDocument = gql`
    query GetMeForSocialsPage {
  me {
    id
    organization {
      id
      ...OrganizationFragmentSocialsPage
    }
  }
}
    ${OrganizationFragmentSocialsPageFragmentDoc}`;

/**
 * __useGetMeForSocialsPageQuery__
 *
 * To run a query within a React component, call `useGetMeForSocialsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeForSocialsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeForSocialsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeForSocialsPageQuery(baseOptions?: Apollo.QueryHookOptions<GetMeForSocialsPageQuery, GetMeForSocialsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeForSocialsPageQuery, GetMeForSocialsPageQueryVariables>(GetMeForSocialsPageDocument, options);
      }
export function useGetMeForSocialsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeForSocialsPageQuery, GetMeForSocialsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeForSocialsPageQuery, GetMeForSocialsPageQueryVariables>(GetMeForSocialsPageDocument, options);
        }
export type GetMeForSocialsPageQueryHookResult = ReturnType<typeof useGetMeForSocialsPageQuery>;
export type GetMeForSocialsPageLazyQueryHookResult = ReturnType<typeof useGetMeForSocialsPageLazyQuery>;
export type GetMeForSocialsPageQueryResult = Apollo.QueryResult<GetMeForSocialsPageQuery, GetMeForSocialsPageQueryVariables>;
export const CreateSocialAuthorForSocialAuthorListSectionDocument = gql`
    mutation CreateSocialAuthorForSocialAuthorListSection($data: CreateSocialAuthorInput!) {
  createSocialAuthor(data: $data) {
    id
    ...SocialAuthorFragmentSocialAuthorListSection
  }
}
    ${SocialAuthorFragmentSocialAuthorListSectionFragmentDoc}`;
export type CreateSocialAuthorForSocialAuthorListSectionMutationFn = Apollo.MutationFunction<CreateSocialAuthorForSocialAuthorListSectionMutation, CreateSocialAuthorForSocialAuthorListSectionMutationVariables>;

/**
 * __useCreateSocialAuthorForSocialAuthorListSectionMutation__
 *
 * To run a mutation, you first call `useCreateSocialAuthorForSocialAuthorListSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocialAuthorForSocialAuthorListSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocialAuthorForSocialAuthorListSectionMutation, { data, loading, error }] = useCreateSocialAuthorForSocialAuthorListSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSocialAuthorForSocialAuthorListSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocialAuthorForSocialAuthorListSectionMutation, CreateSocialAuthorForSocialAuthorListSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocialAuthorForSocialAuthorListSectionMutation, CreateSocialAuthorForSocialAuthorListSectionMutationVariables>(CreateSocialAuthorForSocialAuthorListSectionDocument, options);
      }
export type CreateSocialAuthorForSocialAuthorListSectionMutationHookResult = ReturnType<typeof useCreateSocialAuthorForSocialAuthorListSectionMutation>;
export type CreateSocialAuthorForSocialAuthorListSectionMutationResult = Apollo.MutationResult<CreateSocialAuthorForSocialAuthorListSectionMutation>;
export type CreateSocialAuthorForSocialAuthorListSectionMutationOptions = Apollo.BaseMutationOptions<CreateSocialAuthorForSocialAuthorListSectionMutation, CreateSocialAuthorForSocialAuthorListSectionMutationVariables>;
export const DeleteSocialAuthorForSocialAuthorListSectionDocument = gql`
    mutation DeleteSocialAuthorForSocialAuthorListSection($data: DeleteSocialAuthorInput!) {
  deleteSocialAuthor(data: $data) {
    success
    message
  }
}
    `;
export type DeleteSocialAuthorForSocialAuthorListSectionMutationFn = Apollo.MutationFunction<DeleteSocialAuthorForSocialAuthorListSectionMutation, DeleteSocialAuthorForSocialAuthorListSectionMutationVariables>;

/**
 * __useDeleteSocialAuthorForSocialAuthorListSectionMutation__
 *
 * To run a mutation, you first call `useDeleteSocialAuthorForSocialAuthorListSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialAuthorForSocialAuthorListSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialAuthorForSocialAuthorListSectionMutation, { data, loading, error }] = useDeleteSocialAuthorForSocialAuthorListSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteSocialAuthorForSocialAuthorListSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSocialAuthorForSocialAuthorListSectionMutation, DeleteSocialAuthorForSocialAuthorListSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSocialAuthorForSocialAuthorListSectionMutation, DeleteSocialAuthorForSocialAuthorListSectionMutationVariables>(DeleteSocialAuthorForSocialAuthorListSectionDocument, options);
      }
export type DeleteSocialAuthorForSocialAuthorListSectionMutationHookResult = ReturnType<typeof useDeleteSocialAuthorForSocialAuthorListSectionMutation>;
export type DeleteSocialAuthorForSocialAuthorListSectionMutationResult = Apollo.MutationResult<DeleteSocialAuthorForSocialAuthorListSectionMutation>;
export type DeleteSocialAuthorForSocialAuthorListSectionMutationOptions = Apollo.BaseMutationOptions<DeleteSocialAuthorForSocialAuthorListSectionMutation, DeleteSocialAuthorForSocialAuthorListSectionMutationVariables>;
export const SendOtpDocument = gql`
    mutation SendOTP($data: SendOTPInput!) {
  sendOTP(data: $data) {
    message
    success
  }
}
    `;
export type SendOtpMutationFn = Apollo.MutationFunction<SendOtpMutation, SendOtpMutationVariables>;

/**
 * __useSendOtpMutation__
 *
 * To run a mutation, you first call `useSendOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpMutation, { data, loading, error }] = useSendOtpMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendOtpMutation, SendOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOtpMutation, SendOtpMutationVariables>(SendOtpDocument, options);
      }
export type SendOtpMutationHookResult = ReturnType<typeof useSendOtpMutation>;
export type SendOtpMutationResult = Apollo.MutationResult<SendOtpMutation>;
export type SendOtpMutationOptions = Apollo.BaseMutationOptions<SendOtpMutation, SendOtpMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOTP($data: VerifyOTPInput!) {
  verifyOTP(data: $data) {
    message
    success
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const CreateSocialPostForOutboundCommentsForAddACommentButtonDocument = gql`
    mutation CreateSocialPostForOutboundCommentsForAddACommentButton($data: CreateSocialPostForOutboundCommentsInput!) {
  createSocialPostForOutboundComments(data: $data) {
    id
    ...SocialPostFragmentAddACommentButton
  }
}
    ${SocialPostFragmentAddACommentButtonFragmentDoc}`;
export type CreateSocialPostForOutboundCommentsForAddACommentButtonMutationFn = Apollo.MutationFunction<CreateSocialPostForOutboundCommentsForAddACommentButtonMutation, CreateSocialPostForOutboundCommentsForAddACommentButtonMutationVariables>;

/**
 * __useCreateSocialPostForOutboundCommentsForAddACommentButtonMutation__
 *
 * To run a mutation, you first call `useCreateSocialPostForOutboundCommentsForAddACommentButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocialPostForOutboundCommentsForAddACommentButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocialPostForOutboundCommentsForAddACommentButtonMutation, { data, loading, error }] = useCreateSocialPostForOutboundCommentsForAddACommentButtonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSocialPostForOutboundCommentsForAddACommentButtonMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocialPostForOutboundCommentsForAddACommentButtonMutation, CreateSocialPostForOutboundCommentsForAddACommentButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocialPostForOutboundCommentsForAddACommentButtonMutation, CreateSocialPostForOutboundCommentsForAddACommentButtonMutationVariables>(CreateSocialPostForOutboundCommentsForAddACommentButtonDocument, options);
      }
export type CreateSocialPostForOutboundCommentsForAddACommentButtonMutationHookResult = ReturnType<typeof useCreateSocialPostForOutboundCommentsForAddACommentButtonMutation>;
export type CreateSocialPostForOutboundCommentsForAddACommentButtonMutationResult = Apollo.MutationResult<CreateSocialPostForOutboundCommentsForAddACommentButtonMutation>;
export type CreateSocialPostForOutboundCommentsForAddACommentButtonMutationOptions = Apollo.BaseMutationOptions<CreateSocialPostForOutboundCommentsForAddACommentButtonMutation, CreateSocialPostForOutboundCommentsForAddACommentButtonMutationVariables>;
export const GetSocialPostCommentsDocument = gql`
    query GetSocialPostComments($brandId: String!, $data: SocialPostCommentsInput!) {
  socialPostComments(data: $data) {
    data {
      ...SocialPostCommentFragmentSocialPostCommentCardView
    }
    meta {
      totalCount
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${SocialPostCommentFragmentSocialPostCommentCardViewFragmentDoc}`;

/**
 * __useGetSocialPostCommentsQuery__
 *
 * To run a query within a React component, call `useGetSocialPostCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPostCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPostCommentsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSocialPostCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPostCommentsQuery, GetSocialPostCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPostCommentsQuery, GetSocialPostCommentsQueryVariables>(GetSocialPostCommentsDocument, options);
      }
export function useGetSocialPostCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPostCommentsQuery, GetSocialPostCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPostCommentsQuery, GetSocialPostCommentsQueryVariables>(GetSocialPostCommentsDocument, options);
        }
export type GetSocialPostCommentsQueryHookResult = ReturnType<typeof useGetSocialPostCommentsQuery>;
export type GetSocialPostCommentsLazyQueryHookResult = ReturnType<typeof useGetSocialPostCommentsLazyQuery>;
export type GetSocialPostCommentsQueryResult = Apollo.QueryResult<GetSocialPostCommentsQuery, GetSocialPostCommentsQueryVariables>;
export const GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageDocument = gql`
    query GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPage($brandIds: [String!]!, $userId: String!, $filters: BrandOutboundEngagementPerformanceByUserFilters!) {
  brandOutboundEngagementPerformanceByUser(
    filters: $filters
    userId: $userId
    brandIds: $brandIds
  ) {
    id
    user {
      id
      ...UserFragmentAvatarGroup
    }
    averageEngagement
    numberOfPostsCommentedOn
    maxLikes
  }
}
    ${UserFragmentAvatarGroupFragmentDoc}`;

/**
 * __useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery__
 *
 * To run a query within a React component, call `useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery({
 *   variables: {
 *      brandIds: // value for 'brandIds'
 *      userId: // value for 'userId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery, GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery, GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryVariables>(GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageDocument, options);
      }
export function useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery, GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery, GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryVariables>(GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageDocument, options);
        }
export type GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryHookResult = ReturnType<typeof useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery>;
export type GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageLazyQueryHookResult = ReturnType<typeof useGetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageLazyQuery>;
export type GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryResult = Apollo.QueryResult<GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQuery, GetBrandOutboundEngagementPerformanceByUserForSocialMediaListeningAnalyticsOutboundLeaderboardDetailPageQueryVariables>;
export const GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersDocument = gql`
    query GetPaginatedOrganizationCreatorProfileLabelsForSLCommunityPageFilters($input: PaginatedOrganizationCreatorProfileLabelInput!) {
  paginatedOrganizationCreatorProfileLabels(input: $input) {
    data {
      id
      label
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery, GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery, GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryVariables>(GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersDocument, options);
      }
export function useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery, GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery, GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryVariables>(GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersDocument, options);
        }
export type GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery>;
export type GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersLazyQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersLazyQuery>;
export type GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryResult = Apollo.QueryResult<GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQuery, GetPaginatedOrganizationCreatorProfileLabelsForSlCommunityPageFiltersQueryVariables>;
export const GetLocationsForSlCommunityPageFiltersDocument = gql`
    query GetLocationsForSLCommunityPageFilters($brandId: String!) {
  getCreatorProfileLocations(brandId: $brandId)
}
    `;

/**
 * __useGetLocationsForSlCommunityPageFiltersQuery__
 *
 * To run a query within a React component, call `useGetLocationsForSlCommunityPageFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsForSlCommunityPageFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsForSlCommunityPageFiltersQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetLocationsForSlCommunityPageFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsForSlCommunityPageFiltersQuery, GetLocationsForSlCommunityPageFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsForSlCommunityPageFiltersQuery, GetLocationsForSlCommunityPageFiltersQueryVariables>(GetLocationsForSlCommunityPageFiltersDocument, options);
      }
export function useGetLocationsForSlCommunityPageFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsForSlCommunityPageFiltersQuery, GetLocationsForSlCommunityPageFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsForSlCommunityPageFiltersQuery, GetLocationsForSlCommunityPageFiltersQueryVariables>(GetLocationsForSlCommunityPageFiltersDocument, options);
        }
export type GetLocationsForSlCommunityPageFiltersQueryHookResult = ReturnType<typeof useGetLocationsForSlCommunityPageFiltersQuery>;
export type GetLocationsForSlCommunityPageFiltersLazyQueryHookResult = ReturnType<typeof useGetLocationsForSlCommunityPageFiltersLazyQuery>;
export type GetLocationsForSlCommunityPageFiltersQueryResult = Apollo.QueryResult<GetLocationsForSlCommunityPageFiltersQuery, GetLocationsForSlCommunityPageFiltersQueryVariables>;
export const GetCapturedProductsForSlCommunityPageFiltersDocument = gql`
    query GetCapturedProductsForSLCommunityPageFilters($input: GetCreatorProfilesCapturedProductsArgs!) {
  getCreatorProfilesCapturedProducts(input: $input) {
    data {
      id
      line
      model
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetCapturedProductsForSlCommunityPageFiltersQuery__
 *
 * To run a query within a React component, call `useGetCapturedProductsForSlCommunityPageFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapturedProductsForSlCommunityPageFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapturedProductsForSlCommunityPageFiltersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCapturedProductsForSlCommunityPageFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetCapturedProductsForSlCommunityPageFiltersQuery, GetCapturedProductsForSlCommunityPageFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapturedProductsForSlCommunityPageFiltersQuery, GetCapturedProductsForSlCommunityPageFiltersQueryVariables>(GetCapturedProductsForSlCommunityPageFiltersDocument, options);
      }
export function useGetCapturedProductsForSlCommunityPageFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapturedProductsForSlCommunityPageFiltersQuery, GetCapturedProductsForSlCommunityPageFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapturedProductsForSlCommunityPageFiltersQuery, GetCapturedProductsForSlCommunityPageFiltersQueryVariables>(GetCapturedProductsForSlCommunityPageFiltersDocument, options);
        }
export type GetCapturedProductsForSlCommunityPageFiltersQueryHookResult = ReturnType<typeof useGetCapturedProductsForSlCommunityPageFiltersQuery>;
export type GetCapturedProductsForSlCommunityPageFiltersLazyQueryHookResult = ReturnType<typeof useGetCapturedProductsForSlCommunityPageFiltersLazyQuery>;
export type GetCapturedProductsForSlCommunityPageFiltersQueryResult = Apollo.QueryResult<GetCapturedProductsForSlCommunityPageFiltersQuery, GetCapturedProductsForSlCommunityPageFiltersQueryVariables>;
export const GetSavedConfigsByTypeForSavedMenuViewsDocument = gql`
    query GetSavedConfigsByTypeForSavedMenuViews($input: ListSavedConfigsInput!) {
  getSavedConfigsByType(input: $input) {
    id
    ...SavedConfigFragmentSavedViewsMenu
  }
}
    ${SavedConfigFragmentSavedViewsMenuFragmentDoc}`;

/**
 * __useGetSavedConfigsByTypeForSavedMenuViewsQuery__
 *
 * To run a query within a React component, call `useGetSavedConfigsByTypeForSavedMenuViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedConfigsByTypeForSavedMenuViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedConfigsByTypeForSavedMenuViewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSavedConfigsByTypeForSavedMenuViewsQuery(baseOptions: Apollo.QueryHookOptions<GetSavedConfigsByTypeForSavedMenuViewsQuery, GetSavedConfigsByTypeForSavedMenuViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedConfigsByTypeForSavedMenuViewsQuery, GetSavedConfigsByTypeForSavedMenuViewsQueryVariables>(GetSavedConfigsByTypeForSavedMenuViewsDocument, options);
      }
export function useGetSavedConfigsByTypeForSavedMenuViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedConfigsByTypeForSavedMenuViewsQuery, GetSavedConfigsByTypeForSavedMenuViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedConfigsByTypeForSavedMenuViewsQuery, GetSavedConfigsByTypeForSavedMenuViewsQueryVariables>(GetSavedConfigsByTypeForSavedMenuViewsDocument, options);
        }
export type GetSavedConfigsByTypeForSavedMenuViewsQueryHookResult = ReturnType<typeof useGetSavedConfigsByTypeForSavedMenuViewsQuery>;
export type GetSavedConfigsByTypeForSavedMenuViewsLazyQueryHookResult = ReturnType<typeof useGetSavedConfigsByTypeForSavedMenuViewsLazyQuery>;
export type GetSavedConfigsByTypeForSavedMenuViewsQueryResult = Apollo.QueryResult<GetSavedConfigsByTypeForSavedMenuViewsQuery, GetSavedConfigsByTypeForSavedMenuViewsQueryVariables>;
export const CreateSavedConfigForSavedMenuViewsDocument = gql`
    mutation CreateSavedConfigForSavedMenuViews($input: CreateSavedConfigInput!) {
  createSavedConfig(input: $input) {
    success
    message
  }
}
    `;
export type CreateSavedConfigForSavedMenuViewsMutationFn = Apollo.MutationFunction<CreateSavedConfigForSavedMenuViewsMutation, CreateSavedConfigForSavedMenuViewsMutationVariables>;

/**
 * __useCreateSavedConfigForSavedMenuViewsMutation__
 *
 * To run a mutation, you first call `useCreateSavedConfigForSavedMenuViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedConfigForSavedMenuViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedConfigForSavedMenuViewsMutation, { data, loading, error }] = useCreateSavedConfigForSavedMenuViewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedConfigForSavedMenuViewsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavedConfigForSavedMenuViewsMutation, CreateSavedConfigForSavedMenuViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSavedConfigForSavedMenuViewsMutation, CreateSavedConfigForSavedMenuViewsMutationVariables>(CreateSavedConfigForSavedMenuViewsDocument, options);
      }
export type CreateSavedConfigForSavedMenuViewsMutationHookResult = ReturnType<typeof useCreateSavedConfigForSavedMenuViewsMutation>;
export type CreateSavedConfigForSavedMenuViewsMutationResult = Apollo.MutationResult<CreateSavedConfigForSavedMenuViewsMutation>;
export type CreateSavedConfigForSavedMenuViewsMutationOptions = Apollo.BaseMutationOptions<CreateSavedConfigForSavedMenuViewsMutation, CreateSavedConfigForSavedMenuViewsMutationVariables>;
export const UpdateSavedConfigForSavedMenuViewsDocument = gql`
    mutation UpdateSavedConfigForSavedMenuViews($input: UpdateSavedConfigInput!) {
  updateSavedConfig(input: $input) {
    success
    message
  }
}
    `;
export type UpdateSavedConfigForSavedMenuViewsMutationFn = Apollo.MutationFunction<UpdateSavedConfigForSavedMenuViewsMutation, UpdateSavedConfigForSavedMenuViewsMutationVariables>;

/**
 * __useUpdateSavedConfigForSavedMenuViewsMutation__
 *
 * To run a mutation, you first call `useUpdateSavedConfigForSavedMenuViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedConfigForSavedMenuViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedConfigForSavedMenuViewsMutation, { data, loading, error }] = useUpdateSavedConfigForSavedMenuViewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSavedConfigForSavedMenuViewsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSavedConfigForSavedMenuViewsMutation, UpdateSavedConfigForSavedMenuViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSavedConfigForSavedMenuViewsMutation, UpdateSavedConfigForSavedMenuViewsMutationVariables>(UpdateSavedConfigForSavedMenuViewsDocument, options);
      }
export type UpdateSavedConfigForSavedMenuViewsMutationHookResult = ReturnType<typeof useUpdateSavedConfigForSavedMenuViewsMutation>;
export type UpdateSavedConfigForSavedMenuViewsMutationResult = Apollo.MutationResult<UpdateSavedConfigForSavedMenuViewsMutation>;
export type UpdateSavedConfigForSavedMenuViewsMutationOptions = Apollo.BaseMutationOptions<UpdateSavedConfigForSavedMenuViewsMutation, UpdateSavedConfigForSavedMenuViewsMutationVariables>;
export const DeleteSavedConfigForSavedMenuViewsDocument = gql`
    mutation DeleteSavedConfigForSavedMenuViews($input: DeleteSavedConfigInput!) {
  deleteSavedConfig(input: $input) {
    success
    message
  }
}
    `;
export type DeleteSavedConfigForSavedMenuViewsMutationFn = Apollo.MutationFunction<DeleteSavedConfigForSavedMenuViewsMutation, DeleteSavedConfigForSavedMenuViewsMutationVariables>;

/**
 * __useDeleteSavedConfigForSavedMenuViewsMutation__
 *
 * To run a mutation, you first call `useDeleteSavedConfigForSavedMenuViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedConfigForSavedMenuViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedConfigForSavedMenuViewsMutation, { data, loading, error }] = useDeleteSavedConfigForSavedMenuViewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSavedConfigForSavedMenuViewsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavedConfigForSavedMenuViewsMutation, DeleteSavedConfigForSavedMenuViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavedConfigForSavedMenuViewsMutation, DeleteSavedConfigForSavedMenuViewsMutationVariables>(DeleteSavedConfigForSavedMenuViewsDocument, options);
      }
export type DeleteSavedConfigForSavedMenuViewsMutationHookResult = ReturnType<typeof useDeleteSavedConfigForSavedMenuViewsMutation>;
export type DeleteSavedConfigForSavedMenuViewsMutationResult = Apollo.MutationResult<DeleteSavedConfigForSavedMenuViewsMutation>;
export type DeleteSavedConfigForSavedMenuViewsMutationOptions = Apollo.BaseMutationOptions<DeleteSavedConfigForSavedMenuViewsMutation, DeleteSavedConfigForSavedMenuViewsMutationVariables>;
export const GetCreatorProfileForSlCreatorProfilePageDocument = gql`
    query GetCreatorProfileForSLCreatorProfilePage($id: String!, $brandId: String!) {
  creatorProfile(id: $id) {
    id
    fullName
    isBlockedFromCommunityHub
    isBrandBlocked
    brand {
      id
      name
    }
    defaultCreatorId
    creators {
      id
      ...CreatorFragmentCreatorAvatar
      ...CreatorFragmentCreatorPeeking
    }
    ...CreatorProfileFragmentAboutTabContent
    ...CreatorProfileFragmentActivityTabContent
  }
}
    ${CreatorFragmentCreatorAvatarFragmentDoc}
${CreatorFragmentCreatorPeekingFragmentDoc}
${CreatorProfileFragmentAboutTabContentFragmentDoc}
${CreatorProfileFragmentActivityTabContentFragmentDoc}`;

/**
 * __useGetCreatorProfileForSlCreatorProfilePageQuery__
 *
 * To run a query within a React component, call `useGetCreatorProfileForSlCreatorProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorProfileForSlCreatorProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorProfileForSlCreatorProfilePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetCreatorProfileForSlCreatorProfilePageQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorProfileForSlCreatorProfilePageQuery, GetCreatorProfileForSlCreatorProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorProfileForSlCreatorProfilePageQuery, GetCreatorProfileForSlCreatorProfilePageQueryVariables>(GetCreatorProfileForSlCreatorProfilePageDocument, options);
      }
export function useGetCreatorProfileForSlCreatorProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorProfileForSlCreatorProfilePageQuery, GetCreatorProfileForSlCreatorProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorProfileForSlCreatorProfilePageQuery, GetCreatorProfileForSlCreatorProfilePageQueryVariables>(GetCreatorProfileForSlCreatorProfilePageDocument, options);
        }
export type GetCreatorProfileForSlCreatorProfilePageQueryHookResult = ReturnType<typeof useGetCreatorProfileForSlCreatorProfilePageQuery>;
export type GetCreatorProfileForSlCreatorProfilePageLazyQueryHookResult = ReturnType<typeof useGetCreatorProfileForSlCreatorProfilePageLazyQuery>;
export type GetCreatorProfileForSlCreatorProfilePageQueryResult = Apollo.QueryResult<GetCreatorProfileForSlCreatorProfilePageQuery, GetCreatorProfileForSlCreatorProfilePageQueryVariables>;
export const BlockCreatorFromCreatorProfileForSlCreatorProfilePageDocument = gql`
    mutation BlockCreatorFromCreatorProfileForSLCreatorProfilePage($input: BlockCreatorFromCreatorProfileInput!) {
  blockCreatorFromCreatorProfile(input: $input) {
    success
  }
}
    `;
export type BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationFn = Apollo.MutationFunction<BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>;

/**
 * __useBlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation__
 *
 * To run a mutation, you first call `useBlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, { data, loading, error }] = useBlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation(baseOptions?: Apollo.MutationHookOptions<BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>(BlockCreatorFromCreatorProfileForSlCreatorProfilePageDocument, options);
      }
export type BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationHookResult = ReturnType<typeof useBlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation>;
export type BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationResult = Apollo.MutationResult<BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation>;
export type BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationOptions = Apollo.BaseMutationOptions<BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, BlockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>;
export const UnblockCreatorFromCreatorProfileForSlCreatorProfilePageDocument = gql`
    mutation UnblockCreatorFromCreatorProfileForSLCreatorProfilePage($input: UnblockCreatorFromCreatorProfileInput!) {
  unblockCreatorFromCreatorProfile(input: $input) {
    success
  }
}
    `;
export type UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationFn = Apollo.MutationFunction<UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>;

/**
 * __useUnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation__
 *
 * To run a mutation, you first call `useUnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, { data, loading, error }] = useUnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation(baseOptions?: Apollo.MutationHookOptions<UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>(UnblockCreatorFromCreatorProfileForSlCreatorProfilePageDocument, options);
      }
export type UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationHookResult = ReturnType<typeof useUnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation>;
export type UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationResult = Apollo.MutationResult<UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation>;
export type UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationOptions = Apollo.BaseMutationOptions<UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutation, UnblockCreatorFromCreatorProfileForSlCreatorProfilePageMutationVariables>;
export const BlockCreatorForSlCreatorProfilePageDocument = gql`
    mutation BlockCreatorForSLCreatorProfilePage($data: BlockCreatorInput!) {
  blockCreator(data: $data) {
    success
  }
}
    `;
export type BlockCreatorForSlCreatorProfilePageMutationFn = Apollo.MutationFunction<BlockCreatorForSlCreatorProfilePageMutation, BlockCreatorForSlCreatorProfilePageMutationVariables>;

/**
 * __useBlockCreatorForSlCreatorProfilePageMutation__
 *
 * To run a mutation, you first call `useBlockCreatorForSlCreatorProfilePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCreatorForSlCreatorProfilePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCreatorForSlCreatorProfilePageMutation, { data, loading, error }] = useBlockCreatorForSlCreatorProfilePageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBlockCreatorForSlCreatorProfilePageMutation(baseOptions?: Apollo.MutationHookOptions<BlockCreatorForSlCreatorProfilePageMutation, BlockCreatorForSlCreatorProfilePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCreatorForSlCreatorProfilePageMutation, BlockCreatorForSlCreatorProfilePageMutationVariables>(BlockCreatorForSlCreatorProfilePageDocument, options);
      }
export type BlockCreatorForSlCreatorProfilePageMutationHookResult = ReturnType<typeof useBlockCreatorForSlCreatorProfilePageMutation>;
export type BlockCreatorForSlCreatorProfilePageMutationResult = Apollo.MutationResult<BlockCreatorForSlCreatorProfilePageMutation>;
export type BlockCreatorForSlCreatorProfilePageMutationOptions = Apollo.BaseMutationOptions<BlockCreatorForSlCreatorProfilePageMutation, BlockCreatorForSlCreatorProfilePageMutationVariables>;
export const RemoveCreatorBlockingByHandleForSlCreatorProfilePageDocument = gql`
    mutation RemoveCreatorBlockingByHandleForSLCreatorProfilePage($data: RemoveCreatorBlockingByHandleInput!) {
  removeCreatorBlockingByHandle(data: $data) {
    success
  }
}
    `;
export type RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationFn = Apollo.MutationFunction<RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation, RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationVariables>;

/**
 * __useRemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation__
 *
 * To run a mutation, you first call `useRemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreatorBlockingByHandleForSlCreatorProfilePageMutation, { data, loading, error }] = useRemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation, RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation, RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationVariables>(RemoveCreatorBlockingByHandleForSlCreatorProfilePageDocument, options);
      }
export type RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationHookResult = ReturnType<typeof useRemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation>;
export type RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationResult = Apollo.MutationResult<RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation>;
export type RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationOptions = Apollo.BaseMutationOptions<RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutation, RemoveCreatorBlockingByHandleForSlCreatorProfilePageMutationVariables>;
export const GetBrandMentionStatsForSlCreatorProfileActivityTabContentDocument = gql`
    query GetBrandMentionStatsForSLCreatorProfileActivityTabContent($input: CreatorProfileBrandMentionedStatsInput!) {
  creatorProfileBrandMentionStats(input: $input) {
    brandMentionCount
    engagementRate
    sentiment
    totalLikes
    totalViews
    sentimentScore
  }
}
    `;

/**
 * __useGetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery__
 *
 * To run a query within a React component, call `useGetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery(baseOptions: Apollo.QueryHookOptions<GetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery, GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery, GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryVariables>(GetBrandMentionStatsForSlCreatorProfileActivityTabContentDocument, options);
      }
export function useGetBrandMentionStatsForSlCreatorProfileActivityTabContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery, GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery, GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryVariables>(GetBrandMentionStatsForSlCreatorProfileActivityTabContentDocument, options);
        }
export type GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery>;
export type GetBrandMentionStatsForSlCreatorProfileActivityTabContentLazyQueryHookResult = ReturnType<typeof useGetBrandMentionStatsForSlCreatorProfileActivityTabContentLazyQuery>;
export type GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryResult = Apollo.QueryResult<GetBrandMentionStatsForSlCreatorProfileActivityTabContentQuery, GetBrandMentionStatsForSlCreatorProfileActivityTabContentQueryVariables>;
export const GetStatsForSlCreatorProfileActivityTabContentDocument = gql`
    query GetStatsForSLCreatorProfileActivityTabContent($input: CreatorProfileSuperfanEngagementStatsInput!) {
  getCreatorProfileSuperfanEngagementStats(input: $input) {
    maxLikes
    sentiment
    totalComments
    totalEngagement
    sentimentScore
  }
}
    `;

/**
 * __useGetStatsForSlCreatorProfileActivityTabContentQuery__
 *
 * To run a query within a React component, call `useGetStatsForSlCreatorProfileActivityTabContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsForSlCreatorProfileActivityTabContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsForSlCreatorProfileActivityTabContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStatsForSlCreatorProfileActivityTabContentQuery(baseOptions: Apollo.QueryHookOptions<GetStatsForSlCreatorProfileActivityTabContentQuery, GetStatsForSlCreatorProfileActivityTabContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatsForSlCreatorProfileActivityTabContentQuery, GetStatsForSlCreatorProfileActivityTabContentQueryVariables>(GetStatsForSlCreatorProfileActivityTabContentDocument, options);
      }
export function useGetStatsForSlCreatorProfileActivityTabContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatsForSlCreatorProfileActivityTabContentQuery, GetStatsForSlCreatorProfileActivityTabContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatsForSlCreatorProfileActivityTabContentQuery, GetStatsForSlCreatorProfileActivityTabContentQueryVariables>(GetStatsForSlCreatorProfileActivityTabContentDocument, options);
        }
export type GetStatsForSlCreatorProfileActivityTabContentQueryHookResult = ReturnType<typeof useGetStatsForSlCreatorProfileActivityTabContentQuery>;
export type GetStatsForSlCreatorProfileActivityTabContentLazyQueryHookResult = ReturnType<typeof useGetStatsForSlCreatorProfileActivityTabContentLazyQuery>;
export type GetStatsForSlCreatorProfileActivityTabContentQueryResult = Apollo.QueryResult<GetStatsForSlCreatorProfileActivityTabContentQuery, GetStatsForSlCreatorProfileActivityTabContentQueryVariables>;
export const GetPaginatedRadarEventsForActivityTabContentDocument = gql`
    query GetPaginatedRadarEventsForActivityTabContent($input: PaginatedRadarEventInput!) {
  getPaginatedRadarEvents(input: $input) {
    data {
      id
      ...RadarEventFragmentRadarEventTimelineItemView
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${RadarEventFragmentRadarEventTimelineItemViewFragmentDoc}`;

/**
 * __useGetPaginatedRadarEventsForActivityTabContentQuery__
 *
 * To run a query within a React component, call `useGetPaginatedRadarEventsForActivityTabContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedRadarEventsForActivityTabContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedRadarEventsForActivityTabContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedRadarEventsForActivityTabContentQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedRadarEventsForActivityTabContentQuery, GetPaginatedRadarEventsForActivityTabContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedRadarEventsForActivityTabContentQuery, GetPaginatedRadarEventsForActivityTabContentQueryVariables>(GetPaginatedRadarEventsForActivityTabContentDocument, options);
      }
export function useGetPaginatedRadarEventsForActivityTabContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedRadarEventsForActivityTabContentQuery, GetPaginatedRadarEventsForActivityTabContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedRadarEventsForActivityTabContentQuery, GetPaginatedRadarEventsForActivityTabContentQueryVariables>(GetPaginatedRadarEventsForActivityTabContentDocument, options);
        }
export type GetPaginatedRadarEventsForActivityTabContentQueryHookResult = ReturnType<typeof useGetPaginatedRadarEventsForActivityTabContentQuery>;
export type GetPaginatedRadarEventsForActivityTabContentLazyQueryHookResult = ReturnType<typeof useGetPaginatedRadarEventsForActivityTabContentLazyQuery>;
export type GetPaginatedRadarEventsForActivityTabContentQueryResult = Apollo.QueryResult<GetPaginatedRadarEventsForActivityTabContentQuery, GetPaginatedRadarEventsForActivityTabContentQueryVariables>;
export const GetBrandForSocialMediaListeningDocument = gql`
    query GetBrandForSocialMediaListening($brandId: String!) {
  brand(id: $brandId) {
    id
    name
    regions
    topics {
      id
      name
      type
      topicContentStrategy
    }
    bookmarkState {
      socialListeningEngagement
    }
    ...BrandFragmentBrandConnectedCreators
  }
}
    ${BrandFragmentBrandConnectedCreatorsFragmentDoc}`;

/**
 * __useGetBrandForSocialMediaListeningQuery__
 *
 * To run a query within a React component, call `useGetBrandForSocialMediaListeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForSocialMediaListeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForSocialMediaListeningQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandForSocialMediaListeningQuery(baseOptions: Apollo.QueryHookOptions<GetBrandForSocialMediaListeningQuery, GetBrandForSocialMediaListeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandForSocialMediaListeningQuery, GetBrandForSocialMediaListeningQueryVariables>(GetBrandForSocialMediaListeningDocument, options);
      }
export function useGetBrandForSocialMediaListeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandForSocialMediaListeningQuery, GetBrandForSocialMediaListeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandForSocialMediaListeningQuery, GetBrandForSocialMediaListeningQueryVariables>(GetBrandForSocialMediaListeningDocument, options);
        }
export type GetBrandForSocialMediaListeningQueryHookResult = ReturnType<typeof useGetBrandForSocialMediaListeningQuery>;
export type GetBrandForSocialMediaListeningLazyQueryHookResult = ReturnType<typeof useGetBrandForSocialMediaListeningLazyQuery>;
export type GetBrandForSocialMediaListeningQueryResult = Apollo.QueryResult<GetBrandForSocialMediaListeningQuery, GetBrandForSocialMediaListeningQueryVariables>;
export const GetPostForTaskDetailPageDocument = gql`
    query GetPostForTaskDetailPage($id: String!) {
  post(id: $id) {
    id
    ...PostFragmentTaskHeadingSection
  }
}
    ${PostFragmentTaskHeadingSectionFragmentDoc}`;

/**
 * __useGetPostForTaskDetailPageQuery__
 *
 * To run a query within a React component, call `useGetPostForTaskDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForTaskDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForTaskDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostForTaskDetailPageQuery(baseOptions: Apollo.QueryHookOptions<GetPostForTaskDetailPageQuery, GetPostForTaskDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostForTaskDetailPageQuery, GetPostForTaskDetailPageQueryVariables>(GetPostForTaskDetailPageDocument, options);
      }
export function useGetPostForTaskDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostForTaskDetailPageQuery, GetPostForTaskDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostForTaskDetailPageQuery, GetPostForTaskDetailPageQueryVariables>(GetPostForTaskDetailPageDocument, options);
        }
export type GetPostForTaskDetailPageQueryHookResult = ReturnType<typeof useGetPostForTaskDetailPageQuery>;
export type GetPostForTaskDetailPageLazyQueryHookResult = ReturnType<typeof useGetPostForTaskDetailPageLazyQuery>;
export type GetPostForTaskDetailPageQueryResult = Apollo.QueryResult<GetPostForTaskDetailPageQuery, GetPostForTaskDetailPageQueryVariables>;
export const GetTaskCommentsUnreadCountDocument = gql`
    query GetTaskCommentsUnreadCount($taskId: String!) {
  unreadTaskComments(taskId: $taskId)
}
    `;

/**
 * __useGetTaskCommentsUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetTaskCommentsUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCommentsUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCommentsUnreadCountQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskCommentsUnreadCountQuery(baseOptions: Apollo.QueryHookOptions<GetTaskCommentsUnreadCountQuery, GetTaskCommentsUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskCommentsUnreadCountQuery, GetTaskCommentsUnreadCountQueryVariables>(GetTaskCommentsUnreadCountDocument, options);
      }
export function useGetTaskCommentsUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskCommentsUnreadCountQuery, GetTaskCommentsUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskCommentsUnreadCountQuery, GetTaskCommentsUnreadCountQueryVariables>(GetTaskCommentsUnreadCountDocument, options);
        }
export type GetTaskCommentsUnreadCountQueryHookResult = ReturnType<typeof useGetTaskCommentsUnreadCountQuery>;
export type GetTaskCommentsUnreadCountLazyQueryHookResult = ReturnType<typeof useGetTaskCommentsUnreadCountLazyQuery>;
export type GetTaskCommentsUnreadCountQueryResult = Apollo.QueryResult<GetTaskCommentsUnreadCountQuery, GetTaskCommentsUnreadCountQueryVariables>;
export const GetTasksForTaskCalendarSectionDocument = gql`
    query GetTasksForTaskCalendarSection($filters: TaskFilters!, $take: Int, $after: String) {
  tasks(filters: $filters, take: $take, after: $after) {
    data {
      ...TaskFragmentTaskCalendarEventView
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    meta {
      totalCount
      completedCount
    }
  }
}
    ${TaskFragmentTaskCalendarEventViewFragmentDoc}`;

/**
 * __useGetTasksForTaskCalendarSectionQuery__
 *
 * To run a query within a React component, call `useGetTasksForTaskCalendarSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForTaskCalendarSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksForTaskCalendarSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTasksForTaskCalendarSectionQuery(baseOptions: Apollo.QueryHookOptions<GetTasksForTaskCalendarSectionQuery, GetTasksForTaskCalendarSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksForTaskCalendarSectionQuery, GetTasksForTaskCalendarSectionQueryVariables>(GetTasksForTaskCalendarSectionDocument, options);
      }
export function useGetTasksForTaskCalendarSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksForTaskCalendarSectionQuery, GetTasksForTaskCalendarSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksForTaskCalendarSectionQuery, GetTasksForTaskCalendarSectionQueryVariables>(GetTasksForTaskCalendarSectionDocument, options);
        }
export type GetTasksForTaskCalendarSectionQueryHookResult = ReturnType<typeof useGetTasksForTaskCalendarSectionQuery>;
export type GetTasksForTaskCalendarSectionLazyQueryHookResult = ReturnType<typeof useGetTasksForTaskCalendarSectionLazyQuery>;
export type GetTasksForTaskCalendarSectionQueryResult = Apollo.QueryResult<GetTasksForTaskCalendarSectionQuery, GetTasksForTaskCalendarSectionQueryVariables>;
export const GetTasksForTaskListSectionDocument = gql`
    query GetTasksForTaskListSection($filters: TaskFilters!) {
  tasks(filters: $filters) {
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useGetTasksForTaskListSectionQuery__
 *
 * To run a query within a React component, call `useGetTasksForTaskListSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForTaskListSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksForTaskListSectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTasksForTaskListSectionQuery(baseOptions: Apollo.QueryHookOptions<GetTasksForTaskListSectionQuery, GetTasksForTaskListSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksForTaskListSectionQuery, GetTasksForTaskListSectionQueryVariables>(GetTasksForTaskListSectionDocument, options);
      }
export function useGetTasksForTaskListSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksForTaskListSectionQuery, GetTasksForTaskListSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksForTaskListSectionQuery, GetTasksForTaskListSectionQueryVariables>(GetTasksForTaskListSectionDocument, options);
        }
export type GetTasksForTaskListSectionQueryHookResult = ReturnType<typeof useGetTasksForTaskListSectionQuery>;
export type GetTasksForTaskListSectionLazyQueryHookResult = ReturnType<typeof useGetTasksForTaskListSectionLazyQuery>;
export type GetTasksForTaskListSectionQueryResult = Apollo.QueryResult<GetTasksForTaskListSectionQuery, GetTasksForTaskListSectionQueryVariables>;